
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire66d5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire66d5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("31N0p", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eX8nW = parcelRequire("eX8nW");

var $dDvZT = parcelRequire("dDvZT");

var $gH8Ve = parcelRequire("gH8Ve");

var $lmDUN = parcelRequire("lmDUN");

var $26nWE = parcelRequire("26nWE");

var $gWYwh = parcelRequire("gWYwh");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $c3F4R = parcelRequire("c3F4R");

var $4LxkX = parcelRequire("4LxkX");

var $2IafG = parcelRequire("2IafG");

var $6aMbm = parcelRequire("6aMbm");

var $eE1Sn = parcelRequire("eE1Sn");

var $4wQxQ = parcelRequire("4wQxQ");

var $f3RkF = parcelRequire("f3RkF");

var $ajhqL = parcelRequire("ajhqL");

var $13TrR = parcelRequire("13TrR");

var $3xknF = parcelRequire("3xknF");

var $5JqSP = parcelRequire("5JqSP");

var $lhzyP = parcelRequire("lhzyP");

var $3tUnp = parcelRequire("3tUnp");

var $9tM8w = parcelRequire("9tM8w");

var $du5vT = parcelRequire("du5vT");

var $8OOjj = parcelRequire("8OOjj");

var $fTFTk = parcelRequire("fTFTk");

var $aDJ1B = parcelRequire("aDJ1B");

var $1scQ2 = parcelRequire("1scQ2");

var $ifJZI = parcelRequire("ifJZI");

var $ijm9Y = parcelRequire("ijm9Y");

var $9kCJF = parcelRequire("9kCJF");

var $lCaM2 = parcelRequire("lCaM2");

var $3XlS2 = parcelRequire("3XlS2");

var $iOdTc = parcelRequire("iOdTc");

var $fbkeM = parcelRequire("fbkeM");

var $eEukW = parcelRequire("eEukW");

var $l8Kgs = parcelRequire("l8Kgs");

var $dAAl0 = parcelRequire("dAAl0");

var $bMiFH = parcelRequire("bMiFH");

var $lneXJ = parcelRequire("lneXJ");

var $aX5wF = parcelRequire("aX5wF");

var $l5lP1 = parcelRequire("l5lP1");

var $3TOA3 = parcelRequire("3TOA3");

var $ckhr5 = parcelRequire("ckhr5");

var $dvzf1 = parcelRequire("dvzf1");

var $fnNKN = parcelRequire("fnNKN");

var $fzE9o = parcelRequire("fzE9o");

var $9eSGE = parcelRequire("9eSGE");

var $1E9Rm = parcelRequire("1E9Rm");

var $9A3c5 = parcelRequire("9A3c5");

var $6vUrj = parcelRequire("6vUrj");

var $6Uu3e = parcelRequire("6Uu3e");

var $5CFT4 = parcelRequire("5CFT4");

var $2bFOy = parcelRequire("2bFOy");

var $8gm0h = parcelRequire("8gm0h");

var $fvTyO = parcelRequire("fvTyO");

var $laTYc = parcelRequire("laTYc");

var $gMVt3 = parcelRequire("gMVt3");

var $h6J9f = parcelRequire("h6J9f");

var $2adP5 = parcelRequire("2adP5");

var $ffWyI = parcelRequire("ffWyI");

var $8qWlp = parcelRequire("8qWlp");

var $9QW6c = parcelRequire("9QW6c");

var $bctHB = parcelRequire("bctHB");

var $8mgFa = parcelRequire("8mgFa");

var $3Rkxj = parcelRequire("3Rkxj");

var $g7zRo = parcelRequire("g7zRo");

var $gkhWS = parcelRequire("gkhWS");

var $iVKe8 = parcelRequire("iVKe8");

var $8K7Jl = parcelRequire("8K7Jl");

var $2Nx5l = parcelRequire("2Nx5l");

var $jFWDT = parcelRequire("jFWDT");

var $dwAOK = parcelRequire("dwAOK");

var $dp3IX = parcelRequire("dp3IX");

var $QE2yw = parcelRequire("QE2yw");

var $f6w5N = parcelRequire("f6w5N");

var $f87mP = parcelRequire("f87mP");

var $dp8LO = parcelRequire("dp8LO");

var $dCSiT = parcelRequire("dCSiT");

var $i5zdK = parcelRequire("i5zdK");

var $1V5lh = parcelRequire("1V5lh");

var $1hGnJ = parcelRequire("1hGnJ");

var $jzLgh = parcelRequire("jzLgh");

var $iqqtV = parcelRequire("iqqtV");

var $krgwg = parcelRequire("krgwg");

var $1XBvb = parcelRequire("1XBvb");

var $dDJiI = parcelRequire("dDJiI");

var $7piEH = parcelRequire("7piEH");

var $frFYv = parcelRequire("frFYv");

var $5eiZy = parcelRequire("5eiZy");

var $cRRDT = parcelRequire("cRRDT");

var $6atBT = parcelRequire("6atBT");

var $eN9vd = parcelRequire("eN9vd");

var $lQFj9 = parcelRequire("lQFj9");

var $fbvdA = parcelRequire("fbvdA");

var $gMyai = parcelRequire("gMyai");

var $626Kw = parcelRequire("626Kw");

var $5kKGI = parcelRequire("5kKGI");

var $88Wwg = parcelRequire("88Wwg");

var $5ddno = parcelRequire("5ddno");

var $ax3NO = parcelRequire("ax3NO");

var $j6AED = parcelRequire("j6AED");

var $9nAI4 = parcelRequire("9nAI4");

var $leGC4 = parcelRequire("leGC4");

var $dSnj4 = parcelRequire("dSnj4");

var $lVCHq = parcelRequire("lVCHq");

var $fbA8J = parcelRequire("fbA8J");

var $aGDGs = parcelRequire("aGDGs");

var $iYG6e = parcelRequire("iYG6e");

var $lWjTr = parcelRequire("lWjTr");

var $6OoWC = parcelRequire("6OoWC");

var $hYL8G = parcelRequire("hYL8G");

var $lHZZ7 = parcelRequire("lHZZ7");

var $4mNpz = parcelRequire("4mNpz");

var $6Xrci = parcelRequire("6Xrci");

var $3OVuZ = parcelRequire("3OVuZ");

var $eFFx8 = parcelRequire("eFFx8");

var $aJD8C = parcelRequire("aJD8C");

var $fJLhk = parcelRequire("fJLhk");

var $3zkbY = parcelRequire("3zkbY");

var $9TAZi = parcelRequire("9TAZi");

var $cqs9v = parcelRequire("cqs9v");

var $8PsOG = parcelRequire("8PsOG");

var $as54b = parcelRequire("as54b");

var $1cCOf = parcelRequire("1cCOf");

var $9OEq4 = parcelRequire("9OEq4");

var $eCBhU = parcelRequire("eCBhU");

var $cUgOr = parcelRequire("cUgOr");

var $hGnwj = parcelRequire("hGnwj");

var $g31Ce = parcelRequire("g31Ce");

var $rzjlZ = parcelRequire("rzjlZ");

var $9EvIV = parcelRequire("9EvIV");

var $fQMpe = parcelRequire("fQMpe");

var $42zXR = parcelRequire("42zXR");

var $5ZJSQ = parcelRequire("5ZJSQ");

var $cx0Ur = parcelRequire("cx0Ur");

var $dbBv0 = parcelRequire("dbBv0");

var $dRLB0 = parcelRequire("dRLB0");

var $1nK9H = parcelRequire("1nK9H");

var $foFxi = parcelRequire("foFxi");

var $2AGy2 = parcelRequire("2AGy2");

var $lDdLA = parcelRequire("lDdLA");

var $5L5uH = parcelRequire("5L5uH");

var $7O2T2 = parcelRequire("7O2T2");

var $N4tZW = parcelRequire("N4tZW");

var $j6N8F = parcelRequire("j6N8F");

var $9WX7F = parcelRequire("9WX7F");

var $grFVK = parcelRequire("grFVK");

var $aZ3HH = parcelRequire("aZ3HH");

var $dBuCl = parcelRequire("dBuCl");

var $9eX4e = parcelRequire("9eX4e");

var $jFOY1 = parcelRequire("jFOY1");

var $8tW2T = parcelRequire("8tW2T");

var $bOz44 = parcelRequire("bOz44");

var $aIP8h = parcelRequire("aIP8h");

var $lFg4k = parcelRequire("lFg4k");

var $48AmV = parcelRequire("48AmV");

var $hkF3C = parcelRequire("hkF3C");

var $01r7k = parcelRequire("01r7k");
module.exports.registerSpanErrorInstrumentation = $eX8nW.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $dDvZT.getCapturedScopesOnSpan;
module.exports.markSpanAsTracerProviderSpan = $dDvZT.markSpanAsTracerProviderSpan;
module.exports.markSpanForOtelSourceInference = $dDvZT.markSpanForOtelSourceInference;
module.exports.markSpanSourceAsExplicit = $dDvZT.markSpanSourceAsExplicit;
module.exports.setCapturedScopesOnSpan = $dDvZT.setCapturedScopesOnSpan;
module.exports.spanIsTracerProviderSpan = $dDvZT.spanIsTracerProviderSpan;
module.exports.spanShouldInferOtelSource = $dDvZT.spanShouldInferOtelSource;
module.exports.spanSourceWasExplicitlySet = $dDvZT.spanSourceWasExplicitlySet;
module.exports.TRACING_DEFAULTS = $gH8Ve.TRACING_DEFAULTS;
module.exports.startIdleSpan = $gH8Ve.startIdleSpan;
module.exports.SentrySpan = $lmDUN.SentrySpan;
module.exports._INTERNAL_setDeferSegmentSpanCapture = $26nWE._INTERNAL_setDeferSegmentSpanCapture;
module.exports.SentryNonRecordingSpan = $gWYwh.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $h5H4c.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $h5H4c.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $h5H4c.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $h5H4c.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $h5H4c.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $5CFne.SUPPRESS_TRACING_KEY;
module.exports._INTERNAL_startInactiveSpan = $5CFne._INTERNAL_startInactiveSpan;
module.exports.continueTrace = $5CFne.continueTrace;
module.exports.isTracingSuppressed = $5CFne.isTracingSuppressed;
module.exports.spanIsIgnored = $5CFne.spanIsIgnored;
module.exports.startInactiveSpan = $5CFne.startInactiveSpan;
module.exports.startNewTrace = $5CFne.startNewTrace;
module.exports.startSpan = $5CFne.startSpan;
module.exports.startSpanManual = $5CFne.startSpanManual;
module.exports.suppressTracing = $5CFne.suppressTracing;
module.exports.withActiveSpan = $5CFne.withActiveSpan;
module.exports.bindScopeToEmitter = $c3F4R.bindScopeToEmitter;
module.exports.getDynamicSamplingContextFromClient = $4LxkX.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $4LxkX.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $4LxkX.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $4LxkX.spanToBaggageHeader;
module.exports.setMeasurement = $2IafG.setMeasurement;
module.exports.timedEventsToMeasurements = $2IafG.timedEventsToMeasurements;
module.exports.sampleSpan = $6aMbm.sampleSpan;
module.exports.logSpanEnd = $eE1Sn.logSpanEnd;
module.exports.logSpanStart = $eE1Sn.logSpanStart;
module.exports.captureSpan = $4wQxQ.captureSpan;
module.exports.safeSetSpanJSONAttributes = $4wQxQ.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $f3RkF.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $f3RkF.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $f3RkF.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $f3RkF.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $f3RkF.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $f3RkF.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $f3RkF.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $f3RkF.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $f3RkF.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $f3RkF.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $f3RkF.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $f3RkF.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $f3RkF.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $ajhqL.createEventEnvelope;
module.exports.createSessionEnvelope = $ajhqL.createSessionEnvelope;
module.exports.createSpanEnvelope = $ajhqL.createSpanEnvelope;
module.exports.addEventProcessor = $13TrR.addEventProcessor;
module.exports.captureEvent = $13TrR.captureEvent;
module.exports.captureException = $13TrR.captureException;
module.exports.captureMessage = $13TrR.captureMessage;
module.exports.captureSession = $13TrR.captureSession;
module.exports.close = $13TrR.close;
module.exports.endSession = $13TrR.endSession;
module.exports.flush = $13TrR.flush;
module.exports.isEnabled = $13TrR.isEnabled;
module.exports.isInitialized = $13TrR.isInitialized;
module.exports.lastEventId = $13TrR.lastEventId;
module.exports.setAttribute = $13TrR.setAttribute;
module.exports.setAttributes = $13TrR.setAttributes;
module.exports.setContext = $13TrR.setContext;
module.exports.setConversationId = $13TrR.setConversationId;
module.exports.setExtra = $13TrR.setExtra;
module.exports.setExtras = $13TrR.setExtras;
module.exports.setTag = $13TrR.setTag;
module.exports.setTags = $13TrR.setTags;
module.exports.setUser = $13TrR.setUser;
module.exports.startSession = $13TrR.startSession;
module.exports.captureCheckIn = $3xknF.captureCheckIn;
module.exports.withMonitor = $3xknF.withMonitor;
module.exports.getClient = $5JqSP.getClient;
module.exports.getCurrentScope = $5JqSP.getCurrentScope;
module.exports.getExternalPropagationContext = $5JqSP.getExternalPropagationContext;
module.exports.getGlobalScope = $5JqSP.getGlobalScope;
module.exports.getIsolationScope = $5JqSP.getIsolationScope;
module.exports.getTraceContextFromScope = $5JqSP.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $5JqSP.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $5JqSP.registerExternalPropagationContext;
module.exports.withIsolationScope = $5JqSP.withIsolationScope;
module.exports.withScope = $5JqSP.withScope;
module.exports.getDefaultCurrentScope = $lhzyP.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $lhzyP.getDefaultIsolationScope;
module.exports.getAsyncContextStrategy = $3tUnp.getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $3tUnp.setAsyncContextStrategy;
module.exports._INTERNAL_createTracingChannelBinding = $9tM8w._INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $9tM8w.waitForTracingChannelBinding;
module.exports.getGlobalSingleton = $du5vT.getGlobalSingleton;
module.exports.getMainCarrier = $du5vT.getMainCarrier;
module.exports.closeSession = $8OOjj.closeSession;
module.exports.makeSession = $8OOjj.makeSession;
module.exports.updateSession = $8OOjj.updateSession;
module.exports.Scope = $fTFTk.Scope;
module.exports.notifyEventProcessors = $aDJ1B.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $1scQ2.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $1scQ2.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $1scQ2.getReportDialogEndpoint;
module.exports.Client = $ifJZI.Client;
module.exports.initAndBind = $ijm9Y.initAndBind;
module.exports.setCurrentClient = $ijm9Y.setCurrentClient;
module.exports.createTransport = $9kCJF.createTransport;
module.exports.makeOfflineTransport = $lCaM2.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $3XlS2.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $3XlS2.makeMultiplexedTransport;
module.exports.addIntegration = $iOdTc.addIntegration;
module.exports.defineIntegration = $iOdTc.defineIntegration;
module.exports.extendIntegration = $iOdTc.extendIntegration;
module.exports.getIntegrationsToSetup = $iOdTc.getIntegrationsToSetup;
module.exports.installedIntegrations = $iOdTc.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $fbkeM._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $fbkeM._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $fbkeM._INTERNAL_skipAiProviderWrapping;
module.exports._INTERNAL_filterKeyValueData = $eEukW.filterKeyValueData;
module.exports._INTERNAL_filterCookies = $l8Kgs.filterCookies;
module.exports._INTERNAL_filterQueryParams = $dAAl0.filterQueryParams;
module.exports.filterCollectedUrl = $bMiFH.filterCollectedUrl;
module.exports.filterCollectedUrlQuery = $bMiFH.filterCollectedUrlQuery;
module.exports.envToBool = $lneXJ.envToBool;
module.exports.applyScopeDataToEvent = $aX5wF.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $aX5wF.getCombinedScopeData;
module.exports.mergeScopeData = $aX5wF.mergeScopeData;
module.exports.prepareEvent = $l5lP1.prepareEvent;
module.exports.createCheckInEnvelope = $3TOA3.createCheckInEnvelope;
module.exports.hasSpansEnabled = $ckhr5.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $dvzf1.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $dvzf1.withStreamedSpan;
module.exports.isSentryRequestUrl = $fnNKN.isSentryRequestUrl;
module.exports.handleCallbackErrors = $fzE9o.handleCallbackErrors;
module.exports.fmt = $9eSGE.fmt;
module.exports.parameterize = $9eSGE.parameterize;
module.exports.handleTunnelRequest = $1E9Rm.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $9A3c5.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $9A3c5.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $6vUrj.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $6vUrj.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $6vUrj.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $6vUrj.getActiveSpan;
module.exports.getRootSpan = $6vUrj.getRootSpan;
module.exports.getSpanDescendants = $6vUrj.getSpanDescendants;
module.exports.getStatusMessage = $6vUrj.getStatusMessage;
module.exports.spanIsSampled = $6vUrj.spanIsSampled;
module.exports.spanIsSentrySpan = $6vUrj.spanIsSentrySpan;
module.exports.spanTimeInputToSeconds = $6vUrj.spanTimeInputToSeconds;
module.exports.spanToJSON = $6vUrj.spanToJSON;
module.exports.spanToStreamedSpanJSON = $6vUrj.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $6vUrj.spanToTraceContext;
module.exports.spanToTraceHeader = $6vUrj.spanToTraceHeader;
module.exports.updateSpanName = $6vUrj.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $6Uu3e._setSpanForScope;
module.exports.parseSampleRate = $5CFT4.parseSampleRate;
module.exports.applySdkMetadata = $2bFOy.applySdkMetadata;
module.exports.getTraceData = $8gm0h.getTraceData;
module.exports.shouldPropagateTraceForUrl = $fvTyO.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $laTYc.getTraceMetaTags;
module.exports.debounce = $gMVt3.debounce;
module.exports.uniq = $h6J9f.uniq;
module.exports.derefWeakRef = $2adP5.derefWeakRef;
module.exports.makeWeakRef = $2adP5.makeWeakRef;
module.exports.shouldIgnoreSpan = $ffWyI.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $8qWlp.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $8qWlp.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $8qWlp.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $8qWlp.getMaxBodyByteLength;
module.exports.headersToDict = $8qWlp.headersToDict;
module.exports.httpHeadersToSpanAttributes = $8qWlp.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $8qWlp.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $8qWlp.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $8qWlp.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $9QW6c.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $9QW6c.DEV_ENVIRONMENT;
module.exports.SPAN_KIND = $bctHB.SPAN_KIND;
module.exports.spanKindToName = $bctHB.spanKindToName;
module.exports.addBreadcrumb = $8mgFa.addBreadcrumb;
module.exports.functionToStringIntegration = $3Rkxj.functionToStringIntegration;
module.exports.eventFiltersIntegration = $g7zRo.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $g7zRo.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $gkhWS.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $iVKe8.moduleMetadataIntegration;
module.exports.requestDataIntegration = $8K7Jl.requestDataIntegration;
module.exports.captureConsoleIntegration = $2Nx5l.captureConsoleIntegration;
module.exports.dedupeIntegration = $jFWDT.dedupeIntegration;
module.exports.extraErrorDataIntegration = $dwAOK.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $dp3IX.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $QE2yw.instrumentSupabaseClient;
module.exports.supabaseIntegration = $QE2yw.supabaseIntegration;
module.exports.zodErrorsIntegration = $f6w5N.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $f87mP.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $dp8LO.consoleIntegration;
module.exports.featureFlagsIntegration = $dCSiT.featureFlagsIntegration;
module.exports.growthbookIntegration = $i5zdK.growthbookIntegration;
module.exports.conversationIdIntegration = $1V5lh.conversationIdIntegration;
module.exports.profiler = $1hGnJ.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $jzLgh._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $jzLgh.instrumentFetchRequest;
module.exports.captureFeedback = $iqqtV.captureFeedback;
module.exports._INTERNAL_captureLog = $krgwg._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $krgwg._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $krgwg._INTERNAL_flushLogsBuffer;
module.exports.logger = $1XBvb;
module.exports.consoleLoggingIntegration = $dDJiI.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $7piEH._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $7piEH._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $7piEH._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $frFYv;
module.exports.createConsolaReporter = $5eiZy.createConsolaReporter;
module.exports.LAST_STEP_ONLY_USAGE_KEYS = $cRRDT.LAST_STEP_ONLY_USAGE_KEYS;
module.exports.addVercelAiProcessors = $cRRDT.addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $cRRDT.getProviderMetadataAttributes;
module.exports.getTruncatedJsonString = $6atBT.getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $6atBT.resolveAIRecordingOptions;
module.exports.shouldEnableTruncation = $6atBT.shouldEnableTruncation;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports._INTERNAL_cleanupToolCallSpanContext = $lQFj9._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $lQFj9._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $fbvdA.toolCallSpanContextMap;
module.exports.addOpenAiRequestAttributes = $gMyai.addRequestAttributes;
module.exports.extractOpenAiRequestAttributes = $gMyai.extractRequestAttributes;
module.exports.instrumentOpenAiClient = $gMyai.instrumentOpenAiClient;
module.exports.addOpenAiResponseAttributes = $626Kw.addResponseAttributes;
module.exports.extractOpenAiRequestParameters = $626Kw.extractRequestParameters;
module.exports.instrumentOpenAiStream = $5kKGI.instrumentStream;
module.exports.OPENAI_INTEGRATION_NAME = $88Wwg.OPENAI_INTEGRATION_NAME;
module.exports.addAnthropicRequestAttributes = $5ddno.addPrivateRequestAttributes;
module.exports.addAnthropicResponseAttributes = $5ddno.addResponseAttributes;
module.exports.extractAnthropicRequestAttributes = $5ddno.extractRequestAttributes;
module.exports.instrumentAnthropicAiClient = $5ddno.instrumentAnthropicAiClient;
module.exports.instrumentAsyncIterableStream = $ax3NO.instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $ax3NO.instrumentMessageStream;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $j6AED.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.addGoogleGenAIRequestAttributes = $9nAI4.addPrivateRequestAttributes;
module.exports.addGoogleGenAIResponseAttributes = $9nAI4.addResponseAttributes;
module.exports.extractGoogleGenAIRequestAttributes = $9nAI4.extractRequestAttributes;
module.exports.instrumentGoogleGenAIClient = $9nAI4.instrumentGoogleGenAIClient;
module.exports.instrumentGoogleGenAIStream = $leGC4.instrumentStream;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $dSnj4.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $lVCHq.createLangChainCallbackHandler;
module.exports._INTERNAL_getLangChainEmbeddingsSpanOptions = $fbA8J._INTERNAL_getLangChainEmbeddingsSpanOptions;
module.exports.instrumentLangChainEmbeddings = $fbA8J.instrumentLangChainEmbeddings;
module.exports._INTERNAL_mergeLangChainCallbackHandler = $aGDGs._INTERNAL_mergeLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $iYG6e.LANGCHAIN_INTEGRATION_NAME;
module.exports._INTERNAL_getLangGraphCreateAgentSpanOptions = $lWjTr._INTERNAL_getLangGraphCreateAgentSpanOptions;
module.exports.instrumentCompiledGraphInvoke = $lWjTr.instrumentCompiledGraphInvoke;
module.exports.instrumentCreateReactAgent = $lWjTr.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $lWjTr.instrumentLangGraph;
module.exports.instrumentStateGraph = $lWjTr.instrumentStateGraph;
module.exports.instrumentStateGraphCompile = $lWjTr.instrumentStateGraphCompile;
module.exports.extractAgentNameFromParams = $6OoWC.extractAgentNameFromParams;
module.exports.extractLLMFromParams = $6OoWC.extractLLMFromParams;
module.exports.wrapToolsWithSpans = $6OoWC.wrapToolsWithSpans;
module.exports.LANGGRAPH_INTEGRATION_NAME = $hYL8G.LANGGRAPH_INTEGRATION_NAME;
module.exports.instrumentWorkersAiClient = $lHZZ7.instrumentWorkersAiClient;
module.exports.SpanBuffer = $4mNpz.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $6Xrci.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $3OVuZ.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $eFFx8._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $eFFx8._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $eFFx8._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $eFFx8._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $eFFx8._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $aJD8C.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $fJLhk.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $3zkbY.dsnFromString;
module.exports.dsnToString = $3zkbY.dsnToString;
module.exports.makeDsn = $3zkbY.makeDsn;
module.exports.SentryError = $9TAZi.SentryError;
module.exports.GLOBAL_OBJ = $cqs9v.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $8PsOG.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $8PsOG.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $as54b.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $as54b.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $1cCOf.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $9OEq4.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $eCBhU.addHandler;
module.exports.maybeInstrument = $eCBhU.maybeInstrument;
module.exports.resetInstrumentationHandlers = $eCBhU.resetInstrumentationHandlers;
module.exports.triggerHandlers = $eCBhU.triggerHandlers;
module.exports.isDOMError = $cUgOr.isDOMError;
module.exports.isDOMException = $cUgOr.isDOMException;
module.exports.isElement = $cUgOr.isElement;
module.exports.isError = $cUgOr.isError;
module.exports.isErrorEvent = $cUgOr.isErrorEvent;
module.exports.isEvent = $cUgOr.isEvent;
module.exports.isInstanceOf = $cUgOr.isInstanceOf;
module.exports.isObjectLike = $cUgOr.isObjectLike;
module.exports.isParameterizedString = $cUgOr.isParameterizedString;
module.exports.isPlainObject = $cUgOr.isPlainObject;
module.exports.isPrimitive = $cUgOr.isPrimitive;
module.exports.isRegExp = $cUgOr.isRegExp;
module.exports.isString = $cUgOr.isString;
module.exports.isSyntheticEvent = $cUgOr.isSyntheticEvent;
module.exports.isThenable = $cUgOr.isThenable;
module.exports.isVueViewModel = $cUgOr.isVueViewModel;
module.exports.isBrowser = $hGnwj.isBrowser;
module.exports.CONSOLE_LEVELS = $g31Ce.CONSOLE_LEVELS;
module.exports.consoleSandbox = $g31Ce.consoleSandbox;
module.exports.debug = $g31Ce.debug;
module.exports.originalConsoleMethods = $g31Ce.originalConsoleMethods;
module.exports.addContextToFrame = $rzjlZ.addContextToFrame;
module.exports.addExceptionMechanism = $rzjlZ.addExceptionMechanism;
module.exports.addExceptionTypeValue = $rzjlZ.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $rzjlZ.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $rzjlZ.getEventDescription;
module.exports.isAlreadyCaptured = $rzjlZ.isAlreadyCaptured;
module.exports.parseSemver = $rzjlZ.parseSemver;
module.exports.uuid4 = $rzjlZ.uuid4;
module.exports.normalize = $9EvIV.normalize;
module.exports.normalizeToSize = $9EvIV.normalizeToSize;
module.exports.normalizeUrlToBase = $9EvIV.normalizeUrlToBase;
module.exports.setNormalizeStringifier = $9EvIV.setNormalizeStringifier;
module.exports.setNormalizationDepthOverrideHint = $fQMpe.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $fQMpe.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $42zXR.addNonEnumerableProperty;
module.exports.convertToPlainObject = $42zXR.convertToPlainObject;
module.exports.dropUndefinedKeys = $42zXR.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $42zXR.extractExceptionKeysForMessage;
module.exports.fill = $42zXR.fill;
module.exports.getOriginalFunction = $42zXR.getOriginalFunction;
module.exports.markFunctionWrapped = $42zXR.markFunctionWrapped;
module.exports.objectify = $42zXR.objectify;
module.exports.basename = $5ZJSQ.basename;
module.exports.dirname = $5ZJSQ.dirname;
module.exports.isAbsolute = $5ZJSQ.isAbsolute;
module.exports.join = $5ZJSQ.join;
module.exports.normalizePath = $5ZJSQ.normalizePath;
module.exports.relative = $5ZJSQ.relative;
module.exports.resolve = $5ZJSQ.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $cx0Ur.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $cx0Ur.makePromiseBuffer;
module.exports.severityLevelFromString = $dbBv0.severityLevelFromString;
module.exports.replaceExports = $dRLB0.replaceExports;
module.exports.UNKNOWN_FUNCTION = $1nK9H.UNKNOWN_FUNCTION;
module.exports.createStackParser = $1nK9H.createStackParser;
module.exports.getFramesFromEvent = $1nK9H.getFramesFromEvent;
module.exports.getFunctionName = $1nK9H.getFunctionName;
module.exports.stackParserFromStackParserOptions = $1nK9H.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $1nK9H.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $foFxi.isMatchingPattern;
module.exports.safeJoin = $foFxi.safeJoin;
module.exports.snipLine = $foFxi.snipLine;
module.exports.stringMatchesSomePattern = $foFxi.stringMatchesSomePattern;
module.exports.stringify = $foFxi.stringify;
module.exports.truncate = $foFxi.truncate;
module.exports.isNativeFunction = $2AGy2.isNativeFunction;
module.exports.supportsDOMError = $2AGy2.supportsDOMError;
module.exports.supportsDOMException = $2AGy2.supportsDOMException;
module.exports.supportsErrorEvent = $2AGy2.supportsErrorEvent;
module.exports.supportsFetch = $2AGy2.supportsFetch;
module.exports.supportsHistory = $2AGy2.supportsHistory;
module.exports.supportsNativeFetch = $2AGy2.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $2AGy2.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $2AGy2.supportsReportingObserver;
module.exports.SyncPromise = $lDdLA.SyncPromise;
module.exports.rejectedSyncPromise = $lDdLA.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $lDdLA.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $5L5uH.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $5L5uH.dateTimestampInSeconds;
module.exports.timestampInSeconds = $5L5uH.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $7O2T2.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $7O2T2.extractTraceparentData;
module.exports.generateSentryTraceHeader = $7O2T2.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $7O2T2.generateTraceparentHeader;
module.exports.isContinuingTrace = $7O2T2.isContinuingTrace;
module.exports.propagationContextFromHeaders = $7O2T2.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $7O2T2.shouldContinueTrace;
module.exports.getSDKSource = $N4tZW.getSDKSource;
module.exports.isBrowserBundle = $N4tZW.isBrowserBundle;
module.exports.addItemToEnvelope = $j6N8F.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $j6N8F.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $j6N8F.createEnvelope;
module.exports.createEventEnvelopeHeaders = $j6N8F.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $j6N8F.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $j6N8F.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $j6N8F.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $j6N8F.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $j6N8F.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $j6N8F.parseEnvelope;
module.exports.serializeEnvelope = $j6N8F.serializeEnvelope;
module.exports.createClientReportEnvelope = $9WX7F.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $grFVK.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $grFVK.disabledUntil;
module.exports.isRateLimited = $grFVK.isRateLimited;
module.exports.parseRetryAfterHeader = $grFVK.parseRetryAfterHeader;
module.exports.updateRateLimits = $grFVK.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $aZ3HH.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $aZ3HH.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $aZ3HH.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $aZ3HH.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $aZ3HH.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $aZ3HH.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $aZ3HH.objectToBaggageHeader;
module.exports.parseBaggageHeader = $aZ3HH.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $dBuCl.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $dBuCl.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $dBuCl.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $dBuCl.isURLObjectRelative;
module.exports.parseStringToURLObject = $dBuCl.parseStringToURLObject;
module.exports.parseUrl = $dBuCl.parseUrl;
module.exports.stripDataUrlContent = $dBuCl.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $dBuCl.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $9eX4e._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $9eX4e.eventFromMessage;
module.exports.eventFromUnknownInput = $9eX4e.eventFromUnknownInput;
module.exports.exceptionFromError = $9eX4e.exceptionFromError;
module.exports.parseStackFrames = $9eX4e.parseStackFrames;
module.exports.LRUMap = $jFOY1.LRUMap;
module.exports.generateSpanId = $8tW2T.generateSpanId;
module.exports.generateTraceId = $8tW2T.generateTraceId;
module.exports.SDK_VERSION = $bOz44.SDK_VERSION;
module.exports.getDebugImagesForResources = $aIP8h.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $aIP8h.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $lFg4k.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $48AmV.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $hkF3C.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $hkF3C.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $hkF3C.withRandomSafeContext;
module.exports.getComponentName = $01r7k.getComponentName;
module.exports.getLocationHref = $01r7k.getLocationHref;
module.exports.htmlTreeAsString = $01r7k.htmlTreeAsString;

});
parcelRegister("eX8nW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $1cCOf = parcelRequire("1cCOf");

var $9OEq4 = parcelRequire("9OEq4");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");

var $h5H4c = parcelRequire("h5H4c");
let $ae2d1478f6435221$var$errorsInstrumented = false;
function $ae2d1478f6435221$var$registerSpanErrorInstrumentation() {
    if ($ae2d1478f6435221$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = $6vUrj.getActiveSpan();
        const rootSpan = activeSpan && $6vUrj.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $h5H4c.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    $ae2d1478f6435221$var$errorsInstrumented = true;
    $1cCOf.addGlobalErrorInstrumentationHandler(errorCallback);
    $9OEq4.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $ae2d1478f6435221$var$registerSpanErrorInstrumentation;

});
parcelRegister("3T29C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $2d482de677cff0bd$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $2d482de677cff0bd$var$DEBUG_BUILD;

});

parcelRegister("1cCOf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cqs9v = parcelRequire("cqs9v");

var $eCBhU = parcelRequire("eCBhU");
let $0e0504324afd11ac$var$_oldOnErrorHandler = null;
function $0e0504324afd11ac$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    $eCBhU.addHandler(type, handler);
    $eCBhU.maybeInstrument(type, $0e0504324afd11ac$var$instrumentError);
}
function $0e0504324afd11ac$var$instrumentError() {
    $0e0504324afd11ac$var$_oldOnErrorHandler = $cqs9v.GLOBAL_OBJ.onerror;
    $cqs9v.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $eCBhU.triggerHandlers("error", handlerData);
        if ($0e0504324afd11ac$var$_oldOnErrorHandler) return $0e0504324afd11ac$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $cqs9v.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $0e0504324afd11ac$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("cqs9v", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $90bdc02f7f46955f$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $90bdc02f7f46955f$var$GLOBAL_OBJ;

});

parcelRegister("eCBhU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $1nK9H = parcelRequire("1nK9H");
const $aa5189e8c33be6d7$var$handlers = {};
const $aa5189e8c33be6d7$var$instrumented = {};
function $aa5189e8c33be6d7$var$addHandler(type, handler) {
    $aa5189e8c33be6d7$var$handlers[type] = $aa5189e8c33be6d7$var$handlers[type] || [];
    $aa5189e8c33be6d7$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $aa5189e8c33be6d7$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $aa5189e8c33be6d7$var$resetInstrumentationHandlers() {
    Object.keys($aa5189e8c33be6d7$var$handlers).forEach((key)=>{
        $aa5189e8c33be6d7$var$handlers[key] = void 0;
    });
}
function $aa5189e8c33be6d7$var$maybeInstrument(type, instrumentFn) {
    if (!$aa5189e8c33be6d7$var$instrumented[type]) {
        $aa5189e8c33be6d7$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $aa5189e8c33be6d7$var$triggerHandlers(type, data) {
    const typeHandlers = type && $aa5189e8c33be6d7$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${$1nK9H.getFunctionName(handler)}
Error:`, e);
    }
}
module.exports.addHandler = $aa5189e8c33be6d7$var$addHandler;
module.exports.maybeInstrument = $aa5189e8c33be6d7$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $aa5189e8c33be6d7$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $aa5189e8c33be6d7$var$triggerHandlers;

});
parcelRegister("g31Ce", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");

var $3T29C = parcelRequire("3T29C");

var $cqs9v = parcelRequire("cqs9v");
const $baee2e0277344483$var$CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $baee2e0277344483$var$PREFIX = "Sentry Logger ";
const $baee2e0277344483$var$originalConsoleMethods = {};
function $baee2e0277344483$var$consoleSandbox(callback) {
    if (!("console" in $cqs9v.GLOBAL_OBJ)) return callback();
    const console = $cqs9v.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($baee2e0277344483$var$originalConsoleMethods);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $baee2e0277344483$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $baee2e0277344483$var$enable() {
    $baee2e0277344483$var$_getLoggerSettings().enabled = true;
}
function $baee2e0277344483$var$disable() {
    $baee2e0277344483$var$_getLoggerSettings().enabled = false;
}
function $baee2e0277344483$var$isEnabled() {
    return $baee2e0277344483$var$_getLoggerSettings().enabled;
}
function $baee2e0277344483$var$log(...args) {
    $baee2e0277344483$var$_maybeLog("log", ...args);
}
function $baee2e0277344483$var$warn(...args) {
    $baee2e0277344483$var$_maybeLog("warn", ...args);
}
function $baee2e0277344483$var$error(...args) {
    $baee2e0277344483$var$_maybeLog("error", ...args);
}
function $baee2e0277344483$var$_maybeLog(level, ...args) {
    if (!$3T29C.DEBUG_BUILD) return;
    if ($baee2e0277344483$var$isEnabled()) $baee2e0277344483$var$consoleSandbox(()=>{
        $cqs9v.GLOBAL_OBJ.console[level](`${$baee2e0277344483$var$PREFIX}[${level}]:`, ...args);
    });
}
function $baee2e0277344483$var$_getLoggerSettings() {
    if (!$3T29C.DEBUG_BUILD) return {
        enabled: false
    };
    return $du5vT.getGlobalSingleton("loggerSettings", ()=>({
            enabled: false
        }));
}
const $baee2e0277344483$var$debug = {
    enable: /** Enable logging. */ $baee2e0277344483$var$enable,
    disable: /** Disable logging. */ $baee2e0277344483$var$disable,
    isEnabled: /** Check if logging is enabled. */ $baee2e0277344483$var$isEnabled,
    log: /** Log a message. */ $baee2e0277344483$var$log,
    warn: /** Log a warning. */ $baee2e0277344483$var$warn,
    error: /** Log an error. */ $baee2e0277344483$var$error
};
module.exports.CONSOLE_LEVELS = $baee2e0277344483$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $baee2e0277344483$var$consoleSandbox;
module.exports.debug = $baee2e0277344483$var$debug;
module.exports.originalConsoleMethods = $baee2e0277344483$var$originalConsoleMethods;

});
parcelRegister("du5vT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bOz44 = parcelRequire("bOz44");

var $cqs9v = parcelRequire("cqs9v");
function $9d125a9112331993$var$getMainCarrier() {
    $9d125a9112331993$var$getSentryCarrier($cqs9v.GLOBAL_OBJ);
    return $cqs9v.GLOBAL_OBJ;
}
function $9d125a9112331993$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || $bOz44.SDK_VERSION;
    return __SENTRY__[$bOz44.SDK_VERSION] = __SENTRY__[$bOz44.SDK_VERSION] || {};
}
function $9d125a9112331993$var$getGlobalSingleton(name, creator, obj = $cqs9v.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$bOz44.SDK_VERSION] = __SENTRY__[$bOz44.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $9d125a9112331993$var$getGlobalSingleton;
module.exports.getMainCarrier = $9d125a9112331993$var$getMainCarrier;
module.exports.getSentryCarrier = $9d125a9112331993$var$getSentryCarrier;

});
parcelRegister("bOz44", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $899f905847bf7e36$var$SDK_VERSION = "10.76.2";
module.exports.SDK_VERSION = $899f905847bf7e36$var$SDK_VERSION;

});



parcelRegister("1nK9H", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $101bbded4daee7e7$var$STACKTRACE_FRAME_LIMIT = 50;
const $101bbded4daee7e7$var$UNKNOWN_FUNCTION = "?";
const $101bbded4daee7e7$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $101bbded4daee7e7$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $101bbded4daee7e7$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $101bbded4daee7e7$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($101bbded4daee7e7$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $101bbded4daee7e7$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $101bbded4daee7e7$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
function $101bbded4daee7e7$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $101bbded4daee7e7$var$createStackParser(...stackParser);
    return stackParser;
}
function $101bbded4daee7e7$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($101bbded4daee7e7$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($101bbded4daee7e7$var$STRIP_FRAME_REGEXP.test($101bbded4daee7e7$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($101bbded4daee7e7$var$STRIP_FRAME_REGEXP.test($101bbded4daee7e7$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $101bbded4daee7e7$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $101bbded4daee7e7$var$getLastStackFrame(localStack).filename,
            function: frame.function || $101bbded4daee7e7$var$UNKNOWN_FUNCTION
        }));
}
function $101bbded4daee7e7$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $101bbded4daee7e7$var$defaultFunctionName = "<anonymous>";
function $101bbded4daee7e7$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return $101bbded4daee7e7$var$defaultFunctionName;
        return fn.name || $101bbded4daee7e7$var$defaultFunctionName;
    } catch  {
        return $101bbded4daee7e7$var$defaultFunctionName;
    }
}
function $101bbded4daee7e7$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $101bbded4daee7e7$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $101bbded4daee7e7$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $101bbded4daee7e7$var$createStackParser;
module.exports.getFramesFromEvent = $101bbded4daee7e7$var$getFramesFromEvent;
module.exports.getFunctionName = $101bbded4daee7e7$var$getFunctionName;
module.exports.normalizeStackTracePath = $101bbded4daee7e7$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $101bbded4daee7e7$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $101bbded4daee7e7$var$stripSentryFramesAndReverse;

});



parcelRegister("9OEq4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cqs9v = parcelRequire("cqs9v");

var $eCBhU = parcelRequire("eCBhU");
let $7258230b1b3a55b1$var$_oldOnUnhandledRejectionHandler = null;
function $7258230b1b3a55b1$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    $eCBhU.addHandler(type, handler);
    $eCBhU.maybeInstrument(type, $7258230b1b3a55b1$var$instrumentUnhandledRejection);
}
function $7258230b1b3a55b1$var$instrumentUnhandledRejection() {
    $7258230b1b3a55b1$var$_oldOnUnhandledRejectionHandler = $cqs9v.GLOBAL_OBJ.onunhandledrejection;
    $cqs9v.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $eCBhU.triggerHandlers("unhandledrejection", handlerData);
        if ($7258230b1b3a55b1$var$_oldOnUnhandledRejectionHandler) return $7258230b1b3a55b1$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $cqs9v.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $7258230b1b3a55b1$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("6vUrj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tUnp = parcelRequire("3tUnp");

var $7DFGy = parcelRequire("7DFGy");

var $du5vT = parcelRequire("du5vT");

var $5JqSP = parcelRequire("5JqSP");

var $f3RkF = parcelRequire("f3RkF");

var $h5H4c = parcelRequire("h5H4c");

var $dDvZT = parcelRequire("dDvZT");

var $42zXR = parcelRequire("42zXR");

var $8tW2T = parcelRequire("8tW2T");

var $5L5uH = parcelRequire("5L5uH");

var $7O2T2 = parcelRequire("7O2T2");

var $g31Ce = parcelRequire("g31Ce");

var $6Uu3e = parcelRequire("6Uu3e");
const $0139502da7d050dc$var$TRACE_FLAG_NONE = 0;
const $0139502da7d050dc$var$TRACE_FLAG_SAMPLED = 1;
let $0139502da7d050dc$var$hasShownSpanDropWarning = false;
function $0139502da7d050dc$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $0139502da7d050dc$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $0139502da7d050dc$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $0139502da7d050dc$var$spanToJSON(span).parent_span_id;
    const scope = $dDvZT.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $8tW2T.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $0139502da7d050dc$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $0139502da7d050dc$var$spanIsSampled(span);
    return $7O2T2.generateSentryTraceHeader(traceId, spanId, sampled);
}
function $0139502da7d050dc$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $0139502da7d050dc$var$spanIsSampled(span);
    return $7O2T2.generateTraceparentHeader(traceId, spanId, sampled);
}
function $0139502da7d050dc$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $0139502da7d050dc$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $0139502da7d050dc$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $0139502da7d050dc$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return void 0;
}
function $0139502da7d050dc$var$spanTimeInputToSeconds(input) {
    if (typeof input === "number") return $0139502da7d050dc$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $0139502da7d050dc$var$ensureTimestampInSeconds(input.getTime());
    return $5L5uH.timestampInSeconds();
}
function $0139502da7d050dc$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $0139502da7d050dc$var$spanToJSON(span) {
    if ($0139502da7d050dc$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($0139502da7d050dc$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $0139502da7d050dc$var$getOtelParentSpanId(span),
            start_timestamp: $0139502da7d050dc$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $0139502da7d050dc$var$spanTimeInputToSeconds(endTime) || void 0,
            status: $0139502da7d050dc$var$getStatusMessage(status),
            op: attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $0139502da7d050dc$var$convertSpanLinksForEnvelope(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $0139502da7d050dc$var$spanToStreamedSpanJSON(span) {
    if ($0139502da7d050dc$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($0139502da7d050dc$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $0139502da7d050dc$var$getOtelParentSpanId(span),
            start_timestamp: $0139502da7d050dc$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $0139502da7d050dc$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $0139502da7d050dc$var$INTERNAL_getSegmentSpan(span),
            status: $0139502da7d050dc$var$getSimpleStatus(status),
            attributes: $0139502da7d050dc$var$addStatusMessageAttribute(attributes, status),
            links: $0139502da7d050dc$var$getStreamedSpanLinks(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $0139502da7d050dc$var$INTERNAL_getSegmentSpan(span)
    };
}
function $0139502da7d050dc$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $0139502da7d050dc$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $7DFGy.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $7DFGy.serializeAttributes(link.attributes)
            }))
    };
}
function $0139502da7d050dc$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $0139502da7d050dc$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $0139502da7d050dc$var$spanIsSampled(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $0139502da7d050dc$var$TRACE_FLAG_SAMPLED;
}
function $0139502da7d050dc$var$getStatusMessage(status) {
    if (!status || status.code === $h5H4c.SPAN_STATUS_UNSET) return void 0;
    if (status.code === $h5H4c.SPAN_STATUS_OK) return "ok";
    return status.message || "internal_error";
}
function $0139502da7d050dc$var$getSimpleStatus(status) {
    return !status || status.code === $h5H4c.SPAN_STATUS_OK || status.code === $h5H4c.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
}
function $0139502da7d050dc$var$addStatusMessageAttribute(attributes, status) {
    const statusMessage = $0139502da7d050dc$var$getSimpleStatus(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE]: statusMessage
        },
        ...attributes
    };
}
const $0139502da7d050dc$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $0139502da7d050dc$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $0139502da7d050dc$var$addChildSpanToSpan(span, childSpan) {
    const rootSpan = span[$0139502da7d050dc$var$ROOT_SPAN_FIELD] || span;
    $42zXR.addNonEnumerableProperty(childSpan, $0139502da7d050dc$var$ROOT_SPAN_FIELD, rootSpan);
    if (!$0139502da7d050dc$var$spanIsSampled(span)) return;
    if (!span.isRecording() && !rootSpan.isRecording()) return;
    if (span[$0139502da7d050dc$var$CHILD_SPANS_FIELD]) span[$0139502da7d050dc$var$CHILD_SPANS_FIELD].add(childSpan);
    else $42zXR.addNonEnumerableProperty(span, $0139502da7d050dc$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $0139502da7d050dc$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$0139502da7d050dc$var$CHILD_SPANS_FIELD]) span[$0139502da7d050dc$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $0139502da7d050dc$var$getSpanDescendants(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($0139502da7d050dc$var$spanIsSampled(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$0139502da7d050dc$var$CHILD_SPANS_FIELD] ? Array.from(span2[$0139502da7d050dc$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $0139502da7d050dc$var$getRootSpan = $0139502da7d050dc$var$INTERNAL_getSegmentSpan;
function $0139502da7d050dc$var$INTERNAL_getSegmentSpan(span) {
    return span[$0139502da7d050dc$var$ROOT_SPAN_FIELD] || span;
}
function $0139502da7d050dc$var$getActiveSpan() {
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $6Uu3e._getSpanForScope($5JqSP.getCurrentScope());
}
function $0139502da7d050dc$var$showSpanDropWarning() {
    if (!$0139502da7d050dc$var$hasShownSpanDropWarning) {
        $g31Ce.consoleSandbox(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $0139502da7d050dc$var$hasShownSpanDropWarning = true;
    }
}
function $0139502da7d050dc$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $0139502da7d050dc$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $0139502da7d050dc$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $0139502da7d050dc$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $0139502da7d050dc$var$addChildSpanToSpan;
module.exports.addStatusMessageAttribute = $0139502da7d050dc$var$addStatusMessageAttribute;
module.exports.convertSpanLinksForEnvelope = $0139502da7d050dc$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $0139502da7d050dc$var$getActiveSpan;
module.exports.getRootSpan = $0139502da7d050dc$var$getRootSpan;
module.exports.getSimpleStatus = $0139502da7d050dc$var$getSimpleStatus;
module.exports.getSpanDescendants = $0139502da7d050dc$var$getSpanDescendants;
module.exports.getStatusMessage = $0139502da7d050dc$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $0139502da7d050dc$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $0139502da7d050dc$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $0139502da7d050dc$var$showSpanDropWarning;
module.exports.spanIsSampled = $0139502da7d050dc$var$spanIsSampled;
module.exports.spanIsSentrySpan = $0139502da7d050dc$var$spanIsSentrySpan;
module.exports.spanTimeInputToSeconds = $0139502da7d050dc$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $0139502da7d050dc$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $0139502da7d050dc$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $0139502da7d050dc$var$spanToTraceContext;
module.exports.spanToTraceHeader = $0139502da7d050dc$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $0139502da7d050dc$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $0139502da7d050dc$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $0139502da7d050dc$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $0139502da7d050dc$var$updateSpanName;

});
parcelRegister("3tUnp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");

var $5ARfg = parcelRequire("5ARfg");
function $288fcfb7ac7b2551$var$setAsyncContextStrategy(strategy) {
    const registry = $du5vT.getMainCarrier();
    const sentry = $du5vT.getSentryCarrier(registry);
    sentry.acs = strategy;
}
function $288fcfb7ac7b2551$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $du5vT.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    return $5ARfg.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $288fcfb7ac7b2551$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $288fcfb7ac7b2551$var$setAsyncContextStrategy;

});
parcelRegister("5ARfg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lhzyP = parcelRequire("lhzyP");

var $fTFTk = parcelRequire("fTFTk");

var $6sseM = parcelRequire("6sseM");

var $cUgOr = parcelRequire("cUgOr");

var $du5vT = parcelRequire("du5vT");
class $41299de80defac8e$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $fTFTk.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $fTFTk.Scope();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($cUgOr.isThenable(maybePromiseResult)) return $6sseM.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $41299de80defac8e$var$getAsyncContextStack() {
    const registry = $du5vT.getMainCarrier();
    const sentry = $du5vT.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $41299de80defac8e$var$AsyncContextStack($lhzyP.getDefaultCurrentScope(), $lhzyP.getDefaultIsolationScope());
}
function $41299de80defac8e$var$withScope(callback) {
    return $41299de80defac8e$var$getAsyncContextStack().withScope(callback);
}
function $41299de80defac8e$var$withSetScope(scope, callback) {
    const stack = $41299de80defac8e$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $41299de80defac8e$var$withIsolationScope(callback) {
    return $41299de80defac8e$var$getAsyncContextStack().withScope(()=>{
        return callback($41299de80defac8e$var$getAsyncContextStack().getIsolationScope());
    });
}
function $41299de80defac8e$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $41299de80defac8e$var$withIsolationScope,
        withScope: $41299de80defac8e$var$withScope,
        withSetScope: $41299de80defac8e$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $41299de80defac8e$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$41299de80defac8e$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$41299de80defac8e$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $41299de80defac8e$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $41299de80defac8e$var$getStackAsyncContextStrategy;

});
parcelRegister("lhzyP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");

var $fTFTk = parcelRequire("fTFTk");
function $f7e6c51c8f7f23ac$var$getDefaultCurrentScope() {
    return $du5vT.getGlobalSingleton("defaultCurrentScope", ()=>new $fTFTk.Scope());
}
function $f7e6c51c8f7f23ac$var$getDefaultIsolationScope() {
    return $du5vT.getGlobalSingleton("defaultIsolationScope", ()=>new $fTFTk.Scope());
}
module.exports.getDefaultCurrentScope = $f7e6c51c8f7f23ac$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $f7e6c51c8f7f23ac$var$getDefaultIsolationScope;

});
parcelRegister("fTFTk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $8OOjj = parcelRequire("8OOjj");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $4ty0t = parcelRequire("4ty0t");

var $rzjlZ = parcelRequire("rzjlZ");

var $8tW2T = parcelRequire("8tW2T");

var $hkF3C = parcelRequire("hkF3C");

var $6Uu3e = parcelRequire("6Uu3e");

var $foFxi = parcelRequire("foFxi");

var $5L5uH = parcelRequire("5L5uH");
const $b92c7cceddef7346$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $b92c7cceddef7346$var$Scope {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $8tW2T.generateTraceId(),
            sampleRand: $hkF3C.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $b92c7cceddef7346$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $6Uu3e._setSpanForScope(newScope, $6Uu3e._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) $8OOjj.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $b92c7cceddef7346$var$Scope ? scopeToMerge.getScopeData() : $cUgOr.isPlainObject(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   *
   * @deprecated This method will be removed in v11. To reset scope state, re-initialize the SDK or run
   * your code in a fresh scope via `withScope` instead.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        $6Uu3e._setSpanForScope(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $8tW2T.generateTraceId(),
            sampleRand: $hkF3C.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $b92c7cceddef7346$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $5L5uH.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $foFxi.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $6Uu3e._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $4ty0t.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $rzjlZ.uuid4();
        if (!this._client) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $rzjlZ.uuid4();
        if (!this._client) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $rzjlZ.uuid4();
        if (!this._client) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $b92c7cceddef7346$var$Scope;

});
parcelRegister("8OOjj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $rzjlZ = parcelRequire("rzjlZ");

var $5L5uH = parcelRequire("5L5uH");
function $66ba04d85bff3445$var$makeSession(context) {
    const startingTime = $5L5uH.timestampInSeconds();
    const session = {
        sid: $rzjlZ.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$66ba04d85bff3445$var$sessionToJSON(session)
    };
    if (context) $66ba04d85bff3445$var$updateSession(session, context);
    return session;
}
function $66ba04d85bff3445$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $5L5uH.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : $rzjlZ.uuid4();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $66ba04d85bff3445$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $66ba04d85bff3445$var$updateSession(session, context);
}
function $66ba04d85bff3445$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $66ba04d85bff3445$var$closeSession;
module.exports.makeSession = $66ba04d85bff3445$var$makeSession;
module.exports.updateSession = $66ba04d85bff3445$var$updateSession;

});
parcelRegister("rzjlZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");

var $hkF3C = parcelRequire("hkF3C");

var $foFxi = parcelRequire("foFxi");

var $cqs9v = parcelRequire("cqs9v");
function $052de9ca810d3b4b$var$getCrypto() {
    const gbl = $cqs9v.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $052de9ca810d3b4b$var$emptyUuid;
function $052de9ca810d3b4b$var$getRandomByte() {
    return $hkF3C.safeMathRandom() * 16;
}
function $052de9ca810d3b4b$var$uuid4(crypto = $052de9ca810d3b4b$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return $hkF3C.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$052de9ca810d3b4b$var$emptyUuid) $052de9ca810d3b4b$var$emptyUuid = "10000000100040008000100000000000";
    return $052de9ca810d3b4b$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($052de9ca810d3b4b$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $052de9ca810d3b4b$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $052de9ca810d3b4b$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $052de9ca810d3b4b$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $052de9ca810d3b4b$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $052de9ca810d3b4b$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $052de9ca810d3b4b$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $052de9ca810d3b4b$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $052de9ca810d3b4b$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $052de9ca810d3b4b$var$parseSemver(input) {
    const match = input.match($052de9ca810d3b4b$var$SEMVER_REGEXP) || [];
    const major = $052de9ca810d3b4b$var$_parseInt(match[1]);
    const minor = $052de9ca810d3b4b$var$_parseInt(match[2]);
    const patch = $052de9ca810d3b4b$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $052de9ca810d3b4b$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$foFxi.snipLine(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = $foFxi.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$foFxi.snipLine(line, 0));
}
function $052de9ca810d3b4b$var$checkOrSetAlreadyCaught(exception) {
    if ($052de9ca810d3b4b$var$isAlreadyCaptured(exception)) return true;
    try {
        $42zXR.addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $052de9ca810d3b4b$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}
module.exports.addContextToFrame = $052de9ca810d3b4b$var$addContextToFrame;
module.exports.addExceptionMechanism = $052de9ca810d3b4b$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $052de9ca810d3b4b$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $052de9ca810d3b4b$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $052de9ca810d3b4b$var$getEventDescription;
module.exports.isAlreadyCaptured = $052de9ca810d3b4b$var$isAlreadyCaptured;
module.exports.parseSemver = $052de9ca810d3b4b$var$parseSemver;
module.exports.uuid4 = $052de9ca810d3b4b$var$uuid4;

});
parcelRegister("42zXR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");
function $2f133f1db6540c46$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $2f133f1db6540c46$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
function $2f133f1db6540c46$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $2f133f1db6540c46$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $2f133f1db6540c46$var$addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $2f133f1db6540c46$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($2f133f1db6540c46$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $2f133f1db6540c46$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $2f133f1db6540c46$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
function $2f133f1db6540c46$var$convertToPlainObject(value) {
    if ($cUgOr.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$2f133f1db6540c46$var$getOwnProperties(value)
    };
    if ($cUgOr.isEvent(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$2f133f1db6540c46$var$getOwnProperties(value)
        };
    }
    return value;
}
function $2f133f1db6540c46$var$getOwnProperties(obj) {
    if ($cUgOr.isObjectLike(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $2f133f1db6540c46$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($2f133f1db6540c46$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $2f133f1db6540c46$var$dropUndefinedKeys(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $2f133f1db6540c46$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $2f133f1db6540c46$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($2f133f1db6540c46$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($2f133f1db6540c46$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $2f133f1db6540c46$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $2f133f1db6540c46$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $2f133f1db6540c46$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $cUgOr.isPrimitive(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $2f133f1db6540c46$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $2f133f1db6540c46$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $2f133f1db6540c46$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $2f133f1db6540c46$var$extractExceptionKeysForMessage;
module.exports.fill = $2f133f1db6540c46$var$fill;
module.exports.getOriginalFunction = $2f133f1db6540c46$var$getOriginalFunction;
module.exports.markFunctionWrapped = $2f133f1db6540c46$var$markFunctionWrapped;
module.exports.objectify = $2f133f1db6540c46$var$objectify;
module.exports.wrapMethod = $2f133f1db6540c46$var$wrapMethod;

});
parcelRegister("cUgOr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $9657c1a387c3e228$var$objectToString = Object.prototype.toString;
function $9657c1a387c3e228$var$isError(wat) {
    switch($9657c1a387c3e228$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $9657c1a387c3e228$var$isInstanceOf(wat, Error);
    }
}
function $9657c1a387c3e228$var$isBuiltin(wat, className) {
    return $9657c1a387c3e228$var$objectToString.call(wat) === `[object ${className}]`;
}
function $9657c1a387c3e228$var$isErrorEvent(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "ErrorEvent");
}
function $9657c1a387c3e228$var$isDOMError(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "DOMError");
}
function $9657c1a387c3e228$var$isDOMException(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "DOMException");
}
function $9657c1a387c3e228$var$isString(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "String");
}
function $9657c1a387c3e228$var$isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $9657c1a387c3e228$var$isPrimitive(wat) {
    return wat === null || $9657c1a387c3e228$var$isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $9657c1a387c3e228$var$isPlainObject(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "Object");
}
function $9657c1a387c3e228$var$isObjectLike(wat) {
    return typeof wat === "object" && wat !== null;
}
function $9657c1a387c3e228$var$isEvent(wat) {
    return typeof Event !== "undefined" && $9657c1a387c3e228$var$isInstanceOf(wat, Event);
}
function $9657c1a387c3e228$var$isElement(wat) {
    return typeof Element !== "undefined" && $9657c1a387c3e228$var$isInstanceOf(wat, Element);
}
function $9657c1a387c3e228$var$isRegExp(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "RegExp");
}
function $9657c1a387c3e228$var$isThenable(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $9657c1a387c3e228$var$isSyntheticEvent(wat) {
    return $9657c1a387c3e228$var$isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $9657c1a387c3e228$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $9657c1a387c3e228$var$isVueViewModel(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $9657c1a387c3e228$var$isRequest(request) {
    return typeof Request !== "undefined" && $9657c1a387c3e228$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $9657c1a387c3e228$var$isDOMError;
module.exports.isDOMException = $9657c1a387c3e228$var$isDOMException;
module.exports.isElement = $9657c1a387c3e228$var$isElement;
module.exports.isError = $9657c1a387c3e228$var$isError;
module.exports.isErrorEvent = $9657c1a387c3e228$var$isErrorEvent;
module.exports.isEvent = $9657c1a387c3e228$var$isEvent;
module.exports.isInstanceOf = $9657c1a387c3e228$var$isInstanceOf;
module.exports.isObjectLike = $9657c1a387c3e228$var$isObjectLike;
module.exports.isParameterizedString = $9657c1a387c3e228$var$isParameterizedString;
module.exports.isPlainObject = $9657c1a387c3e228$var$isPlainObject;
module.exports.isPrimitive = $9657c1a387c3e228$var$isPrimitive;
module.exports.isRegExp = $9657c1a387c3e228$var$isRegExp;
module.exports.isRequest = $9657c1a387c3e228$var$isRequest;
module.exports.isString = $9657c1a387c3e228$var$isString;
module.exports.isSyntheticEvent = $9657c1a387c3e228$var$isSyntheticEvent;
module.exports.isThenable = $9657c1a387c3e228$var$isThenable;
module.exports.isVueViewModel = $9657c1a387c3e228$var$isVueViewModel;

});


parcelRegister("hkF3C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cqs9v = parcelRequire("cqs9v");
let $c9e427130d9269a0$var$RESOLVED_RUNNER;
function $c9e427130d9269a0$var$withRandomSafeContext(cb) {
    if ($c9e427130d9269a0$var$RESOLVED_RUNNER !== void 0) return $c9e427130d9269a0$var$RESOLVED_RUNNER ? $c9e427130d9269a0$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = $cqs9v.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $c9e427130d9269a0$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $c9e427130d9269a0$var$RESOLVED_RUNNER(cb);
    }
    $c9e427130d9269a0$var$RESOLVED_RUNNER = null;
    return cb();
}
function $c9e427130d9269a0$var$safeMathRandom() {
    return $c9e427130d9269a0$var$withRandomSafeContext(()=>Math.random());
}
function $c9e427130d9269a0$var$safeDateNow() {
    return $c9e427130d9269a0$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $c9e427130d9269a0$var$safeDateNow;
module.exports.safeMathRandom = $c9e427130d9269a0$var$safeMathRandom;
module.exports.withRandomSafeContext = $c9e427130d9269a0$var$withRandomSafeContext;

});

parcelRegister("foFxi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");

var $9EvIV = parcelRequire("9EvIV");
function $b3595115c73b2dc9$var$stringify(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $b3595115c73b2dc9$var$truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $b3595115c73b2dc9$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $b3595115c73b2dc9$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ($cUgOr.isPrimitive(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push($9EvIV.stringifyValue(void 0, value));
    }
    return output.join(delimiter);
}
function $b3595115c73b2dc9$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$cUgOr.isString(value)) return false;
    if ($cUgOr.isRegExp(pattern)) return pattern.test(value);
    if ($cUgOr.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $b3595115c73b2dc9$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($b3595115c73b2dc9$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $b3595115c73b2dc9$var$isMatchingPattern;
module.exports.safeJoin = $b3595115c73b2dc9$var$safeJoin;
module.exports.snipLine = $b3595115c73b2dc9$var$snipLine;
module.exports.stringMatchesSomePattern = $b3595115c73b2dc9$var$stringMatchesSomePattern;
module.exports.stringify = $b3595115c73b2dc9$var$stringify;
module.exports.truncate = $b3595115c73b2dc9$var$truncate;

});
parcelRegister("9EvIV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fQMpe = parcelRequire("fQMpe");

var $42zXR = parcelRequire("42zXR");

var $1nK9H = parcelRequire("1nK9H");
let $7070751abfdd78c2$var$stringifier;
function $7070751abfdd78c2$var$setNormalizeStringifier(newStringifier) {
    $7070751abfdd78c2$var$stringifier = newStringifier;
}
function $7070751abfdd78c2$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        return $7070751abfdd78c2$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $7070751abfdd78c2$var$normalizeToSize(object, depth = 3, maxSize = 102400) {
    const normalized = $7070751abfdd78c2$var$normalize(object, depth);
    if ($7070751abfdd78c2$var$jsonSize(normalized) > maxSize) return $7070751abfdd78c2$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
function $7070751abfdd78c2$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $7070751abfdd78c2$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $7070751abfdd78c2$var$stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ($fQMpe.hasSkipNormalizationHint(value)) return value;
    const overrideDepth = $fQMpe.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $7070751abfdd78c2$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = $42zXR.convertToPlainObject(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $7070751abfdd78c2$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $7070751abfdd78c2$var$stringifyValue(key, value) {
    try {
        if ($7070751abfdd78c2$var$stringifier) {
            const stringified = $7070751abfdd78c2$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${$1nK9H.getFunctionName(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $7070751abfdd78c2$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $7070751abfdd78c2$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $7070751abfdd78c2$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $7070751abfdd78c2$var$jsonSize(value) {
    return $7070751abfdd78c2$var$utf8Length(JSON.stringify(value));
}
function $7070751abfdd78c2$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $7070751abfdd78c2$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $7070751abfdd78c2$var$normalize;
module.exports.normalizeToSize = $7070751abfdd78c2$var$normalizeToSize;
module.exports.normalizeUrlToBase = $7070751abfdd78c2$var$normalizeUrlToBase;
module.exports.setNormalizeStringifier = $7070751abfdd78c2$var$setNormalizeStringifier;
module.exports.stringifyValue = $7070751abfdd78c2$var$stringifyValue;

});
parcelRegister("fQMpe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");
const $b8a142bff366f410$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $b8a142bff366f410$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $b8a142bff366f410$var$setSkipNormalizationHint(obj) {
    $42zXR.addNonEnumerableProperty(obj, $b8a142bff366f410$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $b8a142bff366f410$var$setNormalizationDepthOverrideHint(obj, depth) {
    $42zXR.addNonEnumerableProperty(obj, $b8a142bff366f410$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $b8a142bff366f410$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$b8a142bff366f410$var$SENTRY_SKIP_NORMALIZATION]);
}
function $b8a142bff366f410$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$b8a142bff366f410$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}
module.exports.getNormalizationDepthOverrideHint = $b8a142bff366f410$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $b8a142bff366f410$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $b8a142bff366f410$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $b8a142bff366f410$var$setSkipNormalizationHint;

});




parcelRegister("5L5uH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hkF3C = parcelRequire("hkF3C");

var $cqs9v = parcelRequire("cqs9v");
const $43159a8cc4d802e2$var$ONE_SECOND_IN_MS = 1e3;
function $43159a8cc4d802e2$var$dateTimestampInSeconds() {
    return $hkF3C.safeDateNow() / $43159a8cc4d802e2$var$ONE_SECOND_IN_MS;
}
function $43159a8cc4d802e2$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $cqs9v.GLOBAL_OBJ;
    if (!performance?.now || !performance.timeOrigin) return $43159a8cc4d802e2$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + $hkF3C.withRandomSafeContext(()=>performance.now())) / $43159a8cc4d802e2$var$ONE_SECOND_IN_MS;
    };
}
let $43159a8cc4d802e2$var$_cachedTimestampInSeconds;
function $43159a8cc4d802e2$var$timestampInSeconds() {
    const func = $43159a8cc4d802e2$var$_cachedTimestampInSeconds ?? ($43159a8cc4d802e2$var$_cachedTimestampInSeconds = $43159a8cc4d802e2$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $43159a8cc4d802e2$var$cachedTimeOrigin = null;
function $43159a8cc4d802e2$var$getBrowserTimeOrigin() {
    const { performance: performance } = $cqs9v.GLOBAL_OBJ;
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = $hkF3C.withRandomSafeContext(()=>performance.now());
    const dateNow = $hkF3C.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $43159a8cc4d802e2$var$browserPerformanceTimeOrigin() {
    if ($43159a8cc4d802e2$var$cachedTimeOrigin === null) $43159a8cc4d802e2$var$cachedTimeOrigin = $43159a8cc4d802e2$var$getBrowserTimeOrigin();
    return $43159a8cc4d802e2$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $43159a8cc4d802e2$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $43159a8cc4d802e2$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $43159a8cc4d802e2$var$timestampInSeconds;

});


parcelRegister("4ty0t", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $34243fdcb1b8eefc$var$merge(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $34243fdcb1b8eefc$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $34243fdcb1b8eefc$var$merge;

});

parcelRegister("8tW2T", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $rzjlZ = parcelRequire("rzjlZ");
function $62ce0ecfa1927b33$var$generateTraceId() {
    return $rzjlZ.uuid4();
}
function $62ce0ecfa1927b33$var$generateSpanId() {
    return $rzjlZ.uuid4().substring(16);
}
module.exports.generateSpanId = $62ce0ecfa1927b33$var$generateSpanId;
module.exports.generateTraceId = $62ce0ecfa1927b33$var$generateTraceId;

});

parcelRegister("6Uu3e", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");

var $2adP5 = parcelRequire("2adP5");
const $507f489210a81073$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $507f489210a81073$var$_setSpanForScope(scope, span) {
    if (span) $42zXR.addNonEnumerableProperty(scope, $507f489210a81073$var$SCOPE_SPAN_FIELD, $2adP5.makeWeakRef(span));
    else delete scope[$507f489210a81073$var$SCOPE_SPAN_FIELD];
}
function $507f489210a81073$var$_getSpanForScope(scope) {
    return $2adP5.derefWeakRef(scope[$507f489210a81073$var$SCOPE_SPAN_FIELD]);
}
module.exports._getSpanForScope = $507f489210a81073$var$_getSpanForScope;
module.exports._setSpanForScope = $507f489210a81073$var$_setSpanForScope;

});
parcelRegister("2adP5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cqs9v = parcelRequire("cqs9v");
function $19373ceb3edf88b5$var$makeWeakRef(value) {
    try {
        const WeakRefImpl = $cqs9v.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $19373ceb3edf88b5$var$derefWeakRef(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}
module.exports.derefWeakRef = $19373ceb3edf88b5$var$derefWeakRef;
module.exports.makeWeakRef = $19373ceb3edf88b5$var$makeWeakRef;

});




parcelRegister("6sseM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $4b3b42f24caf0bc4$var$isActualPromise = (p)=>p instanceof Promise && !p[$4b3b42f24caf0bc4$var$kChainedCopy];
const $4b3b42f24caf0bc4$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $4b3b42f24caf0bc4$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $4b3b42f24caf0bc4$var$isActualPromise(chained) && $4b3b42f24caf0bc4$var$isActualPromise(original) ? chained : $4b3b42f24caf0bc4$var$copyProps(original, chained);
};
const $4b3b42f24caf0bc4$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$4b3b42f24caf0bc4$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $4b3b42f24caf0bc4$var$chainAndCopyPromiseLike;

});



parcelRegister("7DFGy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");
function $58fc82c09605267a$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $58fc82c09605267a$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $58fc82c09605267a$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $58fc82c09605267a$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $58fc82c09605267a$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $58fc82c09605267a$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $58fc82c09605267a$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $58fc82c09605267a$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($cUgOr.isPrimitive(val)) weight += $58fc82c09605267a$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $58fc82c09605267a$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $58fc82c09605267a$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $58fc82c09605267a$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $58fc82c09605267a$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $58fc82c09605267a$var$isAttributeObject;
module.exports.serializeAttributes = $58fc82c09605267a$var$serializeAttributes;

});

parcelRegister("5JqSP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tUnp = parcelRequire("3tUnp");

var $du5vT = parcelRequire("du5vT");

var $fTFTk = parcelRequire("fTFTk");

var $8tW2T = parcelRequire("8tW2T");
let $42c6023278febdcd$var$_externalPropagationContextProvider;
function $42c6023278febdcd$var$registerExternalPropagationContext(fn) {
    $42c6023278febdcd$var$_externalPropagationContextProvider = fn;
}
function $42c6023278febdcd$var$getExternalPropagationContext() {
    return $42c6023278febdcd$var$_externalPropagationContextProvider?.();
}
function $42c6023278febdcd$var$hasExternalPropagationContext() {
    return $42c6023278febdcd$var$_externalPropagationContextProvider !== void 0;
}
function $42c6023278febdcd$var$getCurrentScope() {
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
function $42c6023278febdcd$var$getIsolationScope() {
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
function $42c6023278febdcd$var$getGlobalScope() {
    return $du5vT.getGlobalSingleton("globalScope", ()=>new $fTFTk.Scope());
}
function $42c6023278febdcd$var$withScope(...rest) {
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $42c6023278febdcd$var$withIsolationScope(...rest) {
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $42c6023278febdcd$var$getClient() {
    return $42c6023278febdcd$var$getCurrentScope().getClient();
}
function $42c6023278febdcd$var$getTraceContextFromScope(scope) {
    const externalContext = $42c6023278febdcd$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $8tW2T.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $42c6023278febdcd$var$getClient;
module.exports.getCurrentScope = $42c6023278febdcd$var$getCurrentScope;
module.exports.getExternalPropagationContext = $42c6023278febdcd$var$getExternalPropagationContext;
module.exports.getGlobalScope = $42c6023278febdcd$var$getGlobalScope;
module.exports.getIsolationScope = $42c6023278febdcd$var$getIsolationScope;
module.exports.getTraceContextFromScope = $42c6023278febdcd$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $42c6023278febdcd$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $42c6023278febdcd$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $42c6023278febdcd$var$withIsolationScope;
module.exports.withScope = $42c6023278febdcd$var$withScope;

});

parcelRegister("f3RkF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = "sentry.status.message";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const $af708185da4792c9$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const $af708185da4792c9$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $af708185da4792c9$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $af708185da4792c9$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("h5H4c", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c7144f765c0d780b$var$SPAN_STATUS_UNSET = 0;
const $c7144f765c0d780b$var$SPAN_STATUS_OK = 1;
const $c7144f765c0d780b$var$SPAN_STATUS_ERROR = 2;
function $c7144f765c0d780b$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $c7144f765c0d780b$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
function $c7144f765c0d780b$var$setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $c7144f765c0d780b$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $c7144f765c0d780b$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $c7144f765c0d780b$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $c7144f765c0d780b$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $c7144f765c0d780b$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $c7144f765c0d780b$var$setHttpStatus;

});

parcelRegister("dDvZT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");

var $2adP5 = parcelRequire("2adP5");
const $9ed7bcdda0d6e774$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $9ed7bcdda0d6e774$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $9ed7bcdda0d6e774$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $9ed7bcdda0d6e774$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $9ed7bcdda0d6e774$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $9ed7bcdda0d6e774$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $42zXR.addNonEnumerableProperty(span, $9ed7bcdda0d6e774$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $2adP5.makeWeakRef(isolationScope));
        $42zXR.addNonEnumerableProperty(span, $9ed7bcdda0d6e774$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $9ed7bcdda0d6e774$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$9ed7bcdda0d6e774$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $2adP5.derefWeakRef(spanWithScopes[$9ed7bcdda0d6e774$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $9ed7bcdda0d6e774$var$markSpanForOtelSourceInference(span) {
    $42zXR.addNonEnumerableProperty(span, $9ed7bcdda0d6e774$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $9ed7bcdda0d6e774$var$spanShouldInferOtelSource(span) {
    return span[$9ed7bcdda0d6e774$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $9ed7bcdda0d6e774$var$markSpanSourceAsExplicit(span) {
    $42zXR.addNonEnumerableProperty(span, $9ed7bcdda0d6e774$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $9ed7bcdda0d6e774$var$spanSourceWasExplicitlySet(span) {
    return span[$9ed7bcdda0d6e774$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $9ed7bcdda0d6e774$var$markSpanAsTracerProviderSpan(span) {
    $42zXR.addNonEnumerableProperty(span, $9ed7bcdda0d6e774$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $9ed7bcdda0d6e774$var$spanIsTracerProviderSpan(span) {
    return span[$9ed7bcdda0d6e774$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}
module.exports.getCapturedScopesOnSpan = $9ed7bcdda0d6e774$var$getCapturedScopesOnSpan;
module.exports.markSpanAsTracerProviderSpan = $9ed7bcdda0d6e774$var$markSpanAsTracerProviderSpan;
module.exports.markSpanForOtelSourceInference = $9ed7bcdda0d6e774$var$markSpanForOtelSourceInference;
module.exports.markSpanSourceAsExplicit = $9ed7bcdda0d6e774$var$markSpanSourceAsExplicit;
module.exports.setCapturedScopesOnSpan = $9ed7bcdda0d6e774$var$setCapturedScopesOnSpan;
module.exports.spanIsTracerProviderSpan = $9ed7bcdda0d6e774$var$spanIsTracerProviderSpan;
module.exports.spanShouldInferOtelSource = $9ed7bcdda0d6e774$var$spanShouldInferOtelSource;
module.exports.spanSourceWasExplicitlySet = $9ed7bcdda0d6e774$var$spanSourceWasExplicitlySet;

});

parcelRegister("7O2T2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g31Ce = parcelRequire("g31Ce");

var $aZ3HH = parcelRequire("aZ3HH");

var $3zkbY = parcelRequire("3zkbY");

var $5CFT4 = parcelRequire("5CFT4");

var $8tW2T = parcelRequire("8tW2T");

var $hkF3C = parcelRequire("hkF3C");
const $5aef712847bf836f$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $5aef712847bf836f$var$extractTraceparentData(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($5aef712847bf836f$var$TRACEPARENT_REGEXP);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $5aef712847bf836f$var$isContinuingTrace(propagationContext) {
    return !!propagationContext.parentSpanId || !!propagationContext.dsc;
}
function $5aef712847bf836f$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $5aef712847bf836f$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $aZ3HH.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $8tW2T.generateTraceId(),
        sampleRand: $hkF3C.safeMathRandom()
    };
    const sampleRand = $5aef712847bf836f$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $5aef712847bf836f$var$generateSentryTraceHeader(traceId = $8tW2T.generateTraceId(), spanId = $8tW2T.generateSpanId(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $5aef712847bf836f$var$generateTraceparentHeader(traceId = $8tW2T.generateTraceId(), spanId = $8tW2T.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $5aef712847bf836f$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = $5CFT4.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = $5CFT4.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    $hkF3C.safeMathRandom() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + $hkF3C.safeMathRandom() * (1 - parsedSampleRate);
    else return $hkF3C.safeMathRandom();
}
function $5aef712847bf836f$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $3zkbY.extractOrgIdFromClient(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $g31Ce.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $g31Ce.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $5aef712847bf836f$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $5aef712847bf836f$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $5aef712847bf836f$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $5aef712847bf836f$var$generateTraceparentHeader;
module.exports.isContinuingTrace = $5aef712847bf836f$var$isContinuingTrace;
module.exports.propagationContextFromHeaders = $5aef712847bf836f$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $5aef712847bf836f$var$shouldContinueTrace;

});
parcelRegister("aZ3HH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");
const $7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const $7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const $7ff2796312ccd2d8$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
function $7ff2796312ccd2d8$var$baggageHeaderToDynamicSamplingContext(baggageHeader) {
    const baggageObject = $7ff2796312ccd2d8$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $7ff2796312ccd2d8$var$dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $7ff2796312ccd2d8$var$objectToBaggageHeader(sentryPrefixedDSC);
}
function $7ff2796312ccd2d8$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$cUgOr.isString(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $7ff2796312ccd2d8$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $7ff2796312ccd2d8$var$baggageHeaderToObject(baggageHeader);
}
function $7ff2796312ccd2d8$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $7ff2796312ccd2d8$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $7ff2796312ccd2d8$var$MAX_BAGGAGE_STRING_LENGTH) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $7ff2796312ccd2d8$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $7ff2796312ccd2d8$var$parseBaggageHeader(existing);
    const incomingEntries = $7ff2796312ccd2d8$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $7ff2796312ccd2d8$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $7ff2796312ccd2d8$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $7ff2796312ccd2d8$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $7ff2796312ccd2d8$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $7ff2796312ccd2d8$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $7ff2796312ccd2d8$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $7ff2796312ccd2d8$var$parseBaggageHeader;

});

parcelRegister("3zkbY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");
const $29944db88c851502$var$ORG_ID_REGEX = /^o(\d+)\./;
const $29944db88c851502$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $29944db88c851502$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $29944db88c851502$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $29944db88c851502$var$dsnFromString(str) {
    const match = $29944db88c851502$var$DSN_REGEX.exec(str);
    if (!match) {
        $g31Ce.consoleSandbox(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $29944db88c851502$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $29944db88c851502$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $29944db88c851502$var$validateDsn(dsn) {
    if (!$3T29C.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $g31Ce.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $g31Ce.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$29944db88c851502$var$isValidProtocol(protocol)) {
        $g31Ce.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $g31Ce.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $29944db88c851502$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($29944db88c851502$var$ORG_ID_REGEX);
    return match?.[1];
}
function $29944db88c851502$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $29944db88c851502$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
function $29944db88c851502$var$makeDsn(from) {
    const components = typeof from === "string" ? $29944db88c851502$var$dsnFromString(from) : $29944db88c851502$var$dsnFromComponents(from);
    if (!components || !$29944db88c851502$var$validateDsn(components)) return void 0;
    return components;
}
module.exports.dsnFromString = $29944db88c851502$var$dsnFromString;
module.exports.dsnToString = $29944db88c851502$var$dsnToString;
module.exports.extractOrgIdFromClient = $29944db88c851502$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $29944db88c851502$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $29944db88c851502$var$makeDsn;

});

parcelRegister("5CFT4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $4180fe4ee82350a0$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}
module.exports.parseSampleRate = $4180fe4ee82350a0$var$parseSampleRate;

});




parcelRegister("gH8Ve", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $ckhr5 = parcelRequire("ckhr5");

var $ffWyI = parcelRequire("ffWyI");

var $6Uu3e = parcelRequire("6Uu3e");

var $6vUrj = parcelRequire("6vUrj");

var $5L5uH = parcelRequire("5L5uH");

var $gWYwh = parcelRequire("gWYwh");

var $lmDUN = parcelRequire("lmDUN");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $dDvZT = parcelRequire("dDvZT");
const $c2779539310b9438$var$TRACING_DEFAULTS = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $c2779539310b9438$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $c2779539310b9438$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $c2779539310b9438$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $c2779539310b9438$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $c2779539310b9438$var$startIdleSpan(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _childSpanTimeoutID;
    let _finishReason = $c2779539310b9438$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $c2779539310b9438$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $c2779539310b9438$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $c2779539310b9438$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $5JqSP.getClient();
    const scope = $5JqSP.getCurrentScope();
    if (!client || !$ckhr5.hasSpansEnabled()) {
        const span2 = new $gWYwh.SentryNonRecordingSpan({
            traceId: scope.getPropagationContext().traceId
        });
        $dDvZT.setCapturedScopesOnSpan(span2, scope, $5JqSP.getIsolationScope());
        return span2;
    }
    const previousActiveSpan = $6vUrj.getActiveSpan();
    const span = $c2779539310b9438$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if ($gWYwh.spanIsNonRecordingSpan(thisArg)) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $5L5uH.timestampInSeconds();
            const spanEndTimestamp = $6vUrj.spanTimeInputToSeconds(timestamp);
            const spans = $6vUrj.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $6vUrj.spanToJSON(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $6vUrj.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && $ffWyI.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _cancelChildSpanTimeout() {
        if (_childSpanTimeoutID) {
            clearTimeout(_childSpanTimeoutID);
            _childSpanTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $c2779539310b9438$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _cancelChildSpanTimeout();
        _childSpanTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $c2779539310b9438$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $5L5uH.timestampInSeconds();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $5L5uH.timestampInSeconds();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
            _cancelChildSpanTimeout();
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $6Uu3e._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $6vUrj.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: $h5H4c.SPAN_STATUS_OK
        });
        $g31Ce.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $6vUrj.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = $6vUrj.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($3T29C.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) $g31Ce.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $g31Ce.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $6vUrj.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!$6vUrj.spanToJSON(startedSpan).timestamp || startedSpan instanceof $lmDUN.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $6vUrj.getSpanDescendants(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $h5H4c.SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            });
            _finishReason = $c2779539310b9438$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $c2779539310b9438$var$_startIdleSpan(options) {
    const span = $5CFne.startInactiveSpan(options);
    $6Uu3e._setSpanForScope($5JqSP.getCurrentScope(), span);
    $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Tracing] Started span is an idle span");
    return span;
}
module.exports.TRACING_DEFAULTS = $c2779539310b9438$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $c2779539310b9438$var$startIdleSpan;

});
parcelRegister("ckhr5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");
function $8f94e0b485116c5e$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $5JqSP.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $8f94e0b485116c5e$var$hasSpansEnabled;

});

parcelRegister("ffWyI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $foFxi = parcelRequire("foFxi");
function $b1b5ae56630cb71e$var$logIgnoredSpan(droppedSpan) {
    $g31Ce.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $b1b5ae56630cb71e$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($b1b5ae56630cb71e$var$isStringOrRegExp(pattern)) {
            if (span.description && $foFxi.isMatchingPattern(span.description, pattern)) {
                $3T29C.DEBUG_BUILD && $b1b5ae56630cb71e$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $foFxi.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $foFxi.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$b1b5ae56630cb71e$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            $3T29C.DEBUG_BUILD && $b1b5ae56630cb71e$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $b1b5ae56630cb71e$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return $foFxi.isMatchingPattern(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $b1b5ae56630cb71e$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $b1b5ae56630cb71e$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}
module.exports.reparentChildSpans = $b1b5ae56630cb71e$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $b1b5ae56630cb71e$var$shouldIgnoreSpan;

});

parcelRegister("gWYwh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");

var $8tW2T = parcelRequire("8tW2T");

var $6vUrj = parcelRequire("6vUrj");
const $c571020d7209a652$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $c571020d7209a652$var$SentryNonRecordingSpan {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $8tW2T.generateTraceId();
        this._spanId = spanContext.spanId || $8tW2T.generateSpanId();
        this.dropReason = spanContext.dropReason;
        $42zXR.addNonEnumerableProperty(this, $c571020d7209a652$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $6vUrj.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $c571020d7209a652$var$spanIsNonRecordingSpan(span) {
    return !!span && span[$c571020d7209a652$var$NON_RECORDING_SPAN_FIELD] === true;
}
module.exports.SentryNonRecordingSpan = $c571020d7209a652$var$SentryNonRecordingSpan;
module.exports.spanIsNonRecordingSpan = $c571020d7209a652$var$spanIsNonRecordingSpan;

});

parcelRegister("lmDUN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $ajhqL = parcelRequire("ajhqL");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $8tW2T = parcelRequire("8tW2T");

var $6vUrj = parcelRequire("6vUrj");

var $5L5uH = parcelRequire("5L5uH");

var $4LxkX = parcelRequire("4LxkX");

var $eE1Sn = parcelRequire("eE1Sn");

var $2IafG = parcelRequire("2IafG");

var $hcX9d = parcelRequire("hcX9d");

var $6Xrci = parcelRequire("6Xrci");

var $dDvZT = parcelRequire("dDvZT");
const $f8da9d5c51e274f7$var$MAX_SPAN_COUNT = 1e3;
class $f8da9d5c51e274f7$var$SentrySpan {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $8tW2T.generateTraceId();
        this._spanId = spanContext.spanId || $8tW2T.generateSpanId();
        this._startTime = spanContext.startTimestamp || $5L5uH.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._frozen) return this;
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._frozen) return this;
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $6vUrj.TRACE_FLAG_SAMPLED : $6vUrj.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (this._frozen) return this;
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        if (key === $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE && value !== void 0 && $dDvZT.spanShouldInferOtelSource(this)) $dDvZT.markSpanSourceAsExplicit(this);
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        if (this._frozen) return;
        this._startTime = $6vUrj.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        if (this._frozen) return this;
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        if (this._frozen) return this;
        this._name = name;
        if (!$dDvZT.spanShouldInferOtelSource(this)) this.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) {
            this._frozen = $dDvZT.spanIsTracerProviderSpan(this);
            return;
        }
        this._endTime = $6vUrj.spanTimeInputToSeconds(endTimestamp);
        $eE1Sn.logSpanEnd(this);
        this._onSpanEnded();
        this._frozen = $dDvZT.spanIsTracerProviderSpan(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $6vUrj.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $2IafG.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $6vUrj.getRootSpan(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? $6vUrj.getRootSpan(this).spanContext().spanId : void 0,
            links: $6vUrj.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $6vUrj.getRootSpan(this),
            status: $6vUrj.getSimpleStatus(this._status),
            attributes: $6vUrj.addStatusMessageAttribute(this._attributes, this._status),
            links: $6vUrj.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        if (this._frozen) return this;
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Tracing] Adding an event to span:", name);
        const time$1 = $f8da9d5c51e274f7$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $5L5uH.timestampInSeconds();
        const attributes = $f8da9d5c51e274f7$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $6vUrj.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $5JqSP.getClient();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const rootSpan = $6vUrj.getRootSpan(this);
        const isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
        if (this._isStandaloneSpan) {
            if (this._sampled) $f8da9d5c51e274f7$var$sendSpanEnvelope($ajhqL.createSpanEnvelope([
                this
            ], client));
            else {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        if (!isSegmentSpan) {
            const strategy2 = $hcX9d.getSegmentSpanCaptureStrategy();
            if (strategy2) {
                const scope2 = $dDvZT.getCapturedScopesOnSpan(this).scope || $5JqSP.getCurrentScope();
                strategy2.onChildSpanEnded(this, rootSpan, (options)=>this._convertSpanToTransaction(options), scope2);
            }
            return;
        }
        if (client && $6Xrci.hasSpanStreamingEnabled(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const scope = $dDvZT.getCapturedScopesOnSpan(this).scope || $5JqSP.getCurrentScope();
        const strategy = $hcX9d.getSegmentSpanCaptureStrategy();
        if (strategy) strategy.onSegmentSpanEnded((options)=>this._convertSpanToTransaction(options), scope);
        else {
            const transactionEvent = this._convertSpanToTransaction();
            if (transactionEvent) scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction(options = {}) {
        if (!$f8da9d5c51e274f7$var$isFullFinishedSpan($6vUrj.spanToJSON(this))) return void 0;
        if (!this._name) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $dDvZT.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        options.onSpanCaptured?.(this);
        const spans = [];
        for (const descendant of $6vUrj.getSpanDescendants(this)){
            if (descendant === this || $f8da9d5c51e274f7$var$isStandaloneSpan(descendant) || options.isSpanAlreadyCaptured?.(descendant)) continue;
            const spanJSON = $6vUrj.spanToJSON(descendant);
            if (!$f8da9d5c51e274f7$var$isFullFinishedSpan(spanJSON)) continue;
            options.onSpanCaptured?.(descendant);
            spans.push(spanJSON);
        }
        const source = this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        delete this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: $6vUrj.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $f8da9d5c51e274f7$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $f8da9d5c51e274f7$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $4LxkX.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $2IafG.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $f8da9d5c51e274f7$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $f8da9d5c51e274f7$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $f8da9d5c51e274f7$var$isStandaloneSpan(span) {
    return span instanceof $f8da9d5c51e274f7$var$SentrySpan && span.isStandaloneSpan();
}
function $f8da9d5c51e274f7$var$sendSpanEnvelope(envelope) {
    const client = $5JqSP.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $f8da9d5c51e274f7$var$SentrySpan;

});
parcelRegister("ajhqL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4LxkX = parcelRequire("4LxkX");

var $dvzf1 = parcelRequire("dvzf1");

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $hkF3C = parcelRequire("hkF3C");

var $ffWyI = parcelRequire("ffWyI");

var $6vUrj = parcelRequire("6vUrj");
function $78193315b3283e9a$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $78193315b3283e9a$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $j6N8F.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: new Date($hkF3C.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $3zkbY.dsnToString(dsn$1)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return $j6N8F.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
function $78193315b3283e9a$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $j6N8F.getSdkMetadataForEnvelopeHeader(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $78193315b3283e9a$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $j6N8F.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $j6N8F.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
function $78193315b3283e9a$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = $4LxkX.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date($hkF3C.safeDateNow()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $3zkbY.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $6vUrj.spanToJSON(span);
        return !$ffWyI.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $6vUrj.spanToJSON(span);
        const processedSpan = !$dvzf1.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $6vUrj.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $6vUrj.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($j6N8F.createSpanEnvelopeItem(spanJson));
    }
    return $j6N8F.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $78193315b3283e9a$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $78193315b3283e9a$var$createEventEnvelope;
module.exports.createSessionEnvelope = $78193315b3283e9a$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $78193315b3283e9a$var$createSpanEnvelope;

});
parcelRegister("4LxkX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9QW6c = parcelRequire("9QW6c");

var $5JqSP = parcelRequire("5JqSP");

var $f3RkF = parcelRequire("f3RkF");

var $aZ3HH = parcelRequire("aZ3HH");

var $3zkbY = parcelRequire("3zkbY");

var $ckhr5 = parcelRequire("ckhr5");

var $42zXR = parcelRequire("42zXR");

var $6vUrj = parcelRequire("6vUrj");

var $gWYwh = parcelRequire("gWYwh");

var $dDvZT = parcelRequire("dDvZT");
const $3785694342169588$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $3785694342169588$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $42zXR.addNonEnumerableProperty(spanWithMaybeDsc, $3785694342169588$var$FROZEN_DSC_FIELD, dsc);
}
function $3785694342169588$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || $9QW6c.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $3zkbY.extractOrgIdFromClient(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $3785694342169588$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $3785694342169588$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function $3785694342169588$var$getDynamicSamplingContextFromSpan(span) {
    const client = $5JqSP.getClient();
    if (!client) return {};
    const rootSpan = $6vUrj.getRootSpan(span);
    const rootSpanJson = $6vUrj.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$3785694342169588$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = $gWYwh.spanIsNonRecordingSpan(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!$ckhr5.hasSpansEnabled(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = $dDvZT.getCapturedScopesOnSpan(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = {
                ...$3785694342169588$var$getDynamicSamplingContextFromScope(client, capturedScope)
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && $aZ3HH.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $3785694342169588$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    const source = rootSpanAttributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ($ckhr5.hasSpansEnabled()) {
        dsc.sampled = String($6vUrj.spanIsSampled(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $dDvZT.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $3785694342169588$var$spanToBaggageHeader(span) {
    const dsc = $3785694342169588$var$getDynamicSamplingContextFromSpan(span);
    return $aZ3HH.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $3785694342169588$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $3785694342169588$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $3785694342169588$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $3785694342169588$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $3785694342169588$var$spanToBaggageHeader;

});
parcelRegister("9QW6c", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $72c609a756dd8729$var$DEFAULT_ENVIRONMENT = "production";
const $72c609a756dd8729$var$DEV_ENVIRONMENT = "development";
module.exports.DEFAULT_ENVIRONMENT = $72c609a756dd8729$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $72c609a756dd8729$var$DEV_ENVIRONMENT;

});


parcelRegister("dvzf1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");
function $9d5981cb10f487c4$var$withStreamedSpan(callback) {
    $42zXR.addNonEnumerableProperty(callback, "_streamed", true);
    return callback;
}
function $9d5981cb10f487c4$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $9d5981cb10f487c4$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $9d5981cb10f487c4$var$withStreamedSpan;

});

parcelRegister("j6N8F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");

var $3zkbY = parcelRequire("3zkbY");

var $9EvIV = parcelRequire("9EvIV");

var $hkF3C = parcelRequire("hkF3C");

var $cqs9v = parcelRequire("cqs9v");
function $de94b1cea1c7957d$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $de94b1cea1c7957d$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $de94b1cea1c7957d$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $de94b1cea1c7957d$var$envelopeContainsItemType(envelope, types) {
    return $de94b1cea1c7957d$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
function $de94b1cea1c7957d$var$encodeUTF8(input) {
    const carrier$1 = $du5vT.getSentryCarrier($cqs9v.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $de94b1cea1c7957d$var$decodeUTF8(input) {
    const carrier$1 = $du5vT.getSentryCarrier($cqs9v.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $de94b1cea1c7957d$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $de94b1cea1c7957d$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $de94b1cea1c7957d$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify($9EvIV.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $de94b1cea1c7957d$var$concatBuffers(parts);
}
function $de94b1cea1c7957d$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $de94b1cea1c7957d$var$parseEnvelope(env) {
    let buffer = typeof env === "string" ? $de94b1cea1c7957d$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($de94b1cea1c7957d$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $de94b1cea1c7957d$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $de94b1cea1c7957d$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? $de94b1cea1c7957d$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $de94b1cea1c7957d$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $de94b1cea1c7957d$var$_isOverriddenType(type) {
    return type in $de94b1cea1c7957d$var$DATA_CATEGORY_OVERRIDES;
}
function $de94b1cea1c7957d$var$envelopeItemTypeToDataCategory(type) {
    return $de94b1cea1c7957d$var$_isOverriddenType(type) ? $de94b1cea1c7957d$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $de94b1cea1c7957d$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $de94b1cea1c7957d$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date($hkF3C.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $3zkbY.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $de94b1cea1c7957d$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $de94b1cea1c7957d$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $de94b1cea1c7957d$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $de94b1cea1c7957d$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $de94b1cea1c7957d$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $de94b1cea1c7957d$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $de94b1cea1c7957d$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $de94b1cea1c7957d$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $de94b1cea1c7957d$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $de94b1cea1c7957d$var$parseEnvelope;
module.exports.serializeEnvelope = $de94b1cea1c7957d$var$serializeEnvelope;

});


parcelRegister("eE1Sn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");
function $aa9641ae301e3b6d$var$logSpanStart(span) {
    if (!$3T29C.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = $6vUrj.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $6vUrj.spanIsSampled(span);
    const rootSpan = $6vUrj.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = $6vUrj.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    $g31Ce.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $aa9641ae301e3b6d$var$logSpanEnd(span) {
    if (!$3T29C.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = $6vUrj.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $6vUrj.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    $g31Ce.debug.log(msg);
}
module.exports.logSpanEnd = $aa9641ae301e3b6d$var$logSpanEnd;
module.exports.logSpanStart = $aa9641ae301e3b6d$var$logSpanStart;

});

parcelRegister("2IafG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");
function $1f97a4a6faa0ff0d$var$setMeasurement(name, value, unit, activeSpan = $6vUrj.getActiveSpan()) {
    const rootSpan = activeSpan && $6vUrj.getRootSpan(activeSpan);
    if (rootSpan) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
function $1f97a4a6faa0ff0d$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $1f97a4a6faa0ff0d$var$setMeasurement;
module.exports.timedEventsToMeasurements = $1f97a4a6faa0ff0d$var$timedEventsToMeasurements;

});

parcelRegister("hcX9d", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");
function $c8717028b4493875$var$setSegmentSpanCaptureStrategy(strategy) {
    $du5vT.getSentryCarrier($du5vT.getMainCarrier()).segmentSpanCaptureStrategy = strategy;
}
function $c8717028b4493875$var$getSegmentSpanCaptureStrategy() {
    return $du5vT.getSentryCarrier($du5vT.getMainCarrier()).segmentSpanCaptureStrategy;
}
module.exports.getSegmentSpanCaptureStrategy = $c8717028b4493875$var$getSegmentSpanCaptureStrategy;
module.exports.setSegmentSpanCaptureStrategy = $c8717028b4493875$var$setSegmentSpanCaptureStrategy;

});

parcelRegister("6Xrci", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $510d59981c7a3e38$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}
module.exports.hasSpanStreamingEnabled = $510d59981c7a3e38$var$hasSpanStreamingEnabled;

});


parcelRegister("5CFne", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tUnp = parcelRequire("3tUnp");

var $du5vT = parcelRequire("du5vT");

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $f3RkF = parcelRequire("f3RkF");

var $aZ3HH = parcelRequire("aZ3HH");

var $g31Ce = parcelRequire("g31Ce");

var $fzE9o = parcelRequire("fzE9o");

var $ckhr5 = parcelRequire("ckhr5");

var $ffWyI = parcelRequire("ffWyI");

var $6Xrci = parcelRequire("6Xrci");

var $5CFT4 = parcelRequire("5CFT4");

var $8tW2T = parcelRequire("8tW2T");

var $hkF3C = parcelRequire("hkF3C");

var $6Uu3e = parcelRequire("6Uu3e");

var $6vUrj = parcelRequire("6vUrj");

var $7O2T2 = parcelRequire("7O2T2");

var $4LxkX = parcelRequire("4LxkX");

var $eE1Sn = parcelRequire("eE1Sn");

var $6aMbm = parcelRequire("6aMbm");

var $gWYwh = parcelRequire("gWYwh");

var $lmDUN = parcelRequire("lmDUN");

var $h5H4c = parcelRequire("h5H4c");

var $dDvZT = parcelRequire("dDvZT");
const $4180984b3f9577eb$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function $4180984b3f9577eb$var$startSpan(options, callback) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $4180984b3f9577eb$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $5JqSP.withScope(customForkedScope, ()=>{
        const wrapper = $4180984b3f9577eb$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $5JqSP.getCurrentScope();
            const parentSpan = $4180984b3f9577eb$var$getParentSpan(scope, customParentSpan);
            const client = $5JqSP.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $4180984b3f9577eb$var$startMissingRequiredParentSpan(scope, client) : $4180984b3f9577eb$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$4180984b3f9577eb$var$spanIsIgnored(activeSpan) || !parentSpan) $6Uu3e._setSpanForScope(scope, activeSpan);
            return $fzE9o.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                const { status: status } = $6vUrj.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $4180984b3f9577eb$var$startSpanManual(options, callback) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $4180984b3f9577eb$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $5JqSP.withScope(customForkedScope, ()=>{
        const wrapper = $4180984b3f9577eb$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $5JqSP.getCurrentScope();
            const parentSpan = $4180984b3f9577eb$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $4180984b3f9577eb$var$startMissingRequiredParentSpan(scope, $5JqSP.getClient()) : $4180984b3f9577eb$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$4180984b3f9577eb$var$spanIsIgnored(activeSpan) || !parentSpan) $6Uu3e._setSpanForScope(scope, activeSpan);
            return $fzE9o.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = $6vUrj.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            });
        });
    });
}
function $4180984b3f9577eb$var$startInactiveSpan(options) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $4180984b3f9577eb$var$_startInactiveSpanImpl(options);
}
function $4180984b3f9577eb$var$_INTERNAL_startInactiveSpan(options) {
    return $4180984b3f9577eb$var$_startInactiveSpanImpl(options);
}
function $4180984b3f9577eb$var$_startInactiveSpanImpl(options) {
    const spanArguments = $4180984b3f9577eb$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>$5JqSP.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$4180984b3f9577eb$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $5JqSP.getCurrentScope();
        const parentSpan = $4180984b3f9577eb$var$getParentSpan(scope, customParentSpan);
        const client = $5JqSP.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $4180984b3f9577eb$var$startMissingRequiredParentSpan(scope, client);
        return $4180984b3f9577eb$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $4180984b3f9577eb$var$continueTrace = (options, callback)=>{
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $5JqSP.getClient();
    const incomingDsc = $aZ3HH.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$7O2T2.shouldContinueTrace(client, incomingDsc?.org_id)) return $4180984b3f9577eb$var$startNewTrace(callback);
    return $5JqSP.withScope((scope)=>{
        const propagationContext = $7O2T2.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $6Uu3e._setSpanForScope(scope, void 0);
        return callback();
    });
};
function $4180984b3f9577eb$var$withActiveSpan(span, callback) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $5JqSP.withScope((scope)=>{
        $6Uu3e._setSpanForScope(scope, span || void 0);
        return callback(scope);
    });
}
function $4180984b3f9577eb$var$suppressTracing(callback) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $5JqSP.withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [$4180984b3f9577eb$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$4180984b3f9577eb$var$SUPPRESS_TRACING_KEY]: void 0
        });
        return res;
    });
}
function $4180984b3f9577eb$var$isTracingSuppressed(scope = $5JqSP.getCurrentScope()) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$4180984b3f9577eb$var$SUPPRESS_TRACING_KEY] === true;
}
function $4180984b3f9577eb$var$startNewTrace(callback) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $5JqSP.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $8tW2T.generateTraceId(),
            sampleRand: $hkF3C.safeMathRandom()
        });
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $4180984b3f9577eb$var$withActiveSpan(null, callback);
    });
}
function $4180984b3f9577eb$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new $gWYwh.SentryNonRecordingSpan({
        traceId: scope.getPropagationContext().traceId
    });
    $dDvZT.setCapturedScopesOnSpan(span, scope, $5JqSP.getIsolationScope());
    return span;
}
function $4180984b3f9577eb$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = $5JqSP.getIsolationScope();
    if (!$ckhr5.hasSpansEnabled()) {
        const scopePropagationContext = scope.getPropagationContext();
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new $gWYwh.SentryNonRecordingSpan({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) $6vUrj.addChildSpanToSpan(parentSpan, span2);
        $dDvZT.setCapturedScopesOnSpan(span2, scope, isolationScope);
        return span2;
    }
    const client = $5JqSP.getClient();
    if ($4180984b3f9577eb$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$4180984b3f9577eb$var$isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new $gWYwh.SentryNonRecordingSpan({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) $6vUrj.addChildSpanToSpan(parentSpan, ignoredSpan);
        $dDvZT.setCapturedScopesOnSpan(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $4180984b3f9577eb$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        $6vUrj.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        const dsc = $4LxkX.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $6vUrj.spanIsSampled(parentSpan);
        span = $4180984b3f9577eb$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        $4LxkX.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = scope.getPropagationContext();
        span = $4180984b3f9577eb$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) $4LxkX.freezeDscOnSpan(span, dsc);
    }
    $eE1Sn.logSpanStart(span);
    return span;
}
function $4180984b3f9577eb$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $6vUrj.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $4180984b3f9577eb$var$getAcs() {
    const carrier$1 = $du5vT.getMainCarrier();
    return $3tUnp.getAsyncContextStrategy(carrier$1);
}
function $4180984b3f9577eb$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = $5JqSP.getClient();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $4180984b3f9577eb$var$isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : $6aMbm.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: $5CFT4.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $lmDUN.SentrySpan({
        ...spanArguments,
        attributes: {
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", $6Xrci.hasSpanStreamingEnabled(client) ? "span" : "transaction");
    }
    $dDvZT.setCapturedScopesOnSpan(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $4180984b3f9577eb$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $4180984b3f9577eb$var$isTracingSuppressed(scope);
    const sampled = _isTracingSuppressed ? false : $6vUrj.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $lmDUN.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $gWYwh.SentryNonRecordingSpan({
        traceId: traceId
    });
    $6vUrj.addChildSpanToSpan(parentSpan, childSpan);
    $dDvZT.setCapturedScopesOnSpan(childSpan, scope, isolationScope);
    const client = $5JqSP.getClient();
    if (!client) return childSpan;
    if ($6Xrci.hasSpanStreamingEnabled(client) && $gWYwh.spanIsNonRecordingSpan(childSpan)) {
        if ($gWYwh.spanIsNonRecordingSpan(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $4180984b3f9577eb$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = $6Uu3e._getSpanForScope(scope);
    if (!span) return void 0;
    const client = $5JqSP.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $6vUrj.getRootSpan(span);
    return span;
}
function $4180984b3f9577eb$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $4180984b3f9577eb$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
function $4180984b3f9577eb$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$6Xrci.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $ffWyI.shouldIgnoreSpan({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $4180984b3f9577eb$var$spanIsIgnored(span) {
    return $gWYwh.spanIsNonRecordingSpan(span) && span.dropReason === "ignored";
}
module.exports.SUPPRESS_TRACING_KEY = $4180984b3f9577eb$var$SUPPRESS_TRACING_KEY;
module.exports._INTERNAL_startInactiveSpan = $4180984b3f9577eb$var$_INTERNAL_startInactiveSpan;
module.exports.continueTrace = $4180984b3f9577eb$var$continueTrace;
module.exports.isTracingSuppressed = $4180984b3f9577eb$var$isTracingSuppressed;
module.exports.spanIsIgnored = $4180984b3f9577eb$var$spanIsIgnored;
module.exports.startInactiveSpan = $4180984b3f9577eb$var$startInactiveSpan;
module.exports.startNewTrace = $4180984b3f9577eb$var$startNewTrace;
module.exports.startSpan = $4180984b3f9577eb$var$startSpan;
module.exports.startSpanManual = $4180984b3f9577eb$var$startSpanManual;
module.exports.suppressTracing = $4180984b3f9577eb$var$suppressTracing;
module.exports.withActiveSpan = $4180984b3f9577eb$var$withActiveSpan;

});
parcelRegister("fzE9o", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6sseM = parcelRequire("6sseM");

var $cUgOr = parcelRequire("cUgOr");
function $b56944f7a499cdfd$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $b56944f7a499cdfd$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $b56944f7a499cdfd$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($cUgOr.isThenable(value)) return $6sseM.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $b56944f7a499cdfd$var$handleCallbackErrors;

});

parcelRegister("6aMbm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $ckhr5 = parcelRequire("ckhr5");

var $5CFT4 = parcelRequire("5CFT4");
function $47e90d3c2c0ac8d2$var$sampleSpan(options, samplingContext, sampleRand) {
    if (!$ckhr5.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = $5CFT4.parseSampleRate(sampleRate);
    if (parsedSampleRate === void 0) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $47e90d3c2c0ac8d2$var$sampleSpan;

});



parcelRegister("26nWE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gMVt3 = parcelRequire("gMVt3");

var $hcX9d = parcelRequire("hcX9d");
const $187eb74ae7bc7e72$var$CAPTURED_SPANS = /* @__PURE__ */ new WeakSet();
const $187eb74ae7bc7e72$var$isSpanAlreadyCaptured = (span)=>$187eb74ae7bc7e72$var$CAPTURED_SPANS.has(span);
const $187eb74ae7bc7e72$var$markSpanCaptured = (span)=>{
    $187eb74ae7bc7e72$var$CAPTURED_SPANS.add(span);
};
const $187eb74ae7bc7e72$var$CLIENT_QUEUES = /* @__PURE__ */ new WeakMap();
function $187eb74ae7bc7e72$var$_INTERNAL_setDeferSegmentSpanCapture(client) {
    if (!$hcX9d.getSegmentSpanCaptureStrategy()) $hcX9d.setSegmentSpanCaptureStrategy($187eb74ae7bc7e72$var$deferredSegmentSpanCaptureStrategy);
    if ($187eb74ae7bc7e72$var$CLIENT_QUEUES.has(client)) return;
    const pendingCaptures = /* @__PURE__ */ new Set();
    const debouncedDrain = $gMVt3.debounce(()=>{
        const captures = [
            ...pendingCaptures
        ];
        pendingCaptures.clear();
        for (const capture of captures)capture();
    }, 1, {
        maxWait: 100
    });
    client.on("flush", ()=>{
        debouncedDrain.flush();
    });
    $187eb74ae7bc7e72$var$CLIENT_QUEUES.set(client, (capture)=>{
        pendingCaptures.add(capture);
        debouncedDrain();
    });
}
const $187eb74ae7bc7e72$var$deferredSegmentSpanCaptureStrategy = {
    onSegmentSpanEnded (convert, scope) {
        const client = scope.getClient();
        const enqueue = client && $187eb74ae7bc7e72$var$CLIENT_QUEUES.get(client);
        if (!enqueue) {
            const transactionEvent = convert();
            if (transactionEvent) client?.captureEvent(transactionEvent);
            return;
        }
        enqueue(()=>{
            const transactionEvent = convert({
                isSpanAlreadyCaptured: $187eb74ae7bc7e72$var$isSpanAlreadyCaptured,
                onSpanCaptured: $187eb74ae7bc7e72$var$markSpanCaptured
            });
            if (transactionEvent) client.captureEvent(transactionEvent);
        });
    },
    onChildSpanEnded (span, rootSpan, convert, scope) {
        if ($187eb74ae7bc7e72$var$CAPTURED_SPANS.has(span) || !$187eb74ae7bc7e72$var$CAPTURED_SPANS.has(rootSpan)) return;
        const client = scope.getClient();
        const enqueue = client && $187eb74ae7bc7e72$var$CLIENT_QUEUES.get(client);
        const captureOrphan = ()=>{
            const transactionEvent = convert({
                isSpanAlreadyCaptured: $187eb74ae7bc7e72$var$isSpanAlreadyCaptured,
                onSpanCaptured: $187eb74ae7bc7e72$var$markSpanCaptured
            });
            if (transactionEvent?.contexts?.trace?.data) transactionEvent.contexts.trace.data["sentry.parent_span_already_sent"] = true;
            if (transactionEvent) client?.captureEvent(transactionEvent);
        };
        if (enqueue) enqueue(captureOrphan);
        else captureOrphan();
    }
};
module.exports._INTERNAL_setDeferSegmentSpanCapture = $187eb74ae7bc7e72$var$_INTERNAL_setDeferSegmentSpanCapture;

});
parcelRegister("gMVt3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c38db4eed84dc7b7$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $c38db4eed84dc7b7$var$debounce;

});


parcelRegister("c3F4R", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");
const $8c75a0f29048ba84$var$ADD_LISTENER_METHODS = [
    "addListener",
    "on",
    "once",
    "prependListener",
    "prependOnceListener",
    "addEventListener"
];
const $8c75a0f29048ba84$var$REMOVE_LISTENER_METHODS = [
    "removeListener",
    "off",
    "removeEventListener"
];
const $8c75a0f29048ba84$var$SCOPE_BOUND_LISTENERS = /* @__PURE__ */ Symbol("SentryScopeBoundListeners");
let $8c75a0f29048ba84$var$registeringWrapper;
function $8c75a0f29048ba84$var$isReentrantWrapperRegistration(listener) {
    return $8c75a0f29048ba84$var$registeringWrapper !== void 0 && (listener === $8c75a0f29048ba84$var$registeringWrapper || listener.listener === $8c75a0f29048ba84$var$registeringWrapper);
}
function $8c75a0f29048ba84$var$bindScopeToEmitter(emitter, scope = $5JqSP.getCurrentScope()) {
    const ee = emitter;
    if ($8c75a0f29048ba84$var$getPatchMap(ee)) return emitter;
    $8c75a0f29048ba84$var$createPatchMap(ee);
    for (const methodName of $8c75a0f29048ba84$var$ADD_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $8c75a0f29048ba84$var$patchAddListener(ee, ee[methodName], scope);
    }
    for (const methodName of $8c75a0f29048ba84$var$REMOVE_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $8c75a0f29048ba84$var$patchRemoveListener(ee, ee[methodName]);
    }
    if (typeof ee.removeAllListeners === "function") ee.removeAllListeners = $8c75a0f29048ba84$var$patchRemoveAllListeners(ee, ee.removeAllListeners);
    return emitter;
}
function $8c75a0f29048ba84$var$bindListenerToScope(listener, scope) {
    return function(...args) {
        return $5JqSP.withScope(scope, ()=>listener.apply(this, args));
    };
}
function $8c75a0f29048ba84$var$isBoundListener(listener) {
    return typeof listener === "function";
}
function $8c75a0f29048ba84$var$patchAddListener(ee, original, scope) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        if (!$8c75a0f29048ba84$var$isBoundListener(listener) || $8c75a0f29048ba84$var$isReentrantWrapperRegistration(listener)) return original.apply(this, args);
        const map = $8c75a0f29048ba84$var$getPatchMap(ee) || $8c75a0f29048ba84$var$createPatchMap(ee);
        let listeners = map.get(event);
        if (!listeners) {
            listeners = /* @__PURE__ */ new WeakMap();
            map.set(event, listeners);
        }
        let boundListener = listeners.get(listener);
        if (!boundListener) {
            boundListener = $8c75a0f29048ba84$var$bindListenerToScope(listener, scope);
            listeners.set(listener, boundListener);
        }
        const previous = $8c75a0f29048ba84$var$registeringWrapper;
        $8c75a0f29048ba84$var$registeringWrapper = boundListener;
        try {
            return original.call(this, event, boundListener, ...rest);
        } finally{
            $8c75a0f29048ba84$var$registeringWrapper = previous;
        }
    };
}
function $8c75a0f29048ba84$var$patchRemoveListener(ee, original) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        const boundListener = $8c75a0f29048ba84$var$isBoundListener(listener) ? $8c75a0f29048ba84$var$getPatchMap(ee)?.get(event)?.get(listener) : void 0;
        if (!boundListener) return original.apply(this, args);
        return original.call(this, event, boundListener, ...rest);
    };
}
function $8c75a0f29048ba84$var$patchRemoveAllListeners(ee, original) {
    return function(...args) {
        const map = $8c75a0f29048ba84$var$getPatchMap(ee);
        if (map) {
            if (args.length === 0) $8c75a0f29048ba84$var$createPatchMap(ee);
            else {
                const event = args[0];
                map.delete(event);
            }
        }
        return original.apply(this, args);
    };
}
function $8c75a0f29048ba84$var$createPatchMap(ee) {
    const map = /* @__PURE__ */ new Map();
    ee[$8c75a0f29048ba84$var$SCOPE_BOUND_LISTENERS] = map;
    return map;
}
function $8c75a0f29048ba84$var$getPatchMap(ee) {
    return ee[$8c75a0f29048ba84$var$SCOPE_BOUND_LISTENERS];
}
module.exports.bindScopeToEmitter = $8c75a0f29048ba84$var$bindScopeToEmitter;

});

parcelRegister("4wQxQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");

var $aX5wF = parcelRequire("aX5wF");

var $6vUrj = parcelRequire("6vUrj");

var $dDvZT = parcelRequire("dDvZT");

var $dvzf1 = parcelRequire("dvzf1");

var $fYBGH = parcelRequire("fYBGH");

var $9QW6c = parcelRequire("9QW6c");

var $eAISS = parcelRequire("eAISS");
function $34c2e8e657651818$var$captureSpan(span, client) {
    const spanJSON = $6vUrj.spanToStreamedSpanJSON(span);
    const segmentSpan = $6vUrj.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $6vUrj.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $dDvZT.getCapturedScopesOnSpan(span);
    const finalScopeData = $aX5wF.getCombinedScopeData(spanIsolationScope, spanScope);
    $34c2e8e657651818$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $34c2e8e657651818$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $34c2e8e657651818$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $dvzf1.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $34c2e8e657651818$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanJSON.is_segment && spanNameSource) $34c2e8e657651818$var$safeSetSpanJSONAttributes(processedSpan, {
        ["sentry.segment.name.source"]: spanNameSource
    });
    return {
        ...$6vUrj.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $34c2e8e657651818$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = $fYBGH.scopeContextsToSpanAttributes(scopeData.contexts);
    $34c2e8e657651818$var$safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function $34c2e8e657651818$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $34c2e8e657651818$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $34c2e8e657651818$var$safeSetSpanJSONAttributes(segmentSpanJSON, {
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
    });
}
function $34c2e8e657651818$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $34c2e8e657651818$var$safeSetSpanJSONAttributes(spanJSON, {
        [$eAISS.SENTRY_TRACE_LIFECYCLE]: "stream",
        [$eAISS.SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$eAISS.SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$eAISS.SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$eAISS.SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment || $9QW6c.DEFAULT_ENVIRONMENT,
        [$f3RkF.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$f3RkF.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$f3RkF.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$f3RkF.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $34c2e8e657651818$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $6vUrj.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
module.exports.applyBeforeSendSpanCallback = $34c2e8e657651818$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $34c2e8e657651818$var$captureSpan;
module.exports.safeSetSpanJSONAttributes = $34c2e8e657651818$var$safeSetSpanJSONAttributes;

});
parcelRegister("aX5wF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $4LxkX = parcelRequire("4LxkX");

var $4ty0t = parcelRequire("4ty0t");

var $6vUrj = parcelRequire("6vUrj");
function $7f93b3696c1e22bd$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $7f93b3696c1e22bd$var$applyDataToEvent(event, data);
    if (span) $7f93b3696c1e22bd$var$applySpanToEvent(event, span);
    $7f93b3696c1e22bd$var$applyFingerprintToEvent(event, fingerprint);
    $7f93b3696c1e22bd$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $7f93b3696c1e22bd$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $7f93b3696c1e22bd$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, "extra", extra);
    $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, "tags", tags);
    $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, "attributes", attributes);
    $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, "user", user);
    $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = $4ty0t.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $4ty0t.merge(data[prop], mergeVal, 1);
}
function $7f93b3696c1e22bd$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $5JqSP.getGlobalScope().getScopeData();
    isolationScope && $7f93b3696c1e22bd$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $7f93b3696c1e22bd$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $7f93b3696c1e22bd$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $7f93b3696c1e22bd$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $7f93b3696c1e22bd$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $7f93b3696c1e22bd$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $6vUrj.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $4LxkX.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $6vUrj.getRootSpan(span);
    const transactionName = $6vUrj.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $7f93b3696c1e22bd$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $7f93b3696c1e22bd$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $7f93b3696c1e22bd$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $7f93b3696c1e22bd$var$mergeScopeData;

});

parcelRegister("fYBGH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $ba19b19bbb2994c3$var$scopeContextsToSpanAttributes(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}
module.exports.scopeContextsToSpanAttributes = $ba19b19bbb2994c3$var$scopeContextsToSpanAttributes;

});

parcelRegister("eAISS", function(module, exports) {
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

module.exports = (parcelRequire("eZ61f"));

});
parcelRegister("eZ61f", function(module, exports) {

$parcel$export(module.exports, "AI_CITATIONS", function () { return $8b11dd70aaca6dbd$export$b60c5e9f9b7b58bd; }, function (v) { return $8b11dd70aaca6dbd$export$b60c5e9f9b7b58bd = v; });
$parcel$export(module.exports, "AI_COMPLETION_TOKENS_USED", function () { return $8b11dd70aaca6dbd$export$cc06afd6de7f2c10; }, function (v) { return $8b11dd70aaca6dbd$export$cc06afd6de7f2c10 = v; });
$parcel$export(module.exports, "AI_DOCUMENTS", function () { return $8b11dd70aaca6dbd$export$ced6746028fe2cc; }, function (v) { return $8b11dd70aaca6dbd$export$ced6746028fe2cc = v; });
$parcel$export(module.exports, "AI_FINISH_REASON", function () { return $8b11dd70aaca6dbd$export$e6f4aa4f4fcb6da8; }, function (v) { return $8b11dd70aaca6dbd$export$e6f4aa4f4fcb6da8 = v; });
$parcel$export(module.exports, "AI_FREQUENCY_PENALTY", function () { return $8b11dd70aaca6dbd$export$f02d892201cd8d36; }, function (v) { return $8b11dd70aaca6dbd$export$f02d892201cd8d36 = v; });
$parcel$export(module.exports, "AI_FUNCTION_CALL", function () { return $8b11dd70aaca6dbd$export$f277a7ef9e273960; }, function (v) { return $8b11dd70aaca6dbd$export$f277a7ef9e273960 = v; });
$parcel$export(module.exports, "AI_GENERATION_ID", function () { return $8b11dd70aaca6dbd$export$1a8c212c3becaa80; }, function (v) { return $8b11dd70aaca6dbd$export$1a8c212c3becaa80 = v; });
$parcel$export(module.exports, "AI_INPUT_MESSAGES", function () { return $8b11dd70aaca6dbd$export$721b137086c68a47; }, function (v) { return $8b11dd70aaca6dbd$export$721b137086c68a47 = v; });
$parcel$export(module.exports, "AI_IS_SEARCH_REQUIRED", function () { return $8b11dd70aaca6dbd$export$6afde2bb69d9aa86; }, function (v) { return $8b11dd70aaca6dbd$export$6afde2bb69d9aa86 = v; });
$parcel$export(module.exports, "AI_METADATA", function () { return $8b11dd70aaca6dbd$export$eadb4b562c974031; }, function (v) { return $8b11dd70aaca6dbd$export$eadb4b562c974031 = v; });
$parcel$export(module.exports, "AI_MODEL_ID", function () { return $8b11dd70aaca6dbd$export$22a90f0ac1eee843; }, function (v) { return $8b11dd70aaca6dbd$export$22a90f0ac1eee843 = v; });
$parcel$export(module.exports, "AI_MODEL_PROVIDER", function () { return $8b11dd70aaca6dbd$export$a727f215a0be1dad; }, function (v) { return $8b11dd70aaca6dbd$export$a727f215a0be1dad = v; });
$parcel$export(module.exports, "AI_PIPELINE_NAME", function () { return $8b11dd70aaca6dbd$export$536bc61b34d995e5; }, function (v) { return $8b11dd70aaca6dbd$export$536bc61b34d995e5 = v; });
$parcel$export(module.exports, "AI_PREAMBLE", function () { return $8b11dd70aaca6dbd$export$c43ea6115b380e62; }, function (v) { return $8b11dd70aaca6dbd$export$c43ea6115b380e62 = v; });
$parcel$export(module.exports, "AI_PRESENCE_PENALTY", function () { return $8b11dd70aaca6dbd$export$d2a16e26bada7cf1; }, function (v) { return $8b11dd70aaca6dbd$export$d2a16e26bada7cf1 = v; });
$parcel$export(module.exports, "AI_PROMPT_TOKENS_USED", function () { return $8b11dd70aaca6dbd$export$604eb1bd2278163b; }, function (v) { return $8b11dd70aaca6dbd$export$604eb1bd2278163b = v; });
$parcel$export(module.exports, "AI_RAW_PROMPTING", function () { return $8b11dd70aaca6dbd$export$2f8568696c5aa352; }, function (v) { return $8b11dd70aaca6dbd$export$2f8568696c5aa352 = v; });
$parcel$export(module.exports, "AI_RESPONSES", function () { return $8b11dd70aaca6dbd$export$ccc8efd7dd31d3a9; }, function (v) { return $8b11dd70aaca6dbd$export$ccc8efd7dd31d3a9 = v; });
$parcel$export(module.exports, "AI_RESPONSE_FORMAT", function () { return $8b11dd70aaca6dbd$export$e176bf5dc45e40df; }, function (v) { return $8b11dd70aaca6dbd$export$e176bf5dc45e40df = v; });
$parcel$export(module.exports, "AI_SEARCH_QUERIES", function () { return $8b11dd70aaca6dbd$export$c4ea01fd53f64e16; }, function (v) { return $8b11dd70aaca6dbd$export$c4ea01fd53f64e16 = v; });
$parcel$export(module.exports, "AI_SEARCH_RESULTS", function () { return $8b11dd70aaca6dbd$export$bb5e6f2f31a15da9; }, function (v) { return $8b11dd70aaca6dbd$export$bb5e6f2f31a15da9 = v; });
$parcel$export(module.exports, "AI_SEED", function () { return $8b11dd70aaca6dbd$export$1762c11b666b026a; }, function (v) { return $8b11dd70aaca6dbd$export$1762c11b666b026a = v; });
$parcel$export(module.exports, "AI_STREAMING", function () { return $8b11dd70aaca6dbd$export$14ddd4b729910100; }, function (v) { return $8b11dd70aaca6dbd$export$14ddd4b729910100 = v; });
$parcel$export(module.exports, "AI_TAGS", function () { return $8b11dd70aaca6dbd$export$5311d7c8e1f8eabb; }, function (v) { return $8b11dd70aaca6dbd$export$5311d7c8e1f8eabb = v; });
$parcel$export(module.exports, "AI_TEMPERATURE", function () { return $8b11dd70aaca6dbd$export$2b748b9eca00828b; }, function (v) { return $8b11dd70aaca6dbd$export$2b748b9eca00828b = v; });
$parcel$export(module.exports, "AI_TEXTS", function () { return $8b11dd70aaca6dbd$export$5af25308c11addea; }, function (v) { return $8b11dd70aaca6dbd$export$5af25308c11addea = v; });
$parcel$export(module.exports, "AI_TOOLS", function () { return $8b11dd70aaca6dbd$export$28f78b3b1663cb92; }, function (v) { return $8b11dd70aaca6dbd$export$28f78b3b1663cb92 = v; });
$parcel$export(module.exports, "AI_TOOL_CALLS", function () { return $8b11dd70aaca6dbd$export$a1d3f09f0f1f066f; }, function (v) { return $8b11dd70aaca6dbd$export$a1d3f09f0f1f066f = v; });
$parcel$export(module.exports, "AI_TOP_K", function () { return $8b11dd70aaca6dbd$export$322bd4ea9f163663; }, function (v) { return $8b11dd70aaca6dbd$export$322bd4ea9f163663 = v; });
$parcel$export(module.exports, "AI_TOP_P", function () { return $8b11dd70aaca6dbd$export$95711b9e669edad8; }, function (v) { return $8b11dd70aaca6dbd$export$95711b9e669edad8 = v; });
$parcel$export(module.exports, "AI_TOTAL_COST", function () { return $8b11dd70aaca6dbd$export$5924d7d72384626a; }, function (v) { return $8b11dd70aaca6dbd$export$5924d7d72384626a = v; });
$parcel$export(module.exports, "AI_TOTAL_TOKENS_USED", function () { return $8b11dd70aaca6dbd$export$db3b1b877a4ce4db; }, function (v) { return $8b11dd70aaca6dbd$export$db3b1b877a4ce4db = v; });
$parcel$export(module.exports, "AI_WARNINGS", function () { return $8b11dd70aaca6dbd$export$a434a3e8afec2879; }, function (v) { return $8b11dd70aaca6dbd$export$a434a3e8afec2879 = v; });
$parcel$export(module.exports, "ANGULAR_VERSION", function () { return $8b11dd70aaca6dbd$export$fe00bb20636d42af; }, function (v) { return $8b11dd70aaca6dbd$export$fe00bb20636d42af = v; });
$parcel$export(module.exports, "APP_APP_BUILD", function () { return $8b11dd70aaca6dbd$export$712aa698b7ee271e; }, function (v) { return $8b11dd70aaca6dbd$export$712aa698b7ee271e = v; });
$parcel$export(module.exports, "APP_APP_IDENTIFIER", function () { return $8b11dd70aaca6dbd$export$1fac638b11ec16d9; }, function (v) { return $8b11dd70aaca6dbd$export$1fac638b11ec16d9 = v; });
$parcel$export(module.exports, "APP_APP_NAME", function () { return $8b11dd70aaca6dbd$export$d132016ea64058e3; }, function (v) { return $8b11dd70aaca6dbd$export$d132016ea64058e3 = v; });
$parcel$export(module.exports, "APP_APP_START_TIME", function () { return $8b11dd70aaca6dbd$export$53f2f47ec3b2f9ed; }, function (v) { return $8b11dd70aaca6dbd$export$53f2f47ec3b2f9ed = v; });
$parcel$export(module.exports, "APP_APP_VERSION", function () { return $8b11dd70aaca6dbd$export$9f80c4b11053cef1; }, function (v) { return $8b11dd70aaca6dbd$export$9f80c4b11053cef1 = v; });
$parcel$export(module.exports, "APP_BUILD", function () { return $8b11dd70aaca6dbd$export$5f7a08466d84e877; }, function (v) { return $8b11dd70aaca6dbd$export$5f7a08466d84e877 = v; });
$parcel$export(module.exports, "APP_IDENTIFIER", function () { return $8b11dd70aaca6dbd$export$2cea7f14750b8c19; }, function (v) { return $8b11dd70aaca6dbd$export$2cea7f14750b8c19 = v; });
$parcel$export(module.exports, "APP_IN_FOREGROUND", function () { return $8b11dd70aaca6dbd$export$34c59270f032a6c6; }, function (v) { return $8b11dd70aaca6dbd$export$34c59270f032a6c6 = v; });
$parcel$export(module.exports, "APP_NAME", function () { return $8b11dd70aaca6dbd$export$5b6c28c7dca07ad7; }, function (v) { return $8b11dd70aaca6dbd$export$5b6c28c7dca07ad7 = v; });
$parcel$export(module.exports, "APP_START_COLD", function () { return $8b11dd70aaca6dbd$export$1dc8ae58b58d6c50; }, function (v) { return $8b11dd70aaca6dbd$export$1dc8ae58b58d6c50 = v; });
$parcel$export(module.exports, "APP_START_TIME", function () { return $8b11dd70aaca6dbd$export$ba267414e3c0d822; }, function (v) { return $8b11dd70aaca6dbd$export$ba267414e3c0d822 = v; });
$parcel$export(module.exports, "APP_START_TYPE", function () { return $8b11dd70aaca6dbd$export$71b176005902b99e; }, function (v) { return $8b11dd70aaca6dbd$export$71b176005902b99e = v; });
$parcel$export(module.exports, "APP_START_WARM", function () { return $8b11dd70aaca6dbd$export$5c5b5a3c245a0079; }, function (v) { return $8b11dd70aaca6dbd$export$5c5b5a3c245a0079 = v; });
$parcel$export(module.exports, "APP_VERSION", function () { return $8b11dd70aaca6dbd$export$8ee1df3c6367a60; }, function (v) { return $8b11dd70aaca6dbd$export$8ee1df3c6367a60 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_DELAY_VALUE", function () { return $8b11dd70aaca6dbd$export$e8c7802ae95beccf; }, function (v) { return $8b11dd70aaca6dbd$export$e8c7802ae95beccf = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_FROZEN_COUNT", function () { return $8b11dd70aaca6dbd$export$bb237734da4d464; }, function (v) { return $8b11dd70aaca6dbd$export$bb237734da4d464 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_SLOW_COUNT", function () { return $8b11dd70aaca6dbd$export$cdaaf6d1fdcba0b6; }, function (v) { return $8b11dd70aaca6dbd$export$cdaaf6d1fdcba0b6 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_TOTAL_COUNT", function () { return $8b11dd70aaca6dbd$export$36223ebd4a30e9f5; }, function (v) { return $8b11dd70aaca6dbd$export$36223ebd4a30e9f5 = v; });
$parcel$export(module.exports, "APP_VITALS_START_COLD_VALUE", function () { return $8b11dd70aaca6dbd$export$8feaa177bb7941e2; }, function (v) { return $8b11dd70aaca6dbd$export$8feaa177bb7941e2 = v; });
$parcel$export(module.exports, "APP_VITALS_START_PREWARMED", function () { return $8b11dd70aaca6dbd$export$e1ca25240db91d68; }, function (v) { return $8b11dd70aaca6dbd$export$e1ca25240db91d68 = v; });
$parcel$export(module.exports, "APP_VITALS_START_REASON", function () { return $8b11dd70aaca6dbd$export$404a223fd1ada08b; }, function (v) { return $8b11dd70aaca6dbd$export$404a223fd1ada08b = v; });
$parcel$export(module.exports, "APP_VITALS_START_SCREEN", function () { return $8b11dd70aaca6dbd$export$53362079310c68; }, function (v) { return $8b11dd70aaca6dbd$export$53362079310c68 = v; });
$parcel$export(module.exports, "APP_VITALS_START_TYPE", function () { return $8b11dd70aaca6dbd$export$3efb5af0ac379f77; }, function (v) { return $8b11dd70aaca6dbd$export$3efb5af0ac379f77 = v; });
$parcel$export(module.exports, "APP_VITALS_START_WARM_VALUE", function () { return $8b11dd70aaca6dbd$export$2c10c1ca0612c46d; }, function (v) { return $8b11dd70aaca6dbd$export$2c10c1ca0612c46d = v; });
$parcel$export(module.exports, "APP_VITALS_TTFD_VALUE", function () { return $8b11dd70aaca6dbd$export$bbb86ad4d6654da6; }, function (v) { return $8b11dd70aaca6dbd$export$bbb86ad4d6654da6 = v; });
$parcel$export(module.exports, "APP_VITALS_TTID_VALUE", function () { return $8b11dd70aaca6dbd$export$ad6896f00a2b1076; }, function (v) { return $8b11dd70aaca6dbd$export$ad6896f00a2b1076 = v; });
$parcel$export(module.exports, "ART_GC_BLOCKING_COUNT", function () { return $8b11dd70aaca6dbd$export$300f39d8506a273d; }, function (v) { return $8b11dd70aaca6dbd$export$300f39d8506a273d = v; });
$parcel$export(module.exports, "ART_GC_BLOCKING_TIME", function () { return $8b11dd70aaca6dbd$export$ecaa0e7f4773ddc7; }, function (v) { return $8b11dd70aaca6dbd$export$ecaa0e7f4773ddc7 = v; });
$parcel$export(module.exports, "ART_GC_PRE_OOME_COUNT", function () { return $8b11dd70aaca6dbd$export$74b78acb4c54c06b; }, function (v) { return $8b11dd70aaca6dbd$export$74b78acb4c54c06b = v; });
$parcel$export(module.exports, "ART_GC_TOTAL_COUNT", function () { return $8b11dd70aaca6dbd$export$b15b2c133bc50e33; }, function (v) { return $8b11dd70aaca6dbd$export$b15b2c133bc50e33 = v; });
$parcel$export(module.exports, "ART_GC_TOTAL_TIME", function () { return $8b11dd70aaca6dbd$export$5f1381d9ae1b1c95; }, function (v) { return $8b11dd70aaca6dbd$export$5f1381d9ae1b1c95 = v; });
$parcel$export(module.exports, "ART_GC_WAITING_TIME", function () { return $8b11dd70aaca6dbd$export$c170b7ff277132ea; }, function (v) { return $8b11dd70aaca6dbd$export$c170b7ff277132ea = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE", function () { return $8b11dd70aaca6dbd$export$9459a5df93695e45; }, function (v) { return $8b11dd70aaca6dbd$export$9459a5df93695e45 = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_GC", function () { return $8b11dd70aaca6dbd$export$a7902bd57492ebe8; }, function (v) { return $8b11dd70aaca6dbd$export$a7902bd57492ebe8 = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_OOME", function () { return $8b11dd70aaca6dbd$export$d2ace0da59da09b7; }, function (v) { return $8b11dd70aaca6dbd$export$d2ace0da59da09b7 = v; });
$parcel$export(module.exports, "ART_MEMORY_MAX", function () { return $8b11dd70aaca6dbd$export$c15dd8d2461e0aeb; }, function (v) { return $8b11dd70aaca6dbd$export$c15dd8d2461e0aeb = v; });
$parcel$export(module.exports, "ART_MEMORY_TOTAL", function () { return $8b11dd70aaca6dbd$export$5405b0a98e00e538; }, function (v) { return $8b11dd70aaca6dbd$export$5405b0a98e00e538 = v; });
$parcel$export(module.exports, "ATTRIBUTE_METADATA", function () { return $8b11dd70aaca6dbd$export$bd393bbb84b309d3; }, function (v) { return $8b11dd70aaca6dbd$export$bd393bbb84b309d3 = v; });
$parcel$export(module.exports, "ATTRIBUTE_TYPE", function () { return $8b11dd70aaca6dbd$export$96f586f8837b86ae; }, function (v) { return $8b11dd70aaca6dbd$export$96f586f8837b86ae = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_GROUP", function () { return $8b11dd70aaca6dbd$export$5d9f28f388f552d2; }, function (v) { return $8b11dd70aaca6dbd$export$5d9f28f388f552d2 = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_STREAM", function () { return $8b11dd70aaca6dbd$export$b3d2f68e0e769504; }, function (v) { return $8b11dd70aaca6dbd$export$b3d2f68e0e769504 = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_URL", function () { return $8b11dd70aaca6dbd$export$2c98412ed43013e8; }, function (v) { return $8b11dd70aaca6dbd$export$2c98412ed43013e8 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS", function () { return $8b11dd70aaca6dbd$export$a7bd794d11c19f1b; }, function (v) { return $8b11dd70aaca6dbd$export$a7bd794d11c19f1b = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_CONSISTENT_READ", function () { return $8b11dd70aaca6dbd$export$df4227832b83fdd0; }, function (v) { return $8b11dd70aaca6dbd$export$df4227832b83fdd0 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_CONSUMED_CAPACITY", function () { return $8b11dd70aaca6dbd$export$f131a6d8fbc0534f; }, function (v) { return $8b11dd70aaca6dbd$export$f131a6d8fbc0534f = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_COUNT", function () { return $8b11dd70aaca6dbd$export$9bdc66d4a70e7e3a; }, function (v) { return $8b11dd70aaca6dbd$export$9bdc66d4a70e7e3a = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_EXCLUSIVE_START_TABLE", function () { return $8b11dd70aaca6dbd$export$bfbbc3cbcaa90e98; }, function (v) { return $8b11dd70aaca6dbd$export$bfbbc3cbcaa90e98 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES", function () { return $8b11dd70aaca6dbd$export$3565fa72459aa4d6; }, function (v) { return $8b11dd70aaca6dbd$export$3565fa72459aa4d6 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES", function () { return $8b11dd70aaca6dbd$export$bb67a834ae4bffdc; }, function (v) { return $8b11dd70aaca6dbd$export$bb67a834ae4bffdc = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_INDEX_NAME", function () { return $8b11dd70aaca6dbd$export$4a06c859a283f06; }, function (v) { return $8b11dd70aaca6dbd$export$4a06c859a283f06 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_ITEM_COLLECTION_METRICS", function () { return $8b11dd70aaca6dbd$export$68324fac2038d0f2; }, function (v) { return $8b11dd70aaca6dbd$export$68324fac2038d0f2 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_LIMIT", function () { return $8b11dd70aaca6dbd$export$5e1bd62ffd2786fb; }, function (v) { return $8b11dd70aaca6dbd$export$5e1bd62ffd2786fb = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES", function () { return $8b11dd70aaca6dbd$export$bfdf2261058f56b; }, function (v) { return $8b11dd70aaca6dbd$export$bfdf2261058f56b = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROJECTION", function () { return $8b11dd70aaca6dbd$export$23bf57842d9d53df; }, function (v) { return $8b11dd70aaca6dbd$export$23bf57842d9d53df = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_READ_CAPACITY", function () { return $8b11dd70aaca6dbd$export$bfbd7e060eeb4d35; }, function (v) { return $8b11dd70aaca6dbd$export$bfbd7e060eeb4d35 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY", function () { return $8b11dd70aaca6dbd$export$82eb6cccda27c3ff; }, function (v) { return $8b11dd70aaca6dbd$export$82eb6cccda27c3ff = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SCANNED_COUNT", function () { return $8b11dd70aaca6dbd$export$8ea68734d455808f; }, function (v) { return $8b11dd70aaca6dbd$export$8ea68734d455808f = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SCAN_FORWARD", function () { return $8b11dd70aaca6dbd$export$40050e29324d44ee; }, function (v) { return $8b11dd70aaca6dbd$export$40050e29324d44ee = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SEGMENT", function () { return $8b11dd70aaca6dbd$export$5cd7541006d9f467; }, function (v) { return $8b11dd70aaca6dbd$export$5cd7541006d9f467 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SELECT", function () { return $8b11dd70aaca6dbd$export$81c017edd95d692e; }, function (v) { return $8b11dd70aaca6dbd$export$81c017edd95d692e = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_COUNT", function () { return $8b11dd70aaca6dbd$export$120b3897a58cf903; }, function (v) { return $8b11dd70aaca6dbd$export$120b3897a58cf903 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_NAMES", function () { return $8b11dd70aaca6dbd$export$d4a9de43b4b1076c; }, function (v) { return $8b11dd70aaca6dbd$export$d4a9de43b4b1076c = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TOTAL_SEGMENTS", function () { return $8b11dd70aaca6dbd$export$f37f4f9022f1ab17; }, function (v) { return $8b11dd70aaca6dbd$export$f37f4f9022f1ab17 = v; });
$parcel$export(module.exports, "AWS_EXTENDED_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$66ac18da14747cfb; }, function (v) { return $8b11dd70aaca6dbd$export$66ac18da14747cfb = v; });
$parcel$export(module.exports, "AWS_KINESIS_STREAM_NAME", function () { return $8b11dd70aaca6dbd$export$9e49b833525ca49d; }, function (v) { return $8b11dd70aaca6dbd$export$9e49b833525ca49d = v; });
$parcel$export(module.exports, "AWS_LAMBDA_AWS_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$b084fea5b3097227; }, function (v) { return $8b11dd70aaca6dbd$export$b084fea5b3097227 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS", function () { return $8b11dd70aaca6dbd$export$e09cd8615652e8d0; }, function (v) { return $8b11dd70aaca6dbd$export$e09cd8615652e8d0 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_NAME", function () { return $8b11dd70aaca6dbd$export$a43a60ec723a90ee; }, function (v) { return $8b11dd70aaca6dbd$export$a43a60ec723a90ee = v; });
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_VERSION", function () { return $8b11dd70aaca6dbd$export$34cc955357266287; }, function (v) { return $8b11dd70aaca6dbd$export$34cc955357266287 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_ARN", function () { return $8b11dd70aaca6dbd$export$d9dd218693ea9bba; }, function (v) { return $8b11dd70aaca6dbd$export$d9dd218693ea9bba = v; });
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_FUNCTION_ARN", function () { return $8b11dd70aaca6dbd$export$c9649b7156282a2f; }, function (v) { return $8b11dd70aaca6dbd$export$c9649b7156282a2f = v; });
$parcel$export(module.exports, "AWS_LAMBDA_REMAINING_TIME_IN_MILLIS", function () { return $8b11dd70aaca6dbd$export$daa8ce1f8adc553e; }, function (v) { return $8b11dd70aaca6dbd$export$daa8ce1f8adc553e = v; });
$parcel$export(module.exports, "AWS_LOG_GROUP_NAMES", function () { return $8b11dd70aaca6dbd$export$cb93c7b05db202cf; }, function (v) { return $8b11dd70aaca6dbd$export$cb93c7b05db202cf = v; });
$parcel$export(module.exports, "AWS_LOG_STREAM_NAMES", function () { return $8b11dd70aaca6dbd$export$930f9bd3cc2e5b3d; }, function (v) { return $8b11dd70aaca6dbd$export$930f9bd3cc2e5b3d = v; });
$parcel$export(module.exports, "AWS_REQUEST_EXTENDED_ID", function () { return $8b11dd70aaca6dbd$export$48c6d4c44afdc0b; }, function (v) { return $8b11dd70aaca6dbd$export$48c6d4c44afdc0b = v; });
$parcel$export(module.exports, "AWS_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$c78d41789fe4b1e4; }, function (v) { return $8b11dd70aaca6dbd$export$c78d41789fe4b1e4 = v; });
$parcel$export(module.exports, "AWS_S3_BUCKET", function () { return $8b11dd70aaca6dbd$export$f462d9921f1f7332; }, function (v) { return $8b11dd70aaca6dbd$export$f462d9921f1f7332 = v; });
$parcel$export(module.exports, "AWS_SECRETSMANAGER_SECRET_ARN", function () { return $8b11dd70aaca6dbd$export$bc71f8df9a45e243; }, function (v) { return $8b11dd70aaca6dbd$export$bc71f8df9a45e243 = v; });
$parcel$export(module.exports, "AWS_SNS_TOPIC_ARN", function () { return $8b11dd70aaca6dbd$export$ed840ec4a5f5d053; }, function (v) { return $8b11dd70aaca6dbd$export$ed840ec4a5f5d053 = v; });
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_ACTIVITY_ARN", function () { return $8b11dd70aaca6dbd$export$c1a559a4f74a5e8e; }, function (v) { return $8b11dd70aaca6dbd$export$c1a559a4f74a5e8e = v; });
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN", function () { return $8b11dd70aaca6dbd$export$d1c007424092e3f5; }, function (v) { return $8b11dd70aaca6dbd$export$d1c007424092e3f5 = v; });
$parcel$export(module.exports, "BLOCKED_MAIN_THREAD", function () { return $8b11dd70aaca6dbd$export$9ebb466ce954c49c; }, function (v) { return $8b11dd70aaca6dbd$export$9ebb466ce954c49c = v; });
$parcel$export(module.exports, "BROWSER_NAME", function () { return $8b11dd70aaca6dbd$export$e9aafc7348984403; }, function (v) { return $8b11dd70aaca6dbd$export$e9aafc7348984403 = v; });
$parcel$export(module.exports, "BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START", function () { return $8b11dd70aaca6dbd$export$faaa46964f075237; }, function (v) { return $8b11dd70aaca6dbd$export$faaa46964f075237 = v; });
$parcel$export(module.exports, "BROWSER_PERFORMANCE_TIME_ORIGIN", function () { return $8b11dd70aaca6dbd$export$d28c4b3cc4431a87; }, function (v) { return $8b11dd70aaca6dbd$export$d28c4b3cc4431a87 = v; });
$parcel$export(module.exports, "BROWSER_REPORT_TYPE", function () { return $8b11dd70aaca6dbd$export$734b017b330c8fe6; }, function (v) { return $8b11dd70aaca6dbd$export$734b017b330c8fe6 = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER", function () { return $8b11dd70aaca6dbd$export$683ebdc48ba3758d; }, function (v) { return $8b11dd70aaca6dbd$export$683ebdc48ba3758d = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER_TYPE", function () { return $8b11dd70aaca6dbd$export$be0263971250ef44; }, function (v) { return $8b11dd70aaca6dbd$export$be0263971250ef44 = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_SOURCE_CHAR_POSITION", function () { return $8b11dd70aaca6dbd$export$36a0cbc35c405232; }, function (v) { return $8b11dd70aaca6dbd$export$36a0cbc35c405232 = v; });
$parcel$export(module.exports, "BROWSER_VERSION", function () { return $8b11dd70aaca6dbd$export$469f7765ba335497; }, function (v) { return $8b11dd70aaca6dbd$export$469f7765ba335497 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_REPORT_EVENT", function () { return $8b11dd70aaca6dbd$export$fe6fe2b7af051610; }, function (v) { return $8b11dd70aaca6dbd$export$fe6fe2b7af051610 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY", function () { return $8b11dd70aaca6dbd$export$8345821877c4dfad; }, function (v) { return $8b11dd70aaca6dbd$export$8345821877c4dfad = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$f6c188a7e02335cf; }, function (v) { return $8b11dd70aaca6dbd$export$f6c188a7e02335cf = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_VALUE", function () { return $8b11dd70aaca6dbd$export$aaf709a8971e825f; }, function (v) { return $8b11dd70aaca6dbd$export$aaf709a8971e825f = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FCP_VALUE", function () { return $8b11dd70aaca6dbd$export$def01b82f8c092f7; }, function (v) { return $8b11dd70aaca6dbd$export$def01b82f8c092f7 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FP_VALUE", function () { return $8b11dd70aaca6dbd$export$23d4264c606a73a6; }, function (v) { return $8b11dd70aaca6dbd$export$23d4264c606a73a6 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_INP_VALUE", function () { return $8b11dd70aaca6dbd$export$af9ece53bb92f66b; }, function (v) { return $8b11dd70aaca6dbd$export$af9ece53bb92f66b = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ELEMENT", function () { return $8b11dd70aaca6dbd$export$25421625a565b69; }, function (v) { return $8b11dd70aaca6dbd$export$25421625a565b69 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ID", function () { return $8b11dd70aaca6dbd$export$ab0c90d873e69ccb; }, function (v) { return $8b11dd70aaca6dbd$export$ab0c90d873e69ccb = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_LOAD_TIME", function () { return $8b11dd70aaca6dbd$export$538c05cc8cb2a2bb; }, function (v) { return $8b11dd70aaca6dbd$export$538c05cc8cb2a2bb = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_RENDER_TIME", function () { return $8b11dd70aaca6dbd$export$f86df4de196e1a7c; }, function (v) { return $8b11dd70aaca6dbd$export$f86df4de196e1a7c = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_REPORT_EVENT", function () { return $8b11dd70aaca6dbd$export$51e8aa8c0d65e7b8; }, function (v) { return $8b11dd70aaca6dbd$export$51e8aa8c0d65e7b8 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_SIZE", function () { return $8b11dd70aaca6dbd$export$99023486ecc470bd; }, function (v) { return $8b11dd70aaca6dbd$export$99023486ecc470bd = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_URL", function () { return $8b11dd70aaca6dbd$export$2f6c85eaf382e81; }, function (v) { return $8b11dd70aaca6dbd$export$2f6c85eaf382e81 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_VALUE", function () { return $8b11dd70aaca6dbd$export$1158d57c0aed42be; }, function (v) { return $8b11dd70aaca6dbd$export$1158d57c0aed42be = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_REQUEST_TIME", function () { return $8b11dd70aaca6dbd$export$d85c4f947ab776e3; }, function (v) { return $8b11dd70aaca6dbd$export$d85c4f947ab776e3 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_VALUE", function () { return $8b11dd70aaca6dbd$export$813ef8386d874918; }, function (v) { return $8b11dd70aaca6dbd$export$813ef8386d874918 = v; });
$parcel$export(module.exports, "CACHE_HIT", function () { return $8b11dd70aaca6dbd$export$7c2f74ff9251f64; }, function (v) { return $8b11dd70aaca6dbd$export$7c2f74ff9251f64 = v; });
$parcel$export(module.exports, "CACHE_ITEM_SIZE", function () { return $8b11dd70aaca6dbd$export$993f84dab107b880; }, function (v) { return $8b11dd70aaca6dbd$export$993f84dab107b880 = v; });
$parcel$export(module.exports, "CACHE_KEY", function () { return $8b11dd70aaca6dbd$export$7b9c2315e94d8d2f; }, function (v) { return $8b11dd70aaca6dbd$export$7b9c2315e94d8d2f = v; });
$parcel$export(module.exports, "CACHE_OPERATION", function () { return $8b11dd70aaca6dbd$export$f01e5cd42b9ec146; }, function (v) { return $8b11dd70aaca6dbd$export$f01e5cd42b9ec146 = v; });
$parcel$export(module.exports, "CACHE_TTL", function () { return $8b11dd70aaca6dbd$export$987f6b4367434b55; }, function (v) { return $8b11dd70aaca6dbd$export$987f6b4367434b55 = v; });
$parcel$export(module.exports, "CACHE_WRITE", function () { return $8b11dd70aaca6dbd$export$d9d145585d5022bb; }, function (v) { return $8b11dd70aaca6dbd$export$d9d145585d5022bb = v; });
$parcel$export(module.exports, "CHANNEL", function () { return $8b11dd70aaca6dbd$export$44ffba16bd48dac6; }, function (v) { return $8b11dd70aaca6dbd$export$44ffba16bd48dac6 = v; });
$parcel$export(module.exports, "CLIENT_ADDRESS", function () { return $8b11dd70aaca6dbd$export$3134892c5d2e251a; }, function (v) { return $8b11dd70aaca6dbd$export$3134892c5d2e251a = v; });
$parcel$export(module.exports, "CLIENT_PORT", function () { return $8b11dd70aaca6dbd$export$8495028d10296058; }, function (v) { return $8b11dd70aaca6dbd$export$8495028d10296058 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_DURATION", function () { return $8b11dd70aaca6dbd$export$d6d0e4fcf46d490c; }, function (v) { return $8b11dd70aaca6dbd$export$d6d0e4fcf46d490c = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_QUERY_TYPE", function () { return $8b11dd70aaca6dbd$export$658dced473c19301; }, function (v) { return $8b11dd70aaca6dbd$export$658dced473c19301 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_READ", function () { return $8b11dd70aaca6dbd$export$97b0f9c3fbe64076; }, function (v) { return $8b11dd70aaca6dbd$export$97b0f9c3fbe64076 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_WRITTEN", function () { return $8b11dd70aaca6dbd$export$cf2c95ed5efbe9eb; }, function (v) { return $8b11dd70aaca6dbd$export$cf2c95ed5efbe9eb = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS", function () { return $8b11dd70aaca6dbd$export$880007904f61a388; }, function (v) { return $8b11dd70aaca6dbd$export$880007904f61a388 = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ", function () { return $8b11dd70aaca6dbd$export$3e903b72d4d9e07d; }, function (v) { return $8b11dd70aaca6dbd$export$3e903b72d4d9e07d = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN", function () { return $8b11dd70aaca6dbd$export$34da07180e0e56af; }, function (v) { return $8b11dd70aaca6dbd$export$34da07180e0e56af = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_BUCKET", function () { return $8b11dd70aaca6dbd$export$c49aafdaeb061953; }, function (v) { return $8b11dd70aaca6dbd$export$c49aafdaeb061953 = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_OPERATION", function () { return $8b11dd70aaca6dbd$export$ceb762c61de2f17f; }, function (v) { return $8b11dd70aaca6dbd$export$ceb762c61de2f17f = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_DELIMITER", function () { return $8b11dd70aaca6dbd$export$a5f54ccfb28c0caf; }, function (v) { return $8b11dd70aaca6dbd$export$a5f54ccfb28c0caf = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_KEY", function () { return $8b11dd70aaca6dbd$export$1c86a56857b024db; }, function (v) { return $8b11dd70aaca6dbd$export$1c86a56857b024db = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PART_NUMBER", function () { return $8b11dd70aaca6dbd$export$7598f3464be47440; }, function (v) { return $8b11dd70aaca6dbd$export$7598f3464be47440 = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PREFIX", function () { return $8b11dd70aaca6dbd$export$b673289c971fc0ae; }, function (v) { return $8b11dd70aaca6dbd$export$b673289c971fc0ae = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_ATTEMPT", function () { return $8b11dd70aaca6dbd$export$98b23f3e6f0c2a6f; }, function (v) { return $8b11dd70aaca6dbd$export$98b23f3e6f0c2a6f = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF", function () { return $8b11dd70aaca6dbd$export$6ddeaf0498614ebb; }, function (v) { return $8b11dd70aaca6dbd$export$6ddeaf0498614ebb = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_DELAY", function () { return $8b11dd70aaca6dbd$export$97b78f78d64a7232; }, function (v) { return $8b11dd70aaca6dbd$export$97b78f78d64a7232 = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_LIMIT", function () { return $8b11dd70aaca6dbd$export$5147715be870fff7; }, function (v) { return $8b11dd70aaca6dbd$export$5147715be870fff7 = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_TIMEOUT", function () { return $8b11dd70aaca6dbd$export$5276bb46e6096fba; }, function (v) { return $8b11dd70aaca6dbd$export$5276bb46e6096fba = v; });
$parcel$export(module.exports, "CLOUD_ACCOUNT_ID", function () { return $8b11dd70aaca6dbd$export$cbcbc1f67a937cf3; }, function (v) { return $8b11dd70aaca6dbd$export$cbcbc1f67a937cf3 = v; });
$parcel$export(module.exports, "CLOUD_AVAILABILITY_ZONE", function () { return $8b11dd70aaca6dbd$export$226a2381b8f0cf78; }, function (v) { return $8b11dd70aaca6dbd$export$226a2381b8f0cf78 = v; });
$parcel$export(module.exports, "CLOUD_PLATFORM", function () { return $8b11dd70aaca6dbd$export$fd35512cae286064; }, function (v) { return $8b11dd70aaca6dbd$export$fd35512cae286064 = v; });
$parcel$export(module.exports, "CLOUD_PROVIDER", function () { return $8b11dd70aaca6dbd$export$de9bbf95ab1d81e; }, function (v) { return $8b11dd70aaca6dbd$export$de9bbf95ab1d81e = v; });
$parcel$export(module.exports, "CLOUD_REGION", function () { return $8b11dd70aaca6dbd$export$47fb20e8d18d7d15; }, function (v) { return $8b11dd70aaca6dbd$export$47fb20e8d18d7d15 = v; });
$parcel$export(module.exports, "CLOUD_RESOURCE_ID", function () { return $8b11dd70aaca6dbd$export$9db7964e4b8cb849; }, function (v) { return $8b11dd70aaca6dbd$export$9db7964e4b8cb849 = v; });
$parcel$export(module.exports, "CLS", function () { return $8b11dd70aaca6dbd$export$7139adf9d3bace41; }, function (v) { return $8b11dd70aaca6dbd$export$7139adf9d3bace41 = v; });
$parcel$export(module.exports, "CLS_SOURCE_KEY", function () { return $8b11dd70aaca6dbd$export$8ac3d09060e7f25d; }, function (v) { return $8b11dd70aaca6dbd$export$8ac3d09060e7f25d = v; });
$parcel$export(module.exports, "CLS_SOURCE_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$dad0e4778ea23971; }, function (v) { return $8b11dd70aaca6dbd$export$dad0e4778ea23971 = v; });
$parcel$export(module.exports, "CODE_FILEPATH", function () { return $8b11dd70aaca6dbd$export$c14d903ccf9385a8; }, function (v) { return $8b11dd70aaca6dbd$export$c14d903ccf9385a8 = v; });
$parcel$export(module.exports, "CODE_FILE_PATH", function () { return $8b11dd70aaca6dbd$export$934cded0041affd7; }, function (v) { return $8b11dd70aaca6dbd$export$934cded0041affd7 = v; });
$parcel$export(module.exports, "CODE_FUNCTION", function () { return $8b11dd70aaca6dbd$export$6386da1dcba88c9d; }, function (v) { return $8b11dd70aaca6dbd$export$6386da1dcba88c9d = v; });
$parcel$export(module.exports, "CODE_FUNCTION_NAME", function () { return $8b11dd70aaca6dbd$export$a3371797e606e2; }, function (v) { return $8b11dd70aaca6dbd$export$a3371797e606e2 = v; });
$parcel$export(module.exports, "CODE_LINENO", function () { return $8b11dd70aaca6dbd$export$a5bbef0af83b23e5; }, function (v) { return $8b11dd70aaca6dbd$export$a5bbef0af83b23e5 = v; });
$parcel$export(module.exports, "CODE_LINE_NUMBER", function () { return $8b11dd70aaca6dbd$export$91ed1f55874222a6; }, function (v) { return $8b11dd70aaca6dbd$export$91ed1f55874222a6 = v; });
$parcel$export(module.exports, "CODE_NAMESPACE", function () { return $8b11dd70aaca6dbd$export$23de81068d2aed1b; }, function (v) { return $8b11dd70aaca6dbd$export$23de81068d2aed1b = v; });
$parcel$export(module.exports, "CONNECTIONTYPE", function () { return $8b11dd70aaca6dbd$export$d738320e1fba9e9d; }, function (v) { return $8b11dd70aaca6dbd$export$d738320e1fba9e9d = v; });
$parcel$export(module.exports, "CONNECTION_RTT", function () { return $8b11dd70aaca6dbd$export$2eacdea75497e8a5; }, function (v) { return $8b11dd70aaca6dbd$export$2eacdea75497e8a5 = v; });
$parcel$export(module.exports, "CULTURE_CALENDAR", function () { return $8b11dd70aaca6dbd$export$2bc3ea101f86c1d2; }, function (v) { return $8b11dd70aaca6dbd$export$2bc3ea101f86c1d2 = v; });
$parcel$export(module.exports, "CULTURE_DISPLAY_NAME", function () { return $8b11dd70aaca6dbd$export$c54e27e8d90ee081; }, function (v) { return $8b11dd70aaca6dbd$export$c54e27e8d90ee081 = v; });
$parcel$export(module.exports, "CULTURE_IS_24_HOUR_FORMAT", function () { return $8b11dd70aaca6dbd$export$4943adcec371c2a6; }, function (v) { return $8b11dd70aaca6dbd$export$4943adcec371c2a6 = v; });
$parcel$export(module.exports, "CULTURE_LOCALE", function () { return $8b11dd70aaca6dbd$export$f000a5900d0480c2; }, function (v) { return $8b11dd70aaca6dbd$export$f000a5900d0480c2 = v; });
$parcel$export(module.exports, "CULTURE_TIMEZONE", function () { return $8b11dd70aaca6dbd$export$8f5234893868273b; }, function (v) { return $8b11dd70aaca6dbd$export$8f5234893868273b = v; });
$parcel$export(module.exports, "DB_COLLECTION_NAME", function () { return $8b11dd70aaca6dbd$export$1a35518f6e81e8c7; }, function (v) { return $8b11dd70aaca6dbd$export$1a35518f6e81e8c7 = v; });
$parcel$export(module.exports, "DB_DRIVER_NAME", function () { return $8b11dd70aaca6dbd$export$a2d90911eaae60fc; }, function (v) { return $8b11dd70aaca6dbd$export$a2d90911eaae60fc = v; });
$parcel$export(module.exports, "DB_NAME", function () { return $8b11dd70aaca6dbd$export$3c22ff8b64b8f565; }, function (v) { return $8b11dd70aaca6dbd$export$3c22ff8b64b8f565 = v; });
$parcel$export(module.exports, "DB_NAMESPACE", function () { return $8b11dd70aaca6dbd$export$b8019c0e2a5b5f0f; }, function (v) { return $8b11dd70aaca6dbd$export$b8019c0e2a5b5f0f = v; });
$parcel$export(module.exports, "DB_OPERATION", function () { return $8b11dd70aaca6dbd$export$8c11477e471467c8; }, function (v) { return $8b11dd70aaca6dbd$export$8c11477e471467c8 = v; });
$parcel$export(module.exports, "DB_OPERATION_BATCH_SIZE", function () { return $8b11dd70aaca6dbd$export$92a96f6363488aee; }, function (v) { return $8b11dd70aaca6dbd$export$92a96f6363488aee = v; });
$parcel$export(module.exports, "DB_OPERATION_NAME", function () { return $8b11dd70aaca6dbd$export$f91beb6088f9ded9; }, function (v) { return $8b11dd70aaca6dbd$export$f91beb6088f9ded9 = v; });
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY", function () { return $8b11dd70aaca6dbd$export$78bc7224576bf289; }, function (v) { return $8b11dd70aaca6dbd$export$78bc7224576bf289 = v; });
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$a8027e0ea0d93ca; }, function (v) { return $8b11dd70aaca6dbd$export$a8027e0ea0d93ca = v; });
$parcel$export(module.exports, "DB_QUERY_SUMMARY", function () { return $8b11dd70aaca6dbd$export$5e59d3aea52e5037; }, function (v) { return $8b11dd70aaca6dbd$export$5e59d3aea52e5037 = v; });
$parcel$export(module.exports, "DB_QUERY_TEXT", function () { return $8b11dd70aaca6dbd$export$47e408be0da7933f; }, function (v) { return $8b11dd70aaca6dbd$export$47e408be0da7933f = v; });
$parcel$export(module.exports, "DB_REDIS_CONNECTION", function () { return $8b11dd70aaca6dbd$export$d5772b934ca13e57; }, function (v) { return $8b11dd70aaca6dbd$export$d5772b934ca13e57 = v; });
$parcel$export(module.exports, "DB_REDIS_KEY", function () { return $8b11dd70aaca6dbd$export$36e47f6a5777561d; }, function (v) { return $8b11dd70aaca6dbd$export$36e47f6a5777561d = v; });
$parcel$export(module.exports, "DB_REDIS_PARAMETERS", function () { return $8b11dd70aaca6dbd$export$e768cbc99cd68acf; }, function (v) { return $8b11dd70aaca6dbd$export$e768cbc99cd68acf = v; });
$parcel$export(module.exports, "DB_RESPONSE_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$dfcc6c69df1343f2; }, function (v) { return $8b11dd70aaca6dbd$export$dfcc6c69df1343f2 = v; });
$parcel$export(module.exports, "DB_SQL_BINDINGS", function () { return $8b11dd70aaca6dbd$export$69b0a5d9226b5211; }, function (v) { return $8b11dd70aaca6dbd$export$69b0a5d9226b5211 = v; });
$parcel$export(module.exports, "DB_STATEMENT", function () { return $8b11dd70aaca6dbd$export$da010a4f4fc971ae; }, function (v) { return $8b11dd70aaca6dbd$export$da010a4f4fc971ae = v; });
$parcel$export(module.exports, "DB_STORED_PROCEDURE_NAME", function () { return $8b11dd70aaca6dbd$export$5d515b35be0601a0; }, function (v) { return $8b11dd70aaca6dbd$export$5d515b35be0601a0 = v; });
$parcel$export(module.exports, "DB_SYSTEM", function () { return $8b11dd70aaca6dbd$export$3e1b1037a315c5ca; }, function (v) { return $8b11dd70aaca6dbd$export$3e1b1037a315c5ca = v; });
$parcel$export(module.exports, "DB_SYSTEM_NAME", function () { return $8b11dd70aaca6dbd$export$847fdd494825f0fb; }, function (v) { return $8b11dd70aaca6dbd$export$847fdd494825f0fb = v; });
$parcel$export(module.exports, "DB_USER", function () { return $8b11dd70aaca6dbd$export$a9d76f26c6c730a9; }, function (v) { return $8b11dd70aaca6dbd$export$a9d76f26c6c730a9 = v; });
$parcel$export(module.exports, "DEVICEMEMORY", function () { return $8b11dd70aaca6dbd$export$de03f86d1c9866ca; }, function (v) { return $8b11dd70aaca6dbd$export$de03f86d1c9866ca = v; });
$parcel$export(module.exports, "DEVICE_ARCHS", function () { return $8b11dd70aaca6dbd$export$65798ecab7eef8c; }, function (v) { return $8b11dd70aaca6dbd$export$65798ecab7eef8c = v; });
$parcel$export(module.exports, "DEVICE_BATTERY_LEVEL", function () { return $8b11dd70aaca6dbd$export$22aa61f48b9c79a0; }, function (v) { return $8b11dd70aaca6dbd$export$22aa61f48b9c79a0 = v; });
$parcel$export(module.exports, "DEVICE_BATTERY_TEMPERATURE", function () { return $8b11dd70aaca6dbd$export$69f5fb98f5aed812; }, function (v) { return $8b11dd70aaca6dbd$export$69f5fb98f5aed812 = v; });
$parcel$export(module.exports, "DEVICE_BOOT_TIME", function () { return $8b11dd70aaca6dbd$export$bdea5d1006fd280a; }, function (v) { return $8b11dd70aaca6dbd$export$bdea5d1006fd280a = v; });
$parcel$export(module.exports, "DEVICE_BRAND", function () { return $8b11dd70aaca6dbd$export$f63a7230c5b1d609; }, function (v) { return $8b11dd70aaca6dbd$export$f63a7230c5b1d609 = v; });
$parcel$export(module.exports, "DEVICE_CHARGING", function () { return $8b11dd70aaca6dbd$export$6f25e59b05bb8e17; }, function (v) { return $8b11dd70aaca6dbd$export$6f25e59b05bb8e17 = v; });
$parcel$export(module.exports, "DEVICE_CHIPSET", function () { return $8b11dd70aaca6dbd$export$a56ad13c4afc7421; }, function (v) { return $8b11dd70aaca6dbd$export$a56ad13c4afc7421 = v; });
$parcel$export(module.exports, "DEVICE_CLASS", function () { return $8b11dd70aaca6dbd$export$d9ce89ce8912bf12; }, function (v) { return $8b11dd70aaca6dbd$export$d9ce89ce8912bf12 = v; });
$parcel$export(module.exports, "DEVICE_CONNECTION_TYPE", function () { return $8b11dd70aaca6dbd$export$17094e5f380e4162; }, function (v) { return $8b11dd70aaca6dbd$export$17094e5f380e4162 = v; });
$parcel$export(module.exports, "DEVICE_CPU_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$28a0ffdf747973a0; }, function (v) { return $8b11dd70aaca6dbd$export$28a0ffdf747973a0 = v; });
$parcel$export(module.exports, "DEVICE_EXTERNAL_FREE_STORAGE", function () { return $8b11dd70aaca6dbd$export$5480ae1ba5d50bb9; }, function (v) { return $8b11dd70aaca6dbd$export$5480ae1ba5d50bb9 = v; });
$parcel$export(module.exports, "DEVICE_EXTERNAL_STORAGE_SIZE", function () { return $8b11dd70aaca6dbd$export$edc72ee4a17f5152; }, function (v) { return $8b11dd70aaca6dbd$export$edc72ee4a17f5152 = v; });
$parcel$export(module.exports, "DEVICE_FAMILY", function () { return $8b11dd70aaca6dbd$export$19e4df138d354f8b; }, function (v) { return $8b11dd70aaca6dbd$export$19e4df138d354f8b = v; });
$parcel$export(module.exports, "DEVICE_FREE_MEMORY", function () { return $8b11dd70aaca6dbd$export$92b0d20fa482b4b2; }, function (v) { return $8b11dd70aaca6dbd$export$92b0d20fa482b4b2 = v; });
$parcel$export(module.exports, "DEVICE_FREE_STORAGE", function () { return $8b11dd70aaca6dbd$export$3f638a793d61933f; }, function (v) { return $8b11dd70aaca6dbd$export$3f638a793d61933f = v; });
$parcel$export(module.exports, "DEVICE_ID", function () { return $8b11dd70aaca6dbd$export$3f511731cc3687d4; }, function (v) { return $8b11dd70aaca6dbd$export$3f511731cc3687d4 = v; });
$parcel$export(module.exports, "DEVICE_LOCALE", function () { return $8b11dd70aaca6dbd$export$692b08741d6b6265; }, function (v) { return $8b11dd70aaca6dbd$export$692b08741d6b6265 = v; });
$parcel$export(module.exports, "DEVICE_LOW_MEMORY", function () { return $8b11dd70aaca6dbd$export$cf67f8cb2324428e; }, function (v) { return $8b11dd70aaca6dbd$export$cf67f8cb2324428e = v; });
$parcel$export(module.exports, "DEVICE_LOW_POWER_MODE", function () { return $8b11dd70aaca6dbd$export$9d4197c1ffc5f359; }, function (v) { return $8b11dd70aaca6dbd$export$9d4197c1ffc5f359 = v; });
$parcel$export(module.exports, "DEVICE_MANUFACTURER", function () { return $8b11dd70aaca6dbd$export$509634fbff540e75; }, function (v) { return $8b11dd70aaca6dbd$export$509634fbff540e75 = v; });
$parcel$export(module.exports, "DEVICE_MEMORY_ESTIMATED_CAPACITY", function () { return $8b11dd70aaca6dbd$export$ccbc4fdff4b5eff5; }, function (v) { return $8b11dd70aaca6dbd$export$ccbc4fdff4b5eff5 = v; });
$parcel$export(module.exports, "DEVICE_MEMORY_SIZE", function () { return $8b11dd70aaca6dbd$export$e0cb371ca548b1d6; }, function (v) { return $8b11dd70aaca6dbd$export$e0cb371ca548b1d6 = v; });
$parcel$export(module.exports, "DEVICE_MODEL", function () { return $8b11dd70aaca6dbd$export$3c39026d09026bc2; }, function (v) { return $8b11dd70aaca6dbd$export$3c39026d09026bc2 = v; });
$parcel$export(module.exports, "DEVICE_MODEL_ID", function () { return $8b11dd70aaca6dbd$export$bf9e8248cb72cf00; }, function (v) { return $8b11dd70aaca6dbd$export$bf9e8248cb72cf00 = v; });
$parcel$export(module.exports, "DEVICE_NAME", function () { return $8b11dd70aaca6dbd$export$1054f22a72121d0f; }, function (v) { return $8b11dd70aaca6dbd$export$1054f22a72121d0f = v; });
$parcel$export(module.exports, "DEVICE_ONLINE", function () { return $8b11dd70aaca6dbd$export$723b8a59dad2e467; }, function (v) { return $8b11dd70aaca6dbd$export$723b8a59dad2e467 = v; });
$parcel$export(module.exports, "DEVICE_ORIENTATION", function () { return $8b11dd70aaca6dbd$export$160081ff141bac8e; }, function (v) { return $8b11dd70aaca6dbd$export$160081ff141bac8e = v; });
$parcel$export(module.exports, "DEVICE_PROCESSOR_COUNT", function () { return $8b11dd70aaca6dbd$export$194f62c84d27310; }, function (v) { return $8b11dd70aaca6dbd$export$194f62c84d27310 = v; });
$parcel$export(module.exports, "DEVICE_PROCESSOR_FREQUENCY", function () { return $8b11dd70aaca6dbd$export$7ed866d57b018d09; }, function (v) { return $8b11dd70aaca6dbd$export$7ed866d57b018d09 = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_DENSITY", function () { return $8b11dd70aaca6dbd$export$d50bae4562e03e5; }, function (v) { return $8b11dd70aaca6dbd$export$d50bae4562e03e5 = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_DPI", function () { return $8b11dd70aaca6dbd$export$649ea67a18fe8e8b; }, function (v) { return $8b11dd70aaca6dbd$export$649ea67a18fe8e8b = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_HEIGHT_PIXELS", function () { return $8b11dd70aaca6dbd$export$136a5c1b43caaccd; }, function (v) { return $8b11dd70aaca6dbd$export$136a5c1b43caaccd = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_WIDTH_PIXELS", function () { return $8b11dd70aaca6dbd$export$e33a28ea554b6ddc; }, function (v) { return $8b11dd70aaca6dbd$export$e33a28ea554b6ddc = v; });
$parcel$export(module.exports, "DEVICE_SIMULATOR", function () { return $8b11dd70aaca6dbd$export$acbe2d25ac76ea64; }, function (v) { return $8b11dd70aaca6dbd$export$acbe2d25ac76ea64 = v; });
$parcel$export(module.exports, "DEVICE_STORAGE_SIZE", function () { return $8b11dd70aaca6dbd$export$793c13e17d7e5e2b; }, function (v) { return $8b11dd70aaca6dbd$export$793c13e17d7e5e2b = v; });
$parcel$export(module.exports, "DEVICE_THERMAL_STATE", function () { return $8b11dd70aaca6dbd$export$a5617e33b89fd956; }, function (v) { return $8b11dd70aaca6dbd$export$a5617e33b89fd956 = v; });
$parcel$export(module.exports, "DEVICE_TIMEZONE", function () { return $8b11dd70aaca6dbd$export$b51f82164fa31e07; }, function (v) { return $8b11dd70aaca6dbd$export$b51f82164fa31e07 = v; });
$parcel$export(module.exports, "DEVICE_USABLE_MEMORY", function () { return $8b11dd70aaca6dbd$export$f2ef55183c04d202; }, function (v) { return $8b11dd70aaca6dbd$export$f2ef55183c04d202 = v; });
$parcel$export(module.exports, "DIST", function () { return $8b11dd70aaca6dbd$export$7c98fc0c48a16b1c; }, function (v) { return $8b11dd70aaca6dbd$export$7c98fc0c48a16b1c = v; });
$parcel$export(module.exports, "EFFECTIVECONNECTIONTYPE", function () { return $8b11dd70aaca6dbd$export$f0511e328234ae83; }, function (v) { return $8b11dd70aaca6dbd$export$f0511e328234ae83 = v; });
$parcel$export(module.exports, "ENVIRONMENT", function () { return $8b11dd70aaca6dbd$export$be46596bc6608f3b; }, function (v) { return $8b11dd70aaca6dbd$export$be46596bc6608f3b = v; });
$parcel$export(module.exports, "ERROR_TYPE", function () { return $8b11dd70aaca6dbd$export$f215947b3d76a6b7; }, function (v) { return $8b11dd70aaca6dbd$export$f215947b3d76a6b7 = v; });
$parcel$export(module.exports, "EVENT_ID", function () { return $8b11dd70aaca6dbd$export$89bbc91416db6670; }, function (v) { return $8b11dd70aaca6dbd$export$89bbc91416db6670 = v; });
$parcel$export(module.exports, "EVENT_NAME", function () { return $8b11dd70aaca6dbd$export$b4b5eff8a8712c89; }, function (v) { return $8b11dd70aaca6dbd$export$b4b5eff8a8712c89 = v; });
$parcel$export(module.exports, "EXCEPTION_ESCAPED", function () { return $8b11dd70aaca6dbd$export$f455969a57ab8a03; }, function (v) { return $8b11dd70aaca6dbd$export$f455969a57ab8a03 = v; });
$parcel$export(module.exports, "EXCEPTION_MESSAGE", function () { return $8b11dd70aaca6dbd$export$13f2f8f42af49cec; }, function (v) { return $8b11dd70aaca6dbd$export$13f2f8f42af49cec = v; });
$parcel$export(module.exports, "EXCEPTION_STACKTRACE", function () { return $8b11dd70aaca6dbd$export$cd357afe2ffdd2c3; }, function (v) { return $8b11dd70aaca6dbd$export$cd357afe2ffdd2c3 = v; });
$parcel$export(module.exports, "EXCEPTION_TYPE", function () { return $8b11dd70aaca6dbd$export$d9ca2a279a11be5e; }, function (v) { return $8b11dd70aaca6dbd$export$d9ca2a279a11be5e = v; });
$parcel$export(module.exports, "FAAS_COLDSTART", function () { return $8b11dd70aaca6dbd$export$bbd59a8c7efad4c9; }, function (v) { return $8b11dd70aaca6dbd$export$bbd59a8c7efad4c9 = v; });
$parcel$export(module.exports, "FAAS_CRON", function () { return $8b11dd70aaca6dbd$export$8413282a17f1cda5; }, function (v) { return $8b11dd70aaca6dbd$export$8413282a17f1cda5 = v; });
$parcel$export(module.exports, "FAAS_DURATION_IN_MS", function () { return $8b11dd70aaca6dbd$export$30d19ddc7705e7e8; }, function (v) { return $8b11dd70aaca6dbd$export$30d19ddc7705e7e8 = v; });
$parcel$export(module.exports, "FAAS_ENTRY_POINT", function () { return $8b11dd70aaca6dbd$export$64a4f09e2444b3d; }, function (v) { return $8b11dd70aaca6dbd$export$64a4f09e2444b3d = v; });
$parcel$export(module.exports, "FAAS_EXECUTION", function () { return $8b11dd70aaca6dbd$export$645b039fe163809e; }, function (v) { return $8b11dd70aaca6dbd$export$645b039fe163809e = v; });
$parcel$export(module.exports, "FAAS_ID", function () { return $8b11dd70aaca6dbd$export$b23ef8b8ffa607e1; }, function (v) { return $8b11dd70aaca6dbd$export$b23ef8b8ffa607e1 = v; });
$parcel$export(module.exports, "FAAS_IDENTITY", function () { return $8b11dd70aaca6dbd$export$8bf64516740c1369; }, function (v) { return $8b11dd70aaca6dbd$export$8bf64516740c1369 = v; });
$parcel$export(module.exports, "FAAS_INVOCATION_ID", function () { return $8b11dd70aaca6dbd$export$9a0dc8e612f3e10b; }, function (v) { return $8b11dd70aaca6dbd$export$9a0dc8e612f3e10b = v; });
$parcel$export(module.exports, "FAAS_INVOKED_NAME", function () { return $8b11dd70aaca6dbd$export$abe90fedb3dddda2; }, function (v) { return $8b11dd70aaca6dbd$export$abe90fedb3dddda2 = v; });
$parcel$export(module.exports, "FAAS_INVOKED_PROVIDER", function () { return $8b11dd70aaca6dbd$export$4a19da9c85ed2ade; }, function (v) { return $8b11dd70aaca6dbd$export$4a19da9c85ed2ade = v; });
$parcel$export(module.exports, "FAAS_INVOKED_REGION", function () { return $8b11dd70aaca6dbd$export$5e091479f094bdbc; }, function (v) { return $8b11dd70aaca6dbd$export$5e091479f094bdbc = v; });
$parcel$export(module.exports, "FAAS_NAME", function () { return $8b11dd70aaca6dbd$export$d70909b5aa96a79a; }, function (v) { return $8b11dd70aaca6dbd$export$d70909b5aa96a79a = v; });
$parcel$export(module.exports, "FAAS_TIME", function () { return $8b11dd70aaca6dbd$export$651d142a8017d83d; }, function (v) { return $8b11dd70aaca6dbd$export$651d142a8017d83d = v; });
$parcel$export(module.exports, "FAAS_TRIGGER", function () { return $8b11dd70aaca6dbd$export$44382a010a9f7fcf; }, function (v) { return $8b11dd70aaca6dbd$export$44382a010a9f7fcf = v; });
$parcel$export(module.exports, "FAAS_VERSION", function () { return $8b11dd70aaca6dbd$export$807abfdc6b7b9338; }, function (v) { return $8b11dd70aaca6dbd$export$807abfdc6b7b9338 = v; });
$parcel$export(module.exports, "FCP", function () { return $8b11dd70aaca6dbd$export$31881d07f2569218; }, function (v) { return $8b11dd70aaca6dbd$export$31881d07f2569218 = v; });
$parcel$export(module.exports, "FLAG_EVALUATION_KEY", function () { return $8b11dd70aaca6dbd$export$e5bbf306deb709a6; }, function (v) { return $8b11dd70aaca6dbd$export$e5bbf306deb709a6 = v; });
$parcel$export(module.exports, "FLAG_EVALUATION_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$aa8721167c5c8d2d; }, function (v) { return $8b11dd70aaca6dbd$export$aa8721167c5c8d2d = v; });
$parcel$export(module.exports, "FP", function () { return $8b11dd70aaca6dbd$export$757b93e5b3adc7cb; }, function (v) { return $8b11dd70aaca6dbd$export$757b93e5b3adc7cb = v; });
$parcel$export(module.exports, "FRAMES_DELAY", function () { return $8b11dd70aaca6dbd$export$f869eaa92db1dc9b; }, function (v) { return $8b11dd70aaca6dbd$export$f869eaa92db1dc9b = v; });
$parcel$export(module.exports, "FRAMES_FROZEN", function () { return $8b11dd70aaca6dbd$export$5d1d761e41c32d9e; }, function (v) { return $8b11dd70aaca6dbd$export$5d1d761e41c32d9e = v; });
$parcel$export(module.exports, "FRAMES_FROZEN_RATE", function () { return $8b11dd70aaca6dbd$export$8aec72d9491f9399; }, function (v) { return $8b11dd70aaca6dbd$export$8aec72d9491f9399 = v; });
$parcel$export(module.exports, "FRAMES_SLOW", function () { return $8b11dd70aaca6dbd$export$5562635d2be2ab25; }, function (v) { return $8b11dd70aaca6dbd$export$5562635d2be2ab25 = v; });
$parcel$export(module.exports, "FRAMES_SLOW_RATE", function () { return $8b11dd70aaca6dbd$export$2dc31837ce6f7a3d; }, function (v) { return $8b11dd70aaca6dbd$export$2dc31837ce6f7a3d = v; });
$parcel$export(module.exports, "FRAMES_TOTAL", function () { return $8b11dd70aaca6dbd$export$b561df15f64d32e3; }, function (v) { return $8b11dd70aaca6dbd$export$b561df15f64d32e3 = v; });
$parcel$export(module.exports, "FS_ERROR", function () { return $8b11dd70aaca6dbd$export$181f78b28f2ffa57; }, function (v) { return $8b11dd70aaca6dbd$export$181f78b28f2ffa57 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_ID", function () { return $8b11dd70aaca6dbd$export$6c97c77b89571c75; }, function (v) { return $8b11dd70aaca6dbd$export$6c97c77b89571c75 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_TYPE", function () { return $8b11dd70aaca6dbd$export$51e431eaf1f9bf58; }, function (v) { return $8b11dd70aaca6dbd$export$51e431eaf1f9bf58 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_ID", function () { return $8b11dd70aaca6dbd$export$71429c7ef7cb7063; }, function (v) { return $8b11dd70aaca6dbd$export$71429c7ef7cb7063 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_RESOURCE", function () { return $8b11dd70aaca6dbd$export$99905d7583a6e8ac; }, function (v) { return $8b11dd70aaca6dbd$export$99905d7583a6e8ac = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SOURCE", function () { return $8b11dd70aaca6dbd$export$b6c4be74fd0c06bd; }, function (v) { return $8b11dd70aaca6dbd$export$b6c4be74fd0c06bd = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SPECVERSION", function () { return $8b11dd70aaca6dbd$export$fd23e5b8d261a89; }, function (v) { return $8b11dd70aaca6dbd$export$fd23e5b8d261a89 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIME", function () { return $8b11dd70aaca6dbd$export$25fabc9b3d1dd567; }, function (v) { return $8b11dd70aaca6dbd$export$25fabc9b3d1dd567 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIMESTAMP", function () { return $8b11dd70aaca6dbd$export$41507f7b07dad151; }, function (v) { return $8b11dd70aaca6dbd$export$41507f7b07dad151 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TYPE", function () { return $8b11dd70aaca6dbd$export$1352f3699c35dd73; }, function (v) { return $8b11dd70aaca6dbd$export$1352f3699c35dd73 = v; });
$parcel$export(module.exports, "GCP_PROJECT_ID", function () { return $8b11dd70aaca6dbd$export$fd6c9d5c74d943ac; }, function (v) { return $8b11dd70aaca6dbd$export$fd6c9d5c74d943ac = v; });
$parcel$export(module.exports, "GEN_AI_AGENT_NAME", function () { return $8b11dd70aaca6dbd$export$c29634e3cf41e479; }, function (v) { return $8b11dd70aaca6dbd$export$c29634e3cf41e479 = v; });
$parcel$export(module.exports, "GEN_AI_CONTEXT_UTILIZATION", function () { return $8b11dd70aaca6dbd$export$e6a60882cce7a085; }, function (v) { return $8b11dd70aaca6dbd$export$e6a60882cce7a085 = v; });
$parcel$export(module.exports, "GEN_AI_CONTEXT_WINDOW_SIZE", function () { return $8b11dd70aaca6dbd$export$6773c9098ba5e194; }, function (v) { return $8b11dd70aaca6dbd$export$6773c9098ba5e194 = v; });
$parcel$export(module.exports, "GEN_AI_CONVERSATION_ID", function () { return $8b11dd70aaca6dbd$export$6ee6b62f50047686; }, function (v) { return $8b11dd70aaca6dbd$export$6ee6b62f50047686 = v; });
$parcel$export(module.exports, "GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$efac052bb3661242; }, function (v) { return $8b11dd70aaca6dbd$export$efac052bb3661242 = v; });
$parcel$export(module.exports, "GEN_AI_COST_CACHE_READ_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$7ccd63b9ca955862; }, function (v) { return $8b11dd70aaca6dbd$export$7ccd63b9ca955862 = v; });
$parcel$export(module.exports, "GEN_AI_COST_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$50921df5a58cb3ef; }, function (v) { return $8b11dd70aaca6dbd$export$50921df5a58cb3ef = v; });
$parcel$export(module.exports, "GEN_AI_COST_OUTPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$8e48efc7acb57a97; }, function (v) { return $8b11dd70aaca6dbd$export$8e48efc7acb57a97 = v; });
$parcel$export(module.exports, "GEN_AI_COST_REASONING_OUTPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$cea9121727113f77; }, function (v) { return $8b11dd70aaca6dbd$export$cea9121727113f77 = v; });
$parcel$export(module.exports, "GEN_AI_COST_TOTAL_TOKENS", function () { return $8b11dd70aaca6dbd$export$bed35ff7f9af3aaa; }, function (v) { return $8b11dd70aaca6dbd$export$bed35ff7f9af3aaa = v; });
$parcel$export(module.exports, "GEN_AI_EMBEDDINGS_INPUT", function () { return $8b11dd70aaca6dbd$export$6b729e898b9067ce; }, function (v) { return $8b11dd70aaca6dbd$export$6b729e898b9067ce = v; });
$parcel$export(module.exports, "GEN_AI_FUNCTION_ID", function () { return $8b11dd70aaca6dbd$export$984fbab9b52f7e24; }, function (v) { return $8b11dd70aaca6dbd$export$984fbab9b52f7e24 = v; });
$parcel$export(module.exports, "GEN_AI_INPUT_MESSAGES", function () { return $8b11dd70aaca6dbd$export$9ea17906a87ada6f; }, function (v) { return $8b11dd70aaca6dbd$export$9ea17906a87ada6f = v; });
$parcel$export(module.exports, "GEN_AI_OPERATION_NAME", function () { return $8b11dd70aaca6dbd$export$394b443aaff3ef92; }, function (v) { return $8b11dd70aaca6dbd$export$394b443aaff3ef92 = v; });
$parcel$export(module.exports, "GEN_AI_OPERATION_TYPE", function () { return $8b11dd70aaca6dbd$export$6ddc374adbc06720; }, function (v) { return $8b11dd70aaca6dbd$export$6ddc374adbc06720 = v; });
$parcel$export(module.exports, "GEN_AI_OUTPUT_MESSAGES", function () { return $8b11dd70aaca6dbd$export$ab8c7ebc9add56b2; }, function (v) { return $8b11dd70aaca6dbd$export$ab8c7ebc9add56b2 = v; });
$parcel$export(module.exports, "GEN_AI_PIPELINE_NAME", function () { return $8b11dd70aaca6dbd$export$40ecc5bcd633d1ee; }, function (v) { return $8b11dd70aaca6dbd$export$40ecc5bcd633d1ee = v; });
$parcel$export(module.exports, "GEN_AI_PROMPT", function () { return $8b11dd70aaca6dbd$export$86a8df7fff52fc69; }, function (v) { return $8b11dd70aaca6dbd$export$86a8df7fff52fc69 = v; });
$parcel$export(module.exports, "GEN_AI_PROMPT_NAME", function () { return $8b11dd70aaca6dbd$export$cf2115d46768f4c5; }, function (v) { return $8b11dd70aaca6dbd$export$cf2115d46768f4c5 = v; });
$parcel$export(module.exports, "GEN_AI_PROVIDER_NAME", function () { return $8b11dd70aaca6dbd$export$3d7e036e195764db; }, function (v) { return $8b11dd70aaca6dbd$export$3d7e036e195764db = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_AVAILABLE_TOOLS", function () { return $8b11dd70aaca6dbd$export$60c1d11221608cee; }, function (v) { return $8b11dd70aaca6dbd$export$60c1d11221608cee = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_FREQUENCY_PENALTY", function () { return $8b11dd70aaca6dbd$export$bc3cef164abbc42c; }, function (v) { return $8b11dd70aaca6dbd$export$bc3cef164abbc42c = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MAX_TOKENS", function () { return $8b11dd70aaca6dbd$export$43f9afb62cd79dec; }, function (v) { return $8b11dd70aaca6dbd$export$43f9afb62cd79dec = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MESSAGES", function () { return $8b11dd70aaca6dbd$export$a5ab4ffc4765f75f; }, function (v) { return $8b11dd70aaca6dbd$export$a5ab4ffc4765f75f = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MODEL", function () { return $8b11dd70aaca6dbd$export$ccf46db9ab1743ec; }, function (v) { return $8b11dd70aaca6dbd$export$ccf46db9ab1743ec = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_PRESENCE_PENALTY", function () { return $8b11dd70aaca6dbd$export$76c1c247342d776; }, function (v) { return $8b11dd70aaca6dbd$export$76c1c247342d776 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_REASONING_EFFORT", function () { return $8b11dd70aaca6dbd$export$92f5944f0b02c9fb; }, function (v) { return $8b11dd70aaca6dbd$export$92f5944f0b02c9fb = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_SEED", function () { return $8b11dd70aaca6dbd$export$867eeefcb1c95b27; }, function (v) { return $8b11dd70aaca6dbd$export$867eeefcb1c95b27 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_STOP_SEQUENCES", function () { return $8b11dd70aaca6dbd$export$5ada4697ae6aa17e; }, function (v) { return $8b11dd70aaca6dbd$export$5ada4697ae6aa17e = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TEMPERATURE", function () { return $8b11dd70aaca6dbd$export$427122300e8d54d0; }, function (v) { return $8b11dd70aaca6dbd$export$427122300e8d54d0 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_K", function () { return $8b11dd70aaca6dbd$export$bcea8881375c352f; }, function (v) { return $8b11dd70aaca6dbd$export$bcea8881375c352f = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_P", function () { return $8b11dd70aaca6dbd$export$b867715f9a0c04e9; }, function (v) { return $8b11dd70aaca6dbd$export$b867715f9a0c04e9 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_FINISH_REASONS", function () { return $8b11dd70aaca6dbd$export$69878a39cbdbe097; }, function (v) { return $8b11dd70aaca6dbd$export$69878a39cbdbe097 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_ID", function () { return $8b11dd70aaca6dbd$export$584c61a1b769552d; }, function (v) { return $8b11dd70aaca6dbd$export$584c61a1b769552d = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_MODEL", function () { return $8b11dd70aaca6dbd$export$8169ebcb0b0331dd; }, function (v) { return $8b11dd70aaca6dbd$export$8169ebcb0b0331dd = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_STREAMING", function () { return $8b11dd70aaca6dbd$export$2c9713b624877853; }, function (v) { return $8b11dd70aaca6dbd$export$2c9713b624877853 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TEXT", function () { return $8b11dd70aaca6dbd$export$45942692aeb454e0; }, function (v) { return $8b11dd70aaca6dbd$export$45942692aeb454e0 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK", function () { return $8b11dd70aaca6dbd$export$8e5efeaa031210cd; }, function (v) { return $8b11dd70aaca6dbd$export$8e5efeaa031210cd = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN", function () { return $8b11dd70aaca6dbd$export$35a62769ee05a05a; }, function (v) { return $8b11dd70aaca6dbd$export$35a62769ee05a05a = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOKENS_PER_SECOND", function () { return $8b11dd70aaca6dbd$export$8ea4f7e986ca4b06; }, function (v) { return $8b11dd70aaca6dbd$export$8ea4f7e986ca4b06 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOOL_CALLS", function () { return $8b11dd70aaca6dbd$export$d2fd9ecaff0285a4; }, function (v) { return $8b11dd70aaca6dbd$export$d2fd9ecaff0285a4 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM", function () { return $8b11dd70aaca6dbd$export$a6c8e656a4f9bb67; }, function (v) { return $8b11dd70aaca6dbd$export$a6c8e656a4f9bb67 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM_INSTRUCTIONS", function () { return $8b11dd70aaca6dbd$export$352a8075b163d53; }, function (v) { return $8b11dd70aaca6dbd$export$352a8075b163d53 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM_MESSAGE", function () { return $8b11dd70aaca6dbd$export$426d7b90ba5d79db; }, function (v) { return $8b11dd70aaca6dbd$export$426d7b90ba5d79db = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_ARGUMENTS", function () { return $8b11dd70aaca6dbd$export$f5a1ee40934d19ce; }, function (v) { return $8b11dd70aaca6dbd$export$f5a1ee40934d19ce = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_RESULT", function () { return $8b11dd70aaca6dbd$export$1ba812a9756622ce; }, function (v) { return $8b11dd70aaca6dbd$export$1ba812a9756622ce = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_DEFINITIONS", function () { return $8b11dd70aaca6dbd$export$351120039c36e03; }, function (v) { return $8b11dd70aaca6dbd$export$351120039c36e03 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$d42aa25ca09e17c4; }, function (v) { return $8b11dd70aaca6dbd$export$d42aa25ca09e17c4 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_INPUT", function () { return $8b11dd70aaca6dbd$export$d268db29b88a4286; }, function (v) { return $8b11dd70aaca6dbd$export$d268db29b88a4286 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_MESSAGE", function () { return $8b11dd70aaca6dbd$export$c5deb6018f2d6251; }, function (v) { return $8b11dd70aaca6dbd$export$c5deb6018f2d6251 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_NAME", function () { return $8b11dd70aaca6dbd$export$e06baa3034409453; }, function (v) { return $8b11dd70aaca6dbd$export$e06baa3034409453 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_OUTPUT", function () { return $8b11dd70aaca6dbd$export$646fdb5910ce3931; }, function (v) { return $8b11dd70aaca6dbd$export$646fdb5910ce3931 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_TYPE", function () { return $8b11dd70aaca6dbd$export$662e3d2d4361e29b; }, function (v) { return $8b11dd70aaca6dbd$export$662e3d2d4361e29b = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$1de3962f221ba441; }, function (v) { return $8b11dd70aaca6dbd$export$1de3962f221ba441 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$a4b3f0f5499c8738; }, function (v) { return $8b11dd70aaca6dbd$export$a4b3f0f5499c8738 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_COMPLETION_TOKENS", function () { return $8b11dd70aaca6dbd$export$1aecdac6cecbdc5b; }, function (v) { return $8b11dd70aaca6dbd$export$1aecdac6cecbdc5b = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$2eb2ab35b317a103; }, function (v) { return $8b11dd70aaca6dbd$export$2eb2ab35b317a103 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHED", function () { return $8b11dd70aaca6dbd$export$c7e14ea195ede241; }, function (v) { return $8b11dd70aaca6dbd$export$c7e14ea195ede241 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE", function () { return $8b11dd70aaca6dbd$export$41ac034e7b9725a2; }, function (v) { return $8b11dd70aaca6dbd$export$41ac034e7b9725a2 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$9e521119d7751e37; }, function (v) { return $8b11dd70aaca6dbd$export$9e521119d7751e37 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS_REASONING", function () { return $8b11dd70aaca6dbd$export$cbac8f541a64a150; }, function (v) { return $8b11dd70aaca6dbd$export$cbac8f541a64a150 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_PROMPT_TOKENS", function () { return $8b11dd70aaca6dbd$export$93dd08efa94c9dd4; }, function (v) { return $8b11dd70aaca6dbd$export$93dd08efa94c9dd4 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_REASONING_OUTPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$183e3523dac20bca; }, function (v) { return $8b11dd70aaca6dbd$export$183e3523dac20bca = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_TOTAL_TOKENS", function () { return $8b11dd70aaca6dbd$export$3867ca1d8381d4e3; }, function (v) { return $8b11dd70aaca6dbd$export$3867ca1d8381d4e3 = v; });
$parcel$export(module.exports, "GRAPHQL_DOCUMENT", function () { return $8b11dd70aaca6dbd$export$11febcf9917c0057; }, function (v) { return $8b11dd70aaca6dbd$export$11febcf9917c0057 = v; });
$parcel$export(module.exports, "GRAPHQL_OPERATION_NAME", function () { return $8b11dd70aaca6dbd$export$88ae1ee0c0a63398; }, function (v) { return $8b11dd70aaca6dbd$export$88ae1ee0c0a63398 = v; });
$parcel$export(module.exports, "GRAPHQL_OPERATION_TYPE", function () { return $8b11dd70aaca6dbd$export$d5bd986d1f283f29; }, function (v) { return $8b11dd70aaca6dbd$export$d5bd986d1f283f29 = v; });
$parcel$export(module.exports, "HARDWARECONCURRENCY", function () { return $8b11dd70aaca6dbd$export$fc4a2d238535d998; }, function (v) { return $8b11dd70aaca6dbd$export$fc4a2d238535d998 = v; });
$parcel$export(module.exports, "HTTP_CLIENT_IP", function () { return $8b11dd70aaca6dbd$export$57e53a60bf563f41; }, function (v) { return $8b11dd70aaca6dbd$export$57e53a60bf563f41 = v; });
$parcel$export(module.exports, "HTTP_DECODED_RESPONSE_CONTENT_LENGTH", function () { return $8b11dd70aaca6dbd$export$ffdb1464deb0eedb; }, function (v) { return $8b11dd70aaca6dbd$export$ffdb1464deb0eedb = v; });
$parcel$export(module.exports, "HTTP_FLAVOR", function () { return $8b11dd70aaca6dbd$export$b52670c950fd640; }, function (v) { return $8b11dd70aaca6dbd$export$b52670c950fd640 = v; });
$parcel$export(module.exports, "HTTP_FRAGMENT", function () { return $8b11dd70aaca6dbd$export$c499fd8f1db3d18e; }, function (v) { return $8b11dd70aaca6dbd$export$c499fd8f1db3d18e = v; });
$parcel$export(module.exports, "HTTP_HOST", function () { return $8b11dd70aaca6dbd$export$b2ee2242301eff05; }, function (v) { return $8b11dd70aaca6dbd$export$b2ee2242301eff05 = v; });
$parcel$export(module.exports, "HTTP_METHOD", function () { return $8b11dd70aaca6dbd$export$2ebf9f7586f16841; }, function (v) { return $8b11dd70aaca6dbd$export$2ebf9f7586f16841 = v; });
$parcel$export(module.exports, "HTTP_QUERY", function () { return $8b11dd70aaca6dbd$export$6e9ffd608b3e828b; }, function (v) { return $8b11dd70aaca6dbd$export$6e9ffd608b3e828b = v; });
$parcel$export(module.exports, "HTTP_REQUEST_BODY_DATA", function () { return $8b11dd70aaca6dbd$export$b960c5a73a722e6c; }, function (v) { return $8b11dd70aaca6dbd$export$b960c5a73a722e6c = v; });
$parcel$export(module.exports, "HTTP_REQUEST_CONNECTION_END", function () { return $8b11dd70aaca6dbd$export$a7a850351369c77e; }, function (v) { return $8b11dd70aaca6dbd$export$a7a850351369c77e = v; });
$parcel$export(module.exports, "HTTP_REQUEST_CONNECT_START", function () { return $8b11dd70aaca6dbd$export$b18bca78f4736a94; }, function (v) { return $8b11dd70aaca6dbd$export$b18bca78f4736a94 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_END", function () { return $8b11dd70aaca6dbd$export$61a0059f562fb6c2; }, function (v) { return $8b11dd70aaca6dbd$export$61a0059f562fb6c2 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_START", function () { return $8b11dd70aaca6dbd$export$7dc0d5aefb816d91; }, function (v) { return $8b11dd70aaca6dbd$export$7dc0d5aefb816d91 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_FETCH_START", function () { return $8b11dd70aaca6dbd$export$58f6db56c841bef6; }, function (v) { return $8b11dd70aaca6dbd$export$58f6db56c841bef6 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY", function () { return $8b11dd70aaca6dbd$export$97a3da679f509d5; }, function (v) { return $8b11dd70aaca6dbd$export$97a3da679f509d5 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$c387ec65fd1c2638; }, function (v) { return $8b11dd70aaca6dbd$export$c387ec65fd1c2638 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_METHOD", function () { return $8b11dd70aaca6dbd$export$4d9db82211f308a4; }, function (v) { return $8b11dd70aaca6dbd$export$4d9db82211f308a4 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_END", function () { return $8b11dd70aaca6dbd$export$ee4948a3be025123; }, function (v) { return $8b11dd70aaca6dbd$export$ee4948a3be025123 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_START", function () { return $8b11dd70aaca6dbd$export$e0021eb2979cddaa; }, function (v) { return $8b11dd70aaca6dbd$export$e0021eb2979cddaa = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REQUEST_START", function () { return $8b11dd70aaca6dbd$export$7c0ac0c19a45beac; }, function (v) { return $8b11dd70aaca6dbd$export$7c0ac0c19a45beac = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESEND_COUNT", function () { return $8b11dd70aaca6dbd$export$6c32e9d84f534ee; }, function (v) { return $8b11dd70aaca6dbd$export$6c32e9d84f534ee = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_END", function () { return $8b11dd70aaca6dbd$export$d1f9fbdb211dd29b; }, function (v) { return $8b11dd70aaca6dbd$export$d1f9fbdb211dd29b = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_START", function () { return $8b11dd70aaca6dbd$export$45e7eea99a17d6e4; }, function (v) { return $8b11dd70aaca6dbd$export$45e7eea99a17d6e4 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_SAME_ORIGIN", function () { return $8b11dd70aaca6dbd$export$20ea34e16c0aa64f; }, function (v) { return $8b11dd70aaca6dbd$export$20ea34e16c0aa64f = v; });
$parcel$export(module.exports, "HTTP_REQUEST_SECURE_CONNECTION_START", function () { return $8b11dd70aaca6dbd$export$8365b0f03557fae9; }, function (v) { return $8b11dd70aaca6dbd$export$8365b0f03557fae9 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_TIME_TO_FIRST_BYTE", function () { return $8b11dd70aaca6dbd$export$49ebbb9621675650; }, function (v) { return $8b11dd70aaca6dbd$export$49ebbb9621675650 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_WORKER_START", function () { return $8b11dd70aaca6dbd$export$842be66a901f093; }, function (v) { return $8b11dd70aaca6dbd$export$842be66a901f093 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_BODY_SIZE", function () { return $8b11dd70aaca6dbd$export$a9f5a6cb28adccb1; }, function (v) { return $8b11dd70aaca6dbd$export$a9f5a6cb28adccb1 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_CONTENT_LENGTH", function () { return $8b11dd70aaca6dbd$export$57b055d4bc586d67; }, function (v) { return $8b11dd70aaca6dbd$export$57b055d4bc586d67 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_CONTENT_LENGTH", function () { return $8b11dd70aaca6dbd$export$3ddfd660caa7bf7a; }, function (v) { return $8b11dd70aaca6dbd$export$3ddfd660caa7bf7a = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY", function () { return $8b11dd70aaca6dbd$export$fa7e1f5305153b3d; }, function (v) { return $8b11dd70aaca6dbd$export$fa7e1f5305153b3d = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$5674ce9d013eb7bd; }, function (v) { return $8b11dd70aaca6dbd$export$5674ce9d013eb7bd = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_SIZE", function () { return $8b11dd70aaca6dbd$export$6e8dc14cff6ccf72; }, function (v) { return $8b11dd70aaca6dbd$export$6e8dc14cff6ccf72 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$afd59480458e1b57; }, function (v) { return $8b11dd70aaca6dbd$export$afd59480458e1b57 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_TRANSFER_SIZE", function () { return $8b11dd70aaca6dbd$export$48e61fb9bccccba9; }, function (v) { return $8b11dd70aaca6dbd$export$48e61fb9bccccba9 = v; });
$parcel$export(module.exports, "HTTP_ROUTE", function () { return $8b11dd70aaca6dbd$export$d3e674514dd3a3e1; }, function (v) { return $8b11dd70aaca6dbd$export$d3e674514dd3a3e1 = v; });
$parcel$export(module.exports, "HTTP_SCHEME", function () { return $8b11dd70aaca6dbd$export$97ad02b50c60ef68; }, function (v) { return $8b11dd70aaca6dbd$export$97ad02b50c60ef68 = v; });
$parcel$export(module.exports, "HTTP_SERVER_NAME", function () { return $8b11dd70aaca6dbd$export$61d053b1b63e82c4; }, function (v) { return $8b11dd70aaca6dbd$export$61d053b1b63e82c4 = v; });
$parcel$export(module.exports, "HTTP_SERVER_REQUEST_TIME_IN_QUEUE", function () { return $8b11dd70aaca6dbd$export$54256cce0d674dea; }, function (v) { return $8b11dd70aaca6dbd$export$54256cce0d674dea = v; });
$parcel$export(module.exports, "HTTP_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$8c01f0f407bcc5ca; }, function (v) { return $8b11dd70aaca6dbd$export$8c01f0f407bcc5ca = v; });
$parcel$export(module.exports, "HTTP_TARGET", function () { return $8b11dd70aaca6dbd$export$be3f46982f6c7160; }, function (v) { return $8b11dd70aaca6dbd$export$be3f46982f6c7160 = v; });
$parcel$export(module.exports, "HTTP_URL", function () { return $8b11dd70aaca6dbd$export$778e4213e2788579; }, function (v) { return $8b11dd70aaca6dbd$export$778e4213e2788579 = v; });
$parcel$export(module.exports, "HTTP_USER_AGENT", function () { return $8b11dd70aaca6dbd$export$8b48ca3594d2b172; }, function (v) { return $8b11dd70aaca6dbd$export$8b48ca3594d2b172 = v; });
$parcel$export(module.exports, "ID", function () { return $8b11dd70aaca6dbd$export$8be180ec26319f9f; }, function (v) { return $8b11dd70aaca6dbd$export$8be180ec26319f9f = v; });
$parcel$export(module.exports, "INP", function () { return $8b11dd70aaca6dbd$export$60eccaddefa8fc1c; }, function (v) { return $8b11dd70aaca6dbd$export$60eccaddefa8fc1c = v; });
$parcel$export(module.exports, "JSONRPC_PROTOCOL_VERSION", function () { return $8b11dd70aaca6dbd$export$c99ce4fe37484d84; }, function (v) { return $8b11dd70aaca6dbd$export$c99ce4fe37484d84 = v; });
$parcel$export(module.exports, "JSONRPC_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$fdf432fcac7d8f37; }, function (v) { return $8b11dd70aaca6dbd$export$fdf432fcac7d8f37 = v; });
$parcel$export(module.exports, "JVM_GC_ACTION", function () { return $8b11dd70aaca6dbd$export$4c21cc9cdf2f5dbd; }, function (v) { return $8b11dd70aaca6dbd$export$4c21cc9cdf2f5dbd = v; });
$parcel$export(module.exports, "JVM_GC_NAME", function () { return $8b11dd70aaca6dbd$export$dcc1eab7f3f31816; }, function (v) { return $8b11dd70aaca6dbd$export$dcc1eab7f3f31816 = v; });
$parcel$export(module.exports, "JVM_MEMORY_POOL_NAME", function () { return $8b11dd70aaca6dbd$export$dcb7f1379b2b8f86; }, function (v) { return $8b11dd70aaca6dbd$export$dcb7f1379b2b8f86 = v; });
$parcel$export(module.exports, "JVM_MEMORY_TYPE", function () { return $8b11dd70aaca6dbd$export$53416edeea4c2d74; }, function (v) { return $8b11dd70aaca6dbd$export$53416edeea4c2d74 = v; });
$parcel$export(module.exports, "JVM_THREAD_DAEMON", function () { return $8b11dd70aaca6dbd$export$69f7e5d2b74c5c9e; }, function (v) { return $8b11dd70aaca6dbd$export$69f7e5d2b74c5c9e = v; });
$parcel$export(module.exports, "JVM_THREAD_STATE", function () { return $8b11dd70aaca6dbd$export$8e104aed582a26bc; }, function (v) { return $8b11dd70aaca6dbd$export$8e104aed582a26bc = v; });
$parcel$export(module.exports, "KOA_NAME", function () { return $8b11dd70aaca6dbd$export$577047501949be9; }, function (v) { return $8b11dd70aaca6dbd$export$577047501949be9 = v; });
$parcel$export(module.exports, "KOA_TYPE", function () { return $8b11dd70aaca6dbd$export$c4c45b599a2c15e; }, function (v) { return $8b11dd70aaca6dbd$export$c4c45b599a2c15e = v; });
$parcel$export(module.exports, "LCP", function () { return $8b11dd70aaca6dbd$export$361cb541700d648e; }, function (v) { return $8b11dd70aaca6dbd$export$361cb541700d648e = v; });
$parcel$export(module.exports, "LCP_ELEMENT", function () { return $8b11dd70aaca6dbd$export$974f160e11f25731; }, function (v) { return $8b11dd70aaca6dbd$export$974f160e11f25731 = v; });
$parcel$export(module.exports, "LCP_ID", function () { return $8b11dd70aaca6dbd$export$7162f5c702b95903; }, function (v) { return $8b11dd70aaca6dbd$export$7162f5c702b95903 = v; });
$parcel$export(module.exports, "LCP_LOADTIME", function () { return $8b11dd70aaca6dbd$export$a034d066a9090500; }, function (v) { return $8b11dd70aaca6dbd$export$a034d066a9090500 = v; });
$parcel$export(module.exports, "LCP_RENDERTIME", function () { return $8b11dd70aaca6dbd$export$70938021e43e047c; }, function (v) { return $8b11dd70aaca6dbd$export$70938021e43e047c = v; });
$parcel$export(module.exports, "LCP_SIZE", function () { return $8b11dd70aaca6dbd$export$5f6ac460012a73bb; }, function (v) { return $8b11dd70aaca6dbd$export$5f6ac460012a73bb = v; });
$parcel$export(module.exports, "LCP_URL", function () { return $8b11dd70aaca6dbd$export$d8e498c1c670bcbf; }, function (v) { return $8b11dd70aaca6dbd$export$d8e498c1c670bcbf = v; });
$parcel$export(module.exports, "LOGGER_NAME", function () { return $8b11dd70aaca6dbd$export$cc1a78a24d947903; }, function (v) { return $8b11dd70aaca6dbd$export$cc1a78a24d947903 = v; });
$parcel$export(module.exports, "MCP_CANCELLED_REASON", function () { return $8b11dd70aaca6dbd$export$d29b927e0bb0ffea; }, function (v) { return $8b11dd70aaca6dbd$export$d29b927e0bb0ffea = v; });
$parcel$export(module.exports, "MCP_CANCELLED_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$b3999cacef245779; }, function (v) { return $8b11dd70aaca6dbd$export$b3999cacef245779 = v; });
$parcel$export(module.exports, "MCP_CLIENT_NAME", function () { return $8b11dd70aaca6dbd$export$ff168b5f9cf9dcf6; }, function (v) { return $8b11dd70aaca6dbd$export$ff168b5f9cf9dcf6 = v; });
$parcel$export(module.exports, "MCP_CLIENT_TITLE", function () { return $8b11dd70aaca6dbd$export$2ab876a45bd6e64; }, function (v) { return $8b11dd70aaca6dbd$export$2ab876a45bd6e64 = v; });
$parcel$export(module.exports, "MCP_CLIENT_VERSION", function () { return $8b11dd70aaca6dbd$export$cb8027e4395c6c0e; }, function (v) { return $8b11dd70aaca6dbd$export$cb8027e4395c6c0e = v; });
$parcel$export(module.exports, "MCP_LIFECYCLE_PHASE", function () { return $8b11dd70aaca6dbd$export$f5303d1bac3c2660; }, function (v) { return $8b11dd70aaca6dbd$export$f5303d1bac3c2660 = v; });
$parcel$export(module.exports, "MCP_LOGGING_DATA_TYPE", function () { return $8b11dd70aaca6dbd$export$6c463c5f3b00f64; }, function (v) { return $8b11dd70aaca6dbd$export$6c463c5f3b00f64 = v; });
$parcel$export(module.exports, "MCP_LOGGING_LEVEL", function () { return $8b11dd70aaca6dbd$export$e25d553065457cab; }, function (v) { return $8b11dd70aaca6dbd$export$e25d553065457cab = v; });
$parcel$export(module.exports, "MCP_LOGGING_LOGGER", function () { return $8b11dd70aaca6dbd$export$15d24c154ea8a56f; }, function (v) { return $8b11dd70aaca6dbd$export$15d24c154ea8a56f = v; });
$parcel$export(module.exports, "MCP_LOGGING_MESSAGE", function () { return $8b11dd70aaca6dbd$export$e5065789a6c415d0; }, function (v) { return $8b11dd70aaca6dbd$export$e5065789a6c415d0 = v; });
$parcel$export(module.exports, "MCP_METHOD_NAME", function () { return $8b11dd70aaca6dbd$export$62662c561d7c7835; }, function (v) { return $8b11dd70aaca6dbd$export$62662c561d7c7835 = v; });
$parcel$export(module.exports, "MCP_PROGRESS_CURRENT", function () { return $8b11dd70aaca6dbd$export$218f394557fb0a5a; }, function (v) { return $8b11dd70aaca6dbd$export$218f394557fb0a5a = v; });
$parcel$export(module.exports, "MCP_PROGRESS_MESSAGE", function () { return $8b11dd70aaca6dbd$export$2a5ff6de5448ecdf; }, function (v) { return $8b11dd70aaca6dbd$export$2a5ff6de5448ecdf = v; });
$parcel$export(module.exports, "MCP_PROGRESS_PERCENTAGE", function () { return $8b11dd70aaca6dbd$export$9d23f3030ed2597e; }, function (v) { return $8b11dd70aaca6dbd$export$9d23f3030ed2597e = v; });
$parcel$export(module.exports, "MCP_PROGRESS_TOKEN", function () { return $8b11dd70aaca6dbd$export$a26ff217a6124160; }, function (v) { return $8b11dd70aaca6dbd$export$a26ff217a6124160 = v; });
$parcel$export(module.exports, "MCP_PROGRESS_TOTAL", function () { return $8b11dd70aaca6dbd$export$c8072f5fcfdb5b77; }, function (v) { return $8b11dd70aaca6dbd$export$c8072f5fcfdb5b77 = v; });
$parcel$export(module.exports, "MCP_PROMPT_NAME", function () { return $8b11dd70aaca6dbd$export$c4e4b74f1ccf3d96; }, function (v) { return $8b11dd70aaca6dbd$export$c4e4b74f1ccf3d96 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$328519d02a26ac41; }, function (v) { return $8b11dd70aaca6dbd$export$328519d02a26ac41 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_CONTENT", function () { return $8b11dd70aaca6dbd$export$d2061b291c43d045; }, function (v) { return $8b11dd70aaca6dbd$export$d2061b291c43d045 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_COUNT", function () { return $8b11dd70aaca6dbd$export$d1f04dfd3d695286; }, function (v) { return $8b11dd70aaca6dbd$export$d1f04dfd3d695286 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_ROLE", function () { return $8b11dd70aaca6dbd$export$234fbd86ea0f0bd8; }, function (v) { return $8b11dd70aaca6dbd$export$234fbd86ea0f0bd8 = v; });
$parcel$export(module.exports, "MCP_PROTOCOL_READY", function () { return $8b11dd70aaca6dbd$export$e795000978a75b12; }, function (v) { return $8b11dd70aaca6dbd$export$e795000978a75b12 = v; });
$parcel$export(module.exports, "MCP_PROTOCOL_VERSION", function () { return $8b11dd70aaca6dbd$export$9f4683b4d1018ace; }, function (v) { return $8b11dd70aaca6dbd$export$9f4683b4d1018ace = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY", function () { return $8b11dd70aaca6dbd$export$e431b042fcdb1d63; }, function (v) { return $8b11dd70aaca6dbd$export$e431b042fcdb1d63 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$a453239171ac9a23; }, function (v) { return $8b11dd70aaca6dbd$export$a453239171ac9a23 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_NAME", function () { return $8b11dd70aaca6dbd$export$3a7726a976c18d5f; }, function (v) { return $8b11dd70aaca6dbd$export$3a7726a976c18d5f = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_URI", function () { return $8b11dd70aaca6dbd$export$7eca7a6c06843b93; }, function (v) { return $8b11dd70aaca6dbd$export$7eca7a6c06843b93 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$f25c55f83e5b0672; }, function (v) { return $8b11dd70aaca6dbd$export$f25c55f83e5b0672 = v; });
$parcel$export(module.exports, "MCP_RESOURCE_PROTOCOL", function () { return $8b11dd70aaca6dbd$export$9562bfac4eb079cb; }, function (v) { return $8b11dd70aaca6dbd$export$9562bfac4eb079cb = v; });
$parcel$export(module.exports, "MCP_RESOURCE_URI", function () { return $8b11dd70aaca6dbd$export$c276d164ff91d2f7; }, function (v) { return $8b11dd70aaca6dbd$export$c276d164ff91d2f7 = v; });
$parcel$export(module.exports, "MCP_SERVER_NAME", function () { return $8b11dd70aaca6dbd$export$2f3e0574f1a99754; }, function (v) { return $8b11dd70aaca6dbd$export$2f3e0574f1a99754 = v; });
$parcel$export(module.exports, "MCP_SERVER_TITLE", function () { return $8b11dd70aaca6dbd$export$15eecaab68167880; }, function (v) { return $8b11dd70aaca6dbd$export$15eecaab68167880 = v; });
$parcel$export(module.exports, "MCP_SERVER_VERSION", function () { return $8b11dd70aaca6dbd$export$513c47f6e194086a; }, function (v) { return $8b11dd70aaca6dbd$export$513c47f6e194086a = v; });
$parcel$export(module.exports, "MCP_SESSION_ID", function () { return $8b11dd70aaca6dbd$export$a3f464c4d5cd9096; }, function (v) { return $8b11dd70aaca6dbd$export$a3f464c4d5cd9096 = v; });
$parcel$export(module.exports, "MCP_TOOL_NAME", function () { return $8b11dd70aaca6dbd$export$ed366a03a2330b03; }, function (v) { return $8b11dd70aaca6dbd$export$ed366a03a2330b03 = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT", function () { return $8b11dd70aaca6dbd$export$9b802c784f235e1d; }, function (v) { return $8b11dd70aaca6dbd$export$9b802c784f235e1d = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT_COUNT", function () { return $8b11dd70aaca6dbd$export$add0fc8b8c5726a4; }, function (v) { return $8b11dd70aaca6dbd$export$add0fc8b8c5726a4 = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_IS_ERROR", function () { return $8b11dd70aaca6dbd$export$e7f32463f5bfd554; }, function (v) { return $8b11dd70aaca6dbd$export$e7f32463f5bfd554 = v; });
$parcel$export(module.exports, "MCP_TRANSPORT", function () { return $8b11dd70aaca6dbd$export$f9346f394edf26a; }, function (v) { return $8b11dd70aaca6dbd$export$f9346f394edf26a = v; });
$parcel$export(module.exports, "MDC_KEY", function () { return $8b11dd70aaca6dbd$export$16b917774e73ef92; }, function (v) { return $8b11dd70aaca6dbd$export$16b917774e73ef92 = v; });
$parcel$export(module.exports, "MDC_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$15d2b60bf3b65454; }, function (v) { return $8b11dd70aaca6dbd$export$15d2b60bf3b65454 = v; });
$parcel$export(module.exports, "MESSAGING_BATCH_MESSAGE_COUNT", function () { return $8b11dd70aaca6dbd$export$db55eca5af256142; }, function (v) { return $8b11dd70aaca6dbd$export$db55eca5af256142 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION", function () { return $8b11dd70aaca6dbd$export$967c74f8b1f3d35; }, function (v) { return $8b11dd70aaca6dbd$export$967c74f8b1f3d35 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION_CONNECTION", function () { return $8b11dd70aaca6dbd$export$7c33ae67962515d1; }, function (v) { return $8b11dd70aaca6dbd$export$7c33ae67962515d1 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION_NAME", function () { return $8b11dd70aaca6dbd$export$9c69839b2d93489b; }, function (v) { return $8b11dd70aaca6dbd$export$9c69839b2d93489b = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_BODY_SIZE", function () { return $8b11dd70aaca6dbd$export$be22d22d4b6cf5d8; }, function (v) { return $8b11dd70aaca6dbd$export$be22d22d4b6cf5d8 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_CONVERSATION_ID", function () { return $8b11dd70aaca6dbd$export$c529961b911626ac; }, function (v) { return $8b11dd70aaca6dbd$export$c529961b911626ac = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_ENVELOPE_SIZE", function () { return $8b11dd70aaca6dbd$export$e39c4b15d2881f5; }, function (v) { return $8b11dd70aaca6dbd$export$e39c4b15d2881f5 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_ID", function () { return $8b11dd70aaca6dbd$export$a8ca145161313e7; }, function (v) { return $8b11dd70aaca6dbd$export$a8ca145161313e7 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_RECEIVE_LATENCY", function () { return $8b11dd70aaca6dbd$export$3c1204d03918d076; }, function (v) { return $8b11dd70aaca6dbd$export$3c1204d03918d076 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_RETRY_COUNT", function () { return $8b11dd70aaca6dbd$export$eaac3f141165e288; }, function (v) { return $8b11dd70aaca6dbd$export$eaac3f141165e288 = v; });
$parcel$export(module.exports, "MESSAGING_OPERATION_NAME", function () { return $8b11dd70aaca6dbd$export$4c7e6934714150e6; }, function (v) { return $8b11dd70aaca6dbd$export$4c7e6934714150e6 = v; });
$parcel$export(module.exports, "MESSAGING_OPERATION_TYPE", function () { return $8b11dd70aaca6dbd$export$6f71f9711d666eb4; }, function (v) { return $8b11dd70aaca6dbd$export$6f71f9711d666eb4 = v; });
$parcel$export(module.exports, "MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY", function () { return $8b11dd70aaca6dbd$export$2a3cd2bb71fb63a4; }, function (v) { return $8b11dd70aaca6dbd$export$2a3cd2bb71fb63a4 = v; });
$parcel$export(module.exports, "MESSAGING_SYSTEM", function () { return $8b11dd70aaca6dbd$export$55478a0b7d2ae98f; }, function (v) { return $8b11dd70aaca6dbd$export$55478a0b7d2ae98f = v; });
$parcel$export(module.exports, "METHOD", function () { return $8b11dd70aaca6dbd$export$bed10c4da9b8eb0a; }, function (v) { return $8b11dd70aaca6dbd$export$bed10c4da9b8eb0a = v; });
$parcel$export(module.exports, "MIDDLEWARE_NAME", function () { return $8b11dd70aaca6dbd$export$a82607b6424c06c8; }, function (v) { return $8b11dd70aaca6dbd$export$a82607b6424c06c8 = v; });
$parcel$export(module.exports, "NAVIGATION_ORIGIN", function () { return $8b11dd70aaca6dbd$export$6b081f3484c7f4e5; }, function (v) { return $8b11dd70aaca6dbd$export$6b081f3484c7f4e5 = v; });
$parcel$export(module.exports, "NAVIGATION_ROUTE_ID", function () { return $8b11dd70aaca6dbd$export$b7754d85fd39406c; }, function (v) { return $8b11dd70aaca6dbd$export$b7754d85fd39406c = v; });
$parcel$export(module.exports, "NAVIGATION_TYPE", function () { return $8b11dd70aaca6dbd$export$492856c046eb4728; }, function (v) { return $8b11dd70aaca6dbd$export$492856c046eb4728 = v; });
$parcel$export(module.exports, "NEL_ELAPSED_TIME", function () { return $8b11dd70aaca6dbd$export$c1678a2059fbe906; }, function (v) { return $8b11dd70aaca6dbd$export$c1678a2059fbe906 = v; });
$parcel$export(module.exports, "NEL_PHASE", function () { return $8b11dd70aaca6dbd$export$6d384a0bc1011c34; }, function (v) { return $8b11dd70aaca6dbd$export$6d384a0bc1011c34 = v; });
$parcel$export(module.exports, "NEL_REFERRER", function () { return $8b11dd70aaca6dbd$export$1499a7dbfc01e7d4; }, function (v) { return $8b11dd70aaca6dbd$export$1499a7dbfc01e7d4 = v; });
$parcel$export(module.exports, "NEL_SAMPLING_FUNCTION", function () { return $8b11dd70aaca6dbd$export$cfcbff40019f0ff1; }, function (v) { return $8b11dd70aaca6dbd$export$cfcbff40019f0ff1 = v; });
$parcel$export(module.exports, "NEL_TYPE", function () { return $8b11dd70aaca6dbd$export$27157b5f68e583af; }, function (v) { return $8b11dd70aaca6dbd$export$27157b5f68e583af = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_EFFECTIVE_TYPE", function () { return $8b11dd70aaca6dbd$export$54bf5ed61532925d; }, function (v) { return $8b11dd70aaca6dbd$export$54bf5ed61532925d = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_RTT", function () { return $8b11dd70aaca6dbd$export$60ed0786292ace08; }, function (v) { return $8b11dd70aaca6dbd$export$60ed0786292ace08 = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_TYPE", function () { return $8b11dd70aaca6dbd$export$d770bfb8345e146; }, function (v) { return $8b11dd70aaca6dbd$export$d770bfb8345e146 = v; });
$parcel$export(module.exports, "NETWORK_LOCAL_ADDRESS", function () { return $8b11dd70aaca6dbd$export$bb73817f1290ad28; }, function (v) { return $8b11dd70aaca6dbd$export$bb73817f1290ad28 = v; });
$parcel$export(module.exports, "NETWORK_LOCAL_PORT", function () { return $8b11dd70aaca6dbd$export$f201c980f2b75802; }, function (v) { return $8b11dd70aaca6dbd$export$f201c980f2b75802 = v; });
$parcel$export(module.exports, "NETWORK_PEER_ADDRESS", function () { return $8b11dd70aaca6dbd$export$b40e970572afd0ee; }, function (v) { return $8b11dd70aaca6dbd$export$b40e970572afd0ee = v; });
$parcel$export(module.exports, "NETWORK_PEER_PORT", function () { return $8b11dd70aaca6dbd$export$8850630a3d343488; }, function (v) { return $8b11dd70aaca6dbd$export$8850630a3d343488 = v; });
$parcel$export(module.exports, "NETWORK_PROTOCOL_NAME", function () { return $8b11dd70aaca6dbd$export$fd0a39a918d6516f; }, function (v) { return $8b11dd70aaca6dbd$export$fd0a39a918d6516f = v; });
$parcel$export(module.exports, "NETWORK_PROTOCOL_VERSION", function () { return $8b11dd70aaca6dbd$export$e68ef41f8e0335bf; }, function (v) { return $8b11dd70aaca6dbd$export$e68ef41f8e0335bf = v; });
$parcel$export(module.exports, "NETWORK_TRANSPORT", function () { return $8b11dd70aaca6dbd$export$5bff09650e762829; }, function (v) { return $8b11dd70aaca6dbd$export$5bff09650e762829 = v; });
$parcel$export(module.exports, "NETWORK_TYPE", function () { return $8b11dd70aaca6dbd$export$21c1adce0e067f37; }, function (v) { return $8b11dd70aaca6dbd$export$21c1adce0e067f37 = v; });
$parcel$export(module.exports, "NET_HOST_IP", function () { return $8b11dd70aaca6dbd$export$fed6ce86f48c84bc; }, function (v) { return $8b11dd70aaca6dbd$export$fed6ce86f48c84bc = v; });
$parcel$export(module.exports, "NET_HOST_NAME", function () { return $8b11dd70aaca6dbd$export$500c2675137ac16e; }, function (v) { return $8b11dd70aaca6dbd$export$500c2675137ac16e = v; });
$parcel$export(module.exports, "NET_HOST_PORT", function () { return $8b11dd70aaca6dbd$export$402c7728623fd8df; }, function (v) { return $8b11dd70aaca6dbd$export$402c7728623fd8df = v; });
$parcel$export(module.exports, "NET_PEER_IP", function () { return $8b11dd70aaca6dbd$export$15417259f4c0fe6b; }, function (v) { return $8b11dd70aaca6dbd$export$15417259f4c0fe6b = v; });
$parcel$export(module.exports, "NET_PEER_NAME", function () { return $8b11dd70aaca6dbd$export$2b3b7f579a727f45; }, function (v) { return $8b11dd70aaca6dbd$export$2b3b7f579a727f45 = v; });
$parcel$export(module.exports, "NET_PEER_PORT", function () { return $8b11dd70aaca6dbd$export$514832a0b029734b; }, function (v) { return $8b11dd70aaca6dbd$export$514832a0b029734b = v; });
$parcel$export(module.exports, "NET_PROTOCOL_NAME", function () { return $8b11dd70aaca6dbd$export$b0522e6a14dec1a4; }, function (v) { return $8b11dd70aaca6dbd$export$b0522e6a14dec1a4 = v; });
$parcel$export(module.exports, "NET_PROTOCOL_VERSION", function () { return $8b11dd70aaca6dbd$export$659ea19f71a7ee0b; }, function (v) { return $8b11dd70aaca6dbd$export$659ea19f71a7ee0b = v; });
$parcel$export(module.exports, "NET_SOCK_FAMILY", function () { return $8b11dd70aaca6dbd$export$1b61d972db315e73; }, function (v) { return $8b11dd70aaca6dbd$export$1b61d972db315e73 = v; });
$parcel$export(module.exports, "NET_SOCK_HOST_ADDR", function () { return $8b11dd70aaca6dbd$export$fb2970ee11a479ee; }, function (v) { return $8b11dd70aaca6dbd$export$fb2970ee11a479ee = v; });
$parcel$export(module.exports, "NET_SOCK_HOST_PORT", function () { return $8b11dd70aaca6dbd$export$920aceb2a8fad77e; }, function (v) { return $8b11dd70aaca6dbd$export$920aceb2a8fad77e = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_ADDR", function () { return $8b11dd70aaca6dbd$export$48f8f6fbc999d187; }, function (v) { return $8b11dd70aaca6dbd$export$48f8f6fbc999d187 = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_NAME", function () { return $8b11dd70aaca6dbd$export$eed590fa00a8223b; }, function (v) { return $8b11dd70aaca6dbd$export$eed590fa00a8223b = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_PORT", function () { return $8b11dd70aaca6dbd$export$f2e5bb5cd4a130da; }, function (v) { return $8b11dd70aaca6dbd$export$f2e5bb5cd4a130da = v; });
$parcel$export(module.exports, "NET_TRANSPORT", function () { return $8b11dd70aaca6dbd$export$779ef03d633a9086; }, function (v) { return $8b11dd70aaca6dbd$export$779ef03d633a9086 = v; });
$parcel$export(module.exports, "OS_BUILD", function () { return $8b11dd70aaca6dbd$export$d98b87c8d53d0dbc; }, function (v) { return $8b11dd70aaca6dbd$export$d98b87c8d53d0dbc = v; });
$parcel$export(module.exports, "OS_BUILD_ID", function () { return $8b11dd70aaca6dbd$export$ca719aa57653a0a7; }, function (v) { return $8b11dd70aaca6dbd$export$ca719aa57653a0a7 = v; });
$parcel$export(module.exports, "OS_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$74b19c5f48270c05; }, function (v) { return $8b11dd70aaca6dbd$export$74b19c5f48270c05 = v; });
$parcel$export(module.exports, "OS_KERNEL_VERSION", function () { return $8b11dd70aaca6dbd$export$c351affe7e8098cb; }, function (v) { return $8b11dd70aaca6dbd$export$c351affe7e8098cb = v; });
$parcel$export(module.exports, "OS_NAME", function () { return $8b11dd70aaca6dbd$export$be7cd6b3ae3ae765; }, function (v) { return $8b11dd70aaca6dbd$export$be7cd6b3ae3ae765 = v; });
$parcel$export(module.exports, "OS_RAW_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$ec182524c4c57275; }, function (v) { return $8b11dd70aaca6dbd$export$ec182524c4c57275 = v; });
$parcel$export(module.exports, "OS_ROOTED", function () { return $8b11dd70aaca6dbd$export$9e45758246a85b07; }, function (v) { return $8b11dd70aaca6dbd$export$9e45758246a85b07 = v; });
$parcel$export(module.exports, "OS_THEME", function () { return $8b11dd70aaca6dbd$export$9fa5d5f0144954cb; }, function (v) { return $8b11dd70aaca6dbd$export$9fa5d5f0144954cb = v; });
$parcel$export(module.exports, "OS_TYPE", function () { return $8b11dd70aaca6dbd$export$e66ba5bc4b978023; }, function (v) { return $8b11dd70aaca6dbd$export$e66ba5bc4b978023 = v; });
$parcel$export(module.exports, "OS_VERSION", function () { return $8b11dd70aaca6dbd$export$2306e23cc611a36d; }, function (v) { return $8b11dd70aaca6dbd$export$2306e23cc611a36d = v; });
$parcel$export(module.exports, "OTEL_KIND", function () { return $8b11dd70aaca6dbd$export$144f8c1fe01428db; }, function (v) { return $8b11dd70aaca6dbd$export$144f8c1fe01428db = v; });
$parcel$export(module.exports, "OTEL_SCOPE_NAME", function () { return $8b11dd70aaca6dbd$export$f303b2744d52121c; }, function (v) { return $8b11dd70aaca6dbd$export$f303b2744d52121c = v; });
$parcel$export(module.exports, "OTEL_SCOPE_VERSION", function () { return $8b11dd70aaca6dbd$export$866b2dbc7bf18ce6; }, function (v) { return $8b11dd70aaca6dbd$export$866b2dbc7bf18ce6 = v; });
$parcel$export(module.exports, "OTEL_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$b4c85774878b4841; }, function (v) { return $8b11dd70aaca6dbd$export$b4c85774878b4841 = v; });
$parcel$export(module.exports, "OTEL_STATUS_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$1c967a71bc9a3077; }, function (v) { return $8b11dd70aaca6dbd$export$1c967a71bc9a3077 = v; });
$parcel$export(module.exports, "PARAMS_KEY", function () { return $8b11dd70aaca6dbd$export$5e3884a35a19eb90; }, function (v) { return $8b11dd70aaca6dbd$export$5e3884a35a19eb90 = v; });
$parcel$export(module.exports, "PARAMS_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$6e7ff99bb3259573; }, function (v) { return $8b11dd70aaca6dbd$export$6e7ff99bb3259573 = v; });
$parcel$export(module.exports, "PERFORMANCE_ACTIVATIONSTART", function () { return $8b11dd70aaca6dbd$export$7c932cba2d9e7a7; }, function (v) { return $8b11dd70aaca6dbd$export$7c932cba2d9e7a7 = v; });
$parcel$export(module.exports, "PERFORMANCE_TIMEORIGIN", function () { return $8b11dd70aaca6dbd$export$94091942edce0667; }, function (v) { return $8b11dd70aaca6dbd$export$94091942edce0667 = v; });
$parcel$export(module.exports, "PREVIOUS_ROUTE", function () { return $8b11dd70aaca6dbd$export$3671a8a524706a9d; }, function (v) { return $8b11dd70aaca6dbd$export$3671a8a524706a9d = v; });
$parcel$export(module.exports, "PROCESS_COMMAND_ARGS", function () { return $8b11dd70aaca6dbd$export$c288888dc82d233f; }, function (v) { return $8b11dd70aaca6dbd$export$c288888dc82d233f = v; });
$parcel$export(module.exports, "PROCESS_EXECUTABLE_NAME", function () { return $8b11dd70aaca6dbd$export$8ff188536cebc35; }, function (v) { return $8b11dd70aaca6dbd$export$8ff188536cebc35 = v; });
$parcel$export(module.exports, "PROCESS_PID", function () { return $8b11dd70aaca6dbd$export$6407d78968c0eabe; }, function (v) { return $8b11dd70aaca6dbd$export$6407d78968c0eabe = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$43e9fb9ec28d9743; }, function (v) { return $8b11dd70aaca6dbd$export$43e9fb9ec28d9743 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_NAME", function () { return $8b11dd70aaca6dbd$export$26f31d5c5c201739; }, function (v) { return $8b11dd70aaca6dbd$export$26f31d5c5c201739 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_VERSION", function () { return $8b11dd70aaca6dbd$export$bff85124d2d35b93; }, function (v) { return $8b11dd70aaca6dbd$export$bff85124d2d35b93 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_NAME", function () { return $8b11dd70aaca6dbd$export$495c671ed5a6408c; }, function (v) { return $8b11dd70aaca6dbd$export$495c671ed5a6408c = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_VERSION", function () { return $8b11dd70aaca6dbd$export$54b3d4d5548c35c3; }, function (v) { return $8b11dd70aaca6dbd$export$54b3d4d5548c35c3 = v; });
$parcel$export(module.exports, "QUERY_KEY", function () { return $8b11dd70aaca6dbd$export$2954db6444fe1fa8; }, function (v) { return $8b11dd70aaca6dbd$export$2954db6444fe1fa8 = v; });
$parcel$export(module.exports, "QUERY_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$15c1c974d16dd678; }, function (v) { return $8b11dd70aaca6dbd$export$15c1c974d16dd678 = v; });
$parcel$export(module.exports, "REACT_VERSION", function () { return $8b11dd70aaca6dbd$export$9be2ae89a1eac217; }, function (v) { return $8b11dd70aaca6dbd$export$9be2ae89a1eac217 = v; });
$parcel$export(module.exports, "RELEASE", function () { return $8b11dd70aaca6dbd$export$5c698591c0e586a2; }, function (v) { return $8b11dd70aaca6dbd$export$5c698591c0e586a2 = v; });
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY", function () { return $8b11dd70aaca6dbd$export$b711f2bb9c9a848a; }, function (v) { return $8b11dd70aaca6dbd$export$b711f2bb9c9a848a = v; });
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$1d3a8501efd30213; }, function (v) { return $8b11dd70aaca6dbd$export$1d3a8501efd30213 = v; });
$parcel$export(module.exports, "REPLAY_ID", function () { return $8b11dd70aaca6dbd$export$cebaf684ced5a2c9; }, function (v) { return $8b11dd70aaca6dbd$export$cebaf684ced5a2c9 = v; });
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT", function () { return $8b11dd70aaca6dbd$export$d4c658ecdcb7c78c; }, function (v) { return $8b11dd70aaca6dbd$export$d4c658ecdcb7c78c = v; });
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME", function () { return $8b11dd70aaca6dbd$export$b1b162b01baeb044; }, function (v) { return $8b11dd70aaca6dbd$export$b1b162b01baeb044 = v; });
$parcel$export(module.exports, "RESOURCE_RENDER_BLOCKING_STATUS", function () { return $8b11dd70aaca6dbd$export$8be2d593d7f88ed8; }, function (v) { return $8b11dd70aaca6dbd$export$8be2d593d7f88ed8 = v; });
$parcel$export(module.exports, "ROUTE", function () { return $8b11dd70aaca6dbd$export$dbd0a3528a97ccc0; }, function (v) { return $8b11dd70aaca6dbd$export$dbd0a3528a97ccc0 = v; });
$parcel$export(module.exports, "RPC_GRPC_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$66581dc6d3d083d1; }, function (v) { return $8b11dd70aaca6dbd$export$66581dc6d3d083d1 = v; });
$parcel$export(module.exports, "RPC_METHOD", function () { return $8b11dd70aaca6dbd$export$e545f99e7abcc499; }, function (v) { return $8b11dd70aaca6dbd$export$e545f99e7abcc499 = v; });
$parcel$export(module.exports, "RPC_RESPONSE_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$7e1af5787f8c4aaa; }, function (v) { return $8b11dd70aaca6dbd$export$7e1af5787f8c4aaa = v; });
$parcel$export(module.exports, "RPC_SERVICE", function () { return $8b11dd70aaca6dbd$export$186c94c351c54768; }, function (v) { return $8b11dd70aaca6dbd$export$186c94c351c54768 = v; });
$parcel$export(module.exports, "RPC_SYSTEM", function () { return $8b11dd70aaca6dbd$export$2e3fd8dfcb16fe0c; }, function (v) { return $8b11dd70aaca6dbd$export$2e3fd8dfcb16fe0c = v; });
$parcel$export(module.exports, "RPC_SYSTEM_NAME", function () { return $8b11dd70aaca6dbd$export$7eeeceaa1dbd7cd5; }, function (v) { return $8b11dd70aaca6dbd$export$7eeeceaa1dbd7cd5 = v; });
$parcel$export(module.exports, "RUNTIME_BUILD", function () { return $8b11dd70aaca6dbd$export$9d5bffdff936d554; }, function (v) { return $8b11dd70aaca6dbd$export$9d5bffdff936d554 = v; });
$parcel$export(module.exports, "RUNTIME_NAME", function () { return $8b11dd70aaca6dbd$export$dc3a801c9a2c5b79; }, function (v) { return $8b11dd70aaca6dbd$export$dc3a801c9a2c5b79 = v; });
$parcel$export(module.exports, "RUNTIME_RAW_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$27933a9557f87e98; }, function (v) { return $8b11dd70aaca6dbd$export$27933a9557f87e98 = v; });
$parcel$export(module.exports, "RUNTIME_VERSION", function () { return $8b11dd70aaca6dbd$export$eefa737b40a0d535; }, function (v) { return $8b11dd70aaca6dbd$export$eefa737b40a0d535 = v; });
$parcel$export(module.exports, "SCORE_KEY", function () { return $8b11dd70aaca6dbd$export$92740ffbcb02553b; }, function (v) { return $8b11dd70aaca6dbd$export$92740ffbcb02553b = v; });
$parcel$export(module.exports, "SCORE_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$500e89753f9f1008; }, function (v) { return $8b11dd70aaca6dbd$export$500e89753f9f1008 = v; });
$parcel$export(module.exports, "SCORE_RATIO_KEY", function () { return $8b11dd70aaca6dbd$export$d91a18e47fdddefd; }, function (v) { return $8b11dd70aaca6dbd$export$d91a18e47fdddefd = v; });
$parcel$export(module.exports, "SCORE_RATIO_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$eccbe6f20884ea7f; }, function (v) { return $8b11dd70aaca6dbd$export$eccbe6f20884ea7f = v; });
$parcel$export(module.exports, "SCORE_TOTAL", function () { return $8b11dd70aaca6dbd$export$9e24f11d79141afb; }, function (v) { return $8b11dd70aaca6dbd$export$9e24f11d79141afb = v; });
$parcel$export(module.exports, "SCORE_WEIGHT_KEY", function () { return $8b11dd70aaca6dbd$export$f0b96ad9586f8887; }, function (v) { return $8b11dd70aaca6dbd$export$f0b96ad9586f8887 = v; });
$parcel$export(module.exports, "SCORE_WEIGHT_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$8a92ed5d436a85c6; }, function (v) { return $8b11dd70aaca6dbd$export$8a92ed5d436a85c6 = v; });
$parcel$export(module.exports, "SENTRY_ACTION", function () { return $8b11dd70aaca6dbd$export$edd59acdf7e86a71; }, function (v) { return $8b11dd70aaca6dbd$export$edd59acdf7e86a71 = v; });
$parcel$export(module.exports, "SENTRY_BROWSER_NAME", function () { return $8b11dd70aaca6dbd$export$ae81a1ae71952d50; }, function (v) { return $8b11dd70aaca6dbd$export$ae81a1ae71952d50 = v; });
$parcel$export(module.exports, "SENTRY_BROWSER_VERSION", function () { return $8b11dd70aaca6dbd$export$6101470cd57eac1b; }, function (v) { return $8b11dd70aaca6dbd$export$6101470cd57eac1b = v; });
$parcel$export(module.exports, "SENTRY_CANCELLATION_REASON", function () { return $8b11dd70aaca6dbd$export$452c0aee9673fe67; }, function (v) { return $8b11dd70aaca6dbd$export$452c0aee9673fe67 = v; });
$parcel$export(module.exports, "SENTRY_CATEGORY", function () { return $8b11dd70aaca6dbd$export$773dddd1e8667756; }, function (v) { return $8b11dd70aaca6dbd$export$773dddd1e8667756 = v; });
$parcel$export(module.exports, "SENTRY_CLIENT_SAMPLE_RATE", function () { return $8b11dd70aaca6dbd$export$98815f8579a64a90; }, function (v) { return $8b11dd70aaca6dbd$export$98815f8579a64a90 = v; });
$parcel$export(module.exports, "SENTRY_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$7bc4e27428665019; }, function (v) { return $8b11dd70aaca6dbd$export$7bc4e27428665019 = v; });
$parcel$export(module.exports, "SENTRY_DIST", function () { return $8b11dd70aaca6dbd$export$e7d7477fa9057ee2; }, function (v) { return $8b11dd70aaca6dbd$export$e7d7477fa9057ee2 = v; });
$parcel$export(module.exports, "SENTRY_DOMAIN", function () { return $8b11dd70aaca6dbd$export$1f4267a3fc018448; }, function (v) { return $8b11dd70aaca6dbd$export$1f4267a3fc018448 = v; });
$parcel$export(module.exports, "SENTRY_DSC_ENVIRONMENT", function () { return $8b11dd70aaca6dbd$export$c171cae150389952; }, function (v) { return $8b11dd70aaca6dbd$export$c171cae150389952 = v; });
$parcel$export(module.exports, "SENTRY_DSC_PROJECT_ID", function () { return $8b11dd70aaca6dbd$export$d9bb35e957b22c72; }, function (v) { return $8b11dd70aaca6dbd$export$d9bb35e957b22c72 = v; });
$parcel$export(module.exports, "SENTRY_DSC_PUBLIC_KEY", function () { return $8b11dd70aaca6dbd$export$b3508a2c95f74e3d; }, function (v) { return $8b11dd70aaca6dbd$export$b3508a2c95f74e3d = v; });
$parcel$export(module.exports, "SENTRY_DSC_RELEASE", function () { return $8b11dd70aaca6dbd$export$20bb272f4d21532d; }, function (v) { return $8b11dd70aaca6dbd$export$20bb272f4d21532d = v; });
$parcel$export(module.exports, "SENTRY_DSC_SAMPLED", function () { return $8b11dd70aaca6dbd$export$d7e64fbd0102ce90; }, function (v) { return $8b11dd70aaca6dbd$export$d7e64fbd0102ce90 = v; });
$parcel$export(module.exports, "SENTRY_DSC_SAMPLE_RATE", function () { return $8b11dd70aaca6dbd$export$c17eae7e86dbba3c; }, function (v) { return $8b11dd70aaca6dbd$export$c17eae7e86dbba3c = v; });
$parcel$export(module.exports, "SENTRY_DSC_TRACE_ID", function () { return $8b11dd70aaca6dbd$export$349603c0a9165744; }, function (v) { return $8b11dd70aaca6dbd$export$349603c0a9165744 = v; });
$parcel$export(module.exports, "SENTRY_DSC_TRANSACTION", function () { return $8b11dd70aaca6dbd$export$4dadf693741f0283; }, function (v) { return $8b11dd70aaca6dbd$export$4dadf693741f0283 = v; });
$parcel$export(module.exports, "SENTRY_ENVIRONMENT", function () { return $8b11dd70aaca6dbd$export$6377864d12f7eeb3; }, function (v) { return $8b11dd70aaca6dbd$export$6377864d12f7eeb3 = v; });
$parcel$export(module.exports, "SENTRY_EXCLUSIVE_TIME", function () { return $8b11dd70aaca6dbd$export$ba081af9585ed4; }, function (v) { return $8b11dd70aaca6dbd$export$ba081af9585ed4 = v; });
$parcel$export(module.exports, "SENTRY_GRAPHQL_OPERATION", function () { return $8b11dd70aaca6dbd$export$7841dacb241485d0; }, function (v) { return $8b11dd70aaca6dbd$export$7841dacb241485d0 = v; });
$parcel$export(module.exports, "SENTRY_GROUP", function () { return $8b11dd70aaca6dbd$export$52c7044cf6301362; }, function (v) { return $8b11dd70aaca6dbd$export$52c7044cf6301362 = v; });
$parcel$export(module.exports, "SENTRY_HTTP_PREFETCH", function () { return $8b11dd70aaca6dbd$export$56ea1c9e44590e20; }, function (v) { return $8b11dd70aaca6dbd$export$56ea1c9e44590e20 = v; });
$parcel$export(module.exports, "SENTRY_IDLE_SPAN_FINISH_REASON", function () { return $8b11dd70aaca6dbd$export$7626e389d05f4c36; }, function (v) { return $8b11dd70aaca6dbd$export$7626e389d05f4c36 = v; });
$parcel$export(module.exports, "SENTRY_IS_REMOTE", function () { return $8b11dd70aaca6dbd$export$5e0a48187329b2e7; }, function (v) { return $8b11dd70aaca6dbd$export$5e0a48187329b2e7 = v; });
$parcel$export(module.exports, "SENTRY_KIND", function () { return $8b11dd70aaca6dbd$export$c322b150d7667841; }, function (v) { return $8b11dd70aaca6dbd$export$c322b150d7667841 = v; });
$parcel$export(module.exports, "SENTRY_MAIN_THREAD", function () { return $8b11dd70aaca6dbd$export$4a4797d3c962f753; }, function (v) { return $8b11dd70aaca6dbd$export$4a4797d3c962f753 = v; });
$parcel$export(module.exports, "SENTRY_MESSAGE_PARAMETER_KEY", function () { return $8b11dd70aaca6dbd$export$767524d5e72e2645; }, function (v) { return $8b11dd70aaca6dbd$export$767524d5e72e2645 = v; });
$parcel$export(module.exports, "SENTRY_MESSAGE_TEMPLATE", function () { return $8b11dd70aaca6dbd$export$497354ca7b0ee666; }, function (v) { return $8b11dd70aaca6dbd$export$497354ca7b0ee666 = v; });
$parcel$export(module.exports, "SENTRY_METRIC_SOURCE", function () { return $8b11dd70aaca6dbd$export$cbdc4ad11118116a; }, function (v) { return $8b11dd70aaca6dbd$export$cbdc4ad11118116a = v; });
$parcel$export(module.exports, "SENTRY_MOBILE", function () { return $8b11dd70aaca6dbd$export$5b890de778c4c2fe; }, function (v) { return $8b11dd70aaca6dbd$export$5b890de778c4c2fe = v; });
$parcel$export(module.exports, "SENTRY_MODULE_KEY", function () { return $8b11dd70aaca6dbd$export$a78d9803b5e0a83e; }, function (v) { return $8b11dd70aaca6dbd$export$a78d9803b5e0a83e = v; });
$parcel$export(module.exports, "SENTRY_MODULE_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$df1b536467b3992a; }, function (v) { return $8b11dd70aaca6dbd$export$df1b536467b3992a = v; });
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_ROUTE", function () { return $8b11dd70aaca6dbd$export$73104a329e205998; }, function (v) { return $8b11dd70aaca6dbd$export$73104a329e205998 = v; });
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_TYPE", function () { return $8b11dd70aaca6dbd$export$5740e3da55330b0a; }, function (v) { return $8b11dd70aaca6dbd$export$5740e3da55330b0a = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY", function () { return $8b11dd70aaca6dbd$export$8dcc2d92ff6d65da; }, function (v) { return $8b11dd70aaca6dbd$export$8dcc2d92ff6d65da = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY_HASH", function () { return $8b11dd70aaca6dbd$export$e5f1321e53e24810; }, function (v) { return $8b11dd70aaca6dbd$export$e5f1321e53e24810 = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$56dd3098cbca7c8a; }, function (v) { return $8b11dd70aaca6dbd$export$56dd3098cbca7c8a = v; });
$parcel$export(module.exports, "SENTRY_OBSERVED_TIMESTAMP_NANOS", function () { return $8b11dd70aaca6dbd$export$aa7aff70e4380665; }, function (v) { return $8b11dd70aaca6dbd$export$aa7aff70e4380665 = v; });
$parcel$export(module.exports, "SENTRY_OP", function () { return $8b11dd70aaca6dbd$export$dacb7d452aa6bcaf; }, function (v) { return $8b11dd70aaca6dbd$export$dacb7d452aa6bcaf = v; });
$parcel$export(module.exports, "SENTRY_ORIGIN", function () { return $8b11dd70aaca6dbd$export$15dfc6c5e8f9baf6; }, function (v) { return $8b11dd70aaca6dbd$export$15dfc6c5e8f9baf6 = v; });
$parcel$export(module.exports, "SENTRY_PLATFORM", function () { return $8b11dd70aaca6dbd$export$91ad03bba7909fb5; }, function (v) { return $8b11dd70aaca6dbd$export$91ad03bba7909fb5 = v; });
$parcel$export(module.exports, "SENTRY_PROFILER_ID", function () { return $8b11dd70aaca6dbd$export$86128e6c0ab71d64; }, function (v) { return $8b11dd70aaca6dbd$export$86128e6c0ab71d64 = v; });
$parcel$export(module.exports, "SENTRY_PROFILE_ID", function () { return $8b11dd70aaca6dbd$export$745b60c4819aec1d; }, function (v) { return $8b11dd70aaca6dbd$export$745b60c4819aec1d = v; });
$parcel$export(module.exports, "SENTRY_RELEASE", function () { return $8b11dd70aaca6dbd$export$d2c893bfac1da9a1; }, function (v) { return $8b11dd70aaca6dbd$export$d2c893bfac1da9a1 = v; });
$parcel$export(module.exports, "SENTRY_REPLAY_ID", function () { return $8b11dd70aaca6dbd$export$1c14ad02f9534b19; }, function (v) { return $8b11dd70aaca6dbd$export$1c14ad02f9534b19 = v; });
$parcel$export(module.exports, "SENTRY_REPLAY_IS_BUFFERING", function () { return $8b11dd70aaca6dbd$export$db3cb63e0594d014; }, function (v) { return $8b11dd70aaca6dbd$export$db3cb63e0594d014 = v; });
$parcel$export(module.exports, "SENTRY_REPORT_EVENT", function () { return $8b11dd70aaca6dbd$export$a65c9a0eba2c222d; }, function (v) { return $8b11dd70aaca6dbd$export$a65c9a0eba2c222d = v; });
$parcel$export(module.exports, "SENTRY_SDK_INTEGRATIONS", function () { return $8b11dd70aaca6dbd$export$68dbcca9c0e339ec; }, function (v) { return $8b11dd70aaca6dbd$export$68dbcca9c0e339ec = v; });
$parcel$export(module.exports, "SENTRY_SDK_NAME", function () { return $8b11dd70aaca6dbd$export$d59b669d4bb3f006; }, function (v) { return $8b11dd70aaca6dbd$export$d59b669d4bb3f006 = v; });
$parcel$export(module.exports, "SENTRY_SDK_VERSION", function () { return $8b11dd70aaca6dbd$export$4d88d347aa9667fc; }, function (v) { return $8b11dd70aaca6dbd$export$4d88d347aa9667fc = v; });
$parcel$export(module.exports, "SENTRY_SEGMENT_ID", function () { return $8b11dd70aaca6dbd$export$9943ffdcaa4bc506; }, function (v) { return $8b11dd70aaca6dbd$export$9943ffdcaa4bc506 = v; });
$parcel$export(module.exports, "SENTRY_SEGMENT_NAME", function () { return $8b11dd70aaca6dbd$export$d4f25b923533dbba; }, function (v) { return $8b11dd70aaca6dbd$export$d4f25b923533dbba = v; });
$parcel$export(module.exports, "SENTRY_SERVER_SAMPLE_RATE", function () { return $8b11dd70aaca6dbd$export$35f3396a1cdeea45; }, function (v) { return $8b11dd70aaca6dbd$export$35f3396a1cdeea45 = v; });
$parcel$export(module.exports, "SENTRY_SOURCE", function () { return $8b11dd70aaca6dbd$export$80e399da474bc98d; }, function (v) { return $8b11dd70aaca6dbd$export$80e399da474bc98d = v; });
$parcel$export(module.exports, "SENTRY_SPAN_SOURCE", function () { return $8b11dd70aaca6dbd$export$e01809e2dbceac35; }, function (v) { return $8b11dd70aaca6dbd$export$e01809e2dbceac35 = v; });
$parcel$export(module.exports, "SENTRY_STATUS", function () { return $8b11dd70aaca6dbd$export$41900d5c4e8a9c68; }, function (v) { return $8b11dd70aaca6dbd$export$41900d5c4e8a9c68 = v; });
$parcel$export(module.exports, "SENTRY_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$362bb1cb0bb5ca03; }, function (v) { return $8b11dd70aaca6dbd$export$362bb1cb0bb5ca03 = v; });
$parcel$export(module.exports, "SENTRY_STATUS_MESSAGE", function () { return $8b11dd70aaca6dbd$export$6803ac54f919d9cc; }, function (v) { return $8b11dd70aaca6dbd$export$6803ac54f919d9cc = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_FROM", function () { return $8b11dd70aaca6dbd$export$72f5b47540331169; }, function (v) { return $8b11dd70aaca6dbd$export$72f5b47540331169 = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TO", function () { return $8b11dd70aaca6dbd$export$6c61a8c9aa5305cb; }, function (v) { return $8b11dd70aaca6dbd$export$6c61a8c9aa5305cb = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TYPE", function () { return $8b11dd70aaca6dbd$export$6b5244c457b68e65; }, function (v) { return $8b11dd70aaca6dbd$export$6b5244c457b68e65 = v; });
$parcel$export(module.exports, "SENTRY_THREAD_ID", function () { return $8b11dd70aaca6dbd$export$b7bd0c9a886f3414; }, function (v) { return $8b11dd70aaca6dbd$export$b7bd0c9a886f3414 = v; });
$parcel$export(module.exports, "SENTRY_TIMESTAMP_SEQUENCE", function () { return $8b11dd70aaca6dbd$export$6b77f2bacac7c93d; }, function (v) { return $8b11dd70aaca6dbd$export$6b77f2bacac7c93d = v; });
$parcel$export(module.exports, "SENTRY_TRACE_LIFECYCLE", function () { return $8b11dd70aaca6dbd$export$ddbc15c0e8e8a7ea; }, function (v) { return $8b11dd70aaca6dbd$export$ddbc15c0e8e8a7ea = v; });
$parcel$export(module.exports, "SENTRY_TRACE_PARENT_SPAN_ID", function () { return $8b11dd70aaca6dbd$export$feb4fe753df28a82; }, function (v) { return $8b11dd70aaca6dbd$export$feb4fe753df28a82 = v; });
$parcel$export(module.exports, "SENTRY_TRACE_STATUS", function () { return $8b11dd70aaca6dbd$export$d6267756132e2175; }, function (v) { return $8b11dd70aaca6dbd$export$d6267756132e2175 = v; });
$parcel$export(module.exports, "SENTRY_TRANSACTION", function () { return $8b11dd70aaca6dbd$export$570ac5a3fd7e6cc6; }, function (v) { return $8b11dd70aaca6dbd$export$570ac5a3fd7e6cc6 = v; });
$parcel$export(module.exports, "SENTRY_USER_EMAIL", function () { return $8b11dd70aaca6dbd$export$5b9a0015e1c530ed; }, function (v) { return $8b11dd70aaca6dbd$export$5b9a0015e1c530ed = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_CITY", function () { return $8b11dd70aaca6dbd$export$8bbff71c84508218; }, function (v) { return $8b11dd70aaca6dbd$export$8bbff71c84508218 = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_COUNTRY_CODE", function () { return $8b11dd70aaca6dbd$export$b55aa07a514a2430; }, function (v) { return $8b11dd70aaca6dbd$export$b55aa07a514a2430 = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_REGION", function () { return $8b11dd70aaca6dbd$export$9927ad09f7c084dc; }, function (v) { return $8b11dd70aaca6dbd$export$9927ad09f7c084dc = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_SUBDIVISION", function () { return $8b11dd70aaca6dbd$export$52a07a35ff8ec6b6; }, function (v) { return $8b11dd70aaca6dbd$export$52a07a35ff8ec6b6 = v; });
$parcel$export(module.exports, "SENTRY_USER_ID", function () { return $8b11dd70aaca6dbd$export$a10d277c42e6cae3; }, function (v) { return $8b11dd70aaca6dbd$export$a10d277c42e6cae3 = v; });
$parcel$export(module.exports, "SENTRY_USER_IP", function () { return $8b11dd70aaca6dbd$export$cdc0ce5c66182801; }, function (v) { return $8b11dd70aaca6dbd$export$cdc0ce5c66182801 = v; });
$parcel$export(module.exports, "SENTRY_USER_USERNAME", function () { return $8b11dd70aaca6dbd$export$2504d4bd698dd962; }, function (v) { return $8b11dd70aaca6dbd$export$2504d4bd698dd962 = v; });
$parcel$export(module.exports, "SERVER_ADDRESS", function () { return $8b11dd70aaca6dbd$export$9dc86f3b876e96ef; }, function (v) { return $8b11dd70aaca6dbd$export$9dc86f3b876e96ef = v; });
$parcel$export(module.exports, "SERVER_NAME", function () { return $8b11dd70aaca6dbd$export$70ff7865f52549ae; }, function (v) { return $8b11dd70aaca6dbd$export$70ff7865f52549ae = v; });
$parcel$export(module.exports, "SERVER_PORT", function () { return $8b11dd70aaca6dbd$export$f77b53a42be6e6fd; }, function (v) { return $8b11dd70aaca6dbd$export$f77b53a42be6e6fd = v; });
$parcel$export(module.exports, "SERVICE_NAME", function () { return $8b11dd70aaca6dbd$export$818eb7ab11414506; }, function (v) { return $8b11dd70aaca6dbd$export$818eb7ab11414506 = v; });
$parcel$export(module.exports, "SERVICE_VERSION", function () { return $8b11dd70aaca6dbd$export$829ef6b2e59d984d; }, function (v) { return $8b11dd70aaca6dbd$export$829ef6b2e59d984d = v; });
$parcel$export(module.exports, "SESSION_ID", function () { return $8b11dd70aaca6dbd$export$b30f4cb52c088a26; }, function (v) { return $8b11dd70aaca6dbd$export$b30f4cb52c088a26 = v; });
$parcel$export(module.exports, "STALL_PERCENTAGE", function () { return $8b11dd70aaca6dbd$export$335eace0ff1771cd; }, function (v) { return $8b11dd70aaca6dbd$export$335eace0ff1771cd = v; });
$parcel$export(module.exports, "STALL_TOTAL_TIME", function () { return $8b11dd70aaca6dbd$export$374d88a2025416ac; }, function (v) { return $8b11dd70aaca6dbd$export$374d88a2025416ac = v; });
$parcel$export(module.exports, "STATE_TYPE", function () { return $8b11dd70aaca6dbd$export$bb7a91303551eb37; }, function (v) { return $8b11dd70aaca6dbd$export$bb7a91303551eb37 = v; });
$parcel$export(module.exports, "THREAD_ID", function () { return $8b11dd70aaca6dbd$export$f132ea291a7db56b; }, function (v) { return $8b11dd70aaca6dbd$export$f132ea291a7db56b = v; });
$parcel$export(module.exports, "THREAD_NAME", function () { return $8b11dd70aaca6dbd$export$f0abd4170bbd2468; }, function (v) { return $8b11dd70aaca6dbd$export$f0abd4170bbd2468 = v; });
$parcel$export(module.exports, "TIMBER_TAG", function () { return $8b11dd70aaca6dbd$export$50d00a157dc08581; }, function (v) { return $8b11dd70aaca6dbd$export$50d00a157dc08581 = v; });
$parcel$export(module.exports, "TIME_TO_FULL_DISPLAY", function () { return $8b11dd70aaca6dbd$export$484576567a98833f; }, function (v) { return $8b11dd70aaca6dbd$export$484576567a98833f = v; });
$parcel$export(module.exports, "TIME_TO_INITIAL_DISPLAY", function () { return $8b11dd70aaca6dbd$export$ec9e491e475d0c97; }, function (v) { return $8b11dd70aaca6dbd$export$ec9e491e475d0c97 = v; });
$parcel$export(module.exports, "TRANSACTION", function () { return $8b11dd70aaca6dbd$export$a86c59c10992220f; }, function (v) { return $8b11dd70aaca6dbd$export$a86c59c10992220f = v; });
$parcel$export(module.exports, "TRPC_PROCEDURE_PATH", function () { return $8b11dd70aaca6dbd$export$e12f06597e992fde; }, function (v) { return $8b11dd70aaca6dbd$export$e12f06597e992fde = v; });
$parcel$export(module.exports, "TRPC_PROCEDURE_TYPE", function () { return $8b11dd70aaca6dbd$export$7ec54678ba28ea59; }, function (v) { return $8b11dd70aaca6dbd$export$7ec54678ba28ea59 = v; });
$parcel$export(module.exports, "TTFB", function () { return $8b11dd70aaca6dbd$export$433ba14c16717110; }, function (v) { return $8b11dd70aaca6dbd$export$433ba14c16717110 = v; });
$parcel$export(module.exports, "TTFB_REQUESTTIME", function () { return $8b11dd70aaca6dbd$export$309ee349b8a537f; }, function (v) { return $8b11dd70aaca6dbd$export$309ee349b8a537f = v; });
$parcel$export(module.exports, "TYPE", function () { return $8b11dd70aaca6dbd$export$b87f371cbc396fcf; }, function (v) { return $8b11dd70aaca6dbd$export$b87f371cbc396fcf = v; });
$parcel$export(module.exports, "UI_COMPONENT_NAME", function () { return $8b11dd70aaca6dbd$export$60050fc49fe0e7e2; }, function (v) { return $8b11dd70aaca6dbd$export$60050fc49fe0e7e2 = v; });
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTFD", function () { return $8b11dd70aaca6dbd$export$348c8e2b37f276cd; }, function (v) { return $8b11dd70aaca6dbd$export$348c8e2b37f276cd = v; });
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTID", function () { return $8b11dd70aaca6dbd$export$7f47e8a8b2d97cb2; }, function (v) { return $8b11dd70aaca6dbd$export$7f47e8a8b2d97cb2 = v; });
$parcel$export(module.exports, "UI_ELEMENT_HEIGHT", function () { return $8b11dd70aaca6dbd$export$50d5adc4b543ce95; }, function (v) { return $8b11dd70aaca6dbd$export$50d5adc4b543ce95 = v; });
$parcel$export(module.exports, "UI_ELEMENT_ID", function () { return $8b11dd70aaca6dbd$export$9221f1d2c934d9f; }, function (v) { return $8b11dd70aaca6dbd$export$9221f1d2c934d9f = v; });
$parcel$export(module.exports, "UI_ELEMENT_IDENTIFIER", function () { return $8b11dd70aaca6dbd$export$3a56578b3ae09a02; }, function (v) { return $8b11dd70aaca6dbd$export$3a56578b3ae09a02 = v; });
$parcel$export(module.exports, "UI_ELEMENT_LOAD_TIME", function () { return $8b11dd70aaca6dbd$export$e47b8dab9466c895; }, function (v) { return $8b11dd70aaca6dbd$export$e47b8dab9466c895 = v; });
$parcel$export(module.exports, "UI_ELEMENT_PAINT_TYPE", function () { return $8b11dd70aaca6dbd$export$4ca52f75cf4889c5; }, function (v) { return $8b11dd70aaca6dbd$export$4ca52f75cf4889c5 = v; });
$parcel$export(module.exports, "UI_ELEMENT_RENDER_TIME", function () { return $8b11dd70aaca6dbd$export$7343d7d72195067f; }, function (v) { return $8b11dd70aaca6dbd$export$7343d7d72195067f = v; });
$parcel$export(module.exports, "UI_ELEMENT_TYPE", function () { return $8b11dd70aaca6dbd$export$f334f32f8d4d8063; }, function (v) { return $8b11dd70aaca6dbd$export$f334f32f8d4d8063 = v; });
$parcel$export(module.exports, "UI_ELEMENT_URL", function () { return $8b11dd70aaca6dbd$export$c7bf2089e89a217c; }, function (v) { return $8b11dd70aaca6dbd$export$c7bf2089e89a217c = v; });
$parcel$export(module.exports, "UI_ELEMENT_WIDTH", function () { return $8b11dd70aaca6dbd$export$f514f97553a434b2; }, function (v) { return $8b11dd70aaca6dbd$export$f514f97553a434b2 = v; });
$parcel$export(module.exports, "URL", function () { return $8b11dd70aaca6dbd$export$61abde59b50deb8e; }, function (v) { return $8b11dd70aaca6dbd$export$61abde59b50deb8e = v; });
$parcel$export(module.exports, "URL_DOMAIN", function () { return $8b11dd70aaca6dbd$export$5a5ce44f9fb51f93; }, function (v) { return $8b11dd70aaca6dbd$export$5a5ce44f9fb51f93 = v; });
$parcel$export(module.exports, "URL_FRAGMENT", function () { return $8b11dd70aaca6dbd$export$7044ea8d89b6f59d; }, function (v) { return $8b11dd70aaca6dbd$export$7044ea8d89b6f59d = v; });
$parcel$export(module.exports, "URL_FULL", function () { return $8b11dd70aaca6dbd$export$40eacf1a072c9dbd; }, function (v) { return $8b11dd70aaca6dbd$export$40eacf1a072c9dbd = v; });
$parcel$export(module.exports, "URL_PATH", function () { return $8b11dd70aaca6dbd$export$4c1fa0ac0eff2ac; }, function (v) { return $8b11dd70aaca6dbd$export$4c1fa0ac0eff2ac = v; });
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY", function () { return $8b11dd70aaca6dbd$export$5bee9450fe31dde1; }, function (v) { return $8b11dd70aaca6dbd$export$5bee9450fe31dde1 = v; });
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$d0b571fb4406d953; }, function (v) { return $8b11dd70aaca6dbd$export$d0b571fb4406d953 = v; });
$parcel$export(module.exports, "URL_PORT", function () { return $8b11dd70aaca6dbd$export$258b370e6c2b85d5; }, function (v) { return $8b11dd70aaca6dbd$export$258b370e6c2b85d5 = v; });
$parcel$export(module.exports, "URL_QUERY", function () { return $8b11dd70aaca6dbd$export$dc5e5523da291a4b; }, function (v) { return $8b11dd70aaca6dbd$export$dc5e5523da291a4b = v; });
$parcel$export(module.exports, "URL_SAME_ORIGIN", function () { return $8b11dd70aaca6dbd$export$fd5a8904ab5abfe0; }, function (v) { return $8b11dd70aaca6dbd$export$fd5a8904ab5abfe0 = v; });
$parcel$export(module.exports, "URL_SCHEME", function () { return $8b11dd70aaca6dbd$export$1350d8937b0f26fb; }, function (v) { return $8b11dd70aaca6dbd$export$1350d8937b0f26fb = v; });
$parcel$export(module.exports, "URL_TEMPLATE", function () { return $8b11dd70aaca6dbd$export$2a045f777fb349a8; }, function (v) { return $8b11dd70aaca6dbd$export$2a045f777fb349a8 = v; });
$parcel$export(module.exports, "USER_AGENT_ORIGINAL", function () { return $8b11dd70aaca6dbd$export$8bb874585539a88f; }, function (v) { return $8b11dd70aaca6dbd$export$8bb874585539a88f = v; });
$parcel$export(module.exports, "USER_EMAIL", function () { return $8b11dd70aaca6dbd$export$17d3a50785727199; }, function (v) { return $8b11dd70aaca6dbd$export$17d3a50785727199 = v; });
$parcel$export(module.exports, "USER_FULL_NAME", function () { return $8b11dd70aaca6dbd$export$2931c570009689e; }, function (v) { return $8b11dd70aaca6dbd$export$2931c570009689e = v; });
$parcel$export(module.exports, "USER_GEO_CITY", function () { return $8b11dd70aaca6dbd$export$199cbcedee735a43; }, function (v) { return $8b11dd70aaca6dbd$export$199cbcedee735a43 = v; });
$parcel$export(module.exports, "USER_GEO_COUNTRY_CODE", function () { return $8b11dd70aaca6dbd$export$4ba5bf9d4e3ed862; }, function (v) { return $8b11dd70aaca6dbd$export$4ba5bf9d4e3ed862 = v; });
$parcel$export(module.exports, "USER_GEO_REGION", function () { return $8b11dd70aaca6dbd$export$674c01ec2f0b89c3; }, function (v) { return $8b11dd70aaca6dbd$export$674c01ec2f0b89c3 = v; });
$parcel$export(module.exports, "USER_GEO_SUBDIVISION", function () { return $8b11dd70aaca6dbd$export$bda1686739fd61c7; }, function (v) { return $8b11dd70aaca6dbd$export$bda1686739fd61c7 = v; });
$parcel$export(module.exports, "USER_HASH", function () { return $8b11dd70aaca6dbd$export$8d804148f485d54c; }, function (v) { return $8b11dd70aaca6dbd$export$8d804148f485d54c = v; });
$parcel$export(module.exports, "USER_ID", function () { return $8b11dd70aaca6dbd$export$212a8f1ea37518bd; }, function (v) { return $8b11dd70aaca6dbd$export$212a8f1ea37518bd = v; });
$parcel$export(module.exports, "USER_IP_ADDRESS", function () { return $8b11dd70aaca6dbd$export$c9ac0fee28245883; }, function (v) { return $8b11dd70aaca6dbd$export$c9ac0fee28245883 = v; });
$parcel$export(module.exports, "USER_NAME", function () { return $8b11dd70aaca6dbd$export$77078610759fe5f6; }, function (v) { return $8b11dd70aaca6dbd$export$77078610759fe5f6 = v; });
$parcel$export(module.exports, "USER_ROLES", function () { return $8b11dd70aaca6dbd$export$7c6317deeec7a6c1; }, function (v) { return $8b11dd70aaca6dbd$export$7c6317deeec7a6c1 = v; });
$parcel$export(module.exports, "VERCEL_BRANCH", function () { return $8b11dd70aaca6dbd$export$877ebf2e4ad81f03; }, function (v) { return $8b11dd70aaca6dbd$export$877ebf2e4ad81f03 = v; });
$parcel$export(module.exports, "VERCEL_BUILD_ID", function () { return $8b11dd70aaca6dbd$export$70b2343945496e1f; }, function (v) { return $8b11dd70aaca6dbd$export$70b2343945496e1f = v; });
$parcel$export(module.exports, "VERCEL_DEPLOYMENT_ID", function () { return $8b11dd70aaca6dbd$export$8415b56d2c6d2b1d; }, function (v) { return $8b11dd70aaca6dbd$export$8415b56d2c6d2b1d = v; });
$parcel$export(module.exports, "VERCEL_DESTINATION", function () { return $8b11dd70aaca6dbd$export$cc81114a03caab18; }, function (v) { return $8b11dd70aaca6dbd$export$cc81114a03caab18 = v; });
$parcel$export(module.exports, "VERCEL_EDGE_TYPE", function () { return $8b11dd70aaca6dbd$export$bc14eb892daceb23; }, function (v) { return $8b11dd70aaca6dbd$export$bc14eb892daceb23 = v; });
$parcel$export(module.exports, "VERCEL_ENTRYPOINT", function () { return $8b11dd70aaca6dbd$export$3c973217450c3e9d; }, function (v) { return $8b11dd70aaca6dbd$export$3c973217450c3e9d = v; });
$parcel$export(module.exports, "VERCEL_EXECUTION_REGION", function () { return $8b11dd70aaca6dbd$export$582c0b730ff1ddb9; }, function (v) { return $8b11dd70aaca6dbd$export$582c0b730ff1ddb9 = v; });
$parcel$export(module.exports, "VERCEL_ID", function () { return $8b11dd70aaca6dbd$export$b3edfb545b65f1c5; }, function (v) { return $8b11dd70aaca6dbd$export$b3edfb545b65f1c5 = v; });
$parcel$export(module.exports, "VERCEL_JA3_DIGEST", function () { return $8b11dd70aaca6dbd$export$2593317d8731841c; }, function (v) { return $8b11dd70aaca6dbd$export$2593317d8731841c = v; });
$parcel$export(module.exports, "VERCEL_JA4_DIGEST", function () { return $8b11dd70aaca6dbd$export$8bb5bc1732aa41f; }, function (v) { return $8b11dd70aaca6dbd$export$8bb5bc1732aa41f = v; });
$parcel$export(module.exports, "VERCEL_LOG_TYPE", function () { return $8b11dd70aaca6dbd$export$74a79c98b110b5b9; }, function (v) { return $8b11dd70aaca6dbd$export$74a79c98b110b5b9 = v; });
$parcel$export(module.exports, "VERCEL_PATH", function () { return $8b11dd70aaca6dbd$export$26461b03281b4db4; }, function (v) { return $8b11dd70aaca6dbd$export$26461b03281b4db4 = v; });
$parcel$export(module.exports, "VERCEL_PROJECT_ID", function () { return $8b11dd70aaca6dbd$export$eaea590d6d3dd93c; }, function (v) { return $8b11dd70aaca6dbd$export$eaea590d6d3dd93c = v; });
$parcel$export(module.exports, "VERCEL_PROJECT_NAME", function () { return $8b11dd70aaca6dbd$export$af45365f70099379; }, function (v) { return $8b11dd70aaca6dbd$export$af45365f70099379 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_CACHE_ID", function () { return $8b11dd70aaca6dbd$export$a49e732d34d5ba9b; }, function (v) { return $8b11dd70aaca6dbd$export$a49e732d34d5ba9b = v; });
$parcel$export(module.exports, "VERCEL_PROXY_CLIENT_IP", function () { return $8b11dd70aaca6dbd$export$7c147fe246bc8bd3; }, function (v) { return $8b11dd70aaca6dbd$export$7c147fe246bc8bd3 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_HOST", function () { return $8b11dd70aaca6dbd$export$e5111b6070e1ee9e; }, function (v) { return $8b11dd70aaca6dbd$export$e5111b6070e1ee9e = v; });
$parcel$export(module.exports, "VERCEL_PROXY_LAMBDA_REGION", function () { return $8b11dd70aaca6dbd$export$591cbfd403f8c8d; }, function (v) { return $8b11dd70aaca6dbd$export$591cbfd403f8c8d = v; });
$parcel$export(module.exports, "VERCEL_PROXY_METHOD", function () { return $8b11dd70aaca6dbd$export$b1388db955bbb885; }, function (v) { return $8b11dd70aaca6dbd$export$b1388db955bbb885 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH", function () { return $8b11dd70aaca6dbd$export$e898d0e9e211abd9; }, function (v) { return $8b11dd70aaca6dbd$export$e898d0e9e211abd9 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE", function () { return $8b11dd70aaca6dbd$export$ab6fee0e8a6ee069; }, function (v) { return $8b11dd70aaca6dbd$export$ab6fee0e8a6ee069 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE_VARIANT", function () { return $8b11dd70aaca6dbd$export$9786ad94c199ffbb; }, function (v) { return $8b11dd70aaca6dbd$export$9786ad94c199ffbb = v; });
$parcel$export(module.exports, "VERCEL_PROXY_REFERER", function () { return $8b11dd70aaca6dbd$export$269890524eed693b; }, function (v) { return $8b11dd70aaca6dbd$export$269890524eed693b = v; });
$parcel$export(module.exports, "VERCEL_PROXY_REGION", function () { return $8b11dd70aaca6dbd$export$2ec623a8212d6b64; }, function (v) { return $8b11dd70aaca6dbd$export$2ec623a8212d6b64 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_RESPONSE_BYTE_SIZE", function () { return $8b11dd70aaca6dbd$export$30e7673b01ff994e; }, function (v) { return $8b11dd70aaca6dbd$export$30e7673b01ff994e = v; });
$parcel$export(module.exports, "VERCEL_PROXY_SCHEME", function () { return $8b11dd70aaca6dbd$export$9ea93477840812bf; }, function (v) { return $8b11dd70aaca6dbd$export$9ea93477840812bf = v; });
$parcel$export(module.exports, "VERCEL_PROXY_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$a6da0c365670c430; }, function (v) { return $8b11dd70aaca6dbd$export$a6da0c365670c430 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_TIMESTAMP", function () { return $8b11dd70aaca6dbd$export$7986b22da43f2885; }, function (v) { return $8b11dd70aaca6dbd$export$7986b22da43f2885 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_USER_AGENT", function () { return $8b11dd70aaca6dbd$export$a9f943c7ceb3b42f; }, function (v) { return $8b11dd70aaca6dbd$export$a9f943c7ceb3b42f = v; });
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_CACHE", function () { return $8b11dd70aaca6dbd$export$dfe49501efcdffce; }, function (v) { return $8b11dd70aaca6dbd$export$dfe49501efcdffce = v; });
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_ID", function () { return $8b11dd70aaca6dbd$export$be465f50c92eb01d; }, function (v) { return $8b11dd70aaca6dbd$export$be465f50c92eb01d = v; });
$parcel$export(module.exports, "VERCEL_PROXY_WAF_ACTION", function () { return $8b11dd70aaca6dbd$export$c138d1796bb34999; }, function (v) { return $8b11dd70aaca6dbd$export$c138d1796bb34999 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_WAF_RULE_ID", function () { return $8b11dd70aaca6dbd$export$85a0016690a0ccf2; }, function (v) { return $8b11dd70aaca6dbd$export$85a0016690a0ccf2 = v; });
$parcel$export(module.exports, "VERCEL_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$883acab36ede4bfa; }, function (v) { return $8b11dd70aaca6dbd$export$883acab36ede4bfa = v; });
$parcel$export(module.exports, "VERCEL_SOURCE", function () { return $8b11dd70aaca6dbd$export$9cfc88d203f9cdf1; }, function (v) { return $8b11dd70aaca6dbd$export$9cfc88d203f9cdf1 = v; });
$parcel$export(module.exports, "VERCEL_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$b3c6c599110d7bab; }, function (v) { return $8b11dd70aaca6dbd$export$b3c6c599110d7bab = v; });
$parcel$export(module.exports, "_AWS_KINESIS_STREAM_NAME", function () { return $8b11dd70aaca6dbd$export$247839c65766758; }, function (v) { return $8b11dd70aaca6dbd$export$247839c65766758 = v; });
$parcel$export(module.exports, "_AWS_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$f4d52b02df927d54; }, function (v) { return $8b11dd70aaca6dbd$export$f4d52b02df927d54 = v; });
$parcel$export(module.exports, "_HTTP_REQUEST_METHOD", function () { return $8b11dd70aaca6dbd$export$df30ee8c5b5f1989; }, function (v) { return $8b11dd70aaca6dbd$export$df30ee8c5b5f1989 = v; });
$parcel$export(module.exports, "_SENTRY_SEGMENT_ID", function () { return $8b11dd70aaca6dbd$export$268a117c860fca6d; }, function (v) { return $8b11dd70aaca6dbd$export$268a117c860fca6d = v; });
var $8b11dd70aaca6dbd$export$b60c5e9f9b7b58bd;
var $8b11dd70aaca6dbd$export$cc06afd6de7f2c10;
var $8b11dd70aaca6dbd$export$ced6746028fe2cc;
var $8b11dd70aaca6dbd$export$e6f4aa4f4fcb6da8;
var $8b11dd70aaca6dbd$export$f02d892201cd8d36;
var $8b11dd70aaca6dbd$export$f277a7ef9e273960;
var $8b11dd70aaca6dbd$export$1a8c212c3becaa80;
var $8b11dd70aaca6dbd$export$721b137086c68a47;
var $8b11dd70aaca6dbd$export$6afde2bb69d9aa86;
var $8b11dd70aaca6dbd$export$eadb4b562c974031;
var $8b11dd70aaca6dbd$export$22a90f0ac1eee843;
var $8b11dd70aaca6dbd$export$a727f215a0be1dad;
var $8b11dd70aaca6dbd$export$536bc61b34d995e5;
var $8b11dd70aaca6dbd$export$c43ea6115b380e62;
var $8b11dd70aaca6dbd$export$d2a16e26bada7cf1;
var $8b11dd70aaca6dbd$export$604eb1bd2278163b;
var $8b11dd70aaca6dbd$export$2f8568696c5aa352;
var $8b11dd70aaca6dbd$export$ccc8efd7dd31d3a9;
var $8b11dd70aaca6dbd$export$e176bf5dc45e40df;
var $8b11dd70aaca6dbd$export$c4ea01fd53f64e16;
var $8b11dd70aaca6dbd$export$bb5e6f2f31a15da9;
var $8b11dd70aaca6dbd$export$1762c11b666b026a;
var $8b11dd70aaca6dbd$export$14ddd4b729910100;
var $8b11dd70aaca6dbd$export$5311d7c8e1f8eabb;
var $8b11dd70aaca6dbd$export$2b748b9eca00828b;
var $8b11dd70aaca6dbd$export$5af25308c11addea;
var $8b11dd70aaca6dbd$export$28f78b3b1663cb92;
var $8b11dd70aaca6dbd$export$a1d3f09f0f1f066f;
var $8b11dd70aaca6dbd$export$322bd4ea9f163663;
var $8b11dd70aaca6dbd$export$95711b9e669edad8;
var $8b11dd70aaca6dbd$export$5924d7d72384626a;
var $8b11dd70aaca6dbd$export$db3b1b877a4ce4db;
var $8b11dd70aaca6dbd$export$a434a3e8afec2879;
var $8b11dd70aaca6dbd$export$fe00bb20636d42af;
var $8b11dd70aaca6dbd$export$712aa698b7ee271e;
var $8b11dd70aaca6dbd$export$1fac638b11ec16d9;
var $8b11dd70aaca6dbd$export$d132016ea64058e3;
var $8b11dd70aaca6dbd$export$53f2f47ec3b2f9ed;
var $8b11dd70aaca6dbd$export$9f80c4b11053cef1;
var $8b11dd70aaca6dbd$export$5f7a08466d84e877;
var $8b11dd70aaca6dbd$export$2cea7f14750b8c19;
var $8b11dd70aaca6dbd$export$34c59270f032a6c6;
var $8b11dd70aaca6dbd$export$5b6c28c7dca07ad7;
var $8b11dd70aaca6dbd$export$1dc8ae58b58d6c50;
var $8b11dd70aaca6dbd$export$ba267414e3c0d822;
var $8b11dd70aaca6dbd$export$71b176005902b99e;
var $8b11dd70aaca6dbd$export$5c5b5a3c245a0079;
var $8b11dd70aaca6dbd$export$8ee1df3c6367a60;
var $8b11dd70aaca6dbd$export$e8c7802ae95beccf;
var $8b11dd70aaca6dbd$export$bb237734da4d464;
var $8b11dd70aaca6dbd$export$cdaaf6d1fdcba0b6;
var $8b11dd70aaca6dbd$export$36223ebd4a30e9f5;
var $8b11dd70aaca6dbd$export$8feaa177bb7941e2;
var $8b11dd70aaca6dbd$export$e1ca25240db91d68;
var $8b11dd70aaca6dbd$export$404a223fd1ada08b;
var $8b11dd70aaca6dbd$export$53362079310c68;
var $8b11dd70aaca6dbd$export$3efb5af0ac379f77;
var $8b11dd70aaca6dbd$export$2c10c1ca0612c46d;
var $8b11dd70aaca6dbd$export$bbb86ad4d6654da6;
var $8b11dd70aaca6dbd$export$ad6896f00a2b1076;
var $8b11dd70aaca6dbd$export$300f39d8506a273d;
var $8b11dd70aaca6dbd$export$ecaa0e7f4773ddc7;
var $8b11dd70aaca6dbd$export$74b78acb4c54c06b;
var $8b11dd70aaca6dbd$export$b15b2c133bc50e33;
var $8b11dd70aaca6dbd$export$5f1381d9ae1b1c95;
var $8b11dd70aaca6dbd$export$c170b7ff277132ea;
var $8b11dd70aaca6dbd$export$9459a5df93695e45;
var $8b11dd70aaca6dbd$export$a7902bd57492ebe8;
var $8b11dd70aaca6dbd$export$d2ace0da59da09b7;
var $8b11dd70aaca6dbd$export$c15dd8d2461e0aeb;
var $8b11dd70aaca6dbd$export$5405b0a98e00e538;
var $8b11dd70aaca6dbd$export$bd393bbb84b309d3;
var $8b11dd70aaca6dbd$export$96f586f8837b86ae;
var $8b11dd70aaca6dbd$export$5d9f28f388f552d2;
var $8b11dd70aaca6dbd$export$b3d2f68e0e769504;
var $8b11dd70aaca6dbd$export$2c98412ed43013e8;
var $8b11dd70aaca6dbd$export$a7bd794d11c19f1b;
var $8b11dd70aaca6dbd$export$df4227832b83fdd0;
var $8b11dd70aaca6dbd$export$f131a6d8fbc0534f;
var $8b11dd70aaca6dbd$export$9bdc66d4a70e7e3a;
var $8b11dd70aaca6dbd$export$bfbbc3cbcaa90e98;
var $8b11dd70aaca6dbd$export$3565fa72459aa4d6;
var $8b11dd70aaca6dbd$export$bb67a834ae4bffdc;
var $8b11dd70aaca6dbd$export$4a06c859a283f06;
var $8b11dd70aaca6dbd$export$68324fac2038d0f2;
var $8b11dd70aaca6dbd$export$5e1bd62ffd2786fb;
var $8b11dd70aaca6dbd$export$bfdf2261058f56b;
var $8b11dd70aaca6dbd$export$23bf57842d9d53df;
var $8b11dd70aaca6dbd$export$bfbd7e060eeb4d35;
var $8b11dd70aaca6dbd$export$82eb6cccda27c3ff;
var $8b11dd70aaca6dbd$export$8ea68734d455808f;
var $8b11dd70aaca6dbd$export$40050e29324d44ee;
var $8b11dd70aaca6dbd$export$5cd7541006d9f467;
var $8b11dd70aaca6dbd$export$81c017edd95d692e;
var $8b11dd70aaca6dbd$export$120b3897a58cf903;
var $8b11dd70aaca6dbd$export$d4a9de43b4b1076c;
var $8b11dd70aaca6dbd$export$f37f4f9022f1ab17;
var $8b11dd70aaca6dbd$export$66ac18da14747cfb;
var $8b11dd70aaca6dbd$export$9e49b833525ca49d;
var $8b11dd70aaca6dbd$export$b084fea5b3097227;
var $8b11dd70aaca6dbd$export$e09cd8615652e8d0;
var $8b11dd70aaca6dbd$export$a43a60ec723a90ee;
var $8b11dd70aaca6dbd$export$34cc955357266287;
var $8b11dd70aaca6dbd$export$d9dd218693ea9bba;
var $8b11dd70aaca6dbd$export$c9649b7156282a2f;
var $8b11dd70aaca6dbd$export$daa8ce1f8adc553e;
var $8b11dd70aaca6dbd$export$cb93c7b05db202cf;
var $8b11dd70aaca6dbd$export$930f9bd3cc2e5b3d;
var $8b11dd70aaca6dbd$export$48c6d4c44afdc0b;
var $8b11dd70aaca6dbd$export$c78d41789fe4b1e4;
var $8b11dd70aaca6dbd$export$f462d9921f1f7332;
var $8b11dd70aaca6dbd$export$bc71f8df9a45e243;
var $8b11dd70aaca6dbd$export$ed840ec4a5f5d053;
var $8b11dd70aaca6dbd$export$c1a559a4f74a5e8e;
var $8b11dd70aaca6dbd$export$d1c007424092e3f5;
var $8b11dd70aaca6dbd$export$9ebb466ce954c49c;
var $8b11dd70aaca6dbd$export$e9aafc7348984403;
var $8b11dd70aaca6dbd$export$faaa46964f075237;
var $8b11dd70aaca6dbd$export$d28c4b3cc4431a87;
var $8b11dd70aaca6dbd$export$734b017b330c8fe6;
var $8b11dd70aaca6dbd$export$683ebdc48ba3758d;
var $8b11dd70aaca6dbd$export$be0263971250ef44;
var $8b11dd70aaca6dbd$export$36a0cbc35c405232;
var $8b11dd70aaca6dbd$export$469f7765ba335497;
var $8b11dd70aaca6dbd$export$fe6fe2b7af051610;
var $8b11dd70aaca6dbd$export$8345821877c4dfad;
var $8b11dd70aaca6dbd$export$f6c188a7e02335cf;
var $8b11dd70aaca6dbd$export$aaf709a8971e825f;
var $8b11dd70aaca6dbd$export$def01b82f8c092f7;
var $8b11dd70aaca6dbd$export$23d4264c606a73a6;
var $8b11dd70aaca6dbd$export$af9ece53bb92f66b;
var $8b11dd70aaca6dbd$export$25421625a565b69;
var $8b11dd70aaca6dbd$export$ab0c90d873e69ccb;
var $8b11dd70aaca6dbd$export$538c05cc8cb2a2bb;
var $8b11dd70aaca6dbd$export$f86df4de196e1a7c;
var $8b11dd70aaca6dbd$export$51e8aa8c0d65e7b8;
var $8b11dd70aaca6dbd$export$99023486ecc470bd;
var $8b11dd70aaca6dbd$export$2f6c85eaf382e81;
var $8b11dd70aaca6dbd$export$1158d57c0aed42be;
var $8b11dd70aaca6dbd$export$d85c4f947ab776e3;
var $8b11dd70aaca6dbd$export$813ef8386d874918;
var $8b11dd70aaca6dbd$export$7c2f74ff9251f64;
var $8b11dd70aaca6dbd$export$993f84dab107b880;
var $8b11dd70aaca6dbd$export$7b9c2315e94d8d2f;
var $8b11dd70aaca6dbd$export$f01e5cd42b9ec146;
var $8b11dd70aaca6dbd$export$987f6b4367434b55;
var $8b11dd70aaca6dbd$export$d9d145585d5022bb;
var $8b11dd70aaca6dbd$export$44ffba16bd48dac6;
var $8b11dd70aaca6dbd$export$3134892c5d2e251a;
var $8b11dd70aaca6dbd$export$8495028d10296058;
var $8b11dd70aaca6dbd$export$d6d0e4fcf46d490c;
var $8b11dd70aaca6dbd$export$658dced473c19301;
var $8b11dd70aaca6dbd$export$97b0f9c3fbe64076;
var $8b11dd70aaca6dbd$export$cf2c95ed5efbe9eb;
var $8b11dd70aaca6dbd$export$880007904f61a388;
var $8b11dd70aaca6dbd$export$3e903b72d4d9e07d;
var $8b11dd70aaca6dbd$export$34da07180e0e56af;
var $8b11dd70aaca6dbd$export$c49aafdaeb061953;
var $8b11dd70aaca6dbd$export$ceb762c61de2f17f;
var $8b11dd70aaca6dbd$export$a5f54ccfb28c0caf;
var $8b11dd70aaca6dbd$export$1c86a56857b024db;
var $8b11dd70aaca6dbd$export$7598f3464be47440;
var $8b11dd70aaca6dbd$export$b673289c971fc0ae;
var $8b11dd70aaca6dbd$export$98b23f3e6f0c2a6f;
var $8b11dd70aaca6dbd$export$6ddeaf0498614ebb;
var $8b11dd70aaca6dbd$export$97b78f78d64a7232;
var $8b11dd70aaca6dbd$export$5147715be870fff7;
var $8b11dd70aaca6dbd$export$5276bb46e6096fba;
var $8b11dd70aaca6dbd$export$cbcbc1f67a937cf3;
var $8b11dd70aaca6dbd$export$226a2381b8f0cf78;
var $8b11dd70aaca6dbd$export$fd35512cae286064;
var $8b11dd70aaca6dbd$export$de9bbf95ab1d81e;
var $8b11dd70aaca6dbd$export$47fb20e8d18d7d15;
var $8b11dd70aaca6dbd$export$9db7964e4b8cb849;
var $8b11dd70aaca6dbd$export$7139adf9d3bace41;
var $8b11dd70aaca6dbd$export$8ac3d09060e7f25d;
var $8b11dd70aaca6dbd$export$dad0e4778ea23971;
var $8b11dd70aaca6dbd$export$c14d903ccf9385a8;
var $8b11dd70aaca6dbd$export$934cded0041affd7;
var $8b11dd70aaca6dbd$export$6386da1dcba88c9d;
var $8b11dd70aaca6dbd$export$a3371797e606e2;
var $8b11dd70aaca6dbd$export$a5bbef0af83b23e5;
var $8b11dd70aaca6dbd$export$91ed1f55874222a6;
var $8b11dd70aaca6dbd$export$23de81068d2aed1b;
var $8b11dd70aaca6dbd$export$d738320e1fba9e9d;
var $8b11dd70aaca6dbd$export$2eacdea75497e8a5;
var $8b11dd70aaca6dbd$export$2bc3ea101f86c1d2;
var $8b11dd70aaca6dbd$export$c54e27e8d90ee081;
var $8b11dd70aaca6dbd$export$4943adcec371c2a6;
var $8b11dd70aaca6dbd$export$f000a5900d0480c2;
var $8b11dd70aaca6dbd$export$8f5234893868273b;
var $8b11dd70aaca6dbd$export$1a35518f6e81e8c7;
var $8b11dd70aaca6dbd$export$a2d90911eaae60fc;
var $8b11dd70aaca6dbd$export$3c22ff8b64b8f565;
var $8b11dd70aaca6dbd$export$b8019c0e2a5b5f0f;
var $8b11dd70aaca6dbd$export$8c11477e471467c8;
var $8b11dd70aaca6dbd$export$92a96f6363488aee;
var $8b11dd70aaca6dbd$export$f91beb6088f9ded9;
var $8b11dd70aaca6dbd$export$78bc7224576bf289;
var $8b11dd70aaca6dbd$export$a8027e0ea0d93ca;
var $8b11dd70aaca6dbd$export$5e59d3aea52e5037;
var $8b11dd70aaca6dbd$export$47e408be0da7933f;
var $8b11dd70aaca6dbd$export$d5772b934ca13e57;
var $8b11dd70aaca6dbd$export$36e47f6a5777561d;
var $8b11dd70aaca6dbd$export$e768cbc99cd68acf;
var $8b11dd70aaca6dbd$export$dfcc6c69df1343f2;
var $8b11dd70aaca6dbd$export$69b0a5d9226b5211;
var $8b11dd70aaca6dbd$export$da010a4f4fc971ae;
var $8b11dd70aaca6dbd$export$5d515b35be0601a0;
var $8b11dd70aaca6dbd$export$3e1b1037a315c5ca;
var $8b11dd70aaca6dbd$export$847fdd494825f0fb;
var $8b11dd70aaca6dbd$export$a9d76f26c6c730a9;
var $8b11dd70aaca6dbd$export$de03f86d1c9866ca;
var $8b11dd70aaca6dbd$export$65798ecab7eef8c;
var $8b11dd70aaca6dbd$export$22aa61f48b9c79a0;
var $8b11dd70aaca6dbd$export$69f5fb98f5aed812;
var $8b11dd70aaca6dbd$export$bdea5d1006fd280a;
var $8b11dd70aaca6dbd$export$f63a7230c5b1d609;
var $8b11dd70aaca6dbd$export$6f25e59b05bb8e17;
var $8b11dd70aaca6dbd$export$a56ad13c4afc7421;
var $8b11dd70aaca6dbd$export$d9ce89ce8912bf12;
var $8b11dd70aaca6dbd$export$17094e5f380e4162;
var $8b11dd70aaca6dbd$export$28a0ffdf747973a0;
var $8b11dd70aaca6dbd$export$5480ae1ba5d50bb9;
var $8b11dd70aaca6dbd$export$edc72ee4a17f5152;
var $8b11dd70aaca6dbd$export$19e4df138d354f8b;
var $8b11dd70aaca6dbd$export$92b0d20fa482b4b2;
var $8b11dd70aaca6dbd$export$3f638a793d61933f;
var $8b11dd70aaca6dbd$export$3f511731cc3687d4;
var $8b11dd70aaca6dbd$export$692b08741d6b6265;
var $8b11dd70aaca6dbd$export$cf67f8cb2324428e;
var $8b11dd70aaca6dbd$export$9d4197c1ffc5f359;
var $8b11dd70aaca6dbd$export$509634fbff540e75;
var $8b11dd70aaca6dbd$export$ccbc4fdff4b5eff5;
var $8b11dd70aaca6dbd$export$e0cb371ca548b1d6;
var $8b11dd70aaca6dbd$export$3c39026d09026bc2;
var $8b11dd70aaca6dbd$export$bf9e8248cb72cf00;
var $8b11dd70aaca6dbd$export$1054f22a72121d0f;
var $8b11dd70aaca6dbd$export$723b8a59dad2e467;
var $8b11dd70aaca6dbd$export$160081ff141bac8e;
var $8b11dd70aaca6dbd$export$194f62c84d27310;
var $8b11dd70aaca6dbd$export$7ed866d57b018d09;
var $8b11dd70aaca6dbd$export$d50bae4562e03e5;
var $8b11dd70aaca6dbd$export$649ea67a18fe8e8b;
var $8b11dd70aaca6dbd$export$136a5c1b43caaccd;
var $8b11dd70aaca6dbd$export$e33a28ea554b6ddc;
var $8b11dd70aaca6dbd$export$acbe2d25ac76ea64;
var $8b11dd70aaca6dbd$export$793c13e17d7e5e2b;
var $8b11dd70aaca6dbd$export$a5617e33b89fd956;
var $8b11dd70aaca6dbd$export$b51f82164fa31e07;
var $8b11dd70aaca6dbd$export$f2ef55183c04d202;
var $8b11dd70aaca6dbd$export$7c98fc0c48a16b1c;
var $8b11dd70aaca6dbd$export$f0511e328234ae83;
var $8b11dd70aaca6dbd$export$be46596bc6608f3b;
var $8b11dd70aaca6dbd$export$f215947b3d76a6b7;
var $8b11dd70aaca6dbd$export$89bbc91416db6670;
var $8b11dd70aaca6dbd$export$b4b5eff8a8712c89;
var $8b11dd70aaca6dbd$export$f455969a57ab8a03;
var $8b11dd70aaca6dbd$export$13f2f8f42af49cec;
var $8b11dd70aaca6dbd$export$cd357afe2ffdd2c3;
var $8b11dd70aaca6dbd$export$d9ca2a279a11be5e;
var $8b11dd70aaca6dbd$export$bbd59a8c7efad4c9;
var $8b11dd70aaca6dbd$export$8413282a17f1cda5;
var $8b11dd70aaca6dbd$export$30d19ddc7705e7e8;
var $8b11dd70aaca6dbd$export$64a4f09e2444b3d;
var $8b11dd70aaca6dbd$export$645b039fe163809e;
var $8b11dd70aaca6dbd$export$b23ef8b8ffa607e1;
var $8b11dd70aaca6dbd$export$8bf64516740c1369;
var $8b11dd70aaca6dbd$export$9a0dc8e612f3e10b;
var $8b11dd70aaca6dbd$export$abe90fedb3dddda2;
var $8b11dd70aaca6dbd$export$4a19da9c85ed2ade;
var $8b11dd70aaca6dbd$export$5e091479f094bdbc;
var $8b11dd70aaca6dbd$export$d70909b5aa96a79a;
var $8b11dd70aaca6dbd$export$651d142a8017d83d;
var $8b11dd70aaca6dbd$export$44382a010a9f7fcf;
var $8b11dd70aaca6dbd$export$807abfdc6b7b9338;
var $8b11dd70aaca6dbd$export$31881d07f2569218;
var $8b11dd70aaca6dbd$export$e5bbf306deb709a6;
var $8b11dd70aaca6dbd$export$aa8721167c5c8d2d;
var $8b11dd70aaca6dbd$export$757b93e5b3adc7cb;
var $8b11dd70aaca6dbd$export$f869eaa92db1dc9b;
var $8b11dd70aaca6dbd$export$5d1d761e41c32d9e;
var $8b11dd70aaca6dbd$export$8aec72d9491f9399;
var $8b11dd70aaca6dbd$export$5562635d2be2ab25;
var $8b11dd70aaca6dbd$export$2dc31837ce6f7a3d;
var $8b11dd70aaca6dbd$export$b561df15f64d32e3;
var $8b11dd70aaca6dbd$export$181f78b28f2ffa57;
var $8b11dd70aaca6dbd$export$6c97c77b89571c75;
var $8b11dd70aaca6dbd$export$51e431eaf1f9bf58;
var $8b11dd70aaca6dbd$export$71429c7ef7cb7063;
var $8b11dd70aaca6dbd$export$99905d7583a6e8ac;
var $8b11dd70aaca6dbd$export$b6c4be74fd0c06bd;
var $8b11dd70aaca6dbd$export$fd23e5b8d261a89;
var $8b11dd70aaca6dbd$export$25fabc9b3d1dd567;
var $8b11dd70aaca6dbd$export$41507f7b07dad151;
var $8b11dd70aaca6dbd$export$1352f3699c35dd73;
var $8b11dd70aaca6dbd$export$fd6c9d5c74d943ac;
var $8b11dd70aaca6dbd$export$c29634e3cf41e479;
var $8b11dd70aaca6dbd$export$e6a60882cce7a085;
var $8b11dd70aaca6dbd$export$6773c9098ba5e194;
var $8b11dd70aaca6dbd$export$6ee6b62f50047686;
var $8b11dd70aaca6dbd$export$efac052bb3661242;
var $8b11dd70aaca6dbd$export$7ccd63b9ca955862;
var $8b11dd70aaca6dbd$export$50921df5a58cb3ef;
var $8b11dd70aaca6dbd$export$8e48efc7acb57a97;
var $8b11dd70aaca6dbd$export$cea9121727113f77;
var $8b11dd70aaca6dbd$export$bed35ff7f9af3aaa;
var $8b11dd70aaca6dbd$export$6b729e898b9067ce;
var $8b11dd70aaca6dbd$export$984fbab9b52f7e24;
var $8b11dd70aaca6dbd$export$9ea17906a87ada6f;
var $8b11dd70aaca6dbd$export$394b443aaff3ef92;
var $8b11dd70aaca6dbd$export$6ddc374adbc06720;
var $8b11dd70aaca6dbd$export$ab8c7ebc9add56b2;
var $8b11dd70aaca6dbd$export$40ecc5bcd633d1ee;
var $8b11dd70aaca6dbd$export$86a8df7fff52fc69;
var $8b11dd70aaca6dbd$export$cf2115d46768f4c5;
var $8b11dd70aaca6dbd$export$3d7e036e195764db;
var $8b11dd70aaca6dbd$export$60c1d11221608cee;
var $8b11dd70aaca6dbd$export$bc3cef164abbc42c;
var $8b11dd70aaca6dbd$export$43f9afb62cd79dec;
var $8b11dd70aaca6dbd$export$a5ab4ffc4765f75f;
var $8b11dd70aaca6dbd$export$ccf46db9ab1743ec;
var $8b11dd70aaca6dbd$export$76c1c247342d776;
var $8b11dd70aaca6dbd$export$92f5944f0b02c9fb;
var $8b11dd70aaca6dbd$export$867eeefcb1c95b27;
var $8b11dd70aaca6dbd$export$5ada4697ae6aa17e;
var $8b11dd70aaca6dbd$export$427122300e8d54d0;
var $8b11dd70aaca6dbd$export$bcea8881375c352f;
var $8b11dd70aaca6dbd$export$b867715f9a0c04e9;
var $8b11dd70aaca6dbd$export$69878a39cbdbe097;
var $8b11dd70aaca6dbd$export$584c61a1b769552d;
var $8b11dd70aaca6dbd$export$8169ebcb0b0331dd;
var $8b11dd70aaca6dbd$export$2c9713b624877853;
var $8b11dd70aaca6dbd$export$45942692aeb454e0;
var $8b11dd70aaca6dbd$export$8e5efeaa031210cd;
var $8b11dd70aaca6dbd$export$35a62769ee05a05a;
var $8b11dd70aaca6dbd$export$8ea4f7e986ca4b06;
var $8b11dd70aaca6dbd$export$d2fd9ecaff0285a4;
var $8b11dd70aaca6dbd$export$a6c8e656a4f9bb67;
var $8b11dd70aaca6dbd$export$352a8075b163d53;
var $8b11dd70aaca6dbd$export$426d7b90ba5d79db;
var $8b11dd70aaca6dbd$export$f5a1ee40934d19ce;
var $8b11dd70aaca6dbd$export$1ba812a9756622ce;
var $8b11dd70aaca6dbd$export$351120039c36e03;
var $8b11dd70aaca6dbd$export$d42aa25ca09e17c4;
var $8b11dd70aaca6dbd$export$d268db29b88a4286;
var $8b11dd70aaca6dbd$export$c5deb6018f2d6251;
var $8b11dd70aaca6dbd$export$e06baa3034409453;
var $8b11dd70aaca6dbd$export$646fdb5910ce3931;
var $8b11dd70aaca6dbd$export$662e3d2d4361e29b;
var $8b11dd70aaca6dbd$export$1de3962f221ba441;
var $8b11dd70aaca6dbd$export$a4b3f0f5499c8738;
var $8b11dd70aaca6dbd$export$1aecdac6cecbdc5b;
var $8b11dd70aaca6dbd$export$2eb2ab35b317a103;
var $8b11dd70aaca6dbd$export$c7e14ea195ede241;
var $8b11dd70aaca6dbd$export$41ac034e7b9725a2;
var $8b11dd70aaca6dbd$export$9e521119d7751e37;
var $8b11dd70aaca6dbd$export$cbac8f541a64a150;
var $8b11dd70aaca6dbd$export$93dd08efa94c9dd4;
var $8b11dd70aaca6dbd$export$183e3523dac20bca;
var $8b11dd70aaca6dbd$export$3867ca1d8381d4e3;
var $8b11dd70aaca6dbd$export$11febcf9917c0057;
var $8b11dd70aaca6dbd$export$88ae1ee0c0a63398;
var $8b11dd70aaca6dbd$export$d5bd986d1f283f29;
var $8b11dd70aaca6dbd$export$fc4a2d238535d998;
var $8b11dd70aaca6dbd$export$57e53a60bf563f41;
var $8b11dd70aaca6dbd$export$ffdb1464deb0eedb;
var $8b11dd70aaca6dbd$export$b52670c950fd640;
var $8b11dd70aaca6dbd$export$c499fd8f1db3d18e;
var $8b11dd70aaca6dbd$export$b2ee2242301eff05;
var $8b11dd70aaca6dbd$export$2ebf9f7586f16841;
var $8b11dd70aaca6dbd$export$6e9ffd608b3e828b;
var $8b11dd70aaca6dbd$export$b960c5a73a722e6c;
var $8b11dd70aaca6dbd$export$a7a850351369c77e;
var $8b11dd70aaca6dbd$export$b18bca78f4736a94;
var $8b11dd70aaca6dbd$export$61a0059f562fb6c2;
var $8b11dd70aaca6dbd$export$7dc0d5aefb816d91;
var $8b11dd70aaca6dbd$export$58f6db56c841bef6;
var $8b11dd70aaca6dbd$export$97a3da679f509d5;
var $8b11dd70aaca6dbd$export$c387ec65fd1c2638;
var $8b11dd70aaca6dbd$export$4d9db82211f308a4;
var $8b11dd70aaca6dbd$export$ee4948a3be025123;
var $8b11dd70aaca6dbd$export$e0021eb2979cddaa;
var $8b11dd70aaca6dbd$export$7c0ac0c19a45beac;
var $8b11dd70aaca6dbd$export$6c32e9d84f534ee;
var $8b11dd70aaca6dbd$export$d1f9fbdb211dd29b;
var $8b11dd70aaca6dbd$export$45e7eea99a17d6e4;
var $8b11dd70aaca6dbd$export$20ea34e16c0aa64f;
var $8b11dd70aaca6dbd$export$8365b0f03557fae9;
var $8b11dd70aaca6dbd$export$49ebbb9621675650;
var $8b11dd70aaca6dbd$export$842be66a901f093;
var $8b11dd70aaca6dbd$export$a9f5a6cb28adccb1;
var $8b11dd70aaca6dbd$export$57b055d4bc586d67;
var $8b11dd70aaca6dbd$export$3ddfd660caa7bf7a;
var $8b11dd70aaca6dbd$export$fa7e1f5305153b3d;
var $8b11dd70aaca6dbd$export$5674ce9d013eb7bd;
var $8b11dd70aaca6dbd$export$6e8dc14cff6ccf72;
var $8b11dd70aaca6dbd$export$afd59480458e1b57;
var $8b11dd70aaca6dbd$export$48e61fb9bccccba9;
var $8b11dd70aaca6dbd$export$d3e674514dd3a3e1;
var $8b11dd70aaca6dbd$export$97ad02b50c60ef68;
var $8b11dd70aaca6dbd$export$61d053b1b63e82c4;
var $8b11dd70aaca6dbd$export$54256cce0d674dea;
var $8b11dd70aaca6dbd$export$8c01f0f407bcc5ca;
var $8b11dd70aaca6dbd$export$be3f46982f6c7160;
var $8b11dd70aaca6dbd$export$778e4213e2788579;
var $8b11dd70aaca6dbd$export$8b48ca3594d2b172;
var $8b11dd70aaca6dbd$export$8be180ec26319f9f;
var $8b11dd70aaca6dbd$export$60eccaddefa8fc1c;
var $8b11dd70aaca6dbd$export$c99ce4fe37484d84;
var $8b11dd70aaca6dbd$export$fdf432fcac7d8f37;
var $8b11dd70aaca6dbd$export$4c21cc9cdf2f5dbd;
var $8b11dd70aaca6dbd$export$dcc1eab7f3f31816;
var $8b11dd70aaca6dbd$export$dcb7f1379b2b8f86;
var $8b11dd70aaca6dbd$export$53416edeea4c2d74;
var $8b11dd70aaca6dbd$export$69f7e5d2b74c5c9e;
var $8b11dd70aaca6dbd$export$8e104aed582a26bc;
var $8b11dd70aaca6dbd$export$577047501949be9;
var $8b11dd70aaca6dbd$export$c4c45b599a2c15e;
var $8b11dd70aaca6dbd$export$361cb541700d648e;
var $8b11dd70aaca6dbd$export$974f160e11f25731;
var $8b11dd70aaca6dbd$export$7162f5c702b95903;
var $8b11dd70aaca6dbd$export$a034d066a9090500;
var $8b11dd70aaca6dbd$export$70938021e43e047c;
var $8b11dd70aaca6dbd$export$5f6ac460012a73bb;
var $8b11dd70aaca6dbd$export$d8e498c1c670bcbf;
var $8b11dd70aaca6dbd$export$cc1a78a24d947903;
var $8b11dd70aaca6dbd$export$d29b927e0bb0ffea;
var $8b11dd70aaca6dbd$export$b3999cacef245779;
var $8b11dd70aaca6dbd$export$ff168b5f9cf9dcf6;
var $8b11dd70aaca6dbd$export$2ab876a45bd6e64;
var $8b11dd70aaca6dbd$export$cb8027e4395c6c0e;
var $8b11dd70aaca6dbd$export$f5303d1bac3c2660;
var $8b11dd70aaca6dbd$export$6c463c5f3b00f64;
var $8b11dd70aaca6dbd$export$e25d553065457cab;
var $8b11dd70aaca6dbd$export$15d24c154ea8a56f;
var $8b11dd70aaca6dbd$export$e5065789a6c415d0;
var $8b11dd70aaca6dbd$export$62662c561d7c7835;
var $8b11dd70aaca6dbd$export$218f394557fb0a5a;
var $8b11dd70aaca6dbd$export$2a5ff6de5448ecdf;
var $8b11dd70aaca6dbd$export$9d23f3030ed2597e;
var $8b11dd70aaca6dbd$export$a26ff217a6124160;
var $8b11dd70aaca6dbd$export$c8072f5fcfdb5b77;
var $8b11dd70aaca6dbd$export$c4e4b74f1ccf3d96;
var $8b11dd70aaca6dbd$export$328519d02a26ac41;
var $8b11dd70aaca6dbd$export$d2061b291c43d045;
var $8b11dd70aaca6dbd$export$d1f04dfd3d695286;
var $8b11dd70aaca6dbd$export$234fbd86ea0f0bd8;
var $8b11dd70aaca6dbd$export$e795000978a75b12;
var $8b11dd70aaca6dbd$export$9f4683b4d1018ace;
var $8b11dd70aaca6dbd$export$e431b042fcdb1d63;
var $8b11dd70aaca6dbd$export$a453239171ac9a23;
var $8b11dd70aaca6dbd$export$3a7726a976c18d5f;
var $8b11dd70aaca6dbd$export$7eca7a6c06843b93;
var $8b11dd70aaca6dbd$export$f25c55f83e5b0672;
var $8b11dd70aaca6dbd$export$9562bfac4eb079cb;
var $8b11dd70aaca6dbd$export$c276d164ff91d2f7;
var $8b11dd70aaca6dbd$export$2f3e0574f1a99754;
var $8b11dd70aaca6dbd$export$15eecaab68167880;
var $8b11dd70aaca6dbd$export$513c47f6e194086a;
var $8b11dd70aaca6dbd$export$a3f464c4d5cd9096;
var $8b11dd70aaca6dbd$export$ed366a03a2330b03;
var $8b11dd70aaca6dbd$export$9b802c784f235e1d;
var $8b11dd70aaca6dbd$export$add0fc8b8c5726a4;
var $8b11dd70aaca6dbd$export$e7f32463f5bfd554;
var $8b11dd70aaca6dbd$export$f9346f394edf26a;
var $8b11dd70aaca6dbd$export$16b917774e73ef92;
var $8b11dd70aaca6dbd$export$15d2b60bf3b65454;
var $8b11dd70aaca6dbd$export$db55eca5af256142;
var $8b11dd70aaca6dbd$export$967c74f8b1f3d35;
var $8b11dd70aaca6dbd$export$7c33ae67962515d1;
var $8b11dd70aaca6dbd$export$9c69839b2d93489b;
var $8b11dd70aaca6dbd$export$be22d22d4b6cf5d8;
var $8b11dd70aaca6dbd$export$c529961b911626ac;
var $8b11dd70aaca6dbd$export$e39c4b15d2881f5;
var $8b11dd70aaca6dbd$export$a8ca145161313e7;
var $8b11dd70aaca6dbd$export$3c1204d03918d076;
var $8b11dd70aaca6dbd$export$eaac3f141165e288;
var $8b11dd70aaca6dbd$export$4c7e6934714150e6;
var $8b11dd70aaca6dbd$export$6f71f9711d666eb4;
var $8b11dd70aaca6dbd$export$2a3cd2bb71fb63a4;
var $8b11dd70aaca6dbd$export$55478a0b7d2ae98f;
var $8b11dd70aaca6dbd$export$bed10c4da9b8eb0a;
var $8b11dd70aaca6dbd$export$a82607b6424c06c8;
var $8b11dd70aaca6dbd$export$6b081f3484c7f4e5;
var $8b11dd70aaca6dbd$export$b7754d85fd39406c;
var $8b11dd70aaca6dbd$export$492856c046eb4728;
var $8b11dd70aaca6dbd$export$c1678a2059fbe906;
var $8b11dd70aaca6dbd$export$6d384a0bc1011c34;
var $8b11dd70aaca6dbd$export$1499a7dbfc01e7d4;
var $8b11dd70aaca6dbd$export$cfcbff40019f0ff1;
var $8b11dd70aaca6dbd$export$27157b5f68e583af;
var $8b11dd70aaca6dbd$export$54bf5ed61532925d;
var $8b11dd70aaca6dbd$export$60ed0786292ace08;
var $8b11dd70aaca6dbd$export$d770bfb8345e146;
var $8b11dd70aaca6dbd$export$bb73817f1290ad28;
var $8b11dd70aaca6dbd$export$f201c980f2b75802;
var $8b11dd70aaca6dbd$export$b40e970572afd0ee;
var $8b11dd70aaca6dbd$export$8850630a3d343488;
var $8b11dd70aaca6dbd$export$fd0a39a918d6516f;
var $8b11dd70aaca6dbd$export$e68ef41f8e0335bf;
var $8b11dd70aaca6dbd$export$5bff09650e762829;
var $8b11dd70aaca6dbd$export$21c1adce0e067f37;
var $8b11dd70aaca6dbd$export$fed6ce86f48c84bc;
var $8b11dd70aaca6dbd$export$500c2675137ac16e;
var $8b11dd70aaca6dbd$export$402c7728623fd8df;
var $8b11dd70aaca6dbd$export$15417259f4c0fe6b;
var $8b11dd70aaca6dbd$export$2b3b7f579a727f45;
var $8b11dd70aaca6dbd$export$514832a0b029734b;
var $8b11dd70aaca6dbd$export$b0522e6a14dec1a4;
var $8b11dd70aaca6dbd$export$659ea19f71a7ee0b;
var $8b11dd70aaca6dbd$export$1b61d972db315e73;
var $8b11dd70aaca6dbd$export$fb2970ee11a479ee;
var $8b11dd70aaca6dbd$export$920aceb2a8fad77e;
var $8b11dd70aaca6dbd$export$48f8f6fbc999d187;
var $8b11dd70aaca6dbd$export$eed590fa00a8223b;
var $8b11dd70aaca6dbd$export$f2e5bb5cd4a130da;
var $8b11dd70aaca6dbd$export$779ef03d633a9086;
var $8b11dd70aaca6dbd$export$d98b87c8d53d0dbc;
var $8b11dd70aaca6dbd$export$ca719aa57653a0a7;
var $8b11dd70aaca6dbd$export$74b19c5f48270c05;
var $8b11dd70aaca6dbd$export$c351affe7e8098cb;
var $8b11dd70aaca6dbd$export$be7cd6b3ae3ae765;
var $8b11dd70aaca6dbd$export$ec182524c4c57275;
var $8b11dd70aaca6dbd$export$9e45758246a85b07;
var $8b11dd70aaca6dbd$export$9fa5d5f0144954cb;
var $8b11dd70aaca6dbd$export$e66ba5bc4b978023;
var $8b11dd70aaca6dbd$export$2306e23cc611a36d;
var $8b11dd70aaca6dbd$export$144f8c1fe01428db;
var $8b11dd70aaca6dbd$export$f303b2744d52121c;
var $8b11dd70aaca6dbd$export$866b2dbc7bf18ce6;
var $8b11dd70aaca6dbd$export$b4c85774878b4841;
var $8b11dd70aaca6dbd$export$1c967a71bc9a3077;
var $8b11dd70aaca6dbd$export$5e3884a35a19eb90;
var $8b11dd70aaca6dbd$export$6e7ff99bb3259573;
var $8b11dd70aaca6dbd$export$7c932cba2d9e7a7;
var $8b11dd70aaca6dbd$export$94091942edce0667;
var $8b11dd70aaca6dbd$export$3671a8a524706a9d;
var $8b11dd70aaca6dbd$export$c288888dc82d233f;
var $8b11dd70aaca6dbd$export$8ff188536cebc35;
var $8b11dd70aaca6dbd$export$6407d78968c0eabe;
var $8b11dd70aaca6dbd$export$43e9fb9ec28d9743;
var $8b11dd70aaca6dbd$export$26f31d5c5c201739;
var $8b11dd70aaca6dbd$export$bff85124d2d35b93;
var $8b11dd70aaca6dbd$export$495c671ed5a6408c;
var $8b11dd70aaca6dbd$export$54b3d4d5548c35c3;
var $8b11dd70aaca6dbd$export$2954db6444fe1fa8;
var $8b11dd70aaca6dbd$export$15c1c974d16dd678;
var $8b11dd70aaca6dbd$export$9be2ae89a1eac217;
var $8b11dd70aaca6dbd$export$5c698591c0e586a2;
var $8b11dd70aaca6dbd$export$b711f2bb9c9a848a;
var $8b11dd70aaca6dbd$export$1d3a8501efd30213;
var $8b11dd70aaca6dbd$export$cebaf684ced5a2c9;
var $8b11dd70aaca6dbd$export$d4c658ecdcb7c78c;
var $8b11dd70aaca6dbd$export$b1b162b01baeb044;
var $8b11dd70aaca6dbd$export$8be2d593d7f88ed8;
var $8b11dd70aaca6dbd$export$dbd0a3528a97ccc0;
var $8b11dd70aaca6dbd$export$66581dc6d3d083d1;
var $8b11dd70aaca6dbd$export$e545f99e7abcc499;
var $8b11dd70aaca6dbd$export$7e1af5787f8c4aaa;
var $8b11dd70aaca6dbd$export$186c94c351c54768;
var $8b11dd70aaca6dbd$export$2e3fd8dfcb16fe0c;
var $8b11dd70aaca6dbd$export$7eeeceaa1dbd7cd5;
var $8b11dd70aaca6dbd$export$9d5bffdff936d554;
var $8b11dd70aaca6dbd$export$dc3a801c9a2c5b79;
var $8b11dd70aaca6dbd$export$27933a9557f87e98;
var $8b11dd70aaca6dbd$export$eefa737b40a0d535;
var $8b11dd70aaca6dbd$export$92740ffbcb02553b;
var $8b11dd70aaca6dbd$export$500e89753f9f1008;
var $8b11dd70aaca6dbd$export$d91a18e47fdddefd;
var $8b11dd70aaca6dbd$export$eccbe6f20884ea7f;
var $8b11dd70aaca6dbd$export$9e24f11d79141afb;
var $8b11dd70aaca6dbd$export$f0b96ad9586f8887;
var $8b11dd70aaca6dbd$export$8a92ed5d436a85c6;
var $8b11dd70aaca6dbd$export$edd59acdf7e86a71;
var $8b11dd70aaca6dbd$export$ae81a1ae71952d50;
var $8b11dd70aaca6dbd$export$6101470cd57eac1b;
var $8b11dd70aaca6dbd$export$452c0aee9673fe67;
var $8b11dd70aaca6dbd$export$773dddd1e8667756;
var $8b11dd70aaca6dbd$export$98815f8579a64a90;
var $8b11dd70aaca6dbd$export$7bc4e27428665019;
var $8b11dd70aaca6dbd$export$e7d7477fa9057ee2;
var $8b11dd70aaca6dbd$export$1f4267a3fc018448;
var $8b11dd70aaca6dbd$export$c171cae150389952;
var $8b11dd70aaca6dbd$export$d9bb35e957b22c72;
var $8b11dd70aaca6dbd$export$b3508a2c95f74e3d;
var $8b11dd70aaca6dbd$export$20bb272f4d21532d;
var $8b11dd70aaca6dbd$export$d7e64fbd0102ce90;
var $8b11dd70aaca6dbd$export$c17eae7e86dbba3c;
var $8b11dd70aaca6dbd$export$349603c0a9165744;
var $8b11dd70aaca6dbd$export$4dadf693741f0283;
var $8b11dd70aaca6dbd$export$6377864d12f7eeb3;
var $8b11dd70aaca6dbd$export$ba081af9585ed4;
var $8b11dd70aaca6dbd$export$7841dacb241485d0;
var $8b11dd70aaca6dbd$export$52c7044cf6301362;
var $8b11dd70aaca6dbd$export$56ea1c9e44590e20;
var $8b11dd70aaca6dbd$export$7626e389d05f4c36;
var $8b11dd70aaca6dbd$export$5e0a48187329b2e7;
var $8b11dd70aaca6dbd$export$c322b150d7667841;
var $8b11dd70aaca6dbd$export$4a4797d3c962f753;
var $8b11dd70aaca6dbd$export$767524d5e72e2645;
var $8b11dd70aaca6dbd$export$497354ca7b0ee666;
var $8b11dd70aaca6dbd$export$cbdc4ad11118116a;
var $8b11dd70aaca6dbd$export$5b890de778c4c2fe;
var $8b11dd70aaca6dbd$export$a78d9803b5e0a83e;
var $8b11dd70aaca6dbd$export$df1b536467b3992a;
var $8b11dd70aaca6dbd$export$73104a329e205998;
var $8b11dd70aaca6dbd$export$5740e3da55330b0a;
var $8b11dd70aaca6dbd$export$8dcc2d92ff6d65da;
var $8b11dd70aaca6dbd$export$e5f1321e53e24810;
var $8b11dd70aaca6dbd$export$56dd3098cbca7c8a;
var $8b11dd70aaca6dbd$export$aa7aff70e4380665;
var $8b11dd70aaca6dbd$export$dacb7d452aa6bcaf;
var $8b11dd70aaca6dbd$export$15dfc6c5e8f9baf6;
var $8b11dd70aaca6dbd$export$91ad03bba7909fb5;
var $8b11dd70aaca6dbd$export$86128e6c0ab71d64;
var $8b11dd70aaca6dbd$export$745b60c4819aec1d;
var $8b11dd70aaca6dbd$export$d2c893bfac1da9a1;
var $8b11dd70aaca6dbd$export$1c14ad02f9534b19;
var $8b11dd70aaca6dbd$export$db3cb63e0594d014;
var $8b11dd70aaca6dbd$export$a65c9a0eba2c222d;
var $8b11dd70aaca6dbd$export$68dbcca9c0e339ec;
var $8b11dd70aaca6dbd$export$d59b669d4bb3f006;
var $8b11dd70aaca6dbd$export$4d88d347aa9667fc;
var $8b11dd70aaca6dbd$export$9943ffdcaa4bc506;
var $8b11dd70aaca6dbd$export$d4f25b923533dbba;
var $8b11dd70aaca6dbd$export$35f3396a1cdeea45;
var $8b11dd70aaca6dbd$export$80e399da474bc98d;
var $8b11dd70aaca6dbd$export$e01809e2dbceac35;
var $8b11dd70aaca6dbd$export$41900d5c4e8a9c68;
var $8b11dd70aaca6dbd$export$362bb1cb0bb5ca03;
var $8b11dd70aaca6dbd$export$6803ac54f919d9cc;
var $8b11dd70aaca6dbd$export$72f5b47540331169;
var $8b11dd70aaca6dbd$export$6c61a8c9aa5305cb;
var $8b11dd70aaca6dbd$export$6b5244c457b68e65;
var $8b11dd70aaca6dbd$export$b7bd0c9a886f3414;
var $8b11dd70aaca6dbd$export$6b77f2bacac7c93d;
var $8b11dd70aaca6dbd$export$ddbc15c0e8e8a7ea;
var $8b11dd70aaca6dbd$export$feb4fe753df28a82;
var $8b11dd70aaca6dbd$export$d6267756132e2175;
var $8b11dd70aaca6dbd$export$570ac5a3fd7e6cc6;
var $8b11dd70aaca6dbd$export$5b9a0015e1c530ed;
var $8b11dd70aaca6dbd$export$8bbff71c84508218;
var $8b11dd70aaca6dbd$export$b55aa07a514a2430;
var $8b11dd70aaca6dbd$export$9927ad09f7c084dc;
var $8b11dd70aaca6dbd$export$52a07a35ff8ec6b6;
var $8b11dd70aaca6dbd$export$a10d277c42e6cae3;
var $8b11dd70aaca6dbd$export$cdc0ce5c66182801;
var $8b11dd70aaca6dbd$export$2504d4bd698dd962;
var $8b11dd70aaca6dbd$export$9dc86f3b876e96ef;
var $8b11dd70aaca6dbd$export$70ff7865f52549ae;
var $8b11dd70aaca6dbd$export$f77b53a42be6e6fd;
var $8b11dd70aaca6dbd$export$818eb7ab11414506;
var $8b11dd70aaca6dbd$export$829ef6b2e59d984d;
var $8b11dd70aaca6dbd$export$b30f4cb52c088a26;
var $8b11dd70aaca6dbd$export$335eace0ff1771cd;
var $8b11dd70aaca6dbd$export$374d88a2025416ac;
var $8b11dd70aaca6dbd$export$bb7a91303551eb37;
var $8b11dd70aaca6dbd$export$f132ea291a7db56b;
var $8b11dd70aaca6dbd$export$f0abd4170bbd2468;
var $8b11dd70aaca6dbd$export$50d00a157dc08581;
var $8b11dd70aaca6dbd$export$484576567a98833f;
var $8b11dd70aaca6dbd$export$ec9e491e475d0c97;
var $8b11dd70aaca6dbd$export$a86c59c10992220f;
var $8b11dd70aaca6dbd$export$e12f06597e992fde;
var $8b11dd70aaca6dbd$export$7ec54678ba28ea59;
var $8b11dd70aaca6dbd$export$433ba14c16717110;
var $8b11dd70aaca6dbd$export$309ee349b8a537f;
var $8b11dd70aaca6dbd$export$b87f371cbc396fcf;
var $8b11dd70aaca6dbd$export$60050fc49fe0e7e2;
var $8b11dd70aaca6dbd$export$348c8e2b37f276cd;
var $8b11dd70aaca6dbd$export$7f47e8a8b2d97cb2;
var $8b11dd70aaca6dbd$export$50d5adc4b543ce95;
var $8b11dd70aaca6dbd$export$9221f1d2c934d9f;
var $8b11dd70aaca6dbd$export$3a56578b3ae09a02;
var $8b11dd70aaca6dbd$export$e47b8dab9466c895;
var $8b11dd70aaca6dbd$export$4ca52f75cf4889c5;
var $8b11dd70aaca6dbd$export$7343d7d72195067f;
var $8b11dd70aaca6dbd$export$f334f32f8d4d8063;
var $8b11dd70aaca6dbd$export$c7bf2089e89a217c;
var $8b11dd70aaca6dbd$export$f514f97553a434b2;
var $8b11dd70aaca6dbd$export$61abde59b50deb8e;
var $8b11dd70aaca6dbd$export$5a5ce44f9fb51f93;
var $8b11dd70aaca6dbd$export$7044ea8d89b6f59d;
var $8b11dd70aaca6dbd$export$40eacf1a072c9dbd;
var $8b11dd70aaca6dbd$export$4c1fa0ac0eff2ac;
var $8b11dd70aaca6dbd$export$5bee9450fe31dde1;
var $8b11dd70aaca6dbd$export$d0b571fb4406d953;
var $8b11dd70aaca6dbd$export$258b370e6c2b85d5;
var $8b11dd70aaca6dbd$export$dc5e5523da291a4b;
var $8b11dd70aaca6dbd$export$fd5a8904ab5abfe0;
var $8b11dd70aaca6dbd$export$1350d8937b0f26fb;
var $8b11dd70aaca6dbd$export$2a045f777fb349a8;
var $8b11dd70aaca6dbd$export$8bb874585539a88f;
var $8b11dd70aaca6dbd$export$17d3a50785727199;
var $8b11dd70aaca6dbd$export$2931c570009689e;
var $8b11dd70aaca6dbd$export$199cbcedee735a43;
var $8b11dd70aaca6dbd$export$4ba5bf9d4e3ed862;
var $8b11dd70aaca6dbd$export$674c01ec2f0b89c3;
var $8b11dd70aaca6dbd$export$bda1686739fd61c7;
var $8b11dd70aaca6dbd$export$8d804148f485d54c;
var $8b11dd70aaca6dbd$export$212a8f1ea37518bd;
var $8b11dd70aaca6dbd$export$c9ac0fee28245883;
var $8b11dd70aaca6dbd$export$77078610759fe5f6;
var $8b11dd70aaca6dbd$export$7c6317deeec7a6c1;
var $8b11dd70aaca6dbd$export$877ebf2e4ad81f03;
var $8b11dd70aaca6dbd$export$70b2343945496e1f;
var $8b11dd70aaca6dbd$export$8415b56d2c6d2b1d;
var $8b11dd70aaca6dbd$export$cc81114a03caab18;
var $8b11dd70aaca6dbd$export$bc14eb892daceb23;
var $8b11dd70aaca6dbd$export$3c973217450c3e9d;
var $8b11dd70aaca6dbd$export$582c0b730ff1ddb9;
var $8b11dd70aaca6dbd$export$b3edfb545b65f1c5;
var $8b11dd70aaca6dbd$export$2593317d8731841c;
var $8b11dd70aaca6dbd$export$8bb5bc1732aa41f;
var $8b11dd70aaca6dbd$export$74a79c98b110b5b9;
var $8b11dd70aaca6dbd$export$26461b03281b4db4;
var $8b11dd70aaca6dbd$export$eaea590d6d3dd93c;
var $8b11dd70aaca6dbd$export$af45365f70099379;
var $8b11dd70aaca6dbd$export$a49e732d34d5ba9b;
var $8b11dd70aaca6dbd$export$7c147fe246bc8bd3;
var $8b11dd70aaca6dbd$export$e5111b6070e1ee9e;
var $8b11dd70aaca6dbd$export$591cbfd403f8c8d;
var $8b11dd70aaca6dbd$export$b1388db955bbb885;
var $8b11dd70aaca6dbd$export$e898d0e9e211abd9;
var $8b11dd70aaca6dbd$export$ab6fee0e8a6ee069;
var $8b11dd70aaca6dbd$export$9786ad94c199ffbb;
var $8b11dd70aaca6dbd$export$269890524eed693b;
var $8b11dd70aaca6dbd$export$2ec623a8212d6b64;
var $8b11dd70aaca6dbd$export$30e7673b01ff994e;
var $8b11dd70aaca6dbd$export$9ea93477840812bf;
var $8b11dd70aaca6dbd$export$a6da0c365670c430;
var $8b11dd70aaca6dbd$export$7986b22da43f2885;
var $8b11dd70aaca6dbd$export$a9f943c7ceb3b42f;
var $8b11dd70aaca6dbd$export$dfe49501efcdffce;
var $8b11dd70aaca6dbd$export$be465f50c92eb01d;
var $8b11dd70aaca6dbd$export$c138d1796bb34999;
var $8b11dd70aaca6dbd$export$85a0016690a0ccf2;
var $8b11dd70aaca6dbd$export$883acab36ede4bfa;
var $8b11dd70aaca6dbd$export$9cfc88d203f9cdf1;
var $8b11dd70aaca6dbd$export$b3c6c599110d7bab;
var $8b11dd70aaca6dbd$export$247839c65766758;
var $8b11dd70aaca6dbd$export$f4d52b02df927d54;
var $8b11dd70aaca6dbd$export$df30ee8c5b5f1989;
var $8b11dd70aaca6dbd$export$268a117c860fca6d;
"use strict";
const $8b11dd70aaca6dbd$var$AI_CITATIONS = "ai.citations", $8b11dd70aaca6dbd$var$AI_COMPLETION_TOKENS_USED = "ai.completion_tokens.used", $8b11dd70aaca6dbd$var$AI_DOCUMENTS = "ai.documents", $8b11dd70aaca6dbd$var$AI_FINISH_REASON = "ai.finish_reason", $8b11dd70aaca6dbd$var$AI_FREQUENCY_PENALTY = "ai.frequency_penalty", $8b11dd70aaca6dbd$var$AI_FUNCTION_CALL = "ai.function_call", $8b11dd70aaca6dbd$var$AI_GENERATION_ID = "ai.generation_id", $8b11dd70aaca6dbd$var$AI_INPUT_MESSAGES = "ai.input_messages", $8b11dd70aaca6dbd$var$AI_IS_SEARCH_REQUIRED = "ai.is_search_required", $8b11dd70aaca6dbd$var$AI_METADATA = "ai.metadata", $8b11dd70aaca6dbd$var$AI_MODEL_ID = "ai.model_id", $8b11dd70aaca6dbd$var$AI_MODEL_PROVIDER = "ai.model.provider", $8b11dd70aaca6dbd$var$AI_PIPELINE_NAME = "ai.pipeline.name", $8b11dd70aaca6dbd$var$AI_PREAMBLE = "ai.preamble", $8b11dd70aaca6dbd$var$AI_PRESENCE_PENALTY = "ai.presence_penalty", $8b11dd70aaca6dbd$var$AI_PROMPT_TOKENS_USED = "ai.prompt_tokens.used", $8b11dd70aaca6dbd$var$AI_RAW_PROMPTING = "ai.raw_prompting", $8b11dd70aaca6dbd$var$AI_RESPONSES = "ai.responses", $8b11dd70aaca6dbd$var$AI_RESPONSE_FORMAT = "ai.response_format", $8b11dd70aaca6dbd$var$AI_SEARCH_QUERIES = "ai.search_queries", $8b11dd70aaca6dbd$var$AI_SEARCH_RESULTS = "ai.search_results", $8b11dd70aaca6dbd$var$AI_SEED = "ai.seed", $8b11dd70aaca6dbd$var$AI_STREAMING = "ai.streaming", $8b11dd70aaca6dbd$var$AI_TAGS = "ai.tags", $8b11dd70aaca6dbd$var$AI_TEMPERATURE = "ai.temperature", $8b11dd70aaca6dbd$var$AI_TEXTS = "ai.texts", $8b11dd70aaca6dbd$var$AI_TOOLS = "ai.tools", $8b11dd70aaca6dbd$var$AI_TOOL_CALLS = "ai.tool_calls", $8b11dd70aaca6dbd$var$AI_TOP_K = "ai.top_k", $8b11dd70aaca6dbd$var$AI_TOP_P = "ai.top_p", $8b11dd70aaca6dbd$var$AI_TOTAL_COST = "ai.total_cost", $8b11dd70aaca6dbd$var$AI_TOTAL_TOKENS_USED = "ai.total_tokens.used", $8b11dd70aaca6dbd$var$AI_WARNINGS = "ai.warnings", $8b11dd70aaca6dbd$var$ANGULAR_VERSION = "angular.version", $8b11dd70aaca6dbd$var$APP_APP_BUILD = "app.app_build", $8b11dd70aaca6dbd$var$APP_APP_IDENTIFIER = "app.app_identifier", $8b11dd70aaca6dbd$var$APP_APP_NAME = "app.app_name", $8b11dd70aaca6dbd$var$APP_APP_START_TIME = "app.app_start_time", $8b11dd70aaca6dbd$var$APP_APP_VERSION = "app.app_version", $8b11dd70aaca6dbd$var$APP_BUILD = "app.build", $8b11dd70aaca6dbd$var$APP_IDENTIFIER = "app.identifier", $8b11dd70aaca6dbd$var$APP_IN_FOREGROUND = "app.in_foreground", $8b11dd70aaca6dbd$var$APP_NAME = "app.name", $8b11dd70aaca6dbd$var$APP_START_COLD = "app_start_cold", $8b11dd70aaca6dbd$var$APP_START_TIME = "app.start_time", $8b11dd70aaca6dbd$var$APP_START_TYPE = "app_start_type", $8b11dd70aaca6dbd$var$APP_START_WARM = "app_start_warm", $8b11dd70aaca6dbd$var$APP_VERSION = "app.version", $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_DELAY_VALUE = "app.vitals.frames.delay.value", $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_FROZEN_COUNT = "app.vitals.frames.frozen.count", $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_SLOW_COUNT = "app.vitals.frames.slow.count", $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_TOTAL_COUNT = "app.vitals.frames.total.count", $8b11dd70aaca6dbd$var$APP_VITALS_START_COLD_VALUE = "app.vitals.start.cold.value", $8b11dd70aaca6dbd$var$APP_VITALS_START_PREWARMED = "app.vitals.start.prewarmed", $8b11dd70aaca6dbd$var$APP_VITALS_START_REASON = "app.vitals.start.reason", $8b11dd70aaca6dbd$var$APP_VITALS_START_SCREEN = "app.vitals.start.screen", $8b11dd70aaca6dbd$var$APP_VITALS_START_TYPE = "app.vitals.start.type", $8b11dd70aaca6dbd$var$APP_VITALS_START_WARM_VALUE = "app.vitals.start.warm.value", $8b11dd70aaca6dbd$var$APP_VITALS_TTFD_VALUE = "app.vitals.ttfd.value", $8b11dd70aaca6dbd$var$APP_VITALS_TTID_VALUE = "app.vitals.ttid.value", $8b11dd70aaca6dbd$var$ART_GC_BLOCKING_COUNT = "art.gc.blocking_count", $8b11dd70aaca6dbd$var$ART_GC_BLOCKING_TIME = "art.gc.blocking_time", $8b11dd70aaca6dbd$var$ART_GC_PRE_OOME_COUNT = "art.gc.pre_oome_count", $8b11dd70aaca6dbd$var$ART_GC_TOTAL_COUNT = "art.gc.total_count", $8b11dd70aaca6dbd$var$ART_GC_TOTAL_TIME = "art.gc.total_time", $8b11dd70aaca6dbd$var$ART_GC_WAITING_TIME = "art.gc.waiting_time", $8b11dd70aaca6dbd$var$ART_MEMORY_FREE = "art.memory.free", $8b11dd70aaca6dbd$var$ART_MEMORY_FREE_UNTIL_GC = "art.memory.free_until_gc", $8b11dd70aaca6dbd$var$ART_MEMORY_FREE_UNTIL_OOME = "art.memory.free_until_oome", $8b11dd70aaca6dbd$var$ART_MEMORY_MAX = "art.memory.max", $8b11dd70aaca6dbd$var$ART_MEMORY_TOTAL = "art.memory.total", $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP = "aws.cloudwatch.logs.log_group", $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM = "aws.cloudwatch.logs.log_stream", $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_URL = "aws.cloudwatch.logs.url", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = "aws.dynamodb.attribute_definitions", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_CONSISTENT_READ = "aws.dynamodb.consistent_read", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_CONSUMED_CAPACITY = "aws.dynamodb.consumed_capacity", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_COUNT = "aws.dynamodb.count", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE = "aws.dynamodb.exclusive_start_table", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = "aws.dynamodb.global_secondary_indexes", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = "aws.dynamodb.global_secondary_index_updates", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_INDEX_NAME = "aws.dynamodb.index_name", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS = "aws.dynamodb.item_collection_metrics", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_LIMIT = "aws.dynamodb.limit", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = "aws.dynamodb.local_secondary_indexes", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROJECTION = "aws.dynamodb.projection", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = "aws.dynamodb.provisioned_read_capacity", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = "aws.dynamodb.provisioned_write_capacity", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SCANNED_COUNT = "aws.dynamodb.scanned_count", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SCAN_FORWARD = "aws.dynamodb.scan_forward", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SEGMENT = "aws.dynamodb.segment", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SELECT = "aws.dynamodb.select", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TABLE_COUNT = "aws.dynamodb.table_count", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TABLE_NAMES = "aws.dynamodb.table_names", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TOTAL_SEGMENTS = "aws.dynamodb.total_segments", $8b11dd70aaca6dbd$var$AWS_EXTENDED_REQUEST_ID = "aws.extended_request_id", $8b11dd70aaca6dbd$var$AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream_name", $8b11dd70aaca6dbd$var$_AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream.name", $8b11dd70aaca6dbd$var$AWS_LAMBDA_AWS_REQUEST_ID = "aws.lambda.aws_request_id", $8b11dd70aaca6dbd$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS = "aws.lambda.execution_duration_in_millis", $8b11dd70aaca6dbd$var$AWS_LAMBDA_FUNCTION_NAME = "aws.lambda.function_name", $8b11dd70aaca6dbd$var$AWS_LAMBDA_FUNCTION_VERSION = "aws.lambda.function_version", $8b11dd70aaca6dbd$var$AWS_LAMBDA_INVOKED_ARN = "aws.lambda.invoked_arn", $8b11dd70aaca6dbd$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN = "aws.lambda.invoked_function_arn", $8b11dd70aaca6dbd$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS = "aws.lambda.remaining_time_in_millis", $8b11dd70aaca6dbd$var$AWS_LOG_GROUP_NAMES = "aws.log.group.names", $8b11dd70aaca6dbd$var$AWS_LOG_STREAM_NAMES = "aws.log.stream.names", $8b11dd70aaca6dbd$var$AWS_REQUEST_EXTENDED_ID = "aws.request.extended_id", $8b11dd70aaca6dbd$var$AWS_REQUEST_ID = "aws.request_id", $8b11dd70aaca6dbd$var$_AWS_REQUEST_ID = "aws.request.id", $8b11dd70aaca6dbd$var$AWS_S3_BUCKET = "aws.s3.bucket", $8b11dd70aaca6dbd$var$AWS_SECRETSMANAGER_SECRET_ARN = "aws.secretsmanager.secret.arn", $8b11dd70aaca6dbd$var$AWS_SNS_TOPIC_ARN = "aws.sns.topic.arn", $8b11dd70aaca6dbd$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN = "aws.step_functions.activity.arn", $8b11dd70aaca6dbd$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN = "aws.step_functions.state_machine.arn", $8b11dd70aaca6dbd$var$BLOCKED_MAIN_THREAD = "blocked_main_thread", $8b11dd70aaca6dbd$var$BROWSER_NAME = "browser.name", $8b11dd70aaca6dbd$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START = "browser.performance.navigation.activation_start", $8b11dd70aaca6dbd$var$BROWSER_PERFORMANCE_TIME_ORIGIN = "browser.performance.time_origin", $8b11dd70aaca6dbd$var$BROWSER_REPORT_TYPE = "browser.report.type", $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_INVOKER = "browser.script.invoker", $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_INVOKER_TYPE = "browser.script.invoker_type", $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION = "browser.script.source_char_position", $8b11dd70aaca6dbd$var$BROWSER_VERSION = "browser.version", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT = "browser.web_vital.cls.report_event", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY = "browser.web_vital.cls.source.<key>", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE = "browser.web_vital.cls.source", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_VALUE = "browser.web_vital.cls.value", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_FCP_VALUE = "browser.web_vital.fcp.value", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_FP_VALUE = "browser.web_vital.fp.value", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_INP_VALUE = "browser.web_vital.inp.value", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_ELEMENT = "browser.web_vital.lcp.element", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_ID = "browser.web_vital.lcp.id", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME = "browser.web_vital.lcp.load_time", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME = "browser.web_vital.lcp.render_time", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT = "browser.web_vital.lcp.report_event", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_SIZE = "browser.web_vital.lcp.size", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_URL = "browser.web_vital.lcp.url", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_VALUE = "browser.web_vital.lcp.value", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME = "browser.web_vital.ttfb.request_time", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_TTFB_VALUE = "browser.web_vital.ttfb.value", $8b11dd70aaca6dbd$var$CACHE_HIT = "cache.hit", $8b11dd70aaca6dbd$var$CACHE_ITEM_SIZE = "cache.item_size", $8b11dd70aaca6dbd$var$CACHE_KEY = "cache.key", $8b11dd70aaca6dbd$var$CACHE_OPERATION = "cache.operation", $8b11dd70aaca6dbd$var$CACHE_TTL = "cache.ttl", $8b11dd70aaca6dbd$var$CACHE_WRITE = "cache.write", $8b11dd70aaca6dbd$var$CHANNEL = "channel", $8b11dd70aaca6dbd$var$CLIENT_ADDRESS = "client.address", $8b11dd70aaca6dbd$var$CLIENT_PORT = "client.port", $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_DURATION = "cloudflare.d1.duration", $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_QUERY_TYPE = "cloudflare.d1.query_type", $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_ROWS_READ = "cloudflare.d1.rows_read", $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_ROWS_WRITTEN = "cloudflare.d1.rows_written", $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS = "cloudflare.durable_object.query.bindings", $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ = "cloudflare.durable_object.response.rows_read", $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN = "cloudflare.durable_object.response.rows_written", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_BUCKET = "cloudflare.r2.bucket", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_OPERATION = "cloudflare.r2.operation", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_DELIMITER = "cloudflare.r2.request.delimiter", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_KEY = "cloudflare.r2.request.key", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER = "cloudflare.r2.request.part_number", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_PREFIX = "cloudflare.r2.request.prefix", $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_ATTEMPT = "cloudflare.workflow.attempt", $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF = "cloudflare.workflow.retries.backoff", $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY = "cloudflare.workflow.retries.delay", $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT = "cloudflare.workflow.retries.limit", $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_TIMEOUT = "cloudflare.workflow.timeout", $8b11dd70aaca6dbd$var$CLOUD_ACCOUNT_ID = "cloud.account.id", $8b11dd70aaca6dbd$var$CLOUD_AVAILABILITY_ZONE = "cloud.availability_zone", $8b11dd70aaca6dbd$var$CLOUD_PLATFORM = "cloud.platform", $8b11dd70aaca6dbd$var$CLOUD_PROVIDER = "cloud.provider", $8b11dd70aaca6dbd$var$CLOUD_REGION = "cloud.region", $8b11dd70aaca6dbd$var$CLOUD_RESOURCE_ID = "cloud.resource_id", $8b11dd70aaca6dbd$var$CLS = "cls", $8b11dd70aaca6dbd$var$CLS_SOURCE_KEY = "cls.source.<key>", $8b11dd70aaca6dbd$var$CLS_SOURCE_KEY_BASE = "cls.source", $8b11dd70aaca6dbd$var$CODE_FILEPATH = "code.filepath", $8b11dd70aaca6dbd$var$CODE_FILE_PATH = "code.file.path", $8b11dd70aaca6dbd$var$CODE_FUNCTION = "code.function", $8b11dd70aaca6dbd$var$CODE_FUNCTION_NAME = "code.function.name", $8b11dd70aaca6dbd$var$CODE_LINENO = "code.lineno", $8b11dd70aaca6dbd$var$CODE_LINE_NUMBER = "code.line.number", $8b11dd70aaca6dbd$var$CODE_NAMESPACE = "code.namespace", $8b11dd70aaca6dbd$var$CONNECTIONTYPE = "connectionType", $8b11dd70aaca6dbd$var$CONNECTION_RTT = "connection.rtt", $8b11dd70aaca6dbd$var$CULTURE_CALENDAR = "culture.calendar", $8b11dd70aaca6dbd$var$CULTURE_DISPLAY_NAME = "culture.display_name", $8b11dd70aaca6dbd$var$CULTURE_IS_24_HOUR_FORMAT = "culture.is_24_hour_format", $8b11dd70aaca6dbd$var$CULTURE_LOCALE = "culture.locale", $8b11dd70aaca6dbd$var$CULTURE_TIMEZONE = "culture.timezone", $8b11dd70aaca6dbd$var$DB_COLLECTION_NAME = "db.collection.name", $8b11dd70aaca6dbd$var$DB_DRIVER_NAME = "db.driver.name", $8b11dd70aaca6dbd$var$DB_NAME = "db.name", $8b11dd70aaca6dbd$var$DB_NAMESPACE = "db.namespace", $8b11dd70aaca6dbd$var$DB_OPERATION = "db.operation", $8b11dd70aaca6dbd$var$DB_OPERATION_BATCH_SIZE = "db.operation.batch.size", $8b11dd70aaca6dbd$var$DB_OPERATION_NAME = "db.operation.name", $8b11dd70aaca6dbd$var$DB_QUERY_PARAMETER_KEY = "db.query.parameter.<key>", $8b11dd70aaca6dbd$var$DB_QUERY_PARAMETER_KEY_BASE = "db.query.parameter", $8b11dd70aaca6dbd$var$DB_QUERY_SUMMARY = "db.query.summary", $8b11dd70aaca6dbd$var$DB_QUERY_TEXT = "db.query.text", $8b11dd70aaca6dbd$var$DB_REDIS_CONNECTION = "db.redis.connection", $8b11dd70aaca6dbd$var$DB_REDIS_KEY = "db.redis.key", $8b11dd70aaca6dbd$var$DB_REDIS_PARAMETERS = "db.redis.parameters", $8b11dd70aaca6dbd$var$DB_RESPONSE_STATUS_CODE = "db.response.status_code", $8b11dd70aaca6dbd$var$DB_SQL_BINDINGS = "db.sql.bindings", $8b11dd70aaca6dbd$var$DB_STATEMENT = "db.statement", $8b11dd70aaca6dbd$var$DB_STORED_PROCEDURE_NAME = "db.stored_procedure.name", $8b11dd70aaca6dbd$var$DB_SYSTEM = "db.system", $8b11dd70aaca6dbd$var$DB_SYSTEM_NAME = "db.system.name", $8b11dd70aaca6dbd$var$DB_USER = "db.user", $8b11dd70aaca6dbd$var$DEVICEMEMORY = "deviceMemory", $8b11dd70aaca6dbd$var$DEVICE_ARCHS = "device.archs", $8b11dd70aaca6dbd$var$DEVICE_BATTERY_LEVEL = "device.battery_level", $8b11dd70aaca6dbd$var$DEVICE_BATTERY_TEMPERATURE = "device.battery_temperature", $8b11dd70aaca6dbd$var$DEVICE_BOOT_TIME = "device.boot_time", $8b11dd70aaca6dbd$var$DEVICE_BRAND = "device.brand", $8b11dd70aaca6dbd$var$DEVICE_CHARGING = "device.charging", $8b11dd70aaca6dbd$var$DEVICE_CHIPSET = "device.chipset", $8b11dd70aaca6dbd$var$DEVICE_CLASS = "device.class", $8b11dd70aaca6dbd$var$DEVICE_CONNECTION_TYPE = "device.connection_type", $8b11dd70aaca6dbd$var$DEVICE_CPU_DESCRIPTION = "device.cpu_description", $8b11dd70aaca6dbd$var$DEVICE_EXTERNAL_FREE_STORAGE = "device.external_free_storage", $8b11dd70aaca6dbd$var$DEVICE_EXTERNAL_STORAGE_SIZE = "device.external_storage_size", $8b11dd70aaca6dbd$var$DEVICE_FAMILY = "device.family", $8b11dd70aaca6dbd$var$DEVICE_FREE_MEMORY = "device.free_memory", $8b11dd70aaca6dbd$var$DEVICE_FREE_STORAGE = "device.free_storage", $8b11dd70aaca6dbd$var$DEVICE_ID = "device.id", $8b11dd70aaca6dbd$var$DEVICE_LOCALE = "device.locale", $8b11dd70aaca6dbd$var$DEVICE_LOW_MEMORY = "device.low_memory", $8b11dd70aaca6dbd$var$DEVICE_LOW_POWER_MODE = "device.low_power_mode", $8b11dd70aaca6dbd$var$DEVICE_MANUFACTURER = "device.manufacturer", $8b11dd70aaca6dbd$var$DEVICE_MEMORY_ESTIMATED_CAPACITY = "device.memory.estimated_capacity", $8b11dd70aaca6dbd$var$DEVICE_MEMORY_SIZE = "device.memory_size", $8b11dd70aaca6dbd$var$DEVICE_MODEL = "device.model", $8b11dd70aaca6dbd$var$DEVICE_MODEL_ID = "device.model_id", $8b11dd70aaca6dbd$var$DEVICE_NAME = "device.name", $8b11dd70aaca6dbd$var$DEVICE_ONLINE = "device.online", $8b11dd70aaca6dbd$var$DEVICE_ORIENTATION = "device.orientation", $8b11dd70aaca6dbd$var$DEVICE_PROCESSOR_COUNT = "device.processor_count", $8b11dd70aaca6dbd$var$DEVICE_PROCESSOR_FREQUENCY = "device.processor_frequency", $8b11dd70aaca6dbd$var$DEVICE_SCREEN_DENSITY = "device.screen_density", $8b11dd70aaca6dbd$var$DEVICE_SCREEN_DPI = "device.screen_dpi", $8b11dd70aaca6dbd$var$DEVICE_SCREEN_HEIGHT_PIXELS = "device.screen_height_pixels", $8b11dd70aaca6dbd$var$DEVICE_SCREEN_WIDTH_PIXELS = "device.screen_width_pixels", $8b11dd70aaca6dbd$var$DEVICE_SIMULATOR = "device.simulator", $8b11dd70aaca6dbd$var$DEVICE_STORAGE_SIZE = "device.storage_size", $8b11dd70aaca6dbd$var$DEVICE_THERMAL_STATE = "device.thermal_state", $8b11dd70aaca6dbd$var$DEVICE_TIMEZONE = "device.timezone", $8b11dd70aaca6dbd$var$DEVICE_USABLE_MEMORY = "device.usable_memory", $8b11dd70aaca6dbd$var$DIST = "dist", $8b11dd70aaca6dbd$var$EFFECTIVECONNECTIONTYPE = "effectiveConnectionType", $8b11dd70aaca6dbd$var$ENVIRONMENT = "environment", $8b11dd70aaca6dbd$var$ERROR_TYPE = "error.type", $8b11dd70aaca6dbd$var$EVENT_ID = "event.id", $8b11dd70aaca6dbd$var$EVENT_NAME = "event.name", $8b11dd70aaca6dbd$var$EXCEPTION_ESCAPED = "exception.escaped", $8b11dd70aaca6dbd$var$EXCEPTION_MESSAGE = "exception.message", $8b11dd70aaca6dbd$var$EXCEPTION_STACKTRACE = "exception.stacktrace", $8b11dd70aaca6dbd$var$EXCEPTION_TYPE = "exception.type", $8b11dd70aaca6dbd$var$FAAS_COLDSTART = "faas.coldstart", $8b11dd70aaca6dbd$var$FAAS_CRON = "faas.cron", $8b11dd70aaca6dbd$var$FAAS_DURATION_IN_MS = "faas.duration_in_ms", $8b11dd70aaca6dbd$var$FAAS_ENTRY_POINT = "faas.entry_point", $8b11dd70aaca6dbd$var$FAAS_EXECUTION = "faas.execution", $8b11dd70aaca6dbd$var$FAAS_ID = "faas.id", $8b11dd70aaca6dbd$var$FAAS_IDENTITY = "faas.identity", $8b11dd70aaca6dbd$var$FAAS_INVOCATION_ID = "faas.invocation_id", $8b11dd70aaca6dbd$var$FAAS_INVOKED_NAME = "faas.invoked_name", $8b11dd70aaca6dbd$var$FAAS_INVOKED_PROVIDER = "faas.invoked_provider", $8b11dd70aaca6dbd$var$FAAS_INVOKED_REGION = "faas.invoked_region", $8b11dd70aaca6dbd$var$FAAS_NAME = "faas.name", $8b11dd70aaca6dbd$var$FAAS_TIME = "faas.time", $8b11dd70aaca6dbd$var$FAAS_TRIGGER = "faas.trigger", $8b11dd70aaca6dbd$var$FAAS_VERSION = "faas.version", $8b11dd70aaca6dbd$var$FCP = "fcp", $8b11dd70aaca6dbd$var$FLAG_EVALUATION_KEY = "flag.evaluation.<key>", $8b11dd70aaca6dbd$var$FLAG_EVALUATION_KEY_BASE = "flag.evaluation", $8b11dd70aaca6dbd$var$FP = "fp", $8b11dd70aaca6dbd$var$FRAMES_DELAY = "frames.delay", $8b11dd70aaca6dbd$var$FRAMES_FROZEN = "frames.frozen", $8b11dd70aaca6dbd$var$FRAMES_FROZEN_RATE = "frames_frozen_rate", $8b11dd70aaca6dbd$var$FRAMES_SLOW = "frames.slow", $8b11dd70aaca6dbd$var$FRAMES_SLOW_RATE = "frames_slow_rate", $8b11dd70aaca6dbd$var$FRAMES_TOTAL = "frames.total", $8b11dd70aaca6dbd$var$FS_ERROR = "fs_error", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_EVENT_ID = "gcp.function.context.event_id", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE = "gcp.function.context.event_type", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_ID = "gcp.function.context.id", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_RESOURCE = "gcp.function.context.resource", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_SOURCE = "gcp.function.context.source", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_SPECVERSION = "gcp.function.context.specversion", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TIME = "gcp.function.context.time", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TIMESTAMP = "gcp.function.context.timestamp", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TYPE = "gcp.function.context.type", $8b11dd70aaca6dbd$var$GCP_PROJECT_ID = "gcp.project.id", $8b11dd70aaca6dbd$var$GEN_AI_AGENT_NAME = "gen_ai.agent.name", $8b11dd70aaca6dbd$var$GEN_AI_CONTEXT_UTILIZATION = "gen_ai.context.utilization", $8b11dd70aaca6dbd$var$GEN_AI_CONTEXT_WINDOW_SIZE = "gen_ai.context.window_size", $8b11dd70aaca6dbd$var$GEN_AI_CONVERSATION_ID = "gen_ai.conversation.id", $8b11dd70aaca6dbd$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS = "gen_ai.cost.cache_creation.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS = "gen_ai.cost.cache_read.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_COST_INPUT_TOKENS = "gen_ai.cost.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_COST_OUTPUT_TOKENS = "gen_ai.cost.output_tokens", $8b11dd70aaca6dbd$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS = "gen_ai.cost.reasoning.output_tokens", $8b11dd70aaca6dbd$var$GEN_AI_COST_TOTAL_TOKENS = "gen_ai.cost.total_tokens", $8b11dd70aaca6dbd$var$GEN_AI_EMBEDDINGS_INPUT = "gen_ai.embeddings.input", $8b11dd70aaca6dbd$var$GEN_AI_FUNCTION_ID = "gen_ai.function_id", $8b11dd70aaca6dbd$var$GEN_AI_INPUT_MESSAGES = "gen_ai.input.messages", $8b11dd70aaca6dbd$var$GEN_AI_OPERATION_NAME = "gen_ai.operation.name", $8b11dd70aaca6dbd$var$GEN_AI_OPERATION_TYPE = "gen_ai.operation.type", $8b11dd70aaca6dbd$var$GEN_AI_OUTPUT_MESSAGES = "gen_ai.output.messages", $8b11dd70aaca6dbd$var$GEN_AI_PIPELINE_NAME = "gen_ai.pipeline.name", $8b11dd70aaca6dbd$var$GEN_AI_PROMPT = "gen_ai.prompt", $8b11dd70aaca6dbd$var$GEN_AI_PROMPT_NAME = "gen_ai.prompt.name", $8b11dd70aaca6dbd$var$GEN_AI_PROVIDER_NAME = "gen_ai.provider.name", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_AVAILABLE_TOOLS = "gen_ai.request.available_tools", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_FREQUENCY_PENALTY = "gen_ai.request.frequency_penalty", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MAX_TOKENS = "gen_ai.request.max_tokens", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MESSAGES = "gen_ai.request.messages", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MODEL = "gen_ai.request.model", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_PRESENCE_PENALTY = "gen_ai.request.presence_penalty", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_REASONING_EFFORT = "gen_ai.request.reasoning_effort", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_SEED = "gen_ai.request.seed", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_STOP_SEQUENCES = "gen_ai.request.stop_sequences", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TEMPERATURE = "gen_ai.request.temperature", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TOP_K = "gen_ai.request.top_k", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TOP_P = "gen_ai.request.top_p", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_FINISH_REASONS = "gen_ai.response.finish_reasons", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_ID = "gen_ai.response.id", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_MODEL = "gen_ai.response.model", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_STREAMING = "gen_ai.response.streaming", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TEXT = "gen_ai.response.text", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK = "gen_ai.response.time_to_first_chunk", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN = "gen_ai.response.time_to_first_token", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND = "gen_ai.response.tokens_per_second", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TOOL_CALLS = "gen_ai.response.tool_calls", $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM = "gen_ai.system", $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM_INSTRUCTIONS = "gen_ai.system_instructions", $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM_MESSAGE = "gen_ai.system.message", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_CALL_ARGUMENTS = "gen_ai.tool.call.arguments", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_CALL_RESULT = "gen_ai.tool.call.result", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_DEFINITIONS = "gen_ai.tool.definitions", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_DESCRIPTION = "gen_ai.tool.description", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_INPUT = "gen_ai.tool.input", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_MESSAGE = "gen_ai.tool.message", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_NAME = "gen_ai.tool.name", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_OUTPUT = "gen_ai.tool.output", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_TYPE = "gen_ai.tool.type", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS = "gen_ai.usage.cache_creation.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS = "gen_ai.usage.cache_read.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_COMPLETION_TOKENS = "gen_ai.usage.completion_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS = "gen_ai.usage.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED = "gen_ai.usage.input_tokens.cached", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE = "gen_ai.usage.input_tokens.cache_write", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_OUTPUT_TOKENS = "gen_ai.usage.output_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING = "gen_ai.usage.output_tokens.reasoning", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_PROMPT_TOKENS = "gen_ai.usage.prompt_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS = "gen_ai.usage.reasoning.output_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_TOTAL_TOKENS = "gen_ai.usage.total_tokens", $8b11dd70aaca6dbd$var$GRAPHQL_DOCUMENT = "graphql.document", $8b11dd70aaca6dbd$var$GRAPHQL_OPERATION_NAME = "graphql.operation.name", $8b11dd70aaca6dbd$var$GRAPHQL_OPERATION_TYPE = "graphql.operation.type", $8b11dd70aaca6dbd$var$HARDWARECONCURRENCY = "hardwareConcurrency", $8b11dd70aaca6dbd$var$HTTP_CLIENT_IP = "http.client_ip", $8b11dd70aaca6dbd$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH = "http.decoded_response_content_length", $8b11dd70aaca6dbd$var$HTTP_FLAVOR = "http.flavor", $8b11dd70aaca6dbd$var$HTTP_FRAGMENT = "http.fragment", $8b11dd70aaca6dbd$var$HTTP_HOST = "http.host", $8b11dd70aaca6dbd$var$HTTP_METHOD = "http.method", $8b11dd70aaca6dbd$var$HTTP_QUERY = "http.query", $8b11dd70aaca6dbd$var$HTTP_REQUEST_BODY_DATA = "http.request.body.data", $8b11dd70aaca6dbd$var$HTTP_REQUEST_CONNECTION_END = "http.request.connection_end", $8b11dd70aaca6dbd$var$HTTP_REQUEST_CONNECT_START = "http.request.connect_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_DOMAIN_LOOKUP_END = "http.request.domain_lookup_end", $8b11dd70aaca6dbd$var$HTTP_REQUEST_DOMAIN_LOOKUP_START = "http.request.domain_lookup_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_FETCH_START = "http.request.fetch_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_HEADER_KEY = "http.request.header.<key>", $8b11dd70aaca6dbd$var$HTTP_REQUEST_HEADER_KEY_BASE = "http.request.header", $8b11dd70aaca6dbd$var$HTTP_REQUEST_METHOD = "http.request.method", $8b11dd70aaca6dbd$var$_HTTP_REQUEST_METHOD = "http.request_method", $8b11dd70aaca6dbd$var$HTTP_REQUEST_REDIRECT_END = "http.request.redirect_end", $8b11dd70aaca6dbd$var$HTTP_REQUEST_REDIRECT_START = "http.request.redirect_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_REQUEST_START = "http.request.request_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESEND_COUNT = "http.request.resend_count", $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESPONSE_END = "http.request.response_end", $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESPONSE_START = "http.request.response_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_SAME_ORIGIN = "http.request.same_origin", $8b11dd70aaca6dbd$var$HTTP_REQUEST_SECURE_CONNECTION_START = "http.request.secure_connection_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE = "http.request.time_to_first_byte", $8b11dd70aaca6dbd$var$HTTP_REQUEST_WORKER_START = "http.request.worker_start", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_BODY_SIZE = "http.response.body.size", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH = "http.response.header.content-length", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_KEY = "http.response.header.<key>", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_KEY_BASE = "http.response.header", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_SIZE = "http.response.size", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_STATUS_CODE = "http.response.status_code", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_TRANSFER_SIZE = "http.response_transfer_size", $8b11dd70aaca6dbd$var$HTTP_ROUTE = "http.route", $8b11dd70aaca6dbd$var$HTTP_SCHEME = "http.scheme", $8b11dd70aaca6dbd$var$HTTP_SERVER_NAME = "http.server_name", $8b11dd70aaca6dbd$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE = "http.server.request.time_in_queue", $8b11dd70aaca6dbd$var$HTTP_STATUS_CODE = "http.status_code", $8b11dd70aaca6dbd$var$HTTP_TARGET = "http.target", $8b11dd70aaca6dbd$var$HTTP_URL = "http.url", $8b11dd70aaca6dbd$var$HTTP_USER_AGENT = "http.user_agent", $8b11dd70aaca6dbd$var$ID = "id", $8b11dd70aaca6dbd$var$INP = "inp", $8b11dd70aaca6dbd$var$JSONRPC_PROTOCOL_VERSION = "jsonrpc.protocol.version", $8b11dd70aaca6dbd$var$JSONRPC_REQUEST_ID = "jsonrpc.request.id", $8b11dd70aaca6dbd$var$JVM_GC_ACTION = "jvm.gc.action", $8b11dd70aaca6dbd$var$JVM_GC_NAME = "jvm.gc.name", $8b11dd70aaca6dbd$var$JVM_MEMORY_POOL_NAME = "jvm.memory.pool.name", $8b11dd70aaca6dbd$var$JVM_MEMORY_TYPE = "jvm.memory.type", $8b11dd70aaca6dbd$var$JVM_THREAD_DAEMON = "jvm.thread.daemon", $8b11dd70aaca6dbd$var$JVM_THREAD_STATE = "jvm.thread.state", $8b11dd70aaca6dbd$var$KOA_NAME = "koa.name", $8b11dd70aaca6dbd$var$KOA_TYPE = "koa.type", $8b11dd70aaca6dbd$var$LCP = "lcp", $8b11dd70aaca6dbd$var$LCP_ELEMENT = "lcp.element", $8b11dd70aaca6dbd$var$LCP_ID = "lcp.id", $8b11dd70aaca6dbd$var$LCP_LOADTIME = "lcp.loadTime", $8b11dd70aaca6dbd$var$LCP_RENDERTIME = "lcp.renderTime", $8b11dd70aaca6dbd$var$LCP_SIZE = "lcp.size", $8b11dd70aaca6dbd$var$LCP_URL = "lcp.url", $8b11dd70aaca6dbd$var$LOGGER_NAME = "logger.name", $8b11dd70aaca6dbd$var$MCP_CANCELLED_REASON = "mcp.cancelled.reason", $8b11dd70aaca6dbd$var$MCP_CANCELLED_REQUEST_ID = "mcp.cancelled.request_id", $8b11dd70aaca6dbd$var$MCP_CLIENT_NAME = "mcp.client.name", $8b11dd70aaca6dbd$var$MCP_CLIENT_TITLE = "mcp.client.title", $8b11dd70aaca6dbd$var$MCP_CLIENT_VERSION = "mcp.client.version", $8b11dd70aaca6dbd$var$MCP_LIFECYCLE_PHASE = "mcp.lifecycle.phase", $8b11dd70aaca6dbd$var$MCP_LOGGING_DATA_TYPE = "mcp.logging.data_type", $8b11dd70aaca6dbd$var$MCP_LOGGING_LEVEL = "mcp.logging.level", $8b11dd70aaca6dbd$var$MCP_LOGGING_LOGGER = "mcp.logging.logger", $8b11dd70aaca6dbd$var$MCP_LOGGING_MESSAGE = "mcp.logging.message", $8b11dd70aaca6dbd$var$MCP_METHOD_NAME = "mcp.method.name", $8b11dd70aaca6dbd$var$MCP_PROGRESS_CURRENT = "mcp.progress.current", $8b11dd70aaca6dbd$var$MCP_PROGRESS_MESSAGE = "mcp.progress.message", $8b11dd70aaca6dbd$var$MCP_PROGRESS_PERCENTAGE = "mcp.progress.percentage", $8b11dd70aaca6dbd$var$MCP_PROGRESS_TOKEN = "mcp.progress.token", $8b11dd70aaca6dbd$var$MCP_PROGRESS_TOTAL = "mcp.progress.total", $8b11dd70aaca6dbd$var$MCP_PROMPT_NAME = "mcp.prompt.name", $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_DESCRIPTION = "mcp.prompt.result.description", $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT = "mcp.prompt.result.message_content", $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_COUNT = "mcp.prompt.result.message_count", $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_ROLE = "mcp.prompt.result.message_role", $8b11dd70aaca6dbd$var$MCP_PROTOCOL_READY = "mcp.protocol.ready", $8b11dd70aaca6dbd$var$MCP_PROTOCOL_VERSION = "mcp.protocol.version", $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_KEY = "mcp.request.argument.<key>", $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_KEY_BASE = "mcp.request.argument", $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_NAME = "mcp.request.argument.name", $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_URI = "mcp.request.argument.uri", $8b11dd70aaca6dbd$var$MCP_REQUEST_ID = "mcp.request.id", $8b11dd70aaca6dbd$var$MCP_RESOURCE_PROTOCOL = "mcp.resource.protocol", $8b11dd70aaca6dbd$var$MCP_RESOURCE_URI = "mcp.resource.uri", $8b11dd70aaca6dbd$var$MCP_SERVER_NAME = "mcp.server.name", $8b11dd70aaca6dbd$var$MCP_SERVER_TITLE = "mcp.server.title", $8b11dd70aaca6dbd$var$MCP_SERVER_VERSION = "mcp.server.version", $8b11dd70aaca6dbd$var$MCP_SESSION_ID = "mcp.session.id", $8b11dd70aaca6dbd$var$MCP_TOOL_NAME = "mcp.tool.name", $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_CONTENT = "mcp.tool.result.content", $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_CONTENT_COUNT = "mcp.tool.result.content_count", $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_IS_ERROR = "mcp.tool.result.is_error", $8b11dd70aaca6dbd$var$MCP_TRANSPORT = "mcp.transport", $8b11dd70aaca6dbd$var$MDC_KEY = "mdc.<key>", $8b11dd70aaca6dbd$var$MDC_KEY_BASE = "mdc", $8b11dd70aaca6dbd$var$MESSAGING_BATCH_MESSAGE_COUNT = "messaging.batch.message_count", $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION = "messaging.destination", $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION_CONNECTION = "messaging.destination.connection", $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION_NAME = "messaging.destination.name", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_BODY_SIZE = "messaging.message.body.size", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_CONVERSATION_ID = "messaging.message.conversation_id", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_ENVELOPE_SIZE = "messaging.message.envelope.size", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_ID = "messaging.message.id", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_RECEIVE_LATENCY = "messaging.message.receive.latency", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_RETRY_COUNT = "messaging.message.retry.count", $8b11dd70aaca6dbd$var$MESSAGING_OPERATION_NAME = "messaging.operation.name", $8b11dd70aaca6dbd$var$MESSAGING_OPERATION_TYPE = "messaging.operation.type", $8b11dd70aaca6dbd$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY = "messaging.rabbitmq.destination.routing_key", $8b11dd70aaca6dbd$var$MESSAGING_SYSTEM = "messaging.system", $8b11dd70aaca6dbd$var$METHOD = "method", $8b11dd70aaca6dbd$var$MIDDLEWARE_NAME = "middleware.name", $8b11dd70aaca6dbd$var$NAVIGATION_ORIGIN = "navigation.origin", $8b11dd70aaca6dbd$var$NAVIGATION_ROUTE_ID = "navigation.route.id", $8b11dd70aaca6dbd$var$NAVIGATION_TYPE = "navigation.type", $8b11dd70aaca6dbd$var$NEL_ELAPSED_TIME = "nel.elapsed_time", $8b11dd70aaca6dbd$var$NEL_PHASE = "nel.phase", $8b11dd70aaca6dbd$var$NEL_REFERRER = "nel.referrer", $8b11dd70aaca6dbd$var$NEL_SAMPLING_FUNCTION = "nel.sampling_function", $8b11dd70aaca6dbd$var$NEL_TYPE = "nel.type", $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_EFFECTIVE_TYPE = "network.connection.effective_type", $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_RTT = "network.connection.rtt", $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_TYPE = "network.connection.type", $8b11dd70aaca6dbd$var$NETWORK_LOCAL_ADDRESS = "network.local.address", $8b11dd70aaca6dbd$var$NETWORK_LOCAL_PORT = "network.local.port", $8b11dd70aaca6dbd$var$NETWORK_PEER_ADDRESS = "network.peer.address", $8b11dd70aaca6dbd$var$NETWORK_PEER_PORT = "network.peer.port", $8b11dd70aaca6dbd$var$NETWORK_PROTOCOL_NAME = "network.protocol.name", $8b11dd70aaca6dbd$var$NETWORK_PROTOCOL_VERSION = "network.protocol.version", $8b11dd70aaca6dbd$var$NETWORK_TRANSPORT = "network.transport", $8b11dd70aaca6dbd$var$NETWORK_TYPE = "network.type", $8b11dd70aaca6dbd$var$NET_HOST_IP = "net.host.ip", $8b11dd70aaca6dbd$var$NET_HOST_NAME = "net.host.name", $8b11dd70aaca6dbd$var$NET_HOST_PORT = "net.host.port", $8b11dd70aaca6dbd$var$NET_PEER_IP = "net.peer.ip", $8b11dd70aaca6dbd$var$NET_PEER_NAME = "net.peer.name", $8b11dd70aaca6dbd$var$NET_PEER_PORT = "net.peer.port", $8b11dd70aaca6dbd$var$NET_PROTOCOL_NAME = "net.protocol.name", $8b11dd70aaca6dbd$var$NET_PROTOCOL_VERSION = "net.protocol.version", $8b11dd70aaca6dbd$var$NET_SOCK_FAMILY = "net.sock.family", $8b11dd70aaca6dbd$var$NET_SOCK_HOST_ADDR = "net.sock.host.addr", $8b11dd70aaca6dbd$var$NET_SOCK_HOST_PORT = "net.sock.host.port", $8b11dd70aaca6dbd$var$NET_SOCK_PEER_ADDR = "net.sock.peer.addr", $8b11dd70aaca6dbd$var$NET_SOCK_PEER_NAME = "net.sock.peer.name", $8b11dd70aaca6dbd$var$NET_SOCK_PEER_PORT = "net.sock.peer.port", $8b11dd70aaca6dbd$var$NET_TRANSPORT = "net.transport", $8b11dd70aaca6dbd$var$OS_BUILD = "os.build", $8b11dd70aaca6dbd$var$OS_BUILD_ID = "os.build_id", $8b11dd70aaca6dbd$var$OS_DESCRIPTION = "os.description", $8b11dd70aaca6dbd$var$OS_KERNEL_VERSION = "os.kernel_version", $8b11dd70aaca6dbd$var$OS_NAME = "os.name", $8b11dd70aaca6dbd$var$OS_RAW_DESCRIPTION = "os.raw_description", $8b11dd70aaca6dbd$var$OS_ROOTED = "os.rooted", $8b11dd70aaca6dbd$var$OS_THEME = "os.theme", $8b11dd70aaca6dbd$var$OS_TYPE = "os.type", $8b11dd70aaca6dbd$var$OS_VERSION = "os.version", $8b11dd70aaca6dbd$var$OTEL_KIND = "otel.kind", $8b11dd70aaca6dbd$var$OTEL_SCOPE_NAME = "otel.scope.name", $8b11dd70aaca6dbd$var$OTEL_SCOPE_VERSION = "otel.scope.version", $8b11dd70aaca6dbd$var$OTEL_STATUS_CODE = "otel.status_code", $8b11dd70aaca6dbd$var$OTEL_STATUS_DESCRIPTION = "otel.status_description", $8b11dd70aaca6dbd$var$PARAMS_KEY = "params.<key>", $8b11dd70aaca6dbd$var$PARAMS_KEY_BASE = "params", $8b11dd70aaca6dbd$var$PERFORMANCE_ACTIVATIONSTART = "performance.activationStart", $8b11dd70aaca6dbd$var$PERFORMANCE_TIMEORIGIN = "performance.timeOrigin", $8b11dd70aaca6dbd$var$PREVIOUS_ROUTE = "previous_route", $8b11dd70aaca6dbd$var$PROCESS_COMMAND_ARGS = "process.command_args", $8b11dd70aaca6dbd$var$PROCESS_EXECUTABLE_NAME = "process.executable.name", $8b11dd70aaca6dbd$var$PROCESS_PID = "process.pid", $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_DESCRIPTION = "process.runtime.description", $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_ENGINE_NAME = "process.runtime.engine.name", $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_ENGINE_VERSION = "process.runtime.engine.version", $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_NAME = "process.runtime.name", $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_VERSION = "process.runtime.version", $8b11dd70aaca6dbd$var$QUERY_KEY = "query.<key>", $8b11dd70aaca6dbd$var$QUERY_KEY_BASE = "query", $8b11dd70aaca6dbd$var$REACT_VERSION = "react.version", $8b11dd70aaca6dbd$var$RELEASE = "release", $8b11dd70aaca6dbd$var$REMIX_ACTION_FORM_DATA_KEY = "remix.action_form_data.<key>", $8b11dd70aaca6dbd$var$REMIX_ACTION_FORM_DATA_KEY_BASE = "remix.action_form_data", $8b11dd70aaca6dbd$var$REPLAY_ID = "replay_id", $8b11dd70aaca6dbd$var$RESOURCE_DEPLOYMENT_ENVIRONMENT = "resource.deployment.environment", $8b11dd70aaca6dbd$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME = "resource.deployment.environment.name", $8b11dd70aaca6dbd$var$RESOURCE_RENDER_BLOCKING_STATUS = "resource.render_blocking_status", $8b11dd70aaca6dbd$var$ROUTE = "route", $8b11dd70aaca6dbd$var$RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code", $8b11dd70aaca6dbd$var$RPC_METHOD = "rpc.method", $8b11dd70aaca6dbd$var$RPC_RESPONSE_STATUS_CODE = "rpc.response.status_code", $8b11dd70aaca6dbd$var$RPC_SERVICE = "rpc.service", $8b11dd70aaca6dbd$var$RPC_SYSTEM = "rpc.system", $8b11dd70aaca6dbd$var$RPC_SYSTEM_NAME = "rpc.system.name", $8b11dd70aaca6dbd$var$RUNTIME_BUILD = "runtime.build", $8b11dd70aaca6dbd$var$RUNTIME_NAME = "runtime.name", $8b11dd70aaca6dbd$var$RUNTIME_RAW_DESCRIPTION = "runtime.raw_description", $8b11dd70aaca6dbd$var$RUNTIME_VERSION = "runtime.version", $8b11dd70aaca6dbd$var$SCORE_KEY = "score.<key>", $8b11dd70aaca6dbd$var$SCORE_KEY_BASE = "score", $8b11dd70aaca6dbd$var$SCORE_RATIO_KEY = "score.ratio.<key>", $8b11dd70aaca6dbd$var$SCORE_RATIO_KEY_BASE = "score.ratio", $8b11dd70aaca6dbd$var$SCORE_TOTAL = "score.total", $8b11dd70aaca6dbd$var$SCORE_WEIGHT_KEY = "score.weight.<key>", $8b11dd70aaca6dbd$var$SCORE_WEIGHT_KEY_BASE = "score.weight", $8b11dd70aaca6dbd$var$SENTRY_ACTION = "sentry.action", $8b11dd70aaca6dbd$var$SENTRY_BROWSER_NAME = "sentry.browser.name", $8b11dd70aaca6dbd$var$SENTRY_BROWSER_VERSION = "sentry.browser.version", $8b11dd70aaca6dbd$var$SENTRY_CANCELLATION_REASON = "sentry.cancellation_reason", $8b11dd70aaca6dbd$var$SENTRY_CATEGORY = "sentry.category", $8b11dd70aaca6dbd$var$SENTRY_CLIENT_SAMPLE_RATE = "sentry.client_sample_rate", $8b11dd70aaca6dbd$var$SENTRY_DESCRIPTION = "sentry.description", $8b11dd70aaca6dbd$var$SENTRY_DIST = "sentry.dist", $8b11dd70aaca6dbd$var$SENTRY_DOMAIN = "sentry.domain", $8b11dd70aaca6dbd$var$SENTRY_DSC_ENVIRONMENT = "sentry.dsc.environment", $8b11dd70aaca6dbd$var$SENTRY_DSC_PROJECT_ID = "sentry.dsc.project_id", $8b11dd70aaca6dbd$var$SENTRY_DSC_PUBLIC_KEY = "sentry.dsc.public_key", $8b11dd70aaca6dbd$var$SENTRY_DSC_RELEASE = "sentry.dsc.release", $8b11dd70aaca6dbd$var$SENTRY_DSC_SAMPLED = "sentry.dsc.sampled", $8b11dd70aaca6dbd$var$SENTRY_DSC_SAMPLE_RATE = "sentry.dsc.sample_rate", $8b11dd70aaca6dbd$var$SENTRY_DSC_TRACE_ID = "sentry.dsc.trace_id", $8b11dd70aaca6dbd$var$SENTRY_DSC_TRANSACTION = "sentry.dsc.transaction", $8b11dd70aaca6dbd$var$SENTRY_ENVIRONMENT = "sentry.environment", $8b11dd70aaca6dbd$var$SENTRY_EXCLUSIVE_TIME = "sentry.exclusive_time", $8b11dd70aaca6dbd$var$SENTRY_GRAPHQL_OPERATION = "sentry.graphql.operation", $8b11dd70aaca6dbd$var$SENTRY_GROUP = "sentry.group", $8b11dd70aaca6dbd$var$SENTRY_HTTP_PREFETCH = "sentry.http.prefetch", $8b11dd70aaca6dbd$var$SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason", $8b11dd70aaca6dbd$var$SENTRY_IS_REMOTE = "sentry.is_remote", $8b11dd70aaca6dbd$var$SENTRY_KIND = "sentry.kind", $8b11dd70aaca6dbd$var$SENTRY_MAIN_THREAD = "sentry.main_thread", $8b11dd70aaca6dbd$var$SENTRY_MESSAGE_PARAMETER_KEY = "sentry.message.parameter.<key>", $8b11dd70aaca6dbd$var$SENTRY_MESSAGE_TEMPLATE = "sentry.message.template", $8b11dd70aaca6dbd$var$SENTRY_METRIC_SOURCE = "sentry.metric.source", $8b11dd70aaca6dbd$var$SENTRY_MOBILE = "sentry.mobile", $8b11dd70aaca6dbd$var$SENTRY_MODULE_KEY = "sentry.module.<key>", $8b11dd70aaca6dbd$var$SENTRY_MODULE_KEY_BASE = "sentry.module", $8b11dd70aaca6dbd$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE = "sentry.nextjs.ssr.function.route", $8b11dd70aaca6dbd$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE = "sentry.nextjs.ssr.function.type", $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DB_QUERY = "sentry.normalized_db_query", $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DB_QUERY_HASH = "sentry.normalized_db_query.hash", $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DESCRIPTION = "sentry.normalized_description", $8b11dd70aaca6dbd$var$SENTRY_OBSERVED_TIMESTAMP_NANOS = "sentry.observed_timestamp_nanos", $8b11dd70aaca6dbd$var$SENTRY_OP = "sentry.op", $8b11dd70aaca6dbd$var$SENTRY_ORIGIN = "sentry.origin", $8b11dd70aaca6dbd$var$SENTRY_PLATFORM = "sentry.platform", $8b11dd70aaca6dbd$var$SENTRY_PROFILER_ID = "sentry.profiler_id", $8b11dd70aaca6dbd$var$SENTRY_PROFILE_ID = "sentry.profile_id", $8b11dd70aaca6dbd$var$SENTRY_RELEASE = "sentry.release", $8b11dd70aaca6dbd$var$SENTRY_REPLAY_ID = "sentry.replay_id", $8b11dd70aaca6dbd$var$SENTRY_REPLAY_IS_BUFFERING = "sentry.replay_is_buffering", $8b11dd70aaca6dbd$var$SENTRY_REPORT_EVENT = "sentry.report_event", $8b11dd70aaca6dbd$var$SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations", $8b11dd70aaca6dbd$var$SENTRY_SDK_NAME = "sentry.sdk.name", $8b11dd70aaca6dbd$var$SENTRY_SDK_VERSION = "sentry.sdk.version", $8b11dd70aaca6dbd$var$SENTRY_SEGMENT_ID = "sentry.segment.id", $8b11dd70aaca6dbd$var$_SENTRY_SEGMENT_ID = "sentry.segment_id", $8b11dd70aaca6dbd$var$SENTRY_SEGMENT_NAME = "sentry.segment.name", $8b11dd70aaca6dbd$var$SENTRY_SERVER_SAMPLE_RATE = "sentry.server_sample_rate", $8b11dd70aaca6dbd$var$SENTRY_SOURCE = "sentry.source", $8b11dd70aaca6dbd$var$SENTRY_SPAN_SOURCE = "sentry.span.source", $8b11dd70aaca6dbd$var$SENTRY_STATUS = "sentry.status", $8b11dd70aaca6dbd$var$SENTRY_STATUS_CODE = "sentry.status_code", $8b11dd70aaca6dbd$var$SENTRY_STATUS_MESSAGE = "sentry.status.message", $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_FROM = "sentry.sveltekit.navigation.from", $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_TO = "sentry.sveltekit.navigation.to", $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE = "sentry.sveltekit.navigation.type", $8b11dd70aaca6dbd$var$SENTRY_THREAD_ID = "sentry.thread.id", $8b11dd70aaca6dbd$var$SENTRY_TIMESTAMP_SEQUENCE = "sentry.timestamp.sequence", $8b11dd70aaca6dbd$var$SENTRY_TRACE_LIFECYCLE = "sentry.trace_lifecycle", $8b11dd70aaca6dbd$var$SENTRY_TRACE_PARENT_SPAN_ID = "sentry.trace.parent_span_id", $8b11dd70aaca6dbd$var$SENTRY_TRACE_STATUS = "sentry.trace.status", $8b11dd70aaca6dbd$var$SENTRY_TRANSACTION = "sentry.transaction", $8b11dd70aaca6dbd$var$SENTRY_USER_EMAIL = "sentry.user.email", $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_CITY = "sentry.user.geo.city", $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_COUNTRY_CODE = "sentry.user.geo.country_code", $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_REGION = "sentry.user.geo.region", $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_SUBDIVISION = "sentry.user.geo.subdivision", $8b11dd70aaca6dbd$var$SENTRY_USER_ID = "sentry.user.id", $8b11dd70aaca6dbd$var$SENTRY_USER_IP = "sentry.user.ip", $8b11dd70aaca6dbd$var$SENTRY_USER_USERNAME = "sentry.user.username", $8b11dd70aaca6dbd$var$SERVER_ADDRESS = "server.address", $8b11dd70aaca6dbd$var$SERVER_NAME = "server_name", $8b11dd70aaca6dbd$var$SERVER_PORT = "server.port", $8b11dd70aaca6dbd$var$SERVICE_NAME = "service.name", $8b11dd70aaca6dbd$var$SERVICE_VERSION = "service.version", $8b11dd70aaca6dbd$var$SESSION_ID = "session.id", $8b11dd70aaca6dbd$var$STALL_PERCENTAGE = "stall_percentage", $8b11dd70aaca6dbd$var$STALL_TOTAL_TIME = "stall_total_time", $8b11dd70aaca6dbd$var$STATE_TYPE = "state.type", $8b11dd70aaca6dbd$var$THREAD_ID = "thread.id", $8b11dd70aaca6dbd$var$THREAD_NAME = "thread.name", $8b11dd70aaca6dbd$var$TIMBER_TAG = "timber.tag", $8b11dd70aaca6dbd$var$TIME_TO_FULL_DISPLAY = "time_to_full_display", $8b11dd70aaca6dbd$var$TIME_TO_INITIAL_DISPLAY = "time_to_initial_display", $8b11dd70aaca6dbd$var$TRANSACTION = "transaction", $8b11dd70aaca6dbd$var$TRPC_PROCEDURE_PATH = "trpc.procedure_path", $8b11dd70aaca6dbd$var$TRPC_PROCEDURE_TYPE = "trpc.procedure_type", $8b11dd70aaca6dbd$var$TTFB = "ttfb", $8b11dd70aaca6dbd$var$TTFB_REQUESTTIME = "ttfb.requestTime", $8b11dd70aaca6dbd$var$TYPE = "type", $8b11dd70aaca6dbd$var$UI_COMPONENT_NAME = "ui.component_name", $8b11dd70aaca6dbd$var$UI_CONTRIBUTES_TO_TTFD = "ui.contributes_to_ttfd", $8b11dd70aaca6dbd$var$UI_CONTRIBUTES_TO_TTID = "ui.contributes_to_ttid", $8b11dd70aaca6dbd$var$UI_ELEMENT_HEIGHT = "ui.element.height", $8b11dd70aaca6dbd$var$UI_ELEMENT_ID = "ui.element.id", $8b11dd70aaca6dbd$var$UI_ELEMENT_IDENTIFIER = "ui.element.identifier", $8b11dd70aaca6dbd$var$UI_ELEMENT_LOAD_TIME = "ui.element.load_time", $8b11dd70aaca6dbd$var$UI_ELEMENT_PAINT_TYPE = "ui.element.paint_type", $8b11dd70aaca6dbd$var$UI_ELEMENT_RENDER_TIME = "ui.element.render_time", $8b11dd70aaca6dbd$var$UI_ELEMENT_TYPE = "ui.element.type", $8b11dd70aaca6dbd$var$UI_ELEMENT_URL = "ui.element.url", $8b11dd70aaca6dbd$var$UI_ELEMENT_WIDTH = "ui.element.width", $8b11dd70aaca6dbd$var$URL = "url", $8b11dd70aaca6dbd$var$URL_DOMAIN = "url.domain", $8b11dd70aaca6dbd$var$URL_FRAGMENT = "url.fragment", $8b11dd70aaca6dbd$var$URL_FULL = "url.full", $8b11dd70aaca6dbd$var$URL_PATH = "url.path", $8b11dd70aaca6dbd$var$URL_PATH_PARAMETER_KEY = "url.path.parameter.<key>", $8b11dd70aaca6dbd$var$URL_PATH_PARAMETER_KEY_BASE = "url.path.parameter", $8b11dd70aaca6dbd$var$URL_PORT = "url.port", $8b11dd70aaca6dbd$var$URL_QUERY = "url.query", $8b11dd70aaca6dbd$var$URL_SAME_ORIGIN = "url.same_origin", $8b11dd70aaca6dbd$var$URL_SCHEME = "url.scheme", $8b11dd70aaca6dbd$var$URL_TEMPLATE = "url.template", $8b11dd70aaca6dbd$var$USER_AGENT_ORIGINAL = "user_agent.original", $8b11dd70aaca6dbd$var$USER_EMAIL = "user.email", $8b11dd70aaca6dbd$var$USER_FULL_NAME = "user.full_name", $8b11dd70aaca6dbd$var$USER_GEO_CITY = "user.geo.city", $8b11dd70aaca6dbd$var$USER_GEO_COUNTRY_CODE = "user.geo.country_code", $8b11dd70aaca6dbd$var$USER_GEO_REGION = "user.geo.region", $8b11dd70aaca6dbd$var$USER_GEO_SUBDIVISION = "user.geo.subdivision", $8b11dd70aaca6dbd$var$USER_HASH = "user.hash", $8b11dd70aaca6dbd$var$USER_ID = "user.id", $8b11dd70aaca6dbd$var$USER_IP_ADDRESS = "user.ip_address", $8b11dd70aaca6dbd$var$USER_NAME = "user.name", $8b11dd70aaca6dbd$var$USER_ROLES = "user.roles", $8b11dd70aaca6dbd$var$VERCEL_BRANCH = "vercel.branch", $8b11dd70aaca6dbd$var$VERCEL_BUILD_ID = "vercel.build_id", $8b11dd70aaca6dbd$var$VERCEL_DEPLOYMENT_ID = "vercel.deployment_id", $8b11dd70aaca6dbd$var$VERCEL_DESTINATION = "vercel.destination", $8b11dd70aaca6dbd$var$VERCEL_EDGE_TYPE = "vercel.edge_type", $8b11dd70aaca6dbd$var$VERCEL_ENTRYPOINT = "vercel.entrypoint", $8b11dd70aaca6dbd$var$VERCEL_EXECUTION_REGION = "vercel.execution_region", $8b11dd70aaca6dbd$var$VERCEL_ID = "vercel.id", $8b11dd70aaca6dbd$var$VERCEL_JA3_DIGEST = "vercel.ja3_digest", $8b11dd70aaca6dbd$var$VERCEL_JA4_DIGEST = "vercel.ja4_digest", $8b11dd70aaca6dbd$var$VERCEL_LOG_TYPE = "vercel.log_type", $8b11dd70aaca6dbd$var$VERCEL_PATH = "vercel.path", $8b11dd70aaca6dbd$var$VERCEL_PROJECT_ID = "vercel.project_id", $8b11dd70aaca6dbd$var$VERCEL_PROJECT_NAME = "vercel.project_name", $8b11dd70aaca6dbd$var$VERCEL_PROXY_CACHE_ID = "vercel.proxy.cache_id", $8b11dd70aaca6dbd$var$VERCEL_PROXY_CLIENT_IP = "vercel.proxy.client_ip", $8b11dd70aaca6dbd$var$VERCEL_PROXY_HOST = "vercel.proxy.host", $8b11dd70aaca6dbd$var$VERCEL_PROXY_LAMBDA_REGION = "vercel.proxy.lambda_region", $8b11dd70aaca6dbd$var$VERCEL_PROXY_METHOD = "vercel.proxy.method", $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH = "vercel.proxy.path", $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH_TYPE = "vercel.proxy.path_type", $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH_TYPE_VARIANT = "vercel.proxy.path_type_variant", $8b11dd70aaca6dbd$var$VERCEL_PROXY_REFERER = "vercel.proxy.referer", $8b11dd70aaca6dbd$var$VERCEL_PROXY_REGION = "vercel.proxy.region", $8b11dd70aaca6dbd$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE = "vercel.proxy.response_byte_size", $8b11dd70aaca6dbd$var$VERCEL_PROXY_SCHEME = "vercel.proxy.scheme", $8b11dd70aaca6dbd$var$VERCEL_PROXY_STATUS_CODE = "vercel.proxy.status_code", $8b11dd70aaca6dbd$var$VERCEL_PROXY_TIMESTAMP = "vercel.proxy.timestamp", $8b11dd70aaca6dbd$var$VERCEL_PROXY_USER_AGENT = "vercel.proxy.user_agent", $8b11dd70aaca6dbd$var$VERCEL_PROXY_VERCEL_CACHE = "vercel.proxy.vercel_cache", $8b11dd70aaca6dbd$var$VERCEL_PROXY_VERCEL_ID = "vercel.proxy.vercel_id", $8b11dd70aaca6dbd$var$VERCEL_PROXY_WAF_ACTION = "vercel.proxy.waf_action", $8b11dd70aaca6dbd$var$VERCEL_PROXY_WAF_RULE_ID = "vercel.proxy.waf_rule_id", $8b11dd70aaca6dbd$var$VERCEL_REQUEST_ID = "vercel.request_id", $8b11dd70aaca6dbd$var$VERCEL_SOURCE = "vercel.source", $8b11dd70aaca6dbd$var$VERCEL_STATUS_CODE = "vercel.status_code", $8b11dd70aaca6dbd$var$ATTRIBUTE_TYPE = {
    "ai.citations": "string[]",
    "ai.completion_tokens.used": "integer",
    "ai.documents": "string[]",
    "ai.finish_reason": "string",
    "ai.frequency_penalty": "double",
    "ai.function_call": "string",
    "ai.generation_id": "string",
    "ai.input_messages": "string",
    "ai.is_search_required": "boolean",
    "ai.metadata": "string",
    "ai.model_id": "string",
    "ai.model.provider": "string",
    "ai.pipeline.name": "string",
    "ai.preamble": "string",
    "ai.presence_penalty": "double",
    "ai.prompt_tokens.used": "integer",
    "ai.raw_prompting": "boolean",
    "ai.responses": "string[]",
    "ai.response_format": "string",
    "ai.search_queries": "string[]",
    "ai.search_results": "string[]",
    "ai.seed": "string",
    "ai.streaming": "boolean",
    "ai.tags": "string",
    "ai.temperature": "double",
    "ai.texts": "string[]",
    "ai.tools": "string[]",
    "ai.tool_calls": "string[]",
    "ai.top_k": "integer",
    "ai.top_p": "double",
    "ai.total_cost": "double",
    "ai.total_tokens.used": "integer",
    "ai.warnings": "string[]",
    "angular.version": "string",
    "app.app_build": "string",
    "app.app_identifier": "string",
    "app.app_name": "string",
    "app.app_start_time": "string",
    "app.app_version": "string",
    "app.build": "string",
    "app.identifier": "string",
    "app.in_foreground": "boolean",
    "app.name": "string",
    app_start_cold: "double",
    "app.start_time": "string",
    app_start_type: "string",
    app_start_warm: "double",
    "app.version": "string",
    "app.vitals.frames.delay.value": "integer",
    "app.vitals.frames.frozen.count": "integer",
    "app.vitals.frames.slow.count": "integer",
    "app.vitals.frames.total.count": "integer",
    "app.vitals.start.cold.value": "double",
    "app.vitals.start.prewarmed": "boolean",
    "app.vitals.start.reason": "string",
    "app.vitals.start.screen": "string",
    "app.vitals.start.type": "string",
    "app.vitals.start.warm.value": "double",
    "app.vitals.ttfd.value": "double",
    "app.vitals.ttid.value": "double",
    "art.gc.blocking_count": "integer",
    "art.gc.blocking_time": "double",
    "art.gc.pre_oome_count": "integer",
    "art.gc.total_count": "integer",
    "art.gc.total_time": "double",
    "art.gc.waiting_time": "double",
    "art.memory.free": "integer",
    "art.memory.free_until_gc": "integer",
    "art.memory.free_until_oome": "integer",
    "art.memory.max": "integer",
    "art.memory.total": "integer",
    "aws.cloudwatch.logs.log_group": "string",
    "aws.cloudwatch.logs.log_stream": "string",
    "aws.cloudwatch.logs.url": "string",
    "aws.dynamodb.attribute_definitions": "string[]",
    "aws.dynamodb.consistent_read": "boolean",
    "aws.dynamodb.consumed_capacity": "string[]",
    "aws.dynamodb.count": "integer",
    "aws.dynamodb.exclusive_start_table": "string",
    "aws.dynamodb.global_secondary_indexes": "string[]",
    "aws.dynamodb.global_secondary_index_updates": "string[]",
    "aws.dynamodb.index_name": "string",
    "aws.dynamodb.item_collection_metrics": "string",
    "aws.dynamodb.limit": "integer",
    "aws.dynamodb.local_secondary_indexes": "string[]",
    "aws.dynamodb.projection": "string",
    "aws.dynamodb.provisioned_read_capacity": "double",
    "aws.dynamodb.provisioned_write_capacity": "double",
    "aws.dynamodb.scanned_count": "integer",
    "aws.dynamodb.scan_forward": "boolean",
    "aws.dynamodb.segment": "integer",
    "aws.dynamodb.select": "string",
    "aws.dynamodb.table_count": "integer",
    "aws.dynamodb.table_names": "string[]",
    "aws.dynamodb.total_segments": "integer",
    "aws.extended_request_id": "string",
    "aws.kinesis.stream_name": "string",
    "aws.kinesis.stream.name": "string",
    "aws.lambda.aws_request_id": "string",
    "aws.lambda.execution_duration_in_millis": "double",
    "aws.lambda.function_name": "string",
    "aws.lambda.function_version": "string",
    "aws.lambda.invoked_arn": "string",
    "aws.lambda.invoked_function_arn": "string",
    "aws.lambda.remaining_time_in_millis": "double",
    "aws.log.group.names": "string[]",
    "aws.log.stream.names": "string[]",
    "aws.request.extended_id": "string",
    "aws.request_id": "string",
    "aws.request.id": "string",
    "aws.s3.bucket": "string",
    "aws.secretsmanager.secret.arn": "string",
    "aws.sns.topic.arn": "string",
    "aws.step_functions.activity.arn": "string",
    "aws.step_functions.state_machine.arn": "string",
    blocked_main_thread: "boolean",
    "browser.name": "string",
    "browser.performance.navigation.activation_start": "double",
    "browser.performance.time_origin": "double",
    "browser.report.type": "string",
    "browser.script.invoker": "string",
    "browser.script.invoker_type": "string",
    "browser.script.source_char_position": "integer",
    "browser.version": "string",
    "browser.web_vital.cls.report_event": "string",
    "browser.web_vital.cls.source.<key>": "string",
    "browser.web_vital.cls.value": "double",
    "browser.web_vital.fcp.value": "double",
    "browser.web_vital.fp.value": "double",
    "browser.web_vital.inp.value": "double",
    "browser.web_vital.lcp.element": "string",
    "browser.web_vital.lcp.id": "string",
    "browser.web_vital.lcp.load_time": "integer",
    "browser.web_vital.lcp.render_time": "integer",
    "browser.web_vital.lcp.report_event": "string",
    "browser.web_vital.lcp.size": "integer",
    "browser.web_vital.lcp.url": "string",
    "browser.web_vital.lcp.value": "double",
    "browser.web_vital.ttfb.request_time": "double",
    "browser.web_vital.ttfb.value": "double",
    "cache.hit": "boolean",
    "cache.item_size": "integer",
    "cache.key": "string[]",
    "cache.operation": "string",
    "cache.ttl": "integer",
    "cache.write": "boolean",
    channel: "string",
    "client.address": "string",
    "client.port": "integer",
    "cloudflare.d1.duration": "integer",
    "cloudflare.d1.query_type": "string",
    "cloudflare.d1.rows_read": "integer",
    "cloudflare.d1.rows_written": "integer",
    "cloudflare.durable_object.query.bindings": "integer",
    "cloudflare.durable_object.response.rows_read": "integer",
    "cloudflare.durable_object.response.rows_written": "integer",
    "cloudflare.r2.bucket": "string",
    "cloudflare.r2.operation": "string",
    "cloudflare.r2.request.delimiter": "string",
    "cloudflare.r2.request.key": "string",
    "cloudflare.r2.request.part_number": "integer",
    "cloudflare.r2.request.prefix": "string",
    "cloudflare.workflow.attempt": "integer",
    "cloudflare.workflow.retries.backoff": "string",
    "cloudflare.workflow.retries.delay": "string",
    "cloudflare.workflow.retries.limit": "integer",
    "cloudflare.workflow.timeout": "string",
    "cloud.account.id": "string",
    "cloud.availability_zone": "string",
    "cloud.platform": "string",
    "cloud.provider": "string",
    "cloud.region": "string",
    "cloud.resource_id": "string",
    cls: "double",
    "cls.source.<key>": "string",
    "code.filepath": "string",
    "code.file.path": "string",
    "code.function": "string",
    "code.function.name": "string",
    "code.lineno": "integer",
    "code.line.number": "integer",
    "code.namespace": "string",
    connectionType: "string",
    "connection.rtt": "integer",
    "culture.calendar": "string",
    "culture.display_name": "string",
    "culture.is_24_hour_format": "boolean",
    "culture.locale": "string",
    "culture.timezone": "string",
    "db.collection.name": "string",
    "db.driver.name": "string",
    "db.name": "string",
    "db.namespace": "string",
    "db.operation": "string",
    "db.operation.batch.size": "integer",
    "db.operation.name": "string",
    "db.query.parameter.<key>": "string",
    "db.query.summary": "string",
    "db.query.text": "string",
    "db.redis.connection": "string",
    "db.redis.key": "string",
    "db.redis.parameters": "string[]",
    "db.response.status_code": "string",
    "db.sql.bindings": "string[]",
    "db.statement": "string",
    "db.stored_procedure.name": "string",
    "db.system": "string",
    "db.system.name": "string",
    "db.user": "string",
    deviceMemory: "string",
    "device.archs": "string[]",
    "device.battery_level": "double",
    "device.battery_temperature": "double",
    "device.boot_time": "string",
    "device.brand": "string",
    "device.charging": "boolean",
    "device.chipset": "string",
    "device.class": "string",
    "device.connection_type": "string",
    "device.cpu_description": "string",
    "device.external_free_storage": "integer",
    "device.external_storage_size": "integer",
    "device.family": "string",
    "device.free_memory": "integer",
    "device.free_storage": "integer",
    "device.id": "string",
    "device.locale": "string",
    "device.low_memory": "boolean",
    "device.low_power_mode": "boolean",
    "device.manufacturer": "string",
    "device.memory.estimated_capacity": "integer",
    "device.memory_size": "integer",
    "device.model": "string",
    "device.model_id": "string",
    "device.name": "string",
    "device.online": "boolean",
    "device.orientation": "string",
    "device.processor_count": "integer",
    "device.processor_frequency": "double",
    "device.screen_density": "double",
    "device.screen_dpi": "integer",
    "device.screen_height_pixels": "integer",
    "device.screen_width_pixels": "integer",
    "device.simulator": "boolean",
    "device.storage_size": "integer",
    "device.thermal_state": "string",
    "device.timezone": "string",
    "device.usable_memory": "integer",
    dist: "string",
    effectiveConnectionType: "string",
    environment: "string",
    "error.type": "string",
    "event.id": "integer",
    "event.name": "string",
    "exception.escaped": "boolean",
    "exception.message": "string",
    "exception.stacktrace": "string",
    "exception.type": "string",
    "faas.coldstart": "boolean",
    "faas.cron": "string",
    "faas.duration_in_ms": "integer",
    "faas.entry_point": "string",
    "faas.execution": "string",
    "faas.id": "string",
    "faas.identity": "string",
    "faas.invocation_id": "string",
    "faas.invoked_name": "string",
    "faas.invoked_provider": "string",
    "faas.invoked_region": "string",
    "faas.name": "string",
    "faas.time": "string",
    "faas.trigger": "string",
    "faas.version": "string",
    fcp: "double",
    "flag.evaluation.<key>": "boolean",
    fp: "double",
    "frames.delay": "integer",
    "frames.frozen": "integer",
    frames_frozen_rate: "double",
    "frames.slow": "integer",
    frames_slow_rate: "double",
    "frames.total": "integer",
    fs_error: "string",
    "gcp.function.context.event_id": "string",
    "gcp.function.context.event_type": "string",
    "gcp.function.context.id": "string",
    "gcp.function.context.resource": "string",
    "gcp.function.context.source": "string",
    "gcp.function.context.specversion": "string",
    "gcp.function.context.time": "string",
    "gcp.function.context.timestamp": "string",
    "gcp.function.context.type": "string",
    "gcp.project.id": "string",
    "gen_ai.agent.name": "string",
    "gen_ai.context.utilization": "double",
    "gen_ai.context.window_size": "integer",
    "gen_ai.conversation.id": "string",
    "gen_ai.cost.cache_creation.input_tokens": "double",
    "gen_ai.cost.cache_read.input_tokens": "double",
    "gen_ai.cost.input_tokens": "double",
    "gen_ai.cost.output_tokens": "double",
    "gen_ai.cost.reasoning.output_tokens": "double",
    "gen_ai.cost.total_tokens": "double",
    "gen_ai.embeddings.input": "string",
    "gen_ai.function_id": "string",
    "gen_ai.input.messages": "string",
    "gen_ai.operation.name": "string",
    "gen_ai.operation.type": "string",
    "gen_ai.output.messages": "string",
    "gen_ai.pipeline.name": "string",
    "gen_ai.prompt": "string",
    "gen_ai.prompt.name": "string",
    "gen_ai.provider.name": "string",
    "gen_ai.request.available_tools": "string",
    "gen_ai.request.frequency_penalty": "double",
    "gen_ai.request.max_tokens": "integer",
    "gen_ai.request.messages": "string",
    "gen_ai.request.model": "string",
    "gen_ai.request.presence_penalty": "double",
    "gen_ai.request.reasoning_effort": "string",
    "gen_ai.request.seed": "string",
    "gen_ai.request.stop_sequences": "string[]",
    "gen_ai.request.temperature": "double",
    "gen_ai.request.top_k": "integer",
    "gen_ai.request.top_p": "double",
    "gen_ai.response.finish_reasons": "string",
    "gen_ai.response.id": "string",
    "gen_ai.response.model": "string",
    "gen_ai.response.streaming": "boolean",
    "gen_ai.response.text": "string",
    "gen_ai.response.time_to_first_chunk": "double",
    "gen_ai.response.time_to_first_token": "double",
    "gen_ai.response.tokens_per_second": "double",
    "gen_ai.response.tool_calls": "string",
    "gen_ai.system": "string",
    "gen_ai.system_instructions": "string",
    "gen_ai.system.message": "string",
    "gen_ai.tool.call.arguments": "string",
    "gen_ai.tool.call.result": "string",
    "gen_ai.tool.definitions": "string",
    "gen_ai.tool.description": "string",
    "gen_ai.tool.input": "string",
    "gen_ai.tool.message": "string",
    "gen_ai.tool.name": "string",
    "gen_ai.tool.output": "string",
    "gen_ai.tool.type": "string",
    "gen_ai.usage.cache_creation.input_tokens": "integer",
    "gen_ai.usage.cache_read.input_tokens": "integer",
    "gen_ai.usage.completion_tokens": "integer",
    "gen_ai.usage.input_tokens": "integer",
    "gen_ai.usage.input_tokens.cached": "integer",
    "gen_ai.usage.input_tokens.cache_write": "integer",
    "gen_ai.usage.output_tokens": "integer",
    "gen_ai.usage.output_tokens.reasoning": "integer",
    "gen_ai.usage.prompt_tokens": "integer",
    "gen_ai.usage.reasoning.output_tokens": "integer",
    "gen_ai.usage.total_tokens": "integer",
    "graphql.document": "string",
    "graphql.operation.name": "string",
    "graphql.operation.type": "string",
    hardwareConcurrency: "string",
    "http.client_ip": "string",
    "http.decoded_response_content_length": "integer",
    "http.flavor": "string",
    "http.fragment": "string",
    "http.host": "string",
    "http.method": "string",
    "http.query": "string",
    "http.request.body.data": "string",
    "http.request.connection_end": "double",
    "http.request.connect_start": "double",
    "http.request.domain_lookup_end": "double",
    "http.request.domain_lookup_start": "double",
    "http.request.fetch_start": "double",
    "http.request.header.<key>": "string[]",
    "http.request.method": "string",
    "http.request_method": "string",
    "http.request.redirect_end": "double",
    "http.request.redirect_start": "double",
    "http.request.request_start": "double",
    "http.request.resend_count": "integer",
    "http.request.response_end": "double",
    "http.request.response_start": "double",
    "http.request.same_origin": "boolean",
    "http.request.secure_connection_start": "double",
    "http.request.time_to_first_byte": "double",
    "http.request.worker_start": "double",
    "http.response.body.size": "integer",
    "http.response_content_length": "integer",
    "http.response.header.content-length": "string",
    "http.response.header.<key>": "string[]",
    "http.response.size": "integer",
    "http.response.status_code": "integer",
    "http.response_transfer_size": "integer",
    "http.route": "string",
    "http.scheme": "string",
    "http.server_name": "string",
    "http.server.request.time_in_queue": "double",
    "http.status_code": "integer",
    "http.target": "string",
    "http.url": "string",
    "http.user_agent": "string",
    id: "string",
    inp: "double",
    "jsonrpc.protocol.version": "string",
    "jsonrpc.request.id": "string",
    "jvm.gc.action": "string",
    "jvm.gc.name": "string",
    "jvm.memory.pool.name": "string",
    "jvm.memory.type": "string",
    "jvm.thread.daemon": "boolean",
    "jvm.thread.state": "string",
    "koa.name": "string",
    "koa.type": "string",
    lcp: "double",
    "lcp.element": "string",
    "lcp.id": "string",
    "lcp.loadTime": "integer",
    "lcp.renderTime": "integer",
    "lcp.size": "integer",
    "lcp.url": "string",
    "logger.name": "string",
    "mcp.cancelled.reason": "string",
    "mcp.cancelled.request_id": "string",
    "mcp.client.name": "string",
    "mcp.client.title": "string",
    "mcp.client.version": "string",
    "mcp.lifecycle.phase": "string",
    "mcp.logging.data_type": "string",
    "mcp.logging.level": "string",
    "mcp.logging.logger": "string",
    "mcp.logging.message": "string",
    "mcp.method.name": "string",
    "mcp.progress.current": "integer",
    "mcp.progress.message": "string",
    "mcp.progress.percentage": "double",
    "mcp.progress.token": "string",
    "mcp.progress.total": "integer",
    "mcp.prompt.name": "string",
    "mcp.prompt.result.description": "string",
    "mcp.prompt.result.message_content": "string",
    "mcp.prompt.result.message_count": "integer",
    "mcp.prompt.result.message_role": "string",
    "mcp.protocol.ready": "integer",
    "mcp.protocol.version": "string",
    "mcp.request.argument.<key>": "string",
    "mcp.request.argument.name": "string",
    "mcp.request.argument.uri": "string",
    "mcp.request.id": "string",
    "mcp.resource.protocol": "string",
    "mcp.resource.uri": "string",
    "mcp.server.name": "string",
    "mcp.server.title": "string",
    "mcp.server.version": "string",
    "mcp.session.id": "string",
    "mcp.tool.name": "string",
    "mcp.tool.result.content": "string",
    "mcp.tool.result.content_count": "integer",
    "mcp.tool.result.is_error": "boolean",
    "mcp.transport": "string",
    "mdc.<key>": "string",
    "messaging.batch.message_count": "integer",
    "messaging.destination": "string",
    "messaging.destination.connection": "string",
    "messaging.destination.name": "string",
    "messaging.message.body.size": "integer",
    "messaging.message.conversation_id": "string",
    "messaging.message.envelope.size": "integer",
    "messaging.message.id": "string",
    "messaging.message.receive.latency": "integer",
    "messaging.message.retry.count": "integer",
    "messaging.operation.name": "string",
    "messaging.operation.type": "string",
    "messaging.rabbitmq.destination.routing_key": "string",
    "messaging.system": "string",
    method: "string",
    "middleware.name": "string",
    "navigation.origin": "string",
    "navigation.route.id": "string",
    "navigation.type": "string",
    "nel.elapsed_time": "integer",
    "nel.phase": "string",
    "nel.referrer": "string",
    "nel.sampling_function": "double",
    "nel.type": "string",
    "network.connection.effective_type": "string",
    "network.connection.rtt": "integer",
    "network.connection.type": "string",
    "network.local.address": "string",
    "network.local.port": "integer",
    "network.peer.address": "string",
    "network.peer.port": "integer",
    "network.protocol.name": "string",
    "network.protocol.version": "string",
    "network.transport": "string",
    "network.type": "string",
    "net.host.ip": "string",
    "net.host.name": "string",
    "net.host.port": "integer",
    "net.peer.ip": "string",
    "net.peer.name": "string",
    "net.peer.port": "integer",
    "net.protocol.name": "string",
    "net.protocol.version": "string",
    "net.sock.family": "string",
    "net.sock.host.addr": "string",
    "net.sock.host.port": "integer",
    "net.sock.peer.addr": "string",
    "net.sock.peer.name": "string",
    "net.sock.peer.port": "integer",
    "net.transport": "string",
    "os.build": "string",
    "os.build_id": "string",
    "os.description": "string",
    "os.kernel_version": "string",
    "os.name": "string",
    "os.raw_description": "string",
    "os.rooted": "boolean",
    "os.theme": "string",
    "os.type": "string",
    "os.version": "string",
    "otel.kind": "string",
    "otel.scope.name": "string",
    "otel.scope.version": "string",
    "otel.status_code": "string",
    "otel.status_description": "string",
    "params.<key>": "string",
    "performance.activationStart": "double",
    "performance.timeOrigin": "double",
    previous_route: "string",
    "process.command_args": "string[]",
    "process.executable.name": "string",
    "process.pid": "integer",
    "process.runtime.description": "string",
    "process.runtime.engine.name": "string",
    "process.runtime.engine.version": "string",
    "process.runtime.name": "string",
    "process.runtime.version": "string",
    "query.<key>": "string",
    "react.version": "string",
    release: "string",
    "remix.action_form_data.<key>": "string",
    replay_id: "string",
    "resource.deployment.environment": "string",
    "resource.deployment.environment.name": "string",
    "resource.render_blocking_status": "string",
    route: "string",
    "rpc.grpc.status_code": "integer",
    "rpc.method": "string",
    "rpc.response.status_code": "string",
    "rpc.service": "string",
    "rpc.system": "string",
    "rpc.system.name": "string",
    "runtime.build": "string",
    "runtime.name": "string",
    "runtime.raw_description": "string",
    "runtime.version": "string",
    "score.<key>": "double",
    "score.ratio.<key>": "double",
    "score.total": "double",
    "score.weight.<key>": "double",
    "sentry.action": "string",
    "sentry.browser.name": "string",
    "sentry.browser.version": "string",
    "sentry.cancellation_reason": "string",
    "sentry.category": "string",
    "sentry.client_sample_rate": "double",
    "sentry.description": "string",
    "sentry.dist": "string",
    "sentry.domain": "string",
    "sentry.dsc.environment": "string",
    "sentry.dsc.project_id": "string",
    "sentry.dsc.public_key": "string",
    "sentry.dsc.release": "string",
    "sentry.dsc.sampled": "boolean",
    "sentry.dsc.sample_rate": "string",
    "sentry.dsc.trace_id": "string",
    "sentry.dsc.transaction": "string",
    "sentry.environment": "string",
    "sentry.exclusive_time": "double",
    "sentry.graphql.operation": "string",
    "sentry.group": "string",
    "sentry.http.prefetch": "boolean",
    "sentry.idle_span_finish_reason": "string",
    "sentry.is_remote": "boolean",
    "sentry.kind": "string",
    "sentry.main_thread": "boolean",
    "sentry.message.parameter.<key>": "string",
    "sentry.message.template": "string",
    "sentry.metric.source": "string",
    "sentry.mobile": "boolean",
    "sentry.module.<key>": "string",
    "sentry.nextjs.ssr.function.route": "string",
    "sentry.nextjs.ssr.function.type": "string",
    "sentry.normalized_db_query": "string",
    "sentry.normalized_db_query.hash": "string",
    "sentry.normalized_description": "string",
    "sentry.observed_timestamp_nanos": "string",
    "sentry.op": "string",
    "sentry.origin": "string",
    "sentry.platform": "string",
    "sentry.profiler_id": "string",
    "sentry.profile_id": "string",
    "sentry.release": "string",
    "sentry.replay_id": "string",
    "sentry.replay_is_buffering": "boolean",
    "sentry.report_event": "string",
    "sentry.sdk.integrations": "string[]",
    "sentry.sdk.name": "string",
    "sentry.sdk.version": "string",
    "sentry.segment.id": "string",
    "sentry.segment_id": "string",
    "sentry.segment.name": "string",
    "sentry.server_sample_rate": "double",
    "sentry.source": "string",
    "sentry.span.source": "string",
    "sentry.status": "string",
    "sentry.status_code": "integer",
    "sentry.status.message": "string",
    "sentry.sveltekit.navigation.from": "string",
    "sentry.sveltekit.navigation.to": "string",
    "sentry.sveltekit.navigation.type": "string",
    "sentry.thread.id": "integer",
    "sentry.timestamp.sequence": "integer",
    "sentry.trace_lifecycle": "string",
    "sentry.trace.parent_span_id": "string",
    "sentry.trace.status": "string",
    "sentry.transaction": "string",
    "sentry.user.email": "string",
    "sentry.user.geo.city": "string",
    "sentry.user.geo.country_code": "string",
    "sentry.user.geo.region": "string",
    "sentry.user.geo.subdivision": "string",
    "sentry.user.id": "string",
    "sentry.user.ip": "string",
    "sentry.user.username": "string",
    "server.address": "string",
    server_name: "string",
    "server.port": "integer",
    "service.name": "string",
    "service.version": "string",
    "session.id": "string",
    stall_percentage: "double",
    stall_total_time: "double",
    "state.type": "string",
    "thread.id": "integer",
    "thread.name": "string",
    "timber.tag": "string",
    time_to_full_display: "double",
    time_to_initial_display: "double",
    transaction: "string",
    "trpc.procedure_path": "string",
    "trpc.procedure_type": "string",
    ttfb: "double",
    "ttfb.requestTime": "double",
    type: "string",
    "ui.component_name": "string",
    "ui.contributes_to_ttfd": "boolean",
    "ui.contributes_to_ttid": "boolean",
    "ui.element.height": "integer",
    "ui.element.id": "string",
    "ui.element.identifier": "string",
    "ui.element.load_time": "double",
    "ui.element.paint_type": "string",
    "ui.element.render_time": "double",
    "ui.element.type": "string",
    "ui.element.url": "string",
    "ui.element.width": "integer",
    url: "string",
    "url.domain": "string",
    "url.fragment": "string",
    "url.full": "string",
    "url.path": "string",
    "url.path.parameter.<key>": "string",
    "url.port": "integer",
    "url.query": "string",
    "url.same_origin": "boolean",
    "url.scheme": "string",
    "url.template": "string",
    "user_agent.original": "string",
    "user.email": "string",
    "user.full_name": "string",
    "user.geo.city": "string",
    "user.geo.country_code": "string",
    "user.geo.region": "string",
    "user.geo.subdivision": "string",
    "user.hash": "string",
    "user.id": "string",
    "user.ip_address": "string",
    "user.name": "string",
    "user.roles": "string[]",
    "vercel.branch": "string",
    "vercel.build_id": "string",
    "vercel.deployment_id": "string",
    "vercel.destination": "string",
    "vercel.edge_type": "string",
    "vercel.entrypoint": "string",
    "vercel.execution_region": "string",
    "vercel.id": "string",
    "vercel.ja3_digest": "string",
    "vercel.ja4_digest": "string",
    "vercel.log_type": "string",
    "vercel.path": "string",
    "vercel.project_id": "string",
    "vercel.project_name": "string",
    "vercel.proxy.cache_id": "string",
    "vercel.proxy.client_ip": "string",
    "vercel.proxy.host": "string",
    "vercel.proxy.lambda_region": "string",
    "vercel.proxy.method": "string",
    "vercel.proxy.path": "string",
    "vercel.proxy.path_type": "string",
    "vercel.proxy.path_type_variant": "string",
    "vercel.proxy.referer": "string",
    "vercel.proxy.region": "string",
    "vercel.proxy.response_byte_size": "integer",
    "vercel.proxy.scheme": "string",
    "vercel.proxy.status_code": "integer",
    "vercel.proxy.timestamp": "integer",
    "vercel.proxy.user_agent": "string[]",
    "vercel.proxy.vercel_cache": "string",
    "vercel.proxy.vercel_id": "string",
    "vercel.proxy.waf_action": "string",
    "vercel.proxy.waf_rule_id": "string",
    "vercel.request_id": "string",
    "vercel.source": "string",
    "vercel.status_code": "integer"
}, $8b11dd70aaca6dbd$var$ATTRIBUTE_METADATA = {
    "ai.citations": {
        brief: "References or sources cited by the AI model in its response.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Citation 1",
            "Citation 2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.completion_tokens.used": {
        brief: "The number of tokens used to respond to the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "gen_ai.usage.output_tokens",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.documents": {
        brief: "Documents or content chunks used as context for the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "document1.txt",
            "document2.pdf"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.finish_reason": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.frequency_penalty"
        },
        aliases: [
            "gen_ai.request.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.function_call": {
        brief: "For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "function_name",
        deprecation: {
            replacement: "gen_ai.tool.name"
        },
        aliases: [
            "gen_ai.tool.name",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.generation_id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gen_123abc",
        deprecation: {
            replacement: "gen_ai.response.id"
        },
        aliases: [
            "gen_ai.response.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.input_messages": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.request.messages"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.is_search_required": {
        brief: "Boolean indicating if the model needs to perform a search.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.metadata": {
        brief: "Extra metadata passed to an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"user_id": 123, "session_id": "abc123"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.model_id": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4",
        deprecation: {
            replacement: "gen_ai.response.model"
        },
        aliases: [
            "gen_ai.response.model"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.model.provider": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "gen_ai.provider.name",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.pipeline.name": {
        brief: "The name of the AI pipeline.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        deprecation: {
            replacement: "gen_ai.pipeline.name"
        },
        aliases: [
            "gen_ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    53,
                    76,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.preamble": {
        brief: "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are now a clown.",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        aliases: [
            "gen_ai.system_instructions"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.presence_penalty"
        },
        aliases: [
            "gen_ai.request.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.prompt_tokens.used": {
        brief: "The number of tokens used to process just the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "gen_ai.usage.prompt_tokens",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.raw_prompting": {
        brief: "When enabled, the user\u2019s prompt will be sent to the model without any pre-processing.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.responses": {
        brief: "The response messages sent back by the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "hello",
            "world"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.response_format": {
        brief: "For an AI model call, the format of the response",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "json_object",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.search_queries": {
        brief: "Queries used to search for relevant context or documents.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "climate change effects",
            "renewable energy"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.search_results": {
        brief: "Results returned from search queries for context.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "search_result_1, search_result_2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "gen_ai.request.seed"
        },
        aliases: [
            "gen_ai.request.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.streaming": {
        brief: "Whether the request was streamed back.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "gen_ai.response.streaming"
        },
        aliases: [
            "gen_ai.response.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.tags": {
        brief: "Tags that describe an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"executed_function": "add_integers"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .1,
        deprecation: {
            replacement: "gen_ai.request.temperature"
        },
        aliases: [
            "gen_ai.request.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.texts": {
        brief: "Raw text inputs provided to the model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Hello, how are you?",
            "What is the capital of France?"
        ],
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.input.messages"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.tools": {
        brief: "For an AI model call, the functions that are available",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "function_1",
            "function_2"
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65,
                    127
                ]
            }
        ]
    },
    "ai.tool_calls": {
        brief: "For an AI model call, the tool calls that were made.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "tool_call_1",
            "tool_call_2"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65
                ]
            }
        ]
    },
    "ai.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 35,
        deprecation: {
            replacement: "gen_ai.request.top_k"
        },
        aliases: [
            "gen_ai.request.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .7,
        deprecation: {
            replacement: "gen_ai.request.top_p"
        },
        aliases: [
            "gen_ai.request.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.total_cost": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        deprecation: {
            replacement: "gen_ai.cost.total_tokens"
        },
        aliases: [
            "gen_ai.cost.total_tokens"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    53
                ]
            }
        ]
    },
    "ai.total_tokens.used": {
        brief: "The total number of tokens used to process the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 30,
        deprecation: {
            replacement: "gen_ai.usage.total_tokens"
        },
        aliases: [
            "gen_ai.usage.total_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.warnings": {
        brief: "Warning messages generated during model execution.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Token limit exceeded"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "angular.version": {
        brief: "The version of the Angular framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "17.1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    367
                ],
                description: "Added angular.version attribute"
            }
        ]
    },
    "app.app_build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "app.build",
            reason: "Deprecated in favor of app.build"
        },
        aliases: [
            "app.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_build in favor of app.build"
            }
        ]
    },
    "app.app_identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        deprecation: {
            replacement: "app.identifier",
            reason: "Deprecated in favor of app.identifier"
        },
        aliases: [
            "app.identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_identifier in favor of app.identifier"
            }
        ]
    },
    "app.app_name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        deprecation: {
            replacement: "app.name",
            reason: "Deprecated in favor of app.name"
        },
        aliases: [
            "app.name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_name in favor of app.name"
            }
        ]
    },
    "app.app_start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        deprecation: {
            replacement: "app.start_time",
            reason: "Deprecated in favor of app.start_time"
        },
        aliases: [
            "app.start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_start_time in favor of app.start_time"
            }
        ]
    },
    "app.app_version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        deprecation: {
            replacement: "app.version",
            reason: "Deprecated in favor of app.version"
        },
        aliases: [
            "app.version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_version in favor of app.version"
            }
        ]
    },
    "app.build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        aliases: [
            "app.app_build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.build attribute"
            }
        ]
    },
    "app.identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        aliases: [
            "app.app_identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.identifier attribute"
            }
        ]
    },
    "app.in_foreground": {
        brief: "Whether the application is currently in the foreground.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.in_foreground attribute"
            }
        ]
    },
    "app.name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        aliases: [
            "app.app_name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.name attribute"
            }
        ]
    },
    app_start_cold: {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.cold.value",
            reason: "Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.cold.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.cold.value"
            }
        ]
    },
    "app.start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        aliases: [
            "app.app_start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.start_time attribute"
            }
        ]
    },
    app_start_type: {
        brief: "Mobile app start variant. Either cold or warm.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        deprecation: {
            replacement: "app.vitals.start.type",
            reason: "Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.start.type"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    app_start_warm: {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.warm.value",
            reason: "Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.warm.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.warm.value"
            }
        ]
    },
    "app.version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        aliases: [
            "app.app_version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.version attribute"
            }
        ]
    },
    "app.vitals.frames.delay.value": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        aliases: [
            "frames.delay"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.delay.value to replace frames.delay"
            }
        ]
    },
    "app.vitals.frames.frozen.count": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        aliases: [
            "frames.frozen"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.frozen.count to replace frames.frozen"
            }
        ]
    },
    "app.vitals.frames.slow.count": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        aliases: [
            "frames.slow"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.slow.count to replace frames.slow"
            }
        ]
    },
    "app.vitals.frames.total.count": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        aliases: [
            "frames.total"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.total.count to replace frames.total"
            }
        ]
    },
    "app.vitals.start.cold.value": {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_cold"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.cold.value attribute"
            }
        ]
    },
    "app.vitals.start.prewarmed": {
        brief: "Whether the app start was prewarmed.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    379
                ],
                description: "Added app.vitals.start.prewarmed attribute"
            }
        ]
    },
    "app.vitals.start.reason": {
        brief: "The reason that triggered the app start.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "push",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.reason attribute"
            }
        ]
    },
    "app.vitals.start.screen": {
        brief: "The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MainActivity",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.screen attribute"
            }
        ]
    },
    "app.vitals.start.type": {
        brief: "The type of app start, for example `cold` or `warm`",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        aliases: [
            "app_start_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.type attribute"
            }
        ]
    },
    "app.vitals.start.warm.value": {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_warm"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.warm.value attribute"
            }
        ]
    },
    "app.vitals.ttfd.value": {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_full_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttfd.value attribute"
            }
        ]
    },
    "app.vitals.ttid.value": {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_initial_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttid.value attribute"
            }
        ]
    },
    "art.gc.blocking_count": {
        brief: "Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_count attribute"
            }
        ]
    },
    "art.gc.blocking_time": {
        brief: "Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.873,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_time attribute"
            }
        ]
    },
    "art.gc.pre_oome_count": {
        brief: "Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.pre_oome_count attribute"
            }
        ]
    },
    "art.gc.total_count": {
        brief: "Total number of garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_count attribute"
            }
        ]
    },
    "art.gc.total_time": {
        brief: "Total time spent in garbage collection by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.807,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_time attribute"
            }
        ]
    },
    "art.gc.waiting_time": {
        brief: "Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8.054,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.waiting_time attribute"
            }
        ]
    },
    "art.memory.free": {
        brief: "Free memory available to the process as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free attribute"
            }
        ]
    },
    "art.memory.free_until_gc": {
        brief: "Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_gc attribute"
            }
        ]
    },
    "art.memory.free_until_oome": {
        brief: "Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 196083712,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_oome attribute"
            }
        ]
    },
    "art.memory.max": {
        brief: "Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 201326592,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.max attribute"
            }
        ]
    },
    "art.memory.total": {
        brief: "Total memory currently allocated to the process by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7774208,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.total attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_group": {
        brief: "The name of the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/aws/lambda/my-function",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_group attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_stream": {
        brief: "The name of the CloudWatch Logs log stream",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024/01/01/[$LATEST]abcdef1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_stream attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.url": {
        brief: "The URL to the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.url attribute"
            }
        ]
    },
    "aws.dynamodb.attribute_definitions": {
        brief: "The JSON-serialized value of each item in the `AttributeDefinitions` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "AttributeName": "string", "AttributeType": "string" }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.attribute_definitions attribute"
            }
        ]
    },
    "aws.dynamodb.consistent_read": {
        brief: "The value of the `ConsistentRead` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consistent_read attribute"
            }
        ]
    },
    "aws.dynamodb.consumed_capacity": {
        brief: "The JSON-serialized value of each item in the `ConsumedCapacity` response field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consumed_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.count": {
        brief: "The value of the `Count` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.count attribute"
            }
        ]
    },
    "aws.dynamodb.exclusive_start_table": {
        brief: "The value of the `ExclusiveStartTableName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Users",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.exclusive_start_table attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_index_updates": {
        brief: "The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_index_updates attribute"
            }
        ]
    },
    "aws.dynamodb.index_name": {
        brief: "The value of the `IndexName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "name_to_group",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.index_name attribute"
            }
        ]
    },
    "aws.dynamodb.item_collection_metrics": {
        brief: "The JSON-serialized value of the `ItemCollectionMetrics` response field.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.item_collection_metrics attribute"
            }
        ]
    },
    "aws.dynamodb.limit": {
        brief: "The value of the `Limit` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.limit attribute"
            }
        ]
    },
    "aws.dynamodb.local_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.local_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.projection": {
        brief: "The value of the `ProjectionExpression` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Title, Price, Color",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.projection attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_read_capacity": {
        brief: "The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_read_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_write_capacity": {
        brief: "The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_write_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.scanned_count": {
        brief: "The value of the `ScannedCount` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scanned_count attribute"
            }
        ]
    },
    "aws.dynamodb.scan_forward": {
        brief: "The value of the `ScanIndexForward` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scan_forward attribute"
            }
        ]
    },
    "aws.dynamodb.segment": {
        brief: "The value of the `Segment` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.segment attribute"
            }
        ]
    },
    "aws.dynamodb.select": {
        brief: "The value of the `Select` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ALL_ATTRIBUTES",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.select attribute"
            }
        ]
    },
    "aws.dynamodb.table_count": {
        brief: "The number of items in the `TableNames` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_count attribute"
            }
        ]
    },
    "aws.dynamodb.table_names": {
        brief: "The keys in the `RequestItems` object field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "Users",
            "Cats"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_names attribute"
            }
        ]
    },
    "aws.dynamodb.total_segments": {
        brief: "The value of the `TotalSegments` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.total_segments attribute"
            }
        ]
    },
    "aws.extended_request_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        aliases: [
            "aws.request.extended_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.extended_request_id attribute"
            }
        ]
    },
    "aws.kinesis.stream_name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "some-stream-name",
        aliases: [
            "aws.kinesis.stream.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream_name attribute"
            }
        ]
    },
    "aws.kinesis.stream.name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "some-stream-name",
        deprecation: {
            replacement: "aws.kinesis.stream_name",
            reason: "This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.kinesis.stream_name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name"
            }
        ]
    },
    "aws.lambda.aws_request_id": {
        brief: "The AWS request ID as received by the Lambda function runtime",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8476a536-e9f4-11e8-9739-2dfe598c3fcd",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id"
        },
        aliases: [
            "faas.invocation_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.aws_request_id attribute"
            }
        ]
    },
    "aws.lambda.execution_duration_in_millis": {
        brief: "The execution duration of the Lambda function invocation in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.execution_duration_in_millis attribute"
            }
        ]
    },
    "aws.lambda.function_name": {
        brief: "The name of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-function",
        deprecation: {
            replacement: "faas.name",
            reason: "Use the OTel-aligned faas.name attribute instead"
        },
        aliases: [
            "faas.name"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.function_name in favor of faas.name"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_name attribute"
            }
        ]
    },
    "aws.lambda.function_version": {
        brief: "The version of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "$LATEST",
        deprecation: {
            replacement: "faas.version",
            reason: "Use the OTel-aligned faas.version attribute instead"
        },
        aliases: [
            "faas.version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.function_version in favor of faas.version"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_version attribute"
            }
        ]
    },
    "aws.lambda.invoked_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        aliases: [
            "aws.lambda.invoked_function_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.lambda.invoked_function_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        deprecation: {
            replacement: "aws.lambda.invoked_arn",
            reason: "This attribute is being deprecated in favor of aws.lambda.invoked_arn"
        },
        aliases: [
            "aws.lambda.invoked_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.invoked_function_arn attribute"
            }
        ]
    },
    "aws.lambda.remaining_time_in_millis": {
        brief: "The remaining time in milliseconds before the Lambda function times out",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.remaining_time_in_millis attribute"
            }
        ]
    },
    "aws.log.group.names": {
        brief: "The name(s) of the AWS log group(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "/aws/lambda/my-function",
            "opentelemetry-service"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.log.stream.names": {
        brief: "The name(s) of the AWS log stream(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.request.extended_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        deprecation: {
            replacement: "aws.extended_request_id",
            reason: "This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.extended_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id"
            }
        ]
    },
    "aws.request_id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        aliases: [
            "aws.request.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request_id attribute"
            }
        ]
    },
    "aws.request.id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        deprecation: {
            replacement: "aws.request_id",
            reason: "This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.id attribute, deprecated in favor of aws.request_id"
            }
        ]
    },
    "aws.s3.bucket": {
        brief: "The S3 bucket name the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ot-demo-test",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.s3.bucket attribute"
            }
        ]
    },
    "aws.secretsmanager.secret.arn": {
        brief: "The ARN of the Secret stored in Secrets Manager.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.secretsmanager.secret.arn attribute"
            }
        ]
    },
    "aws.sns.topic.arn": {
        brief: "The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.sns.topic.arn attribute"
            }
        ]
    },
    "aws.step_functions.activity.arn": {
        brief: "The ARN of the AWS Step Functions Activity.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:activity:get-greeting",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.activity.arn attribute"
            }
        ]
    },
    "aws.step_functions.state_machine.arn": {
        brief: "The ARN of the AWS Step Functions State Machine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.state_machine.arn attribute"
            }
        ]
    },
    blocked_main_thread: {
        brief: "Whether the main thread was blocked by the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        aliases: [
            "sentry.browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127,
                    139
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.performance.navigation.activation_start": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        aliases: [
            "performance.activationStart"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.navigation.activation_start attribute"
            }
        ]
    },
    "browser.performance.time_origin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        aliases: [
            "performance.timeOrigin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.time_origin attribute attribute"
            }
        ]
    },
    "browser.report.type": {
        brief: "A browser report sent via reporting API..",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "network-error",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "browser.script.invoker": {
        brief: "How a script was called in the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Window.requestAnimationFrame",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.invoker_type": {
        brief: "Browser script entry point type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "event-listener",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.source_char_position": {
        brief: "A number representing the script character position of the script.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 678,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        aliases: [
            "sentry.browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    59,
                    127,
                    139
                ]
            }
        ]
    },
    "browser.web_vital.cls.report_event": {
        brief: "The event that caused the SDK to report CLS (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigation",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.cls.report_event attribute"
            }
        ]
    },
    "browser.web_vital.cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        aliases: [
            "cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "browser.web_vital.cls.value": {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        aliases: [
            "cls"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.cls.value attribute"
            }
        ]
    },
    "browser.web_vital.fcp.value": {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        aliases: [
            "fcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.fp.value": {
        brief: "The time in milliseconds it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        aliases: [
            "fp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.inp.value": {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        aliases: [
            "inp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.inp.value attribute"
            }
        ]
    },
    "browser.web_vital.lcp.element": {
        brief: "The HTML element selector or component name for which LCP was reported",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > div#container > div",
        aliases: [
            "lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#gero",
        aliases: [
            "lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.load_time": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        aliases: [
            "lcp.loadTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.render_time": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        aliases: [
            "lcp.renderTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.report_event": {
        brief: "The event that caused the SDK to report LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.lcp.report_event attribute"
            }
        ]
    },
    "browser.web_vital.lcp.size": {
        brief: "The size of the largest contentful paint element",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        aliases: [
            "lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/static/img.png",
        aliases: [
            "lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.value": {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        aliases: [
            "lcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.lcp.value attribute"
            }
        ]
    },
    "browser.web_vital.ttfb.request_time": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        aliases: [
            "ttfb.requestTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.ttfb.value": {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194.3322,
        aliases: [
            "ttfb"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "cache.hit": {
        brief: "If the cache was hit during this span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.item_size": {
        brief: "The size of the requested item in the cache. In bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 58,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.key": {
        brief: "The key of the cache accessed.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "my-cache-key",
            "my-other-cache-key"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.operation": {
        brief: "The operation being performed on the cache.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "get",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.ttl": {
        brief: "The ttl of the cache in seconds",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.write": {
        brief: "If the cache operation resulted in a write to the cache.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    channel: {
        brief: "The channel name that is being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mail",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.address": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.client_ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.port": {
        brief: "Client port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 5432,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.duration": {
        brief: "The duration of a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 543,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.query_type": {
        brief: "The type of query executed in a Cloudflare D1 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "run",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "db.operation"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.d1.query_type attribute"
            }
        ]
    },
    "cloudflare.d1.rows_read": {
        brief: "The number of rows read in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.rows_written": {
        brief: "The number of rows written in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.durable_object.query.bindings": {
        brief: "The number of bound parameters passed to the SQL exec call.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.query.bindings attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_read": {
        brief: "The number of rows read by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_read attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_written": {
        brief: "The number of rows written by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_written attribute"
            }
        ]
    },
    "cloudflare.r2.bucket": {
        brief: "The name of the Cloudflare R2 bucket binding",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MY_BUCKET",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.bucket attribute"
            }
        ]
    },
    "cloudflare.r2.operation": {
        brief: "The R2 API operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GetObject",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.operation attribute"
            }
        ]
    },
    "cloudflare.r2.request.delimiter": {
        brief: "The delimiter used to group objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.delimiter attribute"
            }
        ]
    },
    "cloudflare.r2.request.key": {
        brief: "The object key used in the R2 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-file.txt",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.key attribute"
            }
        ]
    },
    "cloudflare.r2.request.part_number": {
        brief: "The part number in a multipart upload operation",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.part_number attribute"
            }
        ]
    },
    "cloudflare.r2.request.prefix": {
        brief: "The prefix used to filter objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "images/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.prefix attribute"
            }
        ]
    },
    "cloudflare.workflow.attempt": {
        brief: "The current attempt number for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.attempt attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.backoff": {
        brief: "The backoff strategy for Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "exponential",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.backoff attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.delay": {
        brief: "The delay between Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "5 seconds",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.delay attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.limit": {
        brief: "The maximum number of retries for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.limit attribute"
            }
        ]
    },
    "cloudflare.workflow.timeout": {
        brief: "The timeout duration for a Cloudflare Workflow step",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1 minute",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.timeout attribute"
            }
        ]
    },
    "cloud.account.id": {
        brief: "The cloud account ID the resource is assigned to",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "123456789012",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.account.id attribute"
            }
        ]
    },
    "cloud.availability_zone": {
        brief: "Cloud regions often have multiple, isolated locations known as zones to increase availability",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1c",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.availability_zone attribute"
            }
        ]
    },
    "cloud.platform": {
        brief: "The cloud platform in use",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws_lambda",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.platform attribute"
            }
        ]
    },
    "cloud.provider": {
        brief: "Name of the cloud provider",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.provider attribute"
            }
        ]
    },
    "cloud.region": {
        brief: "The geographical region the resource is running",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.region attribute"
            }
        ]
    },
    "cloud.resource_id": {
        brief: "Cloud provider-specific native identifier of the monitored cloud resource",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        aliases: [
            "faas.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ],
        additionalContext: [
            "This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other."
        ]
    },
    cls: {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        deprecation: {
            replacement: "browser.web_vital.cls.value",
            reason: "The CLS web vital is now recorded as a browser.web_vital.cls.value attribute."
        },
        aliases: [
            "browser.web_vital.cls.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        deprecation: {
            replacement: "browser.web_vital.cls.source.<key>",
            reason: "The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute."
        },
        aliases: [
            "browser.web_vital.cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "code.filepath": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        deprecation: {
            replacement: "code.file.path"
        },
        aliases: [
            "code.file.path"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.file.path": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        aliases: [
            "code.filepath"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function": {
        brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function.name": {
        brief: "The method or function fully-qualified name without arguments.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.lineno": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        deprecation: {
            replacement: "code.line.number"
        },
        aliases: [
            "code.line.number"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.line.number": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        aliases: [
            "code.lineno"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.namespace": {
        brief: "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.handler",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    connectionType: {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.type for span-first future"
        },
        aliases: [
            "network.connection.type",
            "device.connection_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "network.connection.rtt",
            reason: "Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future"
        },
        aliases: [
            "network.connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "culture.calendar": {
        brief: "The calendar system used by the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GregorianCalendar",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.display_name": {
        brief: "Human readable name of the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "English (United States)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.is_24_hour_format": {
        brief: "Whether the culture uses 24-hour time format.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.locale": {
        brief: "The locale identifier following RFC 4646.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.timezone": {
        brief: "The timezone of the culture, as a geographic timezone identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "db.collection.name": {
        brief: "The name of a collection (table, container) within the database.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "users",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.driver.name": {
        brief: "The name of the driver used for the database connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "psycopg2",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    297
                ],
                description: "Added db.driver.name attribute"
            }
        ]
    },
    "db.name": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        deprecation: {
            replacement: "db.namespace"
        },
        aliases: [
            "db.namespace"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.namespace": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        aliases: [
            "db.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation.batch.size": {
        brief: "The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    407
                ],
                description: "Added db.operation.batch.size attribute"
            }
        ]
    },
    "db.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        aliases: [
            "db.operation",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.parameter.<key>": {
        brief: "A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "db.query.parameter.foo='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103,
                    127
                ]
            }
        ]
    },
    "db.query.summary": {
        brief: "A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT users",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.text": {
        brief: "The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        aliases: [
            "db.statement"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.connection": {
        brief: "The redis connection name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-redis-instance",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    326
                ],
                description: "Added db.redis.key attribute"
            }
        ]
    },
    "db.redis.parameters": {
        brief: "The array of command parameters given to a redis command.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "test",
            "*"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "db.response.status_code": {
        brief: "Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ORA-17002",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    462
                ],
                description: "Added db.response.status_code attribute"
            }
        ]
    },
    "db.sql.bindings": {
        brief: "The array of query bindings.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "1",
            "foo"
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.statement": {
        brief: "The database statement being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users",
        deprecation: {
            replacement: "db.query.text"
        },
        aliases: [
            "db.query.text"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.stored_procedure.name": {
        brief: "The name of a stored procedure being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GetUserById",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    398
                ]
            }
        ]
    },
    "db.system": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        deprecation: {
            replacement: "db.system.name"
        },
        aliases: [
            "db.system.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199,
                    224
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.system.name": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        aliases: [
            "db.system"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.user": {
        brief: "The database user.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "fancy_user",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    deviceMemory: {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8 GB",
        deprecation: {
            replacement: "device.memory.estimated_capacity",
            reason: "Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future"
        },
        aliases: [
            "device.memory.estimated_capacity"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "device.archs": {
        brief: "The CPU architectures of the device.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "arm64-v8a",
            "armeabi-v7a",
            "armeabi"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.archs attribute"
            }
        ]
    },
    "device.battery_level": {
        brief: "The battery level of the device as a percentage (0-100).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_level attribute"
            }
        ]
    },
    "device.battery_temperature": {
        brief: "The battery temperature of the device in Celsius.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 25,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_temperature attribute"
            }
        ]
    },
    "device.boot_time": {
        brief: "A formatted UTC timestamp when the system was booted.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2018-02-08T12:52:12Z",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.boot_time attribute"
            }
        ]
    },
    "device.brand": {
        brief: "The brand of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Apple",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.charging": {
        brief: "Whether the device was charging or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.charging attribute"
            }
        ]
    },
    "device.chipset": {
        brief: "The chipset of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Qualcomm SM8550",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.chipset attribute"
            }
        ]
    },
    "device.class": {
        brief: "The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "medium",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.class attribute"
            }
        ]
    },
    "device.connection_type": {
        brief: "The internet connection type currently being used by the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "This attribute is being deprecated in favor of network.connection.type"
        },
        aliases: [
            "network.connection.type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added and deprecated device.connection_type in favor of network.connection.type"
            }
        ]
    },
    "device.cpu_description": {
        brief: "A description of the CPU of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.cpu_description attribute"
            }
        ]
    },
    "device.external_free_storage": {
        brief: "External storage free size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 67108864e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_free_storage attribute"
            }
        ]
    },
    "device.external_storage_size": {
        brief: "External storage total size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 134217728e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_storage_size attribute"
            }
        ]
    },
    "device.family": {
        brief: "The family of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.free_memory": {
        brief: "Free system memory in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.free_memory attribute"
            }
        ]
    },
    "device.free_storage": {
        brief: "Free device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 107374182400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.free_storage attribute"
            }
        ]
    },
    "device.id": {
        brief: "Unique device identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.id attribute"
            }
        ]
    },
    "device.locale": {
        brief: "The locale of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.locale attribute"
            }
        ]
    },
    "device.low_memory": {
        brief: "Whether the device was low on memory.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.low_memory attribute"
            }
        ]
    },
    "device.low_power_mode": {
        brief: "Whether the device is in Low Power Mode.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    314
                ],
                description: "Added device.low_power_mode attribute"
            }
        ]
    },
    "device.manufacturer": {
        brief: "The manufacturer of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Google",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.manufacturer attribute"
            }
        ]
    },
    "device.memory.estimated_capacity": {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "deviceMemory"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added attribute device.memory.estimated_capacity to be used instead of deviceMemory"
            }
        ]
    },
    "device.memory_size": {
        brief: "Total system memory available in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17179869184,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.memory_size attribute"
            }
        ]
    },
    "device.model": {
        brief: "The model of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone 15 Pro Max",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.model_id": {
        brief: "An internal hardware revision to identify the device exactly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "N861AP",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.model_id attribute"
            }
        ]
    },
    "device.name": {
        brief: "The name of the device. On mobile, this is the user-assigned device name. On servers and desktops, this is typically the hostname.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "localhost",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.name attribute"
            }
        ]
    },
    "device.online": {
        brief: "Whether the device was online or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.online attribute"
            }
        ]
    },
    "device.orientation": {
        brief: 'The orientation of the device, either "portrait" or "landscape".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "portrait",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.orientation attribute"
            }
        ]
    },
    "device.processor_count": {
        brief: 'Number of "logical processors".',
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "hardwareConcurrency"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count"
            }
        ]
    },
    "device.processor_frequency": {
        brief: "Processor frequency in MHz.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.processor_frequency attribute"
            }
        ]
    },
    "device.screen_density": {
        brief: "The screen density of the device.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2.625,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_density attribute"
            }
        ]
    },
    "device.screen_dpi": {
        brief: "The screen density in dots-per-inch (DPI) of the device.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 420,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_dpi attribute"
            }
        ]
    },
    "device.screen_height_pixels": {
        brief: "The height of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_height_pixels attribute"
            }
        ]
    },
    "device.screen_width_pixels": {
        brief: "The width of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1080,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_width_pixels attribute"
            }
        ]
    },
    "device.simulator": {
        brief: "Whether the device is a simulator or an actual device.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.simulator attribute"
            }
        ]
    },
    "device.storage_size": {
        brief: "Total device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 274877906944,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.storage_size attribute"
            }
        ]
    },
    "device.thermal_state": {
        brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum: `nominal`, `fair`, `serious`, or `critical`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "nominal",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.thermal_state attribute"
            }
        ]
    },
    "device.timezone": {
        brief: "The timezone of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.timezone attribute"
            }
        ]
    },
    "device.usable_memory": {
        brief: "Memory usable for the app in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.usable_memory attribute"
            }
        ]
    },
    dist: {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        deprecation: {
            replacement: "sentry.dist",
            reason: "This attribute is being deprecated in favor of sentry.dist."
        },
        aliases: [
            "sentry.dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist attribute"
            }
        ]
    },
    effectiveConnectionType: {
        brief: "Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        deprecation: {
            replacement: "network.connection.effective_type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future"
        },
        aliases: [
            "network.connection.effective_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    environment: {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        aliases: [
            "sentry.environment"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "error.type": {
        brief: "Describes a class of error the operation ended with.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timeout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "event.id": {
        brief: "The unique identifier for this event (log record)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234567890,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101
                ]
            }
        ]
    },
    "event.name": {
        brief: "The name that uniquely identifies this event (log record)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Process Payload",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101,
                    127
                ]
            }
        ]
    },
    "exception.escaped": {
        brief: "SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.message": {
        brief: "The error message.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.stacktrace": {
        brief: "A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: `Exception in thread "main" java.lang.RuntimeException: Test exception
 at com.example.GenerateTrace.methodB(GenerateTrace.java:13)
 at com.example.GenerateTrace.methodA(GenerateTrace.java:9)
 at com.example.GenerateTrace.main(GenerateTrace.java:5)`,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.type": {
        brief: "The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OSError",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.coldstart": {
        brief: "A boolean that is true if the serverless function is executed for the first time (aka cold-start).",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.cron": {
        brief: "A string containing the schedule period as Cron Expression.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "0/5 * * * ? *",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.duration_in_ms": {
        brief: "The duration a function took to run, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.entry_point": {
        brief: "The code that's run when the cloud provider invokes your function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my_main_function",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.execution": {
        brief: "The execution ID of the current function execution.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution attribute, deprecated in favor of faas.invocation_id"
            }
        ]
    },
    "faas.id": {
        brief: "The unique ID of the single function that this runtime instance executes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        deprecation: {
            replacement: "cloud.resource_id",
            reason: "This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0)."
        },
        aliases: [
            "cloud.resource_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id attribute, deprecated in favor of cloud.resource_id"
            }
        ]
    },
    "faas.identity": {
        brief: "The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.invocation_id": {
        brief: "The invocation ID of the current function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        aliases: [
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    "faas.invoked_name": {
        brief: "The name of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my-function",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_name attribute"
            }
        ]
    },
    "faas.invoked_provider": {
        brief: "The cloud provider of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_provider attribute"
            }
        ]
    },
    "faas.invoked_region": {
        brief: "The cloud region of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "eu-central-1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_region attribute"
            }
        ]
    },
    "faas.name": {
        brief: "The name of the serverless function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my_function",
        aliases: [
            "aws.lambda.function_name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.time": {
        brief: "A string containing the function invocation time in the ISO 8601 format expressed in UTC.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2020-01-23T13:47:06Z",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.trigger": {
        brief: "Type of the trigger which caused this function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timer",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.version": {
        brief: "The version of the function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "$LATEST",
        aliases: [
            "aws.lambda.function_version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    fcp: {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        deprecation: {
            replacement: "browser.web_vital.fcp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fcp.value"
        },
        aliases: [
            "browser.web_vital.fcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "flag.evaluation.<key>": {
        brief: "An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "flag.evaluation.is_new_ui=true",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    fp: {
        brief: "The time it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        deprecation: {
            replacement: "browser.web_vital.fp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fp.value"
        },
        aliases: [
            "browser.web_vital.fp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "frames.delay": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        deprecation: {
            replacement: "app.vitals.frames.delay.value",
            reason: "Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.delay.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.delay.value"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.frozen.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_frozen_rate: {
        brief: "The rate of frozen frames, or `app_vitals.frames.frozen.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_frozen_rate attribute"
            }
        ]
    },
    "frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.slow.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_slow_rate: {
        brief: "The rate of slow frames, or `app_vitals.frames.slow.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_slow_rate attribute"
            }
        ]
    },
    "frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.total.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.total.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    fs_error: {
        brief: "The error message of a file system error.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        deprecation: {
            replacement: "error.type",
            reason: "This attribute is not part of the OpenTelemetry specification and error.type fits much better."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gcp.function.context.event_id": {
        brief: "The event ID from the legacy GCP Cloud Function context (1st gen)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_id attribute"
            }
        ]
    },
    "gcp.function.context.event_type": {
        brief: "The type of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "google.pubsub.topic.publish",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_type attribute"
            }
        ]
    },
    "gcp.function.context.id": {
        brief: "The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.id attribute"
            }
        ]
    },
    "gcp.function.context.resource": {
        brief: "The resource that triggered the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.resource attribute"
            }
        ]
    },
    "gcp.function.context.source": {
        brief: "The source of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "//pubsub.googleapis.com/projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.source attribute"
            }
        ]
    },
    "gcp.function.context.specversion": {
        brief: "The CloudEvents specification version of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.specversion attribute"
            }
        ]
    },
    "gcp.function.context.time": {
        brief: "The timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.time attribute"
            }
        ]
    },
    "gcp.function.context.timestamp": {
        brief: "The legacy timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.timestamp attribute"
            }
        ]
    },
    "gcp.function.context.type": {
        brief: "The type of the GCP Cloud Function event context",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cloud_functions.context",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.type attribute"
            }
        ]
    },
    "gcp.project.id": {
        brief: "The ID of the project in GCP that this resource is associated with",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-project-123",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "gen_ai.agent.name": {
        brief: "The name of the agent being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ResearchAssistant",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.context.utilization": {
        brief: "The fraction of the model context window utilized by this generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .75,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.utilization attribute"
            }
        ]
    },
    "gen_ai.context.window_size": {
        brief: "The maximum context window size supported by the model for this generation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.window_size attribute"
            }
        ]
    },
    "gen_ai.conversation.id": {
        brief: "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "conv_5j66UpCpwteGg4YSxUnt7lPY",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    250
                ]
            }
        ]
    },
    "gen_ai.cost.cache_creation.input_tokens": {
        brief: "The cost of input tokens written to cache in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.cache_read.input_tokens": {
        brief: "The cost of cached input tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.input_tokens": {
        brief: "The total cost of all input tokens in USD (includes cached and cache creation tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
            "This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens."
        ]
    },
    "gen_ai.cost.output_tokens": {
        brief: "The total cost of all output tokens in USD (includes reasoning tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
            "This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens."
        ]
    },
    "gen_ai.cost.reasoning.output_tokens": {
        brief: "The cost of reasoning output tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
            "This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.total_tokens": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        aliases: [
            "ai.total_cost"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    126
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens."
        ]
    },
    "gen_ai.embeddings.input": {
        brief: "The input to the embeddings model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "What's the weather in Paris?",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    195
                ]
            }
        ]
    },
    "gen_ai.function_id": {
        brief: "Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-awesome-function",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    308
                ],
                description: "Added gen_ai.function_id attribute"
            }
        ]
    },
    "gen_ai.input.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57\xB0F"}]}]',
        aliases: [
            "ai.texts"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.operation.name": {
        brief: "The name of the operation being performed. It has the following list of well-known values: 'chat', 'create_agent', 'embeddings', 'execute_tool', 'generate_content', 'invoke_agent', 'text_completion'. If one of them applies, then that value MUST be used. Otherwise a custom value MAY be used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "chat",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    225
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.operation.type": {
        brief: "The type of AI operation. Must be one of 'agent' (invoke_agent and create_agent spans), 'ai_client' (any LLM call), 'tool' (execute_tool spans), 'handoff' (handoff spans), 'other' (input and output processors, skill loading, guardrails etc.) . Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "tool",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    257
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    113,
                    127
                ]
            }
        ]
    },
    "gen_ai.output.messages": {
        brief: "The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57\xB0F."}], "finish_reason": "stop"}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.pipeline.name": {
        brief: "Name of the AI pipeline or chain being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        aliases: [
            "ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    127
                ]
            }
        ]
    },
    "gen_ai.prompt": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            reason: "Deprecated from OTEL, use gen_ai.input.messages with the new format instead."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74,
                    108,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.prompt.name": {
        brief: "The name of the prompt that uniquely identifies it.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !0,
        visibility: "public",
        example: "summarize_text",
        aliases: [
            "mcp.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added gen_ai.prompt.name attribute"
            }
        ]
    },
    "gen_ai.provider.name": {
        brief: "The Generative AI provider as identified by the client or server instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        aliases: [
            "ai.model.provider",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            }
        ]
    },
    "gen_ai.request.available_tools": {
        brief: "The available tools for the model. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.max_tokens": {
        brief: "The maximum number of tokens to generate in the response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2048,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.request.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "ai.input_messages"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74,
                    108,
                    119,
                    122
                ]
            }
        ]
    },
    "gen_ai.request.model": {
        brief: "The model identifier being used for the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4-turbo-preview",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.reasoning_effort": {
        brief: "Constrains the effort on reasoning for reasoning models. Supported values vary by provider.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "high",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    334
                ],
                description: "Added gen_ai.request.reasoning_effort attribute"
            }
        ]
    },
    "gen_ai.request.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "ai.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.stop_sequences": {
        brief: "List of sequences that the model will use to stop generating further tokens.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "forest",
            "lived"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added gen_ai.request.stop_sequences attribute"
            }
        ]
    },
    "gen_ai.request.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .1,
        aliases: [
            "ai.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 35,
        aliases: [
            "ai.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .7,
        aliases: [
            "ai.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.response.finish_reasons": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "COMPLETE",
        aliases: [
            "ai.finish_reason"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gen_123abc",
        aliases: [
            "ai.generation_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.model": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4",
        aliases: [
            "ai.model_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.response.streaming": {
        brief: "Whether or not the AI model call's response was streamed back asynchronously",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "ai.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76
                ]
            }
        ]
    },
    "gen_ai.response.text": {
        brief: "The model's response text messages. It has to be a stringified version of an array of response text messages.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '["The weather in Paris is rainy and overcast, with temperatures around 57\xB0F", "The weather in London is sunny and warm, with temperatures around 65\xB0F"]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.response.time_to_first_chunk": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .6853435,
        aliases: [
            "gen_ai.response.time_to_first_token"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.response.time_to_first_chunk attribute"
            }
        ]
    },
    "gen_ai.response.time_to_first_token": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .6853435,
        deprecation: {
            replacement: "gen_ai.response.time_to_first_chunk"
        },
        aliases: [
            "gen_ai.response.time_to_first_chunk"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.response.time_to_first_chunk"
            },
            {
                version: "0.4.0",
                prs: [
                    227
                ]
            }
        ]
    },
    "gen_ai.response.tokens_per_second": {
        brief: "The total output tokens per seconds throughput",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345.67,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    66
                ]
            }
        ]
    },
    "gen_ai.response.tool_calls": {
        brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.system": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "ai.model.provider",
            "gen_ai.provider.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.system_instructions": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "You are a helpful assistant",
        aliases: [
            "ai.preamble"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.system.message": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are a helpful assistant",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.call.arguments": {
        brief: "The arguments of the tool call. It has to be a stringified version of the arguments to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{"location": "Paris"}',
        aliases: [
            "gen_ai.tool.input"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.call.result": {
        brief: "The result of the tool call. It has to be a stringified version of the result of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "rainy, 57\xB0F",
        aliases: [
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.definitions": {
        brief: "The list of source system tool definitions available to the GenAI agent or model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.description": {
        brief: "The description of the tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Searches the web for current information about a topic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.input": {
        brief: "The input of the tool being used. It has to be a stringified version of the input to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments"
        },
        aliases: [
            "gen_ai.tool.call.arguments"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.message": {
        brief: "The response from a tool or function call passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.name": {
        brief: "Name of the tool utilized by the agent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Flights",
        aliases: [
            "ai.function_call",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.output": {
        brief: "The output of the tool being used. It has to be a stringified version of the output of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.type": {
        brief: "The type of tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "function",
        deprecation: {
            reason: "The gen_ai.tool.type attribute is deprecated and should no longer be set."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.usage.cache_creation.input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        aliases: [
            "gen_ai.usage.input_tokens.cache_write"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.cache_read.input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        aliases: [
            "gen_ai.usage.input_tokens.cached"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.completion_tokens": {
        brief: "The number of tokens used in the GenAI response (completion).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.output_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.input_tokens": {
        brief: "The number of tokens used to process the AI input (prompt) including cached input tokens.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.input_tokens.cached": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.input_tokens.cache_write": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_creation.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    217,
                    228
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.output_tokens": {
        brief: "The number of tokens used for creating the AI output (including reasoning tokens).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.output_tokens.reasoning": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 75,
        deprecation: {
            replacement: "gen_ai.usage.reasoning.output_tokens"
        },
        aliases: [
            "gen_ai.usage.reasoning.output_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.prompt_tokens": {
        brief: "The number of tokens used in the GenAI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.reasoning.output_tokens": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 75,
        aliases: [
            "gen_ai.usage.output_tokens.reasoning"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.total_tokens": {
        brief: "The total number of tokens used to process the prompt. (input tokens plus output todkens)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        aliases: [
            "ai.total_tokens.used"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them \u2014 they are already included."
        ]
    },
    "graphql.document": {
        brief: "The GraphQL document being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible."
        },
        isInOtel: !0,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        changelog: [
            {
                version: "0.7.0",
                description: "Adds the `graphql.document` attribute to track the GraphQL document being executed."
            }
        ]
    },
    "graphql.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "findBookById",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.operation.type": {
        brief: "The type of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    hardwareConcurrency: {
        brief: "The number of logical CPU cores available.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "14",
        deprecation: {
            replacement: "device.processor_count",
            reason: "Old namespace-less attribute, to be replaced with device.processor_count for span-first future"
        },
        aliases: [
            "device.processor_count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281,
                    300
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "http.client_ip": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "client.address"
        },
        aliases: [
            "client.address"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.decoded_response_content_length": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.flavor": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.fragment": {
        brief: "The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.host": {
        brief: "The domain name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use one of `server.address` or `client.address`, depending on the usage"
        },
        aliases: [
            "server.address",
            "client.address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.query": {
        brief: "The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !1,
        visibility: "public",
        example: "?foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.body.data": {
        brief: "HTTP request body data. Can be given as string or structural data of any format.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added http.request.body.data attribute"
            }
        ]
    },
    "http.request.connection_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955515e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.connect_start": {
        brief: "The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555111e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555201e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555322e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.fetch_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555389e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.header.<key>": {
        brief: "HTTP request headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.request.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.request.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        aliases: [
            "method",
            "http.method",
            "http.request_method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "method",
            "http.method",
            "http.request.method"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    343
                ],
                description: "Added http.request_method attribute"
            }
        ]
    },
    "http.request.redirect_end": {
        brief: "The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829558502e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.request.redirect_start": {
        brief: "The UNIX timestamp representing the start time of the fetch which that initiates the redirect.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555495e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.request_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955551e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.resend_count": {
        brief: "The ordinal number of request resending attempt (for any reason, including redirects).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955589e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17328295557e-1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "url.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added http.request.same_origin attribute"
            }
        ]
    },
    "http.request.secure_connection_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955573e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.time_to_first_byte": {
        brief: "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.032,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    131
                ]
            }
        ]
    },
    "http.request.worker_start": {
        brief: "The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955368e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.response.body.size": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.response_content_length",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_content_length": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.response.body.size"
        },
        aliases: [
            "http.response.body.size",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.content-length": {
        brief: "The size of the message body sent to the recipient (in bytes)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.response.header.custom-header=['foo', 'bar']",
        aliases: [
            "http.response_content_length",
            "http.response.body.size"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.<key>": {
        brief: "HTTP response headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.response.size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        aliases: [
            "http.response_transfer_size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        aliases: [
            "http.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_transfer_size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.size"
        },
        aliases: [
            "http.response.size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.route": {
        brief: "The matched route, that is, the path template in the format used by the respective server framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "url.template"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        deprecation: {
            replacement: "url.scheme"
        },
        aliases: [
            "url.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server_name": {
        brief: "The server domain name",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server.request.time_in_queue": {
        brief: "The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    267
                ]
            }
        ]
    },
    "http.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        deprecation: {
            replacement: "http.response.status_code"
        },
        aliases: [
            "http.response.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.target": {
        brief: "The pathname and query string of the URL.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.path",
            reason: "This attribute is being deprecated in favor of url.path and url.query"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.url": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.user_agent": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        deprecation: {
            replacement: "user_agent.original"
        },
        aliases: [
            "user_agent.original"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    id: {
        brief: "A unique identifier for the span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    inp: {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        deprecation: {
            replacement: "browser.web_vital.inp.value",
            reason: "The INP web vital is now recorded as a browser.web_vital.inp.value attribute."
        },
        aliases: [
            "browser.web_vital.inp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "jsonrpc.protocol.version": {
        brief: "The version of the JSON-RPC protocol used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.0",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.protocol.version attribute"
            }
        ]
    },
    "jsonrpc.request.id": {
        brief: "The JSON-RPC request identifier. Unique within the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        aliases: [
            "mcp.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.request.id attribute"
            }
        ]
    },
    "jvm.gc.action": {
        brief: "Name of the garbage collector action.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "end of minor GC",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.gc.name": {
        brief: "Name of the garbage collector.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Young Generation",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.pool.name": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.type": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.daemon": {
        brief: "Whether the thread is daemon or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.state": {
        brief: "State of the thread.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "blocked",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "koa.name": {
        brief: "The name of the Koa middleware or matched route that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead."
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    490
                ],
                description: "Added koa.name attribute as deprecated"
            }
        ]
    },
    "koa.type": {
        brief: "The type of the Koa layer that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    471
                ],
                description: "Added koa.type attribute"
            }
        ]
    },
    lcp: {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        deprecation: {
            replacement: "browser.web_vital.lcp.value",
            reason: "The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute."
        },
        aliases: [
            "browser.web_vital.lcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "lcp.element": {
        brief: "The dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        deprecation: {
            replacement: "browser.web_vital.lcp.element",
            reason: "The LCP element is now recorded as a browser.web_vital.lcp.element attribute."
        },
        aliases: [
            "browser.web_vital.lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#hero",
        deprecation: {
            replacement: "browser.web_vital.lcp.id",
            reason: "The LCP id is now recorded as a browser.web_vital.lcp.id attribute."
        },
        aliases: [
            "browser.web_vital.lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.loadTime": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        deprecation: {
            replacement: "browser.web_vital.lcp.load_time",
            reason: "The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.load_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.renderTime": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        deprecation: {
            replacement: "browser.web_vital.lcp.render_time",
            reason: "The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.render_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.size": {
        brief: "The size of the largest contentful paint element.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        deprecation: {
            replacement: "browser.web_vital.lcp.size",
            reason: "The LCP size is now recorded as a browser.web_vital.lcp.size attribute."
        },
        aliases: [
            "browser.web_vital.lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com",
        deprecation: {
            replacement: "browser.web_vital.lcp.url",
            reason: "The LCP url is now recorded as a browser.web_vital.lcp.url attribute."
        },
        aliases: [
            "browser.web_vital.lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "logger.name": {
        brief: "The name of the logger that generated this event.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myLogger",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "mcp.cancelled.reason": {
        brief: "Reason for the cancellation of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Cancellation reasons may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "User cancelled the request",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.cancelled.request_id": {
        brief: "Request ID of the cancelled MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.name": {
        brief: "Name of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "claude-desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.title": {
        brief: "Display title of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Client titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Claude Desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.version": {
        brief: "Version of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.lifecycle.phase": {
        brief: "Lifecycle phase indicator for MCP operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "initialization_complete",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.data_type": {
        brief: "Data type of the logged message content.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "string",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.level": {
        brief: "Log level for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "info",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.logger": {
        brief: "Logger name for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Logger names may be user-defined and could contain sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mcp_server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.message": {
        brief: "Log message content from MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Log messages can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Tool execution completed successfully",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.method.name": {
        brief: "The name of the MCP request or notification method being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tools/call",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.current": {
        brief: "Current progress value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.message": {
        brief: "Progress message describing the current state of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Progress messages may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Processing 50 of 100 items",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.percentage": {
        brief: "Calculated progress percentage of an MCP operation. Computed from current/total * 100.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.token": {
        brief: "Token for tracking progress of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "progress-token-123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.total": {
        brief: "Total progress target value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.name": {
        brief: "Name of the MCP prompt template being used.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        deprecation: {
            replacement: "gen_ai.prompt.name",
            reason: "OTel uses gen_ai.prompt.name for MCP prompt names"
        },
        aliases: [
            "gen_ai.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.prompt.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.description": {
        brief: "Description of the prompt result.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "A summary of the requested information",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_content": {
        brief: "Content of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Please provide a summary of the document",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_count": {
        brief: "Number of messages in the prompt result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_role": {
        brief: "Role of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.ready": {
        brief: "Protocol readiness indicator for MCP session. Non-zero value indicates the protocol is ready.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.version": {
        brief: "MCP protocol version used in the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2024-11-05",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.<key>": {
        brief: "MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Arguments contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mcp.request.argument.query='weather in Paris'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "mcp.request.argument.name": {
        brief: "Name argument from prompts/get MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Prompt names can contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.uri": {
        brief: "URI argument from resources/read MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain user file paths"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file:///path/to/resource",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.id": {
        brief: "JSON-RPC request identifier for the MCP request. Unique within the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "jsonrpc.request.id",
            reason: "OTel models MCP as JSON-RPC, uses jsonrpc.request.id"
        },
        aliases: [
            "jsonrpc.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of jsonrpc.request.id"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.protocol": {
        brief: "Protocol of the resource URI being accessed, extracted from the URI.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file",
        deprecation: {
            replacement: "network.protocol.name",
            reason: "OTel uses the generic network.protocol.name attribute"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.protocol.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.uri": {
        brief: "The resource URI being accessed in an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain sensitive file paths"
        },
        isInOtel: !0,
        visibility: "public",
        example: "file:///path/to/file.txt",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.name": {
        brief: "Name of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry-mcp-server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.title": {
        brief: "Display title of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Server titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Sentry MCP Server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.version": {
        brief: "Version of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.session.id": {
        brief: "Identifier for the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "550e8400-e29b-41d4-a716-446655440000",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.name": {
        brief: "Name of the MCP tool being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "calculator",
        deprecation: {
            replacement: "gen_ai.tool.name",
            reason: "OTel uses gen_ai.tool.name for MCP tool names"
        },
        aliases: [
            "gen_ai.tool.name",
            "ai.function_call"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.content": {
        brief: "The content of the tool result.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Tool results can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"output": "rainy", "toolCallId": "1"}',
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            reason: "OTel uses gen_ai.tool.call.result for MCP tool results"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.call.result"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    164
                ]
            }
        ]
    },
    "mcp.tool.result.content_count": {
        brief: "Number of content items in the tool result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.is_error": {
        brief: "Whether a tool execution resulted in an error.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {
            replacement: "error.type",
            reason: "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string)."
        },
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of error.type"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.transport": {
        brief: "Transport method used for MCP communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdio",
        deprecation: {
            replacement: "network.transport",
            reason: "OTel uses the generic network.transport attribute"
        },
        aliases: [
            "network.transport",
            "net.transport"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.transport"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mdc.<key>": {
        brief: "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mdc.some_key='some_value'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "messaging.batch.message_count": {
        brief: "The number of messages sent, received, or processed in the scope of the batching operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    341
                ],
                description: "Added messaging.batch.message_count attribute"
            }
        ]
    },
    "messaging.destination": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        deprecation: {
            replacement: "messaging.destination.name",
            reason: "This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "messaging.destination.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination attribute, deprecated in favor of messaging.destination.name"
            }
        ]
    },
    "messaging.destination.connection": {
        brief: "The message destination connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination.name": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "BestTopic",
        aliases: [
            "messaging.destination"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.body.size": {
        brief: "The size of the message body in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 839,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "MyConversationId",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.message.conversation_id attribute"
            }
        ]
    },
    "messaging.message.envelope.size": {
        brief: "The size of the message body and metadata in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1045,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.receive.latency": {
        brief: "The latency between when the message was published and received.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732847252,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.retry.count": {
        brief: "The amount of attempts to send the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.operation.name": {
        brief: "The name of the messaging operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "send",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added messaging.operation.name attribute"
            }
        ]
    },
    "messaging.operation.type": {
        brief: "A string identifying the type of the messaging operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "create",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    51,
                    127
                ]
            }
        ]
    },
    "messaging.rabbitmq.destination.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.rabbitmq.destination.routing_key attribute"
            }
        ]
    },
    "messaging.system": {
        brief: "The messaging system as identified by the client instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "activemq",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    method: {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "http.method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "middleware.name": {
        brief: "The name of the middleware.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added middleware.name attribute"
            }
        ]
    },
    "navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added navigation.origin attribute"
            }
        ]
    },
    "navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added navigation.route.id attribute"
            }
        ]
    },
    "navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        aliases: [
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added new deprecated alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "nel.elapsed_time": {
        brief: "The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.phase": {
        brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "application",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.referrer": {
        brief: "request's referrer, as determined by the referrer policy associated with its client.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/foo?bar=baz",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.sampling_function": {
        brief: "The sampling function used to determine if the request should be sampled.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.type": {
        brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dns.unreachable",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "network.connection.effective_type": {
        brief: "Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        aliases: [
            "effectiveConnectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.effective_type to be used instead of effectiveConnectionType"
            }
        ]
    },
    "network.connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        aliases: [
            "connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.rtt to be used instead of connection.rtt"
            }
        ]
    },
    "network.connection.type": {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wifi",
        aliases: [
            "device.connection_type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.type to be used instead of connectionType"
            }
        ]
    },
    "network.local.address": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.host.ip",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.local.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.address": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        aliases: [
            "net.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        aliases: [
            "http.flavor",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        aliases: [
            "net.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.type": {
        brief: "OSI network layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ipv4",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.ip": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "http.server_name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port"
        },
        aliases: [
            "server.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.ip": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use server.address on client spans and client.address on server spans."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.port": {
        brief: "Peer port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            reason: "Deprecated, use server.port on client spans and client.port on server spans."
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        deprecation: {
            replacement: "network.protocol.name"
        },
        aliases: [
            "network.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.family": {
        brief: "OSI transport and network layer",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "inet",
        deprecation: {
            replacement: "network.transport",
            reason: "Deprecated, use network.transport and network.type."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.addr": {
        brief: "Local address of the network connection mapping to Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.host.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.local.port"
        },
        aliases: [
            "network.local.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.addr": {
        brief: "Peer address of the network connection - IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.peer.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.name": {
        brief: "Peer address of the network connection - Unix domain socket name",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            reason: "Deprecated from OTEL, no replacement at this time"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    119,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.peer.port"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        deprecation: {
            replacement: "network.transport"
        },
        aliases: [
            "network.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.build": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "os.build_id"
        },
        aliases: [
            "os.build_id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build attribute, deprecated in favor of os.build_id"
            }
        ]
    },
    "os.build_id": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "os.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build as alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.description": {
        brief: "Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu 18.04.1 LTS",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.kernel_version": {
        brief: "An independent kernel version string. Typically the entire output of the `uname` syscall.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "20.2.0",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.kernel_version attribute"
            }
        ]
    },
    "os.name": {
        brief: "Human readable operating system name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.raw_description": {
        brief: "An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ubuntu 22.04.4 LTS (Jammy Jellyfish)",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.raw_description attribute"
            }
        ]
    },
    "os.rooted": {
        brief: "Whether the operating system has been jailbroken or rooted.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.rooted attribute"
            }
        ]
    },
    "os.theme": {
        brief: "Whether the OS runs in dark mode or light mode.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dark",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.theme attribute"
            }
        ]
    },
    "os.type": {
        brief: "The operating system type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "linux",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.version": {
        brief: "The version of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.kind": {
        brief: "The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SERVER",
        deprecation: {
            replacement: "sentry.kind",
            reason: "Deprecated in favor of sentry.kind"
        },
        aliases: [
            "sentry.kind"
        ],
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    440
                ],
                description: "Added otel.kind attribute"
            }
        ]
    },
    "otel.scope.name": {
        brief: "The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "io.opentelemetry.contrib.mongodb",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.scope.version": {
        brief: "The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.4.5",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_code": {
        brief: "Name of the code, either \u201COK\u201D or \u201CERROR\u201D. MUST NOT be set if the status code is UNSET.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OK",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_description": {
        brief: "Description of the Status if it has a value, otherwise not set.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "resource not found",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "params.id='123'",
        aliases: [
            "url.path.parameter.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "performance.activationStart": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        deprecation: {
            replacement: "browser.performance.navigation.activation_start",
            reason: "The activationStart is now recorded as the browser.performance.navigation.activation_start attribute."
        },
        aliases: [
            "browser.performance.navigation.activation_start"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.activationStart attribute"
            }
        ]
    },
    "performance.timeOrigin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        deprecation: {
            replacement: "browser.performance.time_origin",
            reason: "The timeOrigin is now recorded as the browser.performance.time_origin attribute."
        },
        aliases: [
            "browser.performance.time_origin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.timeOrigin attribute"
            }
        ]
    },
    previous_route: {
        brief: "Also used by mobile SDKs to indicate the previous route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeScreen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.command_args": {
        brief: "All the command arguments (including the command/executable itself) as received by the process.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "cmd/otecol",
            "--config=config.yaml"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    327
                ],
                description: "Added process.command_args attribute"
            }
        ]
    },
    "process.executable.name": {
        brief: "The name of the executable that started the process.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "getsentry",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.pid": {
        brief: "The process ID of the running process.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 12345,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.description": {
        brief: "An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        aliases: [
            "runtime.raw_description"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.name": {
        brief: "The name of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "v8",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.version": {
        brief: "The version of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "12.9.202.13-rusty",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.name": {
        brief: "The name of the runtime. Equivalent to `name` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "node",
        aliases: [
            "runtime.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.version": {
        brief: "The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        aliases: [
            "runtime.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "query.<key>": {
        brief: "An item in a query string. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "query.id='123'",
        deprecation: {
            replacement: "url.query",
            reason: "Instead of sending items individually in query.<key>, they should be sent all together with url.query."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "react.version": {
        brief: "The version of the React framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.2.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    368
                ],
                description: "Added react.version attribute"
            }
        ]
    },
    release: {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.release"
        },
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "remix.action_form_data.<key>": {
        brief: "Remix form data, <key> being the form data key, the value being the form data value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.text='test'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    replay_id: {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "resource.deployment.environment": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    266
                ]
            }
        ]
    },
    "resource.deployment.environment.name": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    196
                ]
            }
        ]
    },
    "resource.render_blocking_status": {
        brief: "The render blocking status of the resource.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "non-blocking",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    route: {
        brief: "The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "App\\Controller::indexAction",
        deprecation: {
            replacement: "http.route"
        },
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.grpc.status_code": {
        brief: "The numeric status code of the gRPC request.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.method": {
        brief: "The fully-qualified logical name of the method from the RPC interface perspective.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "com.example.ExampleService/exampleMethod",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    351
                ],
                description: "Added rpc.method attribute"
            }
        ]
    },
    "rpc.response.status_code": {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    352
                ],
                description: "Added rpc.response.status_code attribute"
            }
        ]
    },
    "rpc.service": {
        brief: "The full (logical) name of the service being called, including its package name, if applicable.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myService.BestService",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.system": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        deprecation: {
            replacement: "rpc.system.name",
            reason: "This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "rpc.system.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system attribute, deprecated in favor of rpc.system.name"
            }
        ]
    },
    "rpc.system.name": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        aliases: [
            "rpc.system"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system.name attribute"
            }
        ]
    },
    "runtime.build": {
        brief: "The application build string, when it is separate from the version.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stable",
        deprecation: {
            reason: "The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute."
        },
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.build attribute"
            }
        ]
    },
    "runtime.name": {
        brief: "The name of the runtime. For example node, CPython, or rustc.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "node",
        deprecation: {
            replacement: "process.runtime.name",
            reason: "Prefer OTel-aligned process.runtime.name"
        },
        aliases: [
            "process.runtime.name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.name attribute in favor of process.runtime.name"
            }
        ]
    },
    "runtime.raw_description": {
        brief: "Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        deprecation: {
            replacement: "process.runtime.description",
            reason: "Prefer OTel-aligned process.runtime.description"
        },
        aliases: [
            "process.runtime.description"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.raw_description attribute in favor of process.runtime.description"
            }
        ]
    },
    "runtime.version": {
        brief: "The version of the runtime.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.04.2",
        deprecation: {
            replacement: "process.runtime.version",
            reason: "Prefer OTel-aligned process.runtime.version"
        },
        aliases: [
            "process.runtime.version"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.version attribute in favor of process.runtime.version"
            }
        ]
    },
    "score.<key>": {
        brief: "The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.cls=0.1723",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.<key> attribute"
            }
        ]
    },
    "score.ratio.<key>": {
        brief: "The score for a web vital, normalized to a number between 0 and 1.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.ratio.inp=0.7748",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.ratio.<key> attribute"
            }
        ]
    },
    "score.total": {
        brief: "The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.total attribute"
            }
        ]
    },
    "score.weight.<key>": {
        brief: "The relative weight of a web vital in a span's performance score.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.weight.fcp=0.25",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.weight.<key> attribute"
            }
        ]
    },
    "sentry.action": {
        brief: "Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        deprecation: {
            replacement: "browser.name"
        },
        aliases: [
            "browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        deprecation: {
            replacement: "browser.version"
        },
        aliases: [
            "browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.cancellation_reason": {
        brief: "The reason why a span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "document.hidden",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.category": {
        brief: "The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). Known values include: 'ai', 'ai.pipeline', 'app', 'browser', 'cache', 'console', 'db', 'event', 'file', 'function.aws', 'function.azure', 'function.gcp', 'function.nextjs', 'function.remix', 'graphql', 'grpc', 'http', 'measure', 'middleware', 'navigation', 'pageload', 'queue', 'resource', 'rpc', 'serialize', 'subprocess', 'template', 'topic', 'ui', 'ui.angular', 'ui.ember', 'ui.react', 'ui.svelte', 'ui.vue', 'view', 'websocket'.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "db",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    218
                ]
            }
        ]
    },
    "sentry.client_sample_rate": {
        brief: "Rate at which a span was sampled in the SDK.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.description": {
        brief: "The human-readable description of a span.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "index view query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    135
                ]
            }
        ]
    },
    "sentry.dist": {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        aliases: [
            "dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.domain": {
        brief: "Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.dsc.environment": {
        brief: "The environment from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "prod",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.project_id": {
        brief: "The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "12345",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    358
                ],
                description: "Add sentry.dsc.project_id as an attribute"
            }
        ]
    },
    "sentry.dsc.public_key": {
        brief: "The public key from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "c51734c603c4430eb57cb0a5728a479d",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.release": {
        brief: "The release identifier from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "frontend@e8211be71b214afab5b85de4b4c54be3714952bb",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sampled": {
        brief: "Whether the event was sampled according to the dynamic sampling context.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sample_rate": {
        brief: "The sample rate from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.trace_id": {
        brief: "The trace ID from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "047372980460430cbc78d9779df33a46",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.transaction": {
        brief: "The transaction name from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "/issues/errors-outages/",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.environment": {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        aliases: [
            "environment"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.exclusive_time": {
        brief: "The exclusive time duration of the span in milliseconds.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    160
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.graphql.operation": {
        brief: "Indicates the type of graphql operation, emitted by the Javascript SDK.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUserById",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.group": {
        brief: "Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.http.prefetch": {
        brief: "If an http request was a prefetch request.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.idle_span_finish_reason": {
        brief: "The reason why an idle span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "idleTimeout",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.is_remote": {
        brief: "Indicates whether a span's parent is remote.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.kind": {
        brief: "Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "server",
        aliases: [
            "otel.kind"
        ],
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.main_thread": {
        brief: "Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.message.parameter.<key>": {
        brief: "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry.message.parameter.0='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.message.template": {
        brief: "The parameterized template string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Hello, {name}!",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.metric.source": {
        brief: "The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "span",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    476
                ],
                description: "Added sentry.metric.source attribute"
            }
        ]
    },
    "sentry.mobile": {
        brief: "Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.module.<key>": {
        brief: "A module that was loaded in the process. The key is the name of the module.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "sentry.module.brianium/paratest='v7.7.0'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.route": {
        brief: "A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/posts/[id]/layout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.type": {
        brief: "A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "generateMetadata",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.normalized_db_query": {
        brief: "The normalized version of `db.query.text`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    194
                ]
            }
        ]
    },
    "sentry.normalized_db_query.hash": {
        brief: "The hash of `sentry.normalized_db_query`.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    200
                ]
            }
        ]
    },
    "sentry.normalized_description": {
        brief: "Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.observed_timestamp_nanos": {
        brief: "The timestamp at which an envelope was received by Relay, in nanoseconds.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1544712660300000000",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    174
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    137
                ]
            }
        ]
    },
    "sentry.op": {
        brief: "The operation of a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "http.client",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.origin": {
        brief: "The origin of the instrumentation (e.g. span, log, etc.)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "auto.http.otel.fastify",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.platform": {
        brief: "The sdk platform that generated the event.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "php",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.profiler_id": {
        brief: "The id of the currently running profiler (continuous profiling)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18779b64dd35d1a538e7ce2dd2d3fad3",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    242
                ]
            }
        ]
    },
    "sentry.profile_id": {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    344
                ],
                description: "Added sentry.profile_id attribute"
            }
        ]
    },
    "sentry.release": {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        aliases: [
            "service.version",
            "release"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_id": {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "replay_id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_is_buffering": {
        brief: "A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.report_event": {
        brief: "(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The report event is now recorded as a browser.web_vital.lcp.report_event or browser.web_vital.cls.report_event attribute. No backfill required."
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    320
                ],
                description: "Added sentry.report_event attribute"
            }
        ]
    },
    "sentry.sdk.integrations": {
        brief: "A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.",
        type: "string[]",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "InboundFilters",
            "FunctionToString",
            "BrowserApiErrors",
            "Breadcrumbs"
        ],
        changelog: [
            {
                version: "0.0.0",
                prs: [
                    42
                ]
            }
        ]
    },
    "sentry.sdk.name": {
        brief: "The sentry sdk name.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "@sentry/react",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.sdk.version": {
        brief: "The sentry sdk version.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.segment.id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        aliases: [
            "sentry.segment_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    107,
                    124
                ]
            }
        ]
    },
    "sentry.segment_id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        deprecation: {
            replacement: "sentry.segment.id"
        },
        aliases: [
            "sentry.segment.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    124
                ]
            }
        ]
    },
    "sentry.segment.name": {
        brief: "The segment name of a span",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /user",
        aliases: [
            "sentry.transaction",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Added sentry.transaction and transaction aliases"
            },
            {
                version: "0.1.0",
                prs: [
                    104
                ]
            }
        ]
    },
    "sentry.server_sample_rate": {
        brief: "Rate at which a span was sampled in Relay.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            replacement: "sentry.span.source",
            reason: "This attribute is being deprecated in favor of sentry.span.source"
        },
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.span.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    214
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.status": {
        brief: `The span's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.status_code": {
        brief: "The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    223,
                    228
                ]
            }
        ]
    },
    "sentry.status.message": {
        brief: "The from OTLP extracted status message.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "foobar",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.sveltekit.navigation.from": {
        brief: "the navigation origin (sveltekit router)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/home",
        deprecation: {
            replacement: "navigation.origin",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.from attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.to": {
        brief: "the navigation destination",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "the navigation destination is already covered by url.* attributes"
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.to attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.type": {
        brief: "The type of navigation event emitted from the sveltekit client router",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "link",
        deprecation: {
            replacement: "navigation.type",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.type attribute"
            }
        ]
    },
    "sentry.thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 56,
        deprecation: {
            replacement: "thread.id",
            reason: "This attribute is being deprecated in favor of the OTel-standard thread.id"
        },
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    451
                ]
            }
        ]
    },
    "sentry.timestamp.sequence": {
        brief: "A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.",
        type: "integer",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    262
                ]
            }
        ]
    },
    "sentry.trace_lifecycle": {
        brief: "Indicates the chosen trace lifecycle mode of the SDK (stream or static)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stream",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    442
                ],
                description: "Added sentry.trace_lifecycle attribute"
            }
        ]
    },
    "sentry.trace.parent_span_id": {
        brief: "The span id of the span that was active when the log was collected. This should not be set if there was no active span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "b0e6f15b45c36b12",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    287
                ],
                description: "Deprecate `sentry.trace.parent_span_id`"
            },
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.trace.status": {
        brief: `The segment's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.transaction": {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            reason: "This attribute is being deprecated in favor of sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Deprecated sentry.transaction in favor of sentry.segment.name"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.email"
        },
        aliases: [
            "user.email"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.city"
        },
        aliases: [
            "user.geo.city"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.country_code"
        },
        aliases: [
            "user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.region"
        },
        aliases: [
            "user.geo.region"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.subdivision"
        },
        aliases: [
            "user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.id"
        },
        aliases: [
            "user.id"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.ip": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.ip_address"
        },
        aliases: [
            "user.ip_address"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.username": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.name"
        },
        aliases: [
            "user.name"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "server.address": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    server_name: {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "This attribute is being deprecated in favor of server.address, which is the OTel-aligned replacement."
        },
        aliases: [
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    477
                ],
                description: "Added server_name attribute, deprecated in favor of server.address"
            }
        ]
    },
    "server.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        aliases: [
            "net.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.name": {
        brief: "Logical name of the service.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "omegastar",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.version": {
        brief: "The version string of the service API or implementation. The format is not defined by these conventions.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "5.0.0",
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "session.id": {
        brief: "A unique id identifying the active session at the time of setting this attribute",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "00112233-4455-6677-8899-aabbccddeeff",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    412
                ],
                description: "Added session.id attribute"
            }
        ]
    },
    stall_percentage: {
        brief: "The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_percentage attribute"
            }
        ]
    },
    stall_total_time: {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_total_time attribute"
            }
        ]
    },
    "state.type": {
        brief: "The type of state management library",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "redux",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    365
                ],
                description: "Added state.type attribute"
            }
        ]
    },
    "thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 56,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "thread.name": {
        brief: "Current thread name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "timber.tag": {
        brief: "The log tag provided by the timber logging framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyTag",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    183
                ]
            }
        ]
    },
    time_to_full_display: {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttfd.value",
            reason: "Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttfd.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttfd.value"
            }
        ]
    },
    time_to_initial_display: {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttid.value",
            reason: "Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttid.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttid.value"
            }
        ]
    },
    transaction: {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "sentry.transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Updated transaction deprecation replacement to sentry.segment.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "trpc.procedure_path": {
        brief: "The path of the tRPC procedure being called",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user.getById",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_path attribute"
            }
        ]
    },
    "trpc.procedure_type": {
        brief: "The type of the tRPC procedure",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_type attribute"
            }
        ]
    },
    ttfb: {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194,
        deprecation: {
            replacement: "browser.web_vital.ttfb.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.value"
        },
        aliases: [
            "browser.web_vital.ttfb.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "ttfb.requestTime": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        deprecation: {
            replacement: "browser.web_vital.ttfb.request_time",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time"
        },
        aliases: [
            "browser.web_vital.ttfb.request_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    type: {
        brief: "More granular type of the operation happening.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "fetch",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.component_name": {
        brief: "The name of the associated component.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeButton",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttfd": {
        brief: "Whether the span execution contributed to the TTFD (time to fully drawn) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttid": {
        brief: "Whether the span execution contributed to the TTID (time to initial display) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.element.height": {
        brief: "The height of the UI element (for Html in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 256,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.height attribute"
            }
        ]
    },
    "ui.element.id": {
        brief: "The id of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "btn-login",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.id attribute"
            }
        ]
    },
    "ui.element.identifier": {
        brief: "The identifier used to measure the UI element timing",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "heroImage",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.identifier attribute"
            }
        ]
    },
    "ui.element.load_time": {
        brief: "The loading time of a UI element (from time origin to finished loading)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 998.2234,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.load_time attribute"
            }
        ]
    },
    "ui.element.paint_type": {
        brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "image-paint",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.paint_type attribute"
            }
        ]
    },
    "ui.element.render_time": {
        brief: "The rendering time of the UI element (from time origin to finished rendering)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1023.1124,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.render_time attribute"
            }
        ]
    },
    "ui.element.type": {
        brief: "type of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.type attribute"
            }
        ]
    },
    "ui.element.url": {
        brief: "The URL of the UI element (e.g. an img src)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://assets.myapp.com/hero.png",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.url attribute"
            }
        ]
    },
    "ui.element.width": {
        brief: "The width of the UI element (for HTML in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.width attribute"
            }
        ]
    },
    url: {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "http.url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.domain": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.fragment": {
        brief: "The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.full": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        aliases: [
            "http.url",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path": {
        brief: "The URI path component.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/foo",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path.parameter.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.parameter.id='123'",
        aliases: [
            "params.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "url.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.query": {
        brief: "The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !0,
        visibility: "public",
        example: "foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "http.request.same_origin",
            reason: "This attribute is being deprecated in favor of http.request.same_origin."
        },
        aliases: [
            "http.request.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added url.same_origin attribute, deprecated in favor of http.request.same_origin"
            }
        ]
    },
    "url.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        aliases: [
            "http.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.template": {
        brief: "The low-cardinality template of an absolute path reference.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user_agent.original": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        aliases: [
            "http.user_agent"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "test@example.com",
        aliases: [
            "sentry.user.email"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.full_name": {
        brief: "User's full name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "John Smith",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Toronto",
        aliases: [
            "sentry.user.geo.city"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "CA",
        aliases: [
            "sentry.user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Canada",
        aliases: [
            "sentry.user.geo.region"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ontario",
        aliases: [
            "sentry.user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.hash": {
        brief: "Unique user hash to correlate information for a user in anonymized form.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "S-1-5-21-202424912787-2692429404-2351956786-1000",
        aliases: [
            "sentry.user.id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.ip_address": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "192.168.1.1",
        aliases: [
            "sentry.user.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    75
                ]
            }
        ]
    },
    "user.name": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "j.smith",
        aliases: [
            "sentry.user.username"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.roles": {
        brief: "Array of user roles at the time of the event.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "admin",
            "editor"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "vercel.branch": {
        brief: "Git branch name for Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.build_id": {
        brief: "Identifier for the Vercel build (only present on build logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bld_cotnkcr76",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.deployment_id": {
        brief: "Identifier for the Vercel deployment",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dpl_233NRGRjVZX1caZrXWtz5g1TAksD",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.destination": {
        brief: "Origin of the external content in Vercel (only on external logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://vitals.vercel-insights.com/v1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.edge_type": {
        brief: "Type of edge runtime in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "edge-function",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.entrypoint": {
        brief: "Entrypoint for the request in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api/index.js",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.execution_region": {
        brief: "Region where the request is executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.id": {
        brief: "Unique identifier for the log entry in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1573817187330377061717300000",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja3_digest": {
        brief: "JA3 fingerprint digest of Vercel request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja4_digest": {
        brief: "JA4 fingerprint digest",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "t13d1516h2_8daaf6152771_02713d6af862",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.log_type": {
        brief: "Vercel log output type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdout",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.path": {
        brief: "Function or dynamic path of the request in Vercel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/[route].json",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    349
                ],
                description: "Added vercel.path attribute"
            }
        ]
    },
    "vercel.project_id": {
        brief: "Identifier for the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gdufoJxB6b9b1fEqr1jUtFkyavUU",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.project_name": {
        brief: "Name of the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.cache_id": {
        brief: "Original request ID when request is served from cache",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pdx1::v8g4b-1744143786684-93dafbc0f70d",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.client_ip": {
        brief: "Client IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.75.16.101",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.host": {
        brief: "Hostname of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "test.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.lambda_region": {
        brief: "Region where lambda function executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.method": {
        brief: "HTTP method of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path": {
        brief: "Request path with query parameters",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/some-value.json?route=some-value",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type": {
        brief: "How the request was served based on its path and project configuration",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "func",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type_variant": {
        brief: "Variant of the path type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.referer": {
        brief: "Referer of the request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "*.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.region": {
        brief: "Region where the request is processed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.response_byte_size": {
        brief: "Size of the response in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.scheme": {
        brief: "Protocol of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.status_code": {
        brief: "HTTP status code of the proxy request",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.timestamp": {
        brief: "Unix timestamp when the proxy request was made",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1573817250172,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.user_agent": {
        brief: "User agent strings of the request",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Mozilla/5.0..."
        ],
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_cache": {
        brief: "Cache status sent to the browser",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "REVALIDATED",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_id": {
        brief: "Vercel-specific identifier",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1::abc123",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_action": {
        brief: "Action taken by firewall rules",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "deny",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_rule_id": {
        brief: "ID of the firewall rule that matched",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rule_gAHz8jtSB1Gy",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.request_id": {
        brief: "Identifier of the Vercel request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "643af4e3-975a-4cc7-9e7a-1eda11539d90",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.source": {
        brief: "Origin of the Vercel log (build, edge, lambda, static, external, or firewall)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "build",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.status_code": {
        brief: "HTTP status code of the request (-1 means no response returned and the lambda crashed)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    }
};
$8b11dd70aaca6dbd$export$b60c5e9f9b7b58bd = $8b11dd70aaca6dbd$var$AI_CITATIONS, $8b11dd70aaca6dbd$export$cc06afd6de7f2c10 = $8b11dd70aaca6dbd$var$AI_COMPLETION_TOKENS_USED, $8b11dd70aaca6dbd$export$ced6746028fe2cc = $8b11dd70aaca6dbd$var$AI_DOCUMENTS, $8b11dd70aaca6dbd$export$e6f4aa4f4fcb6da8 = $8b11dd70aaca6dbd$var$AI_FINISH_REASON, $8b11dd70aaca6dbd$export$f02d892201cd8d36 = $8b11dd70aaca6dbd$var$AI_FREQUENCY_PENALTY, $8b11dd70aaca6dbd$export$f277a7ef9e273960 = $8b11dd70aaca6dbd$var$AI_FUNCTION_CALL, $8b11dd70aaca6dbd$export$1a8c212c3becaa80 = $8b11dd70aaca6dbd$var$AI_GENERATION_ID, $8b11dd70aaca6dbd$export$721b137086c68a47 = $8b11dd70aaca6dbd$var$AI_INPUT_MESSAGES, $8b11dd70aaca6dbd$export$6afde2bb69d9aa86 = $8b11dd70aaca6dbd$var$AI_IS_SEARCH_REQUIRED, $8b11dd70aaca6dbd$export$eadb4b562c974031 = $8b11dd70aaca6dbd$var$AI_METADATA, $8b11dd70aaca6dbd$export$22a90f0ac1eee843 = $8b11dd70aaca6dbd$var$AI_MODEL_ID, $8b11dd70aaca6dbd$export$a727f215a0be1dad = $8b11dd70aaca6dbd$var$AI_MODEL_PROVIDER, $8b11dd70aaca6dbd$export$536bc61b34d995e5 = $8b11dd70aaca6dbd$var$AI_PIPELINE_NAME, $8b11dd70aaca6dbd$export$c43ea6115b380e62 = $8b11dd70aaca6dbd$var$AI_PREAMBLE, $8b11dd70aaca6dbd$export$d2a16e26bada7cf1 = $8b11dd70aaca6dbd$var$AI_PRESENCE_PENALTY, $8b11dd70aaca6dbd$export$604eb1bd2278163b = $8b11dd70aaca6dbd$var$AI_PROMPT_TOKENS_USED, $8b11dd70aaca6dbd$export$2f8568696c5aa352 = $8b11dd70aaca6dbd$var$AI_RAW_PROMPTING, $8b11dd70aaca6dbd$export$ccc8efd7dd31d3a9 = $8b11dd70aaca6dbd$var$AI_RESPONSES, $8b11dd70aaca6dbd$export$e176bf5dc45e40df = $8b11dd70aaca6dbd$var$AI_RESPONSE_FORMAT, $8b11dd70aaca6dbd$export$c4ea01fd53f64e16 = $8b11dd70aaca6dbd$var$AI_SEARCH_QUERIES, $8b11dd70aaca6dbd$export$bb5e6f2f31a15da9 = $8b11dd70aaca6dbd$var$AI_SEARCH_RESULTS, $8b11dd70aaca6dbd$export$1762c11b666b026a = $8b11dd70aaca6dbd$var$AI_SEED, $8b11dd70aaca6dbd$export$14ddd4b729910100 = $8b11dd70aaca6dbd$var$AI_STREAMING, $8b11dd70aaca6dbd$export$5311d7c8e1f8eabb = $8b11dd70aaca6dbd$var$AI_TAGS, $8b11dd70aaca6dbd$export$2b748b9eca00828b = $8b11dd70aaca6dbd$var$AI_TEMPERATURE, $8b11dd70aaca6dbd$export$5af25308c11addea = $8b11dd70aaca6dbd$var$AI_TEXTS, $8b11dd70aaca6dbd$export$28f78b3b1663cb92 = $8b11dd70aaca6dbd$var$AI_TOOLS, $8b11dd70aaca6dbd$export$a1d3f09f0f1f066f = $8b11dd70aaca6dbd$var$AI_TOOL_CALLS, $8b11dd70aaca6dbd$export$322bd4ea9f163663 = $8b11dd70aaca6dbd$var$AI_TOP_K, $8b11dd70aaca6dbd$export$95711b9e669edad8 = $8b11dd70aaca6dbd$var$AI_TOP_P, $8b11dd70aaca6dbd$export$5924d7d72384626a = $8b11dd70aaca6dbd$var$AI_TOTAL_COST, $8b11dd70aaca6dbd$export$db3b1b877a4ce4db = $8b11dd70aaca6dbd$var$AI_TOTAL_TOKENS_USED, $8b11dd70aaca6dbd$export$a434a3e8afec2879 = $8b11dd70aaca6dbd$var$AI_WARNINGS, $8b11dd70aaca6dbd$export$fe00bb20636d42af = $8b11dd70aaca6dbd$var$ANGULAR_VERSION, $8b11dd70aaca6dbd$export$712aa698b7ee271e = $8b11dd70aaca6dbd$var$APP_APP_BUILD, $8b11dd70aaca6dbd$export$1fac638b11ec16d9 = $8b11dd70aaca6dbd$var$APP_APP_IDENTIFIER, $8b11dd70aaca6dbd$export$d132016ea64058e3 = $8b11dd70aaca6dbd$var$APP_APP_NAME, $8b11dd70aaca6dbd$export$53f2f47ec3b2f9ed = $8b11dd70aaca6dbd$var$APP_APP_START_TIME, $8b11dd70aaca6dbd$export$9f80c4b11053cef1 = $8b11dd70aaca6dbd$var$APP_APP_VERSION, $8b11dd70aaca6dbd$export$5f7a08466d84e877 = $8b11dd70aaca6dbd$var$APP_BUILD, $8b11dd70aaca6dbd$export$2cea7f14750b8c19 = $8b11dd70aaca6dbd$var$APP_IDENTIFIER, $8b11dd70aaca6dbd$export$34c59270f032a6c6 = $8b11dd70aaca6dbd$var$APP_IN_FOREGROUND, $8b11dd70aaca6dbd$export$5b6c28c7dca07ad7 = $8b11dd70aaca6dbd$var$APP_NAME, $8b11dd70aaca6dbd$export$1dc8ae58b58d6c50 = $8b11dd70aaca6dbd$var$APP_START_COLD, $8b11dd70aaca6dbd$export$ba267414e3c0d822 = $8b11dd70aaca6dbd$var$APP_START_TIME, $8b11dd70aaca6dbd$export$71b176005902b99e = $8b11dd70aaca6dbd$var$APP_START_TYPE, $8b11dd70aaca6dbd$export$5c5b5a3c245a0079 = $8b11dd70aaca6dbd$var$APP_START_WARM, $8b11dd70aaca6dbd$export$8ee1df3c6367a60 = $8b11dd70aaca6dbd$var$APP_VERSION, $8b11dd70aaca6dbd$export$e8c7802ae95beccf = $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_DELAY_VALUE, $8b11dd70aaca6dbd$export$bb237734da4d464 = $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_FROZEN_COUNT, $8b11dd70aaca6dbd$export$cdaaf6d1fdcba0b6 = $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_SLOW_COUNT, $8b11dd70aaca6dbd$export$36223ebd4a30e9f5 = $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_TOTAL_COUNT, $8b11dd70aaca6dbd$export$8feaa177bb7941e2 = $8b11dd70aaca6dbd$var$APP_VITALS_START_COLD_VALUE, $8b11dd70aaca6dbd$export$e1ca25240db91d68 = $8b11dd70aaca6dbd$var$APP_VITALS_START_PREWARMED, $8b11dd70aaca6dbd$export$404a223fd1ada08b = $8b11dd70aaca6dbd$var$APP_VITALS_START_REASON, $8b11dd70aaca6dbd$export$53362079310c68 = $8b11dd70aaca6dbd$var$APP_VITALS_START_SCREEN, $8b11dd70aaca6dbd$export$3efb5af0ac379f77 = $8b11dd70aaca6dbd$var$APP_VITALS_START_TYPE, $8b11dd70aaca6dbd$export$2c10c1ca0612c46d = $8b11dd70aaca6dbd$var$APP_VITALS_START_WARM_VALUE, $8b11dd70aaca6dbd$export$bbb86ad4d6654da6 = $8b11dd70aaca6dbd$var$APP_VITALS_TTFD_VALUE, $8b11dd70aaca6dbd$export$ad6896f00a2b1076 = $8b11dd70aaca6dbd$var$APP_VITALS_TTID_VALUE, $8b11dd70aaca6dbd$export$300f39d8506a273d = $8b11dd70aaca6dbd$var$ART_GC_BLOCKING_COUNT, $8b11dd70aaca6dbd$export$ecaa0e7f4773ddc7 = $8b11dd70aaca6dbd$var$ART_GC_BLOCKING_TIME, $8b11dd70aaca6dbd$export$74b78acb4c54c06b = $8b11dd70aaca6dbd$var$ART_GC_PRE_OOME_COUNT, $8b11dd70aaca6dbd$export$b15b2c133bc50e33 = $8b11dd70aaca6dbd$var$ART_GC_TOTAL_COUNT, $8b11dd70aaca6dbd$export$5f1381d9ae1b1c95 = $8b11dd70aaca6dbd$var$ART_GC_TOTAL_TIME, $8b11dd70aaca6dbd$export$c170b7ff277132ea = $8b11dd70aaca6dbd$var$ART_GC_WAITING_TIME, $8b11dd70aaca6dbd$export$9459a5df93695e45 = $8b11dd70aaca6dbd$var$ART_MEMORY_FREE, $8b11dd70aaca6dbd$export$a7902bd57492ebe8 = $8b11dd70aaca6dbd$var$ART_MEMORY_FREE_UNTIL_GC, $8b11dd70aaca6dbd$export$d2ace0da59da09b7 = $8b11dd70aaca6dbd$var$ART_MEMORY_FREE_UNTIL_OOME, $8b11dd70aaca6dbd$export$c15dd8d2461e0aeb = $8b11dd70aaca6dbd$var$ART_MEMORY_MAX, $8b11dd70aaca6dbd$export$5405b0a98e00e538 = $8b11dd70aaca6dbd$var$ART_MEMORY_TOTAL, $8b11dd70aaca6dbd$export$bd393bbb84b309d3 = $8b11dd70aaca6dbd$var$ATTRIBUTE_METADATA, $8b11dd70aaca6dbd$export$96f586f8837b86ae = $8b11dd70aaca6dbd$var$ATTRIBUTE_TYPE, $8b11dd70aaca6dbd$export$5d9f28f388f552d2 = $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP, $8b11dd70aaca6dbd$export$b3d2f68e0e769504 = $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM, $8b11dd70aaca6dbd$export$2c98412ed43013e8 = $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_URL, $8b11dd70aaca6dbd$export$a7bd794d11c19f1b = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS, $8b11dd70aaca6dbd$export$df4227832b83fdd0 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_CONSISTENT_READ, $8b11dd70aaca6dbd$export$f131a6d8fbc0534f = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_CONSUMED_CAPACITY, $8b11dd70aaca6dbd$export$9bdc66d4a70e7e3a = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_COUNT, $8b11dd70aaca6dbd$export$bfbbc3cbcaa90e98 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE, $8b11dd70aaca6dbd$export$3565fa72459aa4d6 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES, $8b11dd70aaca6dbd$export$bb67a834ae4bffdc = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES, $8b11dd70aaca6dbd$export$4a06c859a283f06 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_INDEX_NAME, $8b11dd70aaca6dbd$export$68324fac2038d0f2 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS, $8b11dd70aaca6dbd$export$5e1bd62ffd2786fb = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_LIMIT, $8b11dd70aaca6dbd$export$bfdf2261058f56b = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES, $8b11dd70aaca6dbd$export$23bf57842d9d53df = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROJECTION, $8b11dd70aaca6dbd$export$bfbd7e060eeb4d35 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY, $8b11dd70aaca6dbd$export$82eb6cccda27c3ff = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY, $8b11dd70aaca6dbd$export$8ea68734d455808f = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SCANNED_COUNT, $8b11dd70aaca6dbd$export$40050e29324d44ee = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SCAN_FORWARD, $8b11dd70aaca6dbd$export$5cd7541006d9f467 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SEGMENT, $8b11dd70aaca6dbd$export$81c017edd95d692e = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SELECT, $8b11dd70aaca6dbd$export$120b3897a58cf903 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TABLE_COUNT, $8b11dd70aaca6dbd$export$d4a9de43b4b1076c = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TABLE_NAMES, $8b11dd70aaca6dbd$export$f37f4f9022f1ab17 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TOTAL_SEGMENTS, $8b11dd70aaca6dbd$export$66ac18da14747cfb = $8b11dd70aaca6dbd$var$AWS_EXTENDED_REQUEST_ID, $8b11dd70aaca6dbd$export$9e49b833525ca49d = $8b11dd70aaca6dbd$var$AWS_KINESIS_STREAM_NAME, $8b11dd70aaca6dbd$export$b084fea5b3097227 = $8b11dd70aaca6dbd$var$AWS_LAMBDA_AWS_REQUEST_ID, $8b11dd70aaca6dbd$export$e09cd8615652e8d0 = $8b11dd70aaca6dbd$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS, $8b11dd70aaca6dbd$export$a43a60ec723a90ee = $8b11dd70aaca6dbd$var$AWS_LAMBDA_FUNCTION_NAME, $8b11dd70aaca6dbd$export$34cc955357266287 = $8b11dd70aaca6dbd$var$AWS_LAMBDA_FUNCTION_VERSION, $8b11dd70aaca6dbd$export$d9dd218693ea9bba = $8b11dd70aaca6dbd$var$AWS_LAMBDA_INVOKED_ARN, $8b11dd70aaca6dbd$export$c9649b7156282a2f = $8b11dd70aaca6dbd$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN, $8b11dd70aaca6dbd$export$daa8ce1f8adc553e = $8b11dd70aaca6dbd$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS, $8b11dd70aaca6dbd$export$cb93c7b05db202cf = $8b11dd70aaca6dbd$var$AWS_LOG_GROUP_NAMES, $8b11dd70aaca6dbd$export$930f9bd3cc2e5b3d = $8b11dd70aaca6dbd$var$AWS_LOG_STREAM_NAMES, $8b11dd70aaca6dbd$export$48c6d4c44afdc0b = $8b11dd70aaca6dbd$var$AWS_REQUEST_EXTENDED_ID, $8b11dd70aaca6dbd$export$c78d41789fe4b1e4 = $8b11dd70aaca6dbd$var$AWS_REQUEST_ID, $8b11dd70aaca6dbd$export$f462d9921f1f7332 = $8b11dd70aaca6dbd$var$AWS_S3_BUCKET, $8b11dd70aaca6dbd$export$bc71f8df9a45e243 = $8b11dd70aaca6dbd$var$AWS_SECRETSMANAGER_SECRET_ARN, $8b11dd70aaca6dbd$export$ed840ec4a5f5d053 = $8b11dd70aaca6dbd$var$AWS_SNS_TOPIC_ARN, $8b11dd70aaca6dbd$export$c1a559a4f74a5e8e = $8b11dd70aaca6dbd$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN, $8b11dd70aaca6dbd$export$d1c007424092e3f5 = $8b11dd70aaca6dbd$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN, $8b11dd70aaca6dbd$export$9ebb466ce954c49c = $8b11dd70aaca6dbd$var$BLOCKED_MAIN_THREAD, $8b11dd70aaca6dbd$export$e9aafc7348984403 = $8b11dd70aaca6dbd$var$BROWSER_NAME, $8b11dd70aaca6dbd$export$faaa46964f075237 = $8b11dd70aaca6dbd$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START, $8b11dd70aaca6dbd$export$d28c4b3cc4431a87 = $8b11dd70aaca6dbd$var$BROWSER_PERFORMANCE_TIME_ORIGIN, $8b11dd70aaca6dbd$export$734b017b330c8fe6 = $8b11dd70aaca6dbd$var$BROWSER_REPORT_TYPE, $8b11dd70aaca6dbd$export$683ebdc48ba3758d = $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_INVOKER, $8b11dd70aaca6dbd$export$be0263971250ef44 = $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_INVOKER_TYPE, $8b11dd70aaca6dbd$export$36a0cbc35c405232 = $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION, $8b11dd70aaca6dbd$export$469f7765ba335497 = $8b11dd70aaca6dbd$var$BROWSER_VERSION, $8b11dd70aaca6dbd$export$fe6fe2b7af051610 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT, $8b11dd70aaca6dbd$export$8345821877c4dfad = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY, $8b11dd70aaca6dbd$export$f6c188a7e02335cf = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE, $8b11dd70aaca6dbd$export$aaf709a8971e825f = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_VALUE, $8b11dd70aaca6dbd$export$def01b82f8c092f7 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_FCP_VALUE, $8b11dd70aaca6dbd$export$23d4264c606a73a6 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_FP_VALUE, $8b11dd70aaca6dbd$export$af9ece53bb92f66b = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_INP_VALUE, $8b11dd70aaca6dbd$export$25421625a565b69 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_ELEMENT, $8b11dd70aaca6dbd$export$ab0c90d873e69ccb = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_ID, $8b11dd70aaca6dbd$export$538c05cc8cb2a2bb = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME, $8b11dd70aaca6dbd$export$f86df4de196e1a7c = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME, $8b11dd70aaca6dbd$export$51e8aa8c0d65e7b8 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT, $8b11dd70aaca6dbd$export$99023486ecc470bd = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_SIZE, $8b11dd70aaca6dbd$export$2f6c85eaf382e81 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_URL, $8b11dd70aaca6dbd$export$1158d57c0aed42be = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_VALUE, $8b11dd70aaca6dbd$export$d85c4f947ab776e3 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME, $8b11dd70aaca6dbd$export$813ef8386d874918 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_TTFB_VALUE, $8b11dd70aaca6dbd$export$7c2f74ff9251f64 = $8b11dd70aaca6dbd$var$CACHE_HIT, $8b11dd70aaca6dbd$export$993f84dab107b880 = $8b11dd70aaca6dbd$var$CACHE_ITEM_SIZE, $8b11dd70aaca6dbd$export$7b9c2315e94d8d2f = $8b11dd70aaca6dbd$var$CACHE_KEY, $8b11dd70aaca6dbd$export$f01e5cd42b9ec146 = $8b11dd70aaca6dbd$var$CACHE_OPERATION, $8b11dd70aaca6dbd$export$987f6b4367434b55 = $8b11dd70aaca6dbd$var$CACHE_TTL, $8b11dd70aaca6dbd$export$d9d145585d5022bb = $8b11dd70aaca6dbd$var$CACHE_WRITE, $8b11dd70aaca6dbd$export$44ffba16bd48dac6 = $8b11dd70aaca6dbd$var$CHANNEL, $8b11dd70aaca6dbd$export$3134892c5d2e251a = $8b11dd70aaca6dbd$var$CLIENT_ADDRESS, $8b11dd70aaca6dbd$export$8495028d10296058 = $8b11dd70aaca6dbd$var$CLIENT_PORT, $8b11dd70aaca6dbd$export$d6d0e4fcf46d490c = $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_DURATION, $8b11dd70aaca6dbd$export$658dced473c19301 = $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_QUERY_TYPE, $8b11dd70aaca6dbd$export$97b0f9c3fbe64076 = $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_ROWS_READ, $8b11dd70aaca6dbd$export$cf2c95ed5efbe9eb = $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_ROWS_WRITTEN, $8b11dd70aaca6dbd$export$880007904f61a388 = $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS, $8b11dd70aaca6dbd$export$3e903b72d4d9e07d = $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ, $8b11dd70aaca6dbd$export$34da07180e0e56af = $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN, $8b11dd70aaca6dbd$export$c49aafdaeb061953 = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_BUCKET, $8b11dd70aaca6dbd$export$ceb762c61de2f17f = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_OPERATION, $8b11dd70aaca6dbd$export$a5f54ccfb28c0caf = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_DELIMITER, $8b11dd70aaca6dbd$export$1c86a56857b024db = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_KEY, $8b11dd70aaca6dbd$export$7598f3464be47440 = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER, $8b11dd70aaca6dbd$export$b673289c971fc0ae = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_PREFIX, $8b11dd70aaca6dbd$export$98b23f3e6f0c2a6f = $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_ATTEMPT, $8b11dd70aaca6dbd$export$6ddeaf0498614ebb = $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF, $8b11dd70aaca6dbd$export$97b78f78d64a7232 = $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY, $8b11dd70aaca6dbd$export$5147715be870fff7 = $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT, $8b11dd70aaca6dbd$export$5276bb46e6096fba = $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_TIMEOUT, $8b11dd70aaca6dbd$export$cbcbc1f67a937cf3 = $8b11dd70aaca6dbd$var$CLOUD_ACCOUNT_ID, $8b11dd70aaca6dbd$export$226a2381b8f0cf78 = $8b11dd70aaca6dbd$var$CLOUD_AVAILABILITY_ZONE, $8b11dd70aaca6dbd$export$fd35512cae286064 = $8b11dd70aaca6dbd$var$CLOUD_PLATFORM, $8b11dd70aaca6dbd$export$de9bbf95ab1d81e = $8b11dd70aaca6dbd$var$CLOUD_PROVIDER, $8b11dd70aaca6dbd$export$47fb20e8d18d7d15 = $8b11dd70aaca6dbd$var$CLOUD_REGION, $8b11dd70aaca6dbd$export$9db7964e4b8cb849 = $8b11dd70aaca6dbd$var$CLOUD_RESOURCE_ID, $8b11dd70aaca6dbd$export$7139adf9d3bace41 = "cls", $8b11dd70aaca6dbd$export$8ac3d09060e7f25d = $8b11dd70aaca6dbd$var$CLS_SOURCE_KEY, $8b11dd70aaca6dbd$export$dad0e4778ea23971 = $8b11dd70aaca6dbd$var$CLS_SOURCE_KEY_BASE, $8b11dd70aaca6dbd$export$c14d903ccf9385a8 = $8b11dd70aaca6dbd$var$CODE_FILEPATH, $8b11dd70aaca6dbd$export$934cded0041affd7 = $8b11dd70aaca6dbd$var$CODE_FILE_PATH, $8b11dd70aaca6dbd$export$6386da1dcba88c9d = $8b11dd70aaca6dbd$var$CODE_FUNCTION, $8b11dd70aaca6dbd$export$a3371797e606e2 = $8b11dd70aaca6dbd$var$CODE_FUNCTION_NAME, $8b11dd70aaca6dbd$export$a5bbef0af83b23e5 = $8b11dd70aaca6dbd$var$CODE_LINENO, $8b11dd70aaca6dbd$export$91ed1f55874222a6 = $8b11dd70aaca6dbd$var$CODE_LINE_NUMBER, $8b11dd70aaca6dbd$export$23de81068d2aed1b = $8b11dd70aaca6dbd$var$CODE_NAMESPACE, $8b11dd70aaca6dbd$export$d738320e1fba9e9d = $8b11dd70aaca6dbd$var$CONNECTIONTYPE, $8b11dd70aaca6dbd$export$2eacdea75497e8a5 = $8b11dd70aaca6dbd$var$CONNECTION_RTT, $8b11dd70aaca6dbd$export$2bc3ea101f86c1d2 = $8b11dd70aaca6dbd$var$CULTURE_CALENDAR, $8b11dd70aaca6dbd$export$c54e27e8d90ee081 = $8b11dd70aaca6dbd$var$CULTURE_DISPLAY_NAME, $8b11dd70aaca6dbd$export$4943adcec371c2a6 = $8b11dd70aaca6dbd$var$CULTURE_IS_24_HOUR_FORMAT, $8b11dd70aaca6dbd$export$f000a5900d0480c2 = $8b11dd70aaca6dbd$var$CULTURE_LOCALE, $8b11dd70aaca6dbd$export$8f5234893868273b = $8b11dd70aaca6dbd$var$CULTURE_TIMEZONE, $8b11dd70aaca6dbd$export$1a35518f6e81e8c7 = $8b11dd70aaca6dbd$var$DB_COLLECTION_NAME, $8b11dd70aaca6dbd$export$a2d90911eaae60fc = $8b11dd70aaca6dbd$var$DB_DRIVER_NAME, $8b11dd70aaca6dbd$export$3c22ff8b64b8f565 = $8b11dd70aaca6dbd$var$DB_NAME, $8b11dd70aaca6dbd$export$b8019c0e2a5b5f0f = $8b11dd70aaca6dbd$var$DB_NAMESPACE, $8b11dd70aaca6dbd$export$8c11477e471467c8 = $8b11dd70aaca6dbd$var$DB_OPERATION, $8b11dd70aaca6dbd$export$92a96f6363488aee = $8b11dd70aaca6dbd$var$DB_OPERATION_BATCH_SIZE, $8b11dd70aaca6dbd$export$f91beb6088f9ded9 = $8b11dd70aaca6dbd$var$DB_OPERATION_NAME, $8b11dd70aaca6dbd$export$78bc7224576bf289 = $8b11dd70aaca6dbd$var$DB_QUERY_PARAMETER_KEY, $8b11dd70aaca6dbd$export$a8027e0ea0d93ca = $8b11dd70aaca6dbd$var$DB_QUERY_PARAMETER_KEY_BASE, $8b11dd70aaca6dbd$export$5e59d3aea52e5037 = $8b11dd70aaca6dbd$var$DB_QUERY_SUMMARY, $8b11dd70aaca6dbd$export$47e408be0da7933f = $8b11dd70aaca6dbd$var$DB_QUERY_TEXT, $8b11dd70aaca6dbd$export$d5772b934ca13e57 = $8b11dd70aaca6dbd$var$DB_REDIS_CONNECTION, $8b11dd70aaca6dbd$export$36e47f6a5777561d = $8b11dd70aaca6dbd$var$DB_REDIS_KEY, $8b11dd70aaca6dbd$export$e768cbc99cd68acf = $8b11dd70aaca6dbd$var$DB_REDIS_PARAMETERS, $8b11dd70aaca6dbd$export$dfcc6c69df1343f2 = $8b11dd70aaca6dbd$var$DB_RESPONSE_STATUS_CODE, $8b11dd70aaca6dbd$export$69b0a5d9226b5211 = $8b11dd70aaca6dbd$var$DB_SQL_BINDINGS, $8b11dd70aaca6dbd$export$da010a4f4fc971ae = $8b11dd70aaca6dbd$var$DB_STATEMENT, $8b11dd70aaca6dbd$export$5d515b35be0601a0 = $8b11dd70aaca6dbd$var$DB_STORED_PROCEDURE_NAME, $8b11dd70aaca6dbd$export$3e1b1037a315c5ca = $8b11dd70aaca6dbd$var$DB_SYSTEM, $8b11dd70aaca6dbd$export$847fdd494825f0fb = $8b11dd70aaca6dbd$var$DB_SYSTEM_NAME, $8b11dd70aaca6dbd$export$a9d76f26c6c730a9 = $8b11dd70aaca6dbd$var$DB_USER, $8b11dd70aaca6dbd$export$de03f86d1c9866ca = $8b11dd70aaca6dbd$var$DEVICEMEMORY, $8b11dd70aaca6dbd$export$65798ecab7eef8c = $8b11dd70aaca6dbd$var$DEVICE_ARCHS, $8b11dd70aaca6dbd$export$22aa61f48b9c79a0 = $8b11dd70aaca6dbd$var$DEVICE_BATTERY_LEVEL, $8b11dd70aaca6dbd$export$69f5fb98f5aed812 = $8b11dd70aaca6dbd$var$DEVICE_BATTERY_TEMPERATURE, $8b11dd70aaca6dbd$export$bdea5d1006fd280a = $8b11dd70aaca6dbd$var$DEVICE_BOOT_TIME, $8b11dd70aaca6dbd$export$f63a7230c5b1d609 = $8b11dd70aaca6dbd$var$DEVICE_BRAND, $8b11dd70aaca6dbd$export$6f25e59b05bb8e17 = $8b11dd70aaca6dbd$var$DEVICE_CHARGING, $8b11dd70aaca6dbd$export$a56ad13c4afc7421 = $8b11dd70aaca6dbd$var$DEVICE_CHIPSET, $8b11dd70aaca6dbd$export$d9ce89ce8912bf12 = $8b11dd70aaca6dbd$var$DEVICE_CLASS, $8b11dd70aaca6dbd$export$17094e5f380e4162 = $8b11dd70aaca6dbd$var$DEVICE_CONNECTION_TYPE, $8b11dd70aaca6dbd$export$28a0ffdf747973a0 = $8b11dd70aaca6dbd$var$DEVICE_CPU_DESCRIPTION, $8b11dd70aaca6dbd$export$5480ae1ba5d50bb9 = $8b11dd70aaca6dbd$var$DEVICE_EXTERNAL_FREE_STORAGE, $8b11dd70aaca6dbd$export$edc72ee4a17f5152 = $8b11dd70aaca6dbd$var$DEVICE_EXTERNAL_STORAGE_SIZE, $8b11dd70aaca6dbd$export$19e4df138d354f8b = $8b11dd70aaca6dbd$var$DEVICE_FAMILY, $8b11dd70aaca6dbd$export$92b0d20fa482b4b2 = $8b11dd70aaca6dbd$var$DEVICE_FREE_MEMORY, $8b11dd70aaca6dbd$export$3f638a793d61933f = $8b11dd70aaca6dbd$var$DEVICE_FREE_STORAGE, $8b11dd70aaca6dbd$export$3f511731cc3687d4 = $8b11dd70aaca6dbd$var$DEVICE_ID, $8b11dd70aaca6dbd$export$692b08741d6b6265 = $8b11dd70aaca6dbd$var$DEVICE_LOCALE, $8b11dd70aaca6dbd$export$cf67f8cb2324428e = $8b11dd70aaca6dbd$var$DEVICE_LOW_MEMORY, $8b11dd70aaca6dbd$export$9d4197c1ffc5f359 = $8b11dd70aaca6dbd$var$DEVICE_LOW_POWER_MODE, $8b11dd70aaca6dbd$export$509634fbff540e75 = $8b11dd70aaca6dbd$var$DEVICE_MANUFACTURER, $8b11dd70aaca6dbd$export$ccbc4fdff4b5eff5 = $8b11dd70aaca6dbd$var$DEVICE_MEMORY_ESTIMATED_CAPACITY, $8b11dd70aaca6dbd$export$e0cb371ca548b1d6 = $8b11dd70aaca6dbd$var$DEVICE_MEMORY_SIZE, $8b11dd70aaca6dbd$export$3c39026d09026bc2 = $8b11dd70aaca6dbd$var$DEVICE_MODEL, $8b11dd70aaca6dbd$export$bf9e8248cb72cf00 = $8b11dd70aaca6dbd$var$DEVICE_MODEL_ID, $8b11dd70aaca6dbd$export$1054f22a72121d0f = $8b11dd70aaca6dbd$var$DEVICE_NAME, $8b11dd70aaca6dbd$export$723b8a59dad2e467 = $8b11dd70aaca6dbd$var$DEVICE_ONLINE, $8b11dd70aaca6dbd$export$160081ff141bac8e = $8b11dd70aaca6dbd$var$DEVICE_ORIENTATION, $8b11dd70aaca6dbd$export$194f62c84d27310 = $8b11dd70aaca6dbd$var$DEVICE_PROCESSOR_COUNT, $8b11dd70aaca6dbd$export$7ed866d57b018d09 = $8b11dd70aaca6dbd$var$DEVICE_PROCESSOR_FREQUENCY, $8b11dd70aaca6dbd$export$d50bae4562e03e5 = $8b11dd70aaca6dbd$var$DEVICE_SCREEN_DENSITY, $8b11dd70aaca6dbd$export$649ea67a18fe8e8b = $8b11dd70aaca6dbd$var$DEVICE_SCREEN_DPI, $8b11dd70aaca6dbd$export$136a5c1b43caaccd = $8b11dd70aaca6dbd$var$DEVICE_SCREEN_HEIGHT_PIXELS, $8b11dd70aaca6dbd$export$e33a28ea554b6ddc = $8b11dd70aaca6dbd$var$DEVICE_SCREEN_WIDTH_PIXELS, $8b11dd70aaca6dbd$export$acbe2d25ac76ea64 = $8b11dd70aaca6dbd$var$DEVICE_SIMULATOR, $8b11dd70aaca6dbd$export$793c13e17d7e5e2b = $8b11dd70aaca6dbd$var$DEVICE_STORAGE_SIZE, $8b11dd70aaca6dbd$export$a5617e33b89fd956 = $8b11dd70aaca6dbd$var$DEVICE_THERMAL_STATE, $8b11dd70aaca6dbd$export$b51f82164fa31e07 = $8b11dd70aaca6dbd$var$DEVICE_TIMEZONE, $8b11dd70aaca6dbd$export$f2ef55183c04d202 = $8b11dd70aaca6dbd$var$DEVICE_USABLE_MEMORY, $8b11dd70aaca6dbd$export$7c98fc0c48a16b1c = $8b11dd70aaca6dbd$var$DIST, $8b11dd70aaca6dbd$export$f0511e328234ae83 = $8b11dd70aaca6dbd$var$EFFECTIVECONNECTIONTYPE, $8b11dd70aaca6dbd$export$be46596bc6608f3b = $8b11dd70aaca6dbd$var$ENVIRONMENT, $8b11dd70aaca6dbd$export$f215947b3d76a6b7 = $8b11dd70aaca6dbd$var$ERROR_TYPE, $8b11dd70aaca6dbd$export$89bbc91416db6670 = $8b11dd70aaca6dbd$var$EVENT_ID, $8b11dd70aaca6dbd$export$b4b5eff8a8712c89 = $8b11dd70aaca6dbd$var$EVENT_NAME, $8b11dd70aaca6dbd$export$f455969a57ab8a03 = $8b11dd70aaca6dbd$var$EXCEPTION_ESCAPED, $8b11dd70aaca6dbd$export$13f2f8f42af49cec = $8b11dd70aaca6dbd$var$EXCEPTION_MESSAGE, $8b11dd70aaca6dbd$export$cd357afe2ffdd2c3 = $8b11dd70aaca6dbd$var$EXCEPTION_STACKTRACE, $8b11dd70aaca6dbd$export$d9ca2a279a11be5e = $8b11dd70aaca6dbd$var$EXCEPTION_TYPE, $8b11dd70aaca6dbd$export$bbd59a8c7efad4c9 = $8b11dd70aaca6dbd$var$FAAS_COLDSTART, $8b11dd70aaca6dbd$export$8413282a17f1cda5 = $8b11dd70aaca6dbd$var$FAAS_CRON, $8b11dd70aaca6dbd$export$30d19ddc7705e7e8 = $8b11dd70aaca6dbd$var$FAAS_DURATION_IN_MS, $8b11dd70aaca6dbd$export$64a4f09e2444b3d = $8b11dd70aaca6dbd$var$FAAS_ENTRY_POINT, $8b11dd70aaca6dbd$export$645b039fe163809e = $8b11dd70aaca6dbd$var$FAAS_EXECUTION, $8b11dd70aaca6dbd$export$b23ef8b8ffa607e1 = $8b11dd70aaca6dbd$var$FAAS_ID, $8b11dd70aaca6dbd$export$8bf64516740c1369 = $8b11dd70aaca6dbd$var$FAAS_IDENTITY, $8b11dd70aaca6dbd$export$9a0dc8e612f3e10b = $8b11dd70aaca6dbd$var$FAAS_INVOCATION_ID, $8b11dd70aaca6dbd$export$abe90fedb3dddda2 = $8b11dd70aaca6dbd$var$FAAS_INVOKED_NAME, $8b11dd70aaca6dbd$export$4a19da9c85ed2ade = $8b11dd70aaca6dbd$var$FAAS_INVOKED_PROVIDER, $8b11dd70aaca6dbd$export$5e091479f094bdbc = $8b11dd70aaca6dbd$var$FAAS_INVOKED_REGION, $8b11dd70aaca6dbd$export$d70909b5aa96a79a = $8b11dd70aaca6dbd$var$FAAS_NAME, $8b11dd70aaca6dbd$export$651d142a8017d83d = $8b11dd70aaca6dbd$var$FAAS_TIME, $8b11dd70aaca6dbd$export$44382a010a9f7fcf = $8b11dd70aaca6dbd$var$FAAS_TRIGGER, $8b11dd70aaca6dbd$export$807abfdc6b7b9338 = $8b11dd70aaca6dbd$var$FAAS_VERSION, $8b11dd70aaca6dbd$export$31881d07f2569218 = "fcp", $8b11dd70aaca6dbd$export$e5bbf306deb709a6 = $8b11dd70aaca6dbd$var$FLAG_EVALUATION_KEY, $8b11dd70aaca6dbd$export$aa8721167c5c8d2d = $8b11dd70aaca6dbd$var$FLAG_EVALUATION_KEY_BASE, $8b11dd70aaca6dbd$export$757b93e5b3adc7cb = "fp", $8b11dd70aaca6dbd$export$f869eaa92db1dc9b = $8b11dd70aaca6dbd$var$FRAMES_DELAY, $8b11dd70aaca6dbd$export$5d1d761e41c32d9e = $8b11dd70aaca6dbd$var$FRAMES_FROZEN, $8b11dd70aaca6dbd$export$8aec72d9491f9399 = $8b11dd70aaca6dbd$var$FRAMES_FROZEN_RATE, $8b11dd70aaca6dbd$export$5562635d2be2ab25 = $8b11dd70aaca6dbd$var$FRAMES_SLOW, $8b11dd70aaca6dbd$export$2dc31837ce6f7a3d = $8b11dd70aaca6dbd$var$FRAMES_SLOW_RATE, $8b11dd70aaca6dbd$export$b561df15f64d32e3 = $8b11dd70aaca6dbd$var$FRAMES_TOTAL, $8b11dd70aaca6dbd$export$181f78b28f2ffa57 = $8b11dd70aaca6dbd$var$FS_ERROR, $8b11dd70aaca6dbd$export$6c97c77b89571c75 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_EVENT_ID, $8b11dd70aaca6dbd$export$51e431eaf1f9bf58 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE, $8b11dd70aaca6dbd$export$71429c7ef7cb7063 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_ID, $8b11dd70aaca6dbd$export$99905d7583a6e8ac = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_RESOURCE, $8b11dd70aaca6dbd$export$b6c4be74fd0c06bd = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_SOURCE, $8b11dd70aaca6dbd$export$fd23e5b8d261a89 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_SPECVERSION, $8b11dd70aaca6dbd$export$25fabc9b3d1dd567 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TIME, $8b11dd70aaca6dbd$export$41507f7b07dad151 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TIMESTAMP, $8b11dd70aaca6dbd$export$1352f3699c35dd73 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TYPE, $8b11dd70aaca6dbd$export$fd6c9d5c74d943ac = $8b11dd70aaca6dbd$var$GCP_PROJECT_ID, $8b11dd70aaca6dbd$export$c29634e3cf41e479 = $8b11dd70aaca6dbd$var$GEN_AI_AGENT_NAME, $8b11dd70aaca6dbd$export$e6a60882cce7a085 = $8b11dd70aaca6dbd$var$GEN_AI_CONTEXT_UTILIZATION, $8b11dd70aaca6dbd$export$6773c9098ba5e194 = $8b11dd70aaca6dbd$var$GEN_AI_CONTEXT_WINDOW_SIZE, $8b11dd70aaca6dbd$export$6ee6b62f50047686 = $8b11dd70aaca6dbd$var$GEN_AI_CONVERSATION_ID, $8b11dd70aaca6dbd$export$efac052bb3661242 = $8b11dd70aaca6dbd$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS, $8b11dd70aaca6dbd$export$7ccd63b9ca955862 = $8b11dd70aaca6dbd$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS, $8b11dd70aaca6dbd$export$50921df5a58cb3ef = $8b11dd70aaca6dbd$var$GEN_AI_COST_INPUT_TOKENS, $8b11dd70aaca6dbd$export$8e48efc7acb57a97 = $8b11dd70aaca6dbd$var$GEN_AI_COST_OUTPUT_TOKENS, $8b11dd70aaca6dbd$export$cea9121727113f77 = $8b11dd70aaca6dbd$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS, $8b11dd70aaca6dbd$export$bed35ff7f9af3aaa = $8b11dd70aaca6dbd$var$GEN_AI_COST_TOTAL_TOKENS, $8b11dd70aaca6dbd$export$6b729e898b9067ce = $8b11dd70aaca6dbd$var$GEN_AI_EMBEDDINGS_INPUT, $8b11dd70aaca6dbd$export$984fbab9b52f7e24 = $8b11dd70aaca6dbd$var$GEN_AI_FUNCTION_ID, $8b11dd70aaca6dbd$export$9ea17906a87ada6f = $8b11dd70aaca6dbd$var$GEN_AI_INPUT_MESSAGES, $8b11dd70aaca6dbd$export$394b443aaff3ef92 = $8b11dd70aaca6dbd$var$GEN_AI_OPERATION_NAME, $8b11dd70aaca6dbd$export$6ddc374adbc06720 = $8b11dd70aaca6dbd$var$GEN_AI_OPERATION_TYPE, $8b11dd70aaca6dbd$export$ab8c7ebc9add56b2 = $8b11dd70aaca6dbd$var$GEN_AI_OUTPUT_MESSAGES, $8b11dd70aaca6dbd$export$40ecc5bcd633d1ee = $8b11dd70aaca6dbd$var$GEN_AI_PIPELINE_NAME, $8b11dd70aaca6dbd$export$86a8df7fff52fc69 = $8b11dd70aaca6dbd$var$GEN_AI_PROMPT, $8b11dd70aaca6dbd$export$cf2115d46768f4c5 = $8b11dd70aaca6dbd$var$GEN_AI_PROMPT_NAME, $8b11dd70aaca6dbd$export$3d7e036e195764db = $8b11dd70aaca6dbd$var$GEN_AI_PROVIDER_NAME, $8b11dd70aaca6dbd$export$60c1d11221608cee = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_AVAILABLE_TOOLS, $8b11dd70aaca6dbd$export$bc3cef164abbc42c = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_FREQUENCY_PENALTY, $8b11dd70aaca6dbd$export$43f9afb62cd79dec = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MAX_TOKENS, $8b11dd70aaca6dbd$export$a5ab4ffc4765f75f = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MESSAGES, $8b11dd70aaca6dbd$export$ccf46db9ab1743ec = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MODEL, $8b11dd70aaca6dbd$export$76c1c247342d776 = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_PRESENCE_PENALTY, $8b11dd70aaca6dbd$export$92f5944f0b02c9fb = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_REASONING_EFFORT, $8b11dd70aaca6dbd$export$867eeefcb1c95b27 = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_SEED, $8b11dd70aaca6dbd$export$5ada4697ae6aa17e = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_STOP_SEQUENCES, $8b11dd70aaca6dbd$export$427122300e8d54d0 = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TEMPERATURE, $8b11dd70aaca6dbd$export$bcea8881375c352f = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TOP_K, $8b11dd70aaca6dbd$export$b867715f9a0c04e9 = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TOP_P, $8b11dd70aaca6dbd$export$69878a39cbdbe097 = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_FINISH_REASONS, $8b11dd70aaca6dbd$export$584c61a1b769552d = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_ID, $8b11dd70aaca6dbd$export$8169ebcb0b0331dd = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_MODEL, $8b11dd70aaca6dbd$export$2c9713b624877853 = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_STREAMING, $8b11dd70aaca6dbd$export$45942692aeb454e0 = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TEXT, $8b11dd70aaca6dbd$export$8e5efeaa031210cd = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK, $8b11dd70aaca6dbd$export$35a62769ee05a05a = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN, $8b11dd70aaca6dbd$export$8ea4f7e986ca4b06 = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND, $8b11dd70aaca6dbd$export$d2fd9ecaff0285a4 = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TOOL_CALLS, $8b11dd70aaca6dbd$export$a6c8e656a4f9bb67 = $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM, $8b11dd70aaca6dbd$export$352a8075b163d53 = $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM_INSTRUCTIONS, $8b11dd70aaca6dbd$export$426d7b90ba5d79db = $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM_MESSAGE, $8b11dd70aaca6dbd$export$f5a1ee40934d19ce = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_CALL_ARGUMENTS, $8b11dd70aaca6dbd$export$1ba812a9756622ce = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_CALL_RESULT, $8b11dd70aaca6dbd$export$351120039c36e03 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_DEFINITIONS, $8b11dd70aaca6dbd$export$d42aa25ca09e17c4 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_DESCRIPTION, $8b11dd70aaca6dbd$export$d268db29b88a4286 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_INPUT, $8b11dd70aaca6dbd$export$c5deb6018f2d6251 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_MESSAGE, $8b11dd70aaca6dbd$export$e06baa3034409453 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_NAME, $8b11dd70aaca6dbd$export$646fdb5910ce3931 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_OUTPUT, $8b11dd70aaca6dbd$export$662e3d2d4361e29b = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_TYPE, $8b11dd70aaca6dbd$export$1de3962f221ba441 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS, $8b11dd70aaca6dbd$export$a4b3f0f5499c8738 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS, $8b11dd70aaca6dbd$export$1aecdac6cecbdc5b = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_COMPLETION_TOKENS, $8b11dd70aaca6dbd$export$2eb2ab35b317a103 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS, $8b11dd70aaca6dbd$export$c7e14ea195ede241 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED, $8b11dd70aaca6dbd$export$41ac034e7b9725a2 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE, $8b11dd70aaca6dbd$export$9e521119d7751e37 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_OUTPUT_TOKENS, $8b11dd70aaca6dbd$export$cbac8f541a64a150 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING, $8b11dd70aaca6dbd$export$93dd08efa94c9dd4 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_PROMPT_TOKENS, $8b11dd70aaca6dbd$export$183e3523dac20bca = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS, $8b11dd70aaca6dbd$export$3867ca1d8381d4e3 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_TOTAL_TOKENS, $8b11dd70aaca6dbd$export$11febcf9917c0057 = $8b11dd70aaca6dbd$var$GRAPHQL_DOCUMENT, $8b11dd70aaca6dbd$export$88ae1ee0c0a63398 = $8b11dd70aaca6dbd$var$GRAPHQL_OPERATION_NAME, $8b11dd70aaca6dbd$export$d5bd986d1f283f29 = $8b11dd70aaca6dbd$var$GRAPHQL_OPERATION_TYPE, $8b11dd70aaca6dbd$export$fc4a2d238535d998 = $8b11dd70aaca6dbd$var$HARDWARECONCURRENCY, $8b11dd70aaca6dbd$export$57e53a60bf563f41 = $8b11dd70aaca6dbd$var$HTTP_CLIENT_IP, $8b11dd70aaca6dbd$export$ffdb1464deb0eedb = $8b11dd70aaca6dbd$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH, $8b11dd70aaca6dbd$export$b52670c950fd640 = $8b11dd70aaca6dbd$var$HTTP_FLAVOR, $8b11dd70aaca6dbd$export$c499fd8f1db3d18e = $8b11dd70aaca6dbd$var$HTTP_FRAGMENT, $8b11dd70aaca6dbd$export$b2ee2242301eff05 = $8b11dd70aaca6dbd$var$HTTP_HOST, $8b11dd70aaca6dbd$export$2ebf9f7586f16841 = $8b11dd70aaca6dbd$var$HTTP_METHOD, $8b11dd70aaca6dbd$export$6e9ffd608b3e828b = $8b11dd70aaca6dbd$var$HTTP_QUERY, $8b11dd70aaca6dbd$export$b960c5a73a722e6c = $8b11dd70aaca6dbd$var$HTTP_REQUEST_BODY_DATA, $8b11dd70aaca6dbd$export$a7a850351369c77e = $8b11dd70aaca6dbd$var$HTTP_REQUEST_CONNECTION_END, $8b11dd70aaca6dbd$export$b18bca78f4736a94 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_CONNECT_START, $8b11dd70aaca6dbd$export$61a0059f562fb6c2 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_DOMAIN_LOOKUP_END, $8b11dd70aaca6dbd$export$7dc0d5aefb816d91 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_DOMAIN_LOOKUP_START, $8b11dd70aaca6dbd$export$58f6db56c841bef6 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_FETCH_START, $8b11dd70aaca6dbd$export$97a3da679f509d5 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_HEADER_KEY, $8b11dd70aaca6dbd$export$c387ec65fd1c2638 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_HEADER_KEY_BASE, $8b11dd70aaca6dbd$export$4d9db82211f308a4 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_METHOD, $8b11dd70aaca6dbd$export$ee4948a3be025123 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_REDIRECT_END, $8b11dd70aaca6dbd$export$e0021eb2979cddaa = $8b11dd70aaca6dbd$var$HTTP_REQUEST_REDIRECT_START, $8b11dd70aaca6dbd$export$7c0ac0c19a45beac = $8b11dd70aaca6dbd$var$HTTP_REQUEST_REQUEST_START, $8b11dd70aaca6dbd$export$6c32e9d84f534ee = $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESEND_COUNT, $8b11dd70aaca6dbd$export$d1f9fbdb211dd29b = $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESPONSE_END, $8b11dd70aaca6dbd$export$45e7eea99a17d6e4 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESPONSE_START, $8b11dd70aaca6dbd$export$20ea34e16c0aa64f = $8b11dd70aaca6dbd$var$HTTP_REQUEST_SAME_ORIGIN, $8b11dd70aaca6dbd$export$8365b0f03557fae9 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_SECURE_CONNECTION_START, $8b11dd70aaca6dbd$export$49ebbb9621675650 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE, $8b11dd70aaca6dbd$export$842be66a901f093 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_WORKER_START, $8b11dd70aaca6dbd$export$a9f5a6cb28adccb1 = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_BODY_SIZE, $8b11dd70aaca6dbd$export$57b055d4bc586d67 = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_CONTENT_LENGTH, $8b11dd70aaca6dbd$export$3ddfd660caa7bf7a = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH, $8b11dd70aaca6dbd$export$fa7e1f5305153b3d = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_KEY, $8b11dd70aaca6dbd$export$5674ce9d013eb7bd = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_KEY_BASE, $8b11dd70aaca6dbd$export$6e8dc14cff6ccf72 = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_SIZE, $8b11dd70aaca6dbd$export$afd59480458e1b57 = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_STATUS_CODE, $8b11dd70aaca6dbd$export$48e61fb9bccccba9 = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_TRANSFER_SIZE, $8b11dd70aaca6dbd$export$d3e674514dd3a3e1 = $8b11dd70aaca6dbd$var$HTTP_ROUTE, $8b11dd70aaca6dbd$export$97ad02b50c60ef68 = $8b11dd70aaca6dbd$var$HTTP_SCHEME, $8b11dd70aaca6dbd$export$61d053b1b63e82c4 = $8b11dd70aaca6dbd$var$HTTP_SERVER_NAME, $8b11dd70aaca6dbd$export$54256cce0d674dea = $8b11dd70aaca6dbd$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE, $8b11dd70aaca6dbd$export$8c01f0f407bcc5ca = $8b11dd70aaca6dbd$var$HTTP_STATUS_CODE, $8b11dd70aaca6dbd$export$be3f46982f6c7160 = $8b11dd70aaca6dbd$var$HTTP_TARGET, $8b11dd70aaca6dbd$export$778e4213e2788579 = $8b11dd70aaca6dbd$var$HTTP_URL, $8b11dd70aaca6dbd$export$8b48ca3594d2b172 = $8b11dd70aaca6dbd$var$HTTP_USER_AGENT, $8b11dd70aaca6dbd$export$8be180ec26319f9f = "id", $8b11dd70aaca6dbd$export$60eccaddefa8fc1c = "inp", $8b11dd70aaca6dbd$export$c99ce4fe37484d84 = $8b11dd70aaca6dbd$var$JSONRPC_PROTOCOL_VERSION, $8b11dd70aaca6dbd$export$fdf432fcac7d8f37 = $8b11dd70aaca6dbd$var$JSONRPC_REQUEST_ID, $8b11dd70aaca6dbd$export$4c21cc9cdf2f5dbd = $8b11dd70aaca6dbd$var$JVM_GC_ACTION, $8b11dd70aaca6dbd$export$dcc1eab7f3f31816 = $8b11dd70aaca6dbd$var$JVM_GC_NAME, $8b11dd70aaca6dbd$export$dcb7f1379b2b8f86 = $8b11dd70aaca6dbd$var$JVM_MEMORY_POOL_NAME, $8b11dd70aaca6dbd$export$53416edeea4c2d74 = $8b11dd70aaca6dbd$var$JVM_MEMORY_TYPE, $8b11dd70aaca6dbd$export$69f7e5d2b74c5c9e = $8b11dd70aaca6dbd$var$JVM_THREAD_DAEMON, $8b11dd70aaca6dbd$export$8e104aed582a26bc = $8b11dd70aaca6dbd$var$JVM_THREAD_STATE, $8b11dd70aaca6dbd$export$577047501949be9 = $8b11dd70aaca6dbd$var$KOA_NAME, $8b11dd70aaca6dbd$export$c4c45b599a2c15e = $8b11dd70aaca6dbd$var$KOA_TYPE, $8b11dd70aaca6dbd$export$361cb541700d648e = "lcp", $8b11dd70aaca6dbd$export$974f160e11f25731 = $8b11dd70aaca6dbd$var$LCP_ELEMENT, $8b11dd70aaca6dbd$export$7162f5c702b95903 = $8b11dd70aaca6dbd$var$LCP_ID, $8b11dd70aaca6dbd$export$a034d066a9090500 = $8b11dd70aaca6dbd$var$LCP_LOADTIME, $8b11dd70aaca6dbd$export$70938021e43e047c = $8b11dd70aaca6dbd$var$LCP_RENDERTIME, $8b11dd70aaca6dbd$export$5f6ac460012a73bb = $8b11dd70aaca6dbd$var$LCP_SIZE, $8b11dd70aaca6dbd$export$d8e498c1c670bcbf = $8b11dd70aaca6dbd$var$LCP_URL, $8b11dd70aaca6dbd$export$cc1a78a24d947903 = $8b11dd70aaca6dbd$var$LOGGER_NAME, $8b11dd70aaca6dbd$export$d29b927e0bb0ffea = $8b11dd70aaca6dbd$var$MCP_CANCELLED_REASON, $8b11dd70aaca6dbd$export$b3999cacef245779 = $8b11dd70aaca6dbd$var$MCP_CANCELLED_REQUEST_ID, $8b11dd70aaca6dbd$export$ff168b5f9cf9dcf6 = $8b11dd70aaca6dbd$var$MCP_CLIENT_NAME, $8b11dd70aaca6dbd$export$2ab876a45bd6e64 = $8b11dd70aaca6dbd$var$MCP_CLIENT_TITLE, $8b11dd70aaca6dbd$export$cb8027e4395c6c0e = $8b11dd70aaca6dbd$var$MCP_CLIENT_VERSION, $8b11dd70aaca6dbd$export$f5303d1bac3c2660 = $8b11dd70aaca6dbd$var$MCP_LIFECYCLE_PHASE, $8b11dd70aaca6dbd$export$6c463c5f3b00f64 = $8b11dd70aaca6dbd$var$MCP_LOGGING_DATA_TYPE, $8b11dd70aaca6dbd$export$e25d553065457cab = $8b11dd70aaca6dbd$var$MCP_LOGGING_LEVEL, $8b11dd70aaca6dbd$export$15d24c154ea8a56f = $8b11dd70aaca6dbd$var$MCP_LOGGING_LOGGER, $8b11dd70aaca6dbd$export$e5065789a6c415d0 = $8b11dd70aaca6dbd$var$MCP_LOGGING_MESSAGE, $8b11dd70aaca6dbd$export$62662c561d7c7835 = $8b11dd70aaca6dbd$var$MCP_METHOD_NAME, $8b11dd70aaca6dbd$export$218f394557fb0a5a = $8b11dd70aaca6dbd$var$MCP_PROGRESS_CURRENT, $8b11dd70aaca6dbd$export$2a5ff6de5448ecdf = $8b11dd70aaca6dbd$var$MCP_PROGRESS_MESSAGE, $8b11dd70aaca6dbd$export$9d23f3030ed2597e = $8b11dd70aaca6dbd$var$MCP_PROGRESS_PERCENTAGE, $8b11dd70aaca6dbd$export$a26ff217a6124160 = $8b11dd70aaca6dbd$var$MCP_PROGRESS_TOKEN, $8b11dd70aaca6dbd$export$c8072f5fcfdb5b77 = $8b11dd70aaca6dbd$var$MCP_PROGRESS_TOTAL, $8b11dd70aaca6dbd$export$c4e4b74f1ccf3d96 = $8b11dd70aaca6dbd$var$MCP_PROMPT_NAME, $8b11dd70aaca6dbd$export$328519d02a26ac41 = $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_DESCRIPTION, $8b11dd70aaca6dbd$export$d2061b291c43d045 = $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT, $8b11dd70aaca6dbd$export$d1f04dfd3d695286 = $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_COUNT, $8b11dd70aaca6dbd$export$234fbd86ea0f0bd8 = $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_ROLE, $8b11dd70aaca6dbd$export$e795000978a75b12 = $8b11dd70aaca6dbd$var$MCP_PROTOCOL_READY, $8b11dd70aaca6dbd$export$9f4683b4d1018ace = $8b11dd70aaca6dbd$var$MCP_PROTOCOL_VERSION, $8b11dd70aaca6dbd$export$e431b042fcdb1d63 = $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_KEY, $8b11dd70aaca6dbd$export$a453239171ac9a23 = $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_KEY_BASE, $8b11dd70aaca6dbd$export$3a7726a976c18d5f = $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_NAME, $8b11dd70aaca6dbd$export$7eca7a6c06843b93 = $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_URI, $8b11dd70aaca6dbd$export$f25c55f83e5b0672 = $8b11dd70aaca6dbd$var$MCP_REQUEST_ID, $8b11dd70aaca6dbd$export$9562bfac4eb079cb = $8b11dd70aaca6dbd$var$MCP_RESOURCE_PROTOCOL, $8b11dd70aaca6dbd$export$c276d164ff91d2f7 = $8b11dd70aaca6dbd$var$MCP_RESOURCE_URI, $8b11dd70aaca6dbd$export$2f3e0574f1a99754 = $8b11dd70aaca6dbd$var$MCP_SERVER_NAME, $8b11dd70aaca6dbd$export$15eecaab68167880 = $8b11dd70aaca6dbd$var$MCP_SERVER_TITLE, $8b11dd70aaca6dbd$export$513c47f6e194086a = $8b11dd70aaca6dbd$var$MCP_SERVER_VERSION, $8b11dd70aaca6dbd$export$a3f464c4d5cd9096 = $8b11dd70aaca6dbd$var$MCP_SESSION_ID, $8b11dd70aaca6dbd$export$ed366a03a2330b03 = $8b11dd70aaca6dbd$var$MCP_TOOL_NAME, $8b11dd70aaca6dbd$export$9b802c784f235e1d = $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_CONTENT, $8b11dd70aaca6dbd$export$add0fc8b8c5726a4 = $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_CONTENT_COUNT, $8b11dd70aaca6dbd$export$e7f32463f5bfd554 = $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_IS_ERROR, $8b11dd70aaca6dbd$export$f9346f394edf26a = $8b11dd70aaca6dbd$var$MCP_TRANSPORT, $8b11dd70aaca6dbd$export$16b917774e73ef92 = $8b11dd70aaca6dbd$var$MDC_KEY, $8b11dd70aaca6dbd$export$15d2b60bf3b65454 = "mdc", $8b11dd70aaca6dbd$export$db55eca5af256142 = $8b11dd70aaca6dbd$var$MESSAGING_BATCH_MESSAGE_COUNT, $8b11dd70aaca6dbd$export$967c74f8b1f3d35 = $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION, $8b11dd70aaca6dbd$export$7c33ae67962515d1 = $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION_CONNECTION, $8b11dd70aaca6dbd$export$9c69839b2d93489b = $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION_NAME, $8b11dd70aaca6dbd$export$be22d22d4b6cf5d8 = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_BODY_SIZE, $8b11dd70aaca6dbd$export$c529961b911626ac = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_CONVERSATION_ID, $8b11dd70aaca6dbd$export$e39c4b15d2881f5 = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_ENVELOPE_SIZE, $8b11dd70aaca6dbd$export$a8ca145161313e7 = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_ID, $8b11dd70aaca6dbd$export$3c1204d03918d076 = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_RECEIVE_LATENCY, $8b11dd70aaca6dbd$export$eaac3f141165e288 = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_RETRY_COUNT, $8b11dd70aaca6dbd$export$4c7e6934714150e6 = $8b11dd70aaca6dbd$var$MESSAGING_OPERATION_NAME, $8b11dd70aaca6dbd$export$6f71f9711d666eb4 = $8b11dd70aaca6dbd$var$MESSAGING_OPERATION_TYPE, $8b11dd70aaca6dbd$export$2a3cd2bb71fb63a4 = $8b11dd70aaca6dbd$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY, $8b11dd70aaca6dbd$export$55478a0b7d2ae98f = $8b11dd70aaca6dbd$var$MESSAGING_SYSTEM, $8b11dd70aaca6dbd$export$bed10c4da9b8eb0a = $8b11dd70aaca6dbd$var$METHOD, $8b11dd70aaca6dbd$export$a82607b6424c06c8 = $8b11dd70aaca6dbd$var$MIDDLEWARE_NAME, $8b11dd70aaca6dbd$export$6b081f3484c7f4e5 = $8b11dd70aaca6dbd$var$NAVIGATION_ORIGIN, $8b11dd70aaca6dbd$export$b7754d85fd39406c = $8b11dd70aaca6dbd$var$NAVIGATION_ROUTE_ID, $8b11dd70aaca6dbd$export$492856c046eb4728 = $8b11dd70aaca6dbd$var$NAVIGATION_TYPE, $8b11dd70aaca6dbd$export$c1678a2059fbe906 = $8b11dd70aaca6dbd$var$NEL_ELAPSED_TIME, $8b11dd70aaca6dbd$export$6d384a0bc1011c34 = $8b11dd70aaca6dbd$var$NEL_PHASE, $8b11dd70aaca6dbd$export$1499a7dbfc01e7d4 = $8b11dd70aaca6dbd$var$NEL_REFERRER, $8b11dd70aaca6dbd$export$cfcbff40019f0ff1 = $8b11dd70aaca6dbd$var$NEL_SAMPLING_FUNCTION, $8b11dd70aaca6dbd$export$27157b5f68e583af = $8b11dd70aaca6dbd$var$NEL_TYPE, $8b11dd70aaca6dbd$export$54bf5ed61532925d = $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_EFFECTIVE_TYPE, $8b11dd70aaca6dbd$export$60ed0786292ace08 = $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_RTT, $8b11dd70aaca6dbd$export$d770bfb8345e146 = $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_TYPE, $8b11dd70aaca6dbd$export$bb73817f1290ad28 = $8b11dd70aaca6dbd$var$NETWORK_LOCAL_ADDRESS, $8b11dd70aaca6dbd$export$f201c980f2b75802 = $8b11dd70aaca6dbd$var$NETWORK_LOCAL_PORT, $8b11dd70aaca6dbd$export$b40e970572afd0ee = $8b11dd70aaca6dbd$var$NETWORK_PEER_ADDRESS, $8b11dd70aaca6dbd$export$8850630a3d343488 = $8b11dd70aaca6dbd$var$NETWORK_PEER_PORT, $8b11dd70aaca6dbd$export$fd0a39a918d6516f = $8b11dd70aaca6dbd$var$NETWORK_PROTOCOL_NAME, $8b11dd70aaca6dbd$export$e68ef41f8e0335bf = $8b11dd70aaca6dbd$var$NETWORK_PROTOCOL_VERSION, $8b11dd70aaca6dbd$export$5bff09650e762829 = $8b11dd70aaca6dbd$var$NETWORK_TRANSPORT, $8b11dd70aaca6dbd$export$21c1adce0e067f37 = $8b11dd70aaca6dbd$var$NETWORK_TYPE, $8b11dd70aaca6dbd$export$fed6ce86f48c84bc = $8b11dd70aaca6dbd$var$NET_HOST_IP, $8b11dd70aaca6dbd$export$500c2675137ac16e = $8b11dd70aaca6dbd$var$NET_HOST_NAME, $8b11dd70aaca6dbd$export$402c7728623fd8df = $8b11dd70aaca6dbd$var$NET_HOST_PORT, $8b11dd70aaca6dbd$export$15417259f4c0fe6b = $8b11dd70aaca6dbd$var$NET_PEER_IP, $8b11dd70aaca6dbd$export$2b3b7f579a727f45 = $8b11dd70aaca6dbd$var$NET_PEER_NAME, $8b11dd70aaca6dbd$export$514832a0b029734b = $8b11dd70aaca6dbd$var$NET_PEER_PORT, $8b11dd70aaca6dbd$export$b0522e6a14dec1a4 = $8b11dd70aaca6dbd$var$NET_PROTOCOL_NAME, $8b11dd70aaca6dbd$export$659ea19f71a7ee0b = $8b11dd70aaca6dbd$var$NET_PROTOCOL_VERSION, $8b11dd70aaca6dbd$export$1b61d972db315e73 = $8b11dd70aaca6dbd$var$NET_SOCK_FAMILY, $8b11dd70aaca6dbd$export$fb2970ee11a479ee = $8b11dd70aaca6dbd$var$NET_SOCK_HOST_ADDR, $8b11dd70aaca6dbd$export$920aceb2a8fad77e = $8b11dd70aaca6dbd$var$NET_SOCK_HOST_PORT, $8b11dd70aaca6dbd$export$48f8f6fbc999d187 = $8b11dd70aaca6dbd$var$NET_SOCK_PEER_ADDR, $8b11dd70aaca6dbd$export$eed590fa00a8223b = $8b11dd70aaca6dbd$var$NET_SOCK_PEER_NAME, $8b11dd70aaca6dbd$export$f2e5bb5cd4a130da = $8b11dd70aaca6dbd$var$NET_SOCK_PEER_PORT, $8b11dd70aaca6dbd$export$779ef03d633a9086 = $8b11dd70aaca6dbd$var$NET_TRANSPORT, $8b11dd70aaca6dbd$export$d98b87c8d53d0dbc = $8b11dd70aaca6dbd$var$OS_BUILD, $8b11dd70aaca6dbd$export$ca719aa57653a0a7 = $8b11dd70aaca6dbd$var$OS_BUILD_ID, $8b11dd70aaca6dbd$export$74b19c5f48270c05 = $8b11dd70aaca6dbd$var$OS_DESCRIPTION, $8b11dd70aaca6dbd$export$c351affe7e8098cb = $8b11dd70aaca6dbd$var$OS_KERNEL_VERSION, $8b11dd70aaca6dbd$export$be7cd6b3ae3ae765 = $8b11dd70aaca6dbd$var$OS_NAME, $8b11dd70aaca6dbd$export$ec182524c4c57275 = $8b11dd70aaca6dbd$var$OS_RAW_DESCRIPTION, $8b11dd70aaca6dbd$export$9e45758246a85b07 = $8b11dd70aaca6dbd$var$OS_ROOTED, $8b11dd70aaca6dbd$export$9fa5d5f0144954cb = $8b11dd70aaca6dbd$var$OS_THEME, $8b11dd70aaca6dbd$export$e66ba5bc4b978023 = $8b11dd70aaca6dbd$var$OS_TYPE, $8b11dd70aaca6dbd$export$2306e23cc611a36d = $8b11dd70aaca6dbd$var$OS_VERSION, $8b11dd70aaca6dbd$export$144f8c1fe01428db = $8b11dd70aaca6dbd$var$OTEL_KIND, $8b11dd70aaca6dbd$export$f303b2744d52121c = $8b11dd70aaca6dbd$var$OTEL_SCOPE_NAME, $8b11dd70aaca6dbd$export$866b2dbc7bf18ce6 = $8b11dd70aaca6dbd$var$OTEL_SCOPE_VERSION, $8b11dd70aaca6dbd$export$b4c85774878b4841 = $8b11dd70aaca6dbd$var$OTEL_STATUS_CODE, $8b11dd70aaca6dbd$export$1c967a71bc9a3077 = $8b11dd70aaca6dbd$var$OTEL_STATUS_DESCRIPTION, $8b11dd70aaca6dbd$export$5e3884a35a19eb90 = $8b11dd70aaca6dbd$var$PARAMS_KEY, $8b11dd70aaca6dbd$export$6e7ff99bb3259573 = $8b11dd70aaca6dbd$var$PARAMS_KEY_BASE, $8b11dd70aaca6dbd$export$7c932cba2d9e7a7 = $8b11dd70aaca6dbd$var$PERFORMANCE_ACTIVATIONSTART, $8b11dd70aaca6dbd$export$94091942edce0667 = $8b11dd70aaca6dbd$var$PERFORMANCE_TIMEORIGIN, $8b11dd70aaca6dbd$export$3671a8a524706a9d = $8b11dd70aaca6dbd$var$PREVIOUS_ROUTE, $8b11dd70aaca6dbd$export$c288888dc82d233f = $8b11dd70aaca6dbd$var$PROCESS_COMMAND_ARGS, $8b11dd70aaca6dbd$export$8ff188536cebc35 = $8b11dd70aaca6dbd$var$PROCESS_EXECUTABLE_NAME, $8b11dd70aaca6dbd$export$6407d78968c0eabe = $8b11dd70aaca6dbd$var$PROCESS_PID, $8b11dd70aaca6dbd$export$43e9fb9ec28d9743 = $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_DESCRIPTION, $8b11dd70aaca6dbd$export$26f31d5c5c201739 = $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_ENGINE_NAME, $8b11dd70aaca6dbd$export$bff85124d2d35b93 = $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_ENGINE_VERSION, $8b11dd70aaca6dbd$export$495c671ed5a6408c = $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_NAME, $8b11dd70aaca6dbd$export$54b3d4d5548c35c3 = $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_VERSION, $8b11dd70aaca6dbd$export$2954db6444fe1fa8 = $8b11dd70aaca6dbd$var$QUERY_KEY, $8b11dd70aaca6dbd$export$15c1c974d16dd678 = $8b11dd70aaca6dbd$var$QUERY_KEY_BASE, $8b11dd70aaca6dbd$export$9be2ae89a1eac217 = $8b11dd70aaca6dbd$var$REACT_VERSION, $8b11dd70aaca6dbd$export$5c698591c0e586a2 = $8b11dd70aaca6dbd$var$RELEASE, $8b11dd70aaca6dbd$export$b711f2bb9c9a848a = $8b11dd70aaca6dbd$var$REMIX_ACTION_FORM_DATA_KEY, $8b11dd70aaca6dbd$export$1d3a8501efd30213 = $8b11dd70aaca6dbd$var$REMIX_ACTION_FORM_DATA_KEY_BASE, $8b11dd70aaca6dbd$export$cebaf684ced5a2c9 = $8b11dd70aaca6dbd$var$REPLAY_ID, $8b11dd70aaca6dbd$export$d4c658ecdcb7c78c = $8b11dd70aaca6dbd$var$RESOURCE_DEPLOYMENT_ENVIRONMENT, $8b11dd70aaca6dbd$export$b1b162b01baeb044 = $8b11dd70aaca6dbd$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME, $8b11dd70aaca6dbd$export$8be2d593d7f88ed8 = $8b11dd70aaca6dbd$var$RESOURCE_RENDER_BLOCKING_STATUS, $8b11dd70aaca6dbd$export$dbd0a3528a97ccc0 = $8b11dd70aaca6dbd$var$ROUTE, $8b11dd70aaca6dbd$export$66581dc6d3d083d1 = $8b11dd70aaca6dbd$var$RPC_GRPC_STATUS_CODE, $8b11dd70aaca6dbd$export$e545f99e7abcc499 = $8b11dd70aaca6dbd$var$RPC_METHOD, $8b11dd70aaca6dbd$export$7e1af5787f8c4aaa = $8b11dd70aaca6dbd$var$RPC_RESPONSE_STATUS_CODE, $8b11dd70aaca6dbd$export$186c94c351c54768 = $8b11dd70aaca6dbd$var$RPC_SERVICE, $8b11dd70aaca6dbd$export$2e3fd8dfcb16fe0c = $8b11dd70aaca6dbd$var$RPC_SYSTEM, $8b11dd70aaca6dbd$export$7eeeceaa1dbd7cd5 = $8b11dd70aaca6dbd$var$RPC_SYSTEM_NAME, $8b11dd70aaca6dbd$export$9d5bffdff936d554 = $8b11dd70aaca6dbd$var$RUNTIME_BUILD, $8b11dd70aaca6dbd$export$dc3a801c9a2c5b79 = $8b11dd70aaca6dbd$var$RUNTIME_NAME, $8b11dd70aaca6dbd$export$27933a9557f87e98 = $8b11dd70aaca6dbd$var$RUNTIME_RAW_DESCRIPTION, $8b11dd70aaca6dbd$export$eefa737b40a0d535 = $8b11dd70aaca6dbd$var$RUNTIME_VERSION, $8b11dd70aaca6dbd$export$92740ffbcb02553b = $8b11dd70aaca6dbd$var$SCORE_KEY, $8b11dd70aaca6dbd$export$500e89753f9f1008 = $8b11dd70aaca6dbd$var$SCORE_KEY_BASE, $8b11dd70aaca6dbd$export$d91a18e47fdddefd = $8b11dd70aaca6dbd$var$SCORE_RATIO_KEY, $8b11dd70aaca6dbd$export$eccbe6f20884ea7f = $8b11dd70aaca6dbd$var$SCORE_RATIO_KEY_BASE, $8b11dd70aaca6dbd$export$9e24f11d79141afb = $8b11dd70aaca6dbd$var$SCORE_TOTAL, $8b11dd70aaca6dbd$export$f0b96ad9586f8887 = $8b11dd70aaca6dbd$var$SCORE_WEIGHT_KEY, $8b11dd70aaca6dbd$export$8a92ed5d436a85c6 = $8b11dd70aaca6dbd$var$SCORE_WEIGHT_KEY_BASE, $8b11dd70aaca6dbd$export$edd59acdf7e86a71 = $8b11dd70aaca6dbd$var$SENTRY_ACTION, $8b11dd70aaca6dbd$export$ae81a1ae71952d50 = $8b11dd70aaca6dbd$var$SENTRY_BROWSER_NAME, $8b11dd70aaca6dbd$export$6101470cd57eac1b = $8b11dd70aaca6dbd$var$SENTRY_BROWSER_VERSION, $8b11dd70aaca6dbd$export$452c0aee9673fe67 = $8b11dd70aaca6dbd$var$SENTRY_CANCELLATION_REASON, $8b11dd70aaca6dbd$export$773dddd1e8667756 = $8b11dd70aaca6dbd$var$SENTRY_CATEGORY, $8b11dd70aaca6dbd$export$98815f8579a64a90 = $8b11dd70aaca6dbd$var$SENTRY_CLIENT_SAMPLE_RATE, $8b11dd70aaca6dbd$export$7bc4e27428665019 = $8b11dd70aaca6dbd$var$SENTRY_DESCRIPTION, $8b11dd70aaca6dbd$export$e7d7477fa9057ee2 = $8b11dd70aaca6dbd$var$SENTRY_DIST, $8b11dd70aaca6dbd$export$1f4267a3fc018448 = $8b11dd70aaca6dbd$var$SENTRY_DOMAIN, $8b11dd70aaca6dbd$export$c171cae150389952 = $8b11dd70aaca6dbd$var$SENTRY_DSC_ENVIRONMENT, $8b11dd70aaca6dbd$export$d9bb35e957b22c72 = $8b11dd70aaca6dbd$var$SENTRY_DSC_PROJECT_ID, $8b11dd70aaca6dbd$export$b3508a2c95f74e3d = $8b11dd70aaca6dbd$var$SENTRY_DSC_PUBLIC_KEY, $8b11dd70aaca6dbd$export$20bb272f4d21532d = $8b11dd70aaca6dbd$var$SENTRY_DSC_RELEASE, $8b11dd70aaca6dbd$export$d7e64fbd0102ce90 = $8b11dd70aaca6dbd$var$SENTRY_DSC_SAMPLED, $8b11dd70aaca6dbd$export$c17eae7e86dbba3c = $8b11dd70aaca6dbd$var$SENTRY_DSC_SAMPLE_RATE, $8b11dd70aaca6dbd$export$349603c0a9165744 = $8b11dd70aaca6dbd$var$SENTRY_DSC_TRACE_ID, $8b11dd70aaca6dbd$export$4dadf693741f0283 = $8b11dd70aaca6dbd$var$SENTRY_DSC_TRANSACTION, $8b11dd70aaca6dbd$export$6377864d12f7eeb3 = $8b11dd70aaca6dbd$var$SENTRY_ENVIRONMENT, $8b11dd70aaca6dbd$export$ba081af9585ed4 = $8b11dd70aaca6dbd$var$SENTRY_EXCLUSIVE_TIME, $8b11dd70aaca6dbd$export$7841dacb241485d0 = $8b11dd70aaca6dbd$var$SENTRY_GRAPHQL_OPERATION, $8b11dd70aaca6dbd$export$52c7044cf6301362 = $8b11dd70aaca6dbd$var$SENTRY_GROUP, $8b11dd70aaca6dbd$export$56ea1c9e44590e20 = $8b11dd70aaca6dbd$var$SENTRY_HTTP_PREFETCH, $8b11dd70aaca6dbd$export$7626e389d05f4c36 = $8b11dd70aaca6dbd$var$SENTRY_IDLE_SPAN_FINISH_REASON, $8b11dd70aaca6dbd$export$5e0a48187329b2e7 = $8b11dd70aaca6dbd$var$SENTRY_IS_REMOTE, $8b11dd70aaca6dbd$export$c322b150d7667841 = $8b11dd70aaca6dbd$var$SENTRY_KIND, $8b11dd70aaca6dbd$export$4a4797d3c962f753 = $8b11dd70aaca6dbd$var$SENTRY_MAIN_THREAD, $8b11dd70aaca6dbd$export$767524d5e72e2645 = $8b11dd70aaca6dbd$var$SENTRY_MESSAGE_PARAMETER_KEY, $8b11dd70aaca6dbd$export$497354ca7b0ee666 = $8b11dd70aaca6dbd$var$SENTRY_MESSAGE_TEMPLATE, $8b11dd70aaca6dbd$export$cbdc4ad11118116a = $8b11dd70aaca6dbd$var$SENTRY_METRIC_SOURCE, $8b11dd70aaca6dbd$export$5b890de778c4c2fe = $8b11dd70aaca6dbd$var$SENTRY_MOBILE, $8b11dd70aaca6dbd$export$a78d9803b5e0a83e = $8b11dd70aaca6dbd$var$SENTRY_MODULE_KEY, $8b11dd70aaca6dbd$export$df1b536467b3992a = $8b11dd70aaca6dbd$var$SENTRY_MODULE_KEY_BASE, $8b11dd70aaca6dbd$export$73104a329e205998 = $8b11dd70aaca6dbd$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE, $8b11dd70aaca6dbd$export$5740e3da55330b0a = $8b11dd70aaca6dbd$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE, $8b11dd70aaca6dbd$export$8dcc2d92ff6d65da = $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DB_QUERY, $8b11dd70aaca6dbd$export$e5f1321e53e24810 = $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DB_QUERY_HASH, $8b11dd70aaca6dbd$export$56dd3098cbca7c8a = $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DESCRIPTION, $8b11dd70aaca6dbd$export$aa7aff70e4380665 = $8b11dd70aaca6dbd$var$SENTRY_OBSERVED_TIMESTAMP_NANOS, $8b11dd70aaca6dbd$export$dacb7d452aa6bcaf = $8b11dd70aaca6dbd$var$SENTRY_OP, $8b11dd70aaca6dbd$export$15dfc6c5e8f9baf6 = $8b11dd70aaca6dbd$var$SENTRY_ORIGIN, $8b11dd70aaca6dbd$export$91ad03bba7909fb5 = $8b11dd70aaca6dbd$var$SENTRY_PLATFORM, $8b11dd70aaca6dbd$export$86128e6c0ab71d64 = $8b11dd70aaca6dbd$var$SENTRY_PROFILER_ID, $8b11dd70aaca6dbd$export$745b60c4819aec1d = $8b11dd70aaca6dbd$var$SENTRY_PROFILE_ID, $8b11dd70aaca6dbd$export$d2c893bfac1da9a1 = $8b11dd70aaca6dbd$var$SENTRY_RELEASE, $8b11dd70aaca6dbd$export$1c14ad02f9534b19 = $8b11dd70aaca6dbd$var$SENTRY_REPLAY_ID, $8b11dd70aaca6dbd$export$db3cb63e0594d014 = $8b11dd70aaca6dbd$var$SENTRY_REPLAY_IS_BUFFERING, $8b11dd70aaca6dbd$export$a65c9a0eba2c222d = $8b11dd70aaca6dbd$var$SENTRY_REPORT_EVENT, $8b11dd70aaca6dbd$export$68dbcca9c0e339ec = $8b11dd70aaca6dbd$var$SENTRY_SDK_INTEGRATIONS, $8b11dd70aaca6dbd$export$d59b669d4bb3f006 = $8b11dd70aaca6dbd$var$SENTRY_SDK_NAME, $8b11dd70aaca6dbd$export$4d88d347aa9667fc = $8b11dd70aaca6dbd$var$SENTRY_SDK_VERSION, $8b11dd70aaca6dbd$export$9943ffdcaa4bc506 = $8b11dd70aaca6dbd$var$SENTRY_SEGMENT_ID, $8b11dd70aaca6dbd$export$d4f25b923533dbba = $8b11dd70aaca6dbd$var$SENTRY_SEGMENT_NAME, $8b11dd70aaca6dbd$export$35f3396a1cdeea45 = $8b11dd70aaca6dbd$var$SENTRY_SERVER_SAMPLE_RATE, $8b11dd70aaca6dbd$export$80e399da474bc98d = $8b11dd70aaca6dbd$var$SENTRY_SOURCE, $8b11dd70aaca6dbd$export$e01809e2dbceac35 = $8b11dd70aaca6dbd$var$SENTRY_SPAN_SOURCE, $8b11dd70aaca6dbd$export$41900d5c4e8a9c68 = $8b11dd70aaca6dbd$var$SENTRY_STATUS, $8b11dd70aaca6dbd$export$362bb1cb0bb5ca03 = $8b11dd70aaca6dbd$var$SENTRY_STATUS_CODE, $8b11dd70aaca6dbd$export$6803ac54f919d9cc = $8b11dd70aaca6dbd$var$SENTRY_STATUS_MESSAGE, $8b11dd70aaca6dbd$export$72f5b47540331169 = $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_FROM, $8b11dd70aaca6dbd$export$6c61a8c9aa5305cb = $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_TO, $8b11dd70aaca6dbd$export$6b5244c457b68e65 = $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE, $8b11dd70aaca6dbd$export$b7bd0c9a886f3414 = $8b11dd70aaca6dbd$var$SENTRY_THREAD_ID, $8b11dd70aaca6dbd$export$6b77f2bacac7c93d = $8b11dd70aaca6dbd$var$SENTRY_TIMESTAMP_SEQUENCE, $8b11dd70aaca6dbd$export$ddbc15c0e8e8a7ea = $8b11dd70aaca6dbd$var$SENTRY_TRACE_LIFECYCLE, $8b11dd70aaca6dbd$export$feb4fe753df28a82 = $8b11dd70aaca6dbd$var$SENTRY_TRACE_PARENT_SPAN_ID, $8b11dd70aaca6dbd$export$d6267756132e2175 = $8b11dd70aaca6dbd$var$SENTRY_TRACE_STATUS, $8b11dd70aaca6dbd$export$570ac5a3fd7e6cc6 = $8b11dd70aaca6dbd$var$SENTRY_TRANSACTION, $8b11dd70aaca6dbd$export$5b9a0015e1c530ed = $8b11dd70aaca6dbd$var$SENTRY_USER_EMAIL, $8b11dd70aaca6dbd$export$8bbff71c84508218 = $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_CITY, $8b11dd70aaca6dbd$export$b55aa07a514a2430 = $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_COUNTRY_CODE, $8b11dd70aaca6dbd$export$9927ad09f7c084dc = $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_REGION, $8b11dd70aaca6dbd$export$52a07a35ff8ec6b6 = $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_SUBDIVISION, $8b11dd70aaca6dbd$export$a10d277c42e6cae3 = $8b11dd70aaca6dbd$var$SENTRY_USER_ID, $8b11dd70aaca6dbd$export$cdc0ce5c66182801 = $8b11dd70aaca6dbd$var$SENTRY_USER_IP, $8b11dd70aaca6dbd$export$2504d4bd698dd962 = $8b11dd70aaca6dbd$var$SENTRY_USER_USERNAME, $8b11dd70aaca6dbd$export$9dc86f3b876e96ef = $8b11dd70aaca6dbd$var$SERVER_ADDRESS, $8b11dd70aaca6dbd$export$70ff7865f52549ae = $8b11dd70aaca6dbd$var$SERVER_NAME, $8b11dd70aaca6dbd$export$f77b53a42be6e6fd = $8b11dd70aaca6dbd$var$SERVER_PORT, $8b11dd70aaca6dbd$export$818eb7ab11414506 = $8b11dd70aaca6dbd$var$SERVICE_NAME, $8b11dd70aaca6dbd$export$829ef6b2e59d984d = $8b11dd70aaca6dbd$var$SERVICE_VERSION, $8b11dd70aaca6dbd$export$b30f4cb52c088a26 = $8b11dd70aaca6dbd$var$SESSION_ID, $8b11dd70aaca6dbd$export$335eace0ff1771cd = $8b11dd70aaca6dbd$var$STALL_PERCENTAGE, $8b11dd70aaca6dbd$export$374d88a2025416ac = $8b11dd70aaca6dbd$var$STALL_TOTAL_TIME, $8b11dd70aaca6dbd$export$bb7a91303551eb37 = $8b11dd70aaca6dbd$var$STATE_TYPE, $8b11dd70aaca6dbd$export$f132ea291a7db56b = $8b11dd70aaca6dbd$var$THREAD_ID, $8b11dd70aaca6dbd$export$f0abd4170bbd2468 = $8b11dd70aaca6dbd$var$THREAD_NAME, $8b11dd70aaca6dbd$export$50d00a157dc08581 = $8b11dd70aaca6dbd$var$TIMBER_TAG, $8b11dd70aaca6dbd$export$484576567a98833f = $8b11dd70aaca6dbd$var$TIME_TO_FULL_DISPLAY, $8b11dd70aaca6dbd$export$ec9e491e475d0c97 = $8b11dd70aaca6dbd$var$TIME_TO_INITIAL_DISPLAY, $8b11dd70aaca6dbd$export$a86c59c10992220f = $8b11dd70aaca6dbd$var$TRANSACTION, $8b11dd70aaca6dbd$export$e12f06597e992fde = $8b11dd70aaca6dbd$var$TRPC_PROCEDURE_PATH, $8b11dd70aaca6dbd$export$7ec54678ba28ea59 = $8b11dd70aaca6dbd$var$TRPC_PROCEDURE_TYPE, $8b11dd70aaca6dbd$export$433ba14c16717110 = $8b11dd70aaca6dbd$var$TTFB, $8b11dd70aaca6dbd$export$309ee349b8a537f = $8b11dd70aaca6dbd$var$TTFB_REQUESTTIME, $8b11dd70aaca6dbd$export$b87f371cbc396fcf = $8b11dd70aaca6dbd$var$TYPE, $8b11dd70aaca6dbd$export$60050fc49fe0e7e2 = $8b11dd70aaca6dbd$var$UI_COMPONENT_NAME, $8b11dd70aaca6dbd$export$348c8e2b37f276cd = $8b11dd70aaca6dbd$var$UI_CONTRIBUTES_TO_TTFD, $8b11dd70aaca6dbd$export$7f47e8a8b2d97cb2 = $8b11dd70aaca6dbd$var$UI_CONTRIBUTES_TO_TTID, $8b11dd70aaca6dbd$export$50d5adc4b543ce95 = $8b11dd70aaca6dbd$var$UI_ELEMENT_HEIGHT, $8b11dd70aaca6dbd$export$9221f1d2c934d9f = $8b11dd70aaca6dbd$var$UI_ELEMENT_ID, $8b11dd70aaca6dbd$export$3a56578b3ae09a02 = $8b11dd70aaca6dbd$var$UI_ELEMENT_IDENTIFIER, $8b11dd70aaca6dbd$export$e47b8dab9466c895 = $8b11dd70aaca6dbd$var$UI_ELEMENT_LOAD_TIME, $8b11dd70aaca6dbd$export$4ca52f75cf4889c5 = $8b11dd70aaca6dbd$var$UI_ELEMENT_PAINT_TYPE, $8b11dd70aaca6dbd$export$7343d7d72195067f = $8b11dd70aaca6dbd$var$UI_ELEMENT_RENDER_TIME, $8b11dd70aaca6dbd$export$f334f32f8d4d8063 = $8b11dd70aaca6dbd$var$UI_ELEMENT_TYPE, $8b11dd70aaca6dbd$export$c7bf2089e89a217c = $8b11dd70aaca6dbd$var$UI_ELEMENT_URL, $8b11dd70aaca6dbd$export$f514f97553a434b2 = $8b11dd70aaca6dbd$var$UI_ELEMENT_WIDTH, $8b11dd70aaca6dbd$export$61abde59b50deb8e = "url", $8b11dd70aaca6dbd$export$5a5ce44f9fb51f93 = $8b11dd70aaca6dbd$var$URL_DOMAIN, $8b11dd70aaca6dbd$export$7044ea8d89b6f59d = $8b11dd70aaca6dbd$var$URL_FRAGMENT, $8b11dd70aaca6dbd$export$40eacf1a072c9dbd = $8b11dd70aaca6dbd$var$URL_FULL, $8b11dd70aaca6dbd$export$4c1fa0ac0eff2ac = $8b11dd70aaca6dbd$var$URL_PATH, $8b11dd70aaca6dbd$export$5bee9450fe31dde1 = $8b11dd70aaca6dbd$var$URL_PATH_PARAMETER_KEY, $8b11dd70aaca6dbd$export$d0b571fb4406d953 = $8b11dd70aaca6dbd$var$URL_PATH_PARAMETER_KEY_BASE, $8b11dd70aaca6dbd$export$258b370e6c2b85d5 = $8b11dd70aaca6dbd$var$URL_PORT, $8b11dd70aaca6dbd$export$dc5e5523da291a4b = $8b11dd70aaca6dbd$var$URL_QUERY, $8b11dd70aaca6dbd$export$fd5a8904ab5abfe0 = $8b11dd70aaca6dbd$var$URL_SAME_ORIGIN, $8b11dd70aaca6dbd$export$1350d8937b0f26fb = $8b11dd70aaca6dbd$var$URL_SCHEME, $8b11dd70aaca6dbd$export$2a045f777fb349a8 = $8b11dd70aaca6dbd$var$URL_TEMPLATE, $8b11dd70aaca6dbd$export$8bb874585539a88f = $8b11dd70aaca6dbd$var$USER_AGENT_ORIGINAL, $8b11dd70aaca6dbd$export$17d3a50785727199 = $8b11dd70aaca6dbd$var$USER_EMAIL, $8b11dd70aaca6dbd$export$2931c570009689e = $8b11dd70aaca6dbd$var$USER_FULL_NAME, $8b11dd70aaca6dbd$export$199cbcedee735a43 = $8b11dd70aaca6dbd$var$USER_GEO_CITY, $8b11dd70aaca6dbd$export$4ba5bf9d4e3ed862 = $8b11dd70aaca6dbd$var$USER_GEO_COUNTRY_CODE, $8b11dd70aaca6dbd$export$674c01ec2f0b89c3 = $8b11dd70aaca6dbd$var$USER_GEO_REGION, $8b11dd70aaca6dbd$export$bda1686739fd61c7 = $8b11dd70aaca6dbd$var$USER_GEO_SUBDIVISION, $8b11dd70aaca6dbd$export$8d804148f485d54c = $8b11dd70aaca6dbd$var$USER_HASH, $8b11dd70aaca6dbd$export$212a8f1ea37518bd = $8b11dd70aaca6dbd$var$USER_ID, $8b11dd70aaca6dbd$export$c9ac0fee28245883 = $8b11dd70aaca6dbd$var$USER_IP_ADDRESS, $8b11dd70aaca6dbd$export$77078610759fe5f6 = $8b11dd70aaca6dbd$var$USER_NAME, $8b11dd70aaca6dbd$export$7c6317deeec7a6c1 = $8b11dd70aaca6dbd$var$USER_ROLES, $8b11dd70aaca6dbd$export$877ebf2e4ad81f03 = $8b11dd70aaca6dbd$var$VERCEL_BRANCH, $8b11dd70aaca6dbd$export$70b2343945496e1f = $8b11dd70aaca6dbd$var$VERCEL_BUILD_ID, $8b11dd70aaca6dbd$export$8415b56d2c6d2b1d = $8b11dd70aaca6dbd$var$VERCEL_DEPLOYMENT_ID, $8b11dd70aaca6dbd$export$cc81114a03caab18 = $8b11dd70aaca6dbd$var$VERCEL_DESTINATION, $8b11dd70aaca6dbd$export$bc14eb892daceb23 = $8b11dd70aaca6dbd$var$VERCEL_EDGE_TYPE, $8b11dd70aaca6dbd$export$3c973217450c3e9d = $8b11dd70aaca6dbd$var$VERCEL_ENTRYPOINT, $8b11dd70aaca6dbd$export$582c0b730ff1ddb9 = $8b11dd70aaca6dbd$var$VERCEL_EXECUTION_REGION, $8b11dd70aaca6dbd$export$b3edfb545b65f1c5 = $8b11dd70aaca6dbd$var$VERCEL_ID, $8b11dd70aaca6dbd$export$2593317d8731841c = $8b11dd70aaca6dbd$var$VERCEL_JA3_DIGEST, $8b11dd70aaca6dbd$export$8bb5bc1732aa41f = $8b11dd70aaca6dbd$var$VERCEL_JA4_DIGEST, $8b11dd70aaca6dbd$export$74a79c98b110b5b9 = $8b11dd70aaca6dbd$var$VERCEL_LOG_TYPE, $8b11dd70aaca6dbd$export$26461b03281b4db4 = $8b11dd70aaca6dbd$var$VERCEL_PATH, $8b11dd70aaca6dbd$export$eaea590d6d3dd93c = $8b11dd70aaca6dbd$var$VERCEL_PROJECT_ID, $8b11dd70aaca6dbd$export$af45365f70099379 = $8b11dd70aaca6dbd$var$VERCEL_PROJECT_NAME, $8b11dd70aaca6dbd$export$a49e732d34d5ba9b = $8b11dd70aaca6dbd$var$VERCEL_PROXY_CACHE_ID, $8b11dd70aaca6dbd$export$7c147fe246bc8bd3 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_CLIENT_IP, $8b11dd70aaca6dbd$export$e5111b6070e1ee9e = $8b11dd70aaca6dbd$var$VERCEL_PROXY_HOST, $8b11dd70aaca6dbd$export$591cbfd403f8c8d = $8b11dd70aaca6dbd$var$VERCEL_PROXY_LAMBDA_REGION, $8b11dd70aaca6dbd$export$b1388db955bbb885 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_METHOD, $8b11dd70aaca6dbd$export$e898d0e9e211abd9 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH, $8b11dd70aaca6dbd$export$ab6fee0e8a6ee069 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH_TYPE, $8b11dd70aaca6dbd$export$9786ad94c199ffbb = $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH_TYPE_VARIANT, $8b11dd70aaca6dbd$export$269890524eed693b = $8b11dd70aaca6dbd$var$VERCEL_PROXY_REFERER, $8b11dd70aaca6dbd$export$2ec623a8212d6b64 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_REGION, $8b11dd70aaca6dbd$export$30e7673b01ff994e = $8b11dd70aaca6dbd$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE, $8b11dd70aaca6dbd$export$9ea93477840812bf = $8b11dd70aaca6dbd$var$VERCEL_PROXY_SCHEME, $8b11dd70aaca6dbd$export$a6da0c365670c430 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_STATUS_CODE, $8b11dd70aaca6dbd$export$7986b22da43f2885 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_TIMESTAMP, $8b11dd70aaca6dbd$export$a9f943c7ceb3b42f = $8b11dd70aaca6dbd$var$VERCEL_PROXY_USER_AGENT, $8b11dd70aaca6dbd$export$dfe49501efcdffce = $8b11dd70aaca6dbd$var$VERCEL_PROXY_VERCEL_CACHE, $8b11dd70aaca6dbd$export$be465f50c92eb01d = $8b11dd70aaca6dbd$var$VERCEL_PROXY_VERCEL_ID, $8b11dd70aaca6dbd$export$c138d1796bb34999 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_WAF_ACTION, $8b11dd70aaca6dbd$export$85a0016690a0ccf2 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_WAF_RULE_ID, $8b11dd70aaca6dbd$export$883acab36ede4bfa = $8b11dd70aaca6dbd$var$VERCEL_REQUEST_ID, $8b11dd70aaca6dbd$export$9cfc88d203f9cdf1 = $8b11dd70aaca6dbd$var$VERCEL_SOURCE, $8b11dd70aaca6dbd$export$b3c6c599110d7bab = $8b11dd70aaca6dbd$var$VERCEL_STATUS_CODE, $8b11dd70aaca6dbd$export$247839c65766758 = $8b11dd70aaca6dbd$var$_AWS_KINESIS_STREAM_NAME, $8b11dd70aaca6dbd$export$f4d52b02df927d54 = $8b11dd70aaca6dbd$var$_AWS_REQUEST_ID, $8b11dd70aaca6dbd$export$df30ee8c5b5f1989 = $8b11dd70aaca6dbd$var$_HTTP_REQUEST_METHOD, $8b11dd70aaca6dbd$export$268a117c860fca6d = $8b11dd70aaca6dbd$var$_SENTRY_SEGMENT_ID; //# sourceMappingURL=attributes.cjs.map

});



parcelRegister("13TrR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $8OOjj = parcelRequire("8OOjj");

var $g31Ce = parcelRequire("g31Ce");

var $l5lP1 = parcelRequire("l5lP1");

var $aX5wF = parcelRequire("aX5wF");

var $cqs9v = parcelRequire("cqs9v");
function $0c6115202d4214b3$var$captureException(exception, hint) {
    return $5JqSP.getCurrentScope().captureException(exception, $l5lP1.parseEventHintOrCaptureContext(hint));
}
function $0c6115202d4214b3$var$captureMessage(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return $5JqSP.getCurrentScope().captureMessage(message, level, hint);
}
function $0c6115202d4214b3$var$captureEvent(event, hint) {
    return $5JqSP.getCurrentScope().captureEvent(event, hint);
}
function $0c6115202d4214b3$var$setContext(name, context) {
    $5JqSP.getIsolationScope().setContext(name, context);
}
function $0c6115202d4214b3$var$setExtras(extras) {
    $5JqSP.getIsolationScope().setExtras(extras);
}
function $0c6115202d4214b3$var$setExtra(key, extra) {
    $5JqSP.getIsolationScope().setExtra(key, extra);
}
function $0c6115202d4214b3$var$setTags(tags) {
    $5JqSP.getIsolationScope().setTags(tags);
}
function $0c6115202d4214b3$var$setTag(key, value) {
    $5JqSP.getIsolationScope().setTag(key, value);
}
function $0c6115202d4214b3$var$setAttributes(attributes) {
    $5JqSP.getIsolationScope().setAttributes(attributes);
}
function $0c6115202d4214b3$var$setAttribute(key, value) {
    $5JqSP.getIsolationScope().setAttribute(key, value);
}
function $0c6115202d4214b3$var$setUser(user) {
    $5JqSP.getIsolationScope().setUser(user);
}
function $0c6115202d4214b3$var$setConversationId(conversationId) {
    $5JqSP.getIsolationScope().setConversationId(conversationId);
}
function $0c6115202d4214b3$var$lastEventId() {
    return $5JqSP.getIsolationScope().lastEventId();
}
async function $0c6115202d4214b3$var$flush(timeout) {
    const client = $5JqSP.getClient();
    if (client) return client.flush(timeout);
    $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $0c6115202d4214b3$var$close(timeout) {
    const client = $5JqSP.getClient();
    if (client) return client.close(timeout);
    $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $0c6115202d4214b3$var$isInitialized() {
    return !!$5JqSP.getClient();
}
function $0c6115202d4214b3$var$isEnabled() {
    const client = $5JqSP.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $0c6115202d4214b3$var$addEventProcessor(callback) {
    $5JqSP.getIsolationScope().addEventProcessor(callback);
}
function $0c6115202d4214b3$var$startSession(context) {
    const isolationScope = $5JqSP.getIsolationScope();
    const { user: user } = $aX5wF.getCombinedScopeData(isolationScope, $5JqSP.getCurrentScope());
    const { userAgent: userAgent } = $cqs9v.GLOBAL_OBJ.navigator || {};
    const session$1 = $8OOjj.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") $8OOjj.updateSession(currentSession, {
        status: "exited"
    });
    $0c6115202d4214b3$var$endSession();
    isolationScope.setSession(session$1);
    return session$1;
}
function $0c6115202d4214b3$var$endSession() {
    const isolationScope = $5JqSP.getIsolationScope();
    const currentScope = $5JqSP.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $8OOjj.closeSession(session$1);
    $0c6115202d4214b3$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $0c6115202d4214b3$var$_sendSessionUpdate() {
    const isolationScope = $5JqSP.getIsolationScope();
    const client = $5JqSP.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $0c6115202d4214b3$var$captureSession(end = false) {
    if (end) {
        $0c6115202d4214b3$var$endSession();
        return;
    }
    $0c6115202d4214b3$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $0c6115202d4214b3$var$addEventProcessor;
module.exports.captureEvent = $0c6115202d4214b3$var$captureEvent;
module.exports.captureException = $0c6115202d4214b3$var$captureException;
module.exports.captureMessage = $0c6115202d4214b3$var$captureMessage;
module.exports.captureSession = $0c6115202d4214b3$var$captureSession;
module.exports.close = $0c6115202d4214b3$var$close;
module.exports.endSession = $0c6115202d4214b3$var$endSession;
module.exports.flush = $0c6115202d4214b3$var$flush;
module.exports.isEnabled = $0c6115202d4214b3$var$isEnabled;
module.exports.isInitialized = $0c6115202d4214b3$var$isInitialized;
module.exports.lastEventId = $0c6115202d4214b3$var$lastEventId;
module.exports.setAttribute = $0c6115202d4214b3$var$setAttribute;
module.exports.setAttributes = $0c6115202d4214b3$var$setAttributes;
module.exports.setContext = $0c6115202d4214b3$var$setContext;
module.exports.setConversationId = $0c6115202d4214b3$var$setConversationId;
module.exports.setExtra = $0c6115202d4214b3$var$setExtra;
module.exports.setExtras = $0c6115202d4214b3$var$setExtras;
module.exports.setTag = $0c6115202d4214b3$var$setTag;
module.exports.setTags = $0c6115202d4214b3$var$setTags;
module.exports.setUser = $0c6115202d4214b3$var$setUser;
module.exports.startSession = $0c6115202d4214b3$var$startSession;

});
parcelRegister("l5lP1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9QW6c = parcelRequire("9QW6c");

var $aDJ1B = parcelRequire("aDJ1B");

var $fTFTk = parcelRequire("fTFTk");

var $aIP8h = parcelRequire("aIP8h");

var $lpiqE = parcelRequire("lpiqE");

var $rzjlZ = parcelRequire("rzjlZ");

var $9EvIV = parcelRequire("9EvIV");

var $aX5wF = parcelRequire("aX5wF");

var $foFxi = parcelRequire("foFxi");

var $lDdLA = parcelRequire("lDdLA");

var $5L5uH = parcelRequire("5L5uH");
function $f59afdf92dbb9314$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $rzjlZ.uuid4(),
        timestamp: event.timestamp || $5L5uH.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $f59afdf92dbb9314$var$applyClientOptions(prepared, options);
    $f59afdf92dbb9314$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $f59afdf92dbb9314$var$applyDebugIds(prepared, options.stackParser);
    const finalScope = $f59afdf92dbb9314$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $rzjlZ.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = $aX5wF.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $aX5wF.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = $lpiqE.isInternalException(hint) ? $lDdLA.resolvedSyncPromise(prepared) : $aDJ1B.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) $f59afdf92dbb9314$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $f59afdf92dbb9314$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $f59afdf92dbb9314$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || $9QW6c.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $foFxi.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = $foFxi.truncate(exception.value, maxValueLength);
    });
}
function $f59afdf92dbb9314$var$applyDebugIds(event, stackParser) {
    const filenameDebugIdMap = $aIP8h.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $f59afdf92dbb9314$var$applyDebugMeta(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $f59afdf92dbb9314$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $f59afdf92dbb9314$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $9EvIV.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $9EvIV.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $9EvIV.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $9EvIV.normalize(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = $9EvIV.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $9EvIV.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $9EvIV.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $f59afdf92dbb9314$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $fTFTk.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
function $f59afdf92dbb9314$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return void 0;
    if ($f59afdf92dbb9314$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($f59afdf92dbb9314$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $f59afdf92dbb9314$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $fTFTk.Scope || typeof hint === "function";
}
const $f59afdf92dbb9314$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $f59afdf92dbb9314$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$f59afdf92dbb9314$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $f59afdf92dbb9314$var$applyClientOptions;
module.exports.applyDebugIds = $f59afdf92dbb9314$var$applyDebugIds;
module.exports.applyDebugMeta = $f59afdf92dbb9314$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $f59afdf92dbb9314$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $f59afdf92dbb9314$var$prepareEvent;

});
parcelRegister("aDJ1B", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $lDdLA = parcelRequire("lDdLA");
function $7bf078e723615ca5$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $7bf078e723615ca5$var$_notifyEventProcessors(event, hint, processors, index);
        return $cUgOr.isThenable(result) ? result : $lDdLA.resolvedSyncPromise(result);
    } catch (error) {
        return $lDdLA.rejectedSyncPromise(error);
    }
}
function $7bf078e723615ca5$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $3T29C.DEBUG_BUILD && result === null && $g31Ce.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
    if ($cUgOr.isThenable(result)) return result.then((final)=>$7bf078e723615ca5$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $7bf078e723615ca5$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $7bf078e723615ca5$var$notifyEventProcessors;

});
parcelRegister("lDdLA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");
const $fbf7eb3ffe3a5292$var$STATE_PENDING = 0;
const $fbf7eb3ffe3a5292$var$STATE_RESOLVED = 1;
const $fbf7eb3ffe3a5292$var$STATE_REJECTED = 2;
function $fbf7eb3ffe3a5292$var$resolvedSyncPromise(value) {
    return new $fbf7eb3ffe3a5292$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
function $fbf7eb3ffe3a5292$var$rejectedSyncPromise(reason) {
    return new $fbf7eb3ffe3a5292$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
class $fbf7eb3ffe3a5292$var$SyncPromise {
    constructor(executor){
        this._state = $fbf7eb3ffe3a5292$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $fbf7eb3ffe3a5292$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $fbf7eb3ffe3a5292$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $fbf7eb3ffe3a5292$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $fbf7eb3ffe3a5292$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $fbf7eb3ffe3a5292$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $fbf7eb3ffe3a5292$var$STATE_PENDING) return;
            if ($cUgOr.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($fbf7eb3ffe3a5292$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($fbf7eb3ffe3a5292$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $fbf7eb3ffe3a5292$var$SyncPromise;
module.exports.rejectedSyncPromise = $fbf7eb3ffe3a5292$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $fbf7eb3ffe3a5292$var$resolvedSyncPromise;

});


parcelRegister("aIP8h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1nK9H = parcelRequire("1nK9H");

var $cqs9v = parcelRequire("cqs9v");
let $7ce5ad5428bb4776$var$parsedStackResults;
let $7ce5ad5428bb4776$var$lastSentryKeysCount;
let $7ce5ad5428bb4776$var$lastNativeKeysCount;
let $7ce5ad5428bb4776$var$cachedFilenameDebugIds;
function $7ce5ad5428bb4776$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $cqs9v.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $cqs9v.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($7ce5ad5428bb4776$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $7ce5ad5428bb4776$var$lastSentryKeysCount && nativeDebugIdKeys.length === $7ce5ad5428bb4776$var$lastNativeKeysCount) return $7ce5ad5428bb4776$var$cachedFilenameDebugIds;
    $7ce5ad5428bb4776$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $7ce5ad5428bb4776$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $7ce5ad5428bb4776$var$cachedFilenameDebugIds = {};
    if (!$7ce5ad5428bb4776$var$parsedStackResults) $7ce5ad5428bb4776$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $7ce5ad5428bb4776$var$parsedStackResults?.[key];
            if (result && $7ce5ad5428bb4776$var$cachedFilenameDebugIds && debugId) {
                $7ce5ad5428bb4776$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($7ce5ad5428bb4776$var$parsedStackResults) $7ce5ad5428bb4776$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $7ce5ad5428bb4776$var$cachedFilenameDebugIds && $7ce5ad5428bb4776$var$parsedStackResults) {
                        $7ce5ad5428bb4776$var$cachedFilenameDebugIds[filename] = debugId;
                        $7ce5ad5428bb4776$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $7ce5ad5428bb4776$var$cachedFilenameDebugIds;
}
function $7ce5ad5428bb4776$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $7ce5ad5428bb4776$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $1nK9H.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $7ce5ad5428bb4776$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $7ce5ad5428bb4776$var$getFilenameToDebugIdMap;

});

parcelRegister("lpiqE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $f95a3a5fa863ccc5$var$isInternalException(hint) {
    return hint.data?.__sentry__ === true;
}
function $f95a3a5fa863ccc5$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $f95a3a5fa863ccc5$var$getPossibleEventMessages;
module.exports.isInternalException = $f95a3a5fa863ccc5$var$isInternalException;

});



parcelRegister("3xknF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $5CFne = parcelRequire("5CFne");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $rzjlZ = parcelRequire("rzjlZ");

var $5L5uH = parcelRequire("5L5uH");

var $7O2T2 = parcelRequire("7O2T2");
function $293443555adadb2a$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $293443555adadb2a$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = $5L5uH.timestampInSeconds();
        function finishCheckIn(status) {
            $293443555adadb2a$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $5L5uH.timestampInSeconds() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ($cUgOr.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    const oldPropagationContext = {
        ...$5JqSP.getCurrentScope().getPropagationContext()
    };
    return $5JqSP.withIsolationScope(()=>{
        if (upsertMonitorConfig?.isolateTrace) return $5CFne.startNewTrace(runCallback);
        const scope = $5JqSP.getCurrentScope();
        if (!$7O2T2.isContinuingTrace(scope.getPropagationContext())) scope.setPropagationContext(oldPropagationContext);
        return runCallback();
    });
}
function $293443555adadb2a$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $5JqSP.getCurrentScope();
    const client = $5JqSP.getClient();
    if (!client) $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $rzjlZ.uuid4();
}
module.exports.captureCheckIn = $293443555adadb2a$var$captureCheckIn;
module.exports.withMonitor = $293443555adadb2a$var$withMonitor;

});

parcelRegister("9tM8w", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");

var $6Uu3e = parcelRequire("6Uu3e");

var $dFAcI = parcelRequire("dFAcI");

var $3tUnp = parcelRequire("3tUnp");
function $6e6c2965d6f840bb$var$waitForTracingChannelBinding(callback, retries = 1) {
    const binding = $3tUnp.getAsyncContextStrategy($du5vT.getMainCarrier()).getTracingChannelBinding?.();
    if (binding) {
        callback();
        return;
    }
    if (!retries) return;
    $dFAcI.safeUnref(setTimeout(()=>{
        $6e6c2965d6f840bb$var$waitForTracingChannelBinding(callback, retries - 1);
    }, 1));
}
function $6e6c2965d6f840bb$var$_INTERNAL_createTracingChannelBinding(asyncLocalStorage, getScopes) {
    return {
        asyncLocalStorage: asyncLocalStorage,
        getStoreWithActiveSpan: (span)=>{
            const { scope: scope, isolationScope: isolationScope } = getScopes();
            const activeScope = scope.clone();
            $6Uu3e._setSpanForScope(activeScope, span);
            return {
                scope: activeScope,
                isolationScope: isolationScope
            };
        }
    };
}
module.exports._INTERNAL_createTracingChannelBinding = $6e6c2965d6f840bb$var$_INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $6e6c2965d6f840bb$var$waitForTracingChannelBinding;

});
parcelRegister("dFAcI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9f3b30185f3ebd8c$var$safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}
module.exports.safeUnref = $9f3b30185f3ebd8c$var$safeUnref;

});


parcelRegister("1scQ2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3zkbY = parcelRequire("3zkbY");
const $10f25d640eca1a3f$var$SENTRY_API_VERSION = "7";
function $10f25d640eca1a3f$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $10f25d640eca1a3f$var$_getIngestEndpoint(dsn) {
    return `${$10f25d640eca1a3f$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $10f25d640eca1a3f$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $10f25d640eca1a3f$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $10f25d640eca1a3f$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$10f25d640eca1a3f$var$_getIngestEndpoint(dsn)}?${$10f25d640eca1a3f$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $10f25d640eca1a3f$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $3zkbY.makeDsn(dsnLike);
    if (!dsn$1) return "";
    const endpoint = `${$10f25d640eca1a3f$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$3zkbY.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $10f25d640eca1a3f$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $10f25d640eca1a3f$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $10f25d640eca1a3f$var$getReportDialogEndpoint;

});

parcelRegister("ifJZI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1scQ2 = parcelRequire("1scQ2");

var $9QW6c = parcelRequire("9QW6c");

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $ajhqL = parcelRequire("ajhqL");

var $iOdTc = parcelRequire("iOdTc");

var $krgwg = parcelRequire("krgwg");

var $7piEH = parcelRequire("7piEH");

var $8OOjj = parcelRequire("8OOjj");

var $4LxkX = parcelRequire("4LxkX");

var $dvzf1 = parcelRequire("dvzf1");

var $jGI7F = parcelRequire("jGI7F");

var $9kCJF = parcelRequire("9kCJF");

var $9WX7F = parcelRequire("9WX7F");

var $g31Ce = parcelRequire("g31Ce");

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $lpiqE = parcelRequire("lpiqE");

var $cUgOr = parcelRequire("cUgOr");

var $4ty0t = parcelRequire("4ty0t");

var $rzjlZ = parcelRequire("rzjlZ");

var $5CFT4 = parcelRequire("5CFT4");

var $l5lP1 = parcelRequire("l5lP1");

var $cx0Ur = parcelRequire("cx0Ur");

var $hkF3C = parcelRequire("hkF3C");

var $ffWyI = parcelRequire("ffWyI");

var $6vUrj = parcelRequire("6vUrj");

var $dFAcI = parcelRequire("dFAcI");

var $6iJce = parcelRequire("6iJce");

var $ehLHs = parcelRequire("ehLHs");
const $d49d4e3a9c5373f3$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $d49d4e3a9c5373f3$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $d49d4e3a9c5373f3$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $d49d4e3a9c5373f3$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $d49d4e3a9c5373f3$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $d49d4e3a9c5373f3$var$_makeInternalError(message) {
    return {
        message: message,
        [$d49d4e3a9c5373f3$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $d49d4e3a9c5373f3$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$d49d4e3a9c5373f3$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $d49d4e3a9c5373f3$var$_isInternalError(error) {
    return $cUgOr.isObjectLike(error) && $d49d4e3a9c5373f3$var$INTERNAL_ERROR_SYMBOL in error;
}
function $d49d4e3a9c5373f3$var$_isDoNotSendEventError(error) {
    return $cUgOr.isObjectLike(error) && $d49d4e3a9c5373f3$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $d49d4e3a9c5373f3$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $d49d4e3a9c5373f3$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = $dFAcI.safeUnref(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $d49d4e3a9c5373f3$var$Client {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $cx0Ur.makePromiseBuffer(options.transportOptions?.bufferSize ?? $9kCJF.DEFAULT_TRANSPORT_BUFFER_SIZE);
        this._dataCollection = $ehLHs.resolveDataCollectionOptions(options);
        if (options.dsn) this._dsn = $3zkbY.makeDsn(options.dsn);
        else $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = $1scQ2.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs ?? true;
        if (this._options.enableLogs) $d49d4e3a9c5373f3$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $d49d4e3a9c5373f3$var$estimateLogSizeInBytes, $krgwg._INTERNAL_flushLogsBuffer);
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $d49d4e3a9c5373f3$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $d49d4e3a9c5373f3$var$estimateMetricSizeInBytes, $7piEH._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $rzjlZ.uuid4();
        if ($rzjlZ.checkOrSetAlreadyCaught(exception)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log($d49d4e3a9c5373f3$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $rzjlZ.uuid4(),
            ...hint
        };
        const eventMessage = $cUgOr.isParameterizedString(message) ? message : String(message);
        const isMessage = $cUgOr.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $rzjlZ.uuid4();
        if (hint?.originalException && $rzjlZ.checkOrSetAlreadyCaught(hint.originalException)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log($d49d4e3a9c5373f3$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $d49d4e3a9c5373f3$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        $8OOjj.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        $iOdTc.setupIntegration(this, integration$1, this._integrations);
        if (!isAlreadyInstalled) $iOdTc.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = $jGI7F.extractGenAiSpansFromEvent(event, this);
        let env = $ajhqL.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        if (!$lpiqE.isInternalException(hint)) for (const attachment of hint.attachments || [])env = $j6N8F.addItemToEnvelope(env, $j6N8F.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $j6N8F.addItemToEnvelope(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $9QW6c.DEFAULT_ENVIRONMENT } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn($d49d4e3a9c5373f3$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn($d49d4e3a9c5373f3$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = $ajhqL.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Error while sending envelope:", reason);
            return {};
        }
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $iOdTc.setupIntegrations(this, integrations);
        $iOdTc.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session$1.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $8OOjj.updateSession(session$1, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $l5lP1.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$5JqSP.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $4LxkX.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $5JqSP.getCurrentScope(), isolationScope = $5JqSP.getIsolationScope()) {
        if ($3T29C.DEBUG_BUILD && $d49d4e3a9c5373f3$var$isErrorEvent(event)) $g31Ce.debug.log(`Captured error event \`${$lpiqE.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($3T29C.DEBUG_BUILD) {
                if ($d49d4e3a9c5373f3$var$_isDoNotSendEventError(reason)) $g31Ce.debug.log(reason.message);
                else if ($d49d4e3a9c5373f3$var$_isInternalError(reason)) $g31Ce.debug.warn(reason.message);
                else $g31Ce.debug.warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $d49d4e3a9c5373f3$var$isTransactionEvent(event);
        const isError = $d49d4e3a9c5373f3$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : $5CFT4.parseSampleRate(sampleRate);
        const dataCategory = $d49d4e3a9c5373f3$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $d49d4e3a9c5373f3$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            if ($lpiqE.isInternalException(hint)) return prepared;
            const result = $d49d4e3a9c5373f3$var$processBeforeSend(this, options, prepared, hint);
            return $d49d4e3a9c5373f3$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $d49d4e3a9c5373f3$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isError && typeof parsedSampleRate === "number" && $hkF3C.safeMathRandom() > parsedSampleRate) {
                this.recordDroppedEvent("sample_rate", "error");
                throw $d49d4e3a9c5373f3$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`);
            }
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($d49d4e3a9c5373f3$var$_isDoNotSendEventError(reason) || $d49d4e3a9c5373f3$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $d49d4e3a9c5373f3$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $cx0Ur.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log("No dsn provided, will not send outcomes");
            return;
        }
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Sending outcomes:", outcomes);
        const envelope = $9WX7F.createClientReportEnvelope(outcomes, this._options.tunnel && $3zkbY.dsnToString(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $d49d4e3a9c5373f3$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $d49d4e3a9c5373f3$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($cUgOr.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$cUgOr.isPlainObject(event) && event !== null) throw $d49d4e3a9c5373f3$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $d49d4e3a9c5373f3$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$cUgOr.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $d49d4e3a9c5373f3$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $d49d4e3a9c5373f3$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$dvzf1.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($d49d4e3a9c5373f3$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($d49d4e3a9c5373f3$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan$1 || ignoreSpans) {
            const rootSpanJson = $6iJce.convertTransactionEventToSpanJson(processedEvent);
            if (ignoreSpans?.length && $ffWyI.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $6vUrj.showSpanDropWarning();
                else processedEvent = $4ty0t.merge(event, $6iJce.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && $ffWyI.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $ffWyI.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $6vUrj.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $d49d4e3a9c5373f3$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $d49d4e3a9c5373f3$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $d49d4e3a9c5373f3$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $d49d4e3a9c5373f3$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $d49d4e3a9c5373f3$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $d49d4e3a9c5373f3$var$estimateAttributesSizeInBytes(log.attributes);
}
function $d49d4e3a9c5373f3$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $d49d4e3a9c5373f3$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($cUgOr.isPrimitive(value)) weight += $d49d4e3a9c5373f3$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $d49d4e3a9c5373f3$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}
module.exports.Client = $d49d4e3a9c5373f3$var$Client;

});
parcelRegister("iOdTc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");
const $db17ab9f6b83c126$var$installedIntegrations = [];
function $db17ab9f6b83c126$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $db17ab9f6b83c126$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $db17ab9f6b83c126$var$filterDuplicates(integrations);
}
function $db17ab9f6b83c126$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $db17ab9f6b83c126$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $db17ab9f6b83c126$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $db17ab9f6b83c126$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$db17ab9f6b83c126$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $db17ab9f6b83c126$var$installedIntegrations.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Integration installed: ${integration.name}`);
}
function $db17ab9f6b83c126$var$addIntegration(integration) {
    const client = $5JqSP.getClient();
    if (!client) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $db17ab9f6b83c126$var$defineIntegration(fn) {
    return fn;
}
function $db17ab9f6b83c126$var$extendIntegration(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}
module.exports.addIntegration = $db17ab9f6b83c126$var$addIntegration;
module.exports.afterSetupIntegrations = $db17ab9f6b83c126$var$afterSetupIntegrations;
module.exports.defineIntegration = $db17ab9f6b83c126$var$defineIntegration;
module.exports.extendIntegration = $db17ab9f6b83c126$var$extendIntegration;
module.exports.getIntegrationsToSetup = $db17ab9f6b83c126$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $db17ab9f6b83c126$var$installedIntegrations;
module.exports.setupIntegration = $db17ab9f6b83c126$var$setupIntegration;
module.exports.setupIntegrations = $db17ab9f6b83c126$var$setupIntegrations;

});

parcelRegister("krgwg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7DFGy = parcelRequire("7DFGy");

var $du5vT = parcelRequire("du5vT");

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $aX5wF = parcelRequire("aX5wF");

var $6Uu3e = parcelRequire("6Uu3e");

var $5L5uH = parcelRequire("5L5uH");

var $6tiuR = parcelRequire("6tiuR");

var $cyH85 = parcelRequire("cyH85");

var $tJywI = parcelRequire("tJywI");

var $owf5B = parcelRequire("owf5B");
const $ee1324b0e2dbfe43$var$MAX_LOG_BUFFER_SIZE = 100;
function $ee1324b0e2dbfe43$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $ee1324b0e2dbfe43$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $ee1324b0e2dbfe43$var$_getBufferMap();
    const logBuffer = $ee1324b0e2dbfe43$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $ee1324b0e2dbfe43$var$MAX_LOG_BUFFER_SIZE) {
        $ee1324b0e2dbfe43$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $ee1324b0e2dbfe43$var$_INTERNAL_captureLog(beforeLog, currentScope = $5JqSP.getCurrentScope(), captureSerializedLog = $ee1324b0e2dbfe43$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $5JqSP.getClient();
    if (!client) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = true, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = $cyH85._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $aX5wF.getCombinedScopeData($5JqSP.getIsolationScope(), currentScope);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ($cUgOr.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $6Uu3e._getSpanForScope(currentScope);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? $g31Ce.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $5L5uH.timestampInSeconds();
    const sequenceAttr = $6tiuR.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $ee1324b0e2dbfe43$var$_removeLoneSurrogates(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $tJywI.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: $ee1324b0e2dbfe43$var$sanitizeLogAttributes({
            ...$7DFGy.serializeAttributes(scopeAttributes),
            ...$7DFGy.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $ee1324b0e2dbfe43$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $ee1324b0e2dbfe43$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $owf5B.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $ee1324b0e2dbfe43$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope$1);
}
function $ee1324b0e2dbfe43$var$_INTERNAL_getLogBuffer(client) {
    return $ee1324b0e2dbfe43$var$_getBufferMap().get(client);
}
function $ee1324b0e2dbfe43$var$_getBufferMap() {
    return $du5vT.getGlobalSingleton("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $ee1324b0e2dbfe43$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $ee1324b0e2dbfe43$var$_removeLoneSurrogates(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $ee1324b0e2dbfe43$var$_removeLoneSurrogates(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $ee1324b0e2dbfe43$var$_removeLoneSurrogates(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
module.exports._INTERNAL_captureLog = $ee1324b0e2dbfe43$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $ee1324b0e2dbfe43$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $ee1324b0e2dbfe43$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $ee1324b0e2dbfe43$var$_INTERNAL_getLogBuffer;
module.exports._removeLoneSurrogates = $ee1324b0e2dbfe43$var$_removeLoneSurrogates;

});
parcelRegister("6tiuR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $4b63cc92966eeb16$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $4b63cc92966eeb16$var$_sequenceNumber = 0;
let $4b63cc92966eeb16$var$_previousTimestampMs;
function $4b63cc92966eeb16$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($4b63cc92966eeb16$var$_previousTimestampMs !== void 0 && nowMs !== $4b63cc92966eeb16$var$_previousTimestampMs) $4b63cc92966eeb16$var$_sequenceNumber = 0;
    const value = $4b63cc92966eeb16$var$_sequenceNumber;
    $4b63cc92966eeb16$var$_sequenceNumber++;
    $4b63cc92966eeb16$var$_previousTimestampMs = nowMs;
    return {
        key: $4b63cc92966eeb16$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}
module.exports.getSequenceAttribute = $4b63cc92966eeb16$var$getSequenceAttribute;

});

parcelRegister("cyH85", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $4LxkX = parcelRequire("4LxkX");

var $6vUrj = parcelRequire("6vUrj");
function $924a1d99835cbd1c$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return $5JqSP.withScope(scope, ()=>{
        const span = $6vUrj.getActiveSpan();
        const traceContext = span ? $6vUrj.spanToTraceContext(span) : $5JqSP.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $4LxkX.getDynamicSamplingContextFromSpan(span) : $4LxkX.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $924a1d99835cbd1c$var$_getTraceInfoFromScope;

});

parcelRegister("tJywI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $05960bff567f053c$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $05960bff567f053c$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("owf5B", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $hGnwj = parcelRequire("hGnwj");
function $049b40ab805c2423$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...$hGnwj.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $049b40ab805c2423$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $3zkbY.dsnToString(dsn$1);
    return $j6N8F.createEnvelope(headers, [
        $049b40ab805c2423$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $049b40ab805c2423$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $049b40ab805c2423$var$createLogEnvelope;

});
parcelRegister("hGnwj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jlXif = parcelRequire("jlXif");

var $cqs9v = parcelRequire("cqs9v");
function $cdf89a88f9f557e2$var$isBrowser() {
    return typeof window !== "undefined" && (!$jlXif.isNodeEnv() || $cdf89a88f9f557e2$var$isElectronNodeRenderer());
}
function $cdf89a88f9f557e2$var$isElectronNodeRenderer() {
    const process = $cqs9v.GLOBAL_OBJ.process;
    return process?.type === "renderer";
}
module.exports.isBrowser = $cdf89a88f9f557e2$var$isBrowser;

});
parcelRegister("jlXif", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $N4tZW = parcelRequire("N4tZW");
function isNodeEnv() {
    return !$N4tZW.isBrowserBundle() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("N4tZW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $09380dea9edf3ef0$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $09380dea9edf3ef0$var$getSDKSource() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}
module.exports.getSDKSource = $09380dea9edf3ef0$var$getSDKSource;
module.exports.isBrowserBundle = $09380dea9edf3ef0$var$isBrowserBundle;

});





parcelRegister("7piEH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7DFGy = parcelRequire("7DFGy");

var $du5vT = parcelRequire("du5vT");

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $aX5wF = parcelRequire("aX5wF");

var $6Uu3e = parcelRequire("6Uu3e");

var $5L5uH = parcelRequire("5L5uH");

var $6tiuR = parcelRequire("6tiuR");

var $cyH85 = parcelRequire("cyH85");

var $cVjko = parcelRequire("cVjko");
const $564956c3adbb93ed$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $564956c3adbb93ed$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $564956c3adbb93ed$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $564956c3adbb93ed$var$_getBufferMap();
    const metricBuffer = $564956c3adbb93ed$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $564956c3adbb93ed$var$MAX_METRIC_BUFFER_SIZE) {
        $564956c3adbb93ed$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $564956c3adbb93ed$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $564956c3adbb93ed$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = $cyH85._getTraceInfoFromScope(client, currentScope);
    const span = $6Uu3e._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = $5L5uH.timestampInSeconds();
    const sequenceAttr = $6tiuR.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$7DFGy.serializeAttributes(scopeAttributes),
            ...$7DFGy.serializeAttributes(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $564956c3adbb93ed$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $5JqSP.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $564956c3adbb93ed$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $5JqSP.getClient();
    if (!client) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = $aX5wF.getCombinedScopeData($5JqSP.getIsolationScope(), currentScope);
    const enrichedMetric = $564956c3adbb93ed$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $564956c3adbb93ed$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $564956c3adbb93ed$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $564956c3adbb93ed$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $cVjko.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $564956c3adbb93ed$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope$1);
}
function $564956c3adbb93ed$var$_INTERNAL_getMetricBuffer(client) {
    return $564956c3adbb93ed$var$_getBufferMap().get(client);
}
function $564956c3adbb93ed$var$_getBufferMap() {
    return $du5vT.getGlobalSingleton("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
module.exports._INTERNAL_captureMetric = $564956c3adbb93ed$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $564956c3adbb93ed$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $564956c3adbb93ed$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $564956c3adbb93ed$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("cVjko", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $hGnwj = parcelRequire("hGnwj");
function $9689cd02cfc8c867$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...$hGnwj.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $9689cd02cfc8c867$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $3zkbY.dsnToString(dsn$1);
    return $j6N8F.createEnvelope(headers, [
        $9689cd02cfc8c867$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $9689cd02cfc8c867$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $9689cd02cfc8c867$var$createMetricEnvelope;

});


parcelRegister("jGI7F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hGnwj = parcelRequire("hGnwj");

var $6Xrci = parcelRequire("6Xrci");

var $lSsqe = parcelRequire("lSsqe");
function $e5542a69f194c9be$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || client.getOptions().streamGenAiSpans === false || $6Xrci.hasSpanStreamingEnabled(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push($lSsqe.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$hGnwj.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $e5542a69f194c9be$var$extractGenAiSpansFromEvent;

});
parcelRegister("lSsqe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6vUrj = parcelRequire("6vUrj");
function $fed4b02d3998cc26$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $6vUrj.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $fed4b02d3998cc26$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("9kCJF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $j6N8F = parcelRequire("j6N8F");

var $cx0Ur = parcelRequire("cx0Ur");

var $grFVK = parcelRequire("grFVK");
const $6cb40761fed21f8b$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function $6cb40761fed21f8b$var$createTransport(options, makeRequest, buffer = $cx0Ur.makePromiseBuffer(options.bufferSize || $6cb40761fed21f8b$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        $j6N8F.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $j6N8F.envelopeItemTypeToDataCategory(type);
            if ($grFVK.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $j6N8F.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ($j6N8F.envelopeContainsItemType(filteredEnvelope, [
                "client_report"
            ])) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $j6N8F.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $j6N8F.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $j6N8F.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ($3T29C.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) $g31Ce.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $grFVK.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $cx0Ur.SENTRY_BUFFER_FULL_ERROR) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $6cb40761fed21f8b$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $6cb40761fed21f8b$var$createTransport;

});
parcelRegister("cx0Ur", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lDdLA = parcelRequire("lDdLA");

var $dFAcI = parcelRequire("dFAcI");
const $91f945b2de2f1bc8$var$SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $91f945b2de2f1bc8$var$makePromiseBuffer(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return $lDdLA.rejectedSyncPromise($91f945b2de2f1bc8$var$SENTRY_BUFFER_FULL_ERROR);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return $lDdLA.resolvedSyncPromise(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$dFAcI.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $91f945b2de2f1bc8$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $91f945b2de2f1bc8$var$makePromiseBuffer;

});

parcelRegister("grFVK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hkF3C = parcelRequire("hkF3C");
const $bf8fb17aeb222d51$var$DEFAULT_RETRY_AFTER = 60000;
function $bf8fb17aeb222d51$var$parseRetryAfterHeader(header, now = $hkF3C.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $bf8fb17aeb222d51$var$DEFAULT_RETRY_AFTER;
}
function $bf8fb17aeb222d51$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $bf8fb17aeb222d51$var$isRateLimited(limits, dataCategory, now = $hkF3C.safeDateNow()) {
    return $bf8fb17aeb222d51$var$disabledUntil(limits, dataCategory) > now;
}
function $bf8fb17aeb222d51$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $hkF3C.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $bf8fb17aeb222d51$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $bf8fb17aeb222d51$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $bf8fb17aeb222d51$var$disabledUntil;
module.exports.isRateLimited = $bf8fb17aeb222d51$var$isRateLimited;
module.exports.parseRetryAfterHeader = $bf8fb17aeb222d51$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $bf8fb17aeb222d51$var$updateRateLimits;

});


parcelRegister("9WX7F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $j6N8F = parcelRequire("j6N8F");

var $5L5uH = parcelRequire("5L5uH");
function $73e76458722c824e$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || $5L5uH.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $j6N8F.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $73e76458722c824e$var$createClientReportEnvelope;

});

parcelRegister("6iJce", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");
function $49677b90a8cc85d1$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[$f3RkF.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$f3RkF.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $49677b90a8cc85d1$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$f3RkF.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$f3RkF.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $49677b90a8cc85d1$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $49677b90a8cc85d1$var$convertTransactionEventToSpanJson;

});

parcelRegister("ehLHs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bD531 = parcelRequire("bD531");
const $a667a7748364f040$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    urlQueryParams: true,
    graphQL: {
        document: true,
        variables: true
    },
    genAI: {
        inputs: true,
        outputs: true
    },
    databaseQueryData: true,
    stackFrameVariables: true,
    frameContextLines: 5
};
function $a667a7748364f040$var$isCollectBehavior(value) {
    return typeof value === "boolean" || "allow" in value || "deny" in value;
}
function $a667a7748364f040$var$resolveHttpHeaders(httpHeaders, base) {
    if (httpHeaders === void 0) return {
        ...base.httpHeaders
    };
    if ($a667a7748364f040$var$isCollectBehavior(httpHeaders)) return {
        request: httpHeaders,
        response: httpHeaders
    };
    return {
        request: httpHeaders.request ?? base.httpHeaders.request,
        response: httpHeaders.response ?? base.httpHeaders.response
    };
}
function $a667a7748364f040$var$resolveDataCollectionOptions(options) {
    const base = options.dataCollection != null ? $a667a7748364f040$var$DEFAULTS : $bD531.defaultPiiToCollectionOptions(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: $a667a7748364f040$var$resolveHttpHeaders(dc.httpHeaders, base),
        httpBodies: dc.httpBodies ?? base.httpBodies,
        // oxlint-disable-next-line typescript/no-deprecated
        urlQueryParams: dc.urlQueryParams ?? dc.queryParams ?? base.urlQueryParams,
        graphQL: {
            document: dc.graphQL?.document ?? base.graphQL.document,
            variables: dc.graphQL?.variables ?? base.graphQL.variables
        },
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        databaseQueryData: dc.databaseQueryData ?? base.databaseQueryData,
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}
module.exports.resolveDataCollectionOptions = $a667a7748364f040$var$resolveDataCollectionOptions;

});
parcelRegister("bD531", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5qpfH = parcelRequire("5qpfH");
function $8777409456dbe390$var$defaultPiiToCollectionOptions(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        urlQueryParams: true,
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: true,
            outputs: true
        },
        databaseQueryData: true,
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: $5qpfH.PII_HEADER_SNIPPETS
        },
        httpHeaders: {
            request: {
                deny: $5qpfH.PII_HEADER_SNIPPETS
            },
            response: {
                deny: $5qpfH.PII_HEADER_SNIPPETS
            }
        },
        httpBodies: [],
        urlQueryParams: {
            deny: $5qpfH.PII_HEADER_SNIPPETS
        },
        // The GraphQL document has literal values redacted at collection time, so it was historically
        // always attached regardless of `sendDefaultPii`; keep it on to preserve that behavior.
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        // Database query values were only sent with `sendDefaultPii: true` (e.g. Supabase gated on it),
        // so map the legacy "off" state to `false`.
        databaseQueryData: false,
        stackFrameVariables: true,
        frameContextLines: 7
    };
}
module.exports.defaultPiiToCollectionOptions = $8777409456dbe390$var$defaultPiiToCollectionOptions;

});
parcelRegister("5qpfH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $3f32f80539dc08e2$var$FILTERED_VALUE = "[Filtered]";
const $3f32f80539dc08e2$var$PII_HEADER_SNIPPETS = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $3f32f80539dc08e2$var$SENSITIVE_KEY_SNIPPETS = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $3f32f80539dc08e2$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];
module.exports.FILTERED_VALUE = $3f32f80539dc08e2$var$FILTERED_VALUE;
module.exports.PII_HEADER_SNIPPETS = $3f32f80539dc08e2$var$PII_HEADER_SNIPPETS;
module.exports.SENSITIVE_COOKIE_NAME_SNIPPETS = $3f32f80539dc08e2$var$SENSITIVE_COOKIE_NAME_SNIPPETS;
module.exports.SENSITIVE_KEY_SNIPPETS = $3f32f80539dc08e2$var$SENSITIVE_KEY_SNIPPETS;

});




parcelRegister("ijm9Y", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");
function $d54b30cefda1b099$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($3T29C.DEBUG_BUILD) $g31Ce.debug.enable();
        else $g31Ce.consoleSandbox(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = $5JqSP.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $d54b30cefda1b099$var$setCurrentClient(client);
    client.init();
    return client;
}
function $d54b30cefda1b099$var$setCurrentClient(client) {
    $5JqSP.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $d54b30cefda1b099$var$initAndBind;
module.exports.setCurrentClient = $d54b30cefda1b099$var$setCurrentClient;

});

parcelRegister("lCaM2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $j6N8F = parcelRequire("j6N8F");

var $hkF3C = parcelRequire("hkF3C");

var $grFVK = parcelRequire("grFVK");

var $dFAcI = parcelRequire("dFAcI");
const $fbc581032890f96b$var$MIN_DELAY = 100;
const $fbc581032890f96b$var$START_DELAY = 5e3;
const $fbc581032890f96b$var$MAX_DELAY = 36e5;
function $fbc581032890f96b$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $fbc581032890f96b$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay2) {
            if ($j6N8F.envelopeContainsItemType(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay2);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = $dFAcI.safeUnref(setTimeout(async ()=>{
                flushTimer = void 0;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    found[0].sent_at = new Date($hkF3C.safeDateNow()).toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $fbc581032890f96b$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            if (!isRetry && $j6N8F.envelopeContainsItemType(envelope$1, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope$1);
                flushIn($fbc581032890f96b$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope$1);
                let delay = $fbc581032890f96b$var$MIN_DELAY;
                if (result) {
                    if (result.headers?.["retry-after"]) delay = $grFVK.parseRetryAfterHeader(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 6e4;
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $fbc581032890f96b$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                if (timeout === void 0) {
                    retryDelay = $fbc581032890f96b$var$START_DELAY;
                    flushIn($fbc581032890f96b$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $fbc581032890f96b$var$MIN_DELAY;
module.exports.START_DELAY = $fbc581032890f96b$var$START_DELAY;
module.exports.makeOfflineTransport = $fbc581032890f96b$var$makeOfflineTransport;

});

parcelRegister("3XlS2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1scQ2 = parcelRequire("1scQ2");

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");
const $2e17d8d07d4e6df7$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
function $2e17d8d07d4e6df7$var$eventFromEnvelope(env, types) {
    let event;
    $j6N8F.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : void 0;
        return !!event;
    });
    return event;
}
function $2e17d8d07d4e6df7$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $2e17d8d07d4e6df7$var$eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
function $2e17d8d07d4e6df7$var$overrideDsn(envelope$1, dsn) {
    return $j6N8F.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
function $2e17d8d07d4e6df7$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = /* @__PURE__ */ new Map();
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$2e17d8d07d4e6df7$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$2e17d8d07d4e6df7$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$2e17d8d07d4e6df7$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $3zkbY.dsnFromString(dsn$1);
                if (!validatedDsn) return void 0;
                const url = $1scQ2.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $2e17d8d07d4e6df7$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return $2e17d8d07d4e6df7$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, void 0);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($2e17d8d07d4e6df7$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $2e17d8d07d4e6df7$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $2e17d8d07d4e6df7$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $2e17d8d07d4e6df7$var$makeMultiplexedTransport;

});

parcelRegister("fbkeM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");
const $b0d794d28f9c9d2c$var$SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
function $b0d794d28f9c9d2c$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $b0d794d28f9c9d2c$var$SKIPPED_AI_PROVIDERS.add(module);
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
function $b0d794d28f9c9d2c$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $b0d794d28f9c9d2c$var$SKIPPED_AI_PROVIDERS.has(module);
}
function $b0d794d28f9c9d2c$var$_INTERNAL_clearAiProviderSkips() {
    $b0d794d28f9c9d2c$var$SKIPPED_AI_PROVIDERS.clear();
    $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Cleared AI provider skip registrations");
}
module.exports._INTERNAL_clearAiProviderSkips = $b0d794d28f9c9d2c$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $b0d794d28f9c9d2c$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $b0d794d28f9c9d2c$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("eEukW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5qpfH = parcelRequire("5qpfH");
function $aaac555d2270f807$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $aaac555d2270f807$var$shouldFilterDataKey(key, behavior, additionalDenyTerms) {
    if (behavior === false) return true;
    const lowerKey = key.toLowerCase();
    const denySnippets = additionalDenyTerms != null ? [
        ...$5qpfH.SENSITIVE_KEY_SNIPPETS,
        ...additionalDenyTerms
    ] : $5qpfH.SENSITIVE_KEY_SNIPPETS;
    if ($aaac555d2270f807$var$isSensitiveKey(lowerKey, denySnippets)) return true;
    if (behavior === true) return false;
    const terms = "deny" in behavior ? behavior.deny : behavior.allow;
    const matchesConfiguredTerm = terms.some((term)=>lowerKey.includes(term.toLowerCase()));
    return "deny" in behavior ? matchesConfiguredTerm : !matchesConfiguredTerm;
}
function $aaac555d2270f807$var$filterKeyValueData(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const result = {};
    for (const key of Object.keys(data))result[key] = $aaac555d2270f807$var$shouldFilterDataKey(key, behavior, additionalDenyTerms) ? $5qpfH.FILTERED_VALUE : data[key];
    return result;
}
module.exports.filterKeyValueData = $aaac555d2270f807$var$filterKeyValueData;
module.exports.shouldFilterDataKey = $aaac555d2270f807$var$shouldFilterDataKey;

});

parcelRegister("l8Kgs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dixtt = parcelRequire("dixtt");

var $5qpfH = parcelRequire("5qpfH");

var $eEukW = parcelRequire("eEukW");
function $f63e3b7f0c741638$var$filterCookies(cookieString, behavior) {
    if (behavior === false) return {};
    try {
        const parsed = $dixtt.parseCookie(cookieString);
        if (Object.keys(parsed).length === 0) return {};
        return $eEukW.filterKeyValueData(parsed, behavior, $5qpfH.SENSITIVE_COOKIE_NAME_SNIPPETS);
    } catch  {
        return $5qpfH.FILTERED_VALUE;
    }
}
module.exports.filterCookies = $f63e3b7f0c741638$var$filterCookies;

});
parcelRegister("dixtt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9ae6ec215cbbc078$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            if (val.charCodeAt(0) === 34) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $9ae6ec215cbbc078$var$parseCookie;

});


parcelRegister("dAAl0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5qpfH = parcelRequire("5qpfH");

var $eEukW = parcelRequire("eEukW");
function $9e4ad3184b16c68b$var$filterQueryParams(queryString, behavior) {
    if (!queryString || behavior === false) return void 0;
    return queryString.split("&").map((pair)=>{
        const separatorIndex = pair.indexOf("=");
        const encodedKey = separatorIndex === -1 ? pair : pair.slice(0, separatorIndex);
        const key = new URLSearchParams(`${encodedKey}=`).keys().next().value;
        return key !== void 0 && $eEukW.shouldFilterDataKey(key, behavior) ? `${encodedKey}=${$5qpfH.FILTERED_VALUE}` : pair;
    }).join("&");
}
module.exports.filterQueryParams = $9e4ad3184b16c68b$var$filterQueryParams;

});

parcelRegister("bMiFH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $dAAl0 = parcelRequire("dAAl0");

var $deA5a = parcelRequire("deA5a");
function $8932a929f51eaadd$var$urlQueryParamsBehavior(client) {
    return (client ?? $5JqSP.getClient())?.getDataCollectionOptions().urlQueryParams ?? true;
}
function $8932a929f51eaadd$var$filterCollectedUrl(url, client) {
    return url === void 0 ? void 0 : $deA5a.filterUrlQuery(url, $8932a929f51eaadd$var$urlQueryParamsBehavior(client));
}
function $8932a929f51eaadd$var$filterCollectedUrlQuery(query, client) {
    if (!query) return query;
    const hasPrefix = query.startsWith("?");
    const filtered = $dAAl0.filterQueryParams(hasPrefix ? query.slice(1) : query, $8932a929f51eaadd$var$urlQueryParamsBehavior(client));
    return filtered && hasPrefix ? `?${filtered}` : filtered;
}
module.exports.filterCollectedUrl = $8932a929f51eaadd$var$filterCollectedUrl;
module.exports.filterCollectedUrlQuery = $8932a929f51eaadd$var$filterCollectedUrlQuery;

});
parcelRegister("deA5a", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dAAl0 = parcelRequire("dAAl0");
function $9a28925bce5c6738$var$filterUrlQuery(url, behavior) {
    const fragmentStart = url.indexOf("#");
    const queryEnd = fragmentStart === -1 ? url.length : fragmentStart;
    const queryStart = url.indexOf("?");
    if (queryStart === -1 || queryStart > queryEnd) return url;
    const prefix = url.slice(0, queryStart);
    const query = url.slice(queryStart + 1, queryEnd);
    const suffix = url.slice(queryEnd);
    const filtered = $dAAl0.filterQueryParams(query, behavior);
    return filtered ? `${prefix}?${filtered}${suffix}` : `${prefix}${suffix}`;
}
module.exports.filterUrlQuery = $9a28925bce5c6738$var$filterUrlQuery;

});


parcelRegister("lneXJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f8f75a345f867308$var$FALSY_ENV_VALUES = /* @__PURE__ */ new Set([
    "false",
    "f",
    "n",
    "no",
    "off",
    "0"
]);
const $f8f75a345f867308$var$TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set([
    "true",
    "t",
    "y",
    "yes",
    "on",
    "1"
]);
function $f8f75a345f867308$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($f8f75a345f867308$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($f8f75a345f867308$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $f8f75a345f867308$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $f8f75a345f867308$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $f8f75a345f867308$var$envToBool;

});

parcelRegister("3TOA3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $hkF3C = parcelRequire("hkF3C");
function $2d6dbe66eee26d01$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: new Date($hkF3C.safeDateNow()).toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $3zkbY.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $2d6dbe66eee26d01$var$createCheckInEnvelopeItem(checkIn);
    return $j6N8F.createEnvelope(headers, [
        item
    ]);
}
function $2d6dbe66eee26d01$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $2d6dbe66eee26d01$var$createCheckInEnvelope;

});

parcelRegister("fnNKN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dBuCl = parcelRequire("dBuCl");
function $b32f9911f4d0d105$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $b32f9911f4d0d105$var$checkDsn(url, dsn) || $b32f9911f4d0d105$var$checkTunnel(url, tunnel);
}
function $b32f9911f4d0d105$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $b32f9911f4d0d105$var$removeTrailingSlash(url) === $b32f9911f4d0d105$var$removeTrailingSlash(tunnel);
}
function $b32f9911f4d0d105$var$checkDsn(url$1, dsn) {
    const urlParts = $dBuCl.parseStringToURLObject(url$1);
    if (!urlParts || $dBuCl.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $b32f9911f4d0d105$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $b32f9911f4d0d105$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $b32f9911f4d0d105$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $b32f9911f4d0d105$var$isSentryRequestUrl;

});
parcelRegister("dBuCl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $f3RkF = parcelRequire("f3RkF");

var $bMiFH = parcelRequire("bMiFH");
const $9e767b0ca808b61c$var$DEFAULT_BASE_URL = "thismessage:/";
function $9e767b0ca808b61c$var$isURLObjectRelative(url) {
    return "isRelative" in url;
}
function $9e767b0ca808b61c$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $9e767b0ca808b61c$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $9e767b0ca808b61c$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($9e767b0ca808b61c$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $9e767b0ca808b61c$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $9e767b0ca808b61c$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $9e767b0ca808b61c$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName, client) {
    const attributes$1 = {
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
    };
    if (routeName) {
        attributes$1[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes$1[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes$1[$f3RkF.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes$1["url.query"] = $bMiFH.filterCollectedUrlQuery(urlObject.search, client);
        if (urlObject.hash) attributes$1["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes$1["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes$1[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$9e767b0ca808b61c$var$isURLObjectRelative(urlObject)) {
            attributes$1[$eAISS.URL_FULL] = $bMiFH.filterCollectedUrl(urlObject.href, client);
            if (urlObject.port) attributes$1["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes$1["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes$1[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $9e767b0ca808b61c$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes$1
    ];
}
function $9e767b0ca808b61c$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $9e767b0ca808b61c$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $9e767b0ca808b61c$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $9e767b0ca808b61c$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $9e767b0ca808b61c$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $9e767b0ca808b61c$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $9e767b0ca808b61c$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $9e767b0ca808b61c$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $9e767b0ca808b61c$var$parseStringToURLObject;
module.exports.parseUrl = $9e767b0ca808b61c$var$parseUrl;
module.exports.stripDataUrlContent = $9e767b0ca808b61c$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $9e767b0ca808b61c$var$stripUrlQueryAndFragment;

});


parcelRegister("9eSGE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6b9fd78cb281f867$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
const $6b9fd78cb281f867$var$fmt = $6b9fd78cb281f867$var$parameterize;
module.exports.fmt = $6b9fd78cb281f867$var$fmt;
module.exports.parameterize = $6b9fd78cb281f867$var$parameterize;

});

parcelRegister("1E9Rm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1scQ2 = parcelRequire("1scQ2");

var $g31Ce = parcelRequire("g31Ce");

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");
async function $13312ccd86a07de6$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response("Tunnel not configured", {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $j6N8F.parseEnvelope(body);
    } catch  {
        return new Response("Invalid envelope", {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response("Invalid envelope: missing header", {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response("Invalid envelope: missing DSN", {
        status: 400
    });
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $g31Ce.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response("DSN not allowed", {
            status: 403
        });
    }
    const dsnComponents = $3zkbY.makeDsn(dsn$1);
    if (!dsnComponents) {
        $g31Ce.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response("Invalid DSN", {
            status: 403
        });
    }
    const sentryIngestUrl = $1scQ2.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            body: body
        });
    } catch (error) {
        $g31Ce.debug.error("Sentry tunnel: failed to forward envelope", error);
        return new Response("Failed to forward envelope to Sentry", {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $13312ccd86a07de6$var$handleTunnelRequest;

});

parcelRegister("9A3c5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6f99f418a33e1378$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $6f99f418a33e1378$var$addAutoIpAddressToSession(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}
module.exports.addAutoIpAddressToSession = $6f99f418a33e1378$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $6f99f418a33e1378$var$addAutoIpAddressToUser;

});

parcelRegister("2bFOy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bOz44 = parcelRequire("bOz44");
function $197d0b56419d73f3$var$applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: $bOz44.SDK_VERSION
            }));
        sdk.version = $bOz44.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $197d0b56419d73f3$var$applySdkMetadata;

});

parcelRegister("8gm0h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tUnp = parcelRequire("3tUnp");

var $du5vT = parcelRequire("du5vT");

var $5JqSP = parcelRequire("5JqSP");

var $13TrR = parcelRequire("13TrR");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");

var $ckhr5 = parcelRequire("ckhr5");

var $gWYwh = parcelRequire("gWYwh");

var $4LxkX = parcelRequire("4LxkX");

var $aZ3HH = parcelRequire("aZ3HH");

var $7O2T2 = parcelRequire("7O2T2");
function $6040e2ce93309652$var$getTraceData(options = {}) {
    const client = options.client || $5JqSP.getClient();
    if (!$13TrR.isEnabled() || !client) return {};
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $5JqSP.getCurrentScope();
    const span = options.span || $6vUrj.getActiveSpan();
    const isTwpPlaceholder = $gWYwh.spanIsNonRecordingSpan(span) && !$ckhr5.hasSpansEnabled(client.getOptions());
    if (!span && $5JqSP.hasExternalPropagationContext()) return {};
    const sentryTrace = span && !isTwpPlaceholder ? $6vUrj.spanToTraceHeader(span) : $6040e2ce93309652$var$scopeToTraceHeader(scope);
    const dsc = span ? $4LxkX.getDynamicSamplingContextFromSpan(span) : $4LxkX.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $aZ3HH.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $7O2T2.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $g31Ce.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span && !isTwpPlaceholder ? $6vUrj.spanToTraceparentHeader(span) : $6040e2ce93309652$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $6040e2ce93309652$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $7O2T2.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $6040e2ce93309652$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $7O2T2.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $6040e2ce93309652$var$getTraceData;

});

parcelRegister("fvTyO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $foFxi = parcelRequire("foFxi");
const $b4b4d9726191fe5f$var$NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
function $b4b4d9726191fe5f$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== "string" || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== void 0) {
        $3T29C.DEBUG_BUILD && !cachedDecision && $g31Ce.debug.log($b4b4d9726191fe5f$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $foFxi.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $3T29C.DEBUG_BUILD && !decision && $g31Ce.debug.log($b4b4d9726191fe5f$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $b4b4d9726191fe5f$var$shouldPropagateTraceForUrl;

});

parcelRegister("laTYc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8gm0h = parcelRequire("8gm0h");
function $f6a5f2a16a237c39$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $8gm0h.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join("");
}
module.exports.getTraceMetaTags = $f6a5f2a16a237c39$var$getTraceMetaTags;

});

parcelRegister("h6J9f", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c74604b311330f5a$var$uniq(input) {
    return Array.from(new Set(input));
}
module.exports.uniq = $c74604b311330f5a$var$uniq;

});

parcelRegister("8qWlp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $bD531 = parcelRequire("bD531");

var $5qpfH = parcelRequire("5qpfH");

var $eEukW = parcelRequire("eEukW");

var $dFAcI = parcelRequire("dFAcI");
const $623e026128e97057$var$MAX_BODY_BYTE_LENGTH = 1048576;
const $623e026128e97057$var$TEXT_CONTENT_TYPES = [
    "text/",
    "application/json",
    "application/x-www-form-urlencoded",
    "application/xml",
    "application/graphql"
];
function $623e026128e97057$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === "small") return 1e3;
    if (maxRequestBodySize === "medium") return 1e4;
    return $623e026128e97057$var$MAX_BODY_BYTE_LENGTH;
}
function $623e026128e97057$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") headers[key] = value;
        });
    } catch  {}
    return headers;
}
function $623e026128e97057$var$headersToDict(reqHeaders) {
    const headers = /* @__PURE__ */ Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === "string") headers[key] = value;
            else if (typeof value === "number") headers[key] = String(value);
        });
    } catch  {}
    return headers;
}
function $623e026128e97057$var$winterCGRequestToRequestData(req) {
    const headers = $623e026128e97057$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $623e026128e97057$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
function $623e026128e97057$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $623e026128e97057$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
async function $623e026128e97057$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get("content-type");
        if (!$623e026128e97057$var$isTextualContentType(contentType)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Skipping body capture for non-textual content type:", contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get("content-length");
        const maxBodySize = $623e026128e97057$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $623e026128e97057$var$MAX_BODY_BYTE_LENGTH) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Skipping body capture: body too large", length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $dFAcI.safeUnref(setTimeout(()=>resolve(null), 2e3));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Timeout reading request body");
            return;
        }
        if (!body) return;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Captured request body:", bodyByteLength, "bytes");
    } catch (error) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Error capturing request body:", error);
    }
}
function $623e026128e97057$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
    const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
    const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? "https" : "http");
    const url = request.url || "";
    const absoluteUrl = $623e026128e97057$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    const data = request.body || void 0;
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $623e026128e97057$var$extractQueryParamsFromUrl(url),
        headers: $623e026128e97057$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $623e026128e97057$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith("http")) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return void 0;
}
function $623e026128e97057$var$httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
    const resolvedDataCollection = typeof dataCollection === "boolean" ? $bD531.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
    const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
    const cookieBehavior = resolvedDataCollection.cookies;
    const prefix = `http.${lifecycle}.header.`;
    const spanAttributes = {};
    try {
        const regularHeaders = {};
        for (const [key, value] of Object.entries(headers)){
            if (value == null) continue;
            const lowerKey = key.toLowerCase();
            const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
            if (isCookieHeader) {
                if (cookieBehavior === false) continue;
                if (typeof value === "string" && value !== "") {
                    const parsed = $623e026128e97057$var$parseCookieHeader(value, lowerKey === "set-cookie");
                    const filtered = $eEukW.filterKeyValueData(parsed, cookieBehavior, $5qpfH.SENSITIVE_COOKIE_NAME_SNIPPETS);
                    for (const [cookieKey, cookieValue] of Object.entries(filtered))spanAttributes[`${prefix}${$623e026128e97057$var$normalizeAttributeKey(lowerKey)}.${$623e026128e97057$var$normalizeAttributeKey(cookieKey)}`] = cookieValue;
                } else spanAttributes[`${prefix}${$623e026128e97057$var$normalizeAttributeKey(lowerKey)}`] = $5qpfH.FILTERED_VALUE;
            } else {
                if (headerBehavior === false) continue;
                if (Array.isArray(value)) regularHeaders[lowerKey] = value.map((v)=>v != null ? String(v) : v).join(";");
                else if (typeof value === "string") regularHeaders[lowerKey] = value;
            }
        }
        if (headerBehavior !== false) {
            const filtered = $eEukW.filterKeyValueData(regularHeaders, headerBehavior);
            for (const [headerKey, headerValue] of Object.entries(filtered))spanAttributes[`${prefix}${$623e026128e97057$var$normalizeAttributeKey(headerKey)}`] = headerValue;
        }
    } catch  {}
    return spanAttributes;
}
function $623e026128e97057$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, "_");
}
function $623e026128e97057$var$parseCookieHeader(value, isSetCookie) {
    const semicolonIndex = value.indexOf(";");
    const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
    const cookies = isSetCookie ? [
        cookieString
    ] : cookieString.split("; ");
    const result = {};
    for (const cookie of cookies){
        const equalSignIndex = cookie.indexOf("=");
        const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
        const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
        result[cookieKey] = cookieValue;
    }
    return result;
}
function $623e026128e97057$var$extractQueryParamsFromUrl(url) {
    if (!url) return;
    try {
        const queryParams = new URL(url, "http://s.io").search.slice(1);
        return queryParams.length ? queryParams : void 0;
    } catch  {
        return void 0;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $623e026128e97057$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $623e026128e97057$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $623e026128e97057$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $623e026128e97057$var$getMaxBodyByteLength;
module.exports.headersToDict = $623e026128e97057$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $623e026128e97057$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $623e026128e97057$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $623e026128e97057$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $623e026128e97057$var$winterCGRequestToRequestData;

});

parcelRegister("bctHB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $8277daf33362ca55$var$SPAN_KIND = {
    INTERNAL: 0,
    SERVER: 1,
    CLIENT: 2,
    PRODUCER: 3,
    CONSUMER: 4
};
const $8277daf33362ca55$var$SPAN_KIND_NAME = {
    [$8277daf33362ca55$var$SPAN_KIND.INTERNAL]: "INTERNAL",
    [$8277daf33362ca55$var$SPAN_KIND.SERVER]: "SERVER",
    [$8277daf33362ca55$var$SPAN_KIND.CLIENT]: "CLIENT",
    [$8277daf33362ca55$var$SPAN_KIND.PRODUCER]: "PRODUCER",
    [$8277daf33362ca55$var$SPAN_KIND.CONSUMER]: "CONSUMER"
};
function $8277daf33362ca55$var$spanKindToName(kind) {
    return $8277daf33362ca55$var$SPAN_KIND_NAME[kind];
}
module.exports.SPAN_KIND = $8277daf33362ca55$var$SPAN_KIND;
module.exports.spanKindToName = $8277daf33362ca55$var$spanKindToName;

});

parcelRegister("8mgFa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $g31Ce = parcelRequire("g31Ce");

var $5L5uH = parcelRequire("5L5uH");
const $615d4db46a01524f$var$DEFAULT_BREADCRUMBS = 100;
function $615d4db46a01524f$var$addBreadcrumb(breadcrumb, hint) {
    const client = $5JqSP.getClient();
    const isolationScope = $5JqSP.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $615d4db46a01524f$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $5L5uH.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $g31Ce.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $615d4db46a01524f$var$addBreadcrumb;

});

parcelRegister("3Rkxj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $iOdTc = parcelRequire("iOdTc");

var $42zXR = parcelRequire("42zXR");
const $2cf640672a2aea88$var$INTEGRATION_NAME = "FunctionToString";
const $2cf640672a2aea88$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $2cf640672a2aea88$var$_functionToStringIntegration = ()=>{
    return {
        name: $2cf640672a2aea88$var$INTEGRATION_NAME,
        setupOnce () {
            const originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $42zXR.getOriginalFunction(this);
                    let unwrappedFunction;
                    try {
                        if ($2cf640672a2aea88$var$SETUP_CLIENTS.has($5JqSP.getClient()) && originalFunction !== void 0) unwrappedFunction = originalFunction;
                    } catch  {}
                    return originalFunctionToString.apply(unwrappedFunction ?? this, args);
                };
            } catch  {}
        },
        setup (client) {
            $2cf640672a2aea88$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $2cf640672a2aea88$var$functionToStringIntegration = $iOdTc.defineIntegration($2cf640672a2aea88$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $2cf640672a2aea88$var$functionToStringIntegration;

});

parcelRegister("g7zRo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $iOdTc = parcelRequire("iOdTc");

var $g31Ce = parcelRequire("g31Ce");

var $lpiqE = parcelRequire("lpiqE");

var $rzjlZ = parcelRequire("rzjlZ");

var $foFxi = parcelRequire("foFxi");
const $bbc91de2425cb6af$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /Java exception was raised during method invocation$/,
    // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065, https://github.com/getsentry/sentry-javascript/issues/23733)
    /Java object is gone$/
];
const $bbc91de2425cb6af$var$INTEGRATION_NAME = "EventFilters";
const $bbc91de2425cb6af$var$eventFiltersIntegration = $iOdTc.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $bbc91de2425cb6af$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $bbc91de2425cb6af$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $bbc91de2425cb6af$var$_mergeOptions(options, clientOptions);
            }
            return $bbc91de2425cb6af$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $bbc91de2425cb6af$var$inboundFiltersIntegration = $iOdTc.defineIntegration((options = {})=>{
    return {
        ...$bbc91de2425cb6af$var$eventFiltersIntegration(options),
        name: "InboundFilters"
    };
});
function $bbc91de2425cb6af$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $bbc91de2425cb6af$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $bbc91de2425cb6af$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($bbc91de2425cb6af$var$_isIgnoredError(event, options.ignoreErrors)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${$rzjlZ.getEventDescription(event)}`);
            return true;
        }
        if ($bbc91de2425cb6af$var$_isUselessError(event)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${$rzjlZ.getEventDescription(event)}`);
            return true;
        }
        if ($bbc91de2425cb6af$var$_isDeniedUrl(event, options.denyUrls)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${$rzjlZ.getEventDescription(event)}.
Url: ${$bbc91de2425cb6af$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$bbc91de2425cb6af$var$_isAllowedUrl(event, options.allowUrls)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${$rzjlZ.getEventDescription(event)}.
Url: ${$bbc91de2425cb6af$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($bbc91de2425cb6af$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${$rzjlZ.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $bbc91de2425cb6af$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $lpiqE.getPossibleEventMessages(event).some((message)=>$foFxi.stringMatchesSomePattern(message, ignoreErrors));
}
function $bbc91de2425cb6af$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $foFxi.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $bbc91de2425cb6af$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $bbc91de2425cb6af$var$_getEventFilterUrl(event);
    return !url ? false : $foFxi.stringMatchesSomePattern(url, denyUrls);
}
function $bbc91de2425cb6af$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $bbc91de2425cb6af$var$_getEventFilterUrl(event);
    return !url ? true : $foFxi.stringMatchesSomePattern(url, allowUrls);
}
function $bbc91de2425cb6af$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $bbc91de2425cb6af$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $bbc91de2425cb6af$var$_getLastValidUrl(frames) : null;
    } catch  {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error(`Cannot extract url for event ${$rzjlZ.getEventDescription(event)}`);
        return null;
    }
}
function $bbc91de2425cb6af$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}
module.exports.eventFiltersIntegration = $bbc91de2425cb6af$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $bbc91de2425cb6af$var$inboundFiltersIntegration;

});

parcelRegister("gkhWS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $aJD8C = parcelRequire("aJD8C");

var $9eX4e = parcelRequire("9eX4e");
const $be2c6fce6a30c3a1$var$DEFAULT_KEY = "cause";
const $be2c6fce6a30c3a1$var$DEFAULT_LIMIT = 5;
const $be2c6fce6a30c3a1$var$INTEGRATION_NAME = "LinkedErrors";
const $be2c6fce6a30c3a1$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $be2c6fce6a30c3a1$var$DEFAULT_LIMIT;
    const key = options.key || $be2c6fce6a30c3a1$var$DEFAULT_KEY;
    return {
        name: $be2c6fce6a30c3a1$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            $aJD8C.applyAggregateErrorsToEvent($9eX4e.exceptionFromError, options2.stackParser, key, limit, event, hint);
        }
    };
};
const $be2c6fce6a30c3a1$var$linkedErrorsIntegration = $iOdTc.defineIntegration($be2c6fce6a30c3a1$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $be2c6fce6a30c3a1$var$linkedErrorsIntegration;

});
parcelRegister("aJD8C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");
function $7d0c775358931250$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$cUgOr.isError(hint.originalException)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $7d0c775358931250$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $7d0c775358931250$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ($cUgOr.isError(error[key])) {
        $7d0c775358931250$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $7d0c775358931250$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $7d0c775358931250$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($7d0c775358931250$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($cUgOr.isError(childError)) {
            $7d0c775358931250$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $7d0c775358931250$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $7d0c775358931250$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $7d0c775358931250$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $7d0c775358931250$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$7d0c775358931250$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $7d0c775358931250$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $7d0c775358931250$var$applyAggregateErrorsToEvent;

});

parcelRegister("9eX4e", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");

var $rzjlZ = parcelRequire("rzjlZ");

var $9EvIV = parcelRequire("9EvIV");

var $42zXR = parcelRequire("42zXR");
function $6ba33d6325c7ea10$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $6ba33d6325c7ea10$var$hasSentryFetchUrlHost(error) {
    return $cUgOr.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $6ba33d6325c7ea10$var$_enhanceErrorWithSentryInfo(error) {
    if ($6ba33d6325c7ea10$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $6ba33d6325c7ea10$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $6ba33d6325c7ea10$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $6ba33d6325c7ea10$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $6ba33d6325c7ea10$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if ($cUgOr.isError(value)) return value;
    }
    return void 0;
}
function $6ba33d6325c7ea10$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = $42zXR.extractExceptionKeysForMessage(exception);
    if ($cUgOr.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $6ba33d6325c7ea10$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $6ba33d6325c7ea10$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $6ba33d6325c7ea10$var$getException(client, mechanism, exception, hint) {
    if ($cUgOr.isError(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ($cUgOr.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: $9EvIV.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $6ba33d6325c7ea10$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $6ba33d6325c7ea10$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $6ba33d6325c7ea10$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $6ba33d6325c7ea10$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $6ba33d6325c7ea10$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $rzjlZ.addExceptionTypeValue(event, void 0, void 0);
    $rzjlZ.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $6ba33d6325c7ea10$var$eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $6ba33d6325c7ea10$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $rzjlZ.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($cUgOr.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $6ba33d6325c7ea10$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $6ba33d6325c7ea10$var$eventFromMessage;
module.exports.eventFromUnknownInput = $6ba33d6325c7ea10$var$eventFromUnknownInput;
module.exports.exceptionFromError = $6ba33d6325c7ea10$var$exceptionFromError;
module.exports.parseStackFrames = $6ba33d6325c7ea10$var$parseStackFrames;

});


parcelRegister("iVKe8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $lFg4k = parcelRequire("lFg4k");

var $j6N8F = parcelRequire("j6N8F");
const $dc81689577bb540b$var$moduleMetadataIntegration = $iOdTc.defineIntegration(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $j6N8F.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $lFg4k.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $lFg4k.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $dc81689577bb540b$var$moduleMetadataIntegration;

});
parcelRegister("lFg4k", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cqs9v = parcelRequire("cqs9v");
const $fc59e44246a66f95$var$filenameMetadataMap = /* @__PURE__ */ new Map();
const $fc59e44246a66f95$var$parsedStacks = /* @__PURE__ */ new Set();
function $fc59e44246a66f95$var$getFilenameToMetadataMap(parser) {
    if (!$cqs9v.GLOBAL_OBJ._sentryModuleMetadata) return {};
    const filenameMap = {};
    for (const stack of Object.keys($cqs9v.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $cqs9v.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $fc59e44246a66f95$var$ensureMetadataStacksAreParsed(parser) {
    if (!$cqs9v.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($cqs9v.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $cqs9v.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($fc59e44246a66f95$var$parsedStacks.has(stack)) continue;
        $fc59e44246a66f95$var$parsedStacks.add(stack);
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            $fc59e44246a66f95$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
function $fc59e44246a66f95$var$getMetadataForUrl(parser, filename) {
    $fc59e44246a66f95$var$ensureMetadataStacksAreParsed(parser);
    return $fc59e44246a66f95$var$filenameMetadataMap.get(filename);
}
function $fc59e44246a66f95$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $fc59e44246a66f95$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
function $fc59e44246a66f95$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $fc59e44246a66f95$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $fc59e44246a66f95$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $fc59e44246a66f95$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $fc59e44246a66f95$var$stripMetadataFromStackFrames;

});


parcelRegister("8K7Jl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $iOdTc = parcelRequire("iOdTc");

var $f3RkF = parcelRequire("f3RkF");

var $dixtt = parcelRequire("dixtt");

var $dAAl0 = parcelRequire("dAAl0");

var $deA5a = parcelRequire("deA5a");

var $8qWlp = parcelRequire("8qWlp");

var $iI370 = parcelRequire("iI370");

var $4wQxQ = parcelRequire("4wQxQ");

var $eAISS = parcelRequire("eAISS");
const $65d89db27b188a6b$var$INTEGRATION_NAME = "RequestData";
const $65d89db27b188a6b$var$_requestDataIntegration = (options = {})=>{
    function resolveIncludeAndDataCollection(client) {
        const dc = client.getDataCollectionOptions();
        const dataCollection = {
            ...dc,
            ...options.include?.cookies === true && dc.cookies === false && {
                cookies: true
            },
            ...options.include?.headers === true && dc.httpHeaders.request === false && {
                httpHeaders: {
                    ...dc.httpHeaders,
                    request: true
                }
            },
            ...options.include?.query_string === true && dc.urlQueryParams === false && {
                urlQueryParams: true
            }
        };
        return {
            dataCollection: dataCollection,
            include: {
                cookies: dataCollection.cookies !== false,
                // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
                data: true,
                headers: dataCollection.httpHeaders.request !== false,
                ip: dataCollection.userInfo,
                query_string: dataCollection.urlQueryParams !== false,
                // No dataCollection equivalent — URL is always included
                url: true,
                ...options.include
            }
        };
    }
    return {
        name: $65d89db27b188a6b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            if (normalizedRequest) $65d89db27b188a6b$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, include, dataCollection);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $5JqSP.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            $65d89db27b188a6b$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
        }
    };
};
const $65d89db27b188a6b$var$requestDataIntegration = $iOdTc.defineIntegration($65d89db27b188a6b$var$_requestDataIntegration);
function $65d89db27b188a6b$var$addNormalizedRequestDataToEvent(event, req, additionalData, include, dataCollection) {
    const requestData = $65d89db27b188a6b$var$extractNormalizedRequestData(req, include);
    if (requestData.query_string) requestData.query_string = $65d89db27b188a6b$var$normalizeAndFilterQueryString(requestData.query_string, dataCollection.urlQueryParams);
    if (requestData.url) requestData.url = $deA5a.filterUrlQuery(requestData.url, dataCollection.urlQueryParams);
    event.request = {
        ...event.request,
        ...requestData
    };
    if (include.ip) {
        const ip = req.headers && $iI370.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $65d89db27b188a6b$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
    const requestData = $65d89db27b188a6b$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes$1 = {};
    if (requestData.url) attributes$1[$eAISS.URL_FULL] = $deA5a.filterUrlQuery(requestData.url, dataCollection.urlQueryParams);
    if (requestData.method) attributes$1["http.request.method"] = requestData.method;
    if (requestData.query_string) attributes$1[$eAISS.URL_QUERY] = $65d89db27b188a6b$var$normalizeAndFilterQueryString(requestData.query_string, dataCollection.urlQueryParams);
    $4wQxQ.safeSetSpanJSONAttributes(span, attributes$1);
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join("; ");
        const cookieAttributes = $8qWlp.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, dataCollection, "request");
        $4wQxQ.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $8qWlp.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
        $4wQxQ.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $4wQxQ.safeSetSpanJSONAttributes(span, {
            "http.request.body.data": serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $iI370.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
        if (ip) $4wQxQ.safeSetSpanJSONAttributes(span, {
            [$f3RkF.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $65d89db27b188a6b$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($iI370.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $dixtt.parseCookie(headers.cookie) : void 0);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $65d89db27b188a6b$var$normalizeAndFilterQueryString(queryString, behavior) {
    const normalized = $65d89db27b188a6b$var$normalizeQueryString(queryString);
    return normalized ? $dAAl0.filterQueryParams(normalized, behavior) : void 0;
}
function $65d89db27b188a6b$var$normalizeQueryString(queryString) {
    if (typeof queryString === "string") return queryString || void 0;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const normalized = new URLSearchParams(pairs).toString();
    return normalized || void 0;
}
module.exports.requestDataIntegration = $65d89db27b188a6b$var$requestDataIntegration;

});
parcelRegister("iI370", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $d9eec003e23cfeba$var$ipHeaderNames = [
    "X-Client-IP",
    "X-Forwarded-For",
    "Fly-Client-IP",
    "CF-Connecting-IP",
    "Fastly-Client-Ip",
    "True-Client-Ip",
    "X-Real-IP",
    "X-Cluster-Client-IP",
    "X-Forwarded",
    "Forwarded-For",
    "Forwarded",
    "X-Vercel-Forwarded-For"
];
function $d9eec003e23cfeba$var$getClientIPAddress(headers) {
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    const headerValues = $d9eec003e23cfeba$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
        if (headerName === "Forwarded") return $d9eec003e23cfeba$var$parseForwardedHeader(value);
        return value?.split(",").map((v)=>v.trim());
    });
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $d9eec003e23cfeba$var$isIP(ip));
    return ipAddress || null;
}
function $d9eec003e23cfeba$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(";")){
        if (part.startsWith("for=")) return part.slice(4);
    }
    return null;
}
function $d9eec003e23cfeba$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $d9eec003e23cfeba$var$getClientIPAddress;
module.exports.ipHeaderNames = $d9eec003e23cfeba$var$ipHeaderNames;

});


parcelRegister("2Nx5l", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $13TrR = parcelRequire("13TrR");

var $8PsOG = parcelRequire("8PsOG");

var $iOdTc = parcelRequire("iOdTc");

var $g31Ce = parcelRequire("g31Ce");

var $rzjlZ = parcelRequire("rzjlZ");

var $dbBv0 = parcelRequire("dbBv0");

var $foFxi = parcelRequire("foFxi");

var $cqs9v = parcelRequire("cqs9v");
const $2099d26b534f0549$var$INTEGRATION_NAME = "CaptureConsole";
const $2099d26b534f0549$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $g31Ce.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $2099d26b534f0549$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in $cqs9v.GLOBAL_OBJ)) return;
            $8PsOG.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($5JqSP.getClient() !== client || !levels.includes(level)) return;
                $2099d26b534f0549$var$consoleHandler(args, level, handled);
            });
        }
    };
};
const $2099d26b534f0549$var$captureConsoleIntegration = $iOdTc.defineIntegration($2099d26b534f0549$var$_captureConsoleIntegration);
function $2099d26b534f0549$var$consoleHandler(args, level, handled) {
    const severityLevel = $dbBv0.severityLevelFromString(level);
    const syntheticException = new Error();
    const captureContext = {
        level: $dbBv0.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $5JqSP.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            $rzjlZ.addExceptionMechanism(event, {
                handled: handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message2 = `Assertion failed: ${$foFxi.safeJoin(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message2, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $13TrR.captureException(error, captureContext);
            return;
        }
        const message = $foFxi.safeJoin(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $2099d26b534f0549$var$captureConsoleIntegration;

});
parcelRegister("8PsOG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $42zXR = parcelRequire("42zXR");

var $foFxi = parcelRequire("foFxi");

var $cqs9v = parcelRequire("cqs9v");

var $eCBhU = parcelRequire("eCBhU");
const $66d97085e604b789$var$_filter = /* @__PURE__ */ new Set([]);
function $66d97085e604b789$var$addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = $eCBhU.addHandler(type, handler);
    $eCBhU.maybeInstrument(type, $66d97085e604b789$var$instrumentConsole);
    return removeHandler;
}
function $66d97085e604b789$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$66d97085e604b789$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$66d97085e604b789$var$_filter.delete(f);
    };
}
const $66d97085e604b789$var$instrumentedLevels = /* @__PURE__ */ new Set();
function $66d97085e604b789$var$instrumentConsole() {
    if (!("console" in $cqs9v.GLOBAL_OBJ)) return;
    $g31Ce.CONSOLE_LEVELS.forEach(function(level) {
        if ($66d97085e604b789$var$instrumentedLevels.has(level) || !(level in $cqs9v.GLOBAL_OBJ.console)) return;
        $66d97085e604b789$var$instrumentedLevels.add(level);
        $42zXR.fill($cqs9v.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $g31Ce.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $g31Ce.originalConsoleMethods[level];
                const isFiltered = $66d97085e604b789$var$_filter.size && typeof firstArg === "string" && $foFxi.stringMatchesSomePattern(firstArg, $66d97085e604b789$var$_filter);
                if (!isFiltered) $eCBhU.triggerHandlers("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || $3T29C.DEBUG_BUILD && $g31Ce.debug.isEnabled()) log?.apply($cqs9v.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $66d97085e604b789$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $66d97085e604b789$var$addConsoleInstrumentationHandler;
module.exports.instrumentConsole = $66d97085e604b789$var$instrumentConsole;

});

parcelRegister("dbBv0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $999963fca5d2d2fd$var$severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}
module.exports.severityLevelFromString = $999963fca5d2d2fd$var$severityLevelFromString;

});


parcelRegister("jFWDT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $iOdTc = parcelRequire("iOdTc");

var $g31Ce = parcelRequire("g31Ce");

var $1nK9H = parcelRequire("1nK9H");
const $e52f55d1d357b41c$var$INTEGRATION_NAME = "Dedupe";
const $e52f55d1d357b41c$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $e52f55d1d357b41c$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($e52f55d1d357b41c$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $e52f55d1d357b41c$var$dedupeIntegration = $iOdTc.defineIntegration($e52f55d1d357b41c$var$_dedupeIntegration);
function $e52f55d1d357b41c$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($e52f55d1d357b41c$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($e52f55d1d357b41c$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $e52f55d1d357b41c$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$e52f55d1d357b41c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$e52f55d1d357b41c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $e52f55d1d357b41c$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $e52f55d1d357b41c$var$_getExceptionFromEvent(previousEvent);
    const currentException = $e52f55d1d357b41c$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$e52f55d1d357b41c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$e52f55d1d357b41c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $e52f55d1d357b41c$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $1nK9H.getFramesFromEvent(currentEvent);
    let previousFrames = $1nK9H.getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $e52f55d1d357b41c$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $e52f55d1d357b41c$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $e52f55d1d357b41c$var$_shouldDropEvent;
module.exports.dedupeIntegration = $e52f55d1d357b41c$var$dedupeIntegration;

});

parcelRegister("dwAOK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $iOdTc = parcelRequire("iOdTc");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $9EvIV = parcelRequire("9EvIV");

var $fQMpe = parcelRequire("fQMpe");

var $foFxi = parcelRequire("foFxi");
const $9d8ad2b77950e154$var$INTEGRATION_NAME = "ExtraErrorData";
const $9d8ad2b77950e154$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $9d8ad2b77950e154$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $9d8ad2b77950e154$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $9d8ad2b77950e154$var$extraErrorDataIntegration = $iOdTc.defineIntegration($9d8ad2b77950e154$var$_extraErrorDataIntegration);
function $9d8ad2b77950e154$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$cUgOr.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $9d8ad2b77950e154$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $9EvIV.normalize(errorData, depth);
        if ($cUgOr.isPlainObject(normalizedErrorData)) {
            $fQMpe.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
function $9d8ad2b77950e154$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $cUgOr.isError(value) || typeof value === "string" ? maxValueLength ? $foFxi.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        if (captureErrorCause && error.cause !== void 0) {
            if ($cUgOr.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $9d8ad2b77950e154$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $cUgOr.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $9d8ad2b77950e154$var$extraErrorDataIntegration;

});

parcelRegister("dp3IX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $5ZJSQ = parcelRequire("5ZJSQ");

var $cqs9v = parcelRequire("cqs9v");
const $9c207fad3e121ad5$var$INTEGRATION_NAME = "RewriteFrames";
const $9c207fad3e121ad5$var$rewriteFramesIntegration = $iOdTc.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in $cqs9v.GLOBAL_OBJ && !!$cqs9v.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $9c207fad3e121ad5$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $9c207fad3e121ad5$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
function $9c207fad3e121ad5$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
            const base = root ? $5ZJSQ.relative(root, filename) : $5ZJSQ.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $9c207fad3e121ad5$var$generateIteratee;
module.exports.rewriteFramesIntegration = $9c207fad3e121ad5$var$rewriteFramesIntegration;

});
parcelRegister("5ZJSQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $45d63dce37017897$var$normalizeArray(parts, allowAboveRoot) {
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
const $45d63dce37017897$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
function $45d63dce37017897$var$splitPath(filename) {
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $45d63dce37017897$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
function $45d63dce37017897$var$resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    resolvedPath = $45d63dce37017897$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
function $45d63dce37017897$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $45d63dce37017897$var$relative(from, to) {
    from = $45d63dce37017897$var$resolve(from).slice(1);
    to = $45d63dce37017897$var$resolve(to).slice(1);
    const fromParts = $45d63dce37017897$var$trim(from.split("/"));
    const toParts = $45d63dce37017897$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $45d63dce37017897$var$normalizePath(path) {
    const isPathAbsolute = $45d63dce37017897$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    let normalizedPath = $45d63dce37017897$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $45d63dce37017897$var$isAbsolute(path) {
    return path.charAt(0) === "/";
}
function $45d63dce37017897$var$join(...args) {
    return $45d63dce37017897$var$normalizePath(args.join("/"));
}
function $45d63dce37017897$var$dirname(path) {
    const result = $45d63dce37017897$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) return ".";
    if (dir) dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
function $45d63dce37017897$var$basename(path, ext) {
    let f = $45d63dce37017897$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $45d63dce37017897$var$basename;
module.exports.dirname = $45d63dce37017897$var$dirname;
module.exports.isAbsolute = $45d63dce37017897$var$isAbsolute;
module.exports.join = $45d63dce37017897$var$join;
module.exports.normalizePath = $45d63dce37017897$var$normalizePath;
module.exports.relative = $45d63dce37017897$var$relative;
module.exports.resolve = $45d63dce37017897$var$resolve;

});


parcelRegister("QE2yw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8mgFa = parcelRequire("8mgFa");

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $13TrR = parcelRequire("13TrR");

var $iOdTc = parcelRequire("iOdTc");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $rzjlZ = parcelRequire("rzjlZ");

var $cUgOr = parcelRequire("cUgOr");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");
const $09e3ea98f4729cb0$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $09e3ea98f4729cb0$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $09e3ea98f4729cb0$var$FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $09e3ea98f4729cb0$var$DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $09e3ea98f4729cb0$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {}
}
function $09e3ea98f4729cb0$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
function $09e3ea98f4729cb0$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return void 0;
}
function $09e3ea98f4729cb0$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $09e3ea98f4729cb0$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
}
function $09e3ea98f4729cb0$var$getHeader(headers, name) {
    if (!headers) return void 0;
    if (typeof headers.get === "function") return headers.get(name) ?? void 0;
    const plainHeaders = headers;
    const lowerCaseName = name.toLowerCase();
    const key = Object.keys(plainHeaders).find((headerName)=>headerName.toLowerCase() === lowerCaseName);
    return key !== void 0 ? plainHeaders[key] : void 0;
}
function $09e3ea98f4729cb0$var$extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if ($09e3ea98f4729cb0$var$getHeader(headers, "Prefer")?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
function $09e3ea98f4729cb0$var$translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $09e3ea98f4729cb0$var$FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $09e3ea98f4729cb0$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $5CFne.startSpan({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if ($cUgOr.isObjectLike(res) && "error" in res && res.error) {
                        span.setStatus({
                            code: $h5H4c.SPAN_STATUS_ERROR
                        });
                        $13TrR.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: $h5H4c.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $h5H4c.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $13TrR.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $09e3ea98f4729cb0$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $09e3ea98f4729cb0$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $09e3ea98f4729cb0$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $09e3ea98f4729cb0$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $09e3ea98f4729cb0$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $09e3ea98f4729cb0$var$instrumentAuthOperation(authOperation, true);
    }
    $09e3ea98f4729cb0$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $09e3ea98f4729cb0$var$instrumentSupabaseClientConstructor(SupabaseClient, _options) {
    if ($09e3ea98f4729cb0$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $09e3ea98f4729cb0$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
            return rv;
        }
    });
    $09e3ea98f4729cb0$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $09e3ea98f4729cb0$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
    if ($09e3ea98f4729cb0$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $09e3ea98f4729cb0$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $09e3ea98f4729cb0$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())queryItems.push($09e3ea98f4729cb0$var$translateFiltersIntoMethods(key, value));
            const body = /* @__PURE__ */ Object.create(null);
            if ($cUgOr.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const client = $5JqSP.getClient();
            const shouldSendData = _options.sendOperationData ?? client?.getDataCollectionOptions().databaseQueryData === true;
            const bodyPayload = $09e3ea98f4729cb0$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            const mutationPart = operation === "select" ? "" : `${operation}${$09e3ea98f4729cb0$var$hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": $09e3ea98f4729cb0$var$getHeader(typedThis.headers, "X-Client-Info"),
                "db.system": "postgresql",
                "db.operation": operation,
                [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
            };
            if (queryItems.length && shouldSendData) attributes["db.query"] = queryItems;
            if (bodyPayload !== void 0 && shouldSendData) attributes["db.body"] = bodyPayload;
            return $5CFne.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) $h5H4c.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && shouldSendData) supabaseContext.query = queryItems;
                        if (bodyPayload !== void 0 && shouldSendData) supabaseContext.body = bodyPayload;
                        $13TrR.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $rzjlZ.addExceptionMechanism(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && shouldSendData) data.query = queryItems;
                    if (bodyPayload !== void 0 && shouldSendData) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $8mgFa.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        $h5H4c.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $09e3ea98f4729cb0$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $09e3ea98f4729cb0$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
    for (const operation of $09e3ea98f4729cb0$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($09e3ea98f4729cb0$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $09e3ea98f4729cb0$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
                return rv;
            }
        });
        $09e3ea98f4729cb0$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $09e3ea98f4729cb0$var$instrumentSupabaseClient = (supabaseClient, options = {})=>{
    if (!supabaseClient) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $09e3ea98f4729cb0$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
    $09e3ea98f4729cb0$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $09e3ea98f4729cb0$var$INTEGRATION_NAME = "Supabase";
const $09e3ea98f4729cb0$var$_supabaseIntegration = (supabaseClient, options)=>{
    return {
        setupOnce () {
            $09e3ea98f4729cb0$var$instrumentSupabaseClient(supabaseClient, options);
        },
        name: $09e3ea98f4729cb0$var$INTEGRATION_NAME
    };
};
const $09e3ea98f4729cb0$var$supabaseIntegration = $iOdTc.defineIntegration((options)=>{
    return $09e3ea98f4729cb0$var$_supabaseIntegration(options.supabaseClient, {
        sendOperationData: options.sendOperationData
    });
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $09e3ea98f4729cb0$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $09e3ea98f4729cb0$var$FILTER_MAPPINGS;
module.exports.extractOperation = $09e3ea98f4729cb0$var$extractOperation;
module.exports.getHeader = $09e3ea98f4729cb0$var$getHeader;
module.exports.instrumentSupabaseClient = $09e3ea98f4729cb0$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $09e3ea98f4729cb0$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $09e3ea98f4729cb0$var$translateFiltersIntoMethods;

});

parcelRegister("f6w5N", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $cUgOr = parcelRequire("cUgOr");

var $foFxi = parcelRequire("foFxi");
const $aff04f72d4d86d63$var$DEFAULT_LIMIT = 10;
const $aff04f72d4d86d63$var$INTEGRATION_NAME = "ZodErrors";
function $aff04f72d4d86d63$var$originalExceptionIsZodError(originalException) {
    return $cUgOr.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
function $aff04f72d4d86d63$var$flattenIssue(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
    };
}
function $aff04f72d4d86d63$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
function $aff04f72d4d86d63$var$formatIssueMessage(zodError) {
    const errorKeyMap = /* @__PURE__ */ new Set();
    for (const iss of zodError.issues){
        const issuePath = $aff04f72d4d86d63$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$foFxi.truncate(errorKeys.join(", "), 100)}`;
}
function $aff04f72d4d86d63$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$aff04f72d4d86d63$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($aff04f72d4d86d63$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $aff04f72d4d86d63$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
                }
            }
        };
    }
}
const $aff04f72d4d86d63$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $aff04f72d4d86d63$var$DEFAULT_LIMIT;
    return {
        name: $aff04f72d4d86d63$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $aff04f72d4d86d63$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
const $aff04f72d4d86d63$var$zodErrorsIntegration = $iOdTc.defineIntegration($aff04f72d4d86d63$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $aff04f72d4d86d63$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $aff04f72d4d86d63$var$flattenIssue;
module.exports.flattenIssuePath = $aff04f72d4d86d63$var$flattenIssuePath;
module.exports.formatIssueMessage = $aff04f72d4d86d63$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $aff04f72d4d86d63$var$zodErrorsIntegration;

});

parcelRegister("f87mP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $lFg4k = parcelRequire("lFg4k");

var $j6N8F = parcelRequire("j6N8F");

var $1nK9H = parcelRequire("1nK9H");

var $cqs9v = parcelRequire("cqs9v");
const $b03d515c77c654c6$var$thirdPartyErrorFilterIntegration = $iOdTc.defineIntegration((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $j6N8F.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $lFg4k.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $lFg4k.addMetadataToStackFrames(stackParser, event);
            });
        },
        preprocessEvent (event) {
            if (options.ignoreSentryInternalFrames && ($cqs9v.GLOBAL_OBJ._sentryWrappedDepth ?? 0) > 0) event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                insideSentryWrapped: true
            };
        },
        processEvent (event) {
            const insideSentryWrapped = options.ignoreSentryInternalFrames ? event.sdkProcessingMetadata?.insideSentryWrapped === true && event.exception?.values?.length === 1 : false;
            const frameKeys = $b03d515c77c654c6$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames, insideSentryWrapped);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
function $b03d515c77c654c6$var$isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
    if (frameIndex !== 0) return false;
    if (insideSentryWrapped && $b03d515c77c654c6$var$isLikelyMinifiedSentryWrappedFrame(frame)) return true;
    if (frame.function === "sentryWrapped") return true;
    if (!frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($b03d515c77c654c6$var$SENTRY_INTERNAL_FN_APPLY)) return false;
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($b03d515c77c654c6$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $b03d515c77c654c6$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
    const frames = $1nK9H.getFramesFromEvent(event);
    if (!frames) return void 0;
    return frames.filter((frame, index)=>{
        if (!frame.filename) return false;
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        return !ignoreSentryInternalFrames || !$b03d515c77c654c6$var$isSentryInternalFrame(frame, index, !!insideSentryWrapped);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($b03d515c77c654c6$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($b03d515c77c654c6$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
function $b03d515c77c654c6$var$isLikelyMinifiedSentryWrappedFrame(frame) {
    return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
}
const $b03d515c77c654c6$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const $b03d515c77c654c6$var$SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const $b03d515c77c654c6$var$SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";
module.exports.thirdPartyErrorFilterIntegration = $b03d515c77c654c6$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("dp8LO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8mgFa = parcelRequire("8mgFa");

var $5JqSP = parcelRequire("5JqSP");

var $8PsOG = parcelRequire("8PsOG");

var $iOdTc = parcelRequire("iOdTc");

var $g31Ce = parcelRequire("g31Ce");

var $dbBv0 = parcelRequire("dbBv0");

var $foFxi = parcelRequire("foFxi");

var $cqs9v = parcelRequire("cqs9v");
const $9c2469c12e6fa54b$var$INTEGRATION_NAME = "Console";
const $9c2469c12e6fa54b$var$consoleIntegration = $iOdTc.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $g31Ce.CONSOLE_LEVELS);
    return {
        name: $9c2469c12e6fa54b$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $8PsOG.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($5JqSP.getClient() !== client || !levels.has(level)) return;
                $9c2469c12e6fa54b$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = $8PsOG.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $9c2469c12e6fa54b$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: $dbBv0.severityLevelFromString(level),
        message: $9c2469c12e6fa54b$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$9c2469c12e6fa54b$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    $8mgFa.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $9c2469c12e6fa54b$var$formatConsoleArgs(values) {
    return "util" in $cqs9v.GLOBAL_OBJ && typeof $cqs9v.GLOBAL_OBJ.util.format === "function" ? $cqs9v.GLOBAL_OBJ.util.format(...values) : $foFxi.safeJoin(values, " ");
}
module.exports.addConsoleBreadcrumb = $9c2469c12e6fa54b$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $9c2469c12e6fa54b$var$consoleIntegration;

});

parcelRegister("dCSiT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $eFFx8 = parcelRequire("eFFx8");
const $9eb8f2923fbd736a$var$featureFlagsIntegration = $iOdTc.defineIntegration(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return $eFFx8._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $eFFx8._INTERNAL_insertFlagToScope(name, value);
            $eFFx8._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $9eb8f2923fbd736a$var$featureFlagsIntegration;

});
parcelRegister("eFFx8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");
const $aae51cb59fb527e0$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
const $aae51cb59fb527e0$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $aae51cb59fb527e0$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
function $aae51cb59fb527e0$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) return event;
    const scope = $5JqSP.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === void 0) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
function $aae51cb59fb527e0$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $aae51cb59fb527e0$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $5JqSP.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $aae51cb59fb527e0$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
function $aae51cb59fb527e0$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) flags.splice(index, 1);
    if (flags.length === maxSize) flags.shift();
    flags.push({
        flag: name,
        result: value
    });
}
function $aae51cb59fb527e0$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $aae51cb59fb527e0$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = $6vUrj.getActiveSpan();
    if (!span) return;
    const attributes = $6vUrj.spanToJSON(span).data;
    if (`${$aae51cb59fb527e0$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$aae51cb59fb527e0$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($aae51cb59fb527e0$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$aae51cb59fb527e0$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $aae51cb59fb527e0$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $aae51cb59fb527e0$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $aae51cb59fb527e0$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $aae51cb59fb527e0$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $aae51cb59fb527e0$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $aae51cb59fb527e0$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("i5zdK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $eFFx8 = parcelRequire("eFFx8");

var $42zXR = parcelRequire("42zXR");
const $d2b403b7ada96413$var$growthbookIntegration = $iOdTc.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            if (typeof proto.isOn === "function") $42zXR.fill(proto, "isOn", $d2b403b7ada96413$var$_wrapAndCaptureBooleanResult);
            if (typeof proto.getFeatureValue === "function") $42zXR.fill(proto, "getFeatureValue", $d2b403b7ada96413$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $eFFx8._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $d2b403b7ada96413$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            $eFFx8._INTERNAL_insertFlagToScope(flagName, result);
            $eFFx8._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $d2b403b7ada96413$var$growthbookIntegration;

});

parcelRegister("1V5lh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $iOdTc = parcelRequire("iOdTc");

var $f3RkF = parcelRequire("f3RkF");

var $6vUrj = parcelRequire("6vUrj");
const $165f422d979fd1e0$var$INTEGRATION_NAME = "ConversationId";
const $165f422d979fd1e0$var$_conversationIdIntegration = ()=>{
    return {
        name: $165f422d979fd1e0$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = $5JqSP.getCurrentScope().getScopeData();
                const isolationScopeData = $5JqSP.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $6vUrj.spanToJSON(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute($f3RkF.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
const $165f422d979fd1e0$var$conversationIdIntegration = $iOdTc.defineIntegration($165f422d979fd1e0$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $165f422d979fd1e0$var$conversationIdIntegration;

});

parcelRegister("1hGnJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");
function $0ef8411b4ec8151f$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
}
function $0ef8411b4ec8151f$var$startProfiler() {
    const client = $5JqSP.getClient();
    if (!client) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$0ef8411b4ec8151f$var$isProfilingIntegrationWithProfiler(integration)) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.start();
}
function $0ef8411b4ec8151f$var$stopProfiler() {
    const client = $5JqSP.getClient();
    if (!client) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$0ef8411b4ec8151f$var$isProfilingIntegrationWithProfiler(integration)) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.stop();
}
const $0ef8411b4ec8151f$var$profiler = {
    startProfiler: $0ef8411b4ec8151f$var$startProfiler,
    stopProfiler: $0ef8411b4ec8151f$var$stopProfiler
};
module.exports.profiler = $0ef8411b4ec8151f$var$profiler;

});

parcelRegister("jzLgh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $5JqSP = parcelRequire("5JqSP");

var $f3RkF = parcelRequire("f3RkF");

var $6vUrj = parcelRequire("6vUrj");

var $h5H4c = parcelRequire("h5H4c");

var $cUgOr = parcelRequire("cUgOr");

var $ckhr5 = parcelRequire("ckhr5");

var $gWYwh = parcelRequire("gWYwh");

var $aZ3HH = parcelRequire("aZ3HH");

var $6Xrci = parcelRequire("6Xrci");

var $5CFne = parcelRequire("5CFne");

var $bMiFH = parcelRequire("bMiFH");

var $8gm0h = parcelRequire("8gm0h");

var $dBuCl = parcelRequire("dBuCl");
function $e405f25ee64c11ba$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $ckhr5.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $e405f25ee64c11ba$var$endSpan(span2, handlerData);
                $e405f25ee64c11ba$var$_callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $5JqSP.getClient();
    const hasParent = !!$6vUrj.getActiveSpan();
    const shouldEmitSpan = hasParent || !!client && $6Xrci.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $5CFne.startInactiveSpan($e405f25ee64c11ba$var$getSpanStartOptions(url, method, spanOrigin, client)) : new $gWYwh.SentryNonRecordingSpan();
    const spanForTraceHeaders = $5CFne.spanIsIgnored(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $e405f25ee64c11ba$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $ckhr5.hasSpansEnabled() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $e405f25ee64c11ba$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
function $e405f25ee64c11ba$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $8gm0h.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ($cUgOr.isRequest(request) ? request.headers : void 0);
    if (!originalHeaders) return {
        "sentry-trace": sentryTrace,
        ...baggage && {
            baggage: baggage
        },
        ...traceparent && {
            traceparent: traceparent
        }
    };
    else if ($e405f25ee64c11ba$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$e405f25ee64c11ba$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($e405f25ee64c11ba$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $e405f25ee64c11ba$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$e405f25ee64c11ba$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $e405f25ee64c11ba$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            ...newBaggageHeaders.length > 0 && {
                baggage: newBaggageHeaders.join(",")
            }
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $e405f25ee64c11ba$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $h5H4c.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $h5H4c.SPAN_STATUS_ERROR,
        message: "internal_error"
    });
    span.end();
}
function $e405f25ee64c11ba$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith($aZ3HH.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $e405f25ee64c11ba$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && $cUgOr.isInstanceOf(headers, Headers);
}
function $e405f25ee64c11ba$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $e405f25ee64c11ba$var$getSpanStartOptions(url$1, method, spanOrigin, client) {
    if (url$1.startsWith("data:")) {
        const sanitizedUrl2 = $dBuCl.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $e405f25ee64c11ba$var$getFetchSpanAttributes(url$1, void 0, method, spanOrigin, client)
        };
    }
    const parsedUrl = $dBuCl.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $dBuCl.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $e405f25ee64c11ba$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin, client)
    };
}
function $e405f25ee64c11ba$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin, client) {
    const attributes$1 = {
        url: $bMiFH.filterCollectedUrl($dBuCl.stripDataUrlContent(url$1), client),
        type: "fetch",
        "http.method": method,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
    };
    if (parsedUrl) {
        if (!$dBuCl.isURLObjectRelative(parsedUrl)) {
            attributes$1[$eAISS.HTTP_URL] = $bMiFH.filterCollectedUrl($dBuCl.stripDataUrlContent(parsedUrl.href), client);
            attributes$1[$eAISS.URL_FULL] = $bMiFH.filterCollectedUrl($dBuCl.stripDataUrlContent(parsedUrl.href), client);
            attributes$1["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes$1["http.query"] = $bMiFH.filterCollectedUrlQuery(parsedUrl.search, client);
        if (parsedUrl.hash) attributes$1["http.fragment"] = parsedUrl.hash;
    }
    return attributes$1;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $e405f25ee64c11ba$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $e405f25ee64c11ba$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $e405f25ee64c11ba$var$instrumentFetchRequest;

});

parcelRegister("iqqtV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");
function $d69f326a12551363$var$captureFeedback(params, hint = {}, scope = $5JqSP.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || $5JqSP.getClient();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $d69f326a12551363$var$captureFeedback;

});

parcelRegister("1XBvb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $krgwg = parcelRequire("krgwg");

var $9eSGE = parcelRequire("9eSGE");
function $16d864420425cf58$var$captureLog(level, message, attributes, scope, severityNumber) {
    $krgwg._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
function $16d864420425cf58$var$trace(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("trace", message, attributes, scope);
}
function $16d864420425cf58$var$debug(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("debug", message, attributes, scope);
}
function $16d864420425cf58$var$info(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("info", message, attributes, scope);
}
function $16d864420425cf58$var$warn(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("warn", message, attributes, scope);
}
function $16d864420425cf58$var$error(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("error", message, attributes, scope);
}
function $16d864420425cf58$var$fatal(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("fatal", message, attributes, scope);
}
module.exports.fmt = $9eSGE.fmt;
module.exports.debug = $16d864420425cf58$var$debug;
module.exports.error = $16d864420425cf58$var$error;
module.exports.fatal = $16d864420425cf58$var$fatal;
module.exports.info = $16d864420425cf58$var$info;
module.exports.trace = $16d864420425cf58$var$trace;
module.exports.warn = $16d864420425cf58$var$warn;

});

parcelRegister("dDJiI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $8PsOG = parcelRequire("8PsOG");

var $iOdTc = parcelRequire("iOdTc");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $9EvIV = parcelRequire("9EvIV");

var $krgwg = parcelRequire("krgwg");

var $dqieo = parcelRequire("dqieo");
const $9ee20eb215bf3662$var$INTEGRATION_NAME = "ConsoleLogs";
const $9ee20eb215bf3662$var$DEFAULT_ATTRIBUTES = {
    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
};
const $9ee20eb215bf3662$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $g31Ce.CONSOLE_LEVELS;
    return {
        name: $9ee20eb215bf3662$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = $8PsOG.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($5JqSP.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$dqieo.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        $krgwg._INTERNAL_captureLog({
                            level: "error",
                            message: assertionMessage,
                            attributes: $9ee20eb215bf3662$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const attributes = {
                    ...$9ee20eb215bf3662$var$DEFAULT_ATTRIBUTES
                };
                if ($cUgOr.isPlainObject(firstArg)) {
                    Object.assign(attributes, $9EvIV.normalize(firstArg, normalizeDepth, normalizeMaxBreadth));
                    const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
                    const remainingArgs = args.slice(remainingArgsStartIndex);
                    remainingArgs.forEach((arg, index)=>{
                        attributes[`sentry.message.parameter.${index}`] = $9EvIV.normalize(arg, normalizeDepth, normalizeMaxBreadth);
                    });
                } else {
                    const shouldGenerateTemplate = followingArgs.length > 0 && typeof firstArg === "string" && !$dqieo.hasConsoleSubstitutions(firstArg);
                    if (shouldGenerateTemplate) {
                        const templateAttrs = $dqieo.createConsoleTemplateAttributes(firstArg, followingArgs);
                        for (const [key, value] of Object.entries(templateAttrs))attributes[key] = key.startsWith("sentry.message.parameter.") ? $9EvIV.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
                    }
                }
                $krgwg._INTERNAL_captureLog({
                    level: isLevelLog ? "info" : level,
                    message: $dqieo.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $9ee20eb215bf3662$var$consoleLoggingIntegration = $iOdTc.defineIntegration($9ee20eb215bf3662$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $9ee20eb215bf3662$var$consoleLoggingIntegration;

});
parcelRegister("dqieo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");

var $9EvIV = parcelRequire("9EvIV");

var $cqs9v = parcelRequire("cqs9v");
function $9c5bd869679b8bd8$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in $cqs9v.GLOBAL_OBJ && typeof $cqs9v.GLOBAL_OBJ.util.format === "function" ? $cqs9v.GLOBAL_OBJ.util.format(...values) : $9c5bd869679b8bd8$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $9c5bd869679b8bd8$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$cUgOr.isPrimitive(value) ? String(value) : JSON.stringify($9EvIV.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $9c5bd869679b8bd8$var$hasConsoleSubstitutions(str) {
    return /%[sdifocO]/.test(str);
}
function $9c5bd869679b8bd8$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $9c5bd869679b8bd8$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $9c5bd869679b8bd8$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $9c5bd869679b8bd8$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $9c5bd869679b8bd8$var$safeJoinConsoleArgs;

});


parcelRegister("frFYv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piEH = parcelRequire("7piEH");
function $b3e9effe1c610c20$var$captureMetric(type, name, value, options) {
    $7piEH._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
function $b3e9effe1c610c20$var$count(name, value = 1, options) {
    $b3e9effe1c610c20$var$captureMetric("counter", name, value, options);
}
function $b3e9effe1c610c20$var$gauge(name, value, options) {
    $b3e9effe1c610c20$var$captureMetric("gauge", name, value, options);
}
function $b3e9effe1c610c20$var$distribution(name, value, options) {
    $b3e9effe1c610c20$var$captureMetric("distribution", name, value, options);
}
module.exports.count = $b3e9effe1c610c20$var$count;
module.exports.distribution = $b3e9effe1c610c20$var$distribution;
module.exports.gauge = $b3e9effe1c610c20$var$gauge;

});

parcelRegister("5eiZy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $krgwg = parcelRequire("krgwg");

var $dqieo = parcelRequire("dqieo");

var $cUgOr = parcelRequire("cUgOr");

var $9EvIV = parcelRequire("9EvIV");
const $3cecfdf04635d9c2$var$DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
function $3cecfdf04635d9c2$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $3cecfdf04635d9c2$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            const client = providedClient || $5JqSP.getClient();
            if (!client) return;
            const logSeverityLevel = $3cecfdf04635d9c2$var$getLogSeverityLevel(type, level);
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            const attributes = {};
            for (const [key, value] of Object.entries(rest))attributes[key] = $9EvIV.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = $3cecfdf04635d9c2$var$processExtractedAttributes($3cecfdf04635d9c2$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $krgwg._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $dqieo.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes: attributes
            });
        }
    };
}
const $3cecfdf04635d9c2$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
const $3cecfdf04635d9c2$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    // Fatal and Error
    1: "warn",
    // Warnings
    2: "info",
    // Normal logs
    3: "info",
    // Informational logs, success, fail, ready, start, ...
    4: "debug",
    // Debug logs
    5: "trace"
};
function $3cecfdf04635d9c2$var$getLogSeverityLevel(type, level) {
    if (type === "verbose") return "debug";
    if (type === "silent") return "trace";
    if (type) {
        const mappedLevel = $3cecfdf04635d9c2$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    if (typeof level === "number") {
        const mappedLevel = $3cecfdf04635d9c2$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    return "info";
}
function $3cecfdf04635d9c2$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ""
    };
    const message = $dqieo.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($cUgOr.isPlainObject(firstArg)) {
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !$dqieo.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
            messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
        };
    }
}
function $3cecfdf04635d9c2$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $dqieo.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? $9EvIV.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $9EvIV.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$9EvIV.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $3cecfdf04635d9c2$var$createConsolaReporter;

});

parcelRegister("cRRDT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $f3RkF = parcelRequire("f3RkF");

var $6atBT = parcelRequire("6atBT");

var $fbkeM = parcelRequire("fbkeM");

var $6vUrj = parcelRequire("6vUrj");

var $5SzUg = parcelRequire("5SzUg");

var $eN9vd = parcelRequire("eN9vd");

var $fbvdA = parcelRequire("fbvdA");

var $6Xrci = parcelRequire("6Xrci");

var $lQFj9 = parcelRequire("lQFj9");

var $9BctP = parcelRequire("9BctP");
function $95e40b91535f4e5b$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $6vUrj.spanToJSON(span);
    if (!name) return;
    if (attributes[$9BctP.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$9BctP.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
        $95e40b91535f4e5b$var$processToolCallSpan(span, attributes);
        return;
    }
    if (!attributes[$9BctP.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) return;
    if ($fbvdA.SPAN_TO_OPERATION_NAME.get(name) === "generate_content") $fbkeM._INTERNAL_skipAiProviderWrapping([
        $5SzUg.WORKERS_AI_INTEGRATION_NAME
    ]);
    const client = $5JqSP.getClient();
    const integration = client?.getIntegrationByName("VercelAI");
    const enableTruncation = $6atBT.shouldEnableTruncation(integration?.options?.enableTruncation);
    $95e40b91535f4e5b$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $95e40b91535f4e5b$var$vercelAiEventProcessor(event) {
    if (event.type === "transaction" && event.spans) {
        const tokenAccumulator = /* @__PURE__ */ new Map();
        for (const span of event.spans){
            $95e40b91535f4e5b$var$processEndedVercelAiSpan(span);
            $lQFj9.accumulateTokensForParent(span, tokenAccumulator);
        }
        $lQFj9.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        const trace = event.contexts?.trace;
        if (trace?.op === "gen_ai.invoke_agent") $lQFj9.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
function $95e40b91535f4e5b$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== "string") return "stop";
    switch(finishReason){
        case "tool-calls":
            return "tool_call";
        case "stop":
        case "length":
        case "content_filter":
        case "error":
            return finishReason;
        default:
            return finishReason;
    }
}
function $95e40b91535f4e5b$var$buildOutputMessages(attributes) {
    const responseText = attributes[$9BctP.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$9BctP.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$9BctP.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (responseToolCalls != null) try {
        const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: "tool_call",
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
                });
            }
            delete attributes[$9BctP.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {}
    if (parts.length > 0) {
        const outputMessage = {
            role: "assistant",
            parts: parts,
            finish_reason: $95e40b91535f4e5b$var$normalizeFinishReason(finishReason)
        };
        attributes[$eN9vd.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        delete attributes[$9BctP.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
function $95e40b91535f4e5b$var$processVercelAiSpanAttributes(attributes) {
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, "ai.usage.inputTokens", $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, "ai.usage.outputTokens", $eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_USAGE_TOKENS_ATTRIBUTE, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
    const inputTokensAreCacheInclusive = Object.keys(attributes).some((key)=>key.startsWith($9BctP.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX));
    if (!inputTokensAreCacheInclusive && typeof attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    if (typeof attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
        const outputTokens = typeof attributes[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    if (attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE] = $lQFj9.convertAvailableToolsToJsonString(attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE]);
    if (attributes[$9BctP.OPERATION_NAME_ATTRIBUTE]) {
        const rawOperationName = attributes[$9BctP.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$9BctP.AI_OPERATION_ID_ATTRIBUTE] : attributes[$9BctP.OPERATION_NAME_ATTRIBUTE];
        const operationName = $fbvdA.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        delete attributes[$9BctP.OPERATION_NAME_ATTRIBUTE];
    }
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_PROMPT_MESSAGES_ATTRIBUTE, $eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    $95e40b91535f4e5b$var$buildOutputMessages(attributes);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_TOOL_CALL_ARGS_ATTRIBUTE, $eN9vd.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_TOOL_CALL_RESULT_ATTRIBUTE, $eN9vd.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_MODEL_ID_ATTRIBUTE, $eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    if (Array.isArray(attributes[$9BctP.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$9BctP.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$eN9vd.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $95e40b91535f4e5b$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        if (key.startsWith("ai.")) $95e40b91535f4e5b$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $95e40b91535f4e5b$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== "auto.vercelai.otel") return;
    if (span.status && span.status !== "ok") span.status = "internal_error";
    $95e40b91535f4e5b$var$processVercelAiSpanAttributes(attributes);
}
function $95e40b91535f4e5b$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== "auto.vercelai.otel") return;
    $95e40b91535f4e5b$var$processVercelAiSpanAttributes(attributes);
    if (attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
        const descriptions = $fbvdA.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$eN9vd.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    $fbvdA.toolDescriptionMap.delete(span.span_id);
}
function $95e40b91535f4e5b$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        delete attributes[oldKey];
    }
}
function $95e40b91535f4e5b$var$processToolCallSpan(span, attributes) {
    span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
    span.setAttribute($eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_TOOL_CALL_NAME_ATTRIBUTE, $eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_TOOL_CALL_ID_ATTRIBUTE, $eN9vd.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    const toolCallId = attributes[$eN9vd.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === "string") $fbvdA.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    if (!attributes[$eN9vd.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($eN9vd.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
    const toolName = attributes[$eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $95e40b91535f4e5b$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    const nameWthoutAi = name.replace("ai.", "");
    span.setAttribute("ai.pipeline.name", nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$9BctP.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === "string") span.setAttribute("gen_ai.function_id", functionId);
    $lQFj9.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$9BctP.AI_MODEL_ID_ATTRIBUTE] && !attributes[$eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$9BctP.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute("ai.streaming", name.includes("stream"));
    const operationName = $fbvdA.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith("ai.stream")) span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
    if (operationName === "invoke_agent") {
        if (functionId && typeof functionId === "string") span.updateName(`invoke_agent ${functionId}`);
        else span.updateName("invoke_agent");
        return;
    }
    const modelId = attributes[$9BctP.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    const client = $5JqSP.getClient();
    if (client && $6Xrci.hasSpanStreamingEnabled(client) && attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = /* @__PURE__ */ new Map();
        for (const toolStr of attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {}
        if (descriptions.size > 0) {
            const parentSpanId = $6vUrj.spanToJSON(span).parent_span_id;
            if (parentSpanId) $fbvdA.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
const $95e40b91535f4e5b$var$CLIENTS_WITH_VERCEL_AI_PROCESSORS = /* @__PURE__ */ new WeakSet();
function $95e40b91535f4e5b$var$addVercelAiProcessors(client) {
    if ($95e40b91535f4e5b$var$CLIENTS_WITH_VERCEL_AI_PROCESSORS.has(client)) return;
    $95e40b91535f4e5b$var$CLIENTS_WITH_VERCEL_AI_PROCESSORS.add(client);
    client.on("spanStart", $95e40b91535f4e5b$var$onVercelAiSpanStart);
    client.addEventProcessor(Object.assign($95e40b91535f4e5b$var$vercelAiEventProcessor, {
        id: "VercelAiEventProcessor"
    }));
    client.on("processSpan", (span)=>{
        $95e40b91535f4e5b$var$processVercelAiStreamedSpan(span);
    });
}
function $95e40b91535f4e5b$var$getProviderMetadataAttributes(providerMetadata) {
    const attributes = {};
    if (!providerMetadata || typeof providerMetadata !== "object") return attributes;
    const metadata = providerMetadata;
    const openaiMetadata = metadata.openai ?? metadata.azure;
    if (openaiMetadata) {
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_accepted", openaiMetadata.acceptedPredictionTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_rejected", openaiMetadata.rejectedPredictionTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_CONVERSATION_ID_ATTRIBUTE, openaiMetadata.responseId);
    }
    if (metadata.anthropic) {
        const cachedInputTokens = metadata.anthropic.usage?.cache_read_input_tokens ?? metadata.anthropic.cacheReadInputTokens;
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
        const cacheWriteInputTokens = metadata.anthropic.usage?.cache_creation_input_tokens ?? metadata.anthropic.cacheCreationInputTokens;
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
    }
    if (metadata.bedrock?.usage) {
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.bedrock.usage.cacheReadInputTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, metadata.bedrock.usage.cacheWriteInputTokens);
    }
    if (metadata.deepseek) {
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.deepseek.promptCacheHitTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, "gen_ai.usage.input_tokens.cache_miss", metadata.deepseek.promptCacheMissTokens);
    }
    const googleUsage = (metadata.google ?? metadata.vertex)?.usageMetadata;
    if (googleUsage && typeof googleUsage.thoughtsTokenCount === "number" && googleUsage.thoughtsTokenCount > 0) {
        attributes[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = (googleUsage.candidatesTokenCount ?? 0) + googleUsage.thoughtsTokenCount;
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, googleUsage.totalTokenCount);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, "gen_ai.usage.reasoning.output_tokens", googleUsage.thoughtsTokenCount);
    }
    return attributes;
}
const $95e40b91535f4e5b$var$LAST_STEP_ONLY_USAGE_KEYS = /* @__PURE__ */ new Set([
    $eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE,
    $eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE,
    "gen_ai.usage.reasoning.output_tokens"
]);
function $95e40b91535f4e5b$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$9BctP.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (!providerMetadata) return;
    const lastStepOnly = attributes[$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE] === "invoke_agent";
    try {
        const derived = $95e40b91535f4e5b$var$getProviderMetadataAttributes(JSON.parse(providerMetadata));
        for (const [key, value] of Object.entries(derived)){
            if (key === $eN9vd.GEN_AI_CONVERSATION_ID_ATTRIBUTE && attributes[key]) continue;
            if (lastStepOnly && $95e40b91535f4e5b$var$LAST_STEP_ONLY_USAGE_KEYS.has(key)) continue;
            attributes[key] = value;
        }
    } catch  {}
}
function $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.LAST_STEP_ONLY_USAGE_KEYS = $95e40b91535f4e5b$var$LAST_STEP_ONLY_USAGE_KEYS;
module.exports.addVercelAiProcessors = $95e40b91535f4e5b$var$addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $95e40b91535f4e5b$var$getProviderMetadataAttributes;
module.exports.processVercelAiSpanAttributes = $95e40b91535f4e5b$var$processVercelAiSpanAttributes;

});
parcelRegister("6atBT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $5JqSP = parcelRequire("5JqSP");

var $6Xrci = parcelRequire("6Xrci");

var $cUgOr = parcelRequire("cUgOr");

var $eN9vd = parcelRequire("eN9vd");

var $9fi22 = parcelRequire("9fi22");
function $47daa531d791f483$var$resolveAIRecordingOptions(options) {
    const genAI = $5JqSP.getClient()?.getDataCollectionOptions().genAI;
    return {
        ...options,
        recordInputs: options?.recordInputs ?? genAI?.inputs ?? false,
        recordOutputs: options?.recordOutputs ?? genAI?.outputs ?? false
    };
}
function $47daa531d791f483$var$shouldEnableTruncation(enableTruncation) {
    if (enableTruncation !== void 0) return enableTruncation;
    const client = $5JqSP.getClient();
    if (!client) return true;
    return !$6Xrci.hasSpanStreamingEnabled(client) && client.getOptions().streamGenAiSpans === false;
}
function $47daa531d791f483$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
function $47daa531d791f483$var$getTokenUsageAttributes(promptTokens, completionTokens, cacheCreationInputTokens, cacheReadInputTokens, totalTokens) {
    const attributes$1 = {};
    if (typeof promptTokens === "number") attributes$1[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = promptTokens;
    if (typeof cacheCreationInputTokens === "number") attributes$1[$eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS] = cacheCreationInputTokens;
    if (typeof cacheReadInputTokens === "number") attributes$1[$eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS] = cacheReadInputTokens;
    if (typeof completionTokens === "number") attributes$1[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = completionTokens;
    if (typeof totalTokens === "number") attributes$1[$eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = totalTokens;
    else if (typeof promptTokens === "number" || typeof completionTokens === "number") attributes$1[$eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (typeof promptTokens === "number" ? promptTokens : 0) + (typeof completionTokens === "number" ? completionTokens : 0);
    return attributes$1;
}
function $47daa531d791f483$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$eN9vd.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$eN9vd.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    Object.assign(attrs, $47daa531d791f483$var$getTokenUsageAttributes(state.promptTokens, state.completionTokens, state.cacheCreationInputTokens, state.cacheReadInputTokens, state.totalTokens));
    if (typeof state.reasoningOutputTokens === "number") attrs[$eAISS.GEN_AI_USAGE_REASONING_OUTPUT_TOKENS] = state.reasoningOutputTokens;
    if (state.finishReasons.length) attrs[$eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
function $47daa531d791f483$var$getTruncatedJsonString(value) {
    if (typeof value === "string") return $9fi22.truncateGenAiStringInput(value);
    try {
        return JSON.stringify(Array.isArray(value) ? $9fi22.truncateGenAiMessages(value) : value);
    } catch  {
        return "[unserializable]";
    }
}
function $47daa531d791f483$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
    if (!systemContent) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
async function $47daa531d791f483$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise) {
    const [instrumentedResult, originalWrapper] = await Promise.all([
        instrumentedPromise,
        originalWithResponse
    ]);
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
function $47daa531d791f483$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise) {
    if (!$cUgOr.isThenable(originalPromiseLike)) return instrumentedPromise;
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $47daa531d791f483$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $47daa531d791f483$var$buildMethodPath;
module.exports.endStreamSpan = $47daa531d791f483$var$endStreamSpan;
module.exports.extractSystemInstructions = $47daa531d791f483$var$extractSystemInstructions;
module.exports.getTokenUsageAttributes = $47daa531d791f483$var$getTokenUsageAttributes;
module.exports.getTruncatedJsonString = $47daa531d791f483$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $47daa531d791f483$var$resolveAIRecordingOptions;
module.exports.shouldEnableTruncation = $47daa531d791f483$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $47daa531d791f483$var$wrapPromiseWithMethods;

});
parcelRegister("eN9vd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ac4d03438b4e4600$var$GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
const $ac4d03438b4e4600$var$GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
const $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
const $ac4d03438b4e4600$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
const $ac4d03438b4e4600$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
const $ac4d03438b4e4600$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
const $ac4d03438b4e4600$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
const $ac4d03438b4e4600$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
const $ac4d03438b4e4600$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
const $ac4d03438b4e4600$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
const $ac4d03438b4e4600$var$GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
const $ac4d03438b4e4600$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
const $ac4d03438b4e4600$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
const $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
const $ac4d03438b4e4600$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
const $ac4d03438b4e4600$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
const $ac4d03438b4e4600$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
const $ac4d03438b4e4600$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("9fi22", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1qvHT = parcelRequire("1qvHT");
const $6bb3808b6f6891e2$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
const $6bb3808b6f6891e2$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
const $6bb3808b6f6891e2$var$jsonBytes = (value)=>{
    return $6bb3808b6f6891e2$var$utf8Bytes(JSON.stringify(value));
};
function $6bb3808b6f6891e2$var$truncateTextByBytes(text, maxBytes) {
    if ($6bb3808b6f6891e2$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $6bb3808b6f6891e2$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
function $6bb3808b6f6891e2$var$getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
function $6bb3808b6f6891e2$var$withItemText(item, text) {
    if (typeof item === "string") return text;
    return {
        ...item,
        text: text
    };
}
function $6bb3808b6f6891e2$var$isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
function $6bb3808b6f6891e2$var$isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
function $6bb3808b6f6891e2$var$isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
function $6bb3808b6f6891e2$var$truncateContentMessage(message, maxBytes) {
    const emptyMessage = {
        ...message,
        content: ""
    };
    const overhead = $6bb3808b6f6891e2$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $6bb3808b6f6891e2$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
function $6bb3808b6f6891e2$var$getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
function $6bb3808b6f6891e2$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $6bb3808b6f6891e2$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    const emptyItems = items.map((item)=>$6bb3808b6f6891e2$var$withItemText(item, ""));
    const overhead = $6bb3808b6f6891e2$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    const includedItems = [];
    for (const item of items){
        const text = $6bb3808b6f6891e2$var$getItemText(item);
        const textSize = $6bb3808b6f6891e2$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            const truncated = $6bb3808b6f6891e2$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($6bb3808b6f6891e2$var$withItemText(item, truncated));
            break;
        } else break;
    }
    if (includedItems.length <= 0) return [];
    else return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
function $6bb3808b6f6891e2$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    if (typeof message === "string") {
        const truncated = $6bb3808b6f6891e2$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if ($6bb3808b6f6891e2$var$isContentMessage(message)) return $6bb3808b6f6891e2$var$truncateContentMessage(message, maxBytes);
    if ($6bb3808b6f6891e2$var$isContentArrayMessage(message) || $6bb3808b6f6891e2$var$isPartsMessage(message)) return $6bb3808b6f6891e2$var$truncateArrayMessage(message, maxBytes);
    return [];
}
function $6bb3808b6f6891e2$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = void 0;
        if (!!message && typeof message === "object") {
            if ($6bb3808b6f6891e2$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $6bb3808b6f6891e2$var$stripInlineMediaFromMessages(message.content)
            };
            else if ("content" in message && $1qvHT.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $1qvHT.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($6bb3808b6f6891e2$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $6bb3808b6f6891e2$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($1qvHT.isContentMedia(newMessage)) newMessage = $1qvHT.stripInlineMediaFromSingleMessage(newMessage);
            else if ($1qvHT.isContentMedia(message)) newMessage = $1qvHT.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
function $6bb3808b6f6891e2$var$truncateMessagesByBytes(messages, maxBytes) {
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    const effectiveMaxBytes = maxBytes - 2;
    const lastMessage = messages[messages.length - 1];
    const stripped = $6bb3808b6f6891e2$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    const messageBytes = $6bb3808b6f6891e2$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    return $6bb3808b6f6891e2$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
function $6bb3808b6f6891e2$var$truncateGenAiMessages(messages) {
    return $6bb3808b6f6891e2$var$truncateMessagesByBytes(messages, $6bb3808b6f6891e2$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
function $6bb3808b6f6891e2$var$truncateGenAiStringInput(input) {
    return $6bb3808b6f6891e2$var$truncateTextByBytes(input, $6bb3808b6f6891e2$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $6bb3808b6f6891e2$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $6bb3808b6f6891e2$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $6bb3808b6f6891e2$var$truncateGenAiStringInput;

});
parcelRegister("1qvHT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $10a0d07c489e03fa$var$isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return $10a0d07c489e03fa$var$isContentMediaSource(part) || $10a0d07c489e03fa$var$hasInlineData(part) || $10a0d07c489e03fa$var$hasImageUrl(part) || $10a0d07c489e03fa$var$hasInputAudio(part) || $10a0d07c489e03fa$var$hasFileData(part) || $10a0d07c489e03fa$var$hasMediaTypeData(part) || $10a0d07c489e03fa$var$hasVercelFileData(part) || $10a0d07c489e03fa$var$hasVercelImageData(part) || $10a0d07c489e03fa$var$hasBlobOrBase64Type(part) || $10a0d07c489e03fa$var$hasB64Json(part) || $10a0d07c489e03fa$var$hasImageGenerationResult(part) || $10a0d07c489e03fa$var$hasDataUri(part);
}
function $10a0d07c489e03fa$var$hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return $10a0d07c489e03fa$var$hasNestedImageUrl(part);
}
function $10a0d07c489e03fa$var$hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function $10a0d07c489e03fa$var$isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && $10a0d07c489e03fa$var$isContentMedia(part.source);
}
function $10a0d07c489e03fa$var$hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function $10a0d07c489e03fa$var$hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function $10a0d07c489e03fa$var$hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function $10a0d07c489e03fa$var$hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
function $10a0d07c489e03fa$var$hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
function $10a0d07c489e03fa$var$hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function $10a0d07c489e03fa$var$hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function $10a0d07c489e03fa$var$hasB64Json(part) {
    return "b64_json" in part;
}
function $10a0d07c489e03fa$var$hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function $10a0d07c489e03fa$var$hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const $10a0d07c489e03fa$var$REMOVED_STRING = "[Blob substitute]";
const $10a0d07c489e03fa$var$MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
function $10a0d07c489e03fa$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($10a0d07c489e03fa$var$isContentMedia(strip.source)) strip.source = $10a0d07c489e03fa$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($10a0d07c489e03fa$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $10a0d07c489e03fa$var$REMOVED_STRING
    };
    if ($10a0d07c489e03fa$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $10a0d07c489e03fa$var$REMOVED_STRING
    };
    if ($10a0d07c489e03fa$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $10a0d07c489e03fa$var$REMOVED_STRING
    };
    if ($10a0d07c489e03fa$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $10a0d07c489e03fa$var$REMOVED_STRING
    };
    for (const field of $10a0d07c489e03fa$var$MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = $10a0d07c489e03fa$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $10a0d07c489e03fa$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $10a0d07c489e03fa$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("5SzUg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $447dd9323a5c83be$var$WORKERS_AI_PROVIDER_NAME = "cloudflare.workers_ai";
const $447dd9323a5c83be$var$WORKERS_AI_ORIGIN = "auto.ai.cloudflare.workers_ai";
const $447dd9323a5c83be$var$WORKERS_AI_INTEGRATION_NAME = "WorkersAI";
module.exports.WORKERS_AI_INTEGRATION_NAME = $447dd9323a5c83be$var$WORKERS_AI_INTEGRATION_NAME;
module.exports.WORKERS_AI_ORIGIN = $447dd9323a5c83be$var$WORKERS_AI_ORIGIN;
module.exports.WORKERS_AI_PROVIDER_NAME = $447dd9323a5c83be$var$WORKERS_AI_PROVIDER_NAME;

});

parcelRegister("fbvdA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b0e0195def17d50b$var$toolCallSpanContextMap = /* @__PURE__ */ new Map();
const $b0e0195def17d50b$var$toolDescriptionMap = /* @__PURE__ */ new Map();
const $b0e0195def17d50b$var$SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
    [
        "ai.generateText",
        "invoke_agent"
    ],
    [
        "ai.streamText",
        "invoke_agent"
    ],
    [
        "ai.generateObject",
        "invoke_agent"
    ],
    [
        "ai.streamObject",
        "invoke_agent"
    ],
    [
        "ai.generateText.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamText.doStream",
        "generate_content"
    ],
    [
        "ai.generateObject.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamObject.doStream",
        "generate_content"
    ],
    [
        "ai.embed.doEmbed",
        "embeddings"
    ],
    [
        "ai.embedMany.doEmbed",
        "embeddings"
    ],
    [
        "ai.rerank.doRerank",
        "rerank"
    ],
    [
        "ai.toolCall",
        "execute_tool"
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $b0e0195def17d50b$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $b0e0195def17d50b$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $b0e0195def17d50b$var$toolDescriptionMap;

});

parcelRegister("lQFj9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $foFxi = parcelRequire("foFxi");

var $fbvdA = parcelRequire("fbvdA");

var $9BctP = parcelRequire("9BctP");
function $fe7e7f35d805a9e4$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === "number" || typeof outputTokens === "number") {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === "number") existing.inputTokens += inputTokens;
        if (typeof outputTokens === "number") existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
function $fe7e7f35d805a9e4$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
}
function $fe7e7f35d805a9e4$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = /* @__PURE__ */ new Map();
    for (const span of spans){
        const availableTools = span.data[$eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== "string") continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {}
    }
    return toolDescriptions;
}
function $fe7e7f35d805a9e4$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    const toolDescriptions = $fe7e7f35d805a9e4$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === "gen_ai.execute_tool") {
            const toolName = span.data[$eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$eN9vd.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === "gen_ai.invoke_agent") $fe7e7f35d805a9e4$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
function $fe7e7f35d805a9e4$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $fbvdA.toolCallSpanContextMap.get(toolCallId);
}
function $fe7e7f35d805a9e4$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $fbvdA.toolCallSpanContextMap.delete(toolCallId);
}
function $fe7e7f35d805a9e4$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === "string") try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
function $fe7e7f35d805a9e4$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === "object" && "role" in m && "content" in m);
}
function $fe7e7f35d805a9e4$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === "object") {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            if (typeof system === "string") result.push({
                role: "system",
                content: system
            });
            if (typeof messages === "string") try {
                messages = JSON.parse(messages);
            } catch  {}
            if (Array.isArray(messages)) {
                result.push(...$fe7e7f35d805a9e4$var$filterMessagesArray(messages));
                return result;
            }
            if (Array.isArray(prompt)) {
                result.push(...$fe7e7f35d805a9e4$var$filterMessagesArray(prompt));
                return result;
            }
            if (typeof prompt === "string") result.push({
                role: "user",
                content: prompt
            });
            if (result.length > 0) return result;
        }
    } catch  {}
    return [];
}
function $fe7e7f35d805a9e4$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$9BctP.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$9BctP.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        const userInput = attributes[$9BctP.AI_PROMPT_ATTRIBUTE];
        const messages = $fe7e7f35d805a9e4$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages);
            span.setAttributes({
                [$9BctP.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$9BctP.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") {
        const originalMessagesJson = attributes[$9BctP.AI_PROMPT_MESSAGES_ATTRIBUTE];
        try {
            const messages = JSON.parse(originalMessagesJson);
            if (Array.isArray(messages)) {
                const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(messages);
                if (systemInstructions) span.setAttribute($eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                const messagesJson = !enableTruncation && filteredMessages === messages ? originalMessagesJson : enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages);
                span.setAttributes({
                    [$9BctP.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                });
            }
        } catch  {}
    }
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $fe7e7f35d805a9e4$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $fe7e7f35d805a9e4$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $fe7e7f35d805a9e4$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $fe7e7f35d805a9e4$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $fe7e7f35d805a9e4$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $fe7e7f35d805a9e4$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $fe7e7f35d805a9e4$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $fe7e7f35d805a9e4$var$requestMessagesFromPrompt;

});
parcelRegister("9BctP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $6fd140086dc954f6$var$OPERATION_NAME_ATTRIBUTE = "operation.name";
const $6fd140086dc954f6$var$AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
const $6fd140086dc954f6$var$AI_PROMPT_ATTRIBUTE = "ai.prompt";
const $6fd140086dc954f6$var$AI_SCHEMA_ATTRIBUTE = "ai.schema";
const $6fd140086dc954f6$var$AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
const $6fd140086dc954f6$var$AI_VALUES_ATTRIBUTE = "ai.values";
const $6fd140086dc954f6$var$AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
const $6fd140086dc954f6$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
const $6fd140086dc954f6$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
const $6fd140086dc954f6$var$AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
const $6fd140086dc954f6$var$AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
const $6fd140086dc954f6$var$AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
const $6fd140086dc954f6$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
const $6fd140086dc954f6$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
const $6fd140086dc954f6$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = "ai.usage.inputTokenDetails.";
const $6fd140086dc954f6$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
const $6fd140086dc954f6$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
const $6fd140086dc954f6$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
const $6fd140086dc954f6$var$AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
const $6fd140086dc954f6$var$AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
const $6fd140086dc954f6$var$AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
const $6fd140086dc954f6$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
const $6fd140086dc954f6$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";
module.exports.AI_MODEL_ID_ATTRIBUTE = $6fd140086dc954f6$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $6fd140086dc954f6$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $6fd140086dc954f6$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $6fd140086dc954f6$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $6fd140086dc954f6$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $6fd140086dc954f6$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $6fd140086dc954f6$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $6fd140086dc954f6$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $6fd140086dc954f6$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $6fd140086dc954f6$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $6fd140086dc954f6$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $6fd140086dc954f6$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $6fd140086dc954f6$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $6fd140086dc954f6$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $6fd140086dc954f6$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $6fd140086dc954f6$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $6fd140086dc954f6$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $6fd140086dc954f6$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = $6fd140086dc954f6$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $6fd140086dc954f6$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $6fd140086dc954f6$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $6fd140086dc954f6$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $6fd140086dc954f6$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("gMyai", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $foFxi = parcelRequire("foFxi");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $88Wwg = parcelRequire("88Wwg");

var $5kKGI = parcelRequire("5kKGI");

var $626Kw = parcelRequire("626Kw");
function $c37ba181f0002cd3$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: "web_search_options",
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return void 0;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Failed to serialize OpenAI tools:", error);
        return void 0;
    }
}
function $c37ba181f0002cd3$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$eN9vd.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = $c37ba181f0002cd3$var$extractAvailableTools(params);
        if (availableTools) attributes[$eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $626Kw.extractRequestParameters(params));
    } else attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $c37ba181f0002cd3$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        if (input == null) return;
        if (typeof input === "string" && input.length === 0) return;
        if (Array.isArray(input) && input.length === 0) return;
        span.setAttribute($eN9vd.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
function $c37ba181f0002cd3$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = $c37ba181f0002cd3$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult2;
            const instrumentedPromise2 = $5CFne.startSpanManual(spanConfig, (span)=>{
                originalResult2 = originalMethod.apply(context, args);
                if (options.recordInputs && params) $c37ba181f0002cd3$var$addRequestAttributes(span, params, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
                return (async ()=>{
                    try {
                        const result = await originalResult2;
                        return $5kKGI.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $h5H4c.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $6atBT.wrapPromiseWithMethods(originalResult2, instrumentedPromise2);
        }
        let originalResult;
        const instrumentedPromise = $5CFne.startSpan(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $c37ba181f0002cd3$var$addRequestAttributes(span, params, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $626Kw.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            });
        });
        return $6atBT.wrapPromiseWithMethods(originalResult, instrumentedPromise);
    };
}
function $c37ba181f0002cd3$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $6atBT.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $88Wwg.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $c37ba181f0002cd3$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $c37ba181f0002cd3$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $c37ba181f0002cd3$var$instrumentOpenAiClient(client, options) {
    return $c37ba181f0002cd3$var$createDeepProxy(client, "", $6atBT.resolveAIRecordingOptions(options));
}
module.exports.addRequestAttributes = $c37ba181f0002cd3$var$addRequestAttributes;
module.exports.extractRequestAttributes = $c37ba181f0002cd3$var$extractRequestAttributes;
module.exports.instrumentOpenAiClient = $c37ba181f0002cd3$var$instrumentOpenAiClient;

});
parcelRegister("88Wwg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $5edc76d503b906a2$var$OPENAI_INTEGRATION_NAME = "OpenAI";
const $5edc76d503b906a2$var$OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const $5edc76d503b906a2$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const $5edc76d503b906a2$var$RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...$5edc76d503b906a2$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $5edc76d503b906a2$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $5edc76d503b906a2$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $5edc76d503b906a2$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $5edc76d503b906a2$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("5kKGI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $13TrR = parcelRequire("13TrR");

var $h5H4c = parcelRequire("h5H4c");

var $6atBT = parcelRequire("6atBT");

var $88Wwg = parcelRequire("88Wwg");

var $626Kw = parcelRequire("626Kw");
function $3e23094403a2384c$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === void 0 || !toolCall.function) continue;
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        };
        else {
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
function $3e23094403a2384c$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
        state.cacheReadInputTokens = chunk.usage.prompt_tokens_details?.cached_tokens ?? state.cacheReadInputTokens;
        state.cacheCreationInputTokens = chunk.usage.prompt_tokens_details?.cache_write_tokens ?? state.cacheCreationInputTokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            if (choice.delta?.tool_calls) $3e23094403a2384c$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
function $3e23094403a2384c$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $h5H4c.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $13TrR.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!$88Wwg.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    if (recordOutputs) {
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
            state.cacheReadInputTokens = response.usage.input_tokens_details?.cached_tokens ?? state.cacheReadInputTokens;
            state.cacheCreationInputTokens = response.usage.input_tokens_details?.cache_write_tokens ?? state.cacheCreationInputTokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
async function* $3e23094403a2384c$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0,
        cacheReadInputTokens: void 0,
        cacheCreationInputTokens: void 0,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($626Kw.isChatCompletionChunk(event)) $3e23094403a2384c$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($626Kw.isResponsesApiStreamEvent(event)) $3e23094403a2384c$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $6atBT.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $3e23094403a2384c$var$instrumentStream;

});
parcelRegister("626Kw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $cUgOr = parcelRequire("cUgOr");

var $eN9vd = parcelRequire("eN9vd");
function $46482a481e93ef16$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
function $46482a481e93ef16$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
function $46482a481e93ef16$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    if (typeof response.id === "string") attrs[$eN9vd.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    if (typeof response.model === "string") attrs[$eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    if (response.object === "conversation" && typeof response.id === "string") attrs[$eN9vd.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === "number") attrs[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === "number") attrs[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[$eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
        const inputDetails = usage.prompt_tokens_details ?? usage.input_tokens_details;
        if ($cUgOr.isObjectLike(inputDetails)) {
            if (typeof inputDetails.cached_tokens === "number") attrs[$eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS] = inputDetails.cached_tokens;
            if (typeof inputDetails.cache_write_tokens === "number") attrs[$eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS] = inputDetails.cache_write_tokens;
        }
    }
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[$eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || "";
            });
            attrs[$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    if (typeof response.status === "string") {
        if (!attrs[$eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        if (typeof response.output_text === "string" && !attrs[$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === "function_call");
            if (functionCalls.length > 0) attrs[$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
function $46482a481e93ef16$var$extractConversationId(params) {
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return void 0;
}
function $46482a481e93ef16$var$extractRequestParameters(params) {
    const attributes = {
        [$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? "unknown"
    };
    if ("temperature" in params) attributes[$eN9vd.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[$eN9vd.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[$eN9vd.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[$eN9vd.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[$eN9vd.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[$eN9vd.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[$eN9vd.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    const conversationId = $46482a481e93ef16$var$extractConversationId(params);
    if (conversationId) attributes[$eN9vd.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $46482a481e93ef16$var$addResponseAttributes;
module.exports.extractRequestParameters = $46482a481e93ef16$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $46482a481e93ef16$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $46482a481e93ef16$var$isResponsesApiStreamEvent;

});



parcelRegister("5ddno", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $j6AED = parcelRequire("j6AED");

var $ax3NO = parcelRequire("ax3NO");

var $3nLrf = parcelRequire("3nLrf");
let $3cb88ae91b980052$var$suppressDelegatedCreate = false;
const $3cb88ae91b980052$var$INSTRUMENTED_METHODS = /* @__PURE__ */ new WeakSet();
function $3cb88ae91b980052$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$eN9vd.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
        if ("temperature" in params) attributes[$eN9vd.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[$eN9vd.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[$eN9vd.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[$eN9vd.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[$eN9vd.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[$eN9vd.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $3cb88ae91b980052$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $3nLrf.messagesFromParams(params);
    $3nLrf.setMessagesAttribute(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [$eN9vd.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
function $3cb88ae91b980052$var$addContentAttributes(span, response) {
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    if ("completion" in response) span.setAttributes({
        [$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    if ("input_tokens" in response) span.setAttributes({
        [$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
function $3cb88ae91b980052$var$addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [$eN9vd.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ("usage" in response && response.usage) span.setAttributes($6atBT.getTokenUsageAttributes(response.usage.input_tokens + (response.usage.cache_creation_input_tokens ?? 0) + (response.usage.cache_read_input_tokens ?? 0), response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens));
    }
}
function $3cb88ae91b980052$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if ("type" in response && response.type === "error") {
        $3nLrf.handleResponseError(span, response);
        return;
    }
    if (recordOutputs) $3cb88ae91b980052$var$addContentAttributes(span, response);
    $3cb88ae91b980052$var$addMetadataAttributes(span, response);
}
function $3cb88ae91b980052$var$handleStreamingError(error, span) {
    if (span.isRecording()) {
        span.setStatus({
            code: $h5H4c.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
function $3cb88ae91b980052$var$handleStreamingRequest(target, invocationThis, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $5CFne.startSpanManual(spanConfig, (span)=>{
            originalResult = target.apply(invocationThis, args);
            if (options.recordInputs && params) $3cb88ae91b980052$var$addPrivateRequestAttributes(span, params, $6atBT.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $ax3NO.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $3cb88ae91b980052$var$handleStreamingError(error, span);
                }
            })();
        });
        return $6atBT.wrapPromiseWithMethods(originalResult, instrumentedPromise);
    } else return $5CFne.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $3cb88ae91b980052$var$addPrivateRequestAttributes(span, params, $6atBT.shouldEnableTruncation(options.enableTruncation));
            $3cb88ae91b980052$var$suppressDelegatedCreate = true;
            const messageStream = target.apply(invocationThis, args);
            $3cb88ae91b980052$var$suppressDelegatedCreate = false;
            return $ax3NO.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            $3cb88ae91b980052$var$suppressDelegatedCreate = false;
            return $3cb88ae91b980052$var$handleStreamingError(error, span);
        }
    });
}
function $3cb88ae91b980052$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const invocationThis = thisArg !== void 0 ? thisArg : context;
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (!isStreamingMethod && $3cb88ae91b980052$var$suppressDelegatedCreate) return target.apply(invocationThis, args);
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = $3cb88ae91b980052$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            const params = typeof args[0] === "object" ? args[0] : void 0;
            const isStreamRequested = Boolean(params?.stream);
            if (isStreamRequested || isStreamingMethod) return $3cb88ae91b980052$var$handleStreamingRequest(target, invocationThis, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $5CFne.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(invocationThis, args);
                if (options.recordInputs && params) $3cb88ae91b980052$var$addPrivateRequestAttributes(span, params, $6atBT.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $3cb88ae91b980052$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                });
            });
            return $6atBT.wrapPromiseWithMethods(originalResult, instrumentedPromise);
        }
    });
}
function $3cb88ae91b980052$var$instrumentClientInPlace(client, options) {
    for (const methodPath of Object.keys($j6AED.ANTHROPIC_METHOD_REGISTRY)){
        const segments = methodPath.split(".");
        const methodName = segments.pop();
        let owner = client;
        for (const segment of segments)owner = owner?.[segment];
        if (!owner || typeof owner[methodName] !== "function") continue;
        const originalMethod = owner[methodName];
        if ($3cb88ae91b980052$var$INSTRUMENTED_METHODS.has(originalMethod)) continue;
        const instrumented = $3cb88ae91b980052$var$instrumentMethod(originalMethod, methodPath, $j6AED.ANTHROPIC_METHOD_REGISTRY[methodPath], owner, options);
        $3cb88ae91b980052$var$INSTRUMENTED_METHODS.add(instrumented);
        owner[methodName] = instrumented;
    }
    return client;
}
function $3cb88ae91b980052$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $3cb88ae91b980052$var$instrumentClientInPlace(anthropicAiClient, $6atBT.resolveAIRecordingOptions(options));
}
module.exports.addPrivateRequestAttributes = $3cb88ae91b980052$var$addPrivateRequestAttributes;
module.exports.addResponseAttributes = $3cb88ae91b980052$var$addResponseAttributes;
module.exports.extractRequestAttributes = $3cb88ae91b980052$var$extractRequestAttributes;
module.exports.instrumentAnthropicAiClient = $3cb88ae91b980052$var$instrumentAnthropicAiClient;

});
parcelRegister("j6AED", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $de8b02a86b535776$var$ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
const $de8b02a86b535776$var$ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $de8b02a86b535776$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $de8b02a86b535776$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("ax3NO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $13TrR = parcelRequire("13TrR");

var $h5H4c = parcelRequire("h5H4c");

var $6atBT = parcelRequire("6atBT");

var $3nLrf = parcelRequire("3nLrf");
function $7aafef8a6ecaaccf$var$isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") {
        if (event.type === "error") {
            span.setStatus({
                code: $h5H4c.SPAN_STATUS_ERROR,
                message: $3nLrf.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            return true;
        }
    }
    return false;
}
function $7aafef8a6ecaaccf$var$handleMessageMetadata(event, state) {
    if (event.type === "message_delta") {
        if (event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
        if (event.delta?.stop_reason) state.finishReasons.push(event.delta.stop_reason);
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens + (message.usage.cache_creation_input_tokens ?? 0) + (message.usage.cache_read_input_tokens ?? 0);
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
function $7aafef8a6ecaaccf$var$handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
function $7aafef8a6ecaaccf$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
function $7aafef8a6ecaaccf$var$handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    delete state.activeToolBlocks[event.index];
}
function $7aafef8a6ecaaccf$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = $7aafef8a6ecaaccf$var$isErrorEvent(event, span);
    if (isError) return;
    $7aafef8a6ecaaccf$var$handleMessageMetadata(event, state);
    $7aafef8a6ecaaccf$var$handleContentBlockStart(event, state);
    $7aafef8a6ecaaccf$var$handleContentBlockDelta(event, state, recordOutputs);
    $7aafef8a6ecaaccf$var$handleContentBlockStop(event, state);
}
async function* $7aafef8a6ecaaccf$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $7aafef8a6ecaaccf$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $6atBT.endStreamSpan(span, state, recordOutputs);
    }
}
function $7aafef8a6ecaaccf$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        $7aafef8a6ecaaccf$var$processEvent(event, state, recordOutputs, span);
    });
    stream.on("message", ()=>{
        $6atBT.endStreamSpan(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        $13TrR.captureException(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $h5H4c.SPAN_STATUS_ERROR,
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $7aafef8a6ecaaccf$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $7aafef8a6ecaaccf$var$instrumentMessageStream;

});
parcelRegister("3nLrf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $13TrR = parcelRequire("13TrR");

var $foFxi = parcelRequire("foFxi");

var $h5H4c = parcelRequire("h5H4c");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");
function $27685164e12c8cb4$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages),
        [$eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $27685164e12c8cb4$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
function $27685164e12c8cb4$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return $27685164e12c8cb4$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
function $27685164e12c8cb4$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $h5H4c.SPAN_STATUS_ERROR,
            message: $27685164e12c8cb4$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $13TrR.captureException(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
function $27685164e12c8cb4$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : void 0;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $27685164e12c8cb4$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $27685164e12c8cb4$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $27685164e12c8cb4$var$messagesFromParams;
module.exports.setMessagesAttribute = $27685164e12c8cb4$var$setMessagesAttribute;

});



parcelRegister("9nAI4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $f3RkF = parcelRequire("f3RkF");

var $foFxi = parcelRequire("foFxi");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $fzE9o = parcelRequire("fzE9o");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $dSnj4 = parcelRequire("dSnj4");

var $leGC4 = parcelRequire("leGC4");

var $1KvWs = parcelRequire("1KvWs");
function $6d42bcdde3c69d49$var$extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    if (context && typeof context === "object") {
        const contextObj = context;
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
function $6d42bcdde3c69d49$var$extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[$eN9vd.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[$eN9vd.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[$eN9vd.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[$eN9vd.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[$eN9vd.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[$eN9vd.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
function $6d42bcdde3c69d49$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$eN9vd.GEN_AI_SYSTEM_ATTRIBUTE]: $dSnj4.GOOGLE_GENAI_SYSTEM_NAME,
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $6d42bcdde3c69d49$var$extractModel(params, context);
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, $6d42bcdde3c69d49$var$extractConfigAttributes(config));
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $6d42bcdde3c69d49$var$extractModel({}, context);
    return attributes;
}
function $6d42bcdde3c69d49$var$addPrivateRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings") {
        const contents = params.contents;
        if (contents != null) span.setAttribute($eN9vd.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...$1KvWs.contentUnionToMessages(params.config.systemInstruction, "system"));
    if ("history" in params) messages.push(...$1KvWs.contentUnionToMessages(params.history, "user"));
    if ("contents" in params) messages.push(...$1KvWs.contentUnionToMessages(params.contents, "user"));
    if ("message" in params) messages.push(...$1KvWs.contentUnionToMessages(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages)
        });
    }
}
function $6d42bcdde3c69d49$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute($eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        const hasOutput = typeof usage.candidatesTokenCount === "number" || typeof usage.thoughtsTokenCount === "number";
        span.setAttributes($6atBT.getTokenUsageAttributes(usage.promptTokenCount, hasOutput ? (usage.candidatesTokenCount ?? 0) + (usage.thoughtsTokenCount ?? 0) : void 0, void 0, usage.cachedContentTokenCount, usage.totalTokenCount));
        if (typeof usage.thoughtsTokenCount === "number") span.setAttribute($eAISS.GEN_AI_USAGE_REASONING_OUTPUT_TOKENS, usage.thoughtsTokenCount);
    }
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
        });
    }
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
function $6d42bcdde3c69d49$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = $6d42bcdde3c69d49$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            if (instrumentedMethod.streaming) return $5CFne.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $6d42bcdde3c69d49$var$addPrivateRequestAttributes(span, params, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $leGC4.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $h5H4c.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    span.end();
                    throw error;
                }
            });
            return $5CFne.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $6d42bcdde3c69d49$var$addPrivateRequestAttributes(span, params, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
                return $fzE9o.handleCallbackErrors(()=>target.apply(context, args), ()=>{}, ()=>{}, (result)=>{
                    if (!isEmbeddings) $6d42bcdde3c69d49$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
function $6d42bcdde3c69d49$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $6atBT.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $dSnj4.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                const wrappedMethod = instrumentedMethod.operation ? $6d42bcdde3c69d49$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return $6d42bcdde3c69d49$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") return value.bind(t);
            if (value && typeof value === "object") return $6d42bcdde3c69d49$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $6d42bcdde3c69d49$var$instrumentGoogleGenAIClient(client, options) {
    return $6d42bcdde3c69d49$var$createDeepProxy(client, "", $6atBT.resolveAIRecordingOptions(options));
}
module.exports.addPrivateRequestAttributes = $6d42bcdde3c69d49$var$addPrivateRequestAttributes;
module.exports.addResponseAttributes = $6d42bcdde3c69d49$var$addResponseAttributes;
module.exports.extractModel = $6d42bcdde3c69d49$var$extractModel;
module.exports.extractRequestAttributes = $6d42bcdde3c69d49$var$extractRequestAttributes;
module.exports.instrumentGoogleGenAIClient = $6d42bcdde3c69d49$var$instrumentGoogleGenAIClient;

});
parcelRegister("dSnj4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $a1a265b3b335d9af$var$GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const $a1a265b3b335d9af$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
const $a1a265b3b335d9af$var$GOOGLE_GENAI_SYSTEM_NAME = "google_genai";
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $a1a265b3b335d9af$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $a1a265b3b335d9af$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $a1a265b3b335d9af$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("leGC4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $13TrR = parcelRequire("13TrR");

var $h5H4c = parcelRequire("h5H4c");

var $6atBT = parcelRequire("6atBT");
function $f75bf5dbae246aa2$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $h5H4c.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $13TrR.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
function $f75bf5dbae246aa2$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.candidateTokens = usage.candidatesTokenCount;
        if (typeof usage.thoughtsTokenCount === "number") state.reasoningOutputTokens = usage.thoughtsTokenCount;
        if (state.candidateTokens !== void 0 || state.reasoningOutputTokens !== void 0) state.completionTokens = (state.candidateTokens ?? 0) + (state.reasoningOutputTokens ?? 0);
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
        if (typeof usage.cachedContentTokenCount === "number") state.cacheReadInputTokens = usage.cachedContentTokenCount;
    }
}
function $f75bf5dbae246aa2$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
function $f75bf5dbae246aa2$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $f75bf5dbae246aa2$var$isErrorChunk(chunk, span)) return;
    $f75bf5dbae246aa2$var$handleResponseMetadata(chunk, state);
    $f75bf5dbae246aa2$var$handleCandidateContent(chunk, state, recordOutputs);
}
async function* $f75bf5dbae246aa2$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $f75bf5dbae246aa2$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $6atBT.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $f75bf5dbae246aa2$var$instrumentStream;

});

parcelRegister("1KvWs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $1462dd54837da644$var$contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content2)=>$1462dd54837da644$var$contentUnionToMessages(content2, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $1462dd54837da644$var$contentUnionToMessages;

});


parcelRegister("lVCHq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $iYG6e = parcelRequire("iYG6e");

var $aGDGs = parcelRequire("aGDGs");
function $ff6cf0bcb7a93f0d$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $6atBT.resolveAIRecordingOptions(options);
    const enableTruncation = $6atBT.shouldEnableTruncation(options.enableTruncation);
    const spanMap = /* @__PURE__ */ new Map();
    const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: void 0,
        lc_attributes: void 0,
        lc_aliases: void 0,
        lc_serializable_keys: void 0,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $aGDGs.getInvocationParams(tags);
            const attributes = $aGDGs.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $5CFne.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$aGDGs.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $aGDGs.getInvocationParams(tags);
            const attributes = $aGDGs.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $aGDGs.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $5CFne.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$aGDGs.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $aGDGs.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            $5CFne.startSpanManual({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: {
                    ...attributes,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = {
                ...$aGDGs.getAgentNameFromMetadata(metadata),
                [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $iYG6e.LANGCHAIN_ORIGIN,
                [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                [$eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$eN9vd.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $5CFne.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: {
                    ...attributes,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$eN9vd.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $ff6cf0bcb7a93f0d$var$createLangChainCallbackHandler;

});
parcelRegister("iYG6e", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $dd0e7caf2ac88560$var$LANGCHAIN_INTEGRATION_NAME = "LangChain";
const $dd0e7caf2ac88560$var$LANGCHAIN_ORIGIN = "auto.ai.langchain";
const $dd0e7caf2ac88560$var$ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $dd0e7caf2ac88560$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $dd0e7caf2ac88560$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $dd0e7caf2ac88560$var$ROLE_MAP;

});

parcelRegister("aGDGs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $f3RkF = parcelRequire("f3RkF");

var $foFxi = parcelRequire("foFxi");

var $cUgOr = parcelRequire("cUgOr");

var $eN9vd = parcelRequire("eN9vd");

var $1qvHT = parcelRequire("1qvHT");

var $6atBT = parcelRequire("6atBT");

var $iYG6e = parcelRequire("iYG6e");
const $7c7c9c05f7ab0056$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
const $7c7c9c05f7ab0056$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
function $7c7c9c05f7ab0056$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && $1qvHT.isContentMedia(part) ? $1qvHT.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $foFxi.stringify(v, String);
}
function $7c7c9c05f7ab0056$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $iYG6e.ROLE_MAP[normalized] ?? normalized;
}
function $7c7c9c05f7ab0056$var$normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
function $7c7c9c05f7ab0056$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return void 0;
    return tags.invocation_params;
}
function $7c7c9c05f7ab0056$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: $7c7c9c05f7ab0056$var$normalizeMessageRole(messageType),
                content: $7c7c9c05f7ab0056$var$normalizeContent(message.content)
            };
        }
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? $7c7c9c05f7ab0056$var$normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: $7c7c9c05f7ab0056$var$normalizeMessageRole(role),
                content: $7c7c9c05f7ab0056$var$normalizeContent(message.kwargs?.content)
            };
        }
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $7c7c9c05f7ab0056$var$normalizeMessageRole(role),
                content: $7c7c9c05f7ab0056$var$normalizeContent(message.content)
            };
        }
        if (message.role) return {
            role: $7c7c9c05f7ab0056$var$normalizeMessageRole(String(message.role)),
            content: $7c7c9c05f7ab0056$var$normalizeContent(message.content)
        };
        const ctor = message.constructor?.name;
        if (ctor && ctor !== "Object") return {
            role: $7c7c9c05f7ab0056$var$normalizeMessageRole($7c7c9c05f7ab0056$var$normalizeRoleNameFromCtor(ctor)),
            content: $7c7c9c05f7ab0056$var$normalizeContent(message.content)
        };
        return {
            role: "user",
            content: $7c7c9c05f7ab0056$var$normalizeContent(message.content)
        };
    });
}
function $7c7c9c05f7ab0056$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $7c7c9c05f7ab0056$var$setNumberIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $7c7c9c05f7ab0056$var$setNumberIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $7c7c9c05f7ab0056$var$setNumberIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $7c7c9c05f7ab0056$var$setNumberIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $7c7c9c05f7ab0056$var$setNumberIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    if (invocationParams && "stream" in invocationParams) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
function $7c7c9c05f7ab0056$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$eN9vd.GEN_AI_SYSTEM_ATTRIBUTE]: $foFxi.stringify(system ?? "langchain", String),
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
        [$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $foFxi.stringify(modelName, String),
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $iYG6e.LANGCHAIN_ORIGIN,
        ...$7c7c9c05f7ab0056$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
function $7c7c9c05f7ab0056$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $7c7c9c05f7ab0056$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $6atBT.getTruncatedJsonString(messages) : $foFxi.stringify(messages));
    }
    return attrs;
}
function $7c7c9c05f7ab0056$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $7c7c9c05f7ab0056$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $7c7c9c05f7ab0056$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(normalized);
        if (systemInstructions) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages));
    }
    return attrs;
}
function $7c7c9c05f7ab0056$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $foFxi.stringify(toolCalls, String));
}
function $7c7c9c05f7ab0056$var$extractMessageTokenUsageAttributes(message) {
    const usage = message.usage_metadata;
    if ($cUgOr.isObjectLike(usage)) {
        const details = $cUgOr.isObjectLike(usage.input_token_details) ? usage.input_token_details : void 0;
        return $6atBT.getTokenUsageAttributes(usage.input_tokens, usage.output_tokens, details?.cache_creation, details?.cache_read, usage.total_tokens);
    }
    const metadata = message.response_metadata;
    const tokenUsage = $cUgOr.isObjectLike(metadata) && $cUgOr.isObjectLike(metadata.tokenUsage) ? metadata.tokenUsage : void 0;
    return $6atBT.getTokenUsageAttributes(tokenUsage?.promptTokens, tokenUsage?.completionTokens, void 0, void 0, tokenUsage?.totalTokens);
}
function $7c7c9c05f7ab0056$var$addTokenUsageAttributes(llmResult, attrs) {
    const normalizedUsage = {};
    const legacyMessageUsage = {};
    for (const generations of llmResult.generations ?? []){
        const message = generations[0]?.message;
        if (message) {
            const usage = $cUgOr.isObjectLike(message.usage_metadata) ? normalizedUsage : legacyMessageUsage;
            for (const [key, value] of Object.entries($7c7c9c05f7ab0056$var$extractMessageTokenUsageAttributes(message)))usage[key] = (usage[key] ?? 0) + value;
        }
    }
    Object.assign(attrs, Object.keys(normalizedUsage).length > 0 ? normalizedUsage : legacyMessageUsage);
    const llmOutput = llmResult.llmOutput;
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (anthropicUsage && Object.keys(normalizedUsage).length === 0 && Object.keys(legacyMessageUsage).length === 0) {
        const { input_tokens: input_tokens, output_tokens: output_tokens, cache_creation_input_tokens: cache_creation_input_tokens, cache_read_input_tokens: cache_read_input_tokens } = anthropicUsage;
        const hasInput = input_tokens !== void 0 || cache_creation_input_tokens !== void 0 || cache_read_input_tokens !== void 0;
        Object.assign(attrs, $6atBT.getTokenUsageAttributes(hasInput ? (input_tokens ?? 0) + (cache_creation_input_tokens ?? 0) + (cache_read_input_tokens ?? 0) : void 0, output_tokens, cache_creation_input_tokens, cache_read_input_tokens));
    } else if (tokenUsage && Object.keys(normalizedUsage).length === 0 && Object.keys(legacyMessageUsage).length === 0) Object.assign(attrs, $6atBT.getTokenUsageAttributes(tokenUsage.promptTokens, tokenUsage.completionTokens, void 0, void 0, tokenUsage.totalTokens));
    if (anthropicUsage) {
        if (typeof anthropicUsage.cache_creation_input_tokens === "number" && !($eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS in attrs)) attrs[$eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS] = anthropicUsage.cache_creation_input_tokens;
        if (typeof anthropicUsage.cache_read_input_tokens === "number" && !($eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS in attrs)) attrs[$eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS] = anthropicUsage.cache_read_input_tokens;
    }
}
function $7c7c9c05f7ab0056$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $foFxi.stringify(finishReasons, String));
        $7c7c9c05f7ab0056$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === "string");
            if (texts.length > 0) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $foFxi.stringify(texts, String));
        }
    }
    $7c7c9c05f7ab0056$var$addTokenUsageAttributes(llmResult, attrs);
    const llmOutput = llmResult.llmOutput;
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $foFxi.stringify(stopReason, String));
    return attrs;
}
function $7c7c9c05f7ab0056$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === "string") attrs[$eN9vd.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $7c7c9c05f7ab0056$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return void 0;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: "function",
            name: tool.name ?? fn?.name ?? "",
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
function $7c7c9c05f7ab0056$var$isCallbackManager(value) {
    if (!value || typeof value !== "object") return false;
    const candidate = value;
    return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
}
function $7c7c9c05f7ab0056$var$isSentryHandler(handler) {
    return typeof handler === "object" && handler?.name === "SentryCallbackHandler";
}
function $7c7c9c05f7ab0056$var$containsSentryHandler(handlers) {
    return handlers.some($7c7c9c05f7ab0056$var$isSentryHandler);
}
function $7c7c9c05f7ab0056$var$_INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if ($7c7c9c05f7ab0056$var$isCallbackManager(existing)) {
        if ($7c7c9c05f7ab0056$var$containsSentryHandler(existing.handlers ?? [])) return existing;
        const copied = existing.copy();
        copied.addHandler(sentryHandler, true);
        return copied;
    }
    const handlers = Array.isArray(existing) ? existing : [
        existing
    ];
    if ($7c7c9c05f7ab0056$var$containsSentryHandler(handlers)) return existing;
    return [
        ...handlers,
        sentryHandler
    ];
}
module.exports._INTERNAL_mergeLangChainCallbackHandler = $7c7c9c05f7ab0056$var$_INTERNAL_mergeLangChainCallbackHandler;
module.exports.extractChatModelRequestAttributes = $7c7c9c05f7ab0056$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $7c7c9c05f7ab0056$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $7c7c9c05f7ab0056$var$extractLlmResponseAttributes;
module.exports.extractMessageTokenUsageAttributes = $7c7c9c05f7ab0056$var$extractMessageTokenUsageAttributes;
module.exports.extractToolDefinitions = $7c7c9c05f7ab0056$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $7c7c9c05f7ab0056$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $7c7c9c05f7ab0056$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $7c7c9c05f7ab0056$var$normalizeLangChainMessages;

});


parcelRegister("fbA8J", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $iYG6e = parcelRequire("iYG6e");
function $b0e3eab0a3f7970b$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
function $b0e3eab0a3f7970b$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $iYG6e.LANGCHAIN_ORIGIN,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $eN9vd.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
        [$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? "unknown"
    };
    attributes[$eN9vd.GEN_AI_SYSTEM_ATTRIBUTE] = $b0e3eab0a3f7970b$var$inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[$eN9vd.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[$eN9vd.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
function $b0e3eab0a3f7970b$var$_INTERNAL_getLangChainEmbeddingsSpanOptions(instance, input, options = {}) {
    const { recordInputs: recordInputs } = $6atBT.resolveAIRecordingOptions(options);
    const attributes = $b0e3eab0a3f7970b$var$extractEmbeddingAttributes(instance);
    const modelName = attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
    if (recordInputs && input != null) attributes[$eN9vd.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
    return {
        name: `embeddings ${modelName}`,
        op: $eN9vd.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        attributes: attributes
    };
}
function $b0e3eab0a3f7970b$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            return $5CFne.startSpan($b0e3eab0a3f7970b$var$_INTERNAL_getLangChainEmbeddingsSpanOptions(thisArg, args[0], options), ()=>{
                return Reflect.apply(target, thisArg, args);
            });
        }
    });
}
function $b0e3eab0a3f7970b$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = $b0e3eab0a3f7970b$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = $b0e3eab0a3f7970b$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports._INTERNAL_getLangChainEmbeddingsSpanOptions = $b0e3eab0a3f7970b$var$_INTERNAL_getLangChainEmbeddingsSpanOptions;
module.exports.instrumentEmbeddingMethod = $b0e3eab0a3f7970b$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $b0e3eab0a3f7970b$var$instrumentLangChainEmbeddings;

});

parcelRegister("lWjTr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");

var $foFxi = parcelRequire("foFxi");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $lVCHq = parcelRequire("lVCHq");

var $aGDGs = parcelRequire("aGDGs");

var $hYL8G = parcelRequire("hYL8G");

var $6OoWC = parcelRequire("6OoWC");
let $ff8e72220f6aa8bb$var$_insideCreateReactAgent = false;
const $ff8e72220f6aa8bb$var$SENTRY_PATCHED = "__sentry_patched__";
function $ff8e72220f6aa8bb$var$_INTERNAL_getLangGraphCreateAgentSpanOptions(agentName) {
    const attributes = {
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $hYL8G.LANGGRAPH_ORIGIN,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
    };
    if (agentName) attributes[$eN9vd.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return {
        op: "gen_ai.create_agent",
        name: agentName ? `create_agent ${agentName}` : "create_agent",
        attributes: attributes
    };
}
function $ff8e72220f6aa8bb$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $ff8e72220f6aa8bb$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $lVCHq.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            if ($ff8e72220f6aa8bb$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $5CFne.startSpan($ff8e72220f6aa8bb$var$_INTERNAL_getLangGraphCreateAgentSpanOptions(), (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    if (compileOptions?.name && typeof compileOptions.name === "string") {
                        span.setAttribute($eN9vd.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = $ff8e72220f6aa8bb$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, void 0, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $h5H4c.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $ff8e72220f6aa8bb$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $ff8e72220f6aa8bb$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $5CFne.startSpan({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $hYL8G.LANGGRAPH_ORIGIN,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $eN9vd.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute($eN9vd.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($eN9vd.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    const config = args.length > 1 ? args[1] : void 0;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute($eN9vd.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === "string" ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $aGDGs._INTERNAL_mergeLangChainCallbackHandler(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    const tools = $6OoWC.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $aGDGs.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $6atBT.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages),
                            [$eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $6OoWC.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $h5H4c.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    throw error;
                }
            });
        }
    });
}
function $ff8e72220f6aa8bb$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $ff8e72220f6aa8bb$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $6atBT.resolveAIRecordingOptions(options);
    const sentryHandler = $lVCHq.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $6OoWC.extractLLMFromParams(args);
            const agentName = $6OoWC.extractAgentNameFromParams(args);
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $6OoWC.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? void 0);
            $ff8e72220f6aa8bb$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $ff8e72220f6aa8bb$var$_insideCreateReactAgent = false;
            }
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $ff8e72220f6aa8bb$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $ff8e72220f6aa8bb$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $ff8e72220f6aa8bb$var$instrumentStateGraph(stateGraph, options) {
    stateGraph.compile = $ff8e72220f6aa8bb$var$instrumentStateGraphCompile(stateGraph.compile, $6atBT.resolveAIRecordingOptions(options));
    return stateGraph;
}
const $ff8e72220f6aa8bb$var$instrumentLangGraph = $ff8e72220f6aa8bb$var$instrumentStateGraph;
module.exports._INTERNAL_getLangGraphCreateAgentSpanOptions = $ff8e72220f6aa8bb$var$_INTERNAL_getLangGraphCreateAgentSpanOptions;
module.exports.instrumentCompiledGraphInvoke = $ff8e72220f6aa8bb$var$instrumentCompiledGraphInvoke;
module.exports.instrumentCreateReactAgent = $ff8e72220f6aa8bb$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $ff8e72220f6aa8bb$var$instrumentLangGraph;
module.exports.instrumentStateGraph = $ff8e72220f6aa8bb$var$instrumentStateGraph;
module.exports.instrumentStateGraphCompile = $ff8e72220f6aa8bb$var$instrumentStateGraphCompile;

});
parcelRegister("hYL8G", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $d16c9b1958e018a8$var$LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const $d16c9b1958e018a8$var$LANGGRAPH_ORIGIN = "auto.ai.langgraph";
module.exports.LANGGRAPH_INTEGRATION_NAME = $d16c9b1958e018a8$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $d16c9b1958e018a8$var$LANGGRAPH_ORIGIN;

});

parcelRegister("6OoWC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $f3RkF = parcelRequire("f3RkF");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $aGDGs = parcelRequire("aGDGs");

var $hYL8G = parcelRequire("hYL8G");
function $4f5ac30be815dfe7$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
function $4f5ac30be815dfe7$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
function $4f5ac30be815dfe7$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : void 0;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $hYL8G.LANGGRAPH_ORIGIN,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $eN9vd.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                    [$eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$eN9vd.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
                };
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === "string") spanAttributes[$eN9vd.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$eN9vd.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[$eN9vd.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[$eN9vd.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {}
                    }
                }
                return $5CFne.startSpan({
                    op: $eN9vd.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute($eN9vd.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === "string" ? content : JSON.stringify(content));
                        } catch  {}
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $h5H4c.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
function $4f5ac30be815dfe7$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
function $4f5ac30be815dfe7$var$extractTokenUsageFromMessage(message) {
    const attributes$1 = $aGDGs.extractMessageTokenUsageAttributes(message);
    return {
        inputTokens: attributes$1[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] ?? 0,
        outputTokens: attributes$1[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] ?? 0,
        totalTokens: attributes$1[$eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] ?? 0,
        cacheCreationInputTokens: attributes$1[$eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS],
        cacheReadInputTokens: attributes$1[$eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS]
    };
}
function $4f5ac30be815dfe7$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute($eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute($eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
function $4f5ac30be815dfe7$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
function $4f5ac30be815dfe7$var$setResponseAttributes(span, inputMessages, result) {
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    const toolCalls = $4f5ac30be815dfe7$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    const normalizedNewMessages = $aGDGs.normalizeLangChainMessages(newMessages);
    span.setAttribute($eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    let cacheCreationInputTokens;
    let cacheReadInputTokens;
    for (const message of newMessages){
        const tokens = $4f5ac30be815dfe7$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        if (tokens.cacheCreationInputTokens !== void 0) cacheCreationInputTokens = (cacheCreationInputTokens ?? 0) + tokens.cacheCreationInputTokens;
        if (tokens.cacheReadInputTokens !== void 0) cacheReadInputTokens = (cacheReadInputTokens ?? 0) + tokens.cacheReadInputTokens;
        $4f5ac30be815dfe7$var$extractModelMetadata(span, message);
    }
    if (totalInputTokens > 0) span.setAttribute($eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
    if (cacheCreationInputTokens !== void 0) span.setAttribute($eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS, cacheCreationInputTokens);
    if (cacheReadInputTokens !== void 0) span.setAttribute($eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS, cacheReadInputTokens);
}
module.exports.extractAgentNameFromParams = $4f5ac30be815dfe7$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $4f5ac30be815dfe7$var$extractLLMFromParams;
module.exports.extractModelMetadata = $4f5ac30be815dfe7$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $4f5ac30be815dfe7$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $4f5ac30be815dfe7$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $4f5ac30be815dfe7$var$extractToolsFromCompiledGraph;
module.exports.setResponseAttributes = $4f5ac30be815dfe7$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $4f5ac30be815dfe7$var$wrapToolsWithSpans;

});


parcelRegister("lHZZ7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $fbkeM = parcelRequire("fbkeM");

var $6atBT = parcelRequire("6atBT");

var $5SzUg = parcelRequire("5SzUg");

var $kpt7v = parcelRequire("kpt7v");

var $6HgHS = parcelRequire("6HgHS");
function $fcddb207857a1cab$var$isReadableStream(value) {
    return $cUgOr.isObjectLike(value) && typeof value.pipeThrough === "function" && typeof value.getReader === "function";
}
function $fcddb207857a1cab$var$instrumentRun(originalRun, context, options) {
    return function instrumentedRun(...args) {
        if ($fbkeM._INTERNAL_shouldSkipAiProviderWrapping($5SzUg.WORKERS_AI_INTEGRATION_NAME)) return originalRun.apply(context, args);
        const [model, inputs, runOptions] = args;
        const operationName = $6HgHS.getOperationName(inputs);
        const requestAttributes = $6HgHS.extractRequestAttributes(model, inputs, operationName);
        const modelName = typeof model === "string" ? model : "unknown";
        const isStreamRequested = !!inputs && typeof inputs === "object" && inputs.stream === true;
        const returnsRawResponse = !!runOptions && typeof runOptions === "object" && (runOptions.returnRawResponse === true || runOptions.websocket === true);
        const spanConfig = {
            name: `${operationName} ${modelName}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested && !returnsRawResponse) return $5CFne.startSpanManual(spanConfig, (span)=>{
            const handleError = (error)=>{
                span.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                span.end();
                throw error;
            };
            let originalResult;
            try {
                originalResult = originalRun.apply(context, args);
            } catch (error) {
                return handleError(error);
            }
            if (options.recordInputs) $6HgHS.addRequestAttributes(span, inputs, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                if ($fcddb207857a1cab$var$isReadableStream(result)) return $kpt7v.instrumentWorkersAiStream(result, span, options.recordOutputs);
                $6HgHS.addResponseAttributes(span, result, options.recordOutputs);
                span.end();
                return result;
            }, handleError);
        });
        return $5CFne.startSpan(spanConfig, (span)=>{
            const originalResult = originalRun.apply(context, args);
            if (options.recordInputs) $6HgHS.addRequestAttributes(span, inputs, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                if (!returnsRawResponse) $6HgHS.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            });
        });
    };
}
function $fcddb207857a1cab$var$instrumentWorkersAiClient(client, options) {
    const resolvedOptions = $6atBT.resolveAIRecordingOptions(options);
    const instrumented = new Proxy(client, {
        get (target, prop, receiver) {
            const value = Reflect.get(target, prop, receiver);
            if (prop === "run" && typeof value === "function") return $fcddb207857a1cab$var$instrumentRun(value, target, resolvedOptions);
            return typeof value === "function" ? value.bind(target) : value;
        }
    });
    return instrumented;
}
module.exports.instrumentWorkersAiClient = $fcddb207857a1cab$var$instrumentWorkersAiClient;

});
parcelRegister("kpt7v", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $h5H4c = parcelRequire("h5H4c");

var $6atBT = parcelRequire("6atBT");

var $6HgHS = parcelRequire("6HgHS");
function $edbcbb12fdaf9afb$var$accumulateStreamingToolCalls(toolCalls, accumulator) {
    for (const toolCall of toolCalls){
        const name = toolCall.function?.name ?? toolCall.name;
        const args = toolCall.function?.arguments ?? toolCall.arguments;
        if (name == null && args == null) continue;
        const index = toolCall.index ?? 0;
        const existing = accumulator[index];
        if (!existing) accumulator[index] = {
            index: index,
            id: toolCall.id,
            type: toolCall.type,
            function: {
                name: name,
                arguments: args ?? ""
            }
        };
        else if (existing.function) {
            if (name && !existing.function.name) existing.function.name = name;
            if (args) existing.function.arguments = `${existing.function.arguments ?? ""}${args}`;
        }
    }
}
function $edbcbb12fdaf9afb$var$processLine(line, state, recordOutputs, toolCallAccumulator) {
    const trimmed = line.trim();
    if (!trimmed.startsWith("data:")) return;
    const data = trimmed.slice(5).trim();
    if (!data || data === "[DONE]") return;
    let parsed;
    try {
        parsed = JSON.parse(data);
    } catch  {
        return;
    }
    if (parsed.usage) {
        if (typeof parsed.usage.prompt_tokens === "number") state.promptTokens = parsed.usage.prompt_tokens;
        if (typeof parsed.usage.completion_tokens === "number") state.completionTokens = parsed.usage.completion_tokens;
        if (typeof parsed.usage.total_tokens === "number") state.totalTokens = parsed.usage.total_tokens;
    }
    if (recordOutputs && typeof parsed.response === "string") state.responseTexts.push(parsed.response);
    if (recordOutputs && Array.isArray(parsed.tool_calls) && parsed.tool_calls.length > 0) state.toolCalls.push(...parsed.tool_calls);
    if (Array.isArray(parsed.choices)) for (const choice of parsed.choices){
        if (recordOutputs && typeof choice.delta?.content === "string" && choice.delta.content) state.responseTexts.push(choice.delta.content);
        if (recordOutputs && Array.isArray(choice.delta?.tool_calls)) $edbcbb12fdaf9afb$var$accumulateStreamingToolCalls(choice.delta.tool_calls, toolCallAccumulator);
        if (typeof choice.finish_reason === "string") state.finishReasons.push(choice.finish_reason);
    }
}
function $edbcbb12fdaf9afb$var$instrumentWorkersAiStream(stream, span, recordOutputs) {
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    const state = {
        responseId: "",
        responseModel: "",
        finishReasons: [],
        responseTexts: [],
        toolCalls: [],
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0
    };
    const toolCallAccumulator = {};
    let buffer = "";
    let spanEnded = false;
    const finish = ()=>{
        if (spanEnded) return;
        spanEnded = true;
        if (recordOutputs) {
            const accumulatedToolCalls = Object.values(toolCallAccumulator);
            if (accumulatedToolCalls.length > 0) state.toolCalls.push(...accumulatedToolCalls);
            $6HgHS.setOutputMessagesAttribute(span, {
                responseText: state.responseTexts.join(""),
                toolCalls: state.toolCalls
            });
        }
        $6atBT.endStreamSpan(span, state, recordOutputs);
    };
    const flushBuffer = (isDone)=>{
        const lines = buffer.split("\n");
        buffer = isDone ? "" : lines.pop() ?? "";
        for (const line of lines)$edbcbb12fdaf9afb$var$processLine(line, state, recordOutputs, toolCallAccumulator);
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await reader.read();
                if (done) {
                    buffer += decoder.decode();
                    flushBuffer(true);
                    finish();
                    controller.close();
                    return;
                }
                buffer += decoder.decode(value, {
                    stream: true
                });
                flushBuffer(false);
                controller.enqueue(value);
            } catch (error) {
                span.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                finish();
                controller.error(error);
            }
        },
        async cancel (reason) {
            finish();
            await reader.cancel(reason);
        }
    });
}
module.exports.instrumentWorkersAiStream = $edbcbb12fdaf9afb$var$instrumentWorkersAiStream;

});
parcelRegister("6HgHS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $f3RkF = parcelRequire("f3RkF");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $foFxi = parcelRequire("foFxi");

var $5SzUg = parcelRequire("5SzUg");
function $4e03b7d555326a14$var$getOperationName(inputs) {
    if (inputs && typeof inputs === "object") {
        if ("messages" in inputs || "prompt" in inputs) return "chat";
        if ("text" in inputs) return "embeddings";
    }
    return "chat";
}
function $4e03b7d555326a14$var$extractRequestAttributes(model, inputs, operationName) {
    const attributes$1 = {
        [$eAISS.GEN_AI_PROVIDER_NAME]: $5SzUg.WORKERS_AI_PROVIDER_NAME,
        [$eAISS.GEN_AI_OPERATION_NAME]: operationName,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $5SzUg.WORKERS_AI_ORIGIN,
        [$eAISS.GEN_AI_REQUEST_MODEL]: typeof model === "string" ? model : "unknown"
    };
    if (inputs && typeof inputs === "object") {
        const params = inputs;
        if (typeof params.temperature === "number") attributes$1[$eAISS.GEN_AI_REQUEST_TEMPERATURE] = params.temperature;
        if (typeof params.max_tokens === "number") attributes$1[$eAISS.GEN_AI_REQUEST_MAX_TOKENS] = params.max_tokens;
        if (typeof params.top_p === "number") attributes$1[$eAISS.GEN_AI_REQUEST_TOP_P] = params.top_p;
        if (typeof params.top_k === "number") attributes$1[$eAISS.GEN_AI_REQUEST_TOP_K] = params.top_k;
        if (typeof params.frequency_penalty === "number") attributes$1[$eAISS.GEN_AI_REQUEST_FREQUENCY_PENALTY] = params.frequency_penalty;
        if (typeof params.presence_penalty === "number") attributes$1[$eAISS.GEN_AI_REQUEST_PRESENCE_PENALTY] = params.presence_penalty;
        if (params.stream === true) attributes$1[$eN9vd.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = true;
    }
    return attributes$1;
}
function $4e03b7d555326a14$var$addRequestAttributes(span, inputs, operationName, enableTruncation) {
    if (!inputs || typeof inputs !== "object") return;
    const params = inputs;
    if (operationName === "embeddings") {
        const text = params.text;
        if (text == null || typeof text === "string" && text.length === 0 || Array.isArray(text) && text.length === 0) return;
        span.setAttribute($eAISS.GEN_AI_EMBEDDINGS_INPUT, typeof text === "string" ? text : JSON.stringify(text));
        return;
    }
    const src = params.messages ?? params.prompt;
    if (src == null || Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($eAISS.GEN_AI_SYSTEM_INSTRUCTIONS, systemInstructions);
    span.setAttribute($eAISS.GEN_AI_INPUT_MESSAGES, enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages));
    span.setAttribute($eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, Array.isArray(filteredMessages) ? filteredMessages.length : 1);
}
function $4e03b7d555326a14$var$setOutputMessagesAttribute(span, { responseText: responseText, toolCalls: toolCalls }) {
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (Array.isArray(toolCalls)) for (const toolCall of toolCalls){
        if (!toolCall || typeof toolCall !== "object") continue;
        const call = toolCall;
        const name = call.function?.name ?? call.name;
        const args = call.function?.arguments ?? call.arguments;
        parts.push({
            type: "tool_call",
            id: call.id,
            name: name,
            arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
        });
    }
    if (parts.length > 0) span.setAttribute($eN9vd.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE, JSON.stringify([
        {
            role: "assistant",
            parts: parts
        }
    ]));
}
function $4e03b7d555326a14$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object" || // Raw `Response` objects (from `returnRawResponse`/`websocket`) cannot be introspected without consuming them.
    typeof Response !== "undefined" && result instanceof Response) return;
    const response = result;
    if (response.usage) span.setAttributes($6atBT.getTokenUsageAttributes(response.usage.prompt_tokens, response.usage.completion_tokens));
    if (recordOutputs) {
        let responseText;
        if (typeof response.response === "string") {
            responseText = response.response;
            span.setAttribute($eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, response.response);
        } else if (response.response != null) {
            responseText = JSON.stringify(response.response);
            span.setAttribute($eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, responseText);
        }
        const toolCalls = Array.isArray(response.tool_calls) && response.tool_calls.length > 0 ? response.tool_calls : void 0;
        if (toolCalls) span.setAttribute($eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
        $4e03b7d555326a14$var$setOutputMessagesAttribute(span, {
            responseText: responseText,
            toolCalls: toolCalls
        });
    }
}
module.exports.addRequestAttributes = $4e03b7d555326a14$var$addRequestAttributes;
module.exports.addResponseAttributes = $4e03b7d555326a14$var$addResponseAttributes;
module.exports.extractRequestAttributes = $4e03b7d555326a14$var$extractRequestAttributes;
module.exports.getOperationName = $4e03b7d555326a14$var$getOperationName;
module.exports.setOutputMessagesAttribute = $4e03b7d555326a14$var$setOutputMessagesAttribute;

});



parcelRegister("4mNpz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $dFAcI = parcelRequire("dFAcI");

var $4LxkX = parcelRequire("4LxkX");

var $sp0kd = parcelRequire("sp0kd");

var $iBvZc = parcelRequire("iBvZc");
const $32df8b92deab68bf$var$MAX_SPANS_PER_ENVELOPE = 1e3;
const $32df8b92deab68bf$var$MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
class $32df8b92deab68bf$var$SpanBuffer {
    constructor(client, options){
        this._traceBuckets = /* @__PURE__ */ new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $32df8b92deab68bf$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $32df8b92deab68bf$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $32df8b92deab68bf$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: /* @__PURE__ */ new Set(),
                size: 0,
                timeout: $dFAcI.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $iBvZc.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = $4LxkX.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $sp0kd.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $32df8b92deab68bf$var$SpanBuffer;

});
parcelRegister("sp0kd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $hGnwj = parcelRequire("hGnwj");

var $hkF3C = parcelRequire("hkF3C");
function $055602f634007196$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $j6N8F.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: new Date($hkF3C.safeDateNow()).toISOString(),
        ...$055602f634007196$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $3zkbY.dsnToString(dsn$1)
        }
    };
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$hGnwj.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $j6N8F.createEnvelope(headers, [
        spanContainer
    ]);
}
function $055602f634007196$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $055602f634007196$var$createStreamedSpanEnvelope;

});

parcelRegister("iBvZc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7DFGy = parcelRequire("7DFGy");
function $d8b47e7da2586131$var$estimateSerializedSpanSizeInBytes(span) {
    let weight = 156;
    weight += span.name.length * 2;
    weight += $7DFGy.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        const linkWeight = 100 + (attributes$1 ? $7DFGy.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $d8b47e7da2586131$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("3OVuZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $iOdTc = parcelRequire("iOdTc");

var $dvzf1 = parcelRequire("dvzf1");

var $4wQxQ = parcelRequire("4wQxQ");

var $6Xrci = parcelRequire("6Xrci");

var $4mNpz = parcelRequire("4mNpz");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");
const $2c82a4b157672b6b$var$spanStreamingIntegration = $iOdTc.defineIntegration(()=>{
    return {
        name: "SpanStreaming",
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!$6Xrci.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = "static";
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$dvzf1.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = "static";
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $4mNpz.SpanBuffer(client);
            client.on("afterSpanEnd", (span)=>{
                if (!$6vUrj.spanIsSampled(span)) return;
                buffer.add($4wQxQ.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $2c82a4b157672b6b$var$spanStreamingIntegration;

});

parcelRegister("fJLhk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b74fbb81e6121da4$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $b74fbb81e6121da4$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("9TAZi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $7345f114e738003a$var$SentryError extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $7345f114e738003a$var$SentryError;

});

parcelRegister("as54b", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $cUgOr = parcelRequire("cUgOr");

var $42zXR = parcelRequire("42zXR");

var $2AGy2 = parcelRequire("2AGy2");

var $5L5uH = parcelRequire("5L5uH");

var $cqs9v = parcelRequire("cqs9v");

var $eCBhU = parcelRequire("eCBhU");
function $79c07301d857e59e$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = $eCBhU.addHandler(type, handler);
    $eCBhU.maybeInstrument(type, ()=>$79c07301d857e59e$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $79c07301d857e59e$var$addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = $eCBhU.addHandler(type, handler);
    $eCBhU.maybeInstrument(type, ()=>$79c07301d857e59e$var$instrumentFetch($79c07301d857e59e$var$streamHandler));
    return removeHandler;
}
function $79c07301d857e59e$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$2AGy2.supportsNativeFetch()) return;
    $42zXR.fill($cqs9v.GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $79c07301d857e59e$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $5L5uH.timestampInSeconds() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $79c07301d857e59e$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) $eCBhU.triggerHandlers("fetch", {
                ...handlerData
            });
            return originalFetch.apply($cqs9v.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $eCBhU.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $5L5uH.timestampInSeconds() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                $eCBhU.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $5L5uH.timestampInSeconds() * 1e3,
                    error: error
                });
                if ($cUgOr.isError(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    $42zXR.addNonEnumerableProperty(error, "framesToPop", 1);
                }
                const client = $5JqSP.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && $cUgOr.isError(error) && error.name === "TypeError" && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else $42zXR.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $79c07301d857e59e$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $79c07301d857e59e$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $79c07301d857e59e$var$resolveResponse(clonedResponseForResolving, ()=>{
        $eCBhU.triggerHandlers("fetch-body-resolved", {
            endTimestamp: $5L5uH.timestampInSeconds() * 1e3,
            response: response
        });
    });
}
function $79c07301d857e59e$var$hasProp(obj, prop) {
    return $cUgOr.isObjectLike(obj) && !!obj[prop];
}
function $79c07301d857e59e$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($79c07301d857e59e$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $79c07301d857e59e$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $79c07301d857e59e$var$getUrlFromResource(resource),
            method: $79c07301d857e59e$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            $cUgOr.isRequest(resource) && $79c07301d857e59e$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $79c07301d857e59e$var$getUrlFromResource(arg),
        method: $79c07301d857e59e$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $79c07301d857e59e$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($cUgOr.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}
module.exports.addFetchEndInstrumentationHandler = $79c07301d857e59e$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $79c07301d857e59e$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $79c07301d857e59e$var$parseFetchArgs;

});
parcelRegister("2AGy2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $cqs9v = parcelRequire("cqs9v");
const $1e2ff2b42bb2c1f5$var$WINDOW = $cqs9v.GLOBAL_OBJ;
function $1e2ff2b42bb2c1f5$var$supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $1e2ff2b42bb2c1f5$var$supportsDOMError() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $1e2ff2b42bb2c1f5$var$supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $1e2ff2b42bb2c1f5$var$supportsHistory() {
    return "history" in $1e2ff2b42bb2c1f5$var$WINDOW && !!$1e2ff2b42bb2c1f5$var$WINDOW.history;
}
const $1e2ff2b42bb2c1f5$var$supportsFetch = $1e2ff2b42bb2c1f5$var$_isFetchSupported;
function $1e2ff2b42bb2c1f5$var$_isFetchSupported() {
    if (!("fetch" in $1e2ff2b42bb2c1f5$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $1e2ff2b42bb2c1f5$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $1e2ff2b42bb2c1f5$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$1e2ff2b42bb2c1f5$var$_isFetchSupported()) return false;
    if ($1e2ff2b42bb2c1f5$var$isNativeFunction($1e2ff2b42bb2c1f5$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $1e2ff2b42bb2c1f5$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $1e2ff2b42bb2c1f5$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $1e2ff2b42bb2c1f5$var$supportsReportingObserver() {
    return "ReportingObserver" in $1e2ff2b42bb2c1f5$var$WINDOW;
}
function $1e2ff2b42bb2c1f5$var$supportsReferrerPolicy() {
    if (!$1e2ff2b42bb2c1f5$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $1e2ff2b42bb2c1f5$var$isNativeFunction;
module.exports.supportsDOMError = $1e2ff2b42bb2c1f5$var$supportsDOMError;
module.exports.supportsDOMException = $1e2ff2b42bb2c1f5$var$supportsDOMException;
module.exports.supportsErrorEvent = $1e2ff2b42bb2c1f5$var$supportsErrorEvent;
module.exports.supportsFetch = $1e2ff2b42bb2c1f5$var$supportsFetch;
module.exports.supportsHistory = $1e2ff2b42bb2c1f5$var$supportsHistory;
module.exports.supportsNativeFetch = $1e2ff2b42bb2c1f5$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $1e2ff2b42bb2c1f5$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $1e2ff2b42bb2c1f5$var$supportsReportingObserver;

});


parcelRegister("dRLB0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $a1852521ba1d10d2$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== "function") return;
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, "default", {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $a1852521ba1d10d2$var$replaceExports;

});

parcelRegister("jFOY1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $e52961ade961520f$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $e52961ade961520f$var$LRUMap;

});

parcelRegister("48AmV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $30341ed51c34bbe7$var$escapeStringForRegex(regexString) {
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
module.exports.escapeStringForRegex = $30341ed51c34bbe7$var$escapeStringForRegex;

});

parcelRegister("01r7k", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");

var $cqs9v = parcelRequire("cqs9v");
const $00452108504bca55$var$WINDOW = $cqs9v.GLOBAL_OBJ;
const $00452108504bca55$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $00452108504bca55$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $00452108504bca55$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $00452108504bca55$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $00452108504bca55$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($00452108504bca55$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $cUgOr.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $00452108504bca55$var$getLocationHref() {
    try {
        return $00452108504bca55$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $00452108504bca55$var$getComponentName(elem, maxTraverseHeight = 5) {
    if (!$00452108504bca55$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $00452108504bca55$var$getComponentName;
module.exports.getLocationHref = $00452108504bca55$var$getLocationHref;
module.exports.htmlTreeAsString = $00452108504bca55$var$htmlTreeAsString;

});


parcelRegister("hJFhm", function(module, exports) {
module.exports = $parcel$import("9OUCt").then(()=>parcelRequire('1Cg2t'));

});

parcelRegister("hFtGY", function(module, exports) {
module.exports = $parcel$import("62s5p").then(()=>parcelRequire('1i3lF'));

});

var $d07d301e30941d7a$exports = {};
$parcel$extendImportMap({
    "9OUCt": "rapidoc-min.1cc45d44.js",
    "62s5p": "charts.39570bf4.js"
});

var $be7ebd92b118fa32$exports = {};
!function(n) {
    "use strict";
    function e(n, e, r) {
        return r.a = n, r.f = e, r;
    }
    function F2(n) {
        return e(2, n, function(e) {
            return function(r) {
                return n(e, r);
            };
        });
    }
    function F3(n) {
        return e(3, n, function(e) {
            return function(r) {
                return function(t) {
                    return n(e, r, t);
                };
            };
        });
    }
    function F4(n) {
        return e(4, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return n(e, r, t, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return e(5, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return n(e, r, t, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return e(6, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(e, r, t, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return e(7, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return n(e, r, t, u, a, i, c);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return e(8, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return n(e, r, t, u, a, i, c, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return e(9, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return n(e, r, t, u, a, i, c, o, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, e, r) {
        return 2 === n.a ? n.f(e, r) : n(e)(r);
    }
    function A3(n, e, r, t) {
        return 3 === n.a ? n.f(e, r, t) : n(e)(r)(t);
    }
    function A4(n, e, r, t, u) {
        return 4 === n.a ? n.f(e, r, t, u) : n(e)(r)(t)(u);
    }
    function A5(n, e, r, t, u, a) {
        return 5 === n.a ? n.f(e, r, t, u, a) : n(e)(r)(t)(u)(a);
    }
    function A6(n, e, r, t, u, a, i) {
        return 6 === n.a ? n.f(e, r, t, u, a, i) : n(e)(r)(t)(u)(a)(i);
    }
    function A7(n, e, r, t, u, a, i, c) {
        return 7 === n.a ? n.f(e, r, t, u, a, i, c) : n(e)(r)(t)(u)(a)(i)(c);
    }
    var r = F3(function(n, e, r) {
        for(var t = Array(n), u = 0; n > u; u++)t[u] = r(e + u);
        return t;
    }), t = F2(function(n, e) {
        for(var r = Array(n), t = 0; n > t && e.b; t++)r[t] = e.a, e = e.b;
        return r.length = t, v(r, e);
    }), u = F2(function(n, e) {
        return e[n];
    }), a = F3(function(n, e, r) {
        for(var t = r.length, u = 0; t > u; u++)e = A2(n, r[u], e);
        return e;
    }), i = F3(function(n, e, r) {
        for(var t = r.length - 1; t >= 0; t--)e = A2(n, r[t], e);
        return e;
    }), c = F2(function(n, e) {
        for(var r = e.length, t = Array(r), u = 0; r > u; u++)t[u] = n(e[u]);
        return t;
    }), o = F3(function(n, e, r) {
        for(var t = r.length, u = Array(t), a = 0; t > a; a++)u[a] = A2(n, e + a, r[a]);
        return u;
    });
    function f(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function s(n, e) {
        for(var r, t = [], u = l(n, e, 0, t); u && (r = t.pop()); u = l(r.a, r.b, 0, t));
        return u;
    }
    function l(n, e, r, t) {
        if (n === e) return !0;
        if ("object" != typeof n || null === n || null === e) return "function" == typeof n && f(5), !1;
        if (r > 100) return t.push(v(n, e)), !0;
        for(var u in 0 > n.$ && (n = Gr(n), e = Gr(e)), n)if (!l(n[u], e[u], r + 1, t)) return !1;
        return !0;
    }
    var d = F2(s), b = F2(function(n, e) {
        return !s(n, e);
    });
    function m(n, e, r) {
        if ("object" != typeof n) return n === e ? 0 : e > n ? -1 : 1;
        if (void 0 === n.$) return (r = m(n.a, e.a)) || (r = m(n.b, e.b)) ? r : m(n.c, e.c);
        for(; n.b && e.b && !(r = m(n.a, e.a)); n = n.b, e = e.b);
        return r || (n.b ? 1 : e.b ? -1 : 0);
    }
    var p = F2(function(n, e) {
        var r = m(n, e);
        return 0 > r ? Jr : r ? Vr : Xr;
    });
    function v(n, e) {
        return {
            a: n,
            b: e
        };
    }
    function g(n, e, r) {
        return {
            a: n,
            b: e,
            c: r
        };
    }
    function h(n) {
        return n;
    }
    function $(n, e) {
        var r = {};
        for(var t in n)r[t] = n[t];
        for(var t in e)r[t] = e[t];
        return r;
    }
    var x = F2(k);
    function k(n, e) {
        if ("string" == typeof n) return n + e;
        if (!n.b) return e;
        var r = y(n.a, e);
        n = n.b;
        for(var t = r; n.b; n = n.b)t = t.b = y(n.a, e);
        return r;
    }
    var j = {
        $: 0
    };
    function y(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }
    var w = F2(y);
    function A(n) {
        for(var e = j, r = n.length; r--;)e = y(n[r], e);
        return e;
    }
    function T(n) {
        for(var e = []; n.b; n = n.b)e.push(n.a);
        return e;
    }
    var E = F3(function(n, e, r) {
        for(var t = []; e.b && r.b; e = e.b, r = r.b)t.push(A2(n, e.a, r.a));
        return A(t);
    }), C = F4(function(n, e, r, t) {
        for(var u = []; e.b && r.b && t.b; e = e.b, r = r.b, t = t.b)u.push(A3(n, e.a, r.a, t.a));
        return A(u);
    }), I = F2(function(n, e) {
        return A(T(e).sort(function(e, r) {
            return m(n(e), n(r));
        }));
    }), S = F2(function(n, e) {
        return A(T(e).sort(function(e, r) {
            var t = A2(n, e, r);
            return t === Xr ? 0 : t === Jr ? -1 : 1;
        }));
    }), O = F2(function(n, e) {
        return n + e;
    }), L = F2(function(n, e) {
        return n * e;
    }), P = F2(Math.pow), q = F2(function(n, e) {
        var r = e % n;
        return 0 === n ? f(11) : r > 0 && 0 > n || 0 > r && n > 0 ? r + n : r;
    }), N = Math.ceil, _ = Math.floor, z = Math.round, U = Math.log, M = isNaN, D = F2(function(n, e) {
        return n + e;
    }), R = F2(function(n, e) {
        return n + e;
    }), F = F2(function(n, e) {
        for(var r = [], t = e.length, u = 0; t > u;){
            var a = e[u], i = e.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += e[u], u++), n(h(a)) && r.push(a);
        }
        return r.join("");
    }), H = F3(function(n, e, r) {
        for(var t = r.length, u = 0; t > u;){
            var a = r[u], i = r.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += r[u], u++), e = A2(n, h(a), e);
        }
        return e;
    }), G = F3(function(n, e, r) {
        for(var t = r.length; t--;){
            var u = r[t], a = r.charCodeAt(t);
            56320 > a || a > 57343 || (u = r[--t] + u), e = A2(n, h(u), e);
        }
        return e;
    }), X = F2(function(n, e) {
        return e.split(n);
    }), V = F2(function(n, e) {
        return e.join(n);
    }), J = F3(function(n, e, r) {
        return r.slice(n, e);
    }), Y = F2(function(n, e) {
        for(var r = e.length; r--;){
            var t = e[r], u = e.charCodeAt(r);
            if (56320 > u || u > 57343 || (t = e[--r] + t), !n(h(t))) return !1;
        }
        return !0;
    }), W = F2(function(n, e) {
        return e.indexOf(n) > -1;
    }), K = F2(function(n, e) {
        return 0 === e.indexOf(n);
    }), B = F2(function(n, e) {
        return e.length >= n.length && e.lastIndexOf(n) === e.length - n.length;
    }), Q = F2(function(n, e) {
        var r = n.length;
        if (1 > r) return j;
        for(var t = 0, u = []; (t = e.indexOf(n, t)) > -1;)u.push(t), t += r;
        return A(u);
    });
    function Z(n) {
        return n + "";
    }
    function nn(n) {
        return {
            $: 2,
            b: n
        };
    }
    var en = nn(function(n) {
        return "number" != typeof n ? $n("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Qr(n) : !isFinite(n) || n % 1 ? $n("an INT", n) : Qr(n);
    }), rn = nn(function(n) {
        return "boolean" == typeof n ? Qr(n) : $n("a BOOL", n);
    }), tn = nn(function(n) {
        return "number" == typeof n ? Qr(n) : $n("a FLOAT", n);
    }), un = nn(function(n) {
        return Qr(n);
    }), an = nn(function(n) {
        return "string" == typeof n ? Qr(n) : n instanceof String ? Qr(n + "") : $n("a STRING", n);
    }), cn = F2(function(n, e) {
        return {
            $: 6,
            d: n,
            b: e
        };
    });
    function on(n, e) {
        return {
            $: 9,
            f: n,
            g: e
        };
    }
    var fn = F2(function(n, e) {
        return {
            $: 10,
            b: e,
            h: n
        };
    }), sn = F2(function(n, e) {
        return on(n, [
            e
        ]);
    }), ln = F3(function(n, e, r) {
        return on(n, [
            e,
            r
        ]);
    }), dn = F4(function(n, e, r, t) {
        return on(n, [
            e,
            r,
            t
        ]);
    }), bn = F2(function(n, e) {
        try {
            return pn(n, JSON.parse(e));
        } catch (n) {
            return Yr(A2(Wr, "This is not valid JSON! " + n.message, e));
        }
    }), mn = F2(function(n, e) {
        return pn(n, e);
    });
    function pn(n, e) {
        switch(n.$){
            case 2:
                return n.b(e);
            case 5:
                return null === e ? Qr(n.c) : $n("null", e);
            case 3:
                return gn(e) ? vn(n.b, e, A) : $n("a LIST", e);
            case 4:
                return gn(e) ? vn(n.b, e, hn) : $n("an ARRAY", e);
            case 6:
                var r = n.d;
                if ("object" != typeof e || null === e || !(r in e)) return $n("an OBJECT with a field named `" + r + "`", e);
                var t = pn(n.b, e[r]);
                return Kt(t) ? t : Yr(A2(Kr, r, t.a));
            case 7:
                var u = n.e;
                return gn(e) ? e.length > u ? (t = pn(n.b, e[u]), Kt(t) ? t : Yr(A2(Br, u, t.a))) : $n("a LONGER array. Need index " + u + " but only see " + e.length + " entries", e) : $n("an ARRAY", e);
            case 8:
                if ("object" != typeof e || null === e || gn(e)) return $n("an OBJECT", e);
                var a = j;
                for(var i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
                    if (t = pn(n.b, e[i]), !Kt(t)) return Yr(A2(Kr, i, t.a));
                    a = y(v(i, t.a), a);
                }
                return Qr(xt(a));
            case 9:
                for(var c = n.f, o = n.g, f = 0; o.length > f; f++){
                    if (t = pn(o[f], e), !Kt(t)) return t;
                    c = c(t.a);
                }
                return Qr(c);
            case 10:
                return t = pn(n.b, e), Kt(t) ? pn(n.h(t.a), e) : t;
            case 11:
                for(var s = j, l = n.g; l.b; l = l.b){
                    if (t = pn(l.a, e), Kt(t)) return t;
                    s = y(t.a, s);
                }
                return Yr(Zr(xt(s)));
            case 1:
                return Yr(A2(Wr, n.a, e));
            case 0:
                return Qr(n.a);
        }
    }
    function vn(n, e, r) {
        for(var t = e.length, u = Array(t), a = 0; t > a; a++){
            var i = pn(n, e[a]);
            if (!Kt(i)) return Yr(A2(Br, a, i.a));
            u[a] = i.a;
        }
        return Qr(r(u));
    }
    function gn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function hn(n) {
        return A2(Wt, n.length, function(e) {
            return n[e];
        });
    }
    function $n(n, e) {
        return Yr(A2(Wr, "Expecting " + n, e));
    }
    function xn(n, e) {
        if (n === e) return !0;
        if (n.$ !== e.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === e.a;
            case 2:
                return n.b === e.b;
            case 5:
                return n.c === e.c;
            case 3:
            case 4:
            case 8:
                return xn(n.b, e.b);
            case 6:
                return n.d === e.d && xn(n.b, e.b);
            case 7:
                return n.e === e.e && xn(n.b, e.b);
            case 9:
                return n.f === e.f && kn(n.g, e.g);
            case 10:
                return n.h === e.h && xn(n.b, e.b);
            case 11:
                return kn(n.g, e.g);
        }
    }
    function kn(n, e) {
        var r = n.length;
        if (r !== e.length) return !1;
        for(var t = 0; r > t; t++)if (!xn(n[t], e[t])) return !1;
        return !0;
    }
    var jn = F2(function(n, e) {
        return JSON.stringify(e, null, n) + "";
    });
    function yn(n) {
        return n;
    }
    function wn(n) {
        return n;
    }
    var An = F3(function(n, e, r) {
        return "toJSON" === n && "function" == typeof e || (r[n] = e), r;
    });
    function Tn(n) {
        return F2(function(e, r) {
            return r.push(n(e)), r;
        });
    }
    function En(n) {
        return {
            $: 0,
            a: n
        };
    }
    function Cn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var In = F2(function(n, e) {
        return {
            $: 3,
            b: n,
            d: e
        };
    }), Sn = F2(function(n, e) {
        return {
            $: 4,
            b: n,
            d: e
        };
    }), On = 0;
    function Ln(n) {
        var e = {
            $: 0,
            e: On++,
            f: n,
            g: null,
            h: []
        };
        return Un(e), e;
    }
    function Pn(n) {
        return Cn(function(e) {
            e(En(Ln(n)));
        });
    }
    function qn(n, e) {
        n.h.push(e), Un(n);
    }
    var Nn = F2(function(n, e) {
        return Cn(function(r) {
            qn(n, e), r(En(0));
        });
    }), _n = !1, zn = [];
    function Un(n) {
        if (zn.push(n), !_n) {
            for(_n = !0; n = zn.shift();)Mn(n);
            _n = !1;
        }
    }
    function Mn(n) {
        for(; n.f;){
            var e = n.f.$;
            if (0 === e || 1 === e) {
                for(; n.g && n.g.$ !== e;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === e) return void (n.f.c = n.f.b(function(e) {
                    n.f = e, Un(n);
                }));
                if (5 === e) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === e ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function Dn(n) {
        return Cn(function(e) {
            var r = setTimeout(function() {
                e(En(0));
            }, n);
            return function() {
                clearTimeout(r);
            };
        });
    }
    var Rn = {};
    function Fn(n, e, r, t, u) {
        return {
            b: n,
            c: e,
            d: r,
            e: t,
            f: u
        };
    }
    function Hn(n, e) {
        var r = {
            g: e,
            h: void 0
        }, t = n.c, u = n.d, a = n.e, i = n.f;
        function c(n) {
            return A2(In, c, {
                $: 5,
                b: function(e) {
                    var c = e.a;
                    return 0 === e.$ ? A3(u, r, c, n) : a && i ? A4(t, r, c.i, c.j, n) : A3(t, r, a ? c.i : c.j, n);
                }
            });
        }
        return r.h = Ln(A2(In, c, n.b));
    }
    var Gn = F2(function(n, e) {
        return Cn(function(r) {
            n.g(e), r(En(0));
        });
    }), Xn = F2(function(n, e) {
        return A2(Nn, n.h, {
            $: 0,
            a: e
        });
    });
    function Vn(n) {
        return function(e) {
            return {
                $: 1,
                k: n,
                l: e
            };
        };
    }
    function Jn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Yn = F2(function(n, e) {
        return {
            $: 3,
            n: n,
            o: e
        };
    }), Wn = [], Kn = !1;
    function Bn(n, e, r) {
        if (Wn.push({
            p: n,
            q: e,
            r: r
        }), !Kn) {
            Kn = !0;
            for(var t; t = Wn.shift();)Qn(t.p, t.q, t.r);
            Kn = !1;
        }
    }
    function Qn(n, e, r) {
        var t = {};
        for(var u in Zn(!0, e, t, null), Zn(!1, r, t, null), n)qn(n[u], {
            $: "fx",
            a: t[u] || {
                i: j,
                j: j
            }
        });
    }
    function Zn(n, e, r, t) {
        switch(e.$){
            case 1:
                var u = e.k, a = function(n, e, r, t) {
                    function u(n) {
                        for(var e = r; e; e = e.t)n = e.s(n);
                        return n;
                    }
                    return A2(n ? Rn[e].e : Rn[e].f, u, t);
                }(n, u, t, e.l);
                return void (r[u] = function(n, e, r) {
                    return r = r || {
                        i: j,
                        j: j
                    }, n ? r.i = y(e, r.i) : r.j = y(e, r.j), r;
                }(n, a, r[u]));
            case 2:
                for(var i = e.m; i.b; i = i.b)Zn(n, i.a, r, t);
                return;
            case 3:
                return void Zn(n, e.o, r, {
                    s: e.n,
                    t: t
                });
        }
    }
    function ne(n) {
        Rn[n] && f(3);
    }
    function ee(n, e) {
        return ne(n), Rn[n] = {
            e: re,
            u: e,
            a: te
        }, Vn(n);
    }
    var re = F2(function(n, e) {
        return e;
    });
    function te(n) {
        var e = [], r = Rn[n].u, t = Dn(0);
        return Rn[n].b = t, Rn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = e, i = wn(r(u.a)), c = 0; a.length > c; c++)a[c](i);
            return t;
        }), {
            subscribe: function(n) {
                e.push(n);
            },
            unsubscribe: function(n) {
                var r = (e = e.slice()).indexOf(n);
                0 > r || e.splice(r, 1);
            }
        };
    }
    var ue, ae = F2(function(n, e) {
        return function(r) {
            return n(e(r));
        };
    });
    var ie = "undefined" != typeof document ? document : {};
    function ce(n, e) {
        n.appendChild(e);
    }
    function oe(n) {
        return {
            $: 0,
            a: n
        };
    }
    var fe = F2(function(n, e) {
        return F2(function(r, t) {
            for(var u = [], a = 0; t.b; t = t.b){
                var i = t.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: e,
                d: Ee(r),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0), se = F2(function(n, e) {
        return F2(function(r, t) {
            for(var u = [], a = 0; t.b; t = t.b){
                var i = t.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: e,
                d: Ee(r),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0), le = F2(function(n, e) {
        return {
            $: 4,
            j: n,
            k: e,
            b: 1 + (e.b || 0)
        };
    });
    var de = F4(function(n, e, r, t) {
        return {
            $: 5,
            l: [
                n,
                e,
                r,
                t
            ],
            m: function() {
                return A3(n, e, r, t);
            },
            k: void 0
        };
    }), be = F2(function(n, e) {
        return {
            $: "a0",
            n: n,
            o: e
        };
    }), me = F2(function(n, e) {
        return {
            $: "a1",
            n: n,
            o: e
        };
    }), pe = F2(function(n, e) {
        return {
            $: "a2",
            n: n,
            o: e
        };
    }), ve = F2(function(n, e) {
        return {
            $: "a3",
            n: n,
            o: e
        };
    }), ge = /^script$/i, he = /^(on|formAction$)/i, $e = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, xe = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function ke(n) {
        return ge.test(n) ? "p" : n;
    }
    function je(n) {
        return xe.test(n) ? "" : n;
    }
    var ye, we = F2(function(n, e) {
        return "a0" === e.$ ? A2(be, e.n, function(n, e) {
            var r = eu(e);
            return {
                $: e.$,
                a: r ? A3(Zt, 3 > r ? Ae : Te, nu(n), e.a) : A2(Qt, n, e.a)
            };
        }(n, e.o)) : e;
    }), Ae = F2(function(n, e) {
        return v(n(e.a), e.b);
    }), Te = F2(function(n, e) {
        return {
            eh: n(e.eh),
            hg: e.hg,
            g2: e.g2
        };
    });
    function Ee(n) {
        for(var e = {}; n.b; n = n.b){
            var r = n.a, t = r.$, u = r.n, a = r.o;
            if ("a2" !== t) {
                var i = e[t] || (e[t] = {});
                "a3" === t && "class" === u ? Ce(i, u, a) : i[u] = a;
            } else "className" === u ? Ce(e, u, wn(a)) : e[u] = wn(a);
        }
        return e;
    }
    function Ce(n, e, r) {
        var t = n[e];
        n[e] = t ? t + " " + r : r;
    }
    function Ie(n, e) {
        var r = n.$;
        if (5 === r) return Ie(n.k || (n.k = n.m()), e);
        if (0 === r) return ie.createTextNode(n.a);
        if (4 === r) {
            for(var t = n.k, u = n.j; 4 === t.$;)"object" != typeof u ? u = [
                u,
                t.j
            ] : u.push(t.j), t = t.k;
            var a = {
                j: u,
                p: e
            };
            return (i = Ie(t, a)).elm_event_node_ref = a, i;
        }
        if (3 === r) return Se(i = n.h(n.g), e, n.d), i;
        var i = n.f ? ie.createElementNS(n.f, n.c) : ie.createElement(n.c);
        ue && "a" == n.c && i.addEventListener("click", ue(i)), Se(i, e, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)ce(i, Ie(1 === r ? c[o] : c[o].b, e));
        return i;
    }
    function Se(n, e, r) {
        for(var t in r){
            var u = r[t];
            "a1" === t ? Oe(n, u) : "a0" === t ? qe(n, e, u) : "a3" === t ? Le(n, u) : "a4" === t ? Pe(n, u) : ("value" !== t && "checked" !== t || n[t] !== u) && (n[t] = u);
        }
    }
    function Oe(n, e) {
        var r = n.style;
        for(var t in e)r[t] = e[t];
    }
    function Le(n, e) {
        for(var r in e){
            var t = e[r];
            void 0 !== t ? n.setAttribute(r, t) : n.removeAttribute(r);
        }
    }
    function Pe(n, e) {
        for(var r in e){
            var t = e[r], u = t.f, a = t.o;
            void 0 !== a ? n.setAttributeNS(u, r, a) : n.removeAttributeNS(u, r);
        }
    }
    function qe(n, e, r) {
        var t = n.elmFs || (n.elmFs = {});
        for(var u in r){
            var a = r[u], i = t[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = Ne(e, a), n.addEventListener(u, i, ye && {
                    passive: 2 > eu(a)
                }), t[u] = i;
            } else n.removeEventListener(u, i), t[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                ye = !0;
            }
        }));
    } catch (n) {}
    function Ne(n, e) {
        function r(e) {
            var t = r.q, u = pn(t.a, e);
            if (Kt(u)) {
                for(var a, i = eu(t), c = u.a, o = i ? 3 > i ? c.a : c.eh : c, f = 1 == i ? c.b : 3 == i && c.hg, s = (f && e.stopPropagation(), (2 == i ? c.b : 3 == i && c.g2) && e.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) o = a(o);
                    else for(var l = a.length; l--;)o = a[l](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return r.q = e, r;
    }
    function _e(n, e) {
        return n.$ == e.$ && xn(n.a, e.a);
    }
    function ze(n, e, r, t) {
        var u = {
            $: e,
            r: r,
            s: t,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Ue(n, e, r, t) {
        if (n !== e) {
            var u = n.$, a = e.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void ze(r, 0, t, e);
                e = function(n) {
                    for(var e = n.e, r = e.length, t = Array(r), u = 0; r > u; u++)t[u] = e[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: t,
                        f: n.f,
                        b: n.b
                    };
                }(e), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, c = e.l, o = i.length, f = o === c.length; f && o--;)f = i[o] === c[o];
                    if (f) return void (e.k = n.k);
                    e.k = e.m();
                    var s = [];
                    return Ue(n.k, e.k, s, 0), void (s.length > 0 && ze(r, 1, t, s));
                case 4:
                    for(var l = n.j, d = e.j, b = !1, m = n.k; 4 === m.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        m.j
                    ] : l.push(m.j), m = m.k;
                    for(var p = e.k; 4 === p.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        p.j
                    ] : d.push(p.j), p = p.k;
                    return b && l.length !== d.length ? void ze(r, 0, t, e) : ((b ? function(n, e) {
                        for(var r = 0; n.length > r; r++)if (n[r] !== e[r]) return !1;
                        return !0;
                    }(l, d) : l === d) || ze(r, 2, t, d), void Ue(m, p, r, t + 1));
                case 0:
                    return void (n.a !== e.a && ze(r, 3, t, e.a));
                case 1:
                    return void Me(n, e, r, t, Re);
                case 2:
                    return void Me(n, e, r, t, Fe);
                case 3:
                    if (n.h !== e.h) return void ze(r, 0, t, e);
                    var v = De(n.d, e.d);
                    v && ze(r, 4, t, v);
                    var g = e.i(n.g, e.g);
                    return void (g && ze(r, 5, t, g));
            }
        }
    }
    function Me(n, e, r, t, u) {
        if (n.c === e.c && n.f === e.f) {
            var a = De(n.d, e.d);
            a && ze(r, 4, t, a), u(n, e, r, t);
        } else ze(r, 0, t, e);
    }
    function De(n, e, r) {
        var t;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in e) {
                var a = n[u], i = e[u];
                a === i && "value" !== u && "checked" !== u || "a0" === r && _e(a, i) || ((t = t || {})[u] = i);
            } else (t = t || {})[u] = r ? "a1" === r ? "" : "a0" === r || "a3" === r ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var c = De(n[u], e[u] || {}, u);
            c && ((t = t || {})[u] = c);
        }
        for(var o in e)o in n || ((t = t || {})[o] = e[o]);
        return t;
    }
    function Re(n, e, r, t) {
        var u = n.e, a = e.e, i = u.length, c = a.length;
        i > c ? ze(r, 6, t, {
            v: c,
            i: i - c
        }) : c > i && ze(r, 7, t, {
            v: i,
            e: a
        });
        for(var o = c > i ? i : c, f = 0; o > f; f++){
            var s = u[f];
            Ue(s, a[f], r, ++t), t += s.b || 0;
        }
    }
    function Fe(n, e, r, t) {
        for(var u = [], a = {}, i = [], c = n.e, o = e.e, f = c.length, s = o.length, l = 0, d = 0, b = t; f > l && s > d;){
            var m = (T = c[l]).a, p = (E = o[d]).a, v = T.b, g = E.b, h = void 0, $ = void 0;
            if (m !== p) {
                var x = c[l + 1], k = o[d + 1];
                if (x) {
                    var j = x.a, y = x.b;
                    $ = p === j;
                }
                if (k) {
                    var w = k.a, A = k.b;
                    h = m === w;
                }
                if (h && $) Ue(v, A, u, ++b), Ge(a, u, m, g, d, i), b += v.b || 0, Xe(a, u, m, y, ++b), b += y.b || 0, l += 2, d += 2;
                else if (h) b++, Ge(a, u, p, g, d, i), Ue(v, A, u, b), b += v.b || 0, l += 1, d += 2;
                else if ($) Xe(a, u, m, v, ++b), b += v.b || 0, Ue(y, g, u, ++b), b += y.b || 0, l += 2, d += 1;
                else {
                    if (!x || j !== w) break;
                    Xe(a, u, m, v, ++b), Ge(a, u, p, g, d, i), b += v.b || 0, Ue(y, A, u, ++b), b += y.b || 0, l += 2, d += 2;
                }
            } else Ue(v, g, u, ++b), b += v.b || 0, l++, d++;
        }
        for(; f > l;){
            var T;
            b++, Xe(a, u, (T = c[l]).a, v = T.b, b), b += v.b || 0, l++;
        }
        for(; s > d;){
            var E, C = C || [];
            Ge(a, u, (E = o[d]).a, E.b, void 0, C), d++;
        }
        (u.length > 0 || i.length > 0 || C) && ze(r, 8, t, {
            w: u,
            x: i,
            y: C
        });
    }
    var He = "_elmW6BL";
    function Ge(n, e, r, t, u, a) {
        var i = n[r];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: t,
                r: u,
                s: void 0
            }
        }), void (n[r] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var c = [];
            return Ue(i.z, t, c, i.r), i.r = u, void (i.s.s = {
                w: c,
                A: i
            });
        }
        Ge(n, e, r + He, t, u, a);
    }
    function Xe(n, e, r, t, u) {
        var a = n[r];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Ue(t, a.z, i, u), void ze(e, 9, u, {
                    w: i,
                    A: a
                });
            }
            Xe(n, e, r + He, t, u);
        } else {
            var c = ze(e, 9, u, void 0);
            n[r] = {
                c: 1,
                z: t,
                r: u,
                s: c
            };
        }
    }
    function Ve(n, e, r, t) {
        Je(n, e, r, 0, 0, e.b, t);
    }
    function Je(n, e, r, t, u, a, i) {
        for(var c = r[t], o = c.r; o === u;){
            var f = c.$;
            if (1 === f) Ve(n, e.k, c.s, i);
            else if (8 === f) c.t = n, c.u = i, (s = c.s.w).length > 0 && Je(n, e, s, 0, u, a, i);
            else if (9 === f) {
                c.t = n, c.u = i;
                var s, l = c.s;
                l && (l.A.s = n, (s = l.w).length > 0 && Je(n, e, s, 0, u, a, i));
            } else c.t = n, c.u = i;
            if (!(c = r[++t]) || (o = c.r) > a) return t;
        }
        var d = e.$;
        if (4 === d) {
            for(var b = e.k; 4 === b.$;)b = b.k;
            return Je(n, b, r, t, u + 1, a, n.elm_event_node_ref);
        }
        for(var m = e.e, p = n.childNodes, v = 0; m.length > v; v++){
            u++;
            var g = 1 === d ? m[v] : m[v].b, h = u + (g.b || 0);
            if (!(u > o || o > h || (c = r[t = Je(p[v], g, r, t, u, h, i)]) && (o = c.r) <= a)) return t;
            u = h;
        }
        return t;
    }
    function Ye(n, e) {
        for(var r = 0; e.length > r; r++){
            var t = e[r], u = t.t, a = We(u, t);
            u === n && (n = a);
        }
        return n;
    }
    function We(n, e) {
        switch(e.$){
            case 0:
                return function(n, e, r) {
                    var t = n.parentNode, u = Ie(e, r);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), t && u !== n && t.replaceChild(u, n), u;
                }(n, e.s, e.u);
            case 4:
                return Se(n, e.u, e.s), n;
            case 3:
                return n.replaceData(0, n.length, e.s), n;
            case 1:
                return Ye(n, e.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = e.s : n.elm_event_node_ref = {
                    j: e.s,
                    p: e.u
                }, n;
            case 6:
                for(var r = e.s, t = 0; r.i > t; t++)n.removeChild(n.childNodes[r.v]);
                return n;
            case 7:
                for(var u = (r = e.s).e, a = n.childNodes[t = r.v]; u.length > t; t++)n.insertBefore(Ie(u[t], e.u), a);
                return n;
            case 9:
                if (!(r = e.s)) return n.parentNode.removeChild(n), n;
                var i = r.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Ye(n, r.w), n;
            case 8:
                return function(n, e) {
                    var r = e.s, t = function(n, e) {
                        if (n) {
                            for(var r = ie.createDocumentFragment(), t = 0; n.length > t; t++){
                                var u = n[t].A;
                                ce(r, 2 === u.c ? u.s : Ie(u.z, e.u));
                            }
                            return r;
                        }
                    }(r.y, e);
                    n = Ye(n, r.w);
                    for(var u = r.x, a = 0; u.length > a; a++){
                        var i = u[a], c = i.A, o = 2 === c.c ? c.s : Ie(c.z, e.u);
                        n.insertBefore(o, n.childNodes[i.r]);
                    }
                    return t && ce(n, t), n;
                }(n, e);
            case 5:
                return e.s(n);
            default:
                f(10);
        }
    }
    function Ke(n) {
        if (3 === n.nodeType) return oe(n.textContent);
        if (1 !== n.nodeType) return oe("");
        for(var e = j, r = n.attributes, t = r.length; t--;){
            var u = r[t];
            e = y(A2(ve, u.name, u.value), e);
        }
        var a = n.tagName.toLowerCase(), i = j, c = n.childNodes;
        for(t = c.length; t--;)i = y(Ke(c[t]), i);
        return A3(fe, a, e, i);
    }
    var Be = F4(function(n, e, r, t) {
        return function(n, e, r, t, u, a) {
            var i = A2(mn, n, e ? e.flags : void 0);
            Kt(i) || f(2);
            var c = {}, o = r(i.a), s = o.a, l = a(b, s), d = function(n, e) {
                var r;
                for(var t in Rn){
                    var u = Rn[t];
                    u.a && ((r = r || {})[t] = u.a(t, e)), n[t] = Hn(u, e);
                }
                return r;
            }(c, b);
            function b(n, e) {
                var r = A2(t, n, s);
                l(s = r.a, e), Bn(c, r.b, u(s));
            }
            return Bn(c, o.b, u(s)), d ? {
                ports: d
            } : {};
        }(e, t, n.mr, n.ph, n.oO, function(e, r) {
            var t = n.hd && n.hd(e), u = n.pM, a = ie.title, i = ie.body, c = Ke(i);
            return function(n, e) {
                e(n);
                var r = 0;
                function t() {
                    r = 1 === r ? 0 : (Qe(t), e(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (e(n), 2 === r && (r = 1)) : (0 === r && Qe(t), r = 2);
                };
            }(r, function(n) {
                ue = t;
                var r = u(n), o = fe("body")(j)(r.kO), f = function(n, e) {
                    var r = [];
                    return Ue(n, e, r, 0), r;
                }(c, o);
                i = function(n, e, r, t) {
                    return 0 === r.length ? n : (Ve(n, e, r, t), Ye(n, r));
                }(i, c, f, e), c = o, ue = 0, a !== r.eG && (ie.title = a = r.eG);
            });
        });
    }), Qe = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function Ze() {
        return hu(ie.location.href).a || f(1);
    }
    var nr = F2(function(n, e) {
        return A2(Lu, $u, Cn(function() {
            history.pushState({}, "", e), n();
        }));
    }), er = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, rr = "undefined" != typeof document ? document : er, tr = "undefined" != typeof window ? window : er, ur = F3(function(n, e, r) {
        return Pn(Cn(function() {
            function t(n) {
                Ln(r(n));
            }
            return n.addEventListener(e, t, ye && {
                passive: !0
            }), function() {
                n.removeEventListener(e, t);
            };
        }));
    }), ar = F2(function(n, e) {
        var r = pn(n, e);
        return Kt(r) ? zr(r.a) : Ur;
    });
    var ir = F2(function(n, e) {
        return function(n, e) {
            return Cn(function(r) {
                Qe(function() {
                    var t = document.getElementById(n);
                    r(t ? En(e(t)) : {
                        $: 1,
                        a: tu(n)
                    });
                });
            });
        }(e, function(e) {
            return e[n](), 0;
        });
    }), cr = F3(function(n, e, r) {
        return Cn(function(t) {
            function u(n) {
                t(e(r.lU.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(Ju);
            }), a.addEventListener("timeout", function() {
                u(Ku);
            }), a.addEventListener("load", function() {
                u(function(n, e) {
                    return A2(e.status >= 200 && 300 > e.status ? Vu : Gu, function(n) {
                        return {
                            a6: n.responseURL,
                            j4: n.status,
                            oI: n.statusText,
                            mc: or(n.getAllResponseHeaders())
                        };
                    }(e), n(e.response));
                }(r.lU.b, a));
            }), Zu(r.pc) && function(n, e, r) {
                e.upload.addEventListener("progress", function(t) {
                    e.c || Ln(A2(na, n, v(r, Wu({
                        oy: t.loaded,
                        oE: t.total
                    }))));
                }), e.addEventListener("progress", function(t) {
                    e.c || Ln(A2(na, n, v(r, Yu({
                        n_: t.loaded,
                        oE: t.lengthComputable ? zr(t.total) : Ur
                    }))));
                });
            }(n, a, r.pc.a);
            try {
                a.open(r.m1, r.a6, !0);
            } catch (n) {
                return u(Xu(r.a6));
            }
            return function(n, e) {
                for(var r = e.mc; r.b; r = r.b)n.setRequestHeader(r.a.a, r.a.b);
                n.timeout = e.oY.a || 0, n.responseType = e.lU.d, n.withCredentials = e.kB;
            }(a, r), r.kO.a && a.setRequestHeader("Content-Type", r.kO.a), a.send(r.kO.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function or(n) {
        if (!n) return Qu;
        for(var e = Qu, r = n.split("\r\n"), t = r.length; t--;){
            var u = r[t], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), c = u.substring(a + 2);
                e = A3(ma, i, function(n) {
                    return zr(Zu(n) ? c + ", " + n.a : c);
                }, e);
            }
        }
        return e;
    }
    var fr, sr = F3(function(n, e, r) {
        return {
            $: 0,
            d: n,
            b: e,
            a: r
        };
    }), lr = F2(function(n, e) {
        return {
            $: 0,
            d: e.d,
            b: e.b,
            a: function(r) {
                return n(e.a(r));
            }
        };
    }), dr = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), br = F2(function(n, e) {
        return Cn(function() {
            var r = setInterval(function() {
                Ln(e);
            }, n);
            return function() {
                clearInterval(r);
            };
        });
    }), mr = F2(function(n, e) {
        var r = "g";
        n.m8 && (r += "m"), n.kS && (r += "i");
        try {
            return zr(RegExp(e, r));
        } catch (n) {
            return Ur;
        }
    }), pr = F2(function(n, e) {
        return null !== e.match(n);
    }), vr = F3(function(n, e, r) {
        for(var t, u = [], a = 0, i = r, c = e.lastIndex, o = -1; a++ < n && (t = e.exec(i)) && o != e.lastIndex;){
            for(var f = t.length - 1, s = Array(f); f > 0;){
                var l = t[f];
                s[--f] = l ? zr(l) : Ur;
            }
            u.push(A4(ws, t[0], t.index, a, A(s))), o = e.lastIndex;
        }
        return e.lastIndex = c, A(u);
    }), gr = F4(function(n, e, r, t) {
        var u = 0;
        return t.replace(e, function(e) {
            if (u++ >= n) return e;
            for(var t = arguments.length - 3, a = Array(t); t > 0;){
                var i = arguments[t];
                a[--t] = i ? zr(i) : Ur;
            }
            return r(A4(ws, e, arguments[arguments.length - 2], u, A(a)));
        });
    }), hr = F3(function(n, e, r) {
        for(var t = r, u = [], a = e.lastIndex, i = e.lastIndex; n--;){
            var c = e.exec(t);
            if (!c) break;
            u.push(t.slice(a, c.index)), a = e.lastIndex;
        }
        return u.push(t.slice(a)), e.lastIndex = i, A(u);
    }), $r = 1 / 0, xr = F5(function(n, e, r, t, u) {
        for(var a = n.length, i = u.length >= e + a, c = 0; i && a > c;){
            var o = u.charCodeAt(e);
            i = n[c++] === u[e++] && (10 === o ? (r++, t = 1) : (t++, 55296 == (63488 & o) ? n[c++] === u[e++] : 1));
        }
        return g(i ? e : -1, r, t);
    }), kr = F3(function(n, e, r) {
        return r.length > e ? 55296 == (63488 & r.charCodeAt(e)) ? n(r.substr(e, 2)) ? e + 2 : -1 : n(r[e]) ? "\n" === r[e] ? -2 : e + 1 : -1 : -1;
    }), jr = F5(function(n, e, r, t, u) {
        for(var a = u.indexOf(n, e), i = 0 > a ? u.length : a + n.length; i > e;){
            var c = u.charCodeAt(e++);
            10 === c ? (t = 1, r++) : (t++, 55296 == (63488 & c) && e++);
        }
        return g(a, r, t);
    });
    nn(function(n) {
        return "undefined" != typeof File && n instanceof File ? Qr(n) : $n("a FILE", n);
    });
    var yr = F3(function(n, e, r) {
        return Cn(function() {
            var t = new Blob([
                r
            ], {
                type: e
            });
            if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(t, n);
            else {
                var u = fr || (fr = document.createElement("a")), a = URL.createObjectURL(t);
                u.href = a, u.download = n, function(n) {
                    if ("function" == typeof MouseEvent) n.dispatchEvent(new MouseEvent("click"));
                    else {
                        var e = document.createEvent("MouseEvents");
                        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), document.body.appendChild(n), n.dispatchEvent(e), document.body.removeChild(n);
                    }
                }(u), URL.revokeObjectURL(a);
            }
        });
    });
    function wr(n) {
        return n.byteLength;
    }
    var Ar = F3(function(n, e, r) {
        return n.setInt8(e, r), e + 1;
    }), Tr = F4(function(n, e, r, t) {
        return n.setInt16(e, r, t), e + 2;
    }), Er = F4(function(n, e, r, t) {
        return n.setInt32(e, r, t), e + 4;
    }), Cr = F3(function(n, e, r) {
        return n.setUint8(e, r), e + 1;
    }), Ir = F4(function(n, e, r, t) {
        return n.setUint16(e, r, t), e + 2;
    }), Sr = F4(function(n, e, r, t) {
        return n.setUint32(e, r, t), e + 4;
    }), Or = F4(function(n, e, r, t) {
        return n.setFloat32(e, r, t), e + 4;
    }), Lr = F4(function(n, e, r, t) {
        return n.setFloat64(e, r, t), e + 8;
    }), Pr = F3(function(n, e, r) {
        for(var t = 0, u = r.byteLength, a = u - 4; a >= t; t += 4)n.setUint32(e + t, r.getUint32(t));
        for(; u > t; t++)n.setUint8(e + t, r.getUint8(t));
        return e + u;
    }), qr = F3(function(n, e, r) {
        for(var t = 0; r.length > t; t++){
            var u = r.charCodeAt(t);
            e += 128 > u ? (n.setUint8(e, u), 1) : 2048 > u ? (n.setUint16(e, 49280 | (u >>> 6 & 31) << 8 | 63 & u), 2) : 55296 > u || u > 56319 ? (n.setUint16(e, 57472 | (u >>> 12 & 15) << 8 | u >>> 6 & 63), n.setUint8(e + 2, 128 | 63 & u), 3) : (u = 1024 * (u - 55296) + r.charCodeAt(++t) - 56320 + 65536, n.setUint32(e, 4034953344 | (u >>> 18 & 7) << 24 | (u >>> 12 & 63) << 16 | (u >>> 6 & 63) << 8 | 63 & u), 4);
        }
        return e;
    }), Nr = F2(function(n, e) {
        try {
            return zr(A2(n, e, 0).b);
        } catch (n) {
            return Ur;
        }
    }), _r = F3(function(n, e, r) {
        for(var t = "", u = r + n; u > r;){
            var a = e.getUint8(r++);
            t += 128 > a ? String.fromCharCode(a) : 192 == (224 & a) ? String.fromCharCode((31 & a) << 6 | 63 & e.getUint8(r++)) : 224 == (240 & a) ? String.fromCharCode((15 & a) << 12 | (63 & e.getUint8(r++)) << 6 | 63 & e.getUint8(r++)) : (a = ((7 & a) << 18 | (63 & e.getUint8(r++)) << 12 | (63 & e.getUint8(r++)) << 6 | 63 & e.getUint8(r++)) - 65536, String.fromCharCode(Math.floor(a / 1024) + 55296, a % 1024 + 56320));
        }
        return v(r, t);
    }), zr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ur = {
        $: 1
    }, Mr = w, Dr = i, Rr = F3(function(n, e, r) {
        var t = r.c, u = r.d, a = F2(function(e, r) {
            return A3(Dr, e.$ ? n : a, r, e.a);
        });
        return A3(Dr, a, A3(Dr, n, e, u), t);
    }), Fr = function(n) {
        return A3(Rr, Mr, j, n);
    }, Hr = F3(function(n, e, r) {
        for(;;){
            if (-2 === r.$) return e;
            var t = r.d, u = n, a = A3(n, r.b, r.c, A3(Hr, n, e, r.e));
            n = u, e = a, r = t;
        }
    }), Gr = function(n) {
        return A3(Hr, F3(function(n, e, r) {
            return A2(Mr, v(n, e), r);
        }), j, n);
    }, Xr = 1, Vr = 2, Jr = 0, Yr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wr = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), Kr = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Br = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Qr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Zr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, nt = O, et = Y, rt = x, tt = jn, ut = Z, at = F2(function(n, e) {
        return A2(V, n, T(e));
    }), it = F2(function(n, e) {
        return A(A2(X, n, e));
    }), ct = function(n) {
        return A2(at, "\n    ", A2(it, "\n", n));
    }, ot = F3(function(n, e, r) {
        for(;;){
            if (!r.b) return e;
            var t = r.b, u = n, a = A2(n, r.a, e);
            n = u, e = a, r = t;
        }
    }), ft = function(n) {
        return A3(ot, F2(function(n, e) {
            return e + 1;
        }), 0, n);
    }, st = E, lt = F3(function(n, e, r) {
        for(;;){
            if (m(n, e) >= 1) return r;
            var t = n, u = e - 1, a = A2(Mr, e, r);
            n = t, e = u, r = a;
        }
    }), dt = F2(function(n, e) {
        return A3(lt, n, e, j);
    }), bt = F2(function(n, e) {
        return A3(st, n, A2(dt, 0, ft(e) - 1), e);
    }), mt = function(n) {
        var e = n.charCodeAt(0);
        return 55296 > e || e > 56319 ? e : 1024 * (e - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, pt = function(n) {
        var e = mt(n);
        return e >= 97 && 122 >= e;
    }, vt = function(n) {
        var e = mt(n);
        return 90 >= e && e >= 65;
    }, gt = function(n) {
        return pt(n) || vt(n);
    }, ht = function(n) {
        var e = mt(n);
        return 57 >= e && e >= 48;
    }, $t = function(n) {
        return pt(n) || vt(n) || ht(n);
    }, xt = function(n) {
        return A3(ot, Mr, j, n);
    }, kt = function(n) {
        var e = n.charCodeAt(0);
        return isNaN(e) ? Ur : zr(55296 > e || e > 56319 ? v(n[0], n.slice(1)) : v(n[0] + n[1], n.slice(2)));
    }, jt = F2(function(n, e) {
        return "\n\n(" + ut(n + 1) + ") " + ct(yt(e));
    }), yt = function(n) {
        return A2(wt, n, j);
    }, wt = F2(function(n, e) {
        n: for(;;)switch(n.$){
            case 0:
                var r = n.a, t = n.b, u = function() {
                    var n = kt(r);
                    if (1 === n.$) return !1;
                    var e = n.a, t = e.b;
                    return gt(e.a) && A2(et, $t, t);
                }();
                n = t, e = A2(Mr, u ? "." + r : "['" + r + "']", e);
                continue n;
            case 1:
                t = n.b;
                var a = "[" + ut(n.a) + "]";
                n = t, e = A2(Mr, a, e);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var c = function() {
                            return e.b ? "The Json.Decode.oneOf at json" + A2(at, "", xt(e)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + ut(ft(i)) + " ways:";
                        return A2(at, "\n\n", A2(Mr, c, A2(bt, jt, i)));
                    }
                    n = t = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return e.b ? " at json" + A2(at, "", xt(e)) : "!";
                }();
            default:
                var o = n.a, f = n.b;
                return (c = function() {
                    return e.b ? "Problem with the value at json" + A2(at, "", xt(e)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (ct(A2(tt, 4, f)) + "\n\n") + o;
        }
    }), At = 32, Tt = F4(function(n, e, r, t) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r,
            d: t
        };
    }), Et = [], Ct = N, It = F2(function(n, e) {
        return U(e) / U(n);
    }), St = function(n) {
        return n;
    }, Ot = Ct(A2(It, 2, At)), Lt = A4(Tt, 0, Ot, Et, Et), Pt = r, qt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Nt = F2(function(n, e) {
        return n(e);
    }), _t = F2(function(n, e) {
        return e(n);
    }), zt = d, Ut = _, Mt = function(n) {
        return n.length;
    }, Dt = F2(function(n, e) {
        return m(n, e) > 0 ? n : e;
    }), Rt = L, Ft = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ht = t, Gt = F2(function(n, e) {
        for(;;){
            var r = A2(Ht, At, n), t = r.b, u = A2(Mr, Ft(r.a), e);
            if (!t.b) return xt(u);
            n = t, e = u;
        }
    }), Xt = function(n) {
        return n.a;
    }, Vt = F2(function(n, e) {
        for(;;){
            var r = Ct(e / At);
            if (1 === r) return A2(Ht, At, n).a;
            n = A2(Gt, n, j), e = r;
        }
    }), Jt = F2(function(n, e) {
        if (e.N) {
            var r = e.N * At, t = Ut(A2(It, At, r - 1)), u = n ? xt(e.V) : e.V, a = A2(Vt, u, e.N);
            return A4(Tt, Mt(e.R) + r, A2(Dt, 5, t * Ot), a, e.R);
        }
        return A4(Tt, Mt(e.R), Ot, Et, e.R);
    }), Yt = F5(function(n, e, r, t, u) {
        for(;;){
            if (0 > e) return A2(Jt, !1, {
                V: t,
                N: r / At | 0,
                R: u
            });
            var a = qt(A3(Pt, At, e, n));
            e -= At, t = A2(Mr, a, t);
        }
    }), Wt = F2(function(n, e) {
        if (n > 0) {
            var r = n % At;
            return A5(Yt, e, n - r - At, n, j, A3(Pt, r, n - r, e));
        }
        return Lt;
    }), Kt = function(n) {
        return !n.$;
    }, Bt = fn, Qt = sn, Zt = ln, nu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eu = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, ru = function(n) {
        return n;
    }, tu = ru, uu = F6(function(n, e, r, t, u, a) {
        return {
            iD: a,
            iN: e,
            jj: t,
            nO: r,
            nU: n,
            g5: u
        };
    }), au = W, iu = function(n) {
        return n.length;
    }, cu = J, ou = F2(function(n, e) {
        return 1 > n ? e : A3(cu, n, iu(e), e);
    }), fu = Q, su = function(n) {
        return "" === n;
    }, lu = F2(function(n, e) {
        return 1 > n ? "" : A3(cu, 0, n, e);
    }), du = function(n) {
        for(var e = 0, r = n.charCodeAt(0), t = 43 == r || 45 == r ? 1 : 0, u = t; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return Ur;
            e = 10 * e + a - 48;
        }
        return u == t ? Ur : zr(45 == r ? -e : e);
    }, bu = F5(function(n, e, r, t, u) {
        if (su(u) || A2(au, "@", u)) return Ur;
        var a = A2(fu, ":", u);
        if (a.b) {
            if (a.b.b) return Ur;
            var i = a.a, c = du(A2(ou, i + 1, u));
            if (1 === c.$) return Ur;
            var o = c;
            return zr(A6(uu, n, A2(lu, i, u), o, e, r, t));
        }
        return zr(A6(uu, n, u, Ur, e, r, t));
    }), mu = F4(function(n, e, r, t) {
        if (su(t)) return Ur;
        var u = A2(fu, "/", t);
        if (u.b) {
            var a = u.a;
            return A5(bu, n, A2(ou, a, t), e, r, A2(lu, a, t));
        }
        return A5(bu, n, "/", e, r, t);
    }), pu = F3(function(n, e, r) {
        if (su(r)) return Ur;
        var t = A2(fu, "?", r);
        if (t.b) {
            var u = t.a;
            return A4(mu, n, zr(A2(ou, u + 1, r)), e, A2(lu, u, r));
        }
        return A4(mu, n, Ur, e, r);
    }), vu = F2(function(n, e) {
        if (su(e)) return Ur;
        var r = A2(fu, "#", e);
        if (r.b) {
            var t = r.a;
            return A3(pu, n, zr(A2(ou, t + 1, e)), A2(lu, t, e));
        }
        return A3(pu, n, Ur, e);
    }), gu = K, hu = function(n) {
        return A2(gu, "http://", n) ? A2(vu, 0, A2(ou, 7, n)) : A2(gu, "https://", n) ? A2(vu, 1, A2(ou, 8, n)) : Ur;
    }, $u = function() {
        for(;;);
    }, xu = En, ku = xu(0), ju = F4(function(n, e, r, t) {
        if (t.b) {
            var u = t.a, a = t.b;
            if (a.b) {
                var i = a.a, c = a.b;
                if (c.b) {
                    var o = c.a, f = c.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, o, A2(n, f.a, r > 500 ? A3(ot, n, e, xt(s)) : A4(ju, n, e, r + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, o, e)));
                }
                return A2(n, u, A2(n, i, e));
            }
            return A2(n, u, e);
        }
        return e;
    }), yu = F3(function(n, e, r) {
        return A4(ju, n, e, 0, r);
    }), wu = F2(function(n, e) {
        return A3(yu, F2(function(e, r) {
            return A2(Mr, n(e), r);
        }), j, e);
    }), Au = In, Tu = F2(function(n, e) {
        return A2(Au, function(e) {
            return xu(n(e));
        }, e);
    }), Eu = F3(function(n, e, r) {
        return A2(Au, function(e) {
            return A2(Au, function(r) {
                return xu(A2(n, e, r));
            }, r);
        }, e);
    }), Cu = function(n) {
        return A3(yu, Eu(Mr), xu(j), n);
    }, Iu = Gn, Su = F2(function(n, e) {
        var r = e;
        return Pn(A2(Au, Iu(n), r));
    });
    Rn.Task = Fn(ku, F3(function(n, e) {
        return A2(Tu, function() {
            return 0;
        }, Cu(A2(wu, Su(n), e)));
    }), F3(function() {
        return xu(0);
    }), F2(function(n, e) {
        return A2(Tu, n, e);
    }));
    var Ou = Vn("Task"), Lu = F2(function(n, e) {
        return Ou(A2(Tu, n, e));
    }), Pu = rn, qu = cn, Nu = {
        $: 1
    }, _u = function(n) {
        return {
            $: 18,
            a: n
        };
    }, zu = null, Uu = ee("appStarted", function() {
        return zu;
    }), Mu = Jn, Du = {
        $: 0
    }, Ru = {
        dS: Du,
        dT: Du,
        e0: Du,
        bT: Du,
        c_: Du,
        fi: Du,
        d6: Du,
        d7: Du,
        d8: Du,
        d9: Du,
        ep: Du,
        eq: Du,
        er: Du,
        W: Du,
        eB: Du,
        eC: Du,
        eD: Du,
        eE: Du,
        af: Du,
        eU: Du,
        eV: Du,
        eW: Du
    }, Fu = F3(function(n, e, r) {
        return {
            $: 11,
            a: n,
            b: e,
            c: r
        };
    }), Hu = F3(function(n, e, r) {
        return e(n(r));
    }), Gu = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), Xu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Vu = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), Ju = {
        $: 2
    }, Yu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ku = {
        $: 1
    }, Bu = {
        $: -2
    }, Qu = Bu, Zu = function(n) {
        return !n.$;
    }, na = Xn, ea = p, ra = F2(function(n, e) {
        n: for(;;){
            if (-2 === e.$) return Ur;
            var r = e.c, t = e.d, u = e.e;
            switch(A2(ea, n, e.b)){
                case 0:
                    e = t;
                    continue n;
                case 1:
                    return zr(r);
                default:
                    e = u;
                    continue n;
            }
        }
    }), ta = F5(function(n, e, r, t, u) {
        return {
            $: -1,
            a: n,
            b: e,
            c: r,
            d: t,
            e: u
        };
    }), ua = F5(function(n, e, r, t, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== t.$ || t.a || -1 !== t.d.$ || t.d.a) return A5(ta, n, e, r, t, u);
            var a = t.d;
            return i = t.e, A5(ta, 0, t.b, t.c, A5(ta, 1, a.b, a.c, a.d, a.e), A5(ta, 1, e, r, i, u));
        }
        var i, c = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== t.$ || t.a ? A5(ta, n, c, o, A5(ta, 0, e, r, t, f), s) : A5(ta, 0, e, r, A5(ta, 1, t.b, t.c, t.d, i = t.e), A5(ta, 1, c, o, f, s));
    }), aa = F3(function(n, e, r) {
        if (-2 === r.$) return A5(ta, 0, n, e, Bu, Bu);
        var t = r.a, u = r.b, a = r.c, i = r.d, c = r.e;
        switch(A2(ea, n, u)){
            case 0:
                return A5(ua, t, u, a, A3(aa, n, e, i), c);
            case 1:
                return A5(ta, t, u, e, i, c);
            default:
                return A5(ua, t, u, a, i, A3(aa, n, e, c));
        }
    }), ia = F3(function(n, e, r) {
        var t = A3(aa, n, e, r);
        return -1 !== t.$ || t.a ? t : A5(ta, 1, t.b, t.c, t.d, t.e);
    }), ca = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var e = n.d, r = n.e;
                return i = r.b, c = r.c, t = r.d, s = r.e, A5(ta, 1, n.b, n.c, A5(ta, 0, e.b, e.c, e.d, e.e), A5(ta, 0, i, c, t, s));
            }
            var t, u = n.d, a = n.e, i = a.b, c = a.c, o = (t = a.d).d, f = t.e, s = a.e;
            return A5(ta, 0, t.b, t.c, A5(ta, 1, n.b, n.c, A5(ta, 0, u.b, u.c, u.d, u.e), o), A5(ta, 1, i, c, f, s));
        }
        return n;
    }, oa = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var e = n.d, r = n.e;
                return f = r.b, s = r.c, l = r.d, d = r.e, A5(ta, 1, t = n.b, u = n.c, A5(ta, 0, e.b, e.c, e.d, c = e.e), A5(ta, 0, f, s, l, d));
            }
            var t = n.b, u = n.c, a = n.d, i = a.d, c = a.e, o = n.e, f = o.b, s = o.c, l = o.d, d = o.e;
            return A5(ta, 0, a.b, a.c, A5(ta, 1, i.b, i.c, i.d, i.e), A5(ta, 1, t, u, c, A5(ta, 0, f, s, l, d)));
        }
        return n;
    }, fa = F7(function(n, e, r, t, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return oa(e);
                        break n;
                    }
                    return oa(e);
                }
                break n;
            }
            return e;
        }
        return A5(ta, r, a.b, a.c, a.d, A5(ta, 0, t, u, a.e, i));
    }), sa = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var e = n.a, r = n.b, t = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var c = ca(n);
                    if (-1 === c.$) {
                        var o = c.e;
                        return A5(ua, c.a, c.b, c.c, sa(c.d), o);
                    }
                    return Bu;
                }
                return A5(ta, e, r, t, sa(u), i);
            }
            return A5(ta, e, r, t, sa(u), i);
        }
        return Bu;
    }, la = F2(function(n, e) {
        if (-2 === e.$) return Bu;
        var r = e.a, t = e.b, u = e.c, a = e.d, i = e.e;
        if (0 > m(n, t)) {
            if (-1 === a.$ && 1 === a.a) {
                var c = a.d;
                if (-1 !== c.$ || c.a) {
                    var o = ca(e);
                    if (-1 === o.$) {
                        var f = o.e;
                        return A5(ua, o.a, o.b, o.c, A2(la, n, o.d), f);
                    }
                    return Bu;
                }
                return A5(ta, r, t, u, A2(la, n, a), i);
            }
            return A5(ta, r, t, u, A2(la, n, a), i);
        }
        return A2(da, n, A7(fa, n, e, r, t, u, a, i));
    }), da = F2(function(n, e) {
        if (-1 === e.$) {
            var r = e.a, t = e.b, u = e.c, a = e.d, i = e.e;
            if (s(n, t)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(i);
                return -1 === c.$ ? A5(ua, r, c.b, c.c, a, sa(i)) : Bu;
            }
            return A5(ua, r, t, u, a, A2(la, n, i));
        }
        return Bu;
    }), ba = F2(function(n, e) {
        var r = A2(la, n, e);
        return -1 !== r.$ || r.a ? r : A5(ta, 1, r.b, r.c, r.d, r.e);
    }), ma = F3(function(n, e, r) {
        var t = e(A2(ra, n, r));
        return t.$ ? A2(ba, n, r) : A3(ia, n, t.a, r);
    }), pa = F2(function(n, e) {
        return A3(sr, "", ru, A2(Hu, e, n));
    }), va = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ga = {
        $: 2
    }, ha = {
        $: 1
    }, $a = F2(function(n, e) {
        return e.$ ? Yr(n(e.a)) : Qr(e.a);
    }), xa = F2(function(n, e) {
        switch(e.$){
            case 0:
                return Yr({
                    $: 0,
                    a: e.a
                });
            case 1:
                return Yr(ha);
            case 2:
                return Yr(ga);
            case 3:
                return Yr(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(e.a.j4));
            default:
                return A2($a, va, n(e.b));
        }
    }), ka = function(n) {
        return A2(pa, n, xa(Qr));
    }, ja = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ya = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wa = function(n) {
        return 1 === n.$ ? ja(n.a) : ya(n.a);
    }, Aa = {
        $: 0
    }, Ta = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ea = F2(function(n, e) {
        return {
            jG: n,
            j7: e
        };
    }), Ca = xu(A2(Ea, Qu, j)), Ia = function(n) {
        return Cn(function(e) {
            var r = n.f;
            2 === r.$ && r.c && r.c(), n.f = null, e(En(0));
        });
    }, Sa = Pn, Oa = F3(function(n, e, r) {
        n: for(;;){
            if (e.b) {
                var t = e.a, u = e.b;
                if (t.$) {
                    var a = t.a;
                    return A2(Au, function(e) {
                        var t = a.pc;
                        return A3(Oa, n, u, 1 === t.$ ? r : A3(ia, t.a, e, r));
                    }, Sa(A3(cr, n, Iu(n), a)));
                }
                var i = t.a, c = A2(ra, i, r);
                if (1 === c.$) {
                    e = u;
                    continue n;
                }
                return A2(Au, function() {
                    return A3(Oa, n, u, A2(ba, i, r));
                }, Ia(c.a));
            }
            return xu(r);
        }
    }), La = F4(function(n, e, r, t) {
        return A2(Au, function(n) {
            return xu(A2(Ea, n, r));
        }, A3(Oa, n, e, t.jG));
    }), Pa = F3(function(n, e, r) {
        var t = n(e);
        return t.$ ? r : A2(Mr, t.a, r);
    }), qa = F2(function(n, e) {
        return A3(yu, Pa(n), j, e);
    }), Na = F4(function(n, e, r, t) {
        var u = t.b;
        return s(e, t.a) ? zr(A2(Iu, n, u(r))) : Ur;
    }), _a = F3(function(n, e, r) {
        return A2(Au, function() {
            return xu(r);
        }, Cu(A2(qa, A3(Na, n, e.a, e.b), r.j7)));
    }), za = F2(function(n, e) {
        if (e.$) {
            var r = e.a;
            return Ta({
                kB: r.kB,
                kO: r.kO,
                lU: A2(lr, n, r.lU),
                mc: r.mc,
                m1: r.m1,
                oY: r.oY,
                pc: r.pc,
                a6: r.a6
            });
        }
        return {
            $: 0,
            a: e.a
        };
    }), Ua = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    });
    Rn.Http = Fn(Ca, La, _a, za, F2(function(n, e) {
        return A2(Ua, e.a, A2(Hu, e.b, n));
    }));
    var Ma = Vn("Http"), Da = (Vn("Http"), function(n) {
        return Ma(Ta({
            kB: !1,
            kO: n.kO,
            lU: n.lU,
            mc: n.mc,
            m1: n.m1,
            oY: n.oY,
            pc: n.pc,
            a6: n.a6
        }));
    }), Ra = function(n) {
        return Da({
            kO: Aa,
            lU: n.lU,
            mc: j,
            m1: "GET",
            oY: Ur,
            pc: Ur,
            a6: n.a6
        });
    }, Fa = {
        $: 1
    }, Ha = F2(function(n, e) {
        switch(e.$){
            case 3:
                return ya(n(e.a));
            case 1:
                return Fa;
            case 0:
                return Du;
            default:
                return ja(e.a);
        }
    }), Ga = ru, Xa = F2(function(n, e) {
        return Ra({
            lU: ka(A2(Hu, wa, A2(Hu, Ha(Ga), e))),
            a6: n
        });
    }), Va = ee("loadJeDonneMonAvis", function() {
        return zu;
    }), Ja = F2(function(n, e) {
        return {
            gB: n,
            fR: e
        };
    }), Ya = Zt(_t), Wa = F3(function(n, e, r) {
        return A2(Ya, A2(qu, n, e), r);
    }), Ka = Zt(_t), Ba = F2(function(n, e) {
        return e.$ ? Ur : n(e.a);
    }), Qa = function(n) {
        return {
            $: 5,
            c: n
        };
    }, Za = function(n) {
        return {
            $: 11,
            g: n
        };
    }, ni = mn, ei = un, ri = F2(function(n, e) {
        return A2(Bt, function(r) {
            return A2(ni, A2(qu, n, ei), r).$ ? nu(Ur) : A2(Qt, zr, A2(qu, n, e));
        }, ei);
    }), ti = F2(function(n, e) {
        return A2(Qt, Ba(ru), A2(ri, n, function(n) {
            return Za(A([
                Qa(Ur),
                A2(Qt, zr, n)
            ]));
        }(e)));
    }), ui = F2(function(n, e) {
        return Ka(A2(ti, n, e));
    }), ai = an, ii = A3(ui, "tag", ai, A3(Wa, "hash", ai, nu(Ja))), ci = bn, oi = F2(function(n, e) {
        return A2(pa, n, xa(function(n) {
            return A2($a, yt, A2(ci, e, n));
        }));
    }), fi = function(n) {
        return Ma(Ta({
            kB: !0,
            kO: n.kO,
            lU: n.lU,
            mc: n.mc,
            m1: n.m1,
            oY: n.oY,
            pc: n.pc,
            a6: n.a6
        }));
    }, si = function(n) {
        return n.dr ? fi : Da;
    }, li = F6(function(n, e, r, t, u, a) {
        return A2(si, e, {
            kO: a,
            lU: A2(oi, A2(Hu, wa, t), u),
            mc: e.mc,
            m1: n,
            oY: e.oY,
            pc: e.pc,
            a6: r
        });
    }), di = F4(function(n, e, r, t) {
        return A6(li, "GET", n, e, r, t, Aa);
    }), bi = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), mi = bi, pi = {
        mc: A([
            A2(mi, "Accept", "application/json")
        ]),
        dr: !1,
        oY: Ur,
        pc: Ur
    }, vi = di($(pi, {
        mc: A2(Mr, A2(mi, "Cache-Control", "no-store, must-revalidate, no-cache, max-age=0"), pi.mc)
    })), gi = function(n) {
        return A3(vi, "version.json", n, ii);
    }, hi = {
        e5: 0,
        bo: j
    }, $i = F3(function(n, e, r) {
        var t;
        return v({
            bz: Ru,
            bc: !1,
            c9: n,
            cn: !1,
            na: r,
            H: Nu,
            bp: hi,
            a6: e
        }, Mu(A([
            Uu(0),
            gi(_u),
            (t = {
                c9: n,
                na: r,
                a6: e
            }, Mu(A2(wu, function(n) {
                return A2(Xa, n.a, A2(Fu, t, n.b));
            }, A([
                v("/data/apparel/categories.json", F2(function(n, e) {
                    return $(e, {
                        e0: n
                    });
                })),
                v("/data/apparel/components.json", F2(function(n, e) {
                    return $(e, {
                        dS: n
                    });
                })),
                v("/data/apparel/examples.json", F2(function(n, e) {
                    return $(e, {
                        dT: n
                    });
                })),
                v("/data/countries.json", F2(function(n, e) {
                    return $(e, {
                        bT: n
                    });
                })),
                v("/data/impacts.json", F2(function(n, e) {
                    return $(e, {
                        c_: n
                    });
                })),
                v("/data/food2/components.json", F2(function(n, e) {
                    return $(e, {
                        fi: n
                    });
                })),
                v("/data/food2/categories.json", F2(function(n, e) {
                    return $(e, {
                        d7: n
                    });
                })),
                v("/data/food2/examples.json", F2(function(n, e) {
                    return $(e, {
                        d6: n
                    });
                })),
                v("/data/food/ingredients.json", F2(function(n, e) {
                    return $(e, {
                        d8: n
                    });
                })),
                v("/data/food/examples.json", F2(function(n, e) {
                    return $(e, {
                        d9: n
                    });
                })),
                v("/data/object/categories.json", F2(function(n, e) {
                    return $(e, {
                        er: n
                    });
                })),
                v("/data/object/components.json", F2(function(n, e) {
                    return $(e, {
                        ep: n
                    });
                })),
                v("/data/object/examples.json", F2(function(n, e) {
                    return $(e, {
                        eq: n
                    });
                })),
                v("/data/processes.json", F2(function(n, e) {
                    return $(e, {
                        W: n
                    });
                })),
                v("/data/textile/components.json", F2(function(n, e) {
                    return $(e, {
                        eB: n
                    });
                })),
                v("/data/textile/examples.json", F2(function(n, e) {
                    return $(e, {
                        eD: n
                    });
                })),
                v("/data/textile/materials.json", F2(function(n, e) {
                    return $(e, {
                        eC: n
                    });
                })),
                v("/data/textile/products.json", F2(function(n, e) {
                    return $(e, {
                        eE: n
                    });
                })),
                v("/data/transports.json", F2(function(n, e) {
                    return $(e, {
                        af: n
                    });
                })),
                v("/data/veli/categories.json", F2(function(n, e) {
                    return $(e, {
                        eW: n
                    });
                })),
                v("/data/veli/components.json", F2(function(n, e) {
                    return $(e, {
                        eU: n
                    });
                })),
                v("/data/veli/examples.json", F2(function(n, e) {
                    return $(e, {
                        eV: n
                    });
                }))
            ])))),
            Va(0)
        ])));
    }), xi = en, ki = {
        $: 3
    }, ji = function(n) {
        return {
            $: 7,
            a: n
        };
    }, yi = function(n) {
        return {
            $: 8,
            a: n
        };
    }, wi = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Ai = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Ti = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Ei = {
        $: 17
    }, Ci = Jn, Ii = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Si = F3(function(n, e, r) {
        return s(r, n) ? nu(e) : Ii(ut(r));
    }), Oi = F2(function(n, e) {
        return A2(Bt, A2(Si, n, e), A2(qu, "keyCode", xi));
    }), Li = function(n) {
        return A2(Oi, 27, n);
    }, Pi = Yn, qi = Ci(j), Ni = F3(function(n, e, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r
        };
    }), _i = F2(function(n, e) {
        return {
            jn: e,
            j7: n
        };
    }), zi = xu(A2(_i, j, Qu)), Ui = function(n) {
        return v(k(n.a ? "w_" : "d_", n.b), n);
    }, Mi = function(n) {
        return A3(ot, F2(function(n, e) {
            return A3(ia, n.a, n.b, e);
        }), Qu, n);
    }, Di = F3(function(n, e, r) {
        for(;;){
            if (-2 === r.$) return e;
            var t = r.e, u = n, a = A3(n, r.b, r.c, A3(Di, n, e, r.d));
            n = u, e = a, r = t;
        }
    }), Ri = F6(function(n, e, r, t, u, a) {
        var i = A3(Di, F3(function(t, u, a) {
            n: for(;;){
                var i = a.a, c = a.b;
                if (i.b) {
                    var o = i.a, f = o.a, s = o.b, l = i.b;
                    if (0 > m(f, t)) {
                        a = v(l, A3(n, f, s, c));
                        continue n;
                    }
                    return m(f, t) > 0 ? v(i, A3(r, t, u, c)) : v(l, A4(e, f, s, u, c));
                }
                return v(i, A3(r, t, u, c));
            }
        }), v(Gr(t), a), u), c = i.a, o = i.b;
        return A3(ot, F2(function(e, r) {
            return A3(n, e.a, e.b, r);
        }), o, c);
    }), Fi = F2(function(n, e) {
        return {
            d3: e,
            fn: n
        };
    }), Hi = F3(function(n, e, r) {
        return A2(Tu, function(n) {
            return v(e, n);
        }, A3(ur, r.a ? tr : rr, r.b, function(r) {
            return A2(na, n, A2(Fi, e, r));
        }));
    }), Gi = F2(function(n, e) {
        return A3(Di, ia, e, n);
    });
    Rn["Browser.Events"] = Fn(zi, F3(function(n, e, r) {
        var t = F3(function(e, r, t) {
            var u = t.c;
            return g(t.a, t.b, A2(Mr, A3(Hi, n, e, r), u));
        }), u = F3(function(n, e, r) {
            var t = r.b, u = r.c;
            return g(A2(Mr, e, r.a), t, u);
        }), a = F4(function(n, e, r, t) {
            var u = t.c;
            return g(t.a, A3(ia, n, e, t.b), u);
        }), i = A2(wu, Ui, e), c = A6(Ri, u, a, t, r.jn, Mi(i), g(j, Qu, j)), o = c.b, f = c.c;
        return A2(Au, function(n) {
            return xu(A2(_i, i, A2(Gi, o, Mi(n))));
        }, A2(Au, function() {
            return Cu(f);
        }, Cu(A2(wu, Ia, c.a))));
    }), F3(function(n, e, r) {
        var t = e.fn, u = e.d3, a = A2(qa, function(n) {
            var e = n.b.c;
            return s(n.a, t) ? A2(ar, e, u) : Ur;
        }, r.j7);
        return A2(Au, function() {
            return xu(r);
        }, Cu(A2(wu, Iu(n), a)));
    }), 0, F2(function(n, e) {
        return A3(Ni, e.a, e.b, A2(Qt, n, e.c));
    }));
    var Xi, Vi = Vn("Browser.Events"), Ji = F3(function(n, e, r) {
        return Vi(A3(Ni, n, e, r));
    }), Yi = A2(Ji, 0, "keydown"), Wi = F2(function(n) {
        return n;
    }), Ki = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Bi = F2(function(n, e) {
        return {
            W: e,
            j9: n
        };
    }), Qi = xu(A2(Bi, Qu, Qu)), Zi = F2(function(n, e) {
        var r = n.a, t = n.b, u = A2(ra, r, e);
        return A3(ia, r, 1 === u.$ ? A([
            t
        ]) : A2(Mr, t, u.a), e);
    }), nc = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), ec = br, rc = F3(function(n, e, r) {
        if (e.b) {
            var t = e.a, u = e.b, a = Sa(A2(ec, t, A2(na, n, t)));
            return A2(Au, function(e) {
                return A3(rc, n, u, A3(ia, t, e, r));
            }, a);
        }
        return xu(r);
    }), tc = F3(function(n, e, r) {
        var t = r.W, u = F3(function(n, e, r) {
            var t = r.c;
            return g(r.a, r.b, A2(Au, function() {
                return t;
            }, Ia(e)));
        }), a = A3(ot, Zi, Qu, e), i = A6(Ri, F3(function(n, e, r) {
            var t = r.b, u = r.c;
            return g(A2(Mr, n, r.a), t, u);
        }), F4(function(n, e, r, t) {
            var u = t.c;
            return g(t.a, A3(ia, n, r, t.b), u);
        }), u, a, t, g(j, Qu, xu(0))), c = i.a, o = i.b;
        return A2(Au, function(n) {
            return xu(A2(Bi, a, n));
        }, A2(Au, function() {
            return A3(rc, n, c, o);
        }, i.c));
    }), uc = ru, ac = (Xi = uc, Cn(function(n) {
        n(En(Xi(Date.now())));
    })), ic = F3(function(n, e, r) {
        var t = A2(ra, e, r.j9);
        if (1 === t.$) return xu(r);
        var u = t.a;
        return A2(Au, function() {
            return xu(r);
        }, A2(Au, function(e) {
            return Cu(A2(wu, function(r) {
                return A2(Iu, n, r(e));
            }, u));
        }, ac));
    }), cc = F3(function(n, e, r) {
        return n(e(r));
    });
    Rn.Time = Fn(Qi, tc, ic, 0, F2(function(n, e) {
        return A2(Ki, e.a, A2(cc, n, e.b));
    }));
    var oc, fc, sc, lc, dc, bc = Vn("Time"), mc = F2(function(n, e) {
        return bc(A2(Ki, n, e));
    }), pc = function(n) {
        return A2(Hu, Wi, mc(1e3 * n));
    }, vc = (oc = "storeChanged", fc = ai, ne(oc), Rn[oc] = {
        f: ae,
        u: fc,
        a: function(n, e) {
            var r = j, t = Rn[n].u, u = En(null);
            return Rn[n].b = u, Rn[n].c = F3(function(n, e) {
                return r = e, u;
            }), {
                send: function(n) {
                    var u = A2(mn, t, n);
                    Kt(u) || f(4);
                    for(var a = u.a, i = r; i.b; i = i.b)e(i.a(a));
                }
            };
        }
    }, Vn(oc)), gc = {
        $: 0
    }, hc = function(n) {
        n: for(;;)switch(n.$){
            case 0:
            case 4:
            case 6:
            case 7:
                if (n.b.$) break n;
                return !0;
            default:
                if (n.a.$) break n;
                return !0;
        }
        return !1;
    }, $c = function(n) {
        return hc(n.aA) ? Yi(Li(gc)) : qi;
    }, xc = {
        $: 5
    }, kc = function(n) {
        return {
            $: 32,
            a: n
        };
    }, jc = function(n) {
        return 5 === n.ad.$ ? qi : Yi(Li(kc(xc)));
    }, yc = function(n) {
        return {
            $: 37,
            a: n
        };
    }, wc = function(n) {
        var e = n.M;
        return e.b ? Yi(Li(yc(e.b))) : qi;
    }, Ac = {
        $: 5
    }, Tc = function(n) {
        return {
            $: 25,
            a: n
        };
    }, Ec = function(n) {
        return 5 === n.ad.$ ? qi : Yi(Li(Tc(Ac)));
    }, Cc = Mu(j), Ic = b, Sc = yn, Oc = ee("saveStore", Sc), Lc = yn, Pc = F2(function(n, e) {
        return e.$ ? Ur : zr(n(e.a));
    }), qc = function(n) {
        return A3(ot, F2(function(n, e) {
            return A3(An, n.a, n.b, e);
        }), {}, n);
    }, Nc = F2(function(n, e) {
        return e.$ ? n : e.a;
    }), _c = yn, zc = function(n) {
        return A2(at, "", n);
    }, Uc = q, Mc = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, Dc = F3(function(n, e, r) {
        n: for(;;){
            if (n > 0) {
                if (e.b) {
                    var t = e.a;
                    n -= 1, e = e.b, r = A2(Mr, t, r);
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Rc = F2(function(n, e) {
        return xt(A3(Dc, n, e, j));
    }), Fc = F3(function(n, e, r) {
        if (e > 0) {
            var t = v(e, r);
            n: for(;;){
                e: for(;;){
                    if (!t.b.b) return r;
                    if (!t.b.b.b) {
                        if (1 === t.a) break n;
                        break e;
                    }
                    switch(t.a){
                        case 1:
                            break n;
                        case 2:
                            var u = t.b;
                            return A([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (t.b.b.b.b) {
                                var a = t.b, i = a.b;
                                return A([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break e;
                        default:
                            if (t.b.b.b.b && t.b.b.b.b.b) {
                                var c = t.b, o = c.b, f = o.b, s = f.b, l = s.b;
                                return A2(Mr, c.a, A2(Mr, o.a, A2(Mr, f.a, A2(Mr, s.a, n > 1e3 ? A2(Rc, e - 4, l) : A3(Fc, n + 1, e - 4, l)))));
                            }
                            break e;
                    }
                }
                return r;
            }
            return A([
                t.b.a
            ]);
        }
        return j;
    }), Hc = F2(function(n, e) {
        return A3(Fc, 0, n, e);
    }), Gc = function(n) {
        return zc(A2(Hc, 3, A2(it, "", n)));
    }, Xc = F3(function(n, e, r) {
        var t = function() {
            switch(n){
                case 0:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "January";
                            case 1:
                                return "February";
                            case 2:
                                return "March";
                            case 3:
                                return "April";
                            case 4:
                                return "May";
                            case 5:
                                return "June";
                            case 6:
                                return "July";
                            case 7:
                                return "August";
                            case 8:
                                return "September";
                            case 9:
                                return "October";
                            case 10:
                                return "November";
                            default:
                                return "December";
                        }
                    }(r);
                case 1:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Janvier";
                            case 1:
                                return "F\xe9vrier";
                            case 2:
                                return "Mars";
                            case 3:
                                return "Avril";
                            case 4:
                                return "Mai";
                            case 5:
                                return "Juin";
                            case 6:
                                return "Juillet";
                            case 7:
                                return "Aout";
                            case 8:
                                return "Septembre";
                            case 9:
                                return "Octobre";
                            case 10:
                                return "Novembre";
                            default:
                                return "D\xe9cembre";
                        }
                    }(r);
                case 2:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Enero";
                            case 1:
                                return "Febrero";
                            case 2:
                                return "Marzo";
                            case 3:
                                return "Abril";
                            case 4:
                                return "Mayo";
                            case 5:
                                return "Junio";
                            case 6:
                                return "Julio";
                            case 7:
                                return "Agosto";
                            case 8:
                                return "Septiembre";
                            case 9:
                                return "Octubre";
                            case 10:
                                return "Noviembre";
                            default:
                                return "Diciembre";
                        }
                    }(r);
                case 3:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Januari";
                            case 1:
                                return "Februari";
                            case 2:
                                return "Maart";
                            case 3:
                                return "April";
                            case 4:
                                return "Mei";
                            case 5:
                                return "Juni";
                            case 6:
                                return "Juli";
                            case 7:
                                return "Augustus";
                            case 8:
                                return "September";
                            case 9:
                                return "Oktober";
                            case 10:
                                return "November";
                            default:
                                return "December";
                        }
                    }(r);
                case 4:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Tammikuu";
                            case 1:
                                return "Helmikuu";
                            case 2:
                                return "Maaliskuu";
                            case 3:
                                return "Huhtikuu";
                            case 4:
                                return "Toukokuu";
                            case 5:
                                return "Kes\xe4kuu";
                            case 6:
                                return "Hein\xe4kuu";
                            case 7:
                                return "Elokuu";
                            case 8:
                                return "Syyskuu";
                            case 9:
                                return "Lokakuu";
                            case 10:
                                return "Marraskuu";
                            default:
                                return "Joulukuu";
                        }
                    }(r);
                case 5:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2";
                            case 1:
                                return "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2";
                            case 2:
                                return "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2";
                            case 3:
                                return "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2";
                            case 4:
                                return "\u039C\u03AC\u03B9\u03BF\u03C2";
                            case 5:
                                return "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2";
                            case 6:
                                return "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2";
                            case 7:
                                return "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2";
                            case 8:
                                return "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2";
                            case 9:
                                return "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2";
                            case 10:
                                return "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2";
                            default:
                                return "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2";
                        }
                    }(r);
                case 6:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Gennaio";
                            case 1:
                                return "Febbraio";
                            case 2:
                                return "Marzo";
                            case 3:
                                return "Aprile";
                            case 4:
                                return "Maggio";
                            case 5:
                                return "Giugno";
                            case 6:
                                return "Luglio";
                            case 7:
                                return "Agosto";
                            case 8:
                                return "Settembre";
                            case 9:
                                return "Ottobre";
                            case 10:
                                return "Novembre";
                            default:
                                return "Dicembre";
                        }
                    }(r);
                case 7:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Januar";
                            case 1:
                                return "Februar";
                            case 2:
                                return "Mars";
                            case 3:
                                return "April";
                            case 4:
                                return "Mai";
                            case 5:
                                return "Juni";
                            case 6:
                                return "Juli";
                            case 7:
                                return "August";
                            case 8:
                                return "September";
                            case 9:
                                return "Oktober";
                            case 10:
                                return "November";
                            default:
                                return "Desember";
                        }
                    }(r);
                case 8:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Janeiro";
                            case 1:
                                return "Fevereiro";
                            case 2:
                                return "Mar\xe7o";
                            case 3:
                                return "Abril";
                            case 4:
                                return "Maio";
                            case 5:
                                return "Junho";
                            case 6:
                                return "Julho";
                            case 7:
                                return "Agosto";
                            case 8:
                                return "Setembro";
                            case 9:
                                return "Outubro";
                            case 10:
                                return "Novembro";
                            default:
                                return "Dezembro";
                        }
                    }(r);
                case 9:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Januari";
                            case 1:
                                return "Februari";
                            case 2:
                                return "Mars";
                            case 3:
                                return "April";
                            case 4:
                                return "Maj";
                            case 5:
                                return "Juni";
                            case 6:
                                return "Juli";
                            case 7:
                                return "Augusti";
                            case 8:
                                return "September";
                            case 9:
                                return "Oktober";
                            case 10:
                                return "November";
                            default:
                                return "December";
                        }
                    }(r);
                case 10:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Januar";
                            case 1:
                                return "Februar";
                            case 2:
                                return "M\xe4rz";
                            case 3:
                                return "April";
                            case 4:
                                return "Mai";
                            case 5:
                                return "Juni";
                            case 6:
                                return "Juli";
                            case 7:
                                return "August";
                            case 8:
                                return "September";
                            case 9:
                                return "Oktober";
                            case 10:
                                return "November";
                            default:
                                return "Dezember";
                        }
                    }(r);
                default:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "\u042F\u043D\u0432\u0430\u0440\u044C";
                            case 1:
                                return "\u0424\u0435\u0432\u0440\u0430\u043B\u044C";
                            case 2:
                                return "\u041C\u0430\u0440\u0442";
                            case 3:
                                return "\u0410\u043F\u0440\u0435\u043B\u044C";
                            case 4:
                                return "\u041C\u0430\u0439";
                            case 5:
                                return "\u0418\u044E\u043D\u044C";
                            case 6:
                                return "\u0418\u044E\u043B\u044C";
                            case 7:
                                return "\u0410\u0432\u0433\u0443\u0441\u0442";
                            case 8:
                                return "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C";
                            case 9:
                                return "\u041E\u043A\u0442\u044F\u0431\u0440\u044C";
                            case 10:
                                return "\u041D\u043E\u044F\u0431\u0440\u044C";
                            default:
                                return "\u0414\u0435\u043A\u0430\u0431\u0440\u044C";
                        }
                    }(r);
            }
        }();
        return e ? t : Gc(t);
    }), Vc = D, Jc = function(n) {
        return A2(Vc, n, "");
    }, Yc = F3(function(n, e, r) {
        return n > 0 ? A3(Yc, n >> 1, k(e, e), 1 & n ? k(r, e) : r) : r;
    }), Wc = F2(function(n, e) {
        return A3(Yc, n, e, "");
    }), Kc = F3(function(n, e, r) {
        return k(A2(Wc, n - iu(r), Jc(e)), r);
    }), Bc = F2(function(n, e) {
        return Ut(n / e);
    }), Qc = function(n) {
        return n;
    }, Zc = F3(function(n, e, r) {
        for(;;){
            if (!r.b) return e + n;
            var t = r.a, u = r.b;
            if (0 > m(t.w, e)) return e + t.h;
            r = u;
        }
    }), no = F2(function(n, e) {
        var r = n.b;
        return A3(Zc, n.a, A2(Bc, e, 6e4), r);
    }), eo = function(n) {
        return -n;
    }, ro = function(n) {
        var e = A2(Bc, n, 1440) + 719468, r = (0 > e ? e - 146096 : e) / 146097 | 0, t = e - 146097 * r, u = (t - (t / 1460 | 0) + (t / 36524 | 0) - (t / 146096 | 0)) / 365 | 0, a = t - (365 * u + (u / 4 | 0) - (u / 100 | 0)), i = (5 * a + 2) / 153 | 0, c = i + (10 > i ? 3 : -9);
        return {
            ie: a - ((153 * i + 2) / 5 | 0) + 1,
            i6: c,
            ks: u + 400 * r + (c > 2 ? 0 : 1)
        };
    }, to = F2(function(n, e) {
        return ro(A2(no, n, e)).ie;
    }), uo = F2(function(n, e) {
        return A2(Uc, 24, A2(Bc, A2(no, n, e), 60));
    }), ao = F2(function(n, e) {
        return A2(Uc, 1e3, e);
    }), io = F2(function(n, e) {
        return A2(Uc, 60, A2(no, n, e));
    }), co = F2(function(n, e) {
        switch(ro(A2(no, n, e)).i6){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), oo = F2(function(n, e) {
        return A2(Uc, 60, A2(Bc, e, 1e3));
    }), fo = F2(function(n, e) {
        switch(A2(Uc, 7, A2(Bc, A2(no, n, e), 1440))){
            case 0:
                return 3;
            case 1:
                return 4;
            case 2:
                return 5;
            case 3:
                return 6;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 2;
        }
    }), so = F2(function(n, e) {
        return ro(A2(no, n, e)).ks;
    }), lo = F3(function(n, e, r) {
        var t = function() {
            switch(n){
                case 0:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Monday";
                            case 1:
                                return "Tuesday";
                            case 2:
                                return "Wednesday";
                            case 3:
                                return "Thursday";
                            case 4:
                                return "Friday";
                            case 5:
                                return "Saturday";
                            default:
                                return "Sunday";
                        }
                    }(r);
                case 1:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Lundi";
                            case 1:
                                return "Mardi";
                            case 2:
                                return "Mercredi";
                            case 3:
                                return "Jeudi";
                            case 4:
                                return "Vendredi";
                            case 5:
                                return "Samedi";
                            default:
                                return "Dimanche";
                        }
                    }(r);
                case 2:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Lunes";
                            case 1:
                                return "Martes";
                            case 2:
                                return "Mi\xe9rcoles";
                            case 3:
                                return "Jueves";
                            case 4:
                                return "Viernes";
                            case 5:
                                return "S\xe1bado";
                            default:
                                return "Domingo";
                        }
                    }(r);
                case 3:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Maandag";
                            case 1:
                                return "Dinsdag";
                            case 2:
                                return "Woensdag";
                            case 3:
                                return "Donderdag";
                            case 4:
                                return "Vrijdag";
                            case 5:
                                return "Zaterdag";
                            default:
                                return "Zondag";
                        }
                    }(r);
                case 4:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Maanantai";
                            case 1:
                                return "Tiistai";
                            case 2:
                                return "Keskiviikko";
                            case 3:
                                return "Torstai";
                            case 4:
                                return "Perjantai";
                            case 5:
                                return "Lauantai";
                            default:
                                return "Sunnuntai";
                        }
                    }(r);
                case 5:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1";
                            case 1:
                                return "\u03A4\u03C1\u03AF\u03C4\u03B7";
                            case 2:
                                return "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7";
                            case 3:
                                return "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7";
                            case 4:
                                return "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE";
                            case 5:
                                return "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF";
                            default:
                                return "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE";
                        }
                    }(r);
                case 6:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Luned\xec";
                            case 1:
                                return "Marted\xec";
                            case 2:
                                return "Mercoled\xec";
                            case 3:
                                return "Gioved\xec";
                            case 4:
                                return "Venerd\xec";
                            case 5:
                                return "Sabato";
                            default:
                                return "Domenica";
                        }
                    }(r);
                case 7:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Mandag";
                            case 1:
                                return "Tirsdag";
                            case 2:
                                return "Onsdag";
                            case 3:
                                return "Torsdag";
                            case 4:
                                return "Fredag";
                            case 5:
                                return "L\xf8rdag";
                            default:
                                return "S\xf8ndag";
                        }
                    }(r);
                case 8:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Segunda-feira";
                            case 1:
                                return "Ter\xe7a-feira";
                            case 2:
                                return "Quarta-feira";
                            case 3:
                                return "Quinta-feira";
                            case 4:
                                return "Sexta-feira";
                            case 5:
                                return "S\xe1bado";
                            default:
                                return "Domingo";
                        }
                    }(r);
                case 9:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "M\xe5ndag";
                            case 1:
                                return "Tisdag";
                            case 2:
                                return "Onsdag";
                            case 3:
                                return "Torsdag";
                            case 4:
                                return "Fredag";
                            case 5:
                                return "L\xf6rdag";
                            default:
                                return "S\xf6ndag";
                        }
                    }(r);
                case 10:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Montag";
                            case 1:
                                return "Dienstag";
                            case 2:
                                return "Mittwoch";
                            case 3:
                                return "Donnerstag";
                            case 4:
                                return "Freitag";
                            case 5:
                                return "Samstag";
                            default:
                                return "Sonntag";
                        }
                    }(r);
                default:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A";
                            case 1:
                                return "\u0432\u0442\u043E\u0440\u043D\u0438\u043A";
                            case 2:
                                return "\u0441\u0440\u0435\u0434\u0430";
                            case 3:
                                return "\u0447\u0435\u0442\u0432\u0435\u0440\u0433";
                            case 4:
                                return "\u043F\u044F\u0442\u043D\u0438\u0446\u0430";
                            case 5:
                                return "\u0441\u0443\u0431\u0431\u043E\u0442\u0430";
                            default:
                                return "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435";
                        }
                    }(r);
            }
        }();
        return e ? t : Gc(t);
    }), bo = F4(function(n, e, r, t) {
        var u = function(n) {
            return 12 === n ? 12 : A2(Uc, 12, n);
        }, a = F2(function(n, e) {
            return zc(A2(Hc, n, A2(it, "", ut(e))));
        }), i = function(n) {
            return A3(Kc, 2, "0", ut(n));
        };
        switch(t){
            case "d":
                return ut(A2(to, n, e));
            case "dd":
                return i(A2(to, n, e));
            case "ddd":
                return A3(lo, r, 0, A2(fo, n, e));
            case "dddd":
                return A3(lo, r, 1, A2(fo, n, e));
            case "h":
                return ut(u(A2(uo, n, e)));
            case "hh":
                return i(u(A2(uo, n, e)));
            case "H":
                return ut(A2(uo, n, e));
            case "HH":
                return i(A2(uo, n, e));
            case "m":
                return ut(A2(io, n, e));
            case "mm":
                return i(A2(io, n, e));
            case "M":
                return ut(Mc(A2(co, n, e)));
            case "MM":
                return i(Mc(A2(co, n, e)));
            case "MMM":
                return A3(Xc, r, 0, A2(co, n, e));
            case "MMMM":
                return A3(Xc, r, 1, A2(co, n, e));
            case "s":
                return ut(A2(oo, n, e));
            case "ss":
                return i(A2(oo, n, e));
            case "t":
                return 12 > A2(uo, n, e) ? "A" : "P";
            case "tt":
                return 12 > A2(uo, n, e) ? "AM" : "PM";
            case "yy":
                return i(A2(Uc, 100, A2(so, n, e)));
            case "yyyy":
                return ut(A2(so, n, e));
            case "f":
                return A2(a, 1, A2(ao, n, e));
            case "ff":
                return A2(a, 2, A2(ao, n, e));
            case "fff":
                return A2(a, 3, A2(ao, n, e));
            default:
                return t;
        }
    }), mo = F2(function(n, e) {
        n: for(;;){
            if (!e.b) return xt(n);
            var r = e.a, t = e.b;
            if (n.b) {
                if (n.a.b) {
                    var u = n.a, a = u.a, i = u.b, c = n.b;
                    if (s(r, a)) {
                        n = A2(Mr, A2(Mr, r, A2(Mr, a, i)), c), e = t;
                        continue n;
                    }
                    n = A2(Mr, A([
                        r
                    ]), A2(Mr, A2(Mr, a, i), c)), e = t;
                    continue n;
                }
                return n;
            }
            n = A([
                A([
                    r
                ])
            ]), e = t;
        }
    }), po = mo(j), vo = F4(function(n, e, r, t) {
        return zc(A2(wu, A3(bo, r, t, n), A2(wu, zc, po(A2(it, "", e)))));
    }), go = F3(function(n, e, r) {
        return A4(vo, 0, n, e, r);
    }), ho = A2(nc, 0, j), $o = A2(Hu, A2(go, "yyyy-MM-ddTHH:mm:ss.fffZ", ho), Sc), xo = function(n) {
        return n;
    }, ko = A2(Hu, xo, Sc), jo = ko, yo = function(n) {
        switch(n.$){
            case 0:
                return "association";
            case 1:
                return "business";
            case 2:
                return "education";
            case 3:
                return "individual";
            case 4:
                return "localAuthority";
            case 5:
                return "media";
            case 6:
                return "public";
            default:
                return "student";
        }
    }, wo = function(n) {
        switch(n.$){
            case 0:
            case 2:
            case 4:
            case 5:
            case 6:
            default:
                return function(e) {
                    return qc(A([
                        v("type", Sc(yo(n))),
                        v("name", Sc(e))
                    ]));
                }(e = n.a);
            case 1:
                var e = n.a, r = n.b;
                return qc(A([
                    v("type", Sc(yo(n))),
                    v("name", Sc(e)),
                    v("siren", Sc(r))
                ]));
            case 3:
                return qc(A([
                    v("type", Sc(yo(n)))
                ]));
        }
    }, Ao = function(n) {
        return qc(A([
            v("assignedAt", $o(n.hQ)),
            v("roleId", Sc(n.jK)),
            v("roleName", Sc(n.jL)),
            v("roleSlug", Sc(n.jM))
        ]));
    }, To = F2(function(n, e) {
        return A3(ot, Tn(n), [], e);
    }), Eo = function(n) {
        var e, r, t, u;
        return qc(A([
            v("accessTokenData", (u = n.f3, qc(A([
                v("access_token", Sc(u.kv)),
                v("expires_in", A2(Nc, zu, A2(Pc, Lc, u.iy))),
                v("refresh_token", A2(Nc, zu, A2(Pc, Sc, u.jC))),
                v("token_type", Sc(u.ke))
            ])))),
            v("user", (e = n.f1, qc(A([
                v("email", Sc(e.c4)),
                v("hasActiveToken", _c(e.iI)),
                v("id", (t = e.mj, jo(t))),
                v("isActive", _c(e.iW)),
                v("isBetauser", _c(e.iY)),
                v("isSuperuser", _c(e.mx)),
                v("isVerified", _c(e.iZ)),
                v("magicLinkSentAt", A2(Nc, zu, A2(Pc, $o, e.i4))),
                v("joinedAt", A2(Nc, zu, A2(Pc, $o, e.i0))),
                v("profile", (r = e.nT, qc(A([
                    v("emailOptin", _c(r.aY)),
                    v("firstName", Sc(r.aD)),
                    v("lastName", Sc(r.aE)),
                    v("organization", wo(r.cq)),
                    v("termsAccepted", _c(r.oW))
                ])))),
                v("roles", A2(To, Ao, e.jN))
            ]))))
        ]));
    }, Co = function(n) {
        switch(n){
            case 0:
                return "apparel";
            case 1:
                return "food2";
            case 2:
                return "object";
            default:
                return "veli";
        }
    }, Io = A2(Hu, Co, Sc), So = function(n) {
        switch(n.a){
            case 0:
                return "ambient";
            case 1:
                return "fresh";
            default:
                return "frozen";
        }
    }, Oo = A2(cc, Sc, So), Lo = function(n) {
        return Sc(n);
    }, Po = function(n) {
        return n;
    }, qo = A2(Hu, Po, Sc), No = yn, _o = function(n) {
        return n;
    }, zo = function(n) {
        return 1e3 * n;
    }, Uo = A2(Hu, zo, No), Mo = function(n) {
        switch(n){
            case 0:
                return zr(Sc("byPlane"));
            case 1:
                return zr(Sc("noPlane"));
            default:
                return Ur;
        }
    }, Do = A2(cc, qc, qa(function(n) {
        var e = n.a;
        return A2(Pc, function(n) {
            return v(e, n);
        }, n.b);
    })), Ro = function(n) {
        var e;
        return Do(A([
            v("id", zr((e = n.mj, jo(e)))),
            v("mass", zr(Uo(n.P))),
            v("country", A2(Pc, qo, n.i)),
            v("byPlane", Mo(n.jo))
        ]));
    }, Fo = function(n) {
        return jo(n);
    }, Ho = function(n) {
        var e;
        return qc(A([
            v("id", Fo(n.mj)),
            v("amount", (e = n.j, No(e)))
        ]));
    }, Go = function(n) {
        return qc(A([
            v("id", Fo(n.mj)),
            v("mass", Uo(n.P))
        ]));
    }, Xo = function(n) {
        var e, r;
        return Do(A([
            v("ingredients", zr(A2(To, Ro, n.mq))),
            v("transform", A2(Pc, Go, n.fX)),
            v("packaging", (r = n.cs, r.b ? zr(A2(To, Ho, r)) : Ur)),
            v("distribution", A2(Pc, Oo, n.E)),
            v("preparation", (e = n.bk, e.b ? zr(A2(To, Lo, e)) : Ur))
        ]));
    }, Vo = function(n) {
        switch(n){
            case 0:
                return "average";
            case 1:
                return "continuous";
            default:
                return "discontinuous";
        }
    }, Jo = A2(Hu, Vo, Sc), Yo = function(n) {
        switch(n){
            case 0:
                return "knitting-circular";
            case 1:
                return "knitting-fully-fashioned";
            case 2:
                return "knitting-integral";
            case 3:
                return "knitting-mix";
            case 4:
                return "knitting-straight";
            default:
                return "weaving";
        }
    }, Wo = A2(Hu, Yo, Sc), Ko = function(n) {
        return n;
    }, Bo = A2(Hu, Ko, No), Qo = function(n) {
        return n ? "substantive" : "pigment";
    }, Zo = A2(Hu, Qo, Sc), nf = function(n) {
        return qc(A([
            v("kind", Zo(n.gJ)),
            v("ratio", Bo(n.nX))
        ]));
    }, ef = function(n) {
        switch(n){
            case 0:
                return "distribution";
            case 1:
                return "end-of-life";
            case 2:
                return "ennobling";
            case 3:
                return "fabric";
            case 4:
                return "making";
            case 5:
                return "material";
            case 6:
                return "spinning";
            default:
                return "use";
        }
    }, rf = A2(Hu, ef, Sc), tf = function(n) {
        switch(n){
            case 0:
                return "large-business-with-services";
            case 1:
                return "large-business-without-services";
            default:
                return "small-business";
        }
    }, uf = A2(Hu, tf, Sc), af = function(n) {
        return n;
    }, cf = A2(Hu, af, No), of = function(n) {
        var e = n.i;
        return e.$ ? Fo(n.mj) : qc(A([
            v("country", qo(e.a)),
            v("id", Fo(n.mj))
        ]));
    }, ff = function(n) {
        return of(n);
    }, sf = function(n) {
        return !n.b;
    }, lf = function(n) {
        return Do(A([
            v("amount", zr(cf(n.j))),
            v("material", zr(of(n.U))),
            v("transforms", sf(n.J) ? Ur : zr(A2(To, ff, n.J)))
        ]));
    }, df = xo, bf = function(n) {
        return df(n);
    }, mf = function(n) {
        return n.trim();
    }, pf = function(n) {
        return Do(k(A([
            v("id", A2(Pc, A2(Hu, bf, Sc), n.mj)),
            v("quantity", zr(Lc(n.D))),
            v("unitMass", A2(Pc, A2(Hu, _o, No), n.dH))
        ]), function() {
            var e = n.Y;
            if (e.$) return j;
            var r = e.a;
            return A([
                v("name", A2(Pc, Sc, A2(Ba, function(n) {
                    return "" === n ? Ur : zr(n);
                }, A2(Pc, mf, r.ek)))),
                v("elements", zr(A2(To, lf, r.r)))
            ]);
        }()));
    }, vf = function(n) {
        switch(n){
            case 0:
                return "ConventionalSpinning";
            case 1:
                return "SyntheticSpinning";
            default:
                return "UnconventionalSpinning";
        }
    }, gf = A2(Hu, vf, Sc), hf = function(n) {
        var e;
        return Do(A([
            v("country", A2(Pc, qo, n.i)),
            v("id", zr((e = n.mj, jo(e)))),
            v("share", zr(Bo(n.aH))),
            v("spinning", A2(Pc, gf, n.dz))
        ]));
    }, $f = function(n) {
        return No(n);
    }, xf = function(n) {
        return n;
    }, kf = A2(Hu, xf, No), jf = F2(function(n, e) {
        return n * e;
    }), yf = z, wf = function(n) {
        return yf(zo(A2(jf, n, 1)));
    }, Af = function(n) {
        return Lc(wf(n));
    }, Tf = function(n) {
        return .001 * n;
    }, Ef = function(n) {
        return n;
    }, Cf = function(n) {
        return Tf(A2(jf, n, 1));
    }, If = A2(Hu, Cf, No), Sf = function(n) {
        return n;
    }, Of = function(n) {
        switch(n){
            case 0:
                return "high";
            case 1:
                return "low";
            case 2:
                return "medium";
            case 3:
                return "non-applicable";
            case 4:
                return "very-high";
            default:
                return "very-low";
        }
    }, Lf = function(n) {
        var e;
        return Do(A([
            v("airTransportRatio", A2(Pc, Bo, n.cJ)),
            v("business", A2(Pc, uf, n.h_)),
            v("countryDyeing", A2(Pc, qo, n.by)),
            v("countryFabric", A2(Pc, qo, n.bU)),
            v("countryMaking", A2(Pc, qo, n.bV)),
            v("countrySpinning", A2(Pc, qo, n.cY)),
            v("disabledSteps", (e = n.c0, e.b ? zr(A2(To, rf, e)) : Ur)),
            v("dyeingProcessType", A2(Pc, Jo, n.c2)),
            v("fabricProcess", A2(Pc, Wo, n.b6)),
            v("fading", A2(Pc, _c, n.c8)),
            v("makingComplexity", A2(Pc, A2(Hu, Of, Sc), n.mV)),
            v("makingDeadStock", A2(Pc, Bo, n.dk)),
            v("makingWaste", A2(Pc, Bo, n.dl)),
            v("mass", zr(No(n.P))),
            v("materials", zr(A2(To, hf, n.ft))),
            v("numberOfReferences", A2(Pc, Lc, n.je)),
            v("physicalDurability", A2(Pc, $f, n.dn)),
            v("price", A2(Pc, kf, n.jr)),
            v("printing", A2(Pc, nf, n.$7)),
            v("product", zr(Sc(n.aS))),
            v("surfaceMass", A2(Pc, Af, n.hj)),
            v("trims", A2(Pc, To(pf), n.pf)),
            v("upcycled", zr(_c(n.dI))),
            v("yarnSize", A2(Pc, If, n.pV))
        ]));
    }, Pf = {
        i: Ur,
        bh: Ur
    }, qf = function(n) {
        var e = n.j;
        return e.$ ? Fo(n.bl) : qc(A([
            v("amount", cf(e.a)),
            v("processId", Fo(n.bl))
        ]));
    }, Nf = function(n) {
        return jo(n);
    }, _f = function(n) {
        var e;
        return qc(A([
            v("amount", No((e = n).j)),
            v("processId", Fo(e.bl))
        ]));
    }, zf = function(n) {
        return No(n);
    }, Uf = {
        a8: 0,
        aN: Ur
    }, Mf = function(n) {
        return 100 * n;
    }, Df = A2(Hu, Mf, No), Rf = function(n) {
        var e, r, t, u, a;
        return Do(A([
            v("assembly", s(n.q, Pf) ? Ur : zr((a = n.q, s(a, Pf) ? zu : Do(A([
                v("country", A2(Pc, qo, a.i)),
                v("operations", A2(Pc, To(Fo), a.bh))
            ]))))),
            v("components", zr(A2(To, pf, n.my))),
            v("consumptions", A2(Pc, To(qf), n.aM)),
            v("distribution", A2(Pc, Fo, n.E)),
            v("durability", A2(Pc, zf, n.aO)),
            v("packagings", sf(n.aR) ? Ur : zr(A2(To, _f, n.aR))),
            v("product", A2(Pc, Nf, n.aS)),
            v("recyclable", zr(_c(n.dq))),
            v("transportOptions", (e = n.ax, r = e.a8, t = e.aN, u = A2(qa, ru, A([
                s(r, Uf.a8) ? Ur : zr(v("byAir", Df(r))),
                A2(Pc, function(n) {
                    return v("cooling", _c(n));
                }, t)
            ])), sf(u) ? Ur : zr(qc(u))))
        ]));
    }, Ff = function(n) {
        switch(n.$){
            case 0:
                return Xo(n.a);
            case 1:
                return Rf(n.b);
            default:
                return Lf(n.a);
        }
    }, Hf = function(n) {
        var e;
        return Do(A([
            v("created", zr(Lc(n.gn))),
            v("name", zr(Sc(n.ek))),
            v("query", zr(Ff(n.g5))),
            v("subScope", (e = n.g5, 1 === e.$ ? zr(Io(e.a)) : Ur))
        ]));
    }, Gf = To(A2(Hu, Hf, A2(Hu, tt(0), Sc))), Xf = F3(function(n, e, r) {
        var t = r;
        return A3(Di, F3(function(e, r, t) {
            return A2(n, e, t);
        }), e, t);
    }), Vf = F2(function(n, e) {
        return A3(Xf, Tn(n), [], e);
    }), Jf = function(n) {
        return qc(A([
            v("comparedSimulations", A2(Vf, Sc, n.aX)),
            v("bookmarks", Gf(n.ap)),
            v("auth", A2(Nc, zu, A2(Pc, Eo, n.aW))),
            v("usageCount", Lc(n.hD))
        ]));
    }, Yf = A2(Hu, Jf, tt(0)), Wf = F2(function(n, e) {
        var r = e.a, t = e.b;
        return v(r, function() {
            var e = r.H;
            if (2 === e.$) {
                var u = e.a;
                return s(n.bH, u.bH) ? t : Mu(A([
                    t,
                    Oc(Yf(u.bH))
                ]));
            }
            return t;
        }());
    }), Kf = F3(function(n, e, r) {
        return {
            $: 4,
            a: n,
            b: e,
            c: r
        };
    }), Bf = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Qf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Zf = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), ns = {
        $: 7
    }, es = function(n) {
        return {
            $: 13,
            a: n
        };
    }, rs = function(n) {
        switch(n.$){
            case 4:
                return "\xc9chec de l'interpr\xe9tation de la r\xe9ponse HTTP: " + n.a;
            case 3:
                return "Erreur HTTP " + ut(n.a);
            case 0:
                return "URL invalide: " + n.a;
            case 2:
                return "Erreur de communication r\xe9seau. \xcates-vous connect\xe9 ?";
            default:
                return "D\xe9lai d\xe9pass\xe9.";
        }
    }, ts = function(n) {
        var e = n.bH.aW;
        return !e.$ && e.a.f1.nT.oW;
    }, us = F8(function(n, e, r, t, u, a, i, c) {
        return {
            ln: n,
            E: e,
            ir: r,
            aO: t,
            _: u,
            Q: a,
            af: i,
            bK: c
        };
    }), as = F2(function(n, e) {
        return e.$ ? Yr(e.a) : n(e.a);
    }), is = function(n) {
        return A2(Qt, Mi, function(n) {
            return {
                $: 8,
                b: n
            };
        }(n));
    }, cs = function(n) {
        return {
            l: Qu,
            aJ: n
        };
    }, os = F3(function(n, e, r) {
        var t = r;
        return $(t, {
            l: A3(ia, t.aJ(n), v(n, e), t.l)
        });
    }), fs = F2(function(n, e) {
        return e.$ ? Yr(e.a) : Qr(n(e.a));
    }), ss = F3(function(n, e, r) {
        return A2(Bt, function(n) {
            return n.$ ? Ii(n.a) : nu(n.a);
        }, A2(Qt, A2(Hr, F2(function(e, r) {
            return as(function(t) {
                return A2(fs, function(n) {
                    return A3(os, n, r, t);
                }, A2(n, e, r));
            });
        }), Qr(cs(e))), is(r)));
    }), ls = {
        $: 0
    }, ds = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bs = {
        $: 2
    }, ms = function(n) {
        switch(n){
            case "apparel":
                return Qr(0);
            case "food2":
                return Qr(1);
            case "object":
                return Qr(2);
            case "veli":
                return Qr(3);
            default:
                return Yr("Couldn't decode unknown generic scope " + n);
        }
    }, ps = function(n) {
        switch(n){
            case "food":
                return Qr(ls);
            case "textile":
                return Qr(bs);
            default:
                var e = n, r = ms(e);
                return 1 === r.$ ? Yr("Couldn't decode unknown scope " + e) : Qr(ds(r.a));
        }
    }, vs = function(n) {
        switch(n.$){
            case 0:
                return "food";
            case 1:
                return Co(n.a);
            default:
                return "textile";
        }
    }, gs = A2(ss, F2(function(n) {
        return ps(n);
    }), vs), hs = F2(function(n, e) {
        return {
            i: n,
            lo: e
        };
    }), $s = A2(Qt, ru, ai), xs = F2(function(n, e) {
        for(;;){
            if (!e.b) return Ur;
            var r = e.a, t = e.b;
            if (n(r)) return zr(r);
            e = t;
        }
    }), ks = F2(function(n, e) {
        return e.$ ? Yr(n) : Qr(e.a);
    }), js = function(n) {
        return A2(Hu, xs(A2(Hu, function(n) {
            return n.cR;
        }, zt(n))), ks("Code pays invalide: " + n + "."));
    }, ys = function(n) {
        return n.$ ? Ii(n.a) : nu(n.a);
    }, ws = F4(function(n, e, r, t) {
        return {
            mo: e,
            eg: n,
            nm: r,
            oN: t
        };
    }), As = pr, Ts = mr, Es = function(n) {
        return A2(Ts, {
            kS: !1,
            m8: !1
        }, n);
    }, Cs = /.^/, Is = A2(Nc, Cs, Es("^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$")), Ss = function(n) {
        return n.toLowerCase();
    }, Os = function(n) {
        return A2(As, Is, n) ? zr(Ss(n)) : Ur;
    }, Ls = A2(Bt, function(n) {
        var e = Os(n);
        return e.$ ? Ii("Not a valid UUID") : nu(e.a);
    }, ai), Ps = Ls, qs = function(n) {
        return df(n);
    }, Ns = F2(function(n, e) {
        return A2(ks, "Proc\xe9d\xe9 introuvable par id : " + qs(n), A2(xs, A2(Hu, function(n) {
            return n.mj;
        }, zt(n)), e));
    }), _s = function(n) {
        return A2(Bt, A2(Hu, ru, A2(Hu, function(e) {
            return A2(Ns, e, n);
        }, ys)), Ps);
    }, zs = function(n) {
        return Za(A([
            A2(Qt, zr, n),
            nu(Ur)
        ]));
    }, Us = F2(function(n, e) {
        return A3(Wa, "defaultProcess", function(n) {
            return gs(zs(_s(n)));
        }(n), A3(Wa, "country", function(n) {
            return A2(Bt, function(e) {
                return ys(A2(js, e, n));
            }, $s);
        }(e), nu(hs)));
    }), Ms = F2(function(n, e) {
        return {
            $8: n,
            jS: e
        };
    }), Ds = A3(Wa, "scoped", gs(is(ai)), A3(Wa, "default", is(ai), nu(Ms))), Rs = A3(Wa, "enabled", gs(Pu), nu(function(n) {
        return {
            gt: n
        };
    })), Fs = F3(function(n, e, r) {
        return {
            gt: n,
            om: e,
            fM: r
        };
    }), Hs = F3(function(n, e, r) {
        return {
            dX: e,
            $8: n,
            em: r
        };
    }), Gs = F3(function(n, e, r) {
        return {
            fl: n,
            fo: e,
            fC: r
        };
    }), Xs = F3(function(n, e, r) {
        return {
            g: n,
            t: e,
            oH: r
        };
    }), Vs = tn, Js = Z, Ys = function(n) {
        return 0 > n || n > 100 ? Yr("Une part (en pourcentage) doit \xeatre comprise entre 0 et 100 inclus (ici\u202F: " + Js(n) + ")") : Qr(n / 100);
    }, Ws = A2(Bt, A2(Hu, Ys, ys), Vs), Ks = {
        bM: 0,
        bR: 0,
        b_: 0,
        b3: 0,
        b4: 0,
        ca: 0,
        cb: 0,
        cd: 0,
        ce: 0,
        cf: 0,
        cg: 0,
        ci: 0,
        ck: 0,
        cp: 0,
        cr: 0,
        cu: 0,
        cv: 0,
        cz: 0,
        cD: 0,
        cH: 0
    }, Bs = A2(Hu, nu, Ya), Qs = function(n) {
        return A3(Wa, "percent", Ws, A3(ui, "processId", _s(n), A2(Bs, Ks, nu(Xs))));
    }, Zs = F3(function(n, e, r) {
        return Ka(A2(Qt, Nc(r), A2(ti, n, e)));
    }), nl = F2(function(n, e) {
        for(;;){
            if (!e.b) return !1;
            var r = e.b;
            if (n(e.a)) return !0;
            e = r;
        }
    }), el = F2(function(n, e) {
        return A2(nl, function(e) {
            return s(e, n);
        }, e);
    }), rl = function(n) {
        return !n;
    }, tl = function(n) {
        return A3(ot, nt, 0, n);
    }, ul = function(n) {
        var e, r, t = (e = A2(wu, function(n) {
            return n.oH;
        }, A([
            n.fl,
            n.fo,
            n.fC
        ])), r = tl(A2(wu, Ko, e)), A2(el, r, A([
            1,
            .6 + .3 + .1
        ])) ? Qr(r) : Yr("La somme des parts ne doit pas exc\xe9der 100%; ici\xa0: " + Js(100 * r) + "%"));
        return 1 === t.$ ? Ii("Strat\xe9gies de fin de vie invalides\xa0: " + t.a) : nu(n);
    }, al = function(n) {
        var e = {
            g: Ks,
            t: Ur,
            oH: 0
        };
        return A2(Bt, ul, A4(Zs, "recycling", Qs(n), e, A4(Zs, "landfilling", Qs(n), e, A4(Zs, "incinerating", Qs(n), e, nu(Gs)))));
    }, il = function(n) {
        switch(n){
            case "aluminium":
                return Qr(0);
            case "battery_cell_nmc811":
                return Qr(4);
            case "battery_cell_nmc622":
                return Qr(3);
            case "battery_cell_lfp":
                return Qr(2);
            case "battery_alkaline":
                return Qr(1);
            case "composites":
                return Qr(6);
            case "containerboard":
                return Qr(7);
            case "copper":
                return Qr(8);
            case "ferrous_metals":
                return Qr(11);
            case "glass":
                return Qr(14);
            case "hdpe":
                return Qr(15);
            case "ldpe":
                return Qr(16);
            case "organic_fibers":
                return Qr(19);
            case "other":
                return Qr(21);
            case "pet":
                return Qr(22);
            case "pp":
                return Qr(23);
            case "pur_foam":
                return Qr(26);
            case "pwb":
                return Qr(24);
            case "rigid_plastics":
                return Qr(28);
            case "rubber":
                return Qr(29);
            case "synthetic_fibers":
                return Qr(30);
            case "wood":
                return Qr(31);
            case "cereals":
                return Qr(5);
            case "dairy":
                return Qr(9);
            case "eggs":
                return Qr(10);
            case "fish_and_shellfish":
                return Qr(12);
            case "fruits_and_vegetables":
                return Qr(13);
            case "legumes":
                return Qr(17);
            case "offal":
                return Qr(18);
            case "other_food_items":
                return Qr(20);
            case "poultry":
                return Qr(25);
            case "red_meats":
                return Qr(27);
            default:
                return Yr("Type de mati\xe8re non support\xe9: " + n);
        }
    }, cl = function(n) {
        switch(n){
            case 0:
                return "aluminium";
            case 1:
                return "battery_alkaline";
            case 2:
                return "battery_cell_lfp";
            case 3:
                return "battery_cell_nmc622";
            case 4:
                return "battery_cell_nmc811";
            case 5:
                return "cereals";
            case 6:
                return "composites";
            case 7:
                return "containerboard";
            case 8:
                return "copper";
            case 9:
                return "dairy";
            case 10:
                return "eggs";
            case 11:
                return "ferrous_metals";
            case 12:
                return "fish_and_shellfish";
            case 13:
                return "fruits_and_vegetables";
            case 14:
                return "glass";
            case 15:
                return "hdpe";
            case 16:
                return "ldpe";
            case 17:
                return "legumes";
            case 18:
                return "offal";
            case 19:
                return "organic_fibers";
            case 20:
                return "other_food_items";
            case 21:
                return "other";
            case 22:
                return "pet";
            case 23:
                return "pp";
            case 24:
                return "pwb";
            case 25:
                return "poultry";
            case 26:
                return "pur_foam";
            case 27:
                return "red_meats";
            case 28:
                return "rigid_plastics";
            case 29:
                return "rubber";
            case 30:
                return "synthetic_fibers";
            default:
                return "wood";
        }
    }, ol = A2(ss, F2(function(n) {
        return il(n);
    }), cl), fl = F2(function(n, e) {
        return {
            ii: n,
            ij: e
        };
    }), sl = F2(function(n, e) {
        return A3(yu, qu, e, n);
    }), ll = F3(function(n, e, r) {
        return A2(Ya, A2(sl, n, e), r);
    }), dl = F2(function(n, e) {
        return {
            ih: n,
            m7: e
        };
    }), bl = F6(function(n, e, r, t, u, a) {
        return {
            f5: n,
            g: e,
            ds: r,
            og: t,
            hb: u,
            oq: a
        };
    }), ml = function(n) {
        return 1e3 * n;
    }, pl = A2(Qt, A2(Hu, Pc(ml), Nc(0)), zs(Vs)), vl = A2(Bs, 0, A3(Wa, "sea", pl, A2(Bs, 0, A3(Wa, "road", pl, A2(Bs, Ks, A3(Wa, "air", pl, nu(bl))))))), gl = F5(function(n, e, r, t, u) {
        return {
            kK: n,
            kL: e,
            mP: r,
            mQ: t,
            nL: u
        };
    }), hl = F2(function(n, e) {
        return {
            ii: n,
            ij: e
        };
    }), $l = function(n) {
        var e = n.bT, r = n.W;
        return A3(Wa, "use", function(n) {
            return A3(ll, A([
                "defaultProcesses",
                "heat"
            ]), _s(n), A3(ll, A([
                "defaultProcesses",
                "elec"
            ]), _s(n), nu(hl)));
        }(r), A3(Wa, "transports", function(n) {
            return A3(Wa, "modeProcesses", function(n) {
                return A3(Wa, "plane", _s(n), A3(Wa, "lorryCooling", _s(n), A3(Wa, "lorry", _s(n), A3(Wa, "boatCooling", _s(n), A3(Wa, "boat", _s(n), nu(gl))))));
            }(n), A3(Wa, "defaultDistance", vl, nu(dl)));
        }(r), A3(Wa, "production", function(n) {
            return A3(ll, A([
                "defaultProcesses",
                "heat"
            ]), _s(n), A3(ll, A([
                "defaultProcesses",
                "elec"
            ]), _s(n), nu(fl)));
        }(r), A3(Wa, "endOfLife", function(n) {
            return A3(Wa, "strategies", function(n) {
                return A3(Wa, "nonCollected", ol(al(n)), A3(Wa, "collected", ol(al(n)), A3(Wa, "default", al(n), nu(Hs))));
            }(n), A3(Wa, "scopeCollectionRates", gs(Ws), A3(Wa, "enabled", gs(Pu), nu(Fs))));
        }(r), A3(Wa, "durability", Rs, A3(Wa, "docLinks", Ds, A3(Wa, "distribution", A2(Us, r, e), A4(Zs, "defaultExamples", gs(Ps), cs(vs), nu(us)))))))));
    }, xl = function(n) {
        return A2(Hu, ci($l(n)), $a(yt));
    }, kl = function(n) {
        var e = n.bH.aW;
        return e.$ ? j : A([
            A2(mi, "Authorization", "Bearer " + e.a.f3.kv)
        ]);
    }, jl = {
        $: 3
    }, yl = {
        $: 4
    }, wl = F5(function(n, e, r, t, u) {
        return {
            ip: n,
            mc: e,
            j4: r,
            eG: t,
            a6: u
        };
    }), Al = F2(function(n, e) {
        return A2(pa, n, function(n) {
            switch(n.$){
                case 3:
                    var r = n.a, t = n.b, u = A2(ci, A2(Bs, (o = r).a6, A3(ui, "title", ai, A3(Wa, "status", xi, A2(Bs, o.mc, A4(Zs, "detail", ai, "No details were given", nu(wl)))))), t);
                    return Yr(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(1 === u.$ ? {
                        ip: "Couldn't decode error response: " + yt(u.a),
                        mc: r.mc,
                        j4: r.j4,
                        eG: Ur,
                        a6: r.a6
                    } : u.a));
                case 0:
                    return Yr(function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(c = n.a));
                case 4:
                    var a = n.a.mc, i = n.a.j4, c = n.a.a6;
                    return t = n.b, A2($a, function(n) {
                        return function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }({
                            ip: yt(n),
                            mc: a,
                            j4: i,
                            eG: zr("Corps de r\xe9ponse invalide"),
                            a6: c
                        });
                    }, A2(ci, e, 204 === i && su(t) ? "null" : t));
                case 2:
                    return Yr(jl);
                default:
                    return Yr(yl);
            }
            var o;
        });
    }), Tl = F4(function(n, e, r, t) {
        var u = e.a6;
        return Da({
            kO: Aa,
            lU: A2(Al, A2(Hu, wa, r), t),
            mc: kl(n),
            m1: "GET",
            oY: Ur,
            pc: Ur,
            a6: u
        });
    }), El = F2(function(n, e) {
        return A4(Tl, n, {
            a6: n.kY + "/processes/processes.json"
        }, e, ai);
    }), Cl = F2(function(n, e) {
        return 1 === n.$ ? e : e + ":" + ut(n.a);
    }), Il = F3(function(n, e, r) {
        return 1 === e.$ ? r : k(r, k(n, e.a));
    }), Sl = function(n) {
        return A3(Il, "#", n.iD, A3(Il, "?", n.g5, k(A2(Cl, n.nO, k(n.nU ? "https://" : "http://", n.iN)), n.jj)));
    }, Ol = ee("sendPlausibleEvent", function(n) {
        return qc(A([
            v("name", Sc(n.ek)),
            v("properties", To(function(n) {
                var e = n.b;
                return A2(To, ru, A([
                    Sc(n.a),
                    e
                ]));
            })(n.jx))
        ]));
    }), Ll = F2(function(n, e) {
        return v(n, Sc(e));
    }), Pl = function(n) {
        switch(n){
            case 0:
                return "acd";
            case 1:
                return "cch";
            case 2:
                return "etf";
            case 3:
                return "etf-c";
            case 4:
                return "fru";
            case 5:
                return "fwe";
            case 6:
                return "htc";
            case 7:
                return "htc-c";
            case 8:
                return "htn";
            case 9:
                return "htn-c";
            case 10:
                return "ior";
            case 11:
                return "ldu";
            case 12:
                return "mru";
            case 13:
                return "ozd";
            case 14:
                return "pco";
            case 15:
                return "pma";
            case 16:
                return "swe";
            case 17:
                return "tre";
            case 18:
                return "wtu";
            default:
                return "ecs";
        }
    }, ql = F2(function(n, e) {
        return v(n, _c(e));
    }), Nl = function(n) {
        return !n.bH.aW.$;
    }, _l = function(n) {
        return n.bH.aW;
    }, zl = A2(Hu, _l, A2(Hu, Pc(A2(Hu, function(n) {
        return n.f1;
    }, function(n) {
        return n.mx;
    })), Nc(!1))), Ul = F2(function(n, e) {
        return A2(Hu, Pc(n(e)), Nc(function(n) {
            return v(n, zu);
        }(e)));
    }), Ml = F3(function(n, e, r) {
        var t;
        return {
            ek: e,
            jx: A2(Mr, A2(ql, "admin", zl(n)), A2(Mr, A2(ql, "authenticated", Nl(n)), A2(Mr, A2(Ll, "clientUrl", n.kY), A2(Mr, A3(Ul, Ll, "scalingoAppName", n.ol), A2(Mr, A2(Ll, "subsystem", "front-end"), A2(Mr, A3(Ul, Ll, "version", (t = n.ld, 2 === t.$ ? t.a.fR : Ur)), r))))))
        };
    }), Dl = F2(function(n, e) {
        return Ol(function() {
            switch(e.$){
                case 0:
                    return A3(Ml, n, "auth_api_token_created", A([
                        A2(Ll, "feature", "auth")
                    ]));
                case 1:
                    return A3(Ml, n, "auth_login_ok", A([
                        A2(Ll, "feature", "auth")
                    ]));
                case 2:
                    return A3(Ml, n, "auth_magic_link_sent", A([
                        A2(Ll, "feature", "auth")
                    ]));
                case 3:
                    return A3(Ml, n, "auth_profile_updated", A([
                        A2(Ll, "feature", "auth")
                    ]));
                case 4:
                    return A3(Ml, n, "auth_signup", A([
                        A2(Ll, "feature", "auth")
                    ]));
                case 5:
                    var r = e.a;
                    return A3(Ml, n, "bookmark_saved", A([
                        A2(Ll, "feature", "bookmarks"),
                        A2(Ll, "scope", vs(r))
                    ]));
                case 6:
                    return r = e.a, A3(Ml, n, "comparator_opened", A([
                        A2(Ll, "feature", "comparator"),
                        A2(Ll, "scope", vs(r))
                    ]));
                case 7:
                    r = e.a;
                    var t = e.b;
                    return A3(Ml, n, "comparison_type_selected", A([
                        A2(Ll, "feature", "comparator"),
                        A2(Ll, "scope", vs(r)),
                        A2(Ll, "comparison_type", t)
                    ]));
                case 8:
                    return r = e.a, A3(Ml, n, "component_added", A([
                        A2(Ll, "feature", "simulator"),
                        A2(Ll, "scope", vs(r))
                    ]));
                case 9:
                    return r = e.a, A3(Ml, n, "component_updated", A([
                        A2(Ll, "feature", "simulator"),
                        A2(Ll, "scope", vs(r))
                    ]));
                case 10:
                    return r = e.a, A3(Ml, n, "consumption_added", A([
                        A2(Ll, "feature", "simulator"),
                        A2(Ll, "scope", vs(r))
                    ]));
                case 11:
                    return r = e.a, A3(Ml, n, "example_selected", A([
                        A2(Ll, "feature", "simulator"),
                        A2(Ll, "scope", vs(r))
                    ]));
                case 12:
                    r = e.a;
                    var u = e.b;
                    return A3(Ml, n, "impact_selected", A([
                        A2(Ll, "feature", "simulator"),
                        A2(Ll, "scope", vs(r)),
                        A2(Ll, "trigram", Pl(u))
                    ]));
                case 13:
                    return A3(Ml, n, "pageview", A([
                        A2(Ll, "url", (i = e.a, Sl(A2(Nc, !1, A2(Pc, gu("/auth/"), i.iD)) ? $(i, {
                            iD: zr("/auth/<***>/")
                        }) : i)))
                    ]));
                default:
                    r = e.a;
                    var a = e.b;
                    return A3(Ml, n, "tab_selected", A([
                        A2(Ll, "feature", "share"),
                        A2(Ll, "scope", vs(r)),
                        A2(Ll, "tab", a)
                    ]));
            }
            var i;
        }());
    }), Rl = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Fl = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hl = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Gl = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xl = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Vl = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Jl = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Yl = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Wl = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Kl = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Bl = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ql = {
        $: 8
    }, Zl = function(n) {
        return {
            $: 12,
            a: n
        };
    }, nd = function(n) {
        return {
            $: 9,
            a: n
        };
    }, ed = function(n) {
        return {
            $: 10,
            a: n
        };
    }, rd = F5(function(n, e, r, t, u) {
        return {
            b9: t,
            ct: r,
            bJ: e,
            eT: u,
            cF: n
        };
    }), td = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(Mr, n.a, td(n.b)) : j;
    }, ud = F2(function(n, e) {
        return zr(1 === e.$ ? A([
            n
        ]) : A2(Mr, n, e.a));
    }), ad = function(n) {
        try {
            return zr(decodeURIComponent(n));
        } catch (n) {
            return Ur;
        }
    }, id = F2(function(n, e) {
        var r = A2(it, "=", n);
        if (r.b && r.b.b && !r.b.b.b) {
            var t = r.b.a, u = ad(r.a);
            if (1 === u.$) return e;
            var a = u.a, i = ad(t);
            return 1 === i.$ ? e : A3(ma, a, ud(i.a), e);
        }
        return e;
    }), cd = F2(function(n, e) {
        var r;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var e = n.a, r = e.bJ;
                    if (r.b) {
                        if ("" !== r.a || r.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return zr(e.eT);
                    }
                    return zr(e.eT);
                }
                return Ur;
            }
        }(n(A5(rd, j, function(n) {
            var e = A2(it, "/", n);
            return td(e.b && "" === e.a ? e.b : e);
        }(e.jj), 1 === (r = e.g5).$ ? Qu : A3(yu, id, Qu, A2(it, "&", r.a)), e.iD, ru)));
    }), od = {
        $: 0
    }, fd = {
        $: 1
    }, sd = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), ld = {
        $: 3
    }, dd = function(n) {
        return {
            $: 4,
            a: n
        };
    }, bd = F2(function(n, e) {
        return {
            $: 5,
            a: n,
            b: e
        };
    }), md = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), pd = function(n) {
        return {
            $: 7,
            a: n
        };
    }, vd = {
        $: 8
    }, gd = {
        $: 12
    }, hd = {
        $: 13
    }, $d = function(n) {
        return {
            $: 15,
            a: n
        };
    }, xd = {
        $: 16
    }, kd = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jd = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), yd = function(n) {
        return {
            $: 8,
            a: n
        };
    }, wd = function(n) {
        switch(n.$){
            case 0:
                return kd(Ur);
            case 1:
                switch(n.a){
                    case 0:
                        return A2(jd, 0, Ur);
                    case 1:
                        return A2(jd, 1, Ur);
                    case 2:
                        return A2(jd, 2, Ur);
                    default:
                        return A2(jd, 3, Ur);
                }
            default:
                return yd(Ur);
        }
    }, Ad = F2(function(n, e) {
        return A5(rd, e.cF, e.bJ, e.ct, e.b9, n(e.eT));
    }), Td = F2(function(n, e) {
        var r = e;
        return function(e) {
            var t = e.cF, u = e.bJ, a = e.ct, i = e.b9;
            return A2(wu, Ad(e.eT), r(A5(rd, t, u, a, i, n)));
        };
    }), Ed = F2(function(n, e) {
        return e.b ? A3(yu, Mr, e, n) : n;
    }), Cd = function(n) {
        return A3(yu, Ed, j, n);
    }, Id = F2(function(n, e) {
        return Cd(A2(wu, n, e));
    }), Sd = function(n) {
        return function(e) {
            return A2(Id, function(n) {
                return n(e);
            }, n);
        };
    }, Od = F2(function(n, e) {
        return function(n) {
            var r = n.cF, t = n.bJ, u = n.ct, a = n.b9, i = n.eT;
            if (t.b) {
                var c = t.a, o = t.b, f = e(c);
                if (f.$) return j;
                var s = f.a;
                return A([
                    A5(rd, A2(Mr, c, r), o, u, a, i(s))
                ]);
            }
            return j;
        };
    }), Ld = function(n) {
        return n.$ ? Ur : zr(n.a);
    }, Pd = A2(Od, "SCOPE", A2(Hu, ps, Ld)), qd = function(n) {
        switch(iu(n) % 4){
            case 3:
                return n + "=";
            case 2:
                return n + "==";
            default:
                return n;
        }
    }, Nd = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, _d = A2(Hu, Nd, Jc), zd = F2(function(n, e) {
        var r = e.a, t = e.b, u = e.c, a = function(n) {
            return 63 & n | r << 6;
        };
        return t ? 1 === t ? g(0, 0, k(u, _d(a(n)))) : g(a(n), t - 1, u) : 128 & n ? 192 == (224 & n) ? g(31 & n, 1, u) : 224 == (240 & n) ? g(15 & n, 2, u) : g(7 & n, 3, u) : g(0, 0, k(u, _d(n)));
    }), Ud = F2(function(n, e) {
        return g(0, 0, A2(zd, 255 & n >>> 0, A2(zd, 255 & n >>> 8, A2(zd, 255 & n >>> 16, e))));
    }), Md = F2(function(n, e) {
        var r = e.a, t = e.b, u = e.c, a = function(n) {
            switch(n){
                case "A":
                default:
                    return 0;
                case "B":
                    return 1;
                case "C":
                    return 2;
                case "D":
                    return 3;
                case "E":
                    return 4;
                case "F":
                    return 5;
                case "G":
                    return 6;
                case "H":
                    return 7;
                case "I":
                    return 8;
                case "J":
                    return 9;
                case "K":
                    return 10;
                case "L":
                    return 11;
                case "M":
                    return 12;
                case "N":
                    return 13;
                case "O":
                    return 14;
                case "P":
                    return 15;
                case "Q":
                    return 16;
                case "R":
                    return 17;
                case "S":
                    return 18;
                case "T":
                    return 19;
                case "U":
                    return 20;
                case "V":
                    return 21;
                case "W":
                    return 22;
                case "X":
                    return 23;
                case "Y":
                    return 24;
                case "Z":
                    return 25;
                case "a":
                    return 26;
                case "b":
                    return 27;
                case "c":
                    return 28;
                case "d":
                    return 29;
                case "e":
                    return 30;
                case "f":
                    return 31;
                case "g":
                    return 32;
                case "h":
                    return 33;
                case "i":
                    return 34;
                case "j":
                    return 35;
                case "k":
                    return 36;
                case "l":
                    return 37;
                case "m":
                    return 38;
                case "n":
                    return 39;
                case "o":
                    return 40;
                case "p":
                    return 41;
                case "q":
                    return 42;
                case "r":
                    return 43;
                case "s":
                    return 44;
                case "t":
                    return 45;
                case "u":
                    return 46;
                case "v":
                    return 47;
                case "w":
                    return 48;
                case "x":
                    return 49;
                case "y":
                    return 50;
                case "z":
                    return 51;
                case "0":
                    return 52;
                case "1":
                    return 53;
                case "2":
                    return 54;
                case "3":
                    return 55;
                case "4":
                    return 56;
                case "5":
                    return 57;
                case "6":
                    return 58;
                case "7":
                    return 59;
                case "8":
                    return 60;
                case "9":
                    return 61;
                case "+":
                    return 62;
                case "/":
                    return 63;
            }
        }(n);
        return 3 === t ? A2(Ud, r | a, u) : g(a << 6 * (3 - t) | r, t + 1, u);
    }), Dd = H, Rd = g(0, 0, g(0, 0, "")), Fd = F2(function(n, e) {
        return 1 > n ? e : A3(cu, 0, -n, e);
    }), Hd = B, Gd = F2(function(n, e) {
        return A2(Hd, "==", n) ? A2(Fd, 2, e) : A2(Hd, "=", n) ? A2(Fd, 1, e) : e;
    }), Xd = A2(Nc, Cs, Es("^([A-Za-z0-9\\/+]{4})*([A-Za-z0-9\\/+]{2}[A-Za-z0-9\\/+=]{2})?$")), Vd = function(n) {
        var e = n.c, r = e.c;
        return e.b > 0 ? Yr("Invalid UTF-16") : Qr(r);
    }, Jd = function(n) {
        return A2(fs, Gd(n), A2(as, A2(Hu, A2(Dd, Md, Rd), Vd), function(n) {
            return A2(As, Xd, n) ? Qr(n) : Yr("Invalid base64");
        }(n)));
    }, Yd = A2(Hu, qd, Jd), Wd = Yd, Kd = F5(function(n, e, r, t, u) {
        return {
            E: n,
            mq: e,
            cs: r,
            bk: t,
            fX: u
        };
    }), Bd = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Qd = function(n) {
        return n;
    }, Zd = function(n) {
        return 36e5 * n;
    }, nb = function(n) {
        return .001 * n;
    }, eb = F2(function(n, e) {
        return n / e;
    }), rb = F2(function(n, e) {
        return n / e;
    }), tb = A2(Bd, 0, {
        aN: A2(eb, Zd(0), 1),
        c5: A2(eb, Zd(123.08), 1),
        eN: ml(600),
        cG: A2(rb, nb(561.5), 1)
    }), ub = A2(Bd, 1, {
        aN: A2(eb, Zd(219.23), 1),
        c5: A2(eb, Zd(46.15), 1),
        eN: ml(600),
        cG: A2(rb, nb(210.6), 1)
    }), ab = A2(Bd, 2, {
        aN: A2(eb, Zd(415.38), 1),
        c5: A2(eb, Zd(61.54), 1),
        eN: ml(600),
        cG: A2(rb, nb(280.8), 1)
    }), ib = function(n) {
        switch(n){
            case "ambient":
                return Qr(tb);
            case "fresh":
                return Qr(ub);
            case "frozen":
                return Qr(ab);
            default:
                return Yr("Choix invalide pour la distribution : " + n);
        }
    }, cb = A2(Bt, A2(Hu, ib, ys), ai), ob = function(n) {
        return 1 - n;
    }, fb = .4, sb = function(n) {
        return 1e6 * n;
    }, lb = A([
        {
            br: !0,
            d2: v(Zd(.667), 1),
            eb: v(sb(0), 0),
            mj: "frying",
            ek: "Friture"
        },
        {
            br: !0,
            d2: v(Zd(.44), fb),
            eb: v(sb(1.584), ob(fb)),
            mj: "pan-cooking",
            ek: "Cuisson \xe0 la po\xeale"
        },
        {
            br: !1,
            d2: v(Zd(.08), fb),
            eb: v(sb(.288), ob(fb)),
            mj: "pan-warming",
            ek: "R\xe9chauffage \xe0 la po\xeale"
        },
        {
            br: !0,
            d2: v(Zd(.999), 1),
            eb: v(sb(0), 0),
            mj: "oven",
            ek: "Cuisson au four"
        },
        {
            br: !0,
            d2: v(Zd(.128), 1),
            eb: v(sb(0), 0),
            mj: "microwave",
            ek: "Cuisson au four micro-ondes"
        },
        {
            br: !1,
            d2: v(Zd(.0777), 1),
            eb: v(sb(0), 0),
            mj: "refrigeration",
            ek: "R\xe9frig\xe9ration"
        },
        {
            br: !1,
            d2: v(Zd(.294), 1),
            eb: v(sb(0), 0),
            mj: "freezing",
            ek: "Cong\xe9lation"
        }
    ]), db = function(n) {
        return n;
    }, bb = function(n) {
        return "Pr\xe9paration inconnue: " + n;
    }, mb = function(n) {
        return A2(el, n, A2(wu, db, A2(wu, function(n) {
            return n.mj;
        }, lb))) ? Qr(n) : Yr(bb(n));
    }, pb = A2(Bt, A2(Hu, mb, ys), ai), vb = F4(function(n, e, r, t) {
        return {
            i: n,
            mj: e,
            P: r,
            jo: t
        };
    }), gb = A2(Qt, ru, Ps), hb = function(n) {
        return .001 * n;
    }, $b = A2(Qt, hb, Vs), xb = A2(Bt, function(n) {
        switch(n){
            case "byPlane":
                return nu(0);
            case "noPlane":
                return nu(1);
            default:
                return Ii("Transport par avion inconnu\xa0: " + n);
        }
    }, ai), kb = A4(Zs, "byPlane", xb, 2, A3(Wa, "mass", $b, A3(Wa, "id", gb, A3(ui, "country", $s, nu(vb))))), jb = F2(function(n, e) {
        return {
            j: n,
            mj: e
        };
    }), yb = A2(Qt, ru, Ps), wb = A2(Qt, ru, Vs), Ab = A3(Zt, jb, A2(qu, "amount", wb), A2(qu, "id", yb)), Tb = F2(function(n, e) {
        return {
            mj: n,
            P: e
        };
    }), Eb = A3(Zt, Tb, A2(qu, "id", yb), A2(qu, "mass", $b)), Cb = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Ib = F3(function(n, e, r) {
        var t = function(n) {
            return Za(A([
                n,
                Qa(r)
            ]));
        };
        return A2(Bt, function(u) {
            var a = A2(ni, A2(sl, n, ei), u);
            if (a.$) return nu(r);
            var i = a.a, c = A2(ni, t(e), i);
            return c.$ ? A2(sl, n, t(e)) : nu(c.a);
        }, ei);
    }), Sb = F4(function(n, e, r, t) {
        return A2(Ya, A3(Ib, A([
            n
        ]), e, r), t);
    }), Ob = A3(ui, "transform", Eb, A4(Sb, "preparation", Cb(pb), j, A4(Sb, "packaging", Cb(Ab), j, A3(Wa, "ingredients", Cb(kb), A3(ui, "distribution", cb, nu(Kd)))))), Lb = A2(Hu, Wd, as(A2(Hu, ci(Ob), $a(yt)))), Pb = A2(Od, "QUERY", A2(Hu, Lb, A2(Hu, Ld, zr))), qb = F3(function(n, e, r) {
        return {
            $: 9,
            a: n,
            b: e,
            c: r
        };
    }), Nb = F2(function(n, e) {
        return {
            $: 10,
            a: n,
            b: e
        };
    }), _b = function(n) {
        return {
            $: 11,
            a: n
        };
    }, zb = F9(function(n, e, r, t, u, a, i, c, o) {
        return {
            q: n,
            aM: e,
            E: r,
            aO: t,
            my: u,
            aR: a,
            aS: i,
            dq: c,
            ax: o
        };
    }), Ub = F2(function(n, e) {
        return {
            i: n,
            bh: e
        };
    }), Mb = Za(A([
        A2(qu, "assembly", A3(ui, "operations", Cb(yb), A3(ui, "country", $s, nu(Ub)))),
        A2(Qt, function(n) {
            return $(Pf, {
                i: zr(n)
            });
        }, A2(qu, "assemblyCountry", $s)),
        nu(Pf)
    ])), Db = F2(function(n, e) {
        return {
            j: n,
            bl: e
        };
    }), Rb = A2(Qt, ru, Vs), Fb = Za(A([
        A2(Qt, Db(Ur), yb),
        A3(Wa, "processId", yb, A3(ui, "amount", Rb, nu(Db)))
    ])), Hb = function(n) {
        return n.f4;
    }, Gb = function(n) {
        var e = n.lv;
        return e.$ ? Hb(n) : e.a;
    }, Xb = {
        $: 9
    }, Vb = F2(function(n, e) {
        return A2(el, n, e.cP);
    }), Jb = Vb(Xb), Yb = F3(function(n, e, r) {
        return A2(at, e, A2(it, n, r));
    }), Wb = function(n) {
        var e = n;
        return 0 > e ? Yr("Une quantit\xe9 doit \xeatre sup\xe9rieure ou \xe9gale \xe0 z\xe9ro") : Qr(e);
    }, Kb = F2(function(n, e) {
        return A2(as, function(n) {
            var r = v(e.j, Jb(n));
            return r.a.$ ? r.b ? Qr(e) : Yr(A3(Yb, "{processName}", Gb(n), 'Le proc\xe9d\xe9 "{processName}" n\u2019etant pas productmassdependent, le champ amount est requis')) : r.b ? Yr(A3(Yb, "{processName}", Gb(n), 'Le proc\xe9d\xe9 "{processName}" \xe9tant productmassdependent, le champ amount n\'est pas accept\xe9')) : A2(fs, function(n) {
                return $(e, {
                    j: zr(n)
                });
            }, Wb(r.a.a));
        }, A2(Ns, e.bl, n));
    }), Bb = A2(Qt, ru, Ps), Qb = F4(function(n, e, r, t) {
        return {
            Y: n,
            mj: e,
            D: r,
            dH: t
        };
    }), Zb = F2(function(n, e) {
        return {
            r: n,
            ek: e
        };
    }), nm = F3(function(n, e, r) {
        return {
            j: n,
            U: e,
            J: r
        };
    }), em = A3(Wa, "id", yb, A3(ui, "country", $s, nu(F2(function(n, e) {
        return {
            i: n,
            mj: e
        };
    })))), rm = function(n) {
        return {
            i: Ur,
            mj: n
        };
    }, tm = Za(A([
        em,
        A2(Qt, rm, yb)
    ])), um = Za(A([
        Cb(em),
        Cb(A2(Qt, rm, yb))
    ])), am = A4(Sb, "transforms", um, j, A3(Wa, "material", tm, A3(Wa, "amount", Rb, nu(nm)))), im = A3(ui, "name", ai, A3(Wa, "elements", Cb(am), nu(Zb))), cm = A2(Bt, function(n) {
        return n.$ ? A2(Bt, function(n) {
            return n.$ ? nu(Ur) : A2(Qt, zr, im);
        }, A2(ri, "elements", ei)) : nu(zr(n.a));
    }, A2(ri, "custom", im)), om = A2(Qt, ru, A2(Bt, function(n) {
        return 1 > n ? Ii("La quantit\xe9 doit \xeatre un nombre entier positif") : nu(n);
    }, xi)), fm = A2(Bt, function(n) {
        return n > 0 ? nu(n) : Ii("La masse unitaire doit \xeatre strictement positive");
    }, Vs), sm = A3(ui, "unitMass", fm, A3(Wa, "quantity", om, A3(ui, "id", A2(Qt, ru, Ps), A2(Ya, cm, nu(Qb))))), lm = F2(function(n, e) {
        return {
            j: n,
            bl: e
        };
    }), dm = A3(Wa, "processId", yb, A3(Wa, "amount", Rb, nu(lm))), bm = A2(Qt, ru, dm), mm = function(n) {
        return n;
    }, pm = A2(Qt, mm, Vs), vm = F2(function(n, e) {
        return {
            a8: n,
            aN: e
        };
    }), gm = A3(ui, "cooling", Pu, A4(Sb, "byAir", Ws, 0, nu(vm))), hm = function(n) {
        return A2(Bt, function(e) {
            return A4(Sb, "transportOptions", gm, Uf, A4(Sb, "recyclable", Pu, !0, A3(ui, "product", Bb, A4(Sb, "packagings", Cb(bm), j, A3(Wa, "components", Cb(sm), A3(ui, "durability", pm, A3(ui, "distribution", yb, A3(ui, "consumptions", Cb(function(n) {
                return sf(n) ? Fb : function(n) {
                    return A2(Bt, A2(Hu, Kb(n), ys), Fb);
                }(n);
            }(n)), nu(zb(e))))))))));
        }, Mb);
    }, $m = A2(Hu, Wd, as(A2(Hu, ci(hm(j)), $a(yt)))), xm = A2(Od, "QUERY", A2(Hu, $m, A2(Hu, Ld, zr))), km = function(n) {
        switch(n){
            case "acd":
                return Qr(0);
            case "cch":
                return Qr(1);
            case "etf":
                return Qr(2);
            case "etf-c":
                return Qr(3);
            case "fru":
                return Qr(4);
            case "fwe":
                return Qr(5);
            case "htc":
                return Qr(6);
            case "htc-c":
                return Qr(7);
            case "htn":
                return Qr(8);
            case "htn-c":
                return Qr(9);
            case "ior":
                return Qr(10);
            case "ldu":
                return Qr(11);
            case "mru":
                return Qr(12);
            case "ozd":
                return Qr(13);
            case "pco":
                return Qr(14);
            case "pma":
                return Qr(15);
            case "swe":
                return Qr(16);
            case "tre":
                return Qr(17);
            case "wtu":
                return Qr(18);
            case "ecs":
                return Qr(19);
            default:
                return Yr("Trigramme d'impact inconnu\u202F: " + n);
        }
    }, jm = A2(Od, "TRIGRAM", function(n) {
        return Ld(km(n));
    }), ym = A2(Hu, Os, ks("UUID invalide")), wm = A2(Od, "EXAMPLE", A2(Hu, ym, Ld)), Am = function(n) {
        return function(e) {
            var r = e.cF, t = e.bJ, u = e.ct, a = e.b9, i = e.eT;
            if (t.b) {
                var c = t.a, o = t.b;
                return s(c, n) ? A([
                    A5(rd, A2(Mr, c, r), o, u, a, i)
                ]) : j;
            }
            return j;
        };
    }, Tm = F2(function(n, e) {
        var r = n, t = e;
        return function(n) {
            return A2(Id, t, r(n));
        };
    }), Em = F2(function(n, e) {
        return Sd(A([
            A2(Td, _b(n), A2(Tm, Am(e), Am("simulator"))),
            A2(Td, qb(n), A2(Tm, Am(e), A2(Tm, Am("simulator"), A2(Tm, jm, xm)))),
            A2(Td, Nb(n), A2(Tm, Am(e), A2(Tm, Am("edit-example"), wm)))
        ]));
    }), Cm = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Im = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Sm = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Om = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Lm = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), Pm = F2(function(n, e) {
        return {
            $: 7,
            a: n,
            b: e
        };
    }), qm = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Nm = function(n) {
        return {
            $: 10,
            a: n
        };
    }, _m = function(n) {
        switch(n){
            case "apparel-components":
                return A2(Cm, ds(0), Ur);
            case "apparel-examples":
                return A2(jd, 0, Ur);
            case "apparel-processes":
                return A2(Lm, ds(0), Ur);
            case "apparel-product-categories":
                return A2(Pm, 0, Ur);
            case "countries":
                return Im(Ur);
            case "food-examples":
                return kd(Ur);
            case "food-processes":
                return A2(Lm, ls, Ur);
            case "food2-examples":
                return A2(jd, 1, Ur);
            case "food2-processes":
                return A2(Lm, ds(1), Ur);
            case "food2-product-categories":
                return A2(Pm, 1, Ur);
            case "impacts":
                return Om(Ur);
            case "ingredients":
                return Sm(Ur);
            case "materials":
                return qm(Ur);
            case "object-components":
                return A2(Cm, ds(2), Ur);
            case "object-examples":
                return A2(jd, 2, Ur);
            case "object-processes":
                return A2(Lm, ds(2), Ur);
            case "object-product-categories":
                return A2(Pm, 2, Ur);
            case "processes":
            case "textile-processes":
                return A2(Lm, bs, Ur);
            case "products":
                return Nm(Ur);
            case "textile-components":
                return A2(Cm, bs, Ur);
            case "veli-components":
                return A2(Cm, ds(3), Ur);
            case "veli-examples":
                return A2(jd, 3, Ur);
            case "veli-processes":
                return A2(Lm, ds(3), Ur);
            case "veli-product-categories":
                return A2(Pm, 3, Ur);
            default:
                return yd(Ur);
        }
    }, zm = A2(Od, "DATASET", A2(Hu, _m, zr)), Um = F2(function(n, e) {
        return {
            $: 14,
            a: n,
            b: e
        };
    }), Mm = function(n) {
        switch(n){
            case "average":
                return Qr(0);
            case "continuous":
                return Qr(1);
            case "discontinuous":
                return Qr(2);
            default:
                return Yr("Type de teinture inconnu\u202F: " + n);
        }
    }, Dm = A2(Bt, A2(Hu, Mm, ys), ai), Rm = function(n) {
        switch(n){
            case "knitting-circular":
                return Qr(0);
            case "knitting-fully-fashioned":
                return Qr(1);
            case "knitting-integral":
                return Qr(2);
            case "knitting-mix":
                return Qr(3);
            case "knitting-straight":
                return Qr(4);
            case "weaving":
                return Qr(5);
            default:
                return Yr("Proc\xe9d\xe9 de tissage/tricotage inconnu: " + n);
        }
    }, Fm = A2(Bt, A2(Hu, Rm, ys), ai), Hm = function(n) {
        switch(n){
            case "high":
                return Qr(0);
            case "low":
                return Qr(1);
            case "medium":
                return Qr(2);
            case "not-applicable":
                return Qr(3);
            case "very-high":
                return Qr(4);
            case "very-low":
                return Qr(5);
            default:
                return Yr("Type de complexit\xe9 de fabrication inconnu\xa0: " + n);
        }
    }, Gm = A2(Bt, function(n) {
        return ys(Hm(n));
    }, ai), Xm = F2(function(n, e) {
        return {
            gJ: n,
            nX: e
        };
    }), Vm = function(n) {
        switch(n){
            case "pigment":
                return Qr(0);
            case "substantive":
                return Qr(1);
            default:
                return Yr("Type d'impression inconnu: " + n);
        }
    }, Jm = A2(Bt, A2(Hu, Vm, ys), ai), Ym = F3(function(n, e, r) {
        return 0 > m(r, n) || m(r, e) > 0 ? Yr("Cette proportion doit \xeatre comprise entre " + Js(n) + " et " + Js(e) + " inclus (ici\u202F: " + Js(r) + ")") : Qr(r);
    }), Wm = A2(Bt, A2(Hu, A2(Ym, 0, .8), ys), Vs), Km = A4(Sb, "ratio", Wm, .2, A3(Wa, "kind", Jm, nu(Xm))), Bm = function(n) {
        switch(n){
            case "small-business":
                return Qr(2);
            case "large-business-with-services":
                return Qr(0);
            case "large-business-without-services":
                return Qr(1);
            default:
                return Yr("Type d'entreprise inconnu : " + n);
        }
    }, Qm = A2(Bt, A2(Hu, Bm, ys), ai), Zm = A2(Ym, 0, 1), np = A2(Bt, A2(Hu, Zm, ys), Vs), ep = function(n) {
        switch(n){
            case "distribution":
                return Qr(0);
            case "ennobling":
                return Qr(2);
            case "end-of-life":
                return Qr(1);
            case "fabric":
                return Qr(3);
            case "making":
                return Qr(4);
            case "material":
                return Qr(5);
            case "spinning":
                return Qr(6);
            case "use":
                return Qr(7);
            default:
                return Yr("Code \xe9tape inconnu: " + n);
        }
    }, rp = A2(Bt, A2(Hu, ep, ys), ai), tp = F4(function(n, e, r, t) {
        return {
            i: n,
            mj: e,
            aH: r,
            dz: t
        };
    }), up = function(n) {
        switch(n){
            case "ConventionalSpinning":
                return Qr(0);
            case "SyntheticSpinning":
                return Qr(1);
            case "UnconventionalSpinning":
                return Qr(2);
            default:
                return Yr("Le proc\xe9d\xe9 de filature ou filage " + n + " n'est pas valide");
        }
    }, ap = A2(Bt, A2(Hu, up, ys), ai), ip = A2(Qt, ru, Ps), cp = A3(ui, "spinning", ap, A3(Wa, "share", np, A3(Wa, "id", ip, A3(ui, "country", $s, nu(tp))))), op = function(n) {
        return n;
    }, fp = A2(Qt, op, Vs), sp = ru, lp = A2(Qt, sp, Vs), dp = function(n) {
        return A2(eb, hb(n), 1);
    }, bp = A2(Qt, dp, xi), mp = vr($r), pp = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return Ur;
        var e = +n;
        return e == e ? zr(e) : Ur;
    }, vp = function(n) {
        return A2(eb, 1e4, hb(n));
    }, gp = function(n) {
        return A2(eb, ml(n), 1);
    }, hp = Za(A([
        A2(Qt, gp, Vs),
        A2(Bt, function(n) {
            return ys(A2(ks, "Titrage invalide: " + n, function(n) {
                var e = A2(Nc, Cs, Es("(\\d+)(Nm|Dtex)")), r = A2(wu, function(n) {
                    return n.oN;
                }, A2(mp, e, n)), t = pp(n);
                if (t.$) {
                    n: for(; r.b && r.a.b && !r.a.a.$ && r.a.b.b && !r.a.b.a.$ && !r.a.b.b.b && !r.b.b;)switch(r.a.b.a.a){
                        case "Nm":
                            return A2(Pc, gp, pp(r.a.a.a));
                        case "Dtex":
                            return A2(Pc, vp, pp(r.a.a.a));
                        default:
                            break n;
                    }
                    return Ur;
                }
                return zr(gp(t.a));
            }(n)));
        }, ai)
    ])), $p = A3(ui, "yarnSize", hp, A4(Sb, "upcycled", Pu, !1, A3(ui, "trims", Cb(sm), A3(ui, "surfaceMass", bp, A3(Wa, "product", A2(Qt, ru, ai), A3(ui, "printing", Km, A3(ui, "price", lp, A3(ui, "physicalDurability", fp, A3(ui, "numberOfReferences", xi, A3(Wa, "materials", Cb(cp), A3(Wa, "mass", A2(Qt, Ef, Vs), A3(ui, "makingWaste", np, A3(ui, "makingDeadStock", np, A3(ui, "makingComplexity", Gm, A3(ui, "fading", Pu, A3(ui, "fabricProcess", Fm, A3(ui, "dyeingProcessType", Dm, A4(Sb, "disabledSteps", Cb(rp), j, A3(ui, "countrySpinning", $s, A3(ui, "countryMaking", $s, A3(ui, "countryFabric", $s, A3(ui, "countryDyeing", $s, A3(ui, "business", Qm, A3(ui, "airTransportRatio", np, nu(function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return function($) {
                                                                                    return function(x) {
                                                                                        return function(k) {
                                                                                            return function(j) {
                                                                                                return function(y) {
                                                                                                    return {
                                                                                                        cJ: n,
                                                                                                        h_: e,
                                                                                                        by: r,
                                                                                                        bU: t,
                                                                                                        bV: u,
                                                                                                        cY: a,
                                                                                                        c0: i,
                                                                                                        c2: c,
                                                                                                        b6: o,
                                                                                                        c8: f,
                                                                                                        mV: s,
                                                                                                        dk: l,
                                                                                                        dl: d,
                                                                                                        P: b,
                                                                                                        ft: m,
                                                                                                        je: p,
                                                                                                        dn: v,
                                                                                                        jr: g,
                                                                                                        $7: h,
                                                                                                        aS: $,
                                                                                                        hj: x,
                                                                                                        pf: k,
                                                                                                        dI: j,
                                                                                                        pV: y
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))), xp = A2(Hu, Wd, as(A2(Hu, ci($p), $a(yt)))), kp = A2(Od, "QUERY", A2(Hu, xp, A2(Hu, Ld, zr))), jp = A2(Od, "STRING", zr), yp = A2(Td, F4(function(n, e, r, t) {
        return A2(Um, n, t);
    }), A2(Tm, Am("textile"), A2(Tm, Am("simulator"), A2(Tm, jm, A2(Tm, jp, A2(Tm, jp, kp)))))), wp = Sd(A([
        yp,
        A2(Td, Um, A2(Tm, Am("textile"), A2(Tm, Am("simulator"), A2(Tm, jm, kp))))
    ])), Ap = function(n) {
        return A([
            n
        ]);
    }, Tp = Sd(A([
        A2(Td, gd, Ap),
        A2(Td, od, Am("api")),
        A2(Td, fd, Am("auth")),
        A2(Td, sd, A2(Tm, Am("auth"), A2(Tm, jp, jp))),
        A2(Td, ld, A2(Tm, Am("auth"), Am("signup"))),
        A2(Td, dd, A2(Tm, Am("pages"), jp)),
        A2(Td, hd, Am("stats")),
        A2(Td, function(n) {
            return A2(bd, n, wd(n));
        }, A2(Tm, Am("explore"), Pd)),
        A2(Td, bd, A2(Tm, Am("explore"), A2(Tm, Pd, zm))),
        A2(Em, 0, "apparel"),
        A2(Em, 1, "food2"),
        A2(Em, 2, "object"),
        A2(Em, 3, "veli"),
        A2(Td, vd, Am("food")),
        A2(Td, md, A2(Tm, Am("food"), A2(Tm, jm, Pb))),
        A2(Td, pd, A2(Tm, Am("food"), A2(Tm, Am("edit-example"), wm))),
        A2(Td, xd, A2(Tm, Am("textile"), Am("simulator"))),
        wp,
        A2(Td, $d, A2(Tm, Am("textile"), A2(Tm, Am("edit-example"), wm)))
    ])), Ep = F2(function(n, e) {
        return {
            bq: j,
            bS: Cc,
            ei: e,
            ey: n
        };
    }), Cp = ee("loadRapidoc", function() {
        return zu;
    }), Ip = ee("scrollTo", function(n) {
        return qc(A([
            v("x", No(n.pT)),
            v("y", No(n.pU))
        ]));
    }), Sp = F2(function(n, e) {
        return $(e, {
            bS: Mu(A([
                e.bS,
                Mu(n)
            ]))
        });
    }), Op = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), Lp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Pp = F3(function(n, e, r) {
        return {
            $: 12,
            a: n,
            b: e,
            c: r
        };
    }), qp = F3(function(n, e, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r
        };
    }), Np = {
        bZ: !1,
        aY: !1,
        aD: "",
        aE: ""
    }, _p = F2(function(n, e) {
        return A2(Ep, n, {
            j$: !1,
            u: A3(qp, e, Np, Qu)
        });
    }), zp = F2(function(n, e) {
        return {
            mj: n,
            mI: e
        };
    }), Up = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Mp = F3(function(n, e, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r
        };
    }), Dp = F2(function(n, e) {
        var r = e;
        return function(e) {
            var t = r(e);
            if (1 === t.$) return A2(Up, t.a, t.b);
            var u = t.a, a = t.c, i = n(t.b)(a);
            if (1 === i.$) {
                var c = i.a;
                return A2(Up, u || c, i.b);
            }
            return c = i.a, A3(Mp, u || c, i.b, i.c);
        };
    }), Rp = Dp, Fp = {
        $: 10
    }, Hp = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Gp = F4(function(n, e, r, t) {
        return {
            h5: e,
            k3: t,
            nS: r,
            oi: n
        };
    }), Xp = {
        $: 0
    }, Vp = F2(function(n, e) {
        return A2(Hp, Xp, A4(Gp, n.oi, n.h5, e, n.k2));
    }), Jp = function(n) {
        return function(e) {
            return s(iu(e.hf), e.h) ? A3(Mp, !1, 0, e) : A2(Up, !1, A2(Vp, e, n));
        };
    }, Yp = Jp(Fp), Wp = kr, Kp = F5(function(n, e, r, t, u) {
        for(;;){
            var a = A3(Wp, n, e, u.hf);
            if (s(a, -1)) return A3(Mp, 0 > m(u.h, e), 0, {
                h5: t,
                k2: u.k2,
                v: u.v,
                h: e,
                oi: r,
                hf: u.hf
            });
            s(a, -2) ? (e += 1, r += 1, t = 1) : (e = a, t += 1);
        }
    }), Bp = function(n) {
        return function(e) {
            return A5(Kp, n, e.h, e.oi, e.h5, e);
        };
    }, Qp = Bp, Zp = F2(function(n, e) {
        var r = e;
        return function(e) {
            var t = r(e);
            if (1 === t.$) return A2(Up, t.a, t.b);
            var u = t.b, a = t.c;
            return A3(Mp, t.a, A2(n, A3(cu, e.h, a.h, e.hf), u), a);
        };
    }), nv = function(n) {
        return A2(Zp, Wi, n);
    }, ev = nv, rv = function(n) {
        return {
            $: 12,
            a: n
        };
    }, tv = function(n) {
        return function(e) {
            return A2(Up, !1, A2(Vp, e, n));
        };
    }, uv = function(n) {
        return tv(rv(n));
    }, av = function(n) {
        return function(e) {
            return A3(Mp, !1, n, e);
        };
    }, iv = av, cv = A2(Rp, function(n) {
        if (iu(n) > 9) return uv("Expected at most 9 digits, but got " + ut(iu(n)));
        var e = pp("0." + n);
        return e.$ ? uv('Invalid float: "' + n + '"') : iv(yf(1e3 * e.a));
    }, ev(Qp(ht))), ov = F6(function(n, e, r, t, u, a) {
        return uc(n + 60 * e * 60000 + 60 * (r - a) * 1e3 + 1e3 * t + u);
    }), fv = F3(function(n, e, r) {
        var t = e, u = r;
        return function(e) {
            var r = t(e);
            if (1 === r.$) return A2(Up, r.a, r.b);
            var a = r.a, i = r.b, c = u(r.c);
            if (1 === c.$) {
                var o = c.a;
                return A2(Up, a || o, c.b);
            }
            o = c.a;
            var f = c.c;
            return A3(Mp, a || o, A2(n, i, c.b), f);
        };
    }), sv = F2(function(n, e) {
        return A3(fv, Wi, n, e);
    }), lv = sv, dv = F2(function(n, e) {
        return A3(fv, Nt, n, e);
    }), bv = dv, mv = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), pv = F3(function(n, e, r) {
        n: for(;;){
            if (r.b) {
                var t = r.b, u = (0, r.a)(n);
                if (u.$) {
                    var a;
                    if ((a = u).a) return a;
                    e = A2(mv, e, a.b), r = t;
                    continue n;
                }
                return u;
            }
            return A2(Up, !1, e);
        }
    }), vv = function(n) {
        return function(e) {
            return A3(pv, e, Xp, n);
        };
    }, gv = vv, hv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $v = R, xv = {
        $: 11
    }, kv = F2(function(n, e) {
        return function(r) {
            var t = A3(Wp, n, r.h, r.hf);
            return s(t, -1) ? A2(Up, !1, A2(Vp, r, e)) : s(t, -2) ? A3(Mp, !0, 0, {
                h5: 1,
                k2: r.k2,
                v: r.v,
                h: r.h + 1,
                oi: r.oi + 1,
                hf: r.hf
            }) : A3(Mp, !0, 0, {
                h5: r.h5 + 1,
                k2: r.k2,
                v: r.v,
                h: t,
                oi: r.oi,
                hf: r.hf
            });
        };
    }), jv = F4(function(n, e, r, t) {
        for(;;){
            var u = r(e)(t);
            if (u.$) return a = u.a, A2(Up, n || a, u.b);
            var a = u.a, i = u.b, c = u.c;
            if (i.$) return A3(Mp, n || a, i.a, c);
            n = n || a, e = i.a, t = c;
        }
    }), yv = F2(function(n, e) {
        return function(r) {
            return A4(jv, !1, n, e, r);
        };
    }), wv = F2(function(n, e) {
        var r = e;
        return function(e) {
            var t = r(e);
            if (t.$) return A2(Up, t.a, t.b);
            var u = t.c;
            return A3(Mp, t.a, n(t.b), u);
        };
    }), Av = wv, Tv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ev = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Cv = function(n) {
        return n.$ ? Tv(n.a) : Ev(n.a);
    }, Iv = F2(function(n, e) {
        return A2(yv, n, function(n) {
            return A2(Av, Cv, e(n));
        });
    }), Sv = function(n) {
        var e = function(e) {
            if (s(iu(e), n)) {
                var r = du(e);
                return r.$ ? uv('Invalid integer: "' + e + '"') : A2(Av, hv, iv(r.a));
            }
            return A2(Av, function(n) {
                return function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(A2($v, e, n));
            }, ev(A2(kv, ht, xv)));
        };
        return A2(Iv, "", e);
    }, Ov = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Lv = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Pv = xr, qv = function(n) {
        var e = n.a, r = n.b, t = !su(e);
        return function(n) {
            var u = A5(Pv, e, n.h, n.oi, n.h5, n.hf), a = u.a, i = u.b, c = u.c;
            return s(a, -1) ? A2(Up, !1, A2(Vp, n, r)) : A3(Mp, t, 0, {
                h5: c,
                k2: n.k2,
                v: n.v,
                h: a,
                oi: i,
                hf: n.hf
            });
        };
    }, Nv = qv, _v = function(n) {
        return Nv(A2(Lv, n, Ov(n)));
    }, zv = function(n) {
        return uv("Invalid day: " + ut(n));
    }, Uv = function(n) {
        return !(A2(Uc, 4, n) || !A2(Uc, 100, n) && A2(Uc, 400, n));
    }, Mv = function(n) {
        var e = n - 1;
        return (e / 4 | 0) - (e / 100 | 0) + (e / 400 | 0);
    }, Dv = function(n) {
        var e = n.a, r = n.b, t = n.c;
        if (0 > t) return zv(t);
        var u = function(n) {
            var u = 31536e6 * (e - 1970), a = 864e5 * ((3 > r || !Uv(e) ? t - 1 : t) + (Mv(e) - Mv(1970)));
            return iv(n + u + a);
        };
        switch(r){
            case 1:
                return t > 31 ? zv(t) : u(0);
            case 2:
                return t > 29 || 29 === t && !Uv(e) ? zv(t) : u(26784e5);
            case 3:
                return t > 31 ? zv(t) : u(50976e5);
            case 4:
                return t > 30 ? zv(t) : u(7776e6);
            case 5:
                return t > 31 ? zv(t) : u(10368e6);
            case 6:
                return t > 30 ? zv(t) : u(130464e5);
            case 7:
                return t > 31 ? zv(t) : u(156384e5);
            case 8:
                return t > 31 ? zv(t) : u(183168e5);
            case 9:
                return t > 30 ? zv(t) : u(209952e5);
            case 10:
                return t > 31 ? zv(t) : u(235872e5);
            case 11:
                return t > 30 ? zv(t) : u(262656e5);
            case 12:
                return t > 31 ? zv(t) : u(288576e5);
            default:
                return uv('Invalid month: "' + ut(r) + '"');
        }
    }, Rv = A2(Rp, Dv, A2(bv, A2(bv, A2(bv, iv(F3(function(n, e, r) {
        return g(n, e, r);
    })), Sv(4)), gv(A([
        A2(bv, A2(lv, iv(ru), _v("-")), Sv(2)),
        Sv(2)
    ]))), gv(A([
        A2(bv, A2(lv, iv(ru), _v("-")), Sv(2)),
        Sv(2)
    ])))), Fv = (sc = F3(function(n, e, r) {
        return n * (60 * e) + r;
    }), A2(bv, iv(ru), gv(A([
        A2(Av, function() {
            return 0;
        }, _v("Z")),
        A2(bv, A2(bv, A2(bv, iv(sc), gv(A([
            A2(Av, function() {
                return 1;
            }, _v("+")),
            A2(Av, function() {
                return -1;
            }, _v("-"))
        ]))), Sv(2)), gv(A([
            A2(bv, A2(lv, iv(ru), _v(":")), Sv(2)),
            Sv(2),
            iv(0)
        ]))),
        A2(lv, iv(0), Yp)
    ])))), Hv = A2(Rp, function(n) {
        return gv(A([
            A2(bv, A2(bv, A2(bv, A2(bv, A2(bv, A2(lv, iv(ov(n)), _v("T")), Sv(2)), gv(A([
                A2(bv, A2(lv, iv(ru), _v(":")), Sv(2)),
                Sv(2)
            ]))), gv(A([
                A2(bv, A2(lv, iv(ru), _v(":")), Sv(2)),
                Sv(2),
                iv(0)
            ]))), gv(A([
                A2(bv, A2(lv, iv(ru), _v(".")), cv),
                iv(0)
            ]))), A2(lv, Fv, Yp)),
            A2(lv, iv(A6(ov, n, 0, 0, 0, 0, 0)), Yp)
        ]));
    }, Rv), Gv = F3(function(n, e, r) {
        return {
            h5: e,
            nS: r,
            oi: n
        };
    }), Xv = function(n) {
        return A3(Gv, n.oi, n.h5, n.nS);
    }, Vv = F2(function(n, e) {
        n: for(;;)switch(n.$){
            case 0:
                return e;
            case 1:
                var r = n.b;
                n = n.a, e = A2(Mr, r, e);
                continue n;
            default:
                var t = n.b;
                n = n.a, e = A2(Vv, t, e);
                continue n;
        }
    }), Jv = F2(function(n, e) {
        var r = n({
            h5: 1,
            k2: j,
            v: 1,
            h: 0,
            oi: 1,
            hf: e
        });
        return r.$ ? Yr(A2(Vv, r.b, j)) : Qr(r.b);
    }), Yv = F2(function(n, e) {
        var r = A2(Jv, n, e);
        return r.$ ? Yr(A2(wu, Xv, r.a)) : Qr(r.a);
    }), Wv = A2(Bt, function(n) {
        var e = A2(Yv, Hv, n);
        return e.$ ? Ii("Expecting an ISO-8601 formatted date+time string") : nu(e.a);
    }, ai), Kv = A3(ui, "lastAccessedAt", Wv, A3(Wa, "id", ai, nu(zp))), Bv = F2(function(n, e) {
        return A2(at, "/", A([
            n.kY,
            "backend",
            "api",
            e
        ]));
    }), Qv = F4(function(n, e, r, t) {
        return Da({
            kO: Aa,
            lU: A2(Al, A2(Hu, wa, r), t),
            mc: kl(n),
            m1: "GET",
            oY: Ur,
            pc: Ur,
            a6: A2(Bv, n, e)
        });
    }), Zv = F2(function(n, e) {
        return A4(Qv, n, "tokens", e, Cb(Kv));
    }), ng = F5(function(n, e, r, t, u) {
        return {
            aY: n,
            aD: e,
            aE: r,
            cq: t,
            oW: u
        };
    }), eg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rg = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), tg = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ug = {
        $: 3
    }, ag = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ig = function(n) {
        return {
            $: 5,
            a: n
        };
    }, cg = function(n) {
        return {
            $: 6,
            a: n
        };
    }, og = function(n) {
        return {
            $: 7,
            a: n
        };
    }, fg = F2(function(n, e) {
        return A2(Bt, function(n) {
            return s(n, e) ? nu(e) : Ii("Unmatched expected value");
        }, n);
    }), sg = G, lg = function(n) {
        return A3(sg, Mr, j, n);
    }, dg = function(n) {
        if (9 !== iu(n)) return Yr("Le num\xe9ro SIREN doit contenir exactement 9 chiffres");
        if (A2(et, ht, n)) {
            var e = A2(wu, A2(Hu, Jc, A2(Hu, du, Nc(0))), lg(n)), r = tl(A2(bt, F2(function(n, e) {
                if (1 === A2(Uc, 2, n)) {
                    var r = 2 * e;
                    return r > 9 ? r - 9 : r;
                }
                return e;
            }), e));
            return A2(Uc, 10, r) ? Yr("Le num\xe9ro SIREN est invalide") : Qr(n);
        }
        return Yr("Le num\xe9ro SIREN ne doit contenir que des chiffres");
    }, bg = A2(Bt, A2(Hu, dg, ys), ai), mg = Za(A2(Mr, A3(Wa, "siren", bg, A3(Wa, "name", ai, A3(Wa, "type", A2(fg, ai, "business"), nu(F3(function(n, e, r) {
        return A2(rg, e, r);
    }))))), k(A2(wu, function(n) {
        var e = n.b;
        return A3(Wa, "name", ai, A3(Wa, "type", A2(fg, ai, n.a), nu(F2(function(n, r) {
            return e(r);
        }))));
    }, A([
        v("association", eg),
        v("education", tg),
        v("localAuthority", ag),
        v("media", ig),
        v("public", cg),
        v("student", og)
    ])), A([
        A3(Wa, "type", A2(fg, ai, "individual"), nu(Wi(ug)))
    ])))), pg = A3(Wa, "termsAccepted", Pu, A3(Wa, "organization", mg, A4(Zs, "lastName", ai, "", A4(Zs, "firstName", ai, "", A4(Zs, "emailOptin", Pu, !1, nu(ng)))))), vg = F4(function(n, e, r, t) {
        return {
            hQ: n,
            jK: e,
            jL: r,
            jM: t
        };
    }), gg = A3(Wa, "roleSlug", ai, A3(Wa, "roleName", ai, A3(Wa, "roleId", ai, A3(Wa, "assignedAt", Wv, nu(vg))))), hg = A3(Wa, "roles", Cb(gg), A3(Wa, "profile", pg, A3(ui, "magicLinkSentAt", Wv, A3(ui, "lastLoginAt", Wv, A3(ui, "joinedAt", Wv, A3(Wa, "isVerified", Pu, A3(Wa, "isSuperuser", Pu, A4(Sb, "isBetauser", Pu, !1, A3(Wa, "isActive", Pu, A3(Wa, "id", A2(Qt, ru, Ps), A4(Sb, "hasActiveToken", Pu, !1, A3(Wa, "email", ai, nu(function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        c4: n,
                                                        iI: e,
                                                        mj: r,
                                                        iW: t,
                                                        iY: u,
                                                        mx: a,
                                                        iZ: i,
                                                        i0: c,
                                                        mJ: o,
                                                        i4: f,
                                                        nT: s,
                                                        jN: l
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), $g = F2(function(n, e) {
        return A4(Qv, n, "me", e, hg);
    }), xg = F2(function(n, e) {
        return A2(Sp, A([
            A2($g, n, A2(Pp, {
                eS: !1
            }, e.f3)),
            A2(Zv, n, Lp)
        ]), A2(_p, n, e));
    }), kg = F2(function(n, e) {
        return A2(Sp, A([
            Ip({
                pT: 0,
                pU: 0
            }),
            Ra({
                lU: ka(A2(Hu, wa, ru)),
                a6: "pages/" + n + ".md"
            })
        ]), A2(Ep, e, {
            h9: Fa,
            aI: n
        }));
    }), jg = ee("addBodyClass", Sc), yg = ee("removeBodyClass", Sc), wg = F2(function(n, e) {
        return A2(Sp, A([
            hc(e.aA) ? jg("prevent-scrolling") : yg("prevent-scrolling")
        ]), A2(Ep, n, e));
    }), Ag = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Tg = F3(function(n, e, r) {
        var t, u = function() {
            switch(e.$){
                case 0:
                case 1:
                case 6:
                    return "Nom";
                case 2:
                case 4:
                case 8:
                    return "Co\xfbt Environnemental";
                case 3:
                case 9:
                default:
                    return "Identifiant";
                case 5:
                    return "Code";
                case 7:
                    return "Cat\xe9gorie de produit";
            }
        }();
        return A2(wg, r, {
            aA: e,
            c7: Qu,
            at: n,
            du: "",
            fQ: (t = u, A2(Ag, t, !1))
        });
    }), Eg = F2(function(n, e) {
        return A2(Sp, A([
            5 === e.ad.$ ? yg("prevent-scrolling") : jg("prevent-scrolling")
        ]), A2(Ep, n, e));
    }), Cg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ig = function(n) {
        return xs(A2(Hu, function(n) {
            return n.g5;
        }, zt(n)));
    }, Sg = function(n) {
        return Ig(Cg(n));
    }, Og = F5(function(n, e, r, t, u) {
        return {
            E: n,
            mq: e,
            cs: r,
            bk: t,
            fX: u
        };
    }), Lg = F2(function(n, e) {
        var r = v(n, e);
        return 1 === r.b.$ ? Yr(r.b.a) : A2(fs, r.b.a, r.a);
    }), Pg = F3(function(n, e, r) {
        for(;;){
            if (!e.b) return Qr(xt(r));
            var t = e.b, u = n(e.a);
            if (u.$) return Yr(u.a);
            e = t, r = A2(Mr, u.a, r);
        }
    }), qg = F2(function(n, e) {
        return A3(Pg, n, e, j);
    }), Ng = F4(function(n, e, r, t) {
        return {
            i: n,
            a_: e,
            P: r,
            jo: t
        };
    }), _g = function(n) {
        return 4 === n.gp ? 0 : 2;
    }, zg = F2(function(n, e) {
        var r = v(n, _g(e));
        n: for(;;)switch(r.a){
            case 0:
                if (2 === r.b) return Yr("Impossible de sp\xe9cifier un acheminement par avion pour cet ingr\xe9dient, son origine par d\xe9faut ne le permet pas.");
                break n;
            case 2:
                if (r.b) break n;
                return Qr(0);
            default:
                break n;
        }
        return Qr(n);
    }), Ug = function(n) {
        return df(n);
    }, Mg = F2(function(n, e) {
        return A2(ks, "Ingr\xe9dient introuvable par id : " + Ug(n), A2(xs, A2(Hu, function(n) {
            return n.mj;
        }, zt(n)), e));
    }), Dg = F2(function(n, e) {
        var r, t = e.i, u = e.P, a = e.jo, i = A2(Mg, e.mj, n.l5.mq);
        return A2(Lg, A2(as, zg(a), i), A2(Lg, Qr(u), A2(Lg, i, A2(Lg, (r = A2(Pc, function(e) {
            return A2(js, e, n.bT);
        }, t)).$ ? Qr(Ur) : r.a.$ ? Yr(r.a.a) : Qr(zr(r.a.a)), Qr(Ng)))));
    }), Rg = function(n) {
        return A2(Hu, function(n) {
            return n.mq;
        }, qg(Dg(n)));
    }, Fg = F2(function(n, e) {
        return {
            j: n,
            t: e
        };
    }), Hg = F2(function(n, e) {
        var r = n.W, t = e.mj;
        return A2(fs, Fg(e.j), A2(Ns, t, r));
    }), Gg = F2(function(n, e) {
        return A2(qg, Hg(n), e.cs);
    }), Xg = F2(function(n, e) {
        for(;;){
            if (!n.b) return Qr(xt(e));
            var r = n.a, t = n.b;
            if (r.$) return Yr(r.a);
            n = t, e = A2(Mr, r.a, e);
        }
    }), Vg = function(n) {
        return A2(Xg, n, j);
    }, Jg = A2(Hu, function(n) {
        return n.bk;
    }, A2(Hu, wu(function(n) {
        return A2(ks, bb(n), A2(xs, A2(Hu, function(n) {
            return n.mj;
        }, zt(n)), lb));
    }), Vg)), Yg = F2(function(n, e) {
        return {
            P: n,
            t: e
        };
    }), Wg = F2(function(n, e) {
        var r = n.W;
        return A2(Nc, Qr(Ur), A2(Pc, function(n) {
            var e = n.mj;
            return A2(fs, A2(Hu, Yg(n.P), zr), A2(Ns, e, r));
        }, e.fX));
    }), Kg = F2(function(n, e) {
        return A2(Lg, A2(Wg, n, e), A2(Lg, Jg(e), A2(Lg, A2(Gg, n, e), A2(Lg, A2(Rg, n, e), A2(Lg, Qr(e.E), Qr(Og))))));
    }), Bg = function(n) {
        return su(n) ? Ur : zr(n);
    }, Qg = function(n) {
        var e = n.mq, r = n.cs, t = n.fX, u = A2(Hu, zo, A2(Hu, yf, ut));
        return A2(at, "; ", A2(qa, ru, A([
            Bg(A2(at, ", ", A2(wu, function(n) {
                return n.a_.ek + " (" + u(n.P) + "g.)";
            }, e))),
            A2(Pc, function(n) {
                var e = n.P;
                return Gb(n.t) + "(" + u(e) + ")";
            }, t),
            A2(Pc, rt("Emballage: "), Bg(A2(at, ", ", A2(wu, A2(Hu, function(n) {
                return n.t;
            }, Gb), r))))
        ])));
    }, Zg = F2(function(n, e) {
        return e.$ ? n : e.a;
    }), nh = F2(function(n, e) {
        var r = n.bH;
        return A2(Nc, A2(Zg, "", A2(fs, Qg, A2(Kg, n.C, e))), A2(Pc, function(n) {
            return n.ek;
        }, A2(Sg, e, r.ap)));
    }), eh = F2(function(n, e) {
        switch(n){
            case 0:
                return e.bM;
            case 1:
                return e.bR;
            case 2:
                return e.b3;
            case 3:
                return e.b4;
            case 4:
                return e.ca;
            case 5:
                return e.cb;
            case 6:
                return e.cd;
            case 7:
                return e.ce;
            case 8:
                return e.cf;
            case 9:
                return e.cg;
            case 10:
                return e.ci;
            case 11:
                return e.ck;
            case 12:
                return e.cp;
            case 13:
                return e.cr;
            case 14:
                return e.cu;
            case 15:
                return e.cv;
            case 16:
                return e.cz;
            case 17:
                return e.cD;
            case 18:
                return e.cH;
            default:
                return e.b_;
        }
    }), rh = F2(function(n, e) {
        return $(e, {
            an: $(e.an, {
                l5: n
            })
        });
    }), th = F3(function(n, e, r) {
        var t = A2(Nc, n.an.l5, r), u = A2(eh, e, n.C.c_);
        return A2(Eg, A2(rh, t, n), {
            dN: 1,
            cN: Ur,
            bv: Ur,
            bw: Ur,
            bx: A2(nh, n, t),
            dW: 1,
            cT: Nl(n) ? 2 : 1,
            O: u,
            dd: t,
            ad: xc
        });
    }), uh = F2(function(n, e) {
        return e + n;
    }), ah = function(n) {
        return A3(ot, uh, 0, n);
    }, ih = {
        ag: Ur,
        aa: Ur,
        ah: Ur,
        aj: Ur,
        ak: Ur,
        al: Ur,
        am: Ur
    }, ch = F2(function(n, e) {
        return A2(eh, n, e);
    }), oh = F2(function(n, e) {
        return {
            bM: A2(n, 0, e.bM),
            bR: A2(n, 1, e.bR),
            b_: A2(n, 19, e.b_),
            b3: A2(n, 2, e.b3),
            b4: A2(n, 3, e.b4),
            ca: A2(n, 4, e.ca),
            cb: A2(n, 5, e.cb),
            cd: A2(n, 6, e.cd),
            ce: A2(n, 7, e.ce),
            cf: A2(n, 8, e.cf),
            cg: A2(n, 9, e.cg),
            ci: A2(n, 10, e.ci),
            ck: A2(n, 11, e.ck),
            cp: A2(n, 12, e.cp),
            cr: A2(n, 13, e.cr),
            cu: A2(n, 14, e.cu),
            cv: A2(n, 15, e.cv),
            cz: A2(n, 16, e.cz),
            cD: A2(n, 17, e.cD),
            cH: A2(n, 18, e.cH)
        };
    }), fh = F2(function(n, e) {
        return A2(oh, n, e);
    }), sh = (lc = F2(function(n, e) {
        return fh(F2(function(r, t) {
            return ah(A([
                A2(ch, r, A2(Nc, Ks, e(n))),
                t
            ]));
        }));
    }), dc = F3(function(n, e, r) {
        var t = A3(lc, e, r, A2(Nc, Ks, r(n)));
        return s(t, Ks) ? Ur : zr(t);
    }), A2(ot, F2(function(n, e) {
        return {
            ag: A3(dc, n, e, function(n) {
                return n.ag;
            }),
            aa: A3(dc, n, e, function(n) {
                return n.aa;
            }),
            ah: A3(dc, n, e, function(n) {
                return n.ah;
            }),
            aj: A3(dc, n, e, function(n) {
                return n.aj;
            }),
            ak: A3(dc, n, e, function(n) {
                return n.ak;
            }),
            al: A3(dc, n, e, function(n) {
                return n.al;
            }),
            am: A3(dc, n, e, function(n) {
                return n.am;
            })
        };
    }), ih)), lh = A2(ot, function(n) {
        return fh(F2(function(e, r) {
            return ah(A([
                A2(ch, e, n),
                r
            ]));
        }));
    }, Ks), dh = F2(function(n, e) {
        var r = n, t = e;
        return $(t, {
            S: sh(A([
                r.S,
                t.S
            ])),
            g: lh(A([
                r.g,
                t.g
            ])),
            my: A2(Mr, r, t.my),
            P: ah(A([
                r.P,
                t.P
            ])),
            av: Ur
        });
    }), bh = F2(function(n, e) {
        return n * e;
    }), mh = function(n) {
        return n;
    }, ph = F2(function(n, e) {
        return A2(bh, n, e);
    }), vh = function(n) {
        return n / 36e5;
    }, gh = function(n) {
        return n / 1e6;
    }, hh = F2(function(n, e) {
        return e * n;
    }), $h = function(n) {
        return fh(function() {
            return bh(n);
        });
    }, xh = F4(function(n, e, r, t) {
        var u = r.d2, a = r.eb, i = t.j, c = t.ai, o = t.g, f = t.my, s = t.P, l = t.S, d = A2($h, i, lh(A([
            e.g,
            A2($h, vh(e.d2), u.g),
            A2($h, gh(e.eb), a.g)
        ]))), b = A2(ph, e.g4, s), m = A2(hh, e.g4, i);
        return {
            j: m,
            S: l,
            g: lh(A([
                d,
                o
            ])),
            my: k(f, A([
                {
                    j: m,
                    S: ih,
                    g: d,
                    my: j,
                    ai: zr(Gb(e)),
                    P: b,
                    aF: Ur,
                    D: 1,
                    av: zr(n)
                }
            ])),
            ai: c,
            P: b,
            aF: Ur,
            D: 1,
            av: Ur
        };
    }), kh = F2(function(n, e) {
        return {
            d2: n,
            eb: e
        };
    }), jh = function(n) {
        return A2(Hu, Pc(function(n) {
            return Qr(A2(kh, n.lO, n.me));
        }), Nc(Qr({
            d2: n.Q.ii,
            eb: n.Q.ij
        })));
    }, yh = F2(function(n, e) {
        return n.$ ? Qr(Ur) : A2(fs, zr, A2(js, n.a, e));
    }), wh = F2(function(n, e) {
        return !A2(nl, A2(cc, rl, n), e);
    }), Ah = F2(function(n, e) {
        return A3(yu, F2(function(e, r) {
            return n(e) ? A2(Mr, e, r) : r;
        }), j, e);
    }), Th = function(n) {
        switch(n){
            case 0:
                return "m3";
            case 1:
                return "Item(s)";
            case 2:
                return "kg";
            case 3:
                return "kWh";
            case 4:
                return "L";
            case 5:
                return "MJ";
            case 6:
                return "m2";
            default:
                return "t\u22C5km";
        }
    }, Eh = F4(function(n, e, r, t) {
        var u;
        return A2(as, function(r) {
            return A2(as, A2(Hu, jh(n.az), as(function(n) {
                return A3(ot, function(e) {
                    return fs(A3(xh, 0, e.t, n));
                }, Qr(t), r);
            })), A2(yh, e, n.C.bT));
        }, (u = r, A2(wh, A2(Hu, function(n) {
            return n.t;
        }, A2(Hu, function(n) {
            return n.aL;
        }, zt(2))), u) ? Qr(u) : Yr("Les proc\xe9d\xe9s d\u2019assemblage doivent \xeatre exprim\xe9s en kg\xa0: " + A2(at, ", ", A2(wu, function(n) {
            var e = n.t;
            return Gb(e) + " (" + Th(e.aL) + ")";
        }, A2(Ah, A2(Hu, function(n) {
            return n.t;
        }, A2(Hu, function(n) {
            return n.aL;
        }, Ic(2))), u))))));
    }), Ch = ru, Ih = {
        j: Ch(0),
        S: ih,
        g: Ks,
        my: j,
        ai: Ur,
        P: 0,
        aF: Ur,
        D: 1,
        av: Ur
    }, Sh = F3(function(n, e, r) {
        var t = n.W;
        return A2(as, function(n) {
            return A2(qg, function(e) {
                return A2(fs, function(e) {
                    return {
                        i: n,
                        t: e
                    };
                }, A2(Ns, e, t));
            }, r);
        }, A2(yh, e, n.bT));
    }), Oh = function(n) {
        return n.P;
    }, Lh = function(n) {
        return df(n);
    }, Ph = function(n) {
        return A2(Hu, xs(A2(Hu, function(n) {
            return n.mj;
        }, zt(n))), ks("Cat\xe9gorie de produit introuvable id=" + Lh(n) + "."));
    }, qh = F2(function(n, e) {
        var r = n.C, t = e.q.bh;
        return t.$ ? A2(Nc, j, A2(Ba, function(n) {
            return A2(Pc, function(n) {
                return n.q;
            }, Ld(A2(Ph, n, r.dp)));
        }, e.aS)) : t.a;
    }), Nh = F3(function(n, e, r) {
        var t = e.q, u = Oh(r.Q), a = A2(qh, n, e);
        return sf(a) ? Qr($(r, {
            q: Ih,
            aT: u
        })) : A2(as, function(e) {
            var a;
            return A2(fs, function(n) {
                return $(r, {
                    q: n,
                    aT: Oh(n)
                });
            }, A4(Eh, n, t.i, e, {
                j: Ch(a = u),
                S: ih,
                g: Ks,
                my: j,
                ai: zr("Assembly"),
                P: a,
                aF: Ur,
                D: 1,
                av: Ur
            }));
        }, A3(Sh, n.C, t.i, a));
    }), _h = F2(function(n, e) {
        return e / n;
    }), zh = A2(Hu, _h(1e3), A2(Hu, _o, Qd)), Uh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mh = {
        $: 1
    }, Dh = {
        $: 1
    }, Rh = function(n) {
        return Ah(A2(Hu, function(n) {
            return n.g9;
        }, nl(function(e) {
            return A2(el, e, n);
        })));
    }, Fh = function(n) {
        return Ah(Vb(n));
    }, Hh = F2(function(n, e) {
        return A2(Ah, A2(Hu, function(n) {
            return n.aL;
        }, zt(0)), A2(Fh, Dh, A2(Rh, A([
            e
        ]), n.W)));
    }), Gh = function(n) {
        return n.b;
    }, Xh = F2(function(n, e) {
        var r = e.l;
        return A2(Pc, Gh, A2(ra, (0, e.aJ)(n), r));
    }), Vh = Xh, Jh = F2(function(n, e) {
        var r = A2(Vh, n, e);
        return r.$ ? Ur : r.a;
    }), Yh = F2(function(n, e) {
        var r = n.az, t = n.C, u = n.at, a = e.E;
        if (a.$) {
            var i = A2(Ba, function(n) {
                return A2(Ba, function(n) {
                    return n.E;
                }, Ld(A2(Ph, n, t.dp)));
            }, e.aS);
            return i.$ ? A2(Pc, function(n) {
                return n.mj;
            }, A2(Jh, u, r.E.lo)) : zr(i.a);
        }
        return zr(a.a);
    }), Wh = F2(function(n, e) {
        var r = n.C, t = n.at, u = A2(Yh, n, e);
        return u.$ ? Yr(Mh) : A2($a, Uh, A2(Ns, u.a, A2(Hh, r, t)));
    }), Kh = F2(function(n, e) {
        var r = n.lO, t = n.me, u = e.eb;
        return lh(A([
            e.g,
            A2($h, vh(e.d2), r.g),
            A2($h, gh(u), t.g)
        ]));
    }), Bh = function(n) {
        return n;
    }, Qh = F3(function(n, e, r) {
        var t = n.az, u = r.E, a = zh(r.aT), i = A2(Wh, n, e);
        if (1 === i.$) return i.a.$ ? Qr($(r, {
            E: $(u, {
                eY: a
            })
        })) : Yr(i.a.a);
        var c = i.a;
        return Qr($(r, {
            E: {
                g: A2($h, a, A2(Kh, t.E.i, c)),
                t: zr(c),
                eY: a
            }
        }));
    }), Zh = F2(function(n, e) {
        return A2(bh, e, n);
    }), n$ = F2(function(n, e) {
        var r = e.t;
        return A2(Nc, Ks, A2(Pc, A2(Hu, function(n) {
            return n.g;
        }, $h(A2(Zh, n, e.oH))), r));
    }), e$ = F2(function(n, e) {
        return {
            l: Mi(A2(wu, function(e) {
                var r = e.a, t = e.b;
                return v(n(r), v(r, t));
            }, e)),
            aJ: n
        };
    }), r$ = F3(function(n, e, r) {
        return e ? A2(Nc, 1, A2(Xh, r, n._.om)) : 0;
    }), t$ = F3(function(n, e, r) {
        var t = r, u = A2(cc, A2(cc, Pc(function(e) {
            return v(n, e);
        }), e), Pc(Gh));
        return $(t, {
            l: A3(ma, t.aJ(n), u, t.l)
        });
    }), u$ = F2(function(n, e) {
        if (-2 === e.$) return Bu;
        var r = e.b, t = e.d, u = e.e;
        return A5(ta, e.a, r, A2(n, r, e.c), A2(u$, n, t), A2(u$, n, u));
    }), a$ = F2(function(n, e) {
        var r = e.l, t = e.aJ;
        return {
            l: A2(u$, F2(function(e, r) {
                var t = r.a;
                return v(t, A2(n, t, r.b));
            }), r),
            aJ: t
        };
    }), i$ = function(n) {
        var e;
        return e = n.l, A3(Hr, F3(function(n, e, r) {
            return A2(Mr, e, r);
        }), j, e);
    }, c$ = F3(function(n, e, r) {
        var t = n.az, u = n.at, a = Oh(r.Q), i = s(r.aT, 0) ? 1 : r.aT / a, c = A3(r$, t, e, u), o = ob(c), f = F2(function(n, e) {
            var r = e.fl, t = e.fo, u = e.fC;
            return v(n, {
                fl: $(r, {
                    g: A2(n$, n, r)
                }),
                fo: $(t, {
                    g: A2(n$, n, t)
                }),
                fC: $(u, {
                    g: A2(n$, n, u)
                })
            });
        });
        return A2(e$, cl, i$(A2(a$, F2(function(n, e) {
            var r = A2(bh, i, e);
            return {
                dX: A2(f, A2(Zh, r, c), A2(Nc, t._.fM.$8, A2(Xh, n, t._.fM.dX))),
                em: A2(f, A2(Zh, r, o), A2(Nc, t._.fM.$8, A2(Xh, n, t._.fM.em)))
            };
        }), function(n) {
            var e = n;
            return A3(ot, F2(function(n, e) {
                var r = n.c.aF, t = A2(bh, n.a, n.b);
                return A3(t$, A2(Nc, 21, r), A2(Hu, Pc(uh(t)), A2(Hu, Nc(t), zr)), e);
            }), cs(cl), A2(Ah, function(n) {
                var e = n.c.av;
                return !s(n.c.aF, Ur) && s(e, zr(1));
            }, A2(Id, function(n) {
                var e = n.a, r = n.b.P;
                return A2(wu, function(n) {
                    return g(e, r, n);
                }, n.b.my);
            }, A2(Id, function(n) {
                var e = n.D;
                return A2(wu, function(n) {
                    return v(e, n);
                }, n.my);
            }, e.my))));
        }(r.Q))));
    }), o$ = function(n) {
        return A2(Hu, function(n) {
            return n.gt;
        }, A2(Hu, Vh(n), Nc(!1)));
    }, f$ = A2(cc, wu(Gh), i$), s$ = F3(function(n, e, r) {
        return A2(o$, n.at, n.az._) ? lh(f$(A2(a$, F2(function(n, e) {
            var r = v(e.dX.b, e.em.b), t = r.a, u = r.b;
            return lh(A2(wu, function(n) {
                return n.g;
            }, A([
                t.fl,
                t.fo,
                t.fC,
                u.fl,
                u.fo,
                u.fC
            ])));
        }), A3(c$, n, e, r)))) : Ks;
    }), l$ = F3(function(n, e, r) {
        return $(r, {
            _: A3(s$, n, e.dq, r)
        });
    }), d$ = function(n) {
        return n;
    }, b$ = function(n) {
        return n;
    }, m$ = F3(function(n, e, r) {
        return $(r, {
            g: lh(A2(wu, function(n) {
                var r = n.a, t = n.b;
                return A2(fh, F2(function(n, r) {
                    return function(n) {
                        return .001 * n;
                    }(e) * Tf(t) * r;
                }), r.g);
            }, A([
                v(n.mP, r.ds),
                v(n.mQ, r.og),
                v(n.kK, r.hb),
                v(n.kL, r.oq),
                v(n.nL, r.f5)
            ])))
        });
    }), p$ = F2(function(n, e) {
        var r = n.a8, t = A2(bh, 2, e.ds), u = s(r, 1) ? v(e.f5, 0) : v(0, e.hb);
        return $(e, {
            f5: u.a,
            ds: t,
            hb: u.b
        });
    }), v$ = F2(function(n, e) {
        return e * n;
    }), g$ = F2(function(n, e) {
        var r = e.f5, t = e.ds, u = e.hb, a = function(n) {
            var e = n.ds, r = n.hb;
            return Tf(e) > 0 && 3e3 > Tf(e) ? 1 : Tf(r) ? 0 : 1;
        }(e), i = ob(a), c = ob(n);
        return $(e, {
            f5: A2(bh, n, r),
            ds: A2(bh, A2(v$, a, c), t),
            hb: A2(bh, A2(v$, i, c), u)
        });
    }), h$ = F3(function(n, e, r) {
        var t = v(A2(Ba, Xh(e.cR), A2(Xh, n.cR, r)), A2(Ba, Xh(n.cR), A2(Xh, e.cR, r)));
        return t.a.$ ? t.b.$ ? Yr("Distances not found between " + n.cR + " to " + e.cR) : Qr(t.b.a) : Qr(t.a.a);
    }), $$ = F4(function(n, e, r, t) {
        var u = n.C, a = n.az.af.ih, i = function(n) {
            var r;
            return zr((r = $(a, {
                ds: ah(A([
                    a.ds,
                    n.fa
                ]))
            }), s(e, 0) ? $(r, {
                f5: 0
            }) : $(r, {
                hb: 0,
                oq: 0
            })));
        }, c = v(r, t);
        if (c.a.$) return Qr(c.b.$ ? Ur : i(f = c.b.a));
        if (1 === c.b.$) return Qr(i(o = c.a.a));
        var o = c.a.a, f = c.b.a;
        return A2(fs, zr, A2(fs, function(n) {
            return $(n, {
                ds: s(o, f) ? o.fa : ah(A([
                    o.fa,
                    n.ds,
                    f.fa
                ]))
            });
        }, A2(fs, g$(e), A3(h$, o, f, u.lw))));
    }), x$ = function(n) {
        return $(n, {
            ds: 0,
            og: ah(A([
                n.og,
                n.ds
            ])),
            hb: 0,
            oq: ah(A([
                n.oq,
                n.hb
            ]))
        });
    }, k$ = F5(function(n, e, r, t, u) {
        var a = n.az, i = e.a8, c = e.aN;
        return A2(fs, A2(m$, a.af.m7, u), A2(fs, A2(Nc, !1, c) ? x$ : ru, A2(fs, Nc(A2(p$, e, a.af.ih)), A4($$, n, i, r, t))));
    }), j$ = F6(function(n, e, r, t, u, a) {
        var i = a;
        return A2(fs, function(n) {
            return $(i, {
                g: lh(A([
                    i.g,
                    n.g
                ])),
                my: k(i.my, A([
                    {
                        j: i.j,
                        S: ih,
                        g: n.g,
                        my: j,
                        ai: zr("Transport"),
                        P: r,
                        aF: Ur,
                        D: 1,
                        av: zr(3)
                    }
                ]))
            });
        }, A5(k$, n, e, t, u, r));
    }), y$ = F3(function(n, e, r) {
        for(;;){
            if (!r.b) return Qr(e);
            var t = r.b, u = A2(n, r.a, e);
            if (1 === u.$) return u;
            e = u.a, r = t;
        }
    }), w$ = F2(function(n, e) {
        return A2(wh, A2(Hu, function(n) {
            return n.t;
        }, A2(Hu, function(n) {
            return n.aL;
        }, zt(n))), e) ? Qr(e) : Yr("Les proc\xe9d\xe9s de transformation ne partagent pas la m\xeame unit\xe9 que la mati\xe8re source (" + Th(n) + ")\xa0: " + A2(at, ", ", A2(wu, function(n) {
            var e = n.t;
            return Gb(e) + " (" + Th(e.aL) + ")";
        }, A2(Ah, A2(Hu, function(n) {
            return n.t;
        }, A2(Hu, function(n) {
            return n.aL;
        }, Ic(n))), e))));
    }), A$ = F6(function(n, e, r, t, u, a) {
        return A2(fs, Gh, A2(as, A2(y$, F2(function(r, t) {
            var u = r.i, a = r.t, i = t.a, c = t.b;
            return A2(as, function(r) {
                return A2(fs, function(n) {
                    return v(u, A4(xh, 2, a, r, n));
                }, A6(j$, n, $(e, {
                    a8: 0
                }), Oh(c), i, u, c));
            }, A2(jh, n.az, u));
        }), v(r, a)), A2(w$, t, u)));
    }), T$ = F2(function(n, e) {
        return e / n;
    }), E$ = F2(function(n, e) {
        return A2(el, 0, A2(wu, mh, n)) ? Yr("Un ratio de variation de quantit\xe9 ne peut pas \xeatre de 0") : Qr(A3(yu, A2(Hu, mh, T$), e, n));
    }), C$ = F3(function(n, e, r) {
        switch(n){
            case 0:
                return $(r, {
                    bM: e(r.bM)
                });
            case 1:
                return $(r, {
                    bR: e(r.bR)
                });
            case 2:
                return $(r, {
                    b3: e(r.b3)
                });
            case 3:
                return $(r, {
                    b4: e(r.b4)
                });
            case 4:
                return $(r, {
                    ca: e(r.ca)
                });
            case 5:
                return $(r, {
                    cb: e(r.cb)
                });
            case 6:
                return $(r, {
                    cd: e(r.cd)
                });
            case 7:
                return $(r, {
                    ce: e(r.ce)
                });
            case 8:
                return $(r, {
                    cf: e(r.cf)
                });
            case 9:
                return $(r, {
                    cg: e(r.cg)
                });
            case 10:
                return $(r, {
                    ci: e(r.ci)
                });
            case 11:
                return $(r, {
                    ck: e(r.ck)
                });
            case 12:
                return $(r, {
                    cp: e(r.cp)
                });
            case 13:
                return $(r, {
                    cr: e(r.cr)
                });
            case 14:
                return $(r, {
                    cu: e(r.cu)
                });
            case 15:
                return $(r, {
                    cv: e(r.cv)
                });
            case 16:
                return $(r, {
                    cz: e(r.cz)
                });
            case 17:
                return $(r, {
                    cD: e(r.cD)
                });
            case 18:
                return $(r, {
                    cH: e(r.cH)
                });
            default:
                return $(r, {
                    b_: e(r.b_)
                });
        }
    }), I$ = F3(function(n, e, r) {
        var t = r;
        return A3(C$, n, Wi(e), t);
    }), S$ = F2(function(n, e) {
        return A3(I$, 19, A2(uh, A2(ch, 19, e), n), e);
    }), O$ = F2(function(n, e) {
        return {
            ag: n(e.ag),
            aa: n(e.aa),
            ah: n(e.ah),
            aj: n(e.aj),
            ak: n(e.ak),
            al: n(e.al),
            am: n(e.am)
        };
    }), L$ = F2(function(n, e) {
        return O$(Pc(function(r) {
            return A2($h, n, A2(S$, r, e));
        }));
    }), P$ = A2(Hu, function(n) {
        return n.cP;
    }, qa(function(n) {
        return 6 === n.$ ? zr(n.a) : Ur;
    })), q$ = function(n) {
        return n.b ? zr(n.a) : Ur;
    }, N$ = F2(function(n, e) {
        return 2 === e.aL ? n : n * A2(Nc, 0, e.mZ);
    }), _$ = F2(function(n, e) {
        var r = zr(A2(Nc, 21, q$(P$(e)))), t = A2(N$, n, e), u = A2($h, n, e.g), a = A2(Nc, ih, A2(Pc, A2(L$, n, Ks), A2(Ba, function(n) {
            return n.k1;
        }, e.m0)));
        return {
            j: n,
            S: a,
            g: u,
            my: A([
                {
                    j: n,
                    S: a,
                    g: u,
                    my: j,
                    ai: zr(Gb(e)),
                    P: t,
                    aF: r,
                    D: 1,
                    av: zr(1)
                }
            ]),
            ai: zr("Element: " + Gb(e)),
            P: t,
            aF: r,
            D: 1,
            av: Ur
        };
    }), z$ = F3(function(n, e, r) {
        return {
            j: n,
            U: e,
            J: r
        };
    }), U$ = F2(function(n, e) {
        return {
            i: n,
            t: e
        };
    }), M$ = function(n) {
        var e = n.bT, r = n.W;
        return A2(Hu, wu(function(n) {
            var t = n.i;
            return A2(Lg, A2(Ns, n.mj, r), A2(Lg, A2(yh, t, e), Qr(U$)));
        }), Vg);
    }, D$ = F2(function(n, e) {
        var r = n.bT, t = n.W, u = e.j, a = e.U;
        return A2(Lg, A2(M$, n, e.J), A2(Lg, A2(Lg, A2(Ns, a.mj, t), A2(Lg, A2(yh, a.i, r), Qr(F2(function(n, e) {
            return {
                i: n,
                t: e
            };
        })))), Qr(z$(u))));
    }), R$ = {
        $: 13
    }, F$ = Vb(R$), H$ = F2(function(n, e) {
        return A2(Hu, D$(n.C), as(function(r) {
            var t = r.j, u = r.U, a = r.J;
            return A2(as, function(r) {
                return A6(A$, n, $(e, {
                    aN: zr(F$(u.t))
                }), u.i, u.t.aL, a, A2(_$, r, u.t));
            }, A2(E$, A2(wu, A2(Hu, function(n) {
                return n.t;
            }, function(n) {
                return n.g4;
            }), a), t));
        }));
    }), G$ = function(n) {
        var e = n.r;
        return A2(Hu, Pc(function(n) {
            return n.r;
        }), Nc(e));
    }, X$ = {
        gh: Ur,
        r: j,
        mj: Ur,
        ek: "",
        jy: !1,
        g9: A([
            ds(2)
        ])
    }, V$ = function(n) {
        return A2(Hu, xs(A2(Hu, function(n) {
            return n.mj;
        }, zt(zr(n)))), ks("Aucun composant avec id=" + bf(n)));
    }, J$ = F3(function(n, e, r) {
        for(;;){
            if (0 >= e) return n;
            n = A2(Mr, r, n), e -= 1;
        }
    }), Y$ = F2(function(n, e) {
        return A3(J$, j, n, e);
    }), W$ = function(n) {
        return n;
    }, K$ = F2(function(n, e) {
        return e * n;
    }), B$ = function(n) {
        return wu(function(e) {
            return $(e, {
                j: A2(K$, n, e.j)
            });
        });
    }, Q$ = F2(function(n, e) {
        return A2(fs, function(n) {
            return A2(N$, n.j, n.U.t);
        }, A2(D$, n, e));
    }), Z$ = F3(function(n, e, r) {
        if (r.$) return Qr(1);
        var t = r.a;
        return A2(as, function(n) {
            return s(n, 0) ? Yr("Impossible de sp\xe9cifier la masse unitaire d\u2019un composant lorsque la masse des \xe9l\xe9ments qui le constituent est nulle") : Qr(t / n);
        }, A2(fs, A2(ot, uh, 0), Vg(A2(wu, Q$(n), e))));
    }), nx = F3(function(n, e, r) {
        return e.$ ? Qr(r) : A2(fs, function(n) {
            return A2(B$, n, r);
        }, A3(Z$, n, r, e));
    }), ex = F3(function(n, e, r) {
        var t = r.Y, u = r.mj, a = r.D, i = r.dH, c = u.$ ? Qr(X$) : A2(V$, u.a, n.C.dZ);
        return A2(fs, function(n) {
            var e, r = n.S, u = n.g, i = n.P, o = n.aF, f = n.my;
            return {
                j: Ch(0),
                S: sh(A2(Y$, a, r)),
                g: lh(A2(Y$, a, u)),
                my: f,
                ai: (e = A2(Ba, function(n) {
                    return n.ek;
                }, t), e.$ ? A2(Zg, Ur, A2(fs, A2(Hu, function(n) {
                    return n.ek;
                }, zr), c)) : zr(e.a)),
                P: ah(A2(Y$, a, i)),
                aF: o,
                D: a,
                av: Ur
            };
        }, A2(fs, A2(yu, dh, Ih), A2(as, function(r) {
            return A2(as, A2(Hu, wu(A2(H$, n, e)), Vg), A3(nx, n.C, i, A2(G$, r, t)));
        }, c)));
    }), rx = F2(function(n, e) {
        return {
            j: n,
            t: e
        };
    }), tx = function(n) {
        return A2(Hu, wu(function(e) {
            var r = e.bl;
            return A2(fs, rx(e.j), A2(Ns, r, n));
        }), Vg);
    }, ux = function(n) {
        return A2(Hu, wu(function(n) {
            return n;
        }), tx(n));
    }, ax = F3(function(n, e, r) {
        return A2(fs, function(n) {
            return $(r, {
                cs: A2(wu, function(n) {
                    return A2($h, n.j, n.t.g);
                }, n)
            });
        }, A2(ux, n.C.W, e.aR));
    }), ix = F2(function(n, e) {
        return {
            eH: n,
            eJ: e
        };
    }), cx = function(n) {
        return {
            f5: 0,
            g: n,
            ds: 0,
            og: 0,
            hb: 0,
            oq: 0
        };
    }, ox = {
        eH: cx(Ks),
        eJ: cx(Ks)
    }, fx = F2(function(n, e) {
        var r = A2(Nc, X$, n);
        return e.$ ? r : $(r, {
            r: e.a.r,
            ek: A2(Nc, r.ek, e.a.ek)
        });
    }), sx = function(n) {
        return qg(D$(n));
    }, lx = F4(function(n, e, r, t) {
        return A2(fs, function(n) {
            return {
                h7: A2(fx, zr(t), e),
                r: n,
                D: r
            };
        }, A2(sx, n, A2(G$, t, e)));
    }), dx = F3(function(n, e, r) {
        return {
            h7: n,
            r: e,
            D: r
        };
    }), bx = F3(function(n, e, r) {
        var t = A2(fx, Ur, e);
        return A2(Lg, Qr(r), A2(Lg, A2(sx, n, A2(G$, t, e)), A2(Lg, Qr(t), Qr(dx))));
    }), mx = F2(function(n, e) {
        var r = e.Y, t = e.mj, u = e.D;
        if (t.$) return A3(bx, n, r, u);
        var a = t.a;
        return A2(as, A3(lx, n, r, u), A2(V$, a, n.dZ));
    }), px = function(n) {
        return A2(Hu, wu(mx(n)), Vg);
    }, vx = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return zr(n.a);
            }
            return Ur;
        }
    }, gx = function(n) {
        return A2(Nc, n.U.i, A2(Pc, function(n) {
            return n.i;
        }, vx(n.J)));
    }, hx = function(n) {
        return n.my;
    }, $x = F2(function(n, e) {
        n: for(;;){
            if (n > 0) {
                if (e.b) {
                    n -= 1, e = e.b;
                    continue n;
                }
                return e;
            }
            return e;
        }
    }), xx = F2(function(n, e) {
        return 0 > n ? Ur : q$(A2($x, n, e));
    }), kx = F2(function(n, e) {
        var r = n.a;
        return A2(as, A2(Hu, hx, A2(Hu, xx(n.b), ks("\xc9l\xe9ment introuvable"))), A2(ks, "Item introuvable", A2(xx, r, hx(e))));
    }), jx = F2(function(n, e) {
        var r = n.C, t = e.ax.aN;
        return t.$ ? A2(Nc, !1, A2(Ba, function(n) {
            return A2(Pc, function(n) {
                return n.aN;
            }, Ld(A2(Ph, n, r.dp)));
        }, e.aS)) : t.a;
    }), yx = F3(function(n, e, r) {
        if (1 === e.$) return Yr(e.a);
        var t = e.a;
        return 1 === r.$ ? Yr(r.a) : Qr(A2(n, t, r.a));
    }), wx = A2(ot, F2(function(n, e) {
        var r = n.g, t = n.ds, u = n.og, a = n.hb, i = n.oq;
        return $(e, {
            f5: A2(uh, n.f5, e.f5),
            g: lh(A([
                e.g,
                r
            ])),
            ds: A2(uh, t, e.ds),
            og: A2(uh, u, e.og),
            hb: A2(uh, a, e.hb),
            oq: A2(uh, i, e.oq)
        });
    }), cx(Ks)), Ax = F3(function(n, e, r) {
        var t, u, a = n.az, i = n.C, c = e.q, o = e.ax;
        return 1 === (t = A3(yx, F2(function(t, u) {
            return sf(e.my) ? u.$ ? Qr($(r, {
                af: ox
            })) : Yr("Une liste de composants vide ne peut \xeatre assembl\xe9e") : A3(yx, F2(function(n, e) {
                return $(r, {
                    af: A2(ix, n, e)
                });
            }), A2(fs, wx, Vg(A2(wu, function(e) {
                var r = e.a, t = e.b, a = e.c;
                return A5(k$, n, $(o, {
                    a8: 0,
                    aN: zr(F$(t.U.t))
                }), gx(t), u, A2(bh, r, Oh(a)));
            }, t))), A5(k$, n, $(o, {
                aN: zr(A2(jx, n, e))
            }), u, zr(a.E.i), r.aT));
        }), A2(as, (u = r.Q, A2(Hu, bt(F2(function(n, e) {
            return A2(bt, F2(function(r, t) {
                return A2(fs, function(n) {
                    return g(e.D, t, n);
                }, A2(kx, v(n, r), u));
            }), e.r);
        })), A2(Hu, Cd, Vg))), A2(px, i, e.my)), A2(yh, c.i, i.bT))).$ ? Yr(t.a) : t.a;
    }), Tx = F2(function(n, e) {
        var r = n.d2, t = n.eb;
        return lh(A([
            e.g,
            A2($h, vh(e.d2), r.g),
            A2($h, gh(e.eb), t.g)
        ]));
    }), Ex = function(n) {
        return A2(Hu, wu(function(n) {
            return {
                j: A2(Nc, Ch(0), n.j),
                bl: n.bl
            };
        }), tx(n));
    }, Cx = F2(function(n, e) {
        var r = n.C, t = e.aM;
        return t.$ ? A2(Nc, j, A2(Ba, function(n) {
            return A2(Pc, function(n) {
                return n.aM;
            }, Ld(A2(Ph, n, r.dp)));
        }, e.aS)) : t.a;
    }), Ix = F3(function(n, e, r) {
        return A2(el, Xb, e.cP) ? Ch(n.aT) : r;
    }), Sx = F3(function(n, e, r) {
        var t = n.az;
        return A2(fs, function(n) {
            return $(r, {
                bK: A2(wu, function(n) {
                    var e = n.t;
                    return A2($h, A3(Ix, r, e, n.j), A2(Tx, {
                        d2: t.bK.ii,
                        eb: t.bK.ij
                    }, e));
                }, n)
            });
        }, A2(Ex, n.C.W, A2(Cx, n, e)));
    }), Ox = {
        q: Ih,
        E: {
            g: Ks,
            t: Ur,
            eY: 0
        },
        _: Ks,
        cs: j,
        aT: 0,
        Q: Ih,
        af: ox,
        bK: j
    }, Lx = F2(function(n, e) {
        return A2(as, A2(Sx, n, e), A2(as, A2(Ax, n, e), A2(fs, A2(l$, n, e), A2(as, A2(Qh, n, e), A2(as, A2(ax, n, e), A2(as, A2(Nh, n, e), A2(fs, function(n) {
            return $(Ox, {
                Q: $(n, {
                    ai: zr("Production")
                })
            });
        }, A2(fs, A2(yu, dh, Ih), Vg(A2(wu, A2(ex, n, e.ax), e.my))))))))));
    }), Px = {
        $: 0
    }, qx = function(n) {
        switch(n.$){
            case 0:
                return "Alimentaire";
            case 1:
                return function(n) {
                    switch(n){
                        case 0:
                            return "Habillement";
                        case 1:
                            return "Alimentaire B\xc9TA";
                        case 2:
                            return "Objets";
                        default:
                            return "V\xe9hicules";
                    }
                }(n.a);
            default:
                return "Textile";
        }
    }, Nx = F2(function(n, e) {
        var r = n.C, t = n.at, u = A2(Ns, e, A2(Rh, A([
            t
        ]), r.W));
        if (1 === u.$) return Yr("Aucun proc\xe9d\xe9 d\u2019assemblage scop\xe9 " + qx(t) + " avec cet id\u202F: " + qs(e));
        var a = u.a;
        return A2(el, Px, a.cP) ? 2 !== a.aL ? Yr("Le proc\xe9d\xe9 d\u2019assemblage doit accepter une masse en kg") : Qr(a.mj) : Yr("Le proc\xe9d\xe9 n\u2019est pas un assemblage");
    }), _x = F3(function(n, e, r) {
        return A2(as, function(e) {
            var t = e.cR;
            return A2(el, n, e.g9) ? Qr(t) : Yr("Le code pays " + r + " n\u2019est pas utilisable dans un contexte " + qx(n) + ".");
        }, A2(js, r, e));
    }), zx = F2(function(n, e) {
        var r = n.C, t = n.at;
        return e.$ ? Qr(Ur) : A2(fs, zr, A3(_x, t, r.bT, e.a));
    }), Ux = F2(function(n, e) {
        return A2(Lg, A2(fs, Wi(e.q.bh), A2(qg, Nx(n), A2(qh, n, e))), A2(Lg, A2(zx, n, e.q.i), Qr(Ub)));
    }), Mx = F2(function(n, e) {
        var r = n.C, t = n.at;
        return A2($a, Wi("Aucun proc\xe9d\xe9 scop\xe9 " + qx(t) + " avec cet id: " + qs(e)), A2(fs, function(n) {
            return n.mj;
        }, A2(Ns, e, A2(Rh, A([
            t
        ]), r.W))));
    }), Dx = F2(function(n, e) {
        return A2(as, function() {
            return A2(Kb, n.C.W, e);
        }, A2(Mx, n, e.bl));
    }), Rx = F2(function(n, e) {
        var r = n.C, t = n.at;
        if (e.$) return Qr(Ur);
        var u = e.a, a = A2(Ns, u, r.W);
        if (1 === a.$) return Yr(a.a);
        var i = a.a;
        return A2(el, Dh, i.cP) ? i.aL ? Yr("Le proc\xe9d\xe9 de distribution doit accepter un volume") : A2(el, t, i.g9) ? Qr(zr(u)) : Yr("Le proc\xe9d\xe9 " + qs(u) + " n'est pas disponible pour le p\xe9rim\xe8tre " + qx(t)) : Yr("Le proc\xe9d\xe9 n'est pas une distribution");
    }), Fx = F2(function(n, e) {
        var r = n.at, t = v(A2(o$, r, n.az.aO), e);
        return t.a || t.b.$ ? Qr(e) : Yr("La durabilit\xe9 n'est pas activ\xe9e pour le p\xe9rim\xe8tre " + qx(r));
    }), Hx = F2(function(n, e) {
        if (1 > e.D) return Yr("La quantit\xe9 doit \xeatre un nombre entier positif");
        var r = e.mj;
        if (r.$) return Qr(e);
        var t = A2(V$, r.a, n);
        return 1 === t.$ ? Yr(t.a) : Qr(e);
    }), Gx = F2(function(n, e) {
        return A2(Lg, A2(Mx, n, e.bl), A2(Lg, Wb(e.j), Qr(lm)));
    }), Xx = F2(function(n, e) {
        return A2(fs, ru, A2(Gx, n, e));
    }), Vx = F2(function(n, e) {
        if (e.$) return Qr(Ur);
        var r = e.a;
        return A2(fs, zr, A2(as, function(e) {
            return s(n.at, ds(e.at)) ? Qr(r) : Yr("La cat\xe9gorie de produit " + e.ai + " n\u2019est pas disponible pour le p\xe9rim\xe8tre " + qx(n.at));
        }, A2(Ph, r, n.C.dp)));
    }), Jx = F2(function(n, e) {
        var r = n.C;
        return A2($a, function(n) {
            return "Requ\xeate invalide\u202F: " + n;
        }, A2(Lg, Qr(e.ax), A2(Lg, Qr(e.dq), A2(Lg, A2(Vx, n, e.aS), A2(Lg, A2(qg, Xx(n), e.aR), A2(Lg, A2(qg, Hx(r.dZ), e.my), A2(Lg, A2(Fx, n, e.aO), A2(Lg, A2(Rx, n, A2(Yh, n, e)), A2(Lg, A2(fs, Wi(e.aM), A2(qg, Dx(n), A2(Cx, n, e))), A2(Lg, A2(Ux, n, e), Qr(zb)))))))))));
    }), Yx = function(n) {
        return A2(Hu, Jx(n), as(Lx(n)));
    }, Wx = F2(function(n, e) {
        return A2(Sp, A([
            e.M.b ? jg("prevent-scrolling") : yg("prevent-scrolling")
        ]), A2(Ep, n, e));
    }), Kx = function(n) {
        return Ah(A2(Hu, function(n) {
            return n.at;
        }, zt(n)));
    }, Bx = {
        q: Pf,
        aM: Ur,
        E: Ur,
        aO: Ur,
        my: j,
        aR: j,
        aS: Ur,
        dq: !0,
        ax: Uf
    }, Qx = function(n) {
        return A2(Hu, xs(A2(Hu, function(n) {
            return n.mj;
        }, zt(n))), ks("Exemple introuvable pour l'uuid " + df(n)));
    }, Zx = F2(function(n, e) {
        switch(n){
            case 0:
                return e.an.e$;
            case 1:
                return e.an.fh;
            case 2:
                return e.an.gR;
            default:
                return e.an.f2;
        }
    }), nk = F2(function(n, e) {
        var r;
        return Nc(sf((r = A2(Zx, e, n)).my) ? A2(Nc, Bx, A2(Ba, function(e) {
            return A2(Pc, function(n) {
                return n.g5;
            }, Ld(A2(Qx, e, n.C.l9.lT)));
        }, A2(Vh, ds(e), n.h8.ln))) : r);
    }), ek = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), rk = function(n) {
        return A2(Hu, ek(n), Ig);
    }, tk = function(n) {
        return A2(Hu, xs(A2(Hu, function(n) {
            return n.g5;
        }, zt(n))), ks("Exemple introuvable"));
    }, uk = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ak = function(n) {
        return 0 > n ? -n : n;
    }, ik = F5(function(n, e, r, t, u) {
        return {
            li: r,
            iV: e,
            ji: n,
            fz: t,
            fN: u
        };
    }), ck = function(n) {
        return A([
            n
        ]);
    }, ok = F, fk = F2(function(n, e) {
        var r = iu(e), t = 0 > m(r, n) ? ak(n - r) : 0;
        return k(e, A2(Wc, t, "0"));
    }), sk = F2(function(n, e) {
        return 1 > n ? "" : A3(cu, -n, iu(e), e);
    }), lk = function(n) {
        return "0" !== A2(sk, 1, n) ? n : lk(A2(Fd, 1, n));
    }, dk = F2(function(n, e) {
        var r = n.li;
        switch(r.$){
            case 1:
                return lk(e);
            case 2:
                return e;
            default:
                return A2(fk, r.a, e);
        }
    }), bk = F2(function(n, e) {
        var r = A2(nl, function(n) {
            return "0" !== n && "." !== n;
        }, lg(e));
        return k(n && r ? "-" : "", e);
    }), mk = function(n) {
        var e = n.a, r = n.b;
        if ("9" === e) {
            var t = kt(r);
            return 1 === t.$ ? "01" : A2(Vc, "0", mk(t.a));
        }
        var u = mt(e);
        return u >= 48 && 57 > u ? A2(Vc, Nd(u + 1), r) : "0";
    }, pk = function(n) {
        return n === 1 / 0 || n === -1 / 0;
    }, vk = M, gk = F3(function(n, e, r) {
        return k(r, A2(Wc, n - iu(r), Jc(e)));
    }), hk = function(n) {
        for(var e = n.length, r = Array(e), t = 0; e > t;){
            var u = n.charCodeAt(t);
            55296 > u || u > 56319 ? (r[e - t] = n[t], t++) : (r[e - t] = n[t + 1], r[e - ++t] = n[t - 1], t++);
        }
        return r.join("");
    }, $k = function(n) {
        var e = A2(it, ".", n);
        return e.b ? v(e.a, e.b.b ? e.b.a : "0") : v("0", "0");
    }, xk = F2(function(n, e) {
        var r = e.b;
        return v(n(e.a), r);
    }), kk = F3(function(n, e, r) {
        if (pk(r) || vk(r)) return Js(r);
        var t = 0 > r, u = $k(function(n) {
            var e = A2(it, "e", Js(ak(n)));
            if (e.b) {
                if (e.b.b) {
                    var r = e.a, t = e.b.a, u = A2(Nc, 0, du(A2(gu, "+", t) ? A2(ou, 1, t) : t)), a = $k(r), i = k(a.a, a.b), c = 0 > u ? A2(Nc, "0", A2(Pc, function(n) {
                        return n.a + "." + n.b;
                    }, A2(Pc, xk(Jc), kt(k(A2(Wc, ak(u), "0"), i))))) : A3(gk, u + 1, "0", i);
                    return k(0 > n ? "-" : "", c);
                }
                return k(0 > n ? "-" : "", r = e.a);
            }
            return "";
        }(ak(r))), a = u.a, i = u.b, c = iu(a) + e, o = k(A2(Wc, 1 - c, "0"), A3(gk, c, "0", k(a, i))), f = iu(o), s = A2(Dt, 1, c), l = A2(n, t, A3(cu, s, f, o)), d = A3(cu, 0, s, o), b = l ? hk(A2(Nc, "1", A2(Pc, mk, kt(hk(d))))) : d, p = iu(b), v = "0" === b ? b : e > 0 ? 0 > m(e, iu(i)) ? A3(cu, 0, p - e, b) + "." + A3(cu, p - e, p, b) : k(a + ".", A3(gk, e, "0", i)) : k(b, A2(Wc, ak(e), "0"));
        return A2(bk, t, v);
    })(F2(function(n, e) {
        var r, t = kt(e);
        return 1 !== t.$ && ("5" === t.a.a ? "" !== t.a.b || !n : (r = mt(t.a.a)) > 53 && n || r >= 53 && !n);
    })), jk = function(n) {
        return n.b ? zr(n.b) : Ur;
    }, yk = F2(function(n, e) {
        var r, t = function() {
            var e = n.li;
            switch(e.$){
                case 1:
                default:
                    return kk(e.a);
                case 0:
                    return Js;
            }
        }(), u = A2(it, ".", t(e)), a = (r = jk(u)).$ ? "" : A2(Nc, "", q$(r.a));
        return v(A2(Nc, "", q$(u)), a);
    }), wk = F2(function(n, e) {
        var r, t = A2(yk, n, e), u = function(n) {
            var e = function(n) {
                return iu(n) > 3 ? A2(Mr, A2(sk, 3, n), e(A2(Fd, 3, n))) : A([
                    n
                ]);
            };
            return xt(e(n));
        }(A2(ok, ht, t.a)), a = A5(ik, e, u, A2(dk, n, t.b), "", "");
        switch(A2(et, function(n) {
            return "0" === n;
        }, zc(A2(Ed, (r = a).iV, ck(r.li)))) ? 1 : 0 > r.ji ? 2 : 0){
            case 2:
                return $(a, {
                    fz: n.fu,
                    fN: n.gO
                });
            case 0:
                return $(a, {
                    fz: n.jp,
                    fN: n.jq
                });
            default:
                return $(a, {
                    fz: n.kt,
                    fN: n.ku
                });
        }
    }), Ak = F2(function(n, e) {
        return "" === e ? "" : k(n.bW, e);
    }), Tk = F2(function(n, e) {
        var r = Ak(n), t = A2(at, n.cC, e.iV), u = r(e.li);
        return zc(A([
            e.fz,
            t,
            u,
            e.fN
        ]));
    }), Ek = F2(function(n, e) {
        return A2(Tk, n, A2(wk, n, e));
    }), Ck = $({
        bW: ".",
        li: {
            $: 0,
            a: 0
        },
        fu: "\u2212",
        gO: "",
        jp: "",
        jq: "",
        cC: "",
        kt: "",
        ku: ""
    }, {
        bW: ",",
        li: uk(3),
        cC: "\u202F"
    }), Ik = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Sk = {
        $: 1
    }, Ok = A2(Nc, Cs, Es("^-?(\\d+\\.?\\d+|\\d+)$")), Lk = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Pk = {
        $: 1
    }, qk = As(A2(Nc, Cs, Es("^-?\\d+$"))), Nk = A2(ot, F2(function(n, e) {
        return 1 === n.$ ? Ur : A2(Pc, Mr(n.a), e);
    }), zr(j)), _k = F3(function(n, e, r) {
        for(;;){
            if ("" === r) return e;
            var t = A2(Fd, n, r);
            e = A2(Mr, A2(sk, n, r), e), r = t;
        }
    }), zk = gr($r), Uk = A2(zk, A2(Nc, Cs, Es("^0*")), function() {
        return "";
    }), Mk = function(n) {
        if (qk(n)) {
            var e = A2(gu, "-", n) ? v(1, Uk(A2(ou, 1, n))) : v(0, Uk(n)), r = e.a, t = e.b;
            return su(t) ? zr(Pk) : A2(Pc, Lk(r), function(n) {
                return Nk(A2(wu, du, A3(_k, 7, j, n)));
            }(t));
        }
        return Ur;
    }, Dk = F3(function(n, e, r) {
        return 1 === e.$ || 1 === r.$ ? Ur : zr(A2(n, e.a, r.a));
    }), Rk = A2(zk, A2(Nc, Cs, Es("0*$")), function() {
        return "";
    }), Fk = F2(function(n, e) {
        var r = A2(it, ".", e);
        n: for(;;){
            if (r.b) {
                if (r.b.b) {
                    if (r.b.b.b) break n;
                    i = r.a;
                    var t = Rk(r.b.a), u = A2(lu, -n, t), a = Mk(k(i, u));
                    return o = -iu(u), A3(Dk, Ik, a, zr(o));
                }
                var i, c = Rk(i = r.a), o = iu(i) - iu(c);
                return A3(Dk, Ik, Mk(c), zr(o));
            }
            break n;
        }
        return Ur;
    }), Hk = F2(function(n, e) {
        var r = A2(it, "e", Ss(e));
        if (r.b && r.b.b && !r.b.b.b) {
            var t = r.b.a, u = A2(it, ".", r.a);
            n: for(;;){
                if (u.b) {
                    if (u.b.b) {
                        if (u.b.b.b) break n;
                        i = u.a;
                        var a = u.b.a;
                        return c = A2(Ba, function(e) {
                            return 0 > m(e, n) ? Ur : zr(e);
                        }, A2(Pc, function(n) {
                            return n - iu(a);
                        }, du(t))), A3(Dk, Ik, Mk(k(i, a)), c);
                    }
                    var i;
                    if (iu(i = u.a) > 1) return Ur;
                    var c = A2(Ba, function(e) {
                        return 0 > m(e, n) ? Ur : zr(e);
                    }, du(t));
                    return "0" === i ? zr(Sk) : A3(Dk, Ik, Mk(i), c);
                }
                break n;
            }
            return Ur;
        }
        return Ur;
    }), Gk = P, Xk = A2(Gk, 10, 7), Vk = F2(function(n, e) {
        for(;;){
            var r = e / Xk | 0;
            if (!r) return xt(A2(Mr, e, n));
            n = A2(Mr, e % Xk, n), e = r;
        }
    })(j), Jk = function(n) {
        switch(A2(ea, n, 0)){
            case 2:
                return A2(Lk, 0, Vk(n));
            case 1:
                return Pk;
            default:
                return A2(Lk, 1, Vk(ak(n)));
        }
    }, Yk = function(n) {
        if (1 === n.$) return "0";
        var e = n.b;
        return k(1 === n.a ? "-" : "", Uk(A3(ot, rt, "", A2(wu, A2(Hu, ut, A2(Kc, 7, "0")), e))));
    }, Wk = Pk, Kk = function(n) {
        var e = Rk(Yk(n)), r = Yk(n);
        return v(A2(Nc, Wk, Mk(e)), iu(r) - iu(e));
    }, Bk = F2(function(n, e) {
        for(;;){
            if (1 === e.$) return Sk;
            var r = e.b, t = Kk(e.a), u = t.a, a = t.b, i = A2(Dt, r + a, n), c = 0 > m(r + a, n) ? A3(Hu, Yk, A2(Hu, Fd(n - (r + a)), A2(Hu, Mk, Nc(Wk))), u) : u;
            if (s(c, Jk(0))) return Sk;
            if (!A3(Hu, Yk, Hd("0"), c)) return A2(Ik, c, i);
            e = A2(Ik, c, i);
        }
    }), Qk = A2(Nc, Cs, Es("^-?\\d{1}(\\.\\d*[1-9]|)e{1}-?\\d+$")), Zk = F2(function(n, e) {
        return "0" === e ? zr(Sk) : A2(As, Ok, e) ? A2(Pc, Bk(n), A2(Fk, n, e)) : A2(As, Qk, e) ? A2(Pc, Bk(n), A2(Hk, n, e)) : Ur;
    })(-32), nj = function(n) {
        var e = Yk(n);
        return iu(A2(gu, "-", e) ? A2(ou, 1, e) : e);
    }, ej = F3(function(n, e, r) {
        n: for(;;){
            var t = v(n, e);
            if (t.a.b) {
                if (t.b.b) {
                    var u = t.a, a = t.b;
                    n = u.b, e = a.b, r = A2(Mr, u.a + a.a, r);
                    continue n;
                }
                return k(xt(r), n);
            }
            return t.b.b ? k(xt(r), e) : xt(r);
        }
    }), rj = F2(function(n, e) {
        var r = e.b, t = n + e.a;
        return v(0 > t ? -1 : t / Xk | 0, A2(Mr, A2(Uc, Xk, t), r));
    }), tj = A2(yu, F2(function(n, e) {
        return !n && sf(e) ? j : A2(Mr, n, e);
    }), j), uj = function(n) {
        return tj(xt(function(n) {
            var e = n.a, r = n.b;
            if (e) {
                if (r.b) {
                    var t = r.b;
                    return r.a + e ? A2(Mr, e, r) : t;
                }
                return j;
            }
            return r;
        }(A3(ot, rj, v(0, j), n))));
    }, aj = F2(function(n, e) {
        return uj(A3(ej, n, e, j));
    }), ij = F2(function(n, e) {
        n: for(;;){
            var r = v(n, e);
            if (!r.a.b) return r.b.b ? 0 : 1;
            if (!r.b.b) return 2;
            var t = r.a, u = t.b, a = r.b, i = a.b;
            switch(A2(ea, t.a, a.a)){
                case 2:
                    return 2;
                case 1:
                    n = u, e = i;
                    continue n;
                default:
                    return 0;
            }
        }
    }), cj = F2(function(n, e) {
        switch(A2(ea, ft(n), ft(e))){
            case 2:
                return 2;
            case 0:
                return 0;
            default:
                return A2(ij, xt(n), xt(e));
        }
    }), oj = F2(function(n, e) {
        var r = v(n, e);
        n: for(;;){
            if (1 === r.a.$) return e;
            if (1 === r.b.$) return n;
            if (r.a.a) {
                if (r.b.a) break n;
                switch(A2(cj, t = r.a.b, u = r.b.b)){
                    case 2:
                        return A2(Lk, 1, A2(aj, t, A2(wu, eo, u)));
                    case 1:
                        return Pk;
                    default:
                        return A2(Lk, 0, A2(aj, A2(wu, eo, t), u));
                }
            } else {
                if (1 !== r.b.a) break n;
                switch(A2(cj, t = r.a.b, u = r.b.b)){
                    case 2:
                        return A2(Lk, 0, A2(aj, t, A2(wu, eo, u)));
                    case 1:
                        return Pk;
                    default:
                        return A2(Lk, 1, A2(aj, A2(wu, eo, t), u));
                }
            }
        }
        var t, u, a = r.a;
        return A2(Lk, a.a, A2(aj, t = a.b, u = r.b.b));
    }), fj = F2(function(n, e) {
        var r = v(n, e);
        n: for(;;){
            if (1 === r.a.$) return 1 === r.b.$ ? 1 : r.b.a ? 2 : 0;
            if (1 === r.b.$) return r.a.a ? 0 : 2;
            if (r.a.a) {
                if (r.b.a) break n;
                return 0;
            }
            if (1 === r.b.a) return 2;
            break n;
        }
        var t = r.a, u = t.a, a = r.b, i = a.a, c = A2(cj, t.b, a.b);
        return 1 === u && 1 === i ? function(n) {
            switch(n){
                case 2:
                    return 0;
                case 1:
                    return 1;
                default:
                    return 2;
            }
        }(c) : c;
    }), sj = function(n) {
        return 1 === n.$ ? Pk : n.a ? A2(Lk, 0, n.b) : n;
    }, lj = function(n) {
        return 1 === n.$ ? Pk : A2(Lk, n.a ? 0 : 1, n.b);
    }, dj = F3(function(n, e, r) {
        var t = r.a, u = r.b, a = v(n, e);
        n: for(; !a.a.$;){
            if (a.a.a) {
                if (a.b.$) break n;
                return v(a.b.a ? t : lj(t), lj(u));
            }
            if (a.b.$ || 1 !== a.b.a) break n;
            return v(lj(t), u);
        }
        return v(t, u);
    }), bj = F2(function(n, e) {
        return A2(wu, function(e) {
            return A2(wu, Rt(e), n);
        }, e);
    }), mj = F2(function(n, e) {
        var r;
        return uj(function(n) {
            return A3(ot, aj, j, n);
        }((r = A2(bj, n, e), A3(ot, F2(function(n, e) {
            var r = e.a, t = e.b;
            return v(r + 1, A2(Mr, A2(Ed, A2(Y$, r, 0), n), t));
        }), v(0, j), r).b)));
    }), pj = F2(function(n, e) {
        var r = v(n, e);
        if (1 === r.a.$) return Pk;
        if (1 === r.b.$) return Pk;
        var t = r.a, u = t.b, a = r.b, i = a.b, c = s(t.a, a.a) ? 0 : 1, o = 2 === A2(ea, ft(u), ft(i)) ? A2(mj, u, i) : A2(mj, i, u);
        return A2(Lk, c, o);
    }), vj = A2(Lk, 0, A([
        1
    ])), gj = F2(function(n, e) {
        var r = v(n, e);
        return 1 === r.a.$ ? lj(e) : 1 === r.b.$ ? n : A2(oj, n, lj(e));
    }), hj = F4(function(n, e, r, t) {
        n: for(;;)switch(A2(fj, n, e)){
            case 0:
                return v(t, n);
            case 1:
                return v(A2(oj, t, vj), Pk);
            default:
                var u = A2(pj, e, Jk(r));
                switch(A2(fj, n, u)){
                    case 0:
                        n = a = n, e = i = e, r = c = r / 2 | 0, t = o = t;
                        continue n;
                    case 1:
                        return v(A2(oj, t, Jk(r)), Pk);
                    default:
                        var a = A2(gj, n, u), i = e, c = r, o = A2(oj, t, Jk(r));
                        n = a, e = i, r = c, t = o;
                        continue n;
                }
        }
    }), $j = function(n) {
        if (1 === n.$) return v(Pk, Pk);
        var e = n.a, r = xt(n.b);
        if (r.b) {
            if (r.b.b) {
                var t = r.b;
                return v(Jk(r.a), A2(Lk, e, xt(t)));
            }
            return v(Jk(r.a), Pk);
        }
        return v(Pk, Pk);
    }, xj = F2(function(n, e) {
        for(;;){
            if (1 === e.$) return Pk;
            if (0 >= n) return e;
            n -= 1, e = A2(Lk, e.a, A2(Mr, 0, e.b));
        }
    }), kj = F4(function(n, e, r, t) {
        for(;;){
            if (1 === v(n, e).a.$) return zr(v(r, t));
            var u = $j(n), a = u.b, i = A4(hj, A2(oj, u.a, A2(xj, 1, t)), e, Xk, Pk), c = i.b;
            n = a, r = A2(oj, i.a, A2(xj, 1, r)), t = c;
        }
    }), jj = F2(function(n, e) {
        var r = v(n, e);
        n: for(;;){
            e: for(;;){
                if (1 === r.b.$) {
                    if (1 === r.a.$) break n;
                    return Ur;
                }
                if (1 === r.a.$) break n;
                if (r.b.a) {
                    if (r.b.b.b && 1 === r.b.b.a && !r.b.b.b.b) return zr(v(lj(n), Pk));
                    break e;
                }
                if (r.b.b.b && 1 === r.b.b.a && !r.b.b.b.b) return zr(v(n, Pk));
                break e;
            }
            var t = r.a, u = t.a, a = r.b, i = a.a;
            switch(A2(cj, t.b, a.b)){
                case 0:
                    return zr(v(Pk, n));
                case 1:
                    var c = s(u, i) ? 0 : 1;
                    return zr(v(A2(Lk, c, A([
                        1
                    ])), Pk));
                default:
                    return A2(Pc, A2(dj, n, e), A4(kj, sj(n), sj(e), Pk, Pk));
            }
        }
        return zr(v(Pk, Pk));
    }), yj = F2(function(n, e) {
        return 1 === A2(fj, n, e);
    }), wj = F2(function(n, e) {
        return !A2(fj, n, e);
    }), Aj = F2(function(n, e) {
        var r = Wk, t = s(A2(wj, n, r), A2(wj, e, r)), u = A2(Nc, v(Wk, Wk), A2(jj, n, e)), a = u.a;
        if (A2(yj, u.b, r)) return a;
        switch(A2(fj, a, r)){
            case 0:
                return A2(oj, a, Jk(-1));
            case 1:
                return A2(oj, a, t ? vj : Jk(-1));
            default:
                return A2(oj, a, vj);
        }
    }), Tj = F2(function(n, e) {
        var r = Wk, t = s(A2(wj, n, r), A2(wj, e, r)), u = A2(Nc, v(Wk, Wk), A2(jj, n, e)), a = u.a;
        if (A2(yj, u.b, r)) return a;
        switch(A2(fj, a, r)){
            case 0:
                return A2(oj, a, Jk(-1));
            case 1:
                return t ? a : A2(oj, a, Jk(-1));
            default:
                return a;
        }
    }), Ej = F2(function(n, e) {
        return A2(Pc, Gh, A2(jj, n, e));
    }), Cj = F2(function(n, e) {
        var r = A2(Nc, v(Wk, Wk), A2(jj, n, e)), t = r.a, u = r.b, a = function() {
            switch(A2(fj, sj(A2(pj, Jk(2), u)), sj(e))){
                case 0:
                    return Wk;
                case 1:
                    if (s(A2(Nc, Wk, A2(Ej, t, Jk(2))), Wk)) return Wk;
                    switch(A2(fj, n, Wk)){
                        case 0:
                            return Jk(-1);
                        case 1:
                            return Wk;
                        default:
                            return vj;
                    }
                default:
                    switch(A2(fj, n, Wk)){
                        case 0:
                            return Jk(-1);
                        case 1:
                            return Wk;
                        default:
                            return vj;
                    }
            }
        }();
        return A2(oj, t, a);
    }), Ij = F2(function(n, e) {
        return A2(Nc, v(Wk, Wk), A2(jj, n, e)).a;
    }), Sj = F2(function(n, e) {
        var r = Wk, t = s(A2(wj, n, r), A2(wj, e, r)), u = A2(Nc, v(Wk, Wk), A2(jj, n, e)), a = u.a;
        if (A2(yj, u.b, r)) return a;
        switch(A2(fj, a, r)){
            case 0:
                return a;
            case 1:
                return t ? A2(oj, a, vj) : a;
            default:
                return A2(oj, a, vj);
        }
    }), Oj = F3(function(n, e, r) {
        switch(n){
            case 0:
                return A2(Tj, e, r);
            case 1:
                return A2(Sj, e, r);
            case 2:
                return A2(Ij, e, r);
            case 3:
                return A2(Aj, e, r);
            default:
                return A2(Cj, e, r);
        }
    }), Lj = F2(function(n, e) {
        return 0 > m(n, e) ? n : e;
    }), Pj = F2(function(n, e) {
        if (1 === e.$) return Sk;
        var r = e.a, t = e.b;
        if (1 > m(n.aP, t)) return e;
        if (m(n.aP, nj(r) + t) > 0) return Sk;
        var u = n.aP - t, a = 11 > u ? Jk(A2(Gk, 10, u)) : A2(Nc, Wk, Mk("1" + A2(Wc, u, "0"))), i = A3(Oj, n.co, r, a);
        return A2(yj, i, Wk) ? Sk : A2(Bk, A2(Lj, n.aP, -32), A2(Ik, i, n.aP));
    }), qj = function(n) {
        return Pj({
            aP: n,
            co: 4
        });
    }, Nj = F2(function(n, e) {
        switch(A2(fj, n, e)){
            case 2:
            case 1:
                return !0;
            default:
                return !1;
        }
    }), _j = F2(function(n, e) {
        if (1 === e.$) return "0";
        var r = e.a, t = e.b;
        if (1 === n) {
            var u = function(n) {
                if (1 === n.$) return v(Sk, 0);
                var e = n.a, r = n.b, t = -(nj(e) - 1);
                return v(A2(Ik, e, t), r - t);
            }(e), a = u.a, i = u.b;
            return k(zj()(a), "e" + ut(i));
        }
        var c = A2(Nj, r, Wk) ? "" : "-", o = Yk(sj(r)), f = function() {
            switch(A2(ea, t, 0)){
                case 2:
                    return k(o, A2(Wc, t, "0"));
                case 1:
                    return o;
                default:
                    switch(A2(ea, iu(o), -t)){
                        case 2:
                            return A2(at, ".", A([
                                A2(Fd, -t, o),
                                A2(sk, -t, o)
                            ]));
                        case 1:
                            return "0." + o;
                        default:
                            return "0." + A3(Kc, -t, "0", o);
                    }
            }
        }();
        return k(c, f);
    });
    function zj() {
        return _j(0);
    }
    var Uj = zj();
    zj = function() {
        return Uj;
    };
    var Mj, Dj, Rj = F2(function(n, e) {
        var r, t = function(n) {
            return A2(Hu, Ek($(Ck, {
                li: uk(n)
            })), A2(Yb, "\u2212", "-"));
        };
        if (vk(e)) return "N/A";
        if (pk(e)) return (0 > e ? "-" : "") + "\u221E";
        if (e) {
            if (s(yf(e), e)) return A2(t, 0, e);
            if (100 > ak(e)) {
                if (.01 > ak(e)) {
                    var u = A2(_j, 1, A2(qj, -12, (r = e, A2(Nc, A2(Ik, Wk, 0), Zk(Js(r)))))), a = A2(Hu, pp, A2(Hu, Nc(0), t(2))), i = A2(it, "e", u);
                    if (i.b && i.b.b && !i.b.b.b) {
                        var c = i.b.a;
                        return a(i.a) + "e" + c;
                    }
                    return A2(t, n, e);
                }
                return A2(t, n, e);
            }
            return A2(t, 0, e);
        }
        return "0";
    }), Fj = F2(function(n, e) {
        return A2(Rj, 5, n) + (Th(e.aL) + " ") + Gb(e);
    }), Hj = F2(function(n, e) {
        return A2(fs, Fj(e.j), A2(Ns, e.U.mj, n));
    }), Gj = F2(function(n, e) {
        var r = e.Y, t = e.mj, u = e.D, a = function(e) {
            return A2(fs, function(n) {
                return ut(u) + " " + A2(fx, zr(e), r).ek + " [ " + n + " ]";
            }, A2(fs, at(" | "), A2(qg, Hj(n.W), A2(G$, e, r))));
        };
        return t.$ ? a(A2(fx, Ur, r)) : A2(as, a, A2(V$, t.a, n.dZ));
    }), Xj = function(n) {
        return A2(Hu, qg(Gj(n)), fs(at(", ")));
    }, Vj = F4(function(n, e, r, t) {
        var u = n.C, a = v(A3(rk, e, t, n.bH.ap), Ld(A2(tk, t, r)));
        return a.a.$ ? a.b.$ ? A2(Zg, "N/A", A2(Xj, u, t.my)) : a.b.a.ek : a.a.a.ek;
    }), Jj = F3(function(n, e, r) {
        var t = r.an;
        switch(n){
            case 0:
                return $(r, {
                    an: $(t, {
                        e$: e
                    })
                });
            case 1:
                return $(r, {
                    an: $(t, {
                        fh: e
                    })
                });
            case 2:
                return $(r, {
                    an: $(t, {
                        gR: e
                    })
                });
            default:
                return $(r, {
                    an: $(t, {
                        f2: e
                    })
                });
        }
    }), Yj = F4(function(n, e, r, t) {
        var u = A3(nk, t, n, r), a = A2(Kx, ds(n), t.C.l9.lT);
        return A2(Sp, r.$ ? A([
            Ip({
                pT: 0,
                pU: 0
            })
        ]) : j, A2(Wx, A3(Jj, n, u, t), {
            dN: 1,
            cN: Ur,
            bv: Ur,
            bw: Ur,
            bx: A4(Vj, t, n, a, u),
            dW: 1,
            cT: Nl(t) ? 2 : 1,
            cV: "",
            cW: "",
            a9: !1,
            bX: j,
            lT: a,
            b7: Ur,
            iE: n,
            O: A2(eh, e, t.C.c_),
            dd: u,
            ac: A2(Yx, {
                az: t.h8,
                C: t.C,
                at: ds(n)
            }, u),
            M: j
        }));
    }), Wj = F3(function(n, e, r) {
        var t = r / e, u = v(.33, 1), a = u.a, i = u.b, c = 0 > m(t, a) ? 1 : m(t, i) > 0 ? 0 : (e - r / i) / (r / a - r / i);
        return function() {
            switch(n){
                case 0:
                    return .67 * c + .33;
                case 1:
                    return .67 * c;
                default:
                    return c;
            }
        }();
    }), Kj = function(n) {
        return n(1.45);
    }, Bj = function(n) {
        return n(.67);
    }, Qj = function(n) {
        return n;
    }, Zj = function(n) {
        return A2(Lj, n.g$, n.jc);
    }, ny = function(n) {
        var e, r, t, u, a, i, c, o = n.A, f = {
            jc: (e = {
                h_: A2(Nc, o.aS.lK.h_, o.h_),
                je: A2(Nc, o.aS.lK.je, o.je),
                jr: A2(Nc, o.aS.lK.jr, o.jr),
                jF: o.aS.lK.jF
            }, u = A2(Hu, Rt(100), A2(Hu, yf, function(n) {
                return n / 100;
            })), a = tl(A2(wu, function(n) {
                return n.a * n.b;
            }, A([
                v(.5, (r = e.je, t = F2(function(n, e) {
                    return (e - r) / (e - n);
                }), r > 1e3 ? r > 7e3 ? r > 16e3 ? 0 : .5 * A2(t, 7e3, 16e3) : .5 + .5 * A2(t, 1e3, 7e3) : 1)),
                v(.5, A3(Wj, e.h_, e.jr, e.jF))
            ]))), i = v(Bj(ru), Kj(ru)), u((c = i.a) + a * (i.b - c))),
            g$: n.aO.g$
        };
        return $(n, {
            go: A2(bh, Zj(f), n.go),
            aO: f,
            pK: yf(n.pK * Zj(f))
        });
    }, ey = function(n) {
        return A2(Zg, 1, function() {
            switch(n){
                case 0:
                    return Ys(19);
                case 1:
                    return Ys(5);
                default:
                    return Ys(37);
            }
        }());
    }, ry = F3(function(n, e, r) {
        var t = e, u = v(A2(bh, t, r.d2), A2(bh, t, r.eb)), a = u.a, i = u.b;
        return {
            c5: lh(A([
                A2($h, vh(a), n.lO.g),
                A2($h, gh(i), n.me.g)
            ])),
            eb: i,
            a$: a,
            bh: ck(r),
            pb: A2($h, A2(v$, t, ey(n.hP)), r.g)
        };
    }), ty = {
        c5: Ks,
        eb: 0,
        a$: 0,
        bh: j,
        pb: Ks
    }, uy = F2(function(n, e) {
        var r = e.hW, t = e.im, u = e.ko;
        switch(n){
            case 0:
                return A([
                    r
                ]);
            case 1:
            case 2:
                return A([
                    r,
                    t
                ]);
            default:
                return A([
                    u
                ]);
        }
    }), ay = F4(function(n, e, r, t) {
        for(;;){
            if (!r.b) return xt(t);
            var u = r.a, a = r.b, i = n(u);
            A2(el, i, e) ? r = a : (e = A2(Mr, i, e), r = a, t = A2(Mr, u, t));
        }
    }), iy = function(n) {
        return A4(ay, ru, j, n, j);
    }, cy = F3(function(n, e, r) {
        var t = r.i, u = r.de;
        return A3(ot, F2(function(n, e) {
            var r = n.eb, t = n.a$, u = n.bh, a = n.pb;
            return $(e, {
                c5: lh(A([
                    e.c5,
                    n.c5
                ])),
                eb: A2(uh, r, e.eb),
                a$: A2(uh, t, e.a$),
                bh: iy(k(e.bh, u)),
                pb: lh(A([
                    e.pb,
                    a
                ]))
            });
        }), ty, A2(Id, function(e) {
            var r = e.U;
            return A2(wu, A2(ry, t, A2(Zh, u, e.aH)), A2(uy, r.jh, n));
        }, e));
    }), oy = F2(function(n, e) {
        return e / n;
    }), fy = function(n) {
        return jf(A2(oy, Zd(1), n));
    }, sy = function(n) {
        return jf(A2(oy, 1, n));
    }, ly = function(n) {
        return jf(A2(oy, sb(1), n));
    }, dy = function(n) {
        return A2(Hu, function(n) {
            return n.g;
        }, ch(n));
    }, by = F5(function(n, e, r, t, u) {
        var a = Zd(u * vh(e.d2)), i = sb(u * gh(e.eb));
        return {
            eb: i,
            g: A2(fh, F2(function(n) {
                return ah(A([
                    A2(sy, A2(dy, n, e), u),
                    A2(ly, A2(dy, n, r), i),
                    A2(fy, A2(dy, n, t), a)
                ]));
            }), n),
            a$: a
        };
    }), my = F2(function(n, e) {
        return 2 === e.hG ? n.iJ : n.iK;
    }), py = function(n) {
        return 3 === n;
    }, vy = F4(function(n, e, r, t) {
        var u = e.hP, a = e.lJ;
        return A2(fh, F2(function(n) {
            var e;
            return e = A2(bh, ey(u), A2(sy, A2(dy, n, a), r)), A2(Zh, e, t);
        }), n);
    }), gy = F2(function(n, e) {
        var r = n.lF, t = n.lG, u = n.lH;
        n: for(; !e.$;)switch(e.a){
            case 1:
                return t;
            case 2:
                return u;
            default:
                break n;
        }
        return r;
    }), hy = F2(function(n, e) {
        return $(e, {
            ac: n(e.ac)
        });
    }), $y = c, xy = F2(function(n, e) {
        var r = e.d, t = function(e) {
            return e.$ ? qt(A2($y, n, e.a)) : Ft(A2($y, t, e.a));
        };
        return A4(Tt, e.a, e.b, A2($y, t, e.c), A2($y, n, r));
    }), ky = F2(function(n, e) {
        return xy(function(r) {
            return s(r.ai, n) ? e(r) : r;
        });
    }), jy = F2(function(n, e) {
        return hy(A2(ky, n, e));
    }), yy = F2(function(n, e) {
        var r = n.oX, t = e.A;
        return A3(jy, 2, function(n) {
            var e = n.i, u = n.c2, a = A3(cy, r.pQ, t.ft, n), i = A2(my, r.pQ, e), c = lh(A2(wu, function(e) {
                var t = e.aH;
                return A4(vy, n.g, {
                    hP: n.i.hP,
                    lJ: py(e.U.jh) ? r.pQ.lI : r.pQ.lE
                }, n.nI, t);
            }, t.ft)), o = A5(by, n.g, A2(gy, r.pQ, u), i, e.lO, n.nI), f = o.g, s = o.a$;
            return $(n, {
                eb: ah(A([
                    n.eb,
                    o.eb,
                    a.eb
                ])),
                g: lh(A([
                    n.g,
                    f,
                    c,
                    a.c5,
                    a.pb
                ])),
                a$: ah(A([
                    n.a$,
                    s,
                    a.a$
                ])),
                nP: a
            });
        }, e);
    }), wy = F3(function(n, e, r) {
        var t = e.cX, u = e._, a = e.me, i = e.nJ, c = A2(_h, .2, e.eY), o = v(ah(A([
            A2(bh, c, i.d2),
            A2(bh, r, u.d2)
        ])), ah(A([
            A2(bh, c, i.eb),
            A2(bh, r, u.eb)
        ]))), f = o.a, s = o.b;
        return {
            eb: s,
            g: A2(fh, F2(function(n) {
                return ah(A([
                    A2(bh, c, A2(dy, n, i)),
                    A2(fy, A2(dy, n, t), f),
                    A2(ly, A2(dy, n, a), s),
                    A2(sy, A2(dy, n, u), r)
                ]));
            }), n),
            a$: f
        };
    }), Ay = F2(function(n, e) {
        var r = n.oX;
        return A3(jy, 1, function(n) {
            var t = n.i, u = A3(wy, n.g, {
                cX: t.lO,
                _: r.pQ._,
                me: t.me,
                nJ: r.pQ.nJ,
                eY: e.A.aS._.eY
            }, n.nI);
            return $(n, {
                eb: u.eb,
                g: u.g,
                a$: u.a$
            });
        }, e);
    }), Ty = F2(function(n, e) {
        switch(e){
            case 0:
                return n.mA;
            case 1:
                return n.mB;
            case 2:
                return n.mD;
            case 3:
                return n.mC;
            case 4:
                return n.mE;
            default:
                return n.pP;
        }
    }), Ey = F3(function(n, e, r) {
        for(;;){
            var t = A2(Ht, At, n), u = t.a, a = t.b;
            if (0 > m(Mt(u), At)) return A2(Jt, !0, {
                V: e,
                N: r,
                R: u
            });
            n = a, e = A2(Mr, qt(u), e), r += 1;
        }
    }), Cy = function(n) {
        return n.b ? A3(Ey, n, j, 0) : Lt;
    }, Iy = F2(function(n, e) {
        return Cy(A3(Rr, F2(function(e, r) {
            return n(e) ? A2(Mr, e, r) : r;
        }), j, e));
    }), Sy = 4294967295 >>> 32 - Ot, Oy = u, Ly = F3(function(n, e, r) {
        for(;;){
            var t = A2(Oy, Sy & e >>> n, r);
            if (t.$) return A2(Oy, Sy & e, t.a);
            n -= Ot, r = t.a;
        }
    }), Py = function(n) {
        return n >>> 5 << 5;
    }, qy = F2(function(n, e) {
        var r = e.a, t = e.b, u = e.c, a = e.d;
        return 0 > n || m(n, r) > -1 ? Ur : m(n, Py(r)) > -1 ? zr(A2(Oy, Sy & n, a)) : zr(A3(Ly, t, n, u));
    }), Ny = function(n) {
        return A2(Hu, Iy(A2(Hu, function(n) {
            return n.ai;
        }, zt(n))), qy(0));
    }, _y = F3(function(n, e, r) {
        return A2(Hu, Ny(n), A2(Hu, Pc(e), Nc(r)));
    }), zy = F3(function(n, e, r) {
        var t = e.cX, u = Zd(r * vh(e.d2));
        return {
            g: A2(fh, F2(function(n) {
                return A2(fy, A2(dy, n, t), u);
            }), n),
            a$: u,
            jm: Ur,
            kc: Ur
        };
    }), Uy = function(n) {
        return n;
    }, My = function(n) {
        return n;
    }, Dy = F2(function(n, e) {
        return yf(n * e * 100);
    }), Ry = ru, Fy = F2(function(n, e) {
        return Ry(wf(n) * Cf(e) / 100 / 2 / 1.08);
    }), Hy = F2(function(n, e) {
        return e / n;
    }), Gy = F2(function(n, e) {
        return A2(Hy, n, e);
    }), Xy = F2(function(n, e) {
        var r = e.cX, t = e.nI, u = e.nK, a = e.hj, i = A2(Fy, a, e.pV), c = A2(Dy, i, A2(Gy, a, t)), o = Zd(u * c);
        return {
            g: A2(fh, F2(function(n) {
                return A2(fy, A2(dy, n, r), o);
            }), n),
            a$: o,
            jm: zr(c),
            kc: zr(i)
        };
    }), Vy = F2(function(n, e) {
        var r = n.oX, t = e.A, u = A4(_y, 3, function(n) {
            return n.nI;
        }, 0, e.ac);
        return A3(jy, 3, function(n) {
            var e = n.i, a = A2(Ty, r.pQ, A2(Nc, t.aS.iz, t.b6)), i = 5 !== A2(Nc, t.aS.iz, t.b6) ? A3(zy, n.g, {
                cX: e.lO,
                d2: a.d2
            }, n.nI) : A2(Xy, n.g, {
                cX: e.lO,
                nI: u,
                nK: 3145e-7,
                hj: A2(Nc, t.aS.hj, t.hj),
                pV: A2(Nc, t.aS.pV, t.pV)
            });
            return $(n, {
                g: i.g,
                a$: i.a$,
                jm: i.jm,
                kc: i.kc
            });
        }, e);
    }), Jy = F2(function(n, e) {
        return e - n;
    }), Yy = F2(function(n, e) {
        var r = A2(_h, n, e);
        return {
            P: r,
            pO: A2(Jy, e, r)
        };
    }), Wy = F2(function(n, e) {
        return $(e, {
            de: n,
            nI: n
        });
    }), Ky = F3(function(n, e, r) {
        return A3(ot, function(n) {
            return A2(ky, n, e);
        }, r, n);
    }), By = F2(function(n, e) {
        return hy(A2(Ky, n, e));
    }), Qy = F2(function(n, e) {
        return n - e;
    }), Zy = F3(function(n, e, r) {
        return $(r, {
            de: e,
            nI: A2(Qy, e, n),
            pO: n
        });
    }), nw = F2(function(n, e) {
        var r = e.A, t = e.ac, u = A2(Yy, A2(Ty, n.oX.pQ, A2(Nc, r.aS.iz, r.b6)).g4, A4(_y, 4, function(n) {
            return n.de;
        }, 0, t)), a = u.P, i = u.pO;
        return A3(By, A([
            5,
            6
        ]), Wy(a), A3(jy, 3, A2(Zy, i, a), e));
    }), ew = a, rw = F3(function(n, e, r) {
        var t = r.c, u = r.d, a = F2(function(e, r) {
            return A3(ew, e.$ ? n : a, r, e.a);
        });
        return A3(ew, n, A3(ew, a, e, t), u);
    }), tw = A2(rw, F2(function(n, e) {
        var r = n.g, t = n.eN;
        return n.gt ? A2(fh, F2(function(n, e) {
            return ah(A([
                A2(ch, n, r),
                e,
                A2(ch, n, t.g)
            ]));
        }), e) : e;
    }), Ks), uw = function(n) {
        return fh(function() {
            return _h(n);
        });
    }, aw = function(n) {
        return O$(Pc(_h(n)));
    }, iw = A([
        function(n) {
            return n.ag;
        },
        function(n) {
            return n.aa;
        },
        function(n) {
            return n.ah;
        },
        function(n) {
            return n.aj;
        },
        function(n) {
            return n.ak;
        },
        function(n) {
            return n.al;
        },
        function(n) {
            return n.am;
        }
    ]), cw = function(n) {
        return A2(wu, function(e) {
            return e(n);
        }, iw);
    }, ow = A2(Hu, cw, A2(Hu, wu(Nc(0)), ah)), fw = F2(function(n, e) {
        var r = ow(n);
        return A3(I$, 19, A2(uh, r, A2(ch, 19, e)), e);
    }), sw = F3(function(n, e, r) {
        return {
            ag: A2(n, e.ag, r.ag),
            aa: A2(n, e.aa, r.aa),
            ah: A2(n, e.ah, r.ah),
            aj: A2(n, e.aj, r.aj),
            ak: A2(n, e.ak, r.ak),
            al: A2(n, e.al, r.al),
            am: A2(n, e.am, r.am)
        };
    }), lw = F2(function(n, e) {
        return A3(sw, F2(function(n, e) {
            var r = v(n, e);
            return r.a.$ ? r.b.$ ? Ur : zr(r.b.a) : zr(r.b.$ ? r.a.a : A2(uh, r.a.a, r.b.a));
        }), n, e);
    }), dw = {
        ag: Ur,
        aa: Ur,
        ah: Ur,
        aj: Ur,
        ak: Ur,
        al: Ur,
        am: Ur
    }, bw = A2(Hu, Fr, A2(Hu, Ah(function(n) {
        return n.gt;
    }), A2(Hu, wu(function(n) {
        return n.S;
    }), A2(ot, lw, dw)))), mw = function(n) {
        var e = n.aO, r = n.ac, t = A2(aw, Zj(e), bw(A2(Iy, function(n) {
            return n.gt;
        }, r)));
        return $(n, {
            S: t,
            g: lh(A([
                n.g,
                A2(fw, t, A2(uw, Zj(e), tw(r)))
            ]))
        });
    }, pw = F3(function(n, e, r) {
        var t = e.iu, u = e.l4, a = e.me, i = v(A2(bh, r, u.eb), A2(bh, r, u.d2)), c = i.a, o = i.b;
        return {
            eb: c,
            g: A2(fh, F2(function(n) {
                return ah(A([
                    A2(sy, A2(dy, n, u), r),
                    A2(ly, A2(dy, n, a), c),
                    A2(fy, A2(dy, n, t), o)
                ]));
            }), n),
            a$: o
        };
    }), vw = F2(function(n, e) {
        var r = n.oX;
        return A3(jy, 2, function(n) {
            var e = n.i, t = A3(pw, n.g, {
                iu: e.lO,
                l4: r.pQ.l3,
                me: A2(my, r.pQ, e)
            }, n.nI), u = t.g, a = t.a$;
            return $(n, {
                eb: A2(uh, t.eb, n.eb),
                g: lh(A([
                    n.g,
                    u
                ])),
                a$: A2(uh, a, n.a$)
            });
        }, e);
    }), gw = ru, hw = function(n) {
        var e = n.aO, r = n.A;
        return A3(jy, 4, function(n) {
            var t, u;
            return $(n, {
                cJ: (t = r.cJ, t.$ ? (u = n.i, 2 === u.hG || s(u.cR, gw("TR")) ? 0 : 1 > Zj(e) ? 1 : .33) : t.a)
            });
        }, n);
    }, $w = F3(function(n, e, r) {
        var t = v(r, e);
        n: for(;;){
            if (!t.b.$) return t.b.a;
            if (t.a.$) break n;
            switch(t.a.a){
                case 1:
                    return 5;
                case 2:
                    return 3;
                default:
                    break n;
            }
        }
        return n;
    }), xw = function(n) {
        return n / 60;
    }, kw = function(n) {
        return 60 * n;
    }, jw = function(n) {
        switch(n){
            case 0:
                return kw(60);
            case 1:
                return kw(15);
            case 2:
                return kw(30);
            case 3:
                return kw(0);
            case 4:
                return kw(120);
            default:
                return kw(5);
        }
    }, yw = F3(function(n, e, r) {
        var t = e.cX, u = e.k9, a = e.l1, i = e.mV, c = Zd(.029), o = A2(bh, xw(jw(i)), c), f = v(A2(bh, r, A2(Nc, 0, A2(Pc, function(n) {
            return n.d2;
        }, a))), A2(bh, r, A2(Nc, 0, A2(Pc, function(n) {
            return n.eb;
        }, a)))), s = f.a, l = f.b;
        return {
            eb: l,
            g: A2(fh, F2(function(n) {
                return ah(A([
                    A2(fy, A2(dy, n, t), o),
                    A2(sy, A2(Nc, 0, A2(Pc, dy(n), a)), r),
                    A2(fy, A2(dy, n, t), s),
                    A2(ly, A2(dy, n, u), l)
                ]));
            }), n),
            a$: ah(A([
                o,
                s
            ]))
        };
    }), ww = F2(function(n, e) {
        var r = n.oX, t = e.A;
        return A3(jy, 4, function(n) {
            var e = n.i, u = A3(yw, n.g, {
                cX: e.lO,
                k9: e.me,
                l1: s(t.c8, zr(!0)) ? zr(r.pQ.c8) : Ur,
                mV: A3($w, t.aS.gL.gi, t.mV, t.b6)
            }, n.nI);
            return $(n, {
                eb: u.eb,
                g: u.g,
                a$: u.a$
            });
        }, e);
    }), Aw = .15, Tw = F2(function(n, e) {
        var r = A2(_h, ob(n), e);
        return {
            lg: A2(Jy, e, r),
            P: r
        };
    }), Ew = A([
        5,
        6,
        3,
        2
    ]), Cw = F3(function(n, e, r) {
        return $(r, {
            lg: n,
            de: e,
            nI: A2(Qy, e, n)
        });
    }), Iw = function(n) {
        var e = n.ac, r = A2(Tw, A2(Nc, Aw, n.A.dk), A4(_y, 4, function(n) {
            return n.de;
        }, 0, e)), t = r.lg, u = r.P;
        return A3(By, Ew, Wy(u), A3(jy, 4, A2(Cw, t, u), n));
    }, Sw = F3(function(n, e, r) {
        var t = v(r, e);
        n: for(;;){
            if (!t.b.$) return t.b.a;
            if (t.a.$) break n;
            switch(t.a.a){
                case 1:
                    return .02;
                case 2:
                    return 0;
                default:
                    break n;
            }
        }
        return n;
    }), Ow = function(n) {
        return n;
    }, Lw = function(n) {
        var e = n.A, r = A2(Yy, function(n) {
            return 1 - n;
        }(A3(Sw, e.aS.gL.jk, e.dl, e.b6)), e.P), t = r.P, u = r.pO;
        return A3(By, Ew, Wy(t), A3(jy, 4, A2(Zy, u, t), n));
    }, Pw = function(n) {
        return df(n);
    }, qw = function(n) {
        return A2(Hu, xs(A2(Hu, function(n) {
            return n.mj;
        }, zt(n))), ks("Mati\xe8re non trouv\xe9e id=" + Pw(n) + "."));
    }, Nw = F2(function(n, e) {
        return v(n, e);
    }), _w = F2(function(n, e) {
        return A3(Dk, Nw, A2(Ba, function(n) {
            return Ld(A2(qw, n, e));
        }, n.g7), n.kT);
    }), zw = F3(function(n, e, r) {
        return A2(fh, F2(function(n) {
            return A2(sy, A2(dy, n, e), r);
        }), n);
    }), Uw = F3(function(n, e, r) {
        var t = e.kT, u = e.nl, a = e.n0, i = t.mW, c = t.n1;
        return A2(fh, F2(function(n) {
            var e = v(A2(dy, n, a), A2(dy, n, u)), t = e.b;
            return r * (A2(v$, e.a, i) + A2(v$, c, ob(i)) * t);
        }), n);
    }), Mw = F3(function(n, e, r) {
        var t = A2(_w, e, n.oX.ft);
        if (t.$) return A3(zw, r.g, e.t, r.nI);
        var u = t.a;
        return A3(Uw, r.g, {
            kT: u.b,
            nl: u.a.t,
            n0: e.t
        }, r.nI);
    }), Dw = F2(function(n, e) {
        var r = e.A;
        return A3(jy, 5, function(e) {
            return $(e, {
                g: lh(A2(wu, function(r) {
                    var t = r.aH;
                    return A2(fh, function() {
                        return bh(t);
                    }, A3(Mw, n, r.U, e));
                }, r.ft))
            });
        }, e);
    }), Rw = function(n) {
        var e, r = n.A, t = (e = A4(_y, 6, function(n) {
            return n.de;
        }, 0, n.ac), A3(ot, F2(function(n, e) {
            return {
                P: A2(uh, e.P, n.P),
                pO: A2(uh, e.pO, n.pO)
            };
        }), {
            P: 0,
            pO: 0
        }, A2(wu, function(n) {
            return A2(Yy, n.U.t.g4, A2(bh, n.aH, e));
        }, r.ft)));
        return A3(jy, 5, A2(Zy, t.pO, t.P), n);
    }, Fw = F2(function(n, e) {
        return n ? {
            nQ: e.jv,
            nR: e.js
        } : {
            nQ: e.ju,
            nR: e.jt
        };
    }), Hw = function(n) {
        return jf(A2(oy, 1, n));
    }, Gw = F4(function(n, e, r, t) {
        var u = e.hP, a = e.nR, i = e.hj;
        return A2(fh, F2(function(n) {
            var e;
            return e = A2(bh, ey(u), A2(Hw, A2(dy, n, a), A2(Gy, i, t))), A2(Zh, e, r);
        }), n);
    }), Xw = F3(function(n, e, r) {
        var t = e.iu, u = e.me, a = e.nQ, i = e.nX, c = A2(Zh, A2(Gy, e.hj, r), i), o = c, f = v(A2(bh, o, a.eb), A2(bh, o, a.d2)), s = f.a, l = f.b;
        return {
            eb: s,
            g: A2(fh, F2(function(n) {
                return ah(A([
                    A2(Hw, A2(dy, n, a), c),
                    A2(ly, A2(dy, n, u), s),
                    A2(fy, A2(dy, n, t), l)
                ]));
            }), n),
            a$: l
        };
    }), Vw = F2(function(n, e) {
        var r = n.oX, t = e.A;
        return A3(jy, 2, function(n) {
            var e = n.i, u = n.$7;
            if (u.$) return n;
            var a = u.a.nX, i = A2(Fw, u.a.gJ, r.pQ), c = i.nQ, o = A4(Gw, n.g, {
                hP: n.i.hP,
                nR: i.nR,
                hj: A2(Nc, t.aS.hj, t.hj)
            }, a, n.nI), f = A3(Xw, n.g, {
                iu: e.lO,
                me: A2(my, r.pQ, e),
                nQ: c,
                nX: a,
                hj: A2(Nc, t.aS.hj, t.hj)
            }, n.nI), s = f.g, l = f.a$;
            return $(n, {
                eb: A2(uh, f.eb, n.eb),
                g: lh(A([
                    n.g,
                    s,
                    o
                ])),
                a$: A2(uh, l, n.a$)
            });
        }, e);
    }), Jw = function(n) {
        return 3 === n ? 1 : 0;
    }, Yw = {
        gj: {
            jd: 4,
            pO: A2(Zg, 0, Ys(12))
        },
        hl: {
            jd: 1.5,
            pO: A2(Zg, 0, Ys(3))
        },
        hB: {
            jd: 2,
            pO: A2(Zg, 0, Ys(12))
        }
    }, Ww = F3(function(n, e, r) {
        return Cf(e) / 50 * function(n) {
            switch(n){
                case 0:
                    return Yw.gj.jd;
                case 1:
                    return Yw.hl.jd;
                default:
                    return Yw.hB.jd;
            }
        }(r) * n;
    }), Kw = F2(function(n, e) {
        var r = e.cX, t = e.oG;
        return {
            eb: 0,
            g: A2(fh, F2(function(n) {
                return A2(fy, A2(dy, n, r), t);
            }), n),
            a$: t
        };
    }), Bw = F4(function(n, e, r, t) {
        var u = A2(Nc, r.pV, t.pV), a = A2(Nc, Jw(n.jh), e), i = Zd(A3(Ww, t.nI, u, a));
        return A2(Kw, t.g, {
            cX: t.i.lO,
            oG: i
        });
    }), Qw = function(n) {
        var e = n.A;
        return A3(jy, 6, function(n) {
            return $(n, {
                g: lh(A2(wu, function(r) {
                    var t = r.aH;
                    return A2(fh, function() {
                        return bh(t);
                    }, A4(Bw, r.U, r.dz, e.aS, n).g);
                }, e.ft)),
                a$: A3(ot, uh, 0, A2(wu, function(r) {
                    return A2(bh, r.aH, A4(Bw, r.U, r.dz, e.aS, n).a$);
                }, e.ft))
            });
        }, n);
    }, Zw = F2(function(n, e) {
        return n / e;
    }), nA = function(n) {
        var e, r = n.A, t = (e = A4(_y, 3, function(n) {
            return n.de;
        }, 0, n.ac), A3(ot, F2(function(n, e) {
            return {
                P: A2(uh, e.P, n.P),
                pO: A2(uh, e.pO, n.pO)
            };
        }), {
            P: 0,
            pO: 0
        }, A2(wu, function(n) {
            var r = n.aH, t = n.dz, u = function(n) {
                switch(n){
                    case 0:
                        return Yw.gj.pO;
                    case 1:
                        return Yw.hl.pO;
                    default:
                        return Yw.hB.pO;
                }
            }(A2(Nc, Jw(n.U.jh), t)), a = A2(bh, r, e), i = A2(Zw, a, ob(u));
            return {
                P: i,
                pO: A2(Qy, i, a)
            };
        }, r.ft)));
        return A3(jy, 6, A2(Zy, t.pO, t.P), n);
    }, eA = 1 / 0, rA = F4(function(n, e, r, t) {
        var u = v(A2(Ba, Xh(r), A2(Xh, e, t)), A2(Ba, Xh(e), A2(Xh, r, t)));
        return u.a.$ ? u.b.$ ? function(n) {
            return {
                f5: eA,
                g: n,
                ds: eA,
                og: eA,
                hb: eA,
                oq: eA
            };
        }(n) : $(u.b.a, {
            g: n
        }) : $(u.a.a, {
            g: n
        });
    }), tA = F3(function(n, e, r) {
        var t = r.i, u = r.U;
        return s(r.aH, 0) ? cx(Ks) : A4(rA, Ks, A2(Nc, u.ig, A2(Pc, function(n) {
            return n.cR;
        }, t)), e, n);
    }), uA = F3(function(n, e, r) {
        return A2(bh, Tf(e), A2(sy, n, A2(_h, 1e3, r)));
    }), aA = F5(function(n, e, r, t, u) {
        var a = e.cI, i = e.dt, c = u.f5, o = u.ds, f = u.hb;
        return {
            f5: c,
            g: A2(fh, F2(function(n) {
                var e = g(A3(uA, A2(dy, n, r), o, t), A3(uA, A2(dy, n, i), f, t), A3(uA, A2(dy, n, a), c, t));
                return ah(A([
                    e.a,
                    e.b,
                    e.c
                ]));
            }), n),
            ds: o,
            og: 0,
            hb: f,
            oq: 0
        };
    }), iA = F4(function(n, e, r, t) {
        var u = n.lw, a = n.oX;
        return A5(aA, Ks, a.pQ, a.pQ.cy, A2(Zh, r, t.aH), A2(g$, 0, A3(tA, u, e.cR, t)));
    }), cA = F2(function(n, e) {
        return $(e, {
            f5: A2(uh, n.f5, e.f5),
            ds: A2(uh, n.ds, e.ds),
            hb: A2(uh, n.hb, e.hb)
        });
    }), oA = F2(function(n, e) {
        var r = cx(n.eN.g);
        switch(n.ai){
            case 0:
                return A2(cA, $(r, {
                    ds: ml(500)
                }), r);
            case 1:
            case 7:
                return r;
            case 4:
                return A2(g$, n.cJ, e);
            default:
                return A2(g$, 0, e);
        }
    }), fA = F2(function(n, e) {
        return 4 === e.ai ? n.P : e.nI;
    }), sA = F4(function(n, e, r, t) {
        var u = t.aG, a = 5 === t.ai ? wx(A2(wu, A3(iA, n, r.i, t.nI), e.ft)) : A5(aA, t.eN.g, n.oX.pQ, n.oX.pQ.cy, A2(fA, e, t), A2(oA, t, A4(rA, t.eN.g, t.i.cR, r.i.cR, n.lw)));
        return $(t, {
            aG: $(u, {
                cI: zr(Gb(n.oX.pQ.cI)),
                cy: zr(Gb(n.oX.pQ.cy)),
                dt: zr(Gb(n.oX.pQ.dt))
            }),
            eN: a
        });
    }), lA = F3(function(n, e, r) {
        for(;;){
            if (!r.b) return Ur;
            var t = r.b;
            if (e(r.a)) return zr(n);
            n += 1, r = t;
        }
    }), dA = lA(0), bA = F2(function(n, e) {
        return v(A2(Hc, n, e), A2($x, n, e));
    }), mA = F2(function(n, e) {
        return A2(Pc, function(n) {
            return A2(bA, n, e);
        }, A2(dA, n, e));
    }), pA = function(n) {
        return A2(Hu, Fr, A2(Hu, mA(A2(Hu, function(n) {
            return n.ai;
        }, zt(n))), A2(Hu, Pc(Gh), Ba(A2(Hu, Ah(function(n) {
            return n.gt;
        }), A2(Hu, $x(1), q$))))));
    }, vA = F3(function(n, e, r) {
        return A2(xy, function(t) {
            return t.gt ? A4(sA, n, e, A2(Nc, t, A2(pA, t.ai, r)), t) : t;
        }, r);
    }), gA = F2(function(n, e) {
        return A2(hy, A2(vA, n, e.A), e);
    }), hA = A2(rw, F2(function(n, e) {
        var r = n.eN;
        return $(e, {
            f5: A2(uh, r.f5, e.f5),
            g: A2(fh, F2(function(n, e) {
                return ah(A([
                    e,
                    A2(ch, n, r.g)
                ]));
            }), e.g),
            ds: A2(uh, r.ds, e.ds),
            hb: A2(uh, r.hb, e.hb)
        });
    }), cx(Ks)), $A = function(n) {
        return $(n, {
            eN: hA(n.ac)
        });
    }, xA = function(n) {
        return n.g;
    }, kA = F2(function(n, e) {
        var r = e.q;
        return $(e, {
            q: $(r, {
                i: sf(n) ? Ur : r.i
            }),
            my: n
        });
    }), jA = F2(function(n, e) {
        var r = e.h8, t = e.aO, u = e.A;
        return A2(fs, function(n) {
            return $(e, {
                g: lh(A([
                    e.g,
                    A2(uw, Zj(t), n)
                ])),
                dF: n
            });
        }, A2(fs, A2(Hu, function(n) {
            return n.Q;
        }, xA), A2(Lx, {
            az: r,
            C: n,
            at: bs
        }, A2(kA, u.pf, Bx))));
    }), yA = F3(function(n, e, r) {
        var t = e.cX, u = e.nk, a = e.pK, i = A2(bh, a, ah(A([
            e.mw,
            A2(bh, r, u.d2)
        ])));
        return {
            eb: 0,
            g: A2(fh, F2(function(n) {
                return ah(A([
                    A2(fy, A2(dy, n, t), i),
                    A2(bh, a, A2(sy, A2(dy, n, u), r))
                ]));
            }), n),
            a$: i
        };
    }), wA = F2(function(n, e) {
        var r = n.oX, t = e.A, u = e.pK;
        return A3(jy, 7, function(n) {
            var e = A3(yA, n.g, {
                cX: r.pQ.mU,
                mw: t.aS.bK.mw,
                nk: t.aS.bK.nk,
                pK: u
            }, n.nI);
            return $(n, {
                g: e.g,
                a$: e.a$
            });
        }, e);
    }), AA = F2(function(n, e) {
        var r = e.h8, t = e.A, u = A2(Zg, 0, A2(fs, A2(Hu, function(n) {
            return n.Q;
        }, Oh), A2(Lx, {
            az: r,
            C: n,
            at: bs
        }, A2(kA, t.pf, Bx))));
        return A3(By, A([
            5,
            6,
            3,
            2
        ]), function(n) {
            return $(n, {
                de: A2(Jy, u, n.de),
                nI: A2(Jy, u, n.nI)
            });
        }, e);
    }), TA = F3(function(n, e, r) {
        return 0 > m(r, n) ? n : m(r, e) > 0 ? e : r;
    }), EA = function(n) {
        return n / 86400;
    }, CA = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return function($) {
                                                                                    return function(x) {
                                                                                        return function(k) {
                                                                                            return function(j) {
                                                                                                return function(y) {
                                                                                                    return function(w) {
                                                                                                        return function(A) {
                                                                                                            return function(T) {
                                                                                                                return function(E) {
                                                                                                                    return {
                                                                                                                        cJ: n,
                                                                                                                        h_: e,
                                                                                                                        gk: r,
                                                                                                                        by: t,
                                                                                                                        gl: u,
                                                                                                                        bU: a,
                                                                                                                        bV: i,
                                                                                                                        ib: c,
                                                                                                                        cY: o,
                                                                                                                        gm: f,
                                                                                                                        c0: s,
                                                                                                                        c2: l,
                                                                                                                        b6: d,
                                                                                                                        c8: b,
                                                                                                                        mV: m,
                                                                                                                        dk: p,
                                                                                                                        dl: v,
                                                                                                                        P: g,
                                                                                                                        ft: h,
                                                                                                                        je: $,
                                                                                                                        dn: x,
                                                                                                                        jr: k,
                                                                                                                        $7: j,
                                                                                                                        aS: y,
                                                                                                                        hj: w,
                                                                                                                        pf: A,
                                                                                                                        dI: T,
                                                                                                                        pV: E
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, IA = function(n) {
        return A2(Hu, xs(A2(Hu, function(n) {
            return n.mj;
        }, zt(n))), ks("Produit non trouv\xe9 id=" + n + "."));
    }, SA = gw("FR"), OA = F2(function(n, e) {
        return A2(Hu, wu(function(r) {
            var t = r.i, u = r.mj, a = r.aH, i = r.dz, c = t.$ ? Qr(Ur) : A2(fs, zr, A2(js, t.a, e));
            return A3(yx, F2(function(n, e) {
                return {
                    i: e,
                    U: n,
                    aH: a,
                    dz: i
                };
            }), A2(qw, u, n), c);
        }), Vg);
    }), LA = I, PA = A2(Hu, LA(A2(Hu, function(n) {
        return n.aH;
    }, A2(Hu, Ko, eo))), A2(Hu, q$, A2(Hu, Pc(function(n) {
        return n.U;
    }), ks("La liste de mati\xe8res est vide.")))), qA = F2(function(n, e) {
        return 1 === n.$ ? e : n;
    }), NA = F2(function(n, e) {
        return A2(qA, e, n);
    }), _A = "---", zA = F2(function(n, e) {
        var r, t = n.bT, u = n.oX, a = A2(js, _A, t), i = (r = e.pf).$ ? A2(fs, function(n) {
            return n.pf;
        }, A2(IA, e.aS, u.dp)) : Qr(r.a), c = A3(OA, u.ft, t, e.ft), o = A2(NA, a, A2(as, function(n) {
            return A2(Hu, PA, as(function(e) {
                return A2(js, e.ig, n);
            }));
        }(t), c)), f = F2(function(n, e) {
            return e.$ ? n : A2(js, e.a, t);
        }), s = A2(js, SA, t);
        return A2(Lg, Qr(e.pV), A2(Lg, Qr(e.dI), A2(Lg, i, A2(Lg, Qr(e.hj), A2(Lg, A2(IA, e.aS, u.dp), A2(Lg, Qr(e.$7), A2(Lg, Qr(e.jr), A2(Lg, Qr(e.dn), A2(Lg, Qr(e.je), A2(Lg, c, A2(Lg, Qr(e.P), A2(Lg, Qr(e.dl), A2(Lg, Qr(e.dk), A2(Lg, Qr(e.mV), A2(Lg, Qr(e.c8), A2(Lg, Qr(e.b6), A2(Lg, Qr(e.c2), A2(Lg, Qr(e.c0), A2(Lg, s, A2(Lg, A2(f, a, e.cY), A2(Lg, o, A2(Lg, A2(f, a, e.bV), A2(Lg, A2(f, a, e.bU), A2(Lg, s, A2(Lg, A2(f, a, e.by), A2(Lg, s, A2(Lg, Qr(e.h_), A2(Lg, Qr(e.cJ), Qr(CA)))))))))))))))))))))))))))));
    }), UA = function(n) {
        return n.dI ? $(n, {
            c0: iy(k(Ew, n.c0)),
            mV: zr(A2(Nc, 0, n.mV))
        }) : n;
    }, MA = {
        cI: Ur,
        cJ: Ur,
        ba: Ur,
        d$: Ur,
        E: Ur,
        gr: Ur,
        _: Ur,
        iz: Ur,
        c8: Ur,
        gL: Ur,
        nJ: Ur,
        $7: Ur,
        cy: Ur,
        dt: Ur,
        f$: Ur,
        f0: Ur
    }, DA = function(n) {
        return n(1);
    }, RA = function(n) {
        return A2(Hu, qa(function(e) {
            var r = e.aH;
            return s(e.U.jh, n) ? zr(Mf(r)) : Ur;
        }), A2(Hu, tl, A2(Hu, Ys, Zg(0))));
    }, FA = function(n) {
        return A2(Zg, 0, Zm(50 > Mf(A2(RA, 3, n)) ? .049 : .121));
    }, HA = function(n) {
        var e = n.P, r = FA(n.ft) * e * 5e3;
        return s(r, 0) ? Ur : zr(r);
    }, GA = function(n) {
        switch(n){
            case 0:
                return 330;
            case 1:
                return 390;
            case 2:
                return 250;
            default:
                return 820;
        }
    }, XA = F2(function(n, e) {
        var r = e.U;
        return A2(bh, A2(Zh, n, e.aH), GA(r.jh));
    }), VA = function(n) {
        var e = n.ft, r = ah(A2(wu, XA(n.P), e));
        return s(r, 0) ? Ur : zr(r);
    }, JA = F3(function(n, e, r) {
        var t, u = n.pQ, a = r.i, i = r.S, c = e.c2, o = e.mV, f = e.dk, s = e.dl, l = e.$7, d = e.hj, b = e.pV;
        switch(r.ai){
            case 0:
                return $(r, {
                    aG: $(MA, {
                        E: zr(Gb(u.E))
                    })
                });
            case 1:
                return $(r, {
                    S: $(i, {
                        ak: HA(e)
                    }),
                    aG: $(MA, {
                        ba: zr(Gb(a.lO)),
                        d$: zr(Gb(a.me)),
                        _: zr(Gb(u._)),
                        nJ: zr("Transport en voiture vers point de collecte (1km)")
                    })
                });
            case 2:
                return $(r, {
                    c2: c,
                    $7: l,
                    aG: $(MA, {
                        ba: zr(Gb(a.lO)),
                        d$: zr(Gb(a.me)),
                        gr: Ur,
                        $7: A2(Pc, function(n) {
                            return Gb(A2(Fw, n.gJ, u).nQ);
                        }, l)
                    })
                });
            case 3:
                return $(r, {
                    aG: $(MA, {
                        ba: zr(Gb(a.lO)),
                        iz: zr(Gb(A2(Ty, u, e.aS.iz)))
                    }),
                    hj: d,
                    pV: b
                });
            case 4:
                return $(r, {
                    mV: o,
                    dk: f,
                    dl: s,
                    aG: $(MA, {
                        ba: zr(Gb(a.lO)),
                        c8: zr(Gb(u.c8))
                    })
                });
            case 5:
                return $(r, {
                    S: $(i, {
                        aj: VA(e)
                    })
                });
            case 6:
                return $(r, {
                    aG: $(MA, {
                        ba: zr(Gb(a.lO))
                    }),
                    pV: b
                });
            default:
                return $(r, {
                    aG: $(MA, {
                        ba: zr(Gb(u.mU)),
                        f$: zr((t = A2(Rj, 4, vh(e.aS.bK.mw)), "Repassage\xa0: " + t + "\xa0kWh")),
                        f0: zr(Gb(e.aS.bK.nk))
                    })
                });
        }
    }), YA = F2(function(n, e) {
        return Cy(A2(wu, A2(JA, n.oX, e), A3(st, F2(function(n, r) {
            var t = n.a;
            return function(n) {
                var e = n.lN, r = n.gt, t = n.ai, u = Ks;
                return {
                    cJ: 0,
                    S: dw,
                    i: n.i,
                    lg: 0,
                    aO: DA(ru),
                    c2: Ur,
                    lN: e,
                    gt: r,
                    eb: 0,
                    g: u,
                    de: 0,
                    a$: 0,
                    ai: t,
                    mV: Ur,
                    dk: Ur,
                    dl: Ur,
                    nI: 0,
                    jm: Ur,
                    nP: ty,
                    $7: Ur,
                    aG: MA,
                    hj: Ur,
                    kc: Ur,
                    eN: cx(u),
                    pO: 0,
                    pV: Ur
                };
            }({
                i: r,
                lN: n.b,
                gt: !A2(el, t, e.c0),
                ai: t
            });
        }), A([
            v(5, !1),
            v(6, !0),
            v(3, !0),
            v(2, !0),
            v(4, !0),
            v(0, !1),
            v(7, !1),
            v(1, !1)
        ]), function(n) {
            return A([
                n.ib,
                n.cY,
                n.bU,
                n.by,
                n.bV,
                n.gk,
                n.gm,
                n.gl
            ]);
        }(e))));
    }), WA = F2(function(n, e) {
        return A2(Hu, UA, A2(Hu, zA(n), fs(function(r) {
            var t, u, a, i = r.aS;
            return t = A2(YA, n, r), {
                S: dw,
                h8: e,
                go: r.aS.bK.go,
                aO: {
                    jc: DA(ru),
                    g$: A2(Nc, Kj(ru), r.dn)
                },
                g: Ks,
                A: r,
                ac: t,
                eN: cx(Ks),
                dF: Ks,
                pK: (u = i.bK, a = u.hE, yf(EA(u.go) / A3(TA, 1, a, a)))
            };
        })));
    }), KA = A([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
    ]), BA = function(n) {
        return A3(By, KA, Wy(n.A.P), n);
    }, QA = F3(function(n, e, r) {
        var t = function(n) {
            return fs(n);
        }, u = F2(function(n, e) {
            return A2(el, n, r.c0) ? ru : t(e);
        }), a = function(e) {
            return t(e(n));
        }, i = F2(function(n, e) {
            return A2(el, n, r.c0) ? ru : a(e);
        });
        return A2(t, mw, A2(function(e) {
            return function(n) {
                return as(n);
            }(e(n));
        }, jA, A2(t, $A, A2(a, gA, A3(i, 1, Ay, A3(i, 7, wA, A3(i, 4, ww, A3(i, 2, vw, A3(i, 2, Vw, A3(i, 2, yy, A3(i, 3, Vy, A3(u, 6, Qw, A3(u, 5, Dw(n), A2(a, AA, A3(u, 4, hw, A2(t, ny, A2(t, Rw, A3(u, 6, nA, A3(i, 3, nw, A3(u, 4, Iw, A3(u, 4, Lw, A2(t, BA, A3(WA, n, e, r)))))))))))))))))))))));
    }), ZA = F2(function(n, e) {
        return A2(Sp, A([
            5 === e.ad.$ ? yg("prevent-scrolling") : jg("prevent-scrolling")
        ]), A2(Ep, n, e));
    }), nT = function(n) {
        return A2(nl, ru, A([
            !s(n.c2, Ur) && !s(n.c2, zr(0)),
            !s(n.b6, Ur),
            !s(n.mV, Ur),
            !s(n.dk, Ur),
            !s(n.dl, Ur),
            A2(nl, A2(Hu, function(n) {
                return n.dz;
            }, Ic(Ur)), n.ft),
            !s(n.dn, Ur),
            !s(n.hj, Ur),
            !s(n.pf, Ur),
            !n.dI && !sf(n.c0),
            !s(n.pV, Ur)
        ]));
    }, eT = function(n) {
        return {
            $: 2,
            a: n
        };
    }, rT = function(n) {
        return Ig(eT(n));
    }, tT = function(n) {
        return A2(Rj, 3, n) + "kg";
    }, uT = function(n) {
        switch(n){
            case 0:
                return "Elev\xe9e";
            case 1:
                return "Faible";
            case 2:
                return "Moyenne";
            case 3:
                return "Non applicable";
            case 4:
                return "Tr\xe8s \xe9lev\xe9e";
            default:
                return "Tr\xe8s faible";
        }
    }, aT = function(n) {
        return A2(Hu, Mf, Ek($(Ck, {
            li: uk(n)
        })));
    }, iT = function(n) {
        var e, r = n.cJ, t = n.c8, u = n.mV, a = n.dk, i = n.dl;
        return "" !== (e = A2(at, ", ", A2(qa, ru, A([
            A2(Pc, A2(Hu, aT(0), function(n) {
                return n + "\u202F% de perte";
            }), i),
            A2(Pc, A2(Hu, aT(0), function(n) {
                return n + "\u202F% de stocks dormants";
            }), a),
            A2(Pc, function(n) {
                return "complexit\xe9 de confection " + uT(n);
            }, u),
            A2(Ba, function(n) {
                return Mf(n) ? zr(A2(aT, 0, n) + " de transport a\xe9rien") : Ur;
            }, r),
            s(t, zr(!0)) ? zr("d\xe9lav\xe9") : Ur
        ])))) ? " (" + e + ")" : "";
    }, cT = function(n) {
        return n ? "Fix\xe9-lav\xe9" : "Pigmentaire";
    }, oT = function(n) {
        switch(n){
            case 0:
                return "Tricotage Circulaire";
            case 1:
                return "Tricotage Fully fashioned / Seamless";
            case 2:
                return "Tricotage Int\xe9gral / Whole garment";
            case 3:
                return "Tricotage moyen (par d\xe9faut)";
            case 4:
                return "Tricotage Rectiligne";
            default:
                return "Tissage";
        }
    }, fT = F2(function(n, e) {
        var r, t, u, a, i = F2(function(n, r) {
            return A2(el, n, e.c0) ? j : r;
        });
        return A2(Ah, A2(cc, rl, sf), A([
            A([
                k(e.aS.ek, k(e.dI ? " remanufactur\xe9" : "", (a = e.dn, a.$ ? "" : ", durabilit\xe9 physique " + A2(Rj, 3, a.a)))),
                tT(e.P)
            ]),
            A2(i, 5, A([
                "mati\xe8re",
                (u = e.ft, A2(at, ", ", A2(wu, function(n) {
                    var e = n.U, r = n.aH, t = A2(Nc, " par d\xe9faut (" + e.ma + ")", A2(Pc, function(n) {
                        return n.ek;
                    }, n.i));
                    return A2(aT, 0, r) + "% " + e.ek + " provenance " + t;
                }, A2(Ah, function(n) {
                    return n.aH > 0;
                }, u))))
            ])),
            A2(i, 6, A([
                "filature",
                e.cY.ek
            ])),
            (t = e.pV, t.$ ? j : A([
                "titrage",
                A2(Rj, 3, Cf(t.a)) + "Nm"
            ])),
            A2(i, 3, A([
                oT(A2(Nc, e.aS.iz, e.b6)),
                e.bU.ek
            ])),
            A2(i, 2, A([
                "ennoblissement\xa0: " + Gb(A2(gy, n, e.c2)),
                e.by.ek
            ])),
            A2(i, 2, A([
                "impression",
                (r = e.$7, r.$ ? "non" : "impression " + function(n) {
                    var e = n.nX;
                    return cT(n.gJ) + " (" + A2(aT, 0, e) + "%)";
                }(r.a) + "\xa0: " + e.by.ek)
            ])),
            A2(i, 4, A([
                "confection",
                k(e.bV.ek, iT(e))
            ])),
            A2(i, 0, A([
                "distribution",
                e.gk.ek
            ])),
            A2(i, 7, A([
                "utilisation",
                e.gm.ek
            ])),
            A2(i, 1, A([
                "fin de vie",
                e.gl.ek
            ]))
        ]));
    }), sT = F2(function(n, e) {
        return A2(at, ", ", A2(wu, at("\xa0: "), A2(fT, n, e)));
    }), lT = F2(function(n, e) {
        var r = n.C, t = v(A2(rT, e, n.bH.ap), Ld(A2(tk, e, r.oX.lT)));
        return t.a.$ ? t.b.$ ? A2(Zg, "", A2(fs, sT(r.oX.pQ), A2(zA, r, e))) : t.b.a.ek : t.a.a.ek;
    }), dT = F2(function(n, e) {
        return $(e, {
            an: $(e.an, {
                oX: n
            })
        });
    }), bT = F3(function(n, e, r) {
        var t = A2(Nc, r.an.oX, e), u = A3(QA, r.C, r.h8, t);
        return A2(Sp, A([
            e.$ ? Ip({
                pT: 0,
                pU: 0
            }) : Cc
        ]), A2(ZA, A2(dT, t, r), {
            dN: 1,
            aV: nT(t) ? 0 : 1,
            cN: Ur,
            bv: Ur,
            bw: Ur,
            bx: A2(lT, r, t),
            dW: 1,
            cT: Nl(r) ? 2 : 1,
            O: A2(eh, n, r.C.c_),
            dd: t,
            ad: Ac,
            dx: u
        }));
    }), mT = {
        E: Ur,
        mq: j,
        cs: j,
        bk: j,
        fX: Ur
    }, pT = F2(function(n, e) {
        var r = A2(Zg, mT, A2(fs, function(n) {
            return n.g5;
        }, A2(Qx, e, n.C.l5.lT)));
        return A2(Sp, A([
            Ip({
                pT: 0,
                pU: 0
            })
        ]), A2(Eg, A2(rh, r, n), {
            dN: 1,
            cN: Ur,
            bv: Ur,
            bw: Ur,
            bx: A2(nh, n, r),
            dW: 1,
            cT: 2,
            O: A2(eh, 19, n.C.c_),
            dd: r,
            ad: xc
        }));
    }), vT = F2(function(n, e) {
        return {
            ed: 0,
            eh: e,
            ev: !0,
            eG: zr(n)
        };
    }), gT = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hT = F2(function(n, e) {
        return $(e, {
            bq: k(e.bq, n)
        });
    }), $T = function(n) {
        return hT(A([
            gT(n)
        ]));
    }, xT = F2(function(n, e) {
        return $T(A2(vT, n, e));
    }), kT = F3(function(n, e, r) {
        return n ? A2(xT, e, r) : ru;
    }), jT = F3(function(n, e, r) {
        var t = ds(e), u = A2(Kx, t, n.C.l9.lT), a = A2(Qx, r, u), i = A2(Zg, Bx, A2(fs, function(n) {
            return n.g5;
        }, a));
        return A2(Sp, A([
            Ip({
                pT: 0,
                pU: 0
            })
        ]), A4(kT, !!a.$, "Exemple introuvable", "L\u2019exemple de produit " + df(r) + " n\u2019existe pas.", A2(Wx, A3(Jj, e, i, n), {
            dN: 1,
            cN: Ur,
            bv: Ur,
            bw: Ur,
            bx: A4(Vj, n, e, u, i),
            dW: 1,
            cT: 2,
            cV: "",
            cW: "",
            a9: !1,
            bX: j,
            lT: u,
            b7: Ur,
            iE: e,
            O: A2(eh, 19, n.C.c_),
            dd: i,
            ac: A2(Yx, {
                az: n.h8,
                C: n.C,
                at: t
            }, i),
            M: j
        })));
    }), yT = F2(function(n, e) {
        var r = A2(Zg, n.an.oX, A2(fs, function(n) {
            return n.g5;
        }, A2(Qx, e, n.C.oX.lT))), t = A3(QA, n.C, n.h8, r);
        return A2(Sp, A([
            Ip({
                pT: 0,
                pU: 0
            })
        ]), A2(ZA, A2(dT, r, n), {
            dN: 1,
            aV: nT(r) ? 0 : 1,
            cN: Ur,
            bv: Ur,
            bw: Ur,
            bx: A2(lT, n, r),
            dW: 1,
            cT: 2,
            O: A2(eh, 19, n.C.c_),
            dd: r,
            ad: Ac,
            dx: t
        }));
    }), wT = F2(function(n, e) {
        return {
            $: 5,
            a: n,
            b: e
        };
    }), AT = nr, TT = function(n) {
        switch(n){
            case 0:
                return "A";
            case 1:
                return "B";
            case 2:
                return "C";
            case 3:
                return "D";
            case 4:
                return "E";
            case 5:
                return "F";
            case 6:
                return "G";
            case 7:
                return "H";
            case 8:
                return "I";
            case 9:
                return "J";
            case 10:
                return "K";
            case 11:
                return "L";
            case 12:
                return "M";
            case 13:
                return "N";
            case 14:
                return "O";
            case 15:
                return "P";
            case 16:
                return "Q";
            case 17:
                return "R";
            case 18:
                return "S";
            case 19:
                return "T";
            case 20:
                return "U";
            case 21:
                return "V";
            case 22:
                return "W";
            case 23:
                return "X";
            case 24:
                return "Y";
            case 25:
                return "Z";
            case 26:
                return "a";
            case 27:
                return "b";
            case 28:
                return "c";
            case 29:
                return "d";
            case 30:
                return "e";
            case 31:
                return "f";
            case 32:
                return "g";
            case 33:
                return "h";
            case 34:
                return "i";
            case 35:
                return "j";
            case 36:
                return "k";
            case 37:
                return "l";
            case 38:
                return "m";
            case 39:
                return "n";
            case 40:
                return "o";
            case 41:
                return "p";
            case 42:
                return "q";
            case 43:
                return "r";
            case 44:
                return "s";
            case 45:
                return "t";
            case 46:
                return "u";
            case 47:
                return "v";
            case 48:
                return "w";
            case 49:
                return "x";
            case 50:
                return "y";
            case 51:
                return "z";
            case 52:
                return "0";
            case 53:
                return "1";
            case 54:
                return "2";
            case 55:
                return "3";
            case 56:
                return "4";
            case 57:
                return "5";
            case 58:
                return "6";
            case 59:
                return "7";
            case 60:
                return "8";
            case 61:
                return "9";
            case 62:
                return "+";
            default:
                return "/";
        }
    }, ET = F2(function(n, e) {
        var r, t = e.a, u = e.b, a = e.c << 8 | n;
        return 2 === u ? g(k(t, k(TT(63 & (r = a) >>> 18), k(TT(63 & r >>> 12), k(TT(63 & r >>> 6), TT(63 & r >>> 0))))), 0, 0) : g(t, u + 1, a);
    }), CT = F2(function(n, e) {
        var r = mt(n);
        return 128 > r ? A2(ET, r, e) : A2(ET, 128 | 63 & r, 2048 > r ? A2(ET, 192 | r >>> 6, e) : A2(ET, 128 | 63 & r >>> 6, 55296 > r || r >= 57344 && 65535 >= r ? A2(ET, 224 | r >>> 12, e) : A2(ET, 128 | 63 & r >>> 12, A2(ET, 240 | r >>> 18, e))));
    }), IT = g("", 0, 0), ST = function(n) {
        return function(n) {
            var e = n.a, r = n.c;
            switch(n.b){
                case 1:
                    return e + (TT(63 & r >>> 2) + (TT(63 & r << 4) + "=="));
                case 2:
                    return e + (TT(63 & r >>> 10) + (TT(63 & r >>> 4) + (TT(63 & r << 2) + "=")));
                default:
                    return e;
            }
        }(A3(Dd, CT, IT, n));
    }, OT = A2(Hu, Xo, A2(Hu, tt(0), ST)), LT = A2(Hu, Lf, A2(Hu, tt(0), ST)), PT = A2(Hu, Rf, A2(Hu, tt(0), ST)), qT = function(n) {
        switch(n.$){
            case 0:
                return {
                    ai: "Composants",
                    aI: vs(n.a) + "-components"
                };
            case 1:
                return {
                    ai: "Pays",
                    aI: "countries"
                };
            case 2:
                return {
                    ai: "Exemples",
                    aI: "food-examples"
                };
            case 3:
                return {
                    ai: "Ingr\xe9dients",
                    aI: "ingredients"
                };
            case 4:
                return {
                    ai: "Exemples",
                    aI: vs(ds(n.a)) + "-examples"
                };
            case 5:
                return {
                    ai: "Impacts",
                    aI: "impacts"
                };
            case 6:
                return {
                    ai: "Proc\xe9d\xe9s",
                    aI: vs(n.a) + "-processes"
                };
            case 7:
                return {
                    ai: "Produits",
                    aI: vs(ds(n.a)) + "-product-categories"
                };
            case 8:
                return {
                    ai: "Exemples",
                    aI: "textile-examples"
                };
            case 9:
                return {
                    ai: "Mati\xe8res",
                    aI: "materials"
                };
            default:
                return {
                    ai: "Produits",
                    aI: "products"
                };
        }
    }, NT = A2(Hu, qT, function(n) {
        return n.aI;
    }), _T = function(n) {
        var e = function() {
            n: for(;;)switch(n.$){
                case 0:
                    return A([
                        "api"
                    ]);
                case 1:
                    return A([
                        "auth"
                    ]);
                case 2:
                    return A([
                        "auth",
                        n.a,
                        n.b
                    ]);
                case 3:
                    return A([
                        "auth",
                        "signup"
                    ]);
                case 4:
                    return A([
                        "pages",
                        n.a
                    ]);
                case 5:
                    switch(n.a.$){
                        case 0:
                            if (2 === n.b.$ && 1 === n.b.a.$) return A([
                                "explore",
                                "food"
                            ]);
                            break n;
                        case 2:
                            if (8 === n.b.$ && 1 === n.b.a.$) return A([
                                "explore",
                                "textile"
                            ]);
                            break n;
                        default:
                            break n;
                    }
                case 6:
                    if (1 === n.b.$) return A([
                        "food",
                        Pl(r = n.a)
                    ]);
                    var e = n.b.a;
                    return A([
                        "food",
                        Pl(r = n.a),
                        OT(e)
                    ]);
                case 7:
                    return A([
                        "food",
                        "edit-example",
                        df(t = n.a)
                    ]);
                case 8:
                    return A([
                        "food"
                    ]);
                case 9:
                    if (n.c.$) return r = n.b, A([
                        vs(ds(n.a)),
                        "simulator",
                        Pl(r)
                    ]);
                    var r = n.b;
                    return e = n.c.a, A([
                        vs(ds(n.a)),
                        "simulator",
                        Pl(r),
                        PT(e)
                    ]);
                case 10:
                    var t = n.b;
                    return A([
                        vs(ds(n.a)),
                        "edit-example",
                        df(t)
                    ]);
                case 11:
                    return A([
                        vs(ds(n.a)),
                        "simulator"
                    ]);
                case 12:
                    return j;
                case 13:
                    return A([
                        "stats"
                    ]);
                case 14:
                    return n.b.$ ? A([
                        "textile",
                        "simulator",
                        Pl(r = n.a)
                    ]) : (e = n.b.a, A([
                        "textile",
                        "simulator",
                        Pl(r = n.a),
                        LT(e)
                    ]));
                case 15:
                    return A([
                        "textile",
                        "edit-example",
                        df(t = n.a)
                    ]);
                default:
                    return A([
                        "textile",
                        "simulator"
                    ]);
            }
            var u = n.b;
            return A2(Mr, "explore", A2(Mr, vs(n.a), function(n) {
                switch(n.$){
                    case 0:
                        if (n.b.$) return A([
                            NT(n)
                        ]);
                        var e = n.b.a;
                        return A([
                            NT(n),
                            bf(e)
                        ]);
                    case 1:
                        if (n.a.$) return A([
                            NT(n)
                        ]);
                        var r = n.a.a;
                        return A([
                            NT(n),
                            r
                        ]);
                    case 2:
                    case 8:
                        return n.a.$ ? A([
                            NT(n)
                        ]) : (e = n.a.a, A([
                            NT(n),
                            df(e)
                        ]));
                    case 3:
                        return n.a.$ ? A([
                            NT(n)
                        ]) : (e = n.a.a, A([
                            NT(n),
                            Ug(e)
                        ]));
                    case 4:
                        return n.b.$ ? A([
                            NT(n)
                        ]) : (e = n.b.a, A([
                            NT(n),
                            df(e)
                        ]));
                    case 5:
                        if (n.a.$) return A([
                            NT(n)
                        ]);
                        var t = n.a.a;
                        return A([
                            NT(n),
                            Pl(t)
                        ]);
                    case 6:
                        return n.b.$ ? A([
                            NT(n)
                        ]) : (e = n.b.a, A([
                            NT(n),
                            qs(e)
                        ]));
                    case 7:
                        return n.b.$ ? A([
                            NT(n)
                        ]) : (e = n.b.a, A([
                            NT(n),
                            Lh(e)
                        ]));
                    case 9:
                        return n.a.$ ? A([
                            NT(n)
                        ]) : (e = n.a.a, A([
                            NT(n),
                            Pw(e)
                        ]));
                    default:
                        return n.a.$ ? A([
                            NT(n)
                        ]) : (e = n.a.a, A([
                            NT(n),
                            e
                        ]));
                }
            }(u)));
        }();
        return "#/" + A2(at, "/", e);
    }, zT = function(n) {
        return A2(Hu, _p(n), Sp(A([
            A2(AT, n.na, _T(fd))
        ])));
    }, UT = F3(function(n, e, r) {
        var t = _l(n);
        return t.$ ? A2(Ep, n, {
            j$: !1,
            u: A2(wT, e, r)
        }) : A2(zT, n, t.a);
    }), MT = F3(function(n, e, r) {
        return {
            $: 7,
            a: n,
            b: e,
            c: r
        };
    }), DT = {
        bZ: !1,
        c4: "",
        aY: !1,
        aD: "",
        aE: "",
        cq: ug,
        oW: !1
    }, RT = function(n) {
        return {
            $: 1,
            a: n
        };
    }, FT = Yn, HT = F2(function(n, e) {
        return A2(Lu, function() {
            return n(e);
        }, xu(0));
    }), GT = function(n) {
        return A2(Hu, function(n) {
            return n.bq;
        }, A2(Hu, wu(HT(n)), Mu));
    }, XT = F5(function(n, e, r, t, u) {
        return v($(n, {
            H: A2(Zf, u.ey, r(u.ei))
        }), Mu(A([
            e,
            A2(FT, t, u.bS),
            A2(GT, RT, u)
        ])));
    }), VT = F4(function(n, e, r, t) {
        var u = t.a, a = t.b, i = function(n) {
            var e, r = 1 === n.nU ? "https" : "http", t = (e = n.nO).$ ? "" : ":" + ut(e.a);
            return A2(cd, Tp, A2(Nc, n, hu(r + "://" + (n.iN + (t + A2(Nc, "/", n.iD))))));
        }(n);
        if (i.$) return v($(u, {
            H: A2(Zf, e, Ql)
        }), Cc);
        switch(i.a.$){
            case 0:
                return A5(XT, u, a, Fl, Rl, function(n) {
                    return A2(Sp, A([
                        Cp(0),
                        Ip({
                            pT: 0,
                            pU: 0
                        })
                    ]), A2(Ep, n, 0));
                }(e));
            case 1:
                var c = A5(XT, u, a, Gl, Hl, function(n) {
                    var e = _l(n);
                    return e.$ ? A2(Ep, n, {
                        j$: !1,
                        u: A2(Op, "", Du)
                    }) : A2(xg, n, e.a);
                }(e));
                if (1 === r.$) {
                    var o = r.a;
                    return o.j$ && Nl(e) ? v($(u, {
                        H: A2(Zf, e, Gl($(o, {
                            j$: !1
                        })))
                    }), a) : c;
                }
                return c;
            case 2:
                var f = i.a;
                return A5(XT, u, a, Gl, Hl, A3(UT, e, f.a, f.b));
            case 3:
                return A5(XT, u, a, Gl, Hl, function(n) {
                    var e = _l(n);
                    return e.$ ? A2(Ep, n, {
                        j$: !1,
                        u: A3(MT, DT, Qu, Du)
                    }) : A2(zT, n, e.a);
                }(e));
            case 4:
                return A5(XT, u, a, Vl, Xl, A2(kg, i.a.a, e));
            case 5:
                var s = i.a;
                return A5(XT, u, a, Jl, ji, A3(Tg, s.a, s.b, e));
            case 6:
                var l = i.a;
                return A5(XT, u, a, Yl, yi, A3(th, e, l.a, l.b));
            case 7:
                return A5(XT, u, a, Yl, yi, A2(pT, e, i.a.a));
            case 8:
                return A5(XT, u, a, Yl, yi, A3(th, e, 19, Ur));
            case 9:
                var d = i.a;
                return A5(XT, u, a, Wl, wi, A4(Yj, d.a, d.b, d.c, e));
            case 10:
                var b = i.a;
                return A5(XT, u, a, Wl, wi, A3(jT, e, b.a, b.b));
            case 12:
                return A5(XT, u, a, Bl, Kl, function(n) {
                    return A2(Sp, A([
                        Ip({
                            pT: 0,
                            pU: 0
                        })
                    ]), A2(Ep, n, 0));
                }(e));
            case 11:
                return A5(XT, u, a, Wl, wi, A4(Yj, i.a.a, 19, Ur, e));
            case 13:
                return A5(XT, u, a, nd, Zl, function(n) {
                    return A2(Sp, A([
                        Ip({
                            pT: 0,
                            pU: 0
                        })
                    ]), A2(Ep, n, 0));
                }(e));
            case 14:
                var m = i.a;
                return A5(XT, u, a, ed, Ti, A3(bT, m.a, m.b, e));
            case 15:
                return A5(XT, u, a, ed, Ti, A2(yT, e, i.a.a));
            default:
                return A5(XT, u, a, ed, Ti, A3(bT, 19, Ur, e));
        }
    }), JT = {
        $: 1
    }, YT = F4(function(n, e, r, t) {
        return {
            aW: n,
            ap: e,
            aX: r,
            hD: t
        };
    }), WT = F2(function(n, e) {
        return {
            f3: n,
            f1: e
        };
    }), KT = F4(function(n, e, r, t) {
        return {
            kv: n,
            iy: e,
            jC: r,
            ke: t
        };
    }), BT = A3(Wa, "token_type", ai, A3(ui, "refresh_token", ai, A3(ui, "expires_in", xi, A3(Wa, "access_token", ai, nu(KT))))), QT = A3(Wa, "user", hg, A3(Wa, "accessTokenData", BT, nu(WT))), ZT = F4(function(n, e, r, t) {
        return {
            gn: n,
            iE: e,
            ek: r,
            g5: t
        };
    }), nE = A2(Bt, A2(Hu, ms, ys), ai), eE = Za(A([
        A2(Qt, Cg, Ob),
        A2(Qt, ek(2), hm(j)),
        A2(Qt, eT, $p)
    ])), rE = A2(Qt, function(n) {
        var e = v(n.g5, n.iE);
        return 1 !== e.a.$ || e.b.$ ? n : $(n, {
            g5: A2(ek, e.b.a, e.a.b)
        });
    }, A3(Wa, "query", eE, A3(Wa, "name", ai, A4(Zs, "subScope", zs(nE), Ur, A3(Wa, "created", A2(Qt, uc, xi), nu(ZT)))))), tE = A2(Qt, A2(Hu, ci(rE), Ld), ai), uE = A2(Qt, qa(ru), Cb(Za(A([
        tE,
        A2(Qt, zr, rE),
        nu(Ur)
    ])))), aE = Qu, iE = F2(function(n, e) {
        return A3(ia, n, 0, e);
    }), cE = function(n) {
        return A3(ot, iE, aE, n);
    }, oE = A4(Sb, "usageCount", xi, 0, A4(Sb, "comparedSimulations", A2(Qt, cE, Cb(ai)), aE, A4(Sb, "bookmarks", uE, j, A3(ui, "auth", QT, nu(YT))))), fE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sE = F2(function(n, e) {
        return $(e, {
            a1: k(e.a1, A([
                fE(n)
            ]))
        });
    }), lE = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), dE = F3(function(n, e, r) {
        return $(r, {
            a1: k(r.a1, A([
                A2(lE, n, e)
            ]))
        });
    }), bE = F9(function(n, e, r, t, u, a, i, c, o) {
        return {
            dZ: n,
            bT: e,
            c_: r,
            lw: t,
            l5: u,
            l9: a,
            W: i,
            dp: c,
            oX: o
        };
    }), mE = A2(Hu, function(n) {
        return n.m0;
    }, Ba(function(n) {
        return n.gp;
    })), pE = F2(function(n, e) {
        var r = function(e) {
            return e.i.$ ? $(e, {
                i: A2(Zg, Ur, A2(fs, mE, A2(Ns, e.mj, n)))
            }) : e;
        };
        return $(e, {
            r: A2(wu, function(n) {
                var e = n.J;
                return $(n, {
                    U: r(n.U),
                    J: A2(wu, r, e)
                });
            }, e.r)
        });
    }), vE = F3(function(n, e, r) {
        return {
            lT: n,
            mq: e,
            pQ: r
        };
    }), gE = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return {
                                                                    hM: n,
                                                                    cP: e,
                                                                    ic: r,
                                                                    gp: t,
                                                                    ls: u,
                                                                    lL: a,
                                                                    mj: i,
                                                                    mp: c,
                                                                    mG: o,
                                                                    ek: f,
                                                                    t: s,
                                                                    nZ: l,
                                                                    jQ: d,
                                                                    hz: b,
                                                                    kn: m
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, hE = F4(function(n, e, r, t) {
        return {
            ag: n,
            ah: e,
            al: r,
            am: t
        };
    }), $E = A2(Qt, d$, Vs), xE = function(n) {
        return -n;
    }, kE = A2(Qt, xE, $E), jE = A4(Sb, "plotSize", kE, 0, A4(Sb, "permanentPasture", kE, 0, A4(Sb, "hedges", kE, 0, A4(Sb, "cropDiversity", kE, 0, nu(hE))))), yE = function(n) {
        switch(n){
            case "animal_product":
                return Qr(0);
            case "conventional":
                return Qr(2);
            case "dairy_product":
                return Qr(3);
            case "grain_raw":
                return Qr(5);
            case "grain_processed":
                return Qr(4);
            case "misc":
                return Qr(6);
            case "nut_oilseed_raw":
                return Qr(8);
            case "nut_oilseed_processed":
                return Qr(7);
            case "spice_condiment_additive":
                return Qr(10);
            case "vegetable_fresh":
                return Qr(11);
            case "vegetable_processed":
                return Qr(12);
            case "organic":
                return Qr(9);
            case "bleublanccoeur":
                return Qr(1);
            default:
                return Yr("Categorie d'ingr\xe9dient invalide : " + n);
        }
    }, wE = A2(Bt, A2(Hu, yE, ys), ai), AE = function(n) {
        switch(n){
            case "ARBORICULTURE":
                return Qr(0);
            case "AUTRES GELS":
                return Qr(14);
            case "ORGE":
                return Qr(1);
            case "CANNE A SUCRE":
                return Qr(23);
            case "MAIS GRAIN ET ENSILAGE":
                return Qr(2);
            case "ESTIVES LANDES":
                return Qr(24);
            case "PLANTES A FIBRES":
                return Qr(3);
            case "FOURRAGE":
                return Qr(4);
            case "GEL (surfaces gel\xe9es sans production)":
                return Qr(5);
            case "GEL INDUSTRIEL":
                return Qr(7);
            case "LEGUMINEUSES A GRAIN":
                return Qr(6);
            case "LEGUMES-FLEURS":
                return Qr(27);
            case "DIVERS":
                return Qr(8);
            case "":
                return Qr(9);
            case "FRUITS A COQUES":
                return Qr(10);
            case "OLIVIERS":
                return Qr(11);
            case "VERGERS":
                return Qr(12);
            case "AUTRES CEREALES":
                return Qr(13);
            case "AUTRES CULTURES INDUSTRIELLES":
                return Qr(15);
            case "AUTRES OLEAGINEUX":
                return Qr(16);
            case "PRAIRIES PERMANENTES":
                return Qr(17);
            case "PROTEAGINEUX":
                return Qr(18);
            case "COLZA":
                return Qr(19);
            case "RIZ":
                return Qr(20);
            case "SEMENCES":
                return Qr(21);
            case "BLE TENDRE":
                return Qr(22);
            case "TOURNESOL":
                return Qr(25);
            case "PRAIRIES TEMPORAIRES":
                return Qr(26);
            case "VIGNES":
                return Qr(28);
            default:
                return Yr("Groupe de culture invalide : " + n);
        }
    }, TE = A2(Bt, A2(Hu, AE, ys), ai), EE = function(n) {
        switch(n){
            case "reference":
                return Qr(3);
            case "organic":
                return Qr(2);
            case "import":
                return Qr(0);
            case "":
                return Qr(1);
            default:
                return Yr("Sc\xe9nario invalide : " + n);
        }
    }, CE = A2(Bt, A2(Hu, EE, ys), ai), IE = function(n) {
        switch(n){
            case "EuropeAndMaghreb":
                return Qr(0);
            case "France":
                return Qr(1);
            case "FranceOutreMer":
                return Qr(2);
            case "OutOfEuropeAndMaghreb":
                return Qr(3);
            case "OutOfEuropeAndMaghrebByPlane":
                return Qr(4);
            default:
                return Yr("Origine g\xe9ographique inconnue : " + n);
        }
    }, SE = A2(Bt, A2(Hu, IE, ys), ai), OE = A2(Bt, function(n) {
        switch(n){
            case "none":
                return nu(2);
            case "always":
                return nu(0);
            case "once_transformed":
                return nu(1);
            default:
                return Ii("Valeur de transport frigorifique invalide : " + n);
        }
    }, ai), LE = {
        ag: 0,
        ah: 0,
        al: 0,
        am: 0
    }, PE = function(n) {
        return 1e3 * n;
    }, qE = A2(Hu, ym, fs(ru)), NE = F6(function(n, e, r, t, u, a) {
        return {
            h0: n,
            mj: e,
            ek: r,
            g5: t,
            dq: u,
            at: a
        };
    }), _E = A2(Bt, A2(Hu, ps, ys), ai), zE = function(n) {
        return A2(Hu, ci(Cb(function(n) {
            return A3(Wa, "scope", _E, A4(Zs, "recyclable", Pu, !0, A3(Wa, "query", n, A3(Wa, "name", ai, A3(Wa, "id", Ps, A3(Wa, "category", ai, nu(NE)))))));
        }(n))), $a(yt));
    }, UE = F9(function(n, e, r, t, u, a, i, c, o) {
        return {
            kM: n,
            kN: e,
            k7: r,
            lB: t,
            mR: u,
            mS: a,
            mT: i,
            jo: c,
            cG: o
        };
    }), ME = F3(function(n, e, r) {
        return A2(Lg, function(n) {
            var e = A2(Hu, qE, A2(Hu, as(function(e) {
                return A2(Ns, e, n);
            }), Lg));
            return A2(e, "7e1fb122-1320-519c-8751-2d926eb435da", A2(e, "326369d9-792a-5ab5-8276-c54108c80cb1", A2(e, "931c9bb0-619a-5f75-b41b-ab8061e2ad92", A2(e, "46e96f29-9ca5-5475-bb3c-6397f43b7a5b", A2(e, "219b986c-9751-58cf-977e-7ba8f0b4ae2b", A2(e, "6cbd45fb-83ff-5852-97a7-87fffecc20f5", A2(e, "a2836bb8-7f45-5cfa-bb00-8b38046291cf", A2(e, "20a62b2c-a543-5076-83aa-c5b7d340206a", A2(e, "3cb99d44-24f6-5f6e-a8f8-f754fe44d641", Qr(UE))))))))));
        }(r), A2(Lg, A2($a, yt, A2(ci, function(n) {
            return A2(Qt, Ah(function(n) {
                return n.kn;
            }), Cb(function(n) {
                return A3(Wa, "visible", Pu, A3(Wa, "transportCooling", OE, A4(Sb, "scenario", CE, 1, A3(Wa, "rawToCookedRatio", pm, A3(Wa, "processId", function(n) {
                    return A2(Bt, A2(Hu, qE, A2(Hu, as(function(e) {
                        return A2(Ns, e, n);
                    }), ys)), ai);
                }(n), A3(Wa, "name", ai, A3(Wa, "landOccupation", Vs, A3(Wa, "inediblePart", np, A3(Wa, "id", gb, A4(Sb, "ecosystemicServices", jE, LE, A3(Wa, "density", A2(Qt, PE, Vs), A3(Wa, "defaultOrigin", SE, A4(Sb, "cropGroup", TE, 9, A3(Wa, "categories", Cb(wE), A3(Wa, "alias", ai, nu(gE))))))))))))))));
            }(n)));
        }(r), e)), A2(Lg, A2(zE, Ob, n), Qr(vE))));
    }), DE = function(n) {
        return {
            lT: n
        };
    }, RE = F5(function(n, e, r, t, u) {
        return A2(fs, A2(Hu, Cd, DE), A2(qg, zE(hm(u)), A([
            n,
            e,
            r,
            t
        ])));
    }), FE = F4(function(n, e, r, t) {
        return {
            lT: n,
            ft: e,
            dp: r,
            pQ: t
        };
    }), HE = F9(function(n, e, r, t, u, a, i, c, o) {
        return {
            hM: n,
            kT: e,
            ig: r,
            ma: t,
            mj: u,
            ek: a,
            jh: i,
            t: c,
            g7: o
        };
    }), GE = A2(Bt, A2(Hu, function(n) {
        switch(n){
            case "ArtificialFromOrganic":
                return Qr(0);
            case "NaturalFromAnimal":
                return Qr(1);
            case "NaturalFromVegetal":
                return Qr(2);
            case "Synthetic":
                return Qr(3);
            default:
                return Yr("Origine inconnue: " + n);
        }
    }, ys), ai), XE = A3(Wa, "recycledQualityRatio", np, A3(Wa, "manufacturerAllocation", np, nu(F2(function(n, e) {
        return {
            mW: n,
            n1: e
        };
    })))), VE = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                lK: n,
                                                _: e,
                                                iz: r,
                                                mj: t,
                                                gL: u,
                                                ek: a,
                                                hj: i,
                                                pf: c,
                                                bK: o,
                                                pV: f
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, JE = A3(Wa, "repairCost", lp, A3(Wa, "price", lp, A3(Wa, "numberOfReferences", xi, A3(Wa, "business", Qm, nu(F4(function(n, e, r, t) {
        return {
            h_: n,
            je: e,
            jr: r,
            jF: t
        };
    })))))), YE = A3(Wa, "volume", A2(Qt, Qd, Vs), nu(function(n) {
        return {
            eY: n
        };
    })), WE = A3(Wa, "pcrWaste", np, A3(Wa, "complexity", Gm, nu(F2(function(n, e) {
        return {
            gi: n,
            jk: e
        };
    })))), KE = F8(function(n, e, r, t, u, a, i, c) {
        return {
            go: n,
            il: e,
            mw: r,
            nk: t,
            jz: u,
            jA: a,
            kd: i,
            hE: c
        };
    }), BE = function(n) {
        return 86400 * n;
    }, QE = function(n) {
        return 3600 * n;
    }, ZE = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return function($) {
                                                                                    return function(x) {
                                                                                        return function(k) {
                                                                                            return function(j) {
                                                                                                return function(y) {
                                                                                                    return function(w) {
                                                                                                        return function(A) {
                                                                                                            return function(T) {
                                                                                                                return function(E) {
                                                                                                                    return function(C) {
                                                                                                                        return function(I) {
                                                                                                                            return {
                                                                                                                                cI: n,
                                                                                                                                hW: e,
                                                                                                                                im: r,
                                                                                                                                E: t,
                                                                                                                                lE: u,
                                                                                                                                lF: a,
                                                                                                                                lG: i,
                                                                                                                                lH: c,
                                                                                                                                lI: o,
                                                                                                                                _: f,
                                                                                                                                c8: s,
                                                                                                                                l3: l,
                                                                                                                                iJ: d,
                                                                                                                                iK: b,
                                                                                                                                mA: m,
                                                                                                                                mB: p,
                                                                                                                                mC: v,
                                                                                                                                mD: g,
                                                                                                                                mE: h,
                                                                                                                                mU: $,
                                                                                                                                nJ: x,
                                                                                                                                js: k,
                                                                                                                                jt: j,
                                                                                                                                ju: y,
                                                                                                                                jv: w,
                                                                                                                                cy: A,
                                                                                                                                dt: T,
                                                                                                                                pd: E,
                                                                                                                                ko: C,
                                                                                                                                pP: I
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, nC = F4(function(n, e, r, t) {
        return A2(Lg, function(n) {
            var e = A2(Hu, qE, A2(Hu, as(function(e) {
                return A2(Ns, e, n);
            }), Lg));
            return A2(e, "235b3488-6157-50ed-b74a-45e5d447dd85", A2(e, "7cdc9616-7fb4-5a69-9436-78e5b84ebf31", A2(e, "cdc841c2-493f-56d6-8fc2-ae5fad2a4917", A2(e, "20a62b2c-a543-5076-83aa-c5b7d340206a", A2(e, "46e96f29-9ca5-5475-bb3c-6397f43b7a5b", A2(e, "5c21e378-b941-57f7-98c9-67345847dbda", A2(e, "9418bfb4-34e5-5bba-920f-b50e2feff1bd", A2(e, "97c209ec-7782-5a29-8c47-af7f17c82d11", A2(e, "cfdc5e31-25fc-56ff-9a54-04670ecad301", A2(e, "2fd6b74f-600a-577c-ba37-b84d8f0482c2", A2(e, "931c9bb0-619a-5f75-b41b-ab8061e2ad92", A2(e, "8343adad-0350-5895-a701-4db41a235ba9", A2(e, "b2dba726-83d2-55b2-8107-91c9e47bdca7", A2(e, "29dc6c73-8d82-5056-8ac0-faf212bc0367", A2(e, "66ef36be-7691-5adc-a684-e83d45e53452", A2(e, "ddcf4b23-1283-57d3-854b-be3121452d50", A2(e, "3561ace1-f710-50ce-a69c-9cf842e729e4", A2(e, "f6ea2983-e024-5de2-b323-273f2436deba", A2(e, "3c66588d-fffb-55cb-b9d5-c197b7e2e591", A2(e, "24edc372-b238-5426-8ac9-059218936641", A2(e, "ab96b73f-8534-59ad-9f34-a579abe3b023", A2(e, "e5e43c57-bd12-5ab7-8a22-7d12cdcece58", A2(e, "7e17b44d-108a-504f-9e0d-0cfe5b5db054", A2(e, "c8be445c-ae33-5240-9007-e7973e97fc24", A2(e, "b7fa51fc-0421-57b0-bb0a-e0573e293c7a", A2(e, "c49a5379-95c4-599a-84da-b5faaa345b97", A2(e, "46e96f29-9ca5-5475-bb3c-6397f43b7a5b", A2(e, "1746b5e1-1d0d-5858-a968-2ade8d778623", A2(e, "b4251621-1747-526a-a54f-e4be7500efff", A2(e, "326369d9-792a-5ab5-8276-c54108c80cb1", Qr(ZE)))))))))))))))))))))))))))))));
        }(t), A2(Lg, A2($a, yt, A2(ci, function(n) {
            return Cb(function(n) {
                return A3(Wa, "yarnSize", hp, A3(Wa, "use", function(n) {
                    return A3(Wa, "wearsPerCycle", xi, A3(Wa, "timeIroning", A2(Qt, QE, Vs), A3(Wa, "ratioIroning", np, A3(Wa, "ratioDryer", np, A3(Wa, "nonIroningProcessUuid", _s(n), A3(Wa, "ironingElecInMJ", A2(Qt, sb, Vs), A3(Wa, "defaultNbCycles", xi, A3(Wa, "daysOfWear", A2(Qt, BE, Vs), nu(KE)))))))));
                }(n), A3(Wa, "trims", Cb(sm), A3(Wa, "surfaceMass", bp, A3(Wa, "name", ai, A3(Wa, "making", WE, A3(Wa, "id", A2(Qt, ru, ai), A3(Wa, "fabric", Fm, A3(Wa, "endOfLife", YE, A3(Wa, "economics", JE, nu(VE)))))))))));
            }(n));
        }(t), r)), A2(Lg, A2($a, yt, A2(ci, function(n) {
            return Cb(function(n) {
                return A3(Wa, "recycledFrom", zs(ip), A3(Wa, "processId", _s(n), A3(Wa, "origin", GE, A3(Wa, "name", ai, A3(Wa, "id", ip, A3(Wa, "geographicOrigin", ai, A3(Wa, "defaultCountry", A2(Qt, gw, ai), A3(Wa, "cff", zs(XE), A3(Wa, "alias", ai, nu(HE))))))))));
            }(n));
        }(t), e)), A2(Lg, A2(zE, $p, n), Qr(FE)))));
    }), eC = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return function($) {
                                                                                    return {
                                                                                        bM: n,
                                                                                        bR: e,
                                                                                        b_: $,
                                                                                        b3: r,
                                                                                        b4: t,
                                                                                        ca: u,
                                                                                        cb: a,
                                                                                        cd: i,
                                                                                        ce: c,
                                                                                        cf: o,
                                                                                        cg: f,
                                                                                        ci: s,
                                                                                        ck: l,
                                                                                        cp: d,
                                                                                        cr: b,
                                                                                        cu: m,
                                                                                        cv: p,
                                                                                        cz: v,
                                                                                        cD: g,
                                                                                        cH: h
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, rC = F6(function(n, e, r, t, u, a) {
        return {
            li: u,
            io: r,
            it: a,
            ai: e,
            kj: n,
            aL: t
        };
    }), tC = A4(dn, F3(function(n, e, r) {
        return {
            dY: n,
            jd: e,
            kp: r
        };
    }), A2(qu, "color", ai), A2(qu, "normalization", $E), A2(qu, "weighting", np)), uC = A2(Mj = function(n) {
        return A2(Wa, n, function(n) {
            return A3(Wa, "ecoscore", zs(tC), A3(Wa, "decimals", xi, A3(Wa, "short_unit", ai, A3(Wa, "description_fr", ai, A3(Wa, "label_fr", ai, A2(Ya, ys(km(n)), nu(rC)))))));
        }(n));
    }, "ecs", A2(Mj, "wtu", A2(Mj, "tre", A2(Mj, "swe", A2(Mj, "pma", A2(Mj, "pco", A2(Mj, "ozd", A2(Mj, "mru", A2(Mj, "ldu", A2(Mj, "ior", A2(Mj, "htn-c", A2(Mj, "htn", A2(Mj, "htc-c", A2(Mj, "htc", A2(Mj, "fwe", A2(Mj, "fru", A2(Mj, "etf-c", A2(Mj, "etf", A2(Mj, "cch", A2(Mj, "acd", nu(eC))))))))))))))))))))), aC = F3(function(n, e, r) {
        return A2(Qt, A2(Hr, F3(function(e, r, t) {
            return A3(os, A2(n, e, r), r, t);
        }), cs(e)), is(r));
    }), iC = A3(aC, F2(function(n) {
        return gw(n);
    }), Po, vl), cC = A3(aC, F2(function(n) {
        return gw(n);
    }), Po, iC), oC = A2(Qt, ru, Za(A([
        A3(Wa, "ecs", $E, A3(Wa, "wtu", $E, A3(Wa, "tre", $E, A3(Wa, "swe", $E, A3(Wa, "pma", $E, A3(Wa, "pco", $E, A3(Wa, "ozd", $E, A3(Wa, "mru", $E, A3(Wa, "ldu", $E, A3(Wa, "ior", $E, A3(Wa, "htn-c", $E, A3(Wa, "htn", $E, A3(Wa, "htc-c", $E, A3(Wa, "htc", $E, A3(Wa, "fwe", $E, A3(Wa, "fru", $E, A3(Wa, "etf-c", $E, A3(Wa, "etf", $E, A3(Wa, "cch", $E, A3(Wa, "acd", $E, nu(eC))))))))))))))))))))),
        A3(Wa, "ecs", $E, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, A2(Bs, 0, nu(eC)))))))))))))))))))))
    ]))), fC = F9(function(n, e, r, t, u, a, i, c, o) {
        return {
            hP: n,
            cR: e,
            gh: r,
            fa: t,
            lO: u,
            me: a,
            ek: i,
            g9: c,
            hG: o
        };
    }), sC = A2(Bt, A2(Hu, function(n) {
        switch(n){
            case "Africa":
                return Qr(0);
            case "Asia":
                return Qr(1);
            case "Europe":
                return Qr(2);
            case "Middle_East":
                return Qr(3);
            case "North_America":
                return Qr(4);
            case "Oceania":
                return Qr(5);
            case "South_America":
                return Qr(6);
            default:
                return Yr("Zone g\xe9ographique inconnue : " + n);
        }
    }, ys), ai), lC = A2(Bt, ys, A2(Qt, function(n) {
        switch(n){
            case "Average":
                return Qr(0);
            case "Best":
                return Qr(1);
            case "Worst":
                return Qr(2);
            default:
                return Yr("Le scenario '" + n + "' n'est pas un sc\xe9nario de pollution aquatique valide (choix entre ['Best', 'Average', 'Worst']");
        }
    }, ai)), dC = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return {
                                                                                    f4: n,
                                                                                    hM: e,
                                                                                    cP: r,
                                                                                    gh: t,
                                                                                    lv: u,
                                                                                    d2: a,
                                                                                    eb: i,
                                                                                    mj: c,
                                                                                    g: o,
                                                                                    mG: f,
                                                                                    i3: s,
                                                                                    mZ: l,
                                                                                    m0: d,
                                                                                    g4: b,
                                                                                    g9: m,
                                                                                    jU: p,
                                                                                    he: v,
                                                                                    aL: g,
                                                                                    kn: h
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, bC = ru, mC = A2(Nc, Cs, Es("[\\W_]+")), pC = A([
        v("\u24B6", "A"),
        v("\uFF21", "A"),
        v("\xc0", "A"),
        v("\xc1", "A"),
        v("\xc2", "A"),
        v("\u1EA6", "A"),
        v("\u1EA4", "A"),
        v("\u1EAA", "A"),
        v("\u1EA8", "A"),
        v("\xc3", "A"),
        v("\u0100", "A"),
        v("\u0102", "A"),
        v("\u1EB0", "A"),
        v("\u1EAE", "A"),
        v("\u1EB4", "A"),
        v("\u1EB2", "A"),
        v("\u0226", "A"),
        v("\u01E0", "A"),
        v("\xc4", "A"),
        v("\u01DE", "A"),
        v("\u1EA2", "A"),
        v("\xc5", "A"),
        v("\u01FA", "A"),
        v("\u01CD", "A"),
        v("\u0200", "A"),
        v("\u0202", "A"),
        v("\u1EA0", "A"),
        v("\u1EAC", "A"),
        v("\u1EB6", "A"),
        v("\u1E00", "A"),
        v("\u0104", "A"),
        v("\u023A", "A"),
        v("\u2C6F", "A"),
        v("\uA732", "AA"),
        v("\xc6", "AE"),
        v("\u01FC", "AE"),
        v("\u01E2", "AE"),
        v("\uA734", "AO"),
        v("\uA736", "AU"),
        v("\uA738", "AV"),
        v("\uA73A", "AV"),
        v("\uA73C", "AY"),
        v("\u24B7", "B"),
        v("\uFF22", "B"),
        v("\u1E02", "B"),
        v("\u1E04", "B"),
        v("\u1E06", "B"),
        v("\u0243", "B"),
        v("\u0182", "B"),
        v("\u0181", "B"),
        v("\u24B8", "C"),
        v("\uFF23", "C"),
        v("\u0106", "C"),
        v("\u0108", "C"),
        v("\u010A", "C"),
        v("\u010C", "C"),
        v("\xc7", "C"),
        v("\u1E08", "C"),
        v("\u0187", "C"),
        v("\u023B", "C"),
        v("\uA73E", "C"),
        v("\u24B9", "D"),
        v("\uFF24", "D"),
        v("\u1E0A", "D"),
        v("\u010E", "D"),
        v("\u1E0C", "D"),
        v("\u1E10", "D"),
        v("\u1E12", "D"),
        v("\u1E0E", "D"),
        v("\u0110", "D"),
        v("\u018B", "D"),
        v("\u018A", "D"),
        v("\u0189", "D"),
        v("\uA779", "D"),
        v("\u01F1", "DZ"),
        v("\u01C4", "DZ"),
        v("\u01F2", "Dz"),
        v("\u01C5", "Dz"),
        v("\u24BA", "E"),
        v("\uFF25", "E"),
        v("\xc8", "E"),
        v("\xc9", "E"),
        v("\xca", "E"),
        v("\u1EC0", "E"),
        v("\u1EBE", "E"),
        v("\u1EC4", "E"),
        v("\u1EC2", "E"),
        v("\u1EBC", "E"),
        v("\u0112", "E"),
        v("\u1E14", "E"),
        v("\u1E16", "E"),
        v("\u0114", "E"),
        v("\u0116", "E"),
        v("\xcb", "E"),
        v("\u1EBA", "E"),
        v("\u011A", "E"),
        v("\u0204", "E"),
        v("\u0206", "E"),
        v("\u1EB8", "E"),
        v("\u1EC6", "E"),
        v("\u0228", "E"),
        v("\u1E1C", "E"),
        v("\u0118", "E"),
        v("\u1E18", "E"),
        v("\u1E1A", "E"),
        v("\u0190", "E"),
        v("\u018E", "E"),
        v("\u24BB", "F"),
        v("\uFF26", "F"),
        v("\u1E1E", "F"),
        v("\u0191", "F"),
        v("\uA77B", "F"),
        v("\u24BC", "G"),
        v("\uFF27", "G"),
        v("\u01F4", "G"),
        v("\u011C", "G"),
        v("\u1E20", "G"),
        v("\u011E", "G"),
        v("\u0120", "G"),
        v("\u01E6", "G"),
        v("\u0122", "G"),
        v("\u01E4", "G"),
        v("\u0193", "G"),
        v("\uA7A0", "G"),
        v("\uA77D", "G"),
        v("\uA77E", "G"),
        v("\u24BD", "H"),
        v("\uFF28", "H"),
        v("\u0124", "H"),
        v("\u1E22", "H"),
        v("\u1E26", "H"),
        v("\u021E", "H"),
        v("\u1E24", "H"),
        v("\u1E28", "H"),
        v("\u1E2A", "H"),
        v("\u0126", "H"),
        v("\u2C67", "H"),
        v("\u2C75", "H"),
        v("\uA78D", "H"),
        v("\u24BE", "I"),
        v("\uFF29", "I"),
        v("\xcc", "I"),
        v("\xcd", "I"),
        v("\xce", "I"),
        v("\u0128", "I"),
        v("\u012A", "I"),
        v("\u012C", "I"),
        v("\u0130", "I"),
        v("\xcf", "I"),
        v("\u1E2E", "I"),
        v("\u1EC8", "I"),
        v("\u01CF", "I"),
        v("\u0208", "I"),
        v("\u020A", "I"),
        v("\u1ECA", "I"),
        v("\u012E", "I"),
        v("\u1E2C", "I"),
        v("\u0197", "I"),
        v("\u24BF", "J"),
        v("\uFF2A", "J"),
        v("\u0134", "J"),
        v("\u0248", "J"),
        v("\u24C0", "K"),
        v("\uFF2B", "K"),
        v("\u1E30", "K"),
        v("\u01E8", "K"),
        v("\u1E32", "K"),
        v("\u0136", "K"),
        v("\u1E34", "K"),
        v("\u0198", "K"),
        v("\u2C69", "K"),
        v("\uA740", "K"),
        v("\uA742", "K"),
        v("\uA744", "K"),
        v("\uA7A2", "K"),
        v("\u24C1", "L"),
        v("\uFF2C", "L"),
        v("\u013F", "L"),
        v("\u0139", "L"),
        v("\u013D", "L"),
        v("\u1E36", "L"),
        v("\u1E38", "L"),
        v("\u013B", "L"),
        v("\u1E3C", "L"),
        v("\u1E3A", "L"),
        v("\u0141", "L"),
        v("\u023D", "L"),
        v("\u2C62", "L"),
        v("\u2C60", "L"),
        v("\uA748", "L"),
        v("\uA746", "L"),
        v("\uA780", "L"),
        v("\u01C7", "LJ"),
        v("\u01C8", "Lj"),
        v("\u24C2", "M"),
        v("\uFF2D", "M"),
        v("\u1E3E", "M"),
        v("\u1E40", "M"),
        v("\u1E42", "M"),
        v("\u2C6E", "M"),
        v("\u019C", "M"),
        v("\u24C3", "N"),
        v("\uFF2E", "N"),
        v("\u01F8", "N"),
        v("\u0143", "N"),
        v("\xd1", "N"),
        v("\u1E44", "N"),
        v("\u0147", "N"),
        v("\u1E46", "N"),
        v("\u0145", "N"),
        v("\u1E4A", "N"),
        v("\u1E48", "N"),
        v("\u0220", "N"),
        v("\u019D", "N"),
        v("\uA790", "N"),
        v("\uA7A4", "N"),
        v("\u01CA", "NJ"),
        v("\u01CB", "Nj"),
        v("\u24C4", "O"),
        v("\uFF2F", "O"),
        v("\xd2", "O"),
        v("\xd3", "O"),
        v("\xd4", "O"),
        v("\u1ED2", "O"),
        v("\u1ED0", "O"),
        v("\u1ED6", "O"),
        v("\u1ED4", "O"),
        v("\xd5", "O"),
        v("\u1E4C", "O"),
        v("\u022C", "O"),
        v("\u1E4E", "O"),
        v("\u014C", "O"),
        v("\u1E50", "O"),
        v("\u1E52", "O"),
        v("\u014E", "O"),
        v("\u022E", "O"),
        v("\u0230", "O"),
        v("\xd6", "O"),
        v("\u022A", "O"),
        v("\u1ECE", "O"),
        v("\u0150", "O"),
        v("\u01D1", "O"),
        v("\u020C", "O"),
        v("\u020E", "O"),
        v("\u01A0", "O"),
        v("\u1EDC", "O"),
        v("\u1EDA", "O"),
        v("\u1EE0", "O"),
        v("\u1EDE", "O"),
        v("\u1EE2", "O"),
        v("\u1ECC", "O"),
        v("\u1ED8", "O"),
        v("\u01EA", "O"),
        v("\u01EC", "O"),
        v("\xd8", "O"),
        v("\u01FE", "O"),
        v("\u0186", "O"),
        v("\u019F", "O"),
        v("\uA74A", "O"),
        v("\uA74C", "O"),
        v("\u01A2", "OI"),
        v("\uA74E", "OO"),
        v("\u0222", "OU"),
        v("\x8c", "OE"),
        v("\u0152", "OE"),
        v("\x9c", "oe"),
        v("\u0153", "oe"),
        v("\u24C5", "P"),
        v("\uFF30", "P"),
        v("\u1E54", "P"),
        v("\u1E56", "P"),
        v("\u01A4", "P"),
        v("\u2C63", "P"),
        v("\uA750", "P"),
        v("\uA752", "P"),
        v("\uA754", "P"),
        v("\u24C6", "Q"),
        v("\uFF31", "Q"),
        v("\uA756", "Q"),
        v("\uA758", "Q"),
        v("\u024A", "Q"),
        v("\u24C7", "R"),
        v("\uFF32", "R"),
        v("\u0154", "R"),
        v("\u1E58", "R"),
        v("\u0158", "R"),
        v("\u0210", "R"),
        v("\u0212", "R"),
        v("\u1E5A", "R"),
        v("\u1E5C", "R"),
        v("\u0156", "R"),
        v("\u1E5E", "R"),
        v("\u024C", "R"),
        v("\u2C64", "R"),
        v("\uA75A", "R"),
        v("\uA7A6", "R"),
        v("\uA782", "R"),
        v("\u24C8", "S"),
        v("\uFF33", "S"),
        v("\u1E9E", "S"),
        v("\u015A", "S"),
        v("\u1E64", "S"),
        v("\u015C", "S"),
        v("\u1E60", "S"),
        v("\u0160", "S"),
        v("\u1E66", "S"),
        v("\u1E62", "S"),
        v("\u1E68", "S"),
        v("\u0218", "S"),
        v("\u015E", "S"),
        v("\u2C7E", "S"),
        v("\uA7A8", "S"),
        v("\uA784", "S"),
        v("\u24C9", "T"),
        v("\uFF34", "T"),
        v("\u1E6A", "T"),
        v("\u0164", "T"),
        v("\u1E6C", "T"),
        v("\u021A", "T"),
        v("\u0162", "T"),
        v("\u1E70", "T"),
        v("\u1E6E", "T"),
        v("\u0166", "T"),
        v("\u01AC", "T"),
        v("\u01AE", "T"),
        v("\u023E", "T"),
        v("\uA786", "T"),
        v("\uA728", "TZ"),
        v("\u24CA", "U"),
        v("\uFF35", "U"),
        v("\xd9", "U"),
        v("\xda", "U"),
        v("\xdb", "U"),
        v("\u0168", "U"),
        v("\u1E78", "U"),
        v("\u016A", "U"),
        v("\u1E7A", "U"),
        v("\u016C", "U"),
        v("\xdc", "U"),
        v("\u01DB", "U"),
        v("\u01D7", "U"),
        v("\u01D5", "U"),
        v("\u01D9", "U"),
        v("\u1EE6", "U"),
        v("\u016E", "U"),
        v("\u0170", "U"),
        v("\u01D3", "U"),
        v("\u0214", "U"),
        v("\u0216", "U"),
        v("\u01AF", "U"),
        v("\u1EEA", "U"),
        v("\u1EE8", "U"),
        v("\u1EEE", "U"),
        v("\u1EEC", "U"),
        v("\u1EF0", "U"),
        v("\u1EE4", "U"),
        v("\u1E72", "U"),
        v("\u0172", "U"),
        v("\u1E76", "U"),
        v("\u1E74", "U"),
        v("\u0244", "U"),
        v("\u24CB", "V"),
        v("\uFF36", "V"),
        v("\u1E7C", "V"),
        v("\u1E7E", "V"),
        v("\u01B2", "V"),
        v("\uA75E", "V"),
        v("\u0245", "V"),
        v("\uA760", "VY"),
        v("\u24CC", "W"),
        v("\uFF37", "W"),
        v("\u1E80", "W"),
        v("\u1E82", "W"),
        v("\u0174", "W"),
        v("\u1E86", "W"),
        v("\u1E84", "W"),
        v("\u1E88", "W"),
        v("\u2C72", "W"),
        v("\u24CD", "X"),
        v("\uFF38", "X"),
        v("\u1E8A", "X"),
        v("\u1E8C", "X"),
        v("\u24CE", "Y"),
        v("\uFF39", "Y"),
        v("\u1EF2", "Y"),
        v("\xdd", "Y"),
        v("\u0176", "Y"),
        v("\u1EF8", "Y"),
        v("\u0232", "Y"),
        v("\u1E8E", "Y"),
        v("\u0178", "Y"),
        v("\u1EF6", "Y"),
        v("\u1EF4", "Y"),
        v("\u01B3", "Y"),
        v("\u024E", "Y"),
        v("\u1EFE", "Y"),
        v("\u24CF", "Z"),
        v("\uFF3A", "Z"),
        v("\u0179", "Z"),
        v("\u1E90", "Z"),
        v("\u017B", "Z"),
        v("\u017D", "Z"),
        v("\u1E92", "Z"),
        v("\u1E94", "Z"),
        v("\u01B5", "Z"),
        v("\u0224", "Z"),
        v("\u2C7F", "Z"),
        v("\u2C6B", "Z"),
        v("\uA762", "Z"),
        v("\u24D0", "a"),
        v("\uFF41", "a"),
        v("\u1E9A", "a"),
        v("\xe0", "a"),
        v("\xe1", "a"),
        v("\xe2", "a"),
        v("\u1EA7", "a"),
        v("\u1EA5", "a"),
        v("\u1EAB", "a"),
        v("\u1EA9", "a"),
        v("\xe3", "a"),
        v("\u0101", "a"),
        v("\u0103", "a"),
        v("\u1EB1", "a"),
        v("\u1EAF", "a"),
        v("\u1EB5", "a"),
        v("\u1EB3", "a"),
        v("\u0227", "a"),
        v("\u01E1", "a"),
        v("\xe4", "a"),
        v("\u01DF", "a"),
        v("\u1EA3", "a"),
        v("\xe5", "a"),
        v("\u01FB", "a"),
        v("\u01CE", "a"),
        v("\u0201", "a"),
        v("\u0203", "a"),
        v("\u1EA1", "a"),
        v("\u1EAD", "a"),
        v("\u1EB7", "a"),
        v("\u1E01", "a"),
        v("\u0105", "a"),
        v("\u2C65", "a"),
        v("\u0250", "a"),
        v("\uA733", "aa"),
        v("\xe6", "ae"),
        v("\u01FD", "ae"),
        v("\u01E3", "ae"),
        v("\uA735", "ao"),
        v("\uA737", "au"),
        v("\uA739", "av"),
        v("\uA73B", "av"),
        v("\uA73D", "ay"),
        v("\u24D1", "b"),
        v("\uFF42", "b"),
        v("\u1E03", "b"),
        v("\u1E05", "b"),
        v("\u1E07", "b"),
        v("\u0180", "b"),
        v("\u0183", "b"),
        v("\u0253", "b"),
        v("\u24D2", "c"),
        v("\uFF43", "c"),
        v("\u0107", "c"),
        v("\u0109", "c"),
        v("\u010B", "c"),
        v("\u010D", "c"),
        v("\xe7", "c"),
        v("\u1E09", "c"),
        v("\u0188", "c"),
        v("\u023C", "c"),
        v("\uA73F", "c"),
        v("\u2184", "c"),
        v("\u24D3", "d"),
        v("\uFF44", "d"),
        v("\u1E0B", "d"),
        v("\u010F", "d"),
        v("\u1E0D", "d"),
        v("\u1E11", "d"),
        v("\u1E13", "d"),
        v("\u1E0F", "d"),
        v("\u0111", "d"),
        v("\u018C", "d"),
        v("\u0256", "d"),
        v("\u0257", "d"),
        v("\uA77A", "d"),
        v("\u01F3", "dz"),
        v("\u01C6", "dz"),
        v("\u24D4", "e"),
        v("\uFF45", "e"),
        v("\xe8", "e"),
        v("\xe9", "e"),
        v("\xea", "e"),
        v("\u1EC1", "e"),
        v("\u1EBF", "e"),
        v("\u1EC5", "e"),
        v("\u1EC3", "e"),
        v("\u1EBD", "e"),
        v("\u0113", "e"),
        v("\u1E15", "e"),
        v("\u1E17", "e"),
        v("\u0115", "e"),
        v("\u0117", "e"),
        v("\xeb", "e"),
        v("\u1EBB", "e"),
        v("\u011B", "e"),
        v("\u0205", "e"),
        v("\u0207", "e"),
        v("\u1EB9", "e"),
        v("\u1EC7", "e"),
        v("\u0229", "e"),
        v("\u1E1D", "e"),
        v("\u0119", "e"),
        v("\u1E19", "e"),
        v("\u1E1B", "e"),
        v("\u0247", "e"),
        v("\u025B", "e"),
        v("\u01DD", "e"),
        v("\u24D5", "f"),
        v("\uFF46", "f"),
        v("\u1E1F", "f"),
        v("\u0192", "f"),
        v("\uA77C", "f"),
        v("\u24D6", "g"),
        v("\uFF47", "g"),
        v("\u01F5", "g"),
        v("\u011D", "g"),
        v("\u1E21", "g"),
        v("\u011F", "g"),
        v("\u0121", "g"),
        v("\u01E7", "g"),
        v("\u0123", "g"),
        v("\u01E5", "g"),
        v("\u0260", "g"),
        v("\uA7A1", "g"),
        v("\u1D79", "g"),
        v("\uA77F", "g"),
        v("\u24D7", "h"),
        v("\uFF48", "h"),
        v("\u0125", "h"),
        v("\u1E23", "h"),
        v("\u1E27", "h"),
        v("\u021F", "h"),
        v("\u1E25", "h"),
        v("\u1E29", "h"),
        v("\u1E2B", "h"),
        v("\u1E96", "h"),
        v("\u0127", "h"),
        v("\u2C68", "h"),
        v("\u2C76", "h"),
        v("\u0265", "h"),
        v("\u0195", "hv"),
        v("\u24D8", "i"),
        v("\uFF49", "i"),
        v("\xec", "i"),
        v("\xed", "i"),
        v("\xee", "i"),
        v("\u0129", "i"),
        v("\u012B", "i"),
        v("\u012D", "i"),
        v("\xef", "i"),
        v("\u1E2F", "i"),
        v("\u1EC9", "i"),
        v("\u01D0", "i"),
        v("\u0209", "i"),
        v("\u020B", "i"),
        v("\u1ECB", "i"),
        v("\u012F", "i"),
        v("\u1E2D", "i"),
        v("\u0268", "i"),
        v("\u0131", "i"),
        v("\u24D9", "j"),
        v("\uFF4A", "j"),
        v("\u0135", "j"),
        v("\u01F0", "j"),
        v("\u0249", "j"),
        v("\u24DA", "k"),
        v("\uFF4B", "k"),
        v("\u1E31", "k"),
        v("\u01E9", "k"),
        v("\u1E33", "k"),
        v("\u0137", "k"),
        v("\u1E35", "k"),
        v("\u0199", "k"),
        v("\u2C6A", "k"),
        v("\uA741", "k"),
        v("\uA743", "k"),
        v("\uA745", "k"),
        v("\uA7A3", "k"),
        v("\u24DB", "l"),
        v("\uFF4C", "l"),
        v("\u0140", "l"),
        v("\u013A", "l"),
        v("\u013E", "l"),
        v("\u1E37", "l"),
        v("\u1E39", "l"),
        v("\u013C", "l"),
        v("\u1E3D", "l"),
        v("\u1E3B", "l"),
        v("\u017F", "l"),
        v("\u0142", "l"),
        v("\u019A", "l"),
        v("\u026B", "l"),
        v("\u2C61", "l"),
        v("\uA749", "l"),
        v("\uA781", "l"),
        v("\uA747", "l"),
        v("\u01C9", "lj"),
        v("\u24DC", "m"),
        v("\uFF4D", "m"),
        v("\u1E3F", "m"),
        v("\u1E41", "m"),
        v("\u1E43", "m"),
        v("\u0271", "m"),
        v("\u026F", "m"),
        v("\u24DD", "n"),
        v("\uFF4E", "n"),
        v("\u01F9", "n"),
        v("\u0144", "n"),
        v("\xf1", "n"),
        v("\u1E45", "n"),
        v("\u0148", "n"),
        v("\u1E47", "n"),
        v("\u0146", "n"),
        v("\u1E4B", "n"),
        v("\u1E49", "n"),
        v("\u019E", "n"),
        v("\u0272", "n"),
        v("\u0149", "n"),
        v("\uA791", "n"),
        v("\uA7A5", "n"),
        v("\u01CC", "nj"),
        v("\u24DE", "o"),
        v("\uFF4F", "o"),
        v("\xf2", "o"),
        v("\xf3", "o"),
        v("\xf4", "o"),
        v("\u1ED3", "o"),
        v("\u1ED1", "o"),
        v("\u1ED7", "o"),
        v("\u1ED5", "o"),
        v("\xf5", "o"),
        v("\u1E4D", "o"),
        v("\u022D", "o"),
        v("\u1E4F", "o"),
        v("\u014D", "o"),
        v("\u1E51", "o"),
        v("\u1E53", "o"),
        v("\u014F", "o"),
        v("\u022F", "o"),
        v("\u0231", "o"),
        v("\xf6", "o"),
        v("\u022B", "o"),
        v("\u1ECF", "o"),
        v("\u0151", "o"),
        v("\u01D2", "o"),
        v("\u020D", "o"),
        v("\u020F", "o"),
        v("\u01A1", "o"),
        v("\u1EDD", "o"),
        v("\u1EDB", "o"),
        v("\u1EE1", "o"),
        v("\u1EDF", "o"),
        v("\u1EE3", "o"),
        v("\u1ECD", "o"),
        v("\u1ED9", "o"),
        v("\u01EB", "o"),
        v("\u01ED", "o"),
        v("\xf8", "o"),
        v("\u01FF", "o"),
        v("\u0254", "o"),
        v("\uA74B", "o"),
        v("\uA74D", "o"),
        v("\u0275", "o"),
        v("\u01A3", "oi"),
        v("\u0223", "ou"),
        v("\uA74F", "oo"),
        v("\u24DF", "p"),
        v("\uFF50", "p"),
        v("\u1E55", "p"),
        v("\u1E57", "p"),
        v("\u01A5", "p"),
        v("\u1D7D", "p"),
        v("\uA751", "p"),
        v("\uA753", "p"),
        v("\uA755", "p"),
        v("\u24E0", "q"),
        v("\uFF51", "q"),
        v("\u024B", "q"),
        v("\uA757", "q"),
        v("\uA759", "q"),
        v("\u24E1", "r"),
        v("\uFF52", "r"),
        v("\u0155", "r"),
        v("\u1E59", "r"),
        v("\u0159", "r"),
        v("\u0211", "r"),
        v("\u0213", "r"),
        v("\u1E5B", "r"),
        v("\u1E5D", "r"),
        v("\u0157", "r"),
        v("\u1E5F", "r"),
        v("\u024D", "r"),
        v("\u027D", "r"),
        v("\uA75B", "r"),
        v("\uA7A7", "r"),
        v("\uA783", "r"),
        v("\u24E2", "s"),
        v("\uFF53", "s"),
        v("\xdf", "s"),
        v("\u015B", "s"),
        v("\u1E65", "s"),
        v("\u015D", "s"),
        v("\u1E61", "s"),
        v("\u0161", "s"),
        v("\u1E67", "s"),
        v("\u1E63", "s"),
        v("\u1E69", "s"),
        v("\u0219", "s"),
        v("\u015F", "s"),
        v("\u023F", "s"),
        v("\uA7A9", "s"),
        v("\uA785", "s"),
        v("\u1E9B", "s"),
        v("\u24E3", "t"),
        v("\uFF54", "t"),
        v("\u1E6B", "t"),
        v("\u1E97", "t"),
        v("\u0165", "t"),
        v("\u1E6D", "t"),
        v("\u021B", "t"),
        v("\u0163", "t"),
        v("\u1E71", "t"),
        v("\u1E6F", "t"),
        v("\u0167", "t"),
        v("\u01AD", "t"),
        v("\u0288", "t"),
        v("\u2C66", "t"),
        v("\uA787", "t"),
        v("\uA729", "tz"),
        v("\u24E4", "u"),
        v("\uFF55", "u"),
        v("\xf9", "u"),
        v("\xfa", "u"),
        v("\xfb", "u"),
        v("\u0169", "u"),
        v("\u1E79", "u"),
        v("\u016B", "u"),
        v("\u1E7B", "u"),
        v("\u016D", "u"),
        v("\xfc", "u"),
        v("\u01DC", "u"),
        v("\u01D8", "u"),
        v("\u01D6", "u"),
        v("\u01DA", "u"),
        v("\u1EE7", "u"),
        v("\u016F", "u"),
        v("\u0171", "u"),
        v("\u01D4", "u"),
        v("\u0215", "u"),
        v("\u0217", "u"),
        v("\u01B0", "u"),
        v("\u1EEB", "u"),
        v("\u1EE9", "u"),
        v("\u1EEF", "u"),
        v("\u1EED", "u"),
        v("\u1EF1", "u"),
        v("\u1EE5", "u"),
        v("\u1E73", "u"),
        v("\u0173", "u"),
        v("\u1E77", "u"),
        v("\u1E75", "u"),
        v("\u0289", "u"),
        v("\u24E5", "v"),
        v("\uFF56", "v"),
        v("\u1E7D", "v"),
        v("\u1E7F", "v"),
        v("\u028B", "v"),
        v("\uA75F", "v"),
        v("\u028C", "v"),
        v("\uA761", "vy"),
        v("\u24E6", "w"),
        v("\uFF57", "w"),
        v("\u1E81", "w"),
        v("\u1E83", "w"),
        v("\u0175", "w"),
        v("\u1E87", "w"),
        v("\u1E85", "w"),
        v("\u1E98", "w"),
        v("\u1E89", "w"),
        v("\u2C73", "w"),
        v("\u24E7", "x"),
        v("\uFF58", "x"),
        v("\u1E8B", "x"),
        v("\u1E8D", "x"),
        v("\u24E8", "y"),
        v("\uFF59", "y"),
        v("\u1EF3", "y"),
        v("\xfd", "y"),
        v("\u0177", "y"),
        v("\u1EF9", "y"),
        v("\u0233", "y"),
        v("\u1E8F", "y"),
        v("\xff", "y"),
        v("\u1EF7", "y"),
        v("\u1E99", "y"),
        v("\u1EF5", "y"),
        v("\u01B4", "y"),
        v("\u024F", "y"),
        v("\u1EFF", "y"),
        v("\u24E9", "z"),
        v("\uFF5A", "z"),
        v("\u017A", "z"),
        v("\u1E91", "z"),
        v("\u017C", "z"),
        v("\u017E", "z"),
        v("\u1E93", "z"),
        v("\u1E95", "z"),
        v("\u01B6", "z")
    ]), vC = Mi(pC), gC = function(n) {
        return n.b ? zr(A3(ot, Dt, n.a, n.b)) : Ur;
    }, hC = A2(Nc, 1114111, gC(A2(wu, mt, A2(wu, Xt, pC)))), $C = Cy(A2(wu, function(n) {
        var e = A2(ra, Nd(n), vC);
        return 1 === e.$ ? Jc(Nd(n)) : e.a;
    }, A2(dt, 0, hC))), xC = A2(Nc, 0, (Dj = A2(wu, mt, A2(wu, Xt, pC))).b ? zr(A3(ot, Lj, Dj.a, Dj.b)) : Ur), kC = function(n) {
        return A3(Dd, F2(function(n, e) {
            if (0 > m(mt(n), xC)) return k(e, Jc(n));
            var r = A2(qy, mt(n), $C);
            return k(e, r.$ ? Jc(n) : r.a);
        }), "", n);
    }, jC = A2(Hu, Ss, A2(Hu, kC, A2(Hu, A2(zk, mC, function() {
        return " ";
    }), mf))), yC = function(n) {
        switch(n){
            case 0:
                return "Aluminium";
            case 1:
                return "Pile Alcaline";
            case 2:
                return "Cellule de batteries LFP";
            case 3:
                return "Cellule de batteries NMC622";
            case 4:
                return "Cellule de batteries NMC811";
            case 5:
                return "Cereals";
            case 6:
                return "Composites";
            case 7:
                return "Carton";
            case 8:
                return "Cuivre";
            case 9:
                return "Produits laitiers";
            case 10:
                return "\u0152ufs";
            case 11:
                return "M\xe9taux ferreux";
            case 12:
                return "Poissons et crustac\xe9es";
            case 13:
                return "Fruits et l\xe9gumes frais";
            case 14:
                return "Verre";
            case 15:
                return "PEHD";
            case 16:
                return "PEBD";
            case 17:
                return "Legumes";
            case 18:
                return "Abats";
            case 19:
                return "Fibres organiques";
            case 20:
                return "Divers ingr\xe9dients";
            case 21:
                return "Autre type de mati\xe8re";
            case 22:
                return "PET";
            case 23:
                return "PP";
            case 24:
                return "Carte de circuit imprim\xe9";
            case 25:
                return "Volailles et viandes blanches";
            case 26:
                return "PUR";
            case 27:
                return "Viandes rouges";
            case 28:
                return "Plastiques rigides";
            case 29:
                return "Caoutchouc";
            case 30:
                return "Fibres synth\xe9tiques";
            default:
                return "Bois";
        }
    }, wC = function(n) {
        switch(n.$){
            case 0:
                return "Assemblage";
            case 1:
                return "Distribution";
            case 2:
                return "Fin de vie";
            case 3:
                return "\xc9nergie";
            case 4:
                return "Ingr\xe9dient";
            case 5:
                return "Mat\xe9riau";
            case 6:
                return "Type de mat\xe9riau:" + yC(n.a);
            case 7:
                return "Emballage";
            case 8:
                return "Type d\u2019emballage:" + function(n) {
                    switch(n){
                        case 0:
                            return "Sachet";
                        case 1:
                            return "Bouteille";
                        case 2:
                            return "Bo\xeete";
                        case 3:
                            return "Etui";
                        case 4:
                            return "Flacon";
                        case 5:
                            return "Pot & bocal";
                        case 6:
                            return "Autres";
                        case 7:
                            return "Lot";
                        case 8:
                            return "Feuille";
                        default:
                            return "Barquette";
                    }
                }(n.a);
            case 9:
                return "D\xe9pendant de la masse produit";
            case 10:
                return "Mat\xe9riau textile";
            case 11:
                return "Transformation";
            case 12:
                return "Transport";
            case 13:
                return "Transport r\xe9frig\xe9r\xe9";
            case 14:
                return "Utilisation";
            default:
                return "Traitement des d\xe9chets";
        }
    }, AC = A2(Hu, function(n) {
        return A2(at, " ", A([
            qs(n.mj),
            Gb(n),
            Hb(n),
            A2(at, " ", A2(wu, wC, n.cP)),
            A2(at, " ", A2(wu, vs, n.g9)),
            n.gh,
            n.he
        ]));
    }, jC), TC = function(n) {
        return $(n, {
            jU: AC(n)
        });
    }, EC = F3(function(n, e, r) {
        return {
            k1: n,
            gp: e,
            iC: r
        };
    }), CC = A3(ui, "plotSize", $E, A3(ui, "permanentPasture", $E, A3(ui, "outOfEuropeEOL", $E, A3(ui, "microfibers", $E, A3(ui, "hedges", $E, A3(ui, "forest", $E, A3(ui, "cropDiversity", $E, nu(F7(function(n, e, r, t, u, a, i) {
        return {
            ag: n,
            aa: e,
            ah: r,
            aj: t,
            ak: u,
            al: a,
            am: i
        };
    }))))))))), IC = A3(ui, "forestManagement", A2(Bt, A2(cc, ys, function(n) {
        switch(n){
            case "certifiedDiversifiedForest":
                return Qr(0);
            case "certifiedSustainableManagement":
                return Qr(1);
            case "diversifiedForest":
                return Qr(2);
            case "intensivePlantation":
                return Qr(3);
            case "sustainableManagement":
                return Qr(4);
            default:
                return Yr("Invalid or non-supported forest management value: " + n);
        }
    }), ai), A3(ui, "defaultOrigin", $s, A3(ui, "complements", CC, nu(EC)))), SC = {
        $: 2
    }, OC = {
        $: 3
    }, LC = {
        $: 4
    }, PC = {
        $: 5
    }, qC = function(n) {
        return {
            $: 6,
            a: n
        };
    }, NC = {
        $: 7
    }, _C = function(n) {
        return {
            $: 8,
            a: n
        };
    }, zC = {
        $: 10
    }, UC = {
        $: 11
    }, MC = {
        $: 12
    }, DC = {
        $: 14
    }, RC = {
        $: 15
    }, FC = Cb(A2(Bt, A2(Hu, function(n) {
        switch(n){
            case "assembly":
                return Qr(Px);
            case "distribution":
                return Qr(Dh);
            case "end-of-life":
                return Qr(SC);
            case "energy":
                return Qr(OC);
            case "ingredient":
                return Qr(LC);
            case "material":
                return Qr(PC);
            case "packaging":
                return Qr(NC);
            case "productmassdependent":
                return Qr(Xb);
            case "textile_material":
                return Qr(zC);
            case "transformation":
                return Qr(UC);
            case "transport":
                return Qr(MC);
            case "transported_cooled":
                return Qr(R$);
            case "use":
                return Qr(DC);
            case "waste treatment":
                return Qr(RC);
            default:
                return A2(gu, "material_type:", n) ? A2(fs, qC, il(A2(ou, 14, n))) : A2(gu, "packaging_type:", n) ? A2(fs, _C, function(n) {
                    switch(n){
                        case "bag":
                            return Qr(0);
                        case "bottle":
                            return Qr(1);
                        case "box":
                            return Qr(2);
                        case "case":
                            return Qr(3);
                        case "flask":
                            return Qr(4);
                        case "jar":
                            return Qr(5);
                        case "other":
                            return Qr(6);
                        case "pack":
                            return Qr(7);
                        case "sheet":
                            return Qr(8);
                        case "tray":
                            return Qr(9);
                        default:
                            return Yr("Type d\u2019emballage non support\xe9\u202F: " + n);
                    }
                }(A2(ou, 15, n))) : Yr("Cat\xe9gorie de proc\xe9d\xe9 invalide: " + n);
        }
    }, ys), ai)), HC = A2(Bt, function(n) {
        return "" === mf(n) ? Ii("String can't be empty") : nu(mf(n));
    }, ai), GC = A2(Qt, Ow, Vs), XC = function(n) {
        switch(n){
            case "item":
                return Qr(1);
            case "kg":
                return Qr(2);
            case "kWh":
                return Qr(3);
            case "L":
                return Qr(4);
            case "m2":
                return Qr(6);
            case "m3":
                return Qr(0);
            case "MJ":
                return Qr(5);
            case "t\u22C5km":
                return Qr(7);
            default:
                return Yr("Invalid or non-supported process unit: " + n);
        }
    }, VC = function(n) {
        return A2(el, Xb, n.cP) && 2 !== n.aL ? Yr("A ProductMassDependent process with a non-mass unit makes no sense") : Qr(n);
    }, JC = A2(Hu, function(n) {
        return A2(Qt, TC, A2(Bt, A2(Hu, VC, ys), A4(Sb, "visible", Pu, !0, A3(Wa, "unit", A2(Bt, A2(cc, ys, XC), ai), A3(Wa, "source", ai, A2(Bs, "", A3(Wa, "scopes", Cb(_E), A3(Wa, "qtyVariationRatio", GC, A3(ui, "metadata", IC, A3(Wa, "massPerUnit", zs(Vs), A3(Wa, "location", zs(ai), A3(ui, "landOccupation", Vs, A3(Wa, "impacts", n, A3(Wa, "id", yb, A3(Wa, "heatMJ", A2(Qt, sb, Vs), A3(Wa, "elecKwh", A2(Qt, Zd, Vs), A3(ui, "displayName", HC, A3(Wa, "comment", ai, A3(Wa, "categories", FC, A3(ui, "alias", HC, A3(Wa, "activityName", A2(Qt, bC, HC), nu(dC))))))))))))))))))))));
    }, Cb), YC = F6(function(n, e, r, t, u, a) {
        return {
            gh: n,
            r: e,
            mj: r,
            ek: t,
            jy: u,
            g9: a
        };
    }), WC = A3(Wa, "scopes", A2(Qt, function(n) {
        return sf(n) ? A([
            ds(2)
        ]) : n;
    }, Cb(_E)), A4(Sb, "published", Pu, !0, A3(Wa, "name", ai, A3(ui, "id", A2(Qt, ru, Ps), A3(Wa, "elements", Cb(am), A3(ui, "comment", ai, nu(YC))))))), KC = Cb(WC), BC = A2(Hu, ci(KC), $a(yt)), QC = F7(function(n, e, r, t, u, a, i) {
        return {
            q: n,
            aM: e,
            aN: r,
            E: t,
            mj: u,
            ai: a,
            at: i
        };
    }), ZC = A3(Wa, "scope", nE, A3(Wa, "label", ai, A3(Wa, "id", Bb, A3(ui, "distribution", yb, A3(Wa, "cooling", Pu, A4(Zs, "consumptions", Cb(Fb), j, A4(Zs, "assembly", Cb(yb), j, nu(QC)))))))), nI = Cb(ZC), eI = A2(Hu, ci(nI), $a(yt)), rI = function(n) {
        return n;
    }, tI = function(n) {
        return A2(as, function(e) {
            return A2(Lg, A4(nC, n.eD, n.eC, n.eE, e), A2(Lg, A2(fs, Cd, Vg(A2(wu, A2(Hu, rI, eI), A([
                n.d7,
                n.er,
                n.eW
            ])))), A2(Lg, Qr(e), A2(Lg, A5(RE, n.dT, n.d6, n.eq, n.eV, e), A2(Lg, A3(ME, n.d9, n.d8, e), A2(Lg, A2($a, yt, A2(ci, cC, n.af)), A2(Lg, A2($a, yt, A2(ci, uC, n.c_)), A2(Lg, A2($a, yt, A2(ci, function(n) {
                return Cb(function(n) {
                    return A3(Wa, "zone", sC, A4(Sb, "scopes", Cb(_E), A([
                        ls,
                        bs
                    ]), A3(Wa, "name", ai, A3(Wa, "heatProcessId", _s(n), A3(Wa, "electricityProcessId", _s(n), A3(Wa, "distanceToHub", A2(Qt, ml, Vs), A3(ui, "comment", ai, A3(Wa, "code", $s, A3(Wa, "aquaticPollutionScenario", lC, nu(fC))))))))));
                }(n));
            }(e), n.bT)), A2(Lg, A2(fs, A2(Hu, Cd, wu(pE(e))), Vg(A2(wu, A2(Hu, rI, BC), A([
                n.dS,
                n.fi,
                n.ep,
                n.eB,
                n.eU
            ])))), Qr(bE))))))))));
        }, A2($a, yt, A2(ci, JC(oC), n.W)));
    }, uI = F3(function(n, e, r) {
        var t = e.d1;
        return A2(fs, function(e) {
            return $(n, {
                h8: e,
                C: r,
                d1: t
            });
        }, A2(xl, r, n.fA.az));
    }), aI = F2(function(n, e) {
        if (ts(n) && !ts(e)) {
            var r = A2(as, A2(uI, t = e, {
                d1: !1
            }), A2(as, tI, A2(ks, "Aucune donn\xe9e brute disponible en session pour reconstruire la base de donn\xe9es", t.fA.C)));
            return 1 === r.$ ? A3(dE, "Impossible de recharger la base avec les donn\xe9es publiques", r.a, e) : r.a;
        }
        var t;
        return e;
    }), iI = F2(function(n, e) {
        var r = A2(ci, oE, n);
        return 1 === r.$ ? A2(sE, r.a, e) : A2(aI, e, $(e, {
            bH: r.a
        }));
    }), cI = gw("CN"), oI = {
        cJ: Ur,
        h_: Ur,
        by: zr(cI),
        bU: zr(cI),
        bV: zr(cI),
        cY: zr(cI),
        c0: j,
        c2: Ur,
        b6: Ur,
        c8: Ur,
        mV: Ur,
        dk: Ur,
        dl: Ur,
        P: .17,
        ft: j,
        je: Ur,
        dn: Ur,
        jr: Ur,
        $7: Ur,
        aS: "tshirt",
        hj: Ur,
        pf: Ur,
        dI: !1,
        pV: Ur
    }, fI = {
        aW: Ur,
        ap: j,
        aX: aE,
        hD: 0
    }, sI = function(n) {
        return A2(Hu, xs(A2(Hu, function(n) {
            return n.ek;
        }, zt(n))), ks("Exemple introuvable avec le nom " + n));
    }, lI = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return function($) {
                                                                                    return function(x) {
                                                                                        return function(k) {
                                                                                            return {
                                                                                                dS: n,
                                                                                                dT: e,
                                                                                                e0: r,
                                                                                                bT: t,
                                                                                                c_: u,
                                                                                                fi: a,
                                                                                                d6: i,
                                                                                                d7: c,
                                                                                                d8: o,
                                                                                                d9: f,
                                                                                                ep: s,
                                                                                                eq: l,
                                                                                                er: d,
                                                                                                W: b,
                                                                                                eB: m,
                                                                                                eC: p,
                                                                                                eD: v,
                                                                                                eE: g,
                                                                                                af: h,
                                                                                                eU: $,
                                                                                                eV: x,
                                                                                                eW: k
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, dI = F2(function(n, e) {
        var r = v(e, n);
        n: for(;;){
            e: for(;;){
                r: for(;;){
                    t: for(;;)switch(r.a.$){
                        case 3:
                            switch(r.b.$){
                                case 3:
                                    return ya((0, r.a.a)(r.b.a));
                                case 2:
                                    break n;
                                case 1:
                                    break r;
                                default:
                                    return Du;
                            }
                        case 2:
                            return ja(r.a.a);
                        case 1:
                            if (2 === r.b.$) break n;
                            break e;
                        default:
                            switch(r.b.$){
                                case 2:
                                    break n;
                                case 1:
                                    break r;
                                default:
                                    break t;
                            }
                    }
                    return Du;
                }
                return Fa;
            }
            return Fa;
        }
        return ja(r.b.a);
    }), bI = ya, mI = function(n) {
        return A2(dI, n.eW, A2(dI, n.eV, A2(dI, n.eU, A2(dI, n.af, A2(dI, n.eE, A2(dI, n.eD, A2(dI, n.eC, A2(dI, n.eB, A2(dI, n.W, A2(dI, n.er, A2(dI, n.eq, A2(dI, n.ep, A2(dI, n.d9, A2(dI, n.d8, A2(dI, n.d7, A2(dI, n.d6, A2(dI, n.fi, A2(dI, n.c_, A2(dI, n.bT, A2(dI, n.e0, A2(dI, n.dT, A2(dI, n.dS, bI(lI)))))))))))))))))))))));
    }, pI = function(n) {
        var e = mI(n);
        return 3 === e.$ ? zr(e.a) : Ur;
    }, vI = F5(function(n, e, r, t, u) {
        var a = n.c9;
        return A2(iI, a.g6, {
            kY: a.kY,
            h8: u,
            ld: JT,
            C: r,
            d1: !1,
            lR: a.lR,
            m_: a.m_,
            na: n.na,
            a1: j,
            nM: a.nM,
            an: {
                e$: Bx,
                l5: mT,
                fh: Bx,
                gR: Bx,
                oX: A2(Zg, oI, A2(fs, function(n) {
                    return n.g5;
                }, A2(sI, "Tshirt coton (150g) - Majorant par d\xe9faut", r.oX.lT))),
                f2: Bx
            },
            fA: {
                az: t,
                C: pI(e)
            },
            ol: a.ol,
            bH: fI,
            pL: a.pL
        });
    }), gI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hI = F2(function(n, e) {
        var r, t = function(n) {
            return "Impossible de charger la configuration des composants: " + n;
        };
        switch(n.$){
            case 4:
                var u = n.a, a = n.b, i = n.c;
                switch(i.$){
                    case 2:
                        return v($(e, {
                            H: Qf(t(rs(i.a)))
                        }), Cc);
                    case 1:
                    case 0:
                        return v(e, Cc);
                    default:
                        var c = i.a, o = A2(xl, u, c);
                        if (1 === o.$) return v($(e, {
                            H: Qf(t(o.a))
                        }), Cc);
                        var f = A5(vI, a, e.bz, u, c, o.a);
                        return A4(VT, a.a6, f, ns, v($(e, {
                            H: A2(Zf, f, ns)
                        }), Mu(A([
                            ts(f) ? A2(El, f, Bf) : Cc,
                            A2(Dl, f, es(a.a6))
                        ]))));
                }
            case 11:
                a = n.a;
                var s = A2(n.b, n.c, e.bz), l = function(n) {
                    var e = mI(n);
                    switch(e.$){
                        case 2:
                            return zr(Yr(function(n) {
                                return {
                                    $: 0,
                                    a: n
                                };
                            }(e.a)));
                        case 1:
                        case 0:
                            return Ur;
                        default:
                            return zr(A2($a, gI, tI(e.a)));
                    }
                }(s);
                return l.$ ? v($(e, {
                    bz: s
                }), Cc) : l.a.$ ? v($(e, {
                    bz: s,
                    H: Qf((r = l.a.a, r.$ ? "Erreur de d\xe9codage des donn\xe9es\xa0: " + r.a : "Erreur de t\xe9l\xe9chargement des donn\xe9es\xa0: " + rs(r.a)))
                }), Cc) : (u = l.a.a, v($(e, {
                    bz: s
                }), Ra({
                    lU: ka(A2(Hu, wa, A2(Kf, u, a))),
                    a6: "/data/components/config.json"
                })));
            default:
                return v(e, Cc);
        }
    }), $I = function(n) {
        return A2(Lu, $u, Cn(function() {
            try {
                tr.location = n;
            } catch (n) {
                ie.location.reload(!1);
            }
        }));
    }, xI = F2(function(n, e) {
        return v(e.a, n(e.b));
    }), kI = F2(function(n, e) {
        return $(e, {
            ac: A2(Yx, {
                az: n.h8,
                C: n.C,
                at: ds(e.iE)
            }, A2(Zx, e.iE, n))
        });
    }), jI = F2(function(n, e) {
        return $(e, {
            dx: A3(QA, n.C, n.h8, n.an.oX)
        });
    }), yI = F2(function(n, e) {
        switch(e.$){
            case 5:
                return Wl(A2(kI, n, e.a));
            case 10:
                return ed(A2(jI, n, e.a));
            default:
                return e;
        }
    }), wI = F2(function(n, e) {
        return $(e, {
            bH: n(e.bH)
        });
    }), AI = F2(function(n, e) {
        var r = e.a, t = e.b;
        if (!n) return v(r, t);
        var u = r.H;
        switch(u.$){
            case 0:
            case 1:
                return v(r, t);
            default:
                var a = u.a, i = u.b, c = function() {
                    if (0 > m(a.bH.hD, 100)) {
                        var n = a.bH.hD + 1;
                        return v(s(n, 100), A2(wI, function(e) {
                            return $(e, {
                                hD: n
                            });
                        }, a));
                    }
                    return v(!1, a);
                }();
                return v($(r, {
                    bc: r.bc || c.a,
                    H: A2(Zf, c.b, i)
                }), t);
        }
    }), TI = F3(function(n, e, r) {
        return A2(Ep, n, r);
    }), EI = function(n) {
        return {
            $: 3,
            a: n
        };
    }, CI = {
        $: 1
    }, II = {
        $: 2
    }, SI = ee("copyToClipboard", Sc), OI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, LI = F2(function(n, e) {
        return $(e, {
            a1: k(e.a1, A([
                OI(n)
            ]))
        });
    }), PI = function(n) {
        return {
            ed: 1,
            eh: n,
            ev: !1,
            eG: Ur
        };
    }, qI = function(n) {
        return $T(PI(n));
    }, NI = {
        $: 3
    }, _I = function(n) {
        return {
            $: 6,
            a: n
        };
    }, zI = function(n) {
        return $(n, {
            a1: j
        });
    }, UI = function(n) {
        return -2 === n.$;
    }, MI = F2(function(n, e) {
        return A2(aI, e, A2(wI, function(e) {
            return $(e, {
                aW: n
            });
        }, e));
    }), DI = MI(Ur), RI = function(n) {
        switch(n.$){
            case 0:
            case 1:
                return n.a;
            case 2:
                var e = n.a;
                return {
                    ip: "L'URL semble mal form\xe9e et n'a pas pu \xeatre charg\xe9e\xa0: " + e,
                    mc: Qu,
                    j4: 0,
                    eG: Ur,
                    a6: e
                };
            case 3:
                return {
                    ip: "Erreur de communication r\xe9seau. \xcates-vous connect\xe9\xa0?",
                    mc: Qu,
                    j4: 0,
                    eG: Ur,
                    a6: ""
                };
            default:
                return {
                    ip: "Le temps maximum d'attente de la r\xe9ponse a \xe9t\xe9 d\xe9pass\xe9.",
                    mc: Qu,
                    j4: 0,
                    eG: Ur,
                    a6: ""
                };
        }
    }, FI = F2(function(n, e) {
        return {
            bq: e.bq,
            bS: e.bS,
            ei: e.ei,
            ey: n(e.ey)
        };
    }), HI = F2(function(n, e) {
        return n ? qI(e) : ru;
    }), GI = function(n) {
        var e = n.nT;
        return {
            bZ: e.oW,
            aY: e.aY,
            aD: e.aD,
            aE: e.aE
        };
    }, XI = F2(function(n, e) {
        return A2(aI, e, A2(wI, function(e) {
            return $(e, {
                aW: A2(Pc, n, e.aW)
            });
        }, e));
    }), VI = F2(function(n, e) {
        return A2(Ep, n, e);
    }), JI = function(n) {
        return A2(dr, "application/json", A2(tt, 0, n));
    }, YI = F5(function(n, e, r, t, u) {
        return Da({
            kO: JI(u),
            lU: A2(Al, A2(Hu, wa, r), t),
            mc: kl(n),
            m1: "PATCH",
            oY: Ur,
            pc: Ur,
            a6: A2(Bv, n, e)
        });
    }), WI = F3(function(n, e, r) {
        return A5(YI, n, "me", e, hg, function(n) {
            return qc(A([
                v("emailOptin", _c(n.aY)),
                v("firstName", Sc(n.aD)),
                v("lastName", Sc(n.aE)),
                v("termsAccepted", _c(n.bZ))
            ]));
        }(r));
    }), KI = F3(function(n, e, r) {
        return r ? A2(ia, n, e) : ru;
    }), BI = function(n) {
        var e = "Le champ est obligatoire", r = A2(Hu, mf, su);
        return A4(KI, "lastName", e, r(n.aE), A4(KI, "firstName", e, r(n.aD), Qu));
    }, QI = F5(function(n, e, r, t, u) {
        n: for(;;)switch(t.$){
            case 8:
                return A2(Sp, A([
                    $I(_T(fd))
                ]), A2(qI, "Vous avez \xe9t\xe9 deconnect\xe9", A2(Ep, DI(n), u)));
            case 12:
                switch(t.c.$){
                    case 3:
                        var a = t.a.eS, i = t.c.a, c = A2(XI, function(n) {
                            return $(n, {
                                f1: i
                            });
                        }, n);
                        return A2(Sp, A([
                            a ? A2(Dl, n, NI) : Cc,
                            i.nT.oW && !c.d1 ? A2(El, c, _I) : Cc
                        ]), A3(HI, a, "Votre profil a \xe9t\xe9 mis \xe0 jour avec succ\xe8s", A2(Ep, c, $(u, {
                            u: A3(qp, $(e, {
                                f1: i
                            }), GI(i), Qu)
                        }))));
                    case 2:
                        var o = t.c.a;
                        return 401 === RI(o).j4 ? A2(qI, "Session invalide ou expir\xe9e, vous avez \xe9t\xe9 deconnect\xe9. Vous devrez vous reconnecter.", A2(FI, DI, A2(Ep, n, $(u, {
                            u: A2(Op, "", Du)
                        })))) : A2(Ep, A2(LI, o, n), u);
                    default:
                        break n;
                }
            case 13:
                var f = BI(r), s = $(u, {
                    u: A3(qp, e, r, f)
                });
                return UI(f) ? A2(Sp, A([
                    A3(WI, n, A2(Pp, {
                        eS: !0
                    }, e.f3), r)
                ]), A2(Ep, zI(n), s)) : A3(xT, "Erreur de sauvegarde", "Veuillez corriger les champs en erreur", A2(Ep, n, s));
            case 18:
                return A2(Ep, n, $(u, {
                    u: A3(qp, e, t.a, Qu)
                }));
            default:
                break n;
        }
        return A2(VI, n, u);
    }), ZI = function(n) {
        return {
            $: 5,
            a: n
        };
    }, nS = F3(function(n, e, r) {
        var t;
        return Da({
            kO: Aa,
            lU: (t = A2(Hu, wa, r), A2(Al, t, nu(0))),
            mc: kl(n),
            m1: "DELETE",
            oY: Ur,
            pc: Ur,
            a6: A2(Bv, n, e)
        });
    }), eS = F3(function(n, e, r) {
        return A3(nS, n, "tokens/" + e.mj, r);
    }), rS = function(n) {
        return $T(function(n) {
            return {
                ed: 2,
                eh: n,
                ev: !1,
                eG: Ur
            };
        }(n));
    }, tS = F3(function(n, e, r) {
        n: for(;;)switch(e.$){
            case 4:
                return A2(Sp, A([
                    A3(eS, n, e.a, ZI)
                ]), A2(Ep, n, r));
            case 5:
                switch(e.a.$){
                    case 3:
                        return A2(Sp, A([
                            A2(Zv, n, Lp)
                        ]), A2(rS, "Le jeton d\u2019API a \xe9t\xe9 supprim\xe9", A2(Ep, n, $(r, {
                            u: EI(Fa)
                        }))));
                    case 2:
                        return A2(Ep, A2(LI, e.a.a, n), r);
                    default:
                        break n;
                }
            default:
                break n;
        }
        return A2(VI, n, r);
    }), uS = function(n) {
        return {
            $: 1,
            a: n
        };
    }, aS = {
        $: 0
    }, iS = function(n) {
        return {
            $: 3,
            a: n
        };
    }, cS = A2(Qt, ru, ai), oS = F5(function(n, e, r, t, u) {
        return Da({
            kO: JI(u),
            lU: A2(Al, A2(Hu, wa, r), t),
            mc: kl(n),
            m1: "POST",
            oY: Ur,
            pc: Ur,
            a6: A2(Bv, n, e)
        });
    }), fS = F2(function(n, e) {
        return A5(oS, n, "tokens", e, A2(sl, A([
            "token"
        ]), cS), zu);
    }), sS = F3(function(n, e, r) {
        n: for(;;)switch(e.$){
            case 0:
                return A2(Ep, n, $(r, {
                    u: EI(e.a)
                }));
            case 2:
                return A2(Sp, A([
                    A2(fS, n, iS)
                ]), A2(Ep, n, r));
            case 3:
                switch(e.a.$){
                    case 3:
                        var t = e.a.a;
                        return A2(Sp, A([
                            A2(Zv, n, Lp),
                            A2(Dl, n, aS)
                        ]), A2(Ep, n, $(r, {
                            u: uS(t)
                        })));
                    case 2:
                        return A2(Ep, A2(LI, e.a.a, n), r);
                    default:
                        break n;
                }
            case 16:
                if (3 === e.a.$) return A2(Sp, A([
                    A2(Zv, n, Lp)
                ]), A2(Ep, n, $(r, {
                    u: EI(Fa)
                })));
                break n;
            default:
                break n;
        }
        return A2(VI, n, r);
    }), lS = F2(function(n, e) {
        var r = A2(as, A2(uI, e, {
            d1: !0
        }), A2(as, function(e) {
            return tI($(e, {
                W: Ga(n)
            }));
        }, A2(ks, "Aucune donn\xe9e brute disponible en session pour reconstruire la base de donn\xe9es", e.fA.C)));
        return 1 === r.$ ? A3(dE, "Impossible de recharger la db avec les nouveaux proc\xe9d\xe9s", r.a, e) : r.a;
    }), dS = function(n) {
        return {
            $: 10,
            a: n
        };
    }, bS = function(n) {
        return {
            $: 6,
            a: n
        };
    }, mS = F3(function(n, e, r) {
        return A5(oS, n, "access/magic_link/login", e, nu(0), qc(A([
            v("email", Sc(r))
        ])));
    }), pS = F5(function(n, e, r, t, u) {
        n: for(;;)switch(t.$){
            case 10:
                switch(t.a.$){
                    case 3:
                        return A2(Ep, n, $(u, {
                            u: bS(e)
                        }));
                    case 2:
                        return A2(Ep, A2(LI, t.a.a, n), u);
                    default:
                        break n;
                }
            case 11:
                return A2(Sp, A([
                    A3(mS, n, dS, mf(e))
                ]), A2(Ep, n, $(u, {
                    u: A2(Op, e, Fa)
                })));
            case 17:
                return A2(Ep, n, $(u, {
                    u: A2(Op, t.a, r)
                }));
            default:
                break n;
        }
        return A2(VI, n, u);
    }), vS = function(n) {
        return {
            $: 7,
            a: n
        };
    }, gS = F4(function(n, e, r, t) {
        return A4(Qv, n, "access/login?email=" + r + "&token=" + t, e, BT);
    }), hS = F3(function(n, e, r) {
        return Da({
            kO: Aa,
            lU: A2(Al, A2(Hu, wa, e), hg),
            mc: A([
                A2(mi, "Authorization", "Bearer " + r)
            ]),
            m1: "GET",
            oY: Ur,
            pc: Ur,
            a6: n.kY + "/backend/api/me"
        });
    }), $S = F5(function(n, e, r, t, u) {
        n: for(;;)switch(t.$){
            case 7:
                switch(t.a.$){
                    case 3:
                        return A2(Sp, A([
                            A3(hS, n, A2(Pp, {
                                eS: !1
                            }, i = t.a.a), i.kv)
                        ]), A2(Ep, n, $(u, {
                            u: A2(wT, e, r)
                        })));
                    case 2:
                        var a = t.a.a;
                        return A2(Sp, A([
                            $I(_T(fd))
                        ]), A2(Ep, Nl(n) && 403 === RI(a).j4 ? n : A2(LI, a, n), u));
                    default:
                        break n;
                }
            case 9:
                return A2(Sp, A([
                    A4(gS, n, vS, e, r)
                ]), A2(Ep, n, u));
            case 12:
                switch(t.c.$){
                    case 3:
                        var i, c = t.c.a, o = A2(MI, zr({
                            f3: i = t.b,
                            f1: c
                        }), n), f = ts(o);
                        return A2(Sp, A([
                            f ? A2(El, o, _I) : A2(AT, o.na, _T(fd))
                        ]), A3(HI, !f, "Vous devez valider les CGU Ecoinvent/Base Empreinte pour avoir acc\xe8s aux impacts d\xe9taill\xe9s", A2(Ep, o, $(u, {
                            j$: !f,
                            u: A3(qp, {
                                f3: i,
                                f1: c
                            }, GI(c), Qu)
                        }))));
                    case 2:
                        return a = t.c.a, A2(Sp, A([
                            $I(_T(fd))
                        ]), A2(Ep, A2(LI, a, n), u));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return A2(VI, n, u);
    }), xS = {
        $: 4
    }, kS = function(n) {
        return {
            $: 8,
            a: n
        };
    }, jS = function(n) {
        return {
            $: 14,
            a: n
        };
    }, yS = F3(function(n, e, r) {
        var t;
        return A5(oS, n, "access/magic_link/signup", e, hg, qc(A([
            v("email", Sc((t = r).c4)),
            v("emailOptin", _c(t.aY)),
            v("firstName", Sc(t.aD)),
            v("lastName", Sc(t.aE)),
            v("organization", wo(t.cq)),
            v("termsAccepted", _c(t.bZ))
        ])));
    }), wS = F3(function(n, e, r) {
        return 1 === e.$ ? A4(KI, n, e.a, !0, r) : r;
    }), AS = function(n) {
        switch(n.$){
            case 0:
            case 1:
            case 2:
            case 4:
            case 5:
            case 6:
            default:
                return zr(n.a);
            case 3:
                return Ur;
        }
    }, TS = ru, ES = function(n) {
        return A4(KI, "email", "L'adresse e-mail est invalide", A2(Nc, !1, A2(Pc, function(e) {
            return !A2(As, e, n);
        }, Es("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"))), Qu);
    }, CS = function(n) {
        var e, r = "Le champ est obligatoire", t = A2(Hu, mf, su);
        return A4(KI, "termsAccepted", "Les CGU doivent \xeatre accept\xe9es", !n.oW, A3(wS, "organization.siren", 1 === (e = n.cq).$ ? dg(e.b) : Qr(TS("")), A4(KI, "organization.name", r, A2(Nc, !1, A2(Pc, t, AS(n.cq))), A4(KI, "lastName", r, t(n.aE), A4(KI, "firstName", r, t(n.aD), ES(n.c4))))));
    }, IS = F5(function(n, e, r, t, u) {
        n: for(;;)switch(t.$){
            case 14:
                switch(t.a.$){
                    case 3:
                        return A2(Sp, A([
                            A2(Dl, n, xS)
                        ]), A2(Ep, n, $(u, {
                            u: kS(e.c4)
                        })));
                    case 2:
                        return A2(Ep, A2(LI, t.a.a, n), $(u, {
                            u: A3(MT, e, Qu, Du)
                        }));
                    default:
                        break n;
                }
            case 15:
                var a = CS(e);
                return UI(a) ? A2(Sp, A([
                    A3(yS, n, jS, e)
                ]), A2(Ep, zI(n), $(u, {
                    u: A3(MT, e, a, Fa)
                }))) : A3(xT, "Erreur de sauvegarde", "Veuillez corriger les champs en erreur", A2(Ep, n, $(u, {
                    u: A3(MT, e, a, Du)
                })));
            case 19:
                return A2(Ep, n, $(u, {
                    u: A3(MT, t.a, Qu, r)
                }));
            default:
                break n;
        }
        return A2(VI, n, u);
    }), SS = F3(function(n, e, r) {
        n: for(;;)switch(e.$){
            case 1:
                return A2(qI, "Le jeton d\u2019API a \xe9t\xe9 copi\xe9 dans le presse-papiers", A2(Sp, A([
                    SI(e.a)
                ]), A2(Ep, n, r)));
            case 6:
                switch(e.a.$){
                    case 3:
                        var t = A2(lS, e.a.a, n);
                        return A2(Sp, A([
                            A2(AT, t.na, _T(fd)),
                            A2(Dl, n, CI)
                        ]), A2(Ep, t, $(r, {
                            j$: !0
                        })));
                    case 2:
                        return A2(Ep, A2(LI, e.a.a, n), r);
                    default:
                        break n;
                }
            case 16:
                switch(e.a.$){
                    case 0:
                        return A2(Sp, A([
                            A2($g, n, A2(Pp, {
                                eS: !1
                            }, (i = e.a.a).f3))
                        ]), A2(Ep, n, $(r, {
                            u: A3(qp, i, Np, Qu)
                        })));
                    case 3:
                        return A2(Sp, A([
                            A2(Zv, n, Lp)
                        ]), A2(Ep, n, $(r, {
                            u: EI(Fa)
                        })));
                    default:
                        return A2(Ep, n, $(r, {
                            u: e.a
                        }));
                }
            default:
                break n;
        }
        var u = e, a = r.u;
        switch(a.$){
            case 0:
                var i;
                return A5(QI, n, i = a.a, a.b, u, r);
            case 1:
                return A2(Ep, n, r);
            case 2:
                return A3(tS, n, u, r);
            case 3:
                return A3(sS, n, u, r);
            case 4:
                return A5(pS, n, a.a, a.b, u, r);
            case 5:
                return A5($S, n, a.a, a.b, u, r);
            case 6:
                return A2(Sp, A([
                    A2(Dl, n, II)
                ]), A2(Ep, n, r));
            case 7:
                return A5(IS, n, a.a, a.c, u, r);
            default:
                return A2(VI, n, r);
        }
    }), OS = F3(function(n, e, r) {
        return A2(Ep, n, $(r, {
            h9: e
        }));
    }), LS = function(n) {
        switch(n.$){
            case 0:
                return A2(Cm, n.a, Ur);
            case 1:
                return Im(Ur);
            case 2:
                return kd(Ur);
            case 3:
                return Sm(Ur);
            case 4:
                return A2(jd, n.a, Ur);
            case 5:
                return Om(Ur);
            case 6:
                return A2(Lm, n.a, Ur);
            case 7:
                return A2(Pm, n.a, Ur);
            case 8:
                return yd(Ur);
            case 9:
                return qm(Ur);
            default:
                return Nm(Ur);
        }
    }, PS = ee("scrollIntoView", Sc), qS = A2(Hu, ym, fs(ru)), NS = A2(Hu, ym, fs(ru)), _S = A2(Hu, ym, fs(ru)), zS = A2(Hu, ym, fs(ru)), US = F2(function(n, e) {
        switch(e.$){
            case 0:
                return A2(Cm, e.a, Ld(qS(n)));
            case 1:
                return Im(zr(gw(n)));
            case 2:
                return kd(Ld(ym(n)));
            case 3:
                return Sm(Ld(_S(n)));
            case 4:
                return A2(jd, e.a, Ld(ym(n)));
            case 5:
                return Om(Ld(km(n)));
            case 6:
                return A2(Lm, e.a, Ld(qE(n)));
            case 7:
                return A2(Pm, e.a, Ld(NS(n)));
            case 8:
                return yd(Ld(ym(n)));
            case 9:
                return qm(Ld(zS(n)));
            default:
                return Nm(zr(n));
        }
    }), MS = F3(function(n, e, r) {
        return A2(Lu, $u, A3(yr, n, e, r));
    }), DS = function(n) {
        return 1 === n.$ ? zr(n.a) : Ur;
    }, RS = function(n) {
        switch(n.$){
            case 0:
            case 3:
                return 1;
            case 1:
            case 4:
                return 2;
            case 2:
            case 5:
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
            case 9:
                return n.a;
            default:
                return wr(n.a);
        }
    }, FS = F3(function(n, e, r) {
        switch(n.$){
            case 0:
                return A3(Ar, e, r, n.a);
            case 1:
                return A4(Tr, e, r, n.b, !n.a);
            case 2:
                return A4(Er, e, r, n.b, !n.a);
            case 3:
                return A3(Cr, e, r, n.a);
            case 4:
                return A4(Ir, e, r, n.b, !n.a);
            case 5:
                return A4(Sr, e, r, n.b, !n.a);
            case 6:
                return A4(Or, e, r, n.b, !n.a);
            case 7:
                return A4(Lr, e, r, n.b, !n.a);
            case 8:
                return A3(HS, n.b, e, r);
            case 9:
                return A3(qr, e, r, n.b);
            default:
                return A3(Pr, e, r, n.a);
        }
    }), HS = F3(function(n, e, r) {
        for(;;){
            if (!n.b) return r;
            var t = n.b, u = e, a = A3(FS, n.a, e, r);
            n = t, e = u, r = a;
        }
    }), GS = F2(function(n, e) {
        return A2(Nr, n, e);
    }), XS = {
        f9: !0,
        e9: ","
    }, VS = function(n) {
        var e = new DataView(new ArrayBuffer(RS(n)));
        return FS(n)(e)(0), e;
    }, JS = F2(function(n, e) {
        return {
            $: 9,
            a: n,
            b: e
        };
    }), YS = function(n) {
        return A2(JS, function(n) {
            for(var e = 0, r = 0; n.length > r; r++){
                var t = n.charCodeAt(r);
                e += 128 > t ? 1 : 2048 > t ? 2 : 55296 > t || t > 56319 ? 3 : (r++, 4);
            }
            return e;
        }(n), n);
    }, WS = YS("\r\n"), KS = A2(Hu, it('"'), at('""')), BS = F2(function(n, e) {
        return n.f9 || A2(au, n.e9, e) ? '"' + KS(e) + '"' : KS(e);
    }), QS = F2(function(n, e) {
        if (e.b) {
            var r = e.b;
            return A2(Mr, e.a, A3(yu, F2(function(e, r) {
                return A2(Mr, n, A2(Mr, e, r));
            }), j, r));
        }
        return j;
    }), ZS = F2(function(n, e) {
        return {
            $: 8,
            a: n,
            b: e
        };
    }), nO = F2(function(n, e) {
        for(;;){
            if (!e.b) return n;
            var r = e.b;
            n += RS(e.a), e = r;
        }
    }), eO = function(n) {
        return A2(ZS, A2(nO, 0, n), n);
    }, rO = function(n) {
        return A2(Hu, wu(function(n) {
            var e = n.e9;
            return A2(Hu, wu(BS(n)), A2(Hu, QS(e), A2(Hu, wu(YS), eO)));
        }(n)), A2(Hu, QS(WS), eO));
    }, tO = F2(function(n, e) {
        return eO(A([
            A2(rO, n, A2(Mr, e.mc, e.n$)),
            WS
        ]));
    }), uO = function(n) {
        return A2(Hu, tO(n), VS);
    }, aO = wr, iO = F2(function(n, e) {
        var r, t = A2(uO, n, e), u = A2(GS, (r = aO(t), _r(r)), t);
        return u.$ ? cO()(e) : u.a;
    });
    function cO() {
        return iO(XS);
    }
    var oO = cO();
    cO = function() {
        return oO;
    };
    var fO, sO, lO, dO = F2(function(n, e) {
        return A2(ba, n, e);
    }), bO = F3(function(n, e, r) {
        return A2(ma, n, A2(Hu, Nc(aE), A2(Hu, r ? iE(e) : dO(e), zr)));
    }), mO = F3(function(n, e, r) {
        switch(e.$){
            case 0:
                return A2(wg, n, $(r, {
                    aA: LS(r.aA)
                }));
            case 1:
                return A2(Sp, A([
                    A3(MS, e.a, "text/csv", oO(e.b))
                ]), A2(wg, n, r));
            case 2:
                return A2(wg, n, $(r, {
                    aA: A2(US, e.a, r.aA)
                }));
            case 3:
                var t = e.a;
                return A2(Sp, A([
                    A2(AT, n.na, _T(A2(bd, t, function() {
                        switch(r.aA.$){
                            case 1:
                                return Im(Ur);
                            case 5:
                                return Om(Ur);
                            case 6:
                                return A2(Lm, t, Ur);
                            case 7:
                                var n = DS(t);
                                return n.$ ? wd(t) : A2(Pm, n.a, Ur);
                            default:
                                return wd(t);
                        }
                    }())))
                ]), A2(wg, n, $(r, {
                    c7: Qu,
                    at: t
                })));
            case 4:
                return A2(wg, n, $(r, {
                    fQ: e.a
                }));
            case 5:
                var u = e.a, a = e.b, i = e.c;
                return A2(Sp, A([
                    i ? PS(A3(Yb, "{key}", u, '[data-scroll-id="{key}"] label:first-child')) : Cc
                ]), A2(wg, n, $(r, {
                    c7: A4(bO, u, a, i, r.c7)
                })));
            default:
                return A2(wg, n, $(r, {
                    du: e.a
                }));
        }
    }), pO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vO = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), gO = function(n) {
        return {
            $: 2,
            a: n
        };
    }, hO = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), $O = function(n) {
        return {
            $: 5,
            a: n
        };
    }, xO = {
        $: 2
    }, kO = function(n) {
        return {
            $: 6,
            a: n
        };
    }, jO = F2(function(n, e) {
        return {
            $: 7,
            a: n,
            b: e
        };
    }), yO = function(n) {
        return {
            $: 11,
            a: n
        };
    }, wO = F2(function(n, e) {
        return {
            $: 12,
            a: n,
            b: e
        };
    }), AO = {
        $: 13
    }, TO = function(n) {
        return {
            $: 14,
            a: n
        };
    }, EO = function(n) {
        return {
            $: 15,
            a: n
        };
    }, CO = function(n) {
        return {
            $: 16,
            a: n
        };
    }, IO = F3(function(n, e, r) {
        return {
            $: 29,
            a: n,
            b: e,
            c: r
        };
    }), SO = function(n) {
        return {
            $: 6,
            a: n
        };
    }, OO = F2(function(n, e) {
        return {
            $: 14,
            a: n,
            b: e
        };
    }), LO = function(n) {
        return $(n, {
            fX: A2(Pc, function(e) {
                var r;
                return $(e, {
                    P: (r = n.mq, ah(A2(wu, function(n) {
                        return n.P;
                    }, r)))
                });
            }, n.fX)
        });
    }, PO = F2(function(n, e) {
        return LO($(e, {
            mq: k(e.mq, A([
                n
            ]))
        }));
    }), qO = F2(function(n, e) {
        return $(e, {
            cs: k(e.cs, A([
                n
            ]))
        });
    }), NO = F2(function(n, e) {
        return $(e, {
            bk: k(e.bk, A([
                n
            ]))
        });
    }), _O = F3(function(n, e, r) {
        var t = r.bq, u = r.ei, a = r.ey;
        return A2(Sp, A([
            r.bS
        ]), A2(hT, t, A3(n, a, e, u)));
    }), zO = F2(function(n, e) {
        return A3(Di, F3(function(e, r, t) {
            return A2(n, e, r) ? A3(ia, e, r, t) : t;
        }), Qu, e);
    }), UO = F2(function(n, e) {
        var r = e;
        return A2(zO, F2(function(e) {
            return n(e);
        }), r);
    }), MO = function(n) {
        return UI(n);
    }, DO = A2(Hu, LA(A2(Hu, function(n) {
        return n.gn;
    }, Qc)), xt), RO = function(n) {
        return vs(function(n) {
            var e = n.g5;
            switch(e.$){
                case 0:
                    return ls;
                case 1:
                    return ds(e.a);
                default:
                    return bs;
            }
        }(n)) + ":" + n.ek;
    }, FO = wI(function(n) {
        var e = n.ap, r = n.aX;
        return $(n, {
            aX: MO(r) ? cE(A2(wu, RO, DO(e))) : A2(UO, function(n) {
                return A2(el, n, A2(wu, RO, e));
            }, r)
        });
    }), HO = function(n) {
        return n.h3;
    }, GO = function(n) {
        switch(n){
            case 0:
                return "Impacts";
            case 1:
                return "\xc9tapes";
            case 2:
                return "Sous-scores";
            default:
                return "Total";
        }
    }, XO = function(n) {
        return {
            j: 2 === n.aL ? .1 : 1,
            mj: n.mj
        };
    }, VO = function(n) {
        return wI(function(e) {
            return $(e, {
                ap: A2(Ah, Ic(n), e.ap)
            });
        });
    }, JO = F2(function(n, e) {
        return LO($(e, {
            mq: A2(Ah, A2(Hu, function(n) {
                return n.mj;
            }, Ic(n)), e.mq)
        }));
    }), YO = F2(function(n, e) {
        return $(e, {
            cs: A2(Ah, A2(Hu, function(n) {
                return n.mj;
            }, Ic(n)), e.cs)
        });
    }), WO = F2(function(n, e) {
        return $(e, {
            bk: A2(Ah, Ic(n), e.bk)
        });
    }), KO = ee("exportBookmarks", function() {
        return zu;
    }), BO = Sn, QO = F2(function(n, e) {
        return Ou(A2(BO, A2(cc, A2(cc, xu, n), Yr), A2(Au, A2(cc, A2(cc, xu, n), Qr), e)));
    }), ZO = ir("focus"), nL = function(n) {
        return A2(QO, Wi(n), ZO("element-search"));
    }, eL = A2(Hu, function(n) {
        return n.W;
    }, A2(Hu, Fh(UC), A2(Hu, Rh(A([
        ls
    ])), LA(Gb)))), rL = ee("importBookmarks", function() {
        return zu;
    }), tL = ee("loadCharts", function() {
        return zu;
    }), uL = function(n) {
        return dA(zt(n));
    }, aL = F3(function(n, e, r) {
        return Cd(A([
            A2(Hc, n, r),
            A([
                e
            ]),
            A2($x, n, r)
        ]));
    }), iL = F2(function(n, e) {
        return A3(ot, Mr, e, n);
    }), cL = F4(function(n, e, r, t) {
        for(;;){
            if (!r.b) return n;
            var u = r.a, a = r.b;
            if (s(e, u)) return A2(iL, t, a);
            r = a, t = A2(Mr, u, t);
        }
    }), oL = F2(function(n, e) {
        return A4(cL, e, n, e, j);
    }), fL = F3(function(n, e, r) {
        var t = A2(uL, e, r);
        return t.$ ? r : A3(aL, t.a, n, A2(oL, n, r));
    }), sL = F2(function(n, e) {
        return wI(function(r) {
            return $(r, {
                ap: A3(fL, n, e, r.ap)
            });
        });
    }), lL = function(n) {
        return {
            mj: n.mj,
            P: hb(100)
        };
    }, dL = F3(function(n, e, r) {
        return A2(wu, function(r) {
            return n(r) ? e(r) : r;
        }, r);
    }), bL = function(n) {
        return A2(dL, A2(Hu, function(n) {
            return n.g5;
        }, zt(n.g5)), Wi(n));
    }, mL = function(n) {
        return wI(function(e) {
            return $(e, {
                ap: A2(bL, n, e.ap)
            });
        });
    }, pL = function(n) {
        return wI(function(e) {
            return $(e, {
                ap: A2(Mr, n, e.ap)
            });
        });
    }, vL = wI(function(n) {
        return $(n, {
            aX: cE(A2(wu, RO, n.ap))
        });
    }), gL = wI(function(n) {
        return $(n, {
            aX: aE
        });
    }), hL = function(n) {
        var e = n;
        return A2(Ba, q$, A2(Pc, function(n) {
            return A2($x, n, e.h3);
        }, e.ox));
    }, $L = F3(function(n, e, r) {
        return e ? A2(Dl, n, r) : Cc;
    }), xL = F2(function(n, e) {
        return $(e, {
            E: zr(n)
        });
    }), kL = F2(function(n, e) {
        return $(e, {
            fX: zr(n)
        });
    }), jL = function(n) {
        switch(n){
            case 0:
                return "Impacts";
            case 1:
                return "\xc9tapes";
            default:
                return "Sous-scores";
        }
    }, yL = F2(function(n, e) {
        return wI(function(r) {
            return $(r, {
                aX: A2(e ? iE : dO, RO(n), r.aX)
            });
        });
    }), wL = function(n) {
        return Ah(function(e) {
            return !A2(el, e.mj, n);
        });
    }, AL = function(n) {
        return {
            $: 1,
            a: n
        };
    }, TL = function(n) {
        return {
            $: 2,
            a: n
        };
    }, EL = {
        $: 3
    }, CL = {
        $: 1
    }, IL = function(n) {
        return {
            $: 2,
            a: n
        };
    }, SL = F2(function(n, e) {
        return 0 > e ? n - 1 : m(e, n) > -1 ? 0 : e;
    }), OL = F3(function(n, e, r) {
        if (0 >= n) return Ur;
        var t = v(e, r);
        switch(t.b){
            case 0:
                return zr(1 === t.a.$ ? n - 1 : A2(SL, n, t.a.a - 1));
            case 1:
                return zr(1 === t.a.$ ? 0 : A2(SL, n, t.a.a + 1));
            default:
                return e;
        }
    }), LL = function(n) {
        return {
            $: 1,
            a: n
        };
    }, PL = Dn, qL = F2(function(n, e) {
        return A2(Lu, function() {
            return e;
        }, PL(n));
    }), NL = F3(function(n, e, r) {
        var t = r, u = $(t, {
            bd: A2(Mr, e, t.bd)
        }), a = function() {
            var e = n.oL;
            switch(e.$){
                case 0:
                    var r = e.a;
                    return t.ef ? Cc : A2(qL, r, LL(Ur));
                case 1:
                    r = e.a;
                    var a = e.b;
                    return t.ef ? Cc : A2(qL, r, LL(zr(a)));
                default:
                    return A2(qL, a = e.a, function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(function(n) {
                        return ft(n.bd);
                    }(u)));
            }
        }();
        return v(u, A2(FT, n.fX, a));
    }), _L = F3(function(n, e) {
        return v(j, n(e));
    }), zL = F4(function(n, e, r, t) {
        var u = t;
        switch(r.$){
            case 0:
                return v(u, Cc);
            case 1:
                var a = r.a, i = u.bd;
                if (i.b) {
                    var c = i.a, o = i.b, f = function() {
                        if (a.$) return Cc;
                        var n = a.a;
                        return A2(qL, n, LL(zr(n)));
                    }(), s = A2(e, c, o), l = s.b;
                    return v($(u, {
                        bd: s.a,
                        ef: !0
                    }), Mu(A([
                        l,
                        A2(FT, n.fX, f)
                    ])));
                }
                return v($(u, {
                    ef: !1
                }), Cc);
            default:
                var d = r.a, b = v(1 > m(ft(u.bd), d), u.bd);
                if (b.a && b.b.b) {
                    var p = b.b, g = A2(e, c = p.a, o = p.b), h = g.b;
                    return v($(u, {
                        bd: g.a
                    }), h);
                }
                return v(u, Cc);
        }
    }), UL = F2(function(n, e) {
        var r = e;
        switch(n.$){
            case 0:
                var t = n.a, u = A3(NL, r.e6, t, r.cZ), a = u.b;
                return v($(r, {
                    cZ: u.a,
                    g5: t,
                    ox: Ur,
                    dL: CL
                }), a);
            case 6:
                var i = n.a, c = A4(zL, r.e6, _L(function(n) {
                    return A2(Lu, AL, xu({
                        h3: r.h3,
                        mk: r.mk,
                        g5: n
                    }));
                }), i, r.cZ);
                return a = c.b, v($(r, {
                    cZ: c.a
                }), a);
            case 1:
                return v(r, A2(QO, IL, r.ff(o = n.a)));
            case 2:
                var o, f = n.a;
                return 1 === f.$ ? v($(r, {
                    dL: TL(f.a)
                }), Cc) : s((o = f.a).g5, r.g5) ? v($(r, {
                    h3: A2(Ah, function(n) {
                        return !A2(el, n, o.mk);
                    }, o.h3),
                    mk: o.mk,
                    dL: EL
                }), Cc) : v(r, Cc);
            case 3:
                var l = n.a;
                return v($(r, {
                    ox: A3(OL, ft(r.h3), r.ox, l)
                }), Cc);
            case 4:
                return v($(r, {
                    ej: zr(n.a)
                }), Cc);
            default:
                var d = n.a;
                return s(r.ej, zr(d)) ? v($(r, {
                    ej: Ur,
                    ox: zr(d)
                }), Cc) : v(r, Cc);
        }
    }), ML = F2(function(n, e) {
        return $(e, {
            E: zr(A2(Zg, tb, ib(n)))
        });
    }), DL = F3(function(n, e, r) {
        return LO($(r, {
            mq: A2(wu, function(r) {
                return s(r.mj, n) ? e : r;
            }, r.mq)
        }));
    }), RL = F3(function(n, e, r) {
        return $(r, {
            cs: A2(wu, function(r) {
                return s(r.mj, n) ? e : r;
            }, r.cs)
        });
    }), FL = F3(function(n, e, r) {
        return $(r, {
            bk: A2(wu, function(r) {
                return s(r, n) ? e : r;
            }, r.bk)
        });
    }), HL = F2(function(n, e) {
        var r = e.ey, t = $(e.ei, {
            bx: A2(nh, r, n)
        });
        return $(e, {
            ei: t,
            ey: A2(rh, n, r)
        });
    }), GL = F2(function(n, e) {
        return $(e, {
            fX: zr(n)
        });
    }), XL = F2(function(n, e) {
        return n ? Sp(A([
            e
        ])) : ru;
    }), VL = F3(function(n, e, r) {
        var t = r.ad;
        switch(t.$){
            case 0:
                return A5(ZL, n, r, e, t.a, t.b);
            case 1:
                return A5(nP, n, r, e, t.a, t.b);
            case 6:
                return A2(JL, t.a, A2(Eg, e, r));
            default:
                return A2(Eg, e, r);
        }
    }), JL = F2(function(n, e) {
        var r = function(n) {
            return {
                $: 12,
                a: n
            };
        }(A2(Nc, mT, hL(n)));
        return A2(Sp, A([
            A2(Dl, e.ey, yO(ls))
        ]), A3(KL, e.ey, r, e.ei));
    }), YL = F2(function(n, e) {
        var r = A2(Nc, q$(HO(n)), A2(Pc, zr, hL(n)));
        return A3(KL, e.ey, A2(Nc, AO, A2(Pc, pO, r)), e.ei);
    }), WL = F2(function(n, e) {
        var r = A2(Nc, q$(HO(n)), A2(Pc, zr, hL(n)));
        return A3(KL, e.ey, A2(Nc, AO, A2(Pc, gO, r)), e.ei);
    }), KL = F3(function(n, e, r) {
        var t, u = n.C, a = n.an.l5, i = F2(function(e, t) {
            return A2(Nc, A2(Eg, n, r), A2(Pc, function(t) {
                return A2(HL, e(t), A2(Eg, n, r));
            }, t));
        });
        switch(e.$){
            case 0:
                return A2(HL, A2(xL, tb, a), A2(Eg, n, r));
            case 1:
                return A2(HL, A2(PO, {
                    i: Ur,
                    mj: (t = e.a).mj,
                    P: hb(100),
                    jo: _g(t)
                }, a), A3(_O, KL, kc(xc), A2(Eg, n, r)));
            case 2:
                return A2(HL, A2(qO, XO(e.a), a), A3(_O, KL, kc(xc), A2(Eg, n, r)));
            case 3:
                return A2(i, function(n) {
                    return A2(NO, n.mj, a);
                }, q$(A2(wL, a.bk, lb)));
            case 4:
                var c = ah(A2(wu, function(n) {
                    return n.P;
                }, a.mq));
                return A2(i, function(n) {
                    return A2(kL, n, a);
                }, A2(Pc, A2(Hu, lL, function(n) {
                    return $(n, {
                        P: c
                    });
                }), q$(eL(u))));
            case 5:
                return A2(Sp, A([
                    SI(e.a)
                ]), A2(Eg, n, r));
            case 6:
                return A2(FI, VO(e.a), A2(HL, a, A2(Eg, n, r)));
            case 7:
                return A2(HL, A2(JO, e.a, a), A2(Eg, n, r));
            case 8:
                return A2(HL, A2(YO, e.a, a), A2(Eg, n, r));
            case 9:
                return A2(HL, A2(WO, e.a, a), A2(Eg, n, r));
            case 10:
                return A2(Sp, A([
                    KO(0)
                ]), A2(Eg, n, r));
            case 11:
                return A2(Sp, A([
                    rL(0)
                ]), A2(Eg, n, r));
            case 12:
                var o = e.a, f = $(r, {
                    dd: o
                });
                return A2(HL, o, A3(_O, KL, kc(xc), A2(Eg, n, f)));
            case 13:
                return A2(Eg, n, r);
            case 14:
                var s = e.a, l = r.ad;
                if (6 === l.$) {
                    var d = A2(UL, s, l.a), b = d.a;
                    return A2(Sp, A([
                        A2(FT, TO, d.b)
                    ]), A2(Eg, n, $(r, {
                        ad: SO(b)
                    })));
                }
                return A2(Eg, n, r);
            case 15:
                s = e.a;
                var m = r.ad;
                if (m.$) return A2(Eg, n, r);
                var p = m.a, v = A2(UL, s, m.b);
                return b = v.a, A2(Sp, A([
                    A2(FT, EO, v.b)
                ]), A2(Eg, n, $(r, {
                    ad: A2(vO, p, b)
                })));
            case 16:
                s = e.a;
                var g = r.ad;
                if (1 === g.$) {
                    var h = g.a, x = A2(UL, s, g.b);
                    return b = x.a, A2(Sp, A([
                        A2(FT, CO, x.b)
                    ]), A2(Eg, n, $(r, {
                        ad: A2(hO, h, b)
                    })));
                }
                return A2(Eg, n, r);
            case 17:
                return A3(VL, a, n, r);
            case 18:
                return A2(Eg, n, $(r, {
                    bv: Ur
                }));
            case 19:
                return A2(Eg, n, $(r, {
                    bv: zr(e.a)
                }));
            case 20:
                return A2(Eg, n, $(r, {
                    cN: zr(e.a)
                }));
            case 21:
                var k = e.a, j = r.cN;
                return j.$ ? A2(Eg, n, r) : A2(Eg, A3(sL, j.a, k, n), $(r, {
                    cN: Ur,
                    bv: Ur
                }));
            case 22:
                return A2(Sp, A([
                    PS("#" + e.a)
                ]), A2(Eg, n, r));
            case 23:
                return A2(Sp, A([
                    A2(Dl, n, kO(ls)),
                    tL(0)
                ]), A2(Eg, FO(n), $(r, {
                    ad: xO
                })));
            case 24:
                var y = r.bw;
                return y.$ ? A2(Eg, n, r) : A2(Eg, A2(mL, y.a, n), $(r, {
                    bw: Ur
                }));
            case 25:
                return A2(HL, r.dd, A2(Eg, n, r));
            case 26:
                return A2(HL, function(n) {
                    return $(n, {
                        E: Ur
                    });
                }(a), A2(Eg, n, r));
            case 27:
                return A2(HL, function(n) {
                    return $(n, {
                        fX: Ur
                    });
                }(a), A2(Eg, n, r));
            case 28:
                return A2(Sp, A([
                    A2(Lu, A2(IO, r.bx, Cg(a)), ac),
                    A2(Dl, n, $O(ls))
                ]), A2(Eg, n, r));
            case 29:
                var w = e.b;
                return A2(Eg, A2(pL, {
                    gn: e.c,
                    iE: Ur,
                    ek: mf(e.a),
                    g5: w
                }, n), r);
            case 30:
                return A2(Eg, vL(n), r);
            case 31:
                return A2(Eg, gL(n), r);
            case 32:
                var T = e.a;
                return A3(XL, function(n) {
                    switch(n.$){
                        case 0:
                        case 1:
                        case 6:
                            return !0;
                        default:
                            return !1;
                    }
                }(T), nL(AO), A2(Eg, n, $(r, {
                    ad: T
                })));
            case 33:
                var E = e.a;
                return A2(Sp, A([
                    A3($L, n, 2 === E, A2(OO, ls, "Partager"))
                ]), A2(Eg, n, $(r, {
                    dW: E
                })));
            case 34:
                var C = e.a;
                return A2(Sp, A([
                    A2(Dl, n, A2(jO, ls, GO(C)))
                ]), A2(Eg, n, $(r, {
                    cT: C
                })));
            case 35:
                if (e.a.$) return A3(xT, "Erreur de s\xe9lection d'impact", e.a.a, A2(Eg, n, r));
                var I = e.a.a;
                return A2(Sp, A([
                    A2(AT, n.na, _T(A2(md, I, zr(a)))),
                    A2(Dl, n, A2(wO, ls, I))
                ]), A2(Eg, n, r));
            case 36:
                var S = e.a;
                return A2(Sp, A([
                    A2(Dl, n, A2(OO, ls, jL(S)))
                ]), A2(Eg, n, $(r, {
                    dN: S
                })));
            case 37:
                return A2(Eg, A3(yL, e.a, e.b, n), r);
            case 38:
                return A2(Eg, n, $(r, {
                    bx: e.a
                }));
            case 39:
                return A2(HL, A2(ML, e.a, a), A2(Eg, n, r));
            case 40:
                return A2(HL, A3(DL, e.a.mj, e.b, a), A2(Eg, n, r));
            case 41:
                return A2(HL, A3(RL, e.a, e.b, a), A2(Eg, n, r));
            case 42:
                return A2(HL, A3(FL, e.a, e.b, a), A2(Eg, n, r));
            case 43:
                return A2(Eg, n, $(r, {
                    bw: zr($(e.a, {
                        ek: e.b
                    }))
                }));
            default:
                return A2(HL, A2(GL, e.a, a), A2(Eg, n, r));
        }
    }), BL = F5(function(n, e, r, t, u) {
        var a = {
            i: Ur,
            mj: u.mj,
            P: t.P,
            jo: _g(u)
        };
        return A2(HL, A3(DL, t.a_.mj, a, n), A3(_O, KL, kc(xc), A2(Eg, r, e)));
    }), QL = F5(function(n, e, r, t, u) {
        return A2(HL, A3(RL, t.mj, XO(u), n), A3(_O, KL, kc(xc), A2(Eg, r, e)));
    }), ZL = F5(function(n, e, r, t, u) {
        var a = hL(u);
        return A2(Nc, A2(YL, u, A3(_O, KL, kc(xc), A2(Eg, r, e))), A3(Dk, A3(BL, n, e, r), t, a));
    }), nP = F5(function(n, e, r, t, u) {
        var a = hL(u);
        return A2(Nc, A2(WL, u, A3(_O, KL, kc(xc), A2(Eg, r, e))), A3(Dk, A3(QL, n, e, r), t, a));
    }), eP = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rP = {
        $: 1
    }, tP = function(n) {
        return {
            $: 9,
            a: n
        };
    }, uP = function(n) {
        return {
            $: 10,
            a: n
        };
    }, aP = function(n) {
        return {
            $: 4,
            a: n
        };
    }, iP = {
        $: 7
    }, cP = function(n) {
        return {
            $: 8,
            a: n
        };
    }, oP = function(n) {
        return {
            $: 9,
            a: n
        };
    }, fP = F4(function(n, e, r, t) {
        return {
            $: 10,
            a: n,
            b: e,
            c: r,
            d: t
        };
    }), sP = function(n) {
        return {
            $: 11,
            a: n
        };
    }, lP = function(n) {
        return {
            $: 12,
            a: n
        };
    }, dP = function(n) {
        return {
            $: 13,
            a: n
        };
    }, bP = F3(function(n, e, r) {
        return {
            $: 33,
            a: n,
            b: e,
            c: r
        };
    }), mP = function(n) {
        return {
            $: 3,
            a: n
        };
    }, pP = function(n) {
        return {
            $: 4,
            a: n
        };
    }, vP = function(n) {
        return {
            $: 5,
            a: n
        };
    }, gP = function(n) {
        return {
            $: 6,
            a: n
        };
    }, hP = F4(function(n, e, r, t) {
        return {
            $: 7,
            a: n,
            b: e,
            c: r,
            d: t
        };
    }), $P = F3(function(n, e, r) {
        return $(r, {
            q: $(r.q, {
                bh: zr(k(A2(qh, n, r), A([
                    e.mj
                ])))
            })
        });
    }), xP = function(n) {
        return {
            j: A2(Vb, Xb, n) ? Ur : zr(Ch(1)),
            bl: n.mj
        };
    }, kP = F3(function(n, e, r) {
        return $(r, {
            aM: zr(k(A2(Cx, n, r), A([
                xP(e)
            ])))
        });
    }), jP = function(n) {
        return n;
    }, yP = function(n) {
        return {
            Y: Ur,
            mj: n,
            D: 1,
            dH: Ur
        };
    }, wP = F2(function(n, e) {
        return k(e, A([
            yP(n)
        ]));
    }), AP = F2(function(n, e) {
        return !!n.mj.$ || A2(nl, ru, A([
            !s(e.r, n.r),
            !s(e.ek, Ur) && !s(e.ek, zr(n.ek))
        ]));
    }), TP = F3(function(n, e, r) {
        if (r.$) return zr(e({
            r: n.r,
            ek: Ur
        }));
        var t = e(r.a);
        return A2(AP, n, t) ? zr(t) : Ur;
    }), EP = F3(function(n, e, r) {
        if (0 > n) return r;
        var t = A2($x, n, r);
        if (t.b) {
            var u = t.a, a = t.b;
            return k(A2(Hc, n, r), A2(Mr, e(u), a));
        }
        return r;
    }), CP = function(n) {
        return EP(n);
    }, IP = F2(function(n, e) {
        var r = n.a;
        return A2(CP, n.b, function(n) {
            return $(n, {
                Y: A3(TP, r, e, n.Y)
            });
        });
    }), SP = F3(function(n, e, r) {
        return A2(el, PC, e.cP) ? Qr(A3(IP, n, function(n) {
            var r;
            return $(n, {
                r: k(n.r, A([
                    {
                        j: Ch(1),
                        U: {
                            i: mE(e),
                            mj: e.mj
                        },
                        J: j
                    }
                ])),
                ek: (r = v(n.ek, n.r), 1 !== r.a.$ || r.b.b ? n.ek : e.lv)
            });
        }, r)) : Yr("L'ajout d'un \xe9l\xe9ment ne peut se faire qu'\xe0 partir d'un proc\xe9d\xe9 mati\xe8re");
    }), OP = F2(function(n, e) {
        var r = n.a, t = r.a, u = n.b;
        return A2(CP, r.b, function(n) {
            return $(n, {
                Y: A3(TP, t, function(n) {
                    return $(n, {
                        r: A3(EP, u, e, n.r)
                    });
                }, n.Y)
            });
        });
    }), LP = F4(function(n, e, r, t) {
        return A2(el, UC, r.cP) ? Qr(A3(OP, n, function(n) {
            return $(n, {
                J: k(n.J, A([
                    {
                        i: e,
                        mj: r.mj
                    }
                ]))
            });
        }, t)) : Yr("Seuls les proc\xe9d\xe9s de cat\xe9gorie `transformation` sont mobilisables comme proc\xe9d\xe9s de transformation");
    }), PP = function(n) {
        var e = n.a;
        return A2(Hu, xx(n.b), A2(Hu, Ba(function(n) {
            return n.Y;
        }), G$(e)));
    }, qP = F3(function(n, e, r) {
        return A2(Ba, function(n) {
            var e = n.U, r = vx(n.J);
            return r.$ ? e.i : r.a.i;
        }, A2(Ba, function(e) {
            return A2(xx, e, A2(PP, n, r));
        }, e));
    }), NP = F4(function(n, e, r, t) {
        return A2(el, PC, r.cP) ? Qr(A3(OP, e, function(e) {
            var t = q$(P$(r));
            return $(e, {
                U: {
                    i: e.U.i,
                    mj: r.mj
                },
                J: A2(Zg, j, A2(fs, wu(Xt), A2(fs, Ah(function(n) {
                    var e = n.b;
                    return !s(t, Ur) && s(q$(P$(e)), t);
                }), Vg(A2(wu, function(e) {
                    return A2(fs, function(n) {
                        return v(e, n);
                    }, A2(Ns, e.mj, n.W));
                }, e.J)))))
            });
        }, t)) : Yr("Seuls les proc\xe9d\xe9s de cat\xe9gorie `material` sont mobilisables comme mati\xe8re");
    }), _P = F6(function(n, e, r, t, u, a) {
        var i = v(e, t);
        n: for(;;)if (i.b.$) switch(i.a.$){
            case 5:
                return A3(SP, r, u, a);
            case 11:
                return Yr("Un proc\xe9d\xe9 de transformation ne peut \xeatre ajout\xe9 qu'\xe0 un \xe9l\xe9ment existant");
            default:
                break n;
        }
        else switch(i.a.$){
            case 5:
                return A4(NP, n, v(r, c = i.b.a), u, a);
            case 11:
                var c = i.b.a, o = A3(qP, r, t, a);
                return A4(LP, v(r, c), o, u, a);
            default:
                break n;
        }
        return Yr("Cat\xe9gorie de proc\xe9d\xe9 non support\xe9e\xa0: " + wC(e));
    }), zP = F2(function(n, e) {
        var r = n.mj;
        return n.c1.$ ? A2(Ba, function(n) {
            return s(n.mj, r) ? Ur : zr(n);
        }, e) : zr(n);
    }), UP = F2(function(n, e) {
        return $(e, {
            b7: A2(zP, n, e.b7)
        });
    }), MP = F3(function(n, e, r) {
        var t = r.a, u = A2(UP, n, r.b), a = n.eT;
        return a.$ ? A2(Wx, t, u) : A2(e, u, Ch(a.a));
    }), DP = F4(function(n, e, r, t) {
        var u = e.a, a = u.a, i = u.b, c = e.b, o = A2(xx, i, t);
        if (o.$) return Qr(t);
        var f = o.a, l = A2(G$, a, f.Y);
        return 0 > c || m(c, ft(l)) > -1 ? Qr(t) : A2(fs, function(n) {
            var e = A2(bt, F2(function(e, t) {
                return s(e, c) ? $(t, {
                    j: r
                }) : $(t, {
                    j: A2(K$, n, t.j)
                });
            }), l);
            return A3(CP, i, function(n) {
                return $(n, {
                    Y: A3(TP, a, function(n) {
                        return $(n, {
                            r: e
                        });
                    }, n.Y),
                    dH: Ur
                });
            }, t);
        }, A3(Z$, n, l, f.dH));
    }), RP = F2(function(n, e) {
        var r = e.ei, t = e.ey, u = ds(r.iE);
        return $(e, {
            ei: $(r, {
                bx: A4(Vj, t, r.iE, r.lT, n),
                dd: n,
                ac: A2(Yx, {
                    az: t.h8,
                    C: t.C,
                    at: u
                }, n)
            }),
            ey: A3(Jj, r.iE, n, t)
        });
    }), FP = F5(function(n, e, r, t, u) {
        var a = A4(DP, n.C, t, u, r.my);
        return 1 === a.$ ? A3(xT, "Erreur de mise \xe0 jour de la quantit\xe9", a.a, A2(Wx, n, e)) : A2(RP, A2(kA, a.a, r), A2(Wx, n, e));
    }), HP = function(n) {
        var e = n.P, r = n.D;
        return r ? A2(_h, r, e) : e;
    }, GP = F2(function(n, e) {
        return m(e, n) > 0;
    }), XP = F2(function(n, e) {
        return A2(kA, n(e.my), e);
    }), VP = F5(function(n, e, r, t, u) {
        var a = A2(GP, 0, u), i = A2(Nc, !0, A2(Pc, function(n) {
            return HP(n) > 0;
        }, A2(Ba, A2(Hu, function(n) {
            return n.Q;
        }, A2(Hu, hx, xx(t))), Ld(e.ac))));
        return a && i ? A2(RP, A2(XP, A2(CP, t, function(n) {
            return $(n, {
                dH: zr(u)
            });
        }), r), A2(Wx, n, e)) : A2(Wx, n, e);
    }), JP = F5(function(n, e, r, t, u) {
        var a = A2(UP, u, e), i = u.eT;
        return i.$ ? A2(Wx, n, a) : A5(VP, n, a, r, t, i.a);
    }), YP = F2(function(n, e) {
        return {
            kP: n,
            nV: e
        };
    }), WP = A3(Wa, "pullRequestUrl", ai, A3(Wa, "branchName", ai, nu(YP))), KP = F3(function(n, e, r) {
        return A5(oS, n, "contrib/examples", r, WP, function(n) {
            return qc(A([
                v("description", Sc(n.io)),
                v("name", Sc(n.ek)),
                v("query", Rf(n.g5)),
                v("scope", Sc(vs(n.at)))
            ]));
        }(e));
    }), BP = function(n) {
        switch(n.$){
            case 0:
                return "\xc9chec de l'interpr\xe9tation de la r\xe9ponse HTTP: " + n.a.ip;
            case 1:
                var e = n.a.ip, r = n.a.eG;
                return mf("Erreur HTTP " + ut(n.a.j4) + ": " + e + ". " + A2(Nc, "", r));
            case 2:
                return "URL invalide: " + n.a;
            case 3:
                return "Erreur de communication r\xe9seau. \xcates-vous connect\xe9 ?";
            default:
                return "D\xe9lai d\xe9pass\xe9.";
        }
    }, QP = function(n) {
        switch(n.$){
            case 0:
            case 3:
            case 4:
            case 5:
            case 7:
                return !0;
            default:
                return !1;
        }
    }, ZP = function(n) {
        return $T(function(n) {
            return {
                ed: 3,
                eh: n,
                ev: !1,
                eG: Ur
            };
        }(n));
    }, nq = function(n) {
        return A2(Hu, lm(n), ru);
    }, eq = F2(function(n, e) {
        if (0 > n) return e;
        var r = A2($x, n, e);
        if (r.b) {
            var t = r.b;
            return k(A2(Hc, n, e), t);
        }
        return e;
    }), rq = F3(function(n, e, r) {
        return $(r, {
            q: $(r.q, {
                bh: zr(A2(eq, e, A2(qh, n, r)))
            })
        });
    }), tq = F3(function(n, e, r) {
        return $(r, {
            aM: zr(A2(eq, e, A2(Cx, n, r)))
        });
    }), uq = F2(function(n, e) {
        return A2(OP, n, function(n) {
            return $(n, {
                J: A2(eq, e, n.J)
            });
        });
    }), aq = F2(function(n, e) {
        return $(e, {
            aR: A2(eq, n, e.aR)
        });
    }), iq = F2(function(n, e) {
        var r = e.q, t = e.ax, u = function(n) {
            return $(e, {
                q: $(r, {
                    bh: Ur
                }),
                aM: Ur,
                E: Ur,
                aS: n,
                ax: $(t, {
                    aN: Ur
                })
            });
        };
        if (n.$) return u(Ur);
        var a = n.a;
        return s(e.aS, zr(a.mj)) ? e : u(zr(a.mj));
    }), cq = F3(function(n, e, r) {
        if (r.$) return RP(A2(iq, Ur, e));
        var t = A2(Ph, r.a, n.C.dp);
        return 1 === t.$ ? A2(xT, "Cat\xe9gorie de produit introuvable", t.a) : RP(A2(iq, zr(t.a), e));
    }), oq = F2(function(n, e) {
        return $(e, {
            ax: $(e.ax, {
                a8: n
            })
        });
    }), fq = F2(function(n, e) {
        return $(e, {
            ax: $(e.ax, {
                aN: zr(n)
            })
        });
    }), sq = F2(function(n, e) {
        return A2(fs, function(n) {
            return A2(kA, n, e);
        }, n(e.my));
    }), lq = F2(function(n, e) {
        return $(e, {
            q: $(e.q, {
                i: n
            })
        });
    }), dq = F4(function(n, e, r, t) {
        return $(t, {
            aM: zr(A3(EP, e, function(n) {
                return n.j.$ ? n : $(n, {
                    j: zr(r)
                });
            }, A2(Cx, n, t)))
        });
    }), bq = F2(function(n, e) {
        return $(e, {
            E: n
        });
    }), mq = F2(function(n, e) {
        return $(e, {
            aO: s(n, 1) ? Ur : zr(n)
        });
    }), pq = F2(function(n, e) {
        return A2(OP, n, function(n) {
            return $(n, {
                U: $(n.U, {
                    i: e
                })
            });
        });
    }), vq = F3(function(n, e, r) {
        return A2(OP, n, function(n) {
            return $(n, {
                J: A3(EP, e, function(n) {
                    return $(n, {
                        i: r
                    });
                }, n.J)
            });
        });
    }), gq = F2(function(n, e) {
        return A2(IP, n, function(n) {
            return $(n, {
                ek: zr(e)
            });
        });
    }), hq = F3(function(n, e, r) {
        return $(r, {
            aR: A3(EP, n, function(n) {
                return $(n, {
                    j: e
                });
            }, r.aR)
        });
    }), $q = F2(function(n, e) {
        return $(e, {
            dq: n
        });
    }), xq = F3(function(n, e, r) {
        var t = hL(e);
        if (t.$) return A2(ZP, "Aucun composant s\xe9lectionn\xe9", r);
        var u = t.a;
        return A3(_O, Tq, yc(j), A2(RP, $(n, {
            aR: k(n.aR, A([
                A2(nq, Ch(1), u.mj)
            ]))
        }), r));
    }), kq = F4(function(n, e, r, t) {
        var u = hL(r);
        if (u.$) return A2(ZP, "Aucun proc\xe9d\xe9 d\u2019assemblage s\xe9lectionn\xe9", t);
        var a = u.a;
        return A3(_O, Tq, yc(j), A2(RP, A3($P, n, a, e), t));
    }), jq = F4(function(n, e, r, t) {
        var u = t.ei, a = hL(r);
        if (a.$) return A2(ZP, "Aucun composant s\xe9lectionn\xe9", t);
        var i = a.a;
        return A2(Sp, A([
            A2(Dl, t.ey, uP(ds(u.iE)))
        ]), A3(_O, Tq, yc(j), A2(RP, A3(kP, n, i, e), t)));
    }), yq = F2(function(n, e) {
        var r = e.ei, t = A2(Nc, Bx, hL(n));
        return A2(Sp, A([
            A2(Dl, e.ey, yO(ds(r.iE)))
        ]), A3(_O, Tq, yc(j), A2(RP, t, e)));
    }), wq = F6(function(n, e, r, t, u, a) {
        var i = a.ei, c = a.ey, o = hL(t);
        if (o.$) return A2(ZP, "Aucun composant s\xe9lectionn\xe9", a);
        var f = A2(sq, A5(_P, c.C, n, e, r, o.a), u);
        if (1 === f.$) return A3(xT, "Erreur", f.a, a);
        var s = f.a;
        return A2(Sp, A([
            A2(Dl, a.ey, tP(ds(i.iE)))
        ]), A3(_O, Tq, yc(A2($x, 1, i.M)), A2(RP, s, a)));
    }), Aq = F3(function(n, e, r) {
        var t = r.ey, u = A2(Dl, r.ey, function(n) {
            return {
                $: 8,
                a: n
            };
        }(ds(r.ei.iE))), a = hL(e);
        if (a.$) return A2(ZP, "Aucun composant s\xe9lectionn\xe9", r);
        if (a.a.$) {
            var i = a.a.a, c = ft(n.my), o = v(X$, c), f = {
                Y: Ur,
                mj: Ur,
                D: 1,
                dH: Ur
            }, s = A2(sq, A5(_P, t.C, PC, o, Ur, i), $(n, {
                my: k(n.my, A([
                    f
                ]))
            }));
            if (1 === s.$) return A3(xT, "Erreur", s.a, r);
            var l = s.a;
            return A2(Sp, A([
                u
            ]), A3(_O, Tq, yc(j), A2(RP, l, r)));
        }
        var d = a.a.a;
        return A2(Sp, A([
            u
        ]), A3(_O, Tq, yc(j), A2(RP, A2(XP, wP(d.mj), n), r)));
    }), Tq = F3(function(n, e, r) {
        var t = n.na, u = A2(Zx, r.iE, n), a = ds(r.iE), i = {
            az: n.h8,
            C: n.C,
            at: a
        }, c = v(e, r.M);
        switch(c.a.$){
            case 0:
                return A2(Wx, n, $(r, {
                    M: A2(Mr, c.a.a, F = c.b)
                }));
            case 1:
                return A2(Sp, A([
                    SI(c.a.a)
                ]), A2(Wx, n, r));
            case 2:
                var o = v(Nl(n), function(n) {
                    var e = v(mf(n.cV), mf(n.cW)), r = e.a, t = e.b;
                    return su(t) ? Yr(A([
                        "Le nom de la contribution est requis"
                    ])) : su(r) ? Yr(A([
                        "La description de la contribution est requise"
                    ])) : Qr({
                        io: r,
                        ek: t,
                        g5: n.dd,
                        at: ds(n.iE)
                    });
                }(r));
                return o.a ? o.b.$ ? A3(xT, "Erreur lors de la cr\xe9ation de votre contribution", A2(at, ", ", o.b.a), A2(Wx, n, $(r, {
                    a9: !1
                }))) : A2(Sp, A([
                    A3(KP, n, o.b.a, aP)
                ]), A2(Wx, n, $(r, {
                    a9: !0
                }))) : A2(ZP, "Vous devez \xeatre authentifi\xe9 pour soumettre une contribution", A2(Wx, n, $(r, {
                    a9: !1
                })));
            case 3:
                return A2(Wx, A2(VO, c.a.a, n), r);
            case 4:
                switch(c.a.a.$){
                    case 2:
                        return A3(xT, "Erreur de contribution", BP(c.a.a.a), A2(Wx, n, $(r, {
                            a9: !1
                        })));
                    case 3:
                        return A2(rS, A3(Yb, "pr_url", c.a.a.a.nV, "La contribution est soumise \xe0 validation par l\u2019\xe9quipe m\xe9thode d\u2019Ecobalyse.\n                        Vous pouvez suivre [sur ce lien](pr_url) l\u2019\xe9tat d\u2019avancement de l\u2019int\xe9gration de votre exemple de produit.\n                        "), A2(Wx, n, $(r, {
                            a9: !1
                        })));
                    default:
                        return A2(Wx, n, r);
                }
            case 5:
                return A2(Sp, A([
                    KO(0)
                ]), A2(Wx, n, r));
            case 6:
                return A2(Sp, A([
                    rL(0)
                ]), A2(Wx, n, r));
            case 7:
                return A2(Wx, n, r);
            case 11:
                if (c.b.b && !c.b.a.$) {
                    var f = c.b, s = f.b, l = A2(UL, c.a.a, f.a.a), d = l.a;
                    return A2(Sp, A([
                        A2(FT, sP, E = l.b)
                    ]), A2(Wx, n, $(r, {
                        M: A2(Mr, eP(d), s)
                    })));
                }
                return A2(Wx, n, r);
            case 8:
                if (c.b.b && 3 === c.b.a.$) {
                    var b = c.b, p = (s = b.b, A2(UL, c.a.a, b.a.a));
                    return d = p.a, A2(Sp, A([
                        A2(FT, cP, E = p.b)
                    ]), A2(Wx, n, $(r, {
                        M: A2(Mr, mP(d), s)
                    })));
                }
                return A2(Wx, n, r);
            case 9:
                if (c.b.b && 4 === c.b.a.$) {
                    var g = c.b, h = (s = g.b, A2(UL, c.a.a, g.a.a));
                    return d = h.a, A2(Sp, A([
                        A2(FT, oP, E = h.b)
                    ]), A2(Wx, n, $(r, {
                        M: A2(Mr, pP(d), s)
                    })));
                }
                return A2(Wx, n, r);
            case 10:
                if (c.b.b && 7 === c.b.a.$) {
                    var x = c.a, k = x.a, j = x.b, y = x.c, w = c.b, T = (s = w.b, A2(UL, x.d, w.a.d)), E = (d = T.a, T.b);
                    return A2(Sp, A([
                        A2(FT, A3(fP, k, j, y), E)
                    ]), A2(Wx, n, $(r, {
                        M: A2(Mr, A4(hP, k, j, y, d), s)
                    })));
                }
                return A2(Wx, n, r);
            case 12:
                if (c.b.b && 5 === c.b.a.$) {
                    var C = c.b, I = (s = C.b, A2(UL, c.a.a, C.a.a));
                    return d = I.a, A2(Sp, A([
                        A2(FT, lP, E = I.b)
                    ]), A2(Wx, n, $(r, {
                        M: A2(Mr, vP(d), s)
                    })));
                }
                return A2(Wx, n, r);
            case 13:
                if (c.b.b && 6 === c.b.a.$) {
                    var S = c.b, O = (s = S.b, A2(UL, c.a.a, S.a.a));
                    return d = O.a, A2(Sp, A([
                        A2(FT, dP, E = O.b)
                    ]), A2(Wx, n, $(r, {
                        M: A2(Mr, gP(d), s)
                    })));
                }
                return A2(Wx, n, r);
            case 19:
                return c.b.b && !c.b.a.$ ? A3(Aq, u, c.b.a.a, A2(Wx, n, r)) : A2(Wx, n, r);
            case 14:
                return c.b.b && 3 === c.b.a.$ ? A4(kq, i, u, c.b.a.a, A2(Wx, n, r)) : A2(Wx, n, r);
            case 15:
                return c.b.b && 4 === c.b.a.$ ? A4(jq, i, u, c.b.a.a, A2(Wx, n, r)) : A2(Wx, n, r);
            case 16:
                return c.b.b && 5 === c.b.a.$ ? A2(yq, c.b.a.a, A2(Wx, n, r)) : A2(Wx, n, r);
            case 17:
                return c.b.b && 6 === c.b.a.$ ? A3(xq, u, c.b.a.a, A2(Wx, n, r)) : A2(Wx, n, r);
            case 18:
                if (c.b.b && 7 === c.b.a.$) {
                    var L = c.a;
                    return A6(wq, k = L.a, j = L.b, L.c, c.b.a.d, u, A2(Wx, n, r));
                }
                return A2(Wx, n, r);
            case 20:
                return A2(Wx, n, $(r, {
                    bv: Ur
                }));
            case 21:
                return A2(Wx, n, $(r, {
                    bv: zr(c.a.a)
                }));
            case 22:
                return A2(Wx, n, $(r, {
                    cN: zr(c.a.a)
                }));
            case 23:
                var P = c.a.a, q = r.cN;
                return q.$ ? A2(Wx, n, r) : A2(Wx, A3(sL, q.a, P, n), $(r, {
                    cN: Ur,
                    bv: Ur
                }));
            case 24:
                return A2(Sp, A([
                    A2(Dl, n, kO(a)),
                    tL(0)
                ]), A2(Wx, FO(n), $(r, {
                    M: A([
                        rP
                    ])
                })));
            case 26:
                var N = c.a.a;
                return A2(Sp, A([
                    A2(Dl, n, tP(a))
                ]), A2(RP, A2(XP, eq(N), u), A2(Wx, n, $(r, {
                    bX: A3(dL, function(n) {
                        return m(n, N) > 0;
                    }, function(n) {
                        return n - 1;
                    }, A2(oL, N, r.bX))
                }))));
            case 25:
                return A2(RP, A3(rq, i, Q = c.a.a, u), A2(Wx, n, r));
            case 27:
                return A2(RP, A3(tq, i, Q = c.a.a, u), A2(Wx, n, r));
            case 28:
                var _ = c.a.a;
                return A2(Sp, A([
                    A2(Dl, n, tP(a))
                ]), A2(RP, A2(XP, function(n) {
                    var e = n.b;
                    return A2(IP, n.a, function(n) {
                        return $(n, {
                            r: A2(eq, e, n.r)
                        });
                    });
                }(_), u), A2(Wx, n, r)));
            case 29:
                var z = c.a, U = (_ = z.a, z.b);
                return A2(Sp, A([
                    A2(Dl, n, tP(a))
                ]), A2(RP, A2(XP, A2(uq, _, U), u), A2(Wx, n, r)));
            case 30:
                return A2(RP, A2(aq, Q = c.a.a, u), A2(Wx, n, r));
            case 31:
                var M = r.bw;
                return M.$ ? A2(Wx, n, r) : A2(Wx, A2(mL, M.a, n), $(r, {
                    bw: Ur
                }));
            case 32:
                return A2(Sp, A([
                    A2(Lu, A2(bP, r.bx, A2(ek, r.iE, u)), ac),
                    A2(Dl, n, $O(a))
                ]), A2(Wx, n, r));
            case 33:
                var D = c.a, R = D.b;
                return A2(Wx, A2(pL, {
                    gn: D.c,
                    iE: Ur,
                    ek: mf(D.a),
                    g5: R
                }, n), r);
            case 34:
                return A2(Wx, vL(n), r);
            case 35:
                return A2(Wx, gL(n), r);
            case 36:
                return A2(Wx, n, $(r, {
                    bX: c.a.a
                }));
            case 37:
                var F;
                return A3(XL, A2(nl, QP, F = c.a.a), nL(iP), A2(Wx, n, $(r, {
                    M: F
                })));
            case 38:
                var H = c.a.a;
                return A2(Sp, A([
                    A3($L, n, 2 === H, A2(OO, ds(r.iE), "Partager"))
                ]), A2(Wx, n, $(r, {
                    dW: H
                })));
            case 39:
                var G = c.a.a;
                return A2(Sp, A([
                    A2(Dl, n, A2(jO, a, GO(G)))
                ]), A2(Wx, n, $(r, {
                    cT: G
                })));
            case 40:
                if (1 === c.a.a.$) return A3(xT, "Erreur de s\xe9lection d'impact", c.a.a.a, A2(Wx, n, r));
                var X = c.a.a.a;
                return A2(Sp, A([
                    A2(AT, t, _T(A3(qb, r.iE, X, zr(u)))),
                    A2(Dl, n, A2(wO, a, X))
                ]), A2(Wx, n, r));
            case 41:
                var V = c.a.a;
                return A2(Sp, A([
                    A2(Dl, n, A2(OO, a, jL(V)))
                ]), A2(Wx, n, $(r, {
                    dN: V
                })));
            case 42:
                var J = c.a;
                return A2(Wx, A3(yL, J.a, J.b, n), r);
            case 43:
                return A2(RP, A2(oq, c.a.a, u), A2(Wx, n, r));
            case 44:
                return A2(RP, A2(fq, c.a.a, u), A2(Wx, n, r));
            case 45:
                return A2(RP, A2(lq, c.a.a, u), A2(Wx, n, r));
            case 46:
                return A2(Wx, n, $(r, {
                    bx: c.a.a
                }));
            case 47:
                var Y = c.a;
                return A2(RP, A2(XP, A2(gq, j = Y.a, Y.b), u), A2(Wx, n, r));
            case 48:
                var W = c.a, K = (N = W.a, W.b);
                return A2(Sp, A([
                    A2(Dl, n, tP(a))
                ]), A2(RP, A2(XP, A2(CP, N, function(n) {
                    return $(n, {
                        D: K
                    });
                }), u), A2(Wx, n, r)));
            case 49:
                var B = c.a, Q = B.a;
                return A3(MP, B.b, F2(function(e, r) {
                    return A2(RP, A4(dq, i, Q, r, u), A2(Wx, n, e));
                }), v(n, r));
            case 50:
                return A2(Wx, n, $(r, {
                    cV: c.a.a
                }));
            case 51:
                return A2(Wx, n, $(r, {
                    cW: c.a.a
                }));
            case 52:
                return c.a.a.$ ? A3(xT, "Erreur de s\xe9lection du proc\xe9d\xe9 de distribution", c.a.a.a, A2(Wx, n, r)) : A2(RP, A2(bq, zr(c.a.a.a), u), A2(Wx, n, r));
            case 53:
                return c.a.a.$ ? A3(xT, "Erreur de durabilit\xe9", c.a.a.a, A2(Wx, n, r)) : A2(RP, A2(mq, c.a.a.a, u), A2(Wx, n, r));
            case 54:
                var Z = c.a;
                return _ = Z.a, A3(MP, Z.b, function(e) {
                    return A4(FP, n, e, u, _);
                }, v(n, r));
            case 57:
                var nn = c.a;
                return A5(JP, n, r, u, N = nn.a, nn.b);
            case 55:
                var en = c.a, rn = (_ = en.a, en.b);
                return A2(Sp, A([
                    A2(Dl, n, tP(a))
                ]), A2(RP, A2(XP, A2(pq, _, rn), u), A2(Wx, n, r)));
            case 56:
                var tn = c.a;
                return _ = tn.a, U = tn.b, rn = tn.c, A2(Sp, A([
                    A2(Dl, n, tP(a))
                ]), A2(RP, A2(XP, A3(vq, _, U, rn), u), A2(Wx, n, r)));
            case 58:
                var un = c.a;
                return Q = un.a, A3(MP, un.b, F2(function(e, r) {
                    return A2(RP, A3(hq, Q, r, u), A2(Wx, n, e));
                }), v(n, r));
            case 59:
                return A4(cq, n, u, c.a.a, A2(Wx, n, r));
            case 60:
                return A2(RP, A2($q, c.a.a, u), A2(Wx, n, r));
            default:
                var an = c.a;
                return A2(Wx, n, $(r, {
                    bw: zr($(an.a, {
                        ek: an.b
                    }))
                }));
        }
    }), Eq = F3(function(n, e, r) {
        if (e.$) {
            var t = e.a;
            return A2(Sp, A([
                Ip({
                    pT: 0,
                    pU: 0
                }),
                $I(_T(t))
            ]), A2(Ep, n, r));
        }
        return A2(Sp, A([
            $I(e.a)
        ]), A2(Ep, n, r));
    }), Cq = F3(function(n, e, r) {
        return A2(Ep, n, r);
    }), Iq = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Sq = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Oq = {
        $: 2
    }, Lq = {
        $: 3
    }, Pq = {
        $: 5
    }, qq = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Nq = function(n) {
        return {
            $: 7,
            a: n
        };
    }, _q = function(n) {
        return {
            $: 8,
            a: n
        };
    }, zq = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Uq = F3(function(n, e, r) {
        return {
            $: 22,
            a: n,
            b: e,
            c: r
        };
    }), Mq = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Dq = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Rq = F2(function(n, e) {
        return $(e, {
            ft: k(e.ft, A([
                {
                    i: Ur,
                    mj: n.mj,
                    aH: 0,
                    dz: Ur
                }
            ]))
        });
    }), Fq = F3(function(n, e, r) {
        return $(r, {
            ft: A3(dL, A2(Hu, function(n) {
                return n.mj;
            }, zt(n)), e, r.ft)
        });
    }), Hq = F2(function(n, e) {
        return A2(Fq, n, function(n) {
            return $(n, {
                aH: e
            });
        });
    }), Gq = F2(function(n, e) {
        var r, t;
        return (t = (r = $(e, {
            ft: A2(Ah, function(e) {
                return !s(e.mj, n);
            }, e.ft)
        })).ft).b && !t.b.b ? A3(Hq, t.a.mj, 1, r) : r;
    }), Xq = F2(function(n, e) {
        return $(e, {
            c0: A2(el, n, e.c0) ? A2(Ah, Ic(n), e.c0) : A2(Mr, n, e.c0)
        });
    }), Vq = F2(function(n, e) {
        return A2(Fq, n, function(n) {
            return $(n, {
                i: e.i,
                mj: e.mj,
                aH: e.aH,
                dz: Ur
            });
        });
    }), Jq = F3(function(n, e, r) {
        return $(r, {
            ft: A2(wu, function(r) {
                return s(r.mj, n.mj) ? $(r, {
                    dz: zr(e)
                }) : r;
            }, r.ft)
        });
    }), Yq = F2(function(n, e) {
        return s(n.mj, e.aS) ? e : $(e, {
            c2: Ur,
            b6: Ur,
            mV: Ur,
            dk: Ur,
            dl: Ur,
            jr: Ur,
            $7: Ur,
            aS: n.mj,
            hj: Ur,
            pf: Ur,
            pV: Ur
        });
    }), Wq = F2(function(n, e) {
        var r = e.ey;
        return $(e, {
            ei: $(e.ei, {
                bx: A2(lT, r, n),
                dx: A3(QA, r.C, r.h8, n)
            }),
            ey: A2(dT, n, r)
        });
    }), Kq = F3(function(n, e, r) {
        var t = s(e, _A) ? Ur : zr(e);
        switch(n){
            case 2:
                return $(r, {
                    by: t
                });
            case 3:
                return $(r, {
                    bU: t
                });
            case 4:
                return $(r, {
                    cJ: s(r.bV, t) ? r.cJ : Ur,
                    bV: t
                });
            case 6:
                return $(r, {
                    cY: t
                });
            default:
                return r;
        }
    }), Bq = F3(function(n, e, r) {
        var t = v(r.pf, A2(fs, function(n) {
            return n.pf;
        }, A2(IA, r.aS, n)));
        if (t.b.$) return $(r, {
            pf: Ur
        });
        if (t.a.$) return $(r, {
            pf: zr(e(a = t.b.a))
        });
        var u = t.a.a, a = t.b.a;
        return $(r, {
            pf: s(e(u), a) ? Ur : zr(e(u))
        });
    }), Qq = F2(function(n, e) {
        var r = e.ei, t = e.ey, u = A2(Nc, oI, hL(n));
        return A2(Sp, A([
            A2(Dl, t, yO(bs))
        ]), A2(Wq, u, A3(_O, rN, Tc(Ac), A2(ZA, A2(dT, u, t), $(r, {
            dd: u
        })))));
    }), Zq = F2(function(n, e) {
        var r = e.ey, t = hL(n);
        return t.$ ? A3(xT, "Erreur", "Aucun mat\xe9riau s\xe9lectionn\xe9", e) : A2(Wq, A2(Rq, t.a, r.an.oX), A3(_O, rN, Tc(Ac), e));
    }), nN = F2(function(n, e) {
        var r = e.ey, t = hL(n);
        return t.$ ? A3(xT, "Erreur", "Aucun produit s\xe9lectionn\xe9", e) : A2(Wq, A2(Yq, t.a, r.an.oX), A3(_O, rN, Tc(Ac), e));
    }), eN = F2(function(n, e) {
        var r = e.ey, t = hL(n);
        return t.$ ? A3(xT, "Erreur", "Aucun accessoire s\xe9lectionn\xe9", e) : t.a.$ ? A3(xT, "Erreur", "Un mat\xe9riau brut ne peut pas \xeatre ajout\xe9 comme accessoire", e) : A2(Wq, A3(Bq, r.C.oX.dp, wP(t.a.a.mj), r.an.oX), A3(_O, rN, Tc(Ac), e));
    }), rN = F3(function(n, e, r) {
        var t, u = n.C, a = n.na, i = n.an.oX, c = v(e, r.ad);
        switch(c.a.$){
            case 0:
                return A2(Wq, function(n) {
                    return $(n, {
                        c0: j,
                        c2: Ur,
                        b6: Ur,
                        mV: Ur,
                        dk: Ur,
                        dl: Ur,
                        ft: A2(wu, function(n) {
                            return $(n, {
                                dz: Ur
                            });
                        }, n.ft),
                        dn: Ur,
                        hj: Ur,
                        pf: Ur,
                        pV: Ur
                    });
                }(i), A3(_O, rN, Tc(Ac), A2(ZA, n, $(r, {
                    aV: 1
                }))));
            case 1:
                return A2(Sp, A([
                    SI(c.a.a)
                ]), A2(ZA, n, r));
            case 2:
                return A2(ZA, A2(VO, c.a.a, n), r);
            case 3:
                return A2(Sp, A([
                    KO(0)
                ]), A2(ZA, n, r));
            case 4:
                return A2(Sp, A([
                    rL(0)
                ]), A2(ZA, n, r));
            case 5:
                return A2(ZA, n, r);
            case 16:
                return A2(Sp, A([
                    A2(Dl, n, kO(bs)),
                    tL(0)
                ]), A2(ZA, FO(n), $(r, {
                    ad: Oq
                })));
            case 10:
                if (1 === c.b.$) {
                    var o = A2(UL, c.a.a, c.b.a), f = o.a;
                    return A2(Sp, A([
                        A2(FT, zq, o.b)
                    ]), A2(ZA, n, $(r, {
                        ad: Sq(f)
                    })));
                }
                return A2(ZA, n, r);
            case 6:
                if (6 === c.b.$) {
                    var s = A2(UL, c.a.a, c.b.a);
                    return f = s.a, A2(Sp, A([
                        A2(FT, qq, s.b)
                    ]), A2(ZA, n, $(r, {
                        ad: Mq(f)
                    })));
                }
                return A2(ZA, n, r);
            case 8:
                if (7 === c.b.$) {
                    var l = A2(UL, c.a.a, c.b.a);
                    return f = l.a, A2(Sp, A([
                        A2(FT, _q, l.b)
                    ]), A2(ZA, n, $(r, {
                        ad: Dq(f)
                    })));
                }
                return A2(ZA, n, r);
            case 7:
                if (c.b.$) return A2(ZA, n, r);
                var d = c.b, b = d.a, m = A2(UL, c.a.a, d.b);
                return f = m.a, A2(Sp, A([
                    A2(FT, Nq, m.b)
                ]), A2(ZA, n, $(r, {
                    ad: A2(Iq, b, f)
                })));
            case 9:
                switch(c.b.$){
                    case 0:
                        var p = c.b;
                        return A4(uN, i, b = p.a, p.b, A2(ZA, n, r));
                    case 1:
                        return A2(eN, c.b.a, A2(ZA, n, r));
                    case 6:
                        return A2(Qq, c.b.a, A2(ZA, n, r));
                    case 7:
                        return A2(nN, c.b.a, A2(ZA, n, r));
                    default:
                        return A2(ZA, n, r);
                }
            case 11:
                return A2(ZA, n, $(r, {
                    bv: Ur
                }));
            case 12:
                return A2(ZA, n, $(r, {
                    bv: zr(c.a.a)
                }));
            case 13:
                return A2(ZA, n, $(r, {
                    cN: zr(c.a.a)
                }));
            case 14:
                var g = c.a.a, h = r.cN;
                return h.$ ? A2(ZA, n, r) : A2(ZA, A3(sL, h.a, g, n), $(r, {
                    cN: Ur,
                    bv: Ur
                }));
            case 15:
                return A2(Sp, A([
                    PS("#" + c.a.a)
                ]), A2(ZA, n, r));
            case 17:
                return A2(Wq, A2(Gq, c.a.a, i), A2(ZA, n, r));
            case 18:
                return A2(Wq, A3(Bq, u.oX.dp, eq(c.a.a), i), A2(ZA, n, r));
            case 19:
                var x = r.bw;
                return x.$ ? A2(ZA, n, r) : A2(ZA, A2(mL, x.a, n), $(r, {
                    bw: Ur
                }));
            case 20:
                return A2(Wq, r.dd, A2(ZA, n, r));
            case 21:
                return A2(Sp, A([
                    A2(Lu, A2(Uq, r.bx, eT(i)), ac),
                    A2(Dl, n, $O(bs))
                ]), A2(ZA, n, r));
            case 22:
                var k = c.a, y = k.b;
                return A2(ZA, A2(pL, {
                    gn: k.c,
                    iE: Ur,
                    ek: mf(k.a),
                    g5: y
                }, n), r);
            case 23:
                return A2(ZA, vL(n), r);
            case 24:
                return A2(ZA, gL(n), r);
            case 25:
                var w = c.a.a;
                return A3(XL, function(n) {
                    switch(n.$){
                        case 0:
                        case 1:
                        case 6:
                        case 7:
                            return !0;
                        default:
                            return !1;
                    }
                }(w), nL(Pq), A2(ZA, n, $(r, {
                    ad: w
                })));
            case 26:
                var T = c.a.a;
                return A2(Sp, A([
                    A3($L, n, 2 === T, A2(OO, bs, "Partager"))
                ]), A2(ZA, n, $(r, {
                    dW: T
                })));
            case 27:
                var E = c.a.a;
                return A2(Sp, A([
                    A2(Dl, n, A2(jO, bs, GO(E)))
                ]), A2(ZA, n, $(r, {
                    cT: E
                })));
            case 28:
                if (c.a.a.$) return A3(xT, "Erreur de s\xe9lection d'impact: ", c.a.a.a, A2(ZA, n, r));
                var C = c.a.a.a;
                return A2(Sp, A([
                    A2(AT, a, _T(A2(Um, C, zr(i)))),
                    A2(Dl, n, A2(wO, bs, C))
                ]), A2(ZA, n, r));
            case 29:
                var I = c.a.a;
                return A2(Sp, A([
                    A2(Dl, n, A2(OO, bs, jL(I)))
                ]), A2(ZA, n, $(r, {
                    dN: I
                })));
            case 30:
                return 1 === c.a.a ? A2(Sp, A([
                    A2(Dl, n, A2(OO, bs, "Regulatory"))
                ]), A2(ZA, n, nT(i) ? $(r, {
                    ad: Lq
                }) : $(r, {
                    aV: 1
                }))) : A2(Sp, A([
                    A2(Dl, n, A2(OO, bs, "Exploratory"))
                ]), A2(ZA, n, $(r, {
                    aV: 0
                })));
            case 31:
                var S = c.a;
                return A2(ZA, A3(yL, S.a, S.b, n), r);
            case 32:
                return A2(Wq, $(i, {
                    c8: zr(c.a.a)
                }), A2(ZA, n, r));
            case 33:
                return A2(Wq, A2(Xq, c.a.a, i), A2(ZA, n, r));
            case 34:
                return A2(Wq, $(i, {
                    cJ: c.a.a
                }), A2(ZA, n, r));
            case 35:
                return A2(ZA, n, $(r, {
                    bx: c.a.a
                }));
            case 36:
                return c.a.a.$ ? A3(xT, "Erreur de type d'entreprise", c.a.a.a, A2(ZA, n, r)) : A2(Wq, $(i, {
                    h_: zr(c.a.a.a)
                }), A2(ZA, n, r));
            case 37:
                return A2(Wq, $(i, {
                    c2: zr(c.a.a)
                }), A2(ZA, n, r));
            case 38:
                return A2(Wq, $(i, {
                    b6: zr(c.a.a)
                }), A2(ZA, n, r));
            case 46:
                return A2(Wq, $(i, {
                    dn: c.a.a
                }), A2(ZA, n, r));
            case 39:
                return A2(Wq, $(i, {
                    mV: zr(c.a.a)
                }), A2(ZA, n, r));
            case 41:
                return A2(Wq, $(i, {
                    dl: c.a.a
                }), A2(ZA, n, r));
            case 40:
                return A2(Wq, $(i, {
                    dk: c.a.a
                }), A2(ZA, n, r));
            case 42:
                return ((t = A2(Pc, hb, pp(c.a.a))).$ ? ru : Wq($(i, {
                    P: t.a
                })))(A2(ZA, n, r));
            case 43:
                var O = c.a;
                return A2(Wq, A3(Vq, O.a.mj, O.b, i), A2(ZA, n, r));
            case 44:
                var L = c.a;
                return A2(Wq, A3(Jq, L.a, L.b, i), A2(ZA, n, r));
            case 45:
                return A2(Wq, $(i, {
                    je: c.a.a
                }), A2(ZA, n, r));
            case 47:
                return A2(Wq, $(i, {
                    jr: c.a.a
                }), A2(ZA, n, r));
            case 48:
                return A2(Wq, $(i, {
                    $7: c.a.a
                }), A2(ZA, n, r));
            case 49:
                var P = c.a;
                return A2(ZA, n, $(r, {
                    bw: zr($(P.a, {
                        ek: P.b
                    }))
                }));
            case 50:
                var q = c.a;
                return A2(Wq, A3(Kq, q.a, q.b, i), A2(ZA, n, r));
            case 51:
                return A2(Wq, $(i, {
                    hj: c.a.a
                }), A2(ZA, n, r));
            case 52:
                var N = c.a, _ = N.b;
                return A2(Wq, A3(Bq, u.oX.dp, A2(CP, N.a, function(n) {
                    return $(n, {
                        D: _
                    });
                }), i), A2(ZA, n, r));
            case 53:
                return A2(Wq, $(i, {
                    dI: c.a.a
                }), A2(ZA, n, r));
            default:
                return A2(Wq, $(i, {
                    pV: c.a.a
                }), A2(ZA, n, r));
        }
    }), tN = F4(function(n, e, r, t) {
        return A2(Wq, A3(Vq, r.U.mj, {
            i: Ur,
            mj: t.mj,
            aH: r.aH,
            dz: Ur
        }, n), A3(_O, rN, Tc(Ac), e));
    }), uN = F4(function(n, e, r, t) {
        var u = hL(r);
        return A2(Nc, A2(Zq, r, A3(_O, rN, Tc(Ac), t)), A3(Dk, A2(tN, n, t), e, u));
    }), aN = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), iN = F2(function(n, e) {
        if (3 !== e.$) return n;
        var r = e.a;
        switch(n.$){
            case 0:
                return n;
            case 1:
                return function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(r);
            default:
                var t = n.a;
                return s(t.gB, r.gB) && s(t.fR, r.fR) ? n : A2(aN, t, r);
        }
    }), cN = F4(function(n, e, r, t) {
        switch(n.$){
            case 2:
                return v(t, A2(HT, RT, gT(A2(vT, "Erreur", "Impossible de charger les impacts d\xe9taill\xe9s; les impacts agr\xe9g\xe9s seront utilis\xe9s."))));
            case 1:
            case 0:
                return v(t, Cc);
            default:
                var u = A2(lS, n.a, e);
                return v($(t, {
                    H: A2(Zf, u, A2(yI, u, r))
                }), Cc);
        }
    }), oN = function(n) {
        return {
            $: 8,
            a: n
        };
    }, fN = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), sN = F2(function(n, e) {
        return A2(Lu, Wi(e), PL(n));
    }), lN = function(n) {
        return {
            $: 2,
            a: n
        };
    }, dN = F2(function(n, e) {
        switch(e.$){
            case 0:
                return j;
            case 1:
                return A([
                    A2(sN, e.a, A2(fN, 2, n))
                ]);
            default:
                return A([
                    A2(sN, e.a, lN(n))
                ]);
        }
    }), bN = F2(function(n, e) {
        return v(e, Mu(n));
    }), mN = F2(function(n, e) {
        var r, t = n.e5, u = k(n.bo, A([
            $(e, {
                mj: t
            })
        ]));
        return A2(bN, A2(Mr, A2(sN, 100, A2(fN, 1, t)), A2(dN, t, e.fq)), $(n, {
            e5: (r = t, r + 1),
            bo: u
        }));
    }), pN = F2(function(n, e) {
        return A2(mN, n, e);
    }), vN = F2(function(n, e) {
        var r = e.a1;
        return $(e, {
            a1: A2(Ah, Ic(n), r)
        });
    }), gN = F2(function(n, e) {
        return {
            bQ: 0,
            h9: e,
            fc: 0,
            mj: -1,
            be: 1,
            fq: n,
            bj: 0
        };
    }), hN = function(n) {
        return gN(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n));
    }, $N = gN({
        $: 0
    }), xN = A2(Lu, $u, Cn(function() {
        ie.location.reload(true);
    })), kN = function(n) {
        return A2(bN, function(n) {
            var e = n.fq;
            return 2 === e.$ ? A([
                A2(sN, e.a, lN(n.mj))
            ]) : j;
        }(n), $(n, {
            bQ: n.bQ + 1,
            be: 1
        }));
    }, jN = function(n) {
        return v(n, Cc);
    }, yN = function(n) {
        return !n.be || n.bQ > 0 ? jN($(n, {
            bQ: n.bQ - 1
        })) : v(n, A2(Lu, ru, xu(A2(fN, 2, n.mj))));
    }, wN = function(n) {
        return v($(n, {
            bj: 2
        }), A2(sN, n.fc, function(n) {
            return {
                $: 3,
                a: n
            };
        }(n.mj)));
    }, AN = F2(function(n, e) {
        return $(n, {
            bo: e
        });
    }), TN = F2(function(n, e) {
        return jN(A2(AN, e, A2(Ah, function(e) {
            return !s(e.mj, n);
        }, e.bo)));
    }), EN = F3(function(n, e, r) {
        n: for(;;){
            if (r.b) {
                var t = r.a, u = r.b, a = n(t);
                if (a.$) {
                    e = A2(Mr, t, e), r = u;
                    continue n;
                }
                var i = a.a, c = i.a, o = i.b;
                return v(k(xt(e), A2(Mr, c, u)), zr(o));
            }
            return v(xt(e), Ur);
        }
    }), CN = F3(function(n, e, r) {
        var t = r.b;
        return v(n(r.a), e(t));
    }), IN = F3(function(n, e, r) {
        var t = function(r) {
            return s(r.mj, e) ? zr(n(r)) : Ur;
        };
        return A3(CN, AN(r), Nc(Cc), A3(EN, t, j, r.bo));
    }), SN = function(n) {
        return IN(A2(Hu, n, jN));
    }, ON = function(n) {
        switch(n.$){
            case 0:
                switch(n.a){
                    case 1:
                        return A2(SN, function(n) {
                            return $(n, {
                                bj: 1
                            });
                        }, n.b);
                    case 0:
                        return A2(SN, function(n) {
                            return $(n, {
                                bj: 0
                            });
                        }, n.b);
                    default:
                        return A2(IN, wN, n.b);
                }
            case 1:
                return n.a ? A2(IN, kN, n.b) : A2(SN, function(n) {
                    return $(n, {
                        be: 0
                    });
                }, n.b);
            case 2:
                return A2(IN, yN, n.a);
            default:
                return TN(n.a);
        }
    }, LN = F2(function(n, e) {
        return A2(xk, ru, A2(ON, n, e));
    }), PN = F4(function(n, e, r, t) {
        switch(r.$){
            case 0:
                var u = A2(pN, t.bp, (i = r.a).ed ? A2(hN, 5e3, i) : $N(i)), a = u.b;
                return v($(t, {
                    bp: u.a
                }), A2(FT, A2(cc, RT, oN), a));
            case 1:
                return v($(t, {
                    cn: !1
                }), Cc);
            case 2:
                var i;
                return v($(t, {
                    H: A2(Zf, A2(vN, i = r.a, n), e)
                }), Cc);
            case 3:
                return v(t, $I(r.a));
            case 4:
                return v($(t, {
                    cn: !0
                }), Cc);
            case 5:
                return v(t, xN);
            case 6:
                var c = $(n, {
                    a1: j,
                    bH: fI
                });
                return v($(t, {
                    bc: !1,
                    H: A2(Zf, c, e)
                }), A2(HT, RT, gT(PI("La session a \xe9t\xe9 r\xe9initialis\xe9e."))));
            case 7:
                return v(t, $I("/versions/" + r.a + "/#" + A2(Nc, "", t.a6.iD)));
            default:
                var o = A2(LN, r.a, t.bp);
                return a = o.b, v($(t, {
                    bp: o.a
                }), A2(FT, A2(cc, RT, oN), a));
        }
    }), qN = F4(function(n, e, r, t) {
        switch(r.$){
            case 0:
                var u = r.a;
                return e.$ ? v(t, Cc) : A5(XT, t, Cc, Fl, Rl, A3(TI, n, u, e.a));
            case 1:
                return A4(PN, n, e, r.a, t);
            case 2:
                return 1 === e.$ ? A5(XT, t, Cc, Gl, Hl, A3(SS, n, r.a, e.a)) : v(t, Cc);
            case 3:
                return v($(t, {
                    bc: !1
                }), Cc);
            case 4:
            case 11:
                return v(t, Cc);
            case 5:
                return A4(cN, r.a, n, e, t);
            case 6:
                return 2 === e.$ ? A5(XT, t, Cc, Vl, Xl, A3(OS, n, r.a, e.a)) : v(t, Cc);
            case 7:
                return 3 === e.$ ? A5(XT, t, Cc, Jl, ji, A3(mO, n, r.a, e.a)) : v(t, Cc);
            case 8:
                var a = r.a;
                if (4 === e.$) {
                    var i = e.a;
                    return A2(AI, function(n) {
                        switch(n.$){
                            case 0:
                            case 3:
                            case 4:
                            case 7:
                            case 8:
                            case 9:
                            case 17:
                            case 26:
                            case 27:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 39:
                            case 40:
                            case 41:
                            case 42:
                            default:
                                return !0;
                            case 1:
                            case 2:
                            case 5:
                            case 6:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 18:
                            case 19:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                            case 25:
                            case 28:
                            case 29:
                            case 30:
                            case 31:
                            case 32:
                            case 33:
                            case 38:
                            case 43:
                                return !1;
                        }
                    }(a), A5(XT, t, Cc, Yl, yi, A3(KL, n, a, i)));
                }
                return v(t, Cc);
            case 9:
                var c = r.a;
                if (5 === e.$) {
                    var o = e.a;
                    return A2(AI, function(n) {
                        switch(n.$){
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                            case 31:
                            case 32:
                            case 33:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 38:
                            case 46:
                            case 47:
                            case 50:
                            case 51:
                            case 53:
                            default:
                                return !1;
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                            case 25:
                            case 26:
                            case 27:
                            case 28:
                            case 29:
                            case 30:
                            case 39:
                            case 40:
                            case 41:
                            case 42:
                            case 43:
                            case 44:
                            case 45:
                            case 48:
                            case 49:
                            case 52:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                            case 58:
                            case 59:
                            case 60:
                                return !0;
                        }
                    }(c), A5(XT, t, Cc, Wl, wi, A3(Tq, n, c, o)));
                }
                return v(t, Cc);
            case 10:
                return 6 === e.$ ? A5(XT, t, Cc, Bl, Kl, A3(Eq, n, r.a, e.a)) : v(t, Cc);
            case 12:
                return 9 === e.$ ? A5(XT, t, Cc, nd, Zl, A3(Cq, n, r.a, e.a)) : v(t, Cc);
            case 13:
                var f = A2(iI, r.a, n), l = s(n.d1, f.d1) ? e : A2(yI, f, e);
                return v($(t, {
                    H: A2(Zf, f, l)
                }), Cc);
            case 14:
                var d = r.a;
                if (10 === e.$) {
                    var b = e.a;
                    return A2(AI, function(n) {
                        switch(n.$){
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 19:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                            case 25:
                            case 26:
                            case 30:
                            case 34:
                            case 35:
                            case 42:
                            case 49:
                                return !1;
                            default:
                                return !0;
                        }
                    }(d), A5(XT, t, Cc, ed, Ti, A3(rN, n, d, b)));
                }
                return v(t, Cc);
            case 15:
                return A2(xI, function(e) {
                    return Mu(A([
                        e,
                        A2(Dl, n, es(m))
                    ]));
                }, A4(VT, m = r.a, n, e, v($(t, {
                    cn: !1,
                    a6: m
                }), Cc)));
            case 16:
                var m;
                return r.a.$ ? v(t, $I(r.a.a)) : v($(t, {
                    a6: m = r.a.a
                }), A2(AT, n.na, Sl(m)));
            case 17:
                return v(t, gi(_u));
            default:
                return v($(t, {
                    H: A2(Zf, $(n, {
                        ld: A2(iN, n.ld, r.a)
                    }), e)
                }), Cc);
        }
    }), NN = F2(function(n, e) {
        var r = e.H;
        switch(r.$){
            case 0:
                return v(e, Cc);
            case 1:
                return A2(hI, n, e);
            default:
                var t = r.a;
                return A2(Wf, t, A4(qN, t, r.b, n, e));
        }
    }), _N = {
        $: 0
    }, zN = {
        $: 1
    }, UN = function(n) {
        return {
            $: 2,
            a: n
        };
    }, MN = {
        $: 3
    }, DN = {
        $: 4
    }, RN = function(n) {
        return {
            $: 5,
            a: n
        };
    }, FN = {
        $: 6
    }, HN = {
        $: 7
    }, GN = {
        $: 8
    }, XN = {
        $: 9
    }, VN = fe("a"), JN = F2(function(n, e) {
        return A2(pe, n, Sc(e));
    }), YN = JN("className"), WN = fe("div"), KN = function(n) {
        return WN(A2(Mr, YN("container"), n));
    }, BN = fe("h1"), QN = function(n) {
        var e;
        return A2(JN, "href", $e.test(e = n) ? "" : e);
    }, ZN = function(n) {
        return QN(_T(n));
    }, n_ = F2(function(n, e) {
        return A2(ve, function(n) {
            return he.test(n) ? "data-" + n : n;
        }(n), je(e));
    }), e_ = fe("button"), r_ = function(n) {
        return YN(A2(at, " ", A2(wu, Xt, A2(Ah, Gh, n))));
    }, t_ = fe("h3"), u_ = be, a_ = F2(function(n, e) {
        return A2(u_, n, function(n) {
            return {
                $: 0,
                a: n
            };
        }(e));
    }), i_ = function(n) {
        return A2(a_, "click", nu(n));
    }, c_ = oe, o_ = JN("type"), f_ = function(n) {
        var e = n.h4, r = n.h9, t = n.ed, u = n.eG;
        return A2(WN, k(n.hS, k(A([
            YN("fr-alert shadow-sm"),
            r_(A([
                v("fr-alert--success", 2 === t),
                v("fr-alert--info", 1 === t),
                v("fr-alert--warning", 3 === t),
                v("fr-alert--error", !t)
            ])),
            A2(n_, "aria-atomic", "true")
        ]), A(t && 3 !== t ? [
            A2(n_, "role", "status"),
            A2(n_, "aria-live", "polite")
        ] : [
            A2(n_, "role", "alert"),
            A2(n_, "aria-live", "assertive")
        ]))), A([
            function() {
                if (u.$) return c_("");
                var n = u.a;
                return A2(t_, A([
                    YN("h5 mb-2")
                ]), A([
                    c_(n)
                ]));
            }(),
            A2(WN, A([
                YN("mb-1")
            ]), r),
            function() {
                if (e.$) return c_("");
                var n = e.a;
                return A2(e_, A([
                    o_("button"),
                    YN("fr-link fr-link--close"),
                    A2(n_, "aria-label", "Fermer"),
                    i_(n)
                ]), A([
                    c_("Masquer le message")
                ]));
            }()
        ]));
    }, s_ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, l_ = fe("i"), d_ = function(n) {
        return A2(l_, A([
            A2(n_, "aria-hidden", "true"),
            YN("icon icon-" + n)
        ]), j);
    }, b_ = d_("info"), m_ = fe("span"), p_ = F2(function(n, e) {
        return A2(WN, A2(Mr, YN("page-notice shadow-inner-top"), A2(Mr, A2(n_, "role", "notice"), n)), A([
            A2(WN, A([
                YN("container px-4")
            ]), A([
                A2(m_, A([
                    YN("d-flex align-items-center gap-1")
                ]), e)
            ]))
        ]));
    }), v_ = p_(A([
        YN("page-notice-info")
    ])), g_ = A2(Hu, it("\n\n"), A2(Hu, wu(mf), at("\n\n"))), h_ = function(n) {
        return "Problem at row " + ut(n.oi) + "\n" + function(n) {
            switch(n.$){
                case 0:
                    return "Expecting " + n.a;
                case 1:
                    return "Expecting int";
                case 2:
                    return "Expecting hex";
                case 3:
                    return "Expecting octal";
                case 4:
                    return "Expecting binary";
                case 5:
                    return "Expecting float";
                case 6:
                    return "Expecting number";
                case 7:
                    return "Expecting variable";
                case 8:
                    return "Expecting symbol " + n.a;
                case 9:
                    return "Expecting keyword " + n.a;
                case 10:
                    return "Expecting keyword end";
                case 11:
                    return "Unexpected char";
                case 12:
                    return n.a;
                default:
                    return "Bad repeat";
            }
        }(n.nS);
    }, $_ = JN("align"), x_ = JN("alt"), k_ = fe("blockquote"), j_ = fe("br"), y_ = F2(function(n, e) {
        return A2(pe, n, _c(e));
    }), w_ = y_("checked"), A_ = fe("code"), T_ = fe("del"), E_ = y_("disabled"), C_ = fe("em"), I_ = fe("h2"), S_ = fe("h4"), O_ = fe("h5"), L_ = fe("h6"), P_ = fe("hr"), q_ = fe("img"), N_ = fe("input"), __ = fe("li"), z_ = fe("ol"), U_ = F2(function(n, e) {
        return 1 === n.$ ? e.$ ? Yr(A2(Mr, n.a, e.a)) : Qr(e.a) : Qr(n.a);
    }), M_ = F2(function(n, e) {
        return sf(e) ? "<" + n + ">" : "<" + n + " " + function(n) {
            return A2(at, " ", A2(wu, function(n) {
                return n.ek + '="' + n.eT + '"';
            }, n));
        }(e) + ">";
    }), D_ = fe("p"), R_ = fe("pre"), F_ = function(n) {
        return A2(JN, "src", je(n));
    }, H_ = fe("strong"), G_ = fe("table"), X_ = fe("tbody"), V_ = fe("td"), J_ = fe("th"), Y_ = fe("thead"), W_ = JN("title"), K_ = fe("tr"), B_ = fe("ul"), Q_ = function(n) {
        return A(n.trim().split(/\s+/g));
    }, Z_ = {
        gb: k_(j),
        gf: function(n) {
            var e, r = n.kO, t = !(e = A2(Pc, Q_, n.mH)).$ && e.a.b ? A([
                YN("language-" + e.a.a)
            ]) : j;
            return A2(R_, j, A([
                A2(A_, t, A([
                    c_(r)
                ]))
            ]));
        },
        gg: function(n) {
            return A2(A_, j, A([
                c_(n)
            ]));
        },
        gs: function(n) {
            return A2(C_, j, n);
        },
        gA: A2(j_, j, j),
        gC: function(n) {
            var e = n.kV;
            switch(n.ed){
                case 0:
                    return A2(BN, j, e);
                case 1:
                    return A2(I_, j, e);
                case 2:
                    return A2(t_, j, e);
                case 3:
                    return A2(S_, j, e);
                case 4:
                    return A2(O_, j, e);
                default:
                    return A2(L_, j, e);
            }
        },
        gE: (fO = j, lO = A2(wu, function(n) {
            return n;
        }, fO), sO = A3(ot, F2(function(n, e) {
            return F3(function(r, t, u) {
                return A2(U_, A3(n, r, t, u), A3(e, r, t, u));
            });
        }), F3(function() {
            return Yr(j);
        }), lO), F3(function(n, e, r) {
            return A2($a, function(r) {
                if (r.b) {
                    if (r.b.b) return "oneOf failed parsing this value:\n    " + A2(M_, n, e) + "\n\nParsing failed in the following 2 ways:\n\n\n" + A2(at, "\n\n", A2(bt, F2(function(n, e) {
                        return "(" + ut(n + 1) + ") " + e;
                    }), r)) + "\n";
                    var t = r.a;
                    return "Problem with the given value:\n\n" + A2(M_, n, e) + "\n\n" + t + "\n";
                }
                return "Ran into a oneOf with no possibilities!";
            }, A3(sO, n, e, r));
        })),
        gF: function(n) {
            var e = n.eG;
            if (e.$) return A2(q_, A([
                F_(n.hf),
                x_(n.f8)
            ]), j);
            var r = e.a;
            return A2(q_, A([
                F_(n.hf),
                x_(n.f8),
                W_(r)
            ]), j);
        },
        dj: F2(function(n, e) {
            var r = n.eG;
            if (r.$) return A2(VN, A([
                QN(n.lt)
            ]), e);
            var t = r.a;
            return A2(VN, A([
                QN(n.lt),
                W_(t)
            ]), e);
        }),
        gX: F2(function(n, e) {
            var r;
            return A2(z_, 1 === n ? A([
                (r = n, A2(JN, "start", ut(r)))
            ]) : j, A2(wu, function(n) {
                return A2(__, j, n);
            }, e));
        }),
        gZ: D_(j),
        hh: function(n) {
            return A2(T_, j, n);
        },
        hi: function(n) {
            return A2(H_, j, n);
        },
        hm: G_(j),
        hn: X_(j),
        ho: function(n) {
            return V_(A2(Nc, j, A2(Pc, ck, A2(Pc, $_, A2(Pc, function(n) {
                switch(n){
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, n)))));
        },
        hp: Y_(j),
        hq: function(n) {
            return J_(A2(Nc, j, A2(Pc, ck, A2(Pc, $_, A2(Pc, function(n) {
                switch(n){
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, n)))));
        },
        fP: K_(j),
        z: c_,
        hu: A2(P_, j, j),
        hC: function(n) {
            return A2(B_, j, A2(wu, function(n) {
                var e = n.a, r = n.b, t = function() {
                    switch(e){
                        case 0:
                            return c_("");
                        case 1:
                            return A2(N_, A([
                                E_(!0),
                                w_(!1),
                                o_("checkbox")
                            ]), j);
                        default:
                            return A2(N_, A([
                                E_(!0),
                                w_(!0),
                                o_("checkbox")
                            ]), j);
                    }
                }();
                return A2(__, j, A2(Mr, t, r));
            }, n));
        }
    }, nz = {
        $: 10
    }, ez = function(n) {
        return {
            $: 11,
            a: n
        };
    }, rz = function(n) {
        return {
            $: 4,
            a: n
        };
    }, tz = function(n) {
        return {
            $: 7,
            a: n
        };
    }, uz = function(n) {
        return {
            $: 5,
            a: n
        };
    }, az = function(n) {
        return {
            $: 3,
            a: n
        };
    }, iz = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), cz = {
        $: 0
    }, oz = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fz = {
        $: 8
    }, sz = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), lz = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), dz = function(n) {
        return {
            $: 2,
            a: n
        };
    }, bz = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pz = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), vz = F3(function(n, e, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r
        };
    }), gz = F3(function(n, e, r) {
        return {
            $: 2,
            a: n,
            b: e,
            c: r
        };
    }), hz = function(n) {
        return {
            $: 6,
            a: n
        };
    }, $z = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xz = F3(function(n, e, r) {
        return {
            $: 1,
            a: n,
            b: e,
            c: r
        };
    }), kz = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), jz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yz = F3(function(n, e, r) {
        return {
            $: 2,
            a: n,
            b: e,
            c: r
        };
    }), wz = F6(function(n, e, r, t, u, a) {
        return {
            $: 4,
            a: n,
            b: e,
            c: r,
            d: t,
            e: u,
            f: a
        };
    }), Az = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Tz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ez = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Cz = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Iz = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Sz = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), Oz = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Lz = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Pz = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), qz = {
        $: 8
    }, Nz = {
        $: 7
    }, _z = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), zz = F4(function(n, e, r, t) {
        return {
            $: 3,
            a: n,
            b: e,
            c: r,
            d: t
        };
    }), Uz = F2(function(n, e) {
        return {
            a: A2(Mr, e, n.a),
            b: n.b
        };
    }), Mz = function(n) {
        var e = n;
        return function(n) {
            var r = e(n);
            return 1 === r.$ ? A2(Up, !1, r.b) : A3(Mp, !1, r.b, r.c);
        };
    }, Dz = function(n) {
        switch(n){
            case " ":
            case "\t":
                return !0;
            default:
                return !1;
        }
    }, Rz = A2(Lv, "\r", oz("a carriage return")), Fz = A2(Lv, "\n", oz("a newline")), Hz = vv(A([
        qv(Fz),
        A2(sv, qv(Rz), vv(A([
            qv(Fz),
            av(0)
        ])))
    ])), Gz = A2(wv, function() {
        return nz;
    }, A2(sv, Mz(Bp(Dz)), Hz)), Xz = A2(Lv, " ", oz("a space")), Vz = A([
        Nv(A2(Lv, ">", oz(">"))),
        A2(sv, Mz(Nv(Xz)), vv(A([
            Nv(A2(Lv, ">", oz(" >"))),
            Nv(A2(Lv, " >", oz("  >"))),
            Nv(A2(Lv, "  >", oz("   >")))
        ])))
    ]), Jz = function(n) {
        switch(n){
            case "\n":
            case "\r":
                return !0;
            default:
                return !1;
        }
    }, Yz = Bp(A2(cc, rl, Jz)), Wz = Jp(oz("the end of the input")), Kz = vv(A([
        Hz,
        Wz
    ])), Bz = A2(dv, A2(sv, A2(sv, av(ez), vv(Vz)), vv(A([
        Nv(Xz),
        av(0)
    ]))), A2(sv, nv(Yz), Kz)), Qz = function(n) {
        return A2(at, "\n", A2(wu, h_, n));
    }, Zz = function(n) {
        n: for(;;)switch(n.$){
            case 1:
                return !A2(Hd, n.a, "\n");
            case 12:
                if ((r = n.a).b) {
                    n = r.a;
                    continue n;
                }
                return !1;
            case 4:
                var e = n.e;
                if (e.b) {
                    var r;
                    if ((r = e.a).b) {
                        n = r.a;
                        continue n;
                    }
                    return !1;
                }
                return !1;
            case 0:
                return !0;
            default:
                return !1;
        }
    }, nU = function(n) {
        return {
            $: 3,
            a: n
        };
    }, eU = F3(function(n, e, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r
        };
    }), rU = oz("at least 1 tag name character"), tU = function(n) {
        switch(n){
            case " ":
            case "\r":
            case "\n":
            case "\t":
            case "/":
            case "<":
            case ">":
            case '"':
            case "'":
            case "=":
                return !1;
            default:
                return !0;
        }
    }, uU = A2(Zp, F2(function(n) {
        return Ss(n);
    }), A2(sv, A2(kv, tU, rU), Bp(tU))), aU = uU, iU = function(n) {
        return qv(A2(Lv, n, Ov(n)));
    }, cU = Mi(A([
        v("amp", "&"),
        v("lt", "<"),
        v("gt", ">"),
        v("apos", "'"),
        v("quot", '"')
    ])), oU = F3(function(n, e, r) {
        n: for(;;){
            if (!e.b) return Qr(r);
            var t = e.a, u = e.b;
            switch(t){
                case "0":
                    n = a = n - 1, e = i = u, r = c = r;
                    continue n;
                case "1":
                    var a = n - 1, i = u, c = r + A2(Gk, 16, n);
                    n = a, e = i, r = c;
                    continue n;
                case "2":
                    a = n - 1, i = u, c = r + 2 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "3":
                    a = n - 1, i = u, c = r + 3 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "4":
                    a = n - 1, i = u, c = r + 4 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "5":
                    a = n - 1, i = u, c = r + 5 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "6":
                    a = n - 1, i = u, c = r + 6 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "7":
                    a = n - 1, i = u, c = r + 7 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "8":
                    a = n - 1, i = u, c = r + 8 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "9":
                    a = n - 1, i = u, c = r + 9 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "a":
                    a = n - 1, i = u, c = r + 10 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "b":
                    a = n - 1, i = u, c = r + 11 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "c":
                    a = n - 1, i = u, c = r + 12 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "d":
                    a = n - 1, i = u, c = r + 13 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "e":
                    a = n - 1, i = u, c = r + 14 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "f":
                    a = n - 1, i = u, c = r + 15 * A2(Gk, 16, n), n = a, e = i, r = c;
                    continue n;
                default:
                    return Yr(Jc(t) + " is not a valid hexadecimal character.");
            }
        }
    }), fU = function(n) {
        var e = function(n) {
            var e, r = A2(gu, "#x", e = n) ? A2($a, rv, A2(fs, Nd, function(n) {
                if (su(n)) return Yr("Empty strings are not valid hexadecimal strings.");
                var e = function() {
                    if (A2(gu, "-", n)) {
                        var e = A2(Nc, j, jk(lg(n)));
                        return A2(fs, eo, A3(oU, ft(e) - 1, e, 0));
                    }
                    return A3(oU, iu(n) - 1, lg(n), 0);
                }();
                return A2($a, function(e) {
                    return A2(at, " ", A([
                        '"' + n + '"',
                        "is not a valid hexadecimal string because",
                        e
                    ]));
                }, e);
            }(A2(ou, 2, e)))) : A2(gu, "#", e) ? A2(ks, rv("Invalid escaped character: " + e), A2(Pc, Nd, du(A2(ou, 1, e)))) : A2(ks, rv('No entity named "&' + e + ';" found.'), A2(ra, e, cU));
            return r.$ ? tv(r.a) : av(r.a);
        }, r = function(e) {
            return !s(e, n) && ";" !== e;
        };
        return A2(dv, A2(sv, av(ru), iU("&")), A2(sv, A2(Dp, e, nv(A2(sv, A2(kv, r, oz("an entity character")), Bp(r)))), iU(";")));
    }, sU = F3(function(n, e, r) {
        return A2(Dp, function(e) {
            return vv(A([
                A2(wv, function(n) {
                    return Ev(k(r, k(e, Jc(n))));
                }, fU(n)),
                av(Tv(k(r, e)))
            ]));
        }, nv(Bp(e)));
    }), lU = function(n) {
        return A2(yv, "", A2(sU, n, function(e) {
            return !s(e, n) && "&" !== e;
        }));
    }, dU = vv(A([
        A2(dv, A2(sv, av(ru), iU('"')), A2(sv, lU('"'), iU('"'))),
        A2(dv, A2(sv, av(ru), iU("'")), A2(sv, lU("'"), iU("'")))
    ])), bU = F2(function(n, e) {
        return zr(e.$ ? n : e.a);
    }), mU = function(n) {
        switch(n){
            case " ":
            case "\r":
            case "\n":
            case "\t":
                return !0;
            default:
                return !1;
        }
    }, pU = Bp(mU), vU = function(n) {
        var e = F2(function(e, r) {
            return Ev(A3(ma, Ss(e), bU(r), n));
        });
        return vv(A([
            A2(dv, A2(dv, av(e), A2(sv, A2(sv, A2(sv, aU, pU), iU("=")), pU)), A2(sv, dU, pU)),
            av(Tv(n))
        ]));
    }, gU = A2(wv, A2(Di, F3(function(n, e, r) {
        return A2(Mr, {
            ek: n,
            eT: e
        }, r);
    }), j), A2(yv, Qu, vU)), hU = function(n) {
        return function(e) {
            var r = A5(jr, n, e.h, e.oi, e.h5, e.hf), t = r.a, u = r.b, a = r.c, i = 0 > t ? iu(e.hf) : t;
            return A3(Mp, 0 > m(e.h, i), 0, {
                h5: a,
                k2: e.k2,
                v: e.v,
                h: i,
                oi: u,
                hf: e.hf
            });
        };
    }, $U = A2(dv, A2(sv, av(ru), iU("<![CDATA[")), A2(sv, nv(hU("]]>")), iU("]]>"))), xU = F2(function(n, e) {
        return A2(wv, function(n) {
            return n(e);
        }, vv(n));
    }), kU = function(n) {
        var e = A2(Dp, function(e) {
            return s(n, e) ? av(0) : tv(rv("tag name mismatch: " + n + " and " + e));
        }, uU);
        return A2(sv, A2(sv, A2(sv, A2(sv, iU("</"), pU), e), pU), iU(">"));
    }, jU = function(n) {
        return A2(Lv, n, oz(n));
    }, yU = A2(dv, A2(sv, av(function(n) {
        return {
            $: 2,
            a: n
        };
    }), qv(jU("\x3c!--"))), A2(sv, nv(hU("--\x3e")), qv(jU("--\x3e")))), wU = F2(function(n, e) {
        return {
            $: 5,
            a: n,
            b: e
        };
    }), AU = oz("at least 1 uppercase character"), TU = nv(A2(sv, A2(kv, vt, AU), Bp(vt))), EU = A2(sv, A2(kv, mU, oz("at least one whitespace")), Bp(mU)), CU = A2(dv, A2(dv, A2(sv, av(wU), iU("<!")), A2(sv, TU, EU)), A2(sv, nv(hU(">")), iU(">"))), IU = A2(dv, A2(sv, av(function(n) {
        return {
            $: 4,
            a: n
        };
    }), iU("<?")), A2(sv, nv(hU("?>")), iU("?>"))), SU = function(n) {
        switch(n){
            case "<":
            case "&":
                return !1;
            default:
                return !0;
        }
    }, OU = A([
        A2(wv, function() {
            return Ev(0);
        }, A2(sv, A2(kv, SU, oz("is not & or <")), Bp(SU))),
        A2(wv, function() {
            return Ev(0);
        }, fU("<")),
        av(Tv(0))
    ]), LU = nv(A2(yv, 0, function() {
        return vv(OU);
    })), PU = function(n) {
        return A2(yv, j, xU(qU(n)));
    }, qU = function(n) {
        return A([
            A2(wv, F2(function(n, e) {
                return Tv(xt(e));
            }), kU(n)),
            A2(Dp, function(e) {
                return su(e) ? A2(wv, F2(function(n, e) {
                    return Tv(xt(e));
                }), kU(n)) : av(function(n) {
                    return Ev(A2(Mr, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(e), n));
                });
            }, LU),
            A2(wv, F2(function(n, e) {
                return Ev(A2(Mr, n, e));
            }), _U())
        ]);
    }, NU = function(n) {
        return A2(dv, A2(dv, A2(sv, av(eU(n)), pU), A2(sv, gU, pU)), vv(A([
            A2(wv, function() {
                return j;
            }, iU("/>")),
            A2(dv, A2(sv, av(ru), iU(">")), PU(n))
        ])));
    };
    function _U() {
        return vv(A([
            A2(wv, nU, $U),
            IU,
            yU,
            CU,
            zU()
        ]));
    }
    function zU() {
        return A2(dv, A2(sv, av(ru), iU("<")), A2(Dp, NU, uU));
    }
    var UU = _U();
    _U = function() {
        return UU;
    };
    var MU = zU();
    zU = function() {
        return MU;
    };
    var DU, RU, FU, HU = A2(Lv, "\t", oz("a tab")), GU = vv(A([
        Nv(HU),
        A2(sv, Mz(Nv(Xz)), vv(A([
            Nv(A2(Lv, "   ", Ov("Indentation"))),
            Nv(A2(Lv, " \t", Ov("Indentation"))),
            Nv(A2(Lv, "  \t", Ov("Indentation")))
        ])))
    ])), XU = A2(dv, A2(sv, av(hz), GU), A2(sv, nv(Yz), Kz)), VU = function(n) {
        return !A2(Uc, 2, n);
    }, JU = function(n) {
        return n ? 1 : 0;
    }, YU = F3(function(n, e, r) {
        var t = v(e, r);
        return "" === t.a ? r : "" === t.b ? e : k(e, k(n, r));
    }), WU = F2(function(n, e) {
        return n + "\n" + e;
    }), KU = A2(Zp, F2(function(n) {
        return jz(n);
    }), Yz), BU = A2(sv, KU, Kz), QU = F4(function(n, e, r, t) {
        return {
            kO: t,
            mu: e,
            mY: r,
            nH: n
        };
    }), ZU = function(n) {
        return A3(Mp, !1, n.h5, n);
    }, nM = A2(dv, av(function(n) {
        return v(n, "");
    }), A2(sv, ZU, Kz)), eM = function(n) {
        return A2(sv, A2(kv, n, rv("Expected one or more character")), Bp(n));
    }, rM = A2(dv, A2(dv, A2(sv, av(F2(function(n, e) {
        return v(n, e);
    })), eM(Dz)), ZU), A2(sv, nv(Yz), Kz)), tM = A2(Lv, ")", oz("a `)`")), uM = A2(Lv, ".", oz("a `.`")), aM = vv(A([
        A2(sv, av(0), Nv(uM)),
        A2(sv, av(1), Nv(tM))
    ])), iM = A2(Zp, F2(function(n) {
        return A2(Nc, 0, du(n));
    }), eM(ht)), cM = A2(Dp, function(n) {
        return n > 999999999 ? tv(rv("Starting numbers must be nine digits or less.")) : av(n);
    }, iM), oM = qv(Xz), fM = F2(function(n, e) {
        var r = A2(Y$, n, e);
        if (r.b) {
            var t = r.a, u = r.b;
            return A3(ot, F2(function(n, e) {
                return vv(A([
                    A2(sv, n, e),
                    av(0)
                ]));
            }), vv(A([
                t,
                av(0)
            ])), u);
        }
        return av(0);
    }), sM = function(n) {
        return 1 === n ? av(n) : tv(rv("Lists inside a paragraph or after a paragraph without a blank line must start with 1"));
    }, lM = function(n) {
        return A2(wv, function(n) {
            return A6(wz, !0, n.mu, n.mY, n.nH, j, n.kO);
        }, function(n) {
            return A2(dv, A2(dv, A2(dv, A2(dv, A2(dv, av(F5(function(n, e, r, t, u) {
                var a = u.a, i = u.b;
                return a - t > 4 ? A4(QU, e, t - n + 1, r, k(A2(Wc, a - t - 1, " "), i)) : A4(QU, e, a - n, r, i);
            })), ZU), Mz(function(n) {
                return n ? A2(Dp, sM, A2(dv, A2(sv, av(ru), A2(fM, 3, oM)), cM)) : A2(dv, A2(sv, av(ru), A2(fM, 3, oM)), cM);
            }(n))), Mz(aM)), ZU), n ? rM : vv(A([
                nM,
                rM
            ])));
        }(n));
    }, dM = {
        $: 1
    }, bM = F3(function(n, e, r) {
        return {
            $: 4,
            a: n,
            b: e,
            c: r
        };
    }), mM = F3(function(n, e, r) {
        return {
            $: 3,
            a: n,
            b: e,
            c: r
        };
    }), pM = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vM = function(n) {
        var e = n, r = e.G;
        switch(r.$){
            case 0:
                return pM(e.z);
            case 1:
                return dM;
            case 2:
                return function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(e.z);
            case 3:
                var t = r.a;
                return A3(mM, t.b, Ur, A([
                    pM(t.a)
                ]));
            case 4:
                var u = r.a;
                return A3(mM, u.a, u.b, gM(e.T));
            case 5:
                var a = r.a;
                return A3(bM, a.a, a.b, gM(e.T));
            case 6:
                return function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(r.a);
            case 7:
                return A2(iz, r.a, gM(e.T));
            default:
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(gM(e.T));
        }
    }, gM = function(n) {
        return A2(wu, vM, n);
    }, hM = F2(function(n, e) {
        return {
            s: e.s - n.X,
            T: e.T,
            w: e.w - n.X,
            z: e.z,
            aw: e.aw - n.X,
            X: e.X - n.X,
            G: e.G
        };
    }), $M = F2(function(n, e) {
        return {
            s: n.s,
            T: A2(Mr, A2(hM, n, e), n.T),
            w: n.w,
            z: n.z,
            aw: n.aw,
            X: n.X,
            G: n.G
        };
    }), xM = function(n) {
        var e = n;
        return {
            s: e.s,
            T: kM(e.T),
            w: e.w,
            z: e.z,
            aw: e.aw,
            X: e.X,
            G: e.G
        };
    }, kM = function(n) {
        var e = A2(LA, function(n) {
            return n.w;
        }, n);
        return e.b ? A3(jM, e.b, e.a, j) : j;
    }, jM = F3(function(n, e, r) {
        for(;;){
            var t = e;
            if (!n.b) return A2(Mr, xM(t), r);
            var u = n.a, a = n.b;
            1 > m(t.s, u.w) ? (n = a, e = u, r = A2(Mr, xM(t), r)) : 0 > m(t.w, u.w) && m(t.s, u.s) > 0 ? (n = a, e = A2($M, t, u)) : (n = a, e = t);
        }
    }), yM = {
        $: 0
    }, wM = A2(Nc, Cs, Es("&#([0-9]{1,8});")), AM = function(n) {
        return function(n) {
            return 9 === n || 10 === n || 13 === n || 133 === n || n >= 32 && 126 >= n || n >= 160 && 55295 >= n || n >= 57344 && 64975 >= n || n >= 65008 && 65533 >= n || n >= 65536 && 1114109 >= n;
        }(n) && !function(n) {
            var e = A2(Uc, 16, n), r = A2(Uc, 131070, n);
            return !(131070 > n || (0 > r || r > 15) && (65536 > r || r > 65551) || 14 !== e && 15 !== e);
        }(n) ? Jc(Nd(n)) : Jc(Nd(65533));
    }, TM = A2(zk, wM, function(n) {
        var e = n.oN;
        if (e.b && !e.a.$) {
            var r = du(e.a.a);
            return r.$ ? n.eg : AM(r.a);
        }
        return n.eg;
    }), EM = A2(Nc, Cs, Es("&([0-9a-zA-Z]+);")), CM = Mi(A([
        v("quot", 34),
        v("amp", 38),
        v("apos", 39),
        v("lt", 60),
        v("gt", 62),
        v("nbsp", 160),
        v("iexcl", 161),
        v("cent", 162),
        v("pound", 163),
        v("curren", 164),
        v("yen", 165),
        v("brvbar", 166),
        v("sect", 167),
        v("uml", 168),
        v("copy", 169),
        v("ordf", 170),
        v("laquo", 171),
        v("not", 172),
        v("shy", 173),
        v("reg", 174),
        v("macr", 175),
        v("deg", 176),
        v("plusmn", 177),
        v("sup2", 178),
        v("sup3", 179),
        v("acute", 180),
        v("micro", 181),
        v("para", 182),
        v("middot", 183),
        v("cedil", 184),
        v("sup1", 185),
        v("ordm", 186),
        v("raquo", 187),
        v("frac14", 188),
        v("frac12", 189),
        v("frac34", 190),
        v("iquest", 191),
        v("Agrave", 192),
        v("Aacute", 193),
        v("Acirc", 194),
        v("Atilde", 195),
        v("Auml", 196),
        v("Aring", 197),
        v("AElig", 198),
        v("Ccedil", 199),
        v("Egrave", 200),
        v("Eacute", 201),
        v("Ecirc", 202),
        v("Euml", 203),
        v("Igrave", 204),
        v("Iacute", 205),
        v("Icirc", 206),
        v("Iuml", 207),
        v("ETH", 208),
        v("Ntilde", 209),
        v("Ograve", 210),
        v("Oacute", 211),
        v("Ocirc", 212),
        v("Otilde", 213),
        v("Ouml", 214),
        v("times", 215),
        v("Oslash", 216),
        v("Ugrave", 217),
        v("Uacute", 218),
        v("Ucirc", 219),
        v("Uuml", 220),
        v("Yacute", 221),
        v("THORN", 222),
        v("szlig", 223),
        v("agrave", 224),
        v("aacute", 225),
        v("acirc", 226),
        v("atilde", 227),
        v("auml", 228),
        v("aring", 229),
        v("aelig", 230),
        v("ccedil", 231),
        v("egrave", 232),
        v("eacute", 233),
        v("ecirc", 234),
        v("euml", 235),
        v("igrave", 236),
        v("iacute", 237),
        v("icirc", 238),
        v("iuml", 239),
        v("eth", 240),
        v("ntilde", 241),
        v("ograve", 242),
        v("oacute", 243),
        v("ocirc", 244),
        v("otilde", 245),
        v("ouml", 246),
        v("divide", 247),
        v("oslash", 248),
        v("ugrave", 249),
        v("uacute", 250),
        v("ucirc", 251),
        v("uuml", 252),
        v("yacute", 253),
        v("thorn", 254),
        v("yuml", 255),
        v("OElig", 338),
        v("oelig", 339),
        v("Scaron", 352),
        v("scaron", 353),
        v("Yuml", 376),
        v("fnof", 402),
        v("circ", 710),
        v("tilde", 732),
        v("Alpha", 913),
        v("Beta", 914),
        v("Gamma", 915),
        v("Delta", 916),
        v("Epsilon", 917),
        v("Zeta", 918),
        v("Eta", 919),
        v("Theta", 920),
        v("Iota", 921),
        v("Kappa", 922),
        v("Lambda", 923),
        v("Mu", 924),
        v("Nu", 925),
        v("Xi", 926),
        v("Omicron", 927),
        v("Pi", 928),
        v("Rho", 929),
        v("Sigma", 931),
        v("Tau", 932),
        v("Upsilon", 933),
        v("Phi", 934),
        v("Chi", 935),
        v("Psi", 936),
        v("Omega", 937),
        v("alpha", 945),
        v("beta", 946),
        v("gamma", 947),
        v("delta", 948),
        v("epsilon", 949),
        v("zeta", 950),
        v("eta", 951),
        v("theta", 952),
        v("iota", 953),
        v("kappa", 954),
        v("lambda", 955),
        v("mu", 956),
        v("nu", 957),
        v("xi", 958),
        v("omicron", 959),
        v("pi", 960),
        v("rho", 961),
        v("sigmaf", 962),
        v("sigma", 963),
        v("tau", 964),
        v("upsilon", 965),
        v("phi", 966),
        v("chi", 967),
        v("psi", 968),
        v("omega", 969),
        v("thetasym", 977),
        v("upsih", 978),
        v("piv", 982),
        v("ensp", 8194),
        v("emsp", 8195),
        v("thinsp", 8201),
        v("zwnj", 8204),
        v("zwj", 8205),
        v("lrm", 8206),
        v("rlm", 8207),
        v("ndash", 8211),
        v("mdash", 8212),
        v("lsquo", 8216),
        v("rsquo", 8217),
        v("sbquo", 8218),
        v("ldquo", 8220),
        v("rdquo", 8221),
        v("bdquo", 8222),
        v("dagger", 8224),
        v("Dagger", 8225),
        v("bull", 8226),
        v("hellip", 8230),
        v("permil", 8240),
        v("prime", 8242),
        v("Prime", 8243),
        v("lsaquo", 8249),
        v("rsaquo", 8250),
        v("oline", 8254),
        v("frasl", 8260),
        v("euro", 8364),
        v("image", 8465),
        v("weierp", 8472),
        v("real", 8476),
        v("trade", 8482),
        v("alefsym", 8501),
        v("larr", 8592),
        v("uarr", 8593),
        v("rarr", 8594),
        v("darr", 8595),
        v("harr", 8596),
        v("crarr", 8629),
        v("lArr", 8656),
        v("uArr", 8657),
        v("rArr", 8658),
        v("dArr", 8659),
        v("hArr", 8660),
        v("forall", 8704),
        v("part", 8706),
        v("exist", 8707),
        v("empty", 8709),
        v("nabla", 8711),
        v("isin", 8712),
        v("notin", 8713),
        v("ni", 8715),
        v("prod", 8719),
        v("sum", 8721),
        v("minus", 8722),
        v("lowast", 8727),
        v("radic", 8730),
        v("prop", 8733),
        v("infin", 8734),
        v("ang", 8736),
        v("and", 8743),
        v("or", 8744),
        v("cap", 8745),
        v("cup", 8746),
        v("int", 8747),
        v("there4", 8756),
        v("sim", 8764),
        v("cong", 8773),
        v("asymp", 8776),
        v("ne", 8800),
        v("equiv", 8801),
        v("le", 8804),
        v("ge", 8805),
        v("sub", 8834),
        v("sup", 8835),
        v("nsub", 8836),
        v("sube", 8838),
        v("supe", 8839),
        v("oplus", 8853),
        v("otimes", 8855),
        v("perp", 8869),
        v("sdot", 8901),
        v("lceil", 8968),
        v("rceil", 8969),
        v("lfloor", 8970),
        v("rfloor", 8971),
        v("lang", 9001),
        v("rang", 9002),
        v("loz", 9674),
        v("spades", 9824),
        v("clubs", 9827),
        v("hearts", 9829),
        v("diams", 9830)
    ])), IM = A2(zk, EM, function(n) {
        var e = n.oN;
        if (e.b && !e.a.$) {
            var r = A2(ra, e.a.a, CM);
            return r.$ ? n.eg : Jc(Nd(r.a));
        }
        return n.eg;
    }), SM = A2(zk, A2(Nc, Cs, Es("(\\\\+)([!\"#$%&\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])")), function(n) {
        var e = n.oN;
        if (e.b && !e.a.$ && e.b.b && !e.b.a.$) {
            var r = e.b.a.a;
            return k(A2(Wc, iu(e.a.a) / 2 | 0, "\\"), r);
        }
        return n.eg;
    }), OM = A2(zk, A2(Nc, Cs, Es("&#[Xx]([0-9a-fA-F]{1,8});")), function(n) {
        var e, r = n.oN;
        return r.b && !r.a.$ ? AM((e = r.a.a, A3(Dd, F2(function(n, e) {
            return 16 * e + A2(Uc, 39, mt(n)) - 9;
        }), 0, Ss(e)))) : n.eg;
    }), LM = function(n) {
        var e = SM(n);
        return A2(au, "&", e) ? OM(TM(IM(e))) : e;
    }, PM = function(n) {
        return {
            s: 0,
            T: j,
            w: 0,
            z: LM(n),
            aw: 0,
            X: 0,
            G: yM
        };
    }, qM = F3(function(n, e, r) {
        var t = e, u = {
            s: t.s,
            T: A3(NM, t.z, j, t.T),
            w: t.w,
            z: t.z,
            aw: t.aw,
            X: t.X,
            G: t.G
        };
        if (r.b) {
            var a = r.a;
            return a.G.$ ? s(t.s, a.w) ? A2(Mr, u, r) : 0 > m(t.s, a.w) ? A2(Mr, u, A2(Mr, PM(A3(cu, t.s, a.w, n)), r)) : r : A2(Mr, u, r);
        }
        var i = A2(ou, t.s, n);
        return su(i) ? A([
            u
        ]) : A([
            u,
            PM(i)
        ]);
    }), NM = F3(function(n, e, r) {
        for(;;){
            if (!r.b) {
                if (e.b) {
                    var t = e.a;
                    return t.w > 0 ? A2(Mr, PM(A2(lu, t.w, n)), e) : e;
                }
                return su(n) ? j : A([
                    PM(n)
                ]);
            }
            var u = r.b, a = n, i = A3(qM, n, r.a, e);
            n = a, e = i, r = u;
        }
    }), _M = F3(function(n, e, r) {
        n: for(;;){
            if (!e.b) return j;
            var t = e.a, u = e.b;
            if (n.b) {
                var a = n.a, i = n.b;
                if (0 > m(a.mo, t.mo)) {
                    if (r) {
                        n = i, r += 1;
                        continue n;
                    }
                    return A2(Mr, a, A3(_M, i, e, r + 1));
                }
                if (r > 1) {
                    e = u, r -= 1;
                    continue n;
                }
                if (1 === r) return A2(Mr, t, A3(_M, n, u, r - 1));
                e = u, r = 0;
            } else if (r > 1) e = u, r -= 1;
            else {
                if (1 === r) return A2(Mr, t, A3(_M, n, u, r - 1));
                e = u, r = 0;
            }
        }
    }), zM = A2(Nc, Cs, Es("(\\\\*)(\\<)")), UM = {
        $: 4
    }, MM = function(n) {
        var e = n.oN;
        if (e.b && e.b.b && !e.b.a.$) {
            var r = A2(Nc, 0, A2(Pc, iu, e.a));
            return VU(r) ? zr({
                mo: n.mo + r,
                gK: 1,
                n: UM
            }) : Ur;
        }
        return Ur;
    }, DM = A2(Nc, Cs, Es("(\\\\*)(\\>)")), RM = function(n) {
        return {
            $: 5,
            a: n
        };
    }, FM = function(n) {
        var e = n.oN;
        if (e.b && e.b.b && !e.b.a.$) {
            var r = A2(Nc, 0, A2(Pc, iu, e.a));
            return zr({
                mo: n.mo + r,
                gK: 1,
                n: VU(r) ? RM(1) : RM(0)
            });
        }
        return Ur;
    }, HM = A2(Nc, Cs, Es("(\\\\*)([^*])?(\\*+)([^*])?")), GM = F2(function(n, e) {
        return {
            $: 7,
            a: n,
            b: e
        };
    }), XM = A2(Dd, F2(function(n, e) {
        return e || function(n) {
            switch(n){
                case "!":
                case '"':
                case "#":
                case "%":
                case "&":
                case "'":
                case "(":
                case ")":
                case "*":
                case ",":
                case "-":
                case ".":
                case "/":
                case ":":
                case ";":
                case "?":
                case "@":
                case "[":
                case "]":
                case "_":
                case "{":
                case "}":
                case "~":
                    return !0;
                default:
                    return !1;
            }
        }(n);
    }), !1), VM = A2(Dd, F2(function(n, e) {
        return e || function(n) {
            switch(n){
                case " ":
                case "\f":
                case "\n":
                case "\r":
                case "\t":
                case "\v":
                case "\xa0":
                case "\u2028":
                case "\u2029":
                    return !0;
                default:
                    return !1;
            }
        }(n);
    }), !1), JM = function(n) {
        if (n.$) return 0;
        var e = n.a;
        return su(e) || VM(e) ? 0 : XM(e) ? 1 : 2;
    }, YM = F3(function(n, e, r) {
        var t = r.oN;
        if (t.b && t.b.b && t.b.b.b && !t.b.b.a.$ && t.b.b.b.b) {
            var u = t.a, a = t.b, i = a.a, c = a.b, o = c.a.a, f = JM(c.b.a), s = i.$ ? 0 : iu(i.a), l = r.mo && !s ? zr(A3(cu, r.mo - 1, r.mo, e)) : i, d = u.$ ? 0 : iu(u.a), b = !VU(d) && !s || !l.$ && "\\" === l.a, m = b ? iu(o) - 1 : iu(o), p = b ? 1 : JM(l);
            return 0 >= m || "_" === n && 2 === p && 2 === f ? Ur : zr({
                mo: r.mo + d + s + (b ? 1 : 0),
                gK: m,
                n: A2(GM, n, {
                    fp: p,
                    fH: f
                })
            });
        }
        return Ur;
    }), WM = A2(Nc, Cs, Es("(\\\\*)(\\`+)")), KM = function(n) {
        return {
            $: 0,
            a: n
        };
    }, BM = function(n) {
        var e = n.oN;
        if (e.b && e.b.b && !e.b.a.$) {
            var r = e.b.a.a, t = A2(Nc, 0, A2(Pc, iu, e.a));
            return zr({
                mo: n.mo + t,
                gK: iu(r),
                n: VU(t) ? KM(1) : KM(0)
            });
        }
        return Ur;
    }, QM = A2(Nc, Cs, Es("(?:(\\\\+)|( {2,}))\\n")), ZM = {
        $: 8
    }, nD = function(n) {
        var e = n.oN;
        n: for(;;){
            if (e.b) {
                if (e.a.$) {
                    if (e.b.b && !e.b.a.$) return zr({
                        mo: n.mo,
                        gK: iu(n.eg),
                        n: ZM
                    });
                    break n;
                }
                var r = iu(e.a.a);
                return VU(r) ? Ur : zr({
                    mo: n.mo + r - 1,
                    gK: 2,
                    n: ZM
                });
            }
            break n;
        }
        return Ur;
    }, eD = (Es("(?:(\\\\+)|( *))\\n"), A2(Nc, Cs, Es("(\\\\*)(\\])"))), rD = {
        $: 3
    }, tD = function(n) {
        var e = n.oN;
        if (e.b && e.b.b && !e.b.a.$) {
            var r = A2(Nc, 0, A2(Pc, iu, e.a));
            return VU(r) ? zr({
                mo: n.mo + r,
                gK: 1,
                n: rD
            }) : Ur;
        }
        return Ur;
    }, uD = A2(Nc, Cs, Es("(\\\\*)(\\!)?(\\[)")), aD = {
        $: 2
    }, iD = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cD = function(n) {
        var e = n.oN;
        if (e.b && e.b.b && e.b.b.b && !e.b.b.a.$) {
            var r = e.b.a, t = A2(Nc, 0, A2(Pc, iu, e.a)), u = !VU(t), a = u ? n.mo + t + 1 : n.mo + t;
            return u ? r.$ ? Ur : zr({
                mo: a,
                gK: 1,
                n: iD(0)
            }) : zr(r.$ ? {
                mo: a,
                gK: 1,
                n: iD(0)
            } : {
                mo: a,
                gK: 2,
                n: aD
            });
        }
        return Ur;
    }, oD = function(n) {
        return {
            $: 9,
            a: n
        };
    }, fD = function(n) {
        var e = n.oN;
        if (e.b && e.b.b && !e.b.a.$) {
            var r = e.b.a.a, t = A2(Nc, 0, A2(Pc, iu, e.a)), u = VU(t) ? v(iu(r), oD(1)) : v(iu(r), oD(0));
            return zr({
                mo: n.mo + t,
                gK: u.a,
                n: u.b
            });
        }
        return Ur;
    }, sD = A2(Nc, Cs, Es("(\\\\*)(~{2,})([^~])?")), lD = A2(Nc, Cs, Es("(\\\\*)([^_])?(\\_+)([^_])?")), dD = F2(function(n, e) {
        if (n.b) {
            var r = n.a, t = n.b;
            if (e.b) {
                var u = e.a, a = e.b;
                return 0 > m(r.mo, u.mo) ? A2(Mr, r, A2(dD, t, e)) : A2(Mr, u, A2(dD, n, a));
            }
            return n;
        }
        return e;
    }), bD = {
        $: 2
    }, mD = function(n) {
        return {
            $: 6,
            a: n
        };
    }, pD = function(n) {
        return {
            $: 5,
            a: n
        };
    }, vD = function(n) {
        return {
            $: 4,
            a: n
        };
    }, gD = {
        $: 8
    }, hD = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $D = A2(Nc, Cs, Es("%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)")), xD = function(n) {
        return encodeURIComponent(n);
    }, kD = A2(Hu, xD, A2(zk, $D, function(n) {
        return A2(Nc, n.eg, ad(n.eg));
    })), jD = A2(Nc, Cs, Es("^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$")), yD = vr, wD = A2(Nc, Cs, Es("^\\[\\s*([^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*)\\s*\\]")), AD = function(n) {
        return n;
    }, TD = A2(Hu, AD, Ss), ED = F2(function(n, e) {
        return v(kD(LM(n)), A2(Pc, LM, e));
    }), CD = F3(function(n, e, r) {
        var t, u = su(t = A2(Nc, n.z, A2(Nc, Ur, A2(Ba, A2(Hu, function(n) {
            return n.oN;
        }, q$), r)))) ? n.z : t, a = A2(ra, TD(u), e);
        if (1 === a.$) return Ur;
        var i = a.a, c = i.a, o = i.b, f = 5 === n.G.$ ? pD(A2(ED, c, o)) : vD(A2(ED, c, o)), s = r.$ ? 0 : iu(r.a.eg);
        return zr($(n, {
            s: n.s + s,
            G: f
        }));
    }), ID = F3(function(n, e, r) {
        return A3(CD, e, r, q$(A3(yD, 1, wD, n)));
    }), SD = " \\t\\f\\v\\r\\n", OD = A2(Nc, Cs, Es("^\\(\\s*(?:<([^<>\\f\\v\\r\\n]*)>|([^" + SD + "\\(\\)\\\\]*(?:\\\\.[^" + SD + "\\(\\)\\\\]*)*))(?:[" + SD + "]+(?:'([^'\\\\]*(?:\\\\.[^'\\\\]*)*)'|\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?\\s*\\)")), LD = function(n) {
        var e = F2(function(n, e) {
            return e.$ ? n : zr(e.a);
        });
        return A3(ot, e, Ur, n);
    }, PD = F2(function(n, e) {
        var r, t = e.oN;
        if (t.b && t.b.b && t.b.b.b && t.b.b.b.b && t.b.b.b.b.b) {
            var u = t.a, a = t.b, i = a.a, c = a.b, o = c.b, f = LD(A([
                c.a,
                o.a,
                o.b.a
            ])), s = LD(A([
                u,
                i
            ]));
            return zr((r = A2(Nc, "", s), $(n, {
                s: n.s + iu(e.eg),
                G: (5 === n.G.$ ? pD : vD)(A2(ED, r, f))
            })));
        }
        return Ur;
    }), qD = F3(function(n, e, r) {
        var t = e, u = A3(yD, 1, OD, n);
        if (u.b) {
            var a = A2(PD, t, u.a);
            return a.$ ? A3(ID, n, t, r) : zr(a.a);
        }
        return A3(ID, n, t, r);
    }), ND = F2(function(n, e) {
        var r = n, t = Ah(function(n) {
            var e = n;
            return m(r.s, e.w) > 0 && 0 > m(r.s, e.s);
        });
        return sf(e) || sf(t(e)) ? zr(A2(Mr, r, e)) : Ur;
    }), _D = A2(Nc, Cs, Es("^([a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$")), zD = function(n) {
        var e = n;
        return A2(As, _D, e.z) ? Qr($(e, {
            G: hD(v(e.z, "mailto:" + kD(e.z)))
        })) : Yr(e);
    }, UD = F3(function(n, e, r) {
        for(;;){
            if (!r.b) return Ur;
            var t = r.a, u = r.b;
            if (e(t)) return zr(g(t, xt(n), u));
            n = A2(Mr, t, n), r = u;
        }
    }), MD = F2(function(n, e) {
        return A3(UD, j, n, e);
    }), DD = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), RD = function(n) {
        return A3(Mp, !1, n.h, n);
    }, FD = F2(function(n, e) {
        var r = e, t = A2(dv, A2(dv, A2(dv, av(F3(function(n, e, r) {
            return {
                iO: e,
                gK: r - n
            };
        })), RD), UU), RD), u = A2(Jv, t, A2(ou, r.w, n));
        return u.$ ? Ur : zr({
            mo: r.w,
            gK: u.a.gK,
            n: A2(DD, 0, u.a.iO)
        });
    }), HD = F2(function(n, e) {
        return e.$ ? n(e.a) : e;
    }), GD = F2(function(n, e) {
        var r = e.n;
        return !r.$ && s(r.a ? e.gK : e.gK - 1, n.gK);
    }), XD = function(n) {
        switch(n.n.$){
            case 1:
            case 2:
                return !0;
            default:
                return !1;
        }
    }, VD = F2(function(n, e) {
        var r = e.n;
        if (7 === r.$) {
            var t = r.b, u = n.n;
            if (7 === u.$) {
                var a = u.b;
                return !(!s(r.a, u.a) || (s(t.fp, t.fH) || s(a.fp, a.fH)) && !A2(Uc, 3, n.gK + e.gK) && (A2(Uc, 3, n.gK) || A2(Uc, 3, e.gK)));
            }
            return !1;
        }
        return !1;
    }), JD = F2(function(n, e) {
        var r, t, u = 9 === (t = e.n).$ ? v(!0, t.a ? e.gK : e.gK - 1) : v(!1, 0), a = u.a, i = u.b, c = 9 === (r = n.n).$ ? v(!0, r.a ? n.gK : n.gK - 1) : v(!1, 0);
        return c.a && a && s(c.b, i);
    }), YD = {
        $: 1
    }, WD = F2(function(n, e) {
        return {
            s: n.mo + n.gK,
            T: j,
            w: n.mo,
            z: "",
            aw: 0,
            X: 0,
            G: e
        };
    }), KD = F2(function(n, e) {
        for(;;){
            if (!n.b) return e;
            var r = n.a, t = n.b;
            8 !== r.n.$ ? n = t : (n = t, e = A2(Mr, A2(WD, r, YD), e));
        }
    }), BD = F2(function(n, e) {
        var r = n;
        return A2(Ah, function(n) {
            return m(n.mo, r.s) > -1;
        }, e);
    }), QD = F6(function(n, e, r, t, u, a) {
        var i, c = a.c, o = A2(HD, zD, A2(As, jD, (i = A7(oR, t, u, function(n) {
            return n;
        }, bD, a.a, n, j)).z) ? Qr($(i, {
            G: hD(v(i.z, kD(i.z)))
        })) : Yr(i));
        if (1 === o.$) {
            if (1 === e) {
                var f = A2(FD, u, o.a);
                return f.$ ? Ur : zr(v(A2(Mr, f.a, c), r));
            }
            return Ur;
        }
        return zr(v(c, A2(Mr, o.a, r)));
    }), ZD = F5(function(n, e, r, t, u) {
        n: for(;;){
            if (!n.b) return A5(tR, xt(e), j, r, t, u);
            var a = n.a, i = n.b, c = a.n;
            switch(c.$){
                case 0:
                    var o = A2(MD, GD(a), e);
                    if (o.$) {
                        n = i, e = A2(Mr, a, e);
                        continue n;
                    }
                    var f = A5(nR, a, r, t, u, o.a);
                    n = i, e = p = f.a, r = v = f.b;
                    continue n;
                case 5:
                    var s = c.a, l = function(n) {
                        return 4 === n.n.$;
                    }, d = A2(MD, l, e);
                    if (d.$) {
                        n = i, e = A2(Ah, A2(cc, rl, l), e);
                        continue n;
                    }
                    var b = A6(QD, a, s, r, t, u, d.a);
                    if (b.$) {
                        n = i, e = A2(Ah, A2(cc, rl, l), e);
                        continue n;
                    }
                    var m = b.a, p = m.a, v = m.b;
                    n = i, e = A2(Ah, A2(cc, rl, l), p), r = v;
                    continue n;
                default:
                    n = i, e = A2(Mr, a, e);
                    continue n;
            }
        }
    }), nR = F5(function(n, e, r, t, u) {
        var a, i = u.a, c = u.c, o = (a = i.n).$ || a.a ? i : $(i, {
            mo: i.mo + 1,
            gK: i.gK - 1
        });
        return v(c, A2(Mr, A7(oR, r, t, AD, bD, o, n, j), e));
    }), eR = F5(function(n, e, r, t, u) {
        n: for(;;){
            if (!n.b) return A5(iR, xt(e), j, r, t, u);
            var a = n.a, i = n.b, c = a.n;
            if (7 !== c.$) n = i, e = A2(Mr, a, e);
            else {
                var o = c.a, f = c.b.fp, l = c.b.fH;
                if (s(f, l)) {
                    if (!l || "_" === o && 1 !== l) {
                        n = i;
                        continue n;
                    }
                    var d = A2(MD, VD(a), e);
                    if (d.$) {
                        n = i, e = A2(Mr, a, e);
                        continue n;
                    }
                    var b = A5(rR, t, u, a, i, d.a);
                    n = b.a, e = b.c, r = A2(Mr, b.b, r);
                    continue n;
                }
                if (0 > m(f, l)) {
                    n = i, e = A2(Mr, a, e);
                    continue n;
                }
                var p = A2(MD, VD(a), e);
                if (p.$) {
                    n = i;
                    continue n;
                }
                var v = A5(rR, t, u, a, i, p.a);
                n = v.a, e = v.c, r = A2(Mr, v.b, r);
            }
        }
    }), rR = F5(function(n, e, r, t, u) {
        var a = u.a, i = u.b, c = u.c, o = a.gK - r.gK, f = o ? o > 0 ? {
            e4: r,
            et: $(a, {
                mo: a.mo + o,
                gK: r.gK
            }),
            fD: A2(Mr, $(a, {
                gK: o
            }), c),
            fW: t
        } : {
            e4: $(r, {
                gK: a.gK
            }),
            et: a,
            fD: c,
            fW: A2(Mr, $(r, {
                mo: r.mo + a.gK,
                gK: -o
            }), t)
        } : {
            e4: r,
            et: a,
            fD: c,
            fW: t
        }, s = A7(oR, n, e, function(n) {
            return n;
        }, function(n) {
            return {
                $: 7,
                a: n
            };
        }(f.et.gK), f.et, f.e4, xt(i));
        return g(f.fW, s, f.fD);
    }), tR = F5(function(n, e, r, t, u) {
        for(;;){
            if (!n.b) return A5(uR, xt(e), j, r, t, u);
            var a = n.a, i = n.b, c = a.n;
            6 !== c.$ ? (n = i, e = A2(Mr, a, e)) : (n = i, r = A2(Mr, A2(WD, a, mD(c.b)), r));
        }
    }), uR = F5(function(n, e, r, t, u) {
        n: for(;;){
            if (!n.b) return A5(eR, xt(e), j, r, t, u);
            var a = n.a, i = n.b;
            if (3 !== a.n.$) n = i, e = A2(Mr, a, e);
            else {
                var c = A2(MD, XD, e);
                if (c.$) {
                    n = i;
                    continue n;
                }
                var o = A6(aR, a, i, r, t, u, c.a);
                if (o.$) {
                    n = i;
                    continue n;
                }
                var f = o.a;
                n = f.a, e = f.c, r = f.b;
            }
        }
    }), aR = F6(function(n, e, r, t, u, a) {
        var i = a.a, c = a.b, o = a.c, f = g(e, r, k(c, o)), s = A2(ou, n.mo + 1, u), l = function(n) {
            return 1 === n.n.$ ? $(n, {
                n: iD(1)
            }) : n;
        }, d = function(e) {
            return A7(oR, t, u, function(n) {
                return n;
            }, e ? vD(v("", Ur)) : pD(v("", Ur)), i, n, xt(c));
        }, b = i.n;
        switch(b.$){
            case 2:
                var m = d(!1), p = A3(qD, s, m, t);
                if (1 === p.$) return zr(f);
                var h = A2(ND, y = p.a, r);
                if (h.$) return zr(f);
                var x = h.a;
                return zr(g(A2(BD, y, e), x, o));
            case 1:
                if (b.a) return zr(f);
                m = d(!0);
                var j = A3(qD, s, m, t);
                if (1 === j.$) return zr(f);
                var y, w = A2(ND, y = j.a, r);
                return w.$ ? zr(f) : (x = w.a, zr(g(A2(BD, y, e), x, A2(wu, l, o))));
            default:
                return Ur;
        }
    }), iR = F5(function(n, e, r, t, u) {
        n: for(;;){
            if (!n.b) return A2(KD, xt(e), r);
            var a = n.a, i = n.b;
            if (9 !== a.n.$) n = i, e = A2(Mr, a, e);
            else {
                var c = A2(MD, JD(a), e);
                if (c.$) {
                    n = i, e = A2(Mr, a, e);
                    continue n;
                }
                var o = A5(cR, a, r, t, u, c.a);
                n = i, e = o.a, r = o.b;
            }
        }
    }), cR = F5(function(n, e, r, t, u) {
        var a, i = u.a, c = u.c, o = 9 !== (a = i.n).$ || a.a ? i : $(i, {
            mo: i.mo + 1,
            gK: i.gK - 1
        });
        return v(c, A2(Mr, A7(oR, r, t, AD, gD, o, n, j), e));
    }), oR = F7(function(n, e, r, t, u, a, i) {
        var c = u.mo + u.gK, o = a.mo, f = r(A3(cu, c, o, e)), s = u.mo, l = a.mo + a.gK, d = {
            s: l,
            T: j,
            w: s,
            z: f,
            aw: o,
            X: c,
            G: t
        };
        return {
            s: l,
            T: A2(wu, function(n) {
                return A2(hM, d, n);
            }, A4(fR, i, j, n, e)),
            w: s,
            z: f,
            aw: o,
            X: c,
            G: t
        };
    }), fR = F4(function(n, e, r, t) {
        return A5(ZD, n, j, e, r, t);
    }), sR = F2(function(n, e) {
        var r = mf(e), t = function(n) {
            var e;
            return A2(dD, A3(_M, A2(LA, function(n) {
                return n.mo;
            }, A2(qa, MM, A2(mp, zM, n))), A2(LA, function(n) {
                return n.mo;
            }, A2(qa, FM, A2(mp, DM, n))), 0), A2(dD, (e = n, A2(qa, nD, A2(mp, QM, e))), A2(dD, function(n) {
                return A2(qa, tD, A2(mp, eD, n));
            }(n), A2(dD, function(n) {
                return A2(qa, cD, A2(mp, uD, n));
            }(n), A2(dD, function(n) {
                return A2(qa, fD, A2(mp, sD, n));
            }(n), A2(dD, function(n) {
                return A2(qa, A2(YM, "_", n), A2(mp, lD, n));
            }(n), A2(dD, function(n) {
                return A2(qa, A2(YM, "*", n), A2(mp, HM, n));
            }(n), function(n) {
                return A2(qa, BM, A2(mp, WM, n));
            }(n))))))));
        }(r);
        return gM(A3(NM, r, j, kM(A4(fR, t, j, n, r))));
    }), lR = vv(A([
        qv(A2(Lv, " ", oz(" "))),
        qv(A2(Lv, ">", oz(">"))),
        A2(sv, A2(sv, A2(kv, gt, oz("Alpha")), Bp(function(n) {
            return $t(n) || "-" === n;
        })), vv(A([
            qv(A2(Lv, ":", oz(":"))),
            qv(A2(Lv, "@", oz("@"))),
            qv(A2(Lv, "\\", oz("\\"))),
            qv(A2(Lv, "+", oz("+"))),
            qv(A2(Lv, ".", oz(".")))
        ])))
    ])), dR = Mz(A2(Zp, F2(function(n) {
        return jz(n);
    }), A2(sv, A2(sv, A2(sv, qv(A2(Lv, "<", oz("<"))), lR), Yz), Kz))), bR = function(n) {
        return qv(A2(Lv, n, oz(n)));
    }, mR = function(n) {
        var e = n.a, r = n.b, t = A2(Nc, Tv(r), A2(Pc, function(n) {
            return Tv(A2(Mr, n, r));
        }, e)), u = A2(Nc, Ev(v(Ur, r)), A2(Pc, function(n) {
            return Ev(v(Ur, A2(Mr, n, r)));
        }, e)), a = function(n) {
            return Ev(v(zr(function(n) {
                return k(A2(Nc, "", e), n);
            }(n)), r));
        };
        return vv(A([
            A2(wv, function() {
                return t;
            }, bR("|\n")),
            A2(wv, function() {
                return t;
            }, bR("\n")),
            A2(wv, function() {
                return t;
            }, Jp(oz("end"))),
            A2(sv, Mz(av(a("|"))), bR("\\\\|")),
            A2(sv, Mz(av(a("\\"))), bR("\\\\")),
            A2(sv, Mz(av(a("|"))), bR("\\|")),
            A2(sv, Mz(av(u)), bR("|")),
            A2(Zp, F2(function(n) {
                return a(n);
            }), A2(kv, Wi(!0), rv("No character found")))
        ]));
    }, pR = A2(wv, A2(ot, F2(function(n, e) {
        return A2(Mr, mf(n), e);
    }), j), A2(yv, v(Ur, j), mR)), vR = A2(dv, A2(sv, av(ru), vv(A([
        bR("|"),
        av(0)
    ]))), pR), gR = F2(function(n, e) {
        var r, t = n.b, u = A2(Jv, vR, e);
        return u.$ ? Yr("Unable to parse previous line as a table header") : s(ft(r = u.a), ft(t)) ? Qr(function(n) {
            return A3(st, F2(function(n, e) {
                return {
                    eZ: e,
                    ai: n
                };
            }), n, t);
        }(r)) : Yr("Tables must have the same number of header columns (" + ut(ft(r)) + ") as delimiter columns (" + ut(ft(t)) + ")");
    }), hR = F2(function(n, e) {
        return {
            kO: e,
            mH: n
        };
    }), $R = {
        e2: "`",
        gJ: 0,
        fV: A2(Lv, "`", oz("a '`'"))
    }, xR = function(n) {
        switch(n){
            case 1:
                return av(0);
            case 2:
                return av(1);
            case 3:
                return av(2);
            case 4:
                return av(3);
            default:
                return tv(oz("Fenced code blocks should be indented no more than 3 spaces"));
        }
    }, kR = F2(function(n, e) {
        var r = A3(ot, F2(function(n, e) {
            return A2(sv, e, n);
        }), av(0), A2(Y$, n, qv(e.fV)));
        return A2(Zp, F2(function(n) {
            return v(e, iu(n));
        }), A2(sv, r, Bp(zt(e.e2))));
    }), jR = {
        e2: "~",
        gJ: 1,
        fV: A2(Lv, "~", oz("a `~`"))
    }, yR = vv(A([
        A2(sv, A2(sv, oM, vv(A([
            oM,
            av(0)
        ]))), vv(A([
            oM,
            av(0)
        ]))),
        av(0)
    ])), wR = A2(dv, A2(dv, A2(sv, av(F2(function(n, e) {
        return {
            e3: e.a,
            gG: n,
            gK: e.b
        };
    })), yR), A2(Dp, xR, ZU)), vv(A([
        A2(kR, 3, $R),
        A2(kR, 3, jR)
    ]))), AR = zt(" "), TR = F2(function(n, e) {
        return A2(sv, A2(sv, A2(sv, A2(sv, av(0), yR), A2(kR, n, e)), Bp(AR)), Kz);
    }), ER = function(n) {
        return A3(Mp, !1, n.hf, n);
    }, CR = function(n) {
        var e, r = n.a, t = n.b;
        return vv(A([
            A2(sv, av(Tv(t)), Jp(Fp)),
            A2(Zp, F2(function(n) {
                return Ev(v(r, k(t, n)));
            }), Hz),
            Mz(A2(sv, av(Tv(t)), A2(TR, r.gK, r.e3))),
            A2(dv, A2(dv, A2(dv, av(F3(function(n, e, u) {
                return Ev(v(r, k(t, A3(cu, n, e, u))));
            })), (e = r.gG, A2(dv, A2(sv, av(ru), A2(fM, e, oM)), A2(sv, A2(sv, RD, Yz), Kz)))), RD), ER)
        ]));
    }, IR = A2(Dp, function(n) {
        var e;
        return A2(dv, A2(dv, av(hR), A2(sv, (e = n.e3, A2(Zp, F2(function(n) {
            var e = mf(n);
            return "" === e ? Ur : zr(e);
        }), Bp(e.gJ ? A2(cc, rl, Jz) : function(n) {
            return "`" !== n && !Jz(n);
        }))), Kz)), function(n) {
            return A2(yv, v(n, ""), CR);
        }(n));
    }, wR), SR = A2(Lv, "#", oz("a `#`")), OR = Bp(function(n) {
        return " " === n || "\n" === n || "\r" === n;
    }), LR = A2(dv, A2(dv, A2(sv, A2(sv, av(lz), A2(Dp, function(n) {
        var e = iu(n);
        return 4 > e ? av(e) : tv(oz("heading with < 4 spaces in front"));
    }, nv(OR))), Nv(SR)), A2(Dp, function(n) {
        var e = iu(n) + 1;
        return 7 > e ? av(e) : tv(oz("heading with < 7 #'s"));
    }, nv(Bp(function(n) {
        return "#" === n;
    })))), vv(A([
        A2(sv, av(""), Nv(Fz)),
        A2(dv, A2(sv, av(ru), vv(A([
            Nv(Xz),
            Nv(HU)
        ]))), A2(Zp, F2(function(n) {
            var e, r;
            return e = mf(n), r = function(n) {
                for(;;){
                    if (!A2(Hd, "#", n)) return n;
                    n = A2(Fd, 1, n);
                }
            }(e), A2(Hd, " ", r) || su(r) ? r.replace(/\s+$/, "") : e;
        }), Yz))
    ]))), PR = jr, qR = F4(function(n, e, r, t) {
        return A2(Hp, Xp, A4(Gp, n, e, r, t));
    }), NR = function(n) {
        var e = n.a, r = n.b;
        return function(n) {
            var t = A5(PR, e, n.h, n.oi, n.h5, n.hf), u = t.a, a = t.b, i = t.c;
            return s(u, -1) ? A2(Up, !1, A4(qR, a, i, r, n.k2)) : A3(Mp, 0 > m(n.h, u), 0, {
                h5: i,
                k2: n.k2,
                v: n.v,
                h: u,
                oi: a,
                hf: n.hf
            });
        };
    }, _R = A2(Lv, ">", oz("a `>`")), zR = F3(function(n, e, r) {
        return {
            h5: e,
            k2: r,
            oi: n
        };
    }), UR = F2(function(n, e) {
        return {
            h5: e.h5,
            k2: n,
            v: e.v,
            h: e.h,
            oi: e.oi,
            hf: e.hf
        };
    }), MR = F2(function(n, e) {
        var r = e;
        return function(e) {
            var t = r(A2(UR, A2(Mr, A3(zR, e.oi, e.h5, n), e.k2), e));
            return t.$ ? t : A3(Mp, t.a, t.b, A2(UR, e.k2, t.c));
        };
    }), DR = function(n) {
        switch(n){
            case " ":
            case "\n":
            case "\t":
            case "\v":
            case "\f":
            case "\r":
                return !0;
            default:
                return !1;
        }
    }, RR = A2(Lv, "<", oz("a `<`")), FR = A2(MR, "link destination", vv(A([
        A2(dv, A2(sv, av(xD), Nv(RR)), A2(sv, nv(NR(_R)), Nv(_R))),
        nv(eM(A2(cc, rl, DR)))
    ]))), HR = A2(Lv, "]", oz("a `]`")), GR = A2(Lv, "[", oz("a `[`")), XR = A2(dv, A2(sv, av(TD), Nv(GR)), A2(sv, nv(NR(HR)), Nv(A2(Lv, "]:", oz("]:"))))), VR = A2(Lv, '"', oz("a double quote")), JR = function(n) {
        return A2(au, "\n\n", n) ? tv(oz("no blank line")) : av(n);
    }, YR = A2(sv, Bp(function(n) {
        return !Jz(n) && DR(n);
    }), Kz), WR = A2(sv, A2(kv, DR, oz("Required whitespace")), Bp(DR)), KR = A2(Lv, "'", oz("a single quote")), BR = (DU = A2(dv, A2(sv, av(zr), Nv(KR)), A2(sv, A2(sv, A2(Dp, JR, nv(NR(KR))), Nv(KR)), YR)), RU = A2(dv, A2(sv, av(zr), Nv(VR)), A2(sv, A2(sv, A2(Dp, JR, nv(NR(VR))), Nv(VR)), YR)), A2(MR, "title", vv(A([
        Mz(A2(dv, A2(sv, av(ru), WR), vv(A([
            RU,
            DU,
            av(Ur)
        ])))),
        A2(sv, av(Ur), YR)
    ])))), QR = A2(MR, "link reference definition", A2(dv, A2(dv, A2(dv, A2(sv, av(F3(function(n, e, r) {
        return v(n, {
            lt: e,
            eG: r
        });
    })), yR), A2(sv, A2(sv, A2(sv, XR, Bp(Dz)), vv(A([
        Hz,
        av(0)
    ]))), Bp(Dz))), FR), BR)), ZR = Bp(Dz), nF = function(n) {
        var e = bR(Jc(n));
        return A2(sv, A2(sv, A2(sv, A2(sv, A2(sv, A2(sv, A2(sv, av(0), e), ZR), e), ZR), e), Bp(function(e) {
            return s(e, n) || Dz(e);
        })), Kz);
    }, eF = vv(A([
        nF("-"),
        nF("*"),
        nF("_")
    ])), rF = vv(A([
        A2(dv, A2(sv, A2(sv, A2(sv, av(ru), oM), vv(A([
            oM,
            av(0)
        ]))), vv(A([
            oM,
            av(0)
        ]))), eF),
        eF
    ])), tF = F2(function(n, e) {
        return {
            $: 13,
            a: n,
            b: e
        };
    }), uF = A2(Lv, "=", oz("a `=`")), aF = A2(Lv, "-", oz("a `-`")), iF = (FU = F3(function(n, e, r) {
        return A2(sv, A2(sv, av(n), qv(e)), Bp(zt(r)));
    }), A2(Zp, F2(function(n, e) {
        return A2(tF, e, n);
    }), A2(dv, A2(sv, av(ru), yR), A2(sv, A2(sv, vv(A([
        A3(FU, 0, uF, "="),
        A3(FU, 1, aF, "-")
    ])), Bp(Dz)), Kz)))), cF = function(n) {
        return {
            $: 9,
            a: n
        };
    }, oF = Bp(Dz), fF = function(n) {
        return vv(A([
            A2(kv, n, rv("Character not found")),
            av(0)
        ]));
    }, sF = function(n) {
        var e;
        return vv(A([
            Mz(A2(wv, function() {
                return Tv(n);
            }, bR("|\n"))),
            A2(wv, function() {
                return Tv(n);
            }, bR("\n")),
            A2(wv, function() {
                return Tv(n);
            }, Jp(oz("end"))),
            Mz(A2(sv, A2(sv, av(Tv(n)), bR("|")), Jp(oz("end")))),
            A2(dv, A2(sv, A2(sv, av(function(e) {
                return Ev(A2(Mr, e, n));
            }), (e = n, sf(e) ? vv(A([
                bR("|"),
                av(0)
            ])) : bR("|"))), oF), A2(sv, nv(A2(sv, A2(sv, A2(sv, av(0), fF(function(n) {
                return ":" === n;
            })), eM(function(n) {
                return "-" === n;
            })), fF(function(n) {
                return ":" === n;
            }))), oF))
        ]));
    }, lF = function(n) {
        var e = v(A2(gu, ":", n), A2(Hd, ":", n));
        return e.a ? zr(e.b ? 2 : 0) : e.b ? zr(1) : Ur;
    }, dF = A2(wv, cF, A2(Dp, function(n) {
        var e = n.a.kk, r = n.b;
        return sf(r) ? tv(oz("Must have at least one column in delimiter row.")) : 1 !== ft(r) || A2(gu, "|", e) && A2(Hd, "|", e) ? av(n) : tv(rv("Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity."));
    }, A2(Zp, F2(function(n, e) {
        return A2(Pz, {
            jB: n,
            kk: mf(n)
        }, A2(wu, lF, xt(e)));
    }), A2(yv, j, sF)))), bF = F2(function(n, e) {
        var r = ft(e);
        switch(A2(ea, n, r)){
            case 0:
                return A2(Hc, n, e);
            case 1:
                return e;
            default:
                return k(e, A2(Y$, n - r, ""));
        }
    }), mF = function(n) {
        var e, r = n.a, t = n.b;
        return A2(wv, function(n) {
            return Oz(A2(Lz, r, k(t, A([
                n
            ]))));
        }, (e = ft(r), A2(Dp, function(n) {
            return sf(n) || A2(wh, su, n) ? tv(rv("A line must have at least one column")) : av(A2(bF, e, n));
        }, vR)));
    }, pF = {
        $: 2
    }, vF = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gF = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), hF = F4(function(n, e, r, t) {
        var u = t.a, a = t.b, i = u - r;
        return i > 4 ? g(e, r - n + 1, function() {
            switch(a.$){
                case 0:
                    var n = a.b;
                    return A2(gF, a.a, k(A2(Wc, i - 1, " "), n));
                case 1:
                    return n = a.a, vF(k(A2(Wc, i - 1, " "), n));
                default:
                    return pF;
            }
        }()) : g(e, u - n, a);
    }), $F = A2(dv, av(function(n) {
        return v(n, pF);
    }), A2(sv, ZU, Kz)), xF = vv(A([
        A2(sv, av(1), Nv(A2(Lv, "[x] ", Ov("[x] ")))),
        A2(sv, av(1), Nv(A2(Lv, "[X] ", Ov("[X] ")))),
        A2(sv, av(0), Nv(A2(Lv, "[ ] ", Ov("[ ] "))))
    ])), kF = A2(dv, vv(A([
        A2(dv, av(gF), A2(sv, xF, Bp(Dz))),
        av(vF)
    ])), A2(sv, nv(Yz), Kz)), jF = A2(dv, A2(dv, A2(sv, av(F2(function(n, e) {
        return v(n, e);
    })), eM(Dz)), ZU), kF), yF = vv(A([
        A2(sv, A2(sv, av(0), A2(fM, 3, oM)), Nv(A2(Lv, "-", Ov("-")))),
        A2(sv, av(1), Nv(A2(Lv, "+", Ov("+")))),
        A2(sv, av(2), Nv(A2(Lv, "*", Ov("*"))))
    ])), wF = function(n) {
        var e = F2(function(n, e) {
            switch(e.$){
                case 0:
                    return {
                        kO: e.b,
                        mY: n,
                        I: zr(1 === e.a)
                    };
                case 1:
                    return {
                        kO: e.a,
                        mY: n,
                        I: Ur
                    };
                default:
                    return {
                        kO: "",
                        mY: n,
                        I: Ur
                    };
            }
        });
        return A2(wv, function(n) {
            return A4(zz, !0, n.b, j, A2(e, n.a, n.c));
        }, function(n) {
            return A2(dv, A2(dv, A2(dv, A2(dv, av(hF), ZU), Mz(yF)), ZU), n ? jF : vv(A([
                $F,
                jF
            ])));
        }(n));
    }, AF = F2(function(n, e) {
        switch(n.$){
            case 0:
                var r = n.a, t = n.b, u = OF(n.c);
                if (u.$) return Yr(u.a);
                var a = bz(A3(vz, r, t, u.a));
                return Qr(A2(Mr, a, e));
            case 1:
                var i = PF(n.a);
                return i.$ ? Yr(oz(A2(at, "\n", A2(wu, h_, i.a)))) : Qr(k(xt(i.a), e));
            case 2:
                return Qr(A2(Mr, bz(mz(n.a)), e));
            case 3:
                return Qr(A2(Mr, bz(rz(n.a)), e));
            case 4:
                return Qr(A2(Mr, bz(Cz(n.a)), e));
            default:
                return Qr(A2(Mr, bz(A2(pz, n.a, n.b)), e));
        }
    }), TF = function(n) {
        var e = n.b;
        n: for(; e.b;)switch(e.a.$){
            case 11:
                var r = e.a.a, t = e.b, u = A2(Jv, HF(), r);
                return u.$ ? tv(rv(Qz(u.a))) : av({
                    a: k(n.a, ($ = u.a).a),
                    b: A2(Mr, Ez($.b), t)
                });
            case 3:
                var a = e.a, i = a.a, c = a.b, o = a.c, f = a.d, s = (t = e.b, A2(Jv, HF(), f.kO));
                if (s.$) return tv(rv(Qz(s.a)));
                var l = !A2(el, nz, ($ = s.a).b) && i;
                return av({
                    a: k(n.a, $.a),
                    b: A2(Mr, A4(zz, l, c, A2(Mr, {
                        kO: $.b,
                        I: f.I
                    }, o), f), t)
                });
            case 4:
                var d = e.a, b = (i = d.a, c = d.b, d.c), m = d.d, p = (o = d.e, f = d.f, t = e.b, A2(Jv, HF(), f));
                return p.$ ? tv(rv(Qz(p.a))) : (l = !A2(el, nz, ($ = p.a).b) && i, av({
                    a: k(n.a, $.a),
                    b: A2(Mr, A6(wz, l, c, b, m, A2(Mr, $.b, o), f), t)
                }));
            case 10:
                if (!e.b.b) break n;
                switch(e.b.a.$){
                    case 3:
                        var v = e.b, g = v.a, h = (i = g.a, c = g.b, o = g.c, f = g.d, t = v.b, A2(Jv, HF(), f.kO));
                        return h.$ ? tv(rv(Qz(h.a))) : (l = !A2(el, nz, ($ = h.a).b) && i, av({
                            a: k(n.a, $.a),
                            b: A2(Mr, A4(zz, l, c, A2(Mr, {
                                kO: $.b,
                                I: f.I
                            }, o), f), t)
                        }));
                    case 4:
                        var $, x = e.b, j = x.a, y = (i = j.a, c = j.b, b = j.c, m = j.d, o = j.e, f = j.f, t = x.b, A2(Jv, HF(), f));
                        return y.$ ? tv(rv(Qz(y.a))) : (l = !A2(el, nz, ($ = y.a).b) && i, av({
                            a: k(n.a, $.a),
                            b: A2(Mr, A6(wz, l, c, b, m, A2(Mr, $.b, o), f), t)
                        }));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return av(n);
    }, EF = F2(function(n, e) {
        var r = v(e, n.b);
        n: for(; r.b.b;)switch(r.b.a.$){
            case 5:
                if (5 === r.a.$) {
                    var t = r.b, u = t.b;
                    return av({
                        a: n.a,
                        b: A2(Mr, uz({
                            kO: A2(WU, t.a.a.kO, r.a.a.kO),
                            mH: Ur
                        }), u)
                    });
                }
                break n;
            case 6:
                switch(r.a.$){
                    case 6:
                        var a = r.b;
                        return u = a.b, av({
                            a: n.a,
                            b: A2(Mr, hz(A2(WU, a.a.a, r.a.a)), u)
                        });
                    case 10:
                        var i = r.b;
                        return u = i.b, av({
                            a: n.a,
                            b: A2(Mr, hz(A2(WU, i.a.a, "\n")), u)
                        });
                    default:
                        break n;
                }
            case 11:
                var c = r.b, o = c.a.a;
                switch(u = c.b, e.$){
                    case 11:
                        return av({
                            a: n.a,
                            b: A2(Mr, ez(A2(WU, o, f = e.a)), u)
                        });
                    case 1:
                        var f = e.a, l = A2(Jv, HF(), o);
                        if (l.$) return tv(rv(Qz(l.a)));
                        var d = (nn = l.a).b;
                        if (d.b) {
                            if (Zz(d.a) && !A2(Hd, "\n", o)) return av({
                                a: n.a,
                                b: A2(Mr, ez(A2(WU, o, f)), u)
                            });
                            var b = A2(Jv, HF(), o);
                            if (b.$) return tv(rv(Qz(b.a)));
                            var m = b.a;
                            return av({
                                a: k(n.a, nn.a),
                                b: A2(Mr, e, A2(Mr, Ez(m.b), u))
                            });
                        }
                        var p = A2(Jv, HF(), o);
                        return p.$ ? tv(rv(Qz(p.a))) : (m = p.a, av({
                            a: k(n.a, nn.a),
                            b: A2(Mr, e, A2(Mr, Ez(m.b), u))
                        }));
                    case 6:
                        f = e.a;
                        var g = A2(Jv, HF(), o);
                        if (g.$) return tv(rv(Qz(g.a)));
                        var h = (nn = g.a).b;
                        if (h.b && 1 === h.a.$) return av({
                            a: n.a,
                            b: A2(Mr, ez(A3(YU, " ", o, f)), u)
                        });
                        var x = A2(Jv, HF(), o);
                        return x.$ ? tv(rv(Qz(x.a))) : (m = x.a, av({
                            a: k(n.a, nn.a),
                            b: A2(Mr, e, A2(Mr, Ez(m.b), u))
                        }));
                    default:
                        var y = A2(Jv, HF(), o);
                        return y.$ ? tv(rv(Qz(y.a))) : av({
                            a: k(n.a, (nn = y.a).a),
                            b: A2(Mr, e, A2(Mr, Ez(nn.b), u))
                        });
                }
            case 3:
                var w = r.b, A = w.a, T = A.a, E = A.b, C = A.c, I = A.d;
                switch(u = w.b, e.$){
                    case 3:
                        var S = e.b;
                        if (s(I.mY, (M = e.d).mY)) {
                            var O = A2(Jv, HF(), I.kO);
                            return O.$ ? tv(rv(Qz(O.a))) : av(A2(el, nz, (nn = O.a).b) ? {
                                a: k(n.a, nn.a),
                                b: A2(Mr, A4(zz, !1, S, A2(Mr, {
                                    kO: nn.b,
                                    I: I.I
                                }, C), M), u)
                            } : {
                                a: k(n.a, nn.a),
                                b: A2(Mr, A4(zz, T, S, A2(Mr, {
                                    kO: nn.b,
                                    I: I.I
                                }, C), M), u)
                            });
                        }
                        var L = A2(Jv, HF(), I.kO);
                        if (L.$) return tv(rv(Qz(L.a)));
                        var P = !A2(el, nz, (nn = L.a).b) && T;
                        return av({
                            a: k(n.a, nn.a),
                            b: A2(Mr, e, A2(Mr, A4(zz, P, E, A2(Mr, {
                                kO: nn.b,
                                I: I.I
                            }, C), M), u))
                        });
                    case 1:
                        return av({
                            a: n.a,
                            b: A2(Mr, A4(zz, T, E, C, $(I, {
                                kO: A3(YU, "\n", I.kO, f = e.a)
                            })), u)
                        });
                    default:
                        var q = A2(Jv, HF(), I.kO);
                        return q.$ ? tv(rv(Qz(q.a))) : (P = !A2(el, nz, (nn = q.a).b) && T, av({
                            a: k(n.a, nn.a),
                            b: A2(Mr, e, A2(Mr, A4(zz, P, E, A2(Mr, {
                                kO: nn.b,
                                I: I.I
                            }, C), I), u))
                        }));
                }
            case 4:
                var N = r.b, _ = N.a, z = (T = _.a, E = _.b, _.c), U = _.d;
                switch(C = _.e, I = _.f, u = N.b, e.$){
                    case 4:
                        S = e.b;
                        var M = e.f;
                        if (s(z, e.c)) {
                            var D = A2(Jv, HF(), I);
                            return D.$ ? tv(rv(Qz(D.a))) : (P = !A2(el, nz, (nn = D.a).b) && T, av({
                                a: k(n.a, nn.a),
                                b: A2(Mr, A6(wz, P, S, z, U, A2(Mr, nn.b, C), M), u)
                            }));
                        }
                        var R = A2(Jv, HF(), I);
                        return R.$ ? tv(rv(Qz(R.a))) : (P = !A2(el, nz, (nn = R.a).b) && T, av({
                            a: k(n.a, nn.a),
                            b: A2(Mr, e, A2(Mr, A6(wz, P, E, z, U, A2(Mr, nn.b, C), I), u))
                        }));
                    case 1:
                        return av({
                            a: n.a,
                            b: A2(Mr, A6(wz, T, E, z, U, C, I + "\n" + (f = e.a)), u)
                        });
                    default:
                        var F = A2(Jv, HF(), I);
                        return F.$ ? tv(rv(Qz(F.a))) : (P = !A2(el, nz, (nn = F.a).b) && T, av({
                            a: k(n.a, nn.a),
                            b: A2(Mr, e, A2(Mr, A6(wz, P, E, z, U, A2(Mr, nn.b, C), I), u))
                        }));
                }
            case 1:
                switch(r.a.$){
                    case 1:
                        var H = r.b;
                        return u = H.b, av({
                            a: n.a,
                            b: A2(Mr, jz(A3(YU, "\n", o = H.a.a, f = r.a.a)), u)
                        });
                    case 13:
                        if (r.a.a) {
                            var G = r.b;
                            return u = G.b, av({
                                a: n.a,
                                b: A2(Mr, A2(lz, 2, G.a.a), u)
                            });
                        }
                        var X = r.b;
                        u = X.b;
                        return av({
                            a: n.a,
                            b: A2(Mr, A2(lz, 1, X.a.a), u)
                        });
                    case 9:
                        var V = r.a.a, J = V.a, Y = r.b, W = Y.a.a, K = (u = Y.b, A2(gR, A2(Pz, J, V.b), W));
                        return av(K.$ ? {
                            a: n.a,
                            b: A2(Mr, jz(A3(YU, "\n", W, J.jB)), u)
                        } : {
                            a: n.a,
                            b: A2(Mr, Oz(A2(Lz, K.a, j)), u)
                        });
                    default:
                        break n;
                }
            case 8:
                if (8 === r.a.$) return u = r.b.b, av({
                    a: n.a,
                    b: A2(Mr, Oz(r.a.a), u)
                });
                break n;
            case 10:
                if (!r.b.b.b) break n;
                switch(r.b.b.a.$){
                    case 4:
                        var B = r.b.b, Q = B.a, Z = (T = Q.a, E = Q.b, z = Q.c, U = Q.d, C = Q.e, I = Q.f, u = B.b, A2(Jv, HF(), I));
                        if (Z.$) return tv(rv(Qz(Z.a)));
                        var nn = Z.a;
                        if (4 === e.$) {
                            S = e.b;
                            var en = e.f;
                            return av({
                                a: k(n.a, nn.a),
                                b: A2(Mr, A6(wz, !1, S, z, U, A2(Mr, nn.b, C), en), u)
                            });
                        }
                        return av({
                            a: k(n.a, nn.a),
                            b: A2(Mr, e, A2(Mr, nz, A2(Mr, A6(wz, T, E, z, U, A2(Mr, nn.b, C), I), u)))
                        });
                    case 3:
                        var rn = r.b.b, tn = rn.a, un = (T = tn.a, E = tn.b, C = tn.c, I = tn.d, u = rn.b, A2(Jv, HF(), I.kO));
                        return un.$ ? tv(rv(Qz(un.a))) : (nn = un.a, 3 === e.$ ? (en = e.d, av({
                            a: k(n.a, nn.a),
                            b: A2(Mr, A4(zz, !1, E, A2(Mr, {
                                kO: nn.b,
                                I: I.I
                            }, C), en), u)
                        })) : av({
                            a: k(n.a, nn.a),
                            b: A2(Mr, e, A2(Mr, nz, A2(Mr, A4(zz, T, E, A2(Mr, {
                                kO: nn.b,
                                I: I.I
                            }, C), I), u)))
                        }));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return av({
            a: n.a,
            b: A2(Mr, e, n.b)
        });
    }), CF = F2(function(n, e) {
        var r = e, t = Mi(A2(wu, xI(function(n) {
            return v(n.lt, n.eG);
        }), n));
        return A2(wu, IF, A2(sR, t, r));
    }), IF = function(n) {
        switch(n.$){
            case 0:
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(n.a);
            case 1:
                return fz;
            case 2:
                return function(n) {
                    return {
                        $: 6,
                        a: n
                    };
                }(n.a);
            case 3:
                return A3(xz, n.a, n.b, A2(wu, IF, r = n.c));
            case 4:
                return A3(gz, n.a, n.b, A2(wu, IF, r = n.c));
            case 5:
                return function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(SF(n.a));
            case 6:
                var e = n.a, r = n.b;
                switch(e){
                    case 1:
                        return az(A2(wu, IF, r));
                    case 2:
                        return Iz(A2(wu, IF, r));
                    default:
                        return VU(e) ? Iz(A([
                            IF(A2(iz, e - 2, r))
                        ])) : az(A([
                            IF(A2(iz, e - 1, r))
                        ]));
                }
            default:
                return function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(A2(wu, IF, r = n.a));
        }
    }, SF = function(n) {
        switch(n.$){
            case 1:
                return mz("TODO this never happens, but use types to drop this case.");
            case 0:
                return A3(vz, n.a, n.b, A2(Id, function(n) {
                    return 1 === n.$ ? RF(n.a) : A([
                        bz(SF(n))
                    ]);
                }, n.c));
            case 2:
                return mz(n.a);
            case 3:
                return rz(n.a);
            case 4:
                return Cz(n.a);
            default:
                return A2(pz, n.a, n.b);
        }
    }, OF = function(n) {
        return A2(LF, n, j);
    }, LF = F2(function(n, e) {
        for(;;){
            if (!n.b) return Qr(xt(e));
            var r = n.b, t = A2(AF, n.a, e);
            if (t.$) return Yr(t.a);
            n = r, e = t.a;
        }
    }), PF = function(n) {
        var e = A2(Jv, A2(sv, HF(), Wz), n);
        if (1 === e.$) return Yr(e.a);
        var r = qF(e.a);
        return 1 === r.$ ? A2(Jv, tv(r.a), "") : Qr(A2(Ah, function(n) {
            return !(5 === n.$ && !n.a.b);
        }, r.a));
    }, qF = function(n) {
        return A3(NF, n, n.b, j);
    }, NF = F3(function(n, e, r) {
        n: for(;;){
            if (!e.b) return Qr(r);
            var t = e.b, u = A2(zF, n.a, e.a);
            switch(u.$){
                case 1:
                    e = t, r = A2(Mr, u.a, r);
                    continue n;
                case 0:
                    e = t;
                    continue n;
                default:
                    return Yr(u.a);
            }
        }
    }), _F = F2(function(n, e) {
        return A2(wu, function(e) {
            var r = e.eZ;
            return A3(UF, n, function(n) {
                return {
                    eZ: r,
                    ai: n
                };
            }, e.ai);
        }, e);
    }), zF = F2(function(n, e) {
        switch(e.$){
            case 0:
                var r = e.b, t = function(n) {
                    switch(n){
                        case 1:
                            return Qr(0);
                        case 2:
                            return Qr(1);
                        case 3:
                            return Qr(2);
                        case 4:
                            return Qr(3);
                        case 5:
                            return Qr(4);
                        case 6:
                            return Qr(5);
                        default:
                            return Yr(oz("A heading with 1 to 6 #'s, but found " + ut(n)));
                    }
                }(e.a);
                return t.$ ? $z(t.a) : Tz(A2(sz, t.a, A2(CF, n, r)));
            case 1:
                return Tz(Az(A2(CF, n, r = e.a)));
            case 2:
                return Tz(bz(e.a));
            case 3:
                var u = e.a, a = e.c, i = F2(function(e, r) {
                    var t, u = e.$ ? 0 : e.a ? 2 : 1, a = (t = qF({
                        a: n,
                        b: r
                    })).$ ? j : t.a;
                    return A2(kz, u, a);
                });
                return Tz(A2(_z, JU(u), xt(A2(wu, function(n) {
                    return A2(i, n.I, n.kO);
                }, a))));
            case 4:
                var c = e.d;
                return a = e.e, i = function(e) {
                    var r = qF({
                        a: n,
                        b: e
                    });
                    return r.$ ? j : r.a;
                }, Tz(A3(yz, JU(u = e.a), c, xt(A2(wu, i, a))));
            case 5:
                return Tz(tz(e.a));
            case 7:
                return Tz(qz);
            case 10:
            case 11:
                return cz;
            case 12:
                var o = qF({
                    a: n,
                    b: e.a
                });
                return o.$ ? $z(o.a) : Tz(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(o.a));
            case 6:
                return Tz(tz({
                    kO: e.a,
                    mH: Ur
                }));
            case 8:
                var f = e.a, s = f.b;
                return Tz(A2(Sz, A2(_F, n, f.a), A2(MF, n, s)));
            case 9:
                return Tz(Az(A2(CF, n, e.a.a.jB)));
            default:
                return Tz(Az(A2(CF, n, e.b)));
        }
    }), UF = F3(function(n, e, r) {
        return e(A2(CF, n, r));
    }), MF = F2(function(n, e) {
        return A2(wu, function(e) {
            return A2(wu, function(e) {
                return A3(UF, n, ru, e);
            }, e);
        }, e);
    }), DF = function(n) {
        return vv(A([
            A2(wv, function() {
                return Tv(n);
            }, Wz),
            A2(wv, function(e) {
                return Ev(A2(Uz, n, e));
            }, Mz(QR)),
            function() {
                var e = n.b;
                n: for(; e.b;)switch(e.a.$){
                    case 1:
                        return A2(wv, function(n) {
                            return Ev(n);
                        }, A2(Dp, EF(n), XF()));
                    case 8:
                        var r = e.a.a;
                        return A2(wv, function(n) {
                            return Ev(n);
                        }, A2(Dp, EF(n), vv(A([
                            GF(),
                            mF(r)
                        ]))));
                    case 3:
                        var t = e.a, u = t.a, a = t.b, i = t.c, c = t.d, o = e.b, f = F2(function(n, e) {
                            return $(n, {
                                b: A2(Mr, nz, A2(Mr, A4(zz, u, a, i, $(c, {
                                    kO: A3(YU, "", c.kO, e)
                                })), o))
                            });
                        }), s = F2(function(n, e) {
                            return $(n, {
                                b: A2(Mr, A4(zz, u, a, i, $(c, {
                                    kO: A3(YU, "\n", c.kO, e)
                                })), o)
                            });
                        });
                        return vv(A([
                            A2(wv, function(n) {
                                return Ev(n);
                            }, A2(wv, function() {
                                return A2(f, n, "\n");
                            }, Gz)),
                            A2(wv, function(n) {
                                return Ev(n);
                            }, A2(wv, s(n), A2(dv, A2(sv, av(ru), Nv(A2(Lv, A2(Wc, a, " "), Ov("Indentation")))), A2(sv, nv(Yz), Kz)))),
                            A2(wv, function(n) {
                                return Ev(n);
                            }, A2(Dp, EF(n), VF()))
                        ]));
                    case 4:
                        var l = e.a, d = (u = l.a, a = l.b, l.c), b = l.d;
                        return i = l.e, c = l.f, o = e.b, f = F2(function(n, e) {
                            return $(n, {
                                b: A2(Mr, nz, A2(Mr, A6(wz, u, a, d, b, i, c + "\n" + e), o))
                            });
                        }), s = F2(function(n, e) {
                            return $(n, {
                                b: A2(Mr, A6(wz, u, a, d, b, i, c + "\n" + e), o)
                            });
                        }), vv(A([
                            A2(wv, function(n) {
                                return Ev(n);
                            }, A2(wv, function() {
                                return A2(f, n, "\n");
                            }, Gz)),
                            A2(wv, function(n) {
                                return Ev(n);
                            }, A2(wv, s(n), A2(dv, A2(sv, av(ru), Nv(A2(Lv, A2(Wc, a, " "), Ov("Indentation")))), A2(sv, nv(Yz), Kz)))),
                            A2(wv, function(n) {
                                return Ev(n);
                            }, A2(Dp, EF(n), VF()))
                        ]));
                    case 10:
                        if (!e.b.b) break n;
                        switch(e.b.a.$){
                            case 3:
                                var m = e.b, p = m.a;
                                return u = p.a, a = p.b, i = p.c, c = p.d, o = m.b, f = F2(function(n, e) {
                                    return $(n, {
                                        b: A2(Mr, nz, A2(Mr, A4(zz, u, a, i, $(c, {
                                            kO: A3(YU, "", c.kO, e)
                                        })), o))
                                    });
                                }), s = F2(function(n, e) {
                                    return $(n, {
                                        b: A2(Mr, A4(zz, u, a, i, $(c, {
                                            kO: A3(YU, "\n", c.kO, e)
                                        })), o)
                                    });
                                }), "" === mf(c.kO) ? A2(wv, function(n) {
                                    return Ev(n);
                                }, A2(Dp, EF(n), GF())) : vv(A([
                                    A2(wv, function(n) {
                                        return Ev(n);
                                    }, A2(wv, function() {
                                        return A2(f, n, "\n");
                                    }, Gz)),
                                    A2(wv, function(n) {
                                        return Ev(n);
                                    }, A2(wv, s(n), A2(dv, A2(sv, av(ru), Nv(A2(Lv, A2(Wc, a, " "), Ov("Indentation")))), A2(sv, nv(Yz), Kz)))),
                                    A2(wv, function(n) {
                                        return Ev(n);
                                    }, A2(Dp, EF(n), GF()))
                                ]));
                            case 4:
                                var v = e.b, g = v.a;
                                return u = g.a, a = g.b, d = g.c, b = g.d, i = g.e, c = g.f, o = v.b, f = F2(function(n, e) {
                                    return $(n, {
                                        b: A2(Mr, nz, A2(Mr, A6(wz, u, a, d, b, i, c + "\n" + e), o))
                                    });
                                }), s = F2(function(n, e) {
                                    return $(n, {
                                        b: A2(Mr, A6(wz, u, a, d, b, i, c + "\n" + e), o)
                                    });
                                }), "" === mf(c) ? A2(wv, function(n) {
                                    return Ev(n);
                                }, A2(Dp, EF(n), GF())) : vv(A([
                                    A2(wv, function(n) {
                                        return Ev(n);
                                    }, A2(wv, function() {
                                        return A2(f, n, "\n");
                                    }, Gz)),
                                    A2(wv, function(n) {
                                        return Ev(n);
                                    }, A2(wv, s(n), A2(dv, A2(sv, av(ru), Nv(A2(Lv, A2(Wc, a, " "), Ov("Indentation")))), A2(sv, nv(Yz), Kz)))),
                                    A2(wv, function(n) {
                                        return Ev(n);
                                    }, A2(Dp, EF(n), GF()))
                                ]));
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                return A2(wv, function(n) {
                    return Ev(n);
                }, A2(Dp, EF(n), GF()));
            }(),
            A2(wv, function(n) {
                return Ev(n);
            }, A2(Dp, EF(n), BU))
        ]));
    }, RF = function(n) {
        return A2(Zg, j, PF(n));
    }, FF = function(n) {
        switch(n.$){
            case 1:
                return av(jz(n.a));
            case 0:
                var e = n.a, r = n.b, t = OF(n.c);
                return t.$ ? tv(t.a) : av(dz(A3(vz, e, r, t.a)));
            case 2:
                return av(dz(mz(n.a)));
            case 3:
                return av(dz(rz(n.a)));
            case 4:
                return av(dz(Cz(n.a)));
            default:
                return av(dz(A2(pz, n.a, n.b)));
        }
    };
    function HF() {
        return A2(Dp, TF, A2(yv, {
            a: j,
            b: j
        }, DF));
    }
    function GF() {
        return vv(A([
            dR,
            Gz,
            Bz,
            A2(wv, uz, Mz(IR)),
            XU,
            A2(wv, function() {
                return Nz;
            }, Mz(rF)),
            wF(!1),
            lM(!1),
            Mz(LR),
            JF()
        ]));
    }
    function XF() {
        return vv(A([
            dR,
            Gz,
            Bz,
            A2(wv, uz, Mz(IR)),
            Mz(iF),
            A2(wv, function() {
                return Nz;
            }, Mz(rF)),
            wF(!0),
            lM(!0),
            Mz(LR),
            JF(),
            Mz(dF)
        ]));
    }
    function VF() {
        return vv(A([
            dR,
            Gz,
            Bz,
            A2(wv, uz, Mz(IR)),
            A2(wv, function() {
                return Nz;
            }, Mz(rF)),
            wF(!1),
            lM(!1),
            Mz(LR),
            JF()
        ]));
    }
    function JF() {
        return A2(Dp, FF, UU);
    }
    var YF = HF();
    HF = function() {
        return YF;
    };
    var WF = GF();
    GF = function() {
        return WF;
    };
    var KF = XF();
    XF = function() {
        return KF;
    };
    var BF = VF();
    VF = function() {
        return BF;
    };
    var QF = JF();
    JF = function() {
        return QF;
    };
    var ZF, nH, eH, rH, tH, uH = A2(yu, yx(Mr), Qr(j)), aH = F3(function(n, e, r) {
        n: for(;;){
            if (!r.b) return e;
            var t = r.a, u = r.b;
            switch(t.$){
                case 0:
                    var a = t.a;
                    if (a.$) {
                        c = n, o = A2(n, t, e), n = c, e = o, r = u;
                        continue n;
                    }
                    var i = a.c, c = n, o = A2(n, t, e);
                    n = c, e = o, r = k(i, u);
                    continue n;
                case 1:
                    var f = A2(Id, function(n) {
                        return n.b;
                    }, s = t.b);
                    c = n, o = A2(n, t, e), n = c, e = o, r = k(f, u);
                    continue n;
                case 2:
                    var s = t.c;
                    c = n, o = A2(n, t, e), n = c, e = o, r = k(Cd(s), u);
                    continue n;
                case 3:
                    s = t.a, c = n, o = A2(n, t, e), n = c, e = o, r = k(s, u);
                    continue n;
                default:
                    c = n, o = A2(n, t, e), n = c, e = o, r = u;
                    continue n;
            }
        }
    }), iH = function(n) {
        switch(n.$){
            case 5:
                return cH(n.a);
            case 0:
                var e = n.a;
                if (e.$) return "";
                var r = e.c;
                return A3(aH, F2(function(n, e) {
                    return k(e, iH(n));
                }), "", r);
            case 1:
                return A2(at, "\n", A2(wu, function(n) {
                    return A2(at, "\n", A2(wu, iH, n.b));
                }, n.b));
            case 2:
                return A2(at, "\n", A2(wu, function(n) {
                    return A2(at, "\n", A2(wu, iH, n));
                }, n.c));
            case 3:
                return A2(at, "\n", A2(wu, iH, r = n.a));
            case 4:
                return cH(n.b);
            case 6:
                var t = n.b;
                return A2(at, "\n", Cd(A([
                    A2(wu, cH, A2(wu, function(n) {
                        return n.ai;
                    }, n.a)),
                    Cd(A2(wu, wu(cH), t))
                ])));
            case 7:
                return n.a.kO;
            default:
                return "";
        }
    }, cH = function(n) {
        return A3(ot, oH, "", n);
    }, oH = F2(function(n, e) {
        switch(n.$){
            case 7:
            case 6:
                return k(e, n.a);
            case 8:
                return e + " ";
            case 1:
            case 2:
                return k(e, cH(n.c));
            case 0:
                var r = n.a;
                if (r.$) return e;
                var t = r.c;
                return A3(aH, F2(function(n, e) {
                    return k(e, iH(n));
                }), e, t);
            default:
                return k(e, cH(n.a));
        }
    }), fH = F5(function(n, e, r, t, u) {
        var a = t;
        return A2(as, function(t) {
            return A2(fs, function(n) {
                return n(t);
            }, A3(a, n, e, r));
        }, uH(u));
    }), sH = F3(function(n, e, r) {
        var t = A2(mH, n, e);
        return t.$ ? r : A2(Mr, t.a, r);
    }), lH = F2(function(n, e) {
        return A2(qa, dH(n), e);
    }), dH = function(n) {
        return function(e) {
            switch(e.$){
                case 4:
                    var r = e.a;
                    return zr(A2(fs, function(e) {
                        return n.gC({
                            kV: e,
                            ed: r,
                            nY: cH(t)
                        });
                    }, A2(pH, n, t = e.b)));
                case 5:
                    var t;
                    return zr(A2(fs, n.gZ, A2(pH, n, t = e.a)));
                case 0:
                    var u = e.a;
                    return u.$ ? Ur : zr(A4(bH, n, u.a, u.b, u.c));
                case 1:
                    var a = e.a;
                    return zr(A2(fs, function(e) {
                        return n.hC(A2(wu, function(n) {
                            return A2(kz, n.a, Cd(n.b));
                        }, e));
                    }, uH(A2(wu, function(e) {
                        var r = e.b;
                        return A2(fs, kz(e.a), uH(A2(qa, function(e) {
                            var r = v(a, e);
                            return 1 === r.a && 5 === r.b.$ ? zr(A2(pH, n, r.b.a)) : A2(Pc, fs(ck), A2(dH, n, e));
                        }, r)));
                    }, e.b))));
                case 2:
                    a = e.a;
                    var i = e.b;
                    return zr(A2(fs, function(e) {
                        return A2(n.gX, i, A2(wu, function(n) {
                            return Cd(n);
                        }, e));
                    }, uH(A2(wu, function(e) {
                        return uH(A2(qa, function(e) {
                            var r = v(a, e);
                            return 1 === r.a && 5 === r.b.$ ? zr(A2(pH, n, r.b.a)) : A2(Pc, fs(ck), A2(dH, n, e));
                        }, e));
                    }, e.c))));
                case 7:
                    return zr(Qr(n.gf(e.a)));
                case 8:
                    return zr(Qr(n.hu));
                case 3:
                    return zr(A2(fs, n.gb, uH(A2(lH, n, e.a))));
                default:
                    var c = e.a, o = e.b, f = uH(A2(wu, function(e) {
                        var r = e.ai;
                        return A2(fs, Nw(e.eZ), A2(pH, n, r));
                    }, c)), s = A2(fs, function(e) {
                        return n.hp(ck(n.fP(A2(wu, function(e) {
                            return A2(n.hq, e.a, e.b);
                        }, e))));
                    }, f), l = function(e) {
                        return A2(fs, n.fP, A2(fs, bt(F2(function(e, r) {
                            return A2(n.ho, A2(Ba, function(n) {
                                return n.eZ;
                            }, q$(A2($x, e, c))), r);
                        })), uH(A2(wu, pH(n), e))));
                    }, d = uH(A2(wu, l, o));
                    return zr(A3(yx, F2(function(e, r) {
                        return n.hm(A2(Mr, e, function(e) {
                            return sf(e) ? j : A([
                                n.hn(e)
                            ]);
                        }(r)));
                    }), s, d));
            }
        };
    }, bH = F4(function(n, e, r, t) {
        return A5(fH, e, r, t, n.gE, A2(lH, n, t));
    }), mH = F2(function(n, e) {
        switch(e.$){
            case 4:
                return zr(A2(fs, n.hi, A2(pH, n, e.a)));
            case 3:
                return zr(A2(fs, n.gs, A2(pH, n, e.a)));
            case 5:
                return zr(A2(fs, n.hh, A2(pH, n, e.a)));
            case 2:
                var r = e.a, t = e.b;
                return zr(Qr(n.gF({
                    f8: cH(e.c),
                    hf: r,
                    eG: t
                })));
            case 7:
                return zr(Qr(n.z(e.a)));
            case 6:
                return zr(Qr(n.gg(e.a)));
            case 1:
                var u = e.a;
                return t = e.b, zr(A2(as, function(e) {
                    return Qr(A2(n.dj, {
                        lt: u,
                        eG: t
                    }, e));
                }, A2(pH, n, e.c)));
            case 8:
                return zr(Qr(n.gA));
            default:
                var a = e.a;
                return a.$ ? Ur : zr(A4(bH, n, a.a, a.b, a.c));
        }
    }), pH = F2(function(n, e) {
        return uH(A3(yu, sH(n), j, e));
    }), vH = F2(function(n, e) {
        return uH(A2(lH, n, e));
    }), gH = A2(Hu, g_, A2(Hu, PF, A2(Hu, $a(A2(Hu, wu(h_), at("\n"))), as(vH(Z_))))), hH = F2(function(n, e) {
        var r = gH(e);
        if (1 === r.$) {
            var t = r.a;
            return A2(WN, A([
                YN("fr-alert fr-alert--warning")
            ]), A([
                c_(t)
            ]));
        }
        var u = r.a;
        return A2(WN, A2(Mr, YN("Markdown bottomed-paragraphs"), n), u);
    }), $H = "/versions/v7.0.0/", xH = F2(function(n, e) {
        switch(e.$){
            case 4:
                return v_(A([
                    b_,
                    A2(hH, j, "**M\xe9thodologie stabilis\xe9e.** Calculette en cours de d\xe9veloppement")
                ]));
            case 5:
                switch(e.a){
                    case 0:
                    default:
                        return v_(A([
                            b_,
                            A2(hH, j, "**Cette version est en cours de d\xe9veloppement.** Elle est r\xe9serv\xe9e \xe0 des beta-testeurs.")
                        ]));
                    case 1:
                        return v_(A([
                            b_,
                            A2(hH, j, "**M\xe9thodologie stabilis\xe9e. Cette version de la calculette remplacera \xe0 terme la version initiale.**"),
                            A2(hH, j, "Contribuez via notre [forum utilisateur](https://chat.ecobalyse.fr/ecobalyse/channels/02_alimentaire_general).")
                        ]));
                    case 2:
                        return v_(A([
                            b_,
                            A2(hH, j, "**Cette version est en cours de d\xe9veloppement.**"),
                            A2(hH, j, "Contribuez via notre [forum utilisateur](https://chat.ecobalyse.fr/ecobalyse/channels/41_ameublement)")
                        ]));
                }
            case 9:
                return v_(A([
                    b_,
                    A2(hH, j, "**Cette version est en cours de d\xe9veloppement.** La version r\xe9glementaire est la v7.0.0.\n                    "),
                    A2(e_, A([
                        o_("button"),
                        YN("btn btn-link p-0 m-0"),
                        i_(n(s_($H + "#/textile/simulator"))),
                        YN("ms-1")
                    ]), A([
                        c_("Acc\xe9der \xe0 la version r\xe9glementaire")
                    ]))
                ]));
            default:
                return c_("");
        }
    }), kH = fe("main"), jH = {
        $: 1
    }, yH = JN("id"), wH = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), AH = F3(function(n, e, r) {
        return {
            $: 1,
            a: n,
            b: e,
            c: r
        };
    }), TH = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), EH = "https://fabrique-numerique.gitbook.io/ecobalyse/communaute", CH = "ecobalyse@beta.gouv.fr", IH = "https://fabrique-numerique.gitbook.io/ecobalyse", SH = F2(function(n, e) {
        return n ? zr(e) : Ur;
    }), OH = fe("sup"), LH = function(n) {
        return A2(qa, ru, A([
            zr(A3(AH, A([
                c_("Accueil")
            ]), gd, FN)),
            A2(SH, n.oX, A3(AH, A([
                c_("Textile")
            ]), xd, XN)),
            A2(SH, n.l5, A3(AH, A([
                c_("Alimentaire")
            ]), vd, DN)),
            A2(SH, n.fh, A3(AH, A([
                c_("Alimentaire"),
                A2(OH, j, A([
                    c_("B\xc9TA")
                ]))
            ]), _b(1), RN(1))),
            A2(SH, n.nn, A3(AH, A([
                c_("Objets")
            ]), _b(2), RN(2))),
            A2(SH, n.f2, A3(AH, A([
                c_("V\xe9hicules")
            ]), _b(3), RN(3))),
            A2(SH, n.e$, A3(AH, A([
                c_("Habillement")
            ]), _b(0), RN(0))),
            zr(A3(AH, A([
                c_("Explorateur")
            ]), A2(bd, bs, yd(Ur)), MN)),
            zr(A3(AH, A([
                c_("API")
            ]), od, _N)),
            zr(A2(TH, "Contact", CH))
        ]));
    }, PH = me, qH = PH, NH = ve("rel"), _H = JN("target"), zH = function(n) {
        return VN(k(n, A([
            _H("_blank"),
            YN("link-external"),
            NH("noopener noreferrer")
        ])));
    }, UH = "https://github.com/MTES-MCT/ecobalyse", MH = function(n) {
        if (2 === n.$) {
            var e = n.a;
            return A2(F2(function(n, e) {
                return A2(zH, A([
                    YN("text-decoration-none"),
                    QN(n)
                ]), A([
                    c_("Version\xa0: " + e)
                ]));
            }), UH + "/commit/" + e.gB, e.gB);
        }
        return c_("");
    }, DH = function(n) {
        return VN(n);
    }, RH = F2(function(n, e) {
        switch(e.$){
            case 0:
                var r = e.a, t = e.b;
                return A2(zH, A([
                    YN("nav-link link-external-muted"),
                    QN(t)
                ]), A([
                    c_(r)
                ]));
            case 1:
                r = e.a;
                var u = e.b, a = e.c;
                return A2(DH, A2(Mr, YN("nav-link"), A2(Mr, r_(A([
                    v("active", s(a, n))
                ])), A2(Mr, ZN(u), s(a, n) ? A([
                    A2(n_, "aria-current", "page")
                ]) : j))), r);
            default:
                r = e.a;
                var i = e.b;
                return A2(VN, A([
                    YN("nav-link"),
                    QN("mailto:" + i)
                ]), A([
                    c_(r)
                ]));
        }
    }), FH = function(n) {
        var e, r, t = n.hK, u = n.o_;
        return A2(WN, j, A([
            A2(WN, A([
                YN("offcanvas offcanvas-start show"),
                A2(qH, "visibility", "visible"),
                yH("navigation"),
                A2(n_, "tabindex", "-1"),
                A2(n_, "aria-labelledby", "navigationLabel"),
                A2(n_, "arial-modal", "true"),
                A2(n_, "role", "dialog")
            ]), A([
                A2(WN, A([
                    YN("offcanvas-header")
                ]), A([
                    A2(t_, A([
                        YN("h5 offcanvas-title"),
                        yH("navigationLabel")
                    ]), A([
                        c_("Navigation")
                    ])),
                    A2(e_, A([
                        o_("button"),
                        YN("btn-close text-reset"),
                        A2(n_, "aria-label", "Close"),
                        i_(u(jH))
                    ]), j)
                ])),
                A2(WN, A([
                    YN("offcanvas-body")
                ]), A([
                    A2(WN, A([
                        YN("nav nav-pills flex-column")
                    ]), A2(wu, RH(t), (e = n, r = e.iX, k(LH(e.lR), A([
                        A2(wH, "Documentation", IH),
                        A2(wH, "Communaut\xe9", EH),
                        A2(TH, "Contact", CH),
                        A3(AH, A(r ? [
                            c_("Mon compte")
                        ] : [
                            c_("Connexion ou inscription")
                        ]), fd, zN)
                    ]))))),
                    A2(S_, A([
                        YN("h6 mt-3")
                    ]), A([
                        c_("Versions")
                    ])),
                    MH(n.ld),
                    A2(VN, A([
                        YN("nav-link"),
                        QN($H),
                        i_(u(s_($H)))
                    ]), A([
                        c_("Version stable textile")
                    ]))
                ]))
            ])),
            A2(WN, A([
                YN("offcanvas-backdrop fade show")
            ]), j)
        ]));
    }, HH = {
        $: 5
    }, GH = function(n) {
        var e = n.ld, r = n.o_;
        if (e.$) return c_("");
        var t = e.b.fR;
        return A2(WN, A([
            YN("NewVersionAlert d-block align-items-center")
        ]), A([
            c_(t.$ ? "Une nouvelle version de l'application est disponible." : "La nouvelle version " + t.a + " de l'application est disponible."),
            A2(e_, A([
                o_("button"),
                YN("btn btn-outline-primary"),
                i_(r(HH))
            ]), A([
                c_("Mettre \xe0 jour")
            ]))
        ]));
    }, XH = {
        $: 6
    }, VH = fe("details"), JH = A2(Hu, A2(Yb, " ", "%20"), A2(Hu, A2(Yb, "\n", "%0A"), A2(Hu, A2(Yb, "\r", "%0D"), A2(Hu, A2(Yb, "\t", "%09"), A2(Hu, A2(Yb, '"', "%22"), A2(Hu, A2(Yb, "'", "%27"), A2(Hu, A2(Yb, "<", "%3C"), A2(Hu, A2(Yb, ">", "%3E"), A2(Yb, "&", "%26"))))))))), YH = function(n) {
        return A2(D_, A([
            YN("fs-7 mt-1 mb-0")
        ]), A([
            A2(VN, A([
                QN("mailto:" + CH + "?Subject=" + JH("[Ecobalyse] Erreur rencontr\xe9e") + "&Body=" + (JH("Bonjour, j'ai rencontr\xe9 une erreur sur le site Ecobalyse. En voici les d\xe9tails:\n\n") + JH(n)))
            ]), A([
                c_("Envoyer un rapport d'incident par email")
            ]))
        ]));
    }, WH = fe("summary"), KH = F3(function(n, e, r) {
        var t = RI(r), u = t.ip, a = t.mc, i = t.j4, c = t.eG, o = t.a6, f = A2(at, "\n", A2(qa, function(n) {
            var e = n.a;
            return A2(Pc, function(n) {
                return e + ": " + n;
            }, n.b);
        }, A([
            v("Title", c),
            v("Message", zr(u)),
            v("URL", su(o) ? Ur : zr(o)),
            v("Status code", i ? zr(ut(i)) : Ur),
            v("En-t\xeates", UI(a) ? Ur : zr(zc(A2(wu, function(n) {
                return "\n- " + n.a + ": " + n.b;
            }, Gr(a)))))
        ])));
        return f_({
            hS: j,
            h4: e,
            h9: A([
                A2(WN, j, A([
                    A2(D_, A([
                        YN("mb-2 text-truncate")
                    ]), A([
                        function() {
                            if (c.$) return c_(u);
                            var n = c.a;
                            return s(n, u) || su(n) ? c_(u) : A2(m_, j, A([
                                A2(H_, j, A([
                                    c_(n + "\xa0: ")
                                ])),
                                c_(u)
                            ]));
                        }()
                    ])),
                    A2(VH, j, A([
                        A2(WH, j, A([
                            c_("D\xe9tails de l'erreur")
                        ])),
                        A2(R_, A([
                            YN("mt-1 mb-0 ms-3")
                        ]), A([
                            c_(f)
                        ]))
                    ])),
                    YH(u + " " + f)
                ])),
                A2(WN, A([
                    YN("fs-8 text-muted")
                ]), A([
                    A2(C_, j, A([
                        c_("Backend url: " + n + "/backend/api")
                    ]))
                ]))
            ]),
            ed: 0,
            eG: zr("Une erreur serveur a \xe9t\xe9 rencontr\xe9e")
        });
    }), BH = F2(function(n, e) {
        var r = n.kY, t = n.o_, u = t(function(n) {
            return {
                $: 2,
                a: n
            };
        }(e));
        switch(e.$){
            case 0:
                var a = e.a, i = A3(KH, r, zr(u), a);
                if (1 === a.$) {
                    var c = a.a.j4, o = a.a.eG;
                    return 409 === c && A2(au, "user already exists", a.a.ip) ? f_({
                        hS: j,
                        h4: zr(u),
                        h9: A([
                            c_("Un compte associ\xe9 \xe0 cette adresse email existe d\xe9j\xe0.")
                        ]),
                        ed: 3,
                        eG: zr("Compte utilisateur existant")
                    }) : 403 === c && A2(Nc, !1, A2(Pc, au("already used"), o)) ? f_({
                        hS: j,
                        h4: zr(u),
                        h9: A([
                            c_("Ce lien d'authentification \xe0 usage unique a d\xe9j\xe0 \xe9t\xe9 utilis\xe9.\n                                          Vous pouvez en redemander un nouveau via le formulaire de connexion ci-dessous.")
                        ]),
                        ed: 3,
                        eG: zr("Lien d'identification expir\xe9")
                    }) : i;
                }
                return i;
            case 1:
                o = e.a;
                var f = e.b;
                return f_({
                    hS: j,
                    h4: zr(u),
                    h9: A([
                        A2(hH, A([
                            YN("mb-1")
                        ]), f)
                    ]),
                    ed: 0,
                    eG: zr(o)
                });
            default:
                var s = e.a;
                return f_({
                    hS: j,
                    h4: Ur,
                    h9: A([
                        A2(D_, A([
                            YN("fw-bold mb-2")
                        ]), A([
                            c_("Vos pr\xe9c\xe9dente session n'a pas pu \xeatre r\xe9cup\xe9r\xe9e et doit \xeatre r\xe9initialis\xe9e.")
                        ])),
                        A2(D_, A([
                            YN("fs-7 d-flex align-items-baseline gap-1")
                        ]), A([
                            c_("\u24D8 Cela se produit g\xe9n\xe9ralement lorsque de nouvelles fonctionnalit\xe9s ou correctifs appliqu\xe9s introduisent des incompatibilit\xe9s avec le format de ces donn\xe9es.")
                        ])),
                        A2(D_, j, A([
                            A2(e_, A([
                                YN("btn btn-primary"),
                                i_(t(XH))
                            ]), A([
                                c_("D\u2019accord, r\xe9initialiser la session")
                            ]))
                        ])),
                        A2(VH, A([
                            YN("fs-8")
                        ]), A([
                            A2(WH, j, A([
                                c_("Afficher les d\xe9tails techniques de l'erreur")
                            ])),
                            A2(R_, A([
                                YN("card p-2 mt-2 bg-light")
                            ]), A([
                                A2(A_, j, A([
                                    c_(yt(s))
                                ]))
                            ]))
                        ]))
                    ]),
                    ed: 1,
                    eG: zr("Probl\xe8me de r\xe9cup\xe9ration de la session")
                });
        }
    }), QH = function(n) {
        var e = n.a1;
        if (e.b) {
            var r = e;
            return A2(KN, A([
                YN("bg-white pt-3")
            ]), A2(wu, BH(n), r));
        }
        return c_("");
    }, ZH = fe("footer"), nG = function(n) {
        return A2(au, "ecobalyse-pr", n) || A2(au, "staging-ecobalyse", n);
    }, eG = A([
        A3(AH, A([
            c_("Accessibilit\xe9\xa0: non conforme")
        ]), dd("accessibilit\xe9"), UN("accessibilit\xe9")),
        A3(AH, A([
            c_("Mentions l\xe9gales")
        ]), dd("mentions-l\xe9gales"), UN("mentions-l\xe9gales")),
        A3(AH, A([
            c_("Politique de confidentialit\xe9")
        ]), dd("politique-de-confidentialite"), UN("politique-de-confidentialite")),
        A2(TH, "Contact", CH)
    ]), rG = "https://fabrique-numerique.gitbook.io/ecobalyse/conditions-dutilisation", tG = function(n) {
        return A2(qa, ru, A([
            zr(A3(AH, A([
                c_("Derni\xe8res mises \xe0 jour")
            ]), dd("maj"), UN("maj"))),
            zr(A3(AH, A([
                c_("Statistiques")
            ]), hd, GN)),
            zr(A2(wH, "Documentation", IH)),
            zr(A2(wH, "Communaut\xe9", EH)),
            zr(A2(wH, "Code source", UH)),
            zr(A2(wH, "CGU", rG)),
            A2(SH, n.fh, A3(AH, A([
                c_("Alimentaire\xb2")
            ]), _b(1), RN(1)))
        ]));
    }, uG = function(n) {
        var e = n.kY, r = n.lR, t = function(n) {
            switch(n.$){
                case 0:
                    var e = n.a, r = n.b;
                    return A2(zH, A([
                        YN("text-decoration-none"),
                        QN(r)
                    ]), A([
                        c_(e)
                    ]));
                case 1:
                    e = n.a;
                    var t = n.b;
                    return A2(DH, A([
                        YN("text-decoration-none"),
                        ZN(t)
                    ]), e);
                default:
                    e = n.a;
                    var u = n.b;
                    return A2(VN, A([
                        YN("text-decoration-none"),
                        QN("mailto:" + u)
                    ]), A([
                        c_(e)
                    ]));
            }
        };
        return A2(ZH, A2(Mr, YN("Footer"), nG(e) ? A([
            YN("pb-5")
        ]) : j), A([
            A2(WN, A([
                YN("FooterNavigation")
            ]), A([
                A2(KN, j, A([
                    A2(WN, A([
                        YN("row")
                    ]), A([
                        A2(WN, A([
                            YN("col-6 col-sm-4 col-md-3 col-lg-2")
                        ]), A([
                            A2(B_, A([
                                YN("list-unstyled")
                            ]), A2(wu, A2(Hu, ck, __(j)), A2(wu, t, LH(r))))
                        ])),
                        A2(WN, A([
                            YN("col-6 col-sm-4 col-md-3 col-lg-2")
                        ]), A([
                            A2(B_, A([
                                YN("list-unstyled")
                            ]), A2(wu, A2(Hu, ck, __(j)), A2(wu, t, tG(r))))
                        ]))
                    ]))
                ]))
            ])),
            A2(KN, A([
                YN("d-flex flex-wrap justify-content-center justify-content-sm-between align-items-center gap-3")
            ]), A([
                A2(VN, A([
                    YN("FooterBrand py-3"),
                    QN("https://www.ecologie.gouv.fr/")
                ]), A([
                    A2(q_, A([
                        YN("FooterLogo"),
                        x_("Minist\xe8re de la Transition \xe9cologique et de la Coh\xe9sion des Territoires"),
                        F_("img/logo_mte.svg"),
                        A2(qH, "width", "201px"),
                        A2(qH, "height", "135px"),
                        A2(qH, "aspect-ratio", "auto 201 / 135")
                    ]), j)
                ])),
                A2(VN, A([
                    YN("FooterBrand py-3"),
                    QN("https://www.ademe.fr/")
                ]), A([
                    A2(q_, A([
                        YN("FooterLogo"),
                        x_("Ademe"),
                        F_("img/logo_ademe.svg"),
                        A2(qH, "height", "120px"),
                        A2(qH, "aspect-ratio", "auto 79.41 / 93.61")
                    ]), j)
                ])),
                A2(WN, A([
                    YN("d-flex justify-content-end align-items-center gap-4 mt-2")
                ]), A([
                    A2(zH, A([
                        YN("FooterInstitutionLink"),
                        QN("https://www.ademe.fr/")
                    ]), A([
                        c_("ademe.fr")
                    ])),
                    A2(zH, A([
                        YN("FooterInstitutionLink"),
                        QN("https://beta.gouv.fr/startups/ecobalyse.html")
                    ]), A([
                        c_("beta.gouv.fr")
                    ])),
                    A2(zH, A([
                        YN("FooterInstitutionLink"),
                        QN("https://www.ecologie.gouv.fr/fabrique-numerique")
                    ]), A([
                        c_("Fabrique Num\xe9rique")
                    ])),
                    A2(zH, A([
                        YN("FooterInstitutionLink"),
                        QN("https://www.economie.gouv.fr/plan-de-relance")
                    ]), A([
                        c_("France Relance")
                    ]))
                ]))
            ])),
            A2(KN, j, A([
                A2(B_, A([
                    YN("FooterLegal d-flex justify-content-start flex-wrap gap-2 list-unstyled mt-3 pt-2 border-top")
                ]), A2(QS, A2(__, A([
                    A2(n_, "aria-hidden", "true"),
                    YN("text-muted")
                ]), A([
                    c_("|")
                ])), A2(wu, A2(Hu, ck, __(j)), A2(wu, t, eG)))),
                A2(WN, A([
                    YN("d-flex align-items-center gap-1 fs-9 mb-2")
                ]), A([
                    MH(n.ld),
                    c_("\xa0|\xa0"),
                    A2(zH, A([
                        QN(UH)
                    ]), A([
                        c_("technical changelog")
                    ]))
                ]))
            ]))
        ]));
    }, aG = {
        $: 4
    }, iG = function(n) {
        return {
            $: 7,
            a: n
        };
    }, cG = function(n) {
        return WN(A2(Mr, YN("container-fluid"), n));
    }, oG = d_("ham"), fG = fe("header"), sG = fe("nav"), lG = function(n) {
        return v(n, !0);
    }, dG = F2(function(n, e) {
        return A2(u_, n, function(n) {
            return {
                $: 1,
                a: n
            };
        }(e));
    }), bG = A2(sl, A([
        "target",
        "value"
    ]), ai), mG = function(n) {
        return A2(dG, "input", A2(Qt, lG, A2(Qt, n, bG)));
    }, pG = fe("option"), vG = fe("select"), gG = y_("selected"), hG = JN("value"), $G = function(n) {
        var e, r = n.hK, t = n.o_;
        return A2(fG, A([
            YN("Header shadow-sm"),
            r_(A([
                v("mb-2", !s(r, FN))
            ])),
            A2(n_, "role", "banner")
        ]), A([
            A2(WN, A([
                YN("MobileMenuButton")
            ]), A([
                A2(e_, A([
                    o_("button"),
                    YN("d-inline-block d-sm-none btn m-0 p-0"),
                    A2(n_, "aria-label", "Ouvrir la navigation"),
                    W_("Ouvrir la navigation"),
                    i_(t(aG))
                ]), A([
                    A2(m_, A([
                        YN("fs-3")
                    ]), A([
                        oG
                    ]))
                ]))
            ])),
            A2(KN, A([
                YN("d-flex justify-content-between align-items-center gap-2")
            ]), A([
                A2(VN, A([
                    YN("HeaderBrand text-decoration-none d-flex align-items-center gap-3 gap-sm-5 pe-3"),
                    A2(n_, "data-testid", "header-brand"),
                    YN("fr-header__brand"),
                    ZN(gd)
                ]), A([
                    A2(q_, A([
                        YN("HeaderLogo"),
                        x_("R\xe9publique Fran\xe7aise"),
                        F_("img/republique-francaise.svg")
                    ]), j),
                    A2(BN, A([
                        YN("HeaderTitle")
                    ]), A([
                        A2(q_, A([
                            YN("HeaderSubLogo"),
                            x_("BetaGouv"),
                            F_("img/logo_betagouv.jpg")
                        ]), j),
                        c_("Ecobalyse")
                    ]))
                ])),
                A2(vG, A([
                    YN("VersionSelector d-none d-sm-block form-select form-select-sm w-auto"),
                    A2(n_, "data-testid", "version-selector"),
                    mG(A2(cc, t, iG))
                ]), A([
                    A2(pG, A([
                        gG(!0)
                    ]), A([
                        c_("Version courante")
                    ])),
                    A2(pG, A([
                        hG("v7.0.0")
                    ]), A([
                        c_("Version stable textile")
                    ]))
                ])),
                A2(WN, A([
                    YN("HeaderAuthLink flex-fill")
                ]), A([
                    A2(VN, A([
                        YN("d-none d-sm-block flex-fill text-end"),
                        ZN(fd),
                        A2(n_, "data-testid", "auth-link")
                    ]), A([
                        c_(n.iX ? "Mon compte" : "Connexion ou inscription")
                    ]))
                ]))
            ])),
            A2(cG, A([
                YN("border-top")
            ]), A([
                A2(WN, A([
                    YN("container")
                ]), A([
                    A2(sG, A([
                        YN("text-end text-sm-start"),
                        A2(n_, "role", "navigation"),
                        A2(n_, "aria-label", "Menu principal")
                    ]), A([
                        A2(WN, A([
                            YN("HeaderNavigation d-none d-sm-flex navbar-nav flex-row overflow-auto")
                        ]), A2(wu, RH(r), (e = n, k(LH(e.lR), A([
                            A2(wH, "Communaut\xe9", EH),
                            A2(wH, "Documentation", IH)
                        ])))))
                    ]))
                ]))
            ]))
        ]));
    }, xG = p_(A([
        YN("page-notice-warning")
    ])), kG = function(n) {
        return n.iX && !n.oW ? xG(A([
            A2(hH, j, A3(Yb, "{url}", _T(fd), "Attention, vous \xeates connect\xe9 mais n\u2019avez pas accept\xe9 les conditions d\u2019utilisation ecoinvent, vous privant ainsi\n                 de **l\u2019acc\xe8s aux impacts d\xe9taill\xe9s** (changement climatique, consommation d'eau, etc). **Vous pouvez\n                 les lire et les accepter depuis [votre espace personnel]({url}).**"))
        ])) : c_("");
    }, jG = function(n) {
        return se(ke(n));
    }, yG = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), wG = we, AG = wG, TG = function(n) {
        return wu(AG(n));
    }, EG = function(n) {
        return A2(a_, "blur", nu(n));
    }, CG = function(n) {
        return A2(a_, "focus", nu(n));
    }, IG = function(n) {
        return A2(a_, "mouseleave", nu(n));
    }, SG = F2(function(n, e) {
        var r;
        return A2(TG, n, A([
            A2(ve, "tabIndex", ut(0)),
            (r = A2(yG, 0, e), A2(a_, "mouseenter", nu(r))),
            IG(A2(yG, 1, e)),
            CG(A2(yG, 0, e)),
            EG(A2(yG, 1, e))
        ]));
    }), OG = F2(function(n, e) {
        return e ? j : n.d5;
    }), LG = F2(function(n, e) {
        switch(e){
            case 0:
                return n.b2;
            case 1:
                return j;
            default:
                return n.b5;
        }
    }), PG = F2(function(n, e) {
        return Cd(A([
            n.eM,
            A2(OG, n, e.be),
            A2(LG, n, e.bj),
            A2(SG, n.hv, e.mj)
        ]));
    }), qG = F3(function(n, e, r) {
        return v("toast-" + ut(r.mj), A2(n, A2(PG, e, r), function(n) {
            return {
                h9: n.h9,
                mj: n.mj,
                be: n.be,
                bj: n.bj
            };
        }(r)));
    }), NG = F3(function(n, e, r) {
        var t = e;
        return A3(jG, r.fY, r.eO, A2(wu, A2(qG, n, r), t.bo));
    }), _G = fN(2), zG = function(n) {
        switch(n){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, UG = F3(function(n, e, r) {
        var t = n.o_, u = r.h9, a = r.mj;
        return f_({
            hS: k(e, A([
                YN("Toast")
            ])),
            h4: zr(t(oN(_G(a)))),
            h9: A([
                A2(hH, A([
                    YN("mb-1")
                ]), u.eh)
            ]),
            ed: zG(u.ed),
            eG: u.eG
        });
    }), MG = F2(function(n, e) {
        var r = e;
        return $(r, {
            b2: k(r.b2, n),
            b5: k(r.b5, n)
        });
    }), DG = F2(function(n, e) {
        return $(e, {
            eO: k(e.eO, n)
        });
    }), RG = function(n) {
        var e = n.o_, r = n.bp;
        return A3(NG, UG(n), r, A2(MG, A([
            YN("fade")
        ]), A2(DG, A([
            YN("ToastTray")
        ]), {
            b2: j,
            b5: j,
            d5: j,
            hv: A2(Hu, oN, e),
            eM: j,
            eO: j,
            fY: "div"
        })));
    }, FG = F2(function(n, e) {
        var r, t, u = n.hK;
        return A([
            (r = n, t = r.o_, nG(r.kY) ? A2(WN, A([
                YN("StagingAlert d-block d-sm-flex justify-content-center align-items-center mt-3")
            ]), A([
                c_("Vous \xeates sur un environnement de recette. "),
                A2(e_, A([
                    o_("button"),
                    YN("btn btn-link"),
                    i_(t(s_("https://ecobalyse.beta.gouv.fr/")))
                ]), A([
                    c_("Retourner vers l'environnement de production")
                ]))
            ])) : c_("")),
            GH(n),
            $G(n),
            A2(xH, n.o_, u),
            kG(n),
            n.cn ? FH(n) : c_(""),
            A2(kH, A([
                YN("PageContent bg-white highcharts-light")
            ]), A([
                QH(n),
                RG(n),
                A2(WN, A([
                    s(u, FN) ? YN("") : YN("pt-2 pt-sm-5")
                ]), e)
            ])),
            uG(n)
        ]);
    }), HG = fe("form"), GG = function(n) {
        return v(n, !0);
    }, XG = F2(function(n, e) {
        return A2(u_, n, function(n) {
            return {
                $: 2,
                a: n
            };
        }(e));
    }), VG = function(n) {
        return A2(XG, "submit", A2(Qt, GG, nu(n)));
    }, JG = function(n) {
        var e, r = A([
            YN("modal-content")
        ]), t = (e = n.l7).$ ? WN(r) : HG(k(r, A([
            VG(e.a)
        ])));
        return A2(WN, A([
            YN("Modal")
        ]), A([
            A2(WN, A([
                YN("modal d-block fade show"),
                A2(n_, "tabindex", "-1"),
                A2(n_, "aria-modal", "true"),
                A2(n_, "role", "dialog"),
                A2(n_, "data-dismiss", "modal"),
                A2(a_, "click", A2(Qt, Wi(n.h4), A2(sl, A([
                    "target",
                    "dataset",
                    "dismiss"
                ]), ai)))
            ]), A([
                A2(WN, A([
                    YN("modal-dialog modal-dialog-centered modal-dialog-scrollable"),
                    r_(A([
                        v("modal-xl", !n.oE),
                        v("modal-lg", 2 === n.oE),
                        v("modal-sm", 3 === n.oE),
                        v("modal-fluid", 1 === n.oE)
                    ])),
                    A2(n_, "aria-modal", "true")
                ]), A([
                    t(A([
                        A2(WN, A([
                            YN("modal-header d-flex justify-content-between align-items-center gap-2")
                        ]), A([
                            A2(m_, A([
                                YN("h5 mb-0"),
                                A2(n_, "aria-hidden", "true")
                            ]), A([
                                c_("\u2192")
                            ])),
                            A2(WN, A([
                                YN("d-flex flex-column gap-1")
                            ]), A([
                                A2(O_, A([
                                    YN("modal-title lh-sm")
                                ]), A([
                                    c_(n.eG)
                                ])),
                                function() {
                                    var e = n.oM;
                                    if (e.$) return c_("");
                                    var r = e.a;
                                    return A2(WN, A([
                                        YN("text-muted fs-7 fw-normal")
                                    ]), A([
                                        c_(r)
                                    ]));
                                }()
                            ])),
                            A2(e_, A([
                                o_("button"),
                                YN("btn-close"),
                                A2(n_, "aria-label", "Fermer"),
                                i_(n.h4)
                            ]), j)
                        ])),
                        A2(WN, A([
                            YN("modal-body no-scroll-chaining p-0")
                        ]), n.h9),
                        sf(n.l6) ? c_("") : A2(WN, A([
                            YN("modal-footer bg-light")
                        ]), n.l6)
                    ]))
                ]))
            ])),
            A2(WN, A([
                YN("modal-backdrop fade show")
            ]), j)
        ]));
    }, YG = F2(function(n, e) {
        var r;
        return $(e, {
            kO: k(e.kO, n.bc ? A([
                (r = n.k_, JG({
                    h4: r,
                    h9: A([
                        A2(WN, A([
                            YN("d-flex flex-column align-items-center gap-3 p-4 text-center")
                        ]), A([
                            A2(D_, A([
                                YN("mb-0")
                            ]), A([
                                c_("Vous avez r\xe9alis\xe9 vos premiers calculs de co\xfbt environnemental.\n                              Dites-nous comment cela s\u2019est pass\xe9 en cliquant sur le bouton ci-dessous.")
                            ])),
                            A2(VN, A([
                                YN("d-inline-block"),
                                QN("https://jedonnemonavis.numerique.gouv.fr/Demarches/4223?button=4973"),
                                i_(r),
                                NH("noopener noreferrer"),
                                _H("_blank"),
                                W_("Je donne mon avis - nouvelle fen\xeatre")
                            ]), A([
                                A2(q_, A([
                                    x_("Je donne mon avis"),
                                    YN("img-fluid"),
                                    F_("https://jedonnemonavis.numerique.gouv.fr/static/bouton-bleu-clair.svg")
                                ]), j)
                            ]))
                        ]))
                    ]),
                    l6: j,
                    l7: Ur,
                    oE: 4,
                    oM: Ur,
                    eG: "Donnez-nous votre avis !"
                }))
            ]) : j)
        });
    }), WG = F2(function(n, e) {
        var r = e.a;
        return A2(YG, n, {
            kO: A2(FG, n, e.b),
            eG: r + " | Ecobalyse"
        });
    }), KG = function(n) {
        return A2(ot, F2(function(e, r) {
            return n(e) ? r + 1 : r;
        }), 0);
    }, BG = A([
        function(n) {
            return n.e0;
        },
        function(n) {
            return n.dS;
        },
        function(n) {
            return n.dT;
        },
        function(n) {
            return n.bT;
        },
        function(n) {
            return n.c_;
        },
        function(n) {
            return n.d7;
        },
        function(n) {
            return n.d6;
        },
        function(n) {
            return n.d8;
        },
        function(n) {
            return n.d9;
        },
        function(n) {
            return n.er;
        },
        function(n) {
            return n.ep;
        },
        function(n) {
            return n.eq;
        },
        function(n) {
            return n.W;
        },
        function(n) {
            return n.eB;
        },
        function(n) {
            return n.eC;
        },
        function(n) {
            return n.eD;
        },
        function(n) {
            return n.eE;
        },
        function(n) {
            return n.af;
        },
        function(n) {
            return n.eW;
        },
        function(n) {
            return n.eU;
        },
        function(n) {
            return n.eV;
        }
    ]), QG = function(n) {
        return {
            mO: A2(KG, function(e) {
                return 3 === e(n).$;
            }, BG),
            bI: ft(BG)
        };
    }, ZG = c_("Chargement\u2026"), nX = function(n) {
        return A2(WN, A([
            YN("d-flex flex-column gap-3 justify-content-center align-items-center"),
            A2(qH, "min-height", "25vh")
        ]), A([
            A2(WN, A([
                YN("spinner-border text-primary"),
                A2(n_, "role", "status")
            ]), j),
            A2(WN, A([
                YN("text-muted")
            ]), A([
                function() {
                    if (n.$) return ZG;
                    var e = n.a.mO, r = n.a.bI;
                    return r > 0 ? A2(WN, A([
                        YN("d-flex flex-column gap-1")
                    ]), A([
                        c_("R\xe9cup\xe9ration des donn\xe9es\xa0: " + ut(e) + "/" + ut(r)),
                        A2(WN, A([
                            YN("progress w-100"),
                            A2(n_, "role", "progressbar"),
                            A2(n_, "aria-label", "Progression du chargement des donn\xe9es"),
                            A2(n_, "aria-valuenow", ut(e)),
                            A2(n_, "aria-valuemin", "0"),
                            A2(n_, "aria-valuemax", ut(r))
                        ]), A([
                            A2(WN, A([
                                YN("progress-bar"),
                                A2(qH, "width", Js(100 * e / r) + "%")
                            ]), j)
                        ]))
                    ])) : ZG;
                }()
            ]))
        ]));
    }, eX = function(n) {
        return A2(KN, A([
            YN("pb-5")
        ]), A([
            nX(n)
        ]));
    }, rX = le, tX = rX, uX = A2(KN, A([
        YN("pb-5")
    ]), A([
        A2(BN, A([
            YN("mb-3")
        ]), A([
            c_("Page non trouv\xe9e")
        ])),
        A2(D_, j, A([
            c_("La page que vous avez demand\xe9 n'existe pas.")
        ])),
        A2(VN, A([
            ZN(gd)
        ]), A([
            c_("Retour \xe0 l'accueil")
        ]))
    ])), aX = function(n) {
        return n.kY + "/api";
    }, iX = function(n) {
        return fe(ke(n));
    }, cX = function(n) {
        return A3(iX, "rapi-doc", A([
            A2(n_, "spec-url", aX(n)),
            A2(n_, "server-url", aX(n)),
            A2(n_, "default-api-server", aX(n)),
            A2(n_, "theme", "light"),
            A2(n_, "font-size", "largest"),
            A2(n_, "load-fonts", "false"),
            A2(n_, "layout", "column"),
            A2(n_, "show-info", "false"),
            A2(n_, "update-route", "false"),
            A2(n_, "render-style", "view"),
            A2(n_, "show-header", "false"),
            A2(n_, "show-components", "true"),
            A2(n_, "schema-description-expanded", "true"),
            A2(n_, "allow-authentication", "false"),
            A2(n_, "allow-server-selection", "false"),
            A2(n_, "allow-api-list-style-selection", "false"),
            A2(n_, "allow-authentication", "true"),
            A2(n_, "persist-auth", "true")
        ]), j);
    }, oX = function(n) {
        var e = F2(function(n, e) {
            return f_({
                hS: j,
                h4: Ur,
                h9: A([
                    A2(hH, A([
                        YN("fs-7")
                    ]), e)
                ]),
                ed: n,
                eG: Ur
            });
        });
        return Nl(n) ? A2(e, 2, A3(Yb, "{route}", _T(fd), "Vous \xeates connect\xe9, vous pouvez utiliser l'API avec un jeton d\xe9di\xe9.\n                Vous pouvez cr\xe9er et g\xe9rer ces jetons depuis votre [compte utilisateur]({route}).")) : A2(e, 1, A3(Yb, "{route}", _T(fd), "Les requ\xeates non authentifi\xe9es \xe0 l'API ne sont pas autoris\xe9es et n\xe9cessitent l\u2019utilisation d\u2019un jeton.\n               **Pour acc\xe9der \xe0 l\u2019API, il est n\xe9cessaire de fournir un jeton d'API**,\n               accessible dans votre [compte utilisateur]({route}) une fois connect\xe9. **Pour acc\xe9der au d\xe9tail\n               des impact, vous devez \xe9galement [accepter les conditions d\u2019utilisation ecoinvent]({route})**."));
    }, fX = A([
        {
            d: "7 septembre 2026",
            e: A([
                "G\xe9n\xe9rique"
            ]),
            ed: "major",
            f: "Ajout de l\u2019API du calculateur g\xe9n\xe9rique pour les p\xe9rim\xe8tres `food2`, `object` et `veli` en version b\xeata\xa0:\n\n- `POST /api/{food2|object|veli}/simulator` calcule les impacts \xe0 partir d\u2019une requ\xeate JSON identique \xe0 celle du simulateur web\n- des points d\u2019acc\xe8s `GET` listent les ressources n\xe9cessaires pour construire une requ\xeate (ingr\xe9dients/mat\xe9riaux, pays, cat\xe9gories, proc\xe9d\xe9s)\n"
        },
        {
            d: "23 f\xe9vrier 2026",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Ajout de l'impact des accessoires textiles dans les r\xe9ponses de l\u2019API."
        },
        {
            d: "17 f\xe9vrier 2026",
            e: A([
                "Textile",
                "Alimentaire",
                "Objets"
            ]),
            ed: "major",
            f: A3(Yb, "{route}", _T(fd), "- Les requ\xeates non authentifi\xe9es \xe0 l'API ne sont plus autoris\xe9es et n\xe9cessitent l\u2019utilisation d\u2019un jeton.\n               **Pour acc\xe9der \xe0 l\u2019API, il est maintenant n\xe9cessaire de fournir un jeton d'API**,\n               accessible dans votre [compte utilisateur]({route}) une fois connect\xe9.\n\n- **Pour acc\xe9der au d\xe9tail des impact, vous devez \xe9galement [accepter les conditions d\u2019utilisation ecoinvent]({route})**.\n")
        },
        {
            d: "11 d\xe9cembre 2025",
            e: A([
                "Textile",
                "Alimentaire",
                "Objets"
            ]),
            ed: "major",
            f: "Suppression de l\u2019indicateur PEF obsol\xe8te dans les r\xe9ponses de l\u2019API."
        },
        {
            d: "22 juillet 2025",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le param\xe9trage de la surface d'impression interdit d\xe9sormais les valeurs sup\xe9rieures \xe0 80%."
        },
        {
            d: "9 juillet 2025",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le param\xe8tre `traceability` est supprim\xe9."
        },
        {
            d: "15 avril 2025",
            e: A([
                "Alimentaire"
            ]),
            ed: "major",
            f: "Afin de permettre une meilleure gestion des donn\xe9es et d'\xe9viter des calculs redondants, **Les identifiants des proc\xe9d\xe9s alimentaires (transformation ou emballage) ont \xe9t\xe9 modifi\xe9s.** Les anciens identifiants ne sont plus valides et doivent \xeatre remplac\xe9s par les nouveaux. Les identifiants des ingr\xe9dients sont inchang\xe9s."
        },
        {
            d: "26 f\xe9vrier 2025",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Les points d'entr\xe9e utilisant les param\xe8tres pass\xe9s en query string pour effectuer des calculs\n      sont d\xe9pr\xe9ci\xe9s, leur \xe9quivalent `POST`/`JSON` leur \xe9tant d\xe9sormais pr\xe9f\xe9r\xe9s\xa0:\n- `GET /food` est d\xe9pr\xe9ci\xe9\n- `GET /textile/simulator` est d\xe9pr\xe9ci\xe9\n- `GET /textile/simulator/{impact}` est d\xe9pr\xe9ci\xe9\n- `GET /textile/simulator/detailed` est d\xe9pr\xe9ci\xe9\n\n                **Note: ces points d'entr\xe9e seront supprim\xe9s dans la prochaine version majeure de l'application.**\n\n                D'autre part et par souci de coh\xe9rence et de consistance, certains noms de champs utilisent\n                d\xe9sormais le `camelCase` dans les r\xe9ponses API\xa0:\n- `elec_kWh` devient `elecKWh`\n- `heat_MJ` devient `heatMJ`"
        },
        {
            d: "17 f\xe9vrier 2025",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le param\xe8tre `dyeingMedium`, qui permettait de s\xe9lectionner le support de teinture,\n                est remplac\xe9 par le nouveau param\xe8tre `dyeingProcessType` permettant de sp\xe9cifier\n                le type de teinture directement (continue, discontinue, moyenne)."
        },
        {
            d: "2 janvier 2025",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Un nouveau param\xe8tre `trims` est disponible dans l'API textile pour pr\xe9ciser les\n                accessoires pr\xe9sents sur le v\xeatement. Un nouveau point d'entr\xe9e `/textile/trims`\n                a \xe9galement \xe9t\xe9 ajout\xe9 pour lister les accessoires disponibles."
        },
        {
            d: "5 d\xe9cembre 2024",
            e: A([
                "Alimentaire"
            ]),
            ed: "major",
            f: "Les identifiants de proc\xe9d\xe9s alimentaires sont d\xe9sormais au format UUID. Le pr\xe9cedent champ\n                `code` pour lier les proc\xe9d\xe9s d'emballage et de transformation est remplac\xe9 par la cl\xe9 `id`\n                exploitant ce format."
        },
        {
            d: "13 novembre 2024",
            e: j,
            ed: "minor",
            f: "Ajout d'une [FAQ](/#/pages/api-faq) d\xe9di\xe9e \xe0 l'API."
        },
        {
            d: "29 octobre 2024",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Ajout du champ `impactsWithoutDurability` dans la r\xe9ponse des calculs d\xe9taill\xe9s. Ce champ a le m\xeame format que le champ `impacts` mais contient les scores avant application du coefficient de durabilit\xe9."
        },
        {
            d: "5 septembre 2024",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Ajout du champ `physicalDurability` qui permet de pr\xe9ciser la durabilit\xe9 physique d'un v\xeatement."
        },
        {
            d: "29 ao\xfbt 2024",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: 'Ajout du champ bool\xe9en `upcycled` qui permet de pr\xe9ciser si un v\xeatement est remanufactur\xe9.\n                En pareil cas, les \xe9tape Mati\xe8res, Filature, Tissage/Tricotage et Ennoblissement sont\n                d\xe9sactiv\xe9es et la complexit\xe9 en confection est automatiquement positionn\xe9e sur "\xc9lev\xe9e".\n             '
        },
        {
            d: "28 ao\xfbt 2024",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: 'Les champs `countryFabric`, `countryDyeing` at `countryMaking` sont d\xe9sormais optionnels et prennent pour valeur par d\xe9faut celles du *Pays inconnu* (voir la\n               [documentation m\xe9thodologique](https://fabrique-numerique.gitbook.io/ecobalyse/textile/cycle-de-vie-des-produits-textiles/transport#pays-par-defaut-etapes-de-transformation)).\n               Techniquement, stipuler le code `"---"` pour ces param\xe8tres ou les omettre revient d\xe9sormais au m\xeame.\n            '
        },
        {
            d: "18 juillet 2024",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le champ `marketingDuration` a \xe9t\xe9 supprim\xe9 et n'est d\xe9sormais plus op\xe9rant.\n            "
        },
        {
            d: "6 juin 2024",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Le champ `fabricProcess` n'est plus requis et prend d\xe9sormais la valeur par\n            d\xe9faut associ\xe9e \xe0 la cat\xe9gorie de produit.\n            "
        },
        {
            d: "10 avril 2024",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Les compl\xe9ments sont d\xe9sormais expos\xe9s de fa\xe7on \xe0 mieux mat\xe9rialiser leurs\n               effets\xa0; une d\xe9gradation est d\xe9sormais exprim\xe9e par un nombre positif\n               (qui additionn\xe9e au co\xfbt le fait augmenter), tandis qu'une am\xe9lioration\n               s'exprime par une valeur n\xe9gative (qui additionn\xe9e au co\xfbt le fait baisser).\n            "
        },
        {
            d: "9 avril 2024",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "En mode d\xe9taill\xe9, le co\xfbt environnemental d'une \xe9tape du cycle de vie textile\n               inclut d\xe9sormais l'impact des compl\xe9ments associ\xe9s."
        },
        {
            d: "25 mars 2024",
            e: A([
                "Alimentaire"
            ]),
            ed: "major",
            f: "La documentation de l'API alimentaire est temporairement mise hors-ligne."
        },
        {
            d: "21 f\xe9vrier 2024",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le param\xe8tre `ennoblingHeatSourceParam` est supprim\xe9. La source\n            de chaleur est donn\xe9e par la zone France, Europe ou World,\n            calcul\xe9e depuis le pays."
        },
        {
            d: "31 janvier 2024",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le param\xe8tre `durability` r\xe9cemment introduit est remplac\xe9 par 5 nouveaux\n            param\xe8tres permettant de calculer cet indice\xa0: `business`, `marketingDuration`,\n            `numberOfReferences`, `price`, `repairCost` et `traceability`."
        },
        {
            d: "16 janvier 2024",
            e: A([
                "Alimentaire"
            ]),
            ed: "major",
            f: "Les param\xe8tres permettant de sp\xe9cifier des compl\xe9ments (ou bonus)\n            personnalis\xe9s par ingr\xe9dient ont \xe9t\xe9 retir\xe9s, il sont remplac\xe9s par la\n            gestion automatis\xe9e des services \xe9cosyst\xe9miques."
        },
        {
            d: "15 janvier 2024",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Les param\xe8tres `quality` et `reparability` on \xe9t\xe9 supprim\xe9s. Il sont\n            remplac\xe9s par le champ `durability`."
        },
        {
            d: "21 d\xe9cembre 2023",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Le param\xe8tre `makingDeadStock` a \xe9t\xe9 rajout\xe9 pour repr\xe9senter\n            le taux de stocks dormants lors de la phase de confection. La valeur par d\xe9faut\n            est de 15% (0.15)."
        },
        {
            d: "20 d\xe9cembre 2023",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le param\xe8tre `disabledFading` a \xe9t\xe9 renomm\xe9 en `fading` et repr\xe9sente\n            l'oppos\xe9. S\xe9lectionner `true` pour **activer** le d\xe9lavage."
        },
        {
            d: "20 d\xe9cembre 2023",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le param\xe8tre optionnel `knittingProcess` a \xe9t\xe9 remplac\xe9 par le\n            param\xe8tre requis `fabricProcess`, qui prend en compte les diff\xe9rents\n            proc\xe9d\xe9s de tricotage ainsi que le proc\xe9d\xe9 de tissage."
        },
        {
            d: "19 d\xe9cembre 2023",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Le param\xe8tre `disabledFading` peut maintenant \xeatre configur\xe9 pour\n            tous les produits."
        },
        {
            d: "9 novembre 2023",
            e: A([
                "Alimentaire",
                "Textile"
            ]),
            ed: "minor",
            f: "La liste des mati\xe8res premi\xe8res textiles et des ingr\xe9dients\n            alimentaires peuvent maintenant \xeatre vides."
        },
        {
            d: "24 octobre 2023",
            e: A([
                "Alimentaire"
            ]),
            ed: "major",
            f: "Les identifiants de certains proc\xe9d\xe9s ont \xe9t\xe9 modifi\xe9s:\n\n- `durumwheat-semolina` devient `durum-wheat-semolina`;\n- `durumwheat` devient `durum-wheat`;\n- `Flank-steak` devient `flank-steak`;\n- `frenchbean` devient `french-bean`;\n- `huilecolza` devient `rapeseed-oil`;\n- `huilecolza-organic` devient `rapeseed-oil-organic`;\n- `soybeanBRdeforestation` devient `soybean-br-deforestation`;\n- `soybeanBRno-deforestation` devient `soybean-br-no-deforestation`;\n- `sunfloweroil` devient `sunflower-oil`;\n- `sunfloweroil-organic` devient `sunflower-oil-organic`;\n- `tapwater` devient `tap-water`;\n- `comte-AOP` devient `comte-aop`.\n"
        },
        {
            d: "12 octobre 2023",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Le param\xe9trage optionnel `country` du code de pays d'origine pour la\n            mati\xe8re a \xe9t\xe9 rajout\xe9."
        },
        {
            d: "4 septembre 2023",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le choix de valeurs pour le param\xe9trage `knittingProcess` a chang\xe9.\n            Il faut maintenant choisir entre\xa0:\n\n- `mix` : Tricotage moyen (mix de m\xe9tiers circulaire & rectiligne)\n- `fully-fashioned` : Tricotage fully-fashioned / seamless\n- `integral` : Tricotage int\xe9gral / whole garment\n- `circular` : Tricotage circulaire, inventaire d\xe9sagr\xe9g\xe9\n- `straight` : Tricotage rectiligne, inventaire d\xe9sagr\xe9g\xe9\n"
        },
        {
            d: "29 ao\xfbt 2023",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Le param\xe9trage optionnel `spinning` du proc\xe9d\xe9 de filature ou filage pour la\n            mati\xe8re a \xe9t\xe9 rajout\xe9.\n"
        },
        {
            d: "6 juillet 2023",
            e: A([
                "Alimentaire"
            ]),
            ed: "major",
            f: "Le param\xe9trage de la variante a \xe9t\xe9 supprim\xe9 du mode de requ\xeatage en query string;\n            l\xe0 o\xf9 on passait `?ingredients=carrot;100;organic;ES` pour 100g de carrot bio\n            d'espagne, on passe d\xe9sormais `?ingredients=carrot;100;ES`; le segment d\xe9finissant\n            la variante \u2014 `organic` \u2014 a \xe9t\xe9 l\xe9gitimement supprim\xe9.\n"
        },
        {
            d: "25 mai 2023",
            e: A([
                "Alimentaire"
            ]),
            ed: "major",
            f: "Le param\xe8tre `category`, qui permettait d'\xe9tablir des scores intra-cat\xe9goriques,\n            a \xe9t\xe9 supprim\xe9. De la m\xeame fa\xe7on, les notes lettr\xe9es et les scores sur 100 ont \xe9t\xe9\n            retir\xe9s des r\xe9sultats. Le scoring ne contient d\xe9sormais par cons\xe9quent que les\n            impacts par aires de protection.\n"
        },
        {
            d: "17 mai 2023",
            e: A([
                "Alimentaire"
            ]),
            ed: "minor",
            f: "Le calcul de l'\xe9coscore dans le r\xe9sultat de l'API alimentaire de constructeur\n            de recette prend maintenant correctement en compte les bonus des ingr\xe9dients.\n\n            Par ailleurs, le bonus total a \xe9t\xe9 rajout\xe9 sous l'entr\xe9e `recipe.totalBonusImpact`.\n"
        },
        {
            d: "16 mai 2023",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Les points d'acc\xe8s de simulation textile acceptent d\xe9sormais le verbe\n            `POST` assorti d'une requ\xeate au format JSON.\n"
        },
        {
            d: "3 mai 2023",
            e: A([
                "Alimentaire"
            ]),
            ed: "minor",
            f: "Un nouveau point d'acc\xe8s `POST /api/food/recipe` a \xe9t\xe9 cr\xe9\xe9,\n            acceptant les requ\xeates au format JSON.\n"
        },
        {
            d: "28 avril 2023",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Le param\xe8tre permettant de choisir la complexit\xe9 de la confection\n            `makingComplexity` a \xe9t\xe9 rajout\xe9.\n\n            D'autre part, le param\xe8tre de titrage `yarnSize` peut maintenant \xeatre exprim\xe9\n            avec une unit\xe9, permettant de sp\xe9cifier le titrage en d\xe9citex (Dtex).\n"
        },
        {
            d: "25 avril 2023",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: 'Le param\xe8tre de choix du proc\xe9d\xe9 de tricotage `knittingProcess`\n            permettant de choisir un proc\xe9d\xe9 autre que le "mix" par d\xe9faut a \xe9t\xe9\n            rajout\xe9.\n'
        },
        {
            d: "13 avril 2023",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le param\xe8tre de simulation `picking` permettant de d\xe9finir le\n            duitage a \xe9t\xe9 supprim\xa0; il est remplac\xe9 par un nouveau param\xe8tre\n            `yarnSize`, permettant de d\xe9finir le titrage du fil utilis\xe9 pour\n            l'\xe9tape de tissage, exprim\xe9 en *num\xe9ro m\xe9trique* (`Nm`).\n\n            Le num\xe9ro m\xe9trique indique un nombre de kilom\xe8tres de fil correspondant\n            \xe0 un poids d'un kilogramme (ex\xa0: 50Nm = 50km de ce fil p\xe8sent 1 kg).\n"
        },
        {
            d: "12 avril 2023",
            e: A([
                "Alimentaire"
            ]),
            ed: "minor",
            f: "Il est d\xe9sormais possible de param\xe9trer les bonus appliqu\xe9s \xe0\n            la diversit\xe9 agricole, aux infrastructures agro-\xe9cologiques et\n            aux conditions d'\xe9levage dans les param\xe8tres d'ingr\xe9dient.\n"
        },
        {
            d: "20 mars 2023",
            e: A([
                "Alimentaire"
            ]),
            ed: "minor",
            f: "Le mode de distribution a \xe9t\xe9 rendu facultatif\n"
        },
        {
            d: "8 mars 2023",
            e: A([
                "Alimentaire"
            ]),
            ed: "minor",
            f: "Une \xe9tape a \xe9t\xe9 ajout\xe9e au constructeur de recette pour tenir\n            compte de l'impact de la consommation. Un nouveau param\xe8tre\n            optionnel `preparation` a \xe9t\xe9 ajout\xe9 sur le point d'entr\xe9e\n            `/food/recipe`, qui accepte une liste de techniques de pr\xe9paration\n            (`freezing` pour cong\xe9lation, `frying` pour friture, etc.)\n"
        },
        {
            d: "21 f\xe9vrier 2023",
            e: A([
                "Alimentaire"
            ]),
            ed: "minor",
            f: "Une \xe9tape a \xe9t\xe9 ajout\xe9e au constructeur de recette pour tenir\n            compte de l'impact de la distribution. Elle se mat\xe9rialise par un\n            param\xe8tre optionnel `distribution` sur le point d'entr\xe9e\n            `/food/recipe` qui prend `ambient` comme valeur par d\xe9faut pour\n            indiquer qu'il s'agit d'une stockage sec \xe0 temp\xe9rature ambiante, ou\n            `fresh` pour un produit r\xe9frig\xe9r\xe9, ou `frozen` pour un produit\n            surgel\xe9.\n"
        },
        {
            d: "21 d\xe9cembre 2022",
            e: A([
                "Alimentaire",
                "Textile"
            ]),
            ed: "major",
            f: "La liste des pays est d\xe9sormais distinctement accessible en fonction du domaine\xa0:\n\n- pour le textile, au point d'entr\xe9e `textile/countries`\n- pour l'alimentaire, au point d'entr\xe9e `food/countries`\n\nDe la m\xeame fa\xe7on, l'ensemble des points d'entr\xe9e textile sont d\xe9sormais pr\xe9fix\xe9s par `textile`, en\ncoh\xe9rence avec ceux de l'alimentaire qui le sont par `food`.\n\nL'ancien point d'entr\xe9e `/countries` est donc redirig\xe9 vers `textile/countries`.\n"
        },
        {
            d: "30 novembre 2022",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Un nouveau param\xe8tre `ennoblingHeatSource` a \xe9t\xe9 ajout\xe9, permettant si besoin de pr\xe9ciser\n            la source de chaleur \xe0 l'\xe9tape d'ennoblissement\xa0; il peut prendre les valeurs\n            suivantes\xa0:\n\n- `coal`: Vapeur \xe0 partir de charbon\n- `naturalgas`: Vapeur \xe0 partir de gaz naturel\n- `lightfuel`: Vapeur \xe0 partir de fioul l\xe9ger\n- `heavyfuel`: Vapeur \xe0 partir de fioul lourd\n\nEn l'absence d'utilisation explicite du param\xe8tre, la source de chaleur utilis\xe9e sera celle du mix r\xe9gional.\n"
        },
        {
            d: "22 novembre 2022",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Un nouveau param\xe8tre `printing` a \xe9t\xe9 ajout\xe9, permettant si besoin de pr\xe9ciser\n            le proc\xe9d\xe9 d'impression utilis\xe9 sur le v\xeatement\xa0; les valeurs possibles\n            sont\xa0:\n\n- `pigment`\xa0: Impression pigmentaire\n- `substantive`\xa0: Impression Fix\xe9-Lav\xe9\n\nD'autre part, le param\xe8tre `surfaceMass` permettant de d\xe9finir le grammage de l'\xe9toffe est\nd\xe9sormais op\xe9rant quand le param\xe8tre `printing` est fourni\xa0; en effet, le proc\xe9d\xe9 d'impression\nest appliqu\xe9 en fonction de la surface du v\xeatement, calcul\xe9e au moyen de cette valeur et\nqui peut d\xe9sormais varier.\n\nEnfin, l'identification de l'\xe9tape d'ennoblissement a \xe9t\xe9 renomm\xe9e de `dyeing` \xe0 `ennobling`. Cela\nimpacte le param\xe8tre `disabledSteps` qui n'accepte d\xe9sormais plus `dyeing` mais bien `ennobling` en\nremplacement.\n"
        },
        {
            d: "14 novembre 2022",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Un nouveau param\xe8tre `dyeingMedium` a \xe9t\xe9 ajout\xe9 pour permettre de pr\xe9ciser le\n            support de teinture, parmi les trois valeurs possibles suivantes\xa0:\n\n- `article` lorsque la teinture est effectu\xe9e sur pi\xe8ce\xa0;\n- `fabric` lorsqu'elle est effectu\xe9e sur le tissu\xa0;\n- `yarn` lorsqu'elle est effectu\xe9e sur fil.\n"
        },
        {
            d: "9 novembre 2022",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le support du param\xe8tre `dyeingWeighting` a \xe9t\xe9 supprim\xe9. Son utilisation est\n            d\xe9sormais inop\xe9rante."
        },
        {
            d: "15 septembre 2022",
            e: A([
                "Alimentaire",
                "Textile"
            ]),
            ed: "major",
            f: "Les scores PEF renvoy\xe9s par l'API sont d\xe9sormais exprim\xe9s en `\xb5Pt` (micropoints)\n            au lieu de `mPt` (millipoints).\n\n            Pour m\xe9moire, `1 Pt = 1\u202F000 mPt = 1\u202F000\u202F000 \xb5Pt`."
        },
        {
            d: "5 juillet 2022",
            e: A([
                "Textile"
            ]),
            ed: "minor",
            f: "Un nouveau param\xe8tre optionnel `disabledSteps` a \xe9t\xe9 ajout\xe9 aux endpoints de\n            simulation, permettant de d\xe9finir la liste des \xe9tapes du cycle de vie \xe0 d\xe9sactiver,\n            s\xe9par\xe9e par des virgules. Chaque \xe9tape est identifi\xe9e par un code\xa0:\n- `material`: Mati\xe8re\n- `spinning`: Filature\n- `fabric`: Tissage/Tricotage\n- `ennobling`: Ennoblissement\n- `making`: Confection\n- `distribution`: Distribution\n- `use`: Utilisation\n- `eol`: Fin de vie\n\n            Par exemple, pour d\xe9sactiver les \xe9tapes de filature et d'ennoblissement, on peut passer\n            `disabledSteps=spinning,ennobling`."
        },
        {
            d: "2 juin 2022",
            e: A([
                "Textile"
            ]),
            ed: "major",
            f: "Le format de d\xe9finition de la liste des mati\xe8res a \xe9volu\xe9\xa0;\n            l\xe0 o\xf9 vous d\xe9finissiez une liste de mati\xe8res en y incluant le pourcentage de mati\xe8re\n            recycl\xe9e, par ex. `materials[]=coton;0.3;0.5&\u2026` pour *30% coton \xe0 50% recycl\xe9*,\n            vous devez d\xe9sormais \xe9crire `materials[]=coton;0.15&materials[]=coton-rdp;0.15&\u2026`\n            (soit *15% coton, 15% coton recycl\xe9*, ce qui revient au m\xeame)."
        }
    ]), sX = function(n) {
        return {
            $: 16,
            a: n
        };
    }, lX = F2(function(n, e) {
        var r = v(n, e);
        n: for(;;)switch(r.a.$){
            case 0:
                if (r.b.$) break n;
                return !0;
            case 3:
                switch(r.b.$){
                    case 3:
                    case 1:
                    case 2:
                        return !0;
                    default:
                        break n;
                }
            case 2:
            case 1:
                if (3 === r.b.$) return !0;
                break n;
            case 5:
                if (4 === r.b.$) return !0;
                break n;
            case 4:
                switch(r.b.$){
                    case 5:
                    case 4:
                    case 6:
                        return !0;
                    default:
                        break n;
                }
            case 6:
                if (4 === r.b.$) return !0;
                break n;
            case 7:
                switch(r.b.$){
                    case 7:
                    case 8:
                        return !0;
                    default:
                        break n;
                }
            default:
                if (7 === r.b.$) return !0;
                break n;
        }
        return !1;
    }), dX = {
        $: 8
    }, bX = {
        $: 13
    }, mX = function(n) {
        return {
            $: 18,
            a: n
        };
    }, pX = A([
        A2(hH, j, A3(Yb, "{url_privacy}", _T(dd("politique-de-confidentialite")), A3(Yb, "{url_ecoinvent}", _T(dd("cgu-ecoinvent")), "Pour acc\xe9der aux impacts d\xe9taill\xe9s, je m\u2019engage \xe0 respecter les [Conditions d\u2019utilisation des donn\xe9es \xab\u202Fecoinvent\u202F\xbb et \xab\u202FBase Empreinte\u202F\xbb pour l\u2019outil Ecobalyse]({url_ecoinvent})\n         et accepte que les informations recueillies sur ce formulaire soient enregistr\xe9es dans un fichier\n         informatis\xe9 par l\u2019ADEME pour\u202F:\n\n           - l\u2019authentification des utilisateurs sur la plateforme web ou via l\u2019API afin d\u2019acc\xe9der aux impacts d\xe9taill\xe9s (ex: changement climatique),\n\n           - la d\xe9livrance de licences nominatives par ecoinvent aux utilisateurs des donn\xe9es ecoinvent via Ecobalyse (les donn\xe9es sont transmises si l\u2019utilisateur consent au moins une fois via son compte Ecobalyse dans l\u2019ann\xe9e).\n\n         Pour plus d\u2019informations veuillez consulter la [politique de confidentialit\xe9]({url_privacy}).")))
    ]), vX = JN("htmlFor"), gX = fe("label"), hX = F2(function(n, e) {
        return !A2(ra, n, e).$;
    }), $X = A2(sl, A([
        "target",
        "checked"
    ]), Pu), xX = function(n) {
        return A2(a_, "change", A2(Qt, n, $X));
    }, kX = JN("placeholder"), jX = y_("required"), yX = fe("small"), wX = F2(function(n, e) {
        var r = A2(ra, n, e);
        if (r.$) return c_("");
        var t = r.a;
        return A2(WN, A([
            YN("invalid-feedback")
        ]), A([
            c_(t)
        ]));
    }), AX = function(n) {
        switch(n.$){
            case 0:
                return "Association\xa0: " + n.a;
            case 1:
                return "Entreprise\xa0: " + n.a + "(" + n.b + ")";
            case 2:
                return "\xc9tablissement\xa0: " + n.a;
            case 3:
                return "Particulier";
            case 4:
                return "Collectivit\xe9\xa0: " + n.a;
            case 5:
                return "M\xe9dia\xa0: " + n.a;
            case 6:
                return "\xc9tablissement public\xa0: " + n.a;
            default:
                return "\xc9tudiant\xb7e\xa0: " + n.a;
        }
    }, TX = F3(function(n, e, r) {
        var t = n.f1;
        return A2(WN, j, A([
            A2(HG, A([
                VG(bX),
                YN("mt-3 view-account-form")
            ]), A([
                A2(WN, A([
                    YN("row")
                ]), A([
                    A2(WN, A([
                        YN("col-md-6 mb-3")
                    ]), A([
                        A2(gX, A([
                            vX("email"),
                            YN("form-label")
                        ]), A([
                            c_("Adresse email")
                        ])),
                        A2(N_, A([
                            o_("text"),
                            YN("form-control"),
                            yH("email"),
                            kX("nom@example.com"),
                            hG(t.c4),
                            E_(!0)
                        ]), j),
                        A2(yX, A([
                            YN("d-flex align-items-center gap-1 text-muted")
                        ]), A([
                            b_,
                            c_("Vous ne pouvez pas encore modifier votre email")
                        ]))
                    ])),
                    A2(WN, A([
                        YN("col-md-6  mb-3")
                    ]), A([
                        A2(WN, A([
                            YN("form-label")
                        ]), A([
                            c_("Organisation")
                        ])),
                        A2(N_, A([
                            o_("text"),
                            YN("form-control"),
                            yH("organization"),
                            kX("ACME Inc."),
                            hG(AX(t.nT.cq)),
                            E_(!0)
                        ]), j),
                        A2(yX, A([
                            YN("d-flex align-items-center gap-1 text-muted")
                        ]), A([
                            b_,
                            c_("Vous ne pouvez pas modifier votre organisation")
                        ]))
                    ]))
                ])),
                A2(WN, A([
                    YN("row")
                ]), A([
                    A2(WN, A([
                        YN("col-md-6 mb-3")
                    ]), A([
                        A2(gX, A([
                            vX("firstName"),
                            YN("form-label")
                        ]), A([
                            c_("Pr\xe9nom")
                        ])),
                        A2(N_, A([
                            o_("text"),
                            YN("form-control"),
                            r_(A([
                                v("is-invalid", A2(hX, "firstName", r))
                            ])),
                            yH("firstName"),
                            kX("Jos\xe9phine"),
                            hG(e.aD),
                            mG(function(n) {
                                return mX($(e, {
                                    aD: n
                                }));
                            }),
                            jX(!0)
                        ]), j),
                        A2(wX, "firstName", r)
                    ])),
                    A2(WN, A([
                        YN("col-md-6 mb-3")
                    ]), A([
                        A2(gX, A([
                            vX("lastName"),
                            YN("form-label")
                        ]), A([
                            c_("Nom")
                        ])),
                        A2(N_, A([
                            o_("text"),
                            YN("form-control"),
                            r_(A([
                                v("is-invalid", A2(hX, "lastName", r))
                            ])),
                            yH("lastName"),
                            kX("Durand"),
                            hG(e.aE),
                            mG(function(n) {
                                return mX($(e, {
                                    aE: n
                                }));
                            }),
                            jX(!0)
                        ]), j),
                        A2(wX, "lastName", r)
                    ]))
                ])),
                A2(WN, A([
                    YN("mb-3 form-check")
                ]), A([
                    A2(N_, A([
                        o_("checkbox"),
                        YN("form-check-input"),
                        r_(A([
                            v("is-invalid", A2(hX, "emailOptin", r))
                        ])),
                        yH("emailOptin"),
                        w_(e.aY),
                        xX(function(n) {
                            return mX($(e, {
                                aY: n
                            }));
                        })
                    ]), j),
                    A2(gX, A([
                        YN("form-check-label"),
                        vX("emailOptin")
                    ]), A([
                        c_("J\u2019accepte de recevoir des informations de la part d\u2019Ecobalyse par email.")
                    ])),
                    A2(wX, "emailOptin", r)
                ])),
                A2(WN, A([
                    YN("mb-3 form-check")
                ]), A([
                    A2(N_, A([
                        o_("checkbox"),
                        YN("form-check-input"),
                        r_(A([
                            v("is-invalid", A2(hX, "termsAccepted", r))
                        ])),
                        yH("termsAccepted"),
                        w_(e.bZ),
                        xX(function(n) {
                            return mX($(e, {
                                bZ: n
                            }));
                        })
                    ]), j),
                    A2(gX, A([
                        YN("form-check-label"),
                        vX("termsAccepted")
                    ]), pX),
                    A2(wX, "termsAccepted", r)
                ])),
                A2(WN, A([
                    YN("d-grid")
                ]), A([
                    A2(e_, A([
                        o_("submit"),
                        YN("btn btn-primary"),
                        E_(s(e, Np) || !UI(r)),
                        A2(n_, "data-testid", "auth-signup-submit")
                    ]), A([
                        c_("Mettre \xe0 jour mes informations")
                    ]))
                ]))
            ])),
            A2(P_, A([
                YN("mt-3 mb-0")
            ]), j),
            A2(WN, A([
                YN("d-flex justify-content-center align-items-center gap-3")
            ]), A([
                A2(VN, A([
                    ZN(gd)
                ]), A([
                    c_("Retour \xe0 l\u2019accueil")
                ])),
                A2(e_, A([
                    o_("button"),
                    YN("btn btn-primary my-3"),
                    i_(dX)
                ]), A([
                    c_("D\xe9connexion")
                ]))
            ]))
        ]));
    }), EX = function(n) {
        return {
            $: 1,
            a: n
        };
    }, CX = d_("clipboard"), IX = y_("readOnly"), SX = function(n) {
        return {
            $: 4,
            a: n
        };
    }, OX = A3(vo, 1, "dd/MM/yyyy \xe0 HH:mm:ss (UTC)", ho), LX = d_("warning"), PX = function(n) {
        return {
            $: 2,
            a: n
        };
    }, qX = {
        $: 2
    }, NX = d_("trash"), _X = A([
        0,
        1,
        2,
        3
    ]), zX = d_("check"), UX = function(n) {
        var e = A2(at, ", ", A2(wu, A2(Hu, ds, qx), _X));
        return A2(Nc, !1, A2(Pc, function(n) {
            var e = n.f1;
            return e.iY || e.mx;
        }, _l(n))) ? A2(D_, A([
            YN("alert alert-success d-flex align-items-center gap-1")
        ]), A([
            zX,
            A2(m_, j, A([
                c_("Votre compte dispose d\u2019un acc\xe8s b\xeata \xe0 "),
                A2(VN, A([
                    ZN(od)
                ]), A([
                    c_("l\u2019API g\xe9n\xe9rique")
                ])),
                c_(" (" + e + ").")
            ]))
        ])) : c_("");
    }, MX = F2(function(n, e) {
        switch(e.$){
            case 2:
                var r = e.a;
                return A2(D_, A([
                    YN("alert alert-danger")
                ]), A([
                    c_("Erreur lors de la r\xe9cup\xe9ration des jetons d\u2019API : " + BP(r))
                ]));
            case 1:
                return nX(Ur);
            case 0:
                return c_("");
            default:
                var t = e.a;
                return A2(WN, j, A([
                    UX(n),
                    sf(t) ? A2(D_, j, A([
                        c_("Aucun jeton d\u2019API actif.")
                    ])) : A2(WN, A([
                        YN("table-responsive border shadow-sm"),
                        A2(n_, "data-testid", "auth-api-tokens-table")
                    ]), A([
                        A2(G_, A([
                            YN("table table-striped mb-0")
                        ]), A([
                            A2(Y_, j, A([
                                A2(K_, j, A([
                                    A2(J_, j, A([
                                        c_("ID")
                                    ])),
                                    A2(J_, A([
                                        YN("text-end")
                                    ]), A([
                                        c_("Date de derni\xe8re utilisation")
                                    ])),
                                    A2(J_, A([
                                        YN("text-end")
                                    ]), j)
                                ]))
                            ])),
                            A2(X_, j, A2(wu, function(n) {
                                return A2(K_, j, A([
                                    A2(V_, A([
                                        YN("align-middle")
                                    ]), A([
                                        c_(n.mj)
                                    ])),
                                    A2(V_, A([
                                        YN("align-middle text-end")
                                    ]), A([
                                        c_(A2(Nc, "Jamais utilis\xe9", A2(Pc, OX, n.mI)))
                                    ])),
                                    A2(V_, A([
                                        YN("align-middle text-end")
                                    ]), A([
                                        A2(e_, A([
                                            YN("btn btn-sm btn-danger"),
                                            W_("Supprimer ce jeton"),
                                            i_(sX(PX(n)))
                                        ]), A([
                                            NX
                                        ]))
                                    ]))
                                ]));
                            }, t))
                        ]))
                    ])),
                    A2(WN, A([
                        YN("d-grid mt-3")
                    ]), A([
                        A2(e_, A([
                            YN("btn btn-primary"),
                            i_(qX)
                        ]), A([
                            c_("Cr\xe9er un jeton d\u2019API")
                        ]))
                    ]))
                ]));
        }
    }), DX = {
        $: 11
    }, RX = function(n) {
        return {
            $: 17,
            a: n
        };
    }, FX = f_({
        hS: j,
        h4: Ur,
        h9: A([
            A2(hH, j, "Notre politique de confidentialit\xe9 de donn\xe9es personnelles a chang\xe9 depuis le **9 d\xe9cembre 2025**.\n            Pour continuer \xe0 acc\xe9der aux impacts d\xe9taill\xe9s, connectez-vous et consentez au traitement particulier de vos\n            donn\xe9es personnelles li\xe9es \xe0 l\u2019usage des impacts d\xe9taill\xe9s.")
        ]),
        ed: 1,
        eG: Ur
    }), HX = F2(function(n, e) {
        return A2(WN, A([
            YN("d-flex flex-column gap-3")
        ]), A([
            FX,
            A2(HG, A([
                VG(DX),
                A2(n_, "data-testid", "auth-magic-link-form")
            ]), A([
                A2(D_, j, A([
                    c_(" Recevez un lien de connexion en soumettant votre adresse email ci-dessous.\n                       ")
                ])),
                A2(WN, A([
                    YN("mb-3")
                ]), A([
                    A2(gX, A([
                        vX("email"),
                        YN("form-label")
                    ]), A([
                        c_("Adresse email")
                    ])),
                    A2(N_, A([
                        o_("email"),
                        YN("form-control"),
                        yH("email"),
                        kX("nom@example.com"),
                        hG(n),
                        mG(RX),
                        jX(!0)
                    ]), j)
                ])),
                A2(WN, A([
                    YN("d-grid")
                ]), A([
                    A2(e_, A([
                        o_("submit"),
                        YN("btn btn-primary"),
                        E_("" === n || !UI(ES(n)) || s(e, Fa)),
                        A2(n_, "data-testid", "auth-magic-link-submit")
                    ]), A([
                        c_(1 === e.$ ? "Email de connexion en cours d\u2019envoi\u2026" : "Recevoir un email de connexion")
                    ]))
                ]))
            ]))
        ]));
    }), GX = {
        $: 9
    }, XX = {
        $: 15
    }, VX = function(n) {
        return {
            $: 19,
            a: n
        };
    }, JX = A([
        A2(hH, j, A3(Yb, "{url_privacy}", _T(dd("politique-de-confidentialite")), A3(Yb, "{url_cgu}", rG, " Je m\u2019engage \xe0 respecter les [CGU d\u2019Ecobalyse]({url_cgu}) et accepte que l\u2019ADEME collecte et traite mes donn\xe9es \xe0 caract\xe8re personnel pour cr\xe9er un compte et me connecter \xe0 Ecobalyse, mesurer la fr\xe9quentation sur le site, suivre les erreurs informatiques et techniques. Pour plus d\u2019informations veuillez consulter la [politique de confidentialit\xe9]({url_privacy}).")))
    ]), YX = A([
        v("association", "Association"),
        v("business", "Entreprise"),
        v("education", "Enseignement/Recherche"),
        v("individual", "Particulier"),
        v("localAuthority", "Collectivit\xe9 ou EPCI"),
        v("media", "M\xe9dia"),
        v("public", "Autre \xe9tablissement public et \xc9tat"),
        v("student", "\xc9tudiant\xb7e")
    ]), WX = F2(function(n, e) {
        switch(e.$){
            case 0:
                return eg(n);
            case 1:
                return A2(rg, n, e.b);
            case 2:
                return tg(n);
            case 3:
                return ug;
            case 4:
                return ag(n);
            case 5:
                return ig(n);
            case 6:
                return cg(n);
            default:
                return og(n);
        }
    }), KX = F2(function(n, e) {
        return 1 === e.$ ? A2(rg, e.a, TS(n)) : e;
    }), BX = F2(function(n, e) {
        var r = A2(Nc, "", AS(e));
        switch(n){
            case "association":
                return eg(r);
            case "business":
                return A2(rg, r, TS(""));
            case "education":
                return tg(r);
            case "individual":
                return ug;
            case "localAuthority":
                return ag(r);
            case "media":
                return ig(r);
            case "public":
                return cg(r);
            case "student":
                return og(r);
            default:
                return e;
        }
    }), QX = F2(function(n, e) {
        return A2(WN, A([
            YN("row")
        ]), A([
            A2(WN, A([
                YN("col-md-6")
            ]), A([
                A2(WN, A([
                    YN("mb-3")
                ]), A([
                    A2(gX, A([
                        vX("organizationType"),
                        YN("form-label")
                    ]), A([
                        c_("Type d\u2019organisation")
                    ])),
                    A2(vG, A([
                        YN("form-select"),
                        yH("organizationType"),
                        mG(function(e) {
                            return VX($(n, {
                                cq: A2(BX, e, n.cq)
                            }));
                        })
                    ]), A2(wu, function(e) {
                        var r = e.a, t = e.b;
                        return A2(pG, A([
                            hG(r),
                            gG(s(r, yo(n.cq)))
                        ]), A([
                            c_(t)
                        ]));
                    }, A2(LA, Gh, YX))),
                    A2(wX, "organization.type", e)
                ]))
            ])),
            s(n.cq, ug) ? c_("") : A2(WN, A([
                YN("col-md-6")
            ]), A([
                A2(WN, A([
                    YN("mb-3")
                ]), A([
                    A2(gX, A([
                        vX("organization"),
                        YN("form-label")
                    ]), A([
                        c_("Nom de l\u2019organisation")
                    ])),
                    A2(N_, A([
                        o_("text"),
                        YN("form-control"),
                        r_(A([
                            v("is-invalid", A2(hX, "organization.name", e))
                        ])),
                        yH("organization"),
                        kX("ACME Inc."),
                        hG(A2(Nc, "", AS(n.cq))),
                        mG(function(e) {
                            return VX($(n, {
                                cq: A2(WX, e, n.cq)
                            }));
                        }),
                        jX(!0)
                    ]), j),
                    A2(wX, "organization.name", e)
                ]))
            ])),
            function() {
                var r = n.cq;
                if (1 === r.$) {
                    var t = r.b;
                    return A2(WN, A([
                        YN("d-grid mb-3")
                    ]), A([
                        A2(gX, A([
                            vX("siren"),
                            YN("form-label")
                        ]), A([
                            c_("Num\xe9ro SIREN")
                        ])),
                        A2(N_, A([
                            o_("text"),
                            YN("form-control"),
                            r_(A([
                                v("is-invalid", A2(hX, "organization.siren", e))
                            ])),
                            yH("siren"),
                            kX("123456789"),
                            hG(t),
                            mG(function(e) {
                                return VX($(n, {
                                    cq: A2(KX, e, n.cq)
                                }));
                            }),
                            jX(!0)
                        ]), j),
                        A2(wX, "organization.siren", e),
                        A2(D_, A([
                            YN("fs-8 text-muted mt-1 mb-0")
                        ]), A([
                            c_("Vous pouvez rechercher le num\xe9ro SIREN \xe0 9 chiffres d\u2019une entreprise sur le "),
                            A2(VN, A([
                                QN("https://annuaire-entreprises.data.gouv.fr/"),
                                _H("_blank")
                            ]), A([
                                c_("service d\u2019annuaire des entreprises data.gouv.fr")
                            ]))
                        ]))
                    ]));
                }
                return c_("");
            }()
        ]));
    }), ZX = F3(function(n, e, r) {
        return A2(HG, A([
            VG(XX),
            A2(n_, "data-testid", "auth-signup-form"),
            YN("signup-form")
        ]), A([
            A2(D_, A([
                YN("fs-8")
            ]), A([
                c_("Sauf mention contraire, tous les champs sont obligatoires.")
            ])),
            A2(WN, A([
                YN("mb-3")
            ]), A([
                A2(gX, A([
                    vX("email"),
                    YN("form-label")
                ]), A([
                    c_("Adresse email")
                ])),
                A2(N_, A([
                    o_("email"),
                    YN("form-control"),
                    r_(A([
                        v("is-invalid", A2(hX, "email", e))
                    ])),
                    yH("email"),
                    kX("nom@example.com"),
                    hG(n.c4),
                    mG(function(e) {
                        return VX($(n, {
                            c4: e
                        }));
                    }),
                    jX(!0)
                ]), j),
                A2(wX, "email", e)
            ])),
            A2(WN, A([
                YN("row")
            ]), A([
                A2(WN, A([
                    YN("col-md-6")
                ]), A([
                    A2(WN, A([
                        YN("mb-3")
                    ]), A([
                        A2(gX, A([
                            vX("firstName"),
                            YN("form-label")
                        ]), A([
                            c_("Pr\xe9nom")
                        ])),
                        A2(N_, A([
                            o_("text"),
                            YN("form-control"),
                            r_(A([
                                v("is-invalid", A2(hX, "firstName", e))
                            ])),
                            yH("firstName"),
                            kX("Jos\xe9phine"),
                            hG(n.aD),
                            mG(function(e) {
                                return VX($(n, {
                                    aD: e
                                }));
                            }),
                            jX(!0)
                        ]), j),
                        A2(wX, "firstName", e)
                    ]))
                ])),
                A2(WN, A([
                    YN("col-md-6")
                ]), A([
                    A2(WN, A([
                        YN("mb-3")
                    ]), A([
                        A2(gX, A([
                            vX("lastName"),
                            YN("form-label")
                        ]), A([
                            c_("Nom")
                        ])),
                        A2(N_, A([
                            o_("text"),
                            YN("form-control"),
                            r_(A([
                                v("is-invalid", A2(hX, "lastName", e))
                            ])),
                            yH("lastName"),
                            kX("Durand"),
                            hG(n.aE),
                            mG(function(e) {
                                return VX($(n, {
                                    aE: e
                                }));
                            }),
                            jX(!0)
                        ]), j),
                        A2(wX, "lastName", e)
                    ]))
                ]))
            ])),
            A2(QX, n, e),
            A2(WN, A([
                YN("mb-3 form-check")
            ]), A([
                A2(N_, A([
                    o_("checkbox"),
                    YN("form-check-input"),
                    r_(A([
                        v("is-invalid", A2(hX, "termsAccepted", e))
                    ])),
                    yH("termsAccepted"),
                    w_(n.oW),
                    xX(function(e) {
                        return VX($(n, {
                            oW: e
                        }));
                    })
                ]), j),
                A2(gX, A([
                    YN("form-check-label"),
                    vX("termsAccepted")
                ]), JX),
                A2(wX, "termsAccepted", e)
            ])),
            A2(WN, A([
                YN("mb-3 form-check")
            ]), A([
                A2(N_, A([
                    o_("checkbox"),
                    YN("form-check-input"),
                    r_(A([
                        v("is-invalid", A2(hX, "emailOptin", e))
                    ])),
                    yH("emailOptin"),
                    w_(n.aY),
                    xX(function(e) {
                        return VX($(n, {
                            aY: e
                        }));
                    })
                ]), j),
                A2(gX, A([
                    YN("form-check-label"),
                    vX("emailOptin")
                ]), A([
                    c_("J\u2019accepte de recevoir des informations de la part d\u2019Ecobalyse par email.")
                ])),
                A2(wX, "emailOptin", e)
            ])),
            A2(WN, A([
                YN("mb-3 form-check")
            ]), A([
                A2(N_, A([
                    o_("checkbox"),
                    YN("form-check-input"),
                    r_(A([
                        v("is-invalid", A2(hX, "ecoinventTermsAccepted", e))
                    ])),
                    yH("ecoinventTermsAccepted"),
                    w_(n.bZ),
                    xX(function(e) {
                        return VX($(n, {
                            bZ: e
                        }));
                    })
                ]), j),
                A2(gX, A([
                    YN("form-check-label"),
                    vX("ecoinventTermsAccepted")
                ]), pX),
                A2(wX, "ecoinventTermsAccepted", e)
            ])),
            A2(WN, A([
                YN("d-grid")
            ]), A([
                A2(e_, A([
                    o_("submit"),
                    YN("btn btn-primary"),
                    E_(s(n, DT) || !UI(e) || s(r, Fa)),
                    A2(n_, "data-testid", "auth-signup-submit")
                ]), A([
                    c_(1 === r.$ ? "Envoi de la demande d\u2019inscription en cours\u2026" : "Valider mon inscription")
                ]))
            ]))
        ]));
    }), nV = F2(function(n, e) {
        var r, t = (r = _l(n)).$ ? v("Connexion / Inscription", A([
            v("Inscription", A3(MT, DT, Qu, Du)),
            v("Connexion", A2(Op, "", Du))
        ])) : v("Mon compte", A([
            v("Compte", A3(qp, r.a, Np, Qu)),
            v("Jetons d\u2019API", EI(Fa))
        ])), u = t.a, a = t.b;
        return A2(WN, j, A([
            A2(BN, A([
                YN("mb-4")
            ]), A([
                c_(u)
            ])),
            A2(WN, A([
                YN("card shadow-sm px-0")
            ]), A([
                A2(WN, A([
                    YN("card-header px-0 pb-0 border-bottom-0")
                ]), A([
                    A2(B_, A([
                        YN("Tabs nav nav-tabs nav-fill justify-content-end gap-2 px-2")
                    ]), A2(wu, function(n) {
                        var r = n.a, t = n.b;
                        return A2(__, A([
                            YN("TabsTab nav-item"),
                            r_(A([
                                v("active", A2(lX, e, t))
                            ]))
                        ]), A([
                            A2(e_, A([
                                o_("button"),
                                YN("nav-link no-outline border-top-0"),
                                r_(A([
                                    v("active", A2(lX, e, t))
                                ])),
                                i_(sX(t))
                            ]), A([
                                c_(r)
                            ]))
                        ]));
                    }, a))
                ])),
                A2(WN, A([
                    YN("card-body")
                ]), A([
                    function() {
                        switch(e.$){
                            case 0:
                                return A3(TX, e.a, e.b, e.c);
                            case 1:
                                return u = e.a, A2(WN, j, A([
                                    A2(I_, A([
                                        YN("h5 mb-3")
                                    ]), A([
                                        c_("\u2705\xa0Un nouveau jeton d\u2019API a \xe9t\xe9 cr\xe9\xe9")
                                    ])),
                                    A2(D_, j, A([
                                        c_("Il vous permet d\u2019effectuer des requ\xeates sur "),
                                        A2(VN, A([
                                            ZN(od),
                                            _H("_blank")
                                        ]), A([
                                            c_("l\u2019API Ecobalyse")
                                        ])),
                                        c_(".")
                                    ])),
                                    A2(hH, A([
                                        YN("alert alert-warning d-flex align-items-center gap-1 mb-3")
                                    ]), "Attention, **ce jeton d\u2019API ne vous sera affich\xe9 qu\u2019une seule et unique fois ci-dessous**.\n             Conservez-le pr\xe9cieusement."),
                                    A2(WN, A([
                                        YN("input-group")
                                    ]), A([
                                        A2(N_, A([
                                            o_("text"),
                                            YN("form-control"),
                                            A2(n_, "data-testid", "auth-api-token"),
                                            IX(!0),
                                            hG(u)
                                        ]), j),
                                        A2(e_, A([
                                            YN("input-group-text"),
                                            W_("Copier dans le presse-papiers"),
                                            i_(EX(u))
                                        ]), A([
                                            CX
                                        ]))
                                    ])),
                                    A2(D_, A([
                                        YN("fs-8 text-muted mt-1 mb-0")
                                    ]), A([
                                        c_("Vous pouvez copier le jeton d\u2019API ci-dessus en cliquant sur le bouton copier \xe0 droite du champ.")
                                    ])),
                                    A2(WN, A([
                                        YN("d-grid mt-2")
                                    ]), A([
                                        A2(e_, A([
                                            YN("btn btn-link"),
                                            i_(sX(EI(Fa)))
                                        ]), A([
                                            c_("\xab\xa0Retour \xe0 la liste des jetons d\u2019API")
                                        ]))
                                    ]))
                                ]));
                            case 2:
                                return t = e.a, A2(WN, j, A([
                                    A2(I_, A([
                                        YN("h5 mb-3")
                                    ]), A([
                                        c_("Supprimer et invalider ce jeton d\u2019API")
                                    ])),
                                    A2(D_, j, A([
                                        A2(hH, j, "\xcates-vous s\xfbr de vouloir supprimer et invalider ce jeton d\u2019API\xa0?\n                 Vous ne pourrez plus l\u2019utiliser.")
                                    ])),
                                    function() {
                                        var n = t.mI;
                                        if (n.$) return A2(D_, A([
                                            YN("alert alert-success d-flex align-items-center gap-1")
                                        ]), A([
                                            b_,
                                            c_("Le token n\u2019a jamais \xe9t\xe9 utilis\xe9")
                                        ]));
                                        var e = n.a;
                                        return A2(D_, A([
                                            YN("alert alert-warning d-flex align-items-center gap-1")
                                        ]), A([
                                            LX,
                                            c_("Derni\xe8re utilisation\xa0:\xa0"),
                                            c_(OX(e))
                                        ]));
                                    }(),
                                    A2(WN, A([
                                        YN("d-flex justify-content-center gap-2 mt-1")
                                    ]), A([
                                        A2(e_, A([
                                            YN("btn btn-link"),
                                            i_(sX(EI(Fa)))
                                        ]), A([
                                            c_("Annuler")
                                        ])),
                                        A2(e_, A([
                                            YN("btn btn-danger"),
                                            i_(SX(t))
                                        ]), A([
                                            c_("Supprimer et invalider ce jeton d\u2019API")
                                        ]))
                                    ]))
                                ]));
                            case 3:
                                return A2(MX, n, e.a);
                            case 4:
                                return A2(HX, e.a, e.b);
                            case 5:
                                return r = e.a, A2(HG, A([
                                    YN("d-flex flex-column justify-content-center p-3"),
                                    VG(GX)
                                ]), A([
                                    A2(D_, A([
                                        YN("d-flex align-items-baseline gap-1")
                                    ]), A([
                                        b_,
                                        c_("Vous allez \xeatre connect\xe9 avec l\u2019adresse email suivante\xa0: "),
                                        A2(H_, j, A([
                                            c_(A2(Nc, r, ad(r)))
                                        ]))
                                    ])),
                                    A2(e_, A([
                                        o_("submit"),
                                        A2(n_, "data-testid", "auth-login-confirm"),
                                        YN("btn btn-primary")
                                    ]), A([
                                        c_("Confirmer la connexion")
                                    ]))
                                ]));
                            case 6:
                            default:
                                return function(n) {
                                    return f_({
                                        hS: j,
                                        h4: Ur,
                                        h9: A([
                                            A2(hH, j, A3(Yb, "{email}", n, "Si vous poss\xe9dez un compte, un email contenant un lien de connexion au service a \xe9t\xe9 envoy\xe9 \xe0 l\u2019adresse **`{email}`**."))
                                        ]),
                                        ed: 1,
                                        eG: zr("Email de connexion envoy\xe9")
                                    });
                                }(e.a);
                            case 7:
                                return A3(ZX, e.a, e.b, e.c);
                        }
                        var r, t, u;
                    }()
                ]))
            ]))
        ]));
    }), eV = F2(function(n, e) {
        return v("Authentification", A([
            A2(KN, A([
                YN("pb-5")
            ]), A([
                A2(WN, A([
                    YN("row")
                ]), A([
                    A2(WN, A([
                        YN("col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 d-flex flex-column gap-3")
                    ]), A([
                        A2(nV, n, e.u)
                    ]))
                ]))
            ]))
        ]));
    }), rV = A2(Hu, qT, function(n) {
        return n.ai;
    }), tV = F2(function(n, e) {
        var r = v(n, e);
        n: for(;;)switch(r.a.$){
            case 1:
                if (1 === r.b.$) return !0;
                break n;
            case 2:
                if (2 === r.b.$) return !0;
                break n;
            case 3:
                if (3 === r.b.$) return !0;
                break n;
            case 6:
                if (6 === r.b.$) return s(r.a.a, r.b.a);
                break n;
            case 7:
                if (7 === r.b.$) return s(r.a.a, r.b.a);
                break n;
            case 5:
                if (5 === r.b.$) return !0;
                break n;
            case 8:
                if (8 === r.b.$) return !0;
                break n;
            case 0:
                if (r.b.$) break n;
                return s(r.a.a, r.b.a);
            case 4:
                if (4 === r.b.$) return s(r.a.a, r.b.a);
                break n;
            case 9:
                if (9 === r.b.$) return !0;
                break n;
            default:
                if (10 === r.b.$) return !0;
                break n;
        }
        return !1;
    }), uV = function(n) {
        var e = n.at, r = n.aA;
        return A2(sG, A([
            YN("Tabs nav nav-tabs d-flex justify-content-end align-items-center gap-0 gap-sm-2")
        ]), A2(wu, function(n) {
            return A2(VN, A([
                YN("TabsTab nav-link"),
                r_(A([
                    v("active", A2(tV, n, r))
                ])),
                ZN(A2(bd, e, n))
            ]), A([
                c_(rV(n))
            ]));
        }, function(n) {
            switch(n.$){
                case 0:
                    return A([
                        kd(Ur),
                        Om(Ur),
                        Sm(Ur),
                        Im(Ur),
                        A2(Lm, ls, Ur)
                    ]);
                case 1:
                    switch(n.a){
                        case 0:
                            return A([
                                A2(jd, 0, Ur),
                                A2(Cm, ds(0), Ur),
                                Im(Ur),
                                A2(Lm, ds(0), Ur),
                                Om(Ur),
                                A2(Pm, 0, Ur)
                            ]);
                        case 1:
                            return A([
                                A2(jd, 1, Ur),
                                Om(Ur),
                                Im(Ur),
                                A2(Lm, ds(1), Ur),
                                A2(Pm, 1, Ur)
                            ]);
                        case 2:
                            return A([
                                A2(jd, 2, Ur),
                                A2(Cm, ds(2), Ur),
                                Im(Ur),
                                A2(Lm, ds(2), Ur),
                                Om(Ur),
                                A2(Pm, 2, Ur)
                            ]);
                        default:
                            return A([
                                A2(jd, 3, Ur),
                                A2(Cm, ds(3), Ur),
                                Im(Ur),
                                Om(Ur),
                                A2(Lm, ds(3), Ur),
                                A2(Pm, 3, Ur)
                            ]);
                    }
                default:
                    return A([
                        yd(Ur),
                        A2(Cm, bs, Ur),
                        Om(Ur),
                        qm(Ur),
                        Im(Ur),
                        A2(Lm, bs, Ur),
                        Nm(Ur)
                    ]);
            }
        }(e)));
    }, aV = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), iV = function(n) {
        return {
            $: 4,
            a: n
        };
    }, cV = F3(function(n, e, r) {
        return {
            $: 5,
            a: n,
            b: e,
            c: r
        };
    }), oV = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fV = function(n) {
        return A2(WN, A([
            YN("p-3 pb-0")
        ]), A([
            f_({
                hS: j,
                h4: Ur,
                h9: A([
                    c_(n)
                ]),
                ed: 0,
                eG: zr("Erreur")
            })
        ]));
    }, sV = function(n) {
        return JG({
            h4: gc,
            h9: A([
                n
            ]),
            l6: j,
            l7: Ur,
            oE: 2,
            oM: Ur,
            eG: "D\xe9tail de l'enregistrement"
        });
    }, lV = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dV = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bV = F3(function(n, e, r) {
        return A2(m_, j, A([
            c_(A2(Rj, n, r)),
            A2(m_, A([
                YN("fs-unit")
            ]), A([
                c_("\u202F"),
                c_(e)
            ]))
        ]));
    }), mV = A2(Hu, Bh, A2(bV, 3, "m\xb3")), pV = A2(Hu, _o, A2(bV, 3, "kg")), vV = function(n) {
        return 1e3 * n;
    }, gV = A2(Hu, vV, A2(bV, 3, "L")), hV = A2(Hu, Uy, A2(bV, 3, "m\xb2")), $V = F2(function(n, e) {
        var r = n.aL, t = e;
        switch(r){
            case 0:
                return mV(t);
            case 2:
                return pV(t);
            case 4:
                return gV(nb(t));
            case 6:
                return hV(t);
            default:
                return c_(Js(t) + " " + Th(r));
        }
    }), xV = "\u2014", kV = function(n) {
        return A2(bV, n.li, n.aL);
    }, jV = F2(function(n, e) {
        return A2(Hu, function(n) {
            return n.r;
        }, A2(Hu, wu(A2(H$, n, e)), A2(Hu, Vg, fs(A2(yu, dh, Ih)))));
    }), yV = F2(function(n, e) {
        return A2(Hu, A2(jV, {
            az: n.h8,
            C: n.C,
            at: e
        }, Uf), fs(A2(Hu, xA, A2(Hu, ch(19), b$))));
    }), wV = F2(function(n, e) {
        return A2(fs, at(" | "), A2(qg, Hj(n.W), e.r));
    }), AV = F2(function(n, e) {
        return A2(at, " ", A([
            A2(Nc, "", A2(Pc, bf, e.mj)),
            e.ek,
            A2(Nc, "", e.gh),
            A2(Zg, "", A2(wV, n, e))
        ]));
    }), TV = A2(Hu, af, Js), EV = F2(function(n, e) {
        var r = n.C, t = e.at;
        return {
            k$: A([
                {
                    ai: "Identifiant",
                    eI: function(n) {
                        var e = n.mj;
                        return e.$ ? c_(xV) : A2(A_, j, A([
                            c_(bf(e.a))
                        ]));
                    },
                    eL: dV(A2(Hu, function(n) {
                        return n.mj;
                    }, A2(Hu, Pc(bf), Nc(xV))))
                },
                {
                    ai: "Nom",
                    eI: A2(Hu, function(n) {
                        return n.ek;
                    }, A2(Hu, c_, A2(Hu, ck, H_(j)))),
                    eL: dV(function(n) {
                        return n.ek;
                    })
                },
                {
                    ai: "\xc9l\xe9ments",
                    eI: function(n) {
                        var e = A2(sx, r, n.r);
                        if (1 === e.$) return f_({
                            hS: j,
                            h4: Ur,
                            h9: A([
                                c_(e.a)
                            ]),
                            ed: 0,
                            eG: Ur
                        });
                        if (e.a.b) {
                            var t = e.a;
                            return A2(B_, A([
                                YN("m-0 px-2")
                            ]), A2(wu, function(n) {
                                var e = n.U, r = n.J;
                                return A2(__, j, A([
                                    A2($V, e.t, n.j),
                                    c_(" de " + Gb(e.t)),
                                    A2(B_, j, A2(wu, A2(Hu, function(n) {
                                        return n.t;
                                    }, A2(Hu, Gb, A2(Hu, c_, A2(Hu, ck, __(j))))), r))
                                ]));
                            }, t));
                        }
                        return A2(C_, j, A([
                            c_("Aucun \xe9l\xe9ment")
                        ]));
                    },
                    eL: dV(function(n) {
                        var e = A2(sx, r, n.r);
                        return 1 === e.$ ? "" : A2(at, ", ", A2(wu, function(n) {
                            var e = n.U;
                            return TV(n.j) + (Th(e.t.aL) + " de ") + Gb(e.t);
                        }, e.a));
                    })
                },
                {
                    ai: "Commentaire",
                    eI: A2(Hu, function(n) {
                        return n.gh;
                    }, A2(Hu, Nc(xV), c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.gh;
                    }, Nc(xV)))
                },
                {
                    ai: "Co\xfbt environnemental",
                    eI: A2(Hu, A2(yV, n, t), A2(Hu, fs(kV({
                        li: 2,
                        aL: "Pts par composant"
                    })), Zg(c_(xV)))),
                    eL: lV(A2(Hu, A2(yV, n, t), Zg(0)))
                }
            ]),
            l$: j,
            l2: "components",
            mM: j,
            oZ: A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, Pc(bf), Nc(""))),
            o$: A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, Cm(t), bd(t))),
            o0: A2(Hu, AV(r), jC)
        };
    }), CV = F2(function(n, e) {
        return A2(WN, A([
            YN("DatasetTable table-responsive table-scroll position-relative")
        ]), A([
            A2(G_, A2(Mr, YN("table table-striped table-hover mb-0"), n), e)
        ]));
    }), IV = F3(function(n, e, r) {
        var t = e({
            lu: !0,
            at: n
        }), u = t.mM, a = t.k$;
        return A2(WN, j, A([
            A2(WN, A([
                YN("text-muted fs-7")
            ]), u),
            A2(CV, A([
                YN("view-details")
            ]), A([
                A2(X_, j, A2(wu, function(n) {
                    var e = n.eI;
                    return A2(K_, j, A([
                        A2(J_, j, A([
                            c_(n.ai)
                        ])),
                        A2(V_, j, A([
                            e(r)
                        ]))
                    ]));
                }, a))
            ]))
        ]));
    }), SV = F2(function(n, e) {
        var r = n.ow;
        return Ah(function(n) {
            return A2(wh, function(e) {
                var t = e.fU;
                return A2(Nc, !0, A2(Pc, function(e) {
                    return !!MO(e) || A2(nl, function(e) {
                        return A2(el, e, t(n));
                    }, function(n) {
                        var e;
                        return e = n, A3(Hr, F3(function(n, e, r) {
                            return A2(Mr, n, r);
                        }), j, e);
                    }(e));
                }, A2(ra, e.fn, r)));
            }, e);
        });
    }), OV = F3(function(n, e, r) {
        return A2(wh, function(e) {
            return A2(n, e, r);
        }, e);
    }), LV = F2(function(n, e) {
        return A2(au, " " + n + " ", " " + e + " ");
    }), PV = F2(function(n, e) {
        return A3(yu, F2(function(e, r) {
            var t = r.a, u = r.b;
            return n(e) ? v(A2(Mr, e, t), u) : v(t, A2(Mr, e, u));
        }), v(j, j), e);
    }), qV = hr($r), NV = A2(Hu, Ss, A2(Hu, kC, qV(mC))), _V = F2(function(n, e) {
        var r = n.m5, t = n.o0, u = mf(n.g5);
        if ("" === u || 0 > m(iu(u), r)) return e;
        var a = A2(Ah, A2(Hu, su, rl), NV(u)), i = A2(PV, A2(Hu, Xt, A2(OV, LV, a)), A2(wu, function(n) {
            return v(t(n), n);
        }, e)), c = i.a, o = i.b, f = A2(PV, A2(Hu, Xt, A2(OV, au, a)), o).a;
        return k(A2(wu, Gh, c), A2(wu, Gh, f));
    }), zV = F2(function(n, e) {
        return _V({
            m5: 2,
            g5: n.du,
            o0: e
        });
    }), UV = F3(function(n, e, r) {
        return A2(Hu, A2(SV, n, e), A2(zV, n, r));
    }), MV = function(n) {
        return function(n) {
            return {
                $: 3,
                a: n
            };
        }(LA(n));
    }, DV = F2(function(n, e) {
        switch(e.$){
            case 0:
                return Js((0, e.a)(n));
            case 1:
                return ut((0, e.a)(n));
            case 2:
                return xV;
            default:
                return (0, e.a)(n);
        }
    }), RV = F2(function(n, e) {
        var r = n.k$, t = A2(Ah, A2(Hu, function(n) {
            return n.ai;
        }, Ic("")), r);
        return {
            mc: A2(wu, function(n) {
                return n.ai;
            }, t),
            n$: A2(wu, function(n) {
                return A2(wu, A2(Hu, function(n) {
                    return n.eL;
                }, DV(n)), t);
            }, e)
        };
    }), FV = {
        $: 0
    }, HV = ru, GV = fe("caption"), XV = F3(function(n, e, r) {
        switch(e.$){
            case 0:
                return r;
            case 1:
                return (t = e.a)(r);
            case 2:
                return xt((t = e.a)(r));
            case 3:
                var t = e.a;
                return n ? xt(t(r)) : t(r);
            default:
                return t = e.a, n ? t(r) : xt(t(r));
        }
    }), VV = F2(function(n, e) {
        for(;;){
            if (!e.b) return Ur;
            var r = e.a.oF, t = e.b;
            if (s(e.a.ek, n)) return zr(r);
            e = t;
        }
    }), JV = F3(function(n, e, r) {
        var t = n.b, u = A2(VV, n.a, e);
        return 1 === u.$ ? r : A3(XV, t, u.a, r);
    }), YV = fe("tfoot"), WV = function(n) {
        return {
            $: 2,
            a: n
        };
    }, KV = {
        $: 0
    }, BV = F3(function(n, e, r) {
        return A2(a_, "click", A2(Qt, r, A3(Zt, Ag, nu(n), nu(e))));
    }), QV = F3(function(n, e, r) {
        var t = n.a, u = n.b, a = r.ek;
        switch(r.oF.$){
            case 0:
                return g(a, KV, A3(BV, t, u, e));
            case 1:
            case 2:
                return g(a, function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(s(a, t)), A3(BV, a, !1, e));
            default:
                return s(a, t) ? g(a, WV(zr(u)), A3(BV, a, !u, e)) : g(a, WV(Ur), A3(BV, a, !1, e));
        }
    }), ZV = de, nJ = ZV, eJ = F2(function(n, e) {
        var r = (0, e.pN)(n);
        return A2(V_, r.hS, r.kV);
    }), rJ = F3(function(n, e, r) {
        return A2(K_, e(r), A2(wu, eJ(r), n));
    }), tJ = F4(function(n, e, r, t) {
        return v(n(t), A4(nJ, rJ, e, r, t));
    }), uJ = F3(function(n, e, r) {
        var t, u, a = n.oZ, i = n.k$, c = n.lf, o = c.kb(A2(wu, A2(QV, e, n.o_), i)), f = A2(Y_, o.hS, o.kV), s = A3(JV, e, i, r), l = A3(jG, "tbody", c.hr, A2(wu, A3(tJ, a, i, c.oj), s)), d = 1 === (t = c.ht).$ ? A2(Mr, l, j) : A2(Mr, A2(YV, t.a.hS, t.a.kV), A2(Mr, l, j));
        return A2(G_, c.oS, 1 === (u = c.gc).$ ? A2(Mr, f, d) : A2(Mr, A2(GV, u.a.hS, u.a.kV), A2(Mr, f, d)));
    }), aJ = F2(function(n, e) {
        return A2(hX, n, e);
    }), iJ = LA(A2(Hu, Ss, kC)), cJ = F4(function(n, e, r, t) {
        return A2(gX, A([
            YN("form-check d-flex align-items-start gap-2 cursor-pointer"),
            r_(A([
                v("fw-semibold", e)
            ])),
            W_(t)
        ]), A([
            A2(N_, A([
                o_("checkbox"),
                YN("form-check-input mt-1 no-outline"),
                w_(e),
                xX(A2(n.ns, r, t))
            ]), j),
            A2(m_, A([
                YN("form-check-label text-truncate")
            ]), A([
                c_(t)
            ]))
        ]));
    }), oJ = F3(function(n, e, r) {
        var t = r.fn, u = r.fU, a = A2(Nc, aE, A2(ra, t, n.ow)), i = A3(CN, iJ, iJ, A3(ot, F2(function(n, e) {
            var r = e.a, t = e.b;
            return A2(aJ, n, a) ? v(A2(Mr, n, r), t) : v(r, A2(Mr, n, t));
        }), v(j, j), iy(A2(Id, u, e)))), c = i.a, o = i.b, f = k(c, o);
        return sf(f) || s(f, A([
            xV
        ])) ? c_("") : A2(WN, A([
            YN("FacetCard card")
        ]), A([
            A2(WN, A([
                YN("card-header fw-bold py-2")
            ]), A([
                c_(t)
            ])),
            A2(WN, A([
                YN("FacetCardBody card-body d-flex flex-column gap-1 p-2 no-scroll-chaining"),
                A2(n_, "data-scroll-id", t)
            ]), Cd(A([
                A2(wu, A3(cJ, n, !0, t), c),
                sf(c) ? j : A([
                    A2(WN, A([
                        YN("FacetCardSeparator border-bottom")
                    ]), j)
                ]),
                A2(wu, A3(cJ, n, !1, t), o)
            ])))
        ]));
    }), fJ = F3(function(n, e, r) {
        return A2(WN, A([
            YN("d-flex flex-column gap-2")
        ]), A2(wu, A2(oJ, n, r), e));
    }), sJ = F6(function(n, e, r, t, u, a) {
        var i, c = u({
            lu: !1,
            at: t
        }), o = c.l2, f = c.oZ, s = c.o0, l = c.l$, d = c.k$, b = c.mM, p = !sf(l), g = A4(UV, e, l, s, a), h = {
            h9: A2(RV, c, g),
            l2: "ecobalyse-" + vs(t) + "-" + o + ".csv"
        }, x = A2(Hc, 100, g), y = ft(g), w = (i = $(e.lf, {
            oj: A2(Hu, n, A2(Hu, i_, ck))
        }), $(i, {
            kb: function(n) {
                var e = i.kb(n);
                return $(e, {
                    hS: k(e.hS, A([
                        YN("sticky-md-top bg-white")
                    ]))
                });
            }
        })), T = function(n) {
            var e = n.oZ, r = n.o_, t = n.lf;
            return {
                k$: A2(wu, function(n) {
                    return n;
                }, n.k$),
                lf: t,
                oZ: e,
                o_: r
            };
        }({
            k$: A2(wu, function(n) {
                var r = n.eI, t = n.eL;
                return HV({
                    ek: n.ai,
                    oF: function() {
                        if ("" !== mf(e.du)) return FV;
                        switch(t.$){
                            case 0:
                            case 1:
                                return MV(t.a);
                            case 2:
                                return FV;
                            default:
                                return MV(A2(Hu, t.a, A2(Hu, Ss, kC)));
                        }
                    }(),
                    pN: function(n) {
                        return {
                            hS: j,
                            kV: A([
                                r(n)
                            ])
                        };
                    }
                });
            }, d),
            lf: w,
            oZ: f,
            o_: e.o_
        });
        return sf(a) ? f_({
            hS: j,
            h4: Ur,
            h9: A([
                c_("Aucun enregistrement disponible pour le secteur "),
                A2(H_, j, A([
                    c_(qx(t))
                ]))
            ]),
            ed: 1,
            eG: Ur
        }) : A2(WN, A([
            YN("row g-3")
        ]), A([
            A2(WN, A([
                r_(A([
                    v("col-xxl-10 col-xl-9 col-lg-9 col-md-12 col-sm-12", p)
                ]))
            ]), A([
                m(y, 100) > 0 ? A2(hH, A([
                    YN("text-muted fs-7 mb-2")
                ]), A3(Yb, "{resultCount}", ut(y), A3(Yb, "{maxRows}", ut(100), "Affichage des {maxRows} premiers r\xe9sultats sur {resultCount} r\xe9sultats"))) : c_(""),
                A2(WN, A([
                    YN("DatasetTable table-responsive table-scroll position-relative")
                ]), A([
                    sf(g) ? f_({
                        hS: j,
                        h4: Ur,
                        h9: A([
                            c_("Cette recherche n\u2019a retourn\xe9 aucun r\xe9sultat")
                        ]),
                        ed: 1,
                        eG: Ur
                    }) : A3(uJ, T, r, x),
                    A2(WN, A([
                        YN("text-muted fs-7")
                    ]), b)
                ])),
                A2(WN, A([
                    YN("text-end pt-3")
                ]), A([
                    A2(e_, A([
                        YN("btn btn-secondary"),
                        i_(A2(e.lD, h.l2, h.h9))
                    ]), A([
                        c_("T\xe9l\xe9charger ces donn\xe9es au format CSV")
                    ]))
                ]))
            ])),
            A2(WN, A([
                YN("col-xxl-2 col-xl-3 col-lg-3 col-md-12 col-sm-12 overflow-y-scroll sticky-top")
            ]), A([
                A3(fJ, e, l, a)
            ]))
        ]));
    }), lJ = F5(function(n, e, r, t, u) {
        var a = A2(Ah, A2(Hu, function(n) {
            return n.g9;
        }, el(e)), n.C.dZ);
        return A([
            A6(sJ, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, Pc(bf), A2(Hu, Nc(""), oV))), r, t, e, EV(n), A2(LA, function(n) {
                return n.ek;
            }, a)),
            function() {
                if (u.$) return c_("");
                var r = u.a;
                return sV(function() {
                    var t = A2(V$, r, a);
                    if (1 === t.$) return fV(t.a);
                    var u = t.a;
                    return A3(IV, e, EV(n), u);
                }());
            }()
        ]);
    }), dJ = F2(function(n, e) {
        return {
            fn: n,
            fU: e
        };
    }), bJ = A2(Hu, Tf, A2(bV, 0, "km")), mJ = F3(function(n, e, r) {
        var t = function(n) {
            return s(n, 0) ? c_(xV) : bJ(n);
        };
        return A2(K_, j, A([
            A2(V_, A([
                W_(A2(Zg, "", A2(fs, function(n) {
                    return n.ek;
                }, A2(js, n, e))))
            ]), A([
                c_(n)
            ])),
            A2(V_, j, A([
                t(r.f5)
            ])),
            A2(V_, j, A([
                t(r.ds)
            ])),
            A2(V_, j, A([
                t(r.hb)
            ]))
        ]));
    }), pJ = F4(function(n, e, r, t) {
        return A2(Mr, A3(mJ, e, n, r), t);
    }), vJ = F3(function(n, e, r) {
        var t = r.l;
        return A3(Di, F2(function(e, r) {
            return A2(n, r.a, r.b);
        }), e, t);
    }), gJ = F3(function(n, e, r) {
        var t = A2(Xh, r.cR, e);
        if (t.$) return c_("");
        var u, a = t.a;
        return u = A3(vJ, pJ(n), j, a), A2(G_, A([
            YN("table table-striped table-hover text-center w-100")
        ]), A([
            A2(Y_, j, A([
                A2(K_, j, A([
                    A2(J_, j, A([
                        c_("Code pays")
                    ])),
                    A2(J_, j, A([
                        c_("A\xe9rien")
                    ])),
                    A2(J_, j, A([
                        c_("Routier")
                    ])),
                    A2(J_, j, A([
                        c_("Maritime")
                    ]))
                ]))
            ])),
            A2(X_, j, xt(u))
        ]));
    }), hJ = function(n) {
        switch(n){
            case 0:
                return "alimentaire/impacts-consideres/complements-hors-acv-en-construction";
            case 1:
                return "alimentaire/etapes-du-cycles-de-vie/vente-au-detail";
            case 2:
                return "alimentaire/part-non-comestible";
            case 3:
                return "alimentaire/donnees";
            case 4:
                return "alimentaire/etapes-du-cycles-de-vie/emballage";
            case 5:
                return "alimentaire/rapport-cru-cuit";
            case 6:
                return "alimentaire/etapes-du-cycles-de-vie/transformation";
            case 7:
                return "alimentaire/transport";
            case 8:
                return "alimentaire/etapes-du-cycles-de-vie/consommation";
            case 9:
                return "textile/cycle-de-vie-des-produits-textiles/circular-footpring-formula-cff";
            case 10:
                return "textile/complements-hors-acv/microfibres";
            case 11:
                return "textile/etapes-du-cycle-de-vie/distribution";
            case 12:
                return "textile/complements-hors-acv/durabilite";
            case 13:
                return "textile/parametres-transverses/electricite";
            case 14:
                return "textile/etapes-du-cycle-de-vie/etape-7-fin-de-vie";
            case 15:
                return "textile/limites-methodologiques/fin-de-vie-hors-europe";
            case 16:
                return "textile/cycle-de-vie-des-produits-textiles/ennoblissement-1";
            case 17:
                return "textile/etapes-du-cycle-de-vie/ennoblissement/inventaires-enrichis#pays-less-than-greater-than-taux-de-pollution-aquatique";
            case 18:
                return "textile/etapes-du-cycle-de-vie/ennoblissement/inventaires-enrichis";
            case 19:
                return "textile/exemples";
            case 20:
                return "textile/etapes-du-cycle-de-vie/tricotage-tissage";
            case 21:
                return "textile/cycle-de-vie-des-produits-textiles/tricotage-tissage#taux-de-perte";
            case 22:
                return "textile/parametres-transverses/chaleur";
            case 23:
                return "textile/etapes-du-cycle-de-vie/confection";
            case 24:
                return "textile/etapes-du-cycle-de-vie/confection#electricite-consommee-mj-kwh";
            case 25:
                return "textile/cas-particuliers/stocks-dormants-deadstock";
            case 26:
                return "textile/parametres-transverses/pertes-et-rebus";
            case 27:
                return "textile/etapes-du-cycle-de-vie/etape-1-matieres";
            case 28:
                return "textile/cycle-de-vie-des-produits-textiles/etape-2-fabrication-du-fil";
            case 29:
                return "textile/parametres-transverses/transport";
            case 30:
                return "textile/cycle-de-vie-des-produits-textiles/accessoires";
            default:
                return "textile/etapes-du-cycle-de-vie/etape-6-utilisation";
        }
    }, $J = function(n) {
        return IH + "/" + n;
    }, xJ = A2(Hu, hJ, $J), kJ = function(n) {
        return VN(A2(Mr, _H("_blank"), A2(Mr, NH("noopener noreferrer"), A2(Mr, YN("btn btn-sm text-secondary text-decoration-none btn-link p-0 ms-1"), n))));
    }, jJ = F2(function(n, e) {
        return c_(A2(aT, n, e) + "\u202F%");
    }), yJ = function(n) {
        switch(n){
            case 0:
                return "Afrique";
            case 1:
                return "Asie";
            case 2:
                return "Europe";
            case 3:
                return "Moyen-Orient";
            case 4:
                return "Am\xe9rique du Nord";
            case 5:
                return "Oc\xe9anie";
            default:
                return "Am\xe9rique du Sud";
        }
    }, wJ = function(n) {
        return A2(at, " ", A([
            n.cR,
            n.ek,
            Gb(n.lO),
            Gb(n.me),
            A2(at, " ", A2(wu, qx, n.g9)),
            yJ(n.hG)
        ]));
    }, AJ = F3(function(n, e, r) {
        var t = r.lu, u = r.at;
        return {
            k$: A2(qa, ru, A([
                zr({
                    ai: "Code",
                    eI: function(n) {
                        return A2(A_, j, A([
                            c_(n.cR)
                        ]));
                    },
                    eL: dV(A2(Hu, function(n) {
                        return n.cR;
                    }, Po))
                }),
                zr({
                    ai: "Nom",
                    eI: A2(Hu, function(n) {
                        return n.ek;
                    }, c_),
                    eL: dV(function(n) {
                        return n.ek;
                    })
                }),
                zr({
                    ai: "Mix \xe9lectrique",
                    eI: A2(Hu, function(n) {
                        return n.lO;
                    }, A2(Hu, Gb, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.lO;
                    }, Gb))
                }),
                zr({
                    ai: "Chaleur",
                    eI: A2(Hu, function(n) {
                        return n.me;
                    }, A2(Hu, Gb, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.me;
                    }, Gb))
                }),
                s(u, bs) ? zr({
                    ai: "Taux de pollution aquatique",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-end", !t)
                            ]))
                        ]), A([
                            A2(jJ, 2, ey(n.hP)),
                            A2(kJ, A([
                                QN(xJ(17))
                            ]), A([
                                b_
                            ]))
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.hP;
                    }, A2(Hu, ey, Mf)))
                }) : Ur,
                t ? zr({
                    ai: "Distances",
                    eI: A2(gJ, e, n),
                    eL: dV(Wi(""))
                }) : Ur
            ])),
            l$: A([
                A2(dJ, "Mix \xe9lectrique", A2(Hu, function(n) {
                    return n.lO;
                }, A2(Hu, Gb, ck))),
                A2(dJ, "Chaleur", A2(Hu, function(n) {
                    return n.me;
                }, A2(Hu, Gb, ck))),
                A2(dJ, "Taux de pollution aquatique", A2(Hu, function(n) {
                    return n.hP;
                }, A2(Hu, ey, A2(Hu, aT(0), function(n) {
                    return A([
                        n + "%"
                    ]);
                }))))
            ]),
            l2: "countries",
            mM: j,
            oZ: A2(Hu, function(n) {
                return n.cR;
            }, Po),
            o$: A2(Hu, function(n) {
                return n.cR;
            }, A2(Hu, zr, A2(Hu, Im, bd(u)))),
            o0: A2(Hu, wJ, jC)
        };
    }), TJ = F5(function(n, e, r, t, u) {
        var a = n.lw, i = n.bT;
        return A([
            A6(sJ, A2(Hu, function(n) {
                return n.cR;
            }, A2(Hu, Po, oV)), e, r, t, A2(AJ, a, i), A2(Ah, A2(Hu, function(n) {
                return n.g9;
            }, el(t)), i)),
            function() {
                if (u.$) return c_("");
                var n = u.a;
                return sV(function() {
                    var e = A2(js, n, i);
                    if (1 === e.$) return fV(e.a);
                    var r = e.a;
                    return A3(IV, t, A2(AJ, a, i), r);
                }());
            }()
        ]);
    }), EJ = F2(function(n, e) {
        return {
            hS: n,
            kV: e
        };
    }), CJ = function(n) {
        return A2(m_, A([
            A2(qH, "color", "#555")
        ]), A([
            c_(" " + n)
        ]));
    }, IJ = function(n) {
        return A2(m_, A([
            A2(qH, "color", "#ccc")
        ]), A([
            c_(" " + n)
        ]));
    }, SJ = function(n) {
        var e = n.a, r = n.b, t = n.c, u = function() {
            switch(r.$){
                case 0:
                    return A([
                        c_(e)
                    ]);
                case 1:
                    var n = r.a;
                    return A([
                        c_(e),
                        n ? CJ("\u2193") : IJ("\u2193")
                    ]);
                default:
                    if (1 === r.a.$) return A([
                        c_(e),
                        IJ("\u2195")
                    ]);
                    var t = r.a.a;
                    return A([
                        c_(e),
                        CJ(t ? "\u2191" : "\u2193")
                    ]);
            }
        }();
        return A2(J_, A([
            t
        ]), u);
    }, OJ = {
        gc: Ur,
        oj: function() {
            return j;
        },
        oS: j,
        hr: j,
        ht: Ur,
        kb: function(n) {
            return A2(EJ, j, A2(wu, SJ, n));
        }
    }, LJ = F3(function(n, e, r) {
        return lh(A([
            A2(fh, function() {
                return A2(Hu, b$, A2(Hu, Rt(vh(r.d2.a)), A2(Hu, Rt(e), A2(Hu, Rt(r.d2.b), d$))));
            }, n.mT.g),
            A2(fh, function() {
                return A2(Hu, b$, A2(Hu, Rt(gh(r.eb.a)), A2(Hu, Rt(e), A2(Hu, Rt(r.eb.b), d$))));
            }, n.lB.g)
        ]));
    }), PJ = A([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19
    ]), qJ = F3(function(n, e, r) {
        return A3(ot, F2(function(e, t) {
            return A3(n, e, A2(eh, e, r), t);
        }), e, PJ);
    }), NJ = F2(function(n, e) {
        return A2(Hu, _h(n), A2(Hu, bh(e), bh(1e6)));
    }), _J = F3(function(n, e, r) {
        var t = r;
        return A3(qJ, function() {
            return uh;
        }, 0, A2(oh, F2(function(r, t) {
            return A2(Nc, 0, A2(Pc, function(n) {
                return A3(NJ, n.jd, n.kp, t);
            }, e(A2(eh, r, n))));
        }), t));
    }), zJ = F3(function(n, e, r) {
        return A3(ot, F2(function(r, t) {
            return n(r) ? t : A3(C$, r, e, t);
        }), r, PJ);
    }), UJ = F2(function(n, e) {
        var r = e, t = function(e) {
            return A3(_J, n, function(n) {
                return n.it;
            }, A3(zJ, function(n) {
                return A2(el, n, e);
            }, Wi(0), r));
        };
        return {
            kJ: t(A([
                0,
                17,
                5,
                16,
                3,
                11
            ])),
            kZ: t(A([
                1
            ])),
            md: t(A([
                13,
                10,
                14,
                9,
                7,
                15
            ])),
            ob: t(A([
                18,
                4,
                12
            ]))
        };
    }), MJ = F3(function(n, e, r) {
        var t = A2(UJ, n, r), u = A2(ch, 19, r);
        return {
            kA: A2(uh, u, e),
            f7: u,
            kJ: t.kJ,
            kZ: t.kZ,
            k1: e,
            md: t.md,
            ob: t.ob
        };
    }), DJ = F2(function(n, e) {
        return A2(Hu, function(n) {
            return n.g;
        }, fh(F2(function(r, t) {
            return vh(A2(jf, n, e)) * t;
        })));
    }), RJ = F2(function(n, e) {
        return A2(Hu, function(n) {
            return n.g;
        }, fh(F2(function(r, t) {
            return vV(A2(bh, n, e)) * t;
        })));
    }), FJ = F3(function(n, e, r) {
        var t = e.b;
        return lh(A([
            A3(RJ, t.cG, n, r.cG),
            A3(DJ, t.aN, n, r.mT),
            A3(DJ, t.c5, n, r.mT)
        ]));
    }), HJ = F2(function(n) {
        return A2(Hu, b$, A2(Hu, Rt(n), d$));
    }), GJ = F3(function(n, e, r) {
        return $(r, e ? {
            og: A2(uh, n, r.og)
        } : {
            ds: A2(uh, n, r.ds)
        });
    }), XJ = A2(wu, gw, A([
        "RAF",
        "RAS",
        "RLA",
        "RME",
        "RNA",
        "ROC"
    ])), VJ = 2e3, JJ = F3(function(n, e, r) {
        var t = r.cR, u = e ? 0 : 1, a = Ks, i = cx(a);
        return s(t, _A) ? $(i, {
            ds: ml(VJ),
            hb: ml(18e3)
        }) : (A2(el, t, XJ) ? A2(GJ, ml(VJ), !1) : ru)(A2(g$, u, A4(rA, a, t, SA, n.lw)));
    }), YJ = function(n) {
        return {
            kK: n.kN,
            kL: n.kM,
            mP: n.mS,
            mQ: n.mR,
            nL: n.jo
        };
    }, WJ = F2(function(n, e) {
        var r = cx(Ks);
        switch(e){
            case 0:
                return $(r, {
                    ds: ml(VJ)
                });
            case 1:
                return r;
            case 2:
                return $(r, n ? {
                    hb: ml(8315)
                } : {
                    f5: ml(8401)
                });
            case 3:
                return $(r, {
                    ds: ml(VJ),
                    hb: ml(18e3)
                });
            default:
                return $(r, n ? {
                    ds: ml(VJ),
                    hb: ml(18e3)
                } : {
                    f5: ml(18e3),
                    ds: ml(VJ)
                });
        }
    }), KJ = gw("ROF"), BJ = F2(function(n, e) {
        var r, t, u = e.i, a = e.a_, i = e.P, c = e.jo, o = YJ(n.l5.pQ), f = function(n) {
            if (u.$) return 2 === a.gp ? n : A3(GJ, ml(500), 1 !== a.gp ? !a.hz : function(n) {
                return A2(el, n.hz, A([
                    0,
                    1
                ]));
            }(a), n);
            var e = u.a.cR;
            return s(e, SA) || s(e, KJ) ? n : A3(GJ, ml(500), !a.hz, n);
        }((t = (r = A2(Nc, A2(WJ, c, a.gp), A2(Pc, A2(JJ, n, c), u)), 2 !== a.hz ? $(r, {
            ds: 0,
            og: r.ds,
            hb: 0,
            oq: r.hb
        }) : r), A3(GJ, ml(160), !a.hz, t)));
        return A3(m$, o, i, f);
    }), QJ = F2(function(n, e) {
        var r = n.ag, t = n.ah, u = n.al, a = n.am, i = bh(e);
        return {
            ag: zr(i(r)),
            aa: Ur,
            ah: zr(i(t)),
            aj: Ur,
            ak: Ur,
            al: zr(i(u)),
            am: zr(i(a))
        };
    }), ZJ = A2(ot, F2(function(n, e) {
        return A2(lw, e, A2(QJ, n.a_.lL, n.P));
    }), dw), nY = function(n) {
        return A2($h, n.j, n.t.g);
    }, eY = function(n) {
        return A2(fh, HJ(n.P), n.t.g);
    }, rY = F2(function(n, e) {
        return A3(GJ, n.b.eN, e, cx(Ks));
    }), tY = function(n) {
        return ah(A2(wu, function(n) {
            var e = n.j, r = n.t;
            return 2 === r.aL ? e : e * A2(Nc, 1, r.mZ);
        }, n.cs));
    }, uY = F2(function(n, e) {
        return s(A2(Pc, function(n) {
            return n.t;
        }, e), zr(n.k7));
    }), aY = wu(function(n) {
        return $(n, {
            P: A2(bh, 1 - n.a_.mp, n.P)
        });
    }), iY = F2(function(n, e) {
        var r = e.fX;
        return ah(A2(wu, function(e) {
            var t = e.a_, u = e.P;
            return A2(uY, n, r) ? A2(bh, t.nZ, u) : u;
        }, aY(e.mq)));
    }), cY = F2(function(n, e) {
        return ah(A([
            A2(iY, n, e),
            tY(e)
        ]));
    }), oY = F2(function(n, e) {
        var r = e.mq, t = e.fX, u = A2(nl, function(n) {
            return n.br;
        }, e.bk);
        return !A2(uY, n, t) && u ? ah(A2(wu, function(n) {
            return A2(bh, n.a_.nZ, n.P);
        }, r)) : A2(iY, n, e);
    }), fY = F2(function(n, e) {
        return A2(Hy, function(n) {
            var e = n.mq;
            if (e.b && !e.b.b) {
                var r = e.a;
                return s(n.fX, Ur) ? r.a_.ls : PE(1);
            }
            return PE(1);
        }(e), A2(iY, n, e));
    }), sY = function(n) {
        return fh(function() {
            return _h(n);
        });
    }, lY = function(n) {
        var e = n.l5;
        return A2(Hu, Kg(n), fs(function(r) {
            var t, u, a = r.mq, i = r.fX, c = r.cs, o = r.E, f = r.bk, s = A2(iY, e.pQ, r), l = A2(Nc, Ks, A2(Pc, eY, i)), d = ZJ(a), b = A2(oY, e.pQ, r), m = A2(O$, Pc(_h(b)), d), p = lh(A2(wu, A2(LJ, e.pQ, s), f)), g = lh(A2(wu, nY, c)), h = wx(A2(wu, BJ(n), a)), $ = A2(wu, function(n) {
                var e, r;
                return A2(Nw, n, (r = (e = n).a_, A2(fh, HJ(e.P), r.t.g)));
            }, a), x = lh(A2(wu, Gh, $)), k = lh(A([
                x,
                l,
                h.g
            ])), j = A2(nl, A2(Hu, function(n) {
                return n.a_;
            }, A2(Hu, function(n) {
                return n.hz;
            }, Ic(2))), a), y = (t = A2(Nc, cx(Ks), A2(Pc, function(n) {
                return A2(rY, n, j);
            }, o)), u = YJ(n.l5.pQ), A3(m$, u, A2(cY, e.pQ, r), t)), w = A2(Nc, Ks, A2(Pc, function(n) {
                return A3(FJ, A2(fY, e.pQ, r), n, e.pQ);
            }, o)), T = lh(A([
                k,
                g,
                w,
                y.g,
                p
            ])), E = A2(sY, b, T), C = A3(MJ, n.c_, ow(m), E), I = function(n) {
                return A2(S$, ow(d), n);
            }, S = I(T);
            return v(r, {
                E: {
                    bI: w,
                    af: y
                },
                cs: g,
                g_: A2(sY, b, S),
                bk: p,
                g1: b,
                bm: {
                    lM: ah(A2(wu, function(n) {
                        return n.P;
                    }, aY(r.mq))),
                    mq: $,
                    gH: I(x),
                    ms: ah(A2(wu, function(n) {
                        return n.P;
                    }, r.mq)),
                    bI: I(k),
                    kf: d,
                    o8: m,
                    fX: l,
                    pe: s,
                    af: h
                },
                ha: C,
                bI: S,
                hy: A2(cY, e.pQ, r),
                af: wx(A([
                    h,
                    y
                ]))
            });
        }));
    }, dY = function(n) {
        return A2(Hu, function(n) {
            return n.g5;
        }, A2(Hu, lY(n), A2(Hu, fs(A2(Hu, Gh, A2(Hu, function(n) {
            return n.bI;
        }, A2(Hu, ch(19), b$)))), Zg(0))));
    }, bY = function(n) {
        return A2(Hu, function(n) {
            return n.g5;
        }, A2(Hu, lY(n), A2(Hu, fs(A2(Hu, Gh, A2(Hu, function(n) {
            return n.g_;
        }, A2(Hu, ch(19), function(n) {
            return n / 10;
        })))), Zg(0))));
    }, mY = {
        $: 2
    }, pY = F3(function(n, e, r) {
        var t = r / e * 100;
        return A2(WN, A([
            YN("d-flex justify-content-center align-items-center gap-2"),
            A2(qH, "min-width", "calc(100% - 76px)")
        ]), A([
            A2(WN, A([
                r_(A([
                    v("text-end", !n)
                ])),
                A2(qH, "min-width", "76px")
            ]), A([
                A3(bV, 2, "Pts", r)
            ])),
            A2(WN, A([
                YN("progress"),
                A2(qH, "min-width", "calc(100% - 76px)")
            ]), A([
                A2(WN, A([
                    YN("progress-bar bg-secondary"),
                    A2(qH, "width", Js(t) + "%")
                ]), j)
            ]))
        ]));
    }), vY = d_("search"), gY = function(n) {
        return A2(at, " ", A([
            df(n.mj),
            n.ek,
            vs(n.at)
        ]));
    }, hY = F2(function(n, e) {
        var r = n.gN, t = n.gM, u = e.lu, a = e.at;
        return {
            k$: A([
                {
                    ai: "Nom",
                    eI: A2(Hu, Xt, A2(Hu, function(n) {
                        return n.ek;
                    }, c_)),
                    eL: dV(A2(Hu, Xt, function(n) {
                        return n.ek;
                    }))
                },
                {
                    ai: "Cat\xe9gorie",
                    eI: A2(Hu, Xt, A2(Hu, function(n) {
                        return n.h0;
                    }, c_)),
                    eL: dV(A2(Hu, Xt, function(n) {
                        return n.h0;
                    }))
                },
                {
                    ai: "Co\xfbt Environnemental",
                    eI: function(n) {
                        return A3(pY, u, r, n.b.bn);
                    },
                    eL: lV(A2(Hu, Gh, function(n) {
                        return n.bn;
                    }))
                },
                {
                    ai: "Co\xfbt Environnemental/100g",
                    eI: function(n) {
                        return A3(pY, u, t, n.b.bi);
                    },
                    eL: lV(A2(Hu, Gh, function(n) {
                        return n.bi;
                    }))
                },
                {
                    ai: "",
                    eI: function(n) {
                        var e = n.a.mj, r = n.a.ek;
                        return A2(VN, A([
                            YN("btn btn-light btn-sm w-100"),
                            ZN(pd(e)),
                            W_("Charger " + r)
                        ]), A([
                            vY
                        ]));
                    },
                    eL: mY
                }
            ]),
            l$: j,
            l2: "examples",
            mM: j,
            oZ: A2(Hu, Xt, A2(Hu, function(n) {
                return n.mj;
            }, df)),
            o$: A2(Hu, Xt, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, zr, A2(Hu, kd, bd(a))))),
            o0: A2(Hu, Xt, A2(Hu, gY, jC))
        };
    }), $Y = F4(function(n, e, r, t) {
        var u = A2(LA, A2(Hu, Xt, function(n) {
            return n.ek;
        }), A2(wu, function(e) {
            return v(e, {
                bi: A2(bY, n, e),
                bn: A2(dY, n, e)
            });
        }, n.l5.lT)), a = {
            gM: A2(Nc, 0, gC(A2(wu, A2(Hu, Gh, function(n) {
                return n.bi;
            }), u))),
            gN: A2(Nc, 0, gC(A2(wu, A2(Hu, Gh, function(n) {
                return n.bn;
            }), u)))
        };
        return A([
            A6(sJ, A2(Hu, Xt, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, df, oV))), e, r, ls, hY(a), A2(LA, A2(Hu, Xt, function(n) {
                return n.ek;
            }), A2(Ah, A2(Hu, Xt, A2(Hu, function(n) {
                return n.g5;
            }, Ic(mT))), u))),
            function() {
                if (t.$) return c_("");
                var e = t.a;
                return sV(function() {
                    var r = A2(Qx, e, n.l5.lT);
                    if (1 === r.$) return fV(r.a);
                    var t = r.a;
                    return A3(IV, ls, hY(a), v(t, {
                        bi: A2(bY, n, t),
                        bn: A2(dY, n, t)
                    }));
                }());
            }()
        ]);
    }), xY = "Diversit\xe9 culturale", kY = "Haies", jY = "Prairies permanentes", yY = "Taille de parcelles", wY = A2(bV, 2, "%"), AY = d_("question"), TY = function(n) {
        switch(n){
            case 0:
                return "Viandes, \u0153ufs, poissons, et d\xe9riv\xe9s";
            case 1:
                return "Bleu-Blanc-C\u0153ur";
            case 2:
                return "Conventionnel";
            case 3:
                return "Lait et ingr\xe9dients laitiers";
            case 4:
                return "C\xe9r\xe9ales transform\xe9es";
            case 5:
                return "C\xe9r\xe9ales brutes";
            case 6:
                return "Divers";
            case 7:
                return "Graisses v\xe9g\xe9tales et ol\xe9oprot\xe9agineux transform\xe9s";
            case 8:
                return "Fruits \xe0 coque et ol\xe9oprot\xe9agineux bruts";
            case 9:
                return "Bio";
            case 10:
                return "Condiments, \xe9pices, additifs";
            case 11:
                return "Fruits et l\xe9gumes frais";
            default:
                return "Fruits et l\xe9gumes transform\xe9s";
        }
    }, EY = function(n) {
        switch(n){
            case 0:
                return "Arboriculture";
            case 1:
                return "Orge";
            case 2:
                return "Ma\xefs grain et ensilage";
            case 3:
                return "Plantes \xe0 fibres";
            case 4:
                return "Fourrage";
            case 5:
                return "Gel (surfaces gel\xe9es sans production)";
            case 6:
                return "L\xe9gumineuses \xe0 grain";
            case 7:
                return "Gel industriel";
            case 8:
                return "Divers";
            case 9:
                return "N/A";
            case 10:
                return "Fruits \xe0 coques";
            case 11:
                return "Oliviers";
            case 12:
                return "Vergers";
            case 13:
                return "Autres c\xe9r\xe9ales";
            case 14:
                return "Autres gels";
            case 15:
                return "Autres cultures industrielles";
            case 16:
                return "Autres ol\xe9agineux";
            case 17:
                return "Prairies permanentes";
            case 18:
                return "Prot\xe9agineux";
            case 19:
                return "Colza";
            case 20:
                return "Riz";
            case 21:
                return "Semences";
            case 22:
                return "Bl\xe9 tendre";
            case 23:
                return "Canne \xe0 sucre";
            case 24:
                return "Estives landes";
            case 25:
                return "Tournesol";
            case 26:
                return "Prairies temporaires";
            case 27:
                return "L\xe9gumes et fleurs";
            default:
                return "Vignes";
        }
    }, CY = function(n) {
        switch(n){
            case 0:
                return "Import";
            case 1:
                return "N/A";
            case 2:
                return "Biologique";
            default:
                return "R\xe9f\xe9rence";
        }
    }, IY = function(n) {
        switch(n){
            case 0:
                return "Europe et Maghreb";
            case 1:
                return "France";
            case 2:
                return "France d\u2019outre-mer";
            case 3:
                return "Hors Europe et Maghreb";
            default:
                return "Hors Europe et Maghreb par avion";
        }
    }, SY = function(n) {
        switch(n){
            case 0:
                return "Toujours frigorifique";
            case 1:
                return "Frigorifique apr\xe8s transformation";
            default:
                return "Non frigorifique";
        }
    }, OY = function(n) {
        return A2(at, " ", A([
            n.hM,
            A2(at, " ", A2(wu, TY, n.cP)),
            EY(n.ic),
            IY(n.gp),
            n.ek,
            Gb(n.t),
            Hb(n.t),
            CY(n.jQ),
            SY(n.hz)
        ]));
    }, LY = function(n) {
        var e = n.lu, r = n.at;
        return {
            k$: A([
                {
                    ai: "Identifiant",
                    eI: function(n) {
                        return A2(A_, j, A([
                            c_(Ug(n.mj))
                        ]));
                    },
                    eL: dV(A2(Hu, function(n) {
                        return n.mj;
                    }, Ug))
                },
                {
                    ai: "Nom",
                    eI: A2(Hu, function(n) {
                        return n.ek;
                    }, c_),
                    eL: dV(function(n) {
                        return n.ek;
                    })
                },
                {
                    ai: "Alias",
                    eI: function(n) {
                        return A2(A_, j, A([
                            c_(n.hM)
                        ]));
                    },
                    eL: dV(function(n) {
                        return n.hM;
                    })
                },
                {
                    ai: "Cat\xe9gories",
                    eI: A2(Hu, function(n) {
                        return n.cP;
                    }, A2(Hu, wu(function(n) {
                        return A2(__, j, A([
                            c_(TY(n))
                        ]));
                    }), B_(A([
                        YN("mb-0")
                    ])))),
                    eL: dV(A2(Hu, function(n) {
                        return n.cP;
                    }, A2(Hu, wu(TY), at(","))))
                },
                {
                    ai: "Origine par d\xe9faut",
                    eI: A2(Hu, function(n) {
                        return n.gp;
                    }, A2(Hu, IY, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.gp;
                    }, IY))
                },
                {
                    ai: "Groupe de culture",
                    eI: A2(Hu, function(n) {
                        return n.ic;
                    }, A2(Hu, EY, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.ic;
                    }, EY))
                },
                {
                    ai: "Sc\xe9nario",
                    eI: A2(Hu, function(n) {
                        return n.jQ;
                    }, A2(Hu, CY, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.jQ;
                    }, CY))
                },
                {
                    ai: "Surface mobilis\xe9e",
                    eI: A2(Hu, function(n) {
                        return n.mG;
                    }, A2(Hu, function(n) {
                        return A2(Rj, 2, n) + " m2.an";
                    }, c_)),
                    eL: lV(function(n) {
                        return n.mG;
                    })
                },
                {
                    ai: "Part non-comestible",
                    eI: function(n) {
                        var r = n.mp;
                        return A2(WN, A([
                            r_(A([
                                v("text-end", !e)
                            ]))
                        ]), A([
                            wY(Mf(r)),
                            A2(kJ, A([
                                QN(xJ(2))
                            ]), A([
                                AY
                            ]))
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.mp;
                    }, Mf))
                },
                {
                    ai: "Rapport cru/cuit",
                    eI: function(n) {
                        var r = n.nZ;
                        return A2(WN, A([
                            r_(A([
                                v("text-end", !e)
                            ]))
                        ]), A([
                            c_(Js(r)),
                            A2(kJ, A([
                                QN(xJ(5))
                            ]), A([
                                AY
                            ]))
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.nZ;
                    }, W$))
                },
                {
                    ai: "Transport frigorifique",
                    eI: A2(Hu, function(n) {
                        return n.hz;
                    }, A2(Hu, SY, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.hz;
                    }, SY))
                },
                {
                    ai: "Proc\xe9d\xe9",
                    eI: function(n) {
                        var r = n.t;
                        return A2(WN, j, A([
                            A2(WN, A([
                                YN("cursor-help"),
                                W_(Hb(r))
                            ]), A([
                                c_(Gb(r)),
                                e ? A2(C_, j, A([
                                    c_(" ("),
                                    c_(Hb(r)),
                                    c_(")")
                                ])) : c_("")
                            ])),
                            A2(WN, A([
                                YN("cursor-help"),
                                W_(r.gh)
                            ]), A([
                                c_(r.gh)
                            ]))
                        ]));
                    },
                    eL: dV(A2(Hu, function(n) {
                        return n.t;
                    }, Gb))
                },
                {
                    ai: "Source",
                    eI: A2(Hu, function(n) {
                        return n.t;
                    }, A2(Hu, function(n) {
                        return n.he;
                    }, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.t;
                    }, function(n) {
                        return n.he;
                    }))
                },
                {
                    ai: "Services \xe9cosyst\xe9miques",
                    eI: function(n) {
                        var e = n.lL;
                        return A2(WN, A([
                            YN("overflow-scroll")
                        ]), A([
                            A2(WN, A([
                                YN("d-flex gap-2")
                            ]), A2(wu, function(n) {
                                var e = n.b;
                                return A2(m_, j, A([
                                    c_(n.a + ": "),
                                    A2(kV, {
                                        li: 2,
                                        aL: "Pts/kg"
                                    }, e)
                                ]));
                            }, A([
                                v(kY, e.ah),
                                v(yY, e.am),
                                v(xY, e.ag),
                                v(jY, e.al)
                            ])))
                        ]));
                    },
                    eL: dV(Wi(xV))
                }
            ]),
            l$: j,
            l2: "ingredients",
            mM: j,
            oZ: A2(Hu, function(n) {
                return n.mj;
            }, Ug),
            o$: A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, zr, A2(Hu, Sm, bd(r)))),
            o0: A2(Hu, OY, jC)
        };
    }, PY = A2(IV, ls, LY), qY = F4(function(n, e, r, t) {
        var u, a = n.l5;
        return A([
            A6(sJ, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, Ug, oV)), e, r, ls, LY, A2(LA, function(n) {
                return n.ek;
            }, a.mq)),
            t.$ ? c_("") : sV(1 === (u = A2(Mg, t.a, a.mq)).$ ? fV(u.a) : PY(u.a))
        ]);
    }), NY = function(n) {
        return n.S;
    }, _Y = A2(Hu, cw, A2(Hu, qa(ru), lh)), zY = function(n) {
        return lh(A([
            xA(n.Q),
            _Y(NY(n.Q)),
            xA(n.q),
            n.E.g,
            n._,
            lh(n.cs),
            n.af.eH.g,
            n.af.eJ.g,
            lh(n.bK)
        ]));
    }, UY = F3(function(n, e, r) {
        var t = n.h8, u = n.C, a = r.g5;
        return A2(Zg, 0, A2(fs, A2(Hu, zY, A2(Hu, ch(19), b$)), A2(Yx, {
            az: t,
            C: u,
            at: e
        }, a)));
    }), MY = function(n) {
        return A2(Hu, sY(n), fh(function() {
            return _h(10);
        }));
    }, DY = F3(function(n, e, r) {
        return A2(Zg, 0, A2(fs, function(n) {
            return A2(ch, 19, A2(MY, n.aT, zY(n)));
        }, A2(Yx, {
            az: n.h8,
            C: n.C,
            at: e
        }, r.g5)));
    }), RY = F3(function(n, e, r) {
        var t = n.gN, u = n.gM, a = r.lu, i = r.at;
        return {
            k$: A([
                {
                    ai: "Nom",
                    eI: A2(Hu, Xt, A2(Hu, function(n) {
                        return n.ek;
                    }, c_)),
                    eL: dV(A2(Hu, Xt, function(n) {
                        return n.ek;
                    }))
                },
                {
                    ai: "Famille",
                    eI: A2(Hu, Xt, A2(Hu, function(n) {
                        return n.at;
                    }, A2(Hu, qx, c_))),
                    eL: dV(A2(Hu, Xt, A2(Hu, function(n) {
                        return n.at;
                    }, qx)))
                },
                {
                    ai: "Cat\xe9gorie",
                    eI: function(n) {
                        var e = n.a.h0;
                        return "" === e ? A2(l_, A([
                            YN("text-muted")
                        ]), A([
                            c_("non-renseign\xe9")
                        ])) : c_(e);
                    },
                    eL: dV(A2(Hu, Xt, function(n) {
                        return n.h0;
                    }))
                },
                {
                    ai: "Co\xfbt Environnemental",
                    eI: function(n) {
                        return A3(pY, a, t, n.b.bn);
                    },
                    eL: lV(A2(Hu, Gh, function(n) {
                        return n.bn;
                    }))
                },
                {
                    ai: "Co\xfbt Environnemental/100g",
                    eI: function(n) {
                        return A3(pY, a, u, n.b.bi);
                    },
                    eL: lV(A2(Hu, Gh, function(n) {
                        return n.bi;
                    }))
                },
                {
                    ai: "",
                    eI: function(n) {
                        var r = n.a;
                        return A2(VN, A([
                            YN("btn btn-light btn-sm w-100"),
                            ZN(A2(Nb, e, r.mj)),
                            W_("Charger " + r.ek)
                        ]), A([
                            vY
                        ]));
                    },
                    eL: mY
                }
            ]),
            l$: j,
            l2: vs(i) + "-examples",
            mM: j,
            oZ: A2(Hu, Xt, A2(Hu, function(n) {
                return n.mj;
            }, df)),
            o$: A2(Hu, Xt, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, zr, A2(Hu, jd(e), bd(i))))),
            o0: A2(Hu, Xt, A2(Hu, gY, jC))
        };
    }), FY = F5(function(n, e, r, t, u) {
        var a = ds(t), i = A2(LA, A2(Hu, Xt, function(n) {
            return n.ek;
        }), A2(wu, function(e) {
            return v(e, {
                bi: A3(DY, n, a, e),
                bn: A3(UY, n, a, e)
            });
        }, A2(Ah, function(n) {
            return s(n.at, a);
        }, n.C.l9.lT))), c = {
            gM: A2(Nc, 0, gC(A2(wu, A2(Hu, Gh, function(n) {
                return n.bi;
            }), i))),
            gN: A2(Nc, 0, gC(A2(wu, A2(Hu, Gh, function(n) {
                return n.bn;
            }), i)))
        };
        return A([
            A6(sJ, A2(Hu, Xt, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, df, oV))), e, r, a, A2(RY, c, t), A2(LA, A2(Hu, Xt, function(n) {
                return n.ek;
            }), A2(Ah, A2(Hu, Xt, A2(Hu, function(n) {
                return n.g5;
            }, Ic(Bx))), i))),
            function() {
                if (u.$) return c_("");
                var e = u.a;
                return sV(function() {
                    var r = A2(Qx, e, n.C.l9.lT);
                    if (1 === r.$) return fV(r.a);
                    var u = r.a;
                    return A3(IV, a, A2(RY, c, t), v(u, {
                        bi: A3(DY, n, a, u),
                        bn: A3(UY, n, a, u)
                    }));
                }());
            }()
        ]);
    }), HY = function(n) {
        return A2(at, " ", A([
            Pl(n.kj),
            n.io,
            n.ai,
            n.aL
        ]));
    }, GY = function(n) {
        var e = n.lu, r = n.at;
        return {
            k$: A([
                {
                    ai: "Code",
                    eI: function(n) {
                        return A2(A_, j, A([
                            c_(Pl(n.kj))
                        ]));
                    },
                    eL: dV(A2(Hu, function(n) {
                        return n.kj;
                    }, Pl))
                },
                {
                    ai: "Nom",
                    eI: function(n) {
                        return A2(m_, A([
                            W_(n.ai)
                        ]), A([
                            c_(n.ai)
                        ]));
                    },
                    eL: dV(function(n) {
                        return n.ai;
                    })
                },
                {
                    ai: "Unit\xe9",
                    eI: function(n) {
                        return A2(A_, j, A([
                            c_(n.aL)
                        ]));
                    },
                    eL: dV(function(n) {
                        return n.aL;
                    })
                },
                {
                    ai: "Normalisation (Co\xfbt Evt)",
                    eI: function(n) {
                        return A2(Nc, c_(xV), A2(Pc, A2(Hu, function(n) {
                            return n.jd;
                        }, A2(Hu, b$, A2(bV, 2, n.aL))), n.it));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.it;
                    }, A2(Hu, Pc(A2(Hu, function(n) {
                        return n.jd;
                    }, b$)), Nc(0))))
                },
                {
                    ai: "Pond\xe9ration (Co\xfbt Evt)",
                    eI: A2(Hu, function(n) {
                        return n.it;
                    }, A2(Hu, Pc(A2(Hu, function(n) {
                        return n.kp;
                    }, jJ(2))), Nc(c_(xV)))),
                    eL: lV(A2(Hu, function(n) {
                        return n.it;
                    }, A2(Hu, Pc(A2(Hu, function(n) {
                        return n.kp;
                    }, Ko)), Nc(0))))
                },
                {
                    ai: "Description",
                    eI: function(n) {
                        return e ? A2(hH, j, n.io) : A2(m_, A([
                            W_(n.io)
                        ]), A([
                            c_(A3(Yb, "*", "", n.io))
                        ]));
                    },
                    eL: dV(function(n) {
                        return n.io;
                    })
                }
            ]),
            l$: A([
                A2(dJ, "Unit\xe9", A2(Hu, function(n) {
                    return n.aL;
                }, ck))
            ]),
            l2: "impacts",
            mM: j,
            oZ: A2(Hu, function(n) {
                return n.kj;
            }, Pl),
            o$: A2(Hu, function(n) {
                return n.kj;
            }, A2(Hu, zr, A2(Hu, Om, bd(r)))),
            o0: A2(Hu, HY, jC)
        };
    }, XY = function(n) {
        return A2(wu, function(e) {
            return A2(eh, e, n);
        }, PJ);
    }, VY = F5(function(n, e, r, t, u) {
        return A([
            A6(sJ, A2(Hu, function(n) {
                return n.kj;
            }, A2(Hu, Pl, oV)), e, r, t, GY, A2(LA, A2(Hu, function(n) {
                return n.kj;
            }, Pl), XY(n))),
            A2(Nc, c_(""), A2(Pc, sV, A2(Pc, A2(IV, t, GY), A2(Pc, function(e) {
                return A2(eh, e, n);
            }, u))))
        ]);
    }), JY = F2(function(n, e) {
        return n || 1 > m(iu(e), 80) ? c_(e) : c_(A2(lu, 80, e) + "\u2026");
    }), YY = A2(Hu, vh, A2(bV, 2, "kWh")), WY = function(n) {
        var e = n.mZ;
        if (e.$) return c_("N/A");
        var r = e.a;
        return 2 !== n.aL ? A3(bV, 2, "kg/" + Th(n.aL), r) : c_("N/A");
    }, KY = A2(Hu, gh, A2(bV, 2, "MJ")), BY = function(n) {
        return c_(Js(n));
    }, QY = F2(function(n, e) {
        var r = n.C, t = A2(js, gw(e), r.bT);
        return 1 === t.$ ? e : t.a.ek + " (" + e + ")";
    }), ZY = function(n) {
        return A2(m_, A([
            YN("cursor-help"),
            W_(n)
        ]), A([
            c_(n)
        ]));
    }, nW = F2(function(n, e) {
        return A([
            {
                ai: "Identifiant",
                eI: function(n) {
                    return A2(A_, j, A([
                        c_(qs(n.mj))
                    ]));
                },
                eL: dV(A2(Hu, function(n) {
                    return n.mj;
                }, qs))
            },
            {
                ai: "Nom",
                eI: function(n) {
                    return A2(WN, A([
                        YN("d-flex flex-column"),
                        W_(Gb(n))
                    ]), A2(qa, ru, A([
                        zr(c_(Gb(n))),
                        A2(Pc, function(n) {
                            return A2(A_, A([
                                YN("fs-9")
                            ]), A([
                                c_(n)
                            ]));
                        }, n.hM)
                    ])));
                },
                eL: dV(Gb)
            },
            {
                ai: "Nom technique",
                eI: A2(Hu, Hb, ZY),
                eL: dV(Hb)
            },
            {
                ai: "Source",
                eI: A2(Hu, function(n) {
                    return n.he;
                }, c_),
                eL: dV(function(n) {
                    return n.he;
                })
            },
            {
                ai: "R\xe9gion",
                eI: A2(Hu, function(n) {
                    return n.i3;
                }, A2(Hu, Pc(QY(n)), A2(Hu, Nc(xV), c_))),
                eL: dV(A2(Hu, function(n) {
                    return n.i3;
                }, Nc(xV)))
            },
            {
                ai: "Cat\xe9gories",
                eI: A2(Hu, function(n) {
                    return n.cP;
                }, A2(Hu, wu(wC), A2(Hu, at(", "), ZY))),
                eL: dV(A2(Hu, function(n) {
                    return n.cP;
                }, A2(Hu, wu(wC), at(", "))))
            },
            {
                ai: "Unit\xe9",
                eI: A2(Hu, function(n) {
                    return n.aL;
                }, A2(Hu, Th, c_)),
                eL: dV(A2(Hu, function(n) {
                    return n.aL;
                }, Th))
            },
            {
                ai: "\xc9lectricit\xe9",
                eI: A2(Hu, function(n) {
                    return n.d2;
                }, YY),
                eL: lV(A2(Hu, function(n) {
                    return n.d2;
                }, vh))
            },
            {
                ai: "Chaleur",
                eI: A2(Hu, function(n) {
                    return n.eb;
                }, KY),
                eL: lV(A2(Hu, function(n) {
                    return n.eb;
                }, gh))
            },
            {
                ai: "Ratio de variation de quantit\xe9",
                eI: A2(Hu, function(n) {
                    return n.g4;
                }, BY),
                eL: lV(A2(Hu, function(n) {
                    return n.g4;
                }, mh))
            },
            {
                ai: "Masse par unit\xe9",
                eI: WY,
                eL: dV(A2(Hu, function(n) {
                    return n.mZ;
                }, A2(Hu, Pc(Js), Nc(xV))))
            },
            {
                ai: "Commentaire",
                eI: A2(Hu, function(n) {
                    return n.gh;
                }, JY(e)),
                eL: dV(function(n) {
                    return n.gh;
                })
            }
        ]);
    }), eW = {
        ag: "Diversit\xe9 culturale",
        aa: "For\xeat",
        ah: "Haies",
        aj: "Microfibres",
        ak: "Export hors-Europe",
        al: "Prairies permanentes",
        am: "Taille de parcelles"
    }, rW = function(n) {
        var e = n.C, r = function(n) {
            return A2(Hu, function(n) {
                return n.m0;
            }, A2(Hu, Ba(function(n) {
                return n.k1;
            }), A2(Hu, Ba(n), Pc(b$))));
        };
        return A3(st, F2(function(n, t) {
            return {
                ai: t,
                eI: A2(Hu, r(n), A2(Hu, Pc(kV(A2(eh, 19, e.c_))), Nc(c_(xV)))),
                eL: lV(A2(Hu, r(n), Nc(0)))
            };
        }), iw, cw(eW));
    }, tW = function(n) {
        var e = n.li, r = n.aL;
        return A2(Hu, ch(n.kj), A2(Hu, b$, A2(bV, e, r)));
    }, uW = F2(function(n, e) {
        return {
            ai: Pl(e),
            eI: A2(Hu, function(n) {
                return n.g;
            }, tW(A2(eh, e, n))),
            eL: lV(A2(Hu, function(n) {
                return n.g;
            }, A2(Hu, ch(e), b$)))
        };
    }), aW = function(n) {
        var e = n.C;
        return zl(n) ? A2(wu, uW(e.c_), PJ) : ck(A2(uW, e.c_, 19));
    }, iW = F2(function(n, e) {
        var r = e.at;
        return {
            k$: k(A2(nW, n, e.lu), k(aW(n), rW(n))),
            l$: A([
                A2(dJ, "Cat\xe9gories", A2(Hu, function(n) {
                    return n.cP;
                }, wu(wC))),
                A2(dJ, "Unit\xe9s", A2(Hu, function(n) {
                    return n.aL;
                }, A2(Hu, Th, ck))),
                A2(dJ, "R\xe9gion", A2(Hu, function(n) {
                    return n.i3;
                }, A2(Hu, Pc(QY(n)), A2(Hu, Nc(xV), ck))))
            ]),
            l2: "processes",
            mM: j,
            oZ: A2(Hu, function(n) {
                return n.mj;
            }, qs),
            o$: A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, zr, A2(Hu, Lm(r), bd(r)))),
            o0: function(n) {
                return n.jU;
            }
        };
    }), cW = F5(function(n, e, r, t, u) {
        var a = A2(Rh, A([
            e
        ]), n.C.W);
        return A([
            A6(sJ, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, qs, oV)), r, t, e, iW(n), A2(LA, Gb, a)),
            function() {
                if (u.$) return c_("");
                var r = u.a;
                return sV(function() {
                    var t = A2(Ns, r, a);
                    if (1 === t.$) return fV(t.a);
                    var u = t.a;
                    return A3(IV, e, iW(n), u);
                }());
            }()
        ]);
    }), oW = function(n) {
        return Ah(A2(Hu, function(n) {
            return n.at;
        }, zt(n)));
    }, fW = F2(function(n, e) {
        var r = A2(fs, Gb, A2(Ns, e, n));
        return 1 === r.$ ? "Erreur\xa0: " + r.a : r.a;
    }), sW = F2(function(n, e) {
        return sf(e.q) ? j : A2(wu, fW(n), e.q);
    }), lW = F2(function(n, e) {
        return sf(e.q) ? xV : A2(at, ", ", A2(wu, fW(n), e.q));
    }), dW = F2(function(n, e) {
        return sf(e.aM) ? j : A2(wu, A2(Hu, function(n) {
            return n.bl;
        }, fW(n)), e.aM);
    }), bW = F2(function(n, e) {
        return sf(e.aM) ? xV : A2(at, ", ", A2(wu, A2(Hu, function(n) {
            return n.bl;
        }, fW(n)), e.aM));
    }), mW = F2(function(n, e) {
        var r = e.E;
        return r.$ ? xV : A2(fW, n, r.a);
    }), pW = function(n) {
        return A2(at, " ", A([
            Lh(n.mj),
            n.ai,
            Co(n.at)
        ]));
    }, vW = function(n) {
        return n ? "Oui" : "Non";
    }, gW = F3(function(n, e) {
        var r = n.C;
        return {
            k$: A([
                {
                    ai: "Identifiant",
                    eI: function(n) {
                        return A2(A_, j, A([
                            c_(Lh(n.mj))
                        ]));
                    },
                    eL: dV(A2(Hu, function(n) {
                        return n.mj;
                    }, Lh))
                },
                {
                    ai: "Cat\xe9gorie de produit",
                    eI: A2(Hu, function(n) {
                        return n.ai;
                    }, c_),
                    eL: dV(function(n) {
                        return n.ai;
                    })
                },
                {
                    ai: "Assemblage",
                    eI: A2(Hu, lW(r.W), c_),
                    eL: dV(lW(r.W))
                },
                {
                    ai: "Transport r\xe9frig\xe9r\xe9",
                    eI: A2(Hu, function(n) {
                        return n.aN;
                    }, A2(Hu, vW, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.aN;
                    }, vW))
                },
                {
                    ai: "Distribution",
                    eI: A2(Hu, mW(r.W), c_),
                    eL: dV(mW(r.W))
                },
                {
                    ai: "Consommations",
                    eI: A2(Hu, bW(r.W), c_),
                    eL: dV(bW(r.W))
                }
            ]),
            l$: A([
                {
                    fn: "Assemblage",
                    fU: sW(r.W)
                },
                {
                    fn: "Transport r\xe9frig\xe9r\xe9",
                    fU: function(n) {
                        return A([
                            vW(n.aN)
                        ]);
                    }
                },
                {
                    fn: "Distribution",
                    fU: A2(Hu, mW(r.W), ck)
                },
                {
                    fn: "Consommations",
                    fU: dW(r.W)
                }
            ]),
            l2: Co(e) + "-product-categories",
            mM: j,
            oZ: A2(Hu, function(n) {
                return n.mj;
            }, Lh),
            o$: function(n) {
                var r = n.mj;
                return A2(bd, ds(e), A2(Pm, e, zr(r)));
            },
            o0: A2(Hu, pW, jC)
        };
    }), hW = F5(function(n, e, r, t, u) {
        var a = ds(e);
        return A([
            A6(sJ, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, Lh, oV)), r, t, a, A2(gW, n, e), A2(oW, e, n.C.dp)),
            function() {
                if (u.$) return c_("");
                var r = u.a;
                return sV(function() {
                    var t = A2(Ph, r, n.C.dp);
                    if (1 === t.$) return fV(t.a);
                    var u = t.a;
                    return A3(IV, a, A2(gW, n, e), u);
                }());
            }()
        ]);
    }), $W = F2(function(n, e) {
        var r = n.h8, t = n.C, u = e.g5;
        return A2(Zg, 0, A2(fs, A2(Hu, function(n) {
            return n.g;
        }, A2(Hu, ch(19), b$)), A3(QA, t, r, u)));
    }), xW = F2(function(n, e) {
        var r = n.h8, t = n.C, u = e.g5;
        return A2(Zg, 0, A2(fs, A2(Hu, function(n) {
            return n.g;
        }, A2(Hu, MY(u.P), A2(Hu, ch(19), b$))), A3(QA, t, r, u)));
    }), kW = F3(function(n, e, r) {
        var t = n.C, u = e.gN, a = e.gM, i = r.lu, c = r.at;
        return {
            k$: A([
                {
                    ai: "Nom",
                    eI: A2(Hu, Xt, A2(Hu, function(n) {
                        return n.ek;
                    }, c_)),
                    eL: dV(A2(Hu, Xt, function(n) {
                        return n.ek;
                    }))
                },
                {
                    ai: "Cat\xe9gorie",
                    eI: A2(Hu, Xt, A2(Hu, function(n) {
                        return n.h0;
                    }, c_)),
                    eL: dV(A2(Hu, Xt, function(n) {
                        return n.h0;
                    }))
                },
                {
                    ai: "Accessoires",
                    eI: function(n) {
                        var e = n.a, r = e.g5.pf;
                        if (r.$) {
                            var u = A2(as, A2(Hu, function(n) {
                                return n.pf;
                            }, Xj(t)), A2(IA, e.g5.aS, t.oX.dp));
                            if (1 === u.$) {
                                var a = u.a;
                                return A2(WN, A([
                                    YN("text-danger")
                                ]), A([
                                    c_("Erreur : " + a)
                                ]));
                            }
                            return c_(u.a);
                        }
                        var i = r.a;
                        return A2(Zg, c_("Aucun"), A2(fs, A2(Hu, at(", "), function(n) {
                            return su(n) ? c_("Aucun") : A2(m_, A([
                                YN("cursor-help"),
                                W_(n)
                            ]), A([
                                c_(n)
                            ]));
                        }), Vg(A2(wu, Gj(t), i))));
                    },
                    eL: mY
                },
                {
                    ai: "Co\xfbt Environnemental",
                    eI: function(n) {
                        return A3(pY, i, u, n.b.bn);
                    },
                    eL: lV(A2(Hu, Gh, function(n) {
                        return n.bn;
                    }))
                },
                {
                    ai: "Co\xfbt Environnemental/100g",
                    eI: function(n) {
                        return A3(pY, i, a, n.b.bi);
                    },
                    eL: lV(A2(Hu, Gh, function(n) {
                        return n.bi;
                    }))
                },
                {
                    ai: "",
                    eI: function(n) {
                        var e = n.a.mj, r = n.a.ek;
                        return A2(VN, A([
                            YN("btn btn-light btn-sm w-100"),
                            ZN($d(e)),
                            W_("Charger " + r)
                        ]), A([
                            vY
                        ]));
                    },
                    eL: mY
                }
            ]),
            l$: A([
                A2(dJ, "Cat\xe9gorie", A2(Hu, Xt, A2(Hu, function(n) {
                    return n.h0;
                }, ck)))
            ]),
            l2: "examples",
            mM: j,
            oZ: A2(Hu, Xt, A2(Hu, function(n) {
                return n.mj;
            }, df)),
            o$: A2(Hu, Xt, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, zr, A2(Hu, yd, bd(c))))),
            o0: A2(Hu, Xt, A2(Hu, gY, jC))
        };
    }), jW = F4(function(n, e, r, t) {
        var u = A2(LA, A2(Hu, Xt, function(n) {
            return n.ek;
        }), A2(wu, function(e) {
            return v(e, {
                bi: A2(xW, n, e),
                bn: A2($W, n, e)
            });
        }, n.C.oX.lT)), a = {
            gM: A2(Nc, 0, gC(A2(wu, A2(Hu, Gh, function(n) {
                return n.bi;
            }), u))),
            gN: A2(Nc, 0, gC(A2(wu, A2(Hu, Gh, function(n) {
                return n.bn;
            }), u)))
        };
        return A([
            A6(sJ, A2(Hu, Xt, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, df, oV))), e, r, bs, A2(kW, n, a), A2(LA, A2(Hu, Xt, function(n) {
                return n.ek;
            }), u)),
            function() {
                if (t.$) return c_("");
                var e = t.a;
                return sV(function() {
                    var r = A2(Qx, e, n.C.oX.lT);
                    if (1 === r.$) return fV(r.a);
                    var t = r.a;
                    return A3(IV, bs, A2(kW, n, a), v(t, {
                        bi: A2(xW, n, t),
                        bn: A2($W, n, t)
                    }));
                }());
            }()
        ]);
    }), yW = F2(function(n, e) {
        return A2(Ba, function(e) {
            return A2(Pc, function(n) {
                return n.t;
            }, Ld(A2(qw, e, n)));
        }, e.g7);
    }), wW = function(n) {
        return 1 !== n.$;
    }, AW = A2(Hu, wW, vW), TW = F2(function(n, e) {
        return c_(A2(Rj, n, e));
    }), EW = function(n) {
        return 3 === n ? "Filage" : "Filature";
    }, CW = function(n) {
        switch(n){
            case 0:
                return "Mati\xe8re artificielle d'origine organique";
            case 1:
                return "Mati\xe8re naturelle d'origine animale";
            case 2:
                return "Mati\xe8re naturelle d'origine v\xe9g\xe9tale";
            default:
                return "Mati\xe8re synth\xe9tique";
        }
    }, IW = function(n) {
        switch(n){
            case 0:
                return "ArtificialFromOrganic";
            case 1:
                return "NaturalFromAnimal";
            case 2:
                return "NaturalFromVegetal";
            default:
                return "Synthetic";
        }
    }, SW = F2(function(n, e) {
        return A2(at, " ", A([
            Pw(e.mj),
            e.ek,
            e.hM,
            IW(e.jh),
            Gb(e.t),
            e.t.he,
            e.ig,
            A2(Zg, "", A2(fs, function(n) {
                return n.ek;
            }, A2(js, e.ig, n)))
        ]));
    }), OW = F2(function(n, e) {
        var r = e.lu, t = e.at, u = F2(function(n, e) {
            return A2(WN, A([
                r_(A([
                    v("text-center", !r)
                ]))
            ]), A([
                e,
                A2(kJ, A([
                    QN(xJ(n))
                ]), A([
                    AY
                ]))
            ]));
        });
        return {
            k$: A([
                {
                    ai: "Identifiant",
                    eI: function(n) {
                        return A2(A_, j, A([
                            c_(Pw(n.mj))
                        ]));
                    },
                    eL: dV(A2(Hu, function(n) {
                        return n.mj;
                    }, Pw))
                },
                {
                    ai: "Nom",
                    eI: A2(Hu, function(n) {
                        return n.ek;
                    }, c_),
                    eL: dV(function(n) {
                        return n.ek;
                    })
                },
                {
                    ai: "Proc\xe9d\xe9",
                    eI: A2(Hu, function(n) {
                        return n.t;
                    }, A2(Hu, Gb, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.t;
                    }, Gb))
                },
                {
                    ai: "Source",
                    eI: A2(Hu, function(n) {
                        return n.t;
                    }, A2(Hu, function(n) {
                        return n.he;
                    }, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.t;
                    }, function(n) {
                        return n.he;
                    }))
                },
                {
                    ai: "Origine",
                    eI: A2(Hu, function(n) {
                        return n.jh;
                    }, A2(Hu, CW, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.jh;
                    }, CW))
                },
                {
                    ai: "Recycl\xe9e ?",
                    eI: A2(Hu, function(n) {
                        return n.g7;
                    }, A2(Hu, AW, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.g7;
                    }, AW))
                },
                {
                    ai: "Compl\xe9ment Microfibres",
                    eI: A2(Hu, function(n) {
                        return n.jh;
                    }, A2(Hu, GA, A2(Hu, b$, A2(Hu, kV({
                        li: 2,
                        aL: "\u202FPts/kg"
                    }), u(10))))),
                    eL: lV(A2(Hu, function(n) {
                        return n.jh;
                    }, A2(Hu, GA, b$)))
                },
                {
                    ai: "Proc\xe9d\xe9 de fabrication du fil",
                    eI: A2(Hu, function(n) {
                        return n.jh;
                    }, A2(Hu, EW, A2(Hu, c_, u(28)))),
                    eL: dV(A2(Hu, function(n) {
                        return n.jh;
                    }, EW))
                },
                {
                    ai: "Proc\xe9d\xe9 de recyclage",
                    eI: A2(Hu, yW(n.oX.ft), A2(Hu, Pc(A2(Hu, Gb, c_)), Nc(c_(xV)))),
                    eL: dV(A2(Hu, yW(n.oX.ft), A2(Hu, Pc(Gb), Nc(xV))))
                },
                {
                    ai: "Origine g\xe9ographique",
                    eI: A2(Hu, function(n) {
                        return n.ma;
                    }, c_),
                    eL: dV(function(n) {
                        return n.ma;
                    })
                },
                {
                    ai: "Pays de production et de filature par d\xe9faut",
                    eI: function(e) {
                        var r = A2(js, e.ig, n.bT);
                        return 1 === r.$ ? f_({
                            hS: j,
                            h4: Ur,
                            h9: A([
                                c_(r.a)
                            ]),
                            ed: 0,
                            eG: Ur
                        }) : c_(r.a.ek);
                    },
                    eL: dV(A2(Hu, function(n) {
                        return n.ig;
                    }, A2(Hu, function(e) {
                        return A2(js, e, n.bT);
                    }, A2(Hu, fs(function(n) {
                        return n.ek;
                    }), A2(Hu, Ld, Nc("error"))))))
                },
                {
                    ai: "CFF: Coefficient d'allocation",
                    eI: A2(Hu, function(n) {
                        return n.kT;
                    }, A2(Hu, Pc(A2(Hu, function(n) {
                        return n.mW;
                    }, A2(Hu, TW(1), u(9)))), Nc(c_(xV)))),
                    eL: lV(A2(Hu, function(n) {
                        return n.kT;
                    }, A2(Hu, Pc(A2(Hu, function(n) {
                        return n.mW;
                    }, Ko)), Nc(0))))
                },
                {
                    ai: "CFF: Rapport de qualit\xe9",
                    eI: A2(Hu, function(n) {
                        return n.kT;
                    }, A2(Hu, Pc(A2(Hu, function(n) {
                        return n.n1;
                    }, A2(Hu, TW(1), u(9)))), Nc(c_(xV)))),
                    eL: lV(A2(Hu, function(n) {
                        return n.kT;
                    }, A2(Hu, Pc(A2(Hu, function(n) {
                        return n.n1;
                    }, Ko)), Nc(0))))
                }
            ]),
            l$: A([
                A2(dJ, "Origine de la mati\xe8re", A2(Hu, function(n) {
                    return n.jh;
                }, A2(Hu, CW, ck))),
                A2(dJ, "Origine g\xe9ographique", A2(Hu, function(n) {
                    return n.ma;
                }, ck)),
                A2(dJ, "Recyclage", A2(Hu, function(n) {
                    return n.g7;
                }, A2(Hu, AW, ck))),
                A2(dJ, "Pays de production et de filature par d\xe9faut", A2(Hu, function(n) {
                    return n.ig;
                }, A2(Hu, function(e) {
                    return A2(js, e, n.bT);
                }, A2(Hu, fs(function(n) {
                    return n.ek + " (" + n.cR + ")";
                }), A2(Hu, Zg(xV), ck)))))
            ]),
            l2: "materials",
            mM: j,
            oZ: A2(Hu, function(n) {
                return n.mj;
            }, Pw),
            o$: A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, zr, A2(Hu, qm, bd(t)))),
            o0: A2(Hu, SW(n.bT), jC)
        };
    }), LW = function(n) {
        return A2(IV, bs, OW(n));
    }, PW = F4(function(n, e, r, t) {
        var u;
        return A([
            A6(sJ, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, Pw, oV)), e, r, bs, OW(n), n.oX.ft),
            t.$ ? c_("") : sV(1 === (u = A2(qw, t.a, n.oX.ft)).$ ? fV(u.a) : A2(LW, n, u.a))
        ]);
    }), qW = function(n) {
        return {
            $: 1,
            a: n
        };
    }, NW = function(n) {
        switch(n){
            case 0:
                return "Grande entreprise avec service de r\xe9paration";
            case 1:
                return "Grande entreprise sans service de r\xe9paration";
            default:
                return "PME/TPE";
        }
    }, _W = A2(Hu, EA, A2(bV, 0, "j")), zW = A2(Hu, function(n) {
        return n.gL;
    }, A2(Hu, function(n) {
        return n.gi;
    }, jw)), UW = function(n) {
        return n / 3600;
    }, MW = A2(Hu, UW, A2(bV, 2, "h")), DW = A2(Hu, xw, A2(bV, 0, "min")), RW = A2(Hu, xf, A2(bV, 2, "\u20AC")), FW = A2(Hu, wf, A2(Hu, St, A2(bV, 0, "g/m\xb2"))), HW = function(n) {
        return A3(bV, 0, "#/cm", n);
    }, GW = function(n) {
        return A2(at, " ", A([
            n.mj,
            n.ek,
            oT(n.iz),
            Yo(n.iz)
        ]));
    }, XW = function(n) {
        return A2(m_, A([
            W_(n)
        ]), A([
            c_(n)
        ]));
    }, VW = A2(Hu, Cf, A2(bV, 0, "Nm")), JW = F2(function(n, e) {
        var r, t = n.C, u = e.lu, a = e.at;
        return {
            k$: A([
                {
                    ai: "Identifiant",
                    eI: function(n) {
                        return A2(A_, j, A([
                            c_(n.mj)
                        ]));
                    },
                    eL: dV(A2(Hu, function(n) {
                        return n.mj;
                    }, Sf))
                },
                {
                    ai: "Produit(s) concern\xe9(s)",
                    eI: A2(Hu, function(n) {
                        return n.ek;
                    }, c_),
                    eL: dV(function(n) {
                        return n.ek;
                    })
                },
                {
                    ai: "Accessoires par d\xe9faut",
                    eI: function(n) {
                        var e = n.pf;
                        if (sf(e)) return c_("Aucun");
                        var r = A2(Xj, t, e);
                        if (1 === r.$) {
                            var u = r.a;
                            return A2(m_, A([
                                YN("text-danger")
                            ]), A([
                                c_("Erreur: " + u)
                            ]));
                        }
                        return c_(r.a);
                    },
                    eL: mY
                },
                {
                    ai: "Titrage*",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            VW(n.pV)
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.pV;
                    }, Cf))
                },
                {
                    ai: "Grammage*",
                    eI: function(n) {
                        var e = n.hj;
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            FW(e)
                        ]));
                    },
                    eL: qW(A2(Hu, function(n) {
                        return n.hj;
                    }, wf))
                },
                (r = function(n) {
                    return A2(Fy, n.hj, n.pV);
                }, {
                    ai: "Densit\xe9 de fils**",
                    eI: A2(Hu, r, HW),
                    eL: lV(A2(Hu, r, My))
                }),
                {
                    ai: "Volume*",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            mV(n._.eY)
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n._;
                    }, A2(Hu, function(n) {
                        return n.eY;
                    }, Bh)))
                },
                {
                    ai: "\xc9toffe*",
                    eI: A2(Hu, function(n) {
                        return n.iz;
                    }, A2(Hu, oT, c_)),
                    eL: dV(A2(Hu, function(n) {
                        return n.iz;
                    }, oT))
                },
                {
                    ai: "Stocks dormants",
                    eI: Wi(A2(WN, A([
                        r_(A([
                            v("text-center", !u)
                        ]))
                    ]), A([
                        A2(jJ, 0, Aw)
                    ]))),
                    eL: lV(Wi(Mf(Aw)))
                },
                {
                    ai: "Confection (complexit\xe9)*",
                    eI: A2(Hu, function(n) {
                        return n.gL;
                    }, A2(Hu, function(n) {
                        return n.gi;
                    }, A2(Hu, uT, c_))),
                    eL: dV(A2(Hu, function(n) {
                        return n.gL;
                    }, A2(Hu, function(n) {
                        return n.gi;
                    }, uT)))
                },
                {
                    ai: "Confection (# minutes)*",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            DW(zW(n))
                        ]));
                    },
                    eL: lV(A2(Hu, zW, xw))
                },
                {
                    ai: "Confection (taux de perte)*",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            A2(jJ, 2, n.gL.jk)
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.gL;
                    }, A2(Hu, function(n) {
                        return n.jk;
                    }, Mf)))
                },
                {
                    ai: "Nombre de jours port\xe9*",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            _W(n.bK.go)
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.bK;
                    }, A2(Hu, function(n) {
                        return n.go;
                    }, EA)))
                },
                {
                    ai: "Utilisations avant lavage*",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            c_(ut(n.bK.hE))
                        ]));
                    },
                    eL: qW(A2(Hu, function(n) {
                        return n.bK;
                    }, function(n) {
                        return n.hE;
                    }))
                },
                {
                    ai: "Cycles d'entretien (par d\xe9faut)**",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            c_(ut(n.bK.il))
                        ]));
                    },
                    eL: qW(A2(Hu, function(n) {
                        return n.bK;
                    }, function(n) {
                        return n.il;
                    }))
                },
                {
                    ai: "Repassage*",
                    eI: A2(Hu, function(n) {
                        return n.bK;
                    }, A2(Hu, function(n) {
                        return n.mw;
                    }, YY)),
                    eL: lV(A2(Hu, function(n) {
                        return n.bK;
                    }, A2(Hu, function(n) {
                        return n.mw;
                    }, vh)))
                },
                {
                    ai: "Proc\xe9d\xe9 d'utilisation hors-repassage**",
                    eI: A2(Hu, function(n) {
                        return n.bK;
                    }, A2(Hu, function(n) {
                        return n.nk;
                    }, A2(Hu, Gb, XW))),
                    eL: dV(A2(Hu, function(n) {
                        return n.bK;
                    }, A2(Hu, function(n) {
                        return n.nk;
                    }, Gb)))
                },
                {
                    ai: "S\xe9chage \xe9lectrique*",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            A2(jJ, 0, n.bK.jz)
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.bK;
                    }, A2(Hu, function(n) {
                        return n.jz;
                    }, Mf)))
                },
                {
                    ai: "Repassage (part)*",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            A2(jJ, 0, n.bK.jA)
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.bK;
                    }, A2(Hu, function(n) {
                        return n.jA;
                    }, Mf)))
                },
                {
                    ai: "Repassage (temps)*",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            MW(n.bK.kd)
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.bK;
                    }, A2(Hu, function(n) {
                        return n.kd;
                    }, UW)))
                },
                {
                    ai: "Prix par d\xe9faut",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            RW(n.lK.jr)
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.lK;
                    }, A2(Hu, function(n) {
                        return n.jr;
                    }, xf)))
                },
                {
                    ai: "Co\xfbt de r\xe9paration par d\xe9faut*",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            RW(n.lK.jF)
                        ]));
                    },
                    eL: lV(A2(Hu, function(n) {
                        return n.lK;
                    }, A2(Hu, function(n) {
                        return n.jF;
                    }, xf)))
                },
                {
                    ai: "Type d'entreprise",
                    eI: A2(Hu, function(n) {
                        return n.lK;
                    }, A2(Hu, function(n) {
                        return n.h_;
                    }, A2(Hu, NW, c_))),
                    eL: dV(A2(Hu, function(n) {
                        return n.lK;
                    }, A2(Hu, function(n) {
                        return n.h_;
                    }, NW)))
                },
                {
                    ai: "Nombre de r\xe9f\xe9rences",
                    eI: function(n) {
                        return A2(WN, A([
                            r_(A([
                                v("text-center", !u)
                            ]))
                        ]), A([
                            c_(ut(n.lK.je)),
                            c_(" r\xe9f\xe9rences")
                        ]));
                    },
                    eL: qW(A2(Hu, function(n) {
                        return n.lK;
                    }, function(n) {
                        return n.je;
                    }))
                }
            ]),
            l$: A([
                A2(dJ, "Confection (complexit\xe9)", A2(Hu, function(n) {
                    return n.gL;
                }, A2(Hu, function(n) {
                    return n.gi;
                }, A2(Hu, uT, ck)))),
                A2(dJ, "\xc9toffe", A2(Hu, function(n) {
                    return n.iz;
                }, A2(Hu, oT, ck))),
                A2(dJ, "Jours de port\xe9e", A2(Hu, function(n) {
                    return n.bK;
                }, A2(Hu, function(n) {
                    return n.go;
                }, A2(Hu, EA, A2(Hu, Js, ck)))))
            ]),
            l2: "products",
            mM: A([
                A2(B_, A([
                    YN("list-unstyled text-muted p-2 m-0")
                ]), A([
                    A2(__, j, A([
                        A2(H_, j, A([
                            c_("*")
                        ])),
                        c_(" Modifi\xe9 au changement de cat\xe9gorie de produit")
                    ])),
                    A2(__, j, A([
                        A2(H_, j, A([
                            c_("**")
                        ])),
                        c_(" Modifi\xe9 au changement de cat\xe9gorie, car d\xe9pendant d\u2019autres param\xe8tres")
                    ]))
                ]))
            ]),
            oZ: A2(Hu, function(n) {
                return n.mj;
            }, Sf),
            o$: A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, zr, A2(Hu, Nm, bd(a)))),
            o0: A2(Hu, GW, jC)
        };
    }), YW = F4(function(n, e, r, t) {
        return A([
            A6(sJ, A2(Hu, function(n) {
                return n.mj;
            }, A2(Hu, Sf, oV)), e, r, bs, JW(n), n.C.oX.dp),
            function() {
                if (t.$) return c_("");
                var e = t.a;
                return sV(function() {
                    var r = A2(IA, e, n.C.oX.dp);
                    if (1 === r.$) return fV(r.a);
                    var t = r.a;
                    return A3(IV, bs, JW(n), t);
                }());
            }()
        ]);
    }), WW = F2(function(n, e) {
        var r = n.C, t = e.c7, u = e.at, a = e.aA, i = e.fQ, c = e.du, o = {
            k$: j,
            lf: $(OJ, {
                oS: A([
                    YN("table table-striped table-hover mb-0 view-list cursor-pointer")
                ])
            }),
            lD: aV,
            ns: cV,
            du: c,
            ow: t,
            oZ: Wi(""),
            o_: iV
        };
        switch(a.$){
            case 0:
                return A5(lJ, n, a.a, o, i, a.b);
            case 1:
                return A5(TJ, r, o, i, u, a.a);
            case 2:
                return A4($Y, r, o, i, a.a);
            case 3:
                return A4(qY, r, o, i, a.a);
            case 4:
                return A5(FY, n, o, i, a.a, a.b);
            case 5:
                return A5(VY, r.c_, o, i, u, a.a);
            case 6:
                return A5(cW, n, a.a, o, i, a.b);
            case 7:
                return A5(hW, n, a.a, o, i, a.b);
            case 8:
                return A4(jW, n, o, i, a.a);
            case 9:
                return A4(PW, r, o, i, a.a);
            default:
                return A4(YW, n, o, i, a.a);
        }
    }), KW = function(n) {
        return {
            $: 3,
            a: n
        };
    }, BW = F2(function(n, e) {
        var r = n.lR;
        return A2(WN, A([
            YN("d-flex align-items-center gap-3")
        ]), A([
            A2(gX, A([
                YN("fw-bold d-none d-sm-block"),
                vX("scope-selector")
            ]), A([
                c_("Secteur")
            ])),
            A2(vG, A([
                YN("form-select"),
                yH("scope-selector"),
                mG(A2(Hu, ps, A2(Hu, Ld, A2(Hu, Nc(bs), KW))))
            ]), A2(wu, function(n) {
                var r = n.a;
                return A2(pG, A([
                    gG(s(e.at, r)),
                    hG(vs(r))
                ]), A([
                    c_(qx(r))
                ]));
            }, A2(Ah, Gh, A([
                v(ls, r.l5),
                v(ds(1), r.fh),
                v(ds(2), r.nn),
                v(bs, !0),
                v(ds(3), r.f2),
                v(ds(0), r.e$)
            ]))))
        ]));
    }), QW = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ZW = F2(function(n, e) {
        var r, t;
        return v(rV(e.aA) + " | Explorer ", A([
            A2(KN, A([
                YN("pb-3")
            ]), A([
                A2(WN, A([
                    YN("row d-flex align-item-end")
                ]), A([
                    A2(WN, A([
                        YN("col-sm-8 mb-1")
                    ]), A([
                        A2(BN, j, A([
                            c_("Explorateur")
                        ]))
                    ])),
                    A2(WN, A([
                        YN("col-sm-4 mt-2")
                    ]), A([
                        A2(BW, n, e)
                    ]))
                ])),
                A2(WN, A([
                    YN("row d-flex align-items-end mt-1 mx-0 g-0")
                ]), A([
                    A2(WN, A([
                        YN("col-12 col-xl-3 col-xxl-4 border-bottom")
                    ]), A([
                        (r = e, t = r.du, A2(WN, A([
                            YN("d-flex justify-content-start align-items-center gap-2")
                        ]), A([
                            A2(gX, A([
                                vX("search-field"),
                                YN("visually-hidden")
                            ]), A([
                                c_("Rechercher")
                            ])),
                            A2(N_, A([
                                o_("search"),
                                YN("form-control mb-1"),
                                yH("search-field"),
                                kX("Rechercher"),
                                hG(t),
                                mG(QW)
                            ]), j)
                        ])))
                    ])),
                    A2(WN, A([
                        YN("col-12 col-xl-9 col-xxl-8 pe-0 me-0")
                    ]), A([
                        uV(e)
                    ]))
                ])),
                A2(WN, A([
                    YN("mt-3")
                ]), A2(WW, n, e))
            ]))
        ]));
    }), nK = {
        $: 17
    }, eK = {
        $: 18
    }, rK = function(n) {
        return {
            $: 19,
            a: n
        };
    }, tK = function(n) {
        return {
            $: 20,
            a: n
        };
    }, uK = function(n) {
        return {
            $: 21,
            a: n
        };
    }, aK = {
        $: 30
    }, iK = {
        $: 31
    }, cK = function(n) {
        return {
            $: 34,
            a: n
        };
    }, oK = F2(function(n, e) {
        return {
            $: 37,
            a: n,
            b: e
        };
    }), fK = F2(function(n, e) {
        return qc(A2(wu, function(r) {
            return v(Pl(r), n(A2(eh, r, e)));
        }, PJ));
    }), sK = A2(Hu, b$, No), lK = function(n) {
        return A2(fK, sK, n);
    }, dK = A2(Hu, Tf, No), bK = function(n) {
        return qc(A([
            v("air", dK(n.f5)),
            v("impacts", lK(n.g)),
            v("road", dK(n.ds)),
            v("roadCooled", dK(n.og)),
            v("sea", dK(n.hb)),
            v("seaCooled", dK(n.oq))
        ]));
    }, mK = {
        ag: "cropDiversity",
        aa: "forest",
        ah: "hedges",
        aj: "microfibers",
        ak: "outOfEuropeEOL",
        al: "permanentPasture",
        am: "plotSize"
    }, pK = A2(Hu, cw, A2(Hu, A2(st, F2(function(n, e) {
        return v(n, A2(Pc, sK, e));
    }), cw(mK)), Do)), vK = function(n) {
        var e;
        return qc(A([
            v("total", lK(n.bI)),
            v("perKg", lK(n.g_)),
            v("scoring", (e = n.ha, qc(A([
                v("all", sK(e.kA)),
                v("climate", sK(e.kZ)),
                v("biodiversity", sK(e.kJ)),
                v("health", sK(e.md)),
                v("resources", sK(e.ob))
            ])))),
            v("totalMass", No(n.hy)),
            v("preparedMass", No(n.g1)),
            v("recipe", qc(A([
                v("total", lK(n.bm.bI)),
                v("ingredientsTotal", lK(n.bm.gH)),
                v("totalBonusImpact", pK(n.bm.kf)),
                v("transform", lK(n.bm.fX)),
                v("transports", bK(n.bm.af))
            ]))),
            v("packaging", lK(n.cs)),
            v("preparation", lK(n.bk)),
            v("transports", bK(n.af)),
            v("distribution", qc(A([
                v("total", lK(n.E.bI)),
                v("transports", bK(n.E.af))
            ])))
        ]));
    }, gK = A2(Hu, Xo, tt(2)), hK = F2(function(n, e) {
        var r = A2(Hu, c_, A2(Hu, ck, R_(j)));
        return A2(VH, j, A([
            A2(WH, j, A([
                c_("Debug")
            ])),
            A2(WN, A([
                YN("row")
            ]), A([
                A2(WN, A([
                    YN("col-7")
                ]), A([
                    r(gK(e))
                ])),
                A2(WN, A([
                    YN("col-5")
                ]), A([
                    r(A2(Zg, "Error serializing the impacts", A2(fs, A2(Hu, Gh, A2(Hu, vK, tt(2))), A2(lY, n, e))))
                ]))
            ]))
        ]));
    }), $K = function(n) {
        return f_({
            hS: j,
            h4: Ur,
            h9: A([
                c_(n)
            ]),
            ed: 0,
            eG: Ur
        });
    }, xK = function(n) {
        return {
            $: 5,
            a: n
        };
    }, kK = function(n) {
        return {
            $: 6,
            a: n
        };
    }, jK = {
        $: 10
    }, yK = {
        $: 11
    }, wK = function(n) {
        return {
            $: 22,
            a: n
        };
    }, AK = {
        $: 23
    }, TK = {
        $: 24
    }, EK = {
        $: 28
    }, CK = function(n) {
        return {
            $: 33,
            a: n
        };
    }, IK = function(n) {
        return {
            $: 35,
            a: n
        };
    }, SK = function(n) {
        return {
            $: 36,
            a: n
        };
    }, OK = function(n) {
        return {
            $: 38,
            a: n
        };
    }, LK = F2(function(n, e) {
        return {
            $: 43,
            a: n,
            b: e
        };
    }), PK = {
        kA: 0,
        f7: 0,
        kJ: 0,
        kZ: 0,
        k1: 0,
        md: 0,
        ob: 0
    }, qK = {
        q: Ur,
        E: Ur,
        _: Ur,
        ft: Ur,
        cs: Ur,
        fX: Ur,
        af: Ur,
        pf: Ur,
        kl: Ur
    }, NK = F5(function(n, e, r, t, u) {
        return {
            dN: r,
            cU: dw,
            ch: e,
            gW: t,
            ha: PK,
            ey: n,
            ez: qK,
            hk: u,
            bI: Ks
        };
    }), _K = F2(function(n, e) {
        var r = A2(Hu, ch(n), zr);
        return {
            q: Ur,
            E: r(e.E.bI),
            _: Ur,
            ft: r(e.bm.gH),
            cs: r(e.cs),
            fX: r(e.bm.fX),
            af: r(e.af.g),
            pf: Ur,
            kl: r(e.bk)
        };
    }), zK = F2(function(n, e) {
        return $(e, {
            cU: n.bm.kf,
            ha: n.ha,
            ez: A2(_K, e.ch.kj, n),
            bI: n.bI
        });
    }), UK = function(n) {
        return 19 === n;
    }, MK = fe("optgroup"), DK = F2(function(n, e) {
        var r = e.dv, t = e.oR, u = function(n) {
            var e = n.kj, t = n.ai;
            return A2(pG, A([
                gG(s(r, n.kj)),
                hG(Pl(e))
            ]), A([
                c_(t)
            ]));
        };
        return A2(WN, A([
            YN("ImpactSelector input-group"),
            A2(n_, "data-testid", "impact-selector")
        ]), A([
            A2(vG, A([
                YN("form-select"),
                mG(A2(Hu, km, t))
            ]), A([
                A2(MK, A([
                    A2(n_, "label", "Impacts agr\xe9g\xe9s")
                ]), A2(wu, u, A2(Ah, A2(Hu, function(n) {
                    return n.kj;
                }, UK), XY(n)))),
                A2(MK, A([
                    A2(n_, "label", "Impacts d\xe9taill\xe9s")
                ]), A2(wu, u, A2(LA, function(n) {
                    return n.ai;
                }, A2(Ah, A2(Hu, function(n) {
                    return n.kj;
                }, A2(Hu, UK, rl)), XY(n)))))
            ]))
        ]));
    }), RK = fe("textarea"), FK = function(n) {
        return 1 === n.$;
    }, HK = JN("pattern"), GK = d_("pencil"), XK = F2(function(n, e) {
        switch(e.$){
            case 0:
                return Cg(n.an.l5);
            case 1:
                var r = e.a;
                return A2(ek, r, A2(Zx, r, n));
            default:
                return eT(n.an.oX);
        }
    }), VK = F2(function(n, e) {
        var r = e.g5;
        switch(r.$){
            case 0:
                return A2(Zg, e.ek, A2(fs, Qg, A2(Kg, n, r.a)));
            case 1:
                return A2(Zg, "N/A", A2(Xj, n, r.b.my));
            default:
                var t = r.a;
                return A2(Zg, e.ek, A2(fs, sT(n.oX.pQ), A2(zA, n, t)));
        }
    }), JK = F2(function(n, e) {
        var r, t, u = e.ek, a = e.g5, i = A2(XK, n.ey, n.at), c = function() {
            switch(a.$){
                case 0:
                    return A2(md, n.O.kj, zr(a.a));
                case 1:
                    return A3(qb, a.a, n.O.kj, zr(a.b));
                default:
                    return A2(Um, n.O.kj, zr(a.a));
            }
        }(), o = !(r = n.bw).$ && s(r.a.g5, e.g5);
        return A2(__, A([
            YN("list-group-item"),
            r_(A([
                v("active", s(a, i))
            ]))
        ]), A([
            A2(HG, A([
                YN("d-flex justify-content-between align-items-center gap-1 fs-7"),
                VG(n.jE)
            ]), A([
                function() {
                    var r = v(o, n.bw);
                    if (r.a && !r.b.$) {
                        var t = r.b.a;
                        return A2(N_, A([
                            o_("text"),
                            YN("form-control form-control-sm"),
                            mG(n.pH(e)),
                            kX("Nom de la simulation"),
                            hG(t.ek),
                            jX(!0),
                            HK("^(?!\\s*$).+")
                        ]), j);
                    }
                    return A2(VN, A([
                        YN("flex-fill text-truncate"),
                        r_(A([
                            v("active text-white", s(a, i))
                        ])),
                        W_(A2(VK, n.ey.C, e)),
                        QN(k(n.ey.kY, _T(c)))
                    ]), A([
                        c_(u)
                    ]));
                }(),
                o ? A2(e_, A([
                    o_("submit"),
                    YN("btn btn-sm btn-success"),
                    A2(qH, "max-width", "30px"),
                    W_("Sauvegarder la simulation dans le stockage local du navigateur")
                ]), A([
                    zX
                ])) : (t = e, A2(e_, A([
                    o_("button"),
                    YN("btn btn-sm btn-info"),
                    W_("Renommer"),
                    A2(n_, "aria-label", "Renommer"),
                    i_(A2(n.pH, t, t.ek))
                ]), A([
                    GK
                ]))),
                A2(e_, A([
                    o_("button"),
                    YN("btn btn-sm btn-danger"),
                    W_("Supprimer"),
                    A2(n_, "aria-label", "Supprimer"),
                    i_(n.lp(e))
                ]), A([
                    NX
                ]))
            ]))
        ]));
    }), YK = d_("file-download"), WK = d_("file-upload"), KK = function(n) {
        return !n.g5.$;
    }, BK = F2(function(n, e) {
        var r = e.g5;
        return 1 === r.$ && s(r.a, n);
    }), QK = function(n) {
        return 2 === n.g5.$;
    }, ZK = F2(function(n, e) {
        return DO(A2(Ah, function() {
            switch(e.$){
                case 0:
                    return KK;
                case 1:
                    return BK(e.a);
                default:
                    return QK;
            }
        }(), n.bH.ap));
    }), nB = d_("stats"), eB = function(n) {
        var e = n.h6, r = n.at, t = A2(ZK, n.ey, r);
        return A2(WN, j, A([
            A2(WN, A([
                YN("card-header border-top rounded-0 d-flex justify-content-between align-items-center gap-1")
            ]), A([
                A2(m_, j, A([
                    c_("Signets")
                ])),
                A2(WN, A([
                    YN("d-flex flex-fill justify-content-end gap-1")
                ]), A([
                    A2(e_, A([
                        YN("btn btn-sm btn-outline-primary d-flex align-items-center"),
                        W_("Exporter les signets"),
                        E_(sf(t)),
                        i_(n.lY)
                    ]), A([
                        YK
                    ])),
                    A2(e_, A([
                        YN("btn btn-sm btn-outline-primary d-flex align-items-center"),
                        W_("Importer les signets"),
                        i_(n.mm)
                    ]), A([
                        WK
                    ])),
                    A2(e_, A([
                        YN("btn btn-sm btn-primary d-flex align-items-center gap-1"),
                        W_("Comparer vos simulations sauvegard\xe9es"),
                        E_(sf(t)),
                        i_(e)
                    ]), A([
                        nB,
                        c_("Comparer")
                    ]))
                ]))
            ])),
            A2(B_, A([
                YN("list-group list-group-flush rounded-bottom overflow-auto"),
                A2(qH, "max-height", "50vh")
            ]), A2(wu, JK(n), A2(Ah, function(n) {
                var e = n.g5;
                switch(e.$){
                    case 0:
                        return s(r, ls);
                    case 1:
                        return s(r, ds(e.a));
                    default:
                        return s(r, bs);
                }
            }, DO(t))))
        ]));
    }, rB = d_("plus"), tB = F3(function(n, e, r) {
        return A3(Yb, "%json%", e, A3(Yb, "%apiUrl%", r, A2(at, " \\\n", A2(qa, ru, A([
            zr("curl -sS -X POST %apiUrl%"),
            zr('  -H "accept: application/json"'),
            zr('  -H "content-type: application/json"'),
            A2(Pc, function(n) {
                return '  -H "Authorization: Bearer ' + n + '"';
            }, n),
            zr("  -d '%json%'")
        ])))));
    }), uB = F3(function(n, e, r) {
        return A3(tB, n, A2(tt, 0, Xo(r)), e + "/api/food");
    }), aB = F3(function(n, e, r) {
        return A3(tB, n, A2(tt, 0, Lf(r)), e + "/api/textile/simulator");
    }), iB = function(n) {
        var e = n.bH;
        return A2(Pc, A2(Hu, function(n) {
            return n.f3;
        }, function(n) {
            return n.kv;
        }), e.aW);
    }, cB = F4(function(n, e, r, t) {
        return A3(tB, e, A2(tt, 0, Rf(t)), r + "/api/" + vs(n) + "/simulator");
    }), oB = F3(function(n, e, r) {
        var t = A2(Zx, r, e);
        return g(k(e.kY, "/" + _T(A3(qb, r, n.kj, zr(t)))), A4(cB, ds(r), iB(e), e.kY, t), A2(tt, 2, Rf(t)));
    }), fB = function(n) {
        var e = n.kF, r = n.h9, t = n.oU;
        return A2(WN, A([
            YN("CardTabs card shadow-sm")
        ]), A2(Mr, A2(WN, A2(Mr, YN("card-header px-0 pb-0 border-bottom-0 bg-white"), e), A([
            A2(B_, A([
                YN("Tabs nav nav-tabs nav-fill justify-content-end gap-2 px-2")
            ]), A2(wu, function(n) {
                var e = n.hJ, r = n.ai, t = n.jg;
                return A2(__, A([
                    YN("TabsTab nav-item"),
                    r_(A([
                        v("active", e)
                    ]))
                ]), A([
                    A2(e_, A([
                        YN("nav-link no-outline border-top-0"),
                        r_(A([
                            v("active", e)
                        ])),
                        i_(t)
                    ]), A([
                        r
                    ]))
                ]));
            }, t))
        ])), r));
    }, sB = F2(function(n, e) {
        return A2(WN, A([
            YN("card-body fs-7")
        ]), A([
            A2(D_, A([
                YN("text-muted")
            ]), A([
                c_(e)
            ])),
            A2(D_, A([
                YN("fw-bold")
            ]), A([
                c_("Comment y acc\xe9der\xa0?")
            ])),
            A2(z_, A([
                YN("ps-3")
            ]), A([
                A2(__, j, A([
                    c_("S\u2019identifier ou se cr\xe9er un compte.")
                ])),
                A2(__, j, A([
                    c_("Depuis votre compte, accepter les conditions d\u2019utilisation des donn\xe9es Base empreinte et Ecoinvent.")
                ])),
                A2(__, j, A([
                    c_("Revenir sur votre simulation en \xe9tant connect\xe9 et avec les conditions d\u2019utilisation accept\xe9es.")
                ]))
            ])),
            A2(WN, A([
                YN("text-center")
            ]), A([
                Nl(n) ? A2(VN, A([
                    YN("btn btn-sm btn-outline-primary"),
                    ZN(fd)
                ]), A([
                    c_("Acc\xe9der \xe0 mon compte")
                ])) : A2(VN, A([
                    YN("btn btn-sm btn-outline-primary"),
                    ZN(ld)
                ]), A([
                    c_("Cr\xe9er un compte")
                ]))
            ]))
        ]));
    }), lB = F3(function(n, e, r) {
        var t = r;
        return A3(qJ, F3(function(r, t, u) {
            var a = A2(eh, r, n), i = e(a);
            return i.$ ? u : A2(Mr, {
                dY: i.a.dY + "bb",
                ek: a.ai,
                eT: A3(NJ, i.a.jd, i.a.kp, t)
            }, u);
        }), j, t);
    }), dB = F2(function(n, e) {
        var r = A2(wu, function(n) {
            return n.eT;
        }, e), t = v(tl(r), A2(Nc, 0, gC(A2(wu, ak, r)))), u = t.a, a = t.b;
        return u || a ? A2(WN, A([
            YN("table-responsive"),
            A2(qH, "max-height", "400px")
        ]), A([
            A2(G_, A([
                YN("table table-hover w-100 m-0")
            ]), A([
                A2(X_, j, A2(wu, function(e) {
                    var r = e.F, t = e.O, u = e.ek, a = e.jl, i = e.kr;
                    return A2(K_, A2(Mr, W_(u + ": " + A2(Rj, 2, a) + "\u202F% (" + A2(Rj, 2, t) + "\u202F" + n.aL + ")"), r), A([
                        A2(J_, A([
                            YN("text-truncate fw-normal fs-8"),
                            A2(qH, "max-width", "200px")
                        ]), A([
                            c_(u)
                        ])),
                        A2(V_, A([
                            YN("HorizontalBarChart"),
                            A2(qH, "width", "200px"),
                            A2(qH, "vertical-align", "middle")
                        ]), A([
                            A2(WN, A([
                                YN("ext"),
                                r_(A([
                                    v("pos", a >= 0),
                                    v("neg", 0 > a)
                                ]))
                            ]), A([
                                A2(WN, A([
                                    YN("bar"),
                                    r_(A([
                                        v("bg-secondary", a >= 0),
                                        v("bg-success", 0 > a)
                                    ])),
                                    A2(qH, "width", Js(i > 0 ? A2(Dt, i, 1) : i) + "%")
                                ]), j)
                            ]))
                        ])),
                        A2(V_, A([
                            YN("text-end text-nowrap fs-8")
                        ]), A([
                            wY(a)
                        ]))
                    ]));
                }, A2(wu, function(n) {
                    var e = n.eT;
                    return {
                        F: n.F,
                        O: e,
                        ek: n.ek,
                        jl: e / u * 100,
                        kr: ak(e) / a * 100
                    };
                }, e)))
            ]))
        ])) : c_("");
    }), bB = "#ff9500", mB = "#f5325b", pB = "#22d2ba", vB = "#7b4dff", gB = "#12a5ed", hB = "#ea60df", $B = "#71c614", xB = "#dddddd", kB = "#ffca00", jB = function(n) {
        return A2(qH, "border-left", "5px " + n + " solid");
    }, yB = function(n) {
        return ah(A([
            A2(Nc, 0, n.ag),
            A2(Nc, 0, n.ah),
            A2(Nc, 0, n.al),
            A2(Nc, 0, n.am)
        ]));
    }, wB = function(n) {
        return A(19 === n.kj ? [
            1,
            2,
            0
        ] : [
            1
        ]);
    }, AB = F2(function(n, e) {
        var r = e.dN, t = e.cU, u = e.ch, a = e.gW, i = e.ha, c = e.ey, o = e.ez, f = e.hk, l = e.bI;
        return fB({
            kF: j,
            h9: A([
                function() {
                    var e = v(r, ts(c));
                    switch(e.a){
                        case 0:
                            return e.b ? A2(dB, u, xt(A2(LA, function(n) {
                                return n.eT;
                            }, k(A([
                                {
                                    F: j,
                                    ek: "Services \xe9cosyst\xe9miques",
                                    eT: yB(t)
                                },
                                {
                                    F: j,
                                    ek: "Compl\xe9ment " + Ss(eW.ak),
                                    eT: A2(Nc, 0, t.ak)
                                },
                                {
                                    F: j,
                                    ek: "Compl\xe9ment " + Ss(eW.aj),
                                    eT: A2(Nc, 0, t.aj)
                                },
                                {
                                    F: j,
                                    ek: "Compl\xe9ment " + Ss(eW.aa),
                                    eT: A2(Nc, 0, t.aa)
                                }
                            ]), A2(wu, function(n) {
                                return {
                                    F: j,
                                    ek: n.ek,
                                    eT: n.eT
                                };
                            }, A3(lB, n, function(n) {
                                return n.it;
                            }, l)))))) : A2(sB, c, "Les impacts d\xe9taill\xe9s ne sont pas accessibles.");
                        case 1:
                            return A2(dB, u, A2(wu, function(n) {
                                var e = n.F, r = n.ek, t = n.eT;
                                return {
                                    F: A2(Mr, A2(qH, "cursor", "pointer"), e),
                                    ek: r,
                                    eT: A2(Nc, 0, A2(Pc, b$, t))
                                };
                            }, A([
                                {
                                    F: A([
                                        jB(xB),
                                        i_(a("trims-stage"))
                                    ]),
                                    ek: "Accessoires",
                                    eT: o.pf
                                },
                                {
                                    F: A([
                                        jB(vB),
                                        i_(a("materials-stage"))
                                    ]),
                                    ek: "Mati\xe8res premi\xe8res",
                                    eT: o.ft
                                },
                                {
                                    F: A([
                                        jB(hB),
                                        i_(a("transform-stage"))
                                    ]),
                                    ek: "Transformation",
                                    eT: o.fX
                                },
                                {
                                    F: A([
                                        jB(bB),
                                        i_(a("assembly-stage"))
                                    ]),
                                    ek: "Assemblage",
                                    eT: o.q
                                },
                                {
                                    F: A([
                                        jB(gB),
                                        i_(a("packaging-stage"))
                                    ]),
                                    ek: "Emballage",
                                    eT: o.cs
                                },
                                {
                                    F: A([
                                        jB($B),
                                        i_(a("transport-stage"))
                                    ]),
                                    ek: "Transports",
                                    eT: o.af
                                },
                                {
                                    F: A([
                                        jB(mB),
                                        i_(a("distribution-stage"))
                                    ]),
                                    ek: "Distribution",
                                    eT: o.E
                                },
                                {
                                    F: A([
                                        jB(kB),
                                        i_(a("usage-stage"))
                                    ]),
                                    ek: "Utilisation",
                                    eT: o.kl
                                },
                                {
                                    F: A([
                                        jB(pB),
                                        i_(a("end-of-life-stage"))
                                    ]),
                                    ek: "Fin de vie",
                                    eT: o._
                                }
                            ])));
                        default:
                            return e.b ? A2(dB, u, A([
                                {
                                    F: j,
                                    ek: "Climat",
                                    eT: i.kZ
                                },
                                {
                                    F: j,
                                    ek: "Biodiversit\xe9",
                                    eT: i.kJ
                                },
                                {
                                    F: j,
                                    ek: "Sant\xe9 environnementale",
                                    eT: i.md
                                },
                                {
                                    F: j,
                                    ek: "Ressource",
                                    eT: i.ob
                                },
                                {
                                    F: j,
                                    ek: "Compl\xe9ments",
                                    eT: i.k1
                                }
                            ])) : A2(sB, c, "Les sous-scores ne sont pas accessibles.");
                    }
                }()
            ]),
            oU: A2(wu, function(n) {
                return {
                    hJ: s(r, n),
                    ai: c_(jL(n)),
                    jg: f(n)
                };
            }, wB(u))
        });
    }), TB = function(n) {
        var e, r, t, u, a, i, c, o, f, l = n.ey.C;
        return A2(WN, A([
            YN("d-flex flex-column gap-3 mb-3 sticky-md-top"),
            A2(qH, "top", "7px")
        ]), A([
            n.ey.d1 ? A2(DK, l.c_, {
                dv: n.dv.kj,
                oR: n.oR
            }) : c_(""),
            (e = {
                id: n.le,
                ch: n.dv,
                P: n.aT,
                bn: n.o9,
                jT: n.pa
            }, r = e.id, t = e.ch, u = e.P, a = e.bn, i = e.jT, A2(WN, A([
                YN("Score card bg-secondary shadow-sm"),
                A2(n_, "data-testid", "score-card"),
                A2(n_, "data-score", Js(A2(ch, t.kj, a)))
            ]), A([
                A2(WN, A([
                    YN("card-body text-center text-nowrap text-white")
                ]), A([
                    A2(WN, A([
                        YN("display-3 lh-1")
                    ]), A([
                        A2(tW, t, a)
                    ])),
                    A2(WN, j, A([
                        A2(Nc, c_(""), A2(Pc, function(n) {
                            return A2(m_, j, A([
                                A2(tW, t, n),
                                c_(" hors durabilit\xe9")
                            ]));
                        }, i))
                    ])),
                    A2(yX, j, A([
                        c_("Pour "),
                        pV(u)
                    ]))
                ])),
                function() {
                    if (r.$) return c_("");
                    var n = r.a;
                    return A2(WN, A([
                        YN("card-footer text-white text-center")
                    ]), A([
                        n
                    ]));
                }()
            ]))),
            function() {
                var e = n.ml;
                return e.$ ? c_("") : A2(AB, l.c_, e.a);
            }(),
            (c = {
                aV: n.kw,
                bw: n.bw,
                bx: n.bx,
                h6: n.k0,
                k4: n.k4,
                k5: n.k5,
                k6: n.k6,
                k8: n.k8,
                la: n.la,
                lp: n.lq,
                lY: n.lY,
                O: n.dv,
                mm: n.mm,
                nc: n.nc,
                jE: n.n9,
                jP: n.ok,
                at: n.at,
                ey: n.ey,
                j8: n.oP,
                ph: n.pk,
                pm: n.pm,
                pn: n.pn,
                pH: n.pH
            }, o = A([
                v(1, c_("Sauvegarder")),
                v(2, c_("Partager"))
            ]), f = FK(c.at) ? k(o, A([
                v(0, c_("Contribuer"))
            ])) : o, fB({
                kF: j,
                h9: A([
                    function() {
                        switch(c.aV){
                            case 0:
                                return function(n) {
                                    var e, r = n.at, t = n.ey, u = Nl(t), a = F2(function(n, e) {
                                        return A2(WN, A([
                                            YN("text-danger fs-7")
                                        ]), A([
                                            n,
                                            c_("\xa0" + e)
                                        ]));
                                    }), i = (e = DS(r)).$ ? Bx : A2(Zx, e.a, t), c = A2(nl, A2(Hu, function(n) {
                                        return n.g5;
                                    }, zt(i)), t.C.l9.lT), o = s(i, Bx), f = n.k6 || !u || o || c;
                                    return A2(WN, A([
                                        YN("card-body d-flex flex-column gap-2")
                                    ]), A([
                                        A2(WN, A([
                                            YN("fs-7 text-muted")
                                        ]), A([
                                            c_("Proposez l\u2019ajout de votre simulation \xe0 la base de donn\xe9es d\u2019exemples " + qx(r) + " sur Ecobalyse.")
                                        ])),
                                        A2(N_, A([
                                            YN("form-control form-control-sm"),
                                            o_("text"),
                                            hG(n.k5),
                                            kX("Nom de l\u2019exemple"),
                                            mG(n.pn),
                                            E_(f)
                                        ]), j),
                                        A2(RK, A([
                                            YN("form-control form-control-sm"),
                                            A2(ve, "rows", ut(3)),
                                            hG(n.k4),
                                            kX("D\xe9crivez ce que simule cet exemple et pourquoi il est pertinent de le proposer aux autres utilisateurs"),
                                            mG(n.pm),
                                            E_(f)
                                        ]), j),
                                        u ? o ? A2(a, LX, "La simulation ne peut \xeatre vide.") : c ? A2(a, LX, "Cette simulation existe d\xe9j\xe0 dans la base de donn\xe9es d\u2019exemples.") : c_("") : A2(a, b_, "Connectez-vous pour proposer une contribution."),
                                        A2(e_, A([
                                            YN("btn btn-primary btn-sm"),
                                            o_("button"),
                                            E_(f),
                                            i_(n.la)
                                        ]), A([
                                            c_(n.k6 ? "Envoi\u2026" : "Contribuer")
                                        ]))
                                    ]));
                                }(c);
                            case 1:
                                return function(n) {
                                    var e = A2(ZK, n.ey, n.at), r = v(A2(el, A2(XK, n.ey, n.at), A2(wu, function(n) {
                                        return n.g5;
                                    }, e)), A2(el, n.bx, A2(wu, function(n) {
                                        return n.ek;
                                    }, e))), t = r.a, u = r.b;
                                    return A2(WN, j, A([
                                        A2(WN, A([
                                            YN("card-body pb-2")
                                        ]), A([
                                            A2(HG, A([
                                                VG(n.jP)
                                            ]), A([
                                                A2(WN, A([
                                                    YN("input-group")
                                                ]), A([
                                                    A2(N_, A([
                                                        o_("text"),
                                                        YN("form-control"),
                                                        mG(n.ph),
                                                        kX("Nom de la simulation"),
                                                        hG(n.bx),
                                                        jX(!0),
                                                        HK("^(?!\\s*$).+"),
                                                        IX(t)
                                                    ]), j),
                                                    A2(e_, A([
                                                        o_("submit"),
                                                        YN("btn btn-primary"),
                                                        W_("Sauvegarder la simulation dans le stockage local au navigateur"),
                                                        E_(t || u)
                                                    ]), A([
                                                        rB
                                                    ]))
                                                ]))
                                            ])),
                                            A2(WN, A([
                                                YN("form-text fs-7 pb-0")
                                            ]), A([
                                                t ? A2(m_, A([
                                                    YN("d-flex align-items-center gap-1")
                                                ]), A([
                                                    b_,
                                                    c_("Cette simulation est d\xe9j\xe0 sauvegard\xe9e")
                                                ])) : u ? A2(m_, A([
                                                    YN("d-flex align-items-center gap-1")
                                                ]), A([
                                                    b_,
                                                    c_("Une simulation portant ce nom existe d\xe9j\xe0")
                                                ])) : c_("Donnez un nom \xe0 cette simulation pour la retrouver plus tard")
                                            ]))
                                        ])),
                                        eB(n)
                                    ]));
                                }(c);
                            default:
                                return function(n) {
                                    var e = n.k8, r = n.O, t = n.at, u = n.ey, a = function() {
                                        switch(t.$){
                                            case 0:
                                                return g(k(u.kY, "/" + _T(A2(md, r.kj, zr(n = u.an.l5)))), A3(uB, iB(u), u.kY, n), A2(tt, 2, Xo(n)));
                                            case 1:
                                                return A3(oB, r, u, t.a);
                                            default:
                                                var n;
                                                return g(k(u.kY, "/" + _T(A2(Um, r.kj, zr(n = u.an.oX)))), A3(aB, iB(u), u.kY, n), A2(tt, 2, Lf(n)));
                                        }
                                    }(), i = a.a, c = a.b, o = a.c;
                                    return A2(WN, j, A([
                                        A2(WN, A([
                                            YN("card-body pt-0 pb-2")
                                        ]), A([
                                            A2(I_, A([
                                                YN("h5 mt-2")
                                            ]), A([
                                                c_("Web")
                                            ])),
                                            A2(WN, A([
                                                YN("input-group")
                                            ]), A([
                                                A2(N_, A([
                                                    o_("url"),
                                                    YN("form-control"),
                                                    hG(i)
                                                ]), j),
                                                A2(e_, A([
                                                    YN("input-group-text"),
                                                    W_("Copier l'adresse"),
                                                    i_(e(i))
                                                ]), A([
                                                    CX
                                                ]))
                                            ])),
                                            A2(WN, A([
                                                YN("form-text fs-7")
                                            ]), A([
                                                c_("Copiez cette adresse pour partager ou sauvegarder votre simulation")
                                            ]))
                                        ])),
                                        A2(WN, A([
                                            YN("card-body border-top pt-0 pb-2")
                                        ]), A([
                                            A2(I_, A([
                                                YN("h5 mt-2")
                                            ]), A([
                                                c_("API")
                                            ])),
                                            A2(R_, A([
                                                YN("bg-dark text-white p-2 m-0")
                                            ]), A([
                                                A2(A_, j, A([
                                                    c_("$ " + c)
                                                ]))
                                            ])),
                                            A2(e_, A([
                                                YN("btn btn-outline-dark btn-sm w-100 d-flex justify-content-center align-items-center gap-1"),
                                                i_(e(c))
                                            ]), A([
                                                CX,
                                                c_("Copier la commande")
                                            ])),
                                            A2(WN, A([
                                                YN("form-text fs-7")
                                            ]), A([
                                                c_("Cette commande utilise l'"),
                                                A2(VN, A([
                                                    ZN(od)
                                                ]), A([
                                                    c_("API Ecobalyse")
                                                ]))
                                            ]))
                                        ])),
                                        A2(WN, A([
                                            YN("card-body border-top pt-0")
                                        ]), A([
                                            A2(I_, A([
                                                YN("h5 mt-2")
                                            ]), A([
                                                c_("Param\xe8tres de simulation JSON")
                                            ])),
                                            A2(R_, A([
                                                YN("bg-dark text-white p-2 m-0"),
                                                A2(qH, "max-height", "200px")
                                            ]), A([
                                                A2(A_, j, A([
                                                    c_(o)
                                                ]))
                                            ])),
                                            A2(e_, A([
                                                YN("btn btn-outline-dark btn-sm w-100 d-flex justify-content-center align-items-center gap-1"),
                                                i_(e(o))
                                            ]), A([
                                                CX,
                                                c_("Copier")
                                            ]))
                                        ]))
                                    ]));
                                }(c);
                        }
                    }()
                ]),
                oU: A2(wu, function(n) {
                    var e = n.a, r = n.b;
                    return {
                        hJ: s(c.aV, e),
                        ai: r,
                        jg: c.j8(e)
                    };
                }, f)
            }))
        ]));
    }, EB = F3(function(n, e, r) {
        return TB({
            kw: e.dW,
            bw: e.bw,
            bx: e.bx,
            k0: AK,
            k4: "",
            k5: "",
            k6: !1,
            k8: xK,
            la: AO,
            le: Ur,
            lq: kK,
            lY: jK,
            ml: zr(A2(zK, r, A5(NK, n, e.O, e.dN, wK, SK))),
            mm: yK,
            nc: AO,
            aT: r.g1,
            n9: TK,
            ok: EK,
            at: ls,
            dv: e.O,
            ey: n,
            oP: CK,
            oR: IK,
            o9: r.bI,
            pa: Ur,
            pk: OK,
            pm: Wi(AO),
            pn: Wi(AO),
            pH: LK
        });
    }), CB = {
        $: 25
    }, IB = {
        $: 3
    }, SB = function(n) {
        return {
            $: 9,
            a: n
        };
    }, OB = F2(function(n, e) {
        return {
            $: 42,
            a: n,
            b: e
        };
    }), LB = function(n) {
        var e = n.ec, r = n.d3, t = n.gJ;
        return A2(__, A([
            YN("list-group-item p-0")
        ]), A([
            A2(e_, A([
                YN("btn btn-outline-primary"),
                YN("d-flex justify-content-center align-items-center"),
                YN("gap-1 w-100"),
                E_(e),
                i_(r)
            ]), A([
                A2(l_, A([
                    YN("icon icon-plus")
                ]), j),
                c_("Ajouter " + t)
            ]))
        ]));
    }, PB = F2(function(n, e) {
        var r = n.bY;
        return A2(e_, A([
            o_("button"),
            YN("ElementDelete d-flex justify-content-center align-items-center btn btn-outline-primary"),
            W_("Supprimer ce composant"),
            i_(e),
            E_(r)
        ]), A([
            NX
        ]));
    }), qB = "d-inline-flex align-items-center btn btn-sm gap-1 rounded-pill", NB = qB + " btn-primary fs-7 py-0", _B = function(n) {
        return VN(A2(Mr, YN(NB), n));
    }, zB = F4(function(n, e, r, t) {
        var u = n.l5;
        return A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between"),
                jB(kB)
            ]), A([
                A2(I_, A([
                    YN("h5 mb-0"),
                    yH("usage-stage")
                ]), A([
                    c_("Consommation")
                ])),
                A2(m_, j, A([
                    A2(tW, e, t.bk),
                    A2(_B, A([
                        YN("btn btn-secondary ms-2 py-1"),
                        QN(xJ(8)),
                        W_("Documentation"),
                        _H("_blank")
                    ]), A([
                        AY
                    ]))
                ]))
            ])),
            A2(B_, A([
                YN("CardList list-group list-group-flush")
            ]), k(sf(r.bk) ? A([
                A2(__, A([
                    YN("list-group-item")
                ]), A([
                    c_("Aucune pr\xe9paration")
                ]))
            ]) : A2(wu, function(n) {
                return A2(__, A([
                    YN("list-group-item d-flex justify-content-between align-items-center gap-2 pb-3")
                ]), A([
                    A2(vG, A([
                        YN("form-select form-select w-50"),
                        mG(A2(Hu, ru, OB(n.mj)))
                    ]), A2(wu, function(e) {
                        var t = e.mj, u = e.ek;
                        return A2(pG, A([
                            gG(s(n.mj, t)),
                            hG(t),
                            E_(A2(el, t, A2(wu, function(n) {
                                return n.mj;
                            }, r.bk)))
                        ]), A([
                            c_(u)
                        ]));
                    }, A2(LA, function(n) {
                        return n.ek;
                    }, lb))),
                    A2(m_, A([
                        YN("w-50 text-end")
                    ]), A([
                        A2(tW, e, A3(LJ, u.pQ, t.bm.pe, n))
                    ])),
                    A2(PB, {
                        bY: !1
                    }, SB(n.mj))
                ]));
            }, r.bk), A([
                LB({
                    d3: IB,
                    ec: 2 === ft(r.bk),
                    gJ: "une technique de pr\xe9paration"
                })
            ])))
        ]);
    }), UB = {
        $: 0
    }, MB = {
        $: 26
    }, DB = function(n) {
        return {
            $: 39,
            a: n
        };
    }, RB = A([
        tb,
        ub,
        ab
    ]), FB = F2(function(n, e) {
        return A2(rb, e, n(1));
    }), HB = function(n) {
        var e = n.b, r = Js(e.cG / A2(rb, nb(1), 1));
        return "\xc9nergie: " + Js(A2(FB, A2(Hu, Zd, oy(1)), e.c5)) + " kWh/m\xb3, R\xe9frig\xe9ration: " + Js(A2(FB, A2(Hu, Zd, oy(1)), e.aN)) + " kWh/m\xb3, Eau " + r + " L/m\xb3";
    }, GB = function(n) {
        switch(n.a){
            case 0:
                return "Sec";
            case 1:
                return "Frais";
            default:
                return "Surgel\xe9";
        }
    }, XB = F3(function(n, e, r) {
        var t = A2(tW, n, r.E.bI);
        return A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between"),
                jB(mB)
            ]), A([
                A2(I_, A([
                    YN("h5 mb-0"),
                    yH("distribution-stage")
                ]), A([
                    c_("Distribution")
                ])),
                A2(m_, j, A([
                    A2(tW, n, r.E.bI),
                    A2(_B, A([
                        YN("btn btn-secondary ms-2 py-1"),
                        QN(xJ(1)),
                        W_("Documentation"),
                        _H("_blank")
                    ]), A([
                        AY
                    ]))
                ]))
            ])),
            A2(B_, A([
                YN("CardList list-group list-group-flush border-top-0 border-bottom-0")
            ]), function() {
                var n = e.E;
                if (n.$) return A([
                    LB({
                        d3: UB,
                        ec: !1,
                        gJ: "un mode de distribution"
                    })
                ]);
                var r = n.a;
                return A([
                    A2(__, A([
                        YN("ElementFormWrapper list-group-item")
                    ]), A([
                        A2(vG, A([
                            YN("form-select form-select"),
                            mG(DB)
                        ]), A2(wu, function(n) {
                            return A2(pG, A([
                                gG(s(e.E, zr(n))),
                                hG(So(n))
                            ]), A([
                                c_(GB(n))
                            ]));
                        }, RB)),
                        A2(m_, A([
                            YN("text-end ImpactDisplay fs-7")
                        ]), A([
                            t
                        ])),
                        A2(PB, {
                            bY: !1
                        }, MB)
                    ])),
                    A2(__, A([
                        YN("list-group-item fs-7 pt-2")
                    ]), A([
                        c_(HB(r))
                    ]))
                ]);
            }())
        ]);
    }), VB = function(n) {
        return Ah(function(e) {
            return !A2(el, e.mj, n);
        });
    }, JB = function(n) {
        return {
            $: 6,
            a: n
        };
    }, YB = {
        $: 0
    }, WB = {
        bd: j,
        ef: !1
    }, KB = function(n) {
        return {
            $: 2,
            a: n
        };
    }, BB = F2(function(n, e) {
        return {
            h3: n.h3,
            e6: {
                oL: KB(200),
                fX: JB
            },
            cZ: WB,
            ff: e,
            mk: n.mk,
            ej: Ur,
            g5: n.g5,
            ox: Ur,
            dL: YB
        };
    }), QB = F2(function(n, e) {
        return A2(BB, {
            h3: e,
            mk: j,
            g5: ""
        }, function(r) {
            return xu($(r, {
                h3: A2(_V, {
                    m5: 1,
                    g5: r.g5,
                    o0: A2(Hu, n, jC)
                }, e)
            }));
        });
    }), ZB = F2(function(n, e) {
        return {
            $: 40,
            a: n,
            b: e
        };
    }), nQ = function(n) {
        var e = A2(Rj, 2, n);
        return A2(m_, j, A([
            c_(A2(gu, "-", e) ? e : "+" + e),
            A2(m_, A([
                YN("fs-unit")
            ]), A([
                c_("\u202FPts")
            ]))
        ]));
    }, eQ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, rQ = JN("min"), tQ = function(n) {
        return A2(JN, "step", n);
    }, uQ = function(n) {
        var e = n.bY, r = n.P, t = n.fw;
        return A2(WN, A([
            YN("input-group")
        ]), A([
            A2(N_, A([
                YN("form-control text-end incdec-arrows-left"),
                o_("number"),
                tQ("1"),
                hG(ut(yf(zo(r)))),
                W_("Quantit\xe9 en grammes"),
                mG(function(n) {
                    return t("" === n ? Ur : A2(Pc, hb, pp(n)));
                }),
                rQ("0"),
                E_(e)
            ]), j),
            A2(m_, A([
                YN("input-group-text"),
                W_("grammes")
            ]), A([
                c_("g")
            ]))
        ]));
    }, aQ = F3(function(n, e, r) {
        var t = r.bb, u = r.fB, a = r.O, i = r.dv;
        return {
            kC: !0,
            kI: {
                i: u.i,
                iv: u.a_,
                D: u.P
            },
            C: {
                bT: A2(LA, function(n) {
                    return n.ek;
                }, A2(Rh, A([
                    ls
                ]), n.bT)),
                c_: n.c_,
                r: n.l5.mq
            },
            ig: IY(u.a_.gp),
            lp: function(n) {
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(n.mj);
            },
            bb: A2(Ah, function(n) {
                return A2(el, n.mj, t);
            }, n.l5.mq),
            O: a,
            nz: A2(Hu, eQ, kc),
            nW: function(n) {
                return uQ({
                    bY: !1,
                    P: n.D,
                    fw: n.fw
                });
            },
            ot: F2(function(n, e) {
                return kc(A2(vO, zr(u), e));
            }),
            dv: i,
            oZ: A2(Hu, function(n) {
                return n.mj;
            }, Ug),
            o1: function(n) {
                return n.ek;
            },
            o2: A2(Hu, function(n) {
                return n.t;
            }, Hb),
            ph: F2(function(n, r) {
                return A2(ZB, e, $(e, {
                    i: A2(Pc, function(n) {
                        return n.cR;
                    }, r.i),
                    mj: r.iv.mj,
                    P: r.D
                }));
            })
        };
    }), iQ = d_("ship"), cQ = d_("snow"), oQ = A2(l_, A([
        A2(n_, "aria-hidden", "true"),
        YN("icon icon-ship")
    ]), A([
        cQ
    ])), fQ = d_("truck"), sQ = A2(l_, A([
        A2(n_, "aria-hidden", "true"),
        YN("icon icon-truck")
    ]), A([
        cQ
    ])), lQ = function(n) {
        var e = n.iq, r = n.iP, t = n.ai, u = n.es;
        return A2(m_, A([
            YN("d-flex align-items-center gap-1"),
            W_(t)
        ]), A([
            A2(m_, A([
                A2(qH, "cursor", "help")
            ]), A([
                r
            ])),
            u ? c_("") : bJ(e)
        ]));
    }, dQ = d_("plane"), bQ = F2(function(n, e) {
        var r = n.gD, t = n.es, u = n.g8, a = n.hc, i = e.ds, c = e.og, o = e.hb, f = e.oq;
        return A2(qa, function(n) {
            var e = n.iq, u = n.iP, a = n.ai;
            return !Tf(e) && r ? Ur : zr(lQ({
                iq: e,
                iP: u,
                ai: a,
                es: t
            }));
        }, A([
            {
                iq: e.f5,
                iP: dQ,
                ai: A2(Nc, "Transport a\xe9rien", n.f6)
            },
            {
                iq: o,
                iP: iQ,
                ai: A2(Nc, "Transport maritime", a)
            },
            {
                iq: f,
                iP: oQ,
                ai: "Transport maritime r\xe9frig\xe9r\xe9"
            },
            {
                iq: i,
                iP: fQ,
                ai: A2(Nc, "Transport routier", u)
            },
            {
                iq: c,
                iP: sQ,
                ai: "Transport routier r\xe9frig\xe9r\xe9"
            }
        ]));
    }), mQ = F4(function(n, e, r, t) {
        return A2(m_, A([
            YN("text-muted d-flex fs-7 gap-3 justify-content-left ElementTransportDistances")
        ]), function() {
            if (2 !== e.jo) {
                var u = 2 !== e.a_.hz, a = !r.jo, i = A2(BJ, n, e), c = i.ds, o = i.og, f = i.f5, l = i.hb, d = i.oq;
                return A([
                    A2(WN, A([
                        YN("IngredientPlaneOrBoatSelector")
                    ]), A([
                        A2(gX, A([
                            YN("PlaneSelector")
                        ]), A([
                            A2(N_, A([
                                o_("radio"),
                                A2(n_, "role", "switch"),
                                w_(a),
                                mG(Wi(t($(r, {
                                    jo: 0
                                }))))
                            ]), j),
                            dQ
                        ])),
                        A2(gX, A([
                            YN("BoatSelector")
                        ]), A([
                            A2(N_, A([
                                o_("radio"),
                                A2(n_, "role", "switch"),
                                w_(!a),
                                mG(Wi(t($(r, {
                                    jo: 1
                                }))))
                            ]), j),
                            u ? oQ : iQ
                        ])),
                        a ? A2(m_, A([
                            YN("ps-1 align-items-center gap-1"),
                            W_("Tranport a\xe9rien")
                        ]), A([
                            bJ(f)
                        ])) : u ? A2(m_, A([
                            YN("ps-1 align-items-center gap-1"),
                            W_("Tranport maritime r\xe9frig\xe9r\xe9")
                        ]), A([
                            bJ(d)
                        ])) : A2(m_, A([
                            YN("ps-1 align-items-center gap-1"),
                            W_("Tranport maritime")
                        ]), A([
                            bJ(l)
                        ]))
                    ])),
                    s(c, ml(0)) ? c_("") : lQ({
                        iq: c,
                        iP: fQ,
                        ai: "Transport routier",
                        es: !1
                    }),
                    s(o, ml(0)) ? c_("") : lQ({
                        iq: o,
                        iP: sQ,
                        ai: "Transport routier r\xe9frig\xe9r\xe9",
                        es: !1
                    })
                ]);
            }
            return A2(bQ, {
                f6: Ur,
                gy: !1,
                gD: !0,
                es: !1,
                g8: Ur,
                hc: Ur
            }, A2(BJ, n, e));
        }());
    }), pQ = qB + " text-secondary text-decoration-none btn-link p-0 ms-1", vQ = function(n) {
        return VN(A2(Mr, YN(pQ), n));
    }, gQ = function(n) {
        var e = n.bb;
        return !(e.b && !e.b.b) && n.kC;
    }, hQ = F2(function(n, e) {
        var r = n.nz, t = n.oZ, u = n.o1, a = n.o2, i = n.kI.iv;
        return A2(WN, A([
            YN("input-group")
        ]), A([
            A2(e_, A([
                YN("form-select ElementSelector text-start"),
                yH("selector-" + t(i)),
                W_(a(i)),
                i_(e)
            ]), A([
                A2(m_, j, A([
                    c_(u(i))
                ]))
            ])),
            A2(e_, A([
                o_("button"),
                YN("input-group-text"),
                W_("Ouvrir les informations d\xe9taill\xe9es"),
                i_(r(i))
            ]), A([
                AY
            ]))
        ]));
    }), $Q = function(n) {
        var e = n.kI, r = n.C, t = n.O, u = n.ph(e), a = n.lp(e.iv), i = A2(QB, n.o1, A2(LA, n.o1, A2(Ah, function(e) {
            return !A2(el, e, n.bb);
        }, r.r)));
        return A([
            A2(m_, A([
                YN("QuantityInputWrapper")
            ]), A([
                n.nW({
                    fw: function(n) {
                        return u(n.$ ? e : $(e, {
                            D: n.a
                        }));
                    },
                    D: e.D
                })
            ])),
            A2(hQ, n, A2(n.ot, e.iv, i)),
            A2(vG, A([
                YN("form-select form-select CountrySelector"),
                mG(function(n) {
                    var t;
                    return u($(e, {
                        i: "" !== n ? Ld((t = gw(n), A2(js, t, r.bT))) : Ur
                    }));
                })
            ]), A2(Mr, A2(pG, A([
                hG(""),
                gG(s(e.i, Ur))
            ]), A([
                c_("Par d\xe9faut (" + n.ig + ")")
            ])), A2(wu, function(n) {
                var r = n.cR, t = n.ek;
                return A2(pG, A([
                    gG(s(A2(Pc, function(n) {
                        return n.cR;
                    }, e.i), zr(r))),
                    hG(r)
                ]), A([
                    c_(t)
                ]));
            }, A2(LA, function(n) {
                return n.ek;
            }, r.bT)))),
            A2(m_, A([
                YN("text-end ImpactDisplay fs-7")
            ]), A([
                A2(tW, n.dv, t)
            ])),
            A2(PB, {
                bY: !gQ(n)
            }, a)
        ]);
    }, xQ = F2(function(n, e) {
        var r = n.S, t = n.ai;
        return A2(VH, A([
            YN("ComplementsDetails fs-7")
        ]), A2(Mr, A2(WH, j, A([
            A2(WN, A([
                YN("ComplementsTable d-flex justify-content-between w-100")
            ]), A([
                A2(m_, A([
                    W_("Cliquez pour plier/d\xe9plier")
                ]), A([
                    c_(t)
                ])),
                A2(m_, A([
                    YN("text-muted text-end"),
                    W_("Total des compl\xe9ments")
                ]), A([
                    nQ(ow(r))
                ]))
            ]))
        ])), e));
    }), kQ = F2(function(n, e) {
        var r = e.fB, t = e.dv, u = e.hA, a = {
            i: A2(Pc, function(n) {
                return n.cR;
            }, r.i),
            mj: r.a_.mj,
            P: r.P,
            jo: r.jo
        }, i = ZB(a), c = A3(aQ, n, a, e);
        return A2(__, A([
            YN("ElementFormWrapper list-group-item")
        ]), k($Q(c), A([
            function() {
                if (19 === t.kj) {
                    var n = A2(QJ, r.a_.lL, r.P);
                    return A2(xQ, {
                        S: n,
                        ai: "Services ecosyst\xe9miques"
                    }, A2(wu, function(n) {
                        var e = n.ek, r = n.d_;
                        return A2(WN, A([
                            YN("ElementComplement"),
                            W_(e)
                        ]), A([
                            A2(m_, A([
                                YN("ComplementName d-flex align-items-center text-nowrap text-muted")
                            ]), A([
                                c_(e),
                                A2(vQ, A([
                                    QN(xJ(0)),
                                    _H("_blank")
                                ]), A([
                                    AY
                                ]))
                            ])),
                            A2(WN, A([
                                YN("ComplementValue d-flex justify-content-end align-items-center text-muted")
                            ]), j),
                            A2(WN, A([
                                YN("ComplementImpact text-black-50 text-muted text-end")
                            ]), A([
                                c_("("),
                                nQ(r),
                                c_(")")
                            ]))
                        ]));
                    }, A([
                        {
                            d_: A2(Nc, 0, n.ah),
                            ek: kY
                        },
                        {
                            d_: A2(Nc, 0, n.am),
                            ek: yY
                        },
                        {
                            d_: A2(Nc, 0, n.ag),
                            ek: xY
                        },
                        {
                            d_: A2(Nc, 0, n.al),
                            ek: jY
                        }
                    ])));
                }
                return c_("");
            }(),
            A4(mQ, n, r, a, i),
            A2(m_, A([
                YN("text-black-50 text-end ElementTransportImpact fs-8"),
                W_("Impact du transport pour cet ingr\xe9dient")
            ]), A([
                c_("(+ "),
                u,
                c_(")")
            ]))
        ])));
    }), jQ = F4(function(n, e, r, t) {
        var u = A2(LA, function(n) {
            return n.ek;
        }, A2(VB, A2(wu, A2(Hu, function(n) {
            return n.a_;
        }, function(n) {
            return n.mj;
        }), r.mq), n.l5.mq)), a = A2(QB, function(n) {
            return n.ek;
        }, u);
        return A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between"),
                jB(vB)
            ]), A([
                A2(I_, A([
                    YN("h5 mb-0"),
                    yH("materials-stage")
                ]), A([
                    c_("Ingr\xe9dients"),
                    A2(kJ, A([
                        ZN(A2(bd, ls, Sm(Ur))),
                        W_("Explorer"),
                        A2(n_, "aria-label", "Explorer")
                    ]), A([
                        vY
                    ]))
                ])),
                A2(m_, j, A([
                    A2(tW, e, t.bm.gH),
                    A2(_B, A([
                        YN("btn btn-secondary ms-2 py-1"),
                        QN(xJ(3)),
                        W_("Documentation"),
                        _H("_blank")
                    ]), A([
                        AY
                    ]))
                ]))
            ])),
            A2(B_, A([
                YN("CardList list-group list-group-flush")
            ]), k(sf(r.mq) ? A([
                A2(__, A([
                    YN("list-group-item")
                ]), A([
                    c_("Aucun ingr\xe9dient")
                ]))
            ]) : A2(wu, function(u) {
                return A2(kQ, n, {
                    bb: A2(wu, A2(Hu, function(n) {
                        return n.a_;
                    }, function(n) {
                        return n.mj;
                    }), r.mq),
                    O: A2(Nc, Ks, A2(Pc, Gh, A2(xs, function(n) {
                        return s(n.a, u);
                    }, t.bm.mq))),
                    fB: u,
                    dv: e,
                    hA: A2(tW, e, A2(BJ, n, u).g)
                });
            }, r.mq), A([
                A2(__, A([
                    YN("list-group-item p-0")
                ]), A([
                    A2(e_, A([
                        YN("btn btn-outline-primary"),
                        YN("d-flex justify-content-center align-items-center"),
                        YN(" gap-1 w-100"),
                        yH("add-new-element"),
                        E_(sf(u)),
                        i_(kc(A2(vO, Ur, a)))
                    ]), A([
                        A2(l_, A([
                            YN("icon icon-plus")
                        ]), j),
                        c_("Ajouter un ingr\xe9dient")
                    ]))
                ]))
            ])))
        ]);
    }), yQ = function(n) {
        return {
            $: 8,
            a: n
        };
    }, wQ = F2(function(n, e) {
        return {
            $: 41,
            a: n,
            b: e
        };
    }), AQ = function(n) {
        return A2(Hu, Fh(NC), Ah(function(e) {
            return !A2(el, e.mj, n);
        }));
    }, TQ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, EQ = F2(function(n, e) {
        return A2(WN, A([
            YN("input-group")
        ]), A([
            A2(e_, A([
                YN("form-select ElementSelector text-start"),
                yH("selector-" + qs(n.mj)),
                W_(Hb(n)),
                i_(e)
            ]), A([
                A2(m_, j, A([
                    c_(Gb(n))
                ]))
            ])),
            A2(e_, A([
                o_("button"),
                YN("input-group-text"),
                W_("Ouvrir les informations d\xe9taill\xe9es"),
                i_(kc(TQ(n)))
            ]), A([
                AY
            ]))
        ]));
    }), CQ = F4(function(n, e, r, t) {
        var u = A2(LA, Gb, A2(AQ, A2(wu, A2(Hu, function(n) {
            return n.t;
        }, function(n) {
            return n.mj;
        }), r.cs), n.W)), a = A2(QB, Gb, u);
        return A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between"),
                jB(gB)
            ]), A([
                A2(I_, A([
                    YN("h5 mb-0"),
                    yH("packaging-stage")
                ]), A([
                    c_("Emballage")
                ])),
                A2(m_, j, A([
                    A2(tW, e, t.cs),
                    A2(_B, A([
                        YN("btn btn-secondary ms-2 py-1"),
                        QN(xJ(4)),
                        W_("Documentation"),
                        _H("_blank")
                    ]), A([
                        AY
                    ]))
                ]))
            ])),
            A2(B_, A([
                YN("CardList list-group list-group-flush")
            ]), k(sf(r.cs) ? A([
                A2(__, A([
                    YN("list-group-item")
                ]), A([
                    c_("Aucun emballage")
                ]))
            ]) : A2(wu, function(t) {
                return function(n) {
                    var e = n.cK, r = n.cs, t = n.O, u = n.dJ, a = n.c$;
                    return A2(__, A([
                        YN("ElementFormWrapper list-group-item")
                    ]), A([
                        A2(m_, A([
                            YN("QuantityInputWrapper")
                        ]), A([
                            1 === r.t.aL ? A2(WN, A([
                                YN("input-group")
                            ]), A([
                                A2(N_, A([
                                    YN("form-control text-end incdec-arrows-left"),
                                    o_("number"),
                                    tQ("1"),
                                    hG(Js(r.j)),
                                    W_("Nombre d\u2019\xe9l\xe9ments"),
                                    mG(function(n) {
                                        var e = pp(n);
                                        return e.$ ? AO : u({
                                            j: e.a,
                                            mj: r.t.mj
                                        });
                                    }),
                                    rQ("0")
                                ]), j)
                            ])) : uQ({
                                bY: !1,
                                P: r.j,
                                fw: function(n) {
                                    return n.$ ? AO : u({
                                        j: n.a,
                                        mj: r.t.mj
                                    });
                                }
                            })
                        ])),
                        A2(EQ, r.t, kc(A2(hO, zr({
                            j: r.j,
                            mj: r.t.mj
                        }), e))),
                        A2(m_, A([
                            YN("text-end ImpactDisplay fs-7")
                        ]), A([
                            t
                        ])),
                        A2(PB, {
                            bY: !1
                        }, a)
                    ]));
                }({
                    cK: a,
                    c$: yQ(t.t.mj),
                    bb: A2(wu, A2(Hu, function(n) {
                        return n.t;
                    }, function(n) {
                        return n.mj;
                    }), r.cs),
                    O: A2(tW, e, nY(t)),
                    cs: t,
                    W: A2(Fh, NC, n.W),
                    dJ: wQ(t.t.mj)
                });
            }, r.cs), A([
                A2(__, A([
                    YN("list-group-item p-0")
                ]), A([
                    A2(e_, A([
                        YN("btn btn-outline-primary"),
                        YN("d-flex justify-content-center align-items-center"),
                        YN(" gap-1 w-100"),
                        yH("add-new-element"),
                        E_(sf(u)),
                        i_(kc(A2(hO, Ur, a)))
                    ]), A([
                        A2(l_, A([
                            YN("icon icon-plus")
                        ]), j),
                        c_("Ajouter un emballage")
                    ]))
                ]))
            ])))
        ]);
    }), IQ = {
        $: 4
    }, SQ = {
        $: 27
    }, OQ = function(n) {
        return {
            $: 44,
            a: n
        };
    }, LQ = F4(function(n, e, r, t) {
        return A2(vG, A([
            YN("form-select form-select"),
            mG(A2(Hu, qE, A2(Hu, fs(e), Zg(AO))))
        ]), A2(wu, function(e) {
            return A2(pG, A([
                gG(s(n, e.mj)),
                hG(qs(e.mj)),
                E_(A2(el, e.mj, r))
            ]), A([
                c_(Gb(e))
            ]));
        }, A2(LA, function(n) {
            return Gb(n);
        }, A2(Rh, A([
            ls
        ]), t))));
    }), PQ = F4(function(n, e, r, t) {
        var u = A2(tW, e, t.bm.fX);
        return A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between"),
                jB(hB)
            ]), A([
                A2(I_, A([
                    YN("h5 mb-0"),
                    yH("transform-stage")
                ]), A([
                    c_("Transformation")
                ])),
                A2(m_, j, A([
                    u,
                    A2(_B, A([
                        YN("btn btn-secondary ms-2 py-1"),
                        QN(xJ(6)),
                        W_("Documentation"),
                        _H("_blank")
                    ]), A([
                        AY
                    ]))
                ]))
            ])),
            A2(B_, A([
                YN("CardList list-group list-group-flush border-top-0 border-bottom-0")
            ]), A([
                function() {
                    var e = r.fX;
                    if (e.$) return LB({
                        d3: IQ,
                        ec: !1,
                        gJ: "une transformation"
                    });
                    var t = e.a;
                    return function(n) {
                        var e = n.W, r = n.bb, t = n.g3, u = n.O, a = n.dJ, i = n.c$;
                        return A2(__, A([
                            YN("ElementFormWrapper list-group-item")
                        ]), A([
                            A2(m_, A([
                                YN("QuantityInputWrapper")
                            ]), A([
                                uQ({
                                    bY: !1,
                                    P: t.P,
                                    fw: function(n) {
                                        return n.$ ? AO : a($(t, {
                                            P: n.a
                                        }));
                                    }
                                })
                            ])),
                            A4(LQ, t.mj, function(n) {
                                return a($(t, {
                                    mj: n
                                }));
                            }, r, A2(LA, Gb, e)),
                            A2(m_, A([
                                YN("text-end ImpactDisplay fs-7")
                            ]), A([
                                u
                            ])),
                            A2(PB, {
                                bY: !1
                            }, i)
                        ]));
                    }({
                        c$: SQ,
                        bb: A([
                            t.t.mj
                        ]),
                        O: u,
                        g3: {
                            mj: t.t.mj,
                            P: t.P
                        },
                        W: eL(n),
                        dJ: OQ
                    });
                }()
            ]))
        ]);
    }), qQ = function(n) {
        return A([
            c_(" + Emballage : "),
            pV(tY(n))
        ]);
    }, NQ = F2(function(n, e) {
        return A2(WN, A([
            YN("d-flex justify-content-between text-muted")
        ]), A([
            A2(m_, A([
                YN("w-50 fs-7 py-4 text-end"),
                A2(qH, "padding", ".5rem 1rem")
            ]), n),
            A2(WN, A([
                YN("DownArrow")
            ]), j),
            A2(WN, A([
                YN("w-50 fs-7 py-4"),
                A2(qH, "padding", ".5rem 1rem")
            ]), e)
        ]));
    }), _Q = F2(function(n, e) {
        return A2(NQ, j, k(A([
            c_("Masse : "),
            pV(e.g1)
        ]), qQ(n)));
    }), zQ = F2(function(n, e) {
        return A2(NQ, j, k(A([
            c_("Masse : "),
            pV(A2(iY, n, e))
        ]), qQ(e)));
    }), UQ = F4(function(n, e, r, t) {
        return A2(NQ, j, A([
            A2(WN, j, k(A([
                c_("Masse : "),
                pV(A2(iY, n, r))
            ]), qQ(r))),
            A2(WN, A([
                YN("d-flex justify-content-between")
            ]), A([
                A2(WN, j, A2(bQ, {
                    f6: Ur,
                    gy: !1,
                    gD: !0,
                    es: !1,
                    g8: Ur,
                    hc: Ur
                }, t.E.af)),
                A2(m_, j, A([
                    A2(tW, e, t.E.af.g),
                    A2(vQ, A([
                        QN(xJ(7)),
                        _H("_blank")
                    ]), A([
                        AY
                    ]))
                ]))
            ]))
        ]));
    }), MQ = F3(function(n, e, r) {
        var t;
        return A2(NQ, j, A([
            A2(WN, j, A([
                c_("Masse comestible\xa0: "),
                pV(r.bm.lM),
                A2(kJ, A([
                    QN(xJ(2)),
                    W_("Acc\xe9der \xe0 la documentation"),
                    A2(n_, "aria-label", "Acc\xe9der \xe0 la documentation")
                ]), A([
                    AY
                ]))
            ])),
            (t = e.fX, t.$ ? c_("") : A2(WN, j, A([
                A2(m_, A([
                    W_("(" + Gb(t.a.t) + ")")
                ]), A([
                    c_("Masse apr\xe8s transformation : ")
                ])),
                pV(A2(iY, n, e)),
                A2(kJ, A([
                    QN(xJ(5)),
                    W_("Acc\xe9der \xe0 la documentation"),
                    A2(n_, "aria-label", "Acc\xe9der \xe0 la documentation")
                ]), A([
                    AY
                ]))
            ])))
        ]));
    }), DQ = F2(function(n, e) {
        return A2(NQ, j, A([
            A2(WN, j, A([
                c_("Masse : "),
                pV(e.bm.ms)
            ])),
            A2(WN, A([
                YN("d-flex justify-content-between")
            ]), A([
                A2(WN, A([
                    YN("d-flex justify-content-between gap-3")
                ]), A2(bQ, {
                    f6: Ur,
                    gy: !1,
                    gD: !0,
                    es: !0,
                    g8: Ur,
                    hc: Ur
                }, e.bm.af)),
                A2(m_, j, A([
                    A2(tW, n, e.bm.af.g),
                    A2(vQ, A([
                        QN(xJ(7)),
                        _H("_blank")
                    ]), A([
                        AY
                    ]))
                ]))
            ]))
        ]));
    }), RQ = F5(function(n, e, r, t, u) {
        var a = n.l5, i = r.O, c = r.dd;
        return A2(WN, j, A([
            A2(WN, A([
                YN("card shadow-sm")
            ]), A4(jQ, n, i, t, u)),
            A2(DQ, i, u),
            A2(WN, A([
                YN("card shadow-sm")
            ]), A4(PQ, n, i, t, u)),
            A3(MQ, a.pQ, t, u),
            A2(WN, A([
                YN("card shadow-sm")
            ]), A4(CQ, n, i, t, u)),
            A4(UQ, a.pQ, i, t, u),
            A2(WN, A([
                YN("card shadow-sm")
            ]), A3(XB, i, t, u)),
            A2(zQ, a.pQ, t),
            A2(WN, A([
                YN("card shadow-sm")
            ]), A4(zB, n, i, t, u)),
            A2(_Q, t, u),
            A2(WN, A([
                YN("d-flex align-items-center justify-content-between mt-3 mb-5")
            ]), A([
                A2(VN, A([
                    ZN(gd)
                ]), A([
                    c_("\xab Retour \xe0 l'accueil")
                ])),
                A2(e_, A([
                    YN("btn btn-secondary"),
                    i_(CB),
                    E_(s(e.an.l5, c))
                ]), A([
                    c_("R\xe9initialiser le produit")
                ]))
            ]))
        ]));
    }), FQ = F2(function(n, e) {
        return A2(Nc, "Produit personnalis\xe9", q$(A2(qa, function(n) {
            var r = n.ek;
            return s(e, n.g5) ? zr(r) : Ur;
        }, n)));
    }), HQ = function(n) {
        var e = A2(QB, FQ(n.lT), A2(wu, function(n) {
            return n.g5;
        }, A2(LA, function(n) {
            return n.ek;
        }, n.lT)));
        return A2(WN, A([
            YN("d-flex flex-row justify-content-between align-items-start gap-3")
        ]), A([
            A2(gX, A([
                vX("selector-example"),
                YN("form-label fw-bold lh-lg mb-0")
            ]), A([
                c_("Exemples")
            ])),
            A2(WN, A([
                YN("d-flex justify-content-between align-items-center flex-fill text-truncate")
            ]), A([
                A2(e_, A([
                    YN("form-select ElementSelector text-start"),
                    yH("selector-example"),
                    W_("Les simulations propos\xe9es ici constituent des exemples. Elles doivent \xeatre adapt\xe9es pour chaque produit mod\xe9lis\xe9"),
                    i_(n.nu(e))
                ]), A([
                    c_(A2(FQ, n.lT, n.lc))
                ])),
                function() {
                    var e = n.mf;
                    if (e.$) return c_("");
                    var r = e.a;
                    return A2(m_, A([
                        YN("input-group-text")
                    ]), A([
                        A2(VN, A([
                            YN("text-secondary text-decoration-none p-0"),
                            QN(xJ(r)),
                            _H("_blank")
                        ]), A([
                            b_
                        ]))
                    ]));
                }()
            ]))
        ]));
    }, GQ = F2(function(n, e) {
        var r = n.C, t = A2(lY, r, n.an.l5);
        return A2(WN, A([
            YN("row gap-3 gap-lg-0")
        ]), A([
            A2(WN, A([
                YN("col-lg-8 d-flex flex-column gap-3")
            ]), A([
                HQ({
                    lc: n.an.l5,
                    lQ: mT,
                    lT: r.l5.lT,
                    mf: Ur,
                    nu: A2(Hu, SO, kc),
                    oh: {
                        lW: A2(bd, ls, kd(Ur)),
                        mN: pd,
                        on: vd
                    }
                }),
                function() {
                    if (1 === t.$) return $K(t.a);
                    var u = t.a;
                    return A5(RQ, r, n, e, u.a, u.b);
                }(),
                A2(hK, r, n.an.l5)
            ])),
            A2(WN, A([
                YN("col-lg-4 d-flex flex-column gap-3")
            ]), A([
                1 === t.$ ? $K(t.a) : A3(EB, n, e, t.a.b)
            ]))
        ]));
    }), XQ = F2(function(n, e) {
        return A2(Nc, "", q$(A2(qa, function(n) {
            var r = n.h0;
            return s(e, n.g5) ? zr(r) : Ur;
        }, n)));
    }), VQ = function(n) {
        return A2(JN, "autocomplete", n ? "on" : "off");
    }, JQ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, YQ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, WQ = F2(function(n, e) {
        var r, t = n.mX;
        return A([
            i_(n.nv),
            A2(XG, "mousedown", nu(v(t(JQ(e)), !0))),
            (r = t(YQ(e)), A2(a_, "mouseup", nu(r)))
        ]);
    }), KQ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, BQ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, QQ = function(n) {
        var e = n.nv, r = n.mX;
        return A2(Bt, function(n) {
            switch(n){
                case "ArrowUp":
                    return nu(v(r(BQ(0)), !0));
                case "ArrowDown":
                    return nu(v(r(BQ(1)), !0));
                case "Enter":
                    return nu(v(e, !0));
                default:
                    return Ii("Ignore other keys");
            }
        }, A2(qu, "key", ai));
    }, ZQ = function(n) {
        return A([
            mG(A2(cc, n.mX, KQ)),
            A2(XG, "keydown", QQ(n))
        ]);
    }, nZ = F2(function(n, e) {
        return 1 !== n.$ && s(n.a, e);
    }), eZ = F5(function(n, e, r, t, u) {
        var a = n.hw, i = n.hx, c = A2(nZ, r, t);
        return A2(e_, k(e(t), A([
            o_("button"),
            YN("AutocompleteChoice"),
            YN("d-flex justify-content-between align-items-center gap-1 w-100"),
            YN("btn btn-outline-primary border-0 border-bottom text-start no-outline"),
            r_(A([
                v("btn-primary selected", c)
            ])),
            A2(n_, "role", "option"),
            A2(n_, "aria-selected", c ? "true" : "false")
        ])), A([
            A2(m_, A([
                YN("text-nowrap")
            ]), A([
                c_(i(u))
            ])),
            A2(m_, A([
                YN("text-muted fs-8 text-truncate")
            ]), A([
                c_(a(u))
            ]))
        ]));
    }), rZ = function(n) {
        var e, r, t, u, a, i, c, o = n.l6, f = n.gT, s = n.gU, l = n.g0, d = n.eG;
        return JG({
            h4: n.ge,
            h9: (r = function(n) {
                return {
                    h3: n.h3,
                    mk: n.mk,
                    g5: n.g5,
                    ox: n.ox,
                    j3: n.dL
                };
            }(n.cK), t = r.h3, u = r.g5, a = r.ox, i = {
                kW: WQ(e = {
                    mX: f,
                    nv: s
                }),
                mt: ZQ(e)
            }, c = i.kW, A([
                A2(N_, k(i.mt, A([
                    o_("search"),
                    yH("element-search"),
                    YN("form-control"),
                    VQ(!1),
                    A2(n_, "role", "combobox"),
                    A2(n_, "aria-autocomplete", "list"),
                    A2(n_, "aria-owns", "element-autocomplete-choices"),
                    kX(l),
                    hG(u)
                ])), j),
                A2(WN, A([
                    YN("ElementAutocomplete"),
                    yH("element-autocomplete-choices")
                ]), A2(bt, A3(eZ, n, c, a), t))
            ])),
            l6: o,
            l7: Ur,
            oE: 2,
            oM: Ur,
            eG: d
        });
    }, tZ = F2(function(n, e) {
        return {
            q: n(e.q),
            E: n(e.E),
            _: n(e._),
            ft: n(e.ft),
            cs: n(e.cs),
            fX: n(e.fX),
            af: n(e.af),
            pf: n(e.pf),
            kl: n(e.kl)
        };
    }), uZ = function(n) {
        var e, r;
        return A3(ot, F2(function(n, e) {
            var r = n.g, t = n.av;
            if (t.$) return e;
            switch(t.a){
                case 0:
                    return $(e, {
                        q: A2(Pc, function(n) {
                            return lh(A([
                                n,
                                r
                            ]));
                        }, e.q)
                    });
                case 1:
                    return $(e, {
                        ft: A2(Pc, function(n) {
                            return lh(A([
                                n,
                                r
                            ]));
                        }, e.ft)
                    });
                case 2:
                    return $(e, {
                        fX: A2(Pc, function(n) {
                            return lh(A([
                                n,
                                r
                            ]));
                        }, e.fX)
                    });
                default:
                    return $(e, {
                        af: A2(Pc, function(n) {
                            return lh(A([
                                n,
                                r
                            ]));
                        }, e.af)
                    });
            }
        }), {
            q: (r = xA(n.q), s(r, Ks) ? Ur : zr(r)),
            E: zr(n.E.g),
            _: zr(n._),
            ft: zr(Ks),
            cs: zr(lh(n.cs)),
            fX: zr(Ks),
            af: zr((e = n.af, lh(A([
                e.eH.g,
                e.eJ.g
            ])))),
            pf: Ur,
            kl: zr(lh(n.bK))
        }, A2(Id, hx, A2(Id, hx, hx(n.Q))));
    }, aZ = function(n) {
        return A2(Hu, uZ, tZ(Pc(ch(n))));
    }, iZ = function(n) {
        return tZ(Pc(_h(n)));
    }, cZ = F2(function(n, e) {
        var r = function(n) {
            return A2(Nc, Ks, A2(Pc, function(n) {
                return n.g;
            }, A2(Ny, n, A2(Iy, function(n) {
                return n.gt;
            }, e.ac))));
        }, t = A2(Hu, ch(n), zr), u = function(r) {
            return 19 === n ? Pc(uh(A2(bh, Zj(e.aO), A2(Nc, 0, r)))) : ru;
        };
        return A2(iZ, Zj(e.aO), {
            q: Ur,
            E: Ur,
            _: A2(u, e.S.ak, t(r(1))),
            ft: A2(u, e.S.aj, t(r(5))),
            cs: Ur,
            fX: t(lh(A([
                r(6),
                r(3),
                r(2),
                r(4)
            ]))),
            af: t(e.eN.g),
            pf: t(e.dF),
            kl: t(r(7))
        });
    }), oZ = F2(function(n, e) {
        var r = n.h8, t = n.C, u = e.ek, a = e.g5;
        switch(a.$){
            case 0:
                return A2(fs, function(n) {
                    var e = n.b;
                    return {
                        cU: e.bm.kf,
                        g: e.bI,
                        ai: u,
                        ez: A2(_K, 19, e)
                    };
                }, A2(lY, t, a.a));
            case 1:
                var i = a.b;
                return A2(fs, function(n) {
                    return {
                        cU: A2(O$, Pc(ch(19)), NY(n.Q)),
                        g: zY(n),
                        ai: u,
                        ez: A2(aZ, 19, n)
                    };
                }, A2(Yx, {
                    az: r,
                    C: t,
                    at: ds(a.a)
                }, i));
            default:
                return A2(fs, function(n) {
                    return {
                        cU: n.S,
                        g: n.g,
                        ai: u,
                        ez: A2(cZ, 19, n)
                    };
                }, A3(QA, t, r, a.a));
        }
    }), fZ = function(n) {
        switch(n){
            case 0:
                return "individual-impacts";
            case 1:
                return "stages-impacts";
            case 2:
                return "grouped-impacts";
            default:
                return "total-impacts";
        }
    }, sZ = function(n) {
        return qc(A([
            v("name", Sc(n.ek)),
            v("y", No(n.eT)),
            v("color", Sc(n.dY))
        ]));
    }, lZ = function(n) {
        return A2(Hu, To(function(e) {
            return qc(A([
                v("label", Sc(e.ai)),
                v("data", A2(To, sZ, n(e)))
            ]));
        }), tt(0));
    }, dZ = S, bZ = F2(function(n, e) {
        var r, t = e.cU, u = e.g, a = Mi(A2(bt, F2(function(n, e) {
            return v(e, n);
        }), A([
            "Changement climatique",
            "Biodiversit\xe9 locale",
            "Acidification",
            "Eutrophisation terrestre",
            "Eutrophisation eaux douces",
            "Eutrophisation marine",
            "\xc9cotoxicit\xe9 de l'eau douce, corrig\xe9e",
            "Utilisation des sols",
            "Appauvrissement de la couche d'ozone",
            "Radiations ionisantes",
            "Formation d'ozone photochimique",
            "Toxicit\xe9 humaine - non-cancer, corrig\xe9e",
            "Toxicit\xe9 humaine - cancer, corrig\xe9e",
            "Particules",
            "Utilisation de ressources en eau",
            "Utilisation de ressources fossiles",
            "Utilisation de ressources min\xe9rales et m\xe9talliques"
        ]))), i = F2(function(n, e) {
            var r = function(n) {
                return A2(ra, n.ek, a);
            }, t = v(r(n), r(e));
            return t.a.$ || t.b.$ ? 1 : m(t.a.a, t.b.a) > 0 ? 2 : 0;
        });
        return xt(k(A([
            {
                dY: "#606060",
                ek: "Services \xe9cosyst\xe9miques",
                eT: yB(r = t)
            },
            {
                dY: "#c0c0c0",
                ek: "Compl\xe9ment microfibres",
                eT: A2(Nc, 0, A2(Pc, b$, r.aj))
            },
            {
                dY: "#e0e0e0",
                ek: "Compl\xe9ment export hors-Europe",
                eT: A2(Nc, 0, A2(Pc, b$, r.ak))
            },
            {
                dY: "#f1f1f1",
                ek: "Compl\xe9ment " + eW.aa,
                eT: A2(Nc, 0, A2(Pc, b$, r.aa))
            }
        ]), A2(dZ, i, A3(lB, n, function(n) {
            return n.it;
        }, u))));
    }), mZ = function(n) {
        var e;
        return xt(A2(wu, function(n) {
            return {
                dY: n.c,
                ek: n.a,
                eT: A2(Nc, 0, A2(Pc, b$, n.b))
            };
        }, A([
            g("Accessoires", (e = n.ez).pf, xB),
            g("Mati\xe8res premi\xe8res", e.ft, vB),
            g("Transformation", e.fX, hB),
            g("Assemblage", e.q, bB),
            g("Emballage", e.cs, gB),
            g("Transports", e.af, $B),
            g("Distribution", e.E, mB),
            g("Utilisation", e.kl, kB),
            g("Fin de vie", e._, pB)
        ])));
    }, pZ = F2(function(n, e) {
        var r, t, u, a, i, c, o = e.cU;
        return u = (r = A2(UJ, n, e.g)).kJ, a = r.kZ, i = r.md, c = r.ob, xt(A([
            (t = o, {
                dY: "#808080",
                ek: "Compl\xe9ments",
                eT: ow(t)
            }),
            {
                dY: "#9025be",
                ek: "Climat",
                eT: a
            },
            {
                dY: "#00b050",
                ek: "Biodiversit\xe9",
                eT: u
            },
            {
                dY: "#ffc000",
                ek: "Sant\xe9 environnementale",
                eT: i
            },
            {
                dY: "#0070c0",
                ek: "Ressource",
                eT: c
            }
        ]));
    }), vZ = function(n) {
        return A([
            {
                dY: "#333333",
                ek: "Impact total",
                eT: A2(ch, 19, n.g)
            }
        ]);
    }, gZ = F2(function(n, e) {
        switch(n){
            case 0:
                return bZ(e);
            case 1:
                return mZ;
            case 2:
                return pZ(e);
            default:
                return vZ;
        }
    }), hZ = function(n) {
        var e = n.ey, r = Vg(A2(qa, function(n) {
            return A2(aJ, RO(n), e.bH.aX) ? zr(A2(oZ, function(n) {
                return {
                    h8: n.h8,
                    C: n.C
                };
            }(e), n)) : Ur;
        }, e.bH.ap));
        return A([
            A2(B_, A([
                YN("Tabs nav nav-tabs nav-fill justify-content-end gap-3 mt-2 px-2")
            ]), A2(wu, function(e) {
                var r = e.a, t = e.b;
                return A2(__, A([
                    YN("TabsTab nav-item"),
                    r_(A([
                        v("active", s(n.cT, t))
                    ]))
                ]), A([
                    A2(e_, A([
                        YN("nav-link no-outline border-top-0 py-1"),
                        r_(A([
                            v("active", s(n.cT, t))
                        ])),
                        i_(n.oQ(t))
                    ]), A([
                        c_(r)
                    ]))
                ]));
            }, k(Nl(e) ? A([
                v("Sous-scores", 2),
                v("Impacts", 0)
            ]) : j, A([
                v("\xc9tapes", 1),
                v("Total", 3)
            ])))),
            function() {
                if (1 === r.$) return f_({
                    hS: j,
                    h4: Ur,
                    h9: A([
                        c_(r.a)
                    ]),
                    ed: 0,
                    eG: zr("Erreur")
                });
                if (r.a.b) {
                    var t = r.a;
                    return A2(WN, A([
                        YN("h-100 " + fZ(n.cT))
                    ]), A([
                        A3(iX, "ecobalyse-comparator", A([
                            A2(n_, "data", A2(lZ, A2(gZ, n.cT, e.C.c_), t))
                        ]), j)
                    ]));
                }
                return A2(D_, A([
                    YN("d-flex h-100 justify-content-center align-items-center pb-5")
                ]), A([
                    c_("S\xe9lectionnez une ou plusieurs simulations pour les comparer")
                ]));
            }()
        ]);
    }, $Z = ve("draggable"), xZ = function(n) {
        return A2(a_, "dragleave", nu(n));
    }, kZ = function(n) {
        return A2(XG, "dragover", nu(v(n, !0)));
    }, jZ = function(n) {
        return A2(XG, "drop", nu(v(n, !0)));
    }, yZ = function(n) {
        return A([
            A2(WN, A([
                YN("p-2 ps-3 mb-0 text-muted")
            ]), A([
                c_("S\xe9lectionnez des simulations pour les comparer")
            ])),
            A2(WN, A([
                YN("text-center")
            ]), A([
                A2(e_, A([
                    YN("btn btn-sm btn-link pt-0"),
                    i_(n.os)
                ]), A([
                    c_("tout s\xe9lectionner")
                ])),
                A2(e_, A([
                    YN("btn btn-sm btn-link pt-0"),
                    i_(n.ou)
                ]), A([
                    c_("tout d\xe9s\xe9lectionner")
                ]))
            ])),
            A2(WN, A([
                YN("list-group list-group-flush overflow-x-hidden ComparatorList")
            ]), A2(wu, function(e) {
                var r, t = v(A2(VK, n.ey.C, e), A2(aJ, RO(e), n.ey.bH.aX)), u = t.a, a = t.b;
                return A2(gX, A([
                    YN("form-check-label list-group-item text-nowrap ps-3 ms-1"),
                    r_(A([
                        v("over", s(n.bv, zr(e)))
                    ])),
                    W_(u),
                    $Z("true"),
                    (r = n.nq(e), A2(a_, "dragstart", nu(r))),
                    xZ(n.no),
                    kZ(n.np(e)),
                    jZ(n.nr(e))
                ]), A([
                    A2(N_, A([
                        o_("checkbox"),
                        YN("form-check-input"),
                        xX(n.o3(e)),
                        w_(a)
                    ]), j),
                    A2(m_, A([
                        YN("d-inline-flex align-middle gap-2 ps-2")
                    ]), A([
                        A2(m_, A([
                            YN("me-2 fw-500")
                        ]), A([
                            c_(e.ek)
                        ])),
                        s(u, e.ek) ? c_("") : A2(m_, A([
                            YN("text-muted fs-7")
                        ]), A([
                            c_(u)
                        ]))
                    ]))
                ]));
            }, n.ey.bH.ap))
        ]);
    }, wZ = function(n) {
        return A2(cG, j, A([
            A2(WN, A([
                YN("row")
            ]), A([
                A2(WN, A([
                    YN("col-lg-4 border-end fs-7 p-0")
                ]), yZ(n)),
                A2(WN, A([
                    YN("col-lg-8 px-4 py-2 overflow-auto"),
                    A2(qH, "min-height", "500px")
                ]), hZ(n))
            ]))
        ]));
    }, AZ = F2(function(n, e) {
        return v("Constructeur de recette", A([
            A2(KN, A([
                YN("pb-3")
            ]), A([
                A2(GQ, n, e),
                function() {
                    var r = e.ad;
                    switch(r.$){
                        case 0:
                            return rZ({
                                cK: r.b,
                                ge: kc(xc),
                                l6: j,
                                gT: EO,
                                gU: nK,
                                g0: "tapez ici le nom de la mati\xe8re premi\xe8re pour la rechercher",
                                eG: "S\xe9lectionnez un ingr\xe9dient",
                                hw: A2(Hu, function(n) {
                                    return n.cP;
                                }, A2(Hu, q$, A2(Hu, Pc(TY), Nc("")))),
                                hx: function(n) {
                                    return n.ek;
                                }
                            });
                        case 1:
                            return rZ({
                                cK: r.b,
                                ge: kc(xc),
                                l6: j,
                                gT: CO,
                                gU: nK,
                                g0: "tapez ici le nom de de l\u2019emballage pour le rechercher",
                                eG: "S\xe9lectionnez un emballage",
                                hw: A2(Hu, function(n) {
                                    return n.cP;
                                }, A2(Hu, q$, A2(Hu, Pc(wC), Nc("")))),
                                hx: Gb
                            });
                        case 2:
                            return JG({
                                h4: kc(xc),
                                h9: A([
                                    wZ({
                                        bv: e.bv,
                                        cT: e.cT,
                                        O: e.O,
                                        no: eK,
                                        np: rK,
                                        nq: tK,
                                        nr: uK,
                                        os: aK,
                                        ou: iK,
                                        ey: n,
                                        oQ: cK,
                                        o3: oK
                                    })
                                ]),
                                l6: j,
                                l7: Ur,
                                oE: 0,
                                oM: zr("Co\xfbt environnemental, par produit \u26A0\uFE0F\xa0Attention, ces r\xe9sultats sont provisoires"),
                                eG: "Comparateur de simulations sauvegard\xe9es"
                            });
                        case 3:
                            var t = r.a;
                            return JG({
                                h4: kc(xc),
                                h9: A([
                                    PY(t)
                                ]),
                                l6: j,
                                l7: Ur,
                                oE: 2,
                                oM: Ur,
                                eG: t.ek
                            });
                        case 4:
                            var u = r.a;
                            return JG({
                                h4: kc(xc),
                                h9: A([
                                    A3(IV, ls, iW(n), u)
                                ]),
                                l6: j,
                                l7: Ur,
                                oE: 2,
                                oM: Ur,
                                eG: Gb(u)
                            });
                        case 5:
                            return c_("");
                        default:
                            return rZ({
                                cK: r.a,
                                ge: kc(xc),
                                l6: j,
                                gT: TO,
                                gU: nK,
                                g0: "tapez ici le nom du produit pour le rechercher",
                                eG: "S\xe9lectionnez un produit",
                                hw: XQ(n.C.l5.lT),
                                hx: FQ(n.C.l5.lT)
                            });
                    }
                }()
            ]))
        ]));
    }), TZ = {
        $: 14
    }, EZ = {
        $: 15
    }, CZ = {
        $: 16
    }, IZ = {
        $: 17
    }, SZ = F3(function(n, e, r) {
        return {
            $: 18,
            a: n,
            b: e,
            c: r
        };
    }), OZ = {
        $: 19
    }, LZ = {
        $: 20
    }, PZ = function(n) {
        return {
            $: 21,
            a: n
        };
    }, qZ = function(n) {
        return {
            $: 22,
            a: n
        };
    }, NZ = function(n) {
        return {
            $: 23,
            a: n
        };
    }, _Z = {
        $: 34
    }, zZ = {
        $: 35
    }, UZ = function(n) {
        return {
            $: 39,
            a: n
        };
    }, MZ = F2(function(n, e) {
        return {
            $: 42,
            a: n,
            b: e
        };
    }), DZ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, RZ = function(n) {
        return {
            $: 25,
            a: n
        };
    }, FZ = function(n) {
        return {
            $: 26,
            a: n
        };
    }, HZ = function(n) {
        return {
            $: 27,
            a: n
        };
    }, GZ = function(n) {
        return {
            $: 28,
            a: n
        };
    }, XZ = F2(function(n, e) {
        return {
            $: 29,
            a: n,
            b: e
        };
    }), VZ = function(n) {
        return {
            $: 30,
            a: n
        };
    }, JZ = function(n) {
        return {
            $: 36,
            a: n
        };
    }, YZ = function(n) {
        return {
            $: 43,
            a: n
        };
    }, WZ = function(n) {
        return {
            $: 44,
            a: n
        };
    }, KZ = function(n) {
        return {
            $: 45,
            a: n
        };
    }, BZ = F2(function(n, e) {
        return {
            $: 47,
            a: n,
            b: e
        };
    }), QZ = F2(function(n, e) {
        return {
            $: 48,
            a: n,
            b: e
        };
    }), ZZ = F2(function(n, e) {
        return {
            $: 49,
            a: n,
            b: e
        };
    }), n1 = function(n) {
        return {
            $: 52,
            a: n
        };
    }, e1 = F2(function(n, e) {
        return {
            $: 54,
            a: n,
            b: e
        };
    }), r1 = F2(function(n, e) {
        return {
            $: 55,
            a: n,
            b: e
        };
    }), t1 = F3(function(n, e, r) {
        return {
            $: 56,
            a: n,
            b: e,
            c: r
        };
    }), u1 = F2(function(n, e) {
        return {
            $: 57,
            a: n,
            b: e
        };
    }), a1 = F2(function(n, e) {
        return {
            $: 58,
            a: n,
            b: e
        };
    }), i1 = function(n) {
        return {
            $: 60,
            a: n
        };
    }, c1 = nl(function(n) {
        return 2 === n.$;
    }), o1 = F2(function(n, e) {
        if (n) return {
            bN: "Ajouter un accessoire",
            bO: "Ajouter un \xe9l\xe9ment",
            b$: "\xc9l\xe9ment",
            b0: "\xc9l\xe9ments",
            b1: "Aucun accessoire",
            cj: "Libell\xe9 de l'accessoire",
            bf: "Nom de l'accessoire",
            en: "Accessoire",
            eo: "Accessoires",
            cw: "Accessoires",
            du: "tapez ici le nom de l\u2019accessoire pour le rechercher",
            or: "S\xe9lectionnez un accessoire"
        };
        n: for(; 1 === e.$;)switch(e.a){
            case 0:
                return {
                    bN: "Ajouter un composant",
                    bO: "Ajouter un mat\xe9riau",
                    b$: "Mat\xe9riau",
                    b0: "Mat\xe9riaux",
                    b1: "Aucun composant",
                    cj: "Libell\xe9 du composant",
                    bf: "Nom du composant",
                    en: "Composant",
                    eo: "Composants",
                    cw: "Composition",
                    du: "tapez ici le nom du composant pour le rechercher",
                    or: "S\xe9lectionnez un composant"
                };
            case 1:
                return {
                    bN: "Ajouter un ingr\xe9dient",
                    bO: "Ajouter un sous-ingr\xe9dient",
                    b$: "Sous-ingr\xe9dient",
                    b0: "Sous-ingr\xe9dients",
                    b1: "Aucun ingr\xe9dient",
                    cj: "Libell\xe9 de l'ingr\xe9dient",
                    bf: "Nom de l'ingr\xe9dient",
                    en: "Ingr\xe9dient",
                    eo: "Ingr\xe9dients",
                    cw: "Recette",
                    du: "tapez ici le nom de l\u2019ingr\xe9dient pour le rechercher",
                    or: "S\xe9lectionnez un ingr\xe9dient"
                };
            default:
                break n;
        }
        return {
            bN: "Ajouter un mat\xe9riau",
            bO: "Ajouter un sous-mat\xe9riau",
            b$: "Sous-mat\xe9riau",
            b0: "Sous-mat\xe9riaux",
            b1: "Aucun mat\xe9riau",
            cj: "Libell\xe9 du mat\xe9riau",
            bf: "Nom du mat\xe9riau",
            en: "Mat\xe9riau",
            eo: "Mat\xe9riaux",
            cw: "Production des mat\xe9riaux",
            du: "tapez ici le nom du mat\xe9riau pour le rechercher",
            or: "S\xe9lectionnez un mat\xe9riau"
        };
    }), f1 = F2(function(n, e) {
        var r = e.iE, t = ds(r);
        return {
            h8: n.h8,
            k2: 0,
            C: n.C,
            lh: !0,
            lu: e.bX,
            ly: Ur,
            lX: zr(A2(bd, t, A2(Cm, t, Ur))),
            b7: e.b7,
            O: e.O,
            mF: A2(o1, 0, t),
            ac: e.ac,
            nc: iP,
            nA: function(n) {
                return DZ(function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(n));
            },
            nB: A2(Hu, mP, DZ),
            nC: A2(Hu, pP, DZ),
            nD: A2(Hu, gP, DZ),
            nE: F4(function(n, e, r, t) {
                return DZ(A4(hP, n, e, r, t));
            }),
            nF: A2(Hu, eP, DZ),
            g5: A2(Zx, r, n),
            n3: RZ,
            n4: HZ,
            n5: GZ,
            n6: XZ,
            n7: FZ,
            n8: VZ,
            at: t,
            oz: JZ,
            o6: YZ,
            o7: WZ,
            pg: c1(e.M),
            pj: KZ,
            pl: ZZ,
            pp: n1,
            pr: e1,
            ps: r1,
            pt: t1,
            pw: BZ,
            px: QZ,
            py: u1,
            pE: a1,
            pG: i1
        };
    }), s1 = F2(function(n, e) {
        return f_({
            hS: j,
            h4: Ur,
            h9: A([
                c_(e)
            ]),
            ed: 0,
            eG: n
        });
    }), l1 = F3(function(n, e, r) {
        return A2(LA, Gb, A2(Fh, e, A2(Rh, A([
            n
        ]), A2(Ah, function(n) {
            return n.kn;
        }, r))));
    }), d1 = F2(function(n, e) {
        return A2(QB, Gb, A2(Ah, function(n) {
            return !A2(el, NC, n.cP);
        }, A3(l1, e, PC, n.W)));
    }), b1 = F2(function(n, e) {
        return A2(e_, A([
            o_("button"),
            YN("btn btn-primary"),
            YN("d-flex justify-content-center align-items-center gap-1"),
            i_(A4(n.nE, PC, e, Ur, A2(d1, n.C, n.at)))
        ]), A([
            rB,
            c_(n.mF.bO)
        ]));
    }), m1 = function(n) {
        return A2(ve, "colspan", ut(n));
    }, p1 = fe("dd"), v1 = fe("dt"), g1 = function(n) {
        return A2(Hu, Ah(function(e) {
            return !A2(el, e.mj, n);
        }), LA(Gb));
    }, h1 = function(n) {
        var e = n.b;
        return A2(Hu, PP(n.a), A2(Hu, xx(e), A2(Hu, Pc(function(n) {
            return n.J;
        }), A2(Hu, Pc(wu(function(n) {
            return n.mj;
        })), Nc(j)))));
    }, $1 = function(n) {
        var e = P$(n), r = F2(function(n, e) {
            return A2(Ah, function(n) {
                return A2(el, n, e);
            }, n);
        });
        return A2(Hu, Fh(UC), A2(Hu, qa(function(n) {
            var t = P$(n);
            return t.b ? sf(A2(r, e, t)) ? Ur : zr(n) : Ur;
        }), Ah(A2(Hu, function(n) {
            return n.aL;
        }, zt(n.aL)))));
    }, x1 = F3(function(n, e, r) {
        var t = n.C, u = n.nE, a = n.g5, i = n.at, c = r.a, o = r.b, f = A2(g1, A2(h1, v(c, o), a.my), A2(LA, Gb, A2($1, e, A2(Rh, A([
            i
        ]), A2(Ah, function(n) {
            return n.kn;
        }, t.W))))), s = A2(QB, Gb, f);
        return A2(e_, A([
            o_("button"),
            YN("btn btn-sm btn-outline-primary text-nowrap"),
            YN("d-flex align-items-center gap-1"),
            E_(sf(f)),
            i_(A4(u, UC, c, zr(o), s))
        ]), A([
            rB,
            c_("Ajouter une transformation")
        ]));
    }), k1 = {
        hI: c_(""),
        j: c_(""),
        i: c_(""),
        O: c_(""),
        ai: c_(""),
        pO: c_("")
    }, j1 = F2(function(n, e) {
        return A2(K_, n, A([
            A2(V_, A([
                YN("text-end align-middle text-nowrap ps-3 py-2"),
                A2(qH, "min-width", "130px"),
                A2(qH, "max-width", "150px")
            ]), A([
                e.j
            ])),
            A2(V_, A([
                YN("align-middle"),
                A2(qH, "min-width", "16rem")
            ]), A([
                e.ai
            ])),
            A2(V_, A([
                YN("text-end align-middle text-nowrap")
            ]), A([
                e.pO
            ])),
            A2(V_, A([
                YN("align-middle"),
                A2(qH, "min-width", "12rem")
            ]), A([
                e.i
            ])),
            A2(V_, A([
                YN("text-end align-middle text-nowrap")
            ]), A([
                e.O
            ])),
            A2(V_, A([
                YN("pe-3 text-end align-middle text-nowrap")
            ]), A([
                e.hI
            ]))
        ]));
    }), y1 = F2(function(n, e) {
        return A2(K_, A([
            YN("composition-section")
        ]), A([
            A2(V_, A([
                YN("p-3 pb-2"),
                m1(6)
            ]), A([
                A2(WN, A([
                    YN("d-flex justify-content-between align-items-center gap-2")
                ]), A([
                    A2(m_, A([
                        YN("fw-bold")
                    ]), A([
                        c_(n)
                    ])),
                    A2(Nc, c_(""), e)
                ]))
            ]))
        ]));
    }), w1 = {
        $: 1
    }, A1 = function(n) {
        return A3(Yb, ".", ",", Js(n));
    }, T1 = function(n) {
        var e = n.mj, r = n.eT, t = n.H;
        if (t.$) return A1(r);
        var u = t.a;
        return s(u.mj, e) ? A2(Nc, A1(r), u.c1) : A1(r);
    }, E1 = et(ht), C1 = function(n) {
        var e = A2(it, ".", A3(Yb, ",", ".", n));
        n: for(;;){
            if (e.b) {
                if (e.b.b) {
                    if (e.b.b.b) break n;
                    var r = e.b.a;
                    return E1(e.a) && E1(r);
                }
                return E1(e.a);
            }
            break n;
        }
        return !1;
    }, I1 = function(n) {
        var e = A3(Yb, ",", ".", n);
        return su(e) || A2(Hd, ".", e) || A2(gu, ".", e) ? Ur : pp(e);
    }, S1 = F2(function(n, e) {
        var r = n.mj, t = n.eT;
        return C1(e) ? zr({
            c1: zr(e),
            mj: r,
            eT: A2(Ba, function(n) {
                return n > 0 && !s(n, t) ? zr(n) : Ur;
            }, I1(e))
        }) : Ur;
    }), O1 = function(n) {
        var e = n.H;
        if (e.$) return !0;
        var r = e.a;
        if (s(r.mj, n.mj)) {
            var t = r.c1;
            if (t.$) return !0;
            var u = I1(t.a);
            return !u.$ && u.a > 0;
        }
        return !0;
    }, L1 = F4(function(n, e, r, t) {
        return A2(Ya, A3(Ib, n, e, r), t);
    }), P1 = function(n) {
        var e = n.nc;
        return A2(XG, "beforeinput", A2(Bt, function(n) {
            var r = n.a;
            return "insertText" !== r && "insertFromPaste" !== r || C1(n.b) ? Ii("accepted input") : nu(v(e, !0));
        }, A4(L1, A([
            "target",
            "selectionEnd"
        ]), xi, 0, A4(L1, A([
            "target",
            "selectionStart"
        ]), xi, 0, A3(ll, A([
            "target",
            "value"
        ]), ai, A4(Sb, "data", ai, "", A3(Wa, "inputType", ai, nu(F5(function(n, e, r, t, u) {
            return v(n, k(A2(lu, t, r), k(e, A2(ou, u, r))));
        })))))))));
    }, q1 = y_("spellcheck"), N1 = function(n) {
        return A2(N_, k(function(n) {
            var e = n.pS;
            if (e.$) return A([
                r_(A([
                    v("bg-warning-subtle", !O1(n))
                ])),
                hG(T1(n)),
                mG(function(e) {
                    return A2(Nc, n.nc, A2(Pc, n.nt, A2(S1, n, e)));
                }),
                EG(n.nt((r = n.mj, {
                    c1: Ur,
                    mj: r,
                    eT: Ur
                }))),
                P1(n)
            ]);
            var r, t = e.a;
            return A([
                YN("cursor-not-allowed"),
                IX(!0),
                W_(t),
                hG(A1(n.eT))
            ]);
        }(n), A([
            o_("text"),
            YN("form-control form-control-sm text-end"),
            yH(n.mj),
            A2(n_, "aria-label", n.ai),
            A2(n_, "autocomplete", "off"),
            A2(n_, "inputmode", "decimal"),
            q1(!1)
        ])), j);
    }, _1 = F2(function(n, e) {
        return A2(WN, A([
            YN("AmountInput input-group")
        ]), A([
            N1({
                mj: n.mj,
                ai: n.ai,
                nc: n.nc,
                nt: n.nt,
                H: n.H,
                eT: e,
                pS: n.pS
            }),
            A2(yX, A([
                YN("input-group-text fs-8")
            ]), A([
                c_(Th(n.aL))
            ]))
        ]));
    }), z1 = F4(function(n, e, r, t) {
        var u = e.a.b, a = e.b;
        return s(n.at, bs) ? A2($V, r, t) : A2(_1, {
            mj: "element-" + ut(u) + "-" + ut(a),
            ai: "Quantit\xe9",
            nc: n.nc,
            nt: n.pr(e),
            H: n.b7,
            aL: r.aL,
            pS: w1
        }, t);
    }), U1 = F2(function(n, e) {
        return A2(e_, A([
            o_("button"),
            YN("btn btn-sm btn-outline-secondary text-nowrap"),
            YN("d-flex align-items-center gap-1"),
            A2(n_, "aria-label", "Supprimer l\u2019\xe9l\xe9ment"),
            i_(n.n5(e))
        ]), A([
            NX,
            c_("Supprimer")
        ]));
    }), M1 = F2(function(n, e) {
        var r = e.a.a, t = e.b;
        return A2(K_, j, A([
            A2(V_, A([
                YN("py-2 px-3"),
                m1(6)
            ]), A([
                A2(WN, A([
                    YN("d-flex justify-content-between align-items-center gap-2")
                ]), A([
                    A2(m_, A([
                        YN("fw-bold")
                    ]), A([
                        c_(n.mF.b$ + " " + ut(t + 1))
                    ])),
                    ft(r.r) > 1 ? A2(U1, n, e) : c_("")
                ]))
            ]))
        ]));
    }), D1 = F2(function(n, e) {
        return s(e, 0) ? 0 : A2(Zg, 0, Zm(A3(TA, 0, 1, n / e)));
    }), R1 = function(n) {
        return n.j;
    }, F1 = function(n) {
        return n.av;
    }, H1 = fe("abbr"), G1 = d_("package"), X1 = F6(function(n, e, r, t, u, a) {
        var i = n.g5.ax, c = A5(k$, function(n) {
            return {
                az: n.h8,
                C: n.C,
                at: n.at
            };
        }(n), $(i, {
            a8: 0,
            aN: zr(r)
        }), u, a, t);
        if (1 === c.$) {
            var o = c.a;
            return A2(j1, e, $(k1, {
                ai: A2(s1, zr("Erreur de calcul de distance"), o)
            }));
        }
        var f = c.a, s = F2(function(n, e) {
            return A2(GP, 0, e) ? A([
                n,
                bJ(e)
            ]) : j;
        }), l = function(n) {
            if (n.$) return c_("R\xe9gion inconnue");
            var e = n.a.cR;
            return A2(H1, A([
                W_(n.a.ek)
            ]), A([
                c_(e)
            ]));
        };
        return A2(j1, A2(Mr, YN("fs-7 text-muted"), e), $(k1, {
            i: A2(WN, A([
                YN("d-flex flex-wrap justify-content-end align-items-center gap-2")
            ]), k(A2(s, dQ, f.f5), k(A2(s, iQ, f.hb), k(A2(s, oQ, f.oq), k(A2(s, fQ, f.ds), k(A2(s, sQ, f.og), A([
                G1,
                pV(t)
            ]))))))),
            O: A2(tW, n.O, f.g),
            ai: A2(WN, A([
                YN("d-flex align-items-center gap-1 text-nowrap text-muted")
            ]), A([
                c_("Transport\xa0"),
                l(u),
                c_(" \u2192 "),
                l(a)
            ]))
        }));
    }), V1 = F4(function(n, e, r, t) {
        var u = n.C, a = n.g5, i = n.at;
        return A2(Zg, j, A2(fs, ck, A2(fs, A5(X1, n, A([
            YN("subdued")
        ]), e, t, r), A2(yh, a.q.i, A2(Rh, A([
            i
        ]), u.bT)))));
    }), J1 = function(n) {
        return lh(A([
            n.g,
            _Y(n.S)
        ]));
    }, Y1 = F2(function(n, e) {
        return A2(m_, A([
            YN("ImpactPill bg-info-subtle")
        ]), A([
            A2(tW, n.O, e)
        ]));
    }), W1 = d_("calculator"), K1 = F2(function(n, e) {
        return A2(at, "\n", A2(qa, ru, A3(st, F2(function(e, r) {
            var t, u;
            return A2(Pc, A2(Hu, (u = (t = n).li, A2(Hu, ch(t.kj), A2(Hu, b$, Rj(u)))), rt(r + "\xa0: ")), e);
        }), cw(e), cw(eW))));
    }), B1 = F2(function(n, e) {
        var r = e.a, t = e.b;
        return A2(e_, A([
            o_("button"),
            YN("btn btn-sm btn-outline-primary text-nowrap"),
            A2(n_, "aria-label", "Changer de mati\xe8re premi\xe8re"),
            i_(A4(n.nE, PC, r, zr(t), A2(QB, Gb, A3(l1, n.at, PC, n.C.W))))
        ]), A([
            GK
        ]));
    }), Q1 = function(n) {
        var e = n.b;
        return A2(at, "-", A([
            ut(n.a.b),
            ut(e)
        ]));
    }, Z1 = F3(function(n, e, r) {
        var t = v(n, r);
        return t.a && !t.b.$ ? e + " (" + t.b.a + ")" : e;
    }), n0 = function(n) {
        return A2(vG, k(A([
            YN(mf("form-select " + n.kX)),
            yH(n.lA),
            VQ(!1),
            E_(n.bY),
            mG(function(e) {
                return n.or(su(e) ? Ur : zr(gw(e)));
            })
        ]), n.kF), A2(wu, function(e) {
            var r = e.a, t = e.b;
            return A2(pG, A([
                hG(A2(Nc, "", A2(Pc, Po, t))),
                gG(s(n.ov, t))
            ]), A([
                c_(A3(Z1, n.oC, r, t))
            ]));
        }, A2(Mr, v(n.lP, Ur), A2(wu, function(n) {
            return v(n.ek, zr(n.cR));
        }, A2(LA, function(n) {
            return n.ek;
        }, A2(Rh, A([
            n.at
        ]), n.bT))))));
    }, e0 = function(n) {
        var e = n.ai;
        if (e.$) return n0(n);
        var r = e.a;
        return A2(WN, j, A([
            A2(gX, A(n.mh ? [
                YN("visually-hidden"),
                vX(n.lA)
            ] : [
                vX(n.lA)
            ]), A([
                c_(r)
            ])),
            n0(n)
        ]));
    }, r0 = F4(function(n, e, r, t) {
        var u = A2(j1, A([
            YN("fs-7")
        ]), $(k1, {
            hI: A2(B1, n, e),
            j: A2($V, t.t, R1(r)),
            i: e0({
                kF: j,
                kX: "RegionSelector form-select-sm w-100",
                bT: n.C.bT,
                bY: !1,
                lA: "material-country-" + Q1(e),
                lP: "---",
                mh: !0,
                ai: zr("R\xe9gion"),
                at: n.at,
                or: n.ps(e),
                ov: A2(Pc, function(n) {
                    return n.cR;
                }, t.i),
                oC: !0
            }),
            O: A2(Y1, n, J1(r)),
            ai: A2(m_, A([
                YN("fw-bold"),
                W_(Gb(t.t))
            ]), A([
                c_(Gb(t.t))
            ]))
        })), a = NY(r), i = s(a, ih) ? j : A([
            A2(j1, A([
                YN("fs-7 text-muted")
            ]), $(k1, {
                O: A2(tW, n.O, _Y(a)),
                ai: A2(m_, A([
                    YN("cursor-help fs-8"),
                    W_(A2(K1, n.O, a))
                ]), A([
                    A2(m_, A([
                        YN("ComponentElementIcon")
                    ]), A([
                        W1
                    ])),
                    c_("Dont compl\xe9ments")
                ]))
            }))
        ]);
        return A2(Mr, u, i);
    }), t0 = F5(function(n, e, r, t, u) {
        if (u.b) {
            var a = u.a;
            return A([
                A6(X1, n, j, e, Oh(r), t.i, a.i)
            ]);
        }
        return A4(V1, n, e, t.i, Oh(r));
    }), u0 = function(n) {
        return wY(100 * (1 - n));
    }, a0 = F5(function(n, e, r, t, u) {
        return Cd(A2(bt, F2(function(a, i) {
            var c = A2(Nc, Ih, A2(xx, a, t)), o = "Proc\xe9d\xe9\xa0: " + (Gb(i.t) + A2(Zg, "", A2(fs, function(n) {
                var e = n.eb;
                return "\n\xc9lectricit\xe9\xa0: " + Gb(n.d2) + "\nChaleur\xa0: " + Gb(e);
            }, A2(jh, n.h8, i.i))));
            return k(function() {
                if (a) {
                    var r = a, c = Oh(A2(Nc, Ih, A2(xx, r - 1, t)));
                    return A([
                        A6(X1, n, j, e, c, A2(Ba, function(n) {
                            return n.i;
                        }, A2(xx, r - 1, u)), i.i)
                    ]);
                }
                return j;
            }(), A([
                A2(j1, A([
                    YN("fs-7 border-top")
                ]), $(k1, {
                    hI: A2(e_, A([
                        o_("button"),
                        YN("btn btn-sm btn-outline-secondary"),
                        A2(n_, "aria-label", "Supprimer la transformation"),
                        i_(A2(n.n6, r, a))
                    ]), A([
                        NX
                    ])),
                    j: A2($V, i.t, R1(c)),
                    i: e0({
                        kF: j,
                        kX: "RegionSelector form-select-sm w-100",
                        bT: n.C.bT,
                        bY: !1,
                        lA: "transform-country-" + Q1(r) + "-" + ut(a),
                        lP: "---",
                        mh: !0,
                        ai: zr("R\xe9gion"),
                        at: n.at,
                        or: A2(n.pt, r, a),
                        ov: A2(Pc, function(n) {
                            return n.cR;
                        }, i.i),
                        oC: !0
                    }),
                    O: A2(Y1, n, xA(c)),
                    ai: A2(m_, A([
                        YN("fw-bold cursor-help"),
                        W_(o)
                    ]), A([
                        c_(Gb(i.t))
                    ])),
                    pO: u0(i.t.g4)
                }))
            ]));
        }), u));
    }), i0 = F5(function(n, e, r, t, u) {
        var a, i = r.U, c = r.J, o = A2(Y1, n, J1(u)), f = hx(u), l = A2(Ah, A2(Hu, F1, zt(zr(2))), f), d = lh(A2(wu, xA, A2(Ah, A2(Hu, F1, zt(zr(3))), f))), b = A2(Nc, Ih, A2(xs, A2(Hu, F1, zt(zr(1))), f)), m = Oh(u), p = A2(D1, m, HP(t)), v = A2(j1, A([
            YN("fs-7")
        ]), $(k1, {
            j: A4(z1, n, e, i.t, R1(u)),
            O: s(d, Ks) ? o : A2(m_, j, A([
                o,
                A2(m_, A([
                    YN("text-muted fw-normal")
                ]), A([
                    c_(" (dont transport "),
                    A2(tW, n.O, d),
                    c_(")")
                ]))
            ])),
            ai: A2(m_, A([
                YN("text-muted")
            ]), A([
                c_("Poids du " + Ss(n.mF.b$) + "\xa0: "),
                A2(m_, A([
                    YN("fw-bold")
                ]), A([
                    pV(m)
                ])),
                c_(" ("),
                A2(jJ, 0, p),
                c_(")")
            ]))
        })), g = F$(i.t), h = sf(c) ? A([
            A2(j1, A([
                YN("fs-7 text-muted")
            ]), $(k1, {
                ai: c_("Aucune transformation")
            }))
        ]) : A2(Mr, (a = {
            j: "Quantit\xe9",
            i: "Origine",
            ai: "Intitul\xe9",
            pO: "Pertes"
        }, A2(j1, A([
            YN("fs-8 fw-normal text-muted")
        ]), $(k1, {
            j: c_(a.j),
            i: c_(a.i),
            O: c_("Impact"),
            ai: c_(a.ai),
            pO: c_(a.pO)
        }))), k(A5(a0, n, g, e, l, c), A4(V1, n, g, gx(r), A2(Nc, Oh(b), A2(Pc, Oh, vx(l))))));
        return A2(Mr, A2(M1, n, e), A2(Mr, v, A2(Mr, A2(y1, "Mati\xe8re premi\xe8re", Ur), k(A4(r0, n, e, b, i), k(A5(t0, n, g, b, i, c), A2(Mr, A2(y1, "\xc9tape de transformation", zr(A3(x1, n, i.t, e))), h))))));
    }), c0 = C, o0 = F4(function(n, e, r, t) {
        var u = r.h7, a = r.r, i = ft(a), c = F2(function(n, e) {
            return A2(WN, A([
                YN("d-flex flex-column")
            ]), A([
                A2(v1, A([
                    YN("fs-8 text-muted order-2 mb-0")
                ]), A([
                    c_(n)
                ])),
                A2(p1, A([
                    YN("fw-bold text-secondary order-1 mb-0 ps-0")
                ]), e)
            ]));
        });
        return A2(WN, A([
            YN("d-flex flex-column gap-3 p-3")
        ]), A([
            A2(WN, A([
                YN("d-flex flex-row align-items-center gap-2")
            ]), A([
                A2(gX, A([
                    YN("text-nowrap"),
                    vX("item-label")
                ]), A([
                    c_(n.mF.cj)
                ])),
                A2(N_, A([
                    o_("text"),
                    YN("form-control"),
                    yH("item-label"),
                    kX(n.mF.bf),
                    hG(u.ek),
                    mG(n.pw(e))
                ]), j)
            ])),
            A2(WN, A([
                YN("d-flex flex-wrap gap-4 align-items-center bg-info-subtle border rounded row-gap-1 column-gap-2 column-gap-lg-5 p-3"),
                A2(n_, "aria-live", "polite")
            ]), A([
                A2(m_, A([
                    YN("d-flex align-items-center gap-2")
                ]), A([
                    A2(m_, A([
                        YN("fs-4 mt-1 text-secondary opacity-75"),
                        A2(n_, "aria-hidden", "true")
                    ]), A([
                        b_
                    ])),
                    A2(m_, A([
                        YN("fw-bold text-secondary")
                    ]), A([
                        c_("D\xe9tails de la composition")
                    ]))
                ])),
                A2(c, Ss(1 === i ? n.mF.b$ : n.mF.b0), A([
                    c_(ut(i))
                ])),
                A2(c, "masse unitaire", A([
                    pV(HP(t))
                ])),
                A2(c, "impact total", A([
                    A2(tW, n.O, J1(t))
                ]))
            ])),
            A2(WN, A([
                YN("d-flex justify-content-between align-items-center gap-2")
            ]), A([
                A2(t_, A([
                    YN("h5 mb-0")
                ]), A([
                    c_("Liste des " + Ss(n.mF.b0) + " et leurs \xe9tapes de transformation")
                ])),
                A2(b1, n, e)
            ])),
            A2(WN, A([
                YN("table-responsive")
            ]), A([
                A2(G_, A([
                    YN("CompositionElements table table-sm table-borderless mb-0 w-100")
                ]), A2(Mr, A2(GV, A([
                    YN("visually-hidden")
                ]), A([
                    c_("Composition des " + Ss(n.mF.b0))
                ])), sf(a) ? A([
                    A2(X_, j, A([
                        A2(j1, j, $(k1, {
                            ai: c_("Aucun \xe9l\xe9ment")
                        }))
                    ]))
                ]) : A2(QS, A2(X_, A([
                    YN("composition-element-gap")
                ]), A([
                    A2(K_, A([
                        A2(n_, "aria-hidden", "true")
                    ]), A([
                        A2(V_, A([
                            m1(6)
                        ]), j)
                    ]))
                ])), A4(c0, F3(function(r, u, a) {
                    return A2(X_, A([
                        YN("composition-element")
                    ]), A5(i0, n, v(e, r), u, t, a));
                }), A2(dt, 0, i - 1), a, hx(t)))))
            ]))
        ]));
    }), f0 = F2(function(n, e) {
        var r = n.ac, t = e.b, u = A2(px, n.C, n.g5.my);
        if (1 === u.$) {
            var a = u.a;
            return A2(s1, zr("Erreur"), a);
        }
        var i = A2(xx, t, u.a);
        if (i.$) return A2(s1, zr("Erreur"), "Composant introuvable");
        var c = i.a;
        return A4(o0, n, v(c.h7, t), c, A2(Nc, Ih, A2(xx, t, hx(r.Q))));
    }), s0 = F2(function(n, e) {
        var r = n.ac;
        if (1 === r.$) {
            var t = r.a;
            return A2(s1, zr("Erreur"), t);
        }
        return A2(f0, {
            h8: n.h8,
            C: n.C,
            b7: n.b7,
            O: n.O,
            mF: {
                bO: n.mF.bO,
                b$: n.mF.b$,
                b0: n.mF.b0,
                cj: n.mF.cj,
                bf: n.mF.bf
            },
            ac: r.a,
            nc: n.nc,
            nE: n.nE,
            g5: n.g5,
            n5: n.n5,
            n6: n.n6,
            at: n.at,
            pr: n.pr,
            ps: n.ps,
            pt: n.pt,
            pw: n.pw
        }, e);
    }), l0 = function(n) {
        return n.$ ? Gb(n.a) : n.a.ek;
    }, d0 = F3(function(n, e, r) {
        var t = e.M, u = A2(o1, 0, ds(e.iE));
        switch(r.$){
            case 0:
                return rZ({
                    cK: o = r.a,
                    ge: yc(A2($x, 1, t)),
                    l6: j,
                    gT: sP,
                    gU: OZ,
                    g0: u.du,
                    eG: u.or,
                    hw: Wi(""),
                    hx: l0
                });
            case 1:
                return JG({
                    h4: yc(A2($x, 1, t)),
                    h9: A([
                        wZ({
                            bv: e.bv,
                            cT: e.cT,
                            O: e.O,
                            no: LZ,
                            np: PZ,
                            nq: qZ,
                            nr: NZ,
                            os: _Z,
                            ou: zZ,
                            ey: n,
                            oQ: UZ,
                            o3: MZ
                        })
                    ]),
                    l6: j,
                    l7: Ur,
                    oE: 0,
                    oM: zr("Co\xfbt environnemental, par produit"),
                    eG: "Comparateur de simulations sauvegard\xe9es"
                });
            case 2:
                var a = r.a;
                return JG({
                    h4: yc(A2($x, 1, t)),
                    h9: A([
                        A2(s0, A2(f1, n, e), a)
                    ]),
                    l6: j,
                    l7: Ur,
                    oE: 1,
                    oM: Ur,
                    eG: "Param\xe8tres et composition"
                });
            case 3:
                return rZ({
                    cK: o = r.a,
                    ge: yc(A2($x, 1, t)),
                    l6: j,
                    gT: cP,
                    gU: TZ,
                    g0: "tapez ici le nom d'un proc\xe9d\xe9 d'assemblage pour le rechercher",
                    eG: "S\xe9lectionnez un proc\xe9d\xe9 d'assemblage",
                    hw: A2(Hu, function(n) {
                        return n.aL;
                    }, Th),
                    hx: Gb
                });
            case 4:
                return rZ({
                    cK: o = r.a,
                    ge: yc(A2($x, 1, t)),
                    l6: j,
                    gT: oP,
                    gU: EZ,
                    g0: "tapez ici le nom d'un proc\xe9d\xe9 de consommation pour le rechercher",
                    eG: "S\xe9lectionnez une consommation",
                    hw: A2(Hu, function(n) {
                        return n.aL;
                    }, Th),
                    hx: Gb
                });
            case 5:
                return rZ({
                    cK: o = r.a,
                    ge: yc(A2($x, 1, t)),
                    l6: j,
                    gT: lP,
                    gU: CZ,
                    g0: "tapez ici le nom du produit pour le rechercher",
                    eG: "S\xe9lectionnez un produit",
                    hw: XQ(e.lT),
                    hx: FQ(e.lT)
                });
            case 6:
                return rZ({
                    cK: o = r.a,
                    ge: yc(A2($x, 1, t)),
                    l6: j,
                    gT: dP,
                    gU: IZ,
                    g0: "tapez ici le nom d'un emballage pour le rechercher",
                    eG: "S\xe9lectionnez un emballage",
                    hw: A2(Hu, function(n) {
                        return n.aL;
                    }, Th),
                    hx: Gb
                });
            default:
                var i = r.a, c = (a = r.b, r.c), o = r.d, f = function() {
                    switch(i.$){
                        case 5:
                            return v("tapez ici le nom d'une mati\xe8re premi\xe8re pour la rechercher", "S\xe9lectionnez une mati\xe8re premi\xe8re");
                        case 11:
                            return v("tapez ici le nom d'un proc\xe9d\xe9 de transformation pour le rechercher", "S\xe9lectionnez un proc\xe9d\xe9 de transformation");
                        default:
                            return v("tapez ici le nom d'un proc\xe9d\xe9 pour le rechercher", "S\xe9lectionnez un proc\xe9d\xe9");
                    }
                }(), s = f.a, l = f.b;
                return rZ({
                    cK: o,
                    ge: yc(A2($x, 1, t)),
                    l6: j,
                    gT: A3(fP, i, a, c),
                    gU: A3(SZ, i, a, c),
                    g0: s,
                    eG: l,
                    hw: A2(Hu, function(n) {
                        return n.aL;
                    }, Th),
                    hx: Gb
                });
        }
    }), b0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, m0 = {
        $: 2
    }, p0 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, v0 = {
        $: 5
    }, g0 = {
        $: 6
    }, h0 = {
        $: 24
    }, $0 = {
        $: 31
    }, x0 = {
        $: 32
    }, k0 = function(n) {
        return {
            $: 38,
            a: n
        };
    }, j0 = function(n) {
        return {
            $: 40,
            a: n
        };
    }, y0 = function(n) {
        return {
            $: 41,
            a: n
        };
    }, w0 = function(n) {
        return {
            $: 46,
            a: n
        };
    }, A0 = function(n) {
        return {
            $: 50,
            a: n
        };
    }, T0 = function(n) {
        return {
            $: 51,
            a: n
        };
    }, E0 = function(n) {
        return {
            $: 59,
            a: n
        };
    }, C0 = F2(function(n, e) {
        return {
            $: 61,
            a: n,
            b: e
        };
    }), I0 = F2(function(n, e) {
        return n.$ ? e : A2(uw, n.a, e);
    }), S0 = function(n) {
        return A2(Hu, zY, I0(n));
    }, O0 = function(n) {
        return {
            $: 53,
            a: n
        };
    }, L0 = d_("cross-rounded"), P0 = JN("max"), q0 = function(n) {
        return A2(N_, A2(Mr, o_("range"), A2(Mr, YN("form-range"), n)), j);
    }, N0 = F2(function(n, e) {
        return q0(k(n, A([
            mG(A2(Hu, e.l8, e.ph)),
            rQ(e.o1(e.m2)),
            P0(e.o1(e.m$)),
            tQ(e.oJ),
            hG(e.o1(e.eT)),
            E_(e.bY)
        ])));
    }), _0 = F3(function(n, e, r) {
        var t = n.ir, u = A2(Ba, ra(r), A2(Vh, e, t.jS));
        return u.$ ? A2(ra, r, t.$8) : zr(u.a);
    }), z0 = _0, U0 = F3(function(n, e, r) {
        if (A2(o$, e, n.aO)) {
            var t = A2(Nc, 1, r);
            return A2(WN, A([
                YN("card shadow-sm pb-2 mb-3")
            ]), A([
                A2(WN, A([
                    YN("card-header d-flex justify-content-between align-items-center")
                ]), A([
                    A2(I_, A([
                        YN("h5 mb-1 text-truncate")
                    ]), A([
                        c_("Durabilit\xe9")
                    ])),
                    A2(WN, A([
                        YN("d-flex align-items-center gap-2")
                    ]), A([
                        function() {
                            var r = A3(z0, n, e, "durability");
                            if (r.$) return c_("");
                            var t = r.a;
                            return A2(_B, A([
                                YN("bg-secondary"),
                                A2(qH, "height", "24px"),
                                QN(t),
                                W_("Documentation"),
                                _H("_blank")
                            ]), A([
                                AY
                            ]));
                        }()
                    ]))
                ])),
                A2(WN, A([
                    YN("card-body pb-1 row g-3 align-items-start flex-md-columns")
                ]), A([
                    A2(WN, A([
                        YN("col-sm-6 col-md-4")
                    ]), A([
                        A2(gX, A([
                            vX("durability"),
                            YN("text-truncate")
                        ]), A([
                            c_("Coefficient de durabilit\xe9")
                        ]))
                    ])),
                    A2(WN, A([
                        YN("col-sm-2 col-md-2")
                    ]), A([
                        c_(A2(Rj, 2, t))
                    ])),
                    A2(WN, A([
                        YN("col-sm-4 col-md-6 text-nowrap d-flex align-items-center gap-2")
                    ]), A([
                        A2(N0, A([
                            yH("durability")
                        ]), {
                            bY: !1,
                            l8: A2(Hu, pp, A2(Hu, ks("Durabilit\xe9 invalide (un nombre est requis)"), A2(Hu, as(function(n) {
                                return .5 > n ? Yr("Durabilit\xe9 trop faible (minimum: 0.5)") : n > 1.5 ? Yr("Durabilit\xe9 trop \xe9lev\xe9e (maximum: 1.5)") : Qr(n);
                            }), fs(mm)))),
                            m$: 1.5,
                            m2: .5,
                            oJ: "0.01",
                            o1: A2(Hu, W$, Js),
                            ph: O0,
                            eT: t
                        }),
                        A2(e_, A([
                            o_("button"),
                            YN("btn text-primary p-0 border-0"),
                            i_(O0(Qr(1))),
                            W_("R\xe9initialiser la durabilit\xe9"),
                            E_(s(r, Ur) || s(r, zr(1)))
                        ]), A([
                            L0
                        ]))
                    ]))
                ]))
            ]));
        }
        return c_("");
    }), M0 = function(n) {
        return {
            az: n.h8,
            C: n.C,
            at: n.at
        };
    }, D0 = function(n) {
        var e = n.nB, r = n.g5, t = A2(Ah, function(e) {
            return !A2(el, e.mj, A2(qh, M0(n), r));
        }, A3(l1, n.at, Px, n.C.W)), u = A2(QB, Gb, t);
        return A2(e_, A([
            o_("button"),
            YN("btn btn-outline-primary w-100 rounded-0 gap-1"),
            YN("d-flex justify-content-center align-items-center"),
            E_(sf(t)),
            i_(e(u))
        ]), A([
            rB,
            c_("Ajouter un proc\xe9d\xe9 d\u2019assemblage")
        ]));
    }, R0 = F2(function(n, e) {
        var r = A3(z0, n.h8, n.at, e);
        if (r.$) return c_("");
        var t = r.a;
        return A2(_B, A([
            YN("bg-secondary"),
            A2(qH, "height", "24px"),
            QN(t),
            W_("Documentation"),
            _H("_blank")
        ]), A([
            AY
        ]));
    }), F0 = JN("scope"), H0 = F2(function(n, e) {
        var r = n.C, t = n.O, u = n.g5, a = n.at;
        return A2(WN, A([
            YN("card shadow-sm")
        ]), A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between gap-2")
            ]), A([
                A2(I_, A([
                    YN("h5 mb-0")
                ]), A([
                    c_("Assemblage")
                ])),
                A2(WN, A([
                    YN("d-flex flex-fill justify-content-end align-items-center gap-2")
                ]), A([
                    A2(tW, t, xA(e.q))
                ])),
                A2(R0, n, "assembly")
            ])),
            A2(WN, A([
                YN("card-body d-flex flex-column gap-3 p-0")
            ]), A([
                A2(WN, A([
                    YN("d-flex align-items-center gap-2 px-3 pt-3")
                ]), A([
                    A2(gX, A([
                        vX("assembly-country")
                    ]), A([
                        c_("Pays d\u2019assemblage")
                    ])),
                    e0({
                        kF: j,
                        kX: "w-33",
                        bT: r.bT,
                        bY: !1,
                        lA: "assembly-country",
                        lP: "Inconnu",
                        mh: !0,
                        ai: Ur,
                        at: a,
                        or: n.pj,
                        ov: u.q.i,
                        oC: !1
                    })
                ])),
                function() {
                    var a = A3(Sh, r, u.q.i, A2(qh, M0(n), u));
                    if (1 === a.$) {
                        var i = a.a;
                        return A2(WN, A([
                            YN("px-3 pb-3")
                        ]), A([
                            A2(s1, zr("Erreur"), i)
                        ]));
                    }
                    var c = a.a;
                    return sf(c) ? A2(WN, A([
                        YN("px-3 pb-3 text-muted")
                    ]), A([
                        c_("Aucun proc\xe9d\xe9 d\u2019assemblage")
                    ])) : A2(G_, A([
                        YN("table table-sm mb-0 border-top")
                    ]), A([
                        A2(Y_, j, A([
                            A2(K_, A([
                                YN("fs-7 text-muted bg-light")
                            ]), A([
                                A2(J_, A([
                                    YN("bg-light ps-3 align-middle"),
                                    F0("col")
                                ]), A([
                                    c_("Op\xe9ration")
                                ])),
                                A2(J_, A([
                                    YN("bg-light align-middle text-end"),
                                    F0("col")
                                ]), A([
                                    c_("Pertes")
                                ])),
                                A2(J_, A([
                                    YN("bg-light align-middle text-end"),
                                    F0("col")
                                ]), A([
                                    c_("Masse")
                                ])),
                                A2(J_, A([
                                    YN("bg-light align-middle text-end"),
                                    F0("col")
                                ]), A([
                                    c_("Impact")
                                ])),
                                A2(J_, A([
                                    YN("bg-light align-middle"),
                                    F0("col")
                                ]), j)
                            ]))
                        ])),
                        A2(X_, j, A2(bt, F2(function(r, u) {
                            var a = u.t, i = A2(Nc, Ih, A2(xx, r, hx(e.q)));
                            return A2(K_, j, A([
                                A2(V_, A([
                                    YN("ps-3 align-middle w-100")
                                ]), A([
                                    c_(Gb(a))
                                ])),
                                A2(V_, A([
                                    YN("align-middle text-end text-nowrap")
                                ]), A([
                                    u0(a.g4)
                                ])),
                                A2(V_, A([
                                    YN("align-middle text-end text-nowrap")
                                ]), A([
                                    pV(Oh(i))
                                ])),
                                A2(V_, A([
                                    YN("align-middle text-end text-nowrap")
                                ]), A([
                                    A2(tW, t, xA(i))
                                ])),
                                A2(V_, A([
                                    YN("align-middle pe-3 text-end")
                                ]), A([
                                    A2(e_, A([
                                        o_("button"),
                                        YN("btn btn-sm btn-outline-secondary"),
                                        W_("Supprimer ce proc\xe9d\xe9 d\u2019assemblage"),
                                        i_(n.n3(r))
                                    ]), A([
                                        NX
                                    ]))
                                ]))
                            ]));
                        }), c))
                    ]));
                }(),
                D0(n)
            ]))
        ]));
    }), G0 = d_("fork-way"), X0 = d_("lock"), V0 = F2(function(n, e) {
        var r = n.h8, t = n.C, u = n.O, a = n.g5, i = n.at, c = n.pp;
        return A2(WN, A([
            YN("card shadow-sm")
        ]), A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between gap-2")
            ]), A([
                A2(I_, A([
                    YN("h5 mb-0")
                ]), A([
                    c_("Distribution")
                ])),
                A2(WN, A([
                    YN("d-flex flex-fill justify-content-end align-items-center gap-2")
                ]), A([
                    A2(tW, u, e.E.g)
                ])),
                A2(R0, n, "distribution")
            ])),
            A2(WN, A([
                YN("card-body d-flex justify-content-between align-items-center gap-2")
            ]), A2(qa, ru, A([
                zr(A2(WN, A([
                    YN("d-flex align-items-center gap-1")
                ]), A([
                    X0,
                    c_("France")
                ]))),
                zr(A2(WN, A([
                    YN("d-flex align-items-center w-33 justify-content-end gap-1")
                ]), A([
                    G1,
                    mV(e.E.eY)
                ]))),
                function() {
                    var n = A2(Hh, t, i);
                    if (n.b) {
                        var e = n, u = A2(Yh, {
                            az: r,
                            C: t,
                            at: i
                        }, a);
                        return zr(A2(vG, A([
                            YN("form-select w-50"),
                            mG(A2(Hu, qE, c))
                        ]), A2(wu, function(n) {
                            return A2(pG, A([
                                hG(qs(n.mj)),
                                gG(s(u, zr(n.mj)))
                            ]), A([
                                c_(Gb(n))
                            ]));
                        }, e)));
                    }
                    return Ur;
                }()
            ])))
        ]));
    }), J0 = F2(function(n, e) {
        var r = n.h8, t = n.g5, u = n.at, a = e.a, i = e.b.dX, c = e.b.em, o = F2(function(e, r) {
            var t = r.g, u = r.t, a = r.oH;
            if (s(a, 0)) return c_("-");
            var i = A2(ch, n.O.kj, t), c = A2(tW, n.O, t);
            return A2(WN, j, A([
                function() {
                    if (e && !i) return A2(m_, A([
                        YN("cursor-help"),
                        W_("Le recyclage est ici consid\xe9r\xe9 sans impact")
                    ]), A([
                        c,
                        c_("*")
                    ]));
                    if (u.$) return c;
                    var n = u.a;
                    return A2(m_, A([
                        YN("cursor-help"),
                        W_(Hb(n))
                    ]), A([
                        c
                    ]));
                }(),
                A2(yX, j, A([
                    c_("\xa0("),
                    A2(jJ, 0, a),
                    c_(")")
                ]))
            ]));
        }), f = A3(r$, r, t.dq, u), l = ob(f);
        return A([
            A2(K_, A([
                YN("table-active")
            ]), A([
                A2(J_, A([
                    YN("text-end")
                ]), A([
                    c_(yC(a))
                ])),
                A2(V_, A([
                    YN("text-end"),
                    m1(4)
                ]), j),
                A2(V_, A([
                    YN("text-end pe-3 fw-bold")
                ]), A([
                    A2(tW, n.O, lh(A([
                        i.b.fC.g,
                        i.b.fl.g,
                        i.b.fo.g,
                        c.b.fC.g,
                        c.b.fl.g,
                        c.b.fo.g
                    ])))
                ]))
            ])),
            A2(K_, j, A([
                A2(V_, A([
                    YN("text-end")
                ]), A([
                    c_("Collect\xe9 \xe0 "),
                    A2(jJ, 0, f)
                ])),
                A2(V_, A([
                    YN("text-end")
                ]), A([
                    pV(i.a)
                ])),
                A2(V_, A([
                    YN("text-end")
                ]), A([
                    A2(o, !0, i.b.fC)
                ])),
                A2(V_, A([
                    YN("text-end")
                ]), A([
                    A2(o, !1, i.b.fl)
                ])),
                A2(V_, A([
                    YN("text-end")
                ]), A([
                    A2(o, !1, i.b.fo)
                ])),
                A2(V_, A([
                    YN("text-end pe-3")
                ]), A([
                    A2(tW, n.O, lh(A([
                        i.b.fC.g,
                        i.b.fl.g,
                        i.b.fo.g
                    ])))
                ]))
            ])),
            A2(K_, j, A([
                A2(V_, A([
                    YN("text-end")
                ]), A([
                    c_("Non-collect\xe9 \xe0 "),
                    A2(jJ, 0, l)
                ])),
                A2(V_, A([
                    YN("text-end")
                ]), A([
                    pV(c.a)
                ])),
                A2(V_, A([
                    YN("text-end")
                ]), A([
                    A2(o, !0, c.b.fC)
                ])),
                A2(V_, A([
                    YN("text-end")
                ]), A([
                    A2(o, !1, c.b.fl)
                ])),
                A2(V_, A([
                    YN("text-end")
                ]), A([
                    A2(o, !1, c.b.fo)
                ])),
                A2(V_, A([
                    YN("text-end pe-3")
                ]), A([
                    A2(tW, n.O, lh(A([
                        c.b.fC.g,
                        c.b.fl.g,
                        c.b.fo.g
                    ])))
                ]))
            ]))
        ]);
    }), Y0 = JN("name"), W0 = F2(function(n, e) {
        var r = n.h8, t = n.g5, u = n.at, a = n.pG;
        return A2(WN, A([
            YN("card shadow-sm")
        ]), A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between gap-2")
            ]), A([
                A2(WN, A([
                    YN("IngredientPlaneOrBoatSelector")
                ]), A([
                    A2(WN, A([
                        YN("mb-0 d-flex")
                    ]), A([
                        A2(WN, A([
                            YN("h5")
                        ]), A([
                            c_("Fin de vie")
                        ]))
                    ]))
                ])),
                A2(WN, A([
                    YN("d-flex flex-fill align-items-center justify-content-center")
                ]), A([
                    A2(m_, A([
                        YN("pe-3")
                    ]), A([
                        c_("Ce produit est-il recyclable\xa0?")
                    ])),
                    A2(WN, A([
                        YN("form-check form-check-inline")
                    ]), A([
                        A2(N_, A([
                            o_("radio"),
                            YN("form-check-input"),
                            Y0("recyclable"),
                            yH("recyclable-yes"),
                            i_(a(!0)),
                            w_(t.dq)
                        ]), j),
                        A2(gX, A([
                            YN("form-check-label"),
                            vX("recyclable-yes")
                        ]), A([
                            c_("Oui")
                        ]))
                    ])),
                    A2(WN, A([
                        YN("form-check form-check-inline")
                    ]), A([
                        A2(N_, A([
                            o_("radio"),
                            YN("form-check-input"),
                            Y0("recyclable"),
                            yH("recyclable-no"),
                            i_(a(!1)),
                            w_(!t.dq)
                        ]), j),
                        A2(gX, A([
                            YN("form-check-label"),
                            vX("recyclable-no")
                        ]), A([
                            c_("Non")
                        ]))
                    ]))
                ])),
                A2(tW, n.O, e._),
                A2(R0, n, "eol")
            ])),
            A2(WN, A([
                YN("card-body table-responsive p-0")
            ]), A([
                A2(o$, u, n.h8._) ? A2(WN, j, A([
                    A2(G_, A([
                        YN("table mb-0 fs-7")
                    ]), A([
                        A2(Y_, j, A([
                            A2(K_, j, A([
                                A2(J_, A([
                                    YN("text-end")
                                ]), A([
                                    c_("Mati\xe8re")
                                ])),
                                A2(J_, A([
                                    YN("text-end")
                                ]), A([
                                    c_("Masse")
                                ])),
                                A2(J_, A([
                                    YN("text-end")
                                ]), A([
                                    c_("Recyclage")
                                ])),
                                A2(J_, A([
                                    YN("text-end")
                                ]), A([
                                    c_("Incin\xe9ration")
                                ])),
                                A2(J_, A([
                                    YN("text-end")
                                ]), A([
                                    c_("Enfouissement")
                                ])),
                                A2(J_, A([
                                    YN("text-end pe-3")
                                ]), A([
                                    c_("Impact")
                                ]))
                            ]))
                        ])),
                        A2(X_, j, A2(Id, J0(n), A2(LA, A2(Hu, Xt, yC), i$(A3(c$, {
                            az: r,
                            C: n.C,
                            at: n.at
                        }, t.dq, e)))))
                    ]))
                ])) : A2(WN, A([
                    YN("card-body d-flex align-items-center justify-content-start gap-2")
                ]), A([
                    b_,
                    c_("Fin de vie non disponible pour le p\xe9rim\xe8tre " + qx(n.at))
                ]))
            ]))
        ]));
    }), K0 = A2(NQ, j, j), B0 = function(n) {
        return n.bl;
    }, Q0 = function(n) {
        var e = n.g5, r = A2(Ah, function(n) {
            return !A2(el, n.mj, A2(wu, B0, e.aR));
        }, A3(l1, n.at, NC, n.C.W)), t = A2(QB, Gb, r);
        return A2(e_, A([
            o_("button"),
            YN("btn btn-outline-primary w-100"),
            YN("d-flex justify-content-center align-items-center"),
            YN("gap-1 w-100"),
            i_(n.nD(t)),
            E_(sf(r))
        ]), A([
            rB,
            c_("Ajouter un emballage")
        ]));
    }, Z0 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, n2 = F4(function(n, e, r, t) {
        var u = n.C, a = n.b7, i = n.O, c = n.nc;
        return sf(t) ? A2(WN, A([
            YN("card-body")
        ]), A([
            c_(r.fb)
        ])) : A2(WN, A([
            YN("QuantifiedProcessList table-responsive table-scroll position-relative")
        ]), A([
            A2(G_, A([
                YN("table table-hover mb-0")
            ]), A([
                function() {
                    var n = A2(r.fd, u.W, t);
                    if (1 === n.$) return A2(s1, Ur, n.a);
                    var o = n.a;
                    return A2(X_, j, A2(bt, F2(function(n, t) {
                        var u = t.j, o = t.t;
                        return A2(K_, j, A([
                            A2(V_, A([
                                YN("ps-3 align-middle text-nowrap"),
                                A2(qH, "min-width", "160px")
                            ]), A([
                                A2(_1, {
                                    mj: r.fj + "-" + ut(n),
                                    ai: "Quantit\xe9",
                                    nc: c,
                                    nt: r.f_(n),
                                    H: a,
                                    aL: o.aL,
                                    pS: A2(el, Xb, o.cP) ? Z0("Cette quantit\xe9 n\u2019est pas modifiable") : w1
                                }, A3(Ix, e, o, u))
                            ])),
                            A2(V_, A([
                                YN("align-middle text-truncate w-66 cursor-help "),
                                A2(qH, "max-width", "0"),
                                W_(A2(at, "\n", A([
                                    Gb(o),
                                    Hb(o)
                                ])))
                            ]), A([
                                c_(Gb(o))
                            ])),
                            A2(V_, A([
                                YN("align-middle text-end text-nowrap")
                            ]), A([
                                A2(tW, i, A2(Nc, Ks, A2(xx, n, r.fk)))
                            ])),
                            A2(V_, A([
                                YN("align-middle pe-3 pt-2")
                            ]), A([
                                A2(e_, A([
                                    o_("button"),
                                    YN("btn btn-sm btn-outline-secondary"),
                                    W_(r.e8),
                                    i_(r.fE(n))
                                ]), A([
                                    NX
                                ]))
                            ]))
                        ]));
                    }), o));
                }()
            ]))
        ]));
    }), e2 = F2(function(n, e) {
        var r = n.g5;
        return A2(WN, A([
            YN("card shadow-sm")
        ]), A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between gap-2")
            ]), A([
                A2(I_, A([
                    YN("h5 mb-0")
                ]), A([
                    c_("Emballage")
                ])),
                A2(WN, A([
                    YN("d-flex flex-fill justify-content-end align-items-center gap-2")
                ]), A([
                    A2(tW, n.O, lh(e.cs))
                ])),
                A2(R0, n, "packaging")
            ])),
            A4(n2, n, e, {
                e8: "Supprimer cet emballage",
                fb: "Aucun emballage",
                fd: ux,
                fj: "packaging",
                fk: e.cs,
                fE: n.n8,
                f_: n.pE
            }, r.aR),
            Q0(n)
        ]));
    }), r2 = function(n) {
        return n ? 1 : 0;
    }, t2 = function(n) {
        var e = n.gd, r = n.mj, t = n.ai, u = n.gV;
        return A2(WN, A([
            YN("d-flex justify-content-end align-items-center gap-2")
        ]), A([
            A2(N_, A([
                o_("checkbox"),
                YN("form-check-input"),
                yH(r),
                w_(e),
                xX(u)
            ]), j),
            A2(gX, A([
                YN("form-check-label"),
                vX(r)
            ]), A([
                c_(t)
            ]))
        ]));
    }, u2 = function(n) {
        return t2({
            gd: s(n.g5.ax.a8, 1),
            mj: "transportByAirSwitch",
            ai: "par avion",
            gV: A2(Hu, r2, n.o6)
        });
    }, a2 = function(n) {
        var e = n.g5;
        return t2({
            gd: A2(jx, M0(n), e),
            mj: "transportCoolingSwitch",
            ai: "r\xe9frig\xe9r\xe9",
            gV: n.o7
        });
    }, i2 = F2(function(n, e) {
        var r = A3(z0, n.h8, n.at, e);
        if (r.$) return c_("");
        var t = r.a;
        return A2(vQ, A([
            YN("text-muted"),
            QN(t),
            W_("Documentation"),
            _H("_blank")
        ]), A([
            AY
        ]));
    }), c2 = F3(function(n, e, r) {
        var t = n.h8, u = n.O, a = n.at, i = A2(wh, function(n) {
            return A2(el, a, n.g9);
        }, A([
            t.af.m7.kL,
            t.af.m7.mQ
        ])), c = A2(el, a, t.af.m7.nL.g9);
        return A2(NQ, A([
            A2(WN, A([
                YN("d-flex justify-content-end align-items-center gap-2")
            ]), A([
                c_("Transport"),
                G1,
                pV(e),
                i ? a2(n) : c_(""),
                c ? u2(n) : c_("")
            ]))
        ]), A([
            A2(WN, A([
                YN("d-flex align-items-center gap-2")
            ]), A([
                A2(WN, A([
                    YN("d-flex gap-2")
                ]), A2(bQ, {
                    f6: zr("avion"),
                    gy: !0,
                    gD: !0,
                    es: !1,
                    g8: Ur,
                    hc: Ur
                }, r)),
                A2(tW, u, r.g),
                A2(i2, n, "transport")
            ]))
        ]));
    }), o2 = function(n) {
        var e = n.nC, r = n.g5, t = A2(Ah, function(e) {
            return !A2(el, e.mj, A2(wu, function(n) {
                return n.bl;
            }, A2(Cx, M0(n), r)));
        }, A3(l1, n.at, DC, n.C.W)), u = A2(QB, Gb, t);
        return A2(e_, A([
            o_("button"),
            YN("btn btn-outline-primary w-100"),
            YN("d-flex justify-content-center align-items-center"),
            YN("gap-1 w-100"),
            E_(sf(t)),
            i_(e(u))
        ]), A([
            rB,
            c_("Ajouter une consommation")
        ]));
    }, f2 = F2(function(n, e) {
        var r = n.O, t = n.g5;
        return A2(WN, A([
            YN("card shadow-sm")
        ]), A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between gap-2")
            ]), A([
                A2(I_, A([
                    YN("h5 mb-0")
                ]), A([
                    c_("Utilisation")
                ])),
                A2(WN, A([
                    YN("d-flex flex-fill justify-content-end align-items-center gap-2")
                ]), A([
                    A2(tW, r, lh(e.bK))
                ])),
                A2(R0, n, "use")
            ])),
            A2(WN, A([
                YN("d-flex flex-column p-0")
            ]), A([
                A4(n2, n, e, {
                    e8: "Supprimer cette consommation",
                    fb: "Aucune consommation",
                    fd: Ex,
                    fj: "consumption",
                    fk: e.bK,
                    fE: n.n4,
                    f_: n.pl
                }, A2(Cx, M0(n), t)),
                o2(n)
            ]))
        ]));
    }), s2 = F2(function(n, e) {
        return A2(WN, j, A([
            K0,
            A2(e2, n, e),
            A3(c2, n, e.aT, e.af.eJ),
            A2(V0, n, e),
            K0,
            A2(f2, n, e),
            K0,
            A2(W0, n, e)
        ]));
    }), l2 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, d2 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, b2 = function(n) {
        return sf(n.r);
    }, m2 = function(n) {
        var e = n.C, r = 1 === n.k2 ? j : A2(wu, d2, A2(Ah, function(n) {
            return !A2(el, NC, n.cP);
        }, A3(l1, n.at, PC, e.W))), t = k(A2(wu, l2, A2(Ah, A2(Hu, function(n) {
            return n.g9;
        }, el(n.at)), A2(Ah, A2(cc, rl, b2), e.dZ))), r), u = A2(QB, l0, A2(LA, l0, t));
        return A2(e_, A([
            o_("button"),
            YN("btn btn-outline-primary w-100"),
            YN("d-flex justify-content-center align-items-center"),
            YN("gap-1 w-100"),
            E_(sf(t)),
            i_(n.nF(u))
        ]), A([
            rB,
            c_(n.mF.bN)
        ]));
    }, p2 = function(n) {
        return A2(K_, A([
            YN("fs-8 fw-normal text-muted border-bottom")
        ]), A([
            A2(J_, A([
                YN("ps-2 py-2 align-middle"),
                F0("col")
            ]), A([
                A2(m_, A([
                    YN("visually-hidden")
                ]), A([
                    c_("D\xe9tails")
                ]))
            ])),
            A2(J_, A([
                YN("py-2 text-end align-middle text-nowrap"),
                F0("col")
            ]), A([
                c_("Masse unitaire")
            ])),
            A2(J_, A([
                YN("py-2 align-middle text-truncate w-100"),
                A2(qH, "max-width", "0"),
                F0("col")
            ]), A([
                c_(n.mF.bf)
            ])),
            A2(J_, A([
                YN("py-2 align-middle text-center"),
                F0("col")
            ]), A([
                c_("Quantit\xe9")
            ])),
            A2(J_, A([
                YN("py-2 text-end align-middle text-nowrap"),
                F0("col")
            ]), A([
                c_("Masse totale")
            ])),
            A2(J_, A([
                YN("py-2 text-end align-middle text-nowrap"),
                A2(qH, "min-width", "80px"),
                F0("col")
            ]), A([
                c_("Impacts")
            ])),
            A2(J_, A([
                YN("py-2 pe-3 text-end align-middle text-nowrap"),
                F0("col")
            ]), A([
                A2(m_, A([
                    YN("visually-hidden")
                ]), A([
                    c_("Actions")
                ]))
            ]))
        ]));
    }, v2 = function(n) {
        return "item-table-" + ut(n);
    }, g2 = F3(function(n, e, r) {
        var t = r ? "D\xe9plier les d\xe9tails" : "Replier les d\xe9tails";
        return A2(e_, A([
            o_("button"),
            YN("btn btn-link text-muted text-decoration-none font-monospace fs-6 p-0 m-0"),
            W_(t),
            A2(n_, "aria-label", t),
            A2(n_, "aria-expanded", r ? "false" : "true"),
            A2(n_, "aria-controls", v2(e)),
            i_(n.oz(r ? iy(A2(Mr, e, n.lu)) : A2(Ah, Ic(e), n.lu)))
        ]), A([
            c_(r ? "\u25B6" : "\u25BC")
        ]));
    }), h2 = y_("hidden"), $2 = F3(function(n, e, r) {
        var t = A2(e_, A([
            o_("button"),
            YN("btn btn-sm btn-outline-secondary"),
            A2(n_, "aria-label", "Modifier la composition"),
            i_(n.nA(v(r, e)))
        ]), A([
            GK
        ])), u = A2(e_, A([
            o_("button"),
            YN("btn btn-sm btn-outline-secondary"),
            A2(n_, "aria-label", "Supprimer"),
            i_(n.n7(e))
        ]), A([
            NX
        ]));
        return A2(WN, A([
            YN("btn-group")
        ]), A(1 !== n.k2 ? [
            t,
            u
        ] : [
            u
        ]));
    }), x2 = {
        hI: c_(""),
        gu: c_(""),
        g: c_(""),
        ai: c_(""),
        D: c_(""),
        hy: c_(""),
        dH: c_("")
    }, k2 = A2(Hu, wu(function(n) {
        var e = n.i;
        return k(Gb(n.t), e.$ ? "" : " (" + e.a.ek + ")");
    }), at(", ")), j2 = F2(function(n, e) {
        return A2(K_, n, A([
            A2(V_, A([
                YN("ps-2 py-2 align-middle")
            ]), A([
                e.gu
            ])),
            A2(V_, A([
                YN("py-2 text-end align-middle text-nowrap")
            ]), A([
                e.dH
            ])),
            A2(V_, A([
                YN("py-2 align-middle text-truncate w-100"),
                A2(qH, "max-width", "0")
            ]), A([
                e.ai
            ])),
            A2(V_, A([
                YN("py-2 align-middle text-center")
            ]), A([
                e.D
            ])),
            A2(V_, A([
                YN("py-2 text-end align-middle text-nowrap")
            ]), A([
                e.hy
            ])),
            A2(V_, A([
                YN("py-2 text-end align-middle text-nowrap"),
                A2(qH, "min-width", "80px")
            ]), A([
                e.g
            ])),
            A2(V_, A([
                YN("py-2 pe-3 text-end align-middle text-nowrap")
            ]), A([
                e.hI
            ]))
        ]));
    }), y2 = F4(function(n, e, r, t) {
        var u = r.U, a = r.J, i = function(n) {
            var e = n.i;
            return A2(at, " ", A([
                Gb(n.t),
                "(" + A2(Nc, "Inconnu", A2(Pc, function(n) {
                    return n.ek;
                }, e)) + ")"
            ]));
        }, c = Oh(t), o = R1(t), f = A2(m_, A([
            YN("d-flex text-muted fs-8")
        ]), A([
            2 !== u.t.aL ? A2(m_, j, A([
                c_("("),
                A2($V, u.t, o),
                c_(")\xa0")
            ])) : c_(""),
            pV(c)
        ]));
        return A2(j2, A([
            YN("fs-7 border-top")
        ]), $(x2, {
            g: A2(tW, n.O, J1(t)),
            ai: A2(WN, A([
                YN("d-flex flex-column")
            ]), A([
                A2(WN, A([
                    W_(i(u))
                ]), A([
                    c_(i(u))
                ])),
                A2(WN, A([
                    YN("d-flex align-items-center gap-1 text-muted"),
                    W_(k2(a))
                ]), A([
                    sf(a) ? c_("Aucune transformation") : c_(k2(a))
                ]))
            ])),
            dH: A2(WN, A([
                YN("d-flex flex-column align-items-end")
            ]), A([
                A2(jJ, 1, A2(D1, c, HP(e))),
                f
            ]))
        }));
    }), w2 = F3(function(n, e, r) {
        return sf(e) ? ck(A2(j2, A([
            YN("bg-light border-bottom")
        ]), $(x2, {
            ai: c_("Aucun \xe9l\xe9ment")
        }))) : A3(st, A2(y2, n, r), e, hx(r));
    }), T2 = F3(function(n, e, r) {
        return A2(WN, A([
            YN("input-group"),
            A2(qH, "width", "70px")
        ]), A([
            A2(N_, A([
                o_("number"),
                YN("form-control form-control-sm text-end"),
                hG(ut(r)),
                tQ("1"),
                rQ("1"),
                mG(function(r) {
                    return A2(Nc, n.nc, A2(Pc, A2(Hu, jP, n.px(e)), A2(Ba, function(n) {
                        return n > 0 ? zr(n) : Ur;
                    }, du(r))));
                })
            ]), j)
        ]));
    }), E2 = function(n) {
        return 2 === n.aL || !s(n.mZ, Ur);
    }, C2 = F4(function(n, e, r, t) {
        var u = A2(Nc, HP(t), A2(Ba, function(n) {
            return n.dH;
        }, A2(xx, e, n.g5.my))), a = A2(nl, A2(Hu, function(n) {
            return n.U;
        }, A2(Hu, function(n) {
            return n.t;
        }, A2(Hu, E2, rl))), r) ? Z0("La masse par unit\xe9 du proc\xe9d\xe9 mobilis\xe9 n\u2019est pas connue \xe0 ce jour") : s(u, 0) ? Z0("La masse des \xe9l\xe9ments du composant est nulle, \xe9dition impossible") : n.pg ? Z0("La masse unitaire n\u2019est pas modifiable tant que la modale d\u2019\xe9dition du composant est ouverte") : w1;
        return A2(_1, {
            mj: "unit-mass-" + ut(e),
            ai: "Masse unitaire",
            nc: n.nc,
            nt: n.py(e),
            H: n.b7,
            aL: 2,
            pS: a
        }, Ch(u));
    }), I2 = F4(function(n, e, r, t) {
        var u = r.h7, a = r.r, i = r.D, c = !A2(el, e, n.lu);
        return A([
            A2(X_, e > 0 ? A([
                A2(qH, "border-top", "1px solid #777")
            ]) : j, A([
                A2(j2, A([
                    YN("border-bottom"),
                    r_(A([
                        v("table-info", !c)
                    ]))
                ]), {
                    hI: A3($2, n, e, u),
                    gu: 1 === n.k2 ? c_("") : A3(g2, n, e, c),
                    g: A2(tW, n.O, J1(t)),
                    ai: A2(m_, A([
                        W_(u.ek)
                    ]), A([
                        c_(u.ek)
                    ])),
                    D: A3(T2, n, e, i),
                    hy: pV(Oh(t)),
                    dH: 1 === n.k2 ? pV(HP(t)) : A4(C2, n, e, a, t)
                })
            ])),
            A2(X_, A([
                YN("table-light"),
                yH(v2(e)),
                h2(c)
            ]), A3(w2, n, a, t))
        ]);
    }), S2 = F2(function(n, e) {
        var r = n.ly, t = n.lX, u = n.g5;
        return A2(WN, A([
            YN("card shadow-sm")
        ]), A([
            A2(WN, A([
                YN("card-header d-flex align-items-center justify-content-between gap-2")
            ]), A([
                A2(I_, A([
                    YN("h5 mb-0")
                ]), A([
                    c_(n.mF.cw),
                    t.$ ? c_("") : A2(kJ, A([
                        ZN(t.a),
                        W_("Explorer"),
                        A2(n_, "aria-label", "Explorer")
                    ]), A([
                        vY
                    ]))
                ])),
                A2(WN, A([
                    YN("d-flex flex-fill justify-content-end align-items-center gap-2")
                ]), A([
                    A2(m_, A([
                        YN("cursor-help"),
                        W_("Hors transports")
                    ]), A([
                        A2(tW, n.O, J1(e))
                    ])),
                    r.$ ? c_("") : A2(_B, A([
                        QN(r.a),
                        _H("_blank"),
                        A2(qH, "height", "24px")
                    ]), A([
                        AY
                    ]))
                ])),
                n.lz
            ])),
            function() {
                if (sf(u.my)) return A2(WN, A([
                    YN("card-body")
                ]), A([
                    c_(n.mF.b1)
                ]));
                var r = A2(px, n.C, u.my);
                if (1 === r.$) {
                    var t = r.a;
                    return A2(s1, zr("Erreur"), t);
                }
                var a = r.a;
                return A2(WN, A([
                    YN("table-responsive")
                ]), A([
                    A2(G_, A([
                        YN("table table-sm table-borderless mb-0")
                    ]), A2(Mr, A2(Y_, j, A([
                        p2(n)
                    ])), Cd(A4(c0, I2(n), A2(dt, 0, ft(u.my) - 1), a, hx(e)))))
                ]));
            }(),
            m2(n)
        ]));
    }), O2 = F2(function(n, e) {
        return n.$ ? e : A2(O$, Pc(uw(n.a)), e);
    }), L2 = A2(Hu, _Y, ch(19)), P2 = F2(function(n, e) {
        return qc(A([
            v("ecs", sK(n)),
            v("complements", sK(e))
        ]));
    }), q2 = function(n) {
        return A2(Hu, cw, A2(Hu, A2(st, F2(function(e, r) {
            return v(e, A2(Pc, A2(Hu, ch(n), sK), r));
        }), cw(mK)), Do));
    }, N2 = F2(function(n, e) {
        var r = e;
        return qc(A2(wu, function(n) {
            return v(Pl(n), sK(A2(eh, n, r)));
        }, A2(Ah, function(e) {
            return !A2(el, e, n);
        }, PJ)));
    }), _2 = A2(Hu, bf, Sc), z2 = F3(function(n, e, r) {
        var t = r, u = A2(I0, n, J1(t)), a = A2(O2, n, t.S);
        return Do(A([
            v("id", A2(Pc, _2, e.mj)),
            v("name", A2(Pc, Sc, t.ai)),
            v("quantity", zr(Lc(t.D))),
            v("mass", zr(No(t.P))),
            v("score", zr(A2(P2, A2(ch, 19, u), L2(a)))),
            v("impacts", zr(A2(N2, A([
                19
            ]), u))),
            v("complements", zr(A2(q2, 19, a)))
        ]));
    }), U2 = F3(function(n, e, r) {
        return A2(To, ru, A3(st, z2(n), e.my, hx(r.Q)));
    }), M2 = F2(function(n, e) {
        var r = uZ(e), t = A2(Hu, Nc(Ks), A2(Hu, I0(n), A2(Hu, ch(19), sK)));
        return qc(A([
            v("materials", t(r.ft)),
            v("transform", t(r.fX)),
            v("assembly", t(r.q)),
            v("packaging", t(r.cs)),
            v("transports", t(r.af)),
            v("distribution", t(r.E)),
            v("usage", t(r.kl)),
            v("endOfLife", t(r._))
        ]));
    }), D2 = F2(function(n, e) {
        return n.$ ? e : A2(_h, n.a, e);
    }), R2 = F4(function(n, e, r, t) {
        var u = function(n) {
            return sK(A2(D2, e, n));
        }, a = A2(ch, 19, _Y(NY(t.Q))), i = A2(UJ, n, r);
        return qc(A([
            v("biodiversity", u(i.kJ)),
            v("climate", u(i.kZ)),
            v("health", u(i.md)),
            v("resources", u(i.ob)),
            v("complements", u(a))
        ]));
    }), H2 = F3(function(n, e, r) {
        var t = zY(r), u = A2(I0, e.aO, t), a = A2(O2, e.aO, NY(r.Q));
        return A([
            v("productMass", No(r.aT)),
            v("score", A2(P2, A2(ch, 19, u), L2(a))),
            v("impacts", A2(N2, A([
                19
            ]), u)),
            v("complements", A2(q2, 19, a)),
            v("subscores", A4(R2, n, e.aO, t, r)),
            v("stages", A2(M2, e.aO, r)),
            v("composition", A3(U2, e.aO, e, r))
        ]);
    }), G2 = F2(function(n, e) {
        var r = function(e) {
            return n.$ ? lK(e) : sK(A2(ch, n.a, e));
        };
        return Do(A([
            v("cropDiversity", A2(Pc, r, e.ag)),
            v("forest", A2(Pc, r, e.aa)),
            v("hedges", A2(Pc, r, e.ah)),
            v("microfibers", A2(Pc, r, e.aj)),
            v("outOfEuropeEOL", A2(Pc, r, e.ak)),
            v("permanentPasture", A2(Pc, r, e.al)),
            v("plotSize", A2(Pc, r, e.am))
        ]));
    }), X2 = function(n) {
        switch(n){
            case 0:
                return "assembly";
            case 1:
                return "material";
            case 2:
                return "transformation";
            default:
                return "transport";
        }
    }, V2 = F2(function(n, e) {
        var r = e;
        return Do(A([
            v("label", A2(Pc, Sc, r.ai)),
            v("stage", A2(Pc, A2(Hu, X2, Sc), r.av)),
            v("mass", zr(No(r.P))),
            v("materialType", A2(Pc, A2(Hu, cl, Sc), r.aF)),
            v("quantity", zr(Lc(r.D))),
            v("complementsImpacts", zr(A2(G2, n, r.S))),
            v("impacts", zr(n.$ ? lK(r.g) : sK(A2(ch, n.a, r.g)))),
            v("items", zr(A2(To, V2(n), r.my)))
        ]));
    }), J2 = F2(function(n, e) {
        var r, t;
        return qc(A([
            v("endOfLife", n.$ ? lK(e._) : sK(A2(ch, n.a, e._))),
            v("distribution", (t = e.E, Do(A([
                v("impacts", zr(lK(t.g))),
                v("process", A2(Pc, A2(Hu, function(n) {
                    return n.mj;
                }, Fo), t.t)),
                v("volume", zr(No(t.eY)))
            ])))),
            v("production", A2(V2, n, e.Q)),
            v("transport", (r = e.af, qc(A([
                v("toAssembly", bK(r.eH)),
                v("toDistribution", bK(r.eJ))
            ])))),
            v("use", A2(To, lK, e.bK))
        ]));
    }), Y2 = F3(function(n, e, r) {
        return A2(WN, j, A([
            A2(VH, A([
                YN("card-body py-2")
            ]), A([
                A2(WH, j, A([
                    c_("Debug")
                ])),
                A2(WN, A([
                    YN("row g-2")
                ]), A([
                    A2(WN, A([
                        YN("col-6")
                    ]), A([
                        A2(O_, j, A([
                            c_("Results")
                        ])),
                        A2(R_, A([
                            YN("p-2 bg-light")
                        ]), A([
                            c_(A2(tt, 2, A2(J2, zr(19), r)))
                        ]))
                    ])),
                    A2(WN, A([
                        YN("col-6")
                    ]), A([
                        A2(O_, j, A([
                            c_("API response")
                        ])),
                        A2(R_, A([
                            YN("p-2 bg-light")
                        ]), A([
                            c_(A2(tt, 2, qc(A3(H2, n.C.c_, e, r))))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), W2 = F2(function(n, e) {
        var r = n.O, t = n.g5, u = n.at;
        return A2(WN, A([
            YN("d-flex flex-column")
        ]), A([
            A2(S2, {
                k2: n.k2,
                C: n.C,
                lu: n.lu,
                ly: n.ly,
                lz: A2(R0, n, "production"),
                lX: n.lX,
                b7: n.b7,
                O: n.O,
                mF: {
                    bN: n.mF.bN,
                    b1: n.mF.b1,
                    bf: n.mF.bf,
                    cw: n.mF.cw
                },
                nc: n.nc,
                nA: n.nA,
                nF: n.nF,
                g5: n.g5,
                n7: n.n7,
                at: n.at,
                oz: n.oz,
                pg: n.pg,
                px: n.px,
                py: n.py
            }, e.Q),
            FK(u) && !sf(t.my) ? A2(WN, j, A([
                A2(NQ, A([
                    A2(WN, A([
                        YN("d-flex justify-content-end align-items-center gap-1")
                    ]), A([
                        c_("Transport"),
                        A2(m_, j, A([
                            G1,
                            G0,
                            G1
                        ]))
                    ]))
                ]), A([
                    A2(WN, A([
                        YN("d-flex gap-2")
                    ]), A([
                        A2(tW, r, e.af.eH.g),
                        A2(i2, n, "transport")
                    ]))
                ])),
                A2(H0, n, e)
            ])) : c_(""),
            n.k2 || sf(t.my) ? c_("") : A2(s2, n, e),
            n.lh ? A3(Y2, n, t, e) : c_("")
        ]));
    }), K2 = function(n) {
        var e = n.ac;
        if (1 === e.$) {
            var r = e.a;
            return A2(s1, zr("Erreur de chargement du calculateur"), r);
        }
        return A2(W2, n, e.a);
    }, B2 = F2(function(n, e) {
        var r = g(xA(e.Q), e.aT, A2(ch, 19, _Y(NY(e.Q))));
        return A3(MJ, n, r.c, A2(uw, r.b, r.a));
    }), Q2 = F3(function(n, e, r) {
        return $(r, {
            cU: A2(O$, Pc(ch(r.ch.kj)), NY(e.Q)),
            ha: A2(B2, n, e),
            ez: A2(tZ, Pc(ch(r.ch.kj)), uZ(e)),
            bI: zY(e)
        });
    }), Z2 = F2(function(n, e) {
        var r, t, u, a, i, c = n.h8, o = e.iE, f = ds(o), l = A2(Zx, o, n);
        return A2(WN, A([
            YN("row")
        ]), A([
            A2(WN, A([
                YN("col-lg-8 bg-white")
            ]), A([
                A2(BN, A([
                    YN("visually-hidden")
                ]), A([
                    c_("Simulateur ")
                ])),
                A2(WN, A([
                    YN("sticky-md-top bg-white pb-3")
                ]), A([
                    HQ({
                        lc: l,
                        lQ: Bx,
                        lT: e.lT,
                        mf: Ur,
                        nu: A2(Hu, vP, DZ),
                        oh: {
                            lW: A2(bd, f, A2(jd, o, Ur)),
                            mN: Nb(o),
                            on: _b(o)
                        }
                    }),
                    (t = {
                        nv: E0,
                        dp: n.C.dp,
                        g5: l,
                        at: o
                    }, u = t.nv, a = t.g5, i = A2(LA, function(n) {
                        return n.ai;
                    }, A2(oW, t.at, t.dp)), sf(i) || sf(a.my) ? c_("") : A2(WN, A([
                        YN("d-flex flex-row align-items-center gap-2 my-3")
                    ]), A([
                        A2(gX, A([
                            vX("product-category"),
                            YN("form-label fw-bold text-nowrap")
                        ]), A([
                            c_("Cat\xe9gorie de produit")
                        ])),
                        A2(vG, A([
                            yH("product-category"),
                            YN("form-select"),
                            mG(function(n) {
                                return su(n) ? u(Ur) : A2(Zg, u(Ur), A2(fs, A2(Hu, zr, u), NS(n)));
                            })
                        ]), A2(Mr, A2(pG, A([
                            hG(""),
                            gG(s(a.aS, Ur))
                        ]), A([
                            c_("Autres")
                        ])), A2(wu, function(n) {
                            return A2(pG, A([
                                hG(Lh(n.mj)),
                                gG(s(a.aS, zr(n.mj)))
                            ]), A([
                                c_(n.ai)
                            ]));
                        }, i)))
                    ])))
                ])),
                A3(U0, c, f, l.aO),
                K2(A2(f1, n, e))
            ])),
            A2(WN, A([
                YN("col-lg-4 bg-white")
            ]), A([
                (r = A2(Zg, Ox, e.ac), TB({
                    kw: e.dW,
                    bw: e.bw,
                    bx: e.bx,
                    k0: h0,
                    k4: e.cV,
                    k5: e.cW,
                    k6: e.a9,
                    k8: b0,
                    la: m0,
                    le: Ur,
                    lq: p0,
                    lY: v0,
                    ml: sf(l.my) ? Ur : zr(A3(Q2, n.C.c_, r, A5(NK, n, e.O, e.dN, Wi(iP), y0))),
                    mm: g0,
                    nc: iP,
                    aT: r.aT,
                    n9: $0,
                    ok: x0,
                    at: f,
                    dv: e.O,
                    ey: n,
                    oP: k0,
                    oR: j0,
                    o9: A2(S0, l.aO, r),
                    pa: zr(zY(r)),
                    pk: w0,
                    pm: A0,
                    pn: T0,
                    pH: C0
                }))
            ]))
        ]));
    }), n3 = F2(function(n, e) {
        return v("Simulateur", A([
            A2(KN, A([
                YN("Simulator pb-3")
            ]), A([
                A2(Z2, n, e),
                A2(Nc, c_(""), A2(Pc, A2(d0, n, e), q$(e.M)))
            ]))
        ]));
    }), e3 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, r3 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, t3 = fe("cite"), u3 = function(n) {
        var e = n.lR;
        return A2(KN, A([
            YN("pt-4 pb-5")
        ]), A([
            A2(WN, A([
                YN("px-5")
            ]), A([
                A2(I_, A([
                    YN("h1")
                ]), A([
                    c_("Calculez le co\xfbt environnemental de vos produits")
                ])),
                A2(WN, A([
                    YN("fs-5 mt-3 mb-5")
                ]), A([
                    A2(hH, j, "Ecobalyse permet de comprendre et d\u2019exprimer les impacts environnementaux des produits distribu\xe9s en France\n                     par le calcul d\u2019un co\xfbt en points d\u2019impact\u202F: **le co\xfbt environnemental**.\n                     D\xe9couvrez nos outils et notre p\xe9rim\xe8tre d\u2019action\u202F!")
                ])),
                A2(WN, A([
                    YN("d-flex flex-column flex-lg-row gap-3 mb-4")
                ]), A2(qa, function(n) {
                    return n.a ? zr(function(n) {
                        var e = n.ai, r = n.dA, t = n.cO, u = n.dj, a = n.dB;
                        return A2(e_, A([
                            o_("button"),
                            YN("btn btn-lg d-flex flex-column align-items-center justify-content-center"),
                            r_(A([
                                v("btn-primary", t),
                                v("btn-outline-primary", !t)
                            ])),
                            i_(u),
                            A2(n_, "data-testid", a)
                        ]), A([
                            c_(e),
                            function() {
                                if (r.$) return c_("");
                                var n = r.a;
                                return A2(t3, A([
                                    YN("fw-normal fs-7 d-block")
                                ]), A([
                                    c_(n)
                                ]));
                            }()
                        ]));
                    }(n.b)) : Ur;
                }, A([
                    v(!0, {
                        cO: !0,
                        ai: "Calculer l\u2019impact d\u2019un v\xeatement",
                        dj: e3($H + "#/textile/simulator"),
                        dA: zr("Version r\xe9glementaire"),
                        dB: "textile-callout-button"
                    }),
                    v(e.l5, {
                        cO: !1,
                        ai: "Calculer l\u2019impact de l\u2019alimentation",
                        dj: r3(vd),
                        dA: zr("M\xe9thodologie stabilis\xe9e"),
                        dB: "food-callout-button"
                    }),
                    v(e.nn, {
                        cO: !1,
                        ai: "Calculer l\u2019impact d\u2019un objet",
                        dj: r3(_b(2)),
                        dA: zr("Simulateur en construction"),
                        dB: "object-callout-button"
                    }),
                    v(e.f2, {
                        cO: !1,
                        ai: "Calculer l\u2019impact d\u2019un v\xe9hicule",
                        dj: r3(_b(3)),
                        dA: zr("Simulateur en construction"),
                        dB: "veli-callout-button"
                    })
                ])))
            ]))
        ]));
    }, a3 = A2(KN, j, A([
        A2(WN, A([
            YN("d-flex flex-column gap-2 p-0 px-md-5")
        ]), A([
            A2(I_, A([
                YN("h3")
            ]), A([
                c_("Afficher le co\xfbt environnemental")
            ])),
            A2(hH, j, "Le co\xfbt environnemental peut \xeatre utilis\xe9 pour comprendre, informer, enrichir un bilan carbone\nou pour diff\xe9rentes politiques publiques (march\xe9s publics, eco-modulation\u2026)\n\nL\u2019affichage du co\xfbt environnemental d\u2019un produit permet d\u2019**informer le consommateur**. Depuis la loi Climat et\nR\xe9silience de 2021, des travaux sont engag\xe9s pour permettre cet affichage. Ils portent sur les v\xeatements, les\nproduits alimentaires ou encore l\u2019ameublement. Pour plus d\u2019informations, vous pouvez consulter\u202F:\n\n- le [site de l\u2019ADEME](https://affichage-environnemental.ademe.fr)\n- le site du [minist\xe8re en charge de l\u2019\xe9cologie](https://www.ecologie.gouv.fr/politiques-publiques/affichage-environnemental-v\xeatements)"),
            A2(WN, A([
                YN("d-flex flex-column flex-lg-row gap-3")
            ]), A([
                A2(m_, A([
                    YN("home-illustration")
                ]), A([
                    A2(q_, A([
                        F_("img/etiquette-exemple.png"),
                        x_("Exemple d'\xe9tiquetage environnemental r\xe9glementaire de 930 points d'impact")
                    ]), j)
                ])),
                A2(WN, A([
                    YN("row g-3")
                ]), A([
                    A2(WN, A([
                        YN("col-lg-6 d-flex flex-column justify-content-between gap-2 h-100")
                    ]), A([
                        A2(hH, j, "Pour les v\xeatements, **un cadre r\xe8glementaire complet a \xe9t\xe9 publi\xe9 le 9 septembre 2025**.\n                             Il encadre l\u2019affichage volontaire du co\xfbt environnemental des v\xeatements. Une m\xe9thodologie\n                             de calcul r\xe8glementaire est ainsi arr\xeat\xe9e, la **v7.0.0**."),
                        A2(e_, A([
                            YN("btn btn-primary"),
                            i_(e3($H + "#/textile/simulator"))
                        ]), A([
                            c_("Utiliser la version r\xe9glementaire 7.0.0")
                        ]))
                    ])),
                    A2(WN, A([
                        YN("col-lg-6 d-flex flex-column justify-content-between gap-3 h-100")
                    ]), A([
                        A2(hH, j, "Pour afficher le co\xfbt environnemental sur vos produits textiles, il est n\xe9cessaire de **d\xe9clarer leur co\xfbt**\n                             sur un portail d\xe9di\xe9\u202F!"),
                        A2(zH, A([
                            YN("btn btn-outline-primary"),
                            QN("https://affichage-environnemental.ecobalyse.beta.gouv.fr/declarations")
                        ]), A([
                            c_("Acc\xe9der au portail de d\xe9claration")
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ])), i3 = d_("material"), c3 = A2(KN, j, A([
        A2(WN, A([
            YN("row px-md-5 gap-5 gap-md-0")
        ]), A([
            A2(WN, A([
                YN("col-md-6 d-flex flex-column justify-content-between gap-2")
            ]), A([
                A2(t_, A([
                    YN("h4 d-flex align-items-baseline gap-2")
                ]), A([
                    A2(m_, A([
                        YN("fs-5")
                    ]), A([
                        vY
                    ])),
                    c_("Les dessous du co\xfbt environnemental")
                ])),
                A2(hH, A([
                    YN("flex-fill")
                ]), A3(Yb, "{url_pef}", "https://eplca.jrc.ec.europa.eu/EnvironmentalFootprint.html", A3(Yb, "{url_acv}", "https://fr.wikipedia.org/wiki/Analyse_du_cycle_de_vie", 'Le co\xfbt environnemental s\u2019appuie sur la m\xe9thodologie [ACV]({url_acv} "Analyse en Cycle de Vie")\n                     du [PEF]({url_pef} "Product Environmental Footprint")\n                     **compl\xe9t\xe9e sur les aspects qu\u2019elle ne couvre pas encore**. Il est issu du travail des pouvoirs publics\n                     en s\u2019appuyant sur des **experts** et parties prenantes mobilis\xe9s lors de concertations.'))),
                A2(WN, A([
                    YN("d-flex mt-3 gap-3")
                ]), A([
                    A2(zH, A([
                        YN("btn btn-primary text-truncate"),
                        QN(IH)
                    ]), A([
                        c_("Parcourir la documentation m\xe9thodologique")
                    ]))
                ]))
            ])),
            A2(WN, A([
                YN("col-md-6 d-flex flex-column justify-content-between gap-2")
            ]), A([
                A2(t_, A([
                    YN("h4 d-flex align-items-baseline gap-2")
                ]), A([
                    A2(m_, A([
                        YN("fs-5")
                    ]), A([
                        i3
                    ])),
                    c_("Impacts et donn\xe9es d\xe9taill\xe9es")
                ])),
                A2(hH, A([
                    YN("flex-fill")
                ]), "Acc\xe9dez aux **impacts environnementaux d\xe9taill\xe9s** de vos simulations en cr\xe9ant un compte utilisateur\n                     et \xe0 l'ensemble des mod\xe9lisations et **donn\xe9es sources** en parcourant l\u2019explorateur."),
                A2(WN, A([
                    YN("d-flex mt-3 gap-3")
                ]), A([
                    A2(zH, A([
                        YN("btn btn-primary"),
                        QN(_T(ld))
                    ]), A([
                        c_("Cr\xe9er un compte Ecobalyse")
                    ])),
                    A2(e_, A([
                        YN("btn btn-outline-primary"),
                        i_(r3(A2(bd, bs, yd(Ur))))
                    ]), A([
                        c_("Explorer les donn\xe9es")
                    ]))
                ]))
            ]))
        ]))
    ])), o3 = d_("plug"), f3 = A2(KN, j, A([
        A2(WN, A([
            YN("row px-md-5 gap-5 gap-md-0")
        ]), A([
            A2(WN, A([
                YN("col-md-6 d-flex flex-column justify-content-between gap-2")
            ]), A([
                A2(t_, A([
                    YN("h4 d-flex align-items-baseline gap-2")
                ]), A([
                    A2(m_, A([
                        YN("fs-5")
                    ]), A([
                        o3
                    ])),
                    c_("L'API Ecobalyse")
                ])),
                A2(hH, j, A3(Yb, "{api_url}", _T(od), "[L\u2019API HTTP Ecobalyse]({api_url}) permet de calculer les impacts environnementaux des diff\xe9rents produits.\n             Elle est exp\xe9rimentale et donc ne garantit pas de continuit\xe9 de service \xe0 ce stade.")),
                A2(hH, j, A3(Yb, "{api_faq_url}", _T(dd("api-faq")), "Des questions\u202F? Consultez notre [\u202FFAQ d\xe9di\xe9e \xe0 l\u2019API\u202F]({api_faq_url})."))
            ])),
            A2(WN, A([
                YN("col-md-6 d-flex flex-column justify-content-between gap-2")
            ]), A([
                A2(t_, A([
                    YN("h4 d-flex align-items-baseline gap-2")
                ]), A([
                    A2(m_, A([
                        YN("fs-5")
                    ]), A([
                        AY
                    ])),
                    c_("Des questions\xa0?")
                ])),
                A2(hH, A([
                    YN("flex-fill")
                ]), "Ecobalyse est un outil **ouvert et gratuit**. Vos retours sur la m\xe9thode ou sur notre outil nous sont pr\xe9cieux."),
                A2(WN, A([
                    YN("d-flex flex-column flex-xl-row mt-3 gap-3")
                ]), A([
                    A2(zH, A([
                        YN("btn btn-primary text-truncate"),
                        QN(EH)
                    ]), A([
                        c_("Rejoindre la communaut\xe9")
                    ])),
                    A2(zH, A([
                        YN("btn btn-outline-primary text-truncate"),
                        QN("https://fabrique-numerique.gitbook.io/ecobalyse/textile/nous-contacter")
                    ]), A([
                        c_("Contacter l\u2019\xe9quipe \xc9cobalyse")
                    ]))
                ]))
            ]))
        ]))
    ])), s3 = fe("iframe"), l3 = F2(function(n) {
        var e = n.nM;
        return v("Statistiques", A([
            A2(KN, A([
                YN("pb-5")
            ]), A([
                A2(BN, A([
                    YN("mb-3")
                ]), A([
                    c_("Statistiques")
                ])),
                A2(WN, A([
                    YN("border rounded p-2")
                ]), function() {
                    var n = e.iN;
                    if (n.$) return A([
                        A2(WN, A([
                            YN("alert alert-info")
                        ]), A([
                            c_("\u26A0\uFE0F Le service de statistiques n\u2019est pas configur\xe9, affichage impossible.")
                        ]))
                    ]);
                    var r = n.a;
                    return A([
                        A2(s3, A([
                            A2(n_, "plausible-embed", ""),
                            F_("https://" + r + "/share/ecobalyse.beta.gouv.fr?auth=x5YPtaLjZQymaV_F4p8NF&embed=true&theme=light"),
                            A2(n_, "scrolling", "no"),
                            A2(n_, "frameborder", "0"),
                            A2(n_, "loading", "lazy"),
                            A2(qH, "width", "1px"),
                            A2(qH, "min-width", "100%"),
                            A2(qH, "height", "2000px")
                        ]), A([
                            A2(WN, A([
                                YN("alert alert-info")
                            ]), A([
                                A2(hH, j, "Votre adblocker est activ\xe9. Veuillez le d\xe9sactiver ou whitelister *https://" + r + "* pour voir les statistiques.")
                            ]))
                        ])),
                        A3(iX, "script", A([
                            A2(n_, "async", ""),
                            F_(r + "/js/embed.host.js")
                        ]), j)
                    ]);
                }())
            ]))
        ]));
    }), d3 = {
        $: 0
    }, b3 = {
        $: 9
    }, m3 = {
        $: 11
    }, p3 = function(n) {
        return {
            $: 12,
            a: n
        };
    }, v3 = function(n) {
        return {
            $: 13,
            a: n
        };
    }, g3 = function(n) {
        return {
            $: 14,
            a: n
        };
    }, h3 = {
        $: 23
    }, $3 = {
        $: 24
    }, x3 = function(n) {
        return {
            $: 27,
            a: n
        };
    }, k3 = F2(function(n, e) {
        return {
            $: 31,
            a: n,
            b: e
        };
    }), j3 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, y3 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, w3 = {
        $: 3
    }, T3 = {
        $: 4
    }, E3 = function(n) {
        return {
            $: 15,
            a: n
        };
    }, C3 = {
        $: 16
    }, I3 = {
        $: 19
    }, S3 = {
        $: 21
    }, O3 = function(n) {
        return {
            $: 26,
            a: n
        };
    }, L3 = function(n) {
        return {
            $: 28,
            a: n
        };
    }, P3 = function(n) {
        return {
            $: 29,
            a: n
        };
    }, q3 = function(n) {
        return {
            $: 30,
            a: n
        };
    }, N3 = function(n) {
        return {
            $: 35,
            a: n
        };
    }, _3 = F2(function(n, e) {
        return {
            $: 49,
            a: n,
            b: e
        };
    }), z3 = function(n) {
        return lh(A([
            n.g,
            n.eN.g
        ]));
    }, U3 = F3(function(n, e, r) {
        var t, u, a = (u = (t = e).ac, A2(uw, Zj(t.aO), lh(Fr(A2(xy, z3, A2(Iy, function(n) {
            return n.gt;
        }, u))))));
        return $(r, {
            cU: e.S,
            ha: A3(MJ, n, ow(e.S), a),
            ez: A2(cZ, r.ch.kj, e),
            bI: a
        });
    }), M3 = function(n) {
        return {
            $: 18,
            a: n
        };
    }, D3 = {
        $: 20
    }, R3 = F2(function(n, e) {
        return {
            $: 52,
            a: n,
            b: e
        };
    }), H3 = function(n) {
        return {
            $: 53,
            a: n
        };
    }, G3 = function(n) {
        return {
            $: 36,
            a: n
        };
    }, X3 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, V3 = function(n) {
        return {
            $: 17,
            a: n
        };
    }, J3 = function(n) {
        return {
            $: 32,
            a: n
        };
    }, Y3 = function(n) {
        return {
            $: 33,
            a: n
        };
    }, W3 = function(n) {
        return {
            $: 34,
            a: n
        };
    }, K3 = function(n) {
        return {
            $: 37,
            a: n
        };
    }, B3 = function(n) {
        return {
            $: 38,
            a: n
        };
    }, Q3 = function(n) {
        return {
            $: 39,
            a: n
        };
    }, Z3 = function(n) {
        return {
            $: 40,
            a: n
        };
    }, n5 = function(n) {
        return {
            $: 41,
            a: n
        };
    }, e5 = F2(function(n, e) {
        return {
            $: 43,
            a: n,
            b: e
        };
    }), r5 = F2(function(n, e) {
        return {
            $: 44,
            a: n,
            b: e
        };
    }), t5 = function(n) {
        return {
            $: 48,
            a: n
        };
    }, u5 = F2(function(n, e) {
        return {
            $: 50,
            a: n,
            b: e
        };
    }), a5 = function(n) {
        return {
            $: 51,
            a: n
        };
    }, i5 = function(n) {
        return {
            $: 54,
            a: n
        };
    }, c5 = o, o5 = F2(function(n, e) {
        var r = e.c, t = e.d, u = {
            V: j,
            N: 0,
            R: A3(c5, n, Py(e.a), t)
        }, a = F2(function(e, r) {
            if (e.$) {
                var t = qt(A3(c5, n, r.N * At, e.a));
                return {
                    V: A2(Mr, t, r.V),
                    N: r.N + 1,
                    R: r.R
                };
            }
            return A3(ew, a, r, e.a);
        });
        return A2(Jt, !0, A3(ew, a, u, r));
    }), f5 = function(n) {
        return !n.gt || 4 === n.ai && s(n.i.cR, SA);
    }, s5 = function(n) {
        return yf(Mf(n)) ? A2(aT, 0, n) + "% de transport a\xe9rien" : "Aucun transport a\xe9rien";
    }, l5 = function(n) {
        var e = n.hS, r = n.mj, t = n.ai;
        return A2(WN, A([
            YN("RangeSlider row")
        ]), A([
            A2(WN, A([
                YN("col-xxl-6")
            ]), A([
                A2(gX, A([
                    vX(r),
                    YN("form-label text-nowrap fs-7 mb-0")
                ]), A([
                    c_(t)
                ]))
            ])),
            A2(WN, A([
                YN("col-xxl-6")
            ]), A([
                q0(A2(Mr, yH(r), e))
            ]))
        ]));
    }, d5 = function(n) {
        return l5({
            hS: A([
                mG(A2(Hu, pp, A2(Hu, Ba(A2(Hu, Ys, Ld)), n.ph))),
                rQ(ut(n.m2)),
                P0(ut(n.m$)),
                tQ("1"),
                hG(Js(Mf(n.eT))),
                E_(n.bY)
            ]),
            mj: n.mj,
            ai: n.o1(n.eT)
        });
    }, b5 = function(n) {
        var e = n.lb, r = n.pi;
        return A2(m_, A([
            W_("Part de transport a\xe9rien pour le transport entre la confection et l'entrep\xf4t en France.")
        ]), A([
            d5({
                bY: f5(e),
                mj: "airTransportRatio",
                m$: 100,
                m2: 0,
                o1: s5,
                ph: r,
                eT: e.cJ
            })
        ]));
    }, m5 = function(n) {
        var e = n.hS, r = n.bT, t = n.nv, u = n.at, a = n.jX;
        return A2(vG, A2(Mr, YN("form-select"), A2(Mr, mG(A2(Hu, gw, t)), e)), A2(wu, function(n) {
            var e = n.cR, r = n.ek;
            return A2(pG, A([
                gG(s(a, e)),
                hG(e)
            ]), A([
                c_(r)
            ]));
        }, A2(LA, function(n) {
            return n.ek;
        }, A2(Rh, A([
            u
        ]), r))));
    }, p5 = function(n) {
        var e = n.lb, r = n.C, t = n.po;
        return A2(WN, j, A([
            e.lN ? m5({
                hS: A([
                    YN("form-select"),
                    E_(!e.gt),
                    mG(A2(Hu, gw, t(e.ai)))
                ]),
                bT: r.bT,
                nv: t(e.ai),
                at: bs,
                jX: e.i.cR
            }) : A2(WN, A([
                YN("fs-6 text-muted d-flex align-items-center gap-2 ")
            ]), A([
                A2(m_, A([
                    YN("cursor-help"),
                    W_("Le pays n'est pas modifiable \xe0 cette \xe9tape")
                ]), A([
                    X0
                ])),
                c_(e.i.ek)
            ]))
        ]));
    }, v5 = function(n) {
        var e = n.go, r = n.pK;
        return A2(yX, A([
            YN("d-flex align-items-center fs-7 cursor-help"),
            W_("Nombre d\xe9pendant de la cat\xe9gorie de v\xeatement et du coefficient de durabilit\xe9")
        ]), A([
            A2(m_, A([
                YN("pe-1 text-muted")
            ]), A([
                b_
            ])),
            _W(e),
            c_("\xa0port\xe9s, "),
            c_(ut(r)),
            c_(" cycle" + (r > 1 ? "s" : "") + " d'entretien")
        ]));
    }, g5 = function(n) {
        return A2(vQ, A([
            QN(xJ(n)),
            _H("_blank")
        ]), A([
            AY
        ]));
    }, h5 = F2(function(n, e) {
        return n ? e : c_("");
    }), $5 = F2(function(n, e) {
        return A2(h5, 4 === n.lb.ai, A2(__, A([
            YN("list-group-item text-muted d-flex justify-content-center gap-2")
        ]), s(e, 0) ? A([
            c_("Aucun stock dormant.")
        ]) : A([
            c_("Dont stocks dormants\xa0:\xa0"),
            c_(tT(e)),
            g5(25)
        ])));
    }), x5 = function(n) {
        var e = n.lb, r = n.A, t = n.pF;
        return A2(WN, A([
            YN("d-flex justify-content-between align-items-center fs-7")
        ]), A([
            A2(gX, A([
                YN("text-truncate w-33"),
                vX("ennobling-printing"),
                W_("Impression")
            ]), A([
                c_("Impression")
            ])),
            A2(WN, A([
                YN("d-flex justify-content-between align-items-center gap-1 w-75")
            ]), A([
                A2(vG, A([
                    yH("ennobling-printing"),
                    YN("form-select form-select-sm"),
                    A2(qH, "flex", "2"),
                    E_(!e.gt),
                    mG(function(n) {
                        return t(function() {
                            var e = Vm(n);
                            if (1 === e.$) return Ur;
                            var t = e.a, u = r.$7;
                            return zr(u.$ ? {
                                gJ: t,
                                nX: .2
                            } : $(u.a, {
                                gJ: t
                            }));
                        }());
                    })
                ]), A2(Mr, A2(pG, A([
                    gG(s(r.$7, Ur))
                ]), A([
                    c_("Aucune")
                ])), A2(wu, function(n) {
                    return A2(pG, A([
                        hG(Qo(n)),
                        gG(s(A2(Pc, function(n) {
                            return n.gJ;
                        }, r.$7), zr(n)))
                    ]), A([
                        c_(cT(n))
                    ]));
                }, A([
                    0,
                    1
                ])))),
                function() {
                    var n = r.$7;
                    if (n.$) return c_("");
                    var e = n.a.nX;
                    return A2(vG, A([
                        YN("form-select form-select-sm"),
                        A2(qH, "flex", "1"),
                        E_(s(r.$7, Ur)),
                        mG(function(n) {
                            var e = pp(n);
                            if (e.$) return t(Ur);
                            var u = e.a;
                            return t(A2(Pc, function(n) {
                                return $(n, {
                                    nX: A2(Nc, 0, Ld(Ys(u)))
                                });
                            }, r.$7));
                        })
                    ]), A2(wu, function(n) {
                        return A2(pG, A([
                            hG(Js(n)),
                            gG(s(Qr(e), Ys(n)))
                        ]), A([
                            c_(Js(n) + "%")
                        ]));
                    }, A([
                        80,
                        50,
                        20,
                        5,
                        1
                    ])));
                }()
            ]))
        ]));
    }, k5 = function(n) {
        var e, r, t, u, a;
        return A2(WN, A([
            YN("d-flex flex-column gap-1")
        ]), A([
            A2(h5, n.oB, (e = n, r = e.lb, t = e.C, u = e.A, a = e.pq, A2(WN, A([
                YN("d-flex justify-content-between align-items-center fs-7")
            ]), A([
                A2(gX, A([
                    YN("text-truncate w-33"),
                    vX("dyeing-process-type"),
                    W_("Type de teinture")
                ]), A([
                    c_("Type de teinture")
                ])),
                A2(vG, A([
                    yH("dyeing-process-type"),
                    YN("form-select form-select-sm w-75"),
                    E_(!r.gt),
                    mG(A2(Hu, Mm, A2(Hu, Zg(0), a)))
                ]), A2(wu, function(n) {
                    return A2(pG, A([
                        hG(Vo(n)),
                        gG(s(n, A2(Nc, 0, u.c2)))
                    ]), A([
                        c_(Gb(A2(gy, t.oX.pQ, zr(n))))
                    ]));
                }, A([
                    2,
                    1,
                    0
                ])))
            ])))),
            x5(n)
        ]));
    }, j5 = F3(function(n, e, r) {
        var t, u, a, i = e.A, c = e.dv;
        return A2(h5, 2 === r.ai, (t = function() {
            var e = r.$7;
            if (e.$) return Ks;
            var t = e.a.nX;
            return A4(Gw, r.g, {
                hP: r.i.hP,
                nR: A2(Fw, e.a.gJ, n.oX.pQ).nR,
                hj: A2(Nc, i.aS.hj, i.hj)
            }, t, r.nI);
        }(), u = lh(A2(wu, function(e) {
            var t = e.aH;
            return A4(vy, r.g, {
                hP: r.i.hP,
                lJ: py(e.U.jh) ? n.oX.pQ.lI : n.oX.pQ.lE
            }, r.nI, t);
        }, i.ft)), a = A([
            v("Pr\xe9-traitements", r.nP.pb),
            v("Teinture", u),
            v("Impression", t)
        ]), A2(__, A([
            YN("list-group-item text-muted")
        ]), A([
            A2(VH, j, A([
                A2(WH, j, A([
                    A2(m_, j, A([
                        c_("Dont inventaires enrichis\xa0:")
                    ])),
                    A2(m_, A([
                        YN("text-end ImpactDisplay text-black-50 fs-7")
                    ]), A([
                        c_("\xa0(+\xa0"),
                        A2(tW, c, lh(A2(wu, Gh, a))),
                        c_(")"),
                        g5(18)
                    ]))
                ])),
                A2(WN, j, A2(wu, function(n) {
                    var e = n.b;
                    return A2(WN, j, A([
                        c_(n.a + "\xa0: "),
                        A3(bV, 2, "Pts", A2(ch, 19, e))
                    ]));
                }, a))
            ]))
        ]))));
    }), y5 = A([
        3,
        1,
        2,
        0,
        4,
        5
    ]), w5 = function(n) {
        var e = n.lb, r = n.A, t = n.pu;
        return A2(__, A([
            YN("list-group-item d-flex align-items-center gap-2")
        ]), A([
            A2(gX, A([
                YN("text-nowrap w-25"),
                vX("fabric-process")
            ]), A([
                c_("Proc\xe9d\xe9")
            ])),
            A2(vG, A([
                yH("fabric-process"),
                YN("form-select form-select-sm w-75"),
                E_(!e.gt),
                mG(A2(Hu, Rm, A2(Hu, Zg(3), t)))
            ]), A2(wu, function(n) {
                var e;
                return A2(pG, A([
                    hG(Yo(n)),
                    gG((e = r.b6, s(n, e.$ ? r.aS.iz : e.a)))
                ]), A([
                    c_(oT(n))
                ]));
            }, y5))
        ]));
    }, T5 = function(n) {
        var e = n.A, r = n.o4;
        return A2(gX, A([
            YN("form-check form-switch form-check-label fs-7 pt-1 text-truncate"),
            W_("D\xe9lavage")
        ]), A([
            A2(N_, A([
                o_("checkbox"),
                YN("form-check-input no-outline"),
                w_(A2(Nc, !1, e.c8)),
                xX(r)
            ]), j),
            s(e.c8, zr(!0)) ? c_("D\xe9lavage activ\xe9") : c_("D\xe9lavage d\xe9sactiv\xe9")
        ]));
    }, E5 = F2(function(n, e) {
        return s(n, A2(Nc, e.aS.iz, e.b6));
    }), C5 = function(n) {
        var e = n.lb, r = n.A, t = n.pz, u = A3($w, r.aS.gL.gi, r.mV, r.b6);
        return A2(__, A([
            YN("list-group-item d-flex align-items-center gap-2")
        ]), A([
            A2(gX, A([
                YN("text-nowrap w-25"),
                vX("making-complexity")
            ]), A([
                c_("Complexit\xe9")
            ])),
            g5(24),
            A2(E5, 2, r) ? c_("Non applicable") : A2(vG, A([
                yH("making-complexity"),
                YN("form-select form-select-sm w-75"),
                E_(!e.gt),
                mG(A2(Hu, Hm, A2(Hu, Zg(r.aS.gL.gi), t)))
            ]), A2(wu, function(n) {
                return A2(pG, A([
                    hG(Of(n)),
                    gG(s(n, u))
                ]), A([
                    c_(uT(n))
                ]));
            }, A([
                4,
                0,
                2,
                1,
                5
            ])))
        ]));
    }, I5 = function(n) {
        return s(n, 0) ? "Aucun stock dormant" : A2(aT, 0, n) + "% de stocks dormants";
    }, S5 = function(n) {
        var e = n.lb, r = n.pA;
        return A2(h5, n.oB, A2(m_, A([
            W_("Taux moyen de stocks dormants (v\xeatements non vendus + produits semi-finis non utilis\xe9s) sur l\u2019ensemble de la cha\xeene de valeur")
        ]), A([
            d5({
                bY: !e.gt,
                mj: "makingDeadStock",
                m$: yf(Mf(.3)),
                m2: yf(Mf(0)),
                o1: I5,
                ph: r,
                eT: A2(Nc, Aw, e.dk)
            })
        ])));
    }, O5 = function(n) {
        return s(n, 0) ? "Aucune perte en confection" : A2(aT, 0, n) + "% de pertes";
    }, L5 = function(n) {
        var e = n.lb, r = n.A, t = n.pB;
        return A2(m_, A([
            W_("Taux moyen de pertes en confection")
        ]), A([
            d5({
                bY: !e.gt,
                mj: "makingWaste",
                m$: yf(Mf(.4)),
                m2: yf(Mf(0)),
                o1: O5,
                ph: t,
                eT: A3(Sw, r.aS.gL.jk, r.dl, r.b6)
            })
        ]));
    }, P5 = function(n) {
        if (n.$) return c_("");
        var e = n.a;
        return A2(__, A([
            YN("list-group-item text-muted d-flex justify-content-center gap-2")
        ]), A([
            c_("Duitage\xa0:\xa0"),
            A3(bV, 0, "duites.m", e)
        ]));
    }, q5 = function(n) {
        switch(n){
            case 0:
                return "Filature conventionnelle";
            case 1:
                return "Filage";
            default:
                return "Filature non conventionnelle";
        }
    }, N5 = function(n) {
        var e = n.lb, r = n.A, t = n.pD;
        return A2(__, A([
            YN("list-group-item d-flex align-items-center gap-2")
        ]), A([
            A2(WN, A([
                YN("d-flex flex-column gap-1 w-100")
            ]), A2(wu, function(n) {
                var r = n.U, u = n.dz;
                return A2(WN, A([
                    YN("d-flex justify-content-between align-items-center fs-7")
                ]), A([
                    A2(gX, A([
                        vX("spinning-for-" + Pw(r.mj)),
                        YN("text-truncate w-25")
                    ]), A([
                        c_(r.ek)
                    ])),
                    function() {
                        var n = A(3 === r.jh ? [
                            1
                        ] : [
                            0,
                            2
                        ]);
                        if (n.b && !n.b.b) {
                            var a = n.a;
                            return A2(m_, A([
                                YN(" w-75")
                            ]), A([
                                c_(q5(a))
                            ]));
                        }
                        var i = n;
                        return A2(vG, A([
                            YN("form-select form-select-sm w-75"),
                            yH("spinning-for-" + Pw(r.mj)),
                            E_(!e.gt),
                            mG(A2(Hu, up, A2(Hu, Zg(Jw(r.jh)), t(r))))
                        ]), A2(wu, function(n) {
                            return A2(pG, A([
                                hG(vf(n)),
                                gG(s(zr(n), u))
                            ]), A([
                                c_(q5(n))
                            ]));
                        }, i));
                    }()
                ]));
            }, r.ft))
        ]));
    }, _5 = F2(function(n, e) {
        var r = e.de;
        return A2(Gy, A2(Nc, n.aS.hj, n.hj), r);
    }), z5 = F2(function(n, e) {
        var r = e.nI;
        return A2(Gy, A2(Nc, n.aS.hj, n.hj), r);
    }), U5 = F2(function(n, e) {
        var r = 3 === e.ai ? zr(v("sortante", A2(z5, n, e))) : 2 === e.ai ? zr(v("entrante", A2(_5, n, e))) : Ur;
        if (r.$) return c_("");
        var t = r.a, u = t.a, a = t.b;
        return A2(__, A([
            YN("list-group-item text-muted d-flex justify-content-center gap-2")
        ]), A([
            A2(m_, j, A([
                c_("Surface \xe9toffe (" + u + ")\xa0:")
            ])),
            A2(m_, j, A([
                hV(a)
            ]))
        ]));
    }), M5 = dp(500), D5 = dp(80), R5 = function(n) {
        return "Grammage\xa0: " + ut(wf(n)) + "\u202Fg/m\xb2";
    }, H5 = function(n) {
        var e, r = n.lb, t = n.A, u = n.pI;
        return A2(WN, A([
            YN("mt-2"),
            W_("Le grammage de l'\xe9toffe, exprim\xe9 en g/m\xb2, repr\xe9sente sa masse surfacique.")
        ]), A([
            (e = {
                bY: !r.gt,
                mj: "surface-density",
                o1: R5,
                ph: u,
                eT: A2(Nc, t.aS.hj, r.hj)
            }, l5({
                hS: A([
                    mG(A2(Hu, du, A2(Hu, Pc(dp), e.ph))),
                    rQ(ut(wf(D5))),
                    P0(ut(wf(M5))),
                    tQ("1"),
                    hG(ut(wf(e.eT))),
                    E_(e.bY)
                ]),
                mj: e.mj,
                ai: e.o1(e.eT)
            }))
        ]));
    }, G5 = Ry(80), X5 = Ry(10), V5 = function(n) {
        return yf(n);
    }, J5 = function(n) {
        if (n.$) return c_("");
        var e = n.a;
        return A2(__, A([
            YN("list-group-item text-muted")
        ]), A([
            A2(m_, A([
                YN("d-flex justify-content-center gap-2")
            ]), A([
                c_("Densit\xe9 de fils (approx.)\xa0:\xa0"),
                A3(bV, 0, "fils/cm", e)
            ])),
            0 > m(yf(e), V5(X5)) ? c_("\u26A0\uFE0F la densit\xe9 de fils semble tr\xe8s faible") : m(yf(e), V5(G5)) > 0 ? c_("\u26A0\uFE0F la densit\xe9 de fils semble tr\xe8s \xe9lev\xe9e") : c_("")
        ]));
    }, Y5 = function(n) {
        if (n.$) return c_("");
        var e = n.a;
        return A2(__, A([
            YN("list-group-item text-truncate"),
            W_(e),
            A2(qH, "cursor", "help")
        ]), A([
            c_(e)
        ]));
    }, W5 = F2(function(n, e) {
        var r = n.lb;
        return A2(h5, 4 === r.ai || 3 === r.ai, A2(__, A([
            YN("list-group-item text-muted d-flex justify-content-center gap-2")
        ]), s(e, 0) ? A([
            c_("Aucune perte en " + (3 === r.ai ? "tissage/tricotage" : "confection") + ".")
        ]) : A([
            c_("Pertes\xa0:\xa0"),
            c_(tT(e)),
            g5(3 === r.ai ? 21 : 26)
        ])));
    }), K5 = gp(200), B5 = gp(9), Q5 = function(n) {
        return "Titrage\xa0: " + Js(Cf(n)) + "\u202FNm (" + function(n) {
            return A2(Rj, 2, function(n) {
                return zo(A2(Hy, n, 1e4));
            }(n)) + "\u202FDtex";
        }(n) + ")";
    }, Z5 = function(n) {
        var e, r = n.lb, t = n.A, u = n.pJ;
        return A2(m_, A([
            W_("Le titrage indique la grosseur d\u2019un fil textile")
        ]), A([
            (e = {
                bY: !r.gt,
                mj: "yarnSize",
                o1: Q5,
                ph: u,
                eT: A2(Nc, t.aS.pV, r.pV)
            }, l5({
                hS: A([
                    mG(A2(Hu, pp, A2(Hu, Pc(gp), e.ph))),
                    rQ(Js(Cf(B5))),
                    P0(Js(Cf(K5))),
                    tQ("1"),
                    hG(Js(Cf(e.eT))),
                    E_(e.bY)
                ]),
                mj: e.mj,
                ai: e.o1(e.eT)
            }))
        ]));
    }, n4 = function(n) {
        var e, r = n.C, t = n.A, u = n.dv, a = n.lb, i = B_(A([
            YN("StageBody list-group list-group-flush fs-7 border-bottom-0"),
            r_(A([
                v("disabled", !a.gt)
            ]))
        ]));
        return A2(WN, A([
            YN("card-group")
        ]), A([
            A2(WN, A([
                YN("card border-start-0 border-top-0 border-bottom-0")
            ]), A([
                i(A([
                    A2(__, A([
                        YN("list-group-item")
                    ]), A([
                        p5(n)
                    ])),
                    Y5(A2(Pc, rt("Elec : "), a.aG.ba)),
                    Y5(A2(Pc, rt("Chaleur : "), a.aG.d$)),
                    Y5(a.aG.E),
                    Y5(a.aG.f$),
                    Y5(a.aG.f0),
                    Y5(a.aG.nJ),
                    Y5(a.aG._),
                    A2(h5, 6 === a.ai, N5(n)),
                    A2(h5, 3 === a.ai, w5(n)),
                    A2(h5, 4 === a.ai, C5(n)),
                    A2(h5, s(t.c8, zr(!0)), Y5(a.aG.c8))
                ])),
                A2(B_, A([
                    YN("StageBody p-0 list-group list-group-flush border-bottom-0 border-top"),
                    r_(A([
                        v("disabled", !a.gt)
                    ]))
                ]), A2(wu, function(n) {
                    return A2(__, A([
                        YN("list-group-item fs-7")
                    ]), A([
                        n
                    ]));
                }, function() {
                    switch(a.ai){
                        case 2:
                            return A([
                                (e = a.nP, r = e.bh, A2(m_, j, A([
                                    c_("Pr\xe9-traitement" + (ft(r) > 1 ? "s" : "") + "\xa0: "),
                                    sf(r) ? c_("Aucun") : c_(A2(at, ", ", A2(wu, Gb, r)))
                                ]))),
                                k5(n),
                                A2(WN, A([
                                    YN("mt-2")
                                ]), A([
                                    c_("Finition\xa0: appr\xeat chimique")
                                ]))
                            ]);
                        case 3:
                            return A([
                                H5(n)
                            ]);
                        case 4:
                            return A([
                                L5(n),
                                S5(n),
                                b5(n),
                                T5(n)
                            ]);
                        case 6:
                            return A([
                                Z5(n)
                            ]);
                        case 7:
                            return A([
                                v5(n)
                            ]);
                        default:
                            return j;
                    }
                    var e, r;
                }()))
            ])),
            A2(WN, A([
                YN("card border-end-0 border-top-0 border-bottom-0 text-center mb-0")
            ]), A([
                A2(B_, A([
                    YN("StageBody list-group list-group-flush fs-7"),
                    r_(A([
                        v("disabled", !a.gt)
                    ]))
                ]), A([
                    A2(h5, (e = a.eb, e / 1e3 > 0 || vh(a.a$) > 0), A2(__, A([
                        YN("list-group-item text-muted d-flex flex-wrap justify-content-around")
                    ]), A([
                        A2(m_, A([
                            YN("d-flex align-items-center")
                        ]), A([
                            A2(m_, A([
                                YN("me-1")
                            ]), A([
                                c_("Chaleur")
                            ])),
                            KY(a.eb),
                            g5(22)
                        ])),
                        A2(m_, A([
                            YN("d-flex align-items-center")
                        ]), A([
                            A2(m_, A([
                                YN("me-1")
                            ]), A([
                                c_("\xc9lectricit\xe9")
                            ])),
                            YY(a.a$),
                            g5(13)
                        ]))
                    ]))),
                    A2(U5, t, a),
                    A3(j5, r, n, a),
                    P5(a.jm),
                    J5(a.kc),
                    A2(W5, n, a.pO),
                    A2($5, n, a.lg),
                    A2(h5, 1 === a.ai, A2(__, A([
                        YN("list-group-item text-muted")
                    ]), A([
                        A2(WN, A([
                            YN("d-flex justify-content-between")
                        ]), A([
                            c_("Fin de vie"),
                            A2(tW, u, a.g)
                        ])),
                        A2(h5, 19 === u.kj, A2(WN, A([
                            YN("text-start mt-2")
                        ]), A([
                            A2(m_, A([
                                YN("fw-bold")
                            ]), A([
                                c_("Compl\xe9ment")
                            ])),
                            A2(WN, A([
                                YN("d-flex justify-content-between")
                            ]), A([
                                c_("-\xa0Export hors-Europe"),
                                nQ(A2(Nc, 0, a.S.ak))
                            ])),
                            A2(WN, A([
                                YN("d-flex justify-content-between")
                            ]), A([
                                A2(m_, A([
                                    YN("me-2 text-truncate")
                                ]), A([
                                    c_("-\xa0Probabilit\xe9 de fin de vie hors-Europe")
                                ])),
                                A2(m_, A([
                                    YN("text-nowrap")
                                ]), A([
                                    A2(jJ, 2, FA(t.ft)),
                                    g5(15)
                                ]))
                            ]))
                        ])))
                    ])))
                ]))
            ]))
        ]));
    }, e4 = function(n) {
        var e = n.lb;
        return A2(WN, A([
            YN("StageBody card-body row align-items-center")
        ]), A([
            A2(WN, A([
                YN("col-lg-7")
            ]), A([
                p5(n),
                function() {
                    switch(e.ai){
                        case 2:
                            return A2(WN, A([
                                YN("mt-2")
                            ]), A([
                                k5(n)
                            ]));
                        case 4:
                            return A2(WN, A([
                                YN("mt-2")
                            ]), A([
                                b5(n),
                                T5(n)
                            ]));
                        case 7:
                            return A2(WN, A([
                                YN("mt-2")
                            ]), A([
                                v5(n)
                            ]));
                        default:
                            return c_("");
                    }
                }()
            ]))
        ]));
    }, r4 = F2(function(n, e) {
        return n && A2(el, e, Ew);
    }), t4 = function(n) {
        switch(n){
            case 0:
                return 11;
            case 1:
                return 14;
            case 2:
                return 16;
            case 3:
                return 20;
            case 4:
                return 23;
            case 5:
                return 27;
            case 6:
                return 28;
            default:
                return 31;
        }
    }, u4 = F2(function(n, e) {
        var r = n.lb, t = n.A, u = n.oB, a = n.o5;
        return A2(WN, A([
            YN("StageActions ms-2")
        ]), A([
            A2(WN, A([
                YN("btn-group")
            ]), A([
                A2(_B, A([
                    YN("btn btn-secondary py-1 rounded"),
                    QN(xJ(t4(e))),
                    W_("Documentation"),
                    _H("_blank")
                ]), A([
                    AY
                ])),
                A2(h5, u, A2(N_, A([
                    o_("checkbox"),
                    YN("form-check-input ms-1 no-outline"),
                    A2(n_, "role", "switch"),
                    w_(r.gt),
                    xX(Wi(a(r.ai))),
                    E_(A2(r4, t.dI, r.ai)),
                    W_(r.gt ? "\xc9tape activ\xe9e, cliquez pour la d\xe9sactiver" : "\xc9tape desactiv\xe9e, cliquez pour la r\xe9activer")
                ]), j))
            ]))
        ]));
    }), a4 = function(n) {
        switch(n){
            case 0:
                return mB;
            case 1:
                return pB;
            case 2:
            case 3:
            case 4:
            case 6:
                return hB;
            case 5:
                return vB;
            default:
                return kB;
        }
    }, i4 = function(n) {
        switch(n){
            case 0:
                return "distribution-stage";
            case 1:
                return "end-of-life-stage";
            case 2:
                return "transform-stage-ennobling";
            case 3:
                return "transform-stage-fabric";
            case 4:
                return "transform-stage-making";
            case 5:
                return "materials-stage";
            case 6:
                return "transform-stage";
            default:
                return "usage-stage";
        }
    }, c4 = function(n) {
        switch(n){
            case 2:
                return "Transformation\xa0- Ennoblissement";
            case 3:
                return "Transformation\xa0- Tissage / Tricotage";
            case 4:
                return "Transformation\xa0- Confection";
            case 6:
                return "Transformation\xa0- Filature";
            default:
                return function(n) {
                    switch(n){
                        case 0:
                            return "Distribution";
                        case 1:
                            return "Fin de vie";
                        case 2:
                            return "Ennoblissement";
                        case 3:
                            return "Tissage & Tricotage";
                        case 4:
                            return "Confection";
                        case 5:
                            return "Mati\xe8res premi\xe8res";
                        case 6:
                            return "Filature";
                        default:
                            return "Utilisation";
                    }
                }(n);
        }
    }, o4 = F2(function(n, e) {
        var r, t, u = e.S, a = e.g;
        return A2(h5, function(n) {
            return n > 0;
        }(A2(ch, n.kj, a)), (r = ow(u), t = A2(S$, r, a), A2(WN, j, A([
            A2(m_, A([
                YN("flex-fill")
            ]), A([
                A2(tW, n, t)
            ]))
        ]))));
    }), f4 = F2(function(n, e) {
        var r = n.lb, t = n.oB;
        return A2(WN, A([
            YN("Stage card shadow-sm")
        ]), A([
            A2(WN, A([
                YN("StageHeader card-header"),
                jB(a4(r.ai)),
                yH(i4(r.ai))
            ]), A([
                A2(WN, A([
                    YN("row d-flex align-items-center")
                ]), A([
                    A2(WN, A([
                        YN("col-9 col-sm-6")
                    ]), A([
                        A2(WN, A([
                            YN("d-flex align-items-center gap-2 text-dark"),
                            r_(A([
                                v("text-secondary", !r.gt)
                            ]))
                        ]), A([
                            A2(I_, A([
                                YN("h5 mb-0"),
                                r_(A([
                                    v("text-body-tertiary", !r.gt)
                                ]))
                            ]), A([
                                c_(c4(r.ai)),
                                A2(h5, 5 === r.ai, A2(kJ, A([
                                    ZN(A2(bd, bs, qm(Ur))),
                                    W_("Explorer"),
                                    A2(n_, "aria-label", "Explorer")
                                ]), A([
                                    vY
                                ])))
                            ]))
                        ]))
                    ])),
                    A2(WN, A([
                        YN("col-3 col-sm-6 d-flex text-end justify-content-end")
                    ]), A([
                        A2(WN, A([
                            YN("d-none d-sm-block text-center")
                        ]), A([
                            A2(h5, r.gt || t, A2(o4, n.dv, r))
                        ])),
                        A2(u4, n, r.ai)
                    ]))
                ]))
            ])),
            e
        ]));
    }), s4 = F2(function(n, e) {
        var r = {
            i: A2(Pc, function(n) {
                return n.cR;
            }, e.i),
            mj: e.U.mj,
            aH: e.aH,
            dz: e.dz
        }, t = A2(fh, function() {
            return bh(e.aH);
        }, A3(Mw, n.C, e.U, n.lb)), u = A2(wu, function(n) {
            return n.U;
        }, n.A.ft);
        return {
            kC: !1,
            kI: {
                i: e.i,
                iv: e.U,
                D: e.aH
            },
            C: {
                bT: A2(LA, function(n) {
                    return n.ek;
                }, A2(Rh, A([
                    bs
                ]), n.C.bT)),
                c_: n.C.c_,
                r: n.C.oX.ft
            },
            ig: e.U.ma,
            lp: n.lr,
            bb: u,
            O: t,
            nz: n.nz,
            nW: function(n) {
                return function(n) {
                    var e = n.bY, r = n.fw, t = n.aH;
                    return A2(WN, A([
                        YN("input-group")
                    ]), A([
                        A2(N_, A([
                            YN("form-control text-end incdec-arrows-left"),
                            o_("number"),
                            tQ("1"),
                            hG(Js(Mf(t))),
                            W_("Quantit\xe9 en pourcents"),
                            mG(function(n) {
                                return r("" === n ? Ur : A2(Ba, A2(Hu, Ys, Ld), pp(n)));
                            }),
                            rQ("0"),
                            E_(e)
                        ]), j),
                        A2(m_, A([
                            YN("input-group-text"),
                            W_("pourcents")
                        ]), A([
                            c_("%")
                        ]))
                    ]));
                }({
                    bY: !1,
                    fw: n.fw,
                    aH: n.D
                });
            },
            ot: F2(function(r, t) {
                return n.oA(A2(n.ky, zr(e), t));
            }),
            dv: n.dv,
            oZ: A2(Hu, function(n) {
                return n.mj;
            }, Pw),
            o1: function(n) {
                return n.ek;
            },
            o2: A2(Hu, function(n) {
                return n.t;
            }, Gb),
            ph: F2(function(e, t) {
                return A2(n.pC, r, $(r, {
                    i: A2(Pc, function(n) {
                        return n.cR;
                    }, t.i),
                    mj: t.iv.mj,
                    aH: t.D
                }));
            })
        };
    }), l4 = F2(function(n, e) {
        var r = A2(XA, n, e), t = $(dw, {
            aj: zr(r)
        });
        return A2(xQ, {
            S: t,
            ai: "Compl\xe9ments"
        }, A([
            A2(WN, A([
                YN("ElementComplement"),
                W_("Microfibres")
            ]), A([
                A2(m_, A([
                    YN("ComplementName d-flex align-items-center text-nowrap text-muted")
                ]), A([
                    c_("Microfibres"),
                    A2(vQ, A([
                        QN(xJ(10)),
                        _H("_blank")
                    ]), A([
                        AY
                    ]))
                ])),
                A2(m_, A([
                    YN("ComplementRange")
                ]), j),
                A2(WN, A([
                    YN("ComplementValue d-flex")
                ]), j),
                A2(WN, A([
                    YN("ComplementImpact text-black-50 text-muted text-end")
                ]), A([
                    c_("("),
                    nQ(r),
                    c_(")")
                ]))
            ]))
        ]));
    }), d4 = function(n) {
        var e, r, t, u, a;
        return A2(B_, A([
            YN("CardList list-group list-group-flush")
        ]), k(A2(wu, function(e) {
            var r = A4(iA, n.C, A2(Nc, n.lb, n.nb).i, n.lb.nI, e);
            return A2(__, A([
                YN("ElementFormWrapper list-group-item")
            ]), Cd(A([
                $Q(A2(s4, n, e)),
                19 === n.dv.kj ? A([
                    A2(l4, n.A.P, e)
                ]) : j,
                A([
                    A2(m_, A([
                        YN("text-muted d-flex fs-7 gap-3 justify-content-left ElementTransportDistances")
                    ]), A2(bQ, {
                        f6: Ur,
                        gy: !1,
                        gD: !0,
                        es: !1,
                        g8: Ur,
                        hc: Ur
                    }, r)),
                    A2(m_, A([
                        YN("text-black-50 text-end ElementTransportImpact fs-8"),
                        W_("Impact du transport pour cette mati\xe8re")
                    ]), A([
                        c_("(+ "),
                        A2(tW, n.dv, r.g),
                        c_(")")
                    ]))
                ])
            ])));
        }, n.A.ft), A([
            (e = tl(A2(wu, A2(Hu, function(n) {
                return n.aH;
            }, A2(Hu, Ko, A2(TA, 0, 1))), n.A.ft)), r = 100 === yf(100 * e), t = ft(n.A.ft), u = A2(wu, function(n) {
                return n.U;
            }, n.A.ft), a = A2(Ah, function(n) {
                return !A2(el, n, u);
            }, n.C.oX.ft), A2(__, A([
                YN("input-group AddElementFormWrapper ps-3")
            ]), A([
                A2(m_, A([
                    YN("SharesTotal ext-end"),
                    YN("d-flex justify-content-between align-items-center gap-1"),
                    r_(A([
                        v("text-success feedback-valid", r),
                        v("text-danger feedback-invalid", !r)
                    ]))
                ]), A([
                    r ? zX : LX,
                    c_(ut(yf(100 * e))),
                    c_("%")
                ])),
                A2(e_, A([
                    YN("AddElementButton btn btn-outline-primary flex-fill"),
                    YN("d-flex justify-content-center align-items-center gap-1 no-outline"),
                    yH("add-new-element"),
                    i_(n.oA(A2(n.ky, Ur, A2(QB, function(n) {
                        return n.ek;
                    }, A2(LA, function(n) {
                        return n.ek;
                    }, a))))),
                    E_(m(t, 5) > -1)
                ]), A([
                    rB,
                    m(t, 5) > -1 ? c_("Nombre maximal de mati\xe8res atteint") : c_("Ajouter une mati\xe8re")
                ]))
            ])))
        ])));
    }, b4 = function(n) {
        return Tf(ah(A([
            n.ds,
            n.hb,
            n.f5
        ])));
    }, m4 = F3(function(n, e, r) {
        var t = e.aV, u = e.O;
        return A2(WN, A([
            YN("pt-1"),
            A2(n_, "data-testid", "life-cycle-stages")
        ]), xt(A2($x, 1, xt(A2(Id, function(n) {
            return A([
                n.av,
                A2(NQ, j, A([
                    n.eN
                ]))
            ]);
        }, Fr(A2(o5, F2(function(e, a) {
            return function(n) {
                var e, r, t, u;
                return {
                    av: A2(f4, n, 5 === n.lb.ai ? d4(n) : n.oB ? n4(n) : e4(n)),
                    eN: (e = n, r = e.lb, t = e.A, u = e.dv, A2(WN, j, A([
                        A2(m_, j, A([
                            c_("Masse\xa0: "),
                            pV(A2(fA, t, r))
                        ])),
                        A2(h5, b4(r.eN) > 0, A2(WN, A([
                            YN("d-flex justify-content-between gap-3 align-items-center")
                        ]), A([
                            A2(WN, A([
                                YN("d-flex justify-content-between gap-3 flex-column flex-md-row")
                            ]), A2(bQ, {
                                f6: Ur,
                                gy: !1,
                                gD: !0,
                                es: !1,
                                g8: Ur,
                                hc: Ur
                            }, r.eN)),
                            A2(m_, j, A([
                                A2(tW, u, r.eN.g),
                                g5(29)
                            ]))
                        ])))
                    ])))
                };
            }({
                ky: Iq,
                lb: a,
                go: r.go,
                C: n,
                lr: A2(Hu, function(n) {
                    return n.mj;
                }, V3),
                mo: e,
                A: r.A,
                nb: A2(pA, a.ai, r.ac),
                nz: A2(Hu, X3, Tc),
                dv: u,
                oA: Tc,
                oB: !t,
                o4: J3,
                o5: Y3,
                pi: W3,
                po: u5,
                pq: K3,
                pu: B3,
                pz: Q3,
                pA: Z3,
                pB: n5,
                pC: e5,
                pD: r5,
                pF: t5,
                pI: a5,
                pJ: i5,
                pK: r.pK
            });
        }), r.ac)))))));
    }), p4 = function(n) {
        return {
            $: 42,
            a: n
        };
    }, v4 = function(n) {
        return {
            $: 45,
            a: n
        };
    }, g4 = function(n) {
        return {
            $: 46,
            a: n
        };
    }, h4 = F2(function(n, e) {
        var r = n.dp, t = A2(QB, function(n) {
            return n.ek;
        }, A2(LA, function(n) {
            return n.ek;
        }, r));
        return A2(WN, A([
            YN("d-flex flex-column")
        ]), A([
            A2(WN, A([
                YN("d-flex justify-content-between align-items-center")
            ]), A([
                A2(gX, A([
                    vX("selector-product"),
                    YN("form-label text-truncate")
                ]), A([
                    c_("Cat\xe9gorie de produit")
                ])),
                A2(vQ, A([
                    YN("text-primary"),
                    ZN(A2(bd, bs, Nm(Ur))),
                    W_("Explorer les cat\xe9gories de produit"),
                    _H("_blank")
                ]), A([
                    AY
                ]))
            ])),
            A2(e_, A([
                yH("selector-product"),
                YN("form-select ElementSelector text-start w-auto"),
                i_(Tc(Dq(t)))
            ]), A([
                c_(A2(Zg, "", A2(fs, function(n) {
                    return n.ek;
                }, A2(IA, e.aS, r))))
            ]))
        ]));
    }), $4 = function(n) {
        return {
            $: 47,
            a: n
        };
    }, x4 = function(n) {
        return s(n, _A) ? Ur : zr(n);
    }, k4 = wu(function(n) {
        var e = n.i, r = n.U, t = n.aH, u = n.dz;
        return {
            i: A2(Ba, A2(Hu, function(n) {
                return n.cR;
            }, x4), e),
            mj: r.mj,
            aH: t,
            dz: u
        };
    }), j4 = function(n) {
        return {
            cJ: n.cJ,
            h_: n.h_,
            by: x4(n.by.cR),
            bU: x4(n.bU.cR),
            bV: x4(n.bV.cR),
            cY: x4(n.cY.cR),
            c0: n.c0,
            c2: n.c2,
            b6: n.b6,
            c8: n.c8,
            mV: n.mV,
            dk: n.dk,
            dl: n.dl,
            P: n.P,
            ft: k4(n.ft),
            je: n.je,
            dn: n.dn,
            jr: n.jr,
            $7: n.$7,
            aS: n.aS.mj,
            hj: n.hj,
            pf: s(n.pf, n.aS.pf) ? Ur : zr(n.pf),
            dI: n.dI,
            pV: n.pV
        };
    }, y4 = F3(function(n, e, r) {
        var t, u, a, i, c, o, f, l, d, b, m = r.A;
        return A([
            A2(WN, A([
                YN("row align-items-start flex-md-columns g-2")
            ]), A([
                A2(WN, A([
                    YN("col-md-6")
                ]), A([
                    A2(h4, n.C.oX, j4(m))
                ])),
                A2(WN, A([
                    YN("col-md-3")
                ]), A([
                    (c = ut(yf(zo(m.P))), A2(WN, A([
                        YN("d-flex flex-column")
                    ]), A([
                        A2(gX, A([
                            vX("mass"),
                            YN("form-label text-truncate")
                        ]), A([
                            c_("Masse du produit fini")
                        ])),
                        A2(WN, A([
                            YN("input-group"),
                            W_("Masse du produit fini, en grammes")
                        ]), A([
                            A2(N_, A([
                                o_("number"),
                                YN("form-control text-end"),
                                yH("mass"),
                                rQ("1"),
                                tQ("1"),
                                hG(c),
                                mG(p4)
                            ]), j),
                            A2(m_, A([
                                YN("input-group-text")
                            ]), A([
                                c_("g")
                            ]))
                        ]))
                    ])))
                ])),
                A2(WN, A([
                    YN("col-md-3 d-flex align-items-end flex-row")
                ]), A([
                    A2(WN, A([
                        YN("d-flex flex-column")
                    ]), A([
                        A2(gX, A([
                            YN("form-label d-none d-md-block"),
                            A2(n_, "aria-hidden", "true")
                        ]), A([
                            c_("\xa0")
                        ])),
                        A2(WN, A([
                            YN("UpcycledCheck form-check text-truncate ms-1")
                        ]), A([
                            A2(N_, A([
                                o_("checkbox"),
                                YN("form-check-input"),
                                yH("upcycled"),
                                w_(m.dI),
                                xX(H3)
                            ]), j),
                            A2(gX, A([
                                vX("upcycled"),
                                YN("form-check-label text-truncate"),
                                W_("Le v\xeatement est-il upcycl\xe9\xa0?")
                            ]), A([
                                c_("Remanufactur\xe9")
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            K2({
                h8: n.h8,
                k2: 1,
                C: n.C,
                lh: !1,
                lu: j,
                ly: zr(xJ(30)),
                lX: zr(A2(bd, bs, A2(Cm, bs, Ur))),
                b7: Ur,
                O: e.O,
                mF: A2(o1, 1, bs),
                ac: A2(Lx, {
                    az: n.h8,
                    C: n.C,
                    at: bs
                }, A2(kA, m.pf, Bx)),
                nc: Pq,
                nA: function() {
                    return Pq;
                },
                nB: function() {
                    return Pq;
                },
                nC: function() {
                    return Pq;
                },
                nD: function() {
                    return Pq;
                },
                nE: F4(function() {
                    return Tc(Ac);
                }),
                nF: A2(Hu, Sq, Tc),
                g5: A2(kA, m.pf, Bx),
                n3: function() {
                    return Pq;
                },
                n4: function() {
                    return Pq;
                },
                n5: function() {
                    return Pq;
                },
                n6: F2(function() {
                    return Pq;
                }),
                n7: M3,
                n8: function() {
                    return Pq;
                },
                at: bs,
                oz: function() {
                    return Pq;
                },
                o6: function() {
                    return Pq;
                },
                o7: function() {
                    return Pq;
                },
                pg: !1,
                pj: function() {
                    return Pq;
                },
                pl: F2(function() {
                    return Pq;
                }),
                pp: function() {
                    return Pq;
                },
                pr: F2(function() {
                    return Pq;
                }),
                ps: F2(function() {
                    return Pq;
                }),
                pt: F3(function() {
                    return Pq;
                }),
                pw: F2(function() {
                    return Pq;
                }),
                px: R3,
                py: F2(function() {
                    return Pq;
                }),
                pE: F2(function() {
                    return Pq;
                }),
                pG: function() {
                    return Pq;
                }
            }),
            A2(WN, A([
                YN("card shadow-sm pb-2")
            ]), A([
                A2(WN, A([
                    YN("card-header d-flex justify-content-between align-items-center")
                ]), A([
                    A2(I_, A([
                        YN("h5 mb-1 text-truncate")
                    ]), A([
                        c_("Durabilit\xe9")
                    ])),
                    A2(WN, A([
                        YN("d-flex align-items-center gap-2")
                    ]), A([
                        A2(m_, A([
                            YN("d-none d-sm-flex text-truncate")
                        ]), A([
                            c_("Coefficient de durabilit\xe9\xa0:")
                        ])),
                        c_(A2(Rj, 2, Zj(r.aO))),
                        A2(_B, A([
                            YN("bg-secondary"),
                            A2(qH, "height", "24px"),
                            QN(xJ(12)),
                            W_("Documentation"),
                            _H("_blank")
                        ]), A([
                            AY
                        ]))
                    ]))
                ])),
                A2(WN, A([
                    YN("card-body pt-3 py-2 row g-3 align-items-start flex-md-columns")
                ]), A([
                    A2(WN, A([
                        YN("col-md-2")
                    ]), A([
                        A2(gX, A([
                            vX("product-price"),
                            YN("col-form-label text-truncate")
                        ]), A([
                            c_("Prix neuf")
                        ]))
                    ])),
                    A2(WN, A([
                        YN("col-md-3")
                    ]), A([
                        (i = A2(Nc, m.aS.lK.jr, m.jr), A2(WN, A([
                            YN("input-group")
                        ]), A([
                            A2(N_, A([
                                o_("number"),
                                yH("product-price"),
                                YN("form-control"),
                                rQ(Js(1)),
                                P0(Js(1e3)),
                                hG(Js(i)),
                                mG(A2(Hu, pp, A2(Hu, Pc(sp), $4)))
                            ]), j),
                            A2(m_, A([
                                YN("input-group-text")
                            ]), A([
                                c_("\u20AC")
                            ]))
                        ])))
                    ])),
                    A2(WN, A([
                        YN("col-md-4")
                    ]), A([
                        A2(gX, A([
                            vX("number-of-references"),
                            YN("col-form-label text-truncate")
                        ]), A([
                            c_("Nombre de r\xe9f\xe9rences")
                        ]))
                    ])),
                    A2(WN, A([
                        YN("col-md-3")
                    ]), A([
                        (a = A2(Nc, m.aS.lK.je, m.je), A2(N_, A([
                            o_("number"),
                            yH("number-of-references"),
                            YN("form-control"),
                            rQ(ut(1)),
                            P0(ut(999999)),
                            tQ("1"),
                            hG(ut(a)),
                            mG(A2(Hu, du, v4))
                        ]), j))
                    ]))
                ])),
                A2(WN, A([
                    YN("card-body py-2 row g-3 align-items-start flex-md-columns")
                ]), A([
                    A2(WN, A([
                        YN("col-md-2")
                    ]), A([
                        A2(gX, A([
                            vX("business"),
                            YN("col-form-label text-truncate")
                        ]), A([
                            c_("Entreprise")
                        ]))
                    ])),
                    A2(WN, A([
                        YN("col-md-10")
                    ]), A([
                        (u = A2(Nc, m.aS.lK.h_, m.h_), A2(vG, A([
                            yH("business"),
                            YN("form-select"),
                            mG(A2(Hu, Bm, G3))
                        ]), A2(wu, function(n) {
                            return A2(pG, A([
                                hG(tf(n)),
                                gG(s(u, n))
                            ]), A([
                                c_(NW(n))
                            ]));
                        }, A([
                            2,
                            1,
                            0
                        ]))))
                    ]))
                ])),
                e.aV ? c_("") : A2(WN, j, A([
                    A2(WN, A([
                        YN("card-body py-2 row g-3 align-items-start flex-md-columns")
                    ]), A([
                        A2(WN, A([
                            YN("col-md-4")
                        ]), A([
                            c_("Durabilit\xe9 non physique")
                        ])),
                        A2(WN, A([
                            YN("col-md-8")
                        ]), A([
                            c_(Js(r.aO.jc))
                        ]))
                    ])),
                    A2(WN, A([
                        YN("card-body py-2 row g-3 align-items-start flex-md-columns")
                    ]), A([
                        A2(WN, A([
                            YN("col-md-4")
                        ]), A([
                            c_("Durabilit\xe9 physique")
                        ])),
                        A2(WN, A([
                            YN("col-md-8")
                        ]), A([
                            (t = r.aO.g$, A2(WN, A([
                                YN("input-group")
                            ]), A([
                                (o = {
                                    bY: !1,
                                    mj: "physicalDurability",
                                    o1: A2(Hu, Qj, Js),
                                    ph: g4,
                                    eT: t
                                }, l = (f = {
                                    hS: A([
                                        mG(A2(Hu, pp, A2(Hu, Pc(op), o.ph))),
                                        rQ(Js(Bj(ru))),
                                        P0(Js(Kj(ru))),
                                        tQ("0.01"),
                                        hG(Js(o.eT)),
                                        E_(o.bY)
                                    ]),
                                    mj: o.mj,
                                    ai: o.o1(o.eT)
                                }).hS, d = f.mj, b = f.ai, A2(WN, A([
                                    YN("RangeSlider row"),
                                    A2(qH, "flex-grow", "1")
                                ]), A([
                                    A2(WN, A([
                                        YN("col-xxl-2")
                                    ]), A([
                                        A2(gX, A([
                                            vX(d),
                                            YN("form-label text-nowrap mb-0")
                                        ]), A([
                                            c_(b)
                                        ]))
                                    ])),
                                    A2(WN, A([
                                        YN("col-xxl-10")
                                    ]), A([
                                        q0(A2(Mr, yH(d), l))
                                    ]))
                                ])))
                            ])))
                        ]))
                    ]))
                ]))
            ])),
            A2(WN, j, A([
                A3(m4, n.C, e, r),
                A2(WN, A([
                    YN("d-flex align-items-center justify-content-between mt-3")
                ]), A([
                    A2(VN, A([
                        ZN(gd)
                    ]), A([
                        c_("\xab Retour \xe0 l'accueil")
                    ])),
                    A2(e_, A([
                        YN("btn btn-secondary"),
                        i_(D3),
                        E_(s(n.an.oX, e.dd))
                    ]), A([
                        c_("R\xe9initialiser le produit")
                    ]))
                ]))
            ]))
        ]);
    }), w4 = F3(function(n, e, r) {
        var t, u, a, i, c = r.A, o = r.g, f = F2(function(n, e) {
            return A2(m_, A([
                YN("d-flex justify-content-between align-items-center gap-1")
            ]), A([
                A2(m_, A([
                    YN("d-flex flex-fill justify-content-center")
                ]), A([
                    c_(e)
                ])),
                A2(m_, A([
                    YN("text-muted fs-8 cursor-help opacity-50"),
                    W_(n)
                ]), A([
                    AY
                ]))
            ]));
        });
        return A2(WN, A([
            YN("row")
        ]), A([
            A2(WN, A([
                YN("col-lg-8 bg-white")
            ]), A([
                A2(BN, A([
                    YN("visually-hidden")
                ]), A([
                    c_("Simulateur ")
                ])),
                A2(WN, A([
                    YN("sticky-md-top bg-white pb-3")
                ]), A([
                    HQ({
                        lc: n.an.oX,
                        lQ: oI,
                        lT: n.C.oX.lT,
                        mf: zr(19),
                        nu: A2(Hu, Mq, Tc),
                        oh: {
                            lW: A2(bd, bs, yd(Ur)),
                            mN: $d,
                            on: xd
                        }
                    })
                ])),
                A2(WN, A([
                    YN("d-flex flex-column bg-white")
                ]), A([
                    fB({
                        kF: A([
                            YN("sticky-md-top"),
                            A2(qH, "top", "50px")
                        ]),
                        h9: A([
                            A2(WN, A([
                                YN("card-body p-2 d-flex flex-column gap-3")
                            ]), A3(y4, n, e, r))
                        ]),
                        oU: A([
                            {
                                hJ: 1 === e.aV,
                                ai: A2(f, "N\u2019affiche que les champs propos\xe9s dans le projet de cadre r\xe9glementaire", "Mode r\xe8glementaire"),
                                jg: q3(1)
                            },
                            {
                                hJ: !e.aV,
                                ai: A2(f, "Affiche des champs suppl\xe9mentaires, hors cadre r\xe9glementaire", "Mode exploratoire"),
                                jg: q3(0)
                            }
                        ])
                    })
                ]))
            ])),
            A2(WN, A([
                YN("col-lg-4 bg-white")
            ]), A([
                TB({
                    kw: e.dW,
                    bw: e.bw,
                    bx: e.bx,
                    k0: C3,
                    k4: "",
                    k5: "",
                    k6: !1,
                    k8: j3,
                    la: Pq,
                    le: zr(A2(WN, A([
                        YN("fs-8")
                    ]), A([
                        c_("Pour 100g\xa0:\xa0"),
                        A2(tW, e.O, A2(MY, c.P, o))
                    ]))),
                    lq: y3,
                    lY: w3,
                    ml: zr(A3(U3, n.C.c_, r, A5(NK, n, e.O, e.dN, E3, P3))),
                    mm: T3,
                    nc: Pq,
                    aT: c.P,
                    n9: I3,
                    ok: S3,
                    at: bs,
                    dv: e.O,
                    ey: n,
                    oP: O3,
                    oR: L3,
                    o9: o,
                    pa: zr((t = r, u = t.ac, a = t.dF, i = bw(A2(Iy, function(n) {
                        return n.gt;
                    }, u)), lh(A([
                        A2(fw, i, tw(u)),
                        a
                    ])))),
                    pk: N3,
                    pm: Wi(Pq),
                    pn: Wi(Pq),
                    pH: _3
                })
            ]))
        ]));
    }), T4 = F2(function(n, e) {
        var r;
        return v("Simulateur", A([
            A2(KN, A([
                YN("Simulator pb-3")
            ]), (r = e.dx, A(1 === r.$ ? [
                f_({
                    hS: j,
                    h4: Ur,
                    h9: A([
                        c_(r.a)
                    ]),
                    ed: 0,
                    eG: zr("Erreur")
                })
            ] : [
                A3(w4, n, e, r.a),
                function() {
                    var r = e.ad;
                    switch(r.$){
                        case 0:
                            return rZ({
                                cK: r.b,
                                ge: Tc(Ac),
                                l6: j,
                                gT: Nq,
                                gU: b3,
                                g0: "tapez ici le nom de la mati\xe8re premi\xe8re pour la rechercher",
                                eG: "S\xe9lectionnez une mati\xe8re premi\xe8re",
                                hw: A2(Hu, function(n) {
                                    return n.jh;
                                }, CW),
                                hx: function(n) {
                                    return n.ek;
                                }
                            });
                        case 1:
                            return rZ({
                                cK: r.a,
                                ge: Tc(Ac),
                                l6: j,
                                gT: zq,
                                gU: b3,
                                g0: "tapez ici un nom d'accesoire pour le rechercher",
                                eG: "S\xe9lectionnez un accessoire",
                                hw: Wi(""),
                                hx: l0
                            });
                        case 2:
                            return JG({
                                h4: Tc(Ac),
                                h9: A([
                                    wZ({
                                        bv: e.bv,
                                        cT: e.cT,
                                        O: e.O,
                                        no: m3,
                                        np: p3,
                                        nq: v3,
                                        nr: g3,
                                        os: h3,
                                        ou: $3,
                                        ey: n,
                                        oQ: x3,
                                        o3: k3
                                    })
                                ]),
                                l6: j,
                                l7: Ur,
                                oE: 0,
                                oM: zr("Co\xfbt environnemental, par produit"),
                                eG: "Comparateur de simulations sauvegard\xe9es"
                            });
                        case 3:
                            return JG({
                                h4: Tc(Ac),
                                h9: A([
                                    A2(WN, A([
                                        YN("p-3")
                                    ]), A([
                                        A2(hH, j, "Basculer en mode r\xe8glementaire r\xe9initialisera les valeurs renseign\xe9es\n                                             pour les champs avanc\xe9s du mode exploratoire."),
                                        A2(D_, A([
                                            YN("d-flex justify-content-center align-items-center gap-1 mt-4")
                                        ]), A([
                                            A2(e_, A([
                                                YN("btn btn-primary"),
                                                i_(d3)
                                            ]), A([
                                                c_("Confirmer")
                                            ])),
                                            c_("ou"),
                                            A2(e_, A([
                                                YN("btn btn-link ps-0"),
                                                i_(Tc(Ac))
                                            ]), A([
                                                c_("rester en mode exploratoire")
                                            ]))
                                        ]))
                                    ]))
                                ]),
                                l6: j,
                                l7: Ur,
                                oE: 4,
                                oM: Ur,
                                eG: "Avertissement"
                            });
                        case 4:
                            var t = r.a;
                            return JG({
                                h4: Tc(Ac),
                                h9: A([
                                    A2(LW, n.C, t)
                                ]),
                                l6: j,
                                l7: Ur,
                                oE: 2,
                                oM: Ur,
                                eG: t.ek
                            });
                        case 5:
                            return c_("");
                        case 6:
                            return rZ({
                                cK: r.a,
                                ge: Tc(Ac),
                                l6: j,
                                gT: qq,
                                gU: b3,
                                g0: "tapez ici le nom du produit pour le rechercher",
                                eG: "S\xe9lectionnez un produit",
                                hw: XQ(n.C.oX.lT),
                                hx: FQ(n.C.oX.lT)
                            });
                        default:
                            return rZ({
                                cK: r.a,
                                ge: Tc(Ac),
                                l6: A([
                                    A2(VN, A([
                                        YN("d-flex justify-content-between gap-2 align-items-center btn btn-primary"),
                                        QN("https://forms.gle/JY6QYMppqRTiCM6g8"),
                                        _H("_blank")
                                    ]), A([
                                        rB,
                                        c_("Sugg\xe9rer une nouvelle cat\xe9gorie")
                                    ]))
                                ]),
                                gT: _q,
                                gU: b3,
                                g0: "tapez ici une cat\xe9gorie pour la rechercher",
                                eG: "S\xe9lectionnez une cat\xe9gorie de produit",
                                hw: Wi(""),
                                hx: function(n) {
                                    return n.ek;
                                }
                            });
                    }
                }()
            ])))
        ]));
    }), E4 = (nH = {
        mr: $i,
        nw: function(n) {
            return {
                $: 15,
                a: n
            };
        },
        nx: function(n) {
            return {
                $: 16,
                a: n
            };
        },
        oO: function(n) {
            var e = n.bc, r = n.H;
            return Ci(A([
                vc(Ai),
                e ? Yi(Li(ki)) : qi,
                2 === r.$ ? A2(pc, r.a.pL, Ei) : qi,
                function() {
                    n: for(; 2 === r.$;)switch(r.b.$){
                        case 3:
                            return A2(Pi, ji, $c(r.b.a));
                        case 4:
                            return A2(Pi, yi, jc(r.b.a));
                        case 5:
                            return A2(Pi, wi, wc(r.b.a));
                        case 10:
                            return A2(Pi, Ti, Ec(r.b.a));
                        default:
                            break n;
                    }
                    return qi;
                }()
            ]));
        },
        ph: NN,
        pM: function(n) {
            var e, r = n.bz, t = n.c9, u = n.H, a = n.bp, i = {
                hK: HN,
                kY: t.kY,
                k_: ki,
                ld: JT,
                lR: t.lR,
                bc: n.bc,
                iX: !1,
                mx: !1,
                cn: n.cn,
                a1: j,
                oW: !1,
                o_: RT,
                bp: a
            };
            switch(u.$){
                case 0:
                    return A2(WG, i, v("Erreur", A([
                        (e = u.a, A2(KN, A([
                            YN("pb-5")
                        ]), A([
                            A2(BN, A([
                                YN("mb-3")
                            ]), A([
                                c_("Erreur")
                            ])),
                            f_({
                                hS: j,
                                h4: Ur,
                                h9: A([
                                    c_(e)
                                ]),
                                ed: 0,
                                eG: Ur
                            }),
                            A2(VN, A([
                                ZN(gd)
                            ]), A([
                                c_("Retour \xe0 l'accueil")
                            ]))
                        ])))
                    ])));
                case 1:
                    return A2(WG, i, v("Chargement des donn\xe9es Ecobalyse", A([
                        eX(zr(QG(r)))
                    ])));
                default:
                    var c = u.a, o = u.b, f = F2(function(n, e) {
                        var r = e.b;
                        return v(e.a, A2(wu, tX(n), r));
                    }), s = function(n) {
                        return WG($(i, {
                            hK: n,
                            ld: c.ld,
                            iX: Nl(c),
                            mx: zl(c),
                            a1: c.a1,
                            oW: ts(c),
                            bp: a
                        }));
                    };
                    switch(o.$){
                        case 0:
                            return A2(s, _N, A2(f, Rl, function(n) {
                                return v("API", A([
                                    A2(KN, A([
                                        YN("pb-5")
                                    ]), A([
                                        A2(BN, A([
                                            YN("mb-3")
                                        ]), A([
                                            c_("API Ecobalyse")
                                        ])),
                                        A2(WN, A([
                                            YN("row")
                                        ]), A([
                                            A2(WN, A([
                                                YN("col-xl-8 d-flex flex-column gap-3")
                                            ]), A([
                                                A2(hH, A([
                                                    YN("fw-bold")
                                                ]), "L'API HTTP Ecobalyse permet de calculer les impacts environnementaux des produits textiles, alimentaires, objets et v\xe9hicules. "),
                                                A2(D_, A([
                                                    YN("mb-0")
                                                ]), A([
                                                    c_("Elle est accessible \xe0 l'adresse "),
                                                    A2(A_, j, A([
                                                        c_(aX(n))
                                                    ])),
                                                    c_(" et "),
                                                    A2(VN, A([
                                                        QN(aX(n)),
                                                        _H("_blank")
                                                    ]), A([
                                                        c_("document\xe9e")
                                                    ])),
                                                    c_(" au format "),
                                                    A2(VN, A([
                                                        QN("https://swagger.io/specification/"),
                                                        _H("_blank")
                                                    ]), A([
                                                        c_("OpenAPI")
                                                    ])),
                                                    c_(".")
                                                ])),
                                                oX(n),
                                                A2(WN, A([
                                                    YN("height-auto")
                                                ]), A([
                                                    cX(n)
                                                ]))
                                            ])),
                                            A2(WN, A([
                                                YN("col-xl-4 d-flex flex-column gap-3")
                                            ]), A([
                                                f_({
                                                    hS: j,
                                                    h4: Ur,
                                                    h9: A([
                                                        A2(hH, A([
                                                            YN("fs-7")
                                                        ]), "Cette API est **exp\xe9rimentale** et n'offre \xe0 ce stade **aucune garantie de disponibilit\xe9 ni de\n             stabilit\xe9** du service, le contrat d'interface restant susceptible de changer \xe0 tout moment en\n             fonction des retours et demandes d'\xe9volutions. **Il est vivement d\xe9conseill\xe9 de vous reposer sur\n             cette API en production et/ou pour des missions critiques.**"),
                                                        A2(D_, A([
                                                            YN("fs-8 mb-0 text-end")
                                                        ]), A([
                                                            A2(VN, A([
                                                                ZN(dd("api-faq"))
                                                            ]), A([
                                                                c_("Acc\xe9der \xe0 la FAQ \xbb")
                                                            ]))
                                                        ]))
                                                    ]),
                                                    ed: 1,
                                                    eG: zr("Avertissement")
                                                }),
                                                A2(WN, A([
                                                    YN("card")
                                                ]), A([
                                                    A2(WN, A([
                                                        YN("card-header")
                                                    ]), A([
                                                        c_("Derni\xe8res mises \xe0 jour")
                                                    ])),
                                                    A2(B_, A([
                                                        YN("list-group list-group-flush")
                                                    ]), A2(wu, function(n) {
                                                        var e = n.d, r = n.ed, t = n.e, u = n.f;
                                                        return A2(__, A([
                                                            YN("list-group-item")
                                                        ]), A([
                                                            A2(WN, A([
                                                                YN("d-flex justify-content-between align-items-right mb-1")
                                                            ]), A([
                                                                A2(WN, A([
                                                                    YN("text-nowrap")
                                                                ]), A([
                                                                    c_(e)
                                                                ])),
                                                                A2(WN, A([
                                                                    YN("d-flex gap-1 flex-wrap justify-content-end")
                                                                ]), A2(Mr, A2(m_, A([
                                                                    YN("badge"),
                                                                    r_(A([
                                                                        v("badge-danger", "major" === r),
                                                                        v("badge-success", "major" !== r)
                                                                    ]))
                                                                ]), A([
                                                                    c_(r)
                                                                ])), A2(wu, function(n) {
                                                                    return A2(m_, A([
                                                                        YN("badge badge-info")
                                                                    ]), A([
                                                                        c_(n)
                                                                    ]));
                                                                }, t)))
                                                            ])),
                                                            A2(hH, A([
                                                                YN("fs-7")
                                                            ]), u)
                                                        ]));
                                                    }, fX))
                                                ]))
                                            ]))
                                        ]))
                                    ]))
                                ]));
                            }(c)));
                        case 1:
                            return A2(s, zN, A2(f, Hl, A2(eV, c, o.a)));
                        case 2:
                            var l = o.a;
                            return A2(s, UN(l.aI), A2(f, Xl, function(n) {
                                var e, r = n.h9;
                                switch(r.$){
                                    case 2:
                                        return v("Erreur de chargement", A([
                                            (e = rs(r.a), f_({
                                                hS: j,
                                                h4: Ur,
                                                h9: function() {
                                                    var n = A(e.split(/\r\n|\r|\n/g));
                                                    if (n.b) {
                                                        if (n.b.b) {
                                                            var r = n.a, t = n.b;
                                                            return A([
                                                                A2(WN, j, A([
                                                                    A2(D_, A([
                                                                        YN("mb-2")
                                                                    ]), A([
                                                                        c_("Une erreur serveur a \xe9t\xe9 rencontr\xe9e\xa0:")
                                                                    ])),
                                                                    A2(R_, A([
                                                                        YN("mb-1")
                                                                    ]), A([
                                                                        c_(r)
                                                                    ])),
                                                                    A2(VH, A([
                                                                        YN("mb-2")
                                                                    ]), A([
                                                                        A2(WH, j, A([
                                                                            c_("Afficher les d\xe9tails de l'erreur")
                                                                        ])),
                                                                        A2(R_, A([
                                                                            YN("mt-1")
                                                                        ]), A([
                                                                            c_(mf(A2(at, "\n", t)))
                                                                        ]))
                                                                    ])),
                                                                    YH(e)
                                                                ]))
                                                            ]);
                                                        }
                                                        return A([
                                                            c_(n.a)
                                                        ]);
                                                    }
                                                    return j;
                                                }(),
                                                ed: 1,
                                                eG: zr("Le serveur a retourn\xe9 une erreur")
                                            }))
                                        ]));
                                    case 1:
                                        return v("Chargement\u2026", A([
                                            nX(Ur)
                                        ]));
                                    case 0:
                                        return v("", j);
                                    default:
                                        var t = r.a;
                                        return v(A2(Nc, "Sans titre", A2(Ba, A2(Hu, it("# "), vx), q$(A2(it, "\n", t)))), A([
                                            A2(KN, j, A([
                                                A2(hH, A([
                                                    YN("pb-5")
                                                ]), t)
                                            ]))
                                        ]));
                                }
                            }(l)));
                        case 3:
                            return A2(s, MN, A2(f, ji, A2(ZW, c, o.a)));
                        case 4:
                            return A2(s, DN, A2(f, yi, A2(AZ, c, o.a)));
                        case 5:
                            return A2(s, RN((d = o.a).iE), A2(f, wi, A2(n3, c, d)));
                        case 6:
                            return A2(s, FN, A2(f, Kl, function(n) {
                                return v("Accueil", A([
                                    A2(WN, A([
                                        YN("d-flex flex-column")
                                    ]), A([
                                        A2(WN, A([
                                            YN("bg-light pt-5 shadow-inner-top")
                                        ]), A([
                                            u3(n)
                                        ])),
                                        A2(WN, A([
                                            YN("p-5")
                                        ]), A([
                                            a3
                                        ])),
                                        A2(WN, A([
                                            YN("bg-light p-5")
                                        ]), A([
                                            c3
                                        ])),
                                        A2(WN, A([
                                            YN("p-5")
                                        ]), A([
                                            f3
                                        ]))
                                    ]))
                                ]));
                            }(c)));
                        case 7:
                            return A2(s, HN, v("Chargement\u2026", A([
                                eX(Ur)
                            ])));
                        case 8:
                            return A2(s, HN, v("404", A([
                                uX
                            ])));
                        case 9:
                            return A2(s, GN, A2(f, Zl, A2(l3, c, o.a)));
                        default:
                            var d;
                            return A2(s, XN, A2(f, Ti, A2(T4, c, d = o.a)));
                    }
            }
        }
    }, eH = nH.nw, rH = nH.nx, tH = function() {
        tH.a(eH(Ze()));
    }, Be({
        hd: function(n) {
            return tH.a = n, tr.addEventListener("popstate", tH), 0 > tr.navigator.userAgent.indexOf("Trident") || tr.addEventListener("hashchange", tH), F2(function(e, r) {
                if (!(r.ctrlKey || r.metaKey || r.shiftKey || r.button >= 1 || e.target || e.hasAttribute("download"))) {
                    r.preventDefault();
                    var t = e.href, u = Ze(), a = hu(t).a;
                    n(rH(a && u.nU === a.nU && u.iN === a.iN && u.nO.a === a.nO.a ? function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(a) : function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(t)));
                }
            });
        },
        mr: function(n) {
            return A3(nH.mr, n, Ze(), tH);
        },
        pM: nH.pM,
        ph: nH.ph,
        oO: nH.oO
    }));
    ZF = {
        Main: {
            init: E4(A2(Bt, function(n) {
                return A2(Bt, function(e) {
                    return A2(Bt, function(r) {
                        return A2(Bt, function(t) {
                            return A2(Bt, function(u) {
                                return A2(Bt, function(a) {
                                    return A2(Bt, function(i) {
                                        return nu({
                                            kY: i,
                                            lR: a,
                                            m_: u,
                                            nM: t,
                                            g6: r,
                                            ol: e,
                                            pL: n
                                        });
                                    }, A2(qu, "clientUrl", ai));
                                }, A2(qu, "enabledSections", A2(Bt, function(n) {
                                    return A2(Bt, function(e) {
                                        return A2(Bt, function(r) {
                                            return A2(Bt, function(t) {
                                                return A2(Bt, function(u) {
                                                    return A2(Bt, function(a) {
                                                        return nu({
                                                            e$: a,
                                                            l5: u,
                                                            fh: t,
                                                            nn: r,
                                                            oX: e,
                                                            f2: n
                                                        });
                                                    }, A2(qu, "apparel", Pu));
                                                }, A2(qu, "food", Pu));
                                            }, A2(qu, "food2", Pu));
                                        }, A2(qu, "objects", Pu));
                                    }, A2(qu, "textile", Pu));
                                }, A2(qu, "veli", Pu))));
                            }, A2(qu, "matomo", A2(Bt, function(n) {
                                return A2(Bt, function(e) {
                                    return nu({
                                        iN: e,
                                        oD: n
                                    });
                                }, A2(qu, "host", ai));
                            }, A2(qu, "siteId", ai))));
                        }, A2(qu, "plausible", A2(Bt, function(n) {
                            return nu({
                                iN: n
                            });
                        }, A2(qu, "host", Za(A([
                            Qa(Ur),
                            A2(Qt, zr, ai)
                        ]))))));
                    }, A2(qu, "rawStore", ai));
                }, A2(qu, "scalingoAppName", Za(A([
                    Qa(Ur),
                    A2(Qt, zr, ai)
                ]))));
            }, A2(qu, "versionPollSeconds", xi)))(0)
        }
    }, n.Elm ? function n(e, r) {
        for(var t in r)t in e ? "init" == t ? f(6) : n(e[t], r[t]) : e[t] = r[t];
    }(n.Elm, ZF) : n.Elm = ZF;
}($be7ebd92b118fa32$exports);


var $873eefa173eeba59$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$873eefa173eeba59$exports = (parcelRequire("31N0p"));




function $c512194462555a6d$export$a6c2d27607295951(stackParser, ex) {
    const frames = $c512194462555a6d$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $c512194462555a6d$export$2e9ae379995d99e3(ex),
        value: $c512194462555a6d$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $c512194462555a6d$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $873eefa173eeba59$exports.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $c512194462555a6d$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $873eefa173eeba59$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $c512194462555a6d$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $873eefa173eeba59$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $c512194462555a6d$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $c512194462555a6d$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $c512194462555a6d$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $c512194462555a6d$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $c512194462555a6d$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $c512194462555a6d$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $c512194462555a6d$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $c512194462555a6d$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $c512194462555a6d$var$getSkipFirstStackStringLines(ex) {
    if (ex && $c512194462555a6d$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $c512194462555a6d$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $c512194462555a6d$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $c512194462555a6d$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $c512194462555a6d$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $c512194462555a6d$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($c512194462555a6d$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $873eefa173eeba59$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $873eefa173eeba59$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
function $c512194462555a6d$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $c512194462555a6d$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $873eefa173eeba59$exports.addExceptionMechanism)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $873eefa173eeba59$exports.resolvedSyncPromise)(event);
}
function $c512194462555a6d$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $c512194462555a6d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $873eefa173eeba59$exports.resolvedSyncPromise)(event);
}
function $c512194462555a6d$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $873eefa173eeba59$exports.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $c512194462555a6d$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $873eefa173eeba59$exports.isDOMError)(exception) || (0, $873eefa173eeba59$exports.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $c512194462555a6d$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $c512194462555a6d$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $873eefa173eeba59$exports.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $873eefa173eeba59$exports.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $c512194462555a6d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $873eefa173eeba59$exports.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $873eefa173eeba59$exports.isError)(exception)) return $c512194462555a6d$var$eventFromError(stackParser, exception);
    if ((0, $873eefa173eeba59$exports.isPlainObject)(exception) || (0, $873eefa173eeba59$exports.isEvent)(exception)) {
        const objectException = exception;
        event = $c512194462555a6d$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $873eefa173eeba59$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $c512194462555a6d$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $873eefa173eeba59$exports.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $873eefa173eeba59$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $c512194462555a6d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $c512194462555a6d$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $873eefa173eeba59$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $873eefa173eeba59$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $c512194462555a6d$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $873eefa173eeba59$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $873eefa173eeba59$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $873eefa173eeba59$exports.isEvent)(exception)) {
        const className = $c512194462555a6d$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $c512194462555a6d$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $c512194462555a6d$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((0, $873eefa173eeba59$exports.isError));
}



const $a50070dc9fce1766$export$56d8a8a25bd48b81 = (0, $873eefa173eeba59$exports.GLOBAL_OBJ);
let $a50070dc9fce1766$var$ignoreOnError = 0;
function $a50070dc9fce1766$export$b79738ab10c590b2() {
    return $a50070dc9fce1766$var$ignoreOnError > 0;
}
function $a50070dc9fce1766$export$1265a142ff5ba165() {
    $a50070dc9fce1766$var$ignoreOnError++;
    setTimeout(()=>{
        $a50070dc9fce1766$var$ignoreOnError--;
    });
}
function $a50070dc9fce1766$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $873eefa173eeba59$exports.getOriginalFunction)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $873eefa173eeba59$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $873eefa173eeba59$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$a50070dc9fce1766$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $a50070dc9fce1766$export$1265a142ff5ba165();
            (0, $873eefa173eeba59$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $873eefa173eeba59$exports.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $873eefa173eeba59$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $873eefa173eeba59$exports.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $873eefa173eeba59$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $873eefa173eeba59$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $873eefa173eeba59$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $873eefa173eeba59$exports.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $a50070dc9fce1766$export$a3c4a8453e8936f0() {
    const url = (0, $873eefa173eeba59$exports.getLocationHref)();
    const { referrer: referrer } = $a50070dc9fce1766$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $a50070dc9fce1766$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


class $3a30d428a485b560$export$1df9218a526d318d extends (0, $873eefa173eeba59$exports.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $3a30d428a485b560$export$4e107b20a7f977(options);
        const sdkSource = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $873eefa173eeba59$exports.getSDKSource)();
        (0, $873eefa173eeba59$exports.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports } = this._options;
        if ((0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document) (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                queueMicrotask(()=>{
                    this.flush();
                });
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $873eefa173eeba59$exports.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $c512194462555a6d$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $c512194462555a6d$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $3a30d428a485b560$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}



const $d67c357688f604e0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $7297b28254e7319a$export$31499a9cd224b78c = "10.76.2";


const $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1 = globalThis;


function $caaab4f0240c1a5f$export$19eade501500c6c1() {
    $caaab4f0240c1a5f$export$c8bfa33e4e8ae492((0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1));
    return 0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1;
}
function $caaab4f0240c1a5f$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $7297b28254e7319a$export$31499a9cd224b78c);
    return __SENTRY__[0, $7297b28254e7319a$export$31499a9cd224b78c] = __SENTRY__[0, $7297b28254e7319a$export$31499a9cd224b78c] || {};
}
function $caaab4f0240c1a5f$export$7e223ec222791509(name, creator, obj = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $7297b28254e7319a$export$31499a9cd224b78c] = __SENTRY__[0, $7297b28254e7319a$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}




const $169ad50b2cdc7abf$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $169ad50b2cdc7abf$var$PREFIX = "Sentry Logger ";
const $169ad50b2cdc7abf$export$77c4ce905194557b = {};
function $169ad50b2cdc7abf$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($169ad50b2cdc7abf$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $169ad50b2cdc7abf$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $169ad50b2cdc7abf$var$enable() {
    $169ad50b2cdc7abf$var$_getLoggerSettings().enabled = true;
}
function $169ad50b2cdc7abf$var$disable() {
    $169ad50b2cdc7abf$var$_getLoggerSettings().enabled = false;
}
function $169ad50b2cdc7abf$var$isEnabled() {
    return $169ad50b2cdc7abf$var$_getLoggerSettings().enabled;
}
function $169ad50b2cdc7abf$var$log(...args) {
    $169ad50b2cdc7abf$var$_maybeLog("log", ...args);
}
function $169ad50b2cdc7abf$var$warn(...args) {
    $169ad50b2cdc7abf$var$_maybeLog("warn", ...args);
}
function $169ad50b2cdc7abf$var$error(...args) {
    $169ad50b2cdc7abf$var$_maybeLog("error", ...args);
}
function $169ad50b2cdc7abf$var$_maybeLog(level, ...args) {
    if (!(0, $d67c357688f604e0$export$16a28057038b10ef)) return;
    if ($169ad50b2cdc7abf$var$isEnabled()) $169ad50b2cdc7abf$export$cda52e2a8927a2ca(()=>{
        (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1).console[level](`${$169ad50b2cdc7abf$var$PREFIX}[${level}]:`, ...args);
    });
}
function $169ad50b2cdc7abf$var$_getLoggerSettings() {
    if (!(0, $d67c357688f604e0$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $caaab4f0240c1a5f$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $169ad50b2cdc7abf$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $169ad50b2cdc7abf$var$enable,
    disable: /** Disable logging. */ $169ad50b2cdc7abf$var$disable,
    isEnabled: /** Check if logging is enabled. */ $169ad50b2cdc7abf$var$isEnabled,
    log: /** Log a message. */ $169ad50b2cdc7abf$var$log,
    warn: /** Log a warning. */ $169ad50b2cdc7abf$var$warn,
    error: /** Log an error. */ $169ad50b2cdc7abf$var$error
};


const $b7086141421221a8$var$STACKTRACE_FRAME_LIMIT = 50;
const $b7086141421221a8$export$27c7e15d453fc0ac = "?";
const $b7086141421221a8$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $b7086141421221a8$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $b7086141421221a8$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $b7086141421221a8$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($b7086141421221a8$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $b7086141421221a8$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $b7086141421221a8$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $b7086141421221a8$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $b7086141421221a8$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $b7086141421221a8$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($b7086141421221a8$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($b7086141421221a8$var$STRIP_FRAME_REGEXP.test($b7086141421221a8$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($b7086141421221a8$var$STRIP_FRAME_REGEXP.test($b7086141421221a8$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $b7086141421221a8$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $b7086141421221a8$var$getLastStackFrame(localStack).filename,
            function: frame.function || $b7086141421221a8$export$27c7e15d453fc0ac
        }));
}
function $b7086141421221a8$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $b7086141421221a8$var$defaultFunctionName = "<anonymous>";
function $b7086141421221a8$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $b7086141421221a8$var$defaultFunctionName;
        return fn.name || $b7086141421221a8$var$defaultFunctionName;
    } catch  {
        return $b7086141421221a8$var$defaultFunctionName;
    }
}
function $b7086141421221a8$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $b7086141421221a8$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


const $915c7efdb0533300$var$handlers = {};
const $915c7efdb0533300$var$instrumented = {};
function $915c7efdb0533300$export$a4e09611e30da72e(type, handler) {
    $915c7efdb0533300$var$handlers[type] = $915c7efdb0533300$var$handlers[type] || [];
    $915c7efdb0533300$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $915c7efdb0533300$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $915c7efdb0533300$export$b17eab759a1cb5fe() {
    Object.keys($915c7efdb0533300$var$handlers).forEach((key)=>{
        $915c7efdb0533300$var$handlers[key] = void 0;
    });
}
function $915c7efdb0533300$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$915c7efdb0533300$var$instrumented[type]) {
        $915c7efdb0533300$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $915c7efdb0533300$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $915c7efdb0533300$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $b7086141421221a8$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}



const $6f219f5f8ad60f48$var$objectToString = Object.prototype.toString;
function $6f219f5f8ad60f48$export$e6127cc7fe7395c3(wat) {
    switch($6f219f5f8ad60f48$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $6f219f5f8ad60f48$export$49034edbe6b62415(wat, Error);
    }
}
function $6f219f5f8ad60f48$var$isBuiltin(wat, className) {
    return $6f219f5f8ad60f48$var$objectToString.call(wat) === `[object ${className}]`;
}
function $6f219f5f8ad60f48$export$9f9636d330b71954(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "ErrorEvent");
}
function $6f219f5f8ad60f48$export$ef9e2056653f0c8e(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "DOMError");
}
function $6f219f5f8ad60f48$export$12e869b2a583f783(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "DOMException");
}
function $6f219f5f8ad60f48$export$844ec244b1367d54(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "String");
}
function $6f219f5f8ad60f48$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $6f219f5f8ad60f48$export$c3825b437cbdea5c(wat) {
    return wat === null || $6f219f5f8ad60f48$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $6f219f5f8ad60f48$export$53b83ca8eaab0383(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "Object");
}
function $6f219f5f8ad60f48$export$c10d0b04eaa80a43(wat) {
    return typeof wat === "object" && wat !== null;
}
function $6f219f5f8ad60f48$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $6f219f5f8ad60f48$export$49034edbe6b62415(wat, Event);
}
function $6f219f5f8ad60f48$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $6f219f5f8ad60f48$export$49034edbe6b62415(wat, Element);
}
function $6f219f5f8ad60f48$export$49841c62b9eff15(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "RegExp");
}
function $6f219f5f8ad60f48$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $6f219f5f8ad60f48$export$bc2894c7158efbac(wat) {
    return $6f219f5f8ad60f48$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $6f219f5f8ad60f48$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $6f219f5f8ad60f48$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $6f219f5f8ad60f48$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $6f219f5f8ad60f48$export$49034edbe6b62415(request, Request);
}


function $73ebe44591c0f61f$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $73ebe44591c0f61f$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $73ebe44591c0f61f$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $73ebe44591c0f61f$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $73ebe44591c0f61f$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $73ebe44591c0f61f$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($73ebe44591c0f61f$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $73ebe44591c0f61f$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $73ebe44591c0f61f$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $73ebe44591c0f61f$export$62ff257738bf57f5(value) {
    if ((0, $6f219f5f8ad60f48$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$73ebe44591c0f61f$var$getOwnProperties(value)
    };
    if ((0, $6f219f5f8ad60f48$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$73ebe44591c0f61f$var$getOwnProperties(value)
        };
    }
    return value;
}
function $73ebe44591c0f61f$var$getOwnProperties(obj) {
    if ((0, $6f219f5f8ad60f48$export$c10d0b04eaa80a43)(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $73ebe44591c0f61f$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($73ebe44591c0f61f$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $73ebe44591c0f61f$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $73ebe44591c0f61f$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $73ebe44591c0f61f$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($73ebe44591c0f61f$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($73ebe44591c0f61f$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $73ebe44591c0f61f$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $73ebe44591c0f61f$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $73ebe44591c0f61f$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $6f219f5f8ad60f48$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



let $31d8160eeba1365b$var$RESOLVED_RUNNER;
function $31d8160eeba1365b$export$ff239213cb80e2da(cb) {
    if ($31d8160eeba1365b$var$RESOLVED_RUNNER !== void 0) return $31d8160eeba1365b$var$RESOLVED_RUNNER ? $31d8160eeba1365b$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $31d8160eeba1365b$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $31d8160eeba1365b$var$RESOLVED_RUNNER(cb);
    }
    $31d8160eeba1365b$var$RESOLVED_RUNNER = null;
    return cb();
}
function $31d8160eeba1365b$export$9869d72de32a3917() {
    return $31d8160eeba1365b$export$ff239213cb80e2da(()=>Math.random());
}
function $31d8160eeba1365b$export$65b1bada40c91b34() {
    return $31d8160eeba1365b$export$ff239213cb80e2da(()=>Date.now());
}




const $7f5b43a8934525be$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $7f5b43a8934525be$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $7f5b43a8934525be$export$280812de8e91ea53(obj) {
    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(obj, $7f5b43a8934525be$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $7f5b43a8934525be$export$610d1422c4bdc4c1(obj, depth) {
    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(obj, $7f5b43a8934525be$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $7f5b43a8934525be$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$7f5b43a8934525be$var$SENTRY_SKIP_NORMALIZATION]);
}
function $7f5b43a8934525be$export$fe95a19841c4b155(value) {
    const v = value[$7f5b43a8934525be$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}




let $252cc08b60bbad6f$var$stringifier;
function $252cc08b60bbad6f$export$575c40989754ba4d(newStringifier) {
    $252cc08b60bbad6f$var$stringifier = newStringifier;
}
function $252cc08b60bbad6f$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $252cc08b60bbad6f$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $252cc08b60bbad6f$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $252cc08b60bbad6f$export$a3295358bff77e(object, depth);
    if ($252cc08b60bbad6f$var$jsonSize(normalized) > maxSize) return $252cc08b60bbad6f$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $252cc08b60bbad6f$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $252cc08b60bbad6f$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $252cc08b60bbad6f$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $7f5b43a8934525be$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $7f5b43a8934525be$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $252cc08b60bbad6f$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $73ebe44591c0f61f$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $252cc08b60bbad6f$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $252cc08b60bbad6f$export$a110e5bc79f44a84(key, value) {
    try {
        if ($252cc08b60bbad6f$var$stringifier) {
            const stringified = $252cc08b60bbad6f$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $b7086141421221a8$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $252cc08b60bbad6f$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $252cc08b60bbad6f$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $252cc08b60bbad6f$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $252cc08b60bbad6f$var$jsonSize(value) {
    return $252cc08b60bbad6f$var$utf8Length(JSON.stringify(value));
}
function $252cc08b60bbad6f$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $252cc08b60bbad6f$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $240729c9e87a40a8$export$fac44ee5b035f737(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $240729c9e87a40a8$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $240729c9e87a40a8$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $240729c9e87a40a8$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $6f219f5f8ad60f48$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $252cc08b60bbad6f$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $240729c9e87a40a8$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $6f219f5f8ad60f48$export$844ec244b1367d54)(value)) return false;
    if ((0, $6f219f5f8ad60f48$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $6f219f5f8ad60f48$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $240729c9e87a40a8$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($240729c9e87a40a8$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $b7774ea50e5fc610$var$getCrypto() {
    const gbl = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $b7774ea50e5fc610$var$emptyUuid;
function $b7774ea50e5fc610$var$getRandomByte() {
    return (0, $31d8160eeba1365b$export$9869d72de32a3917)() * 16;
}
function $b7774ea50e5fc610$export$19f53698e68b2496(crypto = $b7774ea50e5fc610$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $31d8160eeba1365b$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$b7774ea50e5fc610$var$emptyUuid) $b7774ea50e5fc610$var$emptyUuid = "10000000100040008000100000000000";
    return $b7774ea50e5fc610$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($b7774ea50e5fc610$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $b7774ea50e5fc610$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $b7774ea50e5fc610$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $b7774ea50e5fc610$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $b7774ea50e5fc610$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $b7774ea50e5fc610$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $b7774ea50e5fc610$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $b7774ea50e5fc610$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $b7774ea50e5fc610$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $b7774ea50e5fc610$export$d364f2020ab30578(input) {
    const match = input.match($b7774ea50e5fc610$var$SEMVER_REGEXP) || [];
    const major = $b7774ea50e5fc610$var$_parseInt(match[1]);
    const minor = $b7774ea50e5fc610$var$_parseInt(match[2]);
    const patch = $b7774ea50e5fc610$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $b7774ea50e5fc610$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $240729c9e87a40a8$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $240729c9e87a40a8$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $240729c9e87a40a8$export$4215662d762d6f9d)(line, 0));
}
function $b7774ea50e5fc610$export$6de4ffac6a2f1098(exception) {
    if ($b7774ea50e5fc610$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $b7774ea50e5fc610$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}



const $e5af6672c42ca74f$export$56d8a8a25bd48b81 = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);


const $4ae36ed1a9e48935$var$DEBOUNCE_DURATION = 1e3;
let $4ae36ed1a9e48935$var$debounceTimerID;
let $4ae36ed1a9e48935$var$lastCapturedEventType;
let $4ae36ed1a9e48935$var$lastCapturedEventTargetId;
function $4ae36ed1a9e48935$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $915c7efdb0533300$export$a4e09611e30da72e)(type, handler);
    (0, $915c7efdb0533300$export$e18d6c5462c01368)(type, $4ae36ed1a9e48935$export$3014bbf0af0e1d4a);
}
function $4ae36ed1a9e48935$export$3014bbf0af0e1d4a() {
    if (!(0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $915c7efdb0533300$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $4ae36ed1a9e48935$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $73ebe44591c0f61f$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $4ae36ed1a9e48935$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $73ebe44591c0f61f$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $4ae36ed1a9e48935$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $4ae36ed1a9e48935$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $4ae36ed1a9e48935$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $4ae36ed1a9e48935$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $4ae36ed1a9e48935$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $4ae36ed1a9e48935$var$getEventTarget(event);
        if ($4ae36ed1a9e48935$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(target, "_sentryId", (0, $b7774ea50e5fc610$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$4ae36ed1a9e48935$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $4ae36ed1a9e48935$var$lastCapturedEventType = event.type;
            $4ae36ed1a9e48935$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($4ae36ed1a9e48935$var$debounceTimerID);
        $4ae36ed1a9e48935$var$debounceTimerID = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).setTimeout(()=>{
            $4ae36ed1a9e48935$var$lastCapturedEventTargetId = void 0;
            $4ae36ed1a9e48935$var$lastCapturedEventType = void 0;
        }, $4ae36ed1a9e48935$var$DEBOUNCE_DURATION);
    };
}
function $4ae36ed1a9e48935$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}




const $6aeaaf927d53c892$var$WINDOW = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
function $6aeaaf927d53c892$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $6aeaaf927d53c892$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $6aeaaf927d53c892$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $6aeaaf927d53c892$export$67fc34576016d6ec() {
    return "history" in $6aeaaf927d53c892$var$WINDOW && !!$6aeaaf927d53c892$var$WINDOW.history;
}
const $6aeaaf927d53c892$export$edf3cb81fd7d2a3e = $6aeaaf927d53c892$var$_isFetchSupported;
function $6aeaaf927d53c892$var$_isFetchSupported() {
    if (!("fetch" in $6aeaaf927d53c892$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $6aeaaf927d53c892$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $6aeaaf927d53c892$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$6aeaaf927d53c892$var$_isFetchSupported()) return false;
    if ($6aeaaf927d53c892$export$d5f608b368e73f38($6aeaaf927d53c892$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $6aeaaf927d53c892$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $6aeaaf927d53c892$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $6aeaaf927d53c892$export$531055a6c684a70a() {
    return "ReportingObserver" in $6aeaaf927d53c892$var$WINDOW;
}
function $6aeaaf927d53c892$export$2d308b428295192f() {
    if (!$6aeaaf927d53c892$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}



let $b6b753cdb356d243$var$lastHref;
function $b6b753cdb356d243$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $915c7efdb0533300$export$a4e09611e30da72e)(type, handler);
    (0, $915c7efdb0533300$export$e18d6c5462c01368)(type, $b6b753cdb356d243$export$d9b613a6254a184e);
}
function $b6b753cdb356d243$export$d9b613a6254a184e() {
    (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).location.href;
        const from = $b6b753cdb356d243$var$lastHref;
        $b6b753cdb356d243$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $915c7efdb0533300$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $6aeaaf927d53c892$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $b6b753cdb356d243$var$lastHref;
                const to = $b6b753cdb356d243$var$getAbsoluteUrl(String(url));
                $b6b753cdb356d243$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $915c7efdb0533300$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $73ebe44591c0f61f$export$9563e054e6f787fb)((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $73ebe44591c0f61f$export$9563e054e6f787fb)((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $b6b753cdb356d243$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}



const $832ed7dc58639895$var$ONE_SECOND_IN_MS = 1e3;
function $832ed7dc58639895$export$7740643b9eeaf0c4() {
    return (0, $31d8160eeba1365b$export$65b1bada40c91b34)() / $832ed7dc58639895$var$ONE_SECOND_IN_MS;
}
function $832ed7dc58639895$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
    if (!performance?.now || !performance.timeOrigin) return $832ed7dc58639895$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $31d8160eeba1365b$export$ff239213cb80e2da)(()=>performance.now())) / $832ed7dc58639895$var$ONE_SECOND_IN_MS;
    };
}
let $832ed7dc58639895$var$_cachedTimestampInSeconds;
function $832ed7dc58639895$export$ee52dced521e3e18() {
    const func = $832ed7dc58639895$var$_cachedTimestampInSeconds ?? ($832ed7dc58639895$var$_cachedTimestampInSeconds = $832ed7dc58639895$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $832ed7dc58639895$var$cachedTimeOrigin = null;
function $832ed7dc58639895$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $31d8160eeba1365b$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $31d8160eeba1365b$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $832ed7dc58639895$export$baf075a948ffc0bf() {
    if ($832ed7dc58639895$var$cachedTimeOrigin === null) $832ed7dc58639895$var$cachedTimeOrigin = $832ed7dc58639895$var$getBrowserTimeOrigin();
    return $832ed7dc58639895$var$cachedTimeOrigin;
}



const $f8496e812cd386ad$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $f8496e812cd386ad$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $915c7efdb0533300$export$a4e09611e30da72e)(type, handler);
    (0, $915c7efdb0533300$export$e18d6c5462c01368)(type, $f8496e812cd386ad$export$c67d533bf77cbf54);
}
function $f8496e812cd386ad$export$c67d533bf77cbf54() {
    if (!(0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            let virtualError = new Error();
            const startTimestamp = (0, $832ed7dc58639895$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $6f219f5f8ad60f48$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $f8496e812cd386ad$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$f8496e812cd386ad$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$f8496e812cd386ad$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $832ed7dc58639895$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $915c7efdb0533300$export$b18c893e424d3127)("xhr", handlerData);
                    virtualError = void 0;
                    xhrOpenThisArg.removeEventListener("readystatechange", onreadystatechangeHandler);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$f8496e812cd386ad$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $6f219f5f8ad60f48$export$844ec244b1367d54)(header) && (0, $6f219f5f8ad60f48$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$f8496e812cd386ad$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $832ed7dc58639895$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $915c7efdb0533300$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $f8496e812cd386ad$var$parseXhrUrlArg(url) {
    if ((0, $6f219f5f8ad60f48$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}


const $519e8d19cc16330e$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $519e8d19cc16330e$var$accessors = {};
try {
    if (typeof Node !== "undefined") $519e8d19cc16330e$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $519e8d19cc16330e$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $519e8d19cc16330e$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $519e8d19cc16330e$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $519e8d19cc16330e$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $519e8d19cc16330e$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch  {}
function $519e8d19cc16330e$var$_safeRead(el, prop, arg) {
    const fn = $519e8d19cc16330e$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch  {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $519e8d19cc16330e$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $519e8d19cc16330e$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $519e8d19cc16330e$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $519e8d19cc16330e$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $519e8d19cc16330e$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $519e8d19cc16330e$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $519e8d19cc16330e$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>$519e8d19cc16330e$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $519e8d19cc16330e$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $519e8d19cc16330e$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $519e8d19cc16330e$var$_safeRead(el, "className");
        if (className && (0, $6f219f5f8ad60f48$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $519e8d19cc16330e$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}


const $b784161f263a7c57$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $f7f740a4fbe59686$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $f7f740a4fbe59686$var$INTEGRATION_NAME = "Breadcrumbs";
const $f7f740a4fbe59686$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $f7f740a4fbe59686$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $873eefa173eeba59$exports.addConsoleInstrumentationHandler)($f7f740a4fbe59686$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $4ae36ed1a9e48935$export$5aeffd3db2cf9df7)($f7f740a4fbe59686$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $f8496e812cd386ad$export$26ace48dd54c9aea)($f7f740a4fbe59686$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $873eefa173eeba59$exports.addFetchInstrumentationHandler)($f7f740a4fbe59686$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $b6b753cdb356d243$export$3f18c56c58114e75)($f7f740a4fbe59686$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $f7f740a4fbe59686$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $f7f740a4fbe59686$export$c079d904b326663a = (0, $873eefa173eeba59$exports.defineIntegration)($f7f740a4fbe59686$var$_breadcrumbsIntegration);
function $f7f740a4fbe59686$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        (0, $873eefa173eeba59$exports.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $873eefa173eeba59$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $f7f740a4fbe59686$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $f7f740a4fbe59686$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$f7f740a4fbe59686$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$f7f740a4fbe59686$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $f7f740a4fbe59686$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $f7f740a4fbe59686$var$_isEvent(event) ? event.target : event;
            target = (0, $519e8d19cc16330e$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $873eefa173eeba59$exports.getComponentName)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $873eefa173eeba59$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $f7f740a4fbe59686$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $873eefa173eeba59$exports.severityLevelFromString)(handlerData.level),
            message: (0, $873eefa173eeba59$exports.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $873eefa173eeba59$exports.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $873eefa173eeba59$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $f7f740a4fbe59686$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $f8496e812cd386ad$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $873eefa173eeba59$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $873eefa173eeba59$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
function $f7f740a4fbe59686$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $873eefa173eeba59$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $873eefa173eeba59$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $873eefa173eeba59$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
function $f7f740a4fbe59686$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $873eefa173eeba59$exports.parseUrl)((0, $a50070dc9fce1766$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $873eefa173eeba59$exports.parseUrl)(from) : void 0;
        const parsedTo = (0, $873eefa173eeba59$exports.parseUrl)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $873eefa173eeba59$exports.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $f7f740a4fbe59686$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $8af5ba196f611cdb$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $8af5ba196f611cdb$var$INTEGRATION_NAME = "BrowserApiErrors";
const $8af5ba196f611cdb$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $8af5ba196f611cdb$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $873eefa173eeba59$exports.fill)((0, $a50070dc9fce1766$export$56d8a8a25bd48b81), "setTimeout", $8af5ba196f611cdb$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $873eefa173eeba59$exports.fill)((0, $a50070dc9fce1766$export$56d8a8a25bd48b81), "setInterval", $8af5ba196f611cdb$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $873eefa173eeba59$exports.fill)((0, $a50070dc9fce1766$export$56d8a8a25bd48b81), "requestAnimationFrame", $8af5ba196f611cdb$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $a50070dc9fce1766$export$56d8a8a25bd48b81)) (0, $873eefa173eeba59$exports.fill)(XMLHttpRequest.prototype, "send", $8af5ba196f611cdb$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $8af5ba196f611cdb$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$8af5ba196f611cdb$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $8af5ba196f611cdb$export$59bfe9f1c76150e = (0, $873eefa173eeba59$exports.defineIntegration)($8af5ba196f611cdb$var$_browserApiErrorsIntegration);
function $8af5ba196f611cdb$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $a50070dc9fce1766$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $873eefa173eeba59$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $8af5ba196f611cdb$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $a50070dc9fce1766$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $873eefa173eeba59$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $8af5ba196f611cdb$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $873eefa173eeba59$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $873eefa173eeba59$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $873eefa173eeba59$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $873eefa173eeba59$exports.getFunctionName)(originalFunction);
                return (0, $a50070dc9fce1766$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $8af5ba196f611cdb$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $873eefa173eeba59$exports.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($8af5ba196f611cdb$var$isEventListenerObject(fn)) fn.handleEvent = (0, $a50070dc9fce1766$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $873eefa173eeba59$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $8af5ba196f611cdb$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $a50070dc9fce1766$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $873eefa173eeba59$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $873eefa173eeba59$exports.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $8af5ba196f611cdb$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $8af5ba196f611cdb$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}





function $75b0920d6d85e459$export$26d3d892edc56833(type, listener, options) {
    if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document) (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $75b0920d6d85e459$export$324d7b4b46528191(type, listener, options) {
    if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document) (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


const $5f99fbcfcafd9517$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};


const $c4a2423438059f45$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).requestIdleCallback || (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).setTimeout;
    if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        cb = (0, $5f99fbcfcafd9517$export$b841d51e31c12bab)(cb);
        (0, $75b0920d6d85e459$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $75b0920d6d85e459$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $75b0920d6d85e459$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $75b0920d6d85e459$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};




const $51ecc2a8233ee5e8$export$1baa7880e357371c = (0, $873eefa173eeba59$exports.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $873eefa173eeba59$exports.startSession)({
                ignoreDuration: true
            });
            let initialSessionSent = false;
            (0, $c4a2423438059f45$export$d3314d5863fc1fef)(()=>{
                if (!initialSessionSent) {
                    (0, $873eefa173eeba59$exports.captureSession)();
                    initialSessionSent = true;
                }
            });
            const isolationScope = (0, $873eefa173eeba59$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $873eefa173eeba59$exports.captureSession)();
                }
            });
            if (lifecycle === "route") (0, $b6b753cdb356d243$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $873eefa173eeba59$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $873eefa173eeba59$exports.captureSession)();
                    initialSessionSent = true;
                }
            });
        }
    };
});




const $0182c93812b892bb$var$INTEGRATION_NAME = "CultureContext";
const $0182c93812b892bb$var$_cultureContextIntegration = ()=>{
    return {
        name: $0182c93812b892bb$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $0182c93812b892bb$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $0182c93812b892bb$var$getCultureContext();
            if (culture) (0, $873eefa173eeba59$exports.safeSetSpanJSONAttributes)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $0182c93812b892bb$export$ec5976aacdc85985 = (0, $873eefa173eeba59$exports.defineIntegration)($0182c93812b892bb$var$_cultureContextIntegration);
function $0182c93812b892bb$var$getCultureContext() {
    try {
        const intl = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}






const $877fe9a43d6aa4f0$var$INTEGRATION_NAME = "GlobalHandlers";
const $877fe9a43d6aa4f0$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $877fe9a43d6aa4f0$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $877fe9a43d6aa4f0$var$_installGlobalOnErrorHandler(client);
                $877fe9a43d6aa4f0$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $877fe9a43d6aa4f0$var$_installGlobalOnUnhandledRejectionHandler(client);
                $877fe9a43d6aa4f0$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $877fe9a43d6aa4f0$export$66acc70e8cf2b71a = (0, $873eefa173eeba59$exports.defineIntegration)($877fe9a43d6aa4f0$var$_globalHandlersIntegration);
function $877fe9a43d6aa4f0$var$_installGlobalOnErrorHandler(client) {
    (0, $873eefa173eeba59$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $877fe9a43d6aa4f0$var$getOptions();
        if ((0, $873eefa173eeba59$exports.getClient)() !== client || (0, $a50070dc9fce1766$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $877fe9a43d6aa4f0$var$_enhanceEventWithInitialFrame((0, $c512194462555a6d$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $873eefa173eeba59$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $877fe9a43d6aa4f0$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $873eefa173eeba59$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $877fe9a43d6aa4f0$var$getOptions();
        if ((0, $873eefa173eeba59$exports.getClient)() !== client || (0, $a50070dc9fce1766$export$b79738ab10c590b2)()) return;
        const error = $877fe9a43d6aa4f0$export$b2cc40fa8241780(e);
        const event = (0, $873eefa173eeba59$exports.isPrimitive)(error) ? $877fe9a43d6aa4f0$export$1353b5b36844a9ed(error) : (0, $c512194462555a6d$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $873eefa173eeba59$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $877fe9a43d6aa4f0$export$b2cc40fa8241780(error) {
    if ((0, $873eefa173eeba59$exports.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $877fe9a43d6aa4f0$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $877fe9a43d6aa4f0$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $877fe9a43d6aa4f0$var$getFilenameFromUrl(url) ?? (0, $873eefa173eeba59$exports.getLocationHref)(),
        function: (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $877fe9a43d6aa4f0$var$globalHandlerLog(type) {
    (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).log(`Global Handler attached: ${type}`);
}
function $877fe9a43d6aa4f0$var$getOptions() {
    const client = (0, $873eefa173eeba59$exports.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $877fe9a43d6aa4f0$var$getFilenameFromUrl(url) {
    if (!(0, $873eefa173eeba59$exports.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $873eefa173eeba59$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}





var $eAISS = parcelRequire("eAISS");
const $c08cb1f601d03b51$export$1378794447170364 = (0, $873eefa173eeba59$exports.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            if (!(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).navigator && !(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).location && !(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $a50070dc9fce1766$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSpan (span) {
            if (!(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).navigator && !(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).location && !(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $a50070dc9fce1766$export$a3c4a8453e8936f0)();
            (0, $873eefa173eeba59$exports.safeSetSpanJSONAttributes)(span, {
                // This attribute is used by the "Filter out events from legacy browsers and crawlers" features on the Sentry backend.
                // Therefore, it's set on every span.
                [(0, $eAISS.USER_AGENT_ORIGINAL)]: reqData.headers["User-Agent"],
                // These attributes, we only need on the segment span (analogous to the `request` context for events)
                ...span.is_segment && {
                    // Coerce empty string to undefined so the helper's nullish check drops it,
                    // rather than writing an empty `url.full` attribute onto the span.
                    [(0, $eAISS.URL_FULL)]: span.attributes?.[0, $eAISS.SENTRY_OP] !== "http.client" ? (0, $873eefa173eeba59$exports.filterCollectedUrl)(reqData.url) : void 0,
                    [`${0, $eAISS.HTTP_REQUEST_HEADER_KEY_BASE}.referer`]: reqData.headers["Referer"]
                }
            });
        }
    };
});




const $eb7d5d4896892e78$var$DEFAULT_KEY = "cause";
const $eb7d5d4896892e78$var$DEFAULT_LIMIT = 5;
const $eb7d5d4896892e78$var$INTEGRATION_NAME = "LinkedErrors";
const $eb7d5d4896892e78$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $eb7d5d4896892e78$var$DEFAULT_LIMIT;
    const key = options.key || $eb7d5d4896892e78$var$DEFAULT_KEY;
    return {
        name: $eb7d5d4896892e78$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $873eefa173eeba59$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $c512194462555a6d$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $eb7d5d4896892e78$export$ebabb00eb7f3a395 = (0, $873eefa173eeba59$exports.defineIntegration)($eb7d5d4896892e78$var$_linkedErrorsIntegration);



const $14062789fbcfb5db$var$OPERA10_PRIORITY = 10;
const $14062789fbcfb5db$var$OPERA11_PRIORITY = 20;
const $14062789fbcfb5db$var$CHROME_PRIORITY = 30;
const $14062789fbcfb5db$var$WINJS_PRIORITY = 40;
const $14062789fbcfb5db$var$GECKO_PRIORITY = 50;
function $14062789fbcfb5db$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $14062789fbcfb5db$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $14062789fbcfb5db$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $14062789fbcfb5db$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $14062789fbcfb5db$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $14062789fbcfb5db$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($14062789fbcfb5db$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $14062789fbcfb5db$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $14062789fbcfb5db$var$createFrame(filename, (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $14062789fbcfb5db$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $14062789fbcfb5db$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $14062789fbcfb5db$var$extractSafariExtensionDetails(parts[1] || (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION), parts[2]);
        return $14062789fbcfb5db$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $14062789fbcfb5db$export$263a749fff749872 = [
    $14062789fbcfb5db$var$CHROME_PRIORITY,
    $14062789fbcfb5db$var$chromeStackParserFn
];
const $14062789fbcfb5db$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $14062789fbcfb5db$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $14062789fbcfb5db$var$gecko = (line)=>{
    const parts = $14062789fbcfb5db$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $14062789fbcfb5db$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION);
        [func, filename] = $14062789fbcfb5db$var$extractSafariExtensionDetails(func, filename);
        return $14062789fbcfb5db$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $14062789fbcfb5db$export$cdba47a5dd2804d = [
    $14062789fbcfb5db$var$GECKO_PRIORITY,
    $14062789fbcfb5db$var$gecko
];
const $14062789fbcfb5db$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $14062789fbcfb5db$var$winjs = (line)=>{
    const parts = $14062789fbcfb5db$var$winjsRegex.exec(line);
    return parts ? $14062789fbcfb5db$var$createFrame(parts[2], parts[1] || (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $14062789fbcfb5db$export$179460296da408e8 = [
    $14062789fbcfb5db$var$WINJS_PRIORITY,
    $14062789fbcfb5db$var$winjs
];
const $14062789fbcfb5db$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $14062789fbcfb5db$var$opera10 = (line)=>{
    const parts = $14062789fbcfb5db$var$opera10Regex.exec(line);
    return parts ? $14062789fbcfb5db$var$createFrame(parts[2], parts[3] || (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $14062789fbcfb5db$export$f892b52c880ffc7a = [
    $14062789fbcfb5db$var$OPERA10_PRIORITY,
    $14062789fbcfb5db$var$opera10
];
const $14062789fbcfb5db$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $14062789fbcfb5db$var$opera11 = (line)=>{
    const parts = $14062789fbcfb5db$var$opera11Regex.exec(line);
    return parts ? $14062789fbcfb5db$var$createFrame(parts[5], parts[3] || parts[4] || (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $14062789fbcfb5db$export$af11af13f09fb0dc = [
    $14062789fbcfb5db$var$OPERA11_PRIORITY,
    $14062789fbcfb5db$var$opera11
];
const $14062789fbcfb5db$export$7197c0fe6554c079 = [
    $14062789fbcfb5db$export$263a749fff749872,
    $14062789fbcfb5db$export$cdba47a5dd2804d
];
const $14062789fbcfb5db$export$2b2b997d81bf3907 = (0, $873eefa173eeba59$exports.createStackParser)(...$14062789fbcfb5db$export$7197c0fe6554c079);
const $14062789fbcfb5db$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




const $fd229e17678bfd20$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $3eb93b694eb01679$var$cachedImplementations = {};
function $3eb93b694eb01679$export$e464f4a514ac28a8(name) {
    const cached = $3eb93b694eb01679$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81)[name];
    if ((0, $6aeaaf927d53c892$export$d5f608b368e73f38)(impl)) return $3eb93b694eb01679$var$cachedImplementations[name] = impl.bind((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81));
    const document = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $3eb93b694eb01679$var$cachedImplementations[name] = impl.bind((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81));
}
function $3eb93b694eb01679$export$8aa36702e8c8978(name) {
    $3eb93b694eb01679$var$cachedImplementations[name] = void 0;
}
function $3eb93b694eb01679$export$e7aa7bc5c1b3cfb3(...rest) {
    return $3eb93b694eb01679$export$e464f4a514ac28a8("fetch")(...rest);
}
function $3eb93b694eb01679$export$831dc9f2ab0a617b(...rest) {
    try {
        return $3eb93b694eb01679$export$e464f4a514ac28a8("setTimeout")(...rest);
    } catch (e) {
        (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn("Could not use native setTimeout implementation, falling back to window.setTimeout: ", e);
        const fallback = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).setTimeout.bind((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81));
        $3eb93b694eb01679$var$cachedImplementations.setTimeout = fallback;
        return fallback(...rest);
    }
}


const $af57be7b00d81af5$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $af57be7b00d81af5$export$b2311068c46d7cc8(options, nativeFetch = (0, $3eb93b694eb01679$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $3eb93b694eb01679$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $873eefa173eeba59$exports.createTransport)(options, makeRequest, (0, $873eefa173eeba59$exports.makePromiseBuffer)(options.bufferSize || $af57be7b00d81af5$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $b0118be6a67310ff$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $fb7c90f9ce98560e$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $fb7c90f9ce98560e$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $b0118be6a67310ff$export$45a5e7f76e0caa8d)(value)) {
        const objName = $fb7c90f9ce98560e$var$getConstructorName(value);
        if ($fb7c90f9ce98560e$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $519e8d19cc16330e$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $fb7c90f9ce98560e$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}





function $8bff6e4a5c09e026$export$dc236a86065879fc() {
    if ($8bff6e4a5c09e026$var$_isEmbeddedBrowserExtension()) {
        if (0, $b784161f263a7c57$export$16a28057038b10ef) (0, $873eefa173eeba59$exports.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $8bff6e4a5c09e026$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $873eefa173eeba59$exports.getLocationHref)();
    const isDedicatedExtensionPage = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81) === (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $620d70b04505c050$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $873eefa173eeba59$exports.inboundFiltersIntegration)(),
        (0, $873eefa173eeba59$exports.functionToStringIntegration)(),
        (0, $873eefa173eeba59$exports.conversationIdIntegration)(),
        (0, $8af5ba196f611cdb$export$59bfe9f1c76150e)(),
        (0, $f7f740a4fbe59686$export$c079d904b326663a)(),
        (0, $877fe9a43d6aa4f0$export$66acc70e8cf2b71a)(),
        (0, $eb7d5d4896892e78$export$ebabb00eb7f3a395)(),
        (0, $873eefa173eeba59$exports.dedupeIntegration)(),
        (0, $c08cb1f601d03b51$export$1378794447170364)(),
        (0, $0182c93812b892bb$export$ec5976aacdc85985)(),
        (0, $51ecc2a8233ee5e8$export$1baa7880e357371c)()
    ];
}
function $620d70b04505c050$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $8bff6e4a5c09e026$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $620d70b04505c050$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $873eefa173eeba59$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $14062789fbcfb5db$export$2b2b997d81bf3907)),
        integrations: (0, $873eefa173eeba59$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $af57be7b00d81af5$export$b2311068c46d7cc8)
    };
    (0, $873eefa173eeba59$exports.setNormalizeStringifier)((0, $fb7c90f9ce98560e$export$4c88c355e6072df5));
    return (0, $873eefa173eeba59$exports.initAndBind)((0, $3a30d428a485b560$export$1df9218a526d318d), clientOptions);
}
function $620d70b04505c050$export$a3f323d81eede727() {}
function $620d70b04505c050$export$4e4d8b287d028b6b(callback) {
    callback();
}


var $2302afd5d7244c4e$exports = {};
// To ease having both ongoing and stable version stores leveraged on a same domain,
// we use two distinct localStorage keys
const $2302afd5d7244c4e$var$stableVersionKey = "store";
const $2302afd5d7244c4e$var$ongoingVersionKey = "ecobalyse";
function $2302afd5d7244c4e$var$initializeStoreKey(localStorage = window.localStorage) {
    if (localStorage[$2302afd5d7244c4e$var$stableVersionKey] && !localStorage[$2302afd5d7244c4e$var$ongoingVersionKey]) // Ongoing version store has never been initialized, while the stable version one has already
    // => Initialize current storage with stable version session data
    // Note: the ongoing version can always handle and parse old bookmark formats
    localStorage[$2302afd5d7244c4e$var$ongoingVersionKey] = localStorage[$2302afd5d7244c4e$var$stableVersionKey];
    else if (!localStorage[$2302afd5d7244c4e$var$stableVersionKey] && localStorage[$2302afd5d7244c4e$var$ongoingVersionKey]) // Stable version store has never been initialized, while the ongoing version one has already
    // => Backport only auth data, as other stuff is highly unlikely to be compatible
    try {
        const { auth2: auth2 } = JSON.parse(localStorage[$2302afd5d7244c4e$var$ongoingVersionKey]);
        localStorage[$2302afd5d7244c4e$var$stableVersionKey] = JSON.stringify({
            auth2: auth2
        });
    } catch (e) {
        console.error("Unable to retrieve previous valid legacy session data", e);
    }
    return $2302afd5d7244c4e$var$ongoingVersionKey;
}
function $2302afd5d7244c4e$var$exportBookmarks(localStorage = window.localStorage) {
    try {
        const jsonExport = JSON.stringify({
            [$2302afd5d7244c4e$var$ongoingVersionKey]: JSON.parse(localStorage[$2302afd5d7244c4e$var$ongoingVersionKey] || "{}")?.bookmarks || [],
            [$2302afd5d7244c4e$var$stableVersionKey]: JSON.parse(localStorage[$2302afd5d7244c4e$var$stableVersionKey] || "{}")?.bookmarks || []
        });
        let a = document.createElement("a");
        a.href = `data:application/json;base64,${$2302afd5d7244c4e$var$toBase64(jsonExport)}`;
        a.download = $2302afd5d7244c4e$var$createFilename();
        a.click();
    } catch (e) {
        console.error("Unable to export bookmarks", e);
        alert("Erreur durant l'export des signets");
    }
}
function $2302afd5d7244c4e$var$importBookmarks(localStorage = window.localStorage) {
    let field = document.createElement("input");
    field.type = "file";
    field.accept = "application/json,.json";
    field.click();
    field.addEventListener("change", ({ target: target })=>{
        const file = target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.addEventListener("load", ()=>{
                try {
                    const results = JSON.parse(reader.result);
                    $2302afd5d7244c4e$var$importVersionBookmarks(results, $2302afd5d7244c4e$var$stableVersionKey, localStorage);
                    $2302afd5d7244c4e$var$importVersionBookmarks(results, $2302afd5d7244c4e$var$ongoingVersionKey, localStorage);
                    document.location.reload();
                    alert("Les signets ont \xe9t\xe9 import\xe9s");
                } catch (e) {
                    console.error("Error while importing bookmarks", e);
                    alert("Erreur lors de l\u2019import des signets");
                }
            });
            reader.readAsText(file);
        }
    });
}
function $2302afd5d7244c4e$var$importVersionBookmarks(results, key, localStorage = window.localStorage) {
    if (results && key in results) {
        const bookmarks = results[key];
        if (Array.isArray(bookmarks) && bookmarks.length > 0) {
            $2302afd5d7244c4e$var$initializeStoreKey(localStorage);
            const previousStore = JSON.parse(localStorage[key] || "{}");
            const updatedStore = JSON.stringify({
                ...previousStore,
                bookmarks: bookmarks
            });
            localStorage[key] = updatedStore;
        }
    }
}
function $2302afd5d7244c4e$var$createFilename(date = new Date()) {
    const datePart = date.toISOString().replaceAll("-", "").replace("T", "-").replaceAll(":", "").slice(0, 15);
    return `ecobalyse-bookmarks-${datePart}.json`;
}
function $2302afd5d7244c4e$var$toBase64(str) {
    const uint8Array = new TextEncoder().encode(str);
    return btoa(String.fromCharCode(...uint8Array));
}
$2302afd5d7244c4e$exports = {
    exportBookmarks: $2302afd5d7244c4e$var$exportBookmarks,
    importBookmarks: $2302afd5d7244c4e$var$importBookmarks,
    initializeStoreKey: $2302afd5d7244c4e$var$initializeStoreKey
};


// The localStorage key to use to store serialized session data
const $41569a38fd64ffcf$var$storeKey = (0, (/*@__PURE__*/$parcel$interopDefault($2302afd5d7244c4e$exports))).initializeStoreKey();
// Remove trailing slash from root because it's used by the Elm API to resolve backend api urls
const $41569a38fd64ffcf$var$clientUrl = (location.origin + location.pathname).replace(/\/+$/g, "");
// using a `let` statement to avoid this error:
// @parcel/optimizer-swc: 'const' declarations must be initialized
let $41569a38fd64ffcf$var$FORCE_PLAUSIBLE, $41569a38fd64ffcf$var$NODE_ENV = "production", $41569a38fd64ffcf$var$PLAUSIBLE_HOST = "plausible.io", $41569a38fd64ffcf$var$PLAUSIBLE_SCRIPT = "/js/pa-huAqhj4W3hNhYko-4NfoD.js", $41569a38fd64ffcf$var$SENTRY_DSN = "https://5a91b30f00bb4942ad953b90903ad146@sentry.incubateur.net/10";
const $41569a38fd64ffcf$var$plausibleEnabled = $41569a38fd64ffcf$var$PLAUSIBLE_HOST && $41569a38fd64ffcf$var$PLAUSIBLE_SCRIPT && ($41569a38fd64ffcf$var$NODE_ENV === "production" || $41569a38fd64ffcf$var$FORCE_PLAUSIBLE);
// Sentry
if ($41569a38fd64ffcf$var$NODE_ENV === "production" && $41569a38fd64ffcf$var$SENTRY_DSN) {
    const Sentry = {
        init: $620d70b04505c050$export$2cd8252107eb640b,
        setTag: $873eefa173eeba59$exports.setTag
    };
    Sentry.init({
        dsn: $41569a38fd64ffcf$var$SENTRY_DSN,
        allowUrls: [
            /^https:\/\/ecobalyse\.beta\.gouv\.fr/,
            /^https:\/\/staging-ecobalyse\.incubateur\.net/,
            // Review apps
            /^https:\/\/ecobalyse-staging-pr.*\.osc-fr1\.scalingo\.io/
        ],
        ignoreErrors: [
            // Most often due to DOM-aggressive browser extensions
            /_VirtualDom_applyPatch/
        ],
        // IS_REVIEW_APP is set by `scalingo.json` only on review apps
        // See: https://developers.scalingo.com/scalingo-json-schema/
        environment: $41569a38fd64ffcf$var$NODE_ENV || "development"
    });
    Sentry.setTag("subsystem", "front-end");
}
function $41569a38fd64ffcf$var$loadScript(scriptUrl, attributes = {}) {
    var d = document, g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = scriptUrl;
    for (const [key, value] of Object.entries(attributes))g.setAttribute(key, value);
    s.parentNode.insertBefore(g, s);
}
const $41569a38fd64ffcf$var$app = (0, $be7ebd92b118fa32$exports.Elm).Main.init({
    flags: {
        clientUrl: $41569a38fd64ffcf$var$clientUrl,
        enabledSections: {
            apparel: false,
            food: true,
            food2: true,
            objects: true,
            textile: true,
            veli: false
        },
        rawStore: localStorage[$41569a38fd64ffcf$var$storeKey] || "null",
        matomo: {
            host: "stats.beta.gouv.fr",
            siteId: "57"
        },
        plausible: {
            // note: used to render the public stats page, not enable tracking
            host: "plausible.io"
        },
        scalingoAppName: "ecobalyse",
        versionPollSeconds: parseInt(undefined) || 300
    }
});
$41569a38fd64ffcf$var$app.ports.copyToClipboard.subscribe((text)=>{
    navigator.clipboard.writeText(text).then(function() {}, function() {
        alert(`Votre navigateur ne supporte pas la copie automatique; vous pouvez copier l'adresse manuellement`);
    });
});
$41569a38fd64ffcf$var$app.ports.appStarted.subscribe(()=>{
    // Matomo
    var _paq = window._paq = window._paq || [];
    _paq.push([
        "trackPageView"
    ]);
    _paq.push([
        "enableLinkTracking"
    ]);
    var u = `https://${"stats.beta.gouv.fr"}/`;
    _paq.push([
        "setTrackerUrl",
        u + "matomo.php"
    ]);
    _paq.push([
        "disableCookies"
    ]);
    _paq.push([
        "setSiteId",
        "57"
    ]);
    $41569a38fd64ffcf$var$loadScript(u + "matomo.js");
    // Plausible
    if ($41569a38fd64ffcf$var$plausibleEnabled) {
        $41569a38fd64ffcf$var$loadScript(`https://${$41569a38fd64ffcf$var$PLAUSIBLE_HOST}${$41569a38fd64ffcf$var$PLAUSIBLE_SCRIPT}`);
        window.plausible = window.plausible || function() {
            (plausible.q = plausible.q || []).push(arguments);
        }, plausible.init = plausible.init || function(i) {
            plausible.o = i || {};
        };
        plausible.init();
    }
});

$41569a38fd64ffcf$var$app.ports.loadRapidoc.subscribe(()=>{
    // load the rapi-doc script if the component hasn't be registered yet
    if (!customElements.get("rapi-doc")) (parcelRequire("hJFhm"));
});

$41569a38fd64ffcf$var$app.ports.loadCharts.subscribe(()=>{
    if (!customElements.get("ecobalyse-comparator")) (parcelRequire("hFtGY")).then((charts)=>{
        charts.default.registerElements();
    });
});
$41569a38fd64ffcf$var$app.ports.loadJeDonneMonAvis.subscribe(()=>{
    $41569a38fd64ffcf$var$loadScript("https://jedonnemonavis.numerique.gouv.fr/static/jdma-modal-widget.js", {
        "data-jdma-form-url": "https://jedonnemonavis.numerique.gouv.fr/Demarches/avis/2361?button=4816",
        "data-jdma-button-image": "https://jedonnemonavis.numerique.gouv.fr/static/buttons/button-remark-solid-light.svg",
        "data-jdma-button-label": "Une remarque ?",
        "data-jdma-position": "bottom-right",
        defer: "defer"
    });
});
$41569a38fd64ffcf$var$app.ports.saveStore.subscribe((rawStore)=>{
    localStorage[$41569a38fd64ffcf$var$storeKey] = rawStore;
});
$41569a38fd64ffcf$var$app.ports.addBodyClass.subscribe((cls)=>{
    document.body.classList.add(cls);
});
$41569a38fd64ffcf$var$app.ports.exportBookmarks.subscribe(()=>{
    const msg = "Cet export contient l\u2019int\xe9gralit\xe9 de vos signets, tous secteurs et versions confondus";
    if (confirm(msg)) (0, (/*@__PURE__*/$parcel$interopDefault($2302afd5d7244c4e$exports))).exportBookmarks();
});
$41569a38fd64ffcf$var$app.ports.importBookmarks.subscribe(()=>{
    const msg = "Attention, l\u2019import des signets \xe9crasera ceux existant sur ce navigateur pour tous les secteurs (textile, alimentaire, etc). Voulez-vous vraiment continuer\xa0?";
    if (confirm(msg)) (0, (/*@__PURE__*/$parcel$interopDefault($2302afd5d7244c4e$exports))).importBookmarks();
});
$41569a38fd64ffcf$var$app.ports.removeBodyClass.subscribe((cls)=>{
    document.body.classList.remove(cls);
});
$41569a38fd64ffcf$var$app.ports.sendPlausibleEvent.subscribe(({ name: name, properties: properties })=>{
    if (!$41569a38fd64ffcf$var$plausibleEnabled) return;
    try {
        const props = Object.fromEntries(properties);
        const event = name === "pageview" ? {
            u: props.url.replace("/#/", "/"),
            props: props
        } : {
            props: props
        };
        window.plausible(name, event);
        if ($41569a38fd64ffcf$var$NODE_ENV === "development") console.debug("plausible event", name, JSON.stringify(event, null, 2));
    } catch (e) {
        console.error("plausible error", e);
    }
});
$41569a38fd64ffcf$var$app.ports.scrollTo.subscribe((pos)=>{
    window.scrollTo(pos.x, pos.y);
});
$41569a38fd64ffcf$var$app.ports.scrollIntoView.subscribe((selector)=>{
    let node = document.querySelector(selector);
    node?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
    });
});
// Ensure session is refreshed when it changes in another tab/window
window.addEventListener("storage", (event)=>{
    if (event.storageArea === localStorage && event.key === $41569a38fd64ffcf$var$storeKey) $41569a38fd64ffcf$var$app.ports.storeChanged.send(event.newValue);
}, false);


//# sourceMappingURL=8c21aba1-26a1-4655-9c96-ba821ef0d067.8c6ad0c5.js.map
